const Pt = (e) => typeof e == "string", ts = () => {
  let e, n;
  const c = new Promise((E, Y) => {
    e = E, n = Y;
  });
  return c.resolve = e, c.reject = n, c;
}, To = (e) => e == null ? "" : "" + e, Al = (e, n, c) => {
  e.forEach((E) => {
    n[E] && (c[E] = n[E]);
  });
}, el = /###/g, Uo = (e) => e && e.indexOf("###") > -1 ? e.replace(el, ".") : e, No = (e) => !e || Pt(e), is = (e, n, c) => {
  const E = Pt(n) ? n.split(".") : n;
  let Y = 0;
  for (; Y < E.length - 1; ) {
    if (No(e)) return {};
    const X = Uo(E[Y]);
    !e[X] && c && (e[X] = new c()), Object.prototype.hasOwnProperty.call(e, X) ? e = e[X] : e = {}, ++Y;
  }
  return No(e) ? {} : {
    obj: e,
    k: Uo(E[Y])
  };
}, Ro = (e, n, c) => {
  const {
    obj: E,
    k: Y
  } = is(e, n, Object);
  if (E !== void 0 || n.length === 1) {
    E[Y] = c;
    return;
  }
  let X = n[n.length - 1], Q = n.slice(0, n.length - 1), B = is(e, Q, Object);
  for (; B.obj === void 0 && Q.length; )
    X = `${Q[Q.length - 1]}.${X}`, Q = Q.slice(0, Q.length - 1), B = is(e, Q, Object), B?.obj && typeof B.obj[`${B.k}.${X}`] < "u" && (B.obj = void 0);
  B.obj[`${B.k}.${X}`] = c;
}, tl = (e, n, c, E) => {
  const {
    obj: Y,
    k: X
  } = is(e, n, Object);
  Y[X] = Y[X] || [], Y[X].push(c);
}, Ls = (e, n) => {
  const {
    obj: c,
    k: E
  } = is(e, n);
  if (c && Object.prototype.hasOwnProperty.call(c, E))
    return c[E];
}, il = (e, n, c) => {
  const E = Ls(e, c);
  return E !== void 0 ? E : Ls(n, c);
}, mB = (e, n, c) => {
  for (const E in n)
    E !== "__proto__" && E !== "constructor" && (E in e ? Pt(e[E]) || e[E] instanceof String || Pt(n[E]) || n[E] instanceof String ? c && (e[E] = n[E]) : mB(e[E], n[E], c) : e[E] = n[E]);
  return e;
}, xr = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var nl = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const rl = (e) => Pt(e) ? e.replace(/[&<>"'\/]/g, (n) => nl[n]) : e;
class sl {
  constructor(n) {
    this.capacity = n, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(n) {
    const c = this.regExpMap.get(n);
    if (c !== void 0)
      return c;
    const E = new RegExp(n);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(n, E), this.regExpQueue.push(n), E;
  }
}
const al = [" ", ",", "?", "!", ";"], ol = new sl(20), Bl = (e, n, c) => {
  n = n || "", c = c || "";
  const E = al.filter((Q) => n.indexOf(Q) < 0 && c.indexOf(Q) < 0);
  if (E.length === 0) return !0;
  const Y = ol.getRegExp(`(${E.map((Q) => Q === "?" ? "\\?" : Q).join("|")})`);
  let X = !Y.test(e);
  if (!X) {
    const Q = e.indexOf(c);
    Q > 0 && !Y.test(e.substring(0, Q)) && (X = !0);
  }
  return X;
}, ma = (e, n, c = ".") => {
  if (!e) return;
  if (e[n])
    return Object.prototype.hasOwnProperty.call(e, n) ? e[n] : void 0;
  const E = n.split(c);
  let Y = e;
  for (let X = 0; X < E.length; ) {
    if (!Y || typeof Y != "object")
      return;
    let Q, B = "";
    for (let r = X; r < E.length; ++r)
      if (r !== X && (B += c), B += E[r], Q = Y[B], Q !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof Q) > -1 && r < E.length - 1)
          continue;
        X += r - X + 1;
        break;
      }
    Y = Q;
  }
  return Y;
}, as = (e) => e?.replace("_", "-"), gl = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, n) {
    console?.[e]?.apply?.(console, n);
  }
};
class ks {
  constructor(n, c = {}) {
    this.init(n, c);
  }
  init(n, c = {}) {
    this.prefix = c.prefix || "i18next:", this.logger = n || gl, this.options = c, this.debug = c.debug;
  }
  log(...n) {
    return this.forward(n, "log", "", !0);
  }
  warn(...n) {
    return this.forward(n, "warn", "", !0);
  }
  error(...n) {
    return this.forward(n, "error", "");
  }
  deprecate(...n) {
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(n, c, E, Y) {
    return Y && !this.debug ? null : (Pt(n[0]) && (n[0] = `${E}${this.prefix} ${n[0]}`), this.logger[c](n));
  }
  create(n) {
    return new ks(this.logger, {
      prefix: `${this.prefix}:${n}:`,
      ...this.options
    });
  }
  clone(n) {
    return n = n || this.options, n.prefix = n.prefix || this.prefix, new ks(this.logger, n);
  }
}
var Mn = new ks();
class Ks {
  constructor() {
    this.observers = {};
  }
  on(n, c) {
    return n.split(" ").forEach((E) => {
      this.observers[E] || (this.observers[E] = /* @__PURE__ */ new Map());
      const Y = this.observers[E].get(c) || 0;
      this.observers[E].set(c, Y + 1);
    }), this;
  }
  off(n, c) {
    if (this.observers[n]) {
      if (!c) {
        delete this.observers[n];
        return;
      }
      this.observers[n].delete(c);
    }
  }
  emit(n, ...c) {
    this.observers[n] && Array.from(this.observers[n].entries()).forEach(([Y, X]) => {
      for (let Q = 0; Q < X; Q++)
        Y(...c);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([Y, X]) => {
      for (let Q = 0; Q < X; Q++)
        Y.apply(Y, [n, ...c]);
    });
  }
}
class So extends Ks {
  constructor(n, c = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = n || {}, this.options = c, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(n) {
    this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
  }
  removeNamespaces(n) {
    const c = this.options.ns.indexOf(n);
    c > -1 && this.options.ns.splice(c, 1);
  }
  getResource(n, c, E, Y = {}) {
    const X = Y.keySeparator !== void 0 ? Y.keySeparator : this.options.keySeparator, Q = Y.ignoreJSONStructure !== void 0 ? Y.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let B;
    n.indexOf(".") > -1 ? B = n.split(".") : (B = [n, c], E && (Array.isArray(E) ? B.push(...E) : Pt(E) && X ? B.push(...E.split(X)) : B.push(E)));
    const r = Ls(this.data, B);
    return !r && !c && !E && n.indexOf(".") > -1 && (n = B[0], c = B[1], E = B.slice(2).join(".")), r || !Q || !Pt(E) ? r : ma(this.data?.[n]?.[c], E, X);
  }
  addResource(n, c, E, Y, X = {
    silent: !1
  }) {
    const Q = X.keySeparator !== void 0 ? X.keySeparator : this.options.keySeparator;
    let B = [n, c];
    E && (B = B.concat(Q ? E.split(Q) : E)), n.indexOf(".") > -1 && (B = n.split("."), Y = c, c = B[1]), this.addNamespaces(c), Ro(this.data, B, Y), X.silent || this.emit("added", n, c, E, Y);
  }
  addResources(n, c, E, Y = {
    silent: !1
  }) {
    for (const X in E)
      (Pt(E[X]) || Array.isArray(E[X])) && this.addResource(n, c, X, E[X], {
        silent: !0
      });
    Y.silent || this.emit("added", n, c, E);
  }
  addResourceBundle(n, c, E, Y, X, Q = {
    silent: !1,
    skipCopy: !1
  }) {
    let B = [n, c];
    n.indexOf(".") > -1 && (B = n.split("."), Y = E, E = c, c = B[1]), this.addNamespaces(c);
    let r = Ls(this.data, B) || {};
    Q.skipCopy || (E = JSON.parse(JSON.stringify(E))), Y ? mB(r, E, X) : r = {
      ...r,
      ...E
    }, Ro(this.data, B, r), Q.silent || this.emit("added", n, c, E);
  }
  removeResourceBundle(n, c) {
    this.hasResourceBundle(n, c) && delete this.data[n][c], this.removeNamespaces(c), this.emit("removed", n, c);
  }
  hasResourceBundle(n, c) {
    return this.getResource(n, c) !== void 0;
  }
  getResourceBundle(n, c) {
    return c || (c = this.options.defaultNS), this.getResource(n, c);
  }
  getDataByLanguage(n) {
    return this.data[n];
  }
  hasLanguageSomeTranslations(n) {
    const c = this.getDataByLanguage(n);
    return !!(c && Object.keys(c) || []).find((Y) => c[Y] && Object.keys(c[Y]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var YB = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, n, c, E, Y) {
    return e.forEach((X) => {
      n = this.processors[X]?.process(n, c, E, Y) ?? n;
    }), n;
  }
};
const PB = Symbol("i18next/PATH_KEY");
function cl() {
  const e = [], n = /* @__PURE__ */ Object.create(null);
  let c;
  return n.get = (E, Y) => (c?.revoke?.(), Y === PB ? e : (e.push(Y), c = Proxy.revocable(E, n), c.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), n).proxy;
}
function Ya(e, n) {
  const {
    [PB]: c
  } = e(cl());
  return c.join(n?.keySeparator ?? ".");
}
const Go = {}, wa = (e) => !Pt(e) && typeof e != "boolean" && typeof e != "number";
class js extends Ks {
  constructor(n, c = {}) {
    super(), Al(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, this), this.options = c, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Mn.create("translator");
  }
  changeLanguage(n) {
    n && (this.language = n);
  }
  exists(n, c = {
    interpolation: {}
  }) {
    const E = {
      ...c
    };
    if (n == null) return !1;
    const Y = this.resolve(n, E);
    if (Y?.res === void 0) return !1;
    const X = wa(Y.res);
    return !(E.returnObjects === !1 && X);
  }
  extractFromKey(n, c) {
    let E = c.nsSeparator !== void 0 ? c.nsSeparator : this.options.nsSeparator;
    E === void 0 && (E = ":");
    const Y = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator;
    let X = c.ns || this.options.defaultNS || [];
    const Q = E && n.indexOf(E) > -1, B = !this.options.userDefinedKeySeparator && !c.keySeparator && !this.options.userDefinedNsSeparator && !c.nsSeparator && !Bl(n, E, Y);
    if (Q && !B) {
      const r = n.match(this.interpolator.nestingRegexp);
      if (r && r.length > 0)
        return {
          key: n,
          namespaces: Pt(X) ? [X] : X
        };
      const A = n.split(E);
      (E !== Y || E === Y && this.options.ns.indexOf(A[0]) > -1) && (X = A.shift()), n = A.join(Y);
    }
    return {
      key: n,
      namespaces: Pt(X) ? [X] : X
    };
  }
  translate(n, c, E) {
    let Y = typeof c == "object" ? {
      ...c
    } : c;
    if (typeof Y != "object" && this.options.overloadTranslationOptionHandler && (Y = this.options.overloadTranslationOptionHandler(arguments)), typeof Y == "object" && (Y = {
      ...Y
    }), Y || (Y = {}), n == null) return "";
    typeof n == "function" && (n = Ya(n, {
      ...this.options,
      ...Y
    })), Array.isArray(n) || (n = [String(n)]);
    const X = Y.returnDetails !== void 0 ? Y.returnDetails : this.options.returnDetails, Q = Y.keySeparator !== void 0 ? Y.keySeparator : this.options.keySeparator, {
      key: B,
      namespaces: r
    } = this.extractFromKey(n[n.length - 1], Y), A = r[r.length - 1];
    let a = Y.nsSeparator !== void 0 ? Y.nsSeparator : this.options.nsSeparator;
    a === void 0 && (a = ":");
    const d = Y.lng || this.language, x = Y.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return x ? X ? {
        res: `${A}${a}${B}`,
        usedKey: B,
        exactUsedKey: B,
        usedLng: d,
        usedNS: A,
        usedParams: this.getUsedParamsDetails(Y)
      } : `${A}${a}${B}` : X ? {
        res: B,
        usedKey: B,
        exactUsedKey: B,
        usedLng: d,
        usedNS: A,
        usedParams: this.getUsedParamsDetails(Y)
      } : B;
    const U = this.resolve(n, Y);
    let P = U?.res;
    const D = U?.usedKey || B, J = U?.exactUsedKey || B, q = ["[object Number]", "[object Function]", "[object RegExp]"], AA = Y.joinArrays !== void 0 ? Y.joinArrays : this.options.joinArrays, K = !this.i18nFormat || this.i18nFormat.handleAsObject, z = Y.count !== void 0 && !Pt(Y.count), T = js.hasDefaultValue(Y), H = z ? this.pluralResolver.getSuffix(d, Y.count, Y) : "", eA = Y.ordinal && z ? this.pluralResolver.getSuffix(d, Y.count, {
      ordinal: !1
    }) : "", CA = z && !Y.ordinal && Y.count === 0, IA = CA && Y[`defaultValue${this.options.pluralSeparator}zero`] || Y[`defaultValue${H}`] || Y[`defaultValue${eA}`] || Y.defaultValue;
    let k = P;
    K && !P && T && (k = IA);
    const tA = wa(k), lA = Object.prototype.toString.apply(k);
    if (K && k && tA && q.indexOf(lA) < 0 && !(Pt(AA) && Array.isArray(k))) {
      if (!Y.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const uA = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(D, k, {
          ...Y,
          ns: r
        }) : `key '${B} (${this.language})' returned an object instead of string.`;
        return X ? (U.res = uA, U.usedParams = this.getUsedParamsDetails(Y), U) : uA;
      }
      if (Q) {
        const uA = Array.isArray(k), w = uA ? [] : {}, v = uA ? J : D;
        for (const RA in k)
          if (Object.prototype.hasOwnProperty.call(k, RA)) {
            const DA = `${v}${Q}${RA}`;
            T && !P ? w[RA] = this.translate(DA, {
              ...Y,
              defaultValue: wa(IA) ? IA[RA] : void 0,
              joinArrays: !1,
              ns: r
            }) : w[RA] = this.translate(DA, {
              ...Y,
              joinArrays: !1,
              ns: r
            }), w[RA] === DA && (w[RA] = k[RA]);
          }
        P = w;
      }
    } else if (K && Pt(AA) && Array.isArray(P))
      P = P.join(AA), P && (P = this.extendTranslation(P, n, Y, E));
    else {
      let uA = !1, w = !1;
      !this.isValidLookup(P) && T && (uA = !0, P = IA), this.isValidLookup(P) || (w = !0, P = B);
      const RA = (Y.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && w ? void 0 : P, DA = T && IA !== P && this.options.updateMissing;
      if (w || uA || DA) {
        if (this.logger.log(DA ? "updateKey" : "missingKey", d, A, B, DA ? IA : P), Q) {
          const kA = this.resolve(B, {
            ...Y,
            keySeparator: !1
          });
          kA && kA.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let $ = [];
        const cA = this.languageUtils.getFallbackCodes(this.options.fallbackLng, Y.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && cA && cA[0])
          for (let kA = 0; kA < cA.length; kA++)
            $.push(cA[kA]);
        else this.options.saveMissingTo === "all" ? $ = this.languageUtils.toResolveHierarchy(Y.lng || this.language) : $.push(Y.lng || this.language);
        const $A = (kA, WA, EA) => {
          const zA = T && EA !== P ? EA : RA;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(kA, A, WA, zA, DA, Y) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(kA, A, WA, zA, DA, Y), this.emit("missingKey", kA, A, WA, P);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && z ? $.forEach((kA) => {
          const WA = this.pluralResolver.getSuffixes(kA, Y);
          CA && Y[`defaultValue${this.options.pluralSeparator}zero`] && WA.indexOf(`${this.options.pluralSeparator}zero`) < 0 && WA.push(`${this.options.pluralSeparator}zero`), WA.forEach((EA) => {
            $A([kA], B + EA, Y[`defaultValue${EA}`] || IA);
          });
        }) : $A($, B, IA));
      }
      P = this.extendTranslation(P, n, Y, U, E), w && P === B && this.options.appendNamespaceToMissingKey && (P = `${A}${a}${B}`), (w || uA) && this.options.parseMissingKeyHandler && (P = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${A}${a}${B}` : B, uA ? P : void 0, Y));
    }
    return X ? (U.res = P, U.usedParams = this.getUsedParamsDetails(Y), U) : P;
  }
  extendTranslation(n, c, E, Y, X) {
    if (this.i18nFormat?.parse)
      n = this.i18nFormat.parse(n, {
        ...this.options.interpolation.defaultVariables,
        ...E
      }, E.lng || this.language || Y.usedLng, Y.usedNS, Y.usedKey, {
        resolved: Y
      });
    else if (!E.skipInterpolation) {
      E.interpolation && this.interpolator.init({
        ...E,
        interpolation: {
          ...this.options.interpolation,
          ...E.interpolation
        }
      });
      const r = Pt(n) && (E?.interpolation?.skipOnVariables !== void 0 ? E.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let A;
      if (r) {
        const d = n.match(this.interpolator.nestingRegexp);
        A = d && d.length;
      }
      let a = E.replace && !Pt(E.replace) ? E.replace : E;
      if (this.options.interpolation.defaultVariables && (a = {
        ...this.options.interpolation.defaultVariables,
        ...a
      }), n = this.interpolator.interpolate(n, a, E.lng || this.language || Y.usedLng, E), r) {
        const d = n.match(this.interpolator.nestingRegexp), x = d && d.length;
        A < x && (E.nest = !1);
      }
      !E.lng && Y && Y.res && (E.lng = this.language || Y.usedLng), E.nest !== !1 && (n = this.interpolator.nest(n, (...d) => X?.[0] === d[0] && !E.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${c[0]}`), null) : this.translate(...d, c), E)), E.interpolation && this.interpolator.reset();
    }
    const Q = E.postProcess || this.options.postProcess, B = Pt(Q) ? [Q] : Q;
    return n != null && B?.length && E.applyPostProcessor !== !1 && (n = YB.handle(B, n, c, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...Y,
        usedParams: this.getUsedParamsDetails(E)
      },
      ...E
    } : E, this)), n;
  }
  resolve(n, c = {}) {
    let E, Y, X, Q, B;
    return Pt(n) && (n = [n]), n.forEach((r) => {
      if (this.isValidLookup(E)) return;
      const A = this.extractFromKey(r, c), a = A.key;
      Y = a;
      let d = A.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const x = c.count !== void 0 && !Pt(c.count), U = x && !c.ordinal && c.count === 0, P = c.context !== void 0 && (Pt(c.context) || typeof c.context == "number") && c.context !== "", D = c.lngs ? c.lngs : this.languageUtils.toResolveHierarchy(c.lng || this.language, c.fallbackLng);
      d.forEach((J) => {
        this.isValidLookup(E) || (B = J, !Go[`${D[0]}-${J}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(B) && (Go[`${D[0]}-${J}`] = !0, this.logger.warn(`key "${Y}" for languages "${D.join(", ")}" won't get resolved as namespace "${B}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), D.forEach((q) => {
          if (this.isValidLookup(E)) return;
          Q = q;
          const AA = [a];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(AA, a, q, J, c);
          else {
            let z;
            x && (z = this.pluralResolver.getSuffix(q, c.count, c));
            const T = `${this.options.pluralSeparator}zero`, H = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (x && (c.ordinal && z.indexOf(H) === 0 && AA.push(a + z.replace(H, this.options.pluralSeparator)), AA.push(a + z), U && AA.push(a + T)), P) {
              const eA = `${a}${this.options.contextSeparator || "_"}${c.context}`;
              AA.push(eA), x && (c.ordinal && z.indexOf(H) === 0 && AA.push(eA + z.replace(H, this.options.pluralSeparator)), AA.push(eA + z), U && AA.push(eA + T));
            }
          }
          let K;
          for (; K = AA.pop(); )
            this.isValidLookup(E) || (X = K, E = this.getResource(q, J, K, c));
        }));
      });
    }), {
      res: E,
      usedKey: Y,
      exactUsedKey: X,
      usedLng: Q,
      usedNS: B
    };
  }
  isValidLookup(n) {
    return n !== void 0 && !(!this.options.returnNull && n === null) && !(!this.options.returnEmptyString && n === "");
  }
  getResource(n, c, E, Y = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(n, c, E, Y) : this.resourceStore.getResource(n, c, E, Y);
  }
  getUsedParamsDetails(n = {}) {
    const c = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], E = n.replace && !Pt(n.replace);
    let Y = E ? n.replace : n;
    if (E && typeof n.count < "u" && (Y.count = n.count), this.options.interpolation.defaultVariables && (Y = {
      ...this.options.interpolation.defaultVariables,
      ...Y
    }), !E) {
      Y = {
        ...Y
      };
      for (const X of c)
        delete Y[X];
    }
    return Y;
  }
  static hasDefaultValue(n) {
    const c = "defaultValue";
    for (const E in n)
      if (Object.prototype.hasOwnProperty.call(n, E) && c === E.substring(0, c.length) && n[E] !== void 0)
        return !0;
    return !1;
  }
}
class Ho {
  constructor(n) {
    this.options = n, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Mn.create("languageUtils");
  }
  getScriptPartFromCode(n) {
    if (n = as(n), !n || n.indexOf("-") < 0) return null;
    const c = n.split("-");
    return c.length === 2 || (c.pop(), c[c.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(c.join("-"));
  }
  getLanguagePartFromCode(n) {
    if (n = as(n), !n || n.indexOf("-") < 0) return n;
    const c = n.split("-");
    return this.formatLanguageCode(c[0]);
  }
  formatLanguageCode(n) {
    if (Pt(n) && n.indexOf("-") > -1) {
      let c;
      try {
        c = Intl.getCanonicalLocales(n)[0];
      } catch {
      }
      return c && this.options.lowerCaseLng && (c = c.toLowerCase()), c || (this.options.lowerCaseLng ? n.toLowerCase() : n);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
  }
  isSupportedCode(n) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
  }
  getBestMatchFromCodes(n) {
    if (!n) return null;
    let c;
    return n.forEach((E) => {
      if (c) return;
      const Y = this.formatLanguageCode(E);
      (!this.options.supportedLngs || this.isSupportedCode(Y)) && (c = Y);
    }), !c && this.options.supportedLngs && n.forEach((E) => {
      if (c) return;
      const Y = this.getScriptPartFromCode(E);
      if (this.isSupportedCode(Y)) return c = Y;
      const X = this.getLanguagePartFromCode(E);
      if (this.isSupportedCode(X)) return c = X;
      c = this.options.supportedLngs.find((Q) => {
        if (Q === X) return Q;
        if (!(Q.indexOf("-") < 0 && X.indexOf("-") < 0) && (Q.indexOf("-") > 0 && X.indexOf("-") < 0 && Q.substring(0, Q.indexOf("-")) === X || Q.indexOf(X) === 0 && X.length > 1))
          return Q;
      });
    }), c || (c = this.getFallbackCodes(this.options.fallbackLng)[0]), c;
  }
  getFallbackCodes(n, c) {
    if (!n) return [];
    if (typeof n == "function" && (n = n(c)), Pt(n) && (n = [n]), Array.isArray(n)) return n;
    if (!c) return n.default || [];
    let E = n[c];
    return E || (E = n[this.getScriptPartFromCode(c)]), E || (E = n[this.formatLanguageCode(c)]), E || (E = n[this.getLanguagePartFromCode(c)]), E || (E = n.default), E || [];
  }
  toResolveHierarchy(n, c) {
    const E = this.getFallbackCodes((c === !1 ? [] : c) || this.options.fallbackLng || [], n), Y = [], X = (Q) => {
      Q && (this.isSupportedCode(Q) ? Y.push(Q) : this.logger.warn(`rejecting language code not found in supportedLngs: ${Q}`));
    };
    return Pt(n) && (n.indexOf("-") > -1 || n.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && X(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && X(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && X(this.getLanguagePartFromCode(n))) : Pt(n) && X(this.formatLanguageCode(n)), E.forEach((Q) => {
      Y.indexOf(Q) < 0 && X(this.formatLanguageCode(Q));
    }), Y;
  }
}
const Lo = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, ko = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class ll {
  constructor(n, c = {}) {
    this.languageUtils = n, this.options = c, this.logger = Mn.create("pluralResolver"), this.pluralRulesCache = {};
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(n, c = {}) {
    const E = as(n === "dev" ? "en" : n), Y = c.ordinal ? "ordinal" : "cardinal", X = JSON.stringify({
      cleanedCode: E,
      type: Y
    });
    if (X in this.pluralRulesCache)
      return this.pluralRulesCache[X];
    let Q;
    try {
      Q = new Intl.PluralRules(E, {
        type: Y
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), ko;
      if (!n.match(/-|_/)) return ko;
      const r = this.languageUtils.getLanguagePartFromCode(n);
      Q = this.getRule(r, c);
    }
    return this.pluralRulesCache[X] = Q, Q;
  }
  needsPlural(n, c = {}) {
    let E = this.getRule(n, c);
    return E || (E = this.getRule("dev", c)), E?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(n, c, E = {}) {
    return this.getSuffixes(n, E).map((Y) => `${c}${Y}`);
  }
  getSuffixes(n, c = {}) {
    let E = this.getRule(n, c);
    return E || (E = this.getRule("dev", c)), E ? E.resolvedOptions().pluralCategories.sort((Y, X) => Lo[Y] - Lo[X]).map((Y) => `${this.options.prepend}${c.ordinal ? `ordinal${this.options.prepend}` : ""}${Y}`) : [];
  }
  getSuffix(n, c, E = {}) {
    const Y = this.getRule(n, E);
    return Y ? `${this.options.prepend}${E.ordinal ? `ordinal${this.options.prepend}` : ""}${Y.select(c)}` : (this.logger.warn(`no plural rule found for: ${n}`), this.getSuffix("dev", c, E));
  }
}
const jo = (e, n, c, E = ".", Y = !0) => {
  let X = il(e, n, c);
  return !X && Y && Pt(c) && (X = ma(e, c, E), X === void 0 && (X = ma(n, c, E))), X;
}, ua = (e) => e.replace(/\$/g, "$$$$");
class Oo {
  constructor(n = {}) {
    this.logger = Mn.create("interpolator"), this.options = n, this.format = n?.interpolation?.format || ((c) => c), this.init(n);
  }
  init(n = {}) {
    n.interpolation || (n.interpolation = {
      escapeValue: !0
    });
    const {
      escape: c,
      escapeValue: E,
      useRawValueToEscape: Y,
      prefix: X,
      prefixEscaped: Q,
      suffix: B,
      suffixEscaped: r,
      formatSeparator: A,
      unescapeSuffix: a,
      unescapePrefix: d,
      nestingPrefix: x,
      nestingPrefixEscaped: U,
      nestingSuffix: P,
      nestingSuffixEscaped: D,
      nestingOptionsSeparator: J,
      maxReplaces: q,
      alwaysFormat: AA
    } = n.interpolation;
    this.escape = c !== void 0 ? c : rl, this.escapeValue = E !== void 0 ? E : !0, this.useRawValueToEscape = Y !== void 0 ? Y : !1, this.prefix = X ? xr(X) : Q || "{{", this.suffix = B ? xr(B) : r || "}}", this.formatSeparator = A || ",", this.unescapePrefix = a ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : a || "", this.nestingPrefix = x ? xr(x) : U || xr("$t("), this.nestingSuffix = P ? xr(P) : D || xr(")"), this.nestingOptionsSeparator = J || ",", this.maxReplaces = q || 1e3, this.alwaysFormat = AA !== void 0 ? AA : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const n = (c, E) => c?.source === E ? (c.lastIndex = 0, c) : new RegExp(E, "g");
    this.regexp = n(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = n(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = n(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(n, c, E, Y) {
    let X, Q, B;
    const r = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, A = (U) => {
      if (U.indexOf(this.formatSeparator) < 0) {
        const q = jo(c, r, U, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(q, void 0, E, {
          ...Y,
          ...c,
          interpolationkey: U
        }) : q;
      }
      const P = U.split(this.formatSeparator), D = P.shift().trim(), J = P.join(this.formatSeparator).trim();
      return this.format(jo(c, r, D, this.options.keySeparator, this.options.ignoreJSONStructure), J, E, {
        ...Y,
        ...c,
        interpolationkey: D
      });
    };
    this.resetRegExp();
    const a = Y?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = Y?.interpolation?.skipOnVariables !== void 0 ? Y.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (U) => ua(U)
    }, {
      regex: this.regexp,
      safeValue: (U) => this.escapeValue ? ua(this.escape(U)) : ua(U)
    }].forEach((U) => {
      for (B = 0; X = U.regex.exec(n); ) {
        const P = X[1].trim();
        if (Q = A(P), Q === void 0)
          if (typeof a == "function") {
            const J = a(n, X, Y);
            Q = Pt(J) ? J : "";
          } else if (Y && Object.prototype.hasOwnProperty.call(Y, P))
            Q = "";
          else if (d) {
            Q = X[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${P} for interpolating ${n}`), Q = "";
        else !Pt(Q) && !this.useRawValueToEscape && (Q = To(Q));
        const D = U.safeValue(Q);
        if (n = n.replace(X[0], D), d ? (U.regex.lastIndex += Q.length, U.regex.lastIndex -= X[0].length) : U.regex.lastIndex = 0, B++, B >= this.maxReplaces)
          break;
      }
    }), n;
  }
  nest(n, c, E = {}) {
    let Y, X, Q;
    const B = (r, A) => {
      const a = this.nestingOptionsSeparator;
      if (r.indexOf(a) < 0) return r;
      const d = r.split(new RegExp(`${a}[ ]*{`));
      let x = `{${d[1]}`;
      r = d[0], x = this.interpolate(x, Q);
      const U = x.match(/'/g), P = x.match(/"/g);
      ((U?.length ?? 0) % 2 === 0 && !P || P.length % 2 !== 0) && (x = x.replace(/'/g, '"'));
      try {
        Q = JSON.parse(x), A && (Q = {
          ...A,
          ...Q
        });
      } catch (D) {
        return this.logger.warn(`failed parsing options string in nesting for key ${r}`, D), `${r}${a}${x}`;
      }
      return Q.defaultValue && Q.defaultValue.indexOf(this.prefix) > -1 && delete Q.defaultValue, r;
    };
    for (; Y = this.nestingRegexp.exec(n); ) {
      let r = [];
      Q = {
        ...E
      }, Q = Q.replace && !Pt(Q.replace) ? Q.replace : Q, Q.applyPostProcessor = !1, delete Q.defaultValue;
      const A = /{.*}/.test(Y[1]) ? Y[1].lastIndexOf("}") + 1 : Y[1].indexOf(this.formatSeparator);
      if (A !== -1 && (r = Y[1].slice(A).split(this.formatSeparator).map((a) => a.trim()).filter(Boolean), Y[1] = Y[1].slice(0, A)), X = c(B.call(this, Y[1].trim(), Q), Q), X && Y[0] === n && !Pt(X)) return X;
      Pt(X) || (X = To(X)), X || (this.logger.warn(`missed to resolve ${Y[1]} for nesting ${n}`), X = ""), r.length && (X = r.reduce((a, d) => this.format(a, d, E.lng, {
        ...E,
        interpolationkey: Y[1].trim()
      }), X.trim())), n = n.replace(Y[0], X), this.regexp.lastIndex = 0;
    }
    return n;
  }
}
const El = (e) => {
  let n = e.toLowerCase().trim();
  const c = {};
  if (e.indexOf("(") > -1) {
    const E = e.split("(");
    n = E[0].toLowerCase().trim();
    const Y = E[1].substring(0, E[1].length - 1);
    n === "currency" && Y.indexOf(":") < 0 ? c.currency || (c.currency = Y.trim()) : n === "relativetime" && Y.indexOf(":") < 0 ? c.range || (c.range = Y.trim()) : Y.split(";").forEach((Q) => {
      if (Q) {
        const [B, ...r] = Q.split(":"), A = r.join(":").trim().replace(/^'+|'+$/g, ""), a = B.trim();
        c[a] || (c[a] = A), A === "false" && (c[a] = !1), A === "true" && (c[a] = !0), isNaN(A) || (c[a] = parseInt(A, 10));
      }
    });
  }
  return {
    formatName: n,
    formatOptions: c
  };
}, Jo = (e) => {
  const n = {};
  return (c, E, Y) => {
    let X = Y;
    Y && Y.interpolationkey && Y.formatParams && Y.formatParams[Y.interpolationkey] && Y[Y.interpolationkey] && (X = {
      ...X,
      [Y.interpolationkey]: void 0
    });
    const Q = E + JSON.stringify(X);
    let B = n[Q];
    return B || (B = e(as(E), Y), n[Q] = B), B(c);
  };
}, wl = (e) => (n, c, E) => e(as(c), E)(n);
class ul {
  constructor(n = {}) {
    this.logger = Mn.create("formatter"), this.options = n, this.init(n);
  }
  init(n, c = {
    interpolation: {}
  }) {
    this.formatSeparator = c.interpolation.formatSeparator || ",";
    const E = c.cacheInBuiltFormats ? Jo : wl;
    this.formats = {
      number: E((Y, X) => {
        const Q = new Intl.NumberFormat(Y, {
          ...X
        });
        return (B) => Q.format(B);
      }),
      currency: E((Y, X) => {
        const Q = new Intl.NumberFormat(Y, {
          ...X,
          style: "currency"
        });
        return (B) => Q.format(B);
      }),
      datetime: E((Y, X) => {
        const Q = new Intl.DateTimeFormat(Y, {
          ...X
        });
        return (B) => Q.format(B);
      }),
      relativetime: E((Y, X) => {
        const Q = new Intl.RelativeTimeFormat(Y, {
          ...X
        });
        return (B) => Q.format(B, X.range || "day");
      }),
      list: E((Y, X) => {
        const Q = new Intl.ListFormat(Y, {
          ...X
        });
        return (B) => Q.format(B);
      })
    };
  }
  add(n, c) {
    this.formats[n.toLowerCase().trim()] = c;
  }
  addCached(n, c) {
    this.formats[n.toLowerCase().trim()] = Jo(c);
  }
  format(n, c, E, Y = {}) {
    const X = c.split(this.formatSeparator);
    if (X.length > 1 && X[0].indexOf("(") > 1 && X[0].indexOf(")") < 0 && X.find((B) => B.indexOf(")") > -1)) {
      const B = X.findIndex((r) => r.indexOf(")") > -1);
      X[0] = [X[0], ...X.splice(1, B)].join(this.formatSeparator);
    }
    return X.reduce((B, r) => {
      const {
        formatName: A,
        formatOptions: a
      } = El(r);
      if (this.formats[A]) {
        let d = B;
        try {
          const x = Y?.formatParams?.[Y.interpolationkey] || {}, U = x.locale || x.lng || Y.locale || Y.lng || E;
          d = this.formats[A](B, U, {
            ...a,
            ...Y,
            ...x
          });
        } catch (x) {
          this.logger.warn(x);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${A}`);
      return B;
    }, n);
  }
}
const fl = (e, n) => {
  e.pending[n] !== void 0 && (delete e.pending[n], e.pendingCount--);
};
class Ql extends Ks {
  constructor(n, c, E, Y = {}) {
    super(), this.backend = n, this.store = c, this.services = E, this.languageUtils = E.languageUtils, this.options = Y, this.logger = Mn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = Y.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = Y.maxRetries >= 0 ? Y.maxRetries : 5, this.retryTimeout = Y.retryTimeout >= 1 ? Y.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(E, Y.backend, Y);
  }
  queueLoad(n, c, E, Y) {
    const X = {}, Q = {}, B = {}, r = {};
    return n.forEach((A) => {
      let a = !0;
      c.forEach((d) => {
        const x = `${A}|${d}`;
        !E.reload && this.store.hasResourceBundle(A, d) ? this.state[x] = 2 : this.state[x] < 0 || (this.state[x] === 1 ? Q[x] === void 0 && (Q[x] = !0) : (this.state[x] = 1, a = !1, Q[x] === void 0 && (Q[x] = !0), X[x] === void 0 && (X[x] = !0), r[d] === void 0 && (r[d] = !0)));
      }), a || (B[A] = !0);
    }), (Object.keys(X).length || Object.keys(Q).length) && this.queue.push({
      pending: Q,
      pendingCount: Object.keys(Q).length,
      loaded: {},
      errors: [],
      callback: Y
    }), {
      toLoad: Object.keys(X),
      pending: Object.keys(Q),
      toLoadLanguages: Object.keys(B),
      toLoadNamespaces: Object.keys(r)
    };
  }
  loaded(n, c, E) {
    const Y = n.split("|"), X = Y[0], Q = Y[1];
    c && this.emit("failedLoading", X, Q, c), !c && E && this.store.addResourceBundle(X, Q, E, void 0, void 0, {
      skipCopy: !0
    }), this.state[n] = c ? -1 : 2, c && E && (this.state[n] = 0);
    const B = {};
    this.queue.forEach((r) => {
      tl(r.loaded, [X], Q), fl(r, n), c && r.errors.push(c), r.pendingCount === 0 && !r.done && (Object.keys(r.loaded).forEach((A) => {
        B[A] || (B[A] = {});
        const a = r.loaded[A];
        a.length && a.forEach((d) => {
          B[A][d] === void 0 && (B[A][d] = !0);
        });
      }), r.done = !0, r.errors.length ? r.callback(r.errors) : r.callback());
    }), this.emit("loaded", B), this.queue = this.queue.filter((r) => !r.done);
  }
  read(n, c, E, Y = 0, X = this.retryTimeout, Q) {
    if (!n.length) return Q(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: n,
        ns: c,
        fcName: E,
        tried: Y,
        wait: X,
        callback: Q
      });
      return;
    }
    this.readingCalls++;
    const B = (A, a) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (A && a && Y < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, n, c, E, Y + 1, X * 2, Q);
        }, X);
        return;
      }
      Q(A, a);
    }, r = this.backend[E].bind(this.backend);
    if (r.length === 2) {
      try {
        const A = r(n, c);
        A && typeof A.then == "function" ? A.then((a) => B(null, a)).catch(B) : B(null, A);
      } catch (A) {
        B(A);
      }
      return;
    }
    return r(n, c, B);
  }
  prepareLoading(n, c, E = {}, Y) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), Y && Y();
    Pt(n) && (n = this.languageUtils.toResolveHierarchy(n)), Pt(c) && (c = [c]);
    const X = this.queueLoad(n, c, E, Y);
    if (!X.toLoad.length)
      return X.pending.length || Y(), null;
    X.toLoad.forEach((Q) => {
      this.loadOne(Q);
    });
  }
  load(n, c, E) {
    this.prepareLoading(n, c, {}, E);
  }
  reload(n, c, E) {
    this.prepareLoading(n, c, {
      reload: !0
    }, E);
  }
  loadOne(n, c = "") {
    const E = n.split("|"), Y = E[0], X = E[1];
    this.read(Y, X, "read", void 0, void 0, (Q, B) => {
      Q && this.logger.warn(`${c}loading namespace ${X} for language ${Y} failed`, Q), !Q && B && this.logger.log(`${c}loaded namespace ${X} for language ${Y}`, B), this.loaded(n, Q, B);
    });
  }
  saveMissing(n, c, E, Y, X, Q = {}, B = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(c)) {
      this.logger.warn(`did not save key "${E}" as the namespace "${c}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(E == null || E === "")) {
      if (this.backend?.create) {
        const r = {
          ...Q,
          isUpdate: X
        }, A = this.backend.create.bind(this.backend);
        if (A.length < 6)
          try {
            let a;
            A.length === 5 ? a = A(n, c, E, Y, r) : a = A(n, c, E, Y), a && typeof a.then == "function" ? a.then((d) => B(null, d)).catch(B) : B(null, a);
          } catch (a) {
            B(a);
          }
        else
          A(n, c, E, Y, B, r);
      }
      !n || !n[0] || this.store.addResource(n[0], c, E, Y);
    }
  }
}
const fa = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let n = {};
    if (typeof e[1] == "object" && (n = e[1]), Pt(e[1]) && (n.defaultValue = e[1]), Pt(e[2]) && (n.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const c = e[3] || e[2];
      Object.keys(c).forEach((E) => {
        n[E] = c[E];
      });
    }
    return n;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Ko = (e) => (Pt(e.ns) && (e.ns = [e.ns]), Pt(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Pt(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Rs = () => {
}, hl = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((c) => {
    typeof e[c] == "function" && (e[c] = e[c].bind(e));
  });
}, Cl = (e) => !!(e?.modules?.backend?.name?.indexOf("Locize") > 0 || e?.modules?.backend?.constructor?.name?.indexOf("Locize") > 0 || e?.options?.backend?.backends && e.options.backend.backends.some((n) => n?.name?.indexOf("Locize") > 0 || n?.constructor?.name?.indexOf("Locize") > 0));
class ns extends Ks {
  constructor(n = {}, c) {
    if (super(), this.options = Ko(n), this.services = {}, this.logger = Mn, this.modules = {
      external: []
    }, hl(this), c && !this.isInitialized && !n.isClone) {
      if (!this.options.initAsync)
        return this.init(n, c), this;
      setTimeout(() => {
        this.init(n, c);
      }, 0);
    }
  }
  init(n = {}, c) {
    this.isInitializing = !0, typeof n == "function" && (c = n, n = {}), n.defaultNS == null && n.ns && (Pt(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const E = fa();
    this.options = {
      ...E,
      ...this.options,
      ...Ko(n)
    }, this.options.interpolation = {
      ...E.interpolation,
      ...this.options.interpolation
    }, n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator), typeof this.options.overloadTranslationOptionHandler != "function" && (this.options.overloadTranslationOptionHandler = E.overloadTranslationOptionHandler), this.options.showSupportNotice !== !1 && !Cl(this) && typeof console < "u" && typeof console.info < "u" && console.info("🌐 i18next is maintained with support from locize.com — consider powering your project with managed localization (AI, CDN, integrations): https://locize.com 💙");
    const Y = (A) => A ? typeof A == "function" ? new A() : A : null;
    if (!this.options.isClone) {
      this.modules.logger ? Mn.init(Y(this.modules.logger), this.options) : Mn.init(null, this.options);
      let A;
      this.modules.formatter ? A = this.modules.formatter : A = ul;
      const a = new Ho(this.options);
      this.store = new So(this.options.resources, this.options);
      const d = this.services;
      d.logger = Mn, d.resourceStore = this.store, d.languageUtils = a, d.pluralResolver = new ll(a, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== E.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), A && (!this.options.interpolation.format || this.options.interpolation.format === E.interpolation.format) && (d.formatter = Y(A), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Oo(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Ql(Y(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (U, ...P) => {
        this.emit(U, ...P);
      }), this.modules.languageDetector && (d.languageDetector = Y(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = Y(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new js(this.services, this.options), this.translator.on("*", (U, ...P) => {
        this.emit(U, ...P);
      }), this.modules.external.forEach((U) => {
        U.init && U.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, c || (c = Rs), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const A = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      A.length > 0 && A[0] !== "dev" && (this.options.lng = A[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((A) => {
      this[A] = (...a) => this.store[A](...a);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((A) => {
      this[A] = (...a) => (this.store[A](...a), this);
    });
    const B = ts(), r = () => {
      const A = (a, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), B.resolve(d), c(a, d);
      };
      if (this.languages && !this.isInitialized) return A(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, A);
    };
    return this.options.resources || !this.options.initAsync ? r() : setTimeout(r, 0), B;
  }
  loadResources(n, c = Rs) {
    let E = c;
    const Y = Pt(n) ? n : this.language;
    if (typeof n == "function" && (E = n), !this.options.resources || this.options.partialBundledLanguages) {
      if (Y?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return E();
      const X = [], Q = (B) => {
        if (!B || B === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(B).forEach((A) => {
          A !== "cimode" && X.indexOf(A) < 0 && X.push(A);
        });
      };
      Y ? Q(Y) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((r) => Q(r)), this.options.preload?.forEach?.((B) => Q(B)), this.services.backendConnector.load(X, this.options.ns, (B) => {
        !B && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), E(B);
      });
    } else
      E(null);
  }
  reloadResources(n, c, E) {
    const Y = ts();
    return typeof n == "function" && (E = n, n = void 0), typeof c == "function" && (E = c, c = void 0), n || (n = this.languages), c || (c = this.options.ns), E || (E = Rs), this.services.backendConnector.reload(n, c, (X) => {
      Y.resolve(), E(X);
    }), Y;
  }
  use(n) {
    if (!n) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!n.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return n.type === "backend" && (this.modules.backend = n), (n.type === "logger" || n.log && n.warn && n.error) && (this.modules.logger = n), n.type === "languageDetector" && (this.modules.languageDetector = n), n.type === "i18nFormat" && (this.modules.i18nFormat = n), n.type === "postProcessor" && YB.addPostProcessor(n), n.type === "formatter" && (this.modules.formatter = n), n.type === "3rdParty" && this.modules.external.push(n), this;
  }
  setResolvedLanguage(n) {
    if (!(!n || !this.languages) && !(["cimode", "dev"].indexOf(n) > -1)) {
      for (let c = 0; c < this.languages.length; c++) {
        const E = this.languages[c];
        if (!(["cimode", "dev"].indexOf(E) > -1) && this.store.hasLanguageSomeTranslations(E)) {
          this.resolvedLanguage = E;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(n) < 0 && this.store.hasLanguageSomeTranslations(n) && (this.resolvedLanguage = n, this.languages.unshift(n));
    }
  }
  changeLanguage(n, c) {
    this.isLanguageChangingTo = n;
    const E = ts();
    this.emit("languageChanging", n);
    const Y = (B) => {
      this.language = B, this.languages = this.services.languageUtils.toResolveHierarchy(B), this.resolvedLanguage = void 0, this.setResolvedLanguage(B);
    }, X = (B, r) => {
      r ? this.isLanguageChangingTo === n && (Y(r), this.translator.changeLanguage(r), this.isLanguageChangingTo = void 0, this.emit("languageChanged", r), this.logger.log("languageChanged", r)) : this.isLanguageChangingTo = void 0, E.resolve((...A) => this.t(...A)), c && c(B, (...A) => this.t(...A));
    }, Q = (B) => {
      !n && !B && this.services.languageDetector && (B = []);
      const r = Pt(B) ? B : B && B[0], A = this.store.hasLanguageSomeTranslations(r) ? r : this.services.languageUtils.getBestMatchFromCodes(Pt(B) ? [B] : B);
      A && (this.language || Y(A), this.translator.language || this.translator.changeLanguage(A), this.services.languageDetector?.cacheUserLanguage?.(A)), this.loadResources(A, (a) => {
        X(a, A);
      });
    };
    return !n && this.services.languageDetector && !this.services.languageDetector.async ? Q(this.services.languageDetector.detect()) : !n && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(Q) : this.services.languageDetector.detect(Q) : Q(n), E;
  }
  getFixedT(n, c, E) {
    const Y = (X, Q, ...B) => {
      let r;
      typeof Q != "object" ? r = this.options.overloadTranslationOptionHandler([X, Q].concat(B)) : r = {
        ...Q
      }, r.lng = r.lng || Y.lng, r.lngs = r.lngs || Y.lngs, r.ns = r.ns || Y.ns, r.keyPrefix !== "" && (r.keyPrefix = r.keyPrefix || E || Y.keyPrefix);
      const A = this.options.keySeparator || ".";
      let a;
      return r.keyPrefix && Array.isArray(X) ? a = X.map((d) => (typeof d == "function" && (d = Ya(d, {
        ...this.options,
        ...Q
      })), `${r.keyPrefix}${A}${d}`)) : (typeof X == "function" && (X = Ya(X, {
        ...this.options,
        ...Q
      })), a = r.keyPrefix ? `${r.keyPrefix}${A}${X}` : X), this.t(a, r);
    };
    return Pt(n) ? Y.lng = n : Y.lngs = n, Y.ns = c, Y.keyPrefix = E, Y;
  }
  t(...n) {
    return this.translator?.translate(...n);
  }
  exists(...n) {
    return this.translator?.exists(...n);
  }
  setDefaultNamespace(n) {
    this.options.defaultNS = n;
  }
  hasLoadedNamespace(n, c = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const E = c.lng || this.resolvedLanguage || this.languages[0], Y = this.options ? this.options.fallbackLng : !1, X = this.languages[this.languages.length - 1];
    if (E.toLowerCase() === "cimode") return !0;
    const Q = (B, r) => {
      const A = this.services.backendConnector.state[`${B}|${r}`];
      return A === -1 || A === 0 || A === 2;
    };
    if (c.precheck) {
      const B = c.precheck(this, Q);
      if (B !== void 0) return B;
    }
    return !!(this.hasResourceBundle(E, n) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || Q(E, n) && (!Y || Q(X, n)));
  }
  loadNamespaces(n, c) {
    const E = ts();
    return this.options.ns ? (Pt(n) && (n = [n]), n.forEach((Y) => {
      this.options.ns.indexOf(Y) < 0 && this.options.ns.push(Y);
    }), this.loadResources((Y) => {
      E.resolve(), c && c(Y);
    }), E) : (c && c(), Promise.resolve());
  }
  loadLanguages(n, c) {
    const E = ts();
    Pt(n) && (n = [n]);
    const Y = this.options.preload || [], X = n.filter((Q) => Y.indexOf(Q) < 0 && this.services.languageUtils.isSupportedCode(Q));
    return X.length ? (this.options.preload = Y.concat(X), this.loadResources((Q) => {
      E.resolve(), c && c(Q);
    }), E) : (c && c(), Promise.resolve());
  }
  dir(n) {
    if (n || (n = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !n) return "rtl";
    try {
      const Y = new Intl.Locale(n);
      if (Y && Y.getTextInfo) {
        const X = Y.getTextInfo();
        if (X && X.direction) return X.direction;
      }
    } catch {
    }
    const c = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], E = this.services?.languageUtils || new Ho(fa());
    return n.toLowerCase().indexOf("-latn") > 1 ? "ltr" : c.indexOf(E.getLanguagePartFromCode(n)) > -1 || n.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(n = {}, c) {
    const E = new ns(n, c);
    return E.createInstance = ns.createInstance, E;
  }
  cloneInstance(n = {}, c = Rs) {
    const E = n.forkResourceStore;
    E && delete n.forkResourceStore;
    const Y = {
      ...this.options,
      ...n,
      isClone: !0
    }, X = new ns(Y);
    if ((n.debug !== void 0 || n.prefix !== void 0) && (X.logger = X.logger.clone(n)), ["store", "services", "language"].forEach((B) => {
      X[B] = this[B];
    }), X.services = {
      ...this.services
    }, X.services.utils = {
      hasLoadedNamespace: X.hasLoadedNamespace.bind(X)
    }, E) {
      const B = Object.keys(this.store.data).reduce((r, A) => (r[A] = {
        ...this.store.data[A]
      }, r[A] = Object.keys(r[A]).reduce((a, d) => (a[d] = {
        ...r[A][d]
      }, a), r[A]), r), {});
      X.store = new So(B, Y), X.services.resourceStore = X.store;
    }
    if (n.interpolation) {
      const r = {
        ...fa().interpolation,
        ...this.options.interpolation,
        ...n.interpolation
      }, A = {
        ...Y,
        interpolation: r
      };
      X.services.interpolator = new Oo(A);
    }
    return X.translator = new js(X.services, Y), X.translator.on("*", (B, ...r) => {
      X.emit(B, ...r);
    }), X.init(Y, c), X.translator.options = Y, X.translator.backendConnector.services.utils = {
      hasLoadedNamespace: X.hasLoadedNamespace.bind(X)
    }, X;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const l = ns.createInstance();
l.createInstance;
l.dir;
l.init;
l.loadResources;
l.reloadResources;
l.use;
l.changeLanguage;
l.getFixedT;
l.t;
l.exists;
l.setDefaultNamespace;
l.hasLoadedNamespace;
l.loadNamespaces;
l.loadLanguages;
var Wo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vB(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ml(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var n = e.default;
  if (typeof n == "function") {
    var c = function E() {
      var Y = !1;
      try {
        Y = this instanceof E;
      } catch {
      }
      return Y ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    c.prototype = n.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(e).forEach(function(E) {
    var Y = Object.getOwnPropertyDescriptor(e, E);
    Object.defineProperty(c, E, Y.get ? Y : {
      enumerable: !0,
      get: function() {
        return e[E];
      }
    });
  }), c;
}
var Ss = { exports: {} };
/*! pdfmake v0.3.7, @license MIT, @link http://pdfmake.org */
var Dl = Ss.exports, Vo;
function dl() {
  return Vo || (Vo = 1, (function(e, n) {
    (function(E, Y) {
      e.exports = Y();
    })(Object(typeof self < "u" ? self : Dl), () => (
      /******/
      (() => {
        var c = {
          /***/
          7133(Q, B, r) {
            r.d(B, {
              default: () => (
                /* binding */
                Wr
              )
            }), r(187);
            var A = r(5167), a = r(783).Buffer;
            const d = (NA, t) => {
              let C = "normal";
              return NA && t ? C = "bolditalics" : NA ? C = "bold" : t && (C = "italics"), C;
            };
            class x extends A.A {
              constructor(t, C, b, nA, gA, hA) {
                t === void 0 && (t = {}), C === void 0 && (C = {}), b === void 0 && (b = {}), nA === void 0 && (nA = {}), gA === void 0 && (gA = {}), hA === void 0 && (hA = null), super(gA), this.fonts = {}, this.fontCache = {};
                for (let HA in t)
                  if (t.hasOwnProperty(HA)) {
                    let GA = t[HA];
                    this.fonts[HA] = {
                      normal: GA.normal,
                      bold: GA.bold,
                      italics: GA.italics,
                      bolditalics: GA.bolditalics
                    };
                  }
                this.patterns = {};
                for (let HA in b)
                  if (b.hasOwnProperty(HA)) {
                    let GA = b[HA];
                    this.patterns[HA] = this.pattern(GA.boundingBox, GA.xStep, GA.yStep, GA.pattern, GA.colored);
                  }
                this.images = C, this.attachments = nA, this.virtualfs = hA;
              }
              getFontType(t, C) {
                return d(t, C);
              }
              getFontFile(t, C, b) {
                let nA = this.getFontType(C, b);
                return !this.fonts[t] || !this.fonts[t][nA] ? null : this.fonts[t][nA];
              }
              provideFont(t, C, b) {
                let nA = this.getFontType(C, b);
                if (this.getFontFile(t, C, b) === null)
                  throw new Error(`Font '${t}' in style '${nA}' is not defined in the font section of the document definition.`);
                if (this.fontCache[t] = this.fontCache[t] || {}, !this.fontCache[t][nA]) {
                  let gA = this.fonts[t][nA];
                  Array.isArray(gA) || (gA = [gA]), this.virtualfs && this.virtualfs.existsSync(gA[0]) && (gA[0] = this.virtualfs.readFileSync(gA[0])), this.fontCache[t][nA] = this.font(...gA)._font;
                }
                return this.fontCache[t][nA];
              }
              provideImage(t) {
                const C = (nA) => {
                  let gA = this.images[nA];
                  if (!gA)
                    return nA;
                  if (this.virtualfs && this.virtualfs.existsSync(gA))
                    return this.virtualfs.readFileSync(gA);
                  let hA = gA.indexOf("base64,");
                  return hA < 0 ? this.images[nA] : a.from(gA.substring(hA + 7), "base64");
                };
                if (this._imageRegistry[t])
                  return this._imageRegistry[t];
                let b;
                try {
                  if (b = this.openImage(C(t)), !b)
                    throw new Error("No image");
                } catch (nA) {
                  throw new Error(`Invalid image: ${nA.toString()}
Images dictionary should contain dataURL entries (or local file paths in node.js)`, {
                    cause: nA
                  });
                }
                return b.embed(this), this._imageRegistry[t] = b, b;
              }
              /**
               * @param {Array} color pdfmake format: [<pattern name>, <color>]
               * @returns {Array} pdfkit format: [<pattern object>, <color>]
               */
              providePattern(t) {
                return Array.isArray(t) && t.length === 2 ? [this.patterns[t[0]], t[1]] : null;
              }
              provideAttachment(t) {
                const C = (nA) => {
                  if (!nA)
                    throw new Error("No attachment");
                  if (!nA.src)
                    throw new Error('The "src" key is required for attachments');
                  return nA;
                };
                if (typeof t == "object")
                  return C(t);
                let b = C(this.attachments[t]);
                return this.virtualfs && this.virtualfs.existsSync(b.src) ? this.virtualfs.readFileSync(b.src) : b;
              }
              setOpenActionAsPrint() {
                let t = this.ref({
                  Type: "Action",
                  S: "Named",
                  N: "Print"
                });
                this._root.data.OpenAction = t, t.end();
              }
            }
            const U = x;
            function P(NA) {
              return typeof NA == "string" || NA instanceof String;
            }
            function D(NA) {
              return (typeof NA == "number" || NA instanceof Number) && !Number.isNaN(NA);
            }
            function J(NA) {
              return !(!D(NA) || !Number.isInteger(NA) || NA <= 0);
            }
            function q(NA) {
              return NA !== null && !Array.isArray(NA) && !P(NA) && !D(NA) && typeof NA == "object";
            }
            function AA(NA) {
              return q(NA) && Object.keys(NA).length === 0;
            }
            function K(NA) {
              return NA != null;
            }
            function z(NA, t) {
              return NA === "font" ? "font" : t;
            }
            function T(NA) {
              return JSON.stringify(NA, z);
            }
            function H(NA) {
              if (NA.id)
                return NA.id;
              if (Array.isArray(NA.text))
                for (let t of NA.text) {
                  let C = H(t);
                  if (C)
                    return C;
                }
              return null;
            }
            function eA(NA, t) {
              function C(hA, HA, GA) {
                return GA === void 0 && (GA = 0), hA.marginLeft !== void 0 || hA.marginTop !== void 0 || hA.marginRight !== void 0 || hA.marginBottom !== void 0 ? [hA.marginLeft ?? HA[0] ?? GA, hA.marginTop ?? HA[1] ?? GA, hA.marginRight ?? HA[2] ?? GA, hA.marginBottom ?? HA[3] ?? GA] : HA;
              }
              function b(hA, HA, GA) {
                if (GA === void 0 && (GA = /* @__PURE__ */ new Set()), hA = Array.isArray(hA) ? hA : [hA], !hA.every((we) => P(we)))
                  return {};
                let fe = {};
                for (let we = 0; we < hA.length; we++) {
                  let ye = hA[we], De = HA.styleDictionary[ye];
                  if (De !== void 0 && !GA.has(ye)) {
                    if (De.extends !== void 0 && (fe = {
                      ...fe,
                      ...b(De.extends, HA, /* @__PURE__ */ new Set([...GA, ye]))
                    }), De.margin !== void 0) {
                      fe = {
                        margin: nA(De.margin)
                      };
                      continue;
                    }
                    fe = {
                      margin: C(De, fe.margin ?? {}, void 0)
                    };
                  }
                }
                return fe;
              }
              function nA(hA) {
                return D(hA) ? hA = [hA, hA, hA, hA] : Array.isArray(hA) && hA.length === 2 && (hA = [hA[0], hA[1], hA[0], hA[1]]), hA;
              }
              let gA = [void 0, void 0, void 0, void 0];
              if (NA.style) {
                let hA = Array.isArray(NA.style) ? NA.style : [NA.style], HA = b(hA, t);
                HA && (gA = C(HA, gA)), HA.margin && (gA = nA(HA.margin));
              }
              return gA = C(NA, gA), NA.margin !== void 0 && (gA = nA(NA.margin)), gA[0] === void 0 && gA[1] === void 0 && gA[2] === void 0 && gA[3] === void 0 ? null : gA;
            }
            var CA = r(783).Buffer;
            const IA = (NA) => P(NA) ? NA.replace(/\t/g, "    ") : D(NA) || typeof NA == "boolean" ? NA.toString() : !K(NA) || AA(NA) ? "" : NA;
            class k {
              preprocessDocument(t) {
                return this.parentNode = null, this.tocs = [], this.nodeReferences = [], this.preprocessNode(t, !0);
              }
              preprocessBlock(t) {
                return this.parentNode = null, this.tocs = [], this.nodeReferences = [], this.preprocessNode(t);
              }
              preprocessNode(t, C) {
                if (C === void 0 && (C = !1), Array.isArray(t) ? t = {
                  stack: t
                } : P(t) || D(t) || typeof t == "boolean" || !K(t) || AA(t) ? t = {
                  text: IA(t)
                } : "text" in t && (t.text = IA(t.text)), t.section) {
                  if (!C)
                    throw new Error(`Incorrect document structure, section node is only allowed at the root level of document structure: ${T(t)}`);
                  return this.preprocessSection(t);
                } else {
                  if (t.columns)
                    return this.preprocessColumns(t);
                  if (t.stack)
                    return this.preprocessVerticalContainer(t, C);
                  if (t.ul)
                    return this.preprocessList(t);
                  if (t.ol)
                    return this.preprocessList(t);
                  if (t.table)
                    return this.preprocessTable(t);
                  if (t.text !== void 0)
                    return this.preprocessText(t);
                  if (t.toc)
                    return this.preprocessToc(t);
                  if (t.image)
                    return this.preprocessImage(t);
                  if (t.svg)
                    return this.preprocessSVG(t);
                  if (t.canvas)
                    return this.preprocessCanvas(t);
                  if (t.qr)
                    return this.preprocessQr(t);
                  if (t.attachment)
                    return this.preprocessAttachment(t);
                  if (t.pageReference || t.textReference)
                    return this.preprocessText(t);
                  throw new Error(`Unrecognized document structure: ${T(t)}`);
                }
              }
              preprocessSection(t) {
                return t.section = this.preprocessNode(t.section), t;
              }
              preprocessColumns(t) {
                let C = t.columns;
                for (let b = 0, nA = C.length; b < nA; b++)
                  C[b] = this.preprocessNode(C[b]);
                return t;
              }
              preprocessVerticalContainer(t, C) {
                let b = t.stack;
                for (let nA = 0, gA = b.length; nA < gA; nA++)
                  b[nA] = this.preprocessNode(b[nA], C);
                return t;
              }
              preprocessList(t) {
                let C = t.ul || t.ol;
                for (let b = 0, nA = C.length; b < nA; b++)
                  C[b] = this.preprocessNode(C[b]);
                return t;
              }
              preprocessTable(t) {
                let C, b, nA, gA;
                for (C = 0, nA = t.table.body[0].length; C < nA; C++)
                  for (b = 0, gA = t.table.body.length; b < gA; b++) {
                    let hA = t.table.body[b], HA = hA[C];
                    HA !== void 0 && (HA === null && (HA = ""), HA._span || (hA[C] = this.preprocessNode(HA)));
                  }
                return t;
              }
              preprocessText(t) {
                if (t.tocItem) {
                  Array.isArray(t.tocItem) || (t.tocItem = [t.tocItem]);
                  for (let C = 0, b = t.tocItem.length; C < b; C++) {
                    P(t.tocItem[C]) || (t.tocItem[C] = "_default_");
                    let nA = t.tocItem[C];
                    this.tocs[nA] || (this.tocs[nA] = {
                      toc: {
                        _items: [],
                        _pseudo: !0
                      }
                    }), t.id || (t.id = `toc-${nA}-${this.tocs[nA].toc._items.length}`);
                    let gA = {
                      _nodeRef: this._getNodeForNodeRef(t),
                      _textNodeRef: t
                    };
                    this.tocs[nA].toc._items.push(gA);
                  }
                }
                if (t.id)
                  if (this.nodeReferences[t.id]) {
                    if (!this.nodeReferences[t.id]._pseudo)
                      throw new Error(`Node id '${t.id}' already exists`);
                    this.nodeReferences[t.id]._nodeRef = this._getNodeForNodeRef(t), this.nodeReferences[t.id]._textNodeRef = t, this.nodeReferences[t.id]._pseudo = !1;
                  } else
                    this.nodeReferences[t.id] = {
                      _nodeRef: this._getNodeForNodeRef(t),
                      _textNodeRef: t
                    };
                if (t.pageReference && (this.nodeReferences[t.pageReference] || (this.nodeReferences[t.pageReference] = {
                  _nodeRef: {},
                  _textNodeRef: {},
                  _pseudo: !0
                }), t.text = "00000", t.linkToDestination = t.pageReference, t._pageRef = this.nodeReferences[t.pageReference]), t.textReference && (this.nodeReferences[t.textReference] || (this.nodeReferences[t.textReference] = {
                  _nodeRef: {},
                  _pseudo: !0
                }), t.text = "", t.linkToDestination = t.textReference, t._textRef = this.nodeReferences[t.textReference]), t.text && t.text.text)
                  t.text = [this.preprocessNode(t.text)];
                else if (Array.isArray(t.text)) {
                  let C = !1;
                  this.parentNode === null && (this.parentNode = t, C = !0);
                  for (let b = 0, nA = t.text.length; b < nA; b++)
                    t.text[b] = this.preprocessNode(t.text[b]);
                  C && (this.parentNode = null);
                }
                return t;
              }
              preprocessToc(t) {
                if (t.toc.id || (t.toc.id = "_default_"), t.toc.title = t.toc.title ? this.preprocessNode(t.toc.title) : null, t.toc._items = [], this.tocs[t.toc.id]) {
                  if (!this.tocs[t.toc.id].toc._pseudo)
                    throw new Error(`TOC '${t.toc.id}' already exists`);
                  t.toc._items = this.tocs[t.toc.id].toc._items;
                }
                return this.tocs[t.toc.id] = t, t;
              }
              preprocessImage(t) {
                return t.image.type !== void 0 && t.image.data !== void 0 && t.image.type === "Buffer" && Array.isArray(t.image.data) && (t.image = CA.from(t.image.data)), t;
              }
              preprocessCanvas(t) {
                return t;
              }
              preprocessSVG(t) {
                return t;
              }
              preprocessQr(t) {
                return t;
              }
              preprocessAttachment(t) {
                return t;
              }
              _getNodeForNodeRef(t) {
                return this.parentNode ? this.parentNode : t;
              }
            }
            const tA = k;
            var lA = r(7571), uA = r(3915), w = {};
            const v = 5, RA = 12, DA = 13, $ = 16, cA = 17, $A = 22, kA = 28, WA = 31, EA = 33, zA = 34, OA = 35, xA = 36, LA = 37, yA = 38, TA = 39, fA = 40, sA = 41, F = 42, o = 0, h = 1, _ = 2, oA = 3, p = 4, rA = [
              //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
              [
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                oA,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p,
                p
              ],
              [
                o,
                p,
                p,
                h,
                h,
                p,
                p,
                p,
                p,
                h,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                p,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                p,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                h,
                o,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                o,
                h,
                p,
                p,
                p,
                o,
                o,
                h,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                o,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                p,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h,
                h
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                h,
                h,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                h,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                h,
                h,
                h,
                h,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                h,
                h,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                h,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                h,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                o,
                h,
                o,
                o,
                o,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                h,
                p,
                p,
                h,
                h,
                h,
                p,
                p,
                p,
                h,
                h,
                h,
                h,
                h,
                o,
                h,
                h,
                h,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ],
              [
                o,
                p,
                p,
                h,
                h,
                o,
                p,
                p,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                p,
                _,
                p,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                o,
                h,
                o
              ]
              // CB
            ], QA = uA.toByteArray("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"), bA = new lA(QA), y = function(NA) {
              switch (NA) {
                case EA:
                  return RA;
                case TA:
                case fA:
                case F:
                  return RA;
                case OA:
                  return v;
                default:
                  return NA;
              }
            }, M = function(NA) {
              switch (NA) {
                case LA:
                case yA:
                  return zA;
                case sA:
                  return $A;
                default:
                  return NA;
              }
            };
            class FA {
              constructor(t, C = !1) {
                this.position = t, this.required = C;
              }
            }
            class dA {
              nextCodePoint() {
                const t = this.string.charCodeAt(this.pos++), C = this.string.charCodeAt(this.pos);
                return 55296 <= t && t <= 56319 && 56320 <= C && C <= 57343 ? (this.pos++, (t - 55296) * 1024 + (C - 56320) + 65536) : t;
              }
              nextCharClass() {
                return y(bA.get(this.nextCodePoint()));
              }
              getSimpleBreak() {
                switch (this.nextClass) {
                  case sA:
                    return !1;
                  case zA:
                  case LA:
                  case yA:
                    return this.curClass = zA, !1;
                  case xA:
                    return this.curClass = xA, !1;
                }
                return null;
              }
              getPairTableBreak(t) {
                let C = !1;
                switch (rA[this.curClass][this.nextClass]) {
                  case o:
                    C = !0;
                    break;
                  case h:
                    C = t === sA;
                    break;
                  case _:
                    if (C = t === sA, !C)
                      return C = !1, C;
                    break;
                  case oA:
                    if (t !== sA) return C;
                    break;
                }
                return this.LB8a && (C = !1), this.LB21a && (this.curClass === $ || this.curClass === cA) ? (C = !1, this.LB21a = !1) : this.LB21a = this.curClass === DA, this.curClass === kA ? (this.LB30a++, this.LB30a == 2 && this.nextClass === kA && (C = !0, this.LB30a = 0)) : this.LB30a = 0, this.curClass = this.nextClass, C;
              }
              nextBreak() {
                if (this.curClass == null) {
                  let t = this.nextCharClass();
                  this.curClass = M(t), this.nextClass = t, this.LB8a = t === WA, this.LB30a = 0;
                }
                for (; this.pos < this.string.length; ) {
                  this.lastPos = this.pos;
                  const t = this.nextClass;
                  if (this.nextClass = this.nextCharClass(), this.curClass === zA || this.curClass === xA && this.nextClass !== LA)
                    return this.curClass = M(y(this.nextClass)), new FA(this.lastPos, !0);
                  let C = this.getSimpleBreak();
                  if (C === null && (C = this.getPairTableBreak(t)), this.LB8a = this.nextClass === WA, C) return new FA(this.lastPos);
                }
                return this.lastPos < this.string.length ? (this.lastPos = this.string.length, new FA(this.string.length)) : null;
              }
              constructor(t) {
                this.string = t, this.pos = 0, this.lastPos = 0, this.curClass = null, this.nextClass = null, this.LB8a = !1, this.LB21a = !1, this.LB30a = 0;
              }
            }
            w = dA;
            class he {
              /**
               * @param {object} styleDictionary named styles dictionary
               * @param {object} defaultStyle optional default style definition
               */
              constructor(t, C) {
                C === void 0 && (C = {}), this.styleDictionary = t, this.defaultStyle = C, this.styleOverrides = [];
              }
              /**
               * Creates cloned version of current stack
               *
               * @returns {StyleContextStack} current stack snapshot
               */
              clone() {
                let t = new he(this.styleDictionary, this.defaultStyle);
                return this.styleOverrides.forEach((C) => {
                  t.styleOverrides.push(C);
                }), t;
              }
              /**
               * Pushes style-name or style-overrides-object onto the stack for future evaluation
               *
               * @param {string|object} styleNameOrOverride style-name (referring to styleDictionary) or
               *                                            a new dictionary defining overriding properties
               */
              push(t) {
                this.styleOverrides.push(t);
              }
              /**
               * Removes last style-name or style-overrides-object from the stack
               *
               * @param {number} howMany optional number of elements to be popped (if not specified,
               *                         one element will be removed from the stack)
               */
              pop(t) {
                for (t === void 0 && (t = 1); t-- > 0; )
                  this.styleOverrides.pop();
              }
              /**
               * Creates a set of named styles or/and a style-overrides-object based on the item,
               * pushes those elements onto the stack for future evaluation and returns the number
               * of elements pushed, so they can be easily popped then.
               *
               * @param {object} item - an object with optional style property and/or style overrides
               * @returns {number} the number of items pushed onto the stack
               */
              autopush(t) {
                if (P(t) || typeof t.section < "u")
                  return 0;
                let C = [];
                t.style && (Array.isArray(t.style) ? C = t.style : C = [t.style]);
                for (let b = 0, nA = C.length; b < nA; b++)
                  this.push(C[b]);
                return this.push(t), C.length + 1;
              }
              /**
               * Automatically pushes elements onto the stack, using autopush based on item,
               * executes callback and then pops elements back. Returns value returned by callback
               *
               * @param {object} item - an object with optional style property and/or style overrides
               * @param {Function} callback to be called between autopush and pop
               * @returns {object} value returned by callback
               */
              auto(t, C) {
                let b = this.autopush(t), nA = C();
                return b > 0 && this.pop(b), nA;
              }
              /**
               * Evaluates stack and returns value of a named property
               *
               * @param {string} property - property name
               * @returns {?any} property value or null if not found
               */
              getProperty(t) {
                var C = this;
                const b = function(nA, gA, hA) {
                  if (hA === void 0 && (hA = /* @__PURE__ */ new Set()), hA.has(nA))
                    return;
                  hA.add(nA);
                  const HA = C.styleDictionary[nA];
                  if (HA) {
                    if (K(HA[gA]))
                      return HA[gA];
                    if (HA.extends) {
                      let GA = Array.isArray(HA.extends) ? HA.extends : [HA.extends];
                      for (let fe = GA.length - 1; fe >= 0; fe--) {
                        let we = b(GA[fe], gA, hA);
                        if (K(we))
                          return we;
                      }
                    }
                  }
                };
                if (this.styleOverrides)
                  for (let nA = this.styleOverrides.length - 1; nA >= 0; nA--) {
                    let gA = this.styleOverrides[nA];
                    if (P(gA)) {
                      let hA = b(gA, t);
                      if (K(hA))
                        return hA;
                    } else if (K(gA[t]))
                      return gA[t];
                  }
                return this.defaultStyle && this.defaultStyle[t];
              }
              /**
               * @param {object} item
               * @param {StyleContextStack} styleContextStack
               * @param {string} property
               * @param {any} defaultValue
               * @returns {any}
               */
              static getStyleProperty(t, C, b, nA) {
                let gA;
                return K(t[b]) ? t[b] : C ? (C.auto(t, () => {
                  gA = C.getProperty(b);
                }), K(gA) ? gA : nA) : nA;
              }
              /**
               * @param {object} source
               * @param {object} destination
               * @returns {object}
               */
              static copyStyle(t, C) {
                t === void 0 && (t = {}), C === void 0 && (C = {});
                for (let b in t)
                  b != "text" && t.hasOwnProperty(b) && (C[b] = t[b]);
                return C;
              }
            }
            const ie = he, KA = function(NA, t, C) {
              C === void 0 && (C = !1);
              let b = [];
              if (NA == null ? NA = "" : NA = String(NA), t)
                return b.push({
                  text: NA
                }), b;
              if (C)
                return NA.split("").map((HA) => HA.match(/^\n$|^\r$/) ? {
                  text: "",
                  lineEnd: !0
                } : {
                  text: HA
                });
              if (NA.length === 0)
                return b.push({
                  text: ""
                }), b;
              let nA = new w(NA), gA = 0, hA;
              for (; hA = nA.nextBreak(); ) {
                let HA = NA.slice(gA, hA.position);
                hA.required || HA.match(/\r?\n$|\r$/) ? (HA = HA.replace(/\r?\n$|\r$/, ""), b.push({
                  text: HA,
                  lineEnd: !0
                })) : b.push({
                  text: HA
                }), gA = hA.position;
              }
              return b;
            }, Pe = (NA, t) => {
              let C = NA[0];
              if (C === void 0)
                return null;
              if (t) {
                let b = KA(C.text, !1);
                if (b[0] === void 0)
                  return null;
                C = b[0];
              }
              return C.text;
            }, Je = (NA, t) => {
              let C = NA[NA.length - 1];
              if (C === void 0 || C.lineEnd)
                return null;
              if (t) {
                let b = KA(C.text, !1);
                if (b[b.length - 1] === void 0)
                  return null;
                C = b[b.length - 1];
              }
              return C.text;
            };
            class Le {
              /**
               * @param {string|Array} texts
               * @param {StyleContextStack} styleContextStack
               * @returns {Array}
               */
              getBreaks(t, C) {
                let b = [];
                Array.isArray(t) || (t = [t]);
                let nA = null;
                for (let gA = 0, hA = t.length; gA < hA; gA++) {
                  let HA = t[gA], GA = null, fe, we = ie.getStyleProperty(HA || {}, C, "wordBreak", "normal") === "break-all", ye = ie.getStyleProperty(HA || {}, C, "noWrap", !1);
                  if (q(HA) ? (HA._textRef && HA._textRef._textNodeRef.text && (HA.text = HA._textRef._textNodeRef.text), fe = KA(HA.text, ye, we), GA = ie.copyStyle(HA)) : fe = KA(HA, ye, we), nA && fe.length) {
                    let De = Pe(fe, ye);
                    KA(nA + De, !1).length === 1 && (b[b.length - 1].noNewLine = !0);
                  }
                  for (let De = 0, g = fe.length; De < g; De++) {
                    let s = {
                      text: fe[De].text
                    };
                    fe[De].lineEnd && (s.lineEnd = !0), ie.copyStyle(GA, s), b.push(s);
                  }
                  nA = null, gA + 1 < hA && (nA = Je(fe, ye));
                }
                return b;
              }
            }
            const Re = Le, _e = /^(\s)+/g, se = /(\s)+$/g, Ee = (NA) => {
              function t(C) {
                return C.reduce((b, nA) => {
                  let gA = Array.isArray(nA.text) ? t(nA.text) : nA, hA = [].concat(gA).some(Array.isArray);
                  return b.concat(hA ? t(gA) : gA);
                }, []);
              }
              return Array.isArray(NA) || (NA = [NA]), NA = t(NA), NA;
            };
            class wA {
              /**
               * @param {object} pdfDocument object is instance of PDFDocument
               */
              constructor(t) {
                this.pdfDocument = t;
              }
              /**
               * Converts an array of strings (or inline-definition-objects) into a collection
               * of inlines and calculated minWidth/maxWidth and their min/max widths
               *
               * @param {Array|object} textArray an array of inline-definition-objects (or strings)
               * @param {StyleContextStack} styleContextStack current style stack
               * @returns {object} collection of inlines, minWidth, maxWidth
               */
              buildInlines(t, C) {
                const b = (ye) => Math.max(0, ye.width - ye.leadingCut - ye.trailingCut);
                let nA = 0, gA = 0, hA, HA = Ee(t), fe = new Re().getBreaks(HA, C), we = this.measure(fe, C);
                return we.forEach((ye) => {
                  nA = Math.max(nA, b(ye)), hA || (hA = {
                    width: 0,
                    leadingCut: ye.leadingCut,
                    trailingCut: 0
                  }), hA.width += ye.width, hA.trailingCut = ye.trailingCut, gA = Math.max(gA, b(hA)), ye.lineEnd && (hA = null);
                }), ie.getStyleProperty({}, C, "noWrap", !1) && (nA = gA), {
                  items: we,
                  minWidth: nA,
                  maxWidth: gA
                };
              }
              measure(t, C) {
                if (t.length) {
                  let b = ie.getStyleProperty(t[0], C, "leadingIndent", 0);
                  b && (t[0].leadingCut = -b, t[0].leadingIndent = b);
                }
                return t.forEach((b) => {
                  let nA = ie.getStyleProperty(b, C, "font", "Roboto"), gA = ie.getStyleProperty(b, C, "bold", !1), hA = ie.getStyleProperty(b, C, "italics", !1);
                  b.font = this.pdfDocument.provideFont(nA, gA, hA), b.alignment = ie.getStyleProperty(b, C, "alignment", "left"), b.fontSize = ie.getStyleProperty(b, C, "fontSize", 12), b.fontFeatures = ie.getStyleProperty(b, C, "fontFeatures", null), b.characterSpacing = ie.getStyleProperty(b, C, "characterSpacing", 0), b.color = ie.getStyleProperty(b, C, "color", "black"), b.decoration = ie.getStyleProperty(b, C, "decoration", null), b.decorationColor = ie.getStyleProperty(b, C, "decorationColor", null), b.decorationStyle = ie.getStyleProperty(b, C, "decorationStyle", null), b.decorationThickness = ie.getStyleProperty(b, C, "decorationThickness", null), b.background = ie.getStyleProperty(b, C, "background", null), b.link = ie.getStyleProperty(b, C, "link", null), b.linkToPage = ie.getStyleProperty(b, C, "linkToPage", null), b.linkToDestination = ie.getStyleProperty(b, C, "linkToDestination", null), b.noWrap = ie.getStyleProperty(b, C, "noWrap", null), b.opacity = ie.getStyleProperty(b, C, "opacity", 1), b.sup = ie.getStyleProperty(b, C, "sup", !1), b.sub = ie.getStyleProperty(b, C, "sub", !1), (b.sup || b.sub) && (b.fontSize *= 0.58);
                  let HA = ie.getStyleProperty(b, C, "lineHeight", 1);
                  if (b.width = this.widthOfText(b.text, b), b.height = b.font.lineHeight(b.fontSize) * HA, b.leadingCut || (b.leadingCut = 0), !ie.getStyleProperty(b, C, "preserveLeadingSpaces", !1)) {
                    let we = b.text.match(_e);
                    we && (b.leadingCut += this.widthOfText(we[0], b));
                  }
                  if (b.trailingCut = 0, !ie.getStyleProperty(b, C, "preserveTrailingSpaces", !1)) {
                    let we = b.text.match(se);
                    we && (b.trailingCut = this.widthOfText(we[0], b));
                  }
                }, this), t;
              }
              /**
               * Width of text
               *
               * @param {string} text
               * @param {object} inline
               * @returns {number}
               */
              widthOfText(t, C) {
                return C.font.widthOfString(t, C.fontSize, C.fontFeatures) + (C.characterSpacing || 0) * (t.length - 1);
              }
              /**
               * Returns size of the specified string (without breaking it) using the current style
               *
               * @param {string} text text to be measured
               * @param {object} styleContextStack current style stack
               * @returns {object} size of the specified string
               */
              sizeOfText(t, C) {
                let b = ie.getStyleProperty({}, C, "font", "Roboto"), nA = ie.getStyleProperty({}, C, "fontSize", 12), gA = ie.getStyleProperty({}, C, "fontFeatures", null), hA = ie.getStyleProperty({}, C, "bold", !1), HA = ie.getStyleProperty({}, C, "italics", !1), GA = ie.getStyleProperty({}, C, "lineHeight", 1), fe = ie.getStyleProperty({}, C, "characterSpacing", 0), we = this.pdfDocument.provideFont(b, hA, HA);
                return {
                  width: this.widthOfText(t, {
                    font: we,
                    fontSize: nA,
                    characterSpacing: fe,
                    fontFeatures: gA
                  }),
                  height: we.lineHeight(nA) * GA,
                  fontSize: nA,
                  lineHeight: GA,
                  ascender: we.ascender / 1e3 * nA,
                  descender: we.descender / 1e3 * nA
                };
              }
              /**
               * Returns size of the specified rotated string (without breaking it) using the current style
               *
               * @param {string} text text to be measured
               * @param {number} angle
               * @param {object} styleContextStack current style stack
               * @returns {object} size of the specified string
               */
              sizeOfRotatedText(t, C, b) {
                let nA = C * Math.PI / -180, gA = this.sizeOfText(t, b);
                return {
                  width: Math.abs(gA.height * Math.sin(nA)) + Math.abs(gA.width * Math.cos(nA)),
                  height: Math.abs(gA.width * Math.sin(nA)) + Math.abs(gA.height * Math.cos(nA))
                };
              }
            }
            const N = wA;
            function G(NA, t, C, b) {
              C === void 0 && (C = 0);
              let nA = [], gA = 0, hA = 0, HA = [], GA = 0, fe = 0, we = [], ye = t;
              NA.forEach((s) => {
                W(s) ? (nA.push(s), gA += s._minWidth, hA += s._maxWidth) : aA(s) ? (HA.push(s), GA = Math.max(GA, s._minWidth), fe = Math.max(fe, s._maxWidth)) : we.push(s);
              }), we.forEach((s, I) => {
                if (P(s.width) && /\d+%/.test(s.width)) {
                  let f = 0;
                  if (b) {
                    const iA = b._layout.paddingLeft(I, b), YA = b._layout.paddingRight(I, b), XA = b._layout.vLineWidth(I, b), oe = b._layout.vLineWidth(I + 1, b);
                    I === 0 ? f = iA + YA + XA + oe / 2 : I === we.length - 1 ? f = iA + YA + XA / 2 + oe : f = iA + YA + XA / 2 + oe / 2;
                  }
                  const S = ye + C;
                  s.width = parseFloat(s.width) * S / 100 - f;
                }
                s.width < s._minWidth && s.elasticWidth ? s._calcWidth = s._minWidth : s._calcWidth = s.width, t -= s._calcWidth;
              });
              let De = gA + GA * HA.length, g = hA + fe * HA.length;
              if (De >= t)
                nA.forEach((s) => {
                  s._calcWidth = s._minWidth;
                }), HA.forEach((s) => {
                  s._calcWidth = GA;
                });
              else {
                if (g < t)
                  nA.forEach((s) => {
                    s._calcWidth = s._maxWidth, t -= s._calcWidth;
                  });
                else {
                  let s = t - De, I = g - De;
                  nA.forEach((f) => {
                    let S = f._maxWidth - f._minWidth;
                    f._calcWidth = f._minWidth + S * s / I, t -= f._calcWidth;
                  });
                }
                if (HA.length > 0) {
                  let s = t / HA.length;
                  HA.forEach((I) => {
                    I._calcWidth = s;
                  });
                }
              }
            }
            function W(NA) {
              return NA.width === "auto";
            }
            function aA(NA) {
              return NA.width === null || NA.width === void 0 || NA.width === "*" || NA.width === "star";
            }
            function j(NA) {
              let t = {
                min: 0,
                max: 0
              }, C = {
                min: 0,
                max: 0
              }, b = 0;
              for (let nA = 0, gA = NA.length; nA < gA; nA++) {
                let hA = NA[nA];
                aA(hA) ? (C.min = Math.max(C.min, hA._minWidth), C.max = Math.max(C.max, hA._maxWidth), b++) : W(hA) ? (t.min += hA._minWidth, t.max += hA._maxWidth) : (t.min += hA.width !== void 0 && hA.width || hA._minWidth, t.max += hA.width !== void 0 && hA.width || hA._maxWidth);
              }
              return b && (t.min += b * C.min, t.max += b * C.max), t;
            }
            const pA = {
              buildColumnWidths: G,
              measureMinMax: j,
              isAutoColumn: W,
              isStarColumn: aA
            }, Be = {
              noBorders: {
                hLineWidth(NA) {
                  return 0;
                },
                vLineWidth(NA) {
                  return 0;
                },
                paddingLeft(NA) {
                  return NA && 4 || 0;
                },
                paddingRight(NA, t) {
                  return NA < t.table.widths.length - 1 ? 4 : 0;
                }
              },
              headerLineOnly: {
                hLineWidth(NA, t) {
                  return NA === 0 || NA === t.table.body.length ? 0 : NA === t.table.headerRows ? 2 : 0;
                },
                vLineWidth(NA) {
                  return 0;
                },
                paddingLeft(NA) {
                  return NA === 0 ? 0 : 8;
                },
                paddingRight(NA, t) {
                  return NA === t.table.widths.length - 1 ? 0 : 8;
                }
              },
              lightHorizontalLines: {
                hLineWidth(NA, t) {
                  return NA === 0 || NA === t.table.body.length ? 0 : NA === t.table.headerRows ? 2 : 1;
                },
                vLineWidth(NA) {
                  return 0;
                },
                hLineColor(NA) {
                  return NA === 1 ? "black" : "#aaa";
                },
                paddingLeft(NA) {
                  return NA === 0 ? 0 : 8;
                },
                paddingRight(NA, t) {
                  return NA === t.table.widths.length - 1 ? 0 : 8;
                }
              }
            }, Ie = {
              hLineWidth(NA, t) {
                return 1;
              },
              vLineWidth(NA, t) {
                return 1;
              },
              hLineColor(NA, t) {
                return "black";
              },
              vLineColor(NA, t) {
                return "black";
              },
              hLineStyle(NA, t) {
                return null;
              },
              vLineStyle(NA, t) {
                return null;
              },
              paddingLeft(NA, t) {
                return 4;
              },
              paddingRight(NA, t) {
                return 4;
              },
              paddingTop(NA, t) {
                return 2;
              },
              paddingBottom(NA, t) {
                return 2;
              },
              fillColor(NA, t) {
                return null;
              },
              fillOpacity(NA, t) {
                return 1;
              },
              defaultBorder: !0
            };
            function ee() {
              let NA = {};
              for (let t = 0, C = arguments.length; t < C; t++) {
                let b = t < 0 || arguments.length <= t ? void 0 : arguments[t];
                if (b)
                  for (let nA in b)
                    b.hasOwnProperty(nA) && (NA[nA] = b[nA]);
              }
              return NA;
            }
            function Me(NA, t, C) {
              switch (NA.type) {
                case "ellipse":
                case "rect":
                  NA.x += t, NA.y += C;
                  break;
                case "line":
                  NA.x1 += t, NA.x2 += t, NA.y1 += C, NA.y2 += C;
                  break;
                case "polyline":
                  for (let b = 0, nA = NA.points.length; b < nA; b++)
                    NA.points[b].x += t, NA.points[b].y += C;
                  break;
              }
            }
            function MA(NA) {
              return () => (
                // copy to new object
                JSON.parse(JSON.stringify(NA))
              );
            }
            for (var be = [null, [[10, 7, 17, 13], [1, 1, 1, 1], []], [[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]], [[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]], [[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]], [[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]], [[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]], [[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]], [[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]], [[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]], [[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]], [[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]], [[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]], [[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]], [[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]], [[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]], [[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]], [[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]], [[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]], [[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]], [[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]], [[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]], [[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]], [[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]], [[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]], [[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]], [[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]], [[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]], [[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]], [[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]], [[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]], [[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]], [[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]], [[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]], [[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]], [[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]], [[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]], [[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]], [[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]], [[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]], [[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]], at = 0, V = 1, me = 2, Ye = 4, SA = 8, ue = /^\d*$/, Fe = /^[A-Za-z0-9 $%*+\-./:]*$/, tt = /^[A-Z0-9 $%*+\-./:]*$/, We = 1, Ze = 0, Ct = 3, fi = 2, st = [], xt = [-1], Mt = 0, zt = 1; Mt < 255; ++Mt)
              st.push(zt), xt[zt] = Mt, zt = zt * 2 ^ (zt >= 128 ? 285 : 0);
            for (var Xt = [[]], Mt = 0; Mt < 30; ++Mt) {
              for (var xi = Xt[Mt], mi = [], Ot = 0; Ot <= Mt; ++Ot) {
                var vt = Ot < Mt ? st[xi[Ot]] : 0, Zt = st[(Mt + (xi[Ot - 1] || 0)) % 255];
                mi.push(xt[vt ^ Zt]);
              }
              Xt.push(mi);
            }
            for (var ei = {}, Mt = 0; Mt < 45; ++Mt)
              ei["0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:".charAt(Mt)] = Mt;
            var Ke = [function(NA, t) {
              return (NA + t) % 2 === 0;
            }, function(NA, t) {
              return NA % 2 === 0;
            }, function(NA, t) {
              return t % 3 === 0;
            }, function(NA, t) {
              return (NA + t) % 3 === 0;
            }, function(NA, t) {
              return ((NA / 2 | 0) + (t / 3 | 0)) % 2 === 0;
            }, function(NA, t) {
              return NA * t % 2 + NA * t % 3 === 0;
            }, function(NA, t) {
              return (NA * t % 2 + NA * t % 3) % 2 === 0;
            }, function(NA, t) {
              return ((NA + t) % 2 + NA * t % 3) % 2 === 0;
            }], qe = function(NA) {
              return NA > 6;
            }, Dt = function(NA) {
              return 4 * NA + 17;
            }, ut = function(NA) {
              var t = be[NA], C = 16 * NA * NA + 128 * NA + 64;
              return qe(NA) && (C -= 36), t[2].length && (C -= 25 * t[2].length * t[2].length - 10 * t[2].length - 55), C;
            }, ni = function(NA, t) {
              var C = ut(NA) & -8, b = be[NA];
              return C -= 8 * b[0][t] * b[1][t], C;
            }, wi = function(NA, t) {
              switch (t) {
                case V:
                  return NA < 10 ? 10 : NA < 27 ? 12 : 14;
                case me:
                  return NA < 10 ? 9 : NA < 27 ? 11 : 13;
                case Ye:
                  return NA < 10 ? 8 : 16;
                case SA:
                  return NA < 10 ? 8 : NA < 27 ? 10 : 12;
              }
            }, Yi = function(NA, t, C) {
              var b = ni(NA, C) - 4 - wi(NA, t);
              switch (t) {
                case V:
                  return (b / 10 | 0) * 3 + (b % 10 < 4 ? 0 : b % 10 < 7 ? 1 : 2);
                case me:
                  return (b / 11 | 0) * 2 + (b % 11 < 6 ? 0 : 1);
                case Ye:
                  return b / 8 | 0;
                case SA:
                  return b / 13 | 0;
              }
            }, vA = function(NA, t) {
              switch (NA) {
                case V:
                  return t.match(ue) ? t : null;
                case me:
                  return t.match(Fe) ? t.toUpperCase() : null;
                case Ye:
                  if (typeof t == "string") {
                    for (var C = [], b = 0; b < t.length; ++b) {
                      var nA = t.charCodeAt(b);
                      nA < 128 ? C.push(nA) : nA < 2048 ? C.push(192 | nA >> 6, 128 | nA & 63) : nA < 65536 ? C.push(224 | nA >> 12, 128 | nA >> 6 & 63, 128 | nA & 63) : C.push(240 | nA >> 18, 128 | nA >> 12 & 63, 128 | nA >> 6 & 63, 128 | nA & 63);
                    }
                    return C;
                  } else
                    return t;
              }
            }, UA = function(NA, t, C, b) {
              var nA = [], gA = 0, hA = 8, HA = C.length, GA = function(ye, De) {
                if (De >= hA) {
                  for (nA.push(gA | ye >> (De -= hA)); De >= 8; ) nA.push(ye >> (De -= 8) & 255);
                  gA = 0, hA = 8;
                }
                De > 0 && (gA |= (ye & (1 << De) - 1) << (hA -= De));
              }, fe = wi(NA, t);
              switch (GA(t, 4), GA(HA, fe), t) {
                case V:
                  for (var we = 2; we < HA; we += 3)
                    GA(parseInt(C.substring(we - 2, we + 1), 10), 10);
                  GA(parseInt(C.substring(we - 2), 10), [0, 4, 7][HA % 3]);
                  break;
                case me:
                  for (var we = 1; we < HA; we += 2)
                    GA(ei[C.charAt(we - 1)] * 45 + ei[C.charAt(we)], 11);
                  HA % 2 == 1 && GA(ei[C.charAt(we - 1)], 6);
                  break;
                case Ye:
                  for (var we = 0; we < HA; ++we)
                    GA(C[we], 8);
                  break;
              }
              for (GA(at, 4), hA < 8 && nA.push(gA); nA.length + 1 < b; ) nA.push(236, 17);
              return nA.length < b && nA.push(236), nA;
            }, mA = function(NA, t) {
              for (var C = NA.slice(0), b = NA.length, nA = t.length, gA = 0; gA < nA; ++gA) C.push(0);
              for (var gA = 0; gA < b; ) {
                var hA = xt[C[gA++]];
                if (hA >= 0)
                  for (var HA = 0; HA < nA; ++HA)
                    C[gA + HA] ^= st[(hA + t[HA]) % 255];
              }
              return C.slice(b);
            }, qA = function(NA, t, C) {
              for (var b = [], nA = NA.length / t | 0, gA = 0, hA = t - NA.length % t, HA = 0; HA < hA; ++HA)
                b.push(gA), gA += nA;
              for (var HA = hA; HA < t; ++HA)
                b.push(gA), gA += nA + 1;
              b.push(gA);
              for (var GA = [], HA = 0; HA < t; ++HA)
                GA.push(mA(NA.slice(b[HA], b[HA + 1]), C));
              for (var fe = [], we = NA.length / t | 0, HA = 0; HA < we; ++HA)
                for (var ye = 0; ye < t; ++ye)
                  fe.push(NA[b[ye] + HA]);
              for (var ye = hA; ye < t; ++ye)
                fe.push(NA[b[ye + 1] - 1]);
              for (var HA = 0; HA < C.length; ++HA)
                for (var ye = 0; ye < t; ++ye)
                  fe.push(GA[ye][HA]);
              return fe;
            }, _A = function(NA, t, C, b) {
              for (var nA = NA << b, gA = t - 1; gA >= 0; --gA)
                nA >> b + gA & 1 && (nA ^= C << gA);
              return NA << b | nA;
            }, jA = function(NA) {
              for (var t = be[NA], C = Dt(NA), b = [], nA = [], gA = 0; gA < C; ++gA)
                b.push([]), nA.push([]);
              var hA = function(s, I, f, S, iA) {
                for (var YA = 0; YA < f; ++YA)
                  for (var XA = 0; XA < S; ++XA)
                    b[s + YA][I + XA] = iA[YA] >> XA & 1, nA[s + YA][I + XA] = 1;
              };
              hA(0, 0, 9, 9, [127, 65, 93, 93, 93, 65, 383, 0, 64]), hA(C - 8, 0, 8, 9, [256, 127, 65, 93, 93, 93, 65, 127]), hA(0, C - 8, 9, 8, [254, 130, 186, 186, 186, 130, 254, 0, 0]);
              for (var gA = 9; gA < C - 8; ++gA)
                b[6][gA] = b[gA][6] = ~gA & 1, nA[6][gA] = nA[gA][6] = 1;
              for (var HA = t[2], GA = HA.length, gA = 0; gA < GA; ++gA)
                for (var fe = gA === 0 || gA === GA - 1 ? 1 : 0, we = gA === 0 ? GA - 1 : GA, ye = fe; ye < we; ++ye)
                  hA(HA[gA], HA[ye], 5, 5, [31, 17, 21, 17, 31]);
              if (qe(NA))
                for (var De = _A(NA, 6, 7973, 12), g = 0, gA = 0; gA < 6; ++gA)
                  for (var ye = 0; ye < 3; ++ye)
                    b[gA][C - 11 + ye] = b[C - 11 + ye][gA] = De >> g++ & 1, nA[gA][C - 11 + ye] = nA[C - 11 + ye][gA] = 1;
              return {
                matrix: b,
                reserved: nA
              };
            }, le = function(NA, t, C) {
              for (var b = NA.length, nA = 0, gA = -1, hA = b - 1; hA >= 0; hA -= 2) {
                hA == 6 && --hA;
                for (var HA = gA < 0 ? b - 1 : 0, GA = 0; GA < b; ++GA) {
                  for (var fe = hA; fe > hA - 2; --fe)
                    t[HA][fe] || (NA[HA][fe] = C[nA >> 3] >> (~nA & 7) & 1, ++nA);
                  HA += gA;
                }
                gA = -gA;
              }
              return NA;
            }, JA = function(NA, t, C) {
              for (var b = Ke[C], nA = NA.length, gA = 0; gA < nA; ++gA)
                for (var hA = 0; hA < nA; ++hA)
                  t[gA][hA] || (NA[gA][hA] ^= b(gA, hA));
              return NA;
            }, ne = function(NA, t, C, b) {
              for (var nA = NA.length, gA = _A(C << 3 | b, 5, 1335, 10) ^ 21522, hA = 0; hA < 15; ++hA) {
                var HA = [0, 1, 2, 3, 4, 5, 7, 8, nA - 7, nA - 6, nA - 5, nA - 4, nA - 3, nA - 2, nA - 1][hA], GA = [nA - 1, nA - 2, nA - 3, nA - 4, nA - 5, nA - 6, nA - 7, nA - 8, 7, 5, 4, 3, 2, 1, 0][hA];
                NA[HA][8] = NA[8][GA] = gA >> hA & 1;
              }
              return NA;
            }, ae = function(NA) {
              for (var t = 3, C = 3, b = 40, nA = 10, gA = function(f) {
                for (var S = 0, iA = 0; iA < f.length; ++iA)
                  f[iA] >= 5 && (S += t + (f[iA] - 5));
                for (var iA = 5; iA < f.length; iA += 2) {
                  var YA = f[iA];
                  f[iA - 1] == YA && f[iA - 2] == 3 * YA && f[iA - 3] == YA && f[iA - 4] == YA && (f[iA - 5] >= 4 * YA || f[iA + 1] >= 4 * YA) && (S += b);
                }
                return S;
              }, hA = NA.length, HA = 0, GA = 0, fe = 0; fe < hA; ++fe) {
                var we = NA[fe], ye;
                ye = [0];
                for (var De = 0; De < hA; ) {
                  var g;
                  for (g = 0; De < hA && we[De]; ++g) ++De;
                  for (ye.push(g), g = 0; De < hA && !we[De]; ++g) ++De;
                  ye.push(g);
                }
                HA += gA(ye), ye = [0];
                for (var De = 0; De < hA; ) {
                  var g;
                  for (g = 0; De < hA && NA[De][fe]; ++g) ++De;
                  for (ye.push(g), g = 0; De < hA && !NA[De][fe]; ++g) ++De;
                  ye.push(g);
                }
                HA += gA(ye);
                var s = NA[fe + 1] || [];
                GA += we[0];
                for (var De = 1; De < hA; ++De) {
                  var I = we[De];
                  GA += I, we[De - 1] == I && s[De] === I && s[De - 1] === I && (HA += C);
                }
              }
              return HA += nA * (Math.abs(GA / hA / hA - 0.5) / 0.05 | 0), HA;
            }, ve = function(NA, t, C, b, nA) {
              var gA = be[t], hA = UA(t, C, NA, ni(t, b) >> 3);
              hA = qA(hA, gA[1][b], Xt[gA[0][b]]);
              var HA = jA(t), GA = HA.matrix, fe = HA.reserved;
              if (le(GA, fe, hA), nA < 0) {
                JA(GA, fe, 0), ne(GA, fe, b, 0);
                var we = 0, ye = ae(GA);
                for (JA(GA, fe, 0), nA = 1; nA < 8; ++nA) {
                  JA(GA, fe, nA), ne(GA, fe, b, nA);
                  var De = ae(GA);
                  ye > De && (ye = De, we = nA), JA(GA, fe, nA);
                }
                nA = we;
              }
              return JA(GA, fe, nA), ne(GA, fe, b, nA), GA;
            };
            function ze(NA, t) {
              var C = {
                numeric: V,
                alphanumeric: me,
                octet: Ye
              }, b = {
                L: We,
                M: Ze,
                Q: Ct,
                H: fi
              };
              t = t || {};
              var nA = t.version || -1, gA = b[(t.eccLevel || "L").toUpperCase()], hA = t.mode ? C[t.mode.toLowerCase()] : -1, HA = "mask" in t ? t.mask : -1;
              if (hA < 0)
                typeof NA == "string" ? NA.match(ue) ? hA = V : NA.match(tt) ? hA = me : hA = Ye : hA = Ye;
              else if (!(hA == V || hA == me || hA == Ye))
                throw "invalid or unsupported mode";
              if (NA = vA(hA, NA), NA === null) throw "invalid data format";
              if (gA < 0 || gA > 3) throw "invalid ECC level";
              if (nA < 0) {
                for (nA = 1; nA <= 40 && !(NA.length <= Yi(nA, hA, gA)); ++nA)
                  ;
                if (nA > 40) throw "too large data for the Qr format";
              } else if (nA < 1 || nA > 40)
                throw "invalid Qr version! should be between 1 and 40";
              if (HA != -1 && (HA < 0 || HA > 8)) throw "invalid mask";
              return ve(NA, nA, hA, gA, HA);
            }
            function At(NA, t) {
              var C = [], b = t.background || "#fff", nA = t.foreground || "#000", gA = t.padding || 0, hA = ze(NA, t), HA = hA.length, GA = Math.floor(t.fit ? t.fit / HA : 5), fe = HA * GA + GA * gA * 2, we = GA * gA;
              C.push({
                type: "rect",
                x: 0,
                y: 0,
                w: fe,
                h: fe,
                lineWidth: 0,
                color: b
              });
              for (var ye = 0; ye < HA; ++ye)
                for (var De = 0; De < HA; ++De)
                  hA[ye][De] && C.push({
                    type: "rect",
                    x: GA * De + we,
                    y: GA * ye + we,
                    w: GA,
                    h: GA,
                    lineWidth: 0,
                    color: nA
                  });
              return {
                canvas: C,
                size: fe
              };
            }
            function Bt(NA) {
              var t = At(NA.qr, NA);
              return NA._canvas = t.canvas, NA._width = NA._height = NA._minWidth = NA._maxWidth = NA._minHeight = NA._maxHeight = t.size, NA;
            }
            const He = {
              measure: Bt
            };
            class Ce {
              constructor(t, C, b, nA, gA) {
                this.pdfDocument = t, this.textInlines = new N(t), this.styleStack = new ie(C, b), this.svgMeasure = nA, this.tableLayouts = gA, this.autoImageIndex = 1;
              }
              /**
               * Measures all nodes and sets min/max-width properties required for the second
               * layout-pass.
               *
               * @param {object} docStructure document-definition-object
               * @returns {object} document-measurement-object
               */
              measureDocument(t) {
                return this.measureNode(t);
              }
              measureBlock(t) {
                return this.measureNode(t);
              }
              measureNode(t) {
                return this.styleStack.auto(t, () => {
                  if (t._margin = eA(t, this.styleStack), t.section)
                    return C(this.measureSection(t));
                  if (t.columns)
                    return C(this.measureColumns(t));
                  if (t.stack)
                    return C(this.measureVerticalContainer(t));
                  if (t.ul)
                    return C(this.measureUnorderedList(t));
                  if (t.ol)
                    return C(this.measureOrderedList(t));
                  if (t.table)
                    return C(this.measureTable(t));
                  if (t.text !== void 0)
                    return C(this.measureLeaf(t));
                  if (t.toc)
                    return C(this.measureToc(t));
                  if (t.image)
                    return C(this.measureImage(t));
                  if (t.svg)
                    return C(this.measureSVG(t));
                  if (t.canvas)
                    return C(this.measureCanvas(t));
                  if (t.qr)
                    return C(this.measureQr(t));
                  if (t.attachment)
                    return C(this.measureAttachment(t));
                  throw new Error(`Unrecognized document structure: ${T(t)}`);
                });
                function C(b) {
                  let nA = b._margin;
                  return nA && (b._minWidth += nA[0] + nA[2], b._maxWidth += nA[0] + nA[2]), b;
                }
              }
              measureImageWithDimensions(t, C) {
                if (t.fit) {
                  let b = C.width / C.height > t.fit[0] / t.fit[1] ? t.fit[0] / C.width : t.fit[1] / C.height;
                  t._width = t._minWidth = t._maxWidth = C.width * b, t._height = C.height * b;
                } else if (t.cover)
                  t._width = t._minWidth = t._maxWidth = t.cover.width, t._height = t._minHeight = t._maxHeight = t.cover.height;
                else {
                  let b = D(t.width) ? t.width : void 0, nA = D(t.height) ? t.height : void 0, gA = C.width / C.height;
                  t._width = t._minWidth = t._maxWidth = b || (nA ? nA * gA : C.width), t._height = nA || (b ? b / gA : C.height), D(t.maxWidth) && t.maxWidth < t._width && (t._width = t._minWidth = t._maxWidth = t.maxWidth, t._height = t._width * C.height / C.width), D(t.maxHeight) && t.maxHeight < t._height && (t._height = t.maxHeight, t._width = t._minWidth = t._maxWidth = t._height * C.width / C.height), D(t.minWidth) && t.minWidth > t._width && (t._width = t._minWidth = t._maxWidth = t.minWidth, t._height = t._width * C.height / C.width), D(t.minHeight) && t.minHeight > t._height && (t._height = t.minHeight, t._width = t._minWidth = t._maxWidth = t._height * C.width / C.height);
                }
                t._alignment = this.styleStack.getProperty("alignment");
              }
              convertIfBase64Image(t) {
                if (/^data:image\/(jpeg|jpg|png);base64,/.test(t.image)) {
                  let C = `$$pdfmake$$${this.autoImageIndex++}`;
                  this.pdfDocument.images[C] = t.image, t.image = C;
                }
              }
              measureImage(t) {
                this.convertIfBase64Image(t);
                let C = this.pdfDocument.provideImage(t.image), b = {
                  width: C.width,
                  height: C.height
                };
                return C.orientation > 4 && (b = {
                  width: C.height,
                  height: C.width
                }), this.measureImageWithDimensions(t, b), t;
              }
              measureSVG(t) {
                let C = this.svgMeasure.measureSVG(t.svg);
                if (this.measureImageWithDimensions(t, C), t.font = this.styleStack.getProperty("font"), !D(t._width) && !D(t._height))
                  throw new Error("SVG is missing defined width and height.");
                if (D(t._width)) {
                  if (!D(t._height))
                    throw new Error("SVG is missing defined height.");
                } else throw new Error("SVG is missing defined width.");
                return t.svg = this.svgMeasure.writeDimensions(t.svg, {
                  width: t._width,
                  height: t._height
                }), t;
              }
              measureLeaf(t) {
                t._textRef && t._textRef._textNodeRef.text && (t.text = t._textRef._textNodeRef.text);
                let C = this.styleStack.clone();
                C.push(t);
                let b = this.textInlines.buildInlines(t.text, C);
                return t._inlines = b.items, t._minWidth = b.minWidth, t._maxWidth = b.maxWidth, t;
              }
              measureToc(t) {
                if (t.toc.title && (t.toc.title = this.measureNode(t.toc.title)), t.toc._items.length > 0) {
                  let C = [], b = t.toc.textStyle || {}, nA = t.toc.numberStyle || b, gA = t.toc.textMargin || [0, 0, 0, 0];
                  t.toc.sortBy === "title" && t.toc._items.sort((hA, HA) => hA._textNodeRef.text.localeCompare(HA._textNodeRef.text, t.toc.sortLocale));
                  for (let hA = 0, HA = t.toc._items.length; hA < HA; hA++) {
                    let GA = t.toc._items[hA], fe = GA._textNodeRef.tocStyle || b, we = GA._textNodeRef.tocMargin || gA, ye = GA._textNodeRef.tocNumberStyle || nA, De = H(GA._nodeRef);
                    C.push([{
                      text: GA._textNodeRef.text,
                      linkToDestination: De,
                      alignment: "left",
                      style: fe,
                      margin: we
                    }, {
                      text: "00000",
                      linkToDestination: De,
                      alignment: "right",
                      _tocItemRef: GA._nodeRef,
                      style: ye,
                      margin: [0, we[1], 0, we[3]]
                    }]), t.toc.outlines && (GA._textNodeRef.outline = GA._textNodeRef.outline || !0);
                  }
                  t.toc._table = {
                    table: {
                      dontBreakRows: !0,
                      widths: ["*", "auto"],
                      body: C
                    },
                    layout: "noBorders"
                  }, t.toc._table = this.measureNode(t.toc._table);
                }
                return t;
              }
              measureVerticalContainer(t) {
                let C = t.stack;
                t._minWidth = 0, t._maxWidth = 0;
                for (let b = 0, nA = C.length; b < nA; b++)
                  C[b] = this.measureNode(C[b]), t._minWidth = Math.max(t._minWidth, C[b]._minWidth), t._maxWidth = Math.max(t._maxWidth, C[b]._maxWidth);
                return t;
              }
              gapSizeForList() {
                return this.textInlines.sizeOfText("9. ", this.styleStack);
              }
              buildUnorderedMarker(t, C, b, nA) {
                function gA(we, ye) {
                  let De = we.fontSize / 6;
                  return {
                    canvas: [{
                      x: De,
                      y: we.height / we.lineHeight + we.descender - we.fontSize / 3,
                      r1: De,
                      r2: De,
                      type: "ellipse",
                      color: ye
                    }]
                  };
                }
                function hA(we, ye) {
                  let De = we.fontSize / 3;
                  return {
                    canvas: [{
                      x: 0,
                      y: we.height / we.lineHeight + we.descender - we.fontSize / 3 - De / 2,
                      h: De,
                      w: De,
                      type: "rect",
                      color: ye
                    }]
                  };
                }
                function HA(we, ye) {
                  let De = we.fontSize / 6;
                  return {
                    canvas: [{
                      x: De,
                      y: we.height / we.lineHeight + we.descender - we.fontSize / 3,
                      r1: De,
                      r2: De,
                      type: "ellipse",
                      lineColor: ye
                    }]
                  };
                }
                let GA, fe = ie.getStyleProperty(t, C, "markerColor", void 0) || C.getProperty("color") || "black";
                switch (nA) {
                  case "circle":
                    GA = HA(b, fe);
                    break;
                  case "square":
                    GA = hA(b, fe);
                    break;
                  case "none":
                    GA = {};
                    break;
                  case "disc":
                  default:
                    GA = gA(b, fe);
                    break;
                }
                return GA._minWidth = GA._maxWidth = b.width, GA._minHeight = GA._maxHeight = b.height, GA;
              }
              buildOrderedMarker(t, C, b, nA, gA) {
                function hA(De) {
                  function g(s) {
                    return (s >= 26 ? g((s / 26 >> 0) - 1) : "") + "abcdefghijklmnopqrstuvwxyz"[s % 26 >> 0];
                  }
                  return De < 1 ? De.toString() : g(De - 1);
                }
                function HA(De) {
                  if (De < 1 || De > 4999)
                    return De.toString();
                  let g = De, s = {
                    M: 1e3,
                    CM: 900,
                    D: 500,
                    CD: 400,
                    C: 100,
                    XC: 90,
                    L: 50,
                    XL: 40,
                    X: 10,
                    IX: 9,
                    V: 5,
                    IV: 4,
                    I: 1
                  }, I = "";
                  for (let f in s)
                    for (; g >= s[f]; )
                      I += f, g -= s[f];
                  return I;
                }
                function GA(De) {
                  return De.toString();
                }
                let fe;
                switch (nA) {
                  case "none":
                    fe = null;
                    break;
                  case "upper-alpha":
                    fe = hA(C).toUpperCase();
                    break;
                  case "lower-alpha":
                    fe = hA(C);
                    break;
                  case "upper-roman":
                    fe = HA(C);
                    break;
                  case "lower-roman":
                    fe = HA(C).toLowerCase();
                    break;
                  case "decimal":
                  default:
                    fe = GA(C);
                    break;
                }
                if (fe === null)
                  return {};
                gA && (Array.isArray(gA) ? (gA[0] && (fe = gA[0] + fe), gA[1] && (fe += gA[1]), fe += " ") : fe += `${gA} `);
                let we = ie.getStyleProperty(t, b, "markerColor", void 0) || b.getProperty("color") || "black", ye = {
                  text: fe,
                  color: we
                };
                return {
                  _inlines: this.textInlines.buildInlines(ye, b).items
                };
              }
              measureUnorderedList(t) {
                let C = this.styleStack.clone(), b = t.ul;
                t.type = t.type || "disc", t._gapSize = this.gapSizeForList(), t._minWidth = 0, t._maxWidth = 0;
                for (let nA = 0, gA = b.length; nA < gA; nA++) {
                  let hA = b[nA] = this.measureNode(b[nA]);
                  !hA.ol && !hA.ul && (hA.listMarker = this.buildUnorderedMarker(hA, C, t._gapSize, hA.listType || t.type)), t._minWidth = Math.max(t._minWidth, b[nA]._minWidth + t._gapSize.width), t._maxWidth = Math.max(t._maxWidth, b[nA]._maxWidth + t._gapSize.width);
                }
                return t;
              }
              measureOrderedList(t) {
                let C = this.styleStack.clone(), b = t.ol;
                t.type = t.type || "decimal", t.separator = t.separator || ".", t.reversed = t.reversed || !1, D(t.start) || (t.start = t.reversed ? b.length : 1), t._gapSize = this.gapSizeForList(), t._minWidth = 0, t._maxWidth = 0;
                let nA = t.start;
                for (let gA = 0, hA = b.length; gA < hA; gA++) {
                  let HA = b[gA] = this.measureNode(b[gA]);
                  if (!HA.ol && !HA.ul) {
                    let GA = D(HA.counter) ? HA.counter : nA;
                    HA.listMarker = this.buildOrderedMarker(HA, GA, C, HA.listType || t.type, t.separator), HA.listMarker._inlines && (t._gapSize.width = Math.max(t._gapSize.width, HA.listMarker._inlines[0].width)), t.reversed ? nA-- : nA++;
                  }
                  t._minWidth = Math.max(t._minWidth, b[gA]._minWidth), t._maxWidth = Math.max(t._maxWidth, b[gA]._maxWidth);
                }
                t._minWidth += t._gapSize.width, t._maxWidth += t._gapSize.width;
                for (let gA = 0, hA = b.length; gA < hA; gA++) {
                  let HA = b[gA];
                  !HA.ol && !HA.ul && (HA.listMarker._minWidth = HA.listMarker._maxWidth = t._gapSize.width);
                }
                return t;
              }
              measureSection(t) {
                return t.section = this.measureNode(t.section), t;
              }
              measureColumns(t) {
                let C = t.columns;
                t._gap = this.styleStack.getProperty("columnGap") || 0;
                for (let gA = 0, hA = C.length; gA < hA; gA++)
                  C[gA] = this.measureNode(C[gA]);
                let b = pA.measureMinMax(C), nA = C.length > 0 ? C.length - 1 : 0;
                return t._minWidth = b.min + t._gap * nA, t._maxWidth = b.max + t._gap * nA, t;
              }
              measureTable(t) {
                I(t), t._layout = fe(this.tableLayouts), t._offsets = we(t._layout);
                let C = [], b, nA, gA, hA;
                for (b = 0, gA = t.table.body[0].length; b < gA; b++) {
                  let f = t.table.widths[b];
                  for (f._minWidth = 0, f._maxWidth = 0, nA = 0, hA = t.table.body.length; nA < hA; nA++) {
                    let S = t.table.body[nA], iA = S[b];
                    if (iA === void 0)
                      throw new Error(`Malformed table row, a cell is undefined.
Row index: ${nA}
Column index: ${b}
Row data: ${T(S)}`);
                    iA === null && (iA = ""), iA._span || (iA = S[b] = this.styleStack.auto(iA, GA(this, iA)), iA.colSpan && iA.colSpan > 1 ? (g(S, b, iA.colSpan), C.push({
                      col: b,
                      span: iA.colSpan,
                      minWidth: iA._minWidth,
                      maxWidth: iA._maxWidth
                    })) : (f._minWidth = Math.max(f._minWidth, iA._minWidth), f._maxWidth = Math.max(f._maxWidth, iA._maxWidth))), iA.rowSpan && iA.rowSpan > 1 && s(t.table, nA, b, iA.rowSpan);
                  }
                }
                ye();
                let HA = pA.measureMinMax(t.table.widths);
                return t._minWidth = HA.min + t._offsets.total, t._maxWidth = HA.max + t._offsets.total, t;
                function GA(f, S) {
                  return () => (q(S) && (S.fillColor = f.styleStack.getProperty("fillColor"), S.fillOpacity = f.styleStack.getProperty("fillOpacity")), f.measureNode(S));
                }
                function fe(f) {
                  let S = t.layout;
                  return P(S) && (S = f[S]), ee(Ie, S);
                }
                function we(f) {
                  let S = [], iA = 0, YA = 0;
                  for (let XA = 0, oe = t.table.widths.length; XA < oe; XA++) {
                    let pe = YA + f.vLineWidth(XA, t) + f.paddingLeft(XA, t);
                    S.push(pe), iA += pe, YA = f.paddingRight(XA, t);
                  }
                  return iA += YA + f.vLineWidth(t.table.widths.length, t), {
                    total: iA,
                    offsets: S
                  };
                }
                function ye() {
                  let f, S;
                  for (let iA = 0, YA = C.length; iA < YA; iA++) {
                    let XA = C[iA], oe = De(XA.col, XA.span, t._offsets), pe = XA.minWidth - oe.minWidth, xe = XA.maxWidth - oe.maxWidth;
                    if (pe > 0)
                      for (f = pe / XA.span, S = 0; S < XA.span; S++)
                        t.table.widths[XA.col + S]._minWidth += f;
                    if (xe > 0)
                      for (f = xe / XA.span, S = 0; S < XA.span; S++)
                        t.table.widths[XA.col + S]._maxWidth += f;
                  }
                }
                function De(f, S, iA) {
                  let YA = {
                    minWidth: 0,
                    maxWidth: 0
                  };
                  for (let XA = 0; XA < S; XA++)
                    YA.minWidth += t.table.widths[f + XA]._minWidth + (XA ? iA.offsets[f + XA] : 0), YA.maxWidth += t.table.widths[f + XA]._maxWidth + (XA ? iA.offsets[f + XA] : 0);
                  return YA;
                }
                function g(f, S, iA) {
                  for (let YA = 1; YA < iA; YA++)
                    f[S + YA] = {
                      _span: !0,
                      _minWidth: 0,
                      _maxWidth: 0,
                      rowSpan: f[S].rowSpan
                    };
                }
                function s(f, S, iA, YA) {
                  for (let XA = 1; XA < YA; XA++)
                    f.body[S + XA][iA] = {
                      _span: !0,
                      _minWidth: 0,
                      _maxWidth: 0,
                      fillColor: f.body[S][iA].fillColor,
                      fillOpacity: f.body[S][iA].fillOpacity
                    };
                }
                function I(f) {
                  if (f.table.widths || (f.table.widths = "auto"), P(f.table.widths))
                    for (f.table.widths = [f.table.widths]; f.table.widths.length < f.table.body[0].length; )
                      f.table.widths.push(f.table.widths[f.table.widths.length - 1]);
                  for (let S = 0, iA = f.table.widths.length; S < iA; S++) {
                    let YA = f.table.widths[S];
                    (D(YA) || P(YA)) && (f.table.widths[S] = {
                      width: YA
                    });
                  }
                }
              }
              measureCanvas(t) {
                let C = 0, b = 0;
                for (let nA = 0, gA = t.canvas.length; nA < gA; nA++) {
                  let hA = t.canvas[nA];
                  switch (hA.type) {
                    case "ellipse":
                      C = Math.max(C, hA.x + hA.r1), b = Math.max(b, hA.y + hA.r2);
                      break;
                    case "rect":
                      C = Math.max(C, hA.x + hA.w), b = Math.max(b, hA.y + hA.h);
                      break;
                    case "line":
                      C = Math.max(C, hA.x1, hA.x2), b = Math.max(b, hA.y1, hA.y2);
                      break;
                    case "polyline":
                      for (let HA = 0, GA = hA.points.length; HA < GA; HA++)
                        C = Math.max(C, hA.points[HA].x), b = Math.max(b, hA.points[HA].y);
                      break;
                  }
                }
                return t._minWidth = t._maxWidth = C, t._minHeight = t._maxHeight = b, t._alignment = this.styleStack.getProperty("alignment"), t;
              }
              measureQr(t) {
                return t = He.measure(t), t._alignment = this.styleStack.getProperty("alignment"), t;
              }
              measureAttachment(t) {
                return t._width = t.width || 7, t._height = t.height || 18, t;
              }
            }
            const je = Ce;
            var it = r(4785);
            class Et extends it.EventEmitter {
              constructor() {
                super(), this.pages = [], this.pageMargins = void 0, this.x = void 0, this.availableWidth = void 0, this.availableHeight = void 0, this.page = -1, this.snapshots = [], this.backgroundLength = [];
              }
              beginColumnGroup(t, C, b, nA, gA) {
                C === void 0 && (C = {}), b === void 0 && (b = !1), nA === void 0 && (nA = 0), gA === void 0 && (gA = null), this.snapshots.push({
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  page: this.page,
                  bottomByPage: C || {},
                  bottomMost: {
                    x: this.x,
                    y: this.y,
                    availableHeight: this.availableHeight,
                    availableWidth: this.availableWidth,
                    page: this.page
                  },
                  lastColumnWidth: this.lastColumnWidth,
                  snakingColumns: b,
                  gap: nA,
                  columnWidths: gA
                }), this.lastColumnWidth = 0, t && (this.marginXTopParent = t);
              }
              updateBottomByPage() {
                const t = this.snapshots[this.snapshots.length - 1];
                if (!t)
                  return;
                const C = this.page;
                let b = -Number.MIN_VALUE;
                t.bottomByPage && t.bottomByPage[C] && (b = t.bottomByPage[C]), t.bottomByPage && (t.bottomByPage[C] = Math.max(b, this.y));
              }
              resetMarginXTopParent() {
                this.marginXTopParent = null;
              }
              /**
               * Find the most recent (deepest) snaking column group snapshot.
               * @returns {object|null}
               */
              getSnakingSnapshot() {
                for (let t = this.snapshots.length - 1; t >= 0; t--)
                  if (this.snapshots[t].snakingColumns)
                    return this.snapshots[t];
                return null;
              }
              inSnakingColumns() {
                return !!this.getSnakingSnapshot();
              }
              /**
               * Check if we're inside a nested non-snaking column group (e.g., a table row)
               * within an outer snaking column group. This is used to prevent snaking-specific
               * breaks inside table cells — the table's own page break mechanism should handle
               * row breaks, and column breaks should happen between rows.
               * @returns {boolean}
               */
              isInNestedNonSnakingGroup() {
                for (let t = this.snapshots.length - 1; t >= 0; t--) {
                  let C = this.snapshots[t];
                  if (C.snakingColumns)
                    return !1;
                  if (!C.overflowed)
                    return !0;
                }
                return !1;
              }
              beginColumn(t, C, b) {
                let nA = this.snapshots[this.snapshots.length - 1];
                if (nA && nA.overflowed) {
                  for (let gA = this.snapshots.length - 1; gA >= 0; gA--)
                    if (!this.snapshots[gA].overflowed) {
                      nA = this.snapshots[gA];
                      break;
                    }
                }
                this.calculateBottomMost(nA, b), this.page = nA.page, this.x = this.x + this.lastColumnWidth + (C || 0), this.y = nA.y, this.availableWidth = t, this.availableHeight = nA.availableHeight, this.lastColumnWidth = t;
              }
              calculateBottomMost(t, C) {
                C ? this.saveContextInEndingCell(C) : t.bottomMost = Nt(this, t.bottomMost);
              }
              markEnding(t, C, b) {
                this.page = t._columnEndingContext.page, this.x = t._columnEndingContext.x + C, this.y = t._columnEndingContext.y - b, this.availableWidth = t._columnEndingContext.availableWidth, this.availableHeight = t._columnEndingContext.availableHeight, this.lastColumnWidth = t._columnEndingContext.lastColumnWidth;
              }
              saveContextInEndingCell(t) {
                t._columnEndingContext = {
                  page: this.page,
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  lastColumnWidth: this.lastColumnWidth
                };
              }
              completeColumnGroup(t, C) {
                let b = this.snapshots.pop(), nA = this.y, gA = this.page, hA = this.availableHeight;
                for (; b && b.overflowed; ) {
                  let GA = Nt({
                    page: gA,
                    y: nA,
                    availableHeight: hA
                  }, b.bottomMost || {});
                  gA = GA.page, nA = GA.y, hA = GA.availableHeight, b = this.snapshots.pop();
                }
                if (!b)
                  return {};
                (gA > b.bottomMost.page || gA === b.bottomMost.page && nA > b.bottomMost.y) && (b.bottomMost = {
                  x: b.x,
                  y: nA,
                  page: gA,
                  availableHeight: hA,
                  availableWidth: b.availableWidth
                }), this.calculateBottomMost(b, C), this.x = b.x;
                let HA = b.bottomMost.y;
                return t && (b.page === b.bottomMost.page ? b.y + t > HA && (HA = b.y + t) : HA += t), this.y = HA, this.page = b.bottomMost.page, this.availableWidth = b.availableWidth, this.availableHeight = b.bottomMost.availableHeight, t && (this.availableHeight -= HA - b.bottomMost.y), t && b.bottomMost.y - b.y < t ? this.height = t : this.height = b.bottomMost.y - b.y, this.lastColumnWidth = b.lastColumnWidth, b.bottomByPage;
              }
              /**
               * Move to the next column in a column group (snaking columns).
               * Creates an overflowed snapshot to track that we've moved to the next column.
               * @returns {object} Position info for the new column
               */
              moveToNextColumn() {
                let t = this.y, C = this.getSnakingSnapshot();
                if (!C)
                  return {
                    prevY: t,
                    y: this.y
                  };
                this.calculateBottomMost(C, null);
                let b = 0;
                for (let GA = this.snapshots.length - 1; GA >= 0 && this.snapshots[GA].overflowed; GA--)
                  b++;
                let nA = C.columnWidths && C.columnWidths[b] || this.lastColumnWidth || this.availableWidth, gA = C.columnWidths && C.columnWidths[b + 1] || nA;
                this.lastColumnWidth = gA;
                let hA = this.x + (nA || 0) + (C.gap || 0), HA = C.y;
                this.snapshots.push({
                  x: hA,
                  y: HA,
                  availableHeight: C.availableHeight,
                  availableWidth: gA,
                  page: this.page,
                  overflowed: !0,
                  bottomMost: {
                    x: hA,
                    y: HA,
                    availableHeight: C.availableHeight,
                    availableWidth: gA,
                    page: this.page
                  },
                  lastColumnWidth: gA,
                  snakingColumns: !0,
                  gap: C.gap,
                  columnWidths: C.columnWidths
                }), this.x = hA, this.y = HA, this.availableHeight = C.availableHeight, this.availableWidth = gA;
                for (let GA = this.snapshots.length - 2; GA >= 0; GA--) {
                  let fe = this.snapshots[GA];
                  if (fe.overflowed || fe.snakingColumns)
                    break;
                  fe.x = hA, fe.y = HA, fe.page = this.page, fe.availableHeight = C.availableHeight, fe.bottomMost && (fe.bottomMost.x = hA, fe.bottomMost.y = HA, fe.bottomMost.page = this.page, fe.bottomMost.availableHeight = C.availableHeight);
                }
                return {
                  prevY: t,
                  y: this.y
                };
              }
              /**
               * Reset snaking column state when moving to a new page.
               * Clears overflowed snapshots, resets X to left margin, sets width to first column,
               * and syncs all snapshots to new page coordinates.
               */
              resetSnakingColumnsForNewPage() {
                let t = this.getSnakingSnapshot();
                if (!t)
                  return;
                let C = this.pageMargins.top, b = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom, nA = t.columnWidths ? t.columnWidths[0] : this.lastColumnWidth || this.availableWidth;
                for (; this.snapshots.length > 1 && this.snapshots[this.snapshots.length - 1].overflowed; )
                  this.snapshots.pop();
                this.marginXTopParent ? this.x = this.pageMargins.left + this.marginXTopParent[0] : this.x = this.pageMargins.left, this.availableWidth = nA, this.lastColumnWidth = nA;
                for (let gA = 0; gA < this.snapshots.length; gA++) {
                  let hA = this.snapshots[gA], HA = !!hA.snakingColumns;
                  hA.x = this.x, hA.y = HA ? C : this.y, hA.availableHeight = HA ? b : this.availableHeight, hA.page = this.page, hA.bottomMost && (hA.bottomMost.x = this.x, hA.bottomMost.y = HA ? C : this.y, hA.bottomMost.availableHeight = HA ? b : this.availableHeight, hA.bottomMost.page = this.page);
                }
              }
              addMargin(t, C) {
                this.x += t, this.availableWidth -= t + (C || 0);
              }
              moveDown(t) {
                return this.y += t, this.availableHeight -= t, this.availableHeight > 0;
              }
              initializePage() {
                this.y = this.pageMargins.top, this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
                const {
                  pageCtx: t,
                  isSnapshot: C
                } = this.pageSnapshot();
                t.availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right, C && this.marginXTopParent && (t.availableWidth -= this.marginXTopParent[0], t.availableWidth -= this.marginXTopParent[1]);
              }
              pageSnapshot() {
                return this.snapshots[0] ? {
                  pageCtx: this.snapshots[0],
                  isSnapshot: !0
                } : {
                  pageCtx: this,
                  isSnapshot: !1
                };
              }
              moveTo(t, C) {
                t != null && (this.x = t, this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right), C != null && (this.y = C, this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom);
              }
              moveToRelative(t, C) {
                t != null && (this.x = this.x + t), C != null && (this.y = this.y + C);
              }
              beginDetachedBlock() {
                this.snapshots.push({
                  x: this.x,
                  y: this.y,
                  availableHeight: this.availableHeight,
                  availableWidth: this.availableWidth,
                  page: this.page,
                  lastColumnWidth: this.lastColumnWidth
                });
              }
              endDetachedBlock() {
                let t = this.snapshots.pop();
                this.x = t.x, this.y = t.y, this.availableWidth = t.availableWidth, this.availableHeight = t.availableHeight, this.page = t.page, this.lastColumnWidth = t.lastColumnWidth;
              }
              moveToNextPage(t) {
                let C = this.page + 1, b = this.page, nA = this.y;
                if (this.snapshots.length > 0) {
                  let hA = this.snapshots[this.snapshots.length - 1];
                  hA.bottomMost && hA.bottomMost.y && (nA = Math.max(this.y, hA.bottomMost.y));
                }
                let gA = C >= this.pages.length;
                if (gA) {
                  let hA = this.availableWidth, HA = this.getCurrentPage().pageSize.orientation, GA = Qt(this.getCurrentPage(), t);
                  this.addPage(GA, null, this.getCurrentPage().customProperties), HA === GA.orientation && (this.availableWidth = hA);
                } else
                  this.page = C, this.initializePage();
                return {
                  newPageCreated: gA,
                  prevPage: b,
                  prevY: nA,
                  y: this.y
                };
              }
              addPage(t, C, b) {
                C === void 0 && (C = null), b === void 0 && (b = {}), C !== null && (this.pageMargins = C, this.x = C.left, this.availableWidth = t.width - C.left - C.right);
                let nA = {
                  items: [],
                  pageSize: t,
                  pageMargins: this.pageMargins,
                  customProperties: b
                };
                return this.pages.push(nA), this.backgroundLength.push(0), this.page = this.pages.length - 1, this.initializePage(), this.emit("pageAdded", nA), nA;
              }
              getCurrentPage() {
                return this.page < 0 || this.page >= this.pages.length ? null : this.pages[this.page];
              }
              getCurrentPosition() {
                let t = this.getCurrentPage().pageSize, C = t.height - this.pageMargins.top - this.pageMargins.bottom, b = t.width - this.pageMargins.left - this.pageMargins.right;
                return {
                  pageNumber: this.page + 1,
                  pageOrientation: t.orientation,
                  pageInnerHeight: C,
                  pageInnerWidth: b,
                  left: this.x,
                  top: this.y,
                  verticalRatio: (this.y - this.pageMargins.top) / C,
                  horizontalRatio: (this.x - this.pageMargins.left) / b
                };
              }
            }
            function Ft(NA, t) {
              return NA === void 0 ? t : P(NA) && NA.toLowerCase() === "landscape" ? "landscape" : "portrait";
            }
            const Qt = (NA, t) => (t = Ft(t, NA.pageSize.orientation), t !== NA.pageSize.orientation ? {
              orientation: t,
              width: NA.pageSize.height,
              height: NA.pageSize.width
            } : {
              orientation: NA.pageSize.orientation,
              width: NA.pageSize.width,
              height: NA.pageSize.height
            });
            function Nt(NA, t) {
              let C;
              return NA.page > t.page ? C = NA : t.page > NA.page ? C = t : C = NA.y > t.y ? NA : t, {
                page: C.page,
                x: C.x,
                y: C.y,
                availableHeight: C.availableHeight,
                availableWidth: C.availableWidth
              };
            }
            const gt = Et;
            class yt extends it.EventEmitter {
              /**
               * @param {DocumentContext} context
               */
              constructor(t) {
                super(), this._context = t, this.contextStack = [];
              }
              /**
               * @returns {DocumentContext}
               */
              context() {
                return this._context;
              }
              addLine(t, C, b) {
                let nA = t.getHeight(), gA = this.context(), hA = gA.getCurrentPage(), HA = this.getCurrentPositionOnPage();
                return gA.availableHeight < nA || !hA ? !1 : (t.x = gA.x + (t.x || 0), t.y = gA.y + (t.y || 0), this.alignLine(t), oi(hA, {
                  type: "line",
                  item: t
                }, b), this.emit("lineAdded", t), C || gA.moveDown(nA), HA);
              }
              alignLine(t) {
                let C = this.context().availableWidth, b = t.getWidth(), nA = t.inlines && t.inlines.length > 0 && t.inlines[0].alignment, gA = 0;
                switch (nA) {
                  case "right":
                    gA = C - b;
                    break;
                  case "center":
                    gA = (C - b) / 2;
                    break;
                }
                if (gA && (t.x = (t.x || 0) + gA), nA === "justify" && !t.newLineForced && !t.lastLineInParagraph && t.inlines.length > 1) {
                  let hA = (C - b) / (t.inlines.length - 1);
                  for (let HA = 1, GA = t.inlines.length; HA < GA; HA++)
                    gA = HA * hA, t.inlines[HA].x += gA, t.inlines[HA].justifyShift = hA;
                }
              }
              addImage(t, C) {
                let b = this.context(), nA = b.getCurrentPage(), gA = this.getCurrentPositionOnPage();
                return !nA || t.absolutePosition === void 0 && b.availableHeight < t._height && nA.items.length > 0 ? !1 : (t._x === void 0 && (t._x = t.x || 0), t.x = b.x + t._x, t.y = b.y, this.alignImage(t), oi(nA, {
                  type: "image",
                  item: t
                }, C), b.moveDown(t._height), gA);
              }
              addCanvas(t, C) {
                let b = this.context(), nA = b.getCurrentPage(), gA = [], hA = t._minHeight;
                return !nA || t.absolutePosition === void 0 && b.availableHeight < hA ? !1 : (this.alignCanvas(t), t.canvas.forEach(function(HA) {
                  let GA = this.addVector(HA, !1, !1, C);
                  gA.push(GA), C !== void 0 && C++;
                }, this), b.moveDown(hA), gA);
              }
              addSVG(t, C) {
                let b = this.context(), nA = b.getCurrentPage(), gA = this.getCurrentPositionOnPage();
                return !nA || t.absolutePosition === void 0 && b.availableHeight < t._height && nA.items.length > 0 ? !1 : (t._x === void 0 && (t._x = t.x || 0), t.x = b.x + t._x, t.y = b.y, this.alignImage(t), oi(nA, {
                  type: "svg",
                  item: t
                }, C), b.moveDown(t._height), gA);
              }
              addQr(t, C) {
                let b = this.context(), nA = b.getCurrentPage(), gA = this.getCurrentPositionOnPage();
                if (!nA || t.absolutePosition === void 0 && b.availableHeight < t._height)
                  return !1;
                t._x === void 0 && (t._x = t.x || 0), t.x = b.x + t._x, t.y = b.y, this.alignImage(t);
                for (let hA = 0, HA = t._canvas.length; hA < HA; hA++) {
                  let GA = t._canvas[hA];
                  GA.x += t.x, GA.y += t.y, this.addVector(GA, !0, !0, C);
                }
                return b.moveDown(t._height), gA;
              }
              addAttachment(t, C) {
                let b = this.context(), nA = b.getCurrentPage(), gA = this.getCurrentPositionOnPage();
                return !nA || t.absolutePosition === void 0 && b.availableHeight < t._height && nA.items.length > 0 ? !1 : (t._x === void 0 && (t._x = t.x || 0), t.x = b.x + t._x, t.y = b.y, oi(nA, {
                  type: "attachment",
                  item: t
                }, C), b.moveDown(t._height), gA);
              }
              alignImage(t) {
                let C = this.context().availableWidth, b = t._minWidth, nA = 0;
                switch (t._alignment) {
                  case "right":
                    nA = C - b;
                    break;
                  case "center":
                    nA = (C - b) / 2;
                    break;
                }
                nA && (t.x = (t.x || 0) + nA);
              }
              alignCanvas(t) {
                let C = this.context().availableWidth, b = t._minWidth, nA = 0;
                switch (t._alignment) {
                  case "right":
                    nA = C - b;
                    break;
                  case "center":
                    nA = (C - b) / 2;
                    break;
                }
                nA && t.canvas.forEach((gA) => {
                  Me(gA, nA, 0);
                });
              }
              addVector(t, C, b, nA, gA) {
                let hA = this.context(), HA = hA.getCurrentPage();
                D(gA) && (HA = hA.pages[gA]);
                let GA = this.getCurrentPositionOnPage();
                if (HA)
                  return Me(t, C ? 0 : hA.x, b ? 0 : hA.y), oi(HA, {
                    type: "vector",
                    item: t
                  }, nA), GA;
              }
              beginClip(t, C) {
                let b = this.context();
                return b.getCurrentPage().items.push({
                  type: "beginClip",
                  item: {
                    x: b.x,
                    y: b.y,
                    width: t,
                    height: C
                  }
                }), !0;
              }
              endClip() {
                return this.context().getCurrentPage().items.push({
                  type: "endClip"
                }), !0;
              }
              beginVerticalAlignment(t) {
                let C = this.context().getCurrentPage(), b = {
                  type: "beginVerticalAlignment",
                  item: {
                    verticalAlignment: t
                  }
                };
                return C.items.push(b), b;
              }
              endVerticalAlignment(t) {
                let C = this.context().getCurrentPage(), b = {
                  type: "endVerticalAlignment",
                  item: {
                    verticalAlignment: t
                  }
                };
                return C.items.push(b), b;
              }
              addFragment(t, C, b, nA) {
                let gA = this.context(), hA = gA.getCurrentPage();
                return !C && t.height > gA.availableHeight ? !1 : (t.items.forEach((HA) => {
                  switch (HA.type) {
                    case "line":
                      var GA = HA.item.clone();
                      GA._node && (GA._node.positions[0].pageNumber = gA.page + 1), GA.x = (GA.x || 0) + (C ? t.xOffset || 0 : gA.x), GA.y = (GA.y || 0) + (b ? t.yOffset || 0 : gA.y), hA.items.push({
                        type: "line",
                        item: GA
                      });
                      break;
                    case "vector":
                      var fe = ee(HA.item);
                      if (Me(fe, C ? t.xOffset || 0 : gA.x, b ? t.yOffset || 0 : gA.y), fe._isFillColorFromUnbreakable) {
                        delete fe._isFillColorFromUnbreakable;
                        const ye = gA.backgroundLength[gA.page];
                        hA.items.splice(ye, 0, {
                          type: "vector",
                          item: fe
                        });
                      } else
                        hA.items.push({
                          type: "vector",
                          item: fe
                        });
                      break;
                    case "image":
                    case "svg":
                    case "beginClip":
                    case "endClip":
                    case "beginVerticalAlignment":
                    case "endVerticalAlignment":
                      var we = ee(HA.item);
                      we.x = (we.x || 0) + (C ? t.xOffset || 0 : gA.x), we.y = (we.y || 0) + (b ? t.yOffset || 0 : gA.y), hA.items.push({
                        type: HA.type,
                        item: we
                      });
                      break;
                  }
                }), nA || gA.moveDown(t.height), !0);
              }
              /**
               * Pushes the provided context onto the stack or creates a new one
               *
               * pushContext(context) - pushes the provided context and makes it current
               * pushContext(width, height) - creates and pushes a new context with the specified width and height
               * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
               *
               * @param {DocumentContext|number} contextOrWidth
               * @param {number} height
               */
              pushContext(t, C) {
                if (t === void 0 && (C = this.context().getCurrentPage().height - this.context().pageMargins.top - this.context().pageMargins.bottom, t = this.context().availableWidth), D(t)) {
                  let b = t;
                  t = new gt(), t.addPage({
                    width: b,
                    height: C
                  }, {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                  });
                }
                this.contextStack.push(this.context()), this._context = t;
              }
              popContext() {
                this._context = this.contextStack.pop();
              }
              getCurrentPositionOnPage() {
                return (this.contextStack[0] || this.context()).getCurrentPosition();
              }
            }
            function oi(NA, t, C) {
              C == null || C < 0 || C > NA.items.length ? NA.items.push(t) : NA.items.splice(C, 0, t);
            }
            const Ai = yt, _t = {
              "4A0": [4767.87, 6740.79],
              "2A0": [3370.39, 4767.87],
              A0: [2383.94, 3370.39],
              A1: [1683.78, 2383.94],
              A2: [1190.55, 1683.78],
              A3: [841.89, 1190.55],
              A4: [595.28, 841.89],
              A5: [419.53, 595.28],
              A6: [297.64, 419.53],
              A7: [209.76, 297.64],
              A8: [147.4, 209.76],
              A9: [104.88, 147.4],
              A10: [73.7, 104.88],
              B0: [2834.65, 4008.19],
              B1: [2004.09, 2834.65],
              B2: [1417.32, 2004.09],
              B3: [1000.63, 1417.32],
              B4: [708.66, 1000.63],
              B5: [498.9, 708.66],
              B6: [354.33, 498.9],
              B7: [249.45, 354.33],
              B8: [175.75, 249.45],
              B9: [124.72, 175.75],
              B10: [87.87, 124.72],
              C0: [2599.37, 3676.54],
              C1: [1836.85, 2599.37],
              C2: [1298.27, 1836.85],
              C3: [918.43, 1298.27],
              C4: [649.13, 918.43],
              C5: [459.21, 649.13],
              C6: [323.15, 459.21],
              C7: [229.61, 323.15],
              C8: [161.57, 229.61],
              C9: [113.39, 161.57],
              C10: [79.37, 113.39],
              RA0: [2437.8, 3458.27],
              RA1: [1729.13, 2437.8],
              RA2: [1218.9, 1729.13],
              RA3: [864.57, 1218.9],
              RA4: [609.45, 864.57],
              SRA0: [2551.18, 3628.35],
              SRA1: [1814.17, 2551.18],
              SRA2: [1275.59, 1814.17],
              SRA3: [907.09, 1275.59],
              SRA4: [637.8, 907.09],
              EXECUTIVE: [521.86, 756],
              FOLIO: [612, 936],
              LEGAL: [612, 1008],
              LETTER: [612, 792],
              TABLOID: [792, 1224]
            };
            function St(NA, t) {
              function C(gA) {
                return P(gA) ? (gA = gA.toLowerCase(), gA === "portrait" && nA.width > nA.height || gA === "landscape" && nA.width < nA.height) : !1;
              }
              function b(gA) {
                if (P(gA)) {
                  let hA = _t[gA.toUpperCase()];
                  if (!hA)
                    throw new Error(`Page size ${gA} not recognized`);
                  return {
                    width: hA[0],
                    height: hA[1]
                  };
                }
                return gA;
              }
              NA && NA.height === "auto" && (NA.height = 1 / 0);
              let nA = b(NA || "A4");
              return C(t) && (nA = {
                width: nA.height,
                height: nA.width
              }), nA.orientation = nA.width > nA.height ? "landscape" : "portrait", nA;
            }
            function ri(NA) {
              if (D(NA))
                NA = {
                  left: NA,
                  right: NA,
                  top: NA,
                  bottom: NA
                };
              else if (Array.isArray(NA))
                if (NA.length === 2)
                  NA = {
                    left: NA[0],
                    top: NA[1],
                    right: NA[0],
                    bottom: NA[1]
                  };
                else if (NA.length === 4)
                  NA = {
                    left: NA[0],
                    top: NA[1],
                    right: NA[2],
                    bottom: NA[3]
                  };
                else
                  throw new Error("Invalid pageMargins definition");
              return NA;
            }
            class gn extends Ai {
              /**
               * @param {DocumentContext} context
               */
              constructor(t) {
                super(t), this.transactionLevel = 0, this.repeatables = [];
              }
              addLine(t, C, b) {
                return this._fitOnPage(() => super.addLine(t, C, b));
              }
              addImage(t, C) {
                return this._fitOnPage(() => super.addImage(t, C));
              }
              addCanvas(t, C) {
                return this._fitOnPage(() => super.addCanvas(t, C));
              }
              addSVG(t, C) {
                return this._fitOnPage(() => super.addSVG(t, C));
              }
              addQr(t, C) {
                return this._fitOnPage(() => super.addQr(t, C));
              }
              addAttachment(t, C) {
                return this._fitOnPage(() => super.addAttachment(t, C));
              }
              addVector(t, C, b, nA, gA) {
                return super.addVector(t, C, b, nA, gA);
              }
              beginClip(t, C) {
                return super.beginClip(t, C);
              }
              endClip() {
                return super.endClip();
              }
              beginVerticalAlignment(t) {
                return super.beginVerticalAlignment(t);
              }
              endVerticalAlignment(t) {
                return super.endVerticalAlignment(t);
              }
              addFragment(t, C, b, nA) {
                return this._fitOnPage(() => super.addFragment(t, C, b, nA));
              }
              moveToNextPage(t) {
                let C = this.context().moveToNextPage(t);
                this.repeatables.forEach(function(b) {
                  b.insertedOnPages[this.context().page] === void 0 ? (b.insertedOnPages[this.context().page] = !0, this.addFragment(b, !0)) : this.context().moveDown(b.height);
                }, this), this.emit("pageChanged", {
                  prevPage: C.prevPage,
                  prevY: C.prevY,
                  y: this.context().y
                });
              }
              addPage(t, C, b, nA) {
                nA === void 0 && (nA = {});
                let gA = this.page, hA = this.y;
                this.context().addPage(St(t, C), ri(b), nA), this.emit("pageChanged", {
                  prevPage: gA,
                  prevY: hA,
                  y: this.context().y
                });
              }
              beginUnbreakableBlock(t, C) {
                this.transactionLevel++ === 0 && (this.originalX = this.context().x, this.pushContext(t, C));
              }
              commitUnbreakableBlock(t, C) {
                if (--this.transactionLevel === 0) {
                  let b = this.context();
                  this.popContext();
                  let nA = b.pages.length;
                  if (nA > 0) {
                    let gA = b.pages[0];
                    if (gA.xOffset = t, gA.yOffset = C, nA > 1)
                      if (t !== void 0 || C !== void 0)
                        gA.height = b.getCurrentPage().pageSize.height - b.pageMargins.top - b.pageMargins.bottom;
                      else {
                        gA.height = this.context().getCurrentPage().pageSize.height - this.context().pageMargins.top - this.context().pageMargins.bottom;
                        for (let hA = 0, HA = this.repeatables.length; hA < HA; hA++)
                          gA.height -= this.repeatables[hA].height;
                      }
                    else
                      gA.height = b.y;
                    t !== void 0 || C !== void 0 ? super.addFragment(gA, !0, !0, !0) : this.addFragment(gA);
                  }
                }
              }
              currentBlockToRepeatable() {
                let t = this.context(), C = {
                  items: []
                };
                return t.pages[0].items.forEach((b) => {
                  C.items.push(b);
                }), C.xOffset = this.originalX, C.height = t.y, C.insertedOnPages = [], C;
              }
              pushToRepeatables(t) {
                this.repeatables.push(t);
              }
              popFromRepeatables() {
                this.repeatables.pop();
              }
              /**
               * Move to the next column in a column group (snaking columns).
               * Handles repeatables and emits columnChanged event.
               */
              moveToNextColumn() {
                let t = this.context().moveToNextColumn();
                this.repeatables.forEach(function(C) {
                  this.addFragment(C, !1);
                }, this), this.emit("columnChanged", {
                  prevY: t.prevY,
                  y: this.context().y
                });
              }
              /**
               * Check if currently in a column group that can move to next column.
               * Only returns true if snakingColumns is enabled for the column group.
               * @returns {boolean}
               */
              canMoveToNextColumn() {
                let t = this.context(), C = t.getSnakingSnapshot();
                if (C) {
                  for (let De = t.snapshots.length - 1; De >= 0; De--) {
                    let g = t.snapshots[De];
                    if (g.snakingColumns)
                      break;
                    if (!g.overflowed)
                      return !1;
                  }
                  let b = 0;
                  for (let De = t.snapshots.length - 1; De >= 0 && t.snapshots[De].overflowed; De--)
                    b++;
                  if (C.columnWidths && b >= C.columnWidths.length - 1)
                    return !1;
                  let nA = t.availableWidth || t.lastColumnWidth || 0, gA = C.columnWidths ? C.columnWidths[b + 1] : nA, hA = t.x + nA + (C.gap || 0), HA = t.getCurrentPage(), GA = HA.pageSize.width, fe = HA.pageMargins ? HA.pageMargins.right : 0, we = t.marginXTopParent ? t.marginXTopParent[1] : 0, ye = GA - fe - we;
                  return hA + gA <= ye + 1;
                }
                return !1;
              }
              _fitOnPage(t) {
                let C = t();
                if (!C && (this.canMoveToNextColumn() && (this.moveToNextColumn(), C = t()), !C)) {
                  let b = this.context();
                  if (b.getSnakingSnapshot()) {
                    if (b.isInNestedNonSnakingGroup())
                      this.moveToNextPage();
                    else {
                      this.moveToNextPage();
                      let gA = b.lastColumnWidth;
                      b.resetSnakingColumnsForNewPage(), b.lastColumnWidth = gA;
                    }
                    C = t();
                  } else {
                    for (; b.snapshots.length > 0 && b.snapshots[b.snapshots.length - 1].overflowed; ) {
                      let gA = b.snapshots.pop(), hA = b.snapshots[b.snapshots.length - 1];
                      hA && (b.x = hA.x, b.y = hA.y, b.availableHeight = hA.availableHeight, b.availableWidth = gA.availableWidth, b.lastColumnWidth = hA.lastColumnWidth);
                    }
                    this.moveToNextPage(), C = t();
                  }
                }
                return C;
              }
            }
            const Pi = gn;
            class Fi {
              constructor(t) {
                this.tableNode = t;
              }
              beginTable(t) {
                const C = () => {
                  let GA = 0;
                  return gA.table.widths.forEach((fe) => {
                    GA += fe._calcWidth;
                  }), GA;
                }, b = () => {
                  let GA = [], fe = 0, we;
                  GA.push({
                    left: 0,
                    rowSpan: 0
                  });
                  for (let ye = 0, De = this.tableNode.table.body[0].length; ye < De; ye++) {
                    let g = this.layout.paddingLeft(ye, this.tableNode) + this.layout.paddingRight(ye, this.tableNode), s = this.layout.vLineWidth(ye, this.tableNode);
                    we = g + s + this.tableNode.table.widths[ye]._calcWidth, GA[GA.length - 1].width = we, fe += we, GA.push({
                      left: fe,
                      rowSpan: 0,
                      width: 0
                    });
                  }
                  return GA;
                }, nA = (GA) => {
                  for (let we = 0; we < GA.length; we++) {
                    let ye = GA[we];
                    for (let De = 0; De < ye.length; De++) {
                      let g = ye[De];
                      if (g.border) {
                        let s = g.rowSpan || 1, I = g.colSpan || 1;
                        for (let f = 0; f < s; f++)
                          g.border[0] !== void 0 && f > 0 && fe(we + f, De, 0, g.border[0]), g.border[2] !== void 0 && fe(we + f, De + I - 1, 2, g.border[2]);
                        for (let f = 0; f < I; f++)
                          g.border[1] !== void 0 && f > 0 && fe(we, De + f, 1, g.border[1]), g.border[3] !== void 0 && fe(we + s - 1, De + f, 3, g.border[3]);
                      }
                    }
                  }
                  function fe(we, ye, De, g) {
                    let s = GA[we][ye];
                    s.border = s.border || {}, s.border[De] = g;
                  }
                };
                let gA, hA;
                gA = this.tableNode, this.offsets = gA._offsets, this.layout = gA._layout, hA = t.context().availableWidth - this.offsets.total, pA.buildColumnWidths(gA.table.widths, hA, this.offsets.total, gA), this.tableWidth = gA._offsets.total + C(), this.rowSpanData = b(), this.cleanUpRepeatables = !1, this.headerRows = 0, this.rowsWithoutPageBreak = 0;
                const HA = gA.table.headerRows;
                if (J(HA)) {
                  if (this.headerRows = HA, this.headerRows > gA.table.body.length)
                    throw new Error(`Too few rows in the table. Property headerRows requires at least ${this.headerRows}, contains only ${gA.table.body.length}`);
                  this.rowsWithoutPageBreak = this.headerRows;
                  const GA = gA.table.keepWithHeaderRows;
                  J(GA) && (this.rowsWithoutPageBreak += GA);
                }
                this.dontBreakRows = gA.table.dontBreakRows || !1, (this.rowsWithoutPageBreak || this.dontBreakRows) && (t.beginUnbreakableBlock(), this.drawHorizontalLine(0, t), this.rowsWithoutPageBreak && this.dontBreakRows && t.beginUnbreakableBlock()), nA(this.tableNode.table.body);
              }
              onRowBreak(t, C) {
                return () => {
                  let b = this.rowPaddingTop + (this.headerRows ? 0 : this.topLineWidth);
                  C.context().availableHeight -= this.reservedAtBottom, C.context().moveDown(b);
                };
              }
              beginRow(t, C) {
                this.topLineWidth = this.layout.hLineWidth(t, this.tableNode), this.rowPaddingTop = this.layout.paddingTop(t, this.tableNode), this.bottomLineWidth = this.layout.hLineWidth(t + 1, this.tableNode), this.rowPaddingBottom = this.layout.paddingBottom(t, this.tableNode), this.rowCallback = this.onRowBreak(t, C), C.addListener("pageChanged", this.rowCallback), t == 0 && !this.dontBreakRows && !this.rowsWithoutPageBreak && (this._tableTopBorderY = C.context().y, C.context().moveDown(this.topLineWidth)), this.rowTopPageY = C.context().y + this.rowPaddingTop, this.dontBreakRows && t > 0 && C.beginUnbreakableBlock(), this.rowTopY = C.context().y, this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom, C.context().availableHeight -= this.reservedAtBottom, C.context().moveDown(this.rowPaddingTop);
              }
              drawHorizontalLine(t, C, b, nA, gA) {
                nA === void 0 && (nA = !0);
                let hA = this.layout.hLineWidth(t, this.tableNode);
                if (hA) {
                  let we = this.layout.hLineStyle(t, this.tableNode), ye;
                  we && we.dash && (ye = we.dash);
                  let De = hA / 2, g = null, s = this.tableNode.table.body, I, f, S;
                  for (let iA = 0, YA = this.rowSpanData.length; iA < YA; iA++) {
                    let XA = this.rowSpanData[iA], oe = !XA.rowSpan, pe = null;
                    if (oe && iA < YA - 1) {
                      var HA = !1, GA = !1, fe = !1;
                      t > 0 && (I = s[t - 1][iA], GA = I.border ? I.border[3] : this.layout.defaultBorder, GA && I.borderColor && (pe = I.borderColor[3])), t < s.length && (f = s[t][iA], HA = f.border ? f.border[1] : this.layout.defaultBorder, HA && pe == null && f.borderColor && (pe = f.borderColor[1])), oe = HA || GA;
                    }
                    if (I && I._rowSpanCurrentOffset && (S = s[t - 1 - I._rowSpanCurrentOffset][iA], fe = S && S.border ? S.border[3] : this.layout.defaultBorder, fe && S && S.borderColor && (pe = S.borderColor[3])), pe == null && (pe = typeof this.layout.hLineColor == "function" ? this.layout.hLineColor(t, this.tableNode, iA) : this.layout.hLineColor), !g && oe && (g = {
                      left: XA.left,
                      width: 0
                    }), oe) {
                      let Qe = 0;
                      if (S && S.colSpan && fe) {
                        for (; S.colSpan > Qe; )
                          g.width += this.rowSpanData[iA + Qe++].width || 0;
                        iA += Qe - 1;
                      } else if (I && I.colSpan && GA) {
                        for (; I.colSpan > Qe; )
                          g.width += this.rowSpanData[iA + Qe++].width || 0;
                        iA += Qe - 1;
                      } else if (f && f.colSpan && HA) {
                        for (; f.colSpan > Qe; )
                          g.width += this.rowSpanData[iA + Qe++].width || 0;
                        iA += Qe - 1;
                      } else
                        g.width += this.rowSpanData[iA].width || 0;
                    }
                    let xe = (b || 0) + De;
                    oe && g && g.width && (C.addVector({
                      type: "line",
                      x1: g.left,
                      x2: g.left + g.width,
                      y1: xe,
                      y2: xe,
                      lineWidth: hA,
                      dash: ye,
                      lineColor: pe
                    }, !1, D(b), null, gA), g = null, I = null, f = null, S = null);
                  }
                  nA && C.context().moveDown(hA);
                }
              }
              drawVerticalLine(t, C, b, nA, gA, hA, HA) {
                let GA = this.layout.vLineWidth(nA, this.tableNode);
                if (GA === 0)
                  return;
                let fe = this.layout.vLineStyle(nA, this.tableNode), we;
                fe && fe.dash && (we = fe.dash);
                let ye = this.tableNode.table.body, De, g, s;
                if (nA > 0 && (De = ye[hA][HA], De && De.borderColor && (De.border ? De.border[2] : this.layout.defaultBorder) && (s = De.borderColor[2])), s == null && nA < ye.length && (g = ye[hA][nA], g && g.borderColor && (g.border ? g.border[0] : this.layout.defaultBorder) && (s = g.borderColor[0])), s == null && De && De._rowSpanCurrentOffset) {
                  let I = ye[hA - De._rowSpanCurrentOffset][HA];
                  I.borderColor && (I.border ? I.border[2] : this.layout.defaultBorder) && (s = I.borderColor[2]);
                }
                if (s == null && g && g._rowSpanCurrentOffset) {
                  let I = ye[hA - g._rowSpanCurrentOffset][nA];
                  I.borderColor && (I.border ? I.border[2] : this.layout.defaultBorder) && (s = I.borderColor[2]);
                }
                s == null && (s = typeof this.layout.vLineColor == "function" ? this.layout.vLineColor(nA, this.tableNode, hA) : this.layout.vLineColor), gA.addVector({
                  type: "line",
                  x1: t + GA / 2,
                  x2: t + GA / 2,
                  y1: C,
                  y2: b,
                  lineWidth: GA,
                  dash: we,
                  lineColor: s
                }, !1, !0);
              }
              endTable(t) {
                this.cleanUpRepeatables && t.popFromRepeatables();
              }
              endRow(t, C, b) {
                const nA = () => {
                  let S = [], iA = 0;
                  for (let YA = 0, XA = this.tableNode.table.body[t].length; YA < XA; YA++) {
                    if (!iA) {
                      S.push({
                        x: this.rowSpanData[YA].left,
                        index: YA
                      });
                      let oe = this.tableNode.table.body[t][YA];
                      iA = oe._colSpan || oe.colSpan || 0;
                    }
                    iA > 0 && iA--;
                  }
                  return S.push({
                    x: this.rowSpanData[this.rowSpanData.length - 1].left,
                    index: this.rowSpanData.length - 1
                  }), S;
                };
                C.removeListener("pageChanged", this.rowCallback), C.context().moveDown(this.layout.paddingBottom(t, this.tableNode)), C.context().availableHeight += this.reservedAtBottom;
                let gA = C.context().page, hA = C.context().y, HA = nA(), GA = [], fe = b && b.length > 0, we = this.tableNode.table.body;
                if (GA.push({
                  y0: this.rowTopY,
                  page: fe ? b[0].prevPage : gA
                }), fe)
                  for (let S = 0, iA = b.length; S < iA; S++) {
                    let YA = b[S];
                    GA[GA.length - 1].y1 = YA.prevY, GA.push({
                      y0: YA.y,
                      page: YA.prevPage + 1
                    });
                  }
                GA[GA.length - 1].y1 = hA;
                let ye = GA[0].y1 - GA[0].y0 === this.rowPaddingTop;
                if (t === 0 && !ye && !this.rowsWithoutPageBreak && !this.dontBreakRows) {
                  let S = null;
                  b && b.length > 0 && (S = b[0].prevPage), this.drawHorizontalLine(0, C, this._tableTopBorderY, !1, S);
                }
                for (let S = ye ? 1 : 0, iA = GA.length; S < iA; S++) {
                  let YA = S < GA.length - 1, XA = S > 0 && !this.headerRows, oe = XA ? 0 : this.topLineWidth, pe = GA[S].y0, xe = GA[S].y1;
                  YA && (xe = xe + this.rowPaddingBottom), C.context().page != GA[S].page && (C.context().page = GA[S].page, this.reservedAtBottom = 0), YA && this.layout.hLineWhenBroken !== !1 && this.drawHorizontalLine(t + 1, C, xe), XA && this.layout.hLineWhenBroken !== !1 && this.drawHorizontalLine(t, C, pe);
                  for (let Qe = 0, ke = HA.length; Qe < ke; Qe++) {
                    let lt = !1, Xe = !1, et = HA[Qe].index;
                    if (et < we[t].length) {
                      let Oe = we[t][et];
                      lt = Oe.border ? Oe.border[0] : this.layout.defaultBorder, Xe = Oe.border ? Oe.border[2] : this.layout.defaultBorder;
                    }
                    if (et > 0 && !lt) {
                      let Oe = we[t][et - 1];
                      lt = Oe.border ? Oe.border[2] : this.layout.defaultBorder;
                    }
                    if (et + 1 < we[t].length && !Xe) {
                      let Oe = we[t][et + 1];
                      Xe = Oe.border ? Oe.border[0] : this.layout.defaultBorder;
                    }
                    if (lt && this.drawVerticalLine(HA[Qe].x, pe - oe, xe + this.bottomLineWidth, HA[Qe].index, C, t, HA[Qe - 1] ? HA[Qe - 1].index : null), Qe < ke - 1) {
                      if (we[t][et]._willBreak = we[t][et]._willBreak ?? YA, we[t][et]._bottomY === void 0) {
                        let $e = this.dontBreakRows ? xe + this.bottomLineWidth : xe + this.bottomLineWidth / 2;
                        (YA || this.dontBreakRows) && ($e = $e - this.rowPaddingBottom), we[t][et]._bottomY = $e - this.reservedAtBottom;
                      }
                      we[t][et]._rowTopPageY = this.rowTopPageY, this.dontBreakRows && (we[t][et]._rowTopPageYPadding = this.rowPaddingTop), we[t][et]._lastPageNumber = GA[S].page + 1;
                      let Oe = we[t][et].fillColor, rt = we[t][et].fillOpacity;
                      Oe || (Oe = typeof this.layout.fillColor == "function" ? this.layout.fillColor(t, this.tableNode, et) : this.layout.fillColor), D(rt) || (rt = typeof this.layout.fillOpacity == "function" ? this.layout.fillOpacity(t, this.tableNode, et) : this.layout.fillOpacity);
                      var De = we[t][et].overlayPattern, g = we[t][et].overlayOpacity;
                      if (Oe || De) {
                        let $e = lt ? this.layout.vLineWidth(et, this.tableNode) : 0, wt;
                        (et === 0 || et + 1 == we[t].length) && !Xe ? wt = this.layout.vLineWidth(et + 1, this.tableNode) : Xe ? wt = this.layout.vLineWidth(et + 1, this.tableNode) / 2 : wt = 0;
                        let Wt = this.dontBreakRows ? HA[Qe].x + $e : HA[Qe].x + $e / 2, $t = this.dontBreakRows ? pe : pe - oe / 2, Gt = HA[Qe + 1].x + wt, ct = this.dontBreakRows ? xe + this.bottomLineWidth : xe + this.bottomLineWidth / 2;
                        var s = Gt - Wt, I = ct - $t;
                        Oe && C.addVector({
                          type: "rect",
                          x: Wt,
                          y: $t,
                          w: s,
                          h: I,
                          lineWidth: 0,
                          color: Oe,
                          fillOpacity: rt,
                          // mark if we are in an unbreakable block
                          _isFillColorFromUnbreakable: !!C.transactionLevel
                        }, !1, !0, C.context().backgroundLength[C.context().page]), De && C.addVector({
                          type: "rect",
                          x: Wt,
                          y: $t,
                          w: s,
                          h: I,
                          lineWidth: 0,
                          color: De,
                          fillOpacity: g
                        }, !1, !0);
                      }
                    }
                  }
                }
                C.context().page = gA, C.context().y = hA;
                let f = this.tableNode.table.body[t];
                for (let S = 0, iA = f.length; S < iA; S++) {
                  if (f[S].rowSpan) {
                    if (this.rowSpanData[S].rowSpan = f[S].rowSpan, f[S].colSpan && f[S].colSpan > 1)
                      for (let YA = 1; YA < f[S].rowSpan; YA++)
                        this.tableNode.table.body[t + YA][S]._colSpan = f[S].colSpan;
                    if (f[S].rowSpan && f[S].rowSpan > 1)
                      for (let YA = 1; YA < f[S].rowSpan; YA++)
                        this.tableNode.table.body[t + YA][S]._rowSpanCurrentOffset = YA;
                  }
                  this.rowSpanData[S].rowSpan > 0 && this.rowSpanData[S].rowSpan--;
                }
                if (this.drawHorizontalLine(t + 1, C), this.headerRows && t === this.headerRows - 1 && (this.headerRepeatable = C.currentBlockToRepeatable()), this.dontBreakRows) {
                  const S = () => {
                    t > 0 && !this.headerRows && this.layout.hLineWhenBroken !== !1 && this.drawHorizontalLine(t, C);
                  };
                  C.addListener("pageChanged", S), C.commitUnbreakableBlock(), C.removeListener("pageChanged", S);
                }
                this.headerRepeatable && (t === this.rowsWithoutPageBreak - 1 || t === this.tableNode.table.body.length - 1) && (C.commitUnbreakableBlock(), C.pushToRepeatables(this.headerRepeatable), this.cleanUpRepeatables = !0, this.headerRepeatable = null);
              }
            }
            const ki = Fi;
            class di {
              /**
               * @param {number} maxWidth Maximum width this line can have
               */
              constructor(t) {
                this.maxWidth = t, this.leadingCut = 0, this.trailingCut = 0, this.inlineWidths = 0, this.inlines = [];
              }
              /**
               * @param {object} inline
               */
              addInline(t) {
                this.inlines.length === 0 && (this.leadingCut = t.leadingCut || 0), this.trailingCut = t.trailingCut || 0, t.x = this.inlineWidths - this.leadingCut, this.inlines.push(t), this.inlineWidths += t.width, t.lineEnd && (this.newLineForced = !0);
              }
              /**
               * @returns {number}
               */
              getHeight() {
                let t = 0;
                return this.inlines.forEach((C) => {
                  t = Math.max(t, C.height || 0);
                }), t;
              }
              /**
               * @returns {number}
               */
              getAscenderHeight() {
                let t = 0;
                return this.inlines.forEach((C) => {
                  t = Math.max(t, C.font.ascender / 1e3 * C.fontSize);
                }), t;
              }
              /**
               * @returns {number}
               */
              getWidth() {
                return this.inlineWidths - this.leadingCut - this.trailingCut;
              }
              /**
               * @returns {number}
               */
              getAvailableWidth() {
                return this.maxWidth - this.getWidth();
              }
              /**
               * @param {object} inline
               * @param {Array} nextInlines
               * @returns {boolean}
               */
              hasEnoughSpaceForInline(t, C) {
                if (C === void 0 && (C = []), this.inlines.length === 0)
                  return !0;
                if (this.newLineForced)
                  return !1;
                let b = t.width, nA = t.trailingCut || 0;
                if (t.noNewLine)
                  for (let gA = 0, hA = C.length; gA < hA; gA++) {
                    let HA = C[gA];
                    if (b += HA.width, nA += HA.trailingCut || 0, !HA.noNewLine)
                      break;
                  }
                return this.inlineWidths + b - this.leadingCut - nA <= this.maxWidth;
              }
              clone() {
                let t = new di(this.maxWidth);
                for (let C in this)
                  this.hasOwnProperty(C) && (t[C] = this[C]);
                return t;
              }
            }
            const ji = di;
            function pi(NA, t) {
              t.forEach((C) => {
                NA.push(C);
              });
            }
            class Ni {
              /**
               * @param {object} pageSize - an object defining page width and height
               * @param {object} pageMargins - an object defining top, left, right and bottom margins
               * @param {object} svgMeasure
               */
              constructor(t, C, b) {
                this.pageSize = t, this.pageMargins = C, this.svgMeasure = b, this.tableLayouts = {}, this.nestedLevel = 0, this.verticalAlignmentItemStack = [];
              }
              registerTableLayouts(t) {
                this.tableLayouts = ee(this.tableLayouts, t);
              }
              /**
               * Executes layout engine on document-definition-object and creates an array of pages
               * containing positioned Blocks, Lines and inlines
               *
               * @param {object} docStructure document-definition-object
               * @param {object} pdfDocument pdfkit document
               * @param {object} styleDictionary dictionary with style definitions
               * @param {object} defaultStyle default style definition
               * @param {object} background
               * @param {object} header
               * @param {object} footer
               * @param {object} watermark
               * @param {object} pageBreakBeforeFct
               * @returns {Array} an array of pages
               */
              layoutDocument(t, C, b, nA, gA, hA, HA, GA, fe) {
                function we(g, s) {
                  if (typeof fe != "function")
                    return !1;
                  const I = (f) => !(!f || f.positions.length === 0 || f.text === "" && !f.listMarker);
                  g = g.filter(I), g.forEach((f) => {
                    let S = {};
                    ["id", "text", "ul", "ol", "table", "image", "qr", "canvas", "svg", "columns", "headlineLevel", "style", "pageBreak", "pageOrientation", "width", "height"].forEach((iA) => {
                      f[iA] !== void 0 && (S[iA] = f[iA]);
                    }), S.startPosition = f.positions[0], S.pageNumbers = Array.from(new Set(f.positions.map((iA) => iA.pageNumber))), S.pages = s.length, S.stack = Array.isArray(f.stack), f.nodeInfo = S;
                  });
                  for (let f = 0; f < g.length; f++) {
                    let S = g[f];
                    if (S.pageBreak !== "before" && !S.pageBreakCalculated) {
                      S.pageBreakCalculated = !0;
                      let iA = S.nodeInfo.pageNumbers[0];
                      if (fe(S.nodeInfo, {
                        getFollowingNodesOnPage: () => {
                          let YA = [];
                          for (let XA = f + 1, oe = g.length; XA < oe; XA++)
                            g[XA].nodeInfo.pageNumbers.indexOf(iA) > -1 && YA.push(g[XA].nodeInfo);
                          return YA;
                        },
                        getNodesOnNextPage: () => {
                          let YA = [];
                          for (let XA = f + 1, oe = g.length; XA < oe; XA++)
                            g[XA].nodeInfo.pageNumbers.indexOf(iA + 1) > -1 && YA.push(g[XA].nodeInfo);
                          return YA;
                        },
                        getPreviousNodesOnPage: () => {
                          let YA = [];
                          for (let XA = 0; XA < f; XA++)
                            g[XA].nodeInfo.pageNumbers.indexOf(iA) > -1 && YA.push(g[XA].nodeInfo);
                          return YA;
                        }
                      }))
                        return S.pageBreak = "before", !0;
                    }
                  }
                  return !1;
                }
                this.docPreprocessor = new tA(), this.docMeasure = new je(C, b, nA, this.svgMeasure, this.tableLayouts);
                function ye(g) {
                  g.linearNodeList.forEach((s) => {
                    s.resetXY();
                  });
                }
                let De = this.tryLayoutDocument(t, C, b, nA, gA, hA, HA, GA);
                for (; we(De.linearNodeList, De.pages); )
                  ye(De), De = this.tryLayoutDocument(t, C, b, nA, gA, hA, HA, GA);
                return De.pages;
              }
              tryLayoutDocument(t, C, b, nA, gA, hA, HA, GA) {
                const fe = (we) => we.stack && we.stack.length > 0 && we.stack[0].section ? !1 : !we.section;
                return this.linearNodeList = [], t = this.docPreprocessor.preprocessDocument(t), t = this.docMeasure.measureDocument(t), this.writer = new Pi(new gt()), this.writer.context().addListener("pageAdded", (we) => {
                  let ye = gA;
                  (we.customProperties.background || we.customProperties.background === null) && (ye = we.customProperties.background), this.addBackground(ye);
                }), fe(t) && this.writer.addPage(this.pageSize, null, this.pageMargins), this.processNode(t), this.addHeadersAndFooters(hA, HA), this.addWatermark(GA, C, nA), {
                  pages: this.writer.context().pages,
                  linearNodeList: this.linearNodeList
                };
              }
              addBackground(t) {
                let C = typeof t == "function" ? t : () => t, b = this.writer.context(), nA = b.getCurrentPage().pageSize, gA = C(b.page + 1, nA);
                gA && (this.writer.beginUnbreakableBlock(nA.width, nA.height), gA = this.docPreprocessor.preprocessBlock(gA), this.processNode(this.docMeasure.measureBlock(gA)), this.writer.commitUnbreakableBlock(0, 0), b.backgroundLength[b.page] += gA.positions.length);
              }
              addDynamicRepeatable(t, C, b) {
                let nA = this.writer.context().pages;
                for (let gA = 0, hA = nA.length; gA < hA; gA++) {
                  this.writer.context().page = gA;
                  let HA = this.writer.context().getCurrentPage().customProperties, GA = t;
                  if ((HA[b] || HA[b] === null) && (GA = HA[b]), typeof GA > "u" || GA === null)
                    continue;
                  let fe = GA(gA + 1, hA, this.writer.context().pages[gA].pageSize);
                  if (fe) {
                    let we = C(this.writer.context().getCurrentPage().pageSize, this.writer.context().getCurrentPage().pageMargins);
                    this.writer.beginUnbreakableBlock(we.width, we.height), fe = this.docPreprocessor.preprocessBlock(fe), this.processNode(this.docMeasure.measureBlock(fe)), this.writer.commitUnbreakableBlock(we.x, we.y);
                  }
                }
              }
              addHeadersAndFooters(t, C) {
                const b = (gA, hA) => ({
                  x: 0,
                  y: 0,
                  width: gA.width,
                  height: hA.top
                }), nA = (gA, hA) => ({
                  x: 0,
                  y: gA.height - hA.bottom,
                  width: gA.width,
                  height: hA.bottom
                });
                this.addDynamicRepeatable(t, b, "header"), this.addDynamicRepeatable(C, nA, "footer");
              }
              addWatermark(t, C, b) {
                let nA = this.writer.context().pages;
                for (let GA = 0, fe = nA.length; GA < fe; GA++) {
                  let we = t;
                  (nA[GA].customProperties.watermark || nA[GA].customProperties.watermark === null) && (we = nA[GA].customProperties.watermark), we != null && (P(we) && (we = {
                    text: we
                  }), we.text && (nA[GA].watermark = gA({
                    ...we
                  }, nA[GA].pageSize, C, b)));
                }
                function gA(GA, fe, we, ye) {
                  GA.font = GA.font || ye.font || "Roboto", GA.fontSize = GA.fontSize || "auto", GA.color = GA.color || "black", GA.opacity = D(GA.opacity) ? GA.opacity : 0.6, GA.bold = GA.bold || !1, GA.italics = GA.italics || !1, GA.angle = K(GA.angle) ? GA.angle : null, GA.angle === null && (GA.angle = Math.atan2(fe.height, fe.width) * -180 / Math.PI), GA.fontSize === "auto" && (GA.fontSize = HA(fe, GA, we));
                  let De = {
                    text: GA.text,
                    font: we.provideFont(GA.font, GA.bold, GA.italics),
                    fontSize: GA.fontSize,
                    color: GA.color,
                    opacity: GA.opacity,
                    angle: GA.angle
                  };
                  return De._size = hA(GA, we), De;
                }
                function hA(GA, fe) {
                  let we = new N(fe), ye = new ie(null, {
                    font: GA.font,
                    bold: GA.bold,
                    italics: GA.italics
                  });
                  ye.push({
                    fontSize: GA.fontSize
                  });
                  let De = we.sizeOfText(GA.text, ye), g = we.sizeOfRotatedText(GA.text, GA.angle, ye);
                  return {
                    size: De,
                    rotatedSize: g
                  };
                }
                function HA(GA, fe, we) {
                  let ye = new N(we), De = new ie(null, {
                    font: fe.font,
                    bold: fe.bold,
                    italics: fe.italics
                  }), g, s = 0, I = 1e3, f = (s + I) / 2;
                  for (; Math.abs(s - I) > 1; )
                    De.push({
                      fontSize: f
                    }), g = ye.sizeOfRotatedText(fe.text, fe.angle, De), g.width > GA.width ? (I = f, f = (s + I) / 2) : g.width < GA.width && (g.height > GA.height ? (I = f, f = (s + I) / 2) : (s = f, f = (s + I) / 2)), De.pop();
                  return f;
                }
              }
              processNode(t, C) {
                C === void 0 && (C = !1);
                const b = (gA) => {
                  let hA = t._margin;
                  t.pageBreak === "before" ? this.writer.moveToNextPage(t.pageOrientation) : t.pageBreak === "beforeOdd" ? (this.writer.moveToNextPage(t.pageOrientation), (this.writer.context().page + 1) % 2 === 1 && this.writer.moveToNextPage(t.pageOrientation)) : t.pageBreak === "beforeEven" && (this.writer.moveToNextPage(t.pageOrientation), (this.writer.context().page + 1) % 2 === 0 && this.writer.moveToNextPage(t.pageOrientation));
                  const HA = t.relativePosition || t.absolutePosition;
                  if (hA && !HA) {
                    const GA = this.writer.context().availableHeight;
                    GA - hA[1] < 0 ? (this.writer.context().moveDown(GA), this.writer.context().inSnakingColumns() && !this.writer.context().isInNestedNonSnakingGroup() ? this.snakingAwarePageBreak(t.pageOrientation) : this.writer.moveToNextPage(t.pageOrientation)) : this.writer.context().moveDown(hA[1]), this.writer.context().addMargin(hA[0], hA[2]);
                  }
                  if (gA(), hA && !HA) {
                    const GA = this.writer.context().availableHeight;
                    GA - hA[3] < 0 ? (this.writer.context().moveDown(GA), this.writer.context().inSnakingColumns() && !this.writer.context().isInNestedNonSnakingGroup() ? this.snakingAwarePageBreak(t.pageOrientation) : this.writer.moveToNextPage(t.pageOrientation)) : this.writer.context().moveDown(hA[3]), this.writer.context().addMargin(-hA[0], -hA[2]);
                  }
                  t.pageBreak === "after" ? this.writer.moveToNextPage(t.pageOrientation) : t.pageBreak === "afterOdd" ? (this.writer.moveToNextPage(t.pageOrientation), (this.writer.context().page + 1) % 2 === 1 && this.writer.moveToNextPage(t.pageOrientation)) : t.pageBreak === "afterEven" && (this.writer.moveToNextPage(t.pageOrientation), (this.writer.context().page + 1) % 2 === 0 && this.writer.moveToNextPage(t.pageOrientation));
                };
                if (this.linearNodeList.push(t), vi(t), this.writer.context().getCurrentPage() !== null)
                  var nA = this.writer.context().getCurrentPosition().top;
                b(() => {
                  let gA = t.verticalAlignment;
                  if (C && gA)
                    var hA = this.writer.beginVerticalAlignment(gA);
                  let HA = t.unbreakable;
                  HA && this.writer.beginUnbreakableBlock();
                  let GA = t.absolutePosition;
                  GA && (this.writer.context().beginDetachedBlock(), this.writer.context().moveTo(GA.x || 0, GA.y || 0));
                  let fe = t.relativePosition;
                  if (fe && (this.writer.context().beginDetachedBlock(), this.writer.context().moveToRelative(fe.x || 0, fe.y || 0)), t.stack)
                    this.processVerticalContainer(t);
                  else if (t.section)
                    this.processSection(t);
                  else if (t.columns)
                    this.processColumns(t);
                  else if (t.ul)
                    this.processList(!1, t);
                  else if (t.ol)
                    this.processList(!0, t);
                  else if (t.table)
                    this.processTable(t);
                  else if (t.text !== void 0)
                    this.processLeaf(t);
                  else if (t.toc)
                    this.processToc(t);
                  else if (t.image)
                    this.processImage(t);
                  else if (t.svg)
                    this.processSVG(t);
                  else if (t.canvas)
                    this.processCanvas(t);
                  else if (t.qr)
                    this.processQr(t);
                  else if (t.attachment)
                    this.processAttachment(t);
                  else if (!t._span)
                    throw new Error(`Unrecognized document structure: ${T(t)}`);
                  (GA || fe) && this.writer.context().endDetachedBlock(), HA && this.writer.commitUnbreakableBlock(), C && gA && this.verticalAlignmentItemStack.push({
                    begin: hA,
                    end: this.writer.endVerticalAlignment(gA)
                  });
                }), nA !== void 0 && (t.__height = this.writer.context().getCurrentPosition().top - nA);
              }
              /**
               * Helper for page breaks that respects snaking column context.
               * When in snaking columns, first tries moving to next column.
               * If no columns available, moves to next page and resets x to left margin.
               * @param {string} pageOrientation - Optional page orientation for the new page
               */
              snakingAwarePageBreak(t) {
                let C = this.writer.context();
                if (!C.getSnakingSnapshot())
                  return;
                if (this.writer.canMoveToNextColumn()) {
                  this.writer.moveToNextColumn();
                  return;
                }
                this.writer.moveToNextPage(t);
                let nA = C.lastColumnWidth;
                C.resetSnakingColumnsForNewPage(), C.lastColumnWidth = nA;
              }
              // vertical container
              processVerticalContainer(t) {
                t.stack.forEach((C) => {
                  this.processNode(C), pi(t.positions, C.positions);
                }, this);
              }
              // section
              processSection(t) {
                let C = this.writer.context().getCurrentPage();
                if (!C || C && C.items.length) {
                  t.pageSize === "inherit" && (t.pageSize = C ? {
                    width: C.pageSize.width,
                    height: C.pageSize.height
                  } : void 0), t.pageOrientation === "inherit" && (t.pageOrientation = C ? C.pageSize.orientation : void 0), t.pageMargins === "inherit" && (t.pageMargins = C ? C.pageMargins : void 0), t.header === "inherit" && (t.header = C ? C.customProperties.header : void 0), t.footer === "inherit" && (t.footer = C ? C.customProperties.footer : void 0), t.background === "inherit" && (t.background = C ? C.customProperties.background : void 0), t.watermark === "inherit" && (t.watermark = C ? C.customProperties.watermark : void 0), t.header && typeof t.header != "function" && t.header !== null && (t.header = MA(t.header)), t.footer && typeof t.footer != "function" && t.footer !== null && (t.footer = MA(t.footer));
                  let b = {};
                  typeof t.header < "u" && (b.header = t.header), typeof t.footer < "u" && (b.footer = t.footer), typeof t.background < "u" && (b.background = t.background), typeof t.watermark < "u" && (b.watermark = t.watermark), this.writer.addPage(t.pageSize || this.pageSize, t.pageOrientation, t.pageMargins || this.pageMargins, b);
                }
                this.processNode(t.section);
              }
              // columns
              processColumns(t) {
                this.nestedLevel++;
                let C = t.columns, b = this.writer.context().availableWidth, nA = hA(t._gap);
                nA && (b -= (nA.length - 1) * t._gap), pA.buildColumnWidths(C, b);
                let gA = this.processRow({
                  marginX: t._margin ? [t._margin[0], t._margin[2]] : [0, 0],
                  cells: C,
                  widths: C,
                  gaps: nA,
                  snakingColumns: t.snakingColumns
                });
                pi(t.positions, gA.positions), this.nestedLevel--, this.nestedLevel === 0 && this.writer.context().resetMarginXTopParent();
                function hA(HA) {
                  if (!HA)
                    return null;
                  let GA = [];
                  GA.push(0);
                  for (let fe = C.length - 1; fe > 0; fe--)
                    GA.push(HA);
                  return GA;
                }
              }
              /**
              * Searches for a cell in the same row that starts a rowspan and is positioned immediately before the current cell.
              * Alternatively, it finds a cell where the colspan initiating the rowspan extends to the cell just before the current one.
              *
              * @param {Array<object>} arr - An array representing cells in a row.
              * @param {number} i - The index of the current cell to search backward from.
              * @returns {object|null} The starting cell of the rowspan if found; otherwise, `null`.
              */
              _findStartingRowSpanCell(t, C) {
                let b = 1;
                for (let nA = C - 1; nA >= 0; nA--) {
                  if (!t[nA]._span)
                    return t[nA].rowSpan > 1 && (t[nA].colSpan || 1) === b ? t[nA] : null;
                  b++;
                }
                return null;
              }
              /**
              * Retrieves a page break description for a specified page from a list of page breaks.
              *
              * @param {Array<object>} pageBreaks - An array of page break descriptions, each containing `prevPage` properties.
              * @param {number} page - The page number to find the associated page break for.
              * @returns {object|undefined} The page break description object for the specified page if found; otherwise, `undefined`.
              */
              _getPageBreak(t, C) {
                return t.find((b) => b.prevPage === C);
              }
              _getPageBreakListBySpan(t, C, b) {
                if (!t || !t._breaksBySpan)
                  return null;
                const nA = t._breaksBySpan.filter((HA) => HA.prevPage === C && b <= HA.rowIndexOfSpanEnd);
                let gA = Number.MAX_VALUE, hA = Number.MIN_VALUE;
                return nA.forEach((HA) => {
                  hA = Math.max(HA.prevY, hA), gA = Math.min(HA.y, gA);
                }), {
                  prevPage: C,
                  prevY: hA,
                  y: gA
                };
              }
              _findSameRowPageBreakByRowSpanData(t, C, b) {
                return t ? t.find((nA) => nA.prevPage === C && b === nA.rowIndexOfSpanEnd) : null;
              }
              _updatePageBreaksData(t, C, b) {
                Object.keys(C._bottomByPage).forEach((nA) => {
                  const gA = Number(nA), hA = this._getPageBreak(t, gA);
                  if (hA && (hA.prevY = Math.max(hA.prevY, C._bottomByPage[gA])), C._breaksBySpan && C._breaksBySpan.length > 0) {
                    const HA = C._breaksBySpan.filter((GA) => GA.prevPage === gA && b <= GA.rowIndexOfSpanEnd);
                    HA && HA.length > 0 && HA.forEach((GA) => {
                      GA.prevY = Math.max(GA.prevY, C._bottomByPage[gA]);
                    });
                  }
                });
              }
              /**
              * Resolves the Y-coordinates for a target object by comparing two break points.
              *
              * @param {object} break1 - The first break point with `prevY` and `y` properties.
              * @param {object} break2 - The second break point with `prevY` and `y` properties.
              * @param {object} target - The target object to be updated with resolved Y-coordinates.
              * @property {number} target.prevY - Updated to the maximum `prevY` value between `break1` and `break2`.
              * @property {number} target.y - Updated to the minimum `y` value between `break1` and `break2`.
              */
              _resolveBreakY(t, C, b) {
                b.prevY = Math.max(t.prevY, C.prevY), b.y = Math.min(t.y, C.y);
              }
              _storePageBreakData(t, C, b, nA) {
                if (C) {
                  const gA = nA && nA._breaksBySpan || null;
                  let hA = this._findSameRowPageBreakByRowSpanData(gA, t.prevPage, t.rowIndex);
                  hA || (hA = {
                    ...t,
                    rowIndexOfSpanEnd: t.rowIndex + t.rowSpan - 1
                  }, nA._breaksBySpan || (nA._breaksBySpan = []), nA._breaksBySpan.push(hA)), hA.prevY = Math.max(hA.prevY, t.prevY), hA.y = Math.min(hA.y, t.y);
                  let HA = this._getPageBreak(b, t.prevPage);
                  HA && this._resolveBreakY(HA, hA, HA);
                } else {
                  let gA = this._getPageBreak(b, t.prevPage), hA = this._getPageBreakListBySpan(nA, t.prevPage, t.rowIndex);
                  gA || (gA = {
                    ...t
                  }, b.push(gA)), hA && this._resolveBreakY(gA, hA, gA), this._resolveBreakY(gA, t, gA);
                }
              }
              /**
              * Calculates the left offset for a column based on the specified gap values.
              *
              * @param {number} i - The index of the column for which the offset is being calculated.
              * @param {Array<number>} gaps - An array of gap values for each column.
              * @returns {number} The left offset for the column. Returns `gaps[i]` if it exists, otherwise `0`.
              */
              _colLeftOffset(t, C) {
                return C && C.length > t ? C[t] : 0;
              }
              /**
              * Retrieves the ending cell for a row span in case it exists in a specified table column.
              *
              * @param {Array<Array<object>>} tableBody - The table body, represented as a 2D array of cell objects.
              * @param {number} rowIndex - The index of the starting row for the row span.
              * @param {object} column - The column object containing row span information.
              * @param {number} columnIndex - The index of the column within the row.
              * @returns {object|null} The cell at the end of the row span if it exists; otherwise, `null`.
              * @throws {Error} If the row span extends beyond the total row count.
              */
              _getRowSpanEndingCell(t, C, b, nA) {
                if (b.rowSpan && b.rowSpan > 1) {
                  let gA = C + b.rowSpan - 1;
                  if (gA >= t.length)
                    throw new Error(`Row span for column ${nA} (with indexes starting from 0) exceeded row count`);
                  return t[gA][nA];
                }
                return null;
              }
              processRow(t) {
                let {
                  marginX: C = [0, 0],
                  dontBreakRows: b = !1,
                  rowsWithoutPageBreak: nA = 0,
                  cells: gA,
                  widths: hA,
                  gaps: HA,
                  tableNode: GA,
                  tableBody: fe,
                  rowIndex: we,
                  height: ye,
                  snakingColumns: De = !1
                } = t;
                const g = b || we <= nA - 1;
                let s = [], I = [], f = [], S = !1, iA = {};
                hA = hA || gA, !g && ye > this.writer.context().availableHeight && (S = !0);
                const YA = this.nestedLevel === 1 ? C : null, XA = GA ? GA._bottomByPage : null, oe = HA && HA.length > 1 ? HA[1] : 0, pe = hA.map((Xe) => Xe._calcWidth);
                this.writer.context().beginColumnGroup(YA, XA, De, oe, pe);
                for (let Xe = 0, et = gA.length; Xe < et; Xe++) {
                  let Oe = gA[Xe], rt = Xe;
                  const $e = (Ci) => {
                    const _i = Oe.rowSpan && Oe.rowSpan > 1;
                    _i && (Ci.rowSpan = Oe.rowSpan), Ci.rowIndex = we, this._storePageBreakData(Ci, _i, s, GA);
                  };
                  this.writer.addListener("pageChanged", $e);
                  let wt = hA[Xe]._calcWidth, Wt = this._colLeftOffset(Xe, HA), $t = this._findStartingRowSpanCell(gA, Xe);
                  if (Oe.colSpan && Oe.colSpan > 1)
                    for (let Ci = 1; Ci < Oe.colSpan; Ci++)
                      wt += hA[++Xe]._calcWidth + HA[Xe];
                  const Gt = this._getRowSpanEndingCell(fe, we, Oe, Xe), ct = this._getRowSpanEndingCell(fe, we, Oe, rt);
                  Gt && (Oe._endingCell = Gt, Oe._endingCell._startingRowSpanY = Oe._startingRowSpanY), ct && (Oe._leftEndingCell = ct, Oe._leftEndingCell._startingRowSpanY = Oe._startingRowSpanY);
                  let jt = null;
                  $t && $t._endingCell && (jt = $t._endingCell, this.writer.transactionLevel > 0 && (jt._isUnbreakableContext = !0, jt._originalXOffset = this.writer.originalX)), this.writer.context().beginColumn(wt, Wt, jt);
                  const bi = De && Xe > 0;
                  if (!Oe._span && !bi)
                    this.processNode(Oe, !0), this.writer.context().updateBottomByPage(), Oe.verticalAlignment && (iA[rt] = this.verticalAlignmentItemStack.length - 1), pi(f, Oe.positions);
                  else if (Oe._columnEndingContext) {
                    let Ci = 0;
                    b && (Ci = this.writer.contextStack[this.writer.contextStack.length - 1].y - Oe._startingRowSpanY);
                    let _i = 0;
                    Oe._isUnbreakableContext && !this.writer.transactionLevel && (_i = Oe._originalXOffset), this.writer.context().markEnding(Oe, _i, Ci);
                  }
                  this.writer.removeListener("pageChanged", $e);
                }
                let xe = null;
                const Qe = gA.length > 0 ? gA[gA.length - 1] : null;
                if (Qe) {
                  if (Qe._endingCell)
                    xe = Qe._endingCell;
                  else if (Qe._span === !0) {
                    const Xe = this._findStartingRowSpanCell(gA, gA.length);
                    Xe && (xe = Xe._endingCell, this.writer.transactionLevel > 0 && (xe._isUnbreakableContext = !0, xe._originalXOffset = this.writer.originalX));
                  }
                }
                S && !g && s.length === 0 && (this.writer.context().moveDown(this.writer.context().availableHeight), De ? this.snakingAwarePageBreak() : this.writer.moveToNextPage());
                const ke = this.writer.context().completeColumnGroup(ye, xe);
                GA && (GA._bottomByPage = ke, this._updatePageBreaksData(s, GA, we));
                let lt = this.writer.context().height;
                for (let Xe = 0, et = gA.length; Xe < et; Xe++) {
                  let Oe = gA[Xe];
                  if (!Oe._span && Oe.verticalAlignment) {
                    let rt = this.verticalAlignmentItemStack[iA[Xe]].begin.item;
                    rt.viewHeight = lt, rt.nodeHeight = Oe.__height, rt.cell = Oe, rt.bottomY = this.writer.context().y, rt.isCellContentMultiPage = !rt.cell.positions.every((wt) => wt.pageNumber === rt.cell.positions[0].pageNumber), rt.getViewHeight = function() {
                      if (this.cell._willBreak)
                        return this.cell._bottomY - this.cell._rowTopPageY;
                      if (this.cell.rowSpan && this.cell.rowSpan > 1)
                        if (b) {
                          let wt = this.cell._leftEndingCell._startingRowSpanY + this.cell._leftEndingCell._rowTopPageYPadding;
                          return this.cell._leftEndingCell._rowTopPageY - wt + this.cell._leftEndingCell._bottomY;
                        } else
                          return this.cell.positions[0].pageNumber !== this.cell._leftEndingCell._lastPageNumber ? this.bottomY - this.cell._leftEndingCell._bottomY : this.viewHeight + this.cell._leftEndingCell._bottomY - this.bottomY;
                      return this.viewHeight;
                    }, rt.getNodeHeight = function() {
                      return this.nodeHeight;
                    };
                    let $e = this.verticalAlignmentItemStack[iA[Xe]].end.item;
                    $e.isCellContentMultiPage = rt.isCellContentMultiPage;
                  }
                }
                return {
                  pageBreaksBySpan: I,
                  pageBreaks: s,
                  positions: f
                };
              }
              // lists
              processList(t, C) {
                const b = (HA) => {
                  if (hA) {
                    let GA = hA;
                    if (hA = null, GA.canvas) {
                      let fe = GA.canvas[0];
                      Me(fe, -GA._minWidth, 0), this.writer.addVector(fe);
                    } else if (GA._inlines) {
                      let fe = new ji(this.pageSize.width);
                      fe.addInline(GA._inlines[0]), fe.x = -GA._minWidth, fe.y = HA.getAscenderHeight() - fe.getAscenderHeight(), this.writer.addLine(fe, !0);
                    }
                  }
                };
                let nA = t ? C.ol : C.ul, gA = C._gapSize;
                this.writer.context().addMargin(gA.width);
                let hA;
                this.writer.addListener("lineAdded", b), nA.forEach((HA) => {
                  hA = HA.listMarker, this.processNode(HA), pi(C.positions, HA.positions);
                }), this.writer.removeListener("lineAdded", b), this.writer.context().addMargin(-gA.width);
              }
              // tables
              processTable(t) {
                this.nestedLevel++;
                let C = new ki(t);
                C.beginTable(this.writer);
                let b = t.table.heights, nA = 0;
                for (let gA = 0, hA = t.table.body.length; gA < hA; gA++) {
                  if (gA > 0 && this.writer.context().inSnakingColumns()) {
                    let De = nA > 0 ? nA : C.rowPaddingTop + 14 + C.rowPaddingBottom + C.bottomLineWidth + C.topLineWidth;
                    this.writer.context().availableHeight < De && (this.snakingAwarePageBreak(), C.layout.hLineWhenBroken !== !1 && !C.headerRows && C.drawHorizontalLine(gA, this.writer));
                  }
                  let HA = this.writer.context().y;
                  C.dontBreakRows && t.table.body[gA].forEach((De) => {
                    De.rowSpan && De.rowSpan > 1 && (De._startingRowSpanY = this.writer.context().y);
                  }), C.beginRow(gA, this.writer);
                  let GA;
                  typeof b == "function" ? GA = b(gA) : Array.isArray(b) ? GA = b[gA] : GA = b, GA === "auto" && (GA = void 0);
                  const fe = this.writer.context().page;
                  let we = this.processRow({
                    marginX: t._margin ? [t._margin[0], t._margin[2]] : [0, 0],
                    dontBreakRows: C.dontBreakRows,
                    rowsWithoutPageBreak: C.rowsWithoutPageBreak,
                    cells: t.table.body[gA],
                    widths: t.table.widths,
                    gaps: t._offsets.offsets,
                    tableBody: t.table.body,
                    tableNode: t,
                    rowIndex: gA,
                    height: GA
                  });
                  if (pi(t.positions, we.positions), !we.pageBreaks || we.pageBreaks.length === 0) {
                    const De = t && t._breaksBySpan || null, g = this._findSameRowPageBreakByRowSpanData(De, fe, gA);
                    if (g) {
                      const s = this._getPageBreakListBySpan(t, g.prevPage, gA);
                      we.pageBreaks.push(s);
                    }
                  }
                  C.endRow(gA, this.writer, we.pageBreaks);
                  let ye = this.writer.context().y;
                  this.writer.context().page === fe && (nA = ye - HA);
                }
                C.endTable(this.writer), this.nestedLevel--, this.nestedLevel === 0 && this.writer.context().resetMarginXTopParent();
              }
              // leafs (texts)
              processLeaf(t) {
                let C = this.buildNextLine(t);
                C && (t.tocItem || t.id) && (C._node = t);
                let b = C ? C.getHeight() : 0, nA = t.maxHeight || -1;
                if (C) {
                  let gA = H(t);
                  gA && (C.id = gA);
                }
                if (t.outline)
                  C._outline = {
                    id: t.id,
                    parentId: t.outlineParentId,
                    text: t.outlineText || t.text,
                    expanded: t.outlineExpanded || !1
                  };
                else if (Array.isArray(t.text))
                  for (let gA = 0, hA = t.text.length; gA < hA; gA++) {
                    let HA = t.text[gA];
                    HA.outline && (C._outline = {
                      id: HA.id,
                      parentId: HA.outlineParentId,
                      text: HA.outlineText || HA.text,
                      expanded: HA.outlineExpanded || !1
                    });
                  }
                if (t._tocItemRef && (C._pageNodeRef = t._tocItemRef), t._pageRef && (C._pageNodeRef = t._pageRef._nodeRef), C && C.inlines && Array.isArray(C.inlines))
                  for (let gA = 0, hA = C.inlines.length; gA < hA; gA++)
                    C.inlines[gA]._tocItemRef && (C.inlines[gA]._pageNodeRef = C.inlines[gA]._tocItemRef), C.inlines[gA]._pageRef && (C.inlines[gA]._pageNodeRef = C.inlines[gA]._pageRef._nodeRef);
                for (; C && (nA === -1 || b < nA); ) {
                  if (C.getHeight() > this.writer.context().availableHeight && this.writer.context().y > this.writer.context().pageMargins.top)
                    if (this.writer.context().inSnakingColumns() && !this.writer.context().isInNestedNonSnakingGroup()) {
                      this.snakingAwarePageBreak(t.pageOrientation), C.inlines && C.inlines.length > 0 && t._inlines.unshift(...C.inlines), C = this.buildNextLine(t);
                      continue;
                    } else
                      this.writer.moveToNextPage(t.pageOrientation);
                  let gA = this.writer.addLine(C);
                  t.positions.push(gA), C = this.buildNextLine(t), C && (b += C.getHeight());
                }
              }
              processToc(t) {
                !t.toc._table && t.toc.hideEmpty === !0 || (t.toc.title && this.processNode(t.toc.title), t.toc._table && this.processNode(t.toc._table));
              }
              buildNextLine(t) {
                function C(HA) {
                  let GA = HA.constructor();
                  for (let fe in HA)
                    GA[fe] = HA[fe];
                  return GA;
                }
                function b(HA, GA, fe) {
                  let we = 1, ye = HA.length, De = 1;
                  for (; we <= ye; ) {
                    const g = Math.floor((we + ye) / 2), s = HA.substring(0, g);
                    fe(s) <= GA ? (De = g, we = g + 1) : ye = g - 1;
                  }
                  return De;
                }
                if (!t._inlines || t._inlines.length === 0)
                  return null;
                let nA = new ji(this.writer.context().availableWidth);
                const gA = new N(null);
                let hA = !1;
                for (; t._inlines && t._inlines.length > 0 && (nA.hasEnoughSpaceForInline(t._inlines[0], t._inlines.slice(1)) || hA); ) {
                  let HA = !1, GA = t._inlines.shift();
                  if (!GA.noWrap && GA.text.length > 1 && GA.width > nA.getAvailableWidth()) {
                    let fe = b(GA.text, nA.getAvailableWidth(), (we) => gA.widthOfText(we, GA));
                    if (fe < GA.text.length) {
                      let we = C(GA);
                      we.text = GA.text.substr(fe), GA.text = GA.text.substr(0, fe), we.width = gA.widthOfText(we.text, we), GA.width = gA.widthOfText(GA.text, GA), t._inlines.unshift(we), HA = !0;
                    }
                  }
                  nA.addInline(GA), hA = GA.noNewLine && !HA;
                }
                return nA.lastLineInParagraph = t._inlines.length === 0, nA;
              }
              // images
              processImage(t) {
                let C = this.writer.addImage(t);
                t.positions.push(C);
              }
              processCanvas(t) {
                let C = this.writer.addCanvas(t);
                pi(t.positions, C);
              }
              processSVG(t) {
                let C = this.writer.addSVG(t);
                t.positions.push(C);
              }
              processQr(t) {
                let C = this.writer.addQr(t);
                t.positions.push(C);
              }
              processAttachment(t) {
                let C = this.writer.addAttachment(t);
                t.positions.push(C);
              }
            }
            function vi(NA) {
              let t = NA.x, C = NA.y;
              NA.positions = [], Array.isArray(NA.canvas) && NA.canvas.forEach((b) => {
                let nA = b.x, gA = b.y, hA = b.x1, HA = b.y1, GA = b.x2, fe = b.y2;
                b.resetXY = () => {
                  b.x = nA, b.y = gA, b.x1 = hA, b.y1 = HA, b.x2 = GA, b.y2 = fe;
                };
              }), NA.resetXY = () => {
                NA.x = t, NA.y = C, Array.isArray(NA.canvas) && NA.canvas.forEach((b) => {
                  b.resetXY();
                });
              };
            }
            const Wi = Ni;
            var zn = r(7507);
            const Ri = (NA) => {
              let t = parseFloat(NA);
              if (!(typeof t != "number" || isNaN(t)))
                return t;
            }, nn = (NA) => {
              let t;
              try {
                t = new zn.XmlDocument(NA);
              } catch (C) {
                throw new Error("Invalid svg document (" + C + ")", {
                  cause: C
                });
              }
              if (t.name !== "svg")
                throw new Error("Invalid svg document (expected <svg>)");
              return t;
            };
            class Tn {
              constructor() {
              }
              measureSVG(t) {
                let C, b, nA;
                if (P(t)) {
                  let HA = nn(t);
                  C = HA.attr.width, b = HA.attr.height, nA = HA.attr.viewBox;
                } else if (typeof SVGElement < "u" && t instanceof SVGElement && typeof getComputedStyle == "function")
                  C = t.getAttribute("width"), b = t.getAttribute("height"), nA = t.getAttribute("viewBox");
                else
                  throw new Error("Invalid SVG document");
                let gA = Ri(C), hA = Ri(b);
                if ((gA === void 0 || hA === void 0) && typeof nA == "string") {
                  let HA = nA.split(/[,\s]+/);
                  if (HA.length !== 4)
                    throw new Error("Unexpected svg viewBox format, should have 4 entries but found: '" + nA + "'");
                  gA === void 0 && (gA = Ri(HA[2])), hA === void 0 && (hA = Ri(HA[3]));
                }
                return {
                  width: gA,
                  height: hA
                };
              }
              writeDimensions(t, C) {
                if (P(t)) {
                  let b = nn(t);
                  return typeof b.attr.viewBox != "string" && (b.attr.viewBox = `0 0 ${Ri(b.attr.width)} ${Ri(b.attr.height)}`), b.attr.width = "" + C.width, b.attr.height = "" + C.height, b.toString();
                }
                return t.hasAttribute("viewBox") || t.setAttribute("viewBox", `0 0 ${Ri(t.getAttribute("width"))} ${Ri(t.getAttribute("height"))}`), t.setAttribute("width", "" + C.width), t.setAttribute("height", "" + C.height), t;
              }
            }
            const rn = Tn, hi = (NA) => {
              let t = [], C = null;
              for (let b = 0, nA = NA.inlines.length; b < nA; b++) {
                let gA = NA.inlines[b], hA = gA.decoration;
                if (!hA) {
                  C = null;
                  continue;
                }
                Array.isArray(hA) || (hA = [hA]);
                let HA = gA.decorationColor || gA.color || "black", GA = gA.decorationStyle || "solid", fe = D(gA.decorationThickness) ? gA.decorationThickness : null;
                for (let we = 0, ye = hA.length; we < ye; we++) {
                  let De = hA[we];
                  !C || De !== C.decoration || GA !== C.decorationStyle || HA !== C.decorationColor ? (C = {
                    line: NA,
                    decoration: De,
                    decorationColor: HA,
                    decorationStyle: GA,
                    decorationThickness: fe,
                    inlines: [gA]
                  }, t.push(C)) : C.inlines.push(gA);
                }
              }
              return t;
            };
            class In {
              constructor(t) {
                this.pdfDocument = t;
              }
              drawBackground(t, C, b) {
                let nA = t.getHeight();
                for (let gA = 0, hA = t.inlines.length; gA < hA; gA++) {
                  let HA = t.inlines[gA];
                  if (!HA.background)
                    continue;
                  let GA = HA.background, fe = this.pdfDocument.providePattern(HA.background);
                  fe !== null && (GA = fe);
                  let we = HA.justifyShift || 0;
                  this.pdfDocument.fillColor(GA).rect(C + HA.x - we, b, HA.width + we, nA).fill();
                }
              }
              drawDecorations(t, C, b) {
                let nA = hi(t);
                for (let gA = 0, hA = nA.length; gA < hA; gA++)
                  this._drawDecoration(nA[gA], C, b);
              }
              _drawDecoration(t, C, b) {
                const nA = () => {
                  let s = 0;
                  for (let I = 0, f = t.inlines.length; I < f; I++)
                    s = t.inlines[I].fontSize > s ? I : s;
                  return t.inlines[s];
                }, gA = () => {
                  let s = 0;
                  for (let I = 0, f = t.inlines.length; I < f; I++) {
                    let S = t.inlines[I].justifyShift || 0;
                    s += t.inlines[I].width + S;
                  }
                  return s;
                };
                let hA = t.inlines[0], HA = nA(), GA = gA(), fe = t.line.getAscenderHeight(), we = HA.font.ascender / 1e3 * HA.fontSize, De = HA.height - we, g = D(t.decorationThickness) ? t.decorationThickness : 0.5 + Math.floor(Math.max(HA.fontSize - 8, 0) / 2) * 0.12;
                switch (t.decoration) {
                  case "underline":
                    b += fe + De * 0.45;
                    break;
                  case "overline":
                    b += fe - we * 0.85;
                    break;
                  case "lineThrough":
                    b += fe - we * 0.25;
                    break;
                  default:
                    throw new Error(`Unknown decoration : ${t.decoration}`);
                }
                if (t.inlines[0].sup && (b -= t.inlines[0].fontSize * 0.75), t.inlines[0].sub && (b += t.inlines[0].fontSize * 0.35), this.pdfDocument.save(), t.decorationStyle === "double") {
                  let s = Math.max(0.5, g, HA.fontSize * 0.15);
                  this.pdfDocument.fillColor(t.decorationColor).rect(C + hA.x, b - g / 2, GA, g / 2).fill().rect(C + hA.x, b + s - g / 2, GA, g / 2).fill();
                } else if (t.decorationStyle === "dashed") {
                  let s = Math.ceil(GA / 6.8), I = C + hA.x;
                  this.pdfDocument.rect(I, b, GA, g).clip(), this.pdfDocument.fillColor(t.decorationColor);
                  for (let f = 0; f < s; f++)
                    this.pdfDocument.rect(I, b - g / 2, 3.96, g).fill(), I += 6.8;
                } else if (t.decorationStyle === "dotted") {
                  let s = Math.ceil(GA / (g * 3)), I = C + hA.x;
                  this.pdfDocument.rect(I, b, GA, g).clip(), this.pdfDocument.fillColor(t.decorationColor);
                  for (let f = 0; f < s; f++)
                    this.pdfDocument.rect(I, b - g / 2, g, g).fill(), I += g * 3;
                } else if (t.decorationStyle === "wavy") {
                  let s = 0.7, I = 1, f = Math.ceil(GA / (s * 2)) + 1, S = C + hA.x - 1;
                  this.pdfDocument.rect(C + hA.x, b - I, GA, b + I).clip(), this.pdfDocument.lineWidth(g / 3), this.pdfDocument.moveTo(S, b);
                  for (let iA = 0; iA < f; iA++)
                    this.pdfDocument.bezierCurveTo(S + s, b - I, S + s * 2, b - I, S + s * 3, b).bezierCurveTo(S + s * 4, b + I, S + s * 5, b + I, S + s * 6, b), S += s * 6;
                  this.pdfDocument.stroke(t.decorationColor);
                } else
                  this.pdfDocument.fillColor(t.decorationColor).rect(C + hA.x, b - g / 2, GA, g).fill();
                this.pdfDocument.restore();
              }
            }
            const zr = In;
            var ir = r(6582);
            const nr = (NA, t, C) => {
              for (let b = 0; b < t.length; b++) {
                let nA = t[b].toLowerCase();
                for (let gA in NA)
                  if (gA.toLowerCase() === nA)
                    return gA;
              }
              return C;
            }, cn = (NA, t) => {
              let C = NA;
              return t.sup && (C -= t.fontSize * 0.75), t.sub && (C += t.fontSize * 0.35), C;
            };
            class rr {
              constructor(t, C) {
                this.pdfDocument = t, this.progressCallback = C, this.outlineMap = [];
              }
              renderPages(t) {
                this.pdfDocument._pdfMakePages = t;
                let C = 0;
                this.progressCallback && t.forEach((nA) => {
                  C += nA.items.length;
                });
                let b = 0;
                for (let nA = 0; nA < t.length; nA++) {
                  this.pdfDocument.addPage({
                    size: [t[nA].pageSize.width, t[nA].pageSize.height]
                  });
                  let gA = t[nA];
                  for (let hA = 0, HA = gA.items.length; hA < HA; hA++) {
                    let GA = gA.items[hA];
                    switch (GA.type) {
                      case "vector":
                        this.renderVector(GA.item);
                        break;
                      case "line":
                        this.renderLine(GA.item, GA.item.x, GA.item.y);
                        break;
                      case "image":
                        this.renderImage(GA.item);
                        break;
                      case "svg":
                        this.renderSVG(GA.item);
                        break;
                      case "attachment":
                        this.renderAttachment(GA.item);
                        break;
                      case "beginClip":
                        this.beginClip(GA.item);
                        break;
                      case "endClip":
                        this.endClip();
                        break;
                      case "beginVerticalAlignment":
                        this.beginVerticalAlignment(GA.item);
                        break;
                      case "endVerticalAlignment":
                        this.endVerticalAlignment(GA.item);
                        break;
                    }
                    b++, this.progressCallback && this.progressCallback(b / C);
                  }
                  gA.watermark && this.renderWatermark(gA);
                }
              }
              renderLine(t, C, b) {
                function nA(fe, we) {
                  let ye, De, g = new N(null);
                  if (fe.positions === void 0)
                    throw new Error("Page reference id not found");
                  let s = fe.positions[0].pageNumber.toString();
                  switch (we.text = s, ye = g.widthOfText(we.text, we), De = we.width - ye, we.width = ye, we.alignment) {
                    case "right":
                      we.x += De;
                      break;
                    case "center":
                      we.x += De / 2;
                      break;
                  }
                }
                if (t._outline) {
                  let fe = this.pdfDocument.outline;
                  t._outline.parentId && this.outlineMap[t._outline.parentId] && (fe = this.outlineMap[t._outline.parentId]);
                  let we = fe.addItem(t._outline.text, {
                    expanded: t._outline.expanded
                  });
                  t._outline.id && (this.outlineMap[t._outline.id] = we);
                }
                t._pageNodeRef && nA(t._pageNodeRef, t.inlines[0]), C = C || 0, b = b || 0;
                let gA = t.getHeight(), hA = t.getAscenderHeight(), HA = gA - hA;
                const GA = new zr(this.pdfDocument);
                GA.drawBackground(t, C, b);
                for (let fe = 0, we = t.inlines.length; fe < we; fe++) {
                  let ye = t.inlines[fe], De = gA - ye.font.ascender / 1e3 * ye.fontSize - HA;
                  ye._pageNodeRef && nA(ye._pageNodeRef, ye);
                  let g = {
                    lineBreak: !1,
                    textWidth: ye.width,
                    characterSpacing: ye.characterSpacing,
                    wordCount: 1,
                    link: ye.link
                  };
                  ye.linkToDestination && (g.goTo = ye.linkToDestination), t.id && fe === 0 && (g.destination = t.id), ye.fontFeatures && (g.features = ye.fontFeatures);
                  let s = D(ye.opacity) ? ye.opacity : 1;
                  this.pdfDocument.opacity(s), this.pdfDocument.fill(ye.color || "black"), this.pdfDocument._font = ye.font, this.pdfDocument.fontSize(ye.fontSize);
                  let I = cn(b + De, ye);
                  this.pdfDocument.text(ye.text, C + ye.x, I, g), ye.linkToPage && (this.pdfDocument.ref({
                    Type: "Action",
                    S: "GoTo",
                    D: [ye.linkToPage, 0, 0]
                  }).end(), this.pdfDocument.annotate(C + ye.x, I, ye.width, ye.height, {
                    Subtype: "Link",
                    Dest: [ye.linkToPage - 1, "XYZ", null, null, null]
                  }));
                }
                GA.drawDecorations(t, C, b);
              }
              renderVector(t) {
                this.pdfDocument.lineWidth(t.lineWidth || 1), t.dash ? this.pdfDocument.dash(t.dash.length, {
                  space: t.dash.space || t.dash.length,
                  phase: t.dash.phase || 0
                }) : this.pdfDocument.undash(), this.pdfDocument.lineJoin(t.lineJoin || "miter"), this.pdfDocument.lineCap(t.lineCap || "butt");
                let C = null;
                switch (t.type) {
                  case "ellipse":
                    this.pdfDocument.ellipse(t.x, t.y, t.r1, t.r2), t.linearGradient && (C = this.pdfDocument.linearGradient(t.x - t.r1, t.y, t.x + t.r1, t.y));
                    break;
                  case "rect":
                    t.r ? this.pdfDocument.roundedRect(t.x, t.y, t.w, t.h, t.r) : this.pdfDocument.rect(t.x, t.y, t.w, t.h), t.linearGradient && (C = this.pdfDocument.linearGradient(t.x, t.y, t.x + t.w, t.y));
                    break;
                  case "line":
                    this.pdfDocument.moveTo(t.x1, t.y1), this.pdfDocument.lineTo(t.x2, t.y2);
                    break;
                  case "polyline":
                    if (t.points.length === 0)
                      break;
                    this.pdfDocument.moveTo(t.points[0].x, t.points[0].y);
                    for (let hA = 1, HA = t.points.length; hA < HA; hA++)
                      this.pdfDocument.lineTo(t.points[hA].x, t.points[hA].y);
                    if (t.points.length > 1) {
                      let hA = t.points[0], HA = t.points[t.points.length - 1];
                      (t.closePath || hA.x === HA.x && hA.y === HA.y) && this.pdfDocument.closePath();
                    }
                    break;
                  case "path":
                    this.pdfDocument.path(t.d);
                    break;
                }
                if (t.linearGradient && C) {
                  let hA = 1 / (t.linearGradient.length - 1);
                  for (let HA = 0; HA < t.linearGradient.length; HA++)
                    C.stop(HA * hA, t.linearGradient[HA]);
                  t.color = C;
                }
                let b = this.pdfDocument.providePattern(t.color);
                b !== null && (t.color = b);
                let nA = D(t.fillOpacity) ? t.fillOpacity : 1, gA = D(t.strokeOpacity) ? t.strokeOpacity : 1;
                t.color && t.lineColor ? (this.pdfDocument.fillColor(t.color, nA), this.pdfDocument.strokeColor(t.lineColor, gA), this.pdfDocument.fillAndStroke()) : t.color ? (this.pdfDocument.fillColor(t.color, nA), this.pdfDocument.fill()) : (this.pdfDocument.strokeColor(t.lineColor || "black", gA), this.pdfDocument.stroke());
              }
              renderImage(t) {
                let C = D(t.opacity) ? t.opacity : 1;
                if (this.pdfDocument.opacity(C), t.cover) {
                  const b = t.cover.align || "center", nA = t.cover.valign || "center", gA = t.cover.width ? t.cover.width : t.width, hA = t.cover.height ? t.cover.height : t.height;
                  this.pdfDocument.save(), this.pdfDocument.rect(t.x, t.y, gA, hA).clip(), this.pdfDocument.image(t.image, t.x, t.y, {
                    cover: [gA, hA],
                    align: b,
                    valign: nA
                  }), this.pdfDocument.restore();
                } else
                  this.pdfDocument.image(t.image, t.x, t.y, {
                    width: t._width,
                    height: t._height
                  });
                if (t.link && this.pdfDocument.link(t.x, t.y, t._width, t._height, t.link), t.linkToPage && (this.pdfDocument.ref({
                  Type: "Action",
                  S: "GoTo",
                  D: [t.linkToPage, 0, 0]
                }).end(), this.pdfDocument.annotate(t.x, t.y, t._width, t._height, {
                  Subtype: "Link",
                  Dest: [t.linkToPage - 1, "XYZ", null, null, null]
                })), t.linkToDestination && this.pdfDocument.goTo(t.x, t.y, t._width, t._height, t.linkToDestination), t.linkToFile) {
                  const b = this.pdfDocument.provideAttachment(t.linkToFile);
                  this.pdfDocument.fileAnnotation(
                    t.x,
                    t.y,
                    t._width,
                    t._height,
                    b,
                    // add empty rectangle as file annotation appearance with the same size as the rendered image
                    {
                      AP: {
                        N: {
                          Type: "XObject",
                          Subtype: "Form",
                          FormType: 1,
                          BBox: [t.x, t.y, t._width, t._height]
                        }
                      }
                    }
                  );
                }
              }
              renderSVG(t) {
                let C = {
                  width: t._width,
                  height: t._height,
                  assumePt: !0,
                  useCSS: !P(t.svg),
                  ...t.options
                };
                C.fontCallback = (b, nA, gA) => {
                  let hA = b.split(",").map((fe) => fe.trim().replace(/('|")/g, "")), HA = nr(this.pdfDocument.fonts, hA, t.font || "Roboto"), GA = this.pdfDocument.getFontFile(HA, nA, gA);
                  if (GA === null) {
                    let fe = this.pdfDocument.getFontType(nA, gA);
                    throw new Error(`Font '${HA}' in style '${fe}' is not defined in the font section of the document definition.`);
                  }
                  return GA;
                }, (0, ir.A)(this.pdfDocument, t.svg, t.x, t.y, C), t.link && this.pdfDocument.link(t.x, t.y, t._width, t._height, t.link), t.linkToPage && (this.pdfDocument.ref({
                  Type: "Action",
                  S: "GoTo",
                  D: [t.linkToPage, 0, 0]
                }).end(), this.pdfDocument.annotate(t.x, t.y, t._width, t._height, {
                  Subtype: "Link",
                  Dest: [t.linkToPage - 1, "XYZ", null, null, null]
                })), t.linkToDestination && this.pdfDocument.goTo(t.x, t.y, t._width, t._height, t.linkToDestination);
              }
              renderAttachment(t) {
                const C = this.pdfDocument.provideAttachment(t.attachment), b = {};
                t.icon && (b.Name = t.icon), this.pdfDocument.fileAnnotation(t.x, t.y, t._width, t._height, C, b);
              }
              beginClip(t) {
                this.pdfDocument.save(), this.pdfDocument.addContent(`${t.x} ${t.y} ${t.width} ${t.height} re`), this.pdfDocument.clip();
              }
              endClip() {
                this.pdfDocument.restore();
              }
              beginVerticalAlignment(t) {
                if (!t.isCellContentMultiPage)
                  switch (t.verticalAlignment) {
                    case "middle":
                      this.pdfDocument.save(), this.pdfDocument.translate(0, -(t.getNodeHeight() - t.getViewHeight()) / 2);
                      break;
                    case "bottom":
                      this.pdfDocument.save(), this.pdfDocument.translate(0, -(t.getNodeHeight() - t.getViewHeight()));
                      break;
                  }
              }
              endVerticalAlignment(t) {
                if (!t.isCellContentMultiPage)
                  switch (t.verticalAlignment) {
                    case "middle":
                    case "bottom":
                      this.pdfDocument.restore();
                      break;
                  }
              }
              renderWatermark(t) {
                let C = t.watermark;
                this.pdfDocument.fill(C.color), this.pdfDocument.opacity(C.opacity), this.pdfDocument.save(), this.pdfDocument.rotate(C.angle, {
                  origin: [this.pdfDocument.page.width / 2, this.pdfDocument.page.height / 2]
                });
                let b = this.pdfDocument.page.width / 2 - C._size.size.width / 2, nA = this.pdfDocument.page.height / 2 - C._size.size.height / 2;
                this.pdfDocument._font = C.font, this.pdfDocument.fontSize(C.fontSize), this.pdfDocument.text(C.text, b, nA, {
                  lineBreak: !1
                }), this.pdfDocument.restore();
              }
            }
            const sr = rr;
            class ar {
              /**
               * @param {object} fontDescriptors font definition dictionary
               * @param {object} virtualfs
               * @param {object} urlResolver
               */
              constructor(t, C, b) {
                this.fontDescriptors = t, this.virtualfs = C, this.urlResolver = b;
              }
              /**
               * Executes layout engine for the specified document and renders it into a pdfkit document
               * ready to be saved.
               *
               * @param {object} docDefinition
               * @param {object} options
               * @returns {Promise<PDFDocument>} resolved promise return a pdfkit document
               */
              async createPdfKitDocument(t, C) {
                C === void 0 && (C = {}), await this.resolveUrls(t), t.version = t.version || "1.3", t.subset = t.subset || void 0, t.tagged = typeof t.tagged == "boolean" ? t.tagged : !1, t.displayTitle = typeof t.displayTitle == "boolean" ? t.displayTitle : !1, t.compress = typeof t.compress == "boolean" ? t.compress : !0, t.images = t.images || {}, t.attachments = t.attachments || {}, t.pageMargins = K(t.pageMargins) ? t.pageMargins : 40, t.patterns = t.patterns || {}, t.header && typeof t.header != "function" && (t.header = MA(t.header)), t.footer && typeof t.footer != "function" && (t.footer = MA(t.footer));
                let b = St(t.pageSize, t.pageOrientation), nA = {
                  size: [b.width, b.height],
                  pdfVersion: t.version,
                  subset: t.subset,
                  tagged: t.tagged,
                  displayTitle: t.displayTitle,
                  compress: t.compress,
                  userPassword: t.userPassword,
                  ownerPassword: t.ownerPassword,
                  permissions: t.permissions,
                  lang: t.language,
                  fontLayoutCache: typeof C.fontLayoutCache == "boolean" ? C.fontLayoutCache : !0,
                  bufferPages: C.bufferPages || !1,
                  autoFirstPage: !1,
                  info: Tr(t),
                  font: null
                };
                this.pdfKitDoc = new U(this.fontDescriptors, t.images, t.patterns, t.attachments, nA, this.virtualfs), Ur(t, this.pdfKitDoc);
                const gA = new Wi(b, ri(t.pageMargins), new rn());
                gA.registerTableLayouts(Be), C.tableLayouts && gA.registerTableLayouts(C.tableLayouts);
                let hA = gA.layoutDocument(t.content, this.pdfKitDoc, t.styles || {}, t.defaultStyle || {
                  fontSize: 12,
                  font: "Roboto"
                }, t.background, t.header, t.footer, t.watermark, t.pageBreakBefore), HA = t.maxPagesNumber || -1;
                return D(HA) && HA > -1 && (hA = hA.slice(0, HA)), hA.forEach((fe) => {
                  fe.pageSize.height === 1 / 0 && (fe.pageSize.height = Nr(fe, fe.pageMargins));
                }), new sr(this.pdfKitDoc, C.progressCallback).renderPages(hA), this.pdfKitDoc;
              }
              /**
               * @param {object} docDefinition
               * @returns {Promise}
               */
              async resolveUrls(t) {
                const C = (b) => typeof b == "object" ? {
                  url: b.url,
                  headers: b.headers
                } : {
                  url: b,
                  headers: {}
                };
                for (let b in this.fontDescriptors)
                  if (this.fontDescriptors.hasOwnProperty(b)) {
                    if (this.fontDescriptors[b].normal)
                      if (Array.isArray(this.fontDescriptors[b].normal)) {
                        let nA = C(this.fontDescriptors[b].normal[0]);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].normal[0] = nA.url;
                      } else {
                        let nA = C(this.fontDescriptors[b].normal);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].normal = nA.url;
                      }
                    if (this.fontDescriptors[b].bold)
                      if (Array.isArray(this.fontDescriptors[b].bold)) {
                        let nA = C(this.fontDescriptors[b].bold[0]);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].bold[0] = nA.url;
                      } else {
                        let nA = C(this.fontDescriptors[b].bold);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].bold = nA.url;
                      }
                    if (this.fontDescriptors[b].italics)
                      if (Array.isArray(this.fontDescriptors[b].italics)) {
                        let nA = C(this.fontDescriptors[b].italics[0]);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].italics[0] = nA.url;
                      } else {
                        let nA = C(this.fontDescriptors[b].italics);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].italics = nA.url;
                      }
                    if (this.fontDescriptors[b].bolditalics)
                      if (Array.isArray(this.fontDescriptors[b].bolditalics)) {
                        let nA = C(this.fontDescriptors[b].bolditalics[0]);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].bolditalics[0] = nA.url;
                      } else {
                        let nA = C(this.fontDescriptors[b].bolditalics);
                        this.urlResolver.resolve(nA.url, nA.headers), this.fontDescriptors[b].bolditalics = nA.url;
                      }
                  }
                if (t.images) {
                  for (let b in t.images)
                    if (t.images.hasOwnProperty(b)) {
                      let nA = C(t.images[b]);
                      this.urlResolver.resolve(nA.url, nA.headers), t.images[b] = nA.url;
                    }
                }
                if (t.attachments) {
                  for (let b in t.attachments)
                    if (t.attachments.hasOwnProperty(b) && t.attachments[b].src) {
                      let nA = C(t.attachments[b].src);
                      this.urlResolver.resolve(nA.url, nA.headers), t.attachments[b].src = nA.url;
                    }
                }
                if (t.files) {
                  for (let b in t.files)
                    if (t.files.hasOwnProperty(b) && t.files[b].src) {
                      let nA = C(t.files[b].src);
                      this.urlResolver.resolve(nA.url, nA.headers), t.files[b].src = nA.url;
                    }
                }
                await this.urlResolver.resolved();
              }
            }
            function Tr(NA) {
              function t(b) {
                let nA = ["Title", "Author", "Subject", "Keywords", "Creator", "Producer", "CreationDate", "ModDate", "Trapped"], gA = b.charAt(0).toUpperCase() + b.slice(1);
                return nA.includes(gA) ? gA : b.replace(/\s+/g, "");
              }
              let C = {
                Producer: "pdfmake",
                Creator: "pdfmake"
              };
              if (NA.info)
                for (let b in NA.info) {
                  let nA = NA.info[b];
                  nA && (b = t(b), C[b] = nA);
                }
              return C;
            }
            function Ur(NA, t) {
              if (NA.files)
                for (const C in NA.files) {
                  const b = NA.files[C];
                  if (!b.src) return;
                  t.virtualfs && t.virtualfs.existsSync(b.src) && (b.src = t.virtualfs.readFileSync(b.src)), b.name = b.name || C, t.file(b.src, b);
                }
            }
            function Nr(NA, t) {
              function C(hA) {
                return typeof hA.item.getHeight == "function" ? hA.item.getHeight() : hA.item._height ? hA.item._height : hA.type === "vector" ? typeof hA.item.y1 < "u" ? hA.item.y1 > hA.item.y2 ? hA.item.y1 : hA.item.y2 : hA.item.h : 0;
              }
              function b(hA) {
                let HA = hA.item.y || 0, GA = C(hA);
                return HA + GA;
              }
              let nA = ri(t || 40), gA = nA.top;
              return NA.items.forEach((hA) => {
                let HA = b(hA);
                HA > gA && (gA = HA);
              }), gA += nA.bottom, gA;
            }
            const Rr = ar;
            var Sr = r(6811);
            async function or(NA, t) {
              t === void 0 && (t = {});
              try {
                const C = await fetch(NA, {
                  headers: t
                });
                if (!C.ok)
                  throw new Error(`Failed to fetch (status code: ${C.status}, url: "${NA}")`);
                return await C.arrayBuffer();
              } catch (C) {
                throw new Error(`Network request failed (url: "${NA}", error: ${C.message})`, {
                  cause: C
                });
              }
            }
            class Gr {
              constructor(t) {
                this.fs = t, this.resolving = {}, this.urlAccessPolicy = void 0;
              }
              /**
               * @param {(url: string) => boolean} callback
               */
              setUrlAccessPolicy(t) {
                this.urlAccessPolicy = t;
              }
              resolve(t, C) {
                C === void 0 && (C = {});
                const b = async () => {
                  if (t.toLowerCase().startsWith("https://") || t.toLowerCase().startsWith("http://")) {
                    if (this.fs.existsSync(t))
                      return;
                    if (typeof this.urlAccessPolicy < "u" && this.urlAccessPolicy(t) !== !0)
                      throw new Error(`Access to URL denied by resource access policy: ${t}`);
                    const nA = await or(t, C);
                    this.fs.writeFileSync(t, nA);
                  }
                };
                return this.resolving[t] || (this.resolving[t] = b()), this.resolving[t];
              }
              resolved() {
                return Promise.all(Object.values(this.resolving));
              }
            }
            const Br = Gr;
            var Un = r(9964);
            class yn {
              constructor() {
                this.virtualfs = Sr.default, this.urlAccessPolicy = void 0;
              }
              /**
               * @param {object} docDefinition
               * @param {?object} options
               * @returns {object}
               */
              createPdf(t, C) {
                if (C === void 0 && (C = {}), !q(t))
                  throw new Error("Parameter 'docDefinition' has an invalid type. Object expected.");
                if (!q(C))
                  throw new Error("Parameter 'options' has an invalid type. Object expected.");
                C.progressCallback = this.progressCallback, C.tableLayouts = this.tableLayouts;
                const b = typeof Un < "u" && Un?.versions?.node;
                typeof this.urlAccessPolicy > "u" && b && console.warn("No URL access policy defined. Consider using setUrlAccessPolicy() to restrict external resource downloads.");
                let nA = new Br(this.virtualfs);
                nA.setUrlAccessPolicy(this.urlAccessPolicy);
                const hA = new Rr(this.fonts, this.virtualfs, nA).createPdfKitDocument(t, C);
                return this._transformToDocument(hA);
              }
              /**
               * @param {(url: string) => boolean} callback
               */
              setUrlAccessPolicy(t) {
                if (t !== void 0 && typeof t != "function")
                  throw new Error("Parameter 'callback' has an invalid type. Function or undefined expected.");
                this.urlAccessPolicy = t;
              }
              setProgressCallback(t) {
                this.progressCallback = t;
              }
              addTableLayouts(t) {
                this.tableLayouts = ee(this.tableLayouts, t);
              }
              setTableLayouts(t) {
                this.tableLayouts = t;
              }
              clearTableLayouts() {
                this.tableLayouts = {};
              }
              addFonts(t) {
                this.fonts = ee(this.fonts, t);
              }
              setFonts(t) {
                this.fonts = t;
              }
              clearFonts() {
                this.fonts = {};
              }
              _transformToDocument(t) {
                return t;
              }
            }
            const Jn = yn;
            var Hr = r(783).Buffer;
            class gr {
              /**
               * @param {Promise<object>} pdfDocumentPromise
               */
              constructor(t) {
                this.bufferSize = 1073741824, this.pdfDocumentPromise = t, this.bufferPromise = null;
              }
              /**
               * @returns {Promise<object>}
               */
              getStream() {
                return this.pdfDocumentPromise;
              }
              /**
               * @returns {Promise<Buffer>}
               */
              getBuffer() {
                const t = async () => {
                  const C = await this.getStream();
                  return new Promise((b) => {
                    let nA = [];
                    C.on("readable", () => {
                      let gA;
                      for (; (gA = C.read(this.bufferSize)) !== null; )
                        nA.push(gA);
                    }), C.on("end", () => {
                      b(Hr.concat(nA));
                    }), C.end();
                  });
                };
                return this.bufferPromise === null && (this.bufferPromise = t()), this.bufferPromise;
              }
              /**
               * @returns {Promise<string>}
               */
              async getBase64() {
                return (await this.getBuffer()).toString("base64");
              }
              /**
               * @returns {Promise<string>}
               */
              async getDataUrl() {
                return "data:application/pdf;base64," + await this.getBase64();
              }
            }
            const Lr = gr;
            var qi = r(6457);
            const kr = () => {
              let NA = window.open("", "_blank");
              if (NA === null)
                throw new Error("Open PDF in new window blocked by browser");
              return NA;
            };
            class ln extends Lr {
              /**
               * @returns {Promise<Blob>}
               */
              async getBlob() {
                const t = await this.getBuffer();
                return new Blob([t], {
                  type: "application/pdf"
                });
              }
              /**
               * @param {string} filename
               * @returns {Promise}
               */
              async download(t) {
                t === void 0 && (t = "file.pdf");
                const C = await this.getBlob();
                (0, qi.saveAs)(C, t);
              }
              /**
               * @param {Window} win
               * @returns {Promise}
               */
              async open(t) {
                t === void 0 && (t = null), t || (t = kr());
                const C = await this.getBlob();
                try {
                  let nA = (window.URL || window.webkitURL).createObjectURL(C);
                  t.location.href = nA;
                } catch (b) {
                  throw t.close(), b;
                }
              }
              /**
               * @param {Window} win
               * @returns {Promise}
               */
              async print(t) {
                t === void 0 && (t = null), (await this.getStream()).setOpenActionAsPrint(), await this.open(t);
              }
            }
            const jr = ln;
            var Or = r(2416), Jr = /* @__PURE__ */ r.n(Or), Fn = r(890), Kr = /* @__PURE__ */ r.n(Fn);
            Kr()({
              useNative: ["Promise"]
            });
            let cr = {
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf"
              }
            };
            class Kn extends Jn {
              constructor() {
                super(), this.fonts = cr;
              }
              addFontContainer(t) {
                this.addVirtualFileSystem(t.vfs), this.addFonts(t.fonts);
              }
              addVirtualFileSystem(t) {
                for (let C in t)
                  if (t.hasOwnProperty(C)) {
                    let b, nA;
                    typeof t[C] == "object" ? (b = t[C].data, nA = t[C].encoding || "base64") : (b = t[C], nA = "base64"), Jr().writeFileSync(C, b, nA);
                  }
              }
              _transformToDocument(t) {
                return new jr(t);
              }
            }
            const Wr = new Kn();
          },
          /***/
          2736(Q, B, r) {
            Q.exports = r(7133).default;
          },
          /***/
          2416(Q, B, r) {
            Q.exports = r(6811).default;
          },
          /***/
          6811(Q, B, r) {
            var A = "/";
            r.d(B, {
              /* harmony export */
              default: () => U
              /* harmony export */
            });
            var a = r(783).Buffer;
            const d = (P) => (P.indexOf(A) === 0 && (P = P.substring(A.length)), P.indexOf("/") === 0 && (P = P.substring(1)), P);
            class x {
              constructor() {
                this.storage = {};
              }
              /**
               * @param {string} filename
               * @returns {boolean}
               */
              existsSync(D) {
                const J = d(D);
                return typeof this.storage[J] < "u";
              }
              /**
               * @param {string} filename
               * @param {?string|?object} options
               * @returns {string|Buffer}
               */
              readFileSync(D, J) {
                const q = d(D), AA = typeof J == "object" ? J.encoding : J;
                if (!this.existsSync(q))
                  throw new Error(`File '${q}' not found in virtual file system`);
                const K = this.storage[q];
                return AA ? K.toString(AA) : K;
              }
              /**
               * @param {string} filename
               * @param {string|Buffer} content
               * @param {?string|?object} options
               */
              writeFileSync(D, J, q) {
                const AA = d(D), K = typeof q == "object" ? q.encoding : q;
                if (!J && !q)
                  throw new Error("No content");
                this.storage[AA] = K || typeof J == "string" ? new a(J, K) : J;
              }
            }
            const U = new x();
          },
          /***/
          6582(Q, B, r) {
            B.A = void 0;
            var A = a(r(7696));
            function a(d) {
              return d && d.__esModule ? d : { default: d };
            }
            B.A = A.default;
          },
          /***/
          7696(Q, B, r) {
            Q = r.nmd(Q);
            var A = function(a, d, x, U, P) {
              const D = {
                aliceblue: [240, 248, 255],
                antiquewhite: [250, 235, 215],
                aqua: [0, 255, 255],
                aquamarine: [127, 255, 212],
                azure: [240, 255, 255],
                beige: [245, 245, 220],
                bisque: [255, 228, 196],
                black: [0, 0, 0],
                blanchedalmond: [255, 235, 205],
                blue: [0, 0, 255],
                blueviolet: [138, 43, 226],
                brown: [165, 42, 42],
                burlywood: [222, 184, 135],
                cadetblue: [95, 158, 160],
                chartreuse: [127, 255, 0],
                chocolate: [210, 105, 30],
                coral: [255, 127, 80],
                cornflowerblue: [100, 149, 237],
                cornsilk: [255, 248, 220],
                crimson: [220, 20, 60],
                cyan: [0, 255, 255],
                darkblue: [0, 0, 139],
                darkcyan: [0, 139, 139],
                darkgoldenrod: [184, 134, 11],
                darkgray: [169, 169, 169],
                darkgrey: [169, 169, 169],
                darkgreen: [0, 100, 0],
                darkkhaki: [189, 183, 107],
                darkmagenta: [139, 0, 139],
                darkolivegreen: [85, 107, 47],
                darkorange: [255, 140, 0],
                darkorchid: [153, 50, 204],
                darkred: [139, 0, 0],
                darksalmon: [233, 150, 122],
                darkseagreen: [143, 188, 143],
                darkslateblue: [72, 61, 139],
                darkslategray: [47, 79, 79],
                darkslategrey: [47, 79, 79],
                darkturquoise: [0, 206, 209],
                darkviolet: [148, 0, 211],
                deeppink: [255, 20, 147],
                deepskyblue: [0, 191, 255],
                dimgray: [105, 105, 105],
                dimgrey: [105, 105, 105],
                dodgerblue: [30, 144, 255],
                firebrick: [178, 34, 34],
                floralwhite: [255, 250, 240],
                forestgreen: [34, 139, 34],
                fuchsia: [255, 0, 255],
                gainsboro: [220, 220, 220],
                ghostwhite: [248, 248, 255],
                gold: [255, 215, 0],
                goldenrod: [218, 165, 32],
                gray: [128, 128, 128],
                grey: [128, 128, 128],
                green: [0, 128, 0],
                greenyellow: [173, 255, 47],
                honeydew: [240, 255, 240],
                hotpink: [255, 105, 180],
                indianred: [205, 92, 92],
                indigo: [75, 0, 130],
                ivory: [255, 255, 240],
                khaki: [240, 230, 140],
                lavender: [230, 230, 250],
                lavenderblush: [255, 240, 245],
                lawngreen: [124, 252, 0],
                lemonchiffon: [255, 250, 205],
                lightblue: [173, 216, 230],
                lightcoral: [240, 128, 128],
                lightcyan: [224, 255, 255],
                lightgoldenrodyellow: [250, 250, 210],
                lightgray: [211, 211, 211],
                lightgrey: [211, 211, 211],
                lightgreen: [144, 238, 144],
                lightpink: [255, 182, 193],
                lightsalmon: [255, 160, 122],
                lightseagreen: [32, 178, 170],
                lightskyblue: [135, 206, 250],
                lightslategray: [119, 136, 153],
                lightslategrey: [119, 136, 153],
                lightsteelblue: [176, 196, 222],
                lightyellow: [255, 255, 224],
                lime: [0, 255, 0],
                limegreen: [50, 205, 50],
                linen: [250, 240, 230],
                magenta: [255, 0, 255],
                maroon: [128, 0, 0],
                mediumaquamarine: [102, 205, 170],
                mediumblue: [0, 0, 205],
                mediumorchid: [186, 85, 211],
                mediumpurple: [147, 112, 219],
                mediumseagreen: [60, 179, 113],
                mediumslateblue: [123, 104, 238],
                mediumspringgreen: [0, 250, 154],
                mediumturquoise: [72, 209, 204],
                mediumvioletred: [199, 21, 133],
                midnightblue: [25, 25, 112],
                mintcream: [245, 255, 250],
                mistyrose: [255, 228, 225],
                moccasin: [255, 228, 181],
                navajowhite: [255, 222, 173],
                navy: [0, 0, 128],
                oldlace: [253, 245, 230],
                olive: [128, 128, 0],
                olivedrab: [107, 142, 35],
                orange: [255, 165, 0],
                orangered: [255, 69, 0],
                orchid: [218, 112, 214],
                palegoldenrod: [238, 232, 170],
                palegreen: [152, 251, 152],
                paleturquoise: [175, 238, 238],
                palevioletred: [219, 112, 147],
                papayawhip: [255, 239, 213],
                peachpuff: [255, 218, 185],
                peru: [205, 133, 63],
                pink: [255, 192, 203],
                plum: [221, 160, 221],
                powderblue: [176, 224, 230],
                purple: [128, 0, 128],
                rebeccapurple: [102, 51, 153],
                red: [255, 0, 0],
                rosybrown: [188, 143, 143],
                royalblue: [65, 105, 225],
                saddlebrown: [139, 69, 19],
                salmon: [250, 128, 114],
                sandybrown: [244, 164, 96],
                seagreen: [46, 139, 87],
                seashell: [255, 245, 238],
                sienna: [160, 82, 45],
                silver: [192, 192, 192],
                skyblue: [135, 206, 235],
                slateblue: [106, 90, 205],
                slategray: [112, 128, 144],
                slategrey: [112, 128, 144],
                snow: [255, 250, 250],
                springgreen: [0, 255, 127],
                steelblue: [70, 130, 180],
                tan: [210, 180, 140],
                teal: [0, 128, 128],
                thistle: [216, 191, 216],
                tomato: [255, 99, 71],
                turquoise: [64, 224, 208],
                violet: [238, 130, 238],
                wheat: [245, 222, 179],
                white: [255, 255, 255],
                whitesmoke: [245, 245, 245],
                yellow: [255, 255, 0]
              }, J = {
                black: [D.black, 1],
                white: [D.white, 1],
                transparent: [D.black, 0]
              }, q = {
                quot: 34,
                amp: 38,
                lt: 60,
                gt: 62,
                apos: 39,
                OElig: 338,
                oelig: 339,
                Scaron: 352,
                scaron: 353,
                Yuml: 376,
                circ: 710,
                tilde: 732,
                ensp: 8194,
                emsp: 8195,
                thinsp: 8201,
                zwnj: 8204,
                zwj: 8205,
                lrm: 8206,
                rlm: 8207,
                ndash: 8211,
                mdash: 8212,
                lsquo: 8216,
                rsquo: 8217,
                sbquo: 8218,
                ldquo: 8220,
                rdquo: 8221,
                bdquo: 8222,
                dagger: 8224,
                Dagger: 8225,
                permil: 8240,
                lsaquo: 8249,
                rsaquo: 8250,
                euro: 8364,
                nbsp: 160,
                iexcl: 161,
                cent: 162,
                pound: 163,
                curren: 164,
                yen: 165,
                brvbar: 166,
                sect: 167,
                uml: 168,
                copy: 169,
                ordf: 170,
                laquo: 171,
                not: 172,
                shy: 173,
                reg: 174,
                macr: 175,
                deg: 176,
                plusmn: 177,
                sup2: 178,
                sup3: 179,
                acute: 180,
                micro: 181,
                para: 182,
                middot: 183,
                cedil: 184,
                sup1: 185,
                ordm: 186,
                raquo: 187,
                frac14: 188,
                frac12: 189,
                frac34: 190,
                iquest: 191,
                Agrave: 192,
                Aacute: 193,
                Acirc: 194,
                Atilde: 195,
                Auml: 196,
                Aring: 197,
                AElig: 198,
                Ccedil: 199,
                Egrave: 200,
                Eacute: 201,
                Ecirc: 202,
                Euml: 203,
                Igrave: 204,
                Iacute: 205,
                Icirc: 206,
                Iuml: 207,
                ETH: 208,
                Ntilde: 209,
                Ograve: 210,
                Oacute: 211,
                Ocirc: 212,
                Otilde: 213,
                Ouml: 214,
                times: 215,
                Oslash: 216,
                Ugrave: 217,
                Uacute: 218,
                Ucirc: 219,
                Uuml: 220,
                Yacute: 221,
                THORN: 222,
                szlig: 223,
                agrave: 224,
                aacute: 225,
                acirc: 226,
                atilde: 227,
                auml: 228,
                aring: 229,
                aelig: 230,
                ccedil: 231,
                egrave: 232,
                eacute: 233,
                ecirc: 234,
                euml: 235,
                igrave: 236,
                iacute: 237,
                icirc: 238,
                iuml: 239,
                eth: 240,
                ntilde: 241,
                ograve: 242,
                oacute: 243,
                ocirc: 244,
                otilde: 245,
                ouml: 246,
                divide: 247,
                oslash: 248,
                ugrave: 249,
                uacute: 250,
                ucirc: 251,
                uuml: 252,
                yacute: 253,
                thorn: 254,
                yuml: 255,
                fnof: 402,
                Alpha: 913,
                Beta: 914,
                Gamma: 915,
                Delta: 916,
                Epsilon: 917,
                Zeta: 918,
                Eta: 919,
                Theta: 920,
                Iota: 921,
                Kappa: 922,
                Lambda: 923,
                Mu: 924,
                Nu: 925,
                Xi: 926,
                Omicron: 927,
                Pi: 928,
                Rho: 929,
                Sigma: 931,
                Tau: 932,
                Upsilon: 933,
                Phi: 934,
                Chi: 935,
                Psi: 936,
                Omega: 937,
                alpha: 945,
                beta: 946,
                gamma: 947,
                delta: 948,
                epsilon: 949,
                zeta: 950,
                eta: 951,
                theta: 952,
                iota: 953,
                kappa: 954,
                lambda: 955,
                mu: 956,
                nu: 957,
                xi: 958,
                omicron: 959,
                pi: 960,
                rho: 961,
                sigmaf: 962,
                sigma: 963,
                tau: 964,
                upsilon: 965,
                phi: 966,
                chi: 967,
                psi: 968,
                omega: 969,
                thetasym: 977,
                upsih: 978,
                piv: 982,
                bull: 8226,
                hellip: 8230,
                prime: 8242,
                Prime: 8243,
                oline: 8254,
                frasl: 8260,
                weierp: 8472,
                image: 8465,
                real: 8476,
                trade: 8482,
                alefsym: 8501,
                larr: 8592,
                uarr: 8593,
                rarr: 8594,
                darr: 8595,
                harr: 8596,
                crarr: 8629,
                lArr: 8656,
                uArr: 8657,
                rArr: 8658,
                dArr: 8659,
                hArr: 8660,
                forall: 8704,
                part: 8706,
                exist: 8707,
                empty: 8709,
                nabla: 8711,
                isin: 8712,
                notin: 8713,
                ni: 8715,
                prod: 8719,
                sum: 8721,
                minus: 8722,
                lowast: 8727,
                radic: 8730,
                prop: 8733,
                infin: 8734,
                ang: 8736,
                and: 8743,
                or: 8744,
                cap: 8745,
                cup: 8746,
                int: 8747,
                there4: 8756,
                sim: 8764,
                cong: 8773,
                asymp: 8776,
                ne: 8800,
                equiv: 8801,
                le: 8804,
                ge: 8805,
                sub: 8834,
                sup: 8835,
                nsub: 8836,
                sube: 8838,
                supe: 8839,
                oplus: 8853,
                otimes: 8855,
                perp: 8869,
                sdot: 8901,
                lceil: 8968,
                rceil: 8969,
                lfloor: 8970,
                rfloor: 8971,
                lang: 9001,
                rang: 9002,
                loz: 9674,
                spades: 9824,
                clubs: 9827,
                hearts: 9829,
                diams: 9830
              }, AA = {
                A: 7,
                a: 7,
                C: 6,
                c: 6,
                H: 1,
                h: 1,
                L: 2,
                l: 2,
                M: 2,
                m: 2,
                Q: 4,
                q: 4,
                S: 4,
                s: 4,
                T: 2,
                t: 2,
                V: 1,
                v: 1,
                Z: 0,
                z: 0
              }, K = {
                A3: !0,
                A4: !0,
                a3: !0,
                a4: !0
              }, z = {
                color: {
                  inherit: !0,
                  initial: void 0
                },
                visibility: {
                  inherit: !0,
                  initial: "visible",
                  values: {
                    hidden: "hidden",
                    collapse: "hidden",
                    visible: "visible"
                  }
                },
                fill: {
                  inherit: !0,
                  initial: J.black
                },
                stroke: {
                  inherit: !0,
                  initial: "none"
                },
                "stop-color": {
                  inherit: !1,
                  initial: J.black
                },
                "fill-opacity": {
                  inherit: !0,
                  initial: 1
                },
                "stroke-opacity": {
                  inherit: !0,
                  initial: 1
                },
                "stop-opacity": {
                  inherit: !1,
                  initial: 1
                },
                "fill-rule": {
                  inherit: !0,
                  initial: "nonzero",
                  values: {
                    nonzero: "nonzero",
                    evenodd: "evenodd"
                  }
                },
                "clip-rule": {
                  inherit: !0,
                  initial: "nonzero",
                  values: {
                    nonzero: "nonzero",
                    evenodd: "evenodd"
                  }
                },
                "stroke-width": {
                  inherit: !0,
                  initial: 1
                },
                "stroke-dasharray": {
                  inherit: !0,
                  initial: []
                },
                "stroke-dashoffset": {
                  inherit: !0,
                  initial: 0
                },
                "stroke-miterlimit": {
                  inherit: !0,
                  initial: 4
                },
                "stroke-linejoin": {
                  inherit: !0,
                  initial: "miter",
                  values: {
                    miter: "miter",
                    round: "round",
                    bevel: "bevel"
                  }
                },
                "stroke-linecap": {
                  inherit: !0,
                  initial: "butt",
                  values: {
                    butt: "butt",
                    round: "round",
                    square: "square"
                  }
                },
                "font-size": {
                  inherit: !0,
                  initial: 16,
                  values: {
                    "xx-small": 9,
                    "x-small": 10,
                    small: 13,
                    medium: 16,
                    large: 18,
                    "x-large": 24,
                    "xx-large": 32
                  }
                },
                "font-family": {
                  inherit: !0,
                  initial: "sans-serif"
                },
                "font-weight": {
                  inherit: !0,
                  initial: "normal",
                  values: {
                    600: "bold",
                    700: "bold",
                    800: "bold",
                    900: "bold",
                    bold: "bold",
                    bolder: "bold",
                    500: "normal",
                    400: "normal",
                    300: "normal",
                    200: "normal",
                    100: "normal",
                    normal: "normal",
                    lighter: "normal"
                  }
                },
                "font-style": {
                  inherit: !0,
                  initial: "normal",
                  values: {
                    italic: "italic",
                    oblique: "italic",
                    normal: "normal"
                  }
                },
                "text-anchor": {
                  inherit: !0,
                  initial: "start",
                  values: {
                    start: "start",
                    middle: "middle",
                    end: "end"
                  }
                },
                direction: {
                  inherit: !0,
                  initial: "ltr",
                  values: {
                    ltr: "ltr",
                    rtl: "rtl"
                  }
                },
                "dominant-baseline": {
                  inherit: !0,
                  initial: "baseline",
                  values: {
                    auto: "baseline",
                    baseline: "baseline",
                    "before-edge": "before-edge",
                    "text-before-edge": "before-edge",
                    middle: "middle",
                    central: "central",
                    "after-edge": "after-edge",
                    "text-after-edge": "after-edge",
                    ideographic: "ideographic",
                    alphabetic: "alphabetic",
                    hanging: "hanging",
                    mathematical: "mathematical"
                  }
                },
                "alignment-baseline": {
                  inherit: !1,
                  initial: void 0,
                  values: {
                    auto: "baseline",
                    baseline: "baseline",
                    "before-edge": "before-edge",
                    "text-before-edge": "before-edge",
                    middle: "middle",
                    central: "central",
                    "after-edge": "after-edge",
                    "text-after-edge": "after-edge",
                    ideographic: "ideographic",
                    alphabetic: "alphabetic",
                    hanging: "hanging",
                    mathematical: "mathematical"
                  }
                },
                "baseline-shift": {
                  inherit: !0,
                  initial: "baseline",
                  values: {
                    baseline: "baseline",
                    sub: "sub",
                    super: "super"
                  }
                },
                "word-spacing": {
                  inherit: !0,
                  initial: 0,
                  values: {
                    normal: 0
                  }
                },
                "letter-spacing": {
                  inherit: !0,
                  initial: 0,
                  values: {
                    normal: 0
                  }
                },
                "text-decoration": {
                  inherit: !1,
                  initial: "none",
                  values: {
                    none: "none",
                    underline: "underline",
                    overline: "overline",
                    "line-through": "line-through"
                  }
                },
                "xml:space": {
                  inherit: !0,
                  initial: "default",
                  css: "white-space",
                  values: {
                    preserve: "preserve",
                    default: "default",
                    pre: "preserve",
                    "pre-line": "preserve",
                    "pre-wrap": "preserve",
                    nowrap: "default"
                  }
                },
                "marker-start": {
                  inherit: !0,
                  initial: "none"
                },
                "marker-mid": {
                  inherit: !0,
                  initial: "none"
                },
                "marker-end": {
                  inherit: !0,
                  initial: "none"
                },
                opacity: {
                  inherit: !1,
                  initial: 1
                },
                transform: {
                  inherit: !1,
                  initial: [1, 0, 0, 1, 0, 0]
                },
                display: {
                  inherit: !1,
                  initial: "inline",
                  values: {
                    none: "none",
                    inline: "inline",
                    block: "inline"
                  }
                },
                "clip-path": {
                  inherit: !1,
                  initial: "none"
                },
                mask: {
                  inherit: !1,
                  initial: "none"
                },
                overflow: {
                  inherit: !1,
                  initial: "hidden",
                  values: {
                    hidden: "hidden",
                    scroll: "hidden",
                    visible: "visible"
                  }
                },
                "vector-effect": {
                  inherit: !0,
                  initial: "none",
                  values: {
                    none: "none",
                    "non-scaling-stroke": "non-scaling-stroke"
                  }
                }
              };
              function T(vA) {
                let UA = new function() {
                }();
                return UA.name = "G" + (a._groupCount = (a._groupCount || 0) + 1), UA.resources = a.ref(), UA.xobj = a.ref({
                  Type: "XObject",
                  Subtype: "Form",
                  FormType: 1,
                  BBox: vA,
                  Group: {
                    S: "Transparency",
                    CS: "DeviceRGB",
                    I: !0,
                    K: !1
                  },
                  Resources: UA.resources
                }), UA.xobj.write(""), UA.savedMatrix = a._ctm, UA.savedPage = a.page, ut.push(UA), a._ctm = [1, 0, 0, 1, 0, 0], a.page = {
                  width: a.page.width,
                  height: a.page.height,
                  write: function(mA) {
                    UA.xobj.write(mA);
                  },
                  fonts: {},
                  xobjects: {},
                  ext_gstates: {},
                  patterns: {}
                }, UA;
              }
              function H(vA) {
                if (vA !== ut.pop())
                  throw "Group not matching";
                Object.keys(a.page.fonts).length && (vA.resources.data.Font = a.page.fonts), Object.keys(a.page.xobjects).length && (vA.resources.data.XObject = a.page.xobjects), Object.keys(a.page.ext_gstates).length && (vA.resources.data.ExtGState = a.page.ext_gstates), Object.keys(a.page.patterns).length && (vA.resources.data.Pattern = a.page.patterns), vA.resources.end(), vA.xobj.end(), a._ctm = vA.savedMatrix, a.page = vA.savedPage;
              }
              function eA(vA) {
                a.page.xobjects[vA.name] = vA.xobj, a.addContent("/" + vA.name + " Do");
              }
              function CA(vA, UA) {
                let mA = "M" + (a._maskCount = (a._maskCount || 0) + 1), qA = a.ref({
                  Type: "ExtGState",
                  CA: 1,
                  ca: 1,
                  BM: "Normal",
                  SMask: {
                    S: "Luminosity",
                    G: vA.xobj,
                    BC: [0, 0, 0]
                  }
                });
                qA.end(), a.page.ext_gstates[mA] = qA, a.addContent("/" + mA + " gs");
              }
              function IA(vA, UA, mA, qA) {
                return {
                  type: "PDFPattern",
                  group: vA,
                  dx: UA,
                  dy: mA,
                  matrix: qA || [1, 0, 0, 1, 0, 0]
                };
              }
              function k(vA, UA) {
                let mA = "P" + (a._patternCount = (a._patternCount || 0) + 1), qA = a.ref({
                  Type: "Pattern",
                  PatternType: 1,
                  PaintType: 1,
                  TilingType: 2,
                  BBox: [0, 0, vA.dx, vA.dy],
                  XStep: vA.dx,
                  YStep: vA.dy,
                  Matrix: zA(a._ctm, vA.matrix),
                  Resources: {
                    ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                    XObject: (function() {
                      let _A = {};
                      return _A[vA.group.name] = vA.group.xobj, _A;
                    })()
                  }
                });
                qA.write("/" + vA.group.name + " Do"), qA.end(), a.page.patterns[mA] = qA, UA ? (a.addContent("/Pattern CS"), a.addContent("/" + mA + " SCN")) : (a.addContent("/Pattern cs"), a.addContent("/" + mA + " scn"));
              }
              function tA(vA, UA) {
                a.page.fonts[vA.id] || (a.page.fonts[vA.id] = vA.ref()), a.addContent("BT").addContent("/" + vA.id + " " + UA + " Tf");
              }
              function lA(vA, UA, mA, qA, _A, jA) {
                a.addContent(_(vA) + " " + _(UA) + " " + _(-mA) + " " + _(-qA) + " " + _(_A) + " " + _(jA) + " Tm");
              }
              function uA(vA, UA) {
                let mA = vA && UA ? 2 : UA ? 1 : vA ? 0 : 3;
                a.addContent(mA + " Tr");
              }
              function w(vA, UA) {
                let mA = [], qA = "";
                const _A = UA.fauxItalic ? -0.25 : 0;
                function jA(JA) {
                  qA += JA.glyph, JA.kern !== 0 && (mA.push(`<${qA}> ${_(JA.kern)}`), qA = "");
                }
                function le() {
                  qA.length && (mA.push(`<${qA}> 0`), qA = ""), mA.length && (a.addContent(`[${mA.join(" ")}] TJ`), mA = []);
                }
                for (let JA = 0; JA < vA.length; JA++) {
                  const ne = vA[JA];
                  if (ne.hidden || o(ne.width, 0)) {
                    le();
                    continue;
                  }
                  if (ne.continuous) {
                    jA(ne);
                    continue;
                  }
                  le();
                  const ae = Math.cos(ne.rotate), ve = Math.sin(ne.rotate);
                  lA(ae * ne.scale, ve * ne.scale, ae * _A - ve, ve * _A + ae, ne.x, ne.y), jA(ne);
                }
                le();
              }
              function v() {
                a.addContent("ET");
              }
              function RA(vA) {
                vA[0].type === "PDFPattern" ? (a.fillOpacity(vA[1]), k(vA[0], !1)) : a.fillColor(vA[0], vA[1]);
              }
              function DA(vA) {
                vA[0].type === "PDFPattern" ? (a.strokeOpacity(vA[1]), k(vA[0], !0)) : a.strokeColor(vA[0], vA[1]);
              }
              function $(vA, UA) {
                let mA;
                for (; (mA = vA.slice(1, -1).indexOf(0)) !== -1; ) {
                  let _A = mA + 1, jA = vA[_A - 1] + vA[_A + 1];
                  vA = vA.slice(0, _A - 1).concat([jA]).concat(vA.slice(_A + 2));
                }
                if (vA.length === 2)
                  if (vA[0] === 0) {
                    a.strokeOpacity(0);
                    return;
                  } else vA[1] === 0 && (vA = []);
                else
                  vA[0] === 0 && (UA -= vA[1], vA[vA.length - 1] += vA[1], vA = vA.slice(2)), vA[vA.length - 1] === 0 && (UA += vA[vA.length - 2], vA[0] += vA[vA.length - 2], vA = vA.slice(0, -2));
                let qA = 0;
                for (let _A = 0; _A < vA.length; _A++)
                  qA += vA[_A];
                if (qA > 0)
                  for (; UA < 0; )
                    UA += qA;
                a.dash(vA, {
                  phase: UA
                });
              }
              function cA(vA, UA, mA, qA, _A) {
                let jA = a.ref({
                  Type: "Annot",
                  Subtype: "Link",
                  Rect: [vA, UA, mA, qA],
                  Border: [0, 0, 0],
                  A: {
                    S: "URI",
                    URI: new String(_A)
                  }
                });
                jA.end(), wi.push(jA);
              }
              function $A(vA) {
                let UA = function(JA, ne, ae, ve) {
                  this.error = ve, this.nodeName = JA, this.nodeValue = ae, this.nodeType = ne, this.attributes = /* @__PURE__ */ Object.create(null), this.childNodes = [], this.parentNode = null, this.id = "", this.textContent = "", this.classList = [];
                };
                UA.prototype.getAttribute = function(JA) {
                  return this.attributes[JA] != null ? this.attributes[JA] : null;
                }, UA.prototype.getElementById = function(JA) {
                  let ne = null;
                  return (function ae(ve) {
                    if (!ne && ve.nodeType === 1) {
                      ve.id === JA && (ne = ve);
                      for (let ze = 0; ze < ve.childNodes.length; ze++)
                        ae(ve.childNodes[ze]);
                    }
                  })(this), ne;
                }, UA.prototype.getElementsByTagName = function(JA) {
                  let ne = [];
                  return (function ae(ve) {
                    if (ve.nodeType === 1) {
                      ve.nodeName === JA && ne.push(ve);
                      for (let ze = 0; ze < ve.childNodes.length; ze++)
                        ae(ve.childNodes[ze]);
                    }
                  })(this), ne;
                };
                let mA = new Re(vA.trim()), qA, _A, jA = !1, le = function() {
                  let JA, ne;
                  if (JA = mA.match(/^<([\w:.-]+)\s*/, !0)) {
                    let ae = new UA(JA[1], 1, null, jA);
                    for (; JA = mA.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, !0); ) {
                      let ve = JA[1], ze = kA(JA[2] || JA[3] || "");
                      ae.attributes[ve] ? (vt('parseXml: duplicate attribute "' + ve + '"'), jA = !0) : (ae.attributes[ve] = ze, ve === "id" && (ae.id = ze), ve === "class" && (ae.classList = ze.split(" ")));
                    }
                    if (mA.match(/^>/)) {
                      for (; ne = le(); )
                        ae.childNodes.push(ne), ne.parentNode = ae, ae.textContent += ne.nodeType === 3 || ne.nodeType === 4 ? ne.nodeValue : ne.textContent;
                      return (JA = mA.match(/^<\/([\w:.-]+)\s*>/, !0)) ? (JA[1] === ae.nodeName || (vt('parseXml: tag not matching, opening "' + ae.nodeName + '" & closing "' + JA[1] + '"'), jA = !0), ae) : (vt('parseXml: tag not matching, opening "' + ae.nodeName + '" & not closing'), jA = !0, ae);
                    } else {
                      if (mA.match(/^\/>/))
                        return ae;
                      vt('parseXml: tag could not be parsed "' + ae.nodeName + '"'), jA = !0;
                    }
                  } else {
                    if (JA = mA.match(/^<!--[\s\S]*?-->/))
                      return new UA(null, 8, JA, jA);
                    if (JA = mA.match(/^<\?[\s\S]*?\?>/))
                      return new UA(null, 7, JA, jA);
                    if (JA = mA.match(/^<!DOCTYPE\s*([\s\S]*?)>/))
                      return new UA(null, 10, JA, jA);
                    if (JA = mA.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, !0))
                      return new UA("#cdata-section", 4, JA[1], jA);
                    if (JA = mA.match(/^([^<]+)/, !0))
                      return new UA("#text", 3, kA(JA[1]), jA);
                  }
                };
                for (; _A = le(); )
                  _A.nodeType === 1 && !qA ? qA = _A : (_A.nodeType === 1 || _A.nodeType === 3 && _A.nodeValue.trim() !== "") && vt("parseXml: data after document end has been discarded");
                return mA.matchAll() && vt("parseXml: parsing error"), qA;
              }
              function kA(vA) {
                return vA.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(UA, mA, qA, _A) {
                  return mA ? String.fromCharCode(parseInt(mA, 10)) : qA ? String.fromCharCode(parseInt(qA, 16)) : _A && q[_A] ? String.fromCharCode(q[_A]) : UA;
                });
              }
              function WA(vA) {
                let UA, mA;
                return vA = (vA || "").trim(), (UA = D[vA]) ? mA = [UA.slice(), 1] : (UA = vA.match(/^cmyk\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) ? (UA[1] = parseInt(UA[1]), UA[2] = parseInt(UA[2]), UA[3] = parseInt(UA[3]), UA[4] = parseFloat(UA[4]), UA[1] <= 100 && UA[2] <= 100 && UA[3] <= 100 && UA[4] <= 100 && (mA = [UA.slice(1, 5), 1])) : (UA = vA.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) ? (UA[1] = parseInt(UA[1]), UA[2] = parseInt(UA[2]), UA[3] = parseInt(UA[3]), UA[4] = parseFloat(UA[4]), UA[1] < 256 && UA[2] < 256 && UA[3] < 256 && UA[4] <= 1 && (mA = [UA.slice(1, 4), UA[4]])) : (UA = vA.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) ? (UA[1] = parseInt(UA[1]), UA[2] = parseInt(UA[2]), UA[3] = parseInt(UA[3]), UA[1] < 256 && UA[2] < 256 && UA[3] < 256 && (mA = [UA.slice(1, 4), 1])) : (UA = vA.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) ? (UA[1] = 2.55 * parseFloat(UA[1]), UA[2] = 2.55 * parseFloat(UA[2]), UA[3] = 2.55 * parseFloat(UA[3]), UA[1] < 256 && UA[2] < 256 && UA[3] < 256 && (mA = [UA.slice(1, 4), 1])) : (UA = vA.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) ? mA = [[parseInt(UA[1], 16), parseInt(UA[2], 16), parseInt(UA[3], 16)], 1] : (UA = vA.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) && (mA = [[17 * parseInt(UA[1], 16), 17 * parseInt(UA[2], 16), 17 * parseInt(UA[3], 16)], 1]), Ke ? Ke(mA, vA) : mA;
              }
              function EA(vA, UA, mA) {
                let qA = vA[0].slice(), _A = vA[1] * UA;
                if (mA) {
                  for (let jA = 0; jA < vA.length; jA++)
                    qA[jA] *= _A;
                  return [qA, 1];
                } else
                  return [qA, _A];
              }
              function zA() {
                function vA(mA, qA) {
                  return [mA[0] * qA[0] + mA[2] * qA[1], mA[1] * qA[0] + mA[3] * qA[1], mA[0] * qA[2] + mA[2] * qA[3], mA[1] * qA[2] + mA[3] * qA[3], mA[0] * qA[4] + mA[2] * qA[5] + mA[4], mA[1] * qA[4] + mA[3] * qA[5] + mA[5]];
                }
                let UA = arguments[0];
                for (let mA = 1; mA < arguments.length; mA++)
                  UA = vA(UA, arguments[mA]);
                return UA;
              }
              function OA(vA, UA) {
                return [UA[0] * vA[0] + UA[2] * vA[1] + UA[4], UA[1] * vA[0] + UA[3] * vA[1] + UA[5]];
              }
              function xA() {
                let vA = a._ctm;
                for (let UA = ut.length - 1; UA >= 0; UA--)
                  vA = zA(ut[UA].savedMatrix, vA);
                return vA;
              }
              function LA() {
                return new Ee().M(0, 0).L(a.page.width, 0).L(a.page.width, a.page.height).L(0, a.page.height).transform(TA(xA())).getBoundingBox();
              }
              function yA() {
                const vA = LA();
                return a.page.width / vA[2];
              }
              function TA(vA) {
                let UA = vA[0] * vA[3] - vA[1] * vA[2];
                return [vA[3] / UA, -vA[1] / UA, -vA[2] / UA, vA[0] / UA, (vA[2] * vA[5] - vA[3] * vA[4]) / UA, (vA[1] * vA[4] - vA[0] * vA[5]) / UA];
              }
              function fA(vA) {
                let UA = _(vA[0]), mA = _(vA[1]), qA = _(vA[2]), _A = _(vA[3]), jA = _(vA[4]), le = _(vA[5]);
                if (h(UA * _A - mA * qA, 0))
                  return [UA, mA, qA, _A, jA, le];
              }
              function sA(vA) {
                let UA = vA[2] || 0, mA = vA[1] || 0, qA = vA[0] || 0;
                if (o(UA, 0) && o(mA, 0))
                  return [];
                if (o(UA, 0))
                  return [-qA / mA];
                {
                  let _A = mA * mA - 4 * UA * qA;
                  return h(_A, 0) && _A > 0 ? [(-mA + Math.sqrt(_A)) / (2 * UA), (-mA - Math.sqrt(_A)) / (2 * UA)] : o(_A, 0) ? [-mA / (2 * UA)] : [];
                }
              }
              function F(vA, UA) {
                return (UA[0] || 0) + (UA[1] || 0) * vA + (UA[2] || 0) * vA * vA + (UA[3] || 0) * vA * vA * vA;
              }
              function o(vA, UA) {
                return Math.abs(vA - UA) < 1e-10;
              }
              function h(vA, UA) {
                return Math.abs(vA - UA) >= 1e-10;
              }
              function _(vA) {
                return vA > -1e21 && vA < 1e21 ? Math.round(vA * 1e6) / 1e6 : 0;
              }
              function oA(vA) {
                return typeof vA == "object" && vA !== null && typeof vA.length == "number";
              }
              function p(vA) {
                let UA = new Re((vA || "").trim()), mA = [1, 0, 0, 1, 0, 0], qA;
                for (; qA = UA.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, !0); ) {
                  let _A = qA[1], jA = [], le = new Re(qA[2].trim()), JA;
                  for (; JA = le.matchNumber(); )
                    jA.push(Number(JA)), le.matchSeparator();
                  if (_A === "matrix" && jA.length === 6)
                    mA = zA(mA, [jA[0], jA[1], jA[2], jA[3], jA[4], jA[5]]);
                  else if (_A === "translate" && jA.length === 2)
                    mA = zA(mA, [1, 0, 0, 1, jA[0], jA[1]]);
                  else if (_A === "translate" && jA.length === 1)
                    mA = zA(mA, [1, 0, 0, 1, jA[0], 0]);
                  else if (_A === "scale" && jA.length === 2)
                    mA = zA(mA, [jA[0], 0, 0, jA[1], 0, 0]);
                  else if (_A === "scale" && jA.length === 1)
                    mA = zA(mA, [jA[0], 0, 0, jA[0], 0, 0]);
                  else if (_A === "rotate" && jA.length === 3) {
                    let ne = jA[0] * Math.PI / 180;
                    mA = zA(mA, [1, 0, 0, 1, jA[1], jA[2]], [Math.cos(ne), Math.sin(ne), -Math.sin(ne), Math.cos(ne), 0, 0], [1, 0, 0, 1, -jA[1], -jA[2]]);
                  } else if (_A === "rotate" && jA.length === 1) {
                    let ne = jA[0] * Math.PI / 180;
                    mA = zA(mA, [Math.cos(ne), Math.sin(ne), -Math.sin(ne), Math.cos(ne), 0, 0]);
                  } else if (_A === "skewX" && jA.length === 1) {
                    let ne = jA[0] * Math.PI / 180;
                    mA = zA(mA, [1, 0, Math.tan(ne), 1, 0, 0]);
                  } else if (_A === "skewY" && jA.length === 1) {
                    let ne = jA[0] * Math.PI / 180;
                    mA = zA(mA, [1, Math.tan(ne), 0, 1, 0, 0]);
                  } else
                    return;
                  UA.matchSeparator();
                }
                if (!UA.matchAll())
                  return mA;
              }
              function rA(vA, UA, mA, qA, _A, jA) {
                let le = (vA || "").trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [], JA = le[1] || le[4] || "meet", ne = le[2] || "Mid", ae = le[3] || "Mid", ve = UA / qA, ze = mA / _A, At = {
                  Min: 0,
                  Mid: 0.5,
                  Max: 1
                }[ne] - (jA || 0), Bt = {
                  Min: 0,
                  Mid: 0.5,
                  Max: 1
                }[ae] - (jA || 0);
                return JA === "slice" ? ze = ve = Math.max(ve, ze) : JA === "meet" && (ze = ve = Math.min(ve, ze)), [ve, 0, 0, ze, At * (UA - qA * ve), Bt * (mA - _A * ze)];
              }
              function QA(vA) {
                let UA = /* @__PURE__ */ Object.create(null);
                vA = (vA || "").trim().split(/;/);
                for (let mA = 0; mA < vA.length; mA++) {
                  let qA = (vA[mA].split(":")[0] || "").trim(), _A = (vA[mA].split(":")[1] || "").trim();
                  qA && (UA[qA] = _A);
                }
                if (UA.marker && (UA["marker-start"] || (UA["marker-start"] = UA.marker), UA["marker-mid"] || (UA["marker-mid"] = UA.marker), UA["marker-end"] || (UA["marker-end"] = UA.marker)), UA.font) {
                  let mA = null, qA = null, _A = "normal", jA = "normal", le = "normal", JA = UA.font.split(/\s+/);
                  for (let ne = 0; ne < JA.length; ne++)
                    switch (JA[ne]) {
                      case "normal":
                        break;
                      case "italic":
                      case "oblique":
                        _A = JA[ne];
                        break;
                      case "small-caps":
                        le = JA[ne];
                        break;
                      case "bold":
                      case "bolder":
                      case "lighter":
                      case "100":
                      case "200":
                      case "300":
                      case "400":
                      case "500":
                      case "600":
                      case "700":
                      case "800":
                      case "900":
                        jA = JA[ne];
                        break;
                      default:
                        qA ? mA ? mA += " " + JA[ne] : mA = JA[ne] : qA = JA[ne].split("/")[0];
                        break;
                    }
                  UA["font-style"] || (UA["font-style"] = _A), UA["font-variant"] || (UA["font-variant"] = le), UA["font-weight"] || (UA["font-weight"] = jA), UA["font-size"] || (UA["font-size"] = qA), UA["font-family"] || (UA["font-family"] = mA);
                }
                return UA;
              }
              function bA(vA) {
                let UA = vA.split(/(?=[.#])/g), mA = [], qA = [], _A = [], jA;
                for (let le = 0; le < UA.length; le++)
                  if (jA = UA[le].match(/^[#]([_A-Za-z0-9-]+)$/))
                    mA.push(jA[1]);
                  else if (jA = UA[le].match(/^[.]([_A-Za-z0-9-]+)$/))
                    qA.push(jA[1]);
                  else if (jA = UA[le].match(/^([_A-Za-z0-9-]+)$/))
                    _A.push(jA[1]);
                  else if (UA[le] !== "*")
                    return;
                return {
                  tags: _A,
                  ids: mA,
                  classes: qA,
                  specificity: mA.length * 1e4 + qA.length * 100 + _A.length
                };
              }
              function y(vA) {
                let UA = new Re(vA.trim()), mA = [], qA;
                for (; qA = UA.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, !0); ) {
                  let _A = qA[1].split(/\s*,\s*/g), jA = QA(qA[2]);
                  for (let le = 0; le < _A.length; le++) {
                    let JA = bA(_A[le]);
                    JA && mA.push({
                      selector: JA,
                      css: jA
                    });
                  }
                }
                return mA;
              }
              function M(vA, UA) {
                if (vA.nodeType !== 1)
                  return !1;
                for (let mA = 0; mA < UA.tags.length; mA++)
                  if (UA.tags[mA] !== vA.nodeName)
                    return !1;
                for (let mA = 0; mA < UA.ids.length; mA++)
                  if (UA.ids[mA] !== vA.id)
                    return !1;
                for (let mA = 0; mA < UA.classes.length; mA++)
                  if (vA.classList.indexOf(UA.classes[mA]) === -1)
                    return !1;
                return !0;
              }
              function FA(vA) {
                let UA = /* @__PURE__ */ Object.create(null), mA = /* @__PURE__ */ Object.create(null);
                for (let qA = 0; qA < Yi.length; qA++) {
                  let _A = Yi[qA];
                  if (M(vA, _A.selector))
                    for (let jA in _A.css)
                      mA[jA] > _A.selector.specificity || (UA[jA] = _A.css[jA], mA[jA] = _A.selector.specificity);
                }
                return UA;
              }
              function dA(vA, UA) {
                return vA.concat(UA.slice(vA.length));
              }
              function he(vA, UA) {
                return Math.max(vA.ascender, (vA.bbox[3] || vA.bbox.maxY) * (vA.scale || 1)) * UA / 1e3;
              }
              function ie(vA, UA) {
                return Math.min(vA.descender, (vA.bbox[1] || vA.bbox.minY) * (vA.scale || 1)) * UA / 1e3;
              }
              function KA(vA, UA) {
                return (vA.xHeight || 0.5 * (vA.ascender - vA.descender)) * UA / 1e3;
              }
              function Pe(vA, UA, mA, qA) {
                let _A, jA;
                switch (mA) {
                  case "middle":
                    _A = 0.5 * KA(vA, UA);
                    break;
                  case "central":
                    _A = 0.5 * (ie(vA, UA) + he(vA, UA));
                    break;
                  case "after-edge":
                  case "text-after-edge":
                    _A = ie(vA, UA);
                    break;
                  case "alphabetic":
                  case "auto":
                  case "baseline":
                    _A = 0;
                    break;
                  case "mathematical":
                    _A = 0.5 * he(vA, UA);
                    break;
                  case "hanging":
                    _A = 0.8 * he(vA, UA);
                    break;
                  case "before-edge":
                  case "text-before-edge":
                    _A = he(vA, UA);
                    break;
                  default:
                    _A = 0;
                    break;
                }
                switch (qA) {
                  case "baseline":
                    jA = 0;
                    break;
                  case "super":
                    jA = 0.6 * UA;
                    break;
                  case "sub":
                    jA = -0.6 * UA;
                    break;
                  default:
                    jA = qA;
                    break;
                }
                return _A - jA;
              }
              function Je(vA, UA, mA) {
                let qA = vA.encode("" + mA), _A = qA[0], jA = qA[1], le = [];
                for (let JA = 0; JA < _A.length; JA++) {
                  let ne = vA.unicode ? vA.unicode[parseInt(_A[JA], 16)] : [mA.charCodeAt(JA)];
                  le.push({
                    glyph: _A[JA],
                    unicode: ne,
                    kern: jA[JA].advanceWidth - jA[JA].xAdvance,
                    width: jA[JA].advanceWidth * UA / 1e3,
                    xOffset: jA[JA].xOffset * UA / 1e3,
                    yOffset: jA[JA].yOffset * UA / 1e3,
                    xAdvance: jA[JA].xAdvance * UA / 1e3,
                    yAdvance: jA[JA].yAdvance * UA / 1e3
                  });
                }
                return le;
              }
              function Le(vA, UA) {
                switch (vA.nodeName) {
                  case "use":
                    return new aA(vA, UA);
                  case "symbol":
                    return new j(vA, UA);
                  case "g":
                    return new pA(vA, UA);
                  case "a":
                    return new Be(vA, UA);
                  case "svg":
                    return new Ie(vA, UA);
                  case "image":
                    return new ee(vA, UA);
                  case "rect":
                    return new at(vA, UA);
                  case "circle":
                    return new V(vA, UA);
                  case "ellipse":
                    return new me(vA, UA);
                  case "line":
                    return new Ye(vA, UA);
                  case "polyline":
                    return new SA(vA, UA);
                  case "polygon":
                    return new ue(vA, UA);
                  case "path":
                    return new Fe(vA, UA);
                  case "text":
                    return new Mt(vA, UA);
                  case "tspan":
                    return new st(vA, UA);
                  case "textPath":
                    return new xt(vA, UA);
                  case "#text":
                  case "#cdata-section":
                    return new fi(vA);
                  default:
                    return new wA(vA, UA);
                }
              }
              var Re = function(vA) {
                this.match = function(UA, mA) {
                  let qA = vA.match(UA);
                  if (!(!qA || qA.index !== 0))
                    return vA = vA.substring(qA[0].length), mA ? qA : qA[0];
                }, this.matchSeparator = function() {
                  return this.match(/^(?:\s*,\s*|\s*|)/);
                }, this.matchSpace = function() {
                  return this.match(/^(?:\s*)/);
                }, this.matchLengthUnit = function() {
                  return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
                }, this.matchNumber = function() {
                  return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
                }, this.matchAll = function() {
                  return this.match(/^[\s\S]+/);
                };
              }, _e = function(vA, UA, mA, qA, _A, jA, le, JA) {
                let ne = 6 * Dt, ae = [vA, -3 * vA + 3 * mA, 3 * vA - 6 * mA + 3 * _A, -vA + 3 * mA - 3 * _A + le], ve = [UA, -3 * UA + 3 * qA, 3 * UA - 6 * qA + 3 * jA, -UA + 3 * qA - 3 * jA + JA], ze = [-3 * vA + 3 * mA, 6 * vA - 12 * mA + 6 * _A, -3 * vA + 9 * mA - 9 * _A + 3 * le], At = [-3 * UA + 3 * qA, 6 * UA - 12 * qA + 6 * jA, -3 * UA + 9 * qA - 9 * jA + 3 * JA], Bt = [0];
                for (let He = 1; He <= ne; He++) {
                  let Ce = (He - 0.5) / ne, je = F(Ce, ze) / ne, it = F(Ce, At) / ne, Et = Math.sqrt(je * je + it * it);
                  Bt[He] = Bt[He - 1] + Et;
                }
                this.totalLength = Bt[ne], this.startPoint = [vA, UA, o(vA, mA) && o(UA, qA) ? Math.atan2(jA - qA, _A - mA) : Math.atan2(qA - UA, mA - vA)], this.endPoint = [le, JA, o(_A, le) && o(jA, JA) ? Math.atan2(jA - qA, _A - mA) : Math.atan2(JA - jA, le - _A)], this.getBoundingBox = function() {
                  let He, Ce = F(0, ae), je = F(0, ve), it = F(1, ae), Et = F(1, ve);
                  Ce > it && (He = it, it = Ce, Ce = He), je > Et && (He = Et, Et = je, je = He);
                  let Ft = sA(ze);
                  for (let Nt = 0; Nt < Ft.length; Nt++)
                    if (Ft[Nt] >= 0 && Ft[Nt] <= 1) {
                      let gt = F(Ft[Nt], ae);
                      gt < Ce && (Ce = gt), gt > it && (it = gt);
                    }
                  let Qt = sA(At);
                  for (let Nt = 0; Nt < Qt.length; Nt++)
                    if (Qt[Nt] >= 0 && Qt[Nt] <= 1) {
                      let gt = F(Qt[Nt], ve);
                      gt < je && (je = gt), gt > Et && (Et = gt);
                    }
                  return [Ce, je, it, Et];
                }, this.getPointAtLength = function(He) {
                  if (o(He, 0))
                    return this.startPoint;
                  if (o(He, this.totalLength))
                    return this.endPoint;
                  if (!(He < 0 || He > this.totalLength))
                    for (let Ce = 1; Ce <= ne; Ce++) {
                      let je = Bt[Ce - 1], it = Bt[Ce];
                      if (je <= He && He <= it) {
                        let Et = (Ce - (it - He) / (it - je)) / ne, Ft = F(Et, ae), Qt = F(Et, ve), Nt = F(Et, ze), gt = F(Et, At);
                        return [Ft, Qt, Math.atan2(gt, Nt)];
                      }
                    }
                };
              }, se = function(vA, UA, mA, qA) {
                this.totalLength = Math.sqrt((mA - vA) * (mA - vA) + (qA - UA) * (qA - UA)), this.startPoint = [vA, UA, Math.atan2(qA - UA, mA - vA)], this.endPoint = [mA, qA, Math.atan2(qA - UA, mA - vA)], this.getBoundingBox = function() {
                  return [Math.min(this.startPoint[0], this.endPoint[0]), Math.min(this.startPoint[1], this.endPoint[1]), Math.max(this.startPoint[0], this.endPoint[0]), Math.max(this.startPoint[1], this.endPoint[1])];
                }, this.getPointAtLength = function(_A) {
                  if (_A >= 0 && _A <= this.totalLength) {
                    let jA = _A / this.totalLength || 0, le = this.startPoint[0] + jA * (this.endPoint[0] - this.startPoint[0]), JA = this.startPoint[1] + jA * (this.endPoint[1] - this.startPoint[1]);
                    return [le, JA, this.startPoint[2]];
                  }
                };
              }, Ee = function() {
                this.pathCommands = [], this.pathSegments = [], this.startPoint = null, this.endPoint = null, this.totalLength = 0;
                let vA = 0, UA = 0, mA = 0, qA = 0, _A, jA, le;
                this.move = function(JA, ne) {
                  return vA = mA = JA, UA = qA = ne, null;
                }, this.line = function(JA, ne) {
                  let ae = new se(mA, qA, JA, ne);
                  return mA = JA, qA = ne, ae;
                }, this.curve = function(JA, ne, ae, ve, ze, At) {
                  let Bt = new _e(mA, qA, JA, ne, ae, ve, ze, At);
                  return mA = ze, qA = At, Bt;
                }, this.close = function() {
                  let JA = new se(mA, qA, vA, UA);
                  return mA = vA, qA = UA, JA;
                }, this.addCommand = function(JA) {
                  this.pathCommands.push(JA);
                  let ne = this[JA[0]].apply(this, JA.slice(3));
                  ne && (ne.hasStart = JA[1], ne.hasEnd = JA[2], this.startPoint = this.startPoint || ne.startPoint, this.endPoint = ne.endPoint, this.pathSegments.push(ne), this.totalLength += ne.totalLength);
                }, this.M = function(JA, ne) {
                  return this.addCommand(["move", !0, !0, JA, ne]), _A = "M", this;
                }, this.m = function(JA, ne) {
                  return this.M(mA + JA, qA + ne);
                }, this.Z = this.z = function() {
                  return this.addCommand(["close", !0, !0]), _A = "Z", this;
                }, this.L = function(JA, ne) {
                  return this.addCommand(["line", !0, !0, JA, ne]), _A = "L", this;
                }, this.l = function(JA, ne) {
                  return this.L(mA + JA, qA + ne);
                }, this.H = function(JA) {
                  return this.L(JA, qA);
                }, this.h = function(JA) {
                  return this.L(mA + JA, qA);
                }, this.V = function(JA) {
                  return this.L(mA, JA);
                }, this.v = function(JA) {
                  return this.L(mA, qA + JA);
                }, this.C = function(JA, ne, ae, ve, ze, At) {
                  return this.addCommand(["curve", !0, !0, JA, ne, ae, ve, ze, At]), _A = "C", jA = ae, le = ve, this;
                }, this.c = function(JA, ne, ae, ve, ze, At) {
                  return this.C(mA + JA, qA + ne, mA + ae, qA + ve, mA + ze, qA + At);
                }, this.S = function(JA, ne, ae, ve) {
                  return this.C(mA + (_A === "C" ? mA - jA : 0), qA + (_A === "C" ? qA - le : 0), JA, ne, ae, ve);
                }, this.s = function(JA, ne, ae, ve) {
                  return this.C(mA + (_A === "C" ? mA - jA : 0), qA + (_A === "C" ? qA - le : 0), mA + JA, qA + ne, mA + ae, qA + ve);
                }, this.Q = function(JA, ne, ae, ve) {
                  let ze = mA + 0.6666666666666666 * (JA - mA), At = qA + 2 / 3 * (ne - qA), Bt = ae + 2 / 3 * (JA - ae), He = ve + 2 / 3 * (ne - ve);
                  return this.addCommand(["curve", !0, !0, ze, At, Bt, He, ae, ve]), _A = "Q", jA = JA, le = ne, this;
                }, this.q = function(JA, ne, ae, ve) {
                  return this.Q(mA + JA, qA + ne, mA + ae, qA + ve);
                }, this.T = function(JA, ne) {
                  return this.Q(mA + (_A === "Q" ? mA - jA : 0), qA + (_A === "Q" ? qA - le : 0), JA, ne);
                }, this.t = function(JA, ne) {
                  return this.Q(mA + (_A === "Q" ? mA - jA : 0), qA + (_A === "Q" ? qA - le : 0), mA + JA, qA + ne);
                }, this.A = function(JA, ne, ae, ve, ze, At, Bt) {
                  if (o(JA, 0) || o(ne, 0))
                    this.addCommand(["line", !0, !0, At, Bt]);
                  else {
                    ae = ae * (Math.PI / 180), JA = Math.abs(JA), ne = Math.abs(ne), ve = 1 * !!ve, ze = 1 * !!ze;
                    let He = Math.cos(ae) * (mA - At) / 2 + Math.sin(ae) * (qA - Bt) / 2, Ce = Math.cos(ae) * (qA - Bt) / 2 - Math.sin(ae) * (mA - At) / 2, je = He * He / (JA * JA) + Ce * Ce / (ne * ne);
                    je > 1 && (JA *= Math.sqrt(je), ne *= Math.sqrt(je));
                    let it = Math.sqrt(Math.max(0, JA * JA * ne * ne - JA * JA * Ce * Ce - ne * ne * He * He) / (JA * JA * Ce * Ce + ne * ne * He * He)), Et = (ve === ze ? -1 : 1) * it * JA * Ce / ne, Ft = (ve === ze ? 1 : -1) * it * ne * He / JA, Qt = Math.cos(ae) * Et - Math.sin(ae) * Ft + (mA + At) / 2, Nt = Math.sin(ae) * Et + Math.cos(ae) * Ft + (qA + Bt) / 2, gt = Math.atan2((Ce - Ft) / ne, (He - Et) / JA), yt = Math.atan2((-Ce - Ft) / ne, (-He - Et) / JA);
                    ze === 0 && yt - gt > 0 ? yt -= 2 * Math.PI : ze === 1 && yt - gt < 0 && (yt += 2 * Math.PI);
                    let oi = Math.ceil(Math.abs(yt - gt) / (Math.PI / Dt));
                    for (let Ai = 0; Ai < oi; Ai++) {
                      let _t = gt + Ai * (yt - gt) / oi, St = gt + (Ai + 1) * (yt - gt) / oi, ri = 4 / 3 * Math.tan((St - _t) / 4), gn = Qt + Math.cos(ae) * JA * (Math.cos(_t) - ri * Math.sin(_t)) - Math.sin(ae) * ne * (Math.sin(_t) + ri * Math.cos(_t)), Pi = Nt + Math.sin(ae) * JA * (Math.cos(_t) - ri * Math.sin(_t)) + Math.cos(ae) * ne * (Math.sin(_t) + ri * Math.cos(_t)), Fi = Qt + Math.cos(ae) * JA * (Math.cos(St) + ri * Math.sin(St)) - Math.sin(ae) * ne * (Math.sin(St) - ri * Math.cos(St)), ki = Nt + Math.sin(ae) * JA * (Math.cos(St) + ri * Math.sin(St)) + Math.cos(ae) * ne * (Math.sin(St) - ri * Math.cos(St)), di = Qt + Math.cos(ae) * JA * Math.cos(St) - Math.sin(ae) * ne * Math.sin(St), ji = Nt + Math.sin(ae) * JA * Math.cos(St) + Math.cos(ae) * ne * Math.sin(St);
                      this.addCommand(["curve", Ai === 0, Ai === oi - 1, gn, Pi, Fi, ki, di, ji]);
                    }
                  }
                  return _A = "A", this;
                }, this.a = function(JA, ne, ae, ve, ze, At, Bt) {
                  return this.A(JA, ne, ae, ve, ze, mA + At, qA + Bt);
                }, this.path = function(JA) {
                  let ne, ae, ve, ze = new Re((JA || "").trim());
                  for (; ne = ze.match(/^[astvzqmhlcASTVZQMHLC]/); ) {
                    ze.matchSeparator();
                    let At = [];
                    for (; ae = K[ne + At.length] ? ze.match(/^[01]/) : ze.matchNumber(); )
                      ze.matchSeparator(), At.length === AA[ne] && (this[ne].apply(this, At), At = [], ne === "M" ? ne = "L" : ne === "m" && (ne = "l")), At.push(Number(ae));
                    if (At.length === AA[ne])
                      this[ne].apply(this, At);
                    else {
                      vt("SvgPath: command " + ne + " with " + At.length + " numbers");
                      return;
                    }
                  }
                  return (ve = ze.matchAll()) && vt("SvgPath: unexpected string " + ve), this;
                }, this.getBoundingBox = function() {
                  let JA = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  function ne(ae) {
                    ae[0] < JA[0] && (JA[0] = ae[0]), ae[2] > JA[2] && (JA[2] = ae[2]), ae[1] < JA[1] && (JA[1] = ae[1]), ae[3] > JA[3] && (JA[3] = ae[3]);
                  }
                  for (let ae = 0; ae < this.pathSegments.length; ae++)
                    ne(this.pathSegments[ae].getBoundingBox());
                  return JA[0] === 1 / 0 && (JA[0] = 0), JA[1] === 1 / 0 && (JA[1] = 0), JA[2] === -1 / 0 && (JA[2] = 0), JA[3] === -1 / 0 && (JA[3] = 0), JA;
                }, this.getPointAtLength = function(JA) {
                  if (JA >= 0 && JA <= this.totalLength) {
                    let ne;
                    for (let ae = 0; ae < this.pathSegments.length; ae++) {
                      if (ne = this.pathSegments[ae].getPointAtLength(JA))
                        return ne;
                      JA -= this.pathSegments[ae].totalLength;
                    }
                    return this.endPoint;
                  }
                }, this.transform = function(JA) {
                  this.pathSegments = [], this.startPoint = null, this.endPoint = null, this.totalLength = 0;
                  for (let ne = 0; ne < this.pathCommands.length; ne++) {
                    let ae = this.pathCommands.shift();
                    for (let ve = 3; ve < ae.length; ve += 2) {
                      let ze = OA([ae[ve], ae[ve + 1]], JA);
                      ae[ve] = ze[0], ae[ve + 1] = ze[1];
                    }
                    this.addCommand(ae);
                  }
                  return this;
                }, this.mergeShape = function(JA) {
                  for (let ne = 0; ne < JA.pathCommands.length; ne++)
                    this.addCommand(JA.pathCommands[ne].slice());
                  return this;
                }, this.clone = function() {
                  return new Ee().mergeShape(this);
                }, this.insertInDocument = function() {
                  for (let JA = 0; JA < this.pathCommands.length; JA++) {
                    let ne = this.pathCommands[JA][0], ae = this.pathCommands[JA].slice(3);
                    switch (ne) {
                      case "move":
                        a.moveTo(ae[0], ae[1]);
                        break;
                      case "line":
                        a.lineTo(ae[0], ae[1]);
                        break;
                      case "curve":
                        a.bezierCurveTo(ae[0], ae[1], ae[2], ae[3], ae[4], ae[5]);
                        break;
                      case "close":
                        a.closePath();
                        break;
                    }
                  }
                }, this.getSubPaths = function() {
                  let JA = [], ne = new Ee();
                  for (let ae = 0; ae < this.pathCommands.length; ae++) {
                    let ve = this.pathCommands[ae];
                    this.pathCommands[ae][0] === "move" && ae !== 0 && (JA.push(ne), ne = new Ee()), ne.addCommand(ve);
                  }
                  return JA.push(ne), JA;
                }, this.getMarkers = function() {
                  let JA = [], ne = this.getSubPaths();
                  for (let ae = 0; ae < ne.length; ae++) {
                    let ve = ne[ae], ze = [];
                    for (let At = 0; At < ve.pathSegments.length; At++) {
                      let Bt = ve.pathSegments[At];
                      if (h(Bt.totalLength, 0) || At === 0 || At === ve.pathSegments.length - 1) {
                        if (Bt.hasStart) {
                          let He = Bt.getPointAtLength(0), Ce = ze.pop();
                          Ce && (He[2] = 0.5 * (Ce[2] + He[2])), ze.push(He);
                        }
                        if (Bt.hasEnd) {
                          let He = Bt.getPointAtLength(Bt.totalLength);
                          ze.push(He);
                        }
                      }
                    }
                    JA = JA.concat(ze);
                  }
                  return JA;
                };
              }, wA = function(vA, UA) {
                let mA = /* @__PURE__ */ Object.create(null), qA = null;
                this.name = vA.nodeName, this.isOuterElement = vA === d || !vA.parentNode, this.inherits = UA || (this.isOuterElement ? null : Le(vA.parentNode, null)), this.stack = this.inherits ? this.inherits.stack.concat(vA) : [vA], this.style = QA(typeof vA.getAttribute == "function" && vA.getAttribute("style")), this.css = Ot ? getComputedStyle(vA) : FA(vA), this.allowedChildren = [], this.attr = function(_A) {
                  if (typeof vA.getAttribute == "function")
                    return vA.getAttribute(_A);
                }, this.resolveUrl = function(_A) {
                  let jA = (_A || "").match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [], le = jA[1] || jA[3] || jA[5] || jA[7], JA = jA[2] || jA[4] || jA[6] || jA[8];
                  if (JA) {
                    if (!le) {
                      let ne = d.getElementById(JA);
                      if (ne) {
                        if (this.stack.indexOf(ne) === -1)
                          return ne;
                        vt('SVGtoPDF: loop of circular references for id "' + JA + '"');
                        return;
                      }
                    }
                    if (qe) {
                      let ne = ni[le];
                      if (!ne) {
                        ne = qe(le), oA(ne) || (ne = [ne]);
                        for (let ae = 0; ae < ne.length; ae++)
                          typeof ne[ae] == "string" && (ne[ae] = $A(ne[ae]));
                        ni[le] = ne;
                      }
                      for (let ae = 0; ae < ne.length; ae++) {
                        let ve = ne[ae].getElementById(JA);
                        if (ve) {
                          if (this.stack.indexOf(ve) === -1)
                            return ve;
                          vt('SVGtoPDF: loop of circular references for id "' + le + "#" + JA + '"');
                          return;
                        }
                      }
                    }
                  }
                }, this.computeUnits = function(_A, jA, le, JA) {
                  return jA === "%" ? parseFloat(_A) / 100 * (JA || le != null ? le : this.getViewport()) : jA === "ex" || jA === "em" ? _A * {
                    em: 1,
                    ex: 0.5
                  }[jA] * (JA ? le : this.get("font-size")) : _A * {
                    "": 1,
                    px: 1,
                    pt: 96 / 72,
                    cm: 96 / 2.54,
                    mm: 96 / 25.4,
                    in: 96,
                    pc: 96 / 6
                  }[jA];
                }, this.computeLength = function(_A, jA, le, JA) {
                  let ne = new Re((_A || "").trim()), ae, ve;
                  return typeof (ae = ne.matchNumber()) == "string" && typeof (ve = ne.matchLengthUnit()) == "string" && !ne.matchAll() ? this.computeUnits(ae, ve, jA, JA) : le;
                }, this.computeLengthList = function(_A, jA, le) {
                  let JA = new Re((_A || "").trim()), ne = [], ae, ve;
                  for (; typeof (ae = JA.matchNumber()) == "string" && typeof (ve = JA.matchLengthUnit()) == "string"; )
                    ne.push(this.computeUnits(ae, ve, jA)), JA.matchSeparator();
                  if (!(le && JA.matchAll()))
                    return ne;
                }, this.getLength = function(_A, jA, le) {
                  return this.computeLength(this.attr(_A), jA, le);
                }, this.getLengthList = function(_A, jA) {
                  return this.computeLengthList(this.attr(_A), jA);
                }, this.getUrl = function(_A) {
                  return this.resolveUrl(this.attr(_A));
                }, this.getNumberList = function(_A) {
                  let jA = new Re((this.attr(_A) || "").trim()), le = [], JA;
                  for (; JA = jA.matchNumber(); )
                    le.push(Number(JA)), jA.matchSeparator();
                  return le.error = jA.matchAll(), le;
                }, this.getViewbox = function(_A, jA) {
                  let le = this.getNumberList(_A);
                  return le.length === 4 && le[2] >= 0 && le[3] >= 0 ? le : jA;
                }, this.getPercent = function(_A, jA) {
                  let le = this.attr(_A), JA = new Re((le || "").trim()), ne = JA.matchNumber();
                  return !ne || (JA.match("%") && (ne *= 0.01), JA.matchAll()) ? jA : Math.max(0, Math.min(1, ne));
                }, this.chooseValue = function(_A) {
                  for (let jA = 0; jA < arguments.length; jA++)
                    if (arguments[jA] != null && arguments[jA] === arguments[jA])
                      return arguments[jA];
                  return arguments[arguments.length - 1];
                }, this.get = function(_A) {
                  if (mA[_A] !== void 0)
                    return mA[_A];
                  let jA = z[_A] || {}, le, JA;
                  for (let ne = 0; ne < 3; ne++) {
                    switch (ne) {
                      case 0:
                        _A !== "transform" && (le = this.css[jA.css || _A]);
                        break;
                      case 1:
                        le = this.style[_A];
                        break;
                      case 2:
                        le = this.attr(_A);
                        break;
                    }
                    if (le === "inherit" && (JA = this.inherits ? this.inherits.get(_A) : jA.initial, JA != null) || jA.values != null && (JA = jA.values[le], JA != null))
                      return mA[_A] = JA;
                    if (le != null) {
                      let ae;
                      switch (_A) {
                        case "font-size":
                          JA = this.computeLength(le, this.inherits ? this.inherits.get(_A) : jA.initial, void 0, !0);
                          break;
                        case "baseline-shift":
                          JA = this.computeLength(le, this.get("font-size"));
                          break;
                        case "font-family":
                          JA = le || void 0;
                          break;
                        case "opacity":
                        case "stroke-opacity":
                        case "fill-opacity":
                        case "stop-opacity":
                          ae = parseFloat(le), isNaN(ae) || (JA = Math.max(0, Math.min(1, ae)));
                          break;
                        case "transform":
                          JA = p(le);
                          break;
                        case "stroke-dasharray":
                          if (le === "none")
                            JA = [];
                          else if (ae = this.computeLengthList(le, this.getViewport(), !0)) {
                            let ve = 0, ze = !1;
                            for (let At = 0; At < ae.length; At++)
                              ae[At] < 0 && (ze = !0), ve += ae[At];
                            ze || (ae.length % 2 === 1 && (ae = ae.concat(ae)), JA = ve === 0 ? [] : ae);
                          }
                          break;
                        case "color":
                          le === "none" || le === "transparent" ? JA = "none" : JA = WA(le);
                          break;
                        case "fill":
                        case "stroke":
                          if (le === "none" || le === "transparent")
                            JA = "none";
                          else if (le === "currentColor")
                            JA = this.get("color");
                          else {
                            if (ae = WA(le))
                              return ae;
                            if (ae = (le || "").split(" ")) {
                              let ve = this.resolveUrl(ae[0]), ze = WA(ae[1]);
                              ve == null ? JA = ze : ve.nodeName === "linearGradient" || ve.nodeName === "radialGradient" ? JA = new MA(ve, null, ze) : ve.nodeName === "pattern" ? JA = new Me(ve, null, ze) : JA = ze;
                            }
                          }
                          break;
                        case "stop-color":
                          le === "none" || le === "transparent" ? JA = "none" : le === "currentColor" ? JA = this.get("color") : JA = WA(le);
                          break;
                        case "marker-start":
                        case "marker-mid":
                        case "marker-end":
                        case "clip-path":
                        case "mask":
                          le === "none" ? JA = "none" : JA = this.resolveUrl(le);
                          break;
                        case "stroke-width":
                          ae = this.computeLength(le, this.getViewport()), ae != null && ae >= 0 && (JA = ae);
                          break;
                        case "stroke-miterlimit":
                          ae = parseFloat(le), ae != null && ae >= 1 && (JA = ae);
                          break;
                        case "word-spacing":
                        case "letter-spacing":
                          JA = this.computeLength(le, this.getViewport());
                          break;
                        case "stroke-dashoffset":
                          JA = this.computeLength(le, this.getViewport());
                          break;
                      }
                      if (JA != null)
                        return mA[_A] = JA;
                    }
                  }
                  return mA[_A] = jA.inherit && this.inherits ? this.inherits.get(_A) : jA.initial;
                }, this.getChildren = function() {
                  if (qA != null)
                    return qA;
                  let _A = [];
                  for (let jA = 0; jA < vA.childNodes.length; jA++) {
                    let le = vA.childNodes[jA];
                    !le.error && this.allowedChildren.indexOf(le.nodeName) !== -1 && _A.push(Le(le, this));
                  }
                  return qA = _A;
                }, this.getParentVWidth = function() {
                  return this.inherits ? this.inherits.getVWidth() : Xt;
                }, this.getParentVHeight = function() {
                  return this.inherits ? this.inherits.getVHeight() : xi;
                }, this.getParentViewport = function() {
                  return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
                }, this.getVWidth = function() {
                  return this.getParentVWidth();
                }, this.getVHeight = function() {
                  return this.getParentVHeight();
                }, this.getViewport = function() {
                  return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
                }, this.getBoundingBox = function() {
                  return this.getBoundingShape().getBoundingBox();
                };
              }, N = function(vA, UA) {
                wA.call(this, vA, UA), this.transform = function() {
                  a.transform.apply(a, this.getTransformation());
                }, this.clip = function() {
                  if (this.get("clip-path") !== "none") {
                    let mA = new We(this.get("clip-path"), null);
                    return mA.useMask(mA.attr("clipPathUnits") === "objectBoundingBox" ? this.getBoundingBox() : null), !0;
                  }
                }, this.mask = function() {
                  if (this.get("mask") !== "none")
                    return new Ze(this.get("mask"), null).useMask(this.getBoundingBox()), !0;
                }, this.getFill = function(mA, qA) {
                  let _A = this.get("opacity"), jA = this.get("fill"), le = this.get("fill-opacity");
                  if (mA)
                    return J.white;
                  if (jA !== "none" && _A && le)
                    return jA instanceof MA || jA instanceof Me ? jA.getPaint(this.getBoundingBox(), le * _A, mA, qA) : EA(jA, le * _A, qA);
                }, this.getStroke = function(mA, qA) {
                  let _A = this.get("opacity"), jA = this.get("stroke"), le = this.get("stroke-opacity");
                  if (!(mA || o(this.get("stroke-width"), 0)) && jA !== "none" && _A && le)
                    return jA instanceof MA || jA instanceof Me ? jA.getPaint(this.getBoundingBox(), le * _A, mA, qA) : EA(jA, le * _A, qA);
                };
              }, G = function(vA, UA) {
                N.call(this, vA, UA), this.allowedChildren = ["use", "g", "a", "svg", "image", "rect", "circle", "ellipse", "line", "polyline", "polygon", "path", "text"], this.getBoundingShape = function() {
                  let mA = new Ee(), qA = this.getChildren();
                  for (let _A = 0; _A < qA.length; _A++)
                    if (qA[_A].get("display") !== "none" && typeof qA[_A].getBoundingShape == "function") {
                      let jA = qA[_A].getBoundingShape().clone();
                      typeof qA[_A].getTransformation == "function" && jA.transform(qA[_A].getTransformation()), mA.mergeShape(jA);
                    }
                  return mA;
                }, this.drawChildren = function(mA, qA) {
                  let _A = this.getChildren();
                  for (let jA = 0; jA < _A.length; jA++)
                    _A[jA].get("display") !== "none" && typeof _A[jA].drawInDocument == "function" && _A[jA].drawInDocument(mA, qA);
                };
              }, W = function(vA, UA) {
                G.call(this, vA, UA), this.drawContent = function(mA, qA) {
                  this.transform();
                  let _A = this.clip(), jA = this.mask(), le;
                  (this.get("opacity") < 1 || _A || jA) && !mA && (le = T(LA())), this.drawChildren(mA, qA), le && (H(le), a.fillOpacity(this.get("opacity")), eA(le));
                };
              }, aA = function(vA, UA) {
                W.call(this, vA, UA);
                let mA = this.getLength("x", this.getVWidth(), 0), qA = this.getLength("y", this.getVHeight(), 0), _A = this.getUrl("href") || this.getUrl("xlink:href");
                _A && (_A = Le(_A, this)), this.getChildren = function() {
                  return _A ? [_A] : [];
                }, this.drawInDocument = function(jA, le) {
                  a.save(), this.drawContent(jA, le), a.restore();
                }, this.getTransformation = function() {
                  return zA(this.get("transform"), [1, 0, 0, 1, mA, qA]);
                };
              }, j = function(vA, UA) {
                W.call(this, vA, UA);
                let mA = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), qA = this.getLength("height", this.getParentVHeight(), this.getParentVHeight());
                UA instanceof aA && (mA = UA.getLength("width", UA.getParentVWidth(), mA), qA = UA.getLength("height", UA.getParentVHeight(), qA));
                let _A = (this.attr("preserveAspectRatio") || "").trim(), jA = this.getViewbox("viewBox", [0, 0, mA, qA]);
                this.getVWidth = function() {
                  return jA[2];
                }, this.getVHeight = function() {
                  return jA[3];
                }, this.drawInDocument = function(le, JA) {
                  a.save(), this.drawContent(le, JA), a.restore();
                }, this.getTransformation = function() {
                  return zA(rA(_A, mA, qA, jA[2], jA[3]), [1, 0, 0, 1, -jA[0], -jA[1]]);
                };
              }, pA = function(vA, UA) {
                W.call(this, vA, UA), this.drawInDocument = function(mA, qA) {
                  a.save(), this.link && !mA && !qA && this.addLink(), this.drawContent(mA, qA), a.restore();
                }, this.getTransformation = function() {
                  return this.get("transform");
                };
              }, Be = function(vA, UA) {
                UA && UA.isText ? (st.call(this, vA, UA), this.allowedChildren = ["textPath", "tspan", "#text", "#cdata-section", "a"]) : pA.call(this, vA, UA), this.link = this.attr("href") || this.attr("xlink:href"), this.addLink = function() {
                  if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                    let mA = this.getBoundingShape().transform(xA()).getBoundingBox();
                    cA(mA[0], mA[1], mA[2], mA[3], this.link);
                  }
                };
              }, Ie = function(vA, UA) {
                W.call(this, vA, UA);
                let mA = this.getLength("width", this.getParentVWidth(), this.getParentVWidth()), qA = this.getLength("height", this.getParentVHeight(), this.getParentVHeight()), _A = this.getLength("x", this.getParentVWidth(), 0), jA = this.getLength("y", this.getParentVHeight(), 0);
                UA instanceof aA && (mA = UA.getLength("width", UA.getParentVWidth(), mA), qA = UA.getLength("height", UA.getParentVHeight(), qA));
                let le = this.attr("preserveAspectRatio"), JA = this.getViewbox("viewBox", [0, 0, mA, qA]);
                this.isOuterElement && mi && (_A = jA = 0, mA = Xt, qA = xi, le = mi), this.getVWidth = function() {
                  return JA[2];
                }, this.getVHeight = function() {
                  return JA[3];
                }, this.drawInDocument = function(ne, ae) {
                  a.save(), this.get("overflow") === "hidden" && (new Ee().M(_A, jA).L(_A + mA, jA).L(_A + mA, jA + qA).L(_A, jA + qA).Z().transform(this.get("transform")).insertInDocument(), a.clip()), this.drawContent(ne, ae), a.restore();
                }, this.getTransformation = function() {
                  return zA(this.get("transform"), [1, 0, 0, 1, _A, jA], rA(le, mA, qA, JA[2], JA[3]), [1, 0, 0, 1, -JA[0], -JA[1]]);
                };
              }, ee = function(vA, UA) {
                N.call(this, vA, UA);
                let mA = ei(this.attr("href") || this.attr("xlink:href") || ""), qA = this.getLength("x", this.getVWidth(), 0), _A = this.getLength("y", this.getVHeight(), 0), jA = this.getLength("width", this.getVWidth(), "auto"), le = this.getLength("height", this.getVHeight(), "auto"), JA;
                try {
                  JA = a.openImage(mA);
                } catch {
                  vt('SVGElemImage: failed to open image "' + mA + '" in PDFKit');
                }
                JA && (jA === "auto" && le !== "auto" ? jA = le * JA.width / JA.height : le === "auto" && jA !== "auto" ? le = jA * JA.height / JA.width : jA === "auto" && le === "auto" && (jA = JA.width, le = JA.height)), (jA === "auto" || jA < 0) && (jA = 0), (le === "auto" || le < 0) && (le = 0), this.getTransformation = function() {
                  return this.get("transform");
                }, this.getBoundingShape = function() {
                  return new Ee().M(qA, _A).L(qA + jA, _A).M(qA + jA, _A + le).L(qA, _A + le);
                }, this.drawInDocument = function(ne, ae) {
                  this.get("visibility") === "hidden" || !JA || (a.save(), this.transform(), this.get("overflow") === "hidden" && a.rect(qA, _A, jA, le).clip(), this.clip(), this.mask(), a.translate(qA, _A), a.transform.apply(a, rA(this.attr("preserveAspectRatio"), jA, le, JA ? JA.width : jA, JA ? JA.height : le)), ne ? (a.rect(0, 0, JA.width, JA.height), RA(J.white).fill()) : (a.fillOpacity(this.get("opacity")), a.image(JA, 0, 0)), a.restore());
                };
              }, Me = function(vA, UA, mA) {
                G.call(this, vA, UA), this.ref = (function() {
                  let jA = this.getUrl("href") || this.getUrl("xlink:href");
                  if (jA && jA.nodeName === vA.nodeName)
                    return new Me(jA, UA, mA);
                }).call(this);
                let qA = this.attr;
                this.attr = function(jA) {
                  let le = qA.call(this, jA);
                  return le != null || jA === "href" || jA === "xlink:href" ? le : this.ref ? this.ref.attr(jA) : null;
                };
                let _A = this.getChildren;
                this.getChildren = function() {
                  let jA = _A.call(this);
                  return jA.length > 0 ? jA : this.ref ? this.ref.getChildren() : [];
                }, this.getPaint = function(jA, le, JA, ne) {
                  let ae = this.attr("patternUnits") !== "userSpaceOnUse", ve = this.attr("patternContentUnits") === "objectBoundingBox", ze = this.getLength("x", ae ? 1 : this.getParentVWidth(), 0), At = this.getLength("y", ae ? 1 : this.getParentVHeight(), 0), Bt = this.getLength("width", ae ? 1 : this.getParentVWidth(), 0), He = this.getLength("height", ae ? 1 : this.getParentVHeight(), 0);
                  ve && !ae ? (ze = (ze - jA[0]) / (jA[2] - jA[0]) || 0, At = (At - jA[1]) / (jA[3] - jA[1]) || 0, Bt = Bt / (jA[2] - jA[0]) || 0, He = He / (jA[3] - jA[1]) || 0) : !ve && ae && (ze = jA[0] + ze * (jA[2] - jA[0]), At = jA[1] + At * (jA[3] - jA[1]), Bt = Bt * (jA[2] - jA[0]), He = He * (jA[3] - jA[1]));
                  let Ce = this.getViewbox("viewBox", [0, 0, Bt, He]), je = (this.attr("preserveAspectRatio") || "").trim(), it = zA(rA(je, Bt, He, Ce[2], Ce[3], 0), [1, 0, 0, 1, -Ce[0], -Ce[1]]), Et = p(this.attr("patternTransform"));
                  if (ve && (Et = zA([jA[2] - jA[0], 0, 0, jA[3] - jA[1], jA[0], jA[1]], Et)), Et = zA(Et, [1, 0, 0, 1, ze, At]), (Et = fA(Et)) && (it = fA(it)) && (Bt = _(Bt)) && (He = _(He))) {
                    let Ft = T([0, 0, Bt, He]);
                    return a.transform.apply(a, it), this.drawChildren(JA, ne), H(Ft), [IA(Ft, Bt, He, Et), le];
                  } else
                    return mA ? [mA[0], mA[1] * le] : void 0;
                }, this.getVWidth = function() {
                  let jA = this.attr("patternUnits") !== "userSpaceOnUse", le = this.getLength("width", jA ? 1 : this.getParentVWidth(), 0);
                  return this.getViewbox("viewBox", [0, 0, le, 0])[2];
                }, this.getVHeight = function() {
                  let jA = this.attr("patternUnits") !== "userSpaceOnUse", le = this.getLength("height", jA ? 1 : this.getParentVHeight(), 0);
                  return this.getViewbox("viewBox", [0, 0, 0, le])[3];
                };
              }, MA = function(vA, UA, mA) {
                wA.call(this, vA, UA), this.allowedChildren = ["stop"], this.ref = (function() {
                  let jA = this.getUrl("href") || this.getUrl("xlink:href");
                  if (jA && jA.nodeName === vA.nodeName)
                    return new MA(jA, UA, mA);
                }).call(this);
                let qA = this.attr;
                this.attr = function(jA) {
                  let le = qA.call(this, jA);
                  return le != null || jA === "href" || jA === "xlink:href" ? le : this.ref ? this.ref.attr(jA) : null;
                };
                let _A = this.getChildren;
                this.getChildren = function() {
                  let jA = _A.call(this);
                  return jA.length > 0 ? jA : this.ref ? this.ref.getChildren() : [];
                }, this.getPaint = function(jA, le, JA, ne) {
                  let ae = this.getChildren();
                  if (ae.length === 0)
                    return;
                  if (ae.length === 1) {
                    let gt = ae[0], yt = gt.get("stop-color");
                    return yt === "none" ? void 0 : EA(yt, gt.get("stop-opacity") * le, ne);
                  }
                  let ve = this.attr("gradientUnits") !== "userSpaceOnUse", ze = p(this.attr("gradientTransform")), At = this.attr("spreadMethod"), Bt, He, Ce, je, it, Et, Ft = 0, Qt = 0, Nt = 1;
                  if (ve && (ze = zA([jA[2] - jA[0], 0, 0, jA[3] - jA[1], jA[0], jA[1]], ze)), ze = fA(ze)) {
                    if (this.name === "linearGradient")
                      He = this.getLength("x1", ve ? 1 : this.getVWidth(), 0), Ce = this.getLength("x2", ve ? 1 : this.getVWidth(), ve ? 1 : this.getVWidth()), je = this.getLength("y1", ve ? 1 : this.getVHeight(), 0), it = this.getLength("y2", ve ? 1 : this.getVHeight(), 0);
                    else {
                      Ce = this.getLength("cx", ve ? 1 : this.getVWidth(), ve ? 0.5 : 0.5 * this.getVWidth()), it = this.getLength("cy", ve ? 1 : this.getVHeight(), ve ? 0.5 : 0.5 * this.getVHeight()), Et = this.getLength("r", ve ? 1 : this.getViewport(), ve ? 0.5 : 0.5 * this.getViewport()), He = this.getLength("fx", ve ? 1 : this.getVWidth(), Ce), je = this.getLength("fy", ve ? 1 : this.getVHeight(), it), Et < 0 && vt("SvgElemGradient: negative r value");
                      let gt = Math.sqrt(Math.pow(Ce - He, 2) + Math.pow(it - je, 2)), yt = 1;
                      gt > Et && (yt = Et / gt, He = Ce + (He - Ce) * yt, je = it + (je - it) * yt), Et = Math.max(Et, gt * yt * (1 + 1e-6));
                    }
                    if (At === "reflect" || At === "repeat") {
                      let gt = TA(ze), yt = OA([jA[0], jA[1]], gt), oi = OA([jA[2], jA[1]], gt), Ai = OA([jA[2], jA[3]], gt), _t = OA([jA[0], jA[3]], gt);
                      this.name === "linearGradient" ? (Ft = Math.max((yt[0] - Ce) * (Ce - He) + (yt[1] - it) * (it - je), (oi[0] - Ce) * (Ce - He) + (oi[1] - it) * (it - je), (Ai[0] - Ce) * (Ce - He) + (Ai[1] - it) * (it - je), (_t[0] - Ce) * (Ce - He) + (_t[1] - it) * (it - je)) / (Math.pow(Ce - He, 2) + Math.pow(it - je, 2)), Qt = Math.max((yt[0] - He) * (He - Ce) + (yt[1] - je) * (je - it), (oi[0] - He) * (He - Ce) + (oi[1] - je) * (je - it), (Ai[0] - He) * (He - Ce) + (Ai[1] - je) * (je - it), (_t[0] - He) * (He - Ce) + (_t[1] - je) * (je - it)) / (Math.pow(Ce - He, 2) + Math.pow(it - je, 2))) : Ft = Math.sqrt(Math.max(Math.pow(yt[0] - Ce, 2) + Math.pow(yt[1] - it, 2), Math.pow(oi[0] - Ce, 2) + Math.pow(oi[1] - it, 2), Math.pow(Ai[0] - Ce, 2) + Math.pow(Ai[1] - it, 2), Math.pow(_t[0] - Ce, 2) + Math.pow(_t[1] - it, 2))) / Et - 1, Ft = Math.ceil(Ft + 0.5), Qt = Math.ceil(Qt + 0.5), Nt = Qt + 1 + Ft;
                    }
                    this.name === "linearGradient" ? Bt = a.linearGradient(He - Qt * (Ce - He), je - Qt * (it - je), Ce + Ft * (Ce - He), it + Ft * (it - je)) : Bt = a.radialGradient(He, je, 0, Ce, it, Et + Ft * Et);
                    for (let gt = 0; gt < Nt; gt++) {
                      let yt = 0, oi = At !== "reflect" || (gt - Qt) % 2 === 0;
                      for (let Ai = 0; Ai < ae.length; Ai++) {
                        let _t = ae[oi ? Ai : ae.length - 1 - Ai], St = _t.get("stop-color");
                        St === "none" && (St = J.transparent), St = EA(St, _t.get("stop-opacity") * le, ne), yt = Math.max(yt, oi ? _t.getPercent("offset", 0) : 1 - _t.getPercent("offset", 0)), Ai === 0 && St[0].length === 4 && (Bt._colorSpace = "DeviceCMYK"), Ai === 0 && yt > 0 && Bt.stop((gt + 0) / Nt, St[0], St[1]), Bt.stop((gt + yt) / (Ft + Qt + 1), St[0], St[1]), Ai === ae.length - 1 && yt < 1 && Bt.stop((gt + 1) / Nt, St[0], St[1]);
                      }
                    }
                    return Bt.setTransform.apply(Bt, ze), [Bt, 1];
                  } else
                    return mA ? [mA[0], mA[1] * le] : void 0;
                };
              }, be = function(vA, UA) {
                N.call(this, vA, UA), this.dashScale = 1, this.getBoundingShape = function() {
                  return this.shape;
                }, this.getTransformation = function() {
                  return this.get("transform");
                }, this.drawInDocument = function(mA, qA) {
                  if (!(this.get("visibility") === "hidden" || !this.shape)) {
                    if (a.save(), this.get("vector-effect") === "non-scaling-stroke" ? this.shape.transform(this.getTransformation()) : this.transform(), this.clip(), mA)
                      this.shape.insertInDocument(), RA(J.white), a.fill(this.get("clip-rule"));
                    else {
                      let _A = this.mask(), jA;
                      _A && (jA = T(LA()));
                      let le = this.shape.getSubPaths(), JA = this.getFill(mA, qA), ne = this.getStroke(mA, qA), ae = this.get("stroke-width"), ve = this.get("stroke-linecap");
                      if (this.get("vector-effect") === "non-scaling-stroke" && (ae = ae / yA()), JA || ne) {
                        if (JA && RA(JA), ne) {
                          for (let je = 0; je < le.length; je++)
                            if (o(le[je].totalLength, 0) && (ve === "square" || ve === "round") && ae > 0 && le[je].startPoint && le[je].startPoint.length > 1) {
                              let it = le[je].startPoint[0], Et = le[je].startPoint[1];
                              RA(ne), ve === "square" ? a.rect(it - 0.5 * ae, Et - 0.5 * ae, ae, ae) : ve === "round" && a.circle(it, Et, 0.5 * ae), a.fill();
                            }
                          let He = this.get("stroke-dasharray"), Ce = this.get("stroke-dashoffset");
                          if (h(this.dashScale, 1)) {
                            for (let je = 0; je < He.length; je++)
                              He[je] *= this.dashScale;
                            Ce *= this.dashScale;
                          }
                          DA(ne), a.lineWidth(ae).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(ve), $(He, Ce);
                        }
                        for (let He = 0; He < le.length; He++)
                          le[He].totalLength > 0 && le[He].insertInDocument();
                        JA && ne ? a.fillAndStroke(this.get("fill-rule")) : JA ? a.fill(this.get("fill-rule")) : ne && a.stroke();
                      }
                      let ze = this.get("marker-start"), At = this.get("marker-mid"), Bt = this.get("marker-end");
                      if (ze !== "none" || At !== "none" || Bt !== "none") {
                        let He = this.shape.getMarkers();
                        if (ze !== "none" && He.length > 0 && new tt(ze, null).drawMarker(!1, qA, He[0], ae), At !== "none")
                          for (let Ce = 1; Ce < He.length - 1; Ce++)
                            new tt(At, null).drawMarker(!1, qA, He[Ce], ae);
                        Bt !== "none" && He.length > 0 && new tt(Bt, null).drawMarker(!1, qA, He[He.length - 1], ae);
                      }
                      jA && (H(jA), eA(jA));
                    }
                    a.restore();
                  }
                };
              }, at = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getLength("x", this.getVWidth(), 0), qA = this.getLength("y", this.getVHeight(), 0), _A = this.getLength("width", this.getVWidth(), 0), jA = this.getLength("height", this.getVHeight(), 0), le = this.getLength("rx", this.getVWidth()), JA = this.getLength("ry", this.getVHeight());
                le === void 0 && JA === void 0 ? le = JA = 0 : le === void 0 && JA !== void 0 ? le = JA : le !== void 0 && JA === void 0 && (JA = le), _A > 0 && jA > 0 ? le && JA ? (le = Math.min(le, 0.5 * _A), JA = Math.min(JA, 0.5 * jA), this.shape = new Ee().M(mA + le, qA).L(mA + _A - le, qA).A(le, JA, 0, 0, 1, mA + _A, qA + JA).L(mA + _A, qA + jA - JA).A(le, JA, 0, 0, 1, mA + _A - le, qA + jA).L(mA + le, qA + jA).A(le, JA, 0, 0, 1, mA, qA + jA - JA).L(mA, qA + JA).A(le, JA, 0, 0, 1, mA + le, qA).Z()) : this.shape = new Ee().M(mA, qA).L(mA + _A, qA).L(mA + _A, qA + jA).L(mA, qA + jA).Z() : this.shape = new Ee();
              }, V = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getLength("cx", this.getVWidth(), 0), qA = this.getLength("cy", this.getVHeight(), 0), _A = this.getLength("r", this.getViewport(), 0);
                _A > 0 ? this.shape = new Ee().M(mA + _A, qA).A(_A, _A, 0, 0, 1, mA - _A, qA).A(_A, _A, 0, 0, 1, mA + _A, qA).Z() : this.shape = new Ee();
              }, me = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getLength("cx", this.getVWidth(), 0), qA = this.getLength("cy", this.getVHeight(), 0), _A = this.getLength("rx", this.getVWidth(), 0), jA = this.getLength("ry", this.getVHeight(), 0);
                _A > 0 && jA > 0 ? this.shape = new Ee().M(mA + _A, qA).A(_A, jA, 0, 0, 1, mA - _A, qA).A(_A, jA, 0, 0, 1, mA + _A, qA).Z() : this.shape = new Ee();
              }, Ye = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getLength("x1", this.getVWidth(), 0), qA = this.getLength("y1", this.getVHeight(), 0), _A = this.getLength("x2", this.getVWidth(), 0), jA = this.getLength("y2", this.getVHeight(), 0);
                this.shape = new Ee().M(mA, qA).L(_A, jA);
              }, SA = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getNumberList("points");
                this.shape = new Ee();
                for (let qA = 0; qA < mA.length - 1; qA += 2)
                  qA === 0 ? this.shape.M(mA[qA], mA[qA + 1]) : this.shape.L(mA[qA], mA[qA + 1]);
                mA.error && vt("SvgElemPolygon: unexpected string " + mA.error), mA.length % 2 === 1 && vt("SvgElemPolyline: uneven number of coordinates");
              }, ue = function(vA, UA) {
                be.call(this, vA, UA);
                let mA = this.getNumberList("points");
                this.shape = new Ee();
                for (let qA = 0; qA < mA.length - 1; qA += 2)
                  qA === 0 ? this.shape.M(mA[qA], mA[qA + 1]) : this.shape.L(mA[qA], mA[qA + 1]);
                this.shape.Z(), mA.error && vt("SvgElemPolygon: unexpected string " + mA.error), mA.length % 2 === 1 && vt("SvgElemPolygon: uneven number of coordinates");
              }, Fe = function(vA, UA) {
                be.call(this, vA, UA), this.shape = new Ee().path(this.attr("d"));
                let mA = this.getLength("pathLength", this.getViewport());
                this.pathLength = mA > 0 ? mA : void 0, this.dashScale = this.pathLength !== void 0 ? this.shape.totalLength / this.pathLength : 1;
              }, tt = function(vA, UA) {
                G.call(this, vA, UA);
                let mA = this.getLength("markerWidth", this.getParentVWidth(), 3), qA = this.getLength("markerHeight", this.getParentVHeight(), 3), _A = this.getViewbox("viewBox", [0, 0, mA, qA]);
                this.getVWidth = function() {
                  return _A[2];
                }, this.getVHeight = function() {
                  return _A[3];
                }, this.drawMarker = function(jA, le, JA, ne) {
                  a.save();
                  let ae = this.attr("orient"), ve = this.attr("markerUnits"), ze = ae === "auto" ? JA[2] : (parseFloat(ae) || 0) * Math.PI / 180, At = ve === "userSpaceOnUse" ? 1 : ne;
                  a.transform(Math.cos(ze) * At, Math.sin(ze) * At, -Math.sin(ze) * At, Math.cos(ze) * At, JA[0], JA[1]);
                  let Bt = this.getLength("refX", this.getVWidth(), 0), He = this.getLength("refY", this.getVHeight(), 0), Ce = rA(this.attr("preserveAspectRatio"), mA, qA, _A[2], _A[3], 0.5);
                  this.get("overflow") === "hidden" && a.rect(Ce[0] * (_A[0] + _A[2] / 2 - Bt) - mA / 2, Ce[3] * (_A[1] + _A[3] / 2 - He) - qA / 2, mA, qA).clip(), a.transform.apply(a, Ce), a.translate(-Bt, -He);
                  let je;
                  this.get("opacity") < 1 && !jA && (je = T(LA())), this.drawChildren(jA, le), je && (H(je), a.fillOpacity(this.get("opacity")), eA(je)), a.restore();
                };
              }, We = function(vA, UA) {
                G.call(this, vA, UA), this.useMask = function(mA) {
                  let qA = T(LA());
                  a.save(), a.transform.apply(a, this.get("transform")), this.attr("clipPathUnits") === "objectBoundingBox" && a.transform(mA[2] - mA[0], 0, 0, mA[3] - mA[1], mA[0], mA[1]), this.clip(), this.drawChildren(!0, !1), a.restore(), H(qA), CA(qA);
                };
              }, Ze = function(vA, UA) {
                G.call(this, vA, UA), this.useMask = function(mA) {
                  let qA = T(LA());
                  a.save(), this.attr("maskUnits") === "userSpaceOnUse" ? (this.getLength("x", this.getVWidth(), -0.1 * (mA[2] - mA[0]) + mA[0]), this.getLength("y", this.getVHeight(), -0.1 * (mA[3] - mA[1]) + mA[1]), this.getLength("width", this.getVWidth(), 1.2 * (mA[2] - mA[0])), this.getLength("height", this.getVHeight(), 1.2 * (mA[3] - mA[1]))) : (this.getLength("x", this.getVWidth(), -0.1) * (mA[2] - mA[0]) + mA[0], this.getLength("y", this.getVHeight(), -0.1) * (mA[3] - mA[1]) + mA[1], this.getLength("width", this.getVWidth(), 1.2) * (mA[2] - mA[0]), this.getLength("height", this.getVHeight(), 1.2) * (mA[3] - mA[1])), this.attr("maskContentUnits") === "objectBoundingBox" && a.transform(mA[2] - mA[0], 0, 0, mA[3] - mA[1], mA[0], mA[1]), this.clip(), this.drawChildren(!1, !0), a.restore(), H(qA), CA(qA);
                };
              }, Ct = function(vA, UA) {
                N.call(this, vA, UA), this.allowedChildren = ["tspan", "#text", "#cdata-section", "a"], this.isText = !0, this.getBoundingShape = function() {
                  let mA = new Ee();
                  for (let qA = 0; qA < this._pos.length; qA++) {
                    let _A = this._pos[qA];
                    if (!_A.hidden) {
                      let jA = _A.ascent * Math.sin(_A.rotate), le = -_A.ascent * Math.cos(_A.rotate), JA = _A.descent * Math.sin(_A.rotate), ne = -_A.descent * Math.cos(_A.rotate), ae = _A.width * Math.cos(_A.rotate), ve = _A.width * Math.sin(_A.rotate);
                      mA.M(_A.x + jA, _A.y + le).L(_A.x + jA + ae, _A.y + le + ve).M(_A.x + JA + ae, _A.y + ne + ve).L(_A.x + JA, _A.y + ne);
                    }
                  }
                  return mA;
                }, this.drawTextInDocument = function(mA, qA) {
                  this.link && !mA && !qA && this.addLink(), this.get("text-decoration") === "underline" && this.decorate(0.05 * this._font.size, -0.075 * this._font.size, mA, qA), this.get("text-decoration") === "overline" && this.decorate(0.05 * this._font.size, he(this._font.font, this._font.size) + 0.075 * this._font.size, mA, qA);
                  let _A = this.getFill(mA, qA), jA = this.getStroke(mA, qA), le = this.get("stroke-width");
                  this._font.fauxBold && (jA ? le += this._font.size * 0.03 : (jA = _A, le = this._font.size * 0.03));
                  let JA = this.getChildren();
                  for (let ne = 0; ne < JA.length; ne++) {
                    let ae = JA[ne];
                    switch (ae.name) {
                      case "tspan":
                      case "textPath":
                      case "a":
                        ae.get("display") !== "none" && ae.drawTextInDocument(mA, qA);
                        break;
                      case "#text":
                      case "#cdata-section":
                        if (this.get("visibility") === "hidden")
                          continue;
                        (_A || jA || mA) && (_A && RA(_A), jA && le && (DA(jA), a.lineWidth(le).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")), $(this.get("stroke-dasharray"), this.get("stroke-dashoffset"))), tA(this._font.font, this._font.size), uA(!!_A, !!jA), w(ae._pos, this._font), v());
                        break;
                    }
                  }
                  this.get("text-decoration") === "line-through" && this.decorate(0.05 * this._font.size, 0.5 * (he(this._font.font, this._font.size) + ie(this._font.font, this._font.size)), mA, qA);
                }, this.decorate = function(mA, qA, _A, jA) {
                  let le = this.getFill(_A, jA), JA = this.getStroke(_A, jA);
                  le && RA(le), JA && (DA(JA), a.lineWidth(this.get("stroke-width")).miterLimit(this.get("stroke-miterlimit")).lineJoin(this.get("stroke-linejoin")).lineCap(this.get("stroke-linecap")), $(this.get("stroke-dasharray"), this.get("stroke-dashoffset")));
                  for (let ne = 0, ae = this._pos; ne < ae.length; ne++)
                    if (!ae[ne].hidden && h(ae[ne].width, 0)) {
                      let ve = (qA + mA / 2) * Math.sin(ae[ne].rotate), ze = -(qA + mA / 2) * Math.cos(ae[ne].rotate), At = (qA - mA / 2) * Math.sin(ae[ne].rotate), Bt = -(qA - mA / 2) * Math.cos(ae[ne].rotate), He = ae[ne].width * Math.cos(ae[ne].rotate), Ce = ae[ne].width * Math.sin(ae[ne].rotate);
                      new Ee().M(ae[ne].x + ve, ae[ne].y + ze).L(ae[ne].x + ve + He, ae[ne].y + ze + Ce).L(ae[ne].x + At + He, ae[ne].y + Bt + Ce).L(ae[ne].x + At, ae[ne].y + Bt).Z().insertInDocument(), le && JA ? a.fillAndStroke() : le ? a.fill() : JA && a.stroke();
                    }
                };
              }, fi = function(vA, UA) {
                this.name = vA.nodeName, this.textContent = vA.nodeValue;
              }, st = function(vA, UA) {
                Ct.call(this, vA, UA);
              }, xt = function(vA, UA) {
                Ct.call(this, vA, UA);
                let mA;
                if ((mA = this.attr("path")) && mA.trim() !== "") {
                  let qA = this.getLength("pathLength", this.getViewport());
                  this.pathObject = new Ee().path(mA), this.pathLength = qA > 0 ? qA : this.pathObject.totalLength, this.pathScale = this.pathObject.totalLength / this.pathLength;
                } else if ((mA = this.getUrl("href") || this.getUrl("xlink:href")) && mA.nodeName === "path") {
                  let qA = new Fe(mA, this);
                  this.pathObject = qA.shape.clone().transform(qA.get("transform")), this.pathLength = this.chooseValue(qA.pathLength, this.pathObject.totalLength), this.pathScale = this.pathObject.totalLength / this.pathLength;
                }
              }, Mt = function(vA, UA) {
                Ct.call(this, vA, UA), this.allowedChildren = ["textPath", "tspan", "#text", "#cdata-section", "a"], (function(mA) {
                  let qA = "", _A = vA.textContent, jA = [], le = [], JA, ne, ae = 0, ve = 0;
                  function ze() {
                    if (le.length) {
                      let Ce = le[le.length - 1], je = le[0], it = Ce.x + Ce.width - je.x, Et = {
                        startltr: 0,
                        middleltr: 0.5,
                        endltr: 1,
                        startrtl: 1,
                        middlertl: 0.5,
                        endrtl: 0
                      }[JA + ne] * it || 0;
                      for (let Ft = 0; Ft < le.length; Ft++)
                        le[Ft].x -= Et;
                    }
                    le = [];
                  }
                  function At(Ce, je, it) {
                    let Et = Ce[0], Ft = Ce[Ce.length - 1], Qt = Et.x, Nt = Ft.x + Ft.width;
                    if (it) {
                      let gt = je / (Nt - Qt);
                      if (gt > 0 && gt < 1 / 0)
                        for (let yt = 0; yt < Ce.length; yt++)
                          Ce[yt].continuous = !1, Ce[yt].x = Qt + gt * (Ce[yt].x - Qt), Ce[yt].scale *= gt, Ce[yt].width *= gt;
                    } else if (Ce.length >= 2) {
                      let gt = (je - (Nt - Qt)) / (Ce.length - 1);
                      for (let yt = 0; yt < Ce.length; yt++)
                        Ce[yt].continuous = !1, Ce[yt].x += yt * gt;
                    }
                    ae += je - (Nt - Qt);
                  }
                  function Bt(Ce, je) {
                    Ce._x = dA(Ce.getLengthList("x", Ce.getVWidth()), je ? je._x.slice(je._pos.length) : []), Ce._y = dA(Ce.getLengthList("y", Ce.getVHeight()), je ? je._y.slice(je._pos.length) : []), Ce._dx = dA(Ce.getLengthList("dx", Ce.getVWidth()), je ? je._dx.slice(je._pos.length) : []), Ce._dy = dA(Ce.getLengthList("dy", Ce.getVHeight()), je ? je._dy.slice(je._pos.length) : []), Ce._rot = dA(Ce.getNumberList("rotate"), je ? je._rot.slice(je._pos.length) : []), Ce._defRot = Ce.chooseValue(Ce._rot[Ce._rot.length - 1], je && je._defRot, 0), Ce.name === "textPath" && (Ce._y = []);
                    let it = {
                      fauxItalic: !1,
                      fauxBold: !1
                    }, Et = Zt(Ce.get("font-family"), Ce.get("font-weight") === "bold", Ce.get("font-style") === "italic", it);
                    try {
                      a.font(Et);
                    } catch (Pi) {
                      vt('SVGElemText: failed to open font "' + Et + '" in PDFKit: ' + Pi.message);
                    }
                    Ce._pos = [], Ce._index = 0, Ce._font = {
                      font: a._font,
                      size: Ce.get("font-size"),
                      fauxItalic: it.fauxItalic,
                      fauxBold: it.fauxBold
                    };
                    let Ft = Ce.getLength("textLength", Ce.getVWidth(), void 0), Qt = Ce.attr("lengthAdjust") === "spacingAndGlyphs", Nt = Ce.get("word-spacing"), gt = Ce.get("letter-spacing"), yt = Ce.get("text-anchor"), oi = Ce.get("direction"), Ai = Ce.name === "text", _t = Ai ? Ce.get("dominant-baseline") : Ce.get("alignment-baseline") || Ce.get("dominant-baseline"), St = Ai ? "baseline" : Ce.get("baseline-shift"), ri = Pe(Ce._font.font, Ce._font.size, _t, St);
                    Ce.name === "textPath" && (ze(), ae = ve = 0);
                    let gn = Ce.getChildren();
                    for (let Pi = 0; Pi < gn.length; Pi++) {
                      let Fi = gn[Pi];
                      switch (Fi.name) {
                        case "tspan":
                        case "textPath":
                        case "a":
                          Bt(Fi, Ce);
                          break;
                        case "#text":
                        case "#cdata-section":
                          let ki = Fi.textContent, di = ki, ji;
                          Fi._font = Ce._font, Fi._pos = [], _A = _A.substring(ki.length), Ce.get("xml:space") === "preserve" ? di = di.replace(/[\s]/g, " ") : (di = di.replace(/[\s]+/g, " "), qA.match(/[\s]$|^$/) && (di = di.replace(/^[\s]/, "")), _A.match(/^[\s]*$/) && (di = di.replace(/[\s]$/, ""))), qA += ki, Nt === 0 ? ji = [di] : ji = di.split(/(\s)/);
                          for (let pi = 0; pi < ji.length; pi++) {
                            let Ni = Je(Ce._font.font, Ce._font.size, ji[pi]);
                            for (let vi = 0; vi < Ni.length; vi++) {
                              let Wi = Ce._index, zn = Ce._x[Wi], Ri = Ce._y[Wi], nn = Ce._dx[Wi], Tn = Ce._dy[Wi], rn = Ce._rot[Wi], hi = !(pi === 0 && vi === 0);
                              gt !== 0 && (hi = !1), Nt !== 0 && (hi = !1), zn !== void 0 && (hi = !1, ze(), ae = zn), Ri !== void 0 && (hi = !1, ze(), ve = Ri), nn !== void 0 && (hi = !1, ae += nn), Tn !== void 0 && (hi = !1, ve += Tn), (rn !== void 0 || Ce._defRot !== 0) && (hi = !1);
                              let In = {
                                glyph: Ni[vi].glyph,
                                rotate: Math.PI / 180 * Ce.chooseValue(rn, Ce._defRot),
                                x: ae + Ni[vi].xOffset,
                                kern: Ni[vi].kern,
                                y: ve + ri + Ni[vi].yOffset,
                                width: Ni[vi].width,
                                ascent: he(Ce._font.font, Ce._font.size),
                                descent: ie(Ce._font.font, Ce._font.size),
                                scale: 1,
                                hidden: !1,
                                continuous: hi
                              };
                              le.push(In), Fi._pos.push(In), Ce._pos.push(In), Ce._index += Ni[vi].unicode.length, le.length === 1 && (JA = yt, ne = oi), ae += Ni[vi].xAdvance + gt, ve += Ni[vi].yAdvance;
                            }
                            ji[pi] === " " && (ae += Nt);
                          }
                          break;
                        default:
                          _A = _A.substring(Fi.textContent.length);
                      }
                    }
                    if (Ft && Ce._pos.length && At(Ce._pos, Ft, Qt), (Ce.name === "textPath" || Ce.name === "text") && ze(), Ce.name === "textPath") {
                      jA.push(Ce);
                      let Pi = Ce.pathObject;
                      Pi && (ae = Pi.endPoint[0], ve = Pi.endPoint[1]);
                    }
                    je && (je._pos = je._pos.concat(Ce._pos), je._index += Ce._index);
                  }
                  function He(Ce) {
                    let je = Ce.pathObject, it = Ce.pathLength, Et = Ce.pathScale;
                    if (je) {
                      let Ft = Ce.getLength("startOffset", it, 0);
                      for (let Qt = 0; Qt < Ce._pos.length; Qt++) {
                        let Nt = Ft + Ce._pos[Qt].x + 0.5 * Ce._pos[Qt].width;
                        if (Nt > it || Nt < 0)
                          Ce._pos[Qt].hidden = !0;
                        else {
                          let gt = je.getPointAtLength(Nt * Et);
                          h(Et, 1) && (Ce._pos[Qt].scale *= Et, Ce._pos[Qt].width *= Et), Ce._pos[Qt].x = gt[0] - 0.5 * Ce._pos[Qt].width * Math.cos(gt[2]) - Ce._pos[Qt].y * Math.sin(gt[2]), Ce._pos[Qt].y = gt[1] - 0.5 * Ce._pos[Qt].width * Math.sin(gt[2]) + Ce._pos[Qt].y * Math.cos(gt[2]), Ce._pos[Qt].rotate = gt[2] + Ce._pos[Qt].rotate, Ce._pos[Qt].continuous = !1;
                        }
                      }
                    } else
                      for (let Ft = 0; Ft < Ce._pos.length; Ft++)
                        Ce._pos[Ft].hidden = !0;
                  }
                  Bt(mA, null);
                  for (let Ce = 0; Ce < jA.length; Ce++)
                    He(jA[Ce]);
                })(this), this.getTransformation = function() {
                  return this.get("transform");
                }, this.drawInDocument = function(mA, qA) {
                  a.save(), this.transform(), this.clip();
                  let _A = this.mask(), jA;
                  _A && (jA = T(LA())), this.drawTextInDocument(mA, qA), jA && (H(jA), eA(jA)), a.restore();
                };
              };
              P = P || {};
              var zt = P.assumePt ? 1 : 72 / 96, Xt = (P.width || a.page.width) / zt, xi = (P.height || a.page.height) / zt, mi = P.preserveAspectRatio || null, Ot = P.useCSS && typeof SVGElement < "u" && d instanceof SVGElement && typeof getComputedStyle == "function", vt = P.warningCallback, Zt = P.fontCallback, ei = P.imageCallback, Ke = P.colorCallback, qe = P.documentCallback, Dt = Math.ceil(Math.max(1, P.precision)) || 3, ut = [], ni = {}, wi = [], Yi = [];
              if (typeof vt != "function" && (vt = function(vA) {
                typeof console !== void 0 && typeof console.warn == "function" && console.warn(vA);
              }), typeof Zt != "function" && (Zt = function(vA, UA, mA, qA) {
                if (UA && mA) {
                  if (a._registeredFonts.hasOwnProperty(vA + "-BoldItalic"))
                    return vA + "-BoldItalic";
                  if (a._registeredFonts.hasOwnProperty(vA + "-Italic"))
                    return qA.fauxBold = !0, vA + "-Italic";
                  if (a._registeredFonts.hasOwnProperty(vA + "-Bold"))
                    return qA.fauxItalic = !0, vA + "-Bold";
                  if (a._registeredFonts.hasOwnProperty(vA))
                    return qA.fauxBold = !0, qA.fauxItalic = !0, vA;
                }
                if (UA && !mA) {
                  if (a._registeredFonts.hasOwnProperty(vA + "-Bold"))
                    return vA + "-Bold";
                  if (a._registeredFonts.hasOwnProperty(vA))
                    return qA.fauxBold = !0, vA;
                }
                if (!UA && mA) {
                  if (a._registeredFonts.hasOwnProperty(vA + "-Italic"))
                    return vA + "-Italic";
                  if (a._registeredFonts.hasOwnProperty(vA))
                    return qA.fauxItalic = !0, vA;
                }
                if (!UA && !mA && a._registeredFonts.hasOwnProperty(vA))
                  return vA;
                if (vA.match(/(?:^|,)\s*serif\s*$/)) {
                  if (UA && mA)
                    return "Times-BoldItalic";
                  if (UA && !mA)
                    return "Times-Bold";
                  if (!UA && mA)
                    return "Times-Italic";
                  if (!UA && !mA)
                    return "Times-Roman";
                } else if (vA.match(/(?:^|,)\s*monospace\s*$/)) {
                  if (UA && mA)
                    return "Courier-BoldOblique";
                  if (UA && !mA)
                    return "Courier-Bold";
                  if (!UA && mA)
                    return "Courier-Oblique";
                  if (!UA && !mA)
                    return "Courier";
                } else {
                  if (vA.match(/(?:^|,)\s*sans-serif\s*$/), UA && mA)
                    return "Helvetica-BoldOblique";
                  if (UA && !mA)
                    return "Helvetica-Bold";
                  if (!UA && mA)
                    return "Helvetica-Oblique";
                  if (!UA && !mA)
                    return "Helvetica";
                }
              }), typeof ei != "function" && (ei = function(vA) {
                return vA.replace(/\s+/g, "");
              }), typeof Ke != "function")
                Ke = null;
              else
                for (let vA in J) {
                  let UA = Ke(J[vA]);
                  J[vA][0] = UA[0], J[vA][1] = UA[1];
                }
              if (typeof qe != "function" && (qe = null), typeof d == "string" && (d = $A(d)), d) {
                let vA = d.getElementsByTagName("style");
                for (let mA = 0; mA < vA.length; mA++)
                  Yi = Yi.concat(y(vA[mA].textContent));
                let UA = Le(d, null);
                if (typeof UA.drawInDocument == "function") {
                  P.useCSS && !Ot && vt("SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers");
                  let mA = a._fillColor;
                  a.save().translate(x || 0, U || 0).scale(zt), UA.drawInDocument();
                  for (let qA = 0; qA < wi.length; qA++)
                    a.page.annotations.push(wi[qA]);
                  a.restore(), a._fillColor = mA;
                } else
                  vt("SVGtoPDF: this element can't be rendered directly: " + d.nodeName);
              } else
                vt("SVGtoPDF: the input does not look like a valid SVG");
            };
            Q && typeof Q.exports < "u" && (Q.exports = A);
          },
          /***/
          783(Q, B, r) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
            r(187), r(8376), r(6401), r(2017);
            const A = r(2504), a = r(9029), d = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
            B.Buffer = D, B.SlowBuffer = k, B.INSPECT_MAX_BYTES = 50;
            const x = 2147483647;
            B.kMaxLength = x, D.TYPED_ARRAY_SUPPORT = U(), !D.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
            function U() {
              try {
                const wA = new Uint8Array(1), N = {
                  foo: function() {
                    return 42;
                  }
                };
                return Object.setPrototypeOf(N, Uint8Array.prototype), Object.setPrototypeOf(wA, N), wA.foo() === 42;
              } catch {
                return !1;
              }
            }
            Object.defineProperty(D.prototype, "parent", {
              enumerable: !0,
              get: function() {
                if (D.isBuffer(this))
                  return this.buffer;
              }
            }), Object.defineProperty(D.prototype, "offset", {
              enumerable: !0,
              get: function() {
                if (D.isBuffer(this))
                  return this.byteOffset;
              }
            });
            function P(wA) {
              if (wA > x)
                throw new RangeError('The value "' + wA + '" is invalid for option "size"');
              const N = new Uint8Array(wA);
              return Object.setPrototypeOf(N, D.prototype), N;
            }
            function D(wA, N, G) {
              if (typeof wA == "number") {
                if (typeof N == "string")
                  throw new TypeError('The "string" argument must be of type string. Received type number');
                return K(wA);
              }
              return J(wA, N, G);
            }
            D.poolSize = 8192;
            function J(wA, N, G) {
              if (typeof wA == "string")
                return z(wA, N);
              if (ArrayBuffer.isView(wA))
                return H(wA);
              if (wA == null)
                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof wA);
              if (Le(wA, ArrayBuffer) || wA && Le(wA.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Le(wA, SharedArrayBuffer) || wA && Le(wA.buffer, SharedArrayBuffer)))
                return eA(wA, N, G);
              if (typeof wA == "number")
                throw new TypeError('The "value" argument must not be of type number. Received type number');
              const W = wA.valueOf && wA.valueOf();
              if (W != null && W !== wA)
                return D.from(W, N, G);
              const aA = CA(wA);
              if (aA) return aA;
              if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof wA[Symbol.toPrimitive] == "function")
                return D.from(wA[Symbol.toPrimitive]("string"), N, G);
              throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof wA);
            }
            D.from = function(wA, N, G) {
              return J(wA, N, G);
            }, Object.setPrototypeOf(D.prototype, Uint8Array.prototype), Object.setPrototypeOf(D, Uint8Array);
            function q(wA) {
              if (typeof wA != "number")
                throw new TypeError('"size" argument must be of type number');
              if (wA < 0)
                throw new RangeError('The value "' + wA + '" is invalid for option "size"');
            }
            function AA(wA, N, G) {
              return q(wA), wA <= 0 ? P(wA) : N !== void 0 ? typeof G == "string" ? P(wA).fill(N, G) : P(wA).fill(N) : P(wA);
            }
            D.alloc = function(wA, N, G) {
              return AA(wA, N, G);
            };
            function K(wA) {
              return q(wA), P(wA < 0 ? 0 : IA(wA) | 0);
            }
            D.allocUnsafe = function(wA) {
              return K(wA);
            }, D.allocUnsafeSlow = function(wA) {
              return K(wA);
            };
            function z(wA, N) {
              if ((typeof N != "string" || N === "") && (N = "utf8"), !D.isEncoding(N))
                throw new TypeError("Unknown encoding: " + N);
              const G = tA(wA, N) | 0;
              let W = P(G);
              const aA = W.write(wA, N);
              return aA !== G && (W = W.slice(0, aA)), W;
            }
            function T(wA) {
              const N = wA.length < 0 ? 0 : IA(wA.length) | 0, G = P(N);
              for (let W = 0; W < N; W += 1)
                G[W] = wA[W] & 255;
              return G;
            }
            function H(wA) {
              if (Le(wA, Uint8Array)) {
                const N = new Uint8Array(wA);
                return eA(N.buffer, N.byteOffset, N.byteLength);
              }
              return T(wA);
            }
            function eA(wA, N, G) {
              if (N < 0 || wA.byteLength < N)
                throw new RangeError('"offset" is outside of buffer bounds');
              if (wA.byteLength < N + (G || 0))
                throw new RangeError('"length" is outside of buffer bounds');
              let W;
              return N === void 0 && G === void 0 ? W = new Uint8Array(wA) : G === void 0 ? W = new Uint8Array(wA, N) : W = new Uint8Array(wA, N, G), Object.setPrototypeOf(W, D.prototype), W;
            }
            function CA(wA) {
              if (D.isBuffer(wA)) {
                const N = IA(wA.length) | 0, G = P(N);
                return G.length === 0 || wA.copy(G, 0, 0, N), G;
              }
              if (wA.length !== void 0)
                return typeof wA.length != "number" || Re(wA.length) ? P(0) : T(wA);
              if (wA.type === "Buffer" && Array.isArray(wA.data))
                return T(wA.data);
            }
            function IA(wA) {
              if (wA >= x)
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + x.toString(16) + " bytes");
              return wA | 0;
            }
            function k(wA) {
              return +wA != wA && (wA = 0), D.alloc(+wA);
            }
            D.isBuffer = function(N) {
              return N != null && N._isBuffer === !0 && N !== D.prototype;
            }, D.compare = function(N, G) {
              if (Le(N, Uint8Array) && (N = D.from(N, N.offset, N.byteLength)), Le(G, Uint8Array) && (G = D.from(G, G.offset, G.byteLength)), !D.isBuffer(N) || !D.isBuffer(G))
                throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
              if (N === G) return 0;
              let W = N.length, aA = G.length;
              for (let j = 0, pA = Math.min(W, aA); j < pA; ++j)
                if (N[j] !== G[j]) {
                  W = N[j], aA = G[j];
                  break;
                }
              return W < aA ? -1 : aA < W ? 1 : 0;
            }, D.isEncoding = function(N) {
              switch (String(N).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;
                default:
                  return !1;
              }
            }, D.concat = function(N, G) {
              if (!Array.isArray(N))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (N.length === 0)
                return D.alloc(0);
              let W;
              if (G === void 0)
                for (G = 0, W = 0; W < N.length; ++W)
                  G += N[W].length;
              const aA = D.allocUnsafe(G);
              let j = 0;
              for (W = 0; W < N.length; ++W) {
                let pA = N[W];
                if (Le(pA, Uint8Array))
                  j + pA.length > aA.length ? (D.isBuffer(pA) || (pA = D.from(pA)), pA.copy(aA, j)) : Uint8Array.prototype.set.call(aA, pA, j);
                else if (D.isBuffer(pA))
                  pA.copy(aA, j);
                else
                  throw new TypeError('"list" argument must be an Array of Buffers');
                j += pA.length;
              }
              return aA;
            };
            function tA(wA, N) {
              if (D.isBuffer(wA))
                return wA.length;
              if (ArrayBuffer.isView(wA) || Le(wA, ArrayBuffer))
                return wA.byteLength;
              if (typeof wA != "string")
                throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof wA);
              const G = wA.length, W = arguments.length > 2 && arguments[2] === !0;
              if (!W && G === 0) return 0;
              let aA = !1;
              for (; ; )
                switch (N) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return G;
                  case "utf8":
                  case "utf-8":
                    return he(wA).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return G * 2;
                  case "hex":
                    return G >>> 1;
                  case "base64":
                    return Pe(wA).length;
                  default:
                    if (aA)
                      return W ? -1 : he(wA).length;
                    N = ("" + N).toLowerCase(), aA = !0;
                }
            }
            D.byteLength = tA;
            function lA(wA, N, G) {
              let W = !1;
              if ((N === void 0 || N < 0) && (N = 0), N > this.length || ((G === void 0 || G > this.length) && (G = this.length), G <= 0) || (G >>>= 0, N >>>= 0, G <= N))
                return "";
              for (wA || (wA = "utf8"); ; )
                switch (wA) {
                  case "hex":
                    return LA(this, N, G);
                  case "utf8":
                  case "utf-8":
                    return WA(this, N, G);
                  case "ascii":
                    return OA(this, N, G);
                  case "latin1":
                  case "binary":
                    return xA(this, N, G);
                  case "base64":
                    return kA(this, N, G);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return yA(this, N, G);
                  default:
                    if (W) throw new TypeError("Unknown encoding: " + wA);
                    wA = (wA + "").toLowerCase(), W = !0;
                }
            }
            D.prototype._isBuffer = !0;
            function uA(wA, N, G) {
              const W = wA[N];
              wA[N] = wA[G], wA[G] = W;
            }
            D.prototype.swap16 = function() {
              const N = this.length;
              if (N % 2 !== 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (let G = 0; G < N; G += 2)
                uA(this, G, G + 1);
              return this;
            }, D.prototype.swap32 = function() {
              const N = this.length;
              if (N % 4 !== 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (let G = 0; G < N; G += 4)
                uA(this, G, G + 3), uA(this, G + 1, G + 2);
              return this;
            }, D.prototype.swap64 = function() {
              const N = this.length;
              if (N % 8 !== 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (let G = 0; G < N; G += 8)
                uA(this, G, G + 7), uA(this, G + 1, G + 6), uA(this, G + 2, G + 5), uA(this, G + 3, G + 4);
              return this;
            }, D.prototype.toString = function() {
              const N = this.length;
              return N === 0 ? "" : arguments.length === 0 ? WA(this, 0, N) : lA.apply(this, arguments);
            }, D.prototype.toLocaleString = D.prototype.toString, D.prototype.equals = function(N) {
              if (!D.isBuffer(N)) throw new TypeError("Argument must be a Buffer");
              return this === N ? !0 : D.compare(this, N) === 0;
            }, D.prototype.inspect = function() {
              let N = "";
              const G = B.INSPECT_MAX_BYTES;
              return N = this.toString("hex", 0, G).replace(/(.{2})/g, "$1 ").trim(), this.length > G && (N += " ... "), "<Buffer " + N + ">";
            }, d && (D.prototype[d] = D.prototype.inspect), D.prototype.compare = function(N, G, W, aA, j) {
              if (Le(N, Uint8Array) && (N = D.from(N, N.offset, N.byteLength)), !D.isBuffer(N))
                throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof N);
              if (G === void 0 && (G = 0), W === void 0 && (W = N ? N.length : 0), aA === void 0 && (aA = 0), j === void 0 && (j = this.length), G < 0 || W > N.length || aA < 0 || j > this.length)
                throw new RangeError("out of range index");
              if (aA >= j && G >= W)
                return 0;
              if (aA >= j)
                return -1;
              if (G >= W)
                return 1;
              if (G >>>= 0, W >>>= 0, aA >>>= 0, j >>>= 0, this === N) return 0;
              let pA = j - aA, Be = W - G;
              const Ie = Math.min(pA, Be), ee = this.slice(aA, j), Me = N.slice(G, W);
              for (let MA = 0; MA < Ie; ++MA)
                if (ee[MA] !== Me[MA]) {
                  pA = ee[MA], Be = Me[MA];
                  break;
                }
              return pA < Be ? -1 : Be < pA ? 1 : 0;
            };
            function w(wA, N, G, W, aA) {
              if (wA.length === 0) return -1;
              if (typeof G == "string" ? (W = G, G = 0) : G > 2147483647 ? G = 2147483647 : G < -2147483648 && (G = -2147483648), G = +G, Re(G) && (G = aA ? 0 : wA.length - 1), G < 0 && (G = wA.length + G), G >= wA.length) {
                if (aA) return -1;
                G = wA.length - 1;
              } else if (G < 0)
                if (aA) G = 0;
                else return -1;
              if (typeof N == "string" && (N = D.from(N, W)), D.isBuffer(N))
                return N.length === 0 ? -1 : v(wA, N, G, W, aA);
              if (typeof N == "number")
                return N = N & 255, typeof Uint8Array.prototype.indexOf == "function" ? aA ? Uint8Array.prototype.indexOf.call(wA, N, G) : Uint8Array.prototype.lastIndexOf.call(wA, N, G) : v(wA, [N], G, W, aA);
              throw new TypeError("val must be string, number or Buffer");
            }
            function v(wA, N, G, W, aA) {
              let j = 1, pA = wA.length, Be = N.length;
              if (W !== void 0 && (W = String(W).toLowerCase(), W === "ucs2" || W === "ucs-2" || W === "utf16le" || W === "utf-16le")) {
                if (wA.length < 2 || N.length < 2)
                  return -1;
                j = 2, pA /= 2, Be /= 2, G /= 2;
              }
              function Ie(Me, MA) {
                return j === 1 ? Me[MA] : Me.readUInt16BE(MA * j);
              }
              let ee;
              if (aA) {
                let Me = -1;
                for (ee = G; ee < pA; ee++)
                  if (Ie(wA, ee) === Ie(N, Me === -1 ? 0 : ee - Me)) {
                    if (Me === -1 && (Me = ee), ee - Me + 1 === Be) return Me * j;
                  } else
                    Me !== -1 && (ee -= ee - Me), Me = -1;
              } else
                for (G + Be > pA && (G = pA - Be), ee = G; ee >= 0; ee--) {
                  let Me = !0;
                  for (let MA = 0; MA < Be; MA++)
                    if (Ie(wA, ee + MA) !== Ie(N, MA)) {
                      Me = !1;
                      break;
                    }
                  if (Me) return ee;
                }
              return -1;
            }
            D.prototype.includes = function(N, G, W) {
              return this.indexOf(N, G, W) !== -1;
            }, D.prototype.indexOf = function(N, G, W) {
              return w(this, N, G, W, !0);
            }, D.prototype.lastIndexOf = function(N, G, W) {
              return w(this, N, G, W, !1);
            };
            function RA(wA, N, G, W) {
              G = Number(G) || 0;
              const aA = wA.length - G;
              W ? (W = Number(W), W > aA && (W = aA)) : W = aA;
              const j = N.length;
              W > j / 2 && (W = j / 2);
              let pA;
              for (pA = 0; pA < W; ++pA) {
                const Be = parseInt(N.substr(pA * 2, 2), 16);
                if (Re(Be)) return pA;
                wA[G + pA] = Be;
              }
              return pA;
            }
            function DA(wA, N, G, W) {
              return Je(he(N, wA.length - G), wA, G, W);
            }
            function $(wA, N, G, W) {
              return Je(ie(N), wA, G, W);
            }
            function cA(wA, N, G, W) {
              return Je(Pe(N), wA, G, W);
            }
            function $A(wA, N, G, W) {
              return Je(KA(N, wA.length - G), wA, G, W);
            }
            D.prototype.write = function(N, G, W, aA) {
              if (G === void 0)
                aA = "utf8", W = this.length, G = 0;
              else if (W === void 0 && typeof G == "string")
                aA = G, W = this.length, G = 0;
              else if (isFinite(G))
                G = G >>> 0, isFinite(W) ? (W = W >>> 0, aA === void 0 && (aA = "utf8")) : (aA = W, W = void 0);
              else
                throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              const j = this.length - G;
              if ((W === void 0 || W > j) && (W = j), N.length > 0 && (W < 0 || G < 0) || G > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              aA || (aA = "utf8");
              let pA = !1;
              for (; ; )
                switch (aA) {
                  case "hex":
                    return RA(this, N, G, W);
                  case "utf8":
                  case "utf-8":
                    return DA(this, N, G, W);
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return $(this, N, G, W);
                  case "base64":
                    return cA(this, N, G, W);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return $A(this, N, G, W);
                  default:
                    if (pA) throw new TypeError("Unknown encoding: " + aA);
                    aA = ("" + aA).toLowerCase(), pA = !0;
                }
            }, D.prototype.toJSON = function() {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            function kA(wA, N, G) {
              return N === 0 && G === wA.length ? A.fromByteArray(wA) : A.fromByteArray(wA.slice(N, G));
            }
            function WA(wA, N, G) {
              G = Math.min(wA.length, G);
              const W = [];
              let aA = N;
              for (; aA < G; ) {
                const j = wA[aA];
                let pA = null, Be = j > 239 ? 4 : j > 223 ? 3 : j > 191 ? 2 : 1;
                if (aA + Be <= G) {
                  let Ie, ee, Me, MA;
                  switch (Be) {
                    case 1:
                      j < 128 && (pA = j);
                      break;
                    case 2:
                      Ie = wA[aA + 1], (Ie & 192) === 128 && (MA = (j & 31) << 6 | Ie & 63, MA > 127 && (pA = MA));
                      break;
                    case 3:
                      Ie = wA[aA + 1], ee = wA[aA + 2], (Ie & 192) === 128 && (ee & 192) === 128 && (MA = (j & 15) << 12 | (Ie & 63) << 6 | ee & 63, MA > 2047 && (MA < 55296 || MA > 57343) && (pA = MA));
                      break;
                    case 4:
                      Ie = wA[aA + 1], ee = wA[aA + 2], Me = wA[aA + 3], (Ie & 192) === 128 && (ee & 192) === 128 && (Me & 192) === 128 && (MA = (j & 15) << 18 | (Ie & 63) << 12 | (ee & 63) << 6 | Me & 63, MA > 65535 && MA < 1114112 && (pA = MA));
                  }
                }
                pA === null ? (pA = 65533, Be = 1) : pA > 65535 && (pA -= 65536, W.push(pA >>> 10 & 1023 | 55296), pA = 56320 | pA & 1023), W.push(pA), aA += Be;
              }
              return zA(W);
            }
            const EA = 4096;
            function zA(wA) {
              const N = wA.length;
              if (N <= EA)
                return String.fromCharCode.apply(String, wA);
              let G = "", W = 0;
              for (; W < N; )
                G += String.fromCharCode.apply(String, wA.slice(W, W += EA));
              return G;
            }
            function OA(wA, N, G) {
              let W = "";
              G = Math.min(wA.length, G);
              for (let aA = N; aA < G; ++aA)
                W += String.fromCharCode(wA[aA] & 127);
              return W;
            }
            function xA(wA, N, G) {
              let W = "";
              G = Math.min(wA.length, G);
              for (let aA = N; aA < G; ++aA)
                W += String.fromCharCode(wA[aA]);
              return W;
            }
            function LA(wA, N, G) {
              const W = wA.length;
              (!N || N < 0) && (N = 0), (!G || G < 0 || G > W) && (G = W);
              let aA = "";
              for (let j = N; j < G; ++j)
                aA += _e[wA[j]];
              return aA;
            }
            function yA(wA, N, G) {
              const W = wA.slice(N, G);
              let aA = "";
              for (let j = 0; j < W.length - 1; j += 2)
                aA += String.fromCharCode(W[j] + W[j + 1] * 256);
              return aA;
            }
            D.prototype.slice = function(N, G) {
              const W = this.length;
              N = ~~N, G = G === void 0 ? W : ~~G, N < 0 ? (N += W, N < 0 && (N = 0)) : N > W && (N = W), G < 0 ? (G += W, G < 0 && (G = 0)) : G > W && (G = W), G < N && (G = N);
              const aA = this.subarray(N, G);
              return Object.setPrototypeOf(aA, D.prototype), aA;
            };
            function TA(wA, N, G) {
              if (wA % 1 !== 0 || wA < 0) throw new RangeError("offset is not uint");
              if (wA + N > G) throw new RangeError("Trying to access beyond buffer length");
            }
            D.prototype.readUintLE = D.prototype.readUIntLE = function(N, G, W) {
              N = N >>> 0, G = G >>> 0, W || TA(N, G, this.length);
              let aA = this[N], j = 1, pA = 0;
              for (; ++pA < G && (j *= 256); )
                aA += this[N + pA] * j;
              return aA;
            }, D.prototype.readUintBE = D.prototype.readUIntBE = function(N, G, W) {
              N = N >>> 0, G = G >>> 0, W || TA(N, G, this.length);
              let aA = this[N + --G], j = 1;
              for (; G > 0 && (j *= 256); )
                aA += this[N + --G] * j;
              return aA;
            }, D.prototype.readUint8 = D.prototype.readUInt8 = function(N, G) {
              return N = N >>> 0, G || TA(N, 1, this.length), this[N];
            }, D.prototype.readUint16LE = D.prototype.readUInt16LE = function(N, G) {
              return N = N >>> 0, G || TA(N, 2, this.length), this[N] | this[N + 1] << 8;
            }, D.prototype.readUint16BE = D.prototype.readUInt16BE = function(N, G) {
              return N = N >>> 0, G || TA(N, 2, this.length), this[N] << 8 | this[N + 1];
            }, D.prototype.readUint32LE = D.prototype.readUInt32LE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), (this[N] | this[N + 1] << 8 | this[N + 2] << 16) + this[N + 3] * 16777216;
            }, D.prototype.readUint32BE = D.prototype.readUInt32BE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), this[N] * 16777216 + (this[N + 1] << 16 | this[N + 2] << 8 | this[N + 3]);
            }, D.prototype.readBigUInt64LE = se(function(N) {
              N = N >>> 0, y(N, "offset");
              const G = this[N], W = this[N + 7];
              (G === void 0 || W === void 0) && M(N, this.length - 8);
              const aA = G + this[++N] * 2 ** 8 + this[++N] * 2 ** 16 + this[++N] * 2 ** 24, j = this[++N] + this[++N] * 2 ** 8 + this[++N] * 2 ** 16 + W * 2 ** 24;
              return BigInt(aA) + (BigInt(j) << BigInt(32));
            }), D.prototype.readBigUInt64BE = se(function(N) {
              N = N >>> 0, y(N, "offset");
              const G = this[N], W = this[N + 7];
              (G === void 0 || W === void 0) && M(N, this.length - 8);
              const aA = G * 2 ** 24 + this[++N] * 2 ** 16 + this[++N] * 2 ** 8 + this[++N], j = this[++N] * 2 ** 24 + this[++N] * 2 ** 16 + this[++N] * 2 ** 8 + W;
              return (BigInt(aA) << BigInt(32)) + BigInt(j);
            }), D.prototype.readIntLE = function(N, G, W) {
              N = N >>> 0, G = G >>> 0, W || TA(N, G, this.length);
              let aA = this[N], j = 1, pA = 0;
              for (; ++pA < G && (j *= 256); )
                aA += this[N + pA] * j;
              return j *= 128, aA >= j && (aA -= Math.pow(2, 8 * G)), aA;
            }, D.prototype.readIntBE = function(N, G, W) {
              N = N >>> 0, G = G >>> 0, W || TA(N, G, this.length);
              let aA = G, j = 1, pA = this[N + --aA];
              for (; aA > 0 && (j *= 256); )
                pA += this[N + --aA] * j;
              return j *= 128, pA >= j && (pA -= Math.pow(2, 8 * G)), pA;
            }, D.prototype.readInt8 = function(N, G) {
              return N = N >>> 0, G || TA(N, 1, this.length), this[N] & 128 ? (255 - this[N] + 1) * -1 : this[N];
            }, D.prototype.readInt16LE = function(N, G) {
              N = N >>> 0, G || TA(N, 2, this.length);
              const W = this[N] | this[N + 1] << 8;
              return W & 32768 ? W | 4294901760 : W;
            }, D.prototype.readInt16BE = function(N, G) {
              N = N >>> 0, G || TA(N, 2, this.length);
              const W = this[N + 1] | this[N] << 8;
              return W & 32768 ? W | 4294901760 : W;
            }, D.prototype.readInt32LE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), this[N] | this[N + 1] << 8 | this[N + 2] << 16 | this[N + 3] << 24;
            }, D.prototype.readInt32BE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), this[N] << 24 | this[N + 1] << 16 | this[N + 2] << 8 | this[N + 3];
            }, D.prototype.readBigInt64LE = se(function(N) {
              N = N >>> 0, y(N, "offset");
              const G = this[N], W = this[N + 7];
              (G === void 0 || W === void 0) && M(N, this.length - 8);
              const aA = this[N + 4] + this[N + 5] * 2 ** 8 + this[N + 6] * 2 ** 16 + (W << 24);
              return (BigInt(aA) << BigInt(32)) + BigInt(G + this[++N] * 256 + this[++N] * 65536 + this[++N] * 16777216);
            }), D.prototype.readBigInt64BE = se(function(N) {
              N = N >>> 0, y(N, "offset");
              const G = this[N], W = this[N + 7];
              (G === void 0 || W === void 0) && M(N, this.length - 8);
              const aA = (G << 24) + // Overflow
              this[++N] * 2 ** 16 + this[++N] * 2 ** 8 + this[++N];
              return (BigInt(aA) << BigInt(32)) + BigInt(this[++N] * 16777216 + this[++N] * 65536 + this[++N] * 256 + W);
            }), D.prototype.readFloatLE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), a.read(this, N, !0, 23, 4);
            }, D.prototype.readFloatBE = function(N, G) {
              return N = N >>> 0, G || TA(N, 4, this.length), a.read(this, N, !1, 23, 4);
            }, D.prototype.readDoubleLE = function(N, G) {
              return N = N >>> 0, G || TA(N, 8, this.length), a.read(this, N, !0, 52, 8);
            }, D.prototype.readDoubleBE = function(N, G) {
              return N = N >>> 0, G || TA(N, 8, this.length), a.read(this, N, !1, 52, 8);
            };
            function fA(wA, N, G, W, aA, j) {
              if (!D.isBuffer(wA)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (N > aA || N < j) throw new RangeError('"value" argument is out of bounds');
              if (G + W > wA.length) throw new RangeError("Index out of range");
            }
            D.prototype.writeUintLE = D.prototype.writeUIntLE = function(N, G, W, aA) {
              if (N = +N, G = G >>> 0, W = W >>> 0, !aA) {
                const Be = Math.pow(2, 8 * W) - 1;
                fA(this, N, G, W, Be, 0);
              }
              let j = 1, pA = 0;
              for (this[G] = N & 255; ++pA < W && (j *= 256); )
                this[G + pA] = N / j & 255;
              return G + W;
            }, D.prototype.writeUintBE = D.prototype.writeUIntBE = function(N, G, W, aA) {
              if (N = +N, G = G >>> 0, W = W >>> 0, !aA) {
                const Be = Math.pow(2, 8 * W) - 1;
                fA(this, N, G, W, Be, 0);
              }
              let j = W - 1, pA = 1;
              for (this[G + j] = N & 255; --j >= 0 && (pA *= 256); )
                this[G + j] = N / pA & 255;
              return G + W;
            }, D.prototype.writeUint8 = D.prototype.writeUInt8 = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 1, 255, 0), this[G] = N & 255, G + 1;
            }, D.prototype.writeUint16LE = D.prototype.writeUInt16LE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 2, 65535, 0), this[G] = N & 255, this[G + 1] = N >>> 8, G + 2;
            }, D.prototype.writeUint16BE = D.prototype.writeUInt16BE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 2, 65535, 0), this[G] = N >>> 8, this[G + 1] = N & 255, G + 2;
            }, D.prototype.writeUint32LE = D.prototype.writeUInt32LE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 4, 4294967295, 0), this[G + 3] = N >>> 24, this[G + 2] = N >>> 16, this[G + 1] = N >>> 8, this[G] = N & 255, G + 4;
            }, D.prototype.writeUint32BE = D.prototype.writeUInt32BE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 4, 4294967295, 0), this[G] = N >>> 24, this[G + 1] = N >>> 16, this[G + 2] = N >>> 8, this[G + 3] = N & 255, G + 4;
            };
            function sA(wA, N, G, W, aA) {
              bA(N, W, aA, wA, G, 7);
              let j = Number(N & BigInt(4294967295));
              wA[G++] = j, j = j >> 8, wA[G++] = j, j = j >> 8, wA[G++] = j, j = j >> 8, wA[G++] = j;
              let pA = Number(N >> BigInt(32) & BigInt(4294967295));
              return wA[G++] = pA, pA = pA >> 8, wA[G++] = pA, pA = pA >> 8, wA[G++] = pA, pA = pA >> 8, wA[G++] = pA, G;
            }
            function F(wA, N, G, W, aA) {
              bA(N, W, aA, wA, G, 7);
              let j = Number(N & BigInt(4294967295));
              wA[G + 7] = j, j = j >> 8, wA[G + 6] = j, j = j >> 8, wA[G + 5] = j, j = j >> 8, wA[G + 4] = j;
              let pA = Number(N >> BigInt(32) & BigInt(4294967295));
              return wA[G + 3] = pA, pA = pA >> 8, wA[G + 2] = pA, pA = pA >> 8, wA[G + 1] = pA, pA = pA >> 8, wA[G] = pA, G + 8;
            }
            D.prototype.writeBigUInt64LE = se(function(N, G) {
              return G === void 0 && (G = 0), sA(this, N, G, BigInt(0), BigInt("0xffffffffffffffff"));
            }), D.prototype.writeBigUInt64BE = se(function(N, G) {
              return G === void 0 && (G = 0), F(this, N, G, BigInt(0), BigInt("0xffffffffffffffff"));
            }), D.prototype.writeIntLE = function(N, G, W, aA) {
              if (N = +N, G = G >>> 0, !aA) {
                const Ie = Math.pow(2, 8 * W - 1);
                fA(this, N, G, W, Ie - 1, -Ie);
              }
              let j = 0, pA = 1, Be = 0;
              for (this[G] = N & 255; ++j < W && (pA *= 256); )
                N < 0 && Be === 0 && this[G + j - 1] !== 0 && (Be = 1), this[G + j] = (N / pA >> 0) - Be & 255;
              return G + W;
            }, D.prototype.writeIntBE = function(N, G, W, aA) {
              if (N = +N, G = G >>> 0, !aA) {
                const Ie = Math.pow(2, 8 * W - 1);
                fA(this, N, G, W, Ie - 1, -Ie);
              }
              let j = W - 1, pA = 1, Be = 0;
              for (this[G + j] = N & 255; --j >= 0 && (pA *= 256); )
                N < 0 && Be === 0 && this[G + j + 1] !== 0 && (Be = 1), this[G + j] = (N / pA >> 0) - Be & 255;
              return G + W;
            }, D.prototype.writeInt8 = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 1, 127, -128), N < 0 && (N = 255 + N + 1), this[G] = N & 255, G + 1;
            }, D.prototype.writeInt16LE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 2, 32767, -32768), this[G] = N & 255, this[G + 1] = N >>> 8, G + 2;
            }, D.prototype.writeInt16BE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 2, 32767, -32768), this[G] = N >>> 8, this[G + 1] = N & 255, G + 2;
            }, D.prototype.writeInt32LE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 4, 2147483647, -2147483648), this[G] = N & 255, this[G + 1] = N >>> 8, this[G + 2] = N >>> 16, this[G + 3] = N >>> 24, G + 4;
            }, D.prototype.writeInt32BE = function(N, G, W) {
              return N = +N, G = G >>> 0, W || fA(this, N, G, 4, 2147483647, -2147483648), N < 0 && (N = 4294967295 + N + 1), this[G] = N >>> 24, this[G + 1] = N >>> 16, this[G + 2] = N >>> 8, this[G + 3] = N & 255, G + 4;
            }, D.prototype.writeBigInt64LE = se(function(N, G) {
              return G === void 0 && (G = 0), sA(this, N, G, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
            }), D.prototype.writeBigInt64BE = se(function(N, G) {
              return G === void 0 && (G = 0), F(this, N, G, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
            });
            function o(wA, N, G, W, aA, j) {
              if (G + W > wA.length) throw new RangeError("Index out of range");
              if (G < 0) throw new RangeError("Index out of range");
            }
            function h(wA, N, G, W, aA) {
              return N = +N, G = G >>> 0, aA || o(wA, N, G, 4), a.write(wA, N, G, W, 23, 4), G + 4;
            }
            D.prototype.writeFloatLE = function(N, G, W) {
              return h(this, N, G, !0, W);
            }, D.prototype.writeFloatBE = function(N, G, W) {
              return h(this, N, G, !1, W);
            };
            function _(wA, N, G, W, aA) {
              return N = +N, G = G >>> 0, aA || o(wA, N, G, 8), a.write(wA, N, G, W, 52, 8), G + 8;
            }
            D.prototype.writeDoubleLE = function(N, G, W) {
              return _(this, N, G, !0, W);
            }, D.prototype.writeDoubleBE = function(N, G, W) {
              return _(this, N, G, !1, W);
            }, D.prototype.copy = function(N, G, W, aA) {
              if (!D.isBuffer(N)) throw new TypeError("argument should be a Buffer");
              if (W || (W = 0), !aA && aA !== 0 && (aA = this.length), G >= N.length && (G = N.length), G || (G = 0), aA > 0 && aA < W && (aA = W), aA === W || N.length === 0 || this.length === 0) return 0;
              if (G < 0)
                throw new RangeError("targetStart out of bounds");
              if (W < 0 || W >= this.length) throw new RangeError("Index out of range");
              if (aA < 0) throw new RangeError("sourceEnd out of bounds");
              aA > this.length && (aA = this.length), N.length - G < aA - W && (aA = N.length - G + W);
              const j = aA - W;
              return this === N && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(G, W, aA) : Uint8Array.prototype.set.call(N, this.subarray(W, aA), G), j;
            }, D.prototype.fill = function(N, G, W, aA) {
              if (typeof N == "string") {
                if (typeof G == "string" ? (aA = G, G = 0, W = this.length) : typeof W == "string" && (aA = W, W = this.length), aA !== void 0 && typeof aA != "string")
                  throw new TypeError("encoding must be a string");
                if (typeof aA == "string" && !D.isEncoding(aA))
                  throw new TypeError("Unknown encoding: " + aA);
                if (N.length === 1) {
                  const pA = N.charCodeAt(0);
                  (aA === "utf8" && pA < 128 || aA === "latin1") && (N = pA);
                }
              } else typeof N == "number" ? N = N & 255 : typeof N == "boolean" && (N = Number(N));
              if (G < 0 || this.length < G || this.length < W)
                throw new RangeError("Out of range index");
              if (W <= G)
                return this;
              G = G >>> 0, W = W === void 0 ? this.length : W >>> 0, N || (N = 0);
              let j;
              if (typeof N == "number")
                for (j = G; j < W; ++j)
                  this[j] = N;
              else {
                const pA = D.isBuffer(N) ? N : D.from(N, aA), Be = pA.length;
                if (Be === 0)
                  throw new TypeError('The value "' + N + '" is invalid for argument "value"');
                for (j = 0; j < W - G; ++j)
                  this[j + G] = pA[j % Be];
              }
              return this;
            };
            const oA = {};
            function p(wA, N, G) {
              oA[wA] = class extends G {
                constructor() {
                  super(), Object.defineProperty(this, "message", {
                    value: N.apply(this, arguments),
                    writable: !0,
                    configurable: !0
                  }), this.name = `${this.name} [${wA}]`, this.stack, delete this.name;
                }
                get code() {
                  return wA;
                }
                set code(aA) {
                  Object.defineProperty(this, "code", {
                    configurable: !0,
                    enumerable: !0,
                    value: aA,
                    writable: !0
                  });
                }
                toString() {
                  return `${this.name} [${wA}]: ${this.message}`;
                }
              };
            }
            p("ERR_BUFFER_OUT_OF_BOUNDS", function(wA) {
              return wA ? `${wA} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
            }, RangeError), p("ERR_INVALID_ARG_TYPE", function(wA, N) {
              return `The "${wA}" argument must be of type number. Received type ${typeof N}`;
            }, TypeError), p("ERR_OUT_OF_RANGE", function(wA, N, G) {
              let W = `The value of "${wA}" is out of range.`, aA = G;
              return Number.isInteger(G) && Math.abs(G) > 4294967296 ? aA = rA(String(G)) : typeof G == "bigint" && (aA = String(G), (G > BigInt(2) ** BigInt(32) || G < -(BigInt(2) ** BigInt(32))) && (aA = rA(aA)), aA += "n"), W += ` It must be ${N}. Received ${aA}`, W;
            }, RangeError);
            function rA(wA) {
              let N = "", G = wA.length;
              const W = wA[0] === "-" ? 1 : 0;
              for (; G >= W + 4; G -= 3)
                N = `_${wA.slice(G - 3, G)}${N}`;
              return `${wA.slice(0, G)}${N}`;
            }
            function QA(wA, N, G) {
              y(N, "offset"), (wA[N] === void 0 || wA[N + G] === void 0) && M(N, wA.length - (G + 1));
            }
            function bA(wA, N, G, W, aA, j) {
              if (wA > G || wA < N) {
                const pA = typeof N == "bigint" ? "n" : "";
                let Be;
                throw N === 0 || N === BigInt(0) ? Be = `>= 0${pA} and < 2${pA} ** ${(j + 1) * 8}${pA}` : Be = `>= -(2${pA} ** ${(j + 1) * 8 - 1}${pA}) and < 2 ** ${(j + 1) * 8 - 1}${pA}`, new oA.ERR_OUT_OF_RANGE("value", Be, wA);
              }
              QA(W, aA, j);
            }
            function y(wA, N) {
              if (typeof wA != "number")
                throw new oA.ERR_INVALID_ARG_TYPE(N, "number", wA);
            }
            function M(wA, N, G) {
              throw Math.floor(wA) !== wA ? (y(wA, G), new oA.ERR_OUT_OF_RANGE("offset", "an integer", wA)) : N < 0 ? new oA.ERR_BUFFER_OUT_OF_BOUNDS() : new oA.ERR_OUT_OF_RANGE("offset", `>= 0 and <= ${N}`, wA);
            }
            const FA = /[^+/0-9A-Za-z-_]/g;
            function dA(wA) {
              if (wA = wA.split("=")[0], wA = wA.trim().replace(FA, ""), wA.length < 2) return "";
              for (; wA.length % 4 !== 0; )
                wA = wA + "=";
              return wA;
            }
            function he(wA, N) {
              N = N || 1 / 0;
              let G;
              const W = wA.length;
              let aA = null;
              const j = [];
              for (let pA = 0; pA < W; ++pA) {
                if (G = wA.charCodeAt(pA), G > 55295 && G < 57344) {
                  if (!aA) {
                    if (G > 56319) {
                      (N -= 3) > -1 && j.push(239, 191, 189);
                      continue;
                    } else if (pA + 1 === W) {
                      (N -= 3) > -1 && j.push(239, 191, 189);
                      continue;
                    }
                    aA = G;
                    continue;
                  }
                  if (G < 56320) {
                    (N -= 3) > -1 && j.push(239, 191, 189), aA = G;
                    continue;
                  }
                  G = (aA - 55296 << 10 | G - 56320) + 65536;
                } else aA && (N -= 3) > -1 && j.push(239, 191, 189);
                if (aA = null, G < 128) {
                  if ((N -= 1) < 0) break;
                  j.push(G);
                } else if (G < 2048) {
                  if ((N -= 2) < 0) break;
                  j.push(G >> 6 | 192, G & 63 | 128);
                } else if (G < 65536) {
                  if ((N -= 3) < 0) break;
                  j.push(G >> 12 | 224, G >> 6 & 63 | 128, G & 63 | 128);
                } else if (G < 1114112) {
                  if ((N -= 4) < 0) break;
                  j.push(G >> 18 | 240, G >> 12 & 63 | 128, G >> 6 & 63 | 128, G & 63 | 128);
                } else
                  throw new Error("Invalid code point");
              }
              return j;
            }
            function ie(wA) {
              const N = [];
              for (let G = 0; G < wA.length; ++G)
                N.push(wA.charCodeAt(G) & 255);
              return N;
            }
            function KA(wA, N) {
              let G, W, aA;
              const j = [];
              for (let pA = 0; pA < wA.length && !((N -= 2) < 0); ++pA)
                G = wA.charCodeAt(pA), W = G >> 8, aA = G % 256, j.push(aA), j.push(W);
              return j;
            }
            function Pe(wA) {
              return A.toByteArray(dA(wA));
            }
            function Je(wA, N, G, W) {
              let aA;
              for (aA = 0; aA < W && !(aA + G >= N.length || aA >= wA.length); ++aA)
                N[aA + G] = wA[aA];
              return aA;
            }
            function Le(wA, N) {
              return wA instanceof N || wA != null && wA.constructor != null && wA.constructor.name != null && wA.constructor.name === N.name;
            }
            function Re(wA) {
              return wA !== wA;
            }
            const _e = (function() {
              const wA = "0123456789abcdef", N = new Array(256);
              for (let G = 0; G < 16; ++G) {
                const W = G * 16;
                for (let aA = 0; aA < 16; ++aA)
                  N[W + aA] = wA[G] + wA[aA];
              }
              return N;
            })();
            function se(wA) {
              return typeof BigInt > "u" ? Ee : wA;
            }
            function Ee() {
              throw new Error("BigInt not supported");
            }
          },
          /***/
          4406(Q) {
            var B = 1, r = 0;
            class A {
              constructor(d) {
                this.stateTable = d.stateTable, this.accepting = d.accepting, this.tags = d.tags;
              }
              /**
               * Returns an iterable object that yields pattern matches over the input sequence.
               * Matches are of the form [startIndex, endIndex, tags].
               */
              match(d) {
                var x = this;
                return {
                  *[Symbol.iterator]() {
                    for (var U = B, P = null, D = null, J = null, q = 0; q < d.length; q++) {
                      var AA = d[q];
                      J = U, U = x.stateTable[U][AA], U === r && (P != null && D != null && D >= P && (yield [P, D, x.tags[J]]), U = x.stateTable[B][AA], P = null), U !== r && P == null && (P = q), x.accepting[U] && (D = q), U === r && (U = B);
                    }
                    P != null && D != null && D >= P && (yield [P, D, x.tags[U]]);
                  }
                };
              }
              /**
               * For each match over the input sequence, action functions matching
               * the tag definitions in the input pattern are called with the startIndex,
               * endIndex, and sub-match sequence.
               */
              apply(d, x) {
                for (var [U, P, D] of this.match(d))
                  for (var J of D)
                    typeof x[J] == "function" && x[J](U, P, d.slice(U, P + 1));
              }
            }
            Q.exports = A;
          },
          /***/
          3915(Q, B, r) {
            r(8376), r(6401), r(2017);
            var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            (function(a) {
              var d = typeof Uint8Array < "u" ? Uint8Array : Array, x = 43, U = 47, P = 48, D = 97, J = 65, q = 45, AA = 95;
              function K(H) {
                var eA = H.charCodeAt(0);
                if (eA === x || eA === q) return 62;
                if (eA === U || eA === AA) return 63;
                if (eA < P) return -1;
                if (eA < P + 10) return eA - P + 26 + 26;
                if (eA < J + 26) return eA - J;
                if (eA < D + 26) return eA - D + 26;
              }
              function z(H) {
                var eA, CA, IA, k, tA, lA;
                if (H.length % 4 > 0)
                  throw new Error("Invalid string. Length must be a multiple of 4");
                var uA = H.length;
                tA = H.charAt(uA - 2) === "=" ? 2 : H.charAt(uA - 1) === "=" ? 1 : 0, lA = new d(H.length * 3 / 4 - tA), IA = tA > 0 ? H.length - 4 : H.length;
                var w = 0;
                function v(RA) {
                  lA[w++] = RA;
                }
                for (eA = 0, CA = 0; eA < IA; eA += 4, CA += 3)
                  k = K(H.charAt(eA)) << 18 | K(H.charAt(eA + 1)) << 12 | K(H.charAt(eA + 2)) << 6 | K(H.charAt(eA + 3)), v((k & 16711680) >> 16), v((k & 65280) >> 8), v(k & 255);
                return tA === 2 ? (k = K(H.charAt(eA)) << 2 | K(H.charAt(eA + 1)) >> 4, v(k & 255)) : tA === 1 && (k = K(H.charAt(eA)) << 10 | K(H.charAt(eA + 1)) << 4 | K(H.charAt(eA + 2)) >> 2, v(k >> 8 & 255), v(k & 255)), lA;
              }
              function T(H) {
                var eA, CA = H.length % 3, IA = "", k, tA;
                function lA(w) {
                  return A.charAt(w);
                }
                function uA(w) {
                  return lA(w >> 18 & 63) + lA(w >> 12 & 63) + lA(w >> 6 & 63) + lA(w & 63);
                }
                for (eA = 0, tA = H.length - CA; eA < tA; eA += 3)
                  k = (H[eA] << 16) + (H[eA + 1] << 8) + H[eA + 2], IA += uA(k);
                switch (CA) {
                  case 1:
                    k = H[H.length - 1], IA += lA(k >> 2), IA += lA(k << 4 & 63), IA += "==";
                    break;
                  case 2:
                    k = (H[H.length - 2] << 8) + H[H.length - 1], IA += lA(k >> 10), IA += lA(k >> 4 & 63), IA += lA(k << 2 & 63), IA += "=";
                    break;
                }
                return IA;
              }
              a.toByteArray = z, a.fromByteArray = T;
            })(B);
          },
          /***/
          336(Q, B, r) {
            var A = r(783).Buffer;
            r(187);
            const a = r(2416), d = r(6729);
            Q.exports = class Pa {
              static decode(U, P) {
                return a.readFile(U, function(D, J) {
                  return new Pa(J).decode((AA) => P(AA));
                });
              }
              static load(U) {
                const P = a.readFileSync(U);
                return new Pa(P);
              }
              constructor(U) {
                let P;
                for (this.data = U, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {}; ; ) {
                  const z = this.readUInt32();
                  let T = "";
                  for (P = 0; P < 4; P++)
                    T += String.fromCharCode(this.data[this.pos++]);
                  switch (T) {
                    case "IHDR":
                      this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                      break;
                    case "PLTE":
                      this.palette = this.read(z);
                      break;
                    case "IDAT":
                      for (P = 0; P < z; P++)
                        this.imgData.push(this.data[this.pos++]);
                      break;
                    case "tRNS":
                      switch (this.transparency = {}, this.colorType) {
                        case 3:
                          this.transparency.indexed = this.read(z);
                          var D = 255 - this.transparency.indexed.length;
                          if (D > 0)
                            for (P = 0; P < D; P++)
                              this.transparency.indexed.push(255);
                          break;
                        case 0:
                          this.transparency.grayscale = this.read(z)[0];
                          break;
                        case 2:
                          this.transparency.rgb = this.read(z);
                          break;
                      }
                      break;
                    case "tEXt":
                      var J = this.read(z), q = J.indexOf(0), AA = String.fromCharCode.apply(String, J.slice(0, q));
                      this.text[AA] = String.fromCharCode.apply(String, J.slice(q + 1));
                      break;
                    case "IEND":
                      switch (this.colorType) {
                        case 0:
                        case 3:
                        case 4:
                          this.colors = 1;
                          break;
                        case 2:
                        case 6:
                          this.colors = 3;
                          break;
                      }
                      this.hasAlphaChannel = [4, 6].includes(this.colorType);
                      var K = this.colors + (this.hasAlphaChannel ? 1 : 0);
                      switch (this.pixelBitlength = this.bits * K, this.colors) {
                        case 1:
                          this.colorSpace = "DeviceGray";
                          break;
                        case 3:
                          this.colorSpace = "DeviceRGB";
                          break;
                      }
                      this.imgData = new A(this.imgData);
                      return;
                    // removed by dead control flow
                    default:
                      this.pos += z;
                  }
                  if (this.pos += 4, this.pos > this.data.length)
                    throw new Error("Incomplete or corrupt PNG file");
                }
              }
              read(U) {
                const P = new Array(U);
                for (let D = 0; D < U; D++)
                  P[D] = this.data[this.pos++];
                return P;
              }
              readUInt32() {
                const U = this.data[this.pos++] << 24, P = this.data[this.pos++] << 16, D = this.data[this.pos++] << 8, J = this.data[this.pos++];
                return U | P | D | J;
              }
              readUInt16() {
                const U = this.data[this.pos++] << 8, P = this.data[this.pos++];
                return U | P;
              }
              decodePixels(U) {
                return d.inflate(this.imgData, (P, D) => {
                  if (P)
                    throw P;
                  const {
                    width: J,
                    height: q
                  } = this, AA = this.pixelBitlength / 8, K = new A(J * q * AA), {
                    length: z
                  } = D;
                  let T = 0;
                  function H(eA, CA, IA, k, tA) {
                    tA === void 0 && (tA = !1);
                    const lA = Math.ceil((J - eA) / IA), uA = Math.ceil((q - CA) / k), w = AA * lA, v = tA ? K : new A(w * uA);
                    let RA = 0, DA = 0;
                    for (; RA < uA && T < z; ) {
                      var $, cA, $A, kA, WA;
                      switch (D[T++]) {
                        case 0:
                          for ($A = 0; $A < w; $A++)
                            v[DA++] = D[T++];
                          break;
                        case 1:
                          for ($A = 0; $A < w; $A++)
                            $ = D[T++], kA = $A < AA ? 0 : v[DA - AA], v[DA++] = ($ + kA) % 256;
                          break;
                        case 2:
                          for ($A = 0; $A < w; $A++)
                            $ = D[T++], cA = ($A - $A % AA) / AA, WA = RA && v[(RA - 1) * w + cA * AA + $A % AA], v[DA++] = (WA + $) % 256;
                          break;
                        case 3:
                          for ($A = 0; $A < w; $A++)
                            $ = D[T++], cA = ($A - $A % AA) / AA, kA = $A < AA ? 0 : v[DA - AA], WA = RA && v[(RA - 1) * w + cA * AA + $A % AA], v[DA++] = ($ + Math.floor((kA + WA) / 2)) % 256;
                          break;
                        case 4:
                          for ($A = 0; $A < w; $A++) {
                            var EA, zA;
                            $ = D[T++], cA = ($A - $A % AA) / AA, kA = $A < AA ? 0 : v[DA - AA], RA === 0 ? WA = zA = 0 : (WA = v[(RA - 1) * w + cA * AA + $A % AA], zA = cA && v[(RA - 1) * w + (cA - 1) * AA + $A % AA]);
                            const OA = kA + WA - zA, xA = Math.abs(OA - kA), LA = Math.abs(OA - WA), yA = Math.abs(OA - zA);
                            xA <= LA && xA <= yA ? EA = kA : LA <= yA ? EA = WA : EA = zA, v[DA++] = ($ + EA) % 256;
                          }
                          break;
                        default:
                          throw new Error(`Invalid filter algorithm: ${D[T - 1]}`);
                      }
                      if (!tA) {
                        let OA = ((CA + RA * k) * J + eA) * AA, xA = RA * w;
                        for ($A = 0; $A < lA; $A++) {
                          for (let LA = 0; LA < AA; LA++) K[OA++] = v[xA++];
                          OA += (IA - 1) * AA;
                        }
                      }
                      RA++;
                    }
                  }
                  return this.interlaceMethod === 1 ? (H(0, 0, 8, 8), H(4, 0, 8, 8), H(0, 4, 4, 8), H(2, 0, 4, 4), H(0, 2, 2, 4), H(1, 0, 2, 2), H(0, 1, 1, 2)) : H(0, 0, 1, 1, !0), U(K);
                });
              }
              decodePalette() {
                const {
                  palette: U
                } = this, {
                  length: P
                } = U, D = this.transparency.indexed || [], J = new A(D.length + P);
                let q = 0, AA = 0;
                for (let z = 0; z < P; z += 3) {
                  var K;
                  J[q++] = U[z], J[q++] = U[z + 1], J[q++] = U[z + 2], J[q++] = (K = D[AA++]) != null ? K : 255;
                }
                return J;
              }
              copyToImageData(U, P) {
                let D, J, {
                  colors: q
                } = this, AA = null, K = this.hasAlphaChannel;
                this.palette.length && (AA = this._decodedPalette || (this._decodedPalette = this.decodePalette()), q = 4, K = !0);
                const z = U.data || U, {
                  length: T
                } = z, H = AA || P;
                let eA = D = 0;
                if (q === 1)
                  for (; eA < T; ) {
                    J = AA ? P[eA / 4] * 4 : D;
                    const CA = H[J++];
                    z[eA++] = CA, z[eA++] = CA, z[eA++] = CA, z[eA++] = K ? H[J++] : 255, D = J;
                  }
                else
                  for (; eA < T; )
                    J = AA ? P[eA / 4] * 4 : D, z[eA++] = H[J++], z[eA++] = H[J++], z[eA++] = H[J++], z[eA++] = K ? H[J++] : 255, D = J;
              }
              decode(U) {
                const P = new A(this.width * this.height * 4);
                return this.decodePixels((D) => (this.copyToImageData(P, D), U(P)));
              }
            };
          },
          /***/
          182(Q, B, r) {
            function A(eA, CA) {
              var IA = Object.keys(eA);
              if (Object.getOwnPropertySymbols) {
                var k = Object.getOwnPropertySymbols(eA);
                CA && (k = k.filter(function(tA) {
                  return Object.getOwnPropertyDescriptor(eA, tA).enumerable;
                })), IA.push.apply(IA, k);
              }
              return IA;
            }
            function a(eA) {
              for (var CA = 1; CA < arguments.length; CA++) {
                var IA = arguments[CA] != null ? arguments[CA] : {};
                CA % 2 ? A(Object(IA), !0).forEach(function(k) {
                  d(eA, k, IA[k]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(eA, Object.getOwnPropertyDescriptors(IA)) : A(Object(IA)).forEach(function(k) {
                  Object.defineProperty(eA, k, Object.getOwnPropertyDescriptor(IA, k));
                });
              }
              return eA;
            }
            function d(eA, CA, IA) {
              return CA = D(CA), CA in eA ? Object.defineProperty(eA, CA, {
                value: IA,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : eA[CA] = IA, eA;
            }
            function x(eA, CA) {
              if (!(eA instanceof CA))
                throw new TypeError("Cannot call a class as a function");
            }
            function U(eA, CA) {
              for (var IA = 0; IA < CA.length; IA++) {
                var k = CA[IA];
                k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(eA, D(k.key), k);
              }
            }
            function P(eA, CA, IA) {
              return CA && U(eA.prototype, CA), Object.defineProperty(eA, "prototype", {
                writable: !1
              }), eA;
            }
            function D(eA) {
              var CA = J(eA, "string");
              return typeof CA == "symbol" ? CA : String(CA);
            }
            function J(eA, CA) {
              if (typeof eA != "object" || eA === null) return eA;
              var IA = eA[Symbol.toPrimitive];
              if (IA !== void 0) {
                var k = IA.call(eA, CA);
                if (typeof k != "object") return k;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String(eA);
            }
            var q = r(783), AA = q.Buffer, K = r(3779), z = K.inspect, T = z && z.custom || "inspect";
            function H(eA, CA, IA) {
              AA.prototype.copy.call(eA, CA, IA);
            }
            Q.exports = /* @__PURE__ */ (function() {
              function eA() {
                x(this, eA), this.head = null, this.tail = null, this.length = 0;
              }
              return P(eA, [{
                key: "push",
                value: function(IA) {
                  var k = {
                    data: IA,
                    next: null
                  };
                  this.length > 0 ? this.tail.next = k : this.head = k, this.tail = k, ++this.length;
                }
              }, {
                key: "unshift",
                value: function(IA) {
                  var k = {
                    data: IA,
                    next: this.head
                  };
                  this.length === 0 && (this.tail = k), this.head = k, ++this.length;
                }
              }, {
                key: "shift",
                value: function() {
                  if (this.length !== 0) {
                    var IA = this.head.data;
                    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, IA;
                  }
                }
              }, {
                key: "clear",
                value: function() {
                  this.head = this.tail = null, this.length = 0;
                }
              }, {
                key: "join",
                value: function(IA) {
                  if (this.length === 0) return "";
                  for (var k = this.head, tA = "" + k.data; k = k.next; ) tA += IA + k.data;
                  return tA;
                }
              }, {
                key: "concat",
                value: function(IA) {
                  if (this.length === 0) return AA.alloc(0);
                  for (var k = AA.allocUnsafe(IA >>> 0), tA = this.head, lA = 0; tA; )
                    H(tA.data, k, lA), lA += tA.data.length, tA = tA.next;
                  return k;
                }
                // Consumes a specified amount of bytes or characters from the buffered data.
              }, {
                key: "consume",
                value: function(IA, k) {
                  var tA;
                  return IA < this.head.data.length ? (tA = this.head.data.slice(0, IA), this.head.data = this.head.data.slice(IA)) : IA === this.head.data.length ? tA = this.shift() : tA = k ? this._getString(IA) : this._getBuffer(IA), tA;
                }
              }, {
                key: "first",
                value: function() {
                  return this.head.data;
                }
                // Consumes a specified amount of characters from the buffered data.
              }, {
                key: "_getString",
                value: function(IA) {
                  var k = this.head, tA = 1, lA = k.data;
                  for (IA -= lA.length; k = k.next; ) {
                    var uA = k.data, w = IA > uA.length ? uA.length : IA;
                    if (w === uA.length ? lA += uA : lA += uA.slice(0, IA), IA -= w, IA === 0) {
                      w === uA.length ? (++tA, k.next ? this.head = k.next : this.head = this.tail = null) : (this.head = k, k.data = uA.slice(w));
                      break;
                    }
                    ++tA;
                  }
                  return this.length -= tA, lA;
                }
                // Consumes a specified amount of bytes from the buffered data.
              }, {
                key: "_getBuffer",
                value: function(IA) {
                  var k = AA.allocUnsafe(IA), tA = this.head, lA = 1;
                  for (tA.data.copy(k), IA -= tA.data.length; tA = tA.next; ) {
                    var uA = tA.data, w = IA > uA.length ? uA.length : IA;
                    if (uA.copy(k, k.length - IA, 0, w), IA -= w, IA === 0) {
                      w === uA.length ? (++lA, tA.next ? this.head = tA.next : this.head = this.tail = null) : (this.head = tA, tA.data = uA.slice(w));
                      break;
                    }
                    ++lA;
                  }
                  return this.length -= lA, k;
                }
                // Make sure the linked list only shows the minimal necessary information.
              }, {
                key: T,
                value: function(IA, k) {
                  return z(this, a(a({}, k), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: !1
                  }));
                }
              }]), eA;
            })();
          },
          /***/
          5691(Q, B, r) {
            var A = r(783), a = A.Buffer;
            function d(U, P) {
              for (var D in U)
                P[D] = U[D];
            }
            a.from && a.alloc && a.allocUnsafe && a.allocUnsafeSlow ? Q.exports = A : (d(A, B), B.Buffer = x);
            function x(U, P, D) {
              return a(U, P, D);
            }
            d(a, x), x.from = function(U, P, D) {
              if (typeof U == "number")
                throw new TypeError("Argument must not be a number");
              return a(U, P, D);
            }, x.alloc = function(U, P, D) {
              if (typeof U != "number")
                throw new TypeError("Argument must be a number");
              var J = a(U);
              return P !== void 0 ? typeof D == "string" ? J.fill(P, D) : J.fill(P) : J.fill(0), J;
            }, x.allocUnsafe = function(U) {
              if (typeof U != "number")
                throw new TypeError("Argument must be a number");
              return a(U);
            }, x.allocUnsafeSlow = function(U) {
              if (typeof U != "number")
                throw new TypeError("Argument must be a number");
              return A.SlowBuffer(U);
            };
          },
          /***/
          7571(Q, B, r) {
            r(8376), r(6401), r(2017);
            const A = r(3483), {
              swap32LE: a
            } = r(6016), d = 11, x = 5, U = d - x, P = 65536 >> d, J = (1 << U) - 1, q = 2, K = (1 << x) - 1, z = 65536 >> x, T = 1024 >> x, IA = z + T + 32, k = 1 << q;
            class tA {
              constructor(uA) {
                const w = typeof uA.readUInt32BE == "function" && typeof uA.slice == "function";
                if (w || uA instanceof Uint8Array) {
                  let v;
                  if (w)
                    this.highStart = uA.readUInt32LE(0), this.errorValue = uA.readUInt32LE(4), v = uA.readUInt32LE(8), uA = uA.slice(12);
                  else {
                    const RA = new DataView(uA.buffer);
                    this.highStart = RA.getUint32(0, !0), this.errorValue = RA.getUint32(4, !0), v = RA.getUint32(8, !0), uA = uA.subarray(12);
                  }
                  uA = A(uA, new Uint8Array(v)), uA = A(uA, new Uint8Array(v)), a(uA), this.data = new Uint32Array(uA.buffer);
                } else
                  ({
                    data: this.data,
                    highStart: this.highStart,
                    errorValue: this.errorValue
                  } = uA);
              }
              get(uA) {
                let w;
                return uA < 0 || uA > 1114111 ? this.errorValue : uA < 55296 || uA > 56319 && uA <= 65535 ? (w = (this.data[uA >> x] << q) + (uA & K), this.data[w]) : uA <= 65535 ? (w = (this.data[z + (uA - 55296 >> x)] << q) + (uA & K), this.data[w]) : uA < this.highStart ? (w = this.data[IA - P + (uA >> d)], w = this.data[w + (uA >> x & J)], w = (w << q) + (uA & K), this.data[w]) : this.data[this.data.length - k];
              }
            }
            Q.exports = tA;
          },
          /***/
          6016(Q, B, r) {
            r(8376), r(6401), r(2017);
            const A = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, a = (U, P, D) => {
              let J = U[P];
              U[P] = U[D], U[D] = J;
            }, d = (U) => {
              const P = U.length;
              for (let D = 0; D < P; D += 4)
                a(U, D, D + 3), a(U, D + 1, D + 2);
            }, x = (U) => {
              A && d(U);
            };
            Q.exports = {
              swap32LE: x
            };
          },
          /***/
          5167(Q, B, r) {
            var A = "/", a = r(783).Buffer;
            B.A = void 0, r(187), r(8376), r(6401), r(2017);
            var d = H(r(9760)), x = H(r(6729)), U = r(3973), P = H(r(1632)), D = r(7785), J = r(2651), q = T(r(1715)), AA = r(4785), K = H(r(2532)), z = H(r(336));
            function T(g, s) {
              if (typeof WeakMap == "function") var I = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
              return (T = function(S, iA) {
                if (!iA && S && S.__esModule) return S;
                var YA, XA, oe = { __proto__: null, default: S };
                if (S === null || typeof S != "object" && typeof S != "function") return oe;
                if (YA = iA ? f : I) {
                  if (YA.has(S)) return YA.get(S);
                  YA.set(S, oe);
                }
                for (const pe in S) pe !== "default" && {}.hasOwnProperty.call(S, pe) && ((XA = (YA = Object.defineProperty) && Object.getOwnPropertyDescriptor(S, pe)) && (XA.get || XA.set) ? YA(oe, pe, XA) : oe[pe] = S[pe]);
                return oe;
              })(g, s);
            }
            function H(g) {
              return g && g.__esModule ? g : { default: g };
            }
            var eA = r(2416);
            class CA {
              toString() {
                throw new Error("Must be implemented by subclasses");
              }
            }
            class IA {
              constructor() {
                let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this._items = {}, this.limits = typeof s.limits == "boolean" ? s.limits : !0;
              }
              add(s, I) {
                return this._items[s] = I;
              }
              get(s) {
                return this._items[s];
              }
              toString() {
                const s = Object.keys(this._items).sort((f, S) => this._compareKeys(f, S)), I = ["<<"];
                if (this.limits && s.length > 1) {
                  const f = s[0], S = s[s.length - 1];
                  I.push(`  /Limits ${v.convert([this._dataForKey(f), this._dataForKey(S)])}`);
                }
                I.push(`  /${this._keysName()} [`);
                for (let f of s)
                  I.push(`    ${v.convert(this._dataForKey(f))} ${v.convert(this._items[f])}`);
                return I.push("]"), I.push(">>"), I.join(`
`);
              }
              _compareKeys() {
                throw new Error("Must be implemented by subclasses");
              }
              _keysName() {
                throw new Error("Must be implemented by subclasses");
              }
              _dataForKey() {
                throw new Error("Must be implemented by subclasses");
              }
            }
            class k {
              constructor(s, I, f, S, iA, YA) {
                this.id = "CS" + Object.keys(s.spotColors).length, this.name = I, this.values = [f, S, iA, YA], this.ref = s.ref(["Separation", this.name, "DeviceCMYK", {
                  Range: [0, 1, 0, 1, 0, 1, 0, 1],
                  C0: [0, 0, 0, 0],
                  C1: this.values.map((XA) => XA / 100),
                  FunctionType: 2,
                  Domain: [0, 1],
                  N: 1
                }]), this.ref.end();
              }
              toString() {
                return `${this.ref.id} 0 R`;
              }
            }
            const tA = (g, s) => (Array(s + 1).join("0") + g).slice(-s), lA = /[\n\r\t\b\f()\\]/g, uA = {
              "\n": "\\n",
              "\r": "\\r",
              "	": "\\t",
              "\b": "\\b",
              "\f": "\\f",
              "\\": "\\\\",
              "(": "\\(",
              ")": "\\)"
            }, w = function(g) {
              const s = g.length;
              if (s & 1)
                throw new Error("Buffer length must be even");
              for (let I = 0, f = s - 1; I < f; I += 2) {
                const S = g[I];
                g[I] = g[I + 1], g[I + 1] = S;
              }
              return g;
            };
            class v {
              static convert(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (typeof s == "string")
                  return `/${s}`;
                if (s instanceof String) {
                  let f = s, S = !1;
                  for (let YA = 0, XA = f.length; YA < XA; YA++)
                    if (f.charCodeAt(YA) > 127) {
                      S = !0;
                      break;
                    }
                  let iA;
                  return S ? iA = w(a.from(`\uFEFF${f}`, "utf16le")) : iA = a.from(f.valueOf(), "ascii"), I ? f = I(iA).toString("binary") : f = iA.toString("binary"), f = f.replace(lA, (YA) => uA[YA]), `(${f})`;
                } else {
                  if (a.isBuffer(s))
                    return `<${s.toString("hex")}>`;
                  if (s instanceof CA || s instanceof IA || s instanceof k)
                    return s.toString();
                  if (s instanceof Date) {
                    let f = `D:${tA(s.getUTCFullYear(), 4)}` + tA(s.getUTCMonth() + 1, 2) + tA(s.getUTCDate(), 2) + tA(s.getUTCHours(), 2) + tA(s.getUTCMinutes(), 2) + tA(s.getUTCSeconds(), 2) + "Z";
                    return I && (f = I(a.from(f, "ascii")).toString("binary"), f = f.replace(lA, (S) => uA[S])), `(${f})`;
                  } else {
                    if (Array.isArray(s))
                      return `[${s.map((S) => v.convert(S, I)).join(" ")}]`;
                    if ({}.toString.call(s) === "[object Object]") {
                      const f = ["<<"];
                      for (let S in s) {
                        const iA = s[S];
                        f.push(`/${S} ${v.convert(iA, I)}`);
                      }
                      return f.push(">>"), f.join(`
`);
                    } else return typeof s == "number" ? v.number(s) : `${s}`;
                  }
                }
              }
              static number(s) {
                if (s > -1e21 && s < 1e21)
                  return Math.round(s * 1e6) / 1e6;
                throw new Error(`unsupported number: ${s}`);
              }
            }
            class RA extends CA {
              constructor(s, I) {
                let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                super(), this.document = s, this.id = I, this.data = f, this.gen = 0, this.compress = this.document.compress && !this.data.Filter, this.uncompressedLength = 0, this.buffer = [];
              }
              write(s) {
                s instanceof Uint8Array || (s = a.from(s + `
`, "binary")), this.uncompressedLength += s.length, this.data.Length == null && (this.data.Length = 0), this.buffer.push(s), this.data.Length += s.length, this.compress && (this.data.Filter = "FlateDecode");
              }
              end(s) {
                s && this.write(s), this.finalize();
              }
              finalize() {
                this.offset = this.document._offset;
                const s = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
                this.buffer.length && (this.buffer = a.concat(this.buffer), this.compress && (this.buffer = x.default.deflateSync(this.buffer)), s && (this.buffer = s(this.buffer)), this.data.Length = this.buffer.length), this.document._write(`${this.id} ${this.gen} obj`), this.document._write(v.convert(this.data, s)), this.buffer.length && (this.document._write("stream"), this.document._write(this.buffer), this.buffer = [], this.document._write(`
endstream`)), this.document._write("endobj"), this.document._refEnd(this);
              }
              toString() {
                return `${this.id} ${this.gen} R`;
              }
            }
            const DA = new Float32Array(1), $ = new Uint32Array(DA.buffer);
            function cA(g) {
              const s = Math.fround(g);
              return s <= g ? s : (DA[0] = g, g <= 0 ? $[0] += 1 : $[0] -= 1, DA[0]);
            }
            function $A(g) {
              let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (f) => f;
              return (g == null || typeof g == "object" && Object.keys(g).length === 0) && (g = s), g == null || typeof g != "object" ? g = {
                top: g,
                right: g,
                bottom: g,
                left: g
              } : Array.isArray(g) && (g.length === 2 ? g = {
                vertical: g[0],
                horizontal: g[1]
              } : g = {
                top: g[0],
                right: g[1],
                bottom: g[2],
                left: g[3]
              }), ("vertical" in g || "horizontal" in g) && (g = {
                top: g.vertical,
                right: g.horizontal,
                bottom: g.vertical,
                left: g.horizontal
              }), {
                top: I(g.top),
                right: I(g.right),
                bottom: I(g.bottom),
                left: I(g.left)
              };
            }
            const kA = 1 / 10, WA = 1 / 2.54, EA = 1 / 96, zA = 72, OA = 12;
            function xA(g) {
              return g === 0 ? 1 : g === 90 ? 0 : g === 180 ? -1 : g === 270 ? 0 : Math.cos(g * Math.PI / 180);
            }
            function LA(g) {
              return g === 0 ? 0 : g === 90 ? 1 : g === 180 ? 0 : g === 270 ? -1 : Math.sin(g * Math.PI / 180);
            }
            const yA = {
              top: 72,
              left: 72,
              bottom: 72,
              right: 72
            }, TA = {
              "4A0": [4767.87, 6740.79],
              "2A0": [3370.39, 4767.87],
              A0: [2383.94, 3370.39],
              A1: [1683.78, 2383.94],
              A2: [1190.55, 1683.78],
              A3: [841.89, 1190.55],
              A4: [595.28, 841.89],
              A5: [419.53, 595.28],
              A6: [297.64, 419.53],
              A7: [209.76, 297.64],
              A8: [147.4, 209.76],
              A9: [104.88, 147.4],
              A10: [73.7, 104.88],
              B0: [2834.65, 4008.19],
              B1: [2004.09, 2834.65],
              B2: [1417.32, 2004.09],
              B3: [1000.63, 1417.32],
              B4: [708.66, 1000.63],
              B5: [498.9, 708.66],
              B6: [354.33, 498.9],
              B7: [249.45, 354.33],
              B8: [175.75, 249.45],
              B9: [124.72, 175.75],
              B10: [87.87, 124.72],
              C0: [2599.37, 3676.54],
              C1: [1836.85, 2599.37],
              C2: [1298.27, 1836.85],
              C3: [918.43, 1298.27],
              C4: [649.13, 918.43],
              C5: [459.21, 649.13],
              C6: [323.15, 459.21],
              C7: [229.61, 323.15],
              C8: [161.57, 229.61],
              C9: [113.39, 161.57],
              C10: [79.37, 113.39],
              RA0: [2437.8, 3458.27],
              RA1: [1729.13, 2437.8],
              RA2: [1218.9, 1729.13],
              RA3: [864.57, 1218.9],
              RA4: [609.45, 864.57],
              SRA0: [2551.18, 3628.35],
              SRA1: [1814.17, 2551.18],
              SRA2: [1275.59, 1814.17],
              SRA3: [907.09, 1275.59],
              SRA4: [637.8, 907.09],
              EXECUTIVE: [521.86, 756],
              FOLIO: [612, 936],
              LEGAL: [612, 1008],
              LETTER: [612, 792],
              TABLOID: [792, 1224]
            };
            class fA {
              constructor(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.document = s, this._options = I, this.size = I.size || "letter", this.layout = I.layout || "portrait", this.userUnit = I.userUnit || 1;
                const f = Array.isArray(this.size) ? this.size : TA[this.size.toUpperCase()];
                this.width = f[this.layout === "portrait" ? 0 : 1], this.height = f[this.layout === "portrait" ? 1 : 0], this.content = this.document.ref(), I.font && s.font(I.font, I.fontFamily), I.fontSize && s.fontSize(I.fontSize), this.margins = $A(I.margin ?? I.margins, yA, (S) => s.sizeToPoint(S, 0, this)), this.resources = this.document.ref({
                  ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"]
                }), this.dictionary = this.document.ref({
                  Type: "Page",
                  Parent: this.document._root.data.Pages,
                  MediaBox: [0, 0, this.width, this.height],
                  Contents: this.content,
                  Resources: this.resources,
                  UserUnit: this.userUnit
                }), this.markings = [];
              }
              get fonts() {
                const s = this.resources.data;
                return s.Font != null ? s.Font : s.Font = {};
              }
              get xobjects() {
                const s = this.resources.data;
                return s.XObject != null ? s.XObject : s.XObject = {};
              }
              get ext_gstates() {
                const s = this.resources.data;
                return s.ExtGState != null ? s.ExtGState : s.ExtGState = {};
              }
              get patterns() {
                const s = this.resources.data;
                return s.Pattern != null ? s.Pattern : s.Pattern = {};
              }
              get colorSpaces() {
                const s = this.resources.data;
                return s.ColorSpace || (s.ColorSpace = {});
              }
              get annotations() {
                const s = this.dictionary.data;
                return s.Annots != null ? s.Annots : s.Annots = [];
              }
              get structParentTreeKey() {
                const s = this.dictionary.data;
                return s.StructParents != null ? s.StructParents : s.StructParents = this.document.createStructParentTreeNextKey();
              }
              get contentWidth() {
                return this.width - this.margins.left - this.margins.right;
              }
              get contentHeight() {
                return this.height - this.margins.top - this.margins.bottom;
              }
              maxY() {
                return this.height - this.margins.bottom;
              }
              write(s) {
                return this.content.write(s);
              }
              _setTabOrder() {
                !this.dictionary.Tabs && this.document.hasMarkInfoDictionary() && (this.dictionary.data.Tabs = "S");
              }
              end() {
                this._setTabOrder(), this.dictionary.end(), this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
                for (let s of Object.values(this.document.spotColors))
                  this.resources.data.ColorSpace[s.id] = s;
                return this.resources.end(), this.content.end();
              }
            }
            class sA extends IA {
              _compareKeys(s, I) {
                return s.localeCompare(I);
              }
              _keysName() {
                return "Names";
              }
              _dataForKey(s) {
                return new String(s);
              }
            }
            function F(g) {
              return new Uint8Array(P.default.arrayBuffer(g));
            }
            function o(g) {
              return (0, P.default)(g);
            }
            function h(g) {
              return (0, D.sha256)(g);
            }
            function _(g, s, I) {
              let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
              return (0, J.cbc)(s, I, {
                disablePadding: !f
              }).encrypt(g);
            }
            function oA(g, s) {
              return (0, J.ecb)(s, {
                disablePadding: !0
              }).encrypt(g);
            }
            function p(g, s) {
              const I = new Uint8Array(256);
              for (let iA = 0; iA < 256; iA++)
                I[iA] = iA;
              let f = 0;
              for (let iA = 0; iA < 256; iA++)
                f = f + I[iA] + s[iA % s.length] & 255, [I[iA], I[f]] = [I[f], I[iA]];
              const S = new Uint8Array(g.length);
              for (let iA = 0, YA = 0, XA = 0; XA < g.length; XA++)
                iA = iA + 1 & 255, YA = YA + I[iA] & 255, [I[iA], I[YA]] = [I[YA], I[iA]], S[XA] = g[XA] ^ I[I[iA] + I[YA] & 255];
              return S;
            }
            function rA(g) {
              const s = new Uint8Array(g);
              return globalThis.crypto?.getRandomValues ? globalThis.crypto.getRandomValues(s) : r(5470).randomFillSync(s), s;
            }
            function QA(g, s) {
              if (g < s[0]) return !1;
              let I = 0, f = s.length / 2;
              for (; I <= f; ) {
                const S = Math.floor((I + f) / 2), iA = S * 2;
                if (g >= s[iA] && g <= s[iA + 1])
                  return !0;
                g > s[iA + 1] ? I = S + 1 : f = S - 1;
              }
              return !1;
            }
            const bA = [545, 545, 564, 591, 686, 687, 751, 767, 848, 863, 880, 883, 886, 889, 891, 893, 895, 899, 907, 907, 909, 909, 930, 930, 975, 975, 1015, 1023, 1159, 1159, 1231, 1231, 1270, 1271, 1274, 1279, 1296, 1328, 1367, 1368, 1376, 1376, 1416, 1416, 1419, 1424, 1442, 1442, 1466, 1466, 1477, 1487, 1515, 1519, 1525, 1547, 1549, 1562, 1564, 1566, 1568, 1568, 1595, 1599, 1622, 1631, 1774, 1775, 1791, 1791, 1806, 1806, 1837, 1839, 1867, 1919, 1970, 2304, 2308, 2308, 2362, 2363, 2382, 2383, 2389, 2391, 2417, 2432, 2436, 2436, 2445, 2446, 2449, 2450, 2473, 2473, 2481, 2481, 2483, 2485, 2490, 2491, 2493, 2493, 2501, 2502, 2505, 2506, 2510, 2518, 2520, 2523, 2526, 2526, 2532, 2533, 2555, 2561, 2563, 2564, 2571, 2574, 2577, 2578, 2601, 2601, 2609, 2609, 2612, 2612, 2615, 2615, 2618, 2619, 2621, 2621, 2627, 2630, 2633, 2634, 2638, 2648, 2653, 2653, 2655, 2661, 2677, 2688, 2692, 2692, 2700, 2700, 2702, 2702, 2706, 2706, 2729, 2729, 2737, 2737, 2740, 2740, 2746, 2747, 2758, 2758, 2762, 2762, 2766, 2767, 2769, 2783, 2785, 2789, 2800, 2816, 2820, 2820, 2829, 2830, 2833, 2834, 2857, 2857, 2865, 2865, 2868, 2869, 2874, 2875, 2884, 2886, 2889, 2890, 2894, 2901, 2904, 2907, 2910, 2910, 2914, 2917, 2929, 2945, 2948, 2948, 2955, 2957, 2961, 2961, 2966, 2968, 2971, 2971, 2973, 2973, 2976, 2978, 2981, 2983, 2987, 2989, 2998, 2998, 3002, 3005, 3011, 3013, 3017, 3017, 3022, 3030, 3032, 3046, 3059, 3072, 3076, 3076, 3085, 3085, 3089, 3089, 3113, 3113, 3124, 3124, 3130, 3133, 3141, 3141, 3145, 3145, 3150, 3156, 3159, 3167, 3170, 3173, 3184, 3201, 3204, 3204, 3213, 3213, 3217, 3217, 3241, 3241, 3252, 3252, 3258, 3261, 3269, 3269, 3273, 3273, 3278, 3284, 3287, 3293, 3295, 3295, 3298, 3301, 3312, 3329, 3332, 3332, 3341, 3341, 3345, 3345, 3369, 3369, 3386, 3389, 3396, 3397, 3401, 3401, 3406, 3414, 3416, 3423, 3426, 3429, 3440, 3457, 3460, 3460, 3479, 3481, 3506, 3506, 3516, 3516, 3518, 3519, 3527, 3529, 3531, 3534, 3541, 3541, 3543, 3543, 3552, 3569, 3573, 3584, 3643, 3646, 3676, 3712, 3715, 3715, 3717, 3718, 3721, 3721, 3723, 3724, 3726, 3731, 3736, 3736, 3744, 3744, 3748, 3748, 3750, 3750, 3752, 3753, 3756, 3756, 3770, 3770, 3774, 3775, 3781, 3781, 3783, 3783, 3790, 3791, 3802, 3803, 3806, 3839, 3912, 3912, 3947, 3952, 3980, 3983, 3992, 3992, 4029, 4029, 4045, 4046, 4048, 4095, 4130, 4130, 4136, 4136, 4139, 4139, 4147, 4149, 4154, 4159, 4186, 4255, 4294, 4303, 4345, 4346, 4348, 4351, 4442, 4446, 4515, 4519, 4602, 4607, 4615, 4615, 4679, 4679, 4681, 4681, 4686, 4687, 4695, 4695, 4697, 4697, 4702, 4703, 4743, 4743, 4745, 4745, 4750, 4751, 4783, 4783, 4785, 4785, 4790, 4791, 4799, 4799, 4801, 4801, 4806, 4807, 4815, 4815, 4823, 4823, 4847, 4847, 4879, 4879, 4881, 4881, 4886, 4887, 4895, 4895, 4935, 4935, 4955, 4960, 4989, 5023, 5109, 5120, 5751, 5759, 5789, 5791, 5873, 5887, 5901, 5901, 5909, 5919, 5943, 5951, 5972, 5983, 5997, 5997, 6001, 6001, 6004, 6015, 6109, 6111, 6122, 6143, 6159, 6159, 6170, 6175, 6264, 6271, 6314, 7679, 7836, 7839, 7930, 7935, 7958, 7959, 7966, 7967, 8006, 8007, 8014, 8015, 8024, 8024, 8026, 8026, 8028, 8028, 8030, 8030, 8062, 8063, 8117, 8117, 8133, 8133, 8148, 8149, 8156, 8156, 8176, 8177, 8181, 8181, 8191, 8191, 8275, 8278, 8280, 8286, 8292, 8297, 8306, 8307, 8335, 8351, 8370, 8399, 8427, 8447, 8507, 8508, 8524, 8530, 8580, 8591, 9167, 9215, 9255, 9279, 9291, 9311, 9471, 9471, 9748, 9749, 9752, 9752, 9854, 9855, 9866, 9984, 9989, 9989, 9994, 9995, 10024, 10024, 10060, 10060, 10062, 10062, 10067, 10069, 10071, 10071, 10079, 10080, 10133, 10135, 10160, 10160, 10175, 10191, 10220, 10223, 11008, 11903, 11930, 11930, 12020, 12031, 12246, 12271, 12284, 12287, 12352, 12352, 12439, 12440, 12544, 12548, 12589, 12592, 12687, 12687, 12728, 12783, 12829, 12831, 12868, 12880, 12924, 12926, 13004, 13007, 13055, 13055, 13175, 13178, 13278, 13279, 13311, 13311, 19894, 19967, 40870, 40959, 42125, 42127, 42183, 44031, 55204, 55295, 64046, 64047, 64107, 64255, 64263, 64274, 64280, 64284, 64311, 64311, 64317, 64317, 64319, 64319, 64322, 64322, 64325, 64325, 64434, 64466, 64832, 64847, 64912, 64913, 64968, 64975, 65021, 65023, 65040, 65055, 65060, 65071, 65095, 65096, 65107, 65107, 65127, 65127, 65132, 65135, 65141, 65141, 65277, 65278, 65280, 65280, 65471, 65473, 65480, 65481, 65488, 65489, 65496, 65497, 65501, 65503, 65511, 65511, 65519, 65528, 65536, 66303, 66335, 66335, 66340, 66351, 66379, 66559, 66598, 66599, 66638, 118783, 119030, 119039, 119079, 119081, 119262, 119807, 119893, 119893, 119965, 119965, 119968, 119969, 119971, 119972, 119975, 119976, 119981, 119981, 119994, 119994, 119996, 119996, 120001, 120001, 120004, 120004, 120070, 120070, 120075, 120076, 120085, 120085, 120093, 120093, 120122, 120122, 120127, 120127, 120133, 120133, 120135, 120137, 120145, 120145, 120484, 120487, 120778, 120781, 120832, 131069, 173783, 194559, 195102, 196605, 196608, 262141, 262144, 327677, 327680, 393213, 393216, 458749, 458752, 524285, 524288, 589821, 589824, 655357, 655360, 720893, 720896, 786429, 786432, 851965, 851968, 917501, 917504, 917504, 917506, 917535, 917632, 983037], y = (g) => QA(g, bA), M = [173, 173, 847, 847, 6150, 6150, 6155, 6155, 6156, 6156, 6157, 6157, 8203, 8203, 8204, 8204, 8205, 8205, 8288, 8288, 65024, 65024, 65025, 65025, 65026, 65026, 65027, 65027, 65028, 65028, 65029, 65029, 65030, 65030, 65031, 65031, 65032, 65032, 65033, 65033, 65034, 65034, 65035, 65035, 65036, 65036, 65037, 65037, 65038, 65038, 65039, 65039, 65279, 65279], FA = (g) => QA(g, M), dA = [160, 160, 5760, 5760, 8192, 8192, 8193, 8193, 8194, 8194, 8195, 8195, 8196, 8196, 8197, 8197, 8198, 8198, 8199, 8199, 8200, 8200, 8201, 8201, 8202, 8202, 8203, 8203, 8239, 8239, 8287, 8287, 12288, 12288], he = (g) => QA(g, dA), ie = [128, 159, 1757, 1757, 1807, 1807, 6158, 6158, 8204, 8204, 8205, 8205, 8232, 8232, 8233, 8233, 8288, 8288, 8289, 8289, 8290, 8290, 8291, 8291, 8298, 8303, 65279, 65279, 65529, 65532, 119155, 119162], KA = [64976, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1114110, 1114111], Pe = [0, 31, 127, 127, 832, 832, 833, 833, 8206, 8206, 8207, 8207, 8234, 8234, 8235, 8235, 8236, 8236, 8237, 8237, 8238, 8238, 8298, 8298, 8299, 8299, 8300, 8300, 8301, 8301, 8302, 8302, 8303, 8303, 12272, 12283, 55296, 57343, 57344, 63743, 65529, 65529, 65530, 65530, 65531, 65531, 65532, 65532, 65533, 65533, 917505, 917505, 917536, 917631, 983040, 1048573, 1048576, 1114109], Je = (g) => QA(g, dA) || QA(g, Pe) || QA(g, ie) || QA(g, KA), Le = [1470, 1470, 1472, 1472, 1475, 1475, 1488, 1514, 1520, 1524, 1563, 1563, 1567, 1567, 1569, 1594, 1600, 1610, 1645, 1647, 1649, 1749, 1757, 1757, 1765, 1766, 1786, 1790, 1792, 1805, 1808, 1808, 1810, 1836, 1920, 1957, 1969, 1969, 8207, 8207, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65020, 65136, 65140, 65142, 65276], Re = (g) => QA(g, Le), _e = [65, 90, 97, 122, 170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 544, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 1013, 1024, 1154, 1162, 1230, 1232, 1269, 1272, 1273, 1280, 1295, 1329, 1366, 1369, 1375, 1377, 1415, 1417, 1417, 2307, 2307, 2309, 2361, 2365, 2368, 2377, 2380, 2384, 2384, 2392, 2401, 2404, 2416, 2434, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2494, 2496, 2503, 2504, 2507, 2508, 2519, 2519, 2524, 2525, 2527, 2529, 2534, 2545, 2548, 2554, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2622, 2624, 2649, 2652, 2654, 2654, 2662, 2671, 2674, 2676, 2691, 2691, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2752, 2761, 2761, 2763, 2764, 2768, 2768, 2784, 2784, 2790, 2799, 2818, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2877, 2878, 2880, 2880, 2887, 2888, 2891, 2892, 2903, 2903, 2908, 2909, 2911, 2913, 2918, 2928, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3006, 3007, 3009, 3010, 3014, 3016, 3018, 3020, 3031, 3031, 3047, 3058, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3137, 3140, 3168, 3169, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3262, 3262, 3264, 3268, 3271, 3272, 3274, 3275, 3285, 3286, 3294, 3294, 3296, 3297, 3302, 3311, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3390, 3392, 3398, 3400, 3402, 3404, 3415, 3415, 3424, 3425, 3430, 3439, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3535, 3537, 3544, 3551, 3570, 3572, 3585, 3632, 3634, 3635, 3648, 3654, 3663, 3675, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3792, 3801, 3804, 3805, 3840, 3863, 3866, 3892, 3894, 3894, 3896, 3896, 3902, 3911, 3913, 3946, 3967, 3967, 3973, 3973, 3976, 3979, 4030, 4037, 4039, 4044, 4047, 4047, 4096, 4129, 4131, 4135, 4137, 4138, 4140, 4140, 4145, 4145, 4152, 4152, 4160, 4183, 4256, 4293, 4304, 4344, 4347, 4347, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 4961, 4988, 5024, 5108, 5121, 5750, 5761, 5786, 5792, 5872, 5888, 5900, 5902, 5905, 5920, 5937, 5941, 5942, 5952, 5969, 5984, 5996, 5998, 6e3, 6016, 6070, 6078, 6085, 6087, 6088, 6100, 6106, 6108, 6108, 6112, 6121, 6160, 6169, 6176, 6263, 6272, 6312, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8206, 8206, 8305, 8305, 8319, 8319, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8509, 8511, 8517, 8521, 8544, 8579, 9014, 9082, 9109, 9109, 9372, 9449, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12348, 12353, 12438, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12588, 12593, 12686, 12688, 12727, 12784, 12828, 12832, 12867, 12896, 12923, 12927, 12976, 12992, 13003, 13008, 13054, 13056, 13174, 13179, 13277, 13280, 13310, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 55296, 64045, 64048, 64106, 64256, 64262, 64275, 64279, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500, 66304, 66334, 66336, 66339, 66352, 66378, 66560, 66597, 66600, 66637, 118784, 119029, 119040, 119078, 119082, 119142, 119146, 119154, 119171, 119172, 119180, 119209, 119214, 119261, 119808, 119892, 119894, 119964, 119966, 119967, 119970, 119970, 119973, 119974, 119977, 119980, 119982, 119993, 119995, 119995, 119997, 12e4, 120002, 120003, 120005, 120069, 120071, 120074, 120077, 120084, 120086, 120092, 120094, 120121, 120123, 120126, 120128, 120132, 120134, 120134, 120138, 120144, 120146, 120483, 120488, 120777, 131072, 173782, 194560, 195101, 983040, 1048573, 1048576, 1114109], se = (g) => QA(g, _e), Ee = he, wA = FA, N = (g) => g.codePointAt(0), G = (g) => g[0], W = (g) => g[g.length - 1];
            function aA(g) {
              const s = [], I = g.length;
              for (let f = 0; f < I; f += 1) {
                const S = g.charCodeAt(f);
                if (S >= 55296 && S <= 56319 && I > f + 1) {
                  const iA = g.charCodeAt(f + 1);
                  if (iA >= 56320 && iA <= 57343) {
                    s.push((S - 55296) * 1024 + iA - 56320 + 65536), f += 1;
                    continue;
                  }
                }
                s.push(S);
              }
              return s;
            }
            function j(g) {
              let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              if (typeof g != "string")
                throw new TypeError("Expected string.");
              if (g.length === 0)
                return "";
              const I = aA(g).map((xe) => Ee(xe) ? 32 : xe).filter((xe) => !wA(xe)), f = String.fromCodePoint.apply(null, I).normalize("NFKC"), S = aA(f);
              if (S.some(Je))
                throw new Error("Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3");
              if (s.allowUnassigned !== !0 && S.some(y))
                throw new Error("Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5");
              const YA = S.some(Re), XA = S.some(se);
              if (YA && XA)
                throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
              const oe = Re(N(G(f))), pe = Re(N(W(f)));
              if (YA && !(oe && pe))
                throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
              return f;
            }
            class pA {
              static generateFileID() {
                let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, I = `${s.CreationDate.getTime()}
`;
                for (let f in s)
                  s.hasOwnProperty(f) && (I += `${f}: ${s[f].valueOf()}
`);
                return a.from(F(I));
              }
              static generateRandomWordArray(s) {
                return rA(s);
              }
              static create(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return !I.ownerPassword && !I.userPassword ? null : new pA(s, I);
              }
              constructor(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!I.ownerPassword && !I.userPassword)
                  throw new Error("None of owner password and user password is defined.");
                this.document = s, this._setupEncryption(I);
              }
              _setupEncryption(s) {
                switch (s.pdfVersion) {
                  case "1.4":
                  case "1.5":
                    this.version = 2;
                    break;
                  case "1.6":
                  case "1.7":
                    this.version = 4;
                    break;
                  case "1.7ext3":
                    this.version = 5;
                    break;
                  default:
                    this.version = 1;
                    break;
                }
                const I = {
                  Filter: "Standard"
                };
                switch (this.version) {
                  case 1:
                  case 2:
                  case 4:
                    this._setupEncryptionV1V2V4(this.version, I, s);
                    break;
                  case 5:
                    this._setupEncryptionV5(I, s);
                    break;
                }
                this.dictionary = this.document.ref(I);
              }
              _setupEncryptionV1V2V4(s, I, f) {
                let S, iA;
                switch (s) {
                  case 1:
                    S = 2, this.keyBits = 40, iA = Be(f.permissions);
                    break;
                  case 2:
                    S = 3, this.keyBits = 128, iA = Ie(f.permissions);
                    break;
                  case 4:
                    S = 4, this.keyBits = 128, iA = Ie(f.permissions);
                    break;
                }
                const YA = Fe(f.userPassword), XA = f.ownerPassword ? Fe(f.ownerPassword) : YA, oe = MA(S, this.keyBits, YA, XA);
                this.encryptionKey = be(S, this.keyBits, this.document._id, YA, oe, iA);
                let pe;
                S === 2 ? pe = ee(this.encryptionKey) : pe = Me(this.document._id, this.encryptionKey), I.V = s, s >= 2 && (I.Length = this.keyBits), s === 4 && (I.CF = {
                  StdCF: {
                    AuthEvent: "DocOpen",
                    CFM: "AESV2",
                    Length: this.keyBits / 8
                  }
                }, I.StmF = "StdCF", I.StrF = "StdCF"), I.R = S, I.O = a.from(oe), I.U = a.from(pe), I.P = iA;
              }
              _setupEncryptionV5(s, I) {
                this.keyBits = 256;
                const f = Ie(I.permissions), S = tt(I.userPassword), iA = I.ownerPassword ? tt(I.ownerPassword) : S;
                this.encryptionKey = SA(pA.generateRandomWordArray);
                const YA = at(S, pA.generateRandomWordArray), XA = YA.slice(40, 48), oe = V(S, XA, this.encryptionKey), pe = me(iA, YA, pA.generateRandomWordArray), xe = pe.slice(40, 48), Qe = Ye(iA, xe, YA, this.encryptionKey), ke = ue(f, this.encryptionKey, pA.generateRandomWordArray);
                s.V = 5, s.Length = this.keyBits, s.CF = {
                  StdCF: {
                    AuthEvent: "DocOpen",
                    CFM: "AESV3",
                    Length: this.keyBits / 8
                  }
                }, s.StmF = "StdCF", s.StrF = "StdCF", s.R = 5, s.O = a.from(pe), s.OE = a.from(Qe), s.U = a.from(YA), s.UE = a.from(oe), s.P = f, s.Perms = a.from(ke);
              }
              getEncryptFn(s, I) {
                let f;
                if (this.version < 5) {
                  const YA = new Uint8Array([s & 255, s >> 8 & 255, s >> 16 & 255, I & 255, I >> 8 & 255]);
                  f = (0, U.concatBytes)(this.encryptionKey, YA);
                }
                if (this.version === 1 || this.version === 2) {
                  let YA = F(f);
                  const XA = Math.min(16, this.keyBits / 8 + 5);
                  return YA = YA.slice(0, XA), (oe) => a.from(p(new Uint8Array(oe), YA));
                }
                let S;
                if (this.version === 4) {
                  const YA = new Uint8Array([115, 65, 108, 84]);
                  S = F((0, U.concatBytes)(f, YA));
                } else
                  S = this.encryptionKey;
                const iA = pA.generateRandomWordArray(16);
                return (YA) => {
                  const XA = _(new Uint8Array(YA), S, iA, !0);
                  return a.from((0, U.concatBytes)(iA, XA));
                };
              }
              end() {
                this.dictionary.end();
              }
            }
            function Be() {
              let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = -64;
              return g.printing && (s |= 4), g.modifying && (s |= 8), g.copying && (s |= 16), g.annotating && (s |= 32), s;
            }
            function Ie() {
              let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = -3904;
              return g.printing === "lowResolution" && (s |= 4), g.printing === "highResolution" && (s |= 2052), g.modifying && (s |= 8), g.copying && (s |= 16), g.annotating && (s |= 32), g.fillingForms && (s |= 256), g.contentAccessibility && (s |= 512), g.documentAssembly && (s |= 1024), s;
            }
            function ee(g) {
              return p(Fe(), g);
            }
            function Me(g, s) {
              const I = s.slice();
              let f = F((0, U.concatBytes)(Fe(), new Uint8Array(g)));
              for (let iA = 0; iA < 20; iA++) {
                const YA = new Uint8Array(I.length);
                for (let XA = 0; XA < I.length; XA++)
                  YA[XA] = s[XA] ^ iA;
                f = p(f, YA);
              }
              const S = new Uint8Array(32);
              return S.set(f), S;
            }
            function MA(g, s, I, f) {
              let S = f, iA = g >= 3 ? 51 : 1;
              for (let pe = 0; pe < iA; pe++)
                S = F(S);
              const YA = s / 8;
              let XA = S.slice(0, YA), oe = I;
              iA = g >= 3 ? 20 : 1;
              for (let pe = 0; pe < iA; pe++) {
                const xe = new Uint8Array(YA);
                for (let Qe = 0; Qe < YA; Qe++)
                  xe[Qe] = XA[Qe] ^ pe;
                oe = p(oe, xe);
              }
              return oe;
            }
            function be(g, s, I, f, S, iA) {
              const YA = new Uint8Array([iA & 255, iA >> 8 & 255, iA >> 16 & 255, iA >> 24 & 255]);
              let XA = (0, U.concatBytes)(f, S, YA, new Uint8Array(I));
              const oe = g >= 3 ? 51 : 1, pe = s / 8;
              for (let xe = 0; xe < oe; xe++)
                XA = F(XA), XA = XA.slice(0, pe);
              return XA;
            }
            function at(g, s) {
              const I = s(8), f = s(8), S = h((0, U.concatBytes)(g, I));
              return (0, U.concatBytes)(S, I, f);
            }
            function V(g, s, I) {
              const f = h((0, U.concatBytes)(g, s)), S = new Uint8Array(16);
              return _(I, f, S, !1);
            }
            function me(g, s, I) {
              const f = I(8), S = I(8), iA = h((0, U.concatBytes)(g, f, s));
              return (0, U.concatBytes)(iA, f, S);
            }
            function Ye(g, s, I, f) {
              const S = h((0, U.concatBytes)(g, s, I)), iA = new Uint8Array(16);
              return _(f, S, iA, !1);
            }
            function SA(g) {
              return g(32);
            }
            function ue(g, s, I) {
              const f = new Uint8Array(16);
              f[0] = g & 255, f[1] = g >> 8 & 255, f[2] = g >> 16 & 255, f[3] = g >> 24 & 255, f[4] = 255, f[5] = 255, f[6] = 255, f[7] = 255, f[8] = 84, f[9] = 97, f[10] = 100, f[11] = 98;
              const S = I(4);
              return f.set(S, 12), oA(f, s);
            }
            function Fe() {
              let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
              const s = new Uint8Array(32), I = g.length;
              let f = 0;
              for (; f < I && f < 32; ) {
                const S = g.charCodeAt(f);
                if (S > 255)
                  throw new Error("Password contains one or more invalid characters.");
                s[f] = S, f++;
              }
              for (; f < 32; )
                s[f] = We[f - I], f++;
              return s;
            }
            function tt() {
              let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
              g = unescape(encodeURIComponent(j(g)));
              const s = Math.min(127, g.length), I = new Uint8Array(s);
              for (let f = 0; f < s; f++)
                I[f] = g.charCodeAt(f);
              return I;
            }
            const We = [40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122], {
              number: Ze
            } = v;
            class Ct {
              constructor(s) {
                this.doc = s, this.stops = [], this.embedded = !1, this.transform = [1, 0, 0, 1, 0, 0];
              }
              stop(s, I, f) {
                if (f == null && (f = 1), I = this.doc._normalizeColor(I), this.stops.length === 0)
                  if (I.length === 3)
                    this._colorSpace = "DeviceRGB";
                  else if (I.length === 4)
                    this._colorSpace = "DeviceCMYK";
                  else if (I.length === 1)
                    this._colorSpace = "DeviceGray";
                  else
                    throw new Error("Unknown color space");
                else if (this._colorSpace === "DeviceRGB" && I.length !== 3 || this._colorSpace === "DeviceCMYK" && I.length !== 4 || this._colorSpace === "DeviceGray" && I.length !== 1)
                  throw new Error("All gradient stops must use the same color space");
                return f = Math.max(0, Math.min(1, f)), this.stops.push([s, I, f]), this;
              }
              setTransform(s, I, f, S, iA, YA) {
                return this.transform = [s, I, f, S, iA, YA], this;
              }
              embed(s) {
                let I;
                const f = this.stops.length;
                if (f === 0)
                  return;
                this.embedded = !0, this.matrix = s;
                const S = this.stops[f - 1];
                S[0] < 1 && this.stops.push([1, S[1], S[2]]);
                const iA = [], YA = [], XA = [];
                for (let xe = 0; xe < f - 1; xe++)
                  YA.push(0, 1), xe + 2 !== f && iA.push(this.stops[xe + 1][0]), I = this.doc.ref({
                    FunctionType: 2,
                    Domain: [0, 1],
                    C0: this.stops[xe + 0][1],
                    C1: this.stops[xe + 1][1],
                    N: 1
                  }), XA.push(I), I.end();
                f === 1 ? I = XA[0] : (I = this.doc.ref({
                  FunctionType: 3,
                  Domain: [0, 1],
                  Functions: XA,
                  Bounds: iA,
                  Encode: YA
                }), I.end()), this.id = `Sh${++this.doc._gradCount}`;
                const oe = this.shader(I);
                oe.end();
                const pe = this.doc.ref({
                  Type: "Pattern",
                  PatternType: 2,
                  Shading: oe,
                  Matrix: this.matrix.map(Ze)
                });
                if (pe.end(), this.stops.some((xe) => xe[2] < 1)) {
                  let xe = this.opacityGradient();
                  xe._colorSpace = "DeviceGray";
                  for (let et of this.stops)
                    xe.stop(et[0], [et[2]]);
                  xe = xe.embed(this.matrix);
                  const Qe = [0, 0, this.doc.page.width, this.doc.page.height], ke = this.doc.ref({
                    Type: "XObject",
                    Subtype: "Form",
                    FormType: 1,
                    BBox: Qe,
                    Group: {
                      Type: "Group",
                      S: "Transparency",
                      CS: "DeviceGray"
                    },
                    Resources: {
                      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                      Pattern: {
                        Sh1: xe
                      }
                    }
                  });
                  ke.write("/Pattern cs /Sh1 scn"), ke.end(`${Qe.join(" ")} re f`);
                  const lt = this.doc.ref({
                    Type: "ExtGState",
                    SMask: {
                      Type: "Mask",
                      S: "Luminosity",
                      G: ke
                    }
                  });
                  lt.end();
                  const Xe = this.doc.ref({
                    Type: "Pattern",
                    PatternType: 1,
                    PaintType: 1,
                    TilingType: 2,
                    BBox: Qe,
                    XStep: Qe[2],
                    YStep: Qe[3],
                    Resources: {
                      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                      Pattern: {
                        Sh1: pe
                      },
                      ExtGState: {
                        Gs1: lt
                      }
                    }
                  });
                  Xe.write("/Gs1 gs /Pattern cs /Sh1 scn"), Xe.end(`${Qe.join(" ")} re f`), this.doc.page.patterns[this.id] = Xe;
                } else
                  this.doc.page.patterns[this.id] = pe;
                return pe;
              }
              apply(s) {
                const [I, f, S, iA, YA, XA] = this.doc._ctm, [oe, pe, xe, Qe, ke, lt] = this.transform, Xe = [I * oe + S * pe, f * oe + iA * pe, I * xe + S * Qe, f * xe + iA * Qe, I * ke + S * lt + YA, f * ke + iA * lt + XA];
                (!this.embedded || Xe.join(" ") !== this.matrix.join(" ")) && this.embed(Xe), this.doc._setColorSpace("Pattern", s);
                const et = s ? "SCN" : "scn";
                return this.doc.addContent(`/${this.id} ${et}`);
              }
            }
            class fi extends Ct {
              constructor(s, I, f, S, iA) {
                super(s), this.x1 = I, this.y1 = f, this.x2 = S, this.y2 = iA;
              }
              shader(s) {
                return this.doc.ref({
                  ShadingType: 2,
                  ColorSpace: this._colorSpace,
                  Coords: [this.x1, this.y1, this.x2, this.y2],
                  Function: s,
                  Extend: [!0, !0]
                });
              }
              opacityGradient() {
                return new fi(this.doc, this.x1, this.y1, this.x2, this.y2);
              }
            }
            class st extends Ct {
              constructor(s, I, f, S, iA, YA, XA) {
                super(s), this.doc = s, this.x1 = I, this.y1 = f, this.r1 = S, this.x2 = iA, this.y2 = YA, this.r2 = XA;
              }
              shader(s) {
                return this.doc.ref({
                  ShadingType: 3,
                  ColorSpace: this._colorSpace,
                  Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
                  Function: s,
                  Extend: [!0, !0]
                });
              }
              opacityGradient() {
                return new st(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
              }
            }
            var xt = {
              PDFGradient: Ct,
              PDFLinearGradient: fi,
              PDFRadialGradient: st
            };
            const Mt = ["DeviceCMYK", "DeviceRGB"];
            class zt {
              constructor(s, I, f, S, iA) {
                this.doc = s, this.bBox = I, this.xStep = f, this.yStep = S, this.stream = iA;
              }
              createPattern() {
                const s = this.doc.ref();
                s.end();
                const [I, f, S, iA, YA, XA] = this.doc._ctm, [oe, pe, xe, Qe, ke, lt] = [1, 0, 0, 1, 0, 0], Xe = [I * oe + S * pe, f * oe + iA * pe, I * xe + S * Qe, f * xe + iA * Qe, I * ke + S * lt + YA, f * ke + iA * lt + XA], et = this.doc.ref({
                  Type: "Pattern",
                  PatternType: 1,
                  PaintType: 2,
                  TilingType: 2,
                  BBox: this.bBox,
                  XStep: this.xStep,
                  YStep: this.yStep,
                  Matrix: Xe.map((Oe) => +Oe.toFixed(5)),
                  Resources: s
                });
                return et.end(this.stream), et;
              }
              embedPatternColorSpaces() {
                Mt.forEach((s) => {
                  const I = this.getPatternColorSpaceId(s);
                  if (this.doc.page.colorSpaces[I]) return;
                  const f = this.doc.ref(["Pattern", s]);
                  f.end(), this.doc.page.colorSpaces[I] = f;
                });
              }
              getPatternColorSpaceId(s) {
                return `CsP${s}`;
              }
              embed() {
                this.id || (this.doc._patternCount = this.doc._patternCount + 1, this.id = "P" + this.doc._patternCount, this.pattern = this.createPattern()), this.doc.page.patterns[this.id] || (this.doc.page.patterns[this.id] = this.pattern);
              }
              apply(s, I) {
                this.embedPatternColorSpaces(), this.embed();
                const f = this.doc._normalizeColor(I);
                if (!f) throw Error(`invalid pattern color. (value: ${I})`);
                const S = this.getPatternColorSpaceId(this.doc._getColorSpace(f));
                this.doc._setColorSpace(S, s);
                const iA = s ? "SCN" : "scn";
                return this.doc.addContent(`${f.join(" ")} /${this.id} ${iA}`);
              }
            }
            var Xt = {
              PDFTilingPattern: zt
            };
            const {
              PDFGradient: xi,
              PDFLinearGradient: mi,
              PDFRadialGradient: Ot
            } = xt, {
              PDFTilingPattern: vt
            } = Xt;
            var Zt = {
              initColor() {
                this.spotColors = {}, this._opacityRegistry = {}, this._opacityCount = 0, this._patternCount = 0, this._gradCount = 0;
              },
              _normalizeColor(g) {
                if (typeof g == "string") {
                  if (g.charAt(0) === "#") {
                    g.length === 4 && (g = g.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
                    const s = parseInt(g.slice(1), 16);
                    g = [s >> 16, s >> 8 & 255, s & 255];
                  } else if (ei[g])
                    g = ei[g];
                  else if (this.spotColors[g])
                    return this.spotColors[g];
                }
                return Array.isArray(g) ? (g.length === 3 ? g = g.map((s) => s / 255) : g.length === 4 && (g = g.map((s) => s / 100)), g) : null;
              },
              _setColor(g, s) {
                return g instanceof xi ? (g.apply(s), !0) : Array.isArray(g) && g[0] instanceof vt ? (g[0].apply(s, g[1]), !0) : this._setColorCore(g, s);
              },
              _setColorCore(g, s) {
                if (g = this._normalizeColor(g), !g)
                  return !1;
                const I = s ? "SCN" : "scn", f = this._getColorSpace(g);
                return this._setColorSpace(f, s), g instanceof k ? (this.page.colorSpaces[g.id] = g.ref, this.addContent(`1 ${I}`)) : this.addContent(`${g.join(" ")} ${I}`), !0;
              },
              _setColorSpace(g, s) {
                const I = s ? "CS" : "cs";
                return this.addContent(`/${g} ${I}`);
              },
              _getColorSpace(g) {
                return g instanceof k ? g.id : g.length === 4 ? "DeviceCMYK" : "DeviceRGB";
              },
              fillColor(g, s) {
                return this._setColor(g, !1) && this.fillOpacity(s), this._fillColor = [g, s], this;
              },
              strokeColor(g, s) {
                return this._setColor(g, !0) && this.strokeOpacity(s), this;
              },
              opacity(g) {
                return this._doOpacity(g, g), this;
              },
              fillOpacity(g) {
                return this._doOpacity(g, null), this;
              },
              strokeOpacity(g) {
                return this._doOpacity(null, g), this;
              },
              _doOpacity(g, s) {
                let I, f;
                if (g == null && s == null)
                  return;
                g != null && (g = Math.max(0, Math.min(1, g))), s != null && (s = Math.max(0, Math.min(1, s)));
                const S = `${g}_${s}`;
                return this._opacityRegistry[S] ? [I, f] = this._opacityRegistry[S] : (I = {
                  Type: "ExtGState"
                }, g != null && (I.ca = g), s != null && (I.CA = s), I = this.ref(I), I.end(), f = `Gs${++this._opacityCount}`, this._opacityRegistry[S] = [I, f]), this.page.ext_gstates[f] = I, this.addContent(`/${f} gs`);
              },
              linearGradient(g, s, I, f) {
                return new mi(this, g, s, I, f);
              },
              radialGradient(g, s, I, f, S, iA) {
                return new Ot(this, g, s, I, f, S, iA);
              },
              pattern(g, s, I, f) {
                return new vt(this, g, s, I, f);
              },
              addSpotColor(g, s, I, f, S) {
                const iA = new k(this, g, s, I, f, S);
                return this.spotColors[g] = iA, this;
              }
            }, ei = {
              aliceblue: [240, 248, 255],
              antiquewhite: [250, 235, 215],
              aqua: [0, 255, 255],
              aquamarine: [127, 255, 212],
              azure: [240, 255, 255],
              beige: [245, 245, 220],
              bisque: [255, 228, 196],
              black: [0, 0, 0],
              blanchedalmond: [255, 235, 205],
              blue: [0, 0, 255],
              blueviolet: [138, 43, 226],
              brown: [165, 42, 42],
              burlywood: [222, 184, 135],
              cadetblue: [95, 158, 160],
              chartreuse: [127, 255, 0],
              chocolate: [210, 105, 30],
              coral: [255, 127, 80],
              cornflowerblue: [100, 149, 237],
              cornsilk: [255, 248, 220],
              crimson: [220, 20, 60],
              cyan: [0, 255, 255],
              darkblue: [0, 0, 139],
              darkcyan: [0, 139, 139],
              darkgoldenrod: [184, 134, 11],
              darkgray: [169, 169, 169],
              darkgreen: [0, 100, 0],
              darkgrey: [169, 169, 169],
              darkkhaki: [189, 183, 107],
              darkmagenta: [139, 0, 139],
              darkolivegreen: [85, 107, 47],
              darkorange: [255, 140, 0],
              darkorchid: [153, 50, 204],
              darkred: [139, 0, 0],
              darksalmon: [233, 150, 122],
              darkseagreen: [143, 188, 143],
              darkslateblue: [72, 61, 139],
              darkslategray: [47, 79, 79],
              darkslategrey: [47, 79, 79],
              darkturquoise: [0, 206, 209],
              darkviolet: [148, 0, 211],
              deeppink: [255, 20, 147],
              deepskyblue: [0, 191, 255],
              dimgray: [105, 105, 105],
              dimgrey: [105, 105, 105],
              dodgerblue: [30, 144, 255],
              firebrick: [178, 34, 34],
              floralwhite: [255, 250, 240],
              forestgreen: [34, 139, 34],
              fuchsia: [255, 0, 255],
              gainsboro: [220, 220, 220],
              ghostwhite: [248, 248, 255],
              gold: [255, 215, 0],
              goldenrod: [218, 165, 32],
              gray: [128, 128, 128],
              grey: [128, 128, 128],
              green: [0, 128, 0],
              greenyellow: [173, 255, 47],
              honeydew: [240, 255, 240],
              hotpink: [255, 105, 180],
              indianred: [205, 92, 92],
              indigo: [75, 0, 130],
              ivory: [255, 255, 240],
              khaki: [240, 230, 140],
              lavender: [230, 230, 250],
              lavenderblush: [255, 240, 245],
              lawngreen: [124, 252, 0],
              lemonchiffon: [255, 250, 205],
              lightblue: [173, 216, 230],
              lightcoral: [240, 128, 128],
              lightcyan: [224, 255, 255],
              lightgoldenrodyellow: [250, 250, 210],
              lightgray: [211, 211, 211],
              lightgreen: [144, 238, 144],
              lightgrey: [211, 211, 211],
              lightpink: [255, 182, 193],
              lightsalmon: [255, 160, 122],
              lightseagreen: [32, 178, 170],
              lightskyblue: [135, 206, 250],
              lightslategray: [119, 136, 153],
              lightslategrey: [119, 136, 153],
              lightsteelblue: [176, 196, 222],
              lightyellow: [255, 255, 224],
              lime: [0, 255, 0],
              limegreen: [50, 205, 50],
              linen: [250, 240, 230],
              magenta: [255, 0, 255],
              maroon: [128, 0, 0],
              mediumaquamarine: [102, 205, 170],
              mediumblue: [0, 0, 205],
              mediumorchid: [186, 85, 211],
              mediumpurple: [147, 112, 219],
              mediumseagreen: [60, 179, 113],
              mediumslateblue: [123, 104, 238],
              mediumspringgreen: [0, 250, 154],
              mediumturquoise: [72, 209, 204],
              mediumvioletred: [199, 21, 133],
              midnightblue: [25, 25, 112],
              mintcream: [245, 255, 250],
              mistyrose: [255, 228, 225],
              moccasin: [255, 228, 181],
              navajowhite: [255, 222, 173],
              navy: [0, 0, 128],
              oldlace: [253, 245, 230],
              olive: [128, 128, 0],
              olivedrab: [107, 142, 35],
              orange: [255, 165, 0],
              orangered: [255, 69, 0],
              orchid: [218, 112, 214],
              palegoldenrod: [238, 232, 170],
              palegreen: [152, 251, 152],
              paleturquoise: [175, 238, 238],
              palevioletred: [219, 112, 147],
              papayawhip: [255, 239, 213],
              peachpuff: [255, 218, 185],
              peru: [205, 133, 63],
              pink: [255, 192, 203],
              plum: [221, 160, 221],
              powderblue: [176, 224, 230],
              purple: [128, 0, 128],
              red: [255, 0, 0],
              rosybrown: [188, 143, 143],
              royalblue: [65, 105, 225],
              saddlebrown: [139, 69, 19],
              salmon: [250, 128, 114],
              sandybrown: [244, 164, 96],
              seagreen: [46, 139, 87],
              seashell: [255, 245, 238],
              sienna: [160, 82, 45],
              silver: [192, 192, 192],
              skyblue: [135, 206, 235],
              slateblue: [106, 90, 205],
              slategray: [112, 128, 144],
              slategrey: [112, 128, 144],
              snow: [255, 250, 250],
              springgreen: [0, 255, 127],
              steelblue: [70, 130, 180],
              tan: [210, 180, 140],
              teal: [0, 128, 128],
              thistle: [216, 191, 216],
              tomato: [255, 99, 71],
              turquoise: [64, 224, 208],
              violet: [238, 130, 238],
              wheat: [245, 222, 179],
              white: [255, 255, 255],
              whitesmoke: [245, 245, 245],
              yellow: [255, 255, 0],
              yellowgreen: [154, 205, 50]
            };
            let Ke, qe, Dt, ut, ni, wi;
            Ke = qe = Dt = ut = ni = wi = 0;
            const Yi = {
              A: 7,
              a: 7,
              C: 6,
              c: 6,
              H: 1,
              h: 1,
              L: 2,
              l: 2,
              M: 2,
              m: 2,
              Q: 4,
              q: 4,
              S: 4,
              s: 4,
              T: 2,
              t: 2,
              V: 1,
              v: 1,
              Z: 0,
              z: 0
            }, vA = function(g) {
              return g in Yi;
            }, UA = function(g) {
              const s = g.codePointAt(0);
              return s === 32 || s === 9 || s === 13 || s === 10;
            }, mA = function(g) {
              const s = g.codePointAt(0);
              return s == null ? !1 : 48 <= s && s <= 57;
            }, qA = function(g, s) {
              let I = s, f = "", S = "none";
              for (; I < g.length; I += 1) {
                const YA = g[I];
                if (YA === "+" || YA === "-") {
                  if (S === "none") {
                    S = "sign", f += YA;
                    continue;
                  }
                  if (S === "e") {
                    S = "exponent_sign", f += YA;
                    continue;
                  }
                }
                if (mA(YA)) {
                  if (S === "none" || S === "sign" || S === "whole") {
                    S = "whole", f += YA;
                    continue;
                  }
                  if (S === "decimal_point" || S === "decimal") {
                    S = "decimal", f += YA;
                    continue;
                  }
                  if (S === "e" || S === "exponent_sign" || S === "exponent") {
                    S = "exponent", f += YA;
                    continue;
                  }
                }
                if (YA === "." && (S === "none" || S === "sign" || S === "whole")) {
                  S = "decimal_point", f += YA;
                  continue;
                }
                if ((YA === "E" || YA === "e") && (S === "whole" || S === "decimal_point" || S === "decimal")) {
                  S = "e", f += YA;
                  continue;
                }
                break;
              }
              const iA = Number.parseFloat(f);
              return Number.isNaN(iA) ? [s, null] : [I - 1, iA];
            }, _A = function(g) {
              const s = [];
              let I = null, f = [], S = 0, iA = !1, YA = !1;
              for (let XA = 0; XA < g.length; XA += 1) {
                const oe = g.charAt(XA);
                if (UA(oe))
                  continue;
                if (iA && oe === ",") {
                  if (YA)
                    break;
                  YA = !0;
                  continue;
                }
                if (vA(oe)) {
                  if (YA)
                    return s;
                  if (I == null) {
                    if (oe !== "M" && oe !== "m")
                      return s;
                  } else if (f.length !== 0)
                    return s;
                  I = oe, f = [], S = Yi[I], iA = !1, S === 0 && s.push({
                    command: I,
                    args: f
                  });
                  continue;
                }
                if (I == null)
                  return s;
                let pe = XA, xe = null;
                if (I === "A" || I === "a") {
                  const Qe = f.length;
                  (Qe === 0 || Qe === 1) && oe !== "+" && oe !== "-" && ([pe, xe] = qA(g, XA)), (Qe === 2 || Qe === 5 || Qe === 6) && ([pe, xe] = qA(g, XA)), (Qe === 3 || Qe === 4) && (oe === "0" && (xe = 0), oe === "1" && (xe = 1));
                } else
                  [pe, xe] = qA(g, XA);
                if (xe == null)
                  return s;
                f.push(xe), iA = !0, YA = !1, XA = pe, f.length === S && (s.push({
                  command: I,
                  args: f
                }), I === "M" && (I = "L"), I === "m" && (I = "l"), f = []);
              }
              return s;
            }, jA = function(g, s) {
              Ke = qe = Dt = ut = ni = wi = 0;
              for (let I = 0; I < g.length; I++) {
                const f = g[I];
                typeof le[f.command] == "function" && le[f.command](s, f.args);
              }
            }, le = {
              M(g, s) {
                return Ke = s[0], qe = s[1], Dt = ut = null, ni = Ke, wi = qe, g.moveTo(Ke, qe);
              },
              m(g, s) {
                return Ke += s[0], qe += s[1], Dt = ut = null, ni = Ke, wi = qe, g.moveTo(Ke, qe);
              },
              C(g, s) {
                return Ke = s[4], qe = s[5], Dt = s[2], ut = s[3], g.bezierCurveTo(...s);
              },
              c(g, s) {
                return g.bezierCurveTo(s[0] + Ke, s[1] + qe, s[2] + Ke, s[3] + qe, s[4] + Ke, s[5] + qe), Dt = Ke + s[2], ut = qe + s[3], Ke += s[4], qe += s[5];
              },
              S(g, s) {
                return Dt === null && (Dt = Ke, ut = qe), g.bezierCurveTo(Ke - (Dt - Ke), qe - (ut - qe), s[0], s[1], s[2], s[3]), Dt = s[0], ut = s[1], Ke = s[2], qe = s[3];
              },
              s(g, s) {
                return Dt === null && (Dt = Ke, ut = qe), g.bezierCurveTo(Ke - (Dt - Ke), qe - (ut - qe), Ke + s[0], qe + s[1], Ke + s[2], qe + s[3]), Dt = Ke + s[0], ut = qe + s[1], Ke += s[2], qe += s[3];
              },
              Q(g, s) {
                return Dt = s[0], ut = s[1], Ke = s[2], qe = s[3], g.quadraticCurveTo(s[0], s[1], Ke, qe);
              },
              q(g, s) {
                return g.quadraticCurveTo(s[0] + Ke, s[1] + qe, s[2] + Ke, s[3] + qe), Dt = Ke + s[0], ut = qe + s[1], Ke += s[2], qe += s[3];
              },
              T(g, s) {
                return Dt === null ? (Dt = Ke, ut = qe) : (Dt = Ke - (Dt - Ke), ut = qe - (ut - qe)), g.quadraticCurveTo(Dt, ut, s[0], s[1]), Dt = Ke - (Dt - Ke), ut = qe - (ut - qe), Ke = s[0], qe = s[1];
              },
              t(g, s) {
                return Dt === null ? (Dt = Ke, ut = qe) : (Dt = Ke - (Dt - Ke), ut = qe - (ut - qe)), g.quadraticCurveTo(Dt, ut, Ke + s[0], qe + s[1]), Ke += s[0], qe += s[1];
              },
              A(g, s) {
                return JA(g, Ke, qe, s), Ke = s[5], qe = s[6];
              },
              a(g, s) {
                return s[5] += Ke, s[6] += qe, JA(g, Ke, qe, s), Ke = s[5], qe = s[6];
              },
              L(g, s) {
                return Ke = s[0], qe = s[1], Dt = ut = null, g.lineTo(Ke, qe);
              },
              l(g, s) {
                return Ke += s[0], qe += s[1], Dt = ut = null, g.lineTo(Ke, qe);
              },
              H(g, s) {
                return Ke = s[0], Dt = ut = null, g.lineTo(Ke, qe);
              },
              h(g, s) {
                return Ke += s[0], Dt = ut = null, g.lineTo(Ke, qe);
              },
              V(g, s) {
                return qe = s[0], Dt = ut = null, g.lineTo(Ke, qe);
              },
              v(g, s) {
                return qe += s[0], Dt = ut = null, g.lineTo(Ke, qe);
              },
              Z(g) {
                return g.closePath(), Ke = ni, qe = wi;
              },
              z(g) {
                return g.closePath(), Ke = ni, qe = wi;
              }
            }, JA = function(g, s, I, f) {
              const [S, iA, YA, XA, oe, pe, xe] = f, Qe = ne(pe, xe, S, iA, XA, oe, YA, s, I);
              for (let ke of Qe) {
                const lt = ae(...ke);
                g.bezierCurveTo(...lt);
              }
            }, ne = function(g, s, I, f, S, iA, YA, XA, oe) {
              const pe = YA * (Math.PI / 180), xe = Math.sin(pe), Qe = Math.cos(pe);
              I = Math.abs(I), f = Math.abs(f), Dt = Qe * (XA - g) * 0.5 + xe * (oe - s) * 0.5, ut = Qe * (oe - s) * 0.5 - xe * (XA - g) * 0.5;
              let ke = Dt * Dt / (I * I) + ut * ut / (f * f);
              ke > 1 && (ke = Math.sqrt(ke), I *= ke, f *= ke);
              const lt = Qe / I, Xe = xe / I, et = -xe / f, Oe = Qe / f, rt = lt * XA + Xe * oe, $e = et * XA + Oe * oe, wt = lt * g + Xe * s, Wt = et * g + Oe * s;
              let Gt = 1 / ((wt - rt) * (wt - rt) + (Wt - $e) * (Wt - $e)) - 0.25;
              Gt < 0 && (Gt = 0);
              let ct = Math.sqrt(Gt);
              iA === S && (ct = -ct);
              const jt = 0.5 * (rt + wt) - ct * (Wt - $e), bi = 0.5 * ($e + Wt) + ct * (wt - rt), Ci = Math.atan2($e - bi, rt - jt);
              let Oi = Math.atan2(Wt - bi, wt - jt) - Ci;
              Oi < 0 && iA === 1 ? Oi += 2 * Math.PI : Oi > 0 && iA === 0 && (Oi -= 2 * Math.PI);
              const xn = Math.ceil(Math.abs(Oi / (Math.PI * 0.5 + 1e-3))), gs = [];
              for (let Wn = 0; Wn < xn; Wn++) {
                const cs = Ci + Wn * Oi / xn, ea = Ci + (Wn + 1) * Oi / xn;
                gs[Wn] = [jt, bi, cs, ea, I, f, xe, Qe];
              }
              return gs;
            }, ae = function(g, s, I, f, S, iA, YA, XA) {
              const oe = XA * S, pe = -YA * iA, xe = YA * S, Qe = XA * iA, ke = 0.5 * (f - I), lt = 8 / 3 * Math.sin(ke * 0.5) * Math.sin(ke * 0.5) / Math.sin(ke), Xe = g + Math.cos(I) - lt * Math.sin(I), et = s + Math.sin(I) + lt * Math.cos(I), Oe = g + Math.cos(f), rt = s + Math.sin(f), $e = Oe + lt * Math.sin(f), wt = rt - lt * Math.cos(f);
              return [oe * Xe + pe * et, xe * Xe + Qe * et, oe * $e + pe * wt, xe * $e + Qe * wt, oe * Oe + pe * rt, xe * Oe + Qe * rt];
            };
            class ve {
              static apply(s, I) {
                const f = _A(I);
                jA(f, s);
              }
            }
            const {
              number: ze
            } = v, At = 4 * ((Math.sqrt(2) - 1) / 3);
            var Bt = {
              initVector() {
                this._ctm = [1, 0, 0, 1, 0, 0], this._ctmStack = [];
              },
              save() {
                return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
              },
              restore() {
                return this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0], this.addContent("Q");
              },
              closePath() {
                return this.addContent("h");
              },
              lineWidth(g) {
                return this.addContent(`${ze(g)} w`);
              },
              _CAP_STYLES: {
                BUTT: 0,
                ROUND: 1,
                SQUARE: 2
              },
              lineCap(g) {
                return typeof g == "string" && (g = this._CAP_STYLES[g.toUpperCase()]), this.addContent(`${g} J`);
              },
              _JOIN_STYLES: {
                MITER: 0,
                ROUND: 1,
                BEVEL: 2
              },
              lineJoin(g) {
                return typeof g == "string" && (g = this._JOIN_STYLES[g.toUpperCase()]), this.addContent(`${g} j`);
              },
              miterLimit(g) {
                return this.addContent(`${ze(g)} M`);
              },
              dash(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                const I = g;
                if (Array.isArray(g) || (g = [g, s.space || g]), !g.every((S) => Number.isFinite(S) && S > 0))
                  throw new Error(`dash(${JSON.stringify(I)}, ${JSON.stringify(s)}) invalid, lengths must be numeric and greater than zero`);
                return g = g.map(ze).join(" "), this.addContent(`[${g}] ${ze(s.phase || 0)} d`);
              },
              undash() {
                return this.addContent("[] 0 d");
              },
              moveTo(g, s) {
                return this.addContent(`${ze(g)} ${ze(s)} m`);
              },
              lineTo(g, s) {
                return this.addContent(`${ze(g)} ${ze(s)} l`);
              },
              bezierCurveTo(g, s, I, f, S, iA) {
                return this.addContent(`${ze(g)} ${ze(s)} ${ze(I)} ${ze(f)} ${ze(S)} ${ze(iA)} c`);
              },
              quadraticCurveTo(g, s, I, f) {
                return this.addContent(`${ze(g)} ${ze(s)} ${ze(I)} ${ze(f)} v`);
              },
              rect(g, s, I, f) {
                return this.addContent(`${ze(g)} ${ze(s)} ${ze(I)} ${ze(f)} re`);
              },
              roundedRect(g, s, I, f, S) {
                S == null && (S = 0), S = Math.min(S, 0.5 * I, 0.5 * f);
                const iA = S * (1 - At);
                return this.moveTo(g + S, s), this.lineTo(g + I - S, s), this.bezierCurveTo(g + I - iA, s, g + I, s + iA, g + I, s + S), this.lineTo(g + I, s + f - S), this.bezierCurveTo(g + I, s + f - iA, g + I - iA, s + f, g + I - S, s + f), this.lineTo(g + S, s + f), this.bezierCurveTo(g + iA, s + f, g, s + f - iA, g, s + f - S), this.lineTo(g, s + S), this.bezierCurveTo(g, s + iA, g + iA, s, g + S, s), this.closePath();
              },
              ellipse(g, s, I, f) {
                f == null && (f = I), g -= I, s -= f;
                const S = I * At, iA = f * At, YA = g + I * 2, XA = s + f * 2, oe = g + I, pe = s + f;
                return this.moveTo(g, pe), this.bezierCurveTo(g, pe - iA, oe - S, s, oe, s), this.bezierCurveTo(oe + S, s, YA, pe - iA, YA, pe), this.bezierCurveTo(YA, pe + iA, oe + S, XA, oe, XA), this.bezierCurveTo(oe - S, XA, g, pe + iA, g, pe), this.closePath();
              },
              circle(g, s, I) {
                return this.ellipse(g, s, I);
              },
              arc(g, s, I, f, S, iA) {
                iA == null && (iA = !1);
                const YA = 2 * Math.PI, XA = 0.5 * Math.PI;
                let oe = S - f;
                Math.abs(oe) > YA ? oe = YA : oe !== 0 && iA !== oe < 0 && (oe = (iA ? -1 : 1) * YA + oe);
                const pe = Math.ceil(Math.abs(oe) / XA), xe = oe / pe, Qe = xe / XA * At * I;
                let ke = f, lt = -Math.sin(ke) * Qe, Xe = Math.cos(ke) * Qe, et = g + Math.cos(ke) * I, Oe = s + Math.sin(ke) * I;
                this.moveTo(et, Oe);
                for (let rt = 0; rt < pe; rt++) {
                  const $e = et + lt, wt = Oe + Xe;
                  ke += xe, et = g + Math.cos(ke) * I, Oe = s + Math.sin(ke) * I, lt = -Math.sin(ke) * Qe, Xe = Math.cos(ke) * Qe;
                  const Wt = et - lt, $t = Oe - Xe;
                  this.bezierCurveTo($e, wt, Wt, $t, et, Oe);
                }
                return this;
              },
              polygon() {
                for (var g = arguments.length, s = new Array(g), I = 0; I < g; I++)
                  s[I] = arguments[I];
                this.moveTo(...s.shift() || []);
                for (let f of s)
                  this.lineTo(...f || []);
                return this.closePath();
              },
              path(g) {
                return ve.apply(this, g), this;
              },
              _windingRule(g) {
                return /even-?odd/.test(g) ? "*" : "";
              },
              fill(g, s) {
                return /(even-?odd)|(non-?zero)/.test(g) && (s = g, g = null), g && this.fillColor(g), this.addContent(`f${this._windingRule(s)}`);
              },
              stroke(g) {
                return g && this.strokeColor(g), this.addContent("S");
              },
              fillAndStroke(g, s, I) {
                s == null && (s = g);
                const f = /(even-?odd)|(non-?zero)/;
                return f.test(g) && (I = g, g = null), f.test(s) && (I = s, s = g), g && (this.fillColor(g), this.strokeColor(s)), this.addContent(`B${this._windingRule(I)}`);
              },
              clip(g) {
                return this.addContent(`W${this._windingRule(g)} n`);
              },
              transform(g, s, I, f, S, iA) {
                if (g === 1 && s === 0 && I === 0 && f === 1 && S === 0 && iA === 0)
                  return this;
                const YA = this._ctm, [XA, oe, pe, xe, Qe, ke] = YA;
                YA[0] = XA * g + pe * s, YA[1] = oe * g + xe * s, YA[2] = XA * I + pe * f, YA[3] = oe * I + xe * f, YA[4] = XA * S + pe * iA + Qe, YA[5] = oe * S + xe * iA + ke;
                const lt = [g, s, I, f, S, iA].map((Xe) => ze(Xe)).join(" ");
                return this.addContent(`${lt} cm`);
              },
              translate(g, s) {
                return this.transform(1, 0, 0, 1, g, s);
              },
              rotate(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I;
                const f = g * Math.PI / 180, S = Math.cos(f), iA = Math.sin(f);
                let YA = I = 0;
                if (s.origin != null) {
                  [YA, I] = s.origin;
                  const XA = YA * S - I * iA, oe = YA * iA + I * S;
                  YA -= XA, I -= oe;
                }
                return this.transform(S, iA, -iA, S, YA, I);
              },
              scale(g, s) {
                let I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f;
                s == null && (s = g), typeof s == "object" && (I = s, s = g);
                let S = f = 0;
                return I.origin != null && ([S, f] = I.origin, S -= g * S, f -= s * f), this.transform(g, 0, 0, s, S, f);
              }
            };
            const He = {
              402: 131,
              8211: 150,
              8212: 151,
              8216: 145,
              8217: 146,
              8218: 130,
              8220: 147,
              8221: 148,
              8222: 132,
              8224: 134,
              8225: 135,
              8226: 149,
              8230: 133,
              8364: 128,
              8240: 137,
              8249: 139,
              8250: 155,
              710: 136,
              8482: 153,
              338: 140,
              339: 156,
              732: 152,
              352: 138,
              353: 154,
              376: 159,
              381: 142,
              382: 158
            }, Ce = `.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
  
space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question
  
at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore
  
grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef
  
Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis
  
space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown
  
Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls
  
agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis`.split(/\s+/);
            class je {
              constructor(s) {
                this.attributes = {}, this.glyphWidths = {}, this.boundingBoxes = {}, this.kernPairs = {}, this.parse(s), this.bbox = this.attributes.FontBBox.split(/\s+/).map((I) => +I), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
              }
              parse(s) {
                let I = "";
                for (let oe of s.split(`
`)) {
                  var f, S;
                  if (f = oe.match(/^Start(\w+)/)) {
                    I = f[1];
                    continue;
                  } else if (f = oe.match(/^End(\w+)/)) {
                    I = "";
                    continue;
                  }
                  switch (I) {
                    case "FontMetrics":
                      f = oe.match(/(^\w+)\s+(.*)/);
                      var iA = f[1], YA = f[2];
                      (S = this.attributes[iA]) ? (Array.isArray(S) || (S = this.attributes[iA] = [S]), S.push(YA)) : this.attributes[iA] = YA;
                      break;
                    case "CharMetrics":
                      if (!/^CH?\s/.test(oe))
                        continue;
                      var XA = oe.match(/\bN\s+(\.?\w+)\s*;/)[1];
                      this.glyphWidths[XA] = +oe.match(/\bWX\s+(\d+)\s*;/)[1];
                      break;
                    case "KernPairs":
                      f = oe.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), f && (this.kernPairs[f[1] + "\0" + f[2]] = parseInt(f[3]));
                      break;
                  }
                }
              }
              encodeText(s) {
                const I = [];
                for (let f = 0, S = s.length; f < S; f++) {
                  let iA = s.charCodeAt(f);
                  iA = He[iA] || iA, I.push(iA.toString(16));
                }
                return I;
              }
              glyphsForString(s) {
                const I = [];
                for (let f = 0, S = s.length; f < S; f++) {
                  const iA = s.charCodeAt(f);
                  I.push(this.characterToGlyph(iA));
                }
                return I;
              }
              characterToGlyph(s) {
                return Ce[He[s] || s] || ".notdef";
              }
              widthOfGlyph(s) {
                return this.glyphWidths[s] || 0;
              }
              getKernPair(s, I) {
                return this.kernPairs[s + "\0" + I] || 0;
              }
              advancesForGlyphs(s) {
                const I = [];
                for (let f = 0; f < s.length; f++) {
                  const S = s[f], iA = s[f + 1];
                  I.push(this.widthOfGlyph(S) + this.getKernPair(S, iA));
                }
                return I;
              }
            }
            class it {
              constructor() {
              }
              encode() {
                throw new Error("Must be implemented by subclasses");
              }
              widthOfString() {
                throw new Error("Must be implemented by subclasses");
              }
              ref() {
                return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
              }
              finalize() {
                this.embedded || this.dictionary == null || (this.embed(), this.embedded = !0);
              }
              embed() {
                throw new Error("Must be implemented by subclasses");
              }
              lineHeight(s) {
                const f = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? this.lineGap : 0;
                return (this.ascender + f - this.descender) / 1e3 * s;
              }
            }
            const Et = {
              Courier() {
                return eA.readFileSync(A + "/data/Courier.afm", "utf8");
              },
              "Courier-Bold"() {
                return eA.readFileSync(A + "/data/Courier-Bold.afm", "utf8");
              },
              "Courier-Oblique"() {
                return eA.readFileSync(A + "/data/Courier-Oblique.afm", "utf8");
              },
              "Courier-BoldOblique"() {
                return eA.readFileSync(A + "/data/Courier-BoldOblique.afm", "utf8");
              },
              Helvetica() {
                return eA.readFileSync(A + "/data/Helvetica.afm", "utf8");
              },
              "Helvetica-Bold"() {
                return eA.readFileSync(A + "/data/Helvetica-Bold.afm", "utf8");
              },
              "Helvetica-Oblique"() {
                return eA.readFileSync(A + "/data/Helvetica-Oblique.afm", "utf8");
              },
              "Helvetica-BoldOblique"() {
                return eA.readFileSync(A + "/data/Helvetica-BoldOblique.afm", "utf8");
              },
              "Times-Roman"() {
                return eA.readFileSync(A + "/data/Times-Roman.afm", "utf8");
              },
              "Times-Bold"() {
                return eA.readFileSync(A + "/data/Times-Bold.afm", "utf8");
              },
              "Times-Italic"() {
                return eA.readFileSync(A + "/data/Times-Italic.afm", "utf8");
              },
              "Times-BoldItalic"() {
                return eA.readFileSync(A + "/data/Times-BoldItalic.afm", "utf8");
              },
              Symbol() {
                return eA.readFileSync(A + "/data/Symbol.afm", "utf8");
              },
              ZapfDingbats() {
                return eA.readFileSync(A + "/data/ZapfDingbats.afm", "utf8");
              }
            };
            class Ft extends it {
              constructor(s, I, f) {
                super(), this.document = s, this.name = I, this.id = f, this.font = new je(Et[this.name]()), {
                  ascender: this.ascender,
                  descender: this.descender,
                  bbox: this.bbox,
                  lineGap: this.lineGap,
                  xHeight: this.xHeight,
                  capHeight: this.capHeight
                } = this.font;
              }
              embed() {
                return this.dictionary.data = {
                  Type: "Font",
                  BaseFont: this.name,
                  Subtype: "Type1",
                  Encoding: "WinAnsiEncoding"
                }, this.dictionary.end();
              }
              encode(s) {
                const I = this.font.encodeText(s), f = this.font.glyphsForString(`${s}`), S = this.font.advancesForGlyphs(f), iA = [];
                for (let YA = 0; YA < f.length; YA++) {
                  const XA = f[YA];
                  iA.push({
                    xAdvance: S[YA],
                    yAdvance: 0,
                    xOffset: 0,
                    yOffset: 0,
                    advanceWidth: this.font.widthOfGlyph(XA)
                  });
                }
                return [I, iA];
              }
              widthOfString(s, I) {
                const f = this.font.glyphsForString(`${s}`), S = this.font.advancesForGlyphs(f);
                let iA = 0;
                for (let XA of S)
                  iA += XA;
                const YA = I / 1e3;
                return iA * YA;
              }
              static isStandardFont(s) {
                return s in Et;
              }
            }
            const Qt = function(g) {
              return `0000${g.toString(16)}`.slice(-4);
            };
            class Nt extends it {
              constructor(s, I, f) {
                super(), this.document = s, this.font = I, this.id = f, this.subset = this.font.createSubset(), this.unicode = [[0]], this.widths = [this.font.getGlyph(0).advanceWidth], this.name = this.font.postscriptName, this.scale = 1e3 / this.font.unitsPerEm, this.ascender = this.font.ascent * this.scale, this.descender = this.font.descent * this.scale, this.xHeight = this.font.xHeight * this.scale, this.capHeight = this.font.capHeight * this.scale, this.lineGap = this.font.lineGap * this.scale, this.bbox = this.font.bbox, s.options.fontLayoutCache !== !1 && (this.layoutCache = /* @__PURE__ */ Object.create(null));
              }
              layoutRun(s, I) {
                const f = this.font.layout(s, I);
                for (let S = 0; S < f.positions.length; S++) {
                  const iA = f.positions[S];
                  for (let YA in iA)
                    iA[YA] *= this.scale;
                  iA.advanceWidth = f.glyphs[S].advanceWidth * this.scale;
                }
                return f;
              }
              layoutCached(s) {
                if (!this.layoutCache)
                  return this.layoutRun(s);
                let I;
                if (I = this.layoutCache[s])
                  return I;
                const f = this.layoutRun(s);
                return this.layoutCache[s] = f, f;
              }
              layout(s, I, f) {
                if (I)
                  return this.layoutRun(s, I);
                let S = f ? null : [], iA = f ? null : [], YA = 0, XA = 0, oe = 0;
                for (; oe <= s.length; ) {
                  var pe;
                  if (oe === s.length && XA < oe || (pe = s.charAt(oe), [" ", "	"].includes(pe))) {
                    const xe = this.layoutCached(s.slice(XA, ++oe));
                    f || (S = S.concat(xe.glyphs), iA = iA.concat(xe.positions)), YA += xe.advanceWidth, XA = oe;
                  } else
                    oe++;
                }
                return {
                  glyphs: S,
                  positions: iA,
                  advanceWidth: YA
                };
              }
              encode(s, I) {
                const {
                  glyphs: f,
                  positions: S
                } = this.layout(s, I), iA = [];
                for (let YA = 0; YA < f.length; YA++) {
                  const XA = f[YA], oe = this.subset.includeGlyph(XA.id);
                  iA.push(`0000${oe.toString(16)}`.slice(-4)), this.widths[oe] == null && (this.widths[oe] = XA.advanceWidth * this.scale), this.unicode[oe] == null && (this.unicode[oe] = XA.codePoints);
                }
                return [iA, S];
              }
              widthOfString(s, I, f) {
                const S = this.layout(s, f, !0).advanceWidth, iA = I / 1e3;
                return S * iA;
              }
              embed() {
                const s = this.subset.cff != null, I = this.document.ref();
                s && (I.data.Subtype = "CIDFontType0C"), I.end(this.subset.encode());
                const f = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : void 0) || 0) >> 8;
                let S = 0;
                this.font.post.isFixedPitch && (S |= 1), 1 <= f && f <= 7 && (S |= 2), S |= 4, f === 10 && (S |= 8), this.font.head.macStyle.italic && (S |= 64);
                const YA = [1, 2, 3, 4, 5, 6].map((Qe) => String.fromCharCode((this.id.charCodeAt(Qe) || 73) + 17)).join("") + "+" + this.font.postscriptName?.replaceAll(" ", "_"), {
                  bbox: XA
                } = this.font, oe = this.document.ref({
                  Type: "FontDescriptor",
                  FontName: YA,
                  Flags: S,
                  FontBBox: [XA.minX * this.scale, XA.minY * this.scale, XA.maxX * this.scale, XA.maxY * this.scale],
                  ItalicAngle: this.font.italicAngle,
                  Ascent: this.ascender,
                  Descent: this.descender,
                  CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                  XHeight: (this.font.xHeight || 0) * this.scale,
                  StemV: 0
                });
                if (s ? oe.data.FontFile3 = I : oe.data.FontFile2 = I, this.document.subset && this.document.subset === 1) {
                  const Qe = a.from("FFFFFFFFC0", "hex"), ke = this.document.ref();
                  ke.write(Qe), ke.end(), oe.data.CIDSet = ke;
                }
                oe.end();
                const pe = {
                  Type: "Font",
                  Subtype: "CIDFontType0",
                  BaseFont: YA,
                  CIDSystemInfo: {
                    Registry: new String("Adobe"),
                    Ordering: new String("Identity"),
                    Supplement: 0
                  },
                  FontDescriptor: oe,
                  W: [0, this.widths]
                };
                s || (pe.Subtype = "CIDFontType2", pe.CIDToGIDMap = "Identity");
                const xe = this.document.ref(pe);
                return xe.end(), this.dictionary.data = {
                  Type: "Font",
                  Subtype: "Type0",
                  BaseFont: YA,
                  Encoding: "Identity-H",
                  DescendantFonts: [xe],
                  ToUnicode: this.toUnicodeCmap()
                }, this.dictionary.end();
              }
              toUnicodeCmap() {
                const s = this.document.ref(), I = [];
                for (let YA of this.unicode) {
                  const XA = [];
                  for (let oe of YA)
                    oe > 65535 && (oe -= 65536, XA.push(Qt(oe >>> 10 & 1023 | 55296)), oe = 56320 | oe & 1023), XA.push(Qt(oe));
                  I.push(`<${XA.join(" ")}>`);
                }
                const f = 256, S = Math.ceil(I.length / f), iA = [];
                for (let YA = 0; YA < S; YA++) {
                  const XA = YA * f, oe = Math.min((YA + 1) * f, I.length);
                  iA.push(`<${Qt(XA)}> <${Qt(oe - 1)}> [${I.slice(XA, oe).join(" ")}]`);
                }
                return s.end(`/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
${iA.length} beginbfrange
${iA.join(`
`)}
endbfrange
endcmap
CMapName currentdict /CMap defineresource pop
end
end`), s;
              }
            }
            class gt {
              static open(s, I, f, S) {
                let iA;
                if (typeof I == "string") {
                  if (Ft.isStandardFont(I))
                    return new Ft(s, I, S);
                  I = eA.readFileSync(I);
                }
                if (I instanceof Uint8Array ? iA = q.create(I, f) : I instanceof ArrayBuffer && (iA = q.create(new Uint8Array(I), f)), iA == null)
                  throw new Error("Not a supported font format or standard PDF font.");
                return new Nt(s, iA, S);
              }
            }
            const yt = (g, s) => !(g.font._tables?.head?.checkSumAdjustment !== s.font._tables?.head?.checkSumAdjustment || JSON.stringify(g.font._tables?.name?.records) !== JSON.stringify(s.font._tables?.name?.records));
            var oi = {
              initFonts() {
                let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Helvetica", s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 12;
                this._fontFamilies = {}, this._fontCount = 0, this._fontSource = g, this._fontFamily = s, this._fontSize = I, this._font = null, this._remSize = I, this._registeredFonts = {}, g && this.font(g, s);
              },
              font(g, s, I) {
                let f, S;
                if (typeof s == "number" && (I = s, s = null), typeof g == "string" && this._registeredFonts[g] ? (f = g, {
                  src: g,
                  family: s
                } = this._registeredFonts[g]) : (f = s || g, typeof f != "string" && (f = null)), this._fontSource = g, this._fontFamily = s, I != null && this.fontSize(I), S = this._fontFamilies[f])
                  return this._font = S, this;
                const iA = `F${++this._fontCount}`;
                return this._font = gt.open(this, g, s, iA), (S = this._fontFamilies[this._font.name]) && yt(this._font, S) ? (this._font = S, this) : (f && (this._fontFamilies[f] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
              },
              fontSize(g) {
                return this._fontSize = this.sizeToPoint(g), this;
              },
              currentLineHeight(g) {
                return this._font.lineHeight(this._fontSize, g);
              },
              registerFont(g, s, I) {
                return this._registeredFonts[g] = {
                  src: s,
                  family: I
                }, this;
              },
              sizeToPoint(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.page, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : void 0;
                if (f || (f = this._fontSize), typeof s != "number" && (s = this.sizeToPoint(s)), g === void 0) return s;
                if (typeof g == "number") return g;
                if (typeof g == "boolean") return Number(g);
                const S = String(g).match(/((\d+)?(\.\d+)?)(em|in|px|cm|mm|pc|ex|ch|rem|vw|vh|vmin|vmax|%|pt)?/);
                if (!S) throw new Error(`Unsupported size '${g}'`);
                let iA;
                switch (S[4]) {
                  case "em":
                    iA = this._fontSize;
                    break;
                  case "in":
                    iA = zA;
                    break;
                  case "px":
                    iA = EA * zA;
                    break;
                  case "cm":
                    iA = WA * zA;
                    break;
                  case "mm":
                    iA = kA * WA * zA;
                    break;
                  case "pc":
                    iA = OA;
                    break;
                  case "ex":
                    iA = this.currentLineHeight();
                    break;
                  case "ch":
                    iA = this.widthOfString("0");
                    break;
                  case "rem":
                    iA = this._remSize;
                    break;
                  case "vw":
                    iA = I.width / 100;
                    break;
                  case "vh":
                    iA = I.height / 100;
                    break;
                  case "vmin":
                    iA = Math.min(I.width, I.height) / 100;
                    break;
                  case "vmax":
                    iA = Math.max(I.width, I.height) / 100;
                    break;
                  case "%":
                    iA = f / 100;
                    break;
                  case "pt":
                  default:
                    iA = 1;
                }
                return iA * Number(S[1]);
              }
            };
            const Ai = "­", _t = "-";
            class St extends AA.EventEmitter {
              constructor(s, I) {
                super(), this.document = s, this.horizontalScaling = I.horizontalScaling || 100, this.indent = (I.indent || 0) * this.horizontalScaling / 100, this.indentAllLines = I.indentAllLines || !1, this.characterSpacing = (I.characterSpacing || 0) * this.horizontalScaling / 100, this.wordSpacing = (I.wordSpacing === 0) * this.horizontalScaling / 100, this.columns = I.columns || 1, this.columnGap = (I.columnGap != null ? I.columnGap : 18) * this.horizontalScaling / 100, this.lineWidth = (I.width * this.horizontalScaling / 100 - this.columnGap * (this.columns - 1)) / this.columns, this.spaceLeft = this.lineWidth, this.startX = this.document.x, this.startY = this.document.y, this.column = 1, this.ellipsis = I.ellipsis, this.continuedX = 0, this.features = I.features, I.height != null ? (this.height = I.height, this.maxY = cA(this.startY + I.height)) : this.maxY = cA(this.document.page.maxY()), this.on("firstLine", (f) => {
                  const S = this.continuedX || this.indent;
                  this.document.x += S, this.lineWidth -= S, !f.indentAllLines && this.once("line", () => {
                    this.document.x -= S, this.lineWidth += S, f.continued && !this.continuedX && (this.continuedX = this.indent), f.continued || (this.continuedX = 0);
                  });
                }), this.on("lastLine", (f) => {
                  const {
                    align: S
                  } = f;
                  S === "justify" && (f.align = "left"), this.lastLine = !0, this.once("line", () => (this.document.y += f.paragraphGap || 0, f.align = S, this.lastLine = !1));
                });
              }
              wordWidth(s) {
                return cA(this.document.widthOfString(s, this) + this.characterSpacing + this.wordSpacing);
              }
              canFit(s, I) {
                return s[s.length - 1] != Ai ? I <= this.spaceLeft : I + this.wordWidth(_t) <= this.spaceLeft;
              }
              eachWord(s, I) {
                let f;
                const S = new K.default(s);
                let iA = null;
                const YA = /* @__PURE__ */ Object.create(null);
                for (; f = S.nextBreak(); ) {
                  var XA;
                  let xe = s.slice(iA?.position || 0, f.position), Qe = YA[xe] != null ? YA[xe] : YA[xe] = this.wordWidth(xe);
                  if (Qe > this.lineWidth + this.continuedX) {
                    let ke = iA;
                    const lt = {};
                    for (; xe.length; ) {
                      var oe, pe;
                      Qe > this.spaceLeft ? (oe = Math.ceil(this.spaceLeft / (Qe / xe.length)), Qe = this.wordWidth(xe.slice(0, oe)), pe = Qe <= this.spaceLeft && oe < xe.length) : oe = xe.length;
                      let Xe = Qe > this.spaceLeft && oe > 0;
                      for (; Xe || pe; )
                        Xe ? (Qe = this.wordWidth(xe.slice(0, --oe)), Xe = Qe > this.spaceLeft && oe > 0) : (Qe = this.wordWidth(xe.slice(0, ++oe)), Xe = Qe > this.spaceLeft && oe > 0, pe = Qe <= this.spaceLeft && oe < xe.length);
                      if (oe === 0 && this.spaceLeft === this.lineWidth && (oe = 1), lt.required = f.required || oe < xe.length, XA = I(xe.slice(0, oe), Qe, lt, ke), ke = {
                        required: !1
                      }, xe = xe.slice(oe), Qe = this.wordWidth(xe), XA === !1)
                        break;
                    }
                  } else
                    XA = I(xe, Qe, f, iA);
                  if (XA === !1)
                    break;
                  iA = f;
                }
              }
              wrap(s, I) {
                this.horizontalScaling = I.horizontalScaling || 100, I.indent != null && (this.indent = I.indent * this.horizontalScaling / 100), I.characterSpacing != null && (this.characterSpacing = I.characterSpacing * this.horizontalScaling / 100), I.wordSpacing != null && (this.wordSpacing = I.wordSpacing * this.horizontalScaling / 100), I.ellipsis != null && (this.ellipsis = I.ellipsis);
                const f = this.document.y + this.document.currentLineHeight(!0);
                (this.document.y > this.maxY || f > this.maxY) && this.nextSection();
                let S = "", iA = 0, YA = 0, XA = 0, {
                  y: oe
                } = this.document;
                const pe = () => (I.textWidth = iA + this.wordSpacing * (YA - 1), I.wordCount = YA, I.lineWidth = this.lineWidth, {
                  y: oe
                } = this.document, this.emit("line", S, I, this), XA++);
                this.emit("sectionStart", I, this), this.eachWord(s, (xe, Qe, ke, lt) => {
                  if ((lt == null || lt.required) && (this.emit("firstLine", I, this), this.spaceLeft = this.lineWidth), this.canFit(xe, Qe) && (S += xe, iA += Qe, YA++), ke.required || !this.canFit(xe, Qe)) {
                    const Xe = this.document.currentLineHeight(!0);
                    if (this.height != null && this.ellipsis && cA(this.document.y + Xe * 2) > this.maxY && this.column >= this.columns) {
                      for (this.ellipsis === !0 && (this.ellipsis = "…"), S = S.replace(/\s+$/, ""), iA = this.wordWidth(S + this.ellipsis); S && iA > this.lineWidth; )
                        S = S.slice(0, -1).replace(/\s+$/, ""), iA = this.wordWidth(S + this.ellipsis);
                      iA <= this.lineWidth && (S = S + this.ellipsis), iA = this.wordWidth(S);
                    }
                    if (ke.required && (Qe > this.spaceLeft && (pe(), S = xe, iA = Qe, YA = 1), this.emit("lastLine", I, this)), S[S.length - 1] == Ai && (S = S.slice(0, -1) + _t, this.spaceLeft -= this.wordWidth(_t)), pe(), cA(this.document.y + Xe) > this.maxY) {
                      if (this.emit("sectionEnd", I, this), !this.nextSection())
                        return YA = 0, S = "", !1;
                      this.emit("sectionStart", I, this);
                    }
                    return ke.required ? (this.spaceLeft = this.lineWidth, S = "", iA = 0, YA = 0) : (this.spaceLeft = this.lineWidth - Qe, S = xe, iA = Qe, YA = 1);
                  } else
                    return this.spaceLeft -= Qe;
                }), YA > 0 && (this.emit("lastLine", I, this), pe()), this.emit("sectionEnd", I, this), I.continued === !0 ? (XA > 1 && (this.continuedX = 0), this.continuedX += I.textWidth || 0, this.document.y = oe) : this.document.x = this.startX;
              }
              nextSection(s) {
                if (++this.column > this.columns) {
                  if (this.height != null)
                    return !1;
                  if (this.document.continueOnNewPage(), this.column = 1, this.startY = this.document.page.margins.top, this.maxY = this.document.page.maxY(), this.indentAllLines) {
                    const I = this.continuedX || this.indent;
                    this.document.x += I, this.lineWidth -= I;
                  } else
                    this.document.x = this.startX;
                  this.document._fillColor && this.document.fillColor(...this.document._fillColor), this.emit("pageBreak", s, this);
                } else
                  this.document.x += this.lineWidth + this.columnGap, this.document.y = this.startY, this.emit("columnBreak", s, this);
                return !0;
              }
            }
            const {
              number: ri
            } = v;
            function gn(g, s) {
              if (s === "numbered")
                return `${g}.`;
              var I = String.fromCharCode((g - 1) % 26 + 65), f = Math.floor((g - 1) / 26 + 1), S = Array(f + 1).join(I);
              return `${S}.`;
            }
            var Pi = {
              initText() {
                this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
              },
              lineGap(g) {
                return this._lineGap = g, this;
              },
              moveDown(g) {
                return g == null && (g = 1), this.y += this.currentLineHeight(!0) * g + this._lineGap, this;
              },
              moveUp(g) {
                return g == null && (g = 1), this.y -= this.currentLineHeight(!0) * g + this._lineGap, this;
              },
              _text(g, s, I, f, S) {
                f = this._initOptions(s, I, f), g = g == null ? "" : `${g}`, f.wordSpacing && (g = g.replace(/\s{2,}/g, " "));
                const iA = () => {
                  f.structParent && f.structParent.add(this.struct(f.structType || "P", [this.markStructureContent(f.structType || "P")]));
                };
                if (f.rotation !== 0 && (this.save(), this.rotate(-f.rotation, {
                  origin: [this.x, this.y]
                })), f.width) {
                  let YA = this._wrapper;
                  YA || (YA = new St(this, f), YA.on("line", S), YA.on("firstLine", iA)), this._wrapper = f.continued ? YA : null, this._textOptions = f.continued ? f : null, YA.wrap(g, f);
                } else
                  for (let YA of g.split(`
`))
                    iA(), S(YA, f);
                return f.rotation !== 0 && this.restore(), this;
              },
              text(g, s, I, f) {
                return this._text(g, s, I, f, this._line);
              },
              widthOfString(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                const I = s.horizontalScaling || 100;
                return (this._font.widthOfString(g, this._fontSize, s.features) + (s.characterSpacing || 0) * (g.length - 1)) * I / 100;
              },
              boundsOfString(g, s, I, f) {
                f = this._initOptions(s, I, f), {
                  x: s,
                  y: I
                } = this;
                const S = f.lineGap ?? this._lineGap ?? 0, iA = this.currentLineHeight(!0) + S;
                let YA = 0;
                if (g = String(g ?? ""), f.wordSpacing && (g = g.replace(/\s{2,}/g, " ")), f.width) {
                  let Gt = new St(this, f);
                  Gt.on("line", (ct, jt) => {
                    if (this.y += iA, ct = ct.replace(/\n/g, ""), ct.length) {
                      let bi = jt.wordSpacing ?? 0;
                      const Ci = jt.characterSpacing ?? 0;
                      if (jt.width && jt.align === "justify") {
                        const _i = ct.trim().split(/\s+/), Oi = this.widthOfString(ct.replace(/\s+/g, ""), jt), xn = this.widthOfString(" ") + Ci;
                        bi = Math.max(0, (jt.lineWidth - Oi) / Math.max(1, _i.length - 1) - xn);
                      }
                      YA = Math.max(YA, jt.textWidth + bi * (jt.wordCount - 1) + Ci * (ct.length - 1));
                    }
                  }), Gt.wrap(g, f);
                } else
                  for (let Gt of g.split(`
`)) {
                    const ct = this.widthOfString(Gt, f);
                    this.y += iA, YA = Math.max(YA, ct);
                  }
                let XA = this.y - I;
                if (f.height && (XA = Math.min(XA, f.height)), this.x = s, this.y = I, f.rotation === 0)
                  return {
                    x: s,
                    y: I,
                    width: YA,
                    height: XA
                  };
                if (f.rotation === 90)
                  return {
                    x: s,
                    y: I - YA,
                    width: XA,
                    height: YA
                  };
                if (f.rotation === 180)
                  return {
                    x: s - YA,
                    y: I - XA,
                    width: YA,
                    height: XA
                  };
                if (f.rotation === 270)
                  return {
                    x: s - XA,
                    y: I,
                    width: XA,
                    height: YA
                  };
                const oe = xA(f.rotation), pe = LA(f.rotation), xe = s, Qe = I, ke = s + YA * oe, lt = I - YA * pe, Xe = s + YA * oe + XA * pe, et = I - YA * pe + XA * oe, Oe = s + XA * pe, rt = I + XA * oe, $e = Math.min(xe, ke, Xe, Oe), wt = Math.max(xe, ke, Xe, Oe), Wt = Math.min(Qe, lt, et, rt), $t = Math.max(Qe, lt, et, rt);
                return {
                  x: $e,
                  y: Wt,
                  width: wt - $e,
                  height: $t - Wt
                };
              },
              heightOfString(g, s) {
                const {
                  x: I,
                  y: f
                } = this;
                s = this._initOptions(s), s.height = 1 / 0;
                const S = s.lineGap || this._lineGap || 0;
                this._text(g, this.x, this.y, s, () => {
                  this.y += this.currentLineHeight(!0) + S;
                });
                const iA = this.y - f;
                return this.x = I, this.y = f, iA;
              },
              list(g, s, I, f) {
                f = this._initOptions(s, I, f);
                const S = f.listType || "bullet", iA = Math.round(this._font.ascender / 1e3 * this._fontSize), YA = iA / 2, XA = f.bulletRadius || iA / 3, oe = f.textIndent || (S === "bullet" ? XA * 5 : iA * 2), pe = f.bulletIndent || (S === "bullet" ? XA * 8 : iA * 2);
                let xe = 1;
                const Qe = [], ke = [], lt = [];
                var Xe = function(Oe) {
                  let rt = 1;
                  for (let $e = 0; $e < Oe.length; $e++) {
                    const wt = Oe[$e];
                    Array.isArray(wt) ? (xe++, Xe(wt), xe--) : (Qe.push(wt), ke.push(xe), S !== "bullet" && lt.push(rt++));
                  }
                };
                Xe(g);
                const et = function(Oe, rt) {
                  const $e = new St(this, f);
                  $e.on("line", this._line), xe = 1, $e.once("firstLine", () => {
                    let wt, Wt, $t, Gt;
                    f.structParent && (f.structTypes ? [Wt, $t, Gt] = f.structTypes : [Wt, $t, Gt] = ["LI", "Lbl", "LBody"]), Wt ? (wt = this.struct(Wt), f.structParent.add(wt)) : f.structParent && (wt = f.structParent);
                    let ct;
                    if ((ct = ke[rt++]) !== xe) {
                      const bi = pe * (ct - xe);
                      this.x += bi, $e.lineWidth -= bi, xe = ct;
                    }
                    switch (wt && ($t || Gt) && wt.add(this.struct($t || Gt, [this.markStructureContent($t || Gt)])), S) {
                      case "bullet":
                        this.circle(this.x - oe + XA, this.y + YA, XA), this.fill();
                        break;
                      case "numbered":
                      case "lettered":
                        var jt = gn(lt[rt - 1], S);
                        this._fragment(jt, this.x - oe, this.y, f);
                        break;
                    }
                    wt && $t && Gt && wt.add(this.struct(Gt, [this.markStructureContent(Gt)])), wt && wt !== f.structParent && wt.end();
                  }), $e.on("sectionStart", () => {
                    const wt = oe + pe * (xe - 1);
                    this.x += wt, $e.lineWidth -= wt;
                  }), $e.on("sectionEnd", () => {
                    const wt = oe + pe * (xe - 1);
                    this.x -= wt, $e.lineWidth += wt;
                  }), $e.wrap(Oe, f);
                };
                for (let Oe = 0; Oe < Qe.length; Oe++)
                  et.call(this, Qe[Oe], Oe);
                return this;
              },
              _initOptions() {
                let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                typeof g == "object" && (I = g, g = null);
                const f = Object.assign({}, I);
                if (this._textOptions)
                  for (let S in this._textOptions) {
                    const iA = this._textOptions[S];
                    S !== "continued" && f[S] === void 0 && (f[S] = iA);
                  }
                return g != null && (this.x = g), s != null && (this.y = s), f.lineBreak !== !1 && (f.width == null && (f.width = this.page.width - this.x - this.page.margins.right), f.width = Math.max(f.width, 0)), f.columns || (f.columns = 0), f.columnGap == null && (f.columnGap = 18), f.rotation = Number(I.rotation ?? 0) % 360, f.rotation < 0 && (f.rotation += 360), f;
              },
              _line(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I = arguments.length > 2 ? arguments[2] : void 0;
                if (this._fragment(g, this.x, this.y, s), I) {
                  const f = s.lineGap || this._lineGap || 0;
                  this.y += this.currentLineHeight(!0) + f;
                } else
                  this.x += this.widthOfString(g, s);
              },
              _fragment(g, s, I, f) {
                let S, iA, YA, XA, oe, pe;
                if (g = `${g}`.replace(/\n/g, ""), g.length === 0)
                  return;
                const xe = f.align || "left";
                let Qe = f.wordSpacing || 0;
                const ke = f.characterSpacing || 0, lt = f.horizontalScaling || 100;
                if (f.width)
                  switch (xe) {
                    case "right":
                      oe = this.widthOfString(g.replace(/\s+$/, ""), f), s += f.lineWidth - oe;
                      break;
                    case "center":
                      s += f.lineWidth / 2 - f.textWidth / 2;
                      break;
                    case "justify":
                      pe = g.trim().split(/\s+/), oe = this.widthOfString(g.replace(/\s+/g, ""), f);
                      var Xe = this.widthOfString(" ") + ke;
                      Qe = Math.max(0, (f.lineWidth - oe) / Math.max(1, pe.length - 1) - Xe);
                      break;
                  }
                if (typeof f.baseline == "number")
                  S = -f.baseline;
                else {
                  switch (f.baseline) {
                    case "svg-middle":
                      S = 0.5 * this._font.xHeight;
                      break;
                    case "middle":
                    case "svg-central":
                      S = 0.5 * (this._font.descender + this._font.ascender);
                      break;
                    case "bottom":
                    case "ideographic":
                      S = this._font.descender;
                      break;
                    case "alphabetic":
                      S = 0;
                      break;
                    case "mathematical":
                      S = 0.5 * this._font.ascender;
                      break;
                    case "hanging":
                      S = 0.8 * this._font.ascender;
                      break;
                    case "top":
                      S = this._font.ascender;
                      break;
                    default:
                      S = this._font.ascender;
                  }
                  S = S / 1e3 * this._fontSize;
                }
                const et = f.textWidth + Qe * (f.wordCount - 1) + ke * (g.length - 1);
                if (f.link != null) {
                  const ct = {};
                  this._currentStructureElement && this._currentStructureElement.dictionary.data.S === "Link" && (ct.structParent = this._currentStructureElement), this.link(s, I, et, this.currentLineHeight(), f.link, ct);
                }
                if (f.goTo != null && this.goTo(s, I, et, this.currentLineHeight(), f.goTo), f.destination != null && this.addNamedDestination(f.destination, "XYZ", s, I, null), f.underline) {
                  this.save(), f.stroke || this.strokeColor(...this._fillColor || []);
                  const ct = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                  this.lineWidth(ct);
                  let jt = I + this.currentLineHeight() - ct;
                  this.moveTo(s, jt), this.lineTo(s + et, jt), this.stroke(), this.restore();
                }
                if (f.strike) {
                  this.save(), f.stroke || this.strokeColor(...this._fillColor || []);
                  const ct = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                  this.lineWidth(ct);
                  let jt = I + this.currentLineHeight() / 2;
                  this.moveTo(s, jt), this.lineTo(s + et, jt), this.stroke(), this.restore();
                }
                if (this.save(), f.oblique) {
                  let ct;
                  typeof f.oblique == "number" ? ct = -Math.tan(f.oblique * Math.PI / 180) : ct = -0.25, this.transform(1, 0, 0, 1, s, I), this.transform(1, 0, ct, 1, -ct * S, 0), this.transform(1, 0, 0, 1, -s, -I);
                }
                this.transform(1, 0, 0, -1, 0, this.page.height), I = this.page.height - I - S, this.page.fonts[this._font.id] == null && (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent(`1 0 0 1 ${ri(s)} ${ri(I)} Tm`), this.addContent(`/${this._font.id} ${ri(this._fontSize)} Tf`);
                const Oe = f.fill && f.stroke ? 2 : f.stroke ? 1 : 0;
                if (Oe && this.addContent(`${Oe} Tr`), ke && this.addContent(`${ri(ke)} Tc`), lt !== 100 && this.addContent(`${lt} Tz`), Qe) {
                  pe = g.trim().split(/\s+/), Qe += this.widthOfString(" ") + ke, Qe *= 1e3 / this._fontSize, iA = [], XA = [];
                  for (let ct of pe) {
                    const [jt, bi] = this._font.encode(ct, f.features);
                    iA = iA.concat(jt), XA = XA.concat(bi);
                    const Ci = {}, _i = XA[XA.length - 1];
                    for (let Oi in _i) {
                      const xn = _i[Oi];
                      Ci[Oi] = xn;
                    }
                    Ci.xAdvance += Qe, XA[XA.length - 1] = Ci;
                  }
                } else
                  [iA, XA] = this._font.encode(g, f.features);
                const rt = this._fontSize / 1e3, $e = [];
                let wt = 0, Wt = !1;
                const $t = (ct) => {
                  if (wt < ct) {
                    const jt = iA.slice(wt, ct).join(""), bi = XA[ct - 1].xAdvance - XA[ct - 1].advanceWidth;
                    $e.push(`<${jt}> ${ri(-bi)}`);
                  }
                  wt = ct;
                }, Gt = (ct) => {
                  $t(ct), $e.length > 0 && (this.addContent(`[${$e.join(" ")}] TJ`), $e.length = 0);
                };
                for (YA = 0; YA < XA.length; YA++) {
                  const ct = XA[YA];
                  ct.xOffset || ct.yOffset ? (Gt(YA), this.addContent(`1 0 0 1 ${ri(s + ct.xOffset * rt)} ${ri(I + ct.yOffset * rt)} Tm`), Gt(YA + 1), Wt = !0) : (Wt && (this.addContent(`1 0 0 1 ${ri(s)} ${ri(I)} Tm`), Wt = !1), ct.xAdvance - ct.advanceWidth !== 0 && $t(YA + 1)), s += ct.xAdvance * rt;
                }
                Gt(YA), this.addContent("ET"), this.restore();
              }
            };
            const Fi = (g) => {
              if (!g || g.length < 20) return null;
              let s = 2;
              for (; s < g.length - 4; ) {
                for (; s < g.length && g[s] !== 255; ) s++;
                if (s >= g.length - 4) return null;
                const I = g.readUInt16BE(s);
                if (s += 2, I === 65498) return null;
                if (I >= 65488 && I <= 65497 || I === 65281) continue;
                if (s + 2 > g.length) return null;
                const f = g.readUInt16BE(s);
                if (I === 65505 && s + 8 <= g.length && g.subarray(s + 2, s + 8).toString("binary") === "Exif\0\0") {
                  const iA = s + 8;
                  if (iA + 8 > g.length) return null;
                  const YA = g.subarray(iA, iA + 2).toString("ascii"), XA = YA === "II";
                  if (!XA && YA !== "MM") return null;
                  const oe = XA ? (ke) => g.readUInt16LE(ke) : (ke) => g.readUInt16BE(ke), pe = XA ? (ke) => g.readUInt32LE(ke) : (ke) => g.readUInt32BE(ke);
                  if (oe(iA + 2) !== 42) return null;
                  const xe = iA + pe(iA + 4);
                  if (xe + 2 > g.length) return null;
                  const Qe = oe(xe);
                  for (let ke = 0; ke < Qe; ke++) {
                    const lt = xe + 2 + ke * 12;
                    if (lt + 12 > g.length) return null;
                    if (oe(lt) === 274) {
                      const Xe = oe(lt + 8);
                      return Xe >= 1 && Xe <= 8 ? Xe : null;
                    }
                  }
                  return null;
                }
                s += f;
              }
              return null;
            }, ki = [65472, 65473, 65474, 65475, 65477, 65478, 65479, 65480, 65481, 65482, 65483, 65484, 65485, 65486, 65487], di = {
              1: "DeviceGray",
              3: "DeviceRGB",
              4: "DeviceCMYK"
            };
            class ji {
              constructor(s, I) {
                let f;
                if (this.data = s, this.label = I, this.data.readUInt16BE(0) !== 65496)
                  throw "SOI not found in JPEG";
                this.orientation = Fi(this.data) || 1;
                let S = 2;
                for (; S < this.data.length; ) {
                  for (; S < this.data.length && this.data[S] !== 255; ) S++;
                  if (S >= this.data.length || (f = this.data.readUInt16BE(S), S += 2, ki.includes(f)))
                    break;
                  S += this.data.readUInt16BE(S);
                }
                if (!ki.includes(f))
                  throw "Invalid JPEG.";
                S += 2, this.bits = this.data[S++], this.height = this.data.readUInt16BE(S), S += 2, this.width = this.data.readUInt16BE(S), S += 2;
                const iA = this.data[S++];
                this.colorSpace = di[iA], this.obj = null;
              }
              embed(s) {
                if (!this.obj)
                  return this.obj = s.ref({
                    Type: "XObject",
                    Subtype: "Image",
                    BitsPerComponent: this.bits,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: "DCTDecode"
                  }), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [1, 0, 1, 0, 1, 0, 1, 0]), this.obj.end(this.data), this.data = null;
              }
            }
            class pi {
              constructor(s, I) {
                this.label = I, this.image = new z.default(s), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
              }
              embed(s) {
                let I = !1;
                if (this.document = s, this.obj)
                  return;
                const f = this.image.hasAlphaChannel, S = this.image.interlaceMethod === 1;
                if (this.obj = this.document.ref({
                  Type: "XObject",
                  Subtype: "Image",
                  BitsPerComponent: f ? 8 : this.image.bits,
                  Width: this.width,
                  Height: this.height,
                  Filter: "FlateDecode"
                }), !f) {
                  const iA = this.document.ref({
                    Predictor: S ? 1 : 15,
                    Colors: this.image.colors,
                    BitsPerComponent: this.image.bits,
                    Columns: this.width
                  });
                  this.obj.data.DecodeParms = iA, iA.end();
                }
                if (this.image.palette.length === 0)
                  this.obj.data.ColorSpace = this.image.colorSpace;
                else {
                  const iA = this.document.ref();
                  iA.end(a.from(this.image.palette)), this.obj.data.ColorSpace = ["Indexed", "DeviceRGB", this.image.palette.length / 3 - 1, iA];
                }
                if (this.image.transparency.grayscale != null) {
                  const iA = this.image.transparency.grayscale;
                  this.obj.data.Mask = [iA, iA];
                } else if (this.image.transparency.rgb) {
                  const {
                    rgb: iA
                  } = this.image.transparency, YA = [];
                  for (let XA of iA)
                    YA.push(XA, XA);
                  this.obj.data.Mask = YA;
                } else {
                  if (this.image.transparency.indexed)
                    return I = !0, this.loadIndexedAlphaChannel();
                  if (f)
                    return I = !0, this.splitAlphaChannel();
                }
                if (S && !I)
                  return this.decodeData();
                this.finalize();
              }
              finalize() {
                if (this.alphaChannel) {
                  const s = this.document.ref({
                    Type: "XObject",
                    Subtype: "Image",
                    Height: this.height,
                    Width: this.width,
                    BitsPerComponent: 8,
                    Filter: "FlateDecode",
                    ColorSpace: "DeviceGray",
                    Decode: [0, 1]
                  });
                  s.end(this.alphaChannel), this.obj.data.SMask = s;
                }
                return this.obj.end(this.imgData), this.image = null, this.imgData = null;
              }
              splitAlphaChannel() {
                return this.image.decodePixels((s) => {
                  let I, f;
                  const S = this.image.colors, iA = this.width * this.height, YA = a.alloc(iA * S), XA = a.alloc(iA);
                  let oe = f = I = 0;
                  const pe = s.length, xe = this.image.bits === 16 ? 1 : 0;
                  for (; oe < pe; ) {
                    for (let Qe = 0; Qe < S; Qe++)
                      YA[f++] = s[oe++], oe += xe;
                    XA[I++] = s[oe++], oe += xe;
                  }
                  return this.imgData = x.default.deflateSync(YA), this.alphaChannel = x.default.deflateSync(XA), this.finalize();
                });
              }
              loadIndexedAlphaChannel() {
                const s = this.image.transparency.indexed, I = this.image.interlaceMethod === 1;
                return this.image.decodePixels((f) => {
                  const S = a.alloc(this.width * this.height);
                  let iA = 0;
                  for (let YA = 0, XA = f.length; YA < XA; YA++)
                    S[iA++] = s[f[YA]];
                  return I && (this.imgData = x.default.deflateSync(a.from(f))), this.alphaChannel = x.default.deflateSync(S), this.finalize();
                });
              }
              decodeData() {
                this.image.decodePixels((s) => {
                  this.imgData = x.default.deflateSync(s), this.finalize();
                });
              }
            }
            class Ni {
              static open(s, I) {
                let f;
                if (a.isBuffer(s))
                  f = s;
                else if (s instanceof ArrayBuffer)
                  f = a.from(new Uint8Array(s));
                else {
                  const S = /^data:.+?;base64,(.*)$/.exec(s);
                  if (S)
                    f = a.from(S[1], "base64");
                  else if (f = eA.readFileSync(s), !f)
                    return;
                }
                if (f[0] === 255 && f[1] === 216)
                  return new ji(f, I);
                if (f[0] === 137 && f.toString("ascii", 1, 4) === "PNG")
                  return new pi(f, I);
                throw new Error("Unknown image format.");
              }
            }
            var vi = {
              initImages() {
                this._imageRegistry = {}, this._imageCount = 0;
              },
              image(g, s, I) {
                let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S, iA, YA, XA, oe, pe, xe, Qe, ke;
                typeof s == "object" && (f = s, s = null);
                const lt = f.ignoreOrientation || f.ignoreOrientation !== !1 && this.options.ignoreOrientation, Xe = typeof I != "number";
                s = (pe = s ?? f.x) != null ? pe : this.x, I = (xe = I ?? f.y) != null ? xe : this.y, typeof g == "string" && (XA = this._imageRegistry[g]), XA || (g.width && g.height ? XA = g : XA = this.openImage(g)), XA.obj || XA.embed(this), this.page.xobjects[XA.label] == null && (this.page.xobjects[XA.label] = XA.obj);
                let {
                  width: et,
                  height: Oe
                } = XA;
                !lt && XA.orientation > 4 && ([et, Oe] = [Oe, et]);
                let rt = f.width || et, $e = f.height || Oe;
                if (f.width && !f.height) {
                  const jt = rt / et;
                  rt = et * jt, $e = Oe * jt;
                } else if (f.height && !f.width) {
                  const jt = $e / Oe;
                  rt = et * jt, $e = Oe * jt;
                } else f.scale ? (rt = et * f.scale, $e = Oe * f.scale) : f.fit ? ([YA, S] = f.fit, iA = YA / S, oe = et / Oe, oe > iA ? (rt = YA, $e = YA / oe) : ($e = S, rt = S * oe)) : f.cover && ([YA, S] = f.cover, iA = YA / S, oe = et / Oe, oe > iA ? ($e = S, rt = S * oe) : (rt = YA, $e = YA / oe));
                (f.fit || f.cover) && (f.align === "center" ? s = s + YA / 2 - rt / 2 : f.align === "right" && (s = s + YA - rt), f.valign === "center" ? I = I + S / 2 - $e / 2 : f.valign === "bottom" && (I = I + S - $e));
                let wt = 0, Wt = s, $t = I, Gt = $e, ct = rt;
                if (lt)
                  Gt = -$e, $t += $e;
                else
                  switch (XA.orientation) {
                    default:
                    case 1:
                      Gt = -$e, $t += $e;
                      break;
                    case 2:
                      ct = -rt, Gt = -$e, Wt += rt, $t += $e;
                      break;
                    case 3:
                      Qe = s, ke = I, Gt = -$e, Wt -= rt, wt = 180;
                      break;
                    case 4:
                      break;
                    case 5:
                      Qe = s, ke = I, ct = $e, Gt = rt, $t -= Gt, wt = 90;
                      break;
                    case 6:
                      Qe = s, ke = I, ct = $e, Gt = -rt, wt = 90;
                      break;
                    case 7:
                      Qe = s, ke = I, Gt = -rt, ct = -$e, Wt += $e, wt = 90;
                      break;
                    case 8:
                      Qe = s, ke = I, ct = $e, Gt = -rt, Wt -= $e, $t += rt, wt = -90;
                      break;
                  }
                return f.link != null && this.link(s, I, rt, $e, f.link), f.goTo != null && this.goTo(s, I, rt, $e, f.goTo), f.destination != null && this.addNamedDestination(f.destination, "XYZ", s, I, null), Xe && (this.y += $e), this.save(), wt && this.rotate(wt, {
                  origin: [Qe, ke]
                }), this.transform(ct, 0, 0, Gt, Wt, $t), this.addContent(`/${XA.label} Do`), this.restore(), this;
              },
              openImage(g) {
                let s;
                return typeof g == "string" && (s = this._imageRegistry[g]), s || (s = Ni.open(g, `I${++this._imageCount}`), typeof g == "string" && (this._imageRegistry[g] = s)), s;
              }
            };
            class Wi {
              constructor(s) {
                this.annotationRef = s;
              }
            }
            var zn = {
              annotate(g, s, I, f, S) {
                S.Type = "Annot", S.Rect = this._convertRect(g, s, I, f), S.Border = [0, 0, 0], S.Subtype === "Link" && typeof S.F > "u" && (S.F = 4), S.Subtype !== "Link" && S.C == null && (S.C = this._normalizeColor(S.color || [0, 0, 0])), delete S.color, typeof S.Dest == "string" && (S.Dest = new String(S.Dest));
                const iA = S.structParent;
                delete S.structParent;
                for (let XA in S) {
                  const oe = S[XA];
                  S[XA[0].toUpperCase() + XA.slice(1)] = oe;
                }
                const YA = this.ref(S);
                if (this.page.annotations.push(YA), iA && typeof iA.add == "function") {
                  const XA = new Wi(YA);
                  iA.add(XA);
                }
                return YA.end(), this;
              },
              note(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return iA.Subtype = "Text", iA.Contents = new String(S), iA.Name == null && (iA.Name = "Comment"), iA.color == null && (iA.color = [243, 223, 92]), this.annotate(g, s, I, f, iA);
              },
              goTo(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return iA.Subtype = "Link", iA.A = this.ref({
                  S: "GoTo",
                  D: new String(S)
                }), iA.A.end(), this.annotate(g, s, I, f, iA);
              },
              link(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                if (iA.Subtype = "Link", typeof S == "number") {
                  const YA = this._root.data.Pages.data;
                  if (S >= 0 && S < YA.Kids.length)
                    iA.A = this.ref({
                      S: "GoTo",
                      D: [YA.Kids[S], "XYZ", null, null, null]
                    }), iA.A.end();
                  else
                    throw new Error(`The document has no page ${S}`);
                } else
                  iA.A = this.ref({
                    S: "URI",
                    URI: new String(S)
                  }), iA.A.end();
                return iA.structParent && !iA.Contents && (iA.Contents = new String("")), this.annotate(g, s, I, f, iA);
              },
              _markup(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                const [iA, YA, XA, oe] = this._convertRect(g, s, I, f);
                return S.QuadPoints = [iA, oe, XA, oe, iA, YA, XA, YA], S.Contents = new String(), this.annotate(g, s, I, f, S);
              },
              highlight(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "Highlight", S.color == null && (S.color = [241, 238, 148]), this._markup(g, s, I, f, S);
              },
              underline(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "Underline", this._markup(g, s, I, f, S);
              },
              strike(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "StrikeOut", this._markup(g, s, I, f, S);
              },
              lineAnnotation(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "Line", S.Contents = new String(), S.L = [g, this.page.height - s, I, this.page.height - f], this.annotate(g, s, I, f, S);
              },
              rectAnnotation(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "Square", S.Contents = new String(), this.annotate(g, s, I, f, S);
              },
              ellipseAnnotation(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return S.Subtype = "Circle", S.Contents = new String(), this.annotate(g, s, I, f, S);
              },
              textAnnotation(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return iA.Subtype = "FreeText", iA.Contents = new String(S), iA.DA = new String(), this.annotate(g, s, I, f, iA);
              },
              fileAnnotation(g, s, I, f) {
                let S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                const YA = this.file(S.src, Object.assign({
                  hidden: !0
                }, S));
                return iA.Subtype = "FileAttachment", iA.FS = YA, iA.Contents ? iA.Contents = new String(iA.Contents) : YA.data.Desc && (iA.Contents = YA.data.Desc), this.annotate(g, s, I, f, iA);
              },
              _convertRect(g, s, I, f) {
                let S = s;
                s += f;
                let iA = g + I;
                const [YA, XA, oe, pe, xe, Qe] = this._ctm;
                return g = YA * g + oe * s + xe, s = XA * g + pe * s + Qe, iA = YA * iA + oe * S + xe, S = XA * iA + pe * S + Qe, [g, s, iA, S];
              }
            };
            const Ri = {
              top: 0,
              left: 0,
              zoom: 0,
              fit: !0,
              pageNumber: null,
              expanded: !1
            };
            class nn {
              constructor(s, I, f, S) {
                let iA = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Ri;
                if (this.document = s, this.options = iA, this.outlineData = {}, S !== null) {
                  const YA = S.data.MediaBox[2], oe = S.data.MediaBox[3] - (iA.top || 0), pe = YA - (iA.left || 0), xe = iA.zoom || 0;
                  this.outlineData.Dest = iA.fit ? [S, "Fit"] : [S, "XYZ", pe, oe, xe];
                }
                I !== null && (this.outlineData.Parent = I), f !== null && (this.outlineData.Title = new String(f)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
              }
              addItem(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ri;
                const f = this.document._root.data.Pages.data.Kids, S = I.pageNumber != null ? f[I.pageNumber] : this.document.page.dictionary, iA = new nn(this.document, this.dictionary, s, S, I);
                return this.children.push(iA), iA;
              }
              endOutline() {
                if (this.children.length > 0) {
                  this.options.expanded && (this.outlineData.Count = this.children.length);
                  const s = this.children[0], I = this.children[this.children.length - 1];
                  this.outlineData.First = s.dictionary, this.outlineData.Last = I.dictionary;
                  for (let f = 0, S = this.children.length; f < S; f++) {
                    const iA = this.children[f];
                    f > 0 && (iA.outlineData.Prev = this.children[f - 1].dictionary), f < this.children.length - 1 && (iA.outlineData.Next = this.children[f + 1].dictionary), iA.endOutline();
                  }
                }
                return this.dictionary.end();
              }
            }
            var Tn = {
              initOutline() {
                this.outline = new nn(this, null, null, null);
              },
              endOutline() {
                if (this.outline.endOutline(), this.outline.children.length > 0)
                  return this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = this._root.data.PageMode || "UseOutlines";
              }
            };
            class rn {
              constructor(s, I) {
                this.refs = [{
                  pageRef: s,
                  mcid: I
                }];
              }
              push(s) {
                s.refs.forEach((I) => this.refs.push(I));
              }
            }
            class hi {
              constructor(s, I) {
                let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                this.document = s, this._attached = !1, this._ended = !1, this._flushed = !1, this.dictionary = s.ref({
                  S: I
                });
                const iA = this.dictionary.data;
                (Array.isArray(f) || this._isValidChild(f)) && (S = f, f = {}), typeof f.title < "u" && (iA.T = new String(f.title)), typeof f.lang < "u" && (iA.Lang = new String(f.lang)), typeof f.alt < "u" && (iA.Alt = new String(f.alt)), typeof f.expanded < "u" && (iA.E = new String(f.expanded)), typeof f.actual < "u" && (iA.ActualText = new String(f.actual)), this._children = [], S && (Array.isArray(S) || (S = [S]), S.forEach((YA) => this.add(YA)), this.end());
              }
              add(s) {
                if (this._ended)
                  throw new Error("Cannot add child to already-ended structure element");
                if (!this._isValidChild(s))
                  throw new Error("Invalid structure element child");
                return s instanceof hi && (s.setParent(this.dictionary), this._attached && s.setAttached()), s instanceof rn && this._addContentToParentTree(s), s instanceof Wi && this._addAnnotationToParentTree(s.annotationRef), typeof s == "function" && this._attached && (s = this._contentForClosure(s)), this._children.push(s), this;
              }
              _addContentToParentTree(s) {
                s.refs.forEach((I) => {
                  let {
                    pageRef: f,
                    mcid: S
                  } = I;
                  const iA = this.document.getStructParentTree().get(f.data.StructParents);
                  iA[S] = this.dictionary;
                });
              }
              _addAnnotationToParentTree(s) {
                const I = this.document.createStructParentTreeNextKey();
                s.data.StructParent = I, this.document.getStructParentTree().add(I, this.dictionary);
              }
              setParent(s) {
                if (this.dictionary.data.P)
                  throw new Error("Structure element added to more than one parent");
                this.dictionary.data.P = s, this._flush();
              }
              setAttached() {
                this._attached || (this._children.forEach((s, I) => {
                  s instanceof hi && s.setAttached(), typeof s == "function" && (this._children[I] = this._contentForClosure(s));
                }), this._attached = !0, this._flush());
              }
              end() {
                this._ended || (this._children.filter((s) => s instanceof hi).forEach((s) => s.end()), this._ended = !0, this._flush());
              }
              _isValidChild(s) {
                return s instanceof hi || s instanceof rn || s instanceof Wi || typeof s == "function";
              }
              _contentForClosure(s) {
                const I = this.document.markStructureContent(this.dictionary.data.S), f = this.document._currentStructureElement;
                this.document._currentStructureElement = this;
                const S = this._ended;
                return this._ended = !1, s(), this._ended = S, this.document._currentStructureElement = f, this.document.endMarkedContent(), this._addContentToParentTree(I), I;
              }
              _isFlushable() {
                return !this.dictionary.data.P || !this._ended ? !1 : this._children.every((s) => typeof s == "function" ? !1 : s instanceof hi ? s._isFlushable() : !0);
              }
              _flush() {
                this._flushed || !this._isFlushable() || (this.dictionary.data.K = [], this._children.forEach((s) => this._flushChild(s)), this.dictionary.end(), this._children = [], this.dictionary.data.K = null, this._flushed = !0);
              }
              _flushChild(s) {
                if (s instanceof hi && this.dictionary.data.K.push(s.dictionary), s instanceof rn && s.refs.forEach((I) => {
                  let {
                    pageRef: f,
                    mcid: S
                  } = I;
                  this.dictionary.data.Pg || (this.dictionary.data.Pg = f), this.dictionary.data.Pg === f ? this.dictionary.data.K.push(S) : this.dictionary.data.K.push({
                    Type: "MCR",
                    Pg: f,
                    MCID: S
                  });
                }), s instanceof Wi) {
                  const I = this.document.page.dictionary, f = {
                    Type: "OBJR",
                    Obj: s.annotationRef,
                    Pg: I
                  };
                  this.dictionary.data.K.push(f);
                }
              }
            }
            class In extends IA {
              _compareKeys(s, I) {
                return parseInt(s) - parseInt(I);
              }
              _keysName() {
                return "Nums";
              }
              _dataForKey(s) {
                return parseInt(s);
              }
            }
            var zr = {
              initMarkings(g) {
                this.structChildren = [], g.tagged && (this.getMarkInfoDictionary().data.Marked = !0, this.getStructTreeRoot());
              },
              markContent(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (g === "Artifact" || s && s.mcid) {
                  let f = 0;
                  for (this.page.markings.forEach((S) => {
                    (f || S.structContent || S.tag === "Artifact") && f++;
                  }); f--; )
                    this.endMarkedContent();
                }
                if (!s)
                  return this.page.markings.push({
                    tag: g
                  }), this.addContent(`/${g} BMC`), this;
                this.page.markings.push({
                  tag: g,
                  options: s
                });
                const I = {};
                return typeof s.mcid < "u" && (I.MCID = s.mcid), g === "Artifact" && (typeof s.type == "string" && (I.Type = s.type), Array.isArray(s.bbox) && (I.BBox = [s.bbox[0], this.page.height - s.bbox[3], s.bbox[2], this.page.height - s.bbox[1]]), Array.isArray(s.attached) && s.attached.every((f) => typeof f == "string") && (I.Attached = s.attached)), g === "Span" && (s.lang && (I.Lang = new String(s.lang)), s.alt && (I.Alt = new String(s.alt)), s.expanded && (I.E = new String(s.expanded)), s.actual && (I.ActualText = new String(s.actual))), this.addContent(`/${g} ${v.convert(I)} BDC`), this;
              },
              markStructureContent(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                const I = this.getStructParentTree().get(this.page.structParentTreeKey), f = I.length;
                I.push(null), this.markContent(g, {
                  ...s,
                  mcid: f
                });
                const S = new rn(this.page.dictionary, f);
                return this.page.markings.slice(-1)[0].structContent = S, S;
              },
              endMarkedContent() {
                return this.page.markings.pop(), this.addContent("EMC"), this._textOptions && (delete this._textOptions.link, delete this._textOptions.goTo, delete this._textOptions.destination, delete this._textOptions.underline, delete this._textOptions.strike), this;
              },
              struct(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                return new hi(this, g, s, I);
              },
              addStructure(g) {
                const s = this.getStructTreeRoot();
                return g.setParent(s), g.setAttached(), this.structChildren.push(g), s.data.K || (s.data.K = []), s.data.K.push(g.dictionary), this;
              },
              initPageMarkings(g) {
                g.forEach((s) => {
                  if (s.structContent) {
                    const I = s.structContent, f = this.markStructureContent(s.tag, s.options);
                    I.push(f), this.page.markings.slice(-1)[0].structContent = I;
                  } else
                    this.markContent(s.tag, s.options);
                });
              },
              endPageMarkings(g) {
                const s = g.markings;
                return s.forEach(() => g.write("EMC")), g.markings = [], s;
              },
              getMarkInfoDictionary() {
                return this._root.data.MarkInfo || (this._root.data.MarkInfo = this.ref({})), this._root.data.MarkInfo;
              },
              hasMarkInfoDictionary() {
                return !!this._root.data.MarkInfo;
              },
              getStructTreeRoot() {
                return this._root.data.StructTreeRoot || (this._root.data.StructTreeRoot = this.ref({
                  Type: "StructTreeRoot",
                  ParentTree: new In(),
                  ParentTreeNextKey: 0
                })), this._root.data.StructTreeRoot;
              },
              getStructParentTree() {
                return this.getStructTreeRoot().data.ParentTree;
              },
              createStructParentTreeNextKey() {
                this.getMarkInfoDictionary();
                const g = this.getStructTreeRoot(), s = g.data.ParentTreeNextKey++;
                return g.data.ParentTree.add(s, []), s;
              },
              endMarkings() {
                const g = this._root.data.StructTreeRoot;
                g && (g.end(), this.structChildren.forEach((s) => s.end())), this._root.data.MarkInfo && this._root.data.MarkInfo.end();
              }
            };
            const ir = {
              readOnly: 1,
              required: 2,
              noExport: 4,
              multiline: 4096,
              password: 8192,
              toggleToOffButton: 16384,
              radioButton: 32768,
              pushButton: 65536,
              combo: 131072,
              edit: 262144,
              sort: 524288,
              multiSelect: 2097152,
              noSpell: 4194304
            }, nr = {
              left: 0,
              center: 1,
              right: 2
            }, cn = {
              value: "V",
              defaultValue: "DV"
            }, rr = {
              zip: "0",
              zipPlus4: "1",
              zip4: "1",
              phone: "2",
              ssn: "3"
            }, sr = {
              number: {
                nDec: 0,
                sepComma: !1,
                negStyle: "MinusBlack",
                currency: "",
                currencyPrepend: !0
              },
              percent: {
                nDec: 0,
                sepComma: !1
              }
            };
            var ar = {
              initForm() {
                if (!this._font)
                  throw new Error("Must set a font before calling initForm method");
                this._acroform = {
                  fonts: {},
                  defaultFont: this._font.name
                }, this._acroform.fonts[this._font.id] = this._font.ref();
                let g = {
                  Fields: [],
                  NeedAppearances: !0,
                  DA: new String(`/${this._font.id} 0 Tf 0 g`),
                  DR: {
                    Font: {}
                  }
                };
                g.DR.Font[this._font.id] = this._font.ref();
                const s = this.ref(g);
                return this._root.data.AcroForm = s, this;
              },
              endAcroForm() {
                if (this._root.data.AcroForm) {
                  if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont)
                    throw new Error("No fonts specified for PDF form");
                  let g = this._root.data.AcroForm.data.DR.Font;
                  Object.keys(this._acroform.fonts).forEach((s) => {
                    g[s] = this._acroform.fonts[s];
                  }), this._root.data.AcroForm.data.Fields.forEach((s) => {
                    this._endChild(s);
                  }), this._root.data.AcroForm.end();
                }
                return this;
              },
              _endChild(g) {
                return Array.isArray(g.data.Kids) && (g.data.Kids.forEach((s) => {
                  this._endChild(s);
                }), g.end()), this;
              },
              formField(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I = this._fieldDict(g, null, s), f = this.ref(I);
                return this._addToParent(f), f;
              },
              formAnnotation(g, s, I, f, S, iA) {
                let YA = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, XA = this._fieldDict(g, s, YA);
                XA.Subtype = "Widget", XA.F === void 0 && (XA.F = 4), this.annotate(I, f, S, iA, XA);
                let oe = this.page.annotations[this.page.annotations.length - 1];
                return this._addToParent(oe);
              },
              formText(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "text", s, I, f, S, iA);
              },
              formPushButton(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "pushButton", s, I, f, S, iA);
              },
              formCombo(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "combo", s, I, f, S, iA);
              },
              formList(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "list", s, I, f, S, iA);
              },
              formRadioButton(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "radioButton", s, I, f, S, iA);
              },
              formCheckbox(g, s, I, f, S) {
                let iA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                return this.formAnnotation(g, "checkbox", s, I, f, S, iA);
              },
              _addToParent(g) {
                let s = g.data.Parent;
                return s ? (s.data.Kids || (s.data.Kids = []), s.data.Kids.push(g)) : this._root.data.AcroForm.data.Fields.push(g), this;
              },
              _fieldDict(g, s) {
                let I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (!this._acroform)
                  throw new Error("Call document.initForm() method before adding form elements to document");
                let f = Object.assign({}, I);
                return s !== null && (f = this._resolveType(s, I)), f = this._resolveFlags(f), f = this._resolveJustify(f), f = this._resolveFont(f), f = this._resolveStrings(f), f = this._resolveColors(f), f = this._resolveFormat(f), f.T = new String(g), f.parent && (f.Parent = f.parent, delete f.parent), f;
              },
              _resolveType(g, s) {
                if (g === "text")
                  s.FT = "Tx";
                else if (g === "pushButton")
                  s.FT = "Btn", s.pushButton = !0;
                else if (g === "radioButton")
                  s.FT = "Btn", s.radioButton = !0;
                else if (g === "checkbox")
                  s.FT = "Btn";
                else if (g === "combo")
                  s.FT = "Ch", s.combo = !0;
                else if (g === "list")
                  s.FT = "Ch";
                else
                  throw new Error(`Invalid form annotation type '${g}'`);
                return s;
              },
              _resolveFormat(g) {
                const s = g.format;
                if (s && s.type) {
                  let I, f, S = "";
                  if (rr[s.type] !== void 0)
                    I = "AFSpecial_Keystroke", f = "AFSpecial_Format", S = rr[s.type];
                  else {
                    let iA = s.type.charAt(0).toUpperCase() + s.type.slice(1);
                    if (I = `AF${iA}_Keystroke`, f = `AF${iA}_Format`, s.type === "date")
                      I += "Ex", S = String(s.param);
                    else if (s.type === "time")
                      S = String(s.param);
                    else if (s.type === "number") {
                      let YA = Object.assign({}, sr.number, s);
                      S = String([String(YA.nDec), YA.sepComma ? "0" : "1", '"' + YA.negStyle + '"', "null", '"' + YA.currency + '"', String(YA.currencyPrepend)].join(","));
                    } else if (s.type === "percent") {
                      let YA = Object.assign({}, sr.percent, s);
                      S = String([String(YA.nDec), YA.sepComma ? "0" : "1"].join(","));
                    }
                  }
                  g.AA = g.AA ? g.AA : {}, g.AA.K = {
                    S: "JavaScript",
                    JS: new String(`${I}(${S});`)
                  }, g.AA.F = {
                    S: "JavaScript",
                    JS: new String(`${f}(${S});`)
                  };
                }
                return delete g.format, g;
              },
              _resolveColors(g) {
                let s = this._normalizeColor(g.backgroundColor);
                return s && (g.MK || (g.MK = {}), g.MK.BG = s), s = this._normalizeColor(g.borderColor), s && (g.MK || (g.MK = {}), g.MK.BC = s), delete g.backgroundColor, delete g.borderColor, g;
              },
              _resolveFlags(g) {
                let s = 0;
                return Object.keys(g).forEach((I) => {
                  ir[I] && (g[I] && (s |= ir[I]), delete g[I]);
                }), s !== 0 && (g.Ff = g.Ff ? g.Ff : 0, g.Ff |= s), g;
              },
              _resolveJustify(g) {
                let s = 0;
                return g.align !== void 0 && (typeof nr[g.align] == "number" && (s = nr[g.align]), delete g.align), s !== 0 && (g.Q = s), g;
              },
              _resolveFont(g) {
                if (this._acroform.fonts[this._font.id] == null && (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
                  g.DR = {
                    Font: {}
                  };
                  const s = g.fontSize || 0;
                  g.DR.Font[this._font.id] = this._font.ref(), g.DA = new String(`/${this._font.id} ${s} Tf 0 g`);
                }
                return g;
              },
              _resolveStrings(g) {
                let s = [];
                function I(f) {
                  if (Array.isArray(f))
                    for (let S = 0; S < f.length; S++)
                      typeof f[S] == "string" ? s.push(new String(f[S])) : s.push(f[S]);
                }
                return I(g.Opt), g.select && (I(g.select), delete g.select), s.length && (g.Opt = s), Object.keys(cn).forEach((f) => {
                  g[f] !== void 0 && (g[cn[f]] = g[f], delete g[f]);
                }), ["V", "DV"].forEach((f) => {
                  typeof g[f] == "string" && (g[f] = new String(g[f]));
                }), g.MK && g.MK.CA && (g.MK.CA = new String(g.MK.CA)), g.label && (g.MK = g.MK ? g.MK : {}, g.MK.CA = new String(g.label), delete g.label), g;
              }
            }, Tr = {
              file(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                s.name = s.name || g, s.relationship = s.relationship || "Unspecified";
                const I = {
                  Type: "EmbeddedFile",
                  Params: {}
                };
                let f;
                if (!g)
                  throw new Error("No src specified");
                if (a.isBuffer(g))
                  f = g;
                else if (g instanceof ArrayBuffer)
                  f = a.from(new Uint8Array(g));
                else {
                  const pe = /^data:(.*?);base64,(.*)$/.exec(g);
                  if (pe)
                    pe[1] && (I.Subtype = pe[1].replace("/", "#2F")), f = a.from(pe[2], "base64");
                  else {
                    if (f = eA.readFileSync(g), !f)
                      throw new Error(`Could not read contents of file at filepath ${g}`);
                    const {
                      birthtime: xe,
                      ctime: Qe
                    } = eA.statSync(g);
                    I.Params.CreationDate = xe, I.Params.ModDate = Qe;
                  }
                }
                s.creationDate instanceof Date && (I.Params.CreationDate = s.creationDate), s.modifiedDate instanceof Date && (I.Params.ModDate = s.modifiedDate), s.type && (I.Subtype = s.type.replace("/", "#2F"));
                const S = o(new Uint8Array(f));
                I.Params.CheckSum = new String(S), I.Params.Size = f.byteLength;
                let iA;
                this._fileRegistry || (this._fileRegistry = {});
                let YA = this._fileRegistry[s.name];
                YA && Ur(I, YA) ? iA = YA.ref : (iA = this.ref(I), iA.end(f), this._fileRegistry[s.name] = {
                  ...I,
                  ref: iA
                });
                const XA = {
                  Type: "Filespec",
                  AFRelationship: s.relationship,
                  F: new String(s.name),
                  EF: {
                    F: iA
                  },
                  UF: new String(s.name)
                };
                s.description && (XA.Desc = new String(s.description));
                const oe = this.ref(XA);
                return oe.end(), s.hidden || this.addNamedEmbeddedFile(s.name, oe), this._root.data.AF ? this._root.data.AF.push(oe) : this._root.data.AF = [oe], oe;
              }
            };
            function Ur(g, s) {
              return g.Subtype === s.Subtype && g.Params.CheckSum.toString() === s.Params.CheckSum.toString() && g.Params.Size === s.Params.Size && g.Params.CreationDate.getTime() === s.Params.CreationDate.getTime() && (g.Params.ModDate === void 0 && s.Params.ModDate === void 0 || g.Params.ModDate.getTime() === s.Params.ModDate.getTime());
            }
            var Nr = {
              initPDFA(g) {
                g.charAt(g.length - 3) === "-" ? (this.subset_conformance = g.charAt(g.length - 1).toUpperCase(), this.subset = parseInt(g.charAt(g.length - 2))) : (this.subset_conformance = "B", this.subset = parseInt(g.charAt(g.length - 1)));
              },
              endSubset() {
                this._addPdfaMetadata(), this._addColorOutputIntent();
              },
              _addColorOutputIntent() {
                const g = a("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", "base64"), s = this.ref({
                  Length: g.length,
                  N: 3
                });
                s.write(g), s.end();
                const I = this.ref({
                  Type: "OutputIntent",
                  S: "GTS_PDFA1",
                  Info: new String("sRGB IEC61966-2.1"),
                  OutputConditionIdentifier: new String("sRGB IEC61966-2.1"),
                  DestOutputProfile: s
                });
                I.end(), this._root.data.OutputIntents = [I];
              },
              _getPdfaid() {
                return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>${this.subset}</pdfaid:part>
            <pdfaid:conformance>${this.subset_conformance}</pdfaid:conformance>
        </rdf:Description>
        `;
              },
              _addPdfaMetadata() {
                this.appendXML(this._getPdfaid());
              }
            }, Rr = {
              initPDFUA() {
                this.subset = 1;
              },
              endSubset() {
                this._addPdfuaMetadata();
              },
              _addPdfuaMetadata() {
                this.appendXML(this._getPdfuaid());
              },
              _getPdfuaid() {
                return `
        <rdf:Description xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/" rdf:about="">
            <pdfuaid:part>${this.subset}</pdfuaid:part>
        </rdf:Description>
        `;
              }
            }, Sr = {
              _importSubset(g) {
                Object.assign(this, g);
              },
              initSubset(g) {
                switch (g.subset) {
                  case "PDF/A-1":
                  case "PDF/A-1a":
                  case "PDF/A-1b":
                  case "PDF/A-2":
                  case "PDF/A-2a":
                  case "PDF/A-2b":
                  case "PDF/A-3":
                  case "PDF/A-3a":
                  case "PDF/A-3b":
                    this._importSubset(Nr), this.initPDFA(g.subset);
                    break;
                  case "PDF/UA":
                    this._importSubset(Rr), this.initPDFUA();
                    break;
                }
              }
            };
            const or = ["height", "minHeight", "maxHeight"], Gr = ["width", "minWidth", "maxWidth"];
            function Br(g, s) {
              const I = /* @__PURE__ */ new Map();
              return function() {
                const f = arguments.length <= 0 ? void 0 : arguments[0];
                return I.has(f) || (I.set(f, g(...arguments)), I.size > s && I.delete(I.keys().next())), I.get(f);
              };
            }
            function Un(g) {
              return g && typeof g == "object" && !Array.isArray(g);
            }
            function yn(g) {
              if (!Un(g)) return g;
              g = Jn(g);
              for (var s = arguments.length, I = new Array(s > 1 ? s - 1 : 0), f = 1; f < s; f++)
                I[f - 1] = arguments[f];
              for (const S of I)
                if (Un(S))
                  for (const iA in S)
                    Un(S[iA]) ? (iA in g || (g[iA] = {}), g[iA] = yn(g[iA], S[iA])) : S[iA] !== void 0 && (g[iA] = Jn(S[iA]));
              return g;
            }
            function Jn(g) {
              let s = g;
              if (g && typeof g == "object") {
                s = Array.isArray(g) ? [] : {};
                for (const I in g) s[I] = Jn(g[I]);
              }
              return s;
            }
            function Hr(g) {
              let s = g;
              typeof s != "object" && (s = {
                text: s
              });
              const I = Object.fromEntries(Object.entries(s).filter((S) => {
                let [iA] = S;
                return or.includes(iA);
              })), f = Object.fromEntries(Object.entries(s).filter((S) => {
                let [iA] = S;
                return Gr.includes(iA);
              }));
              return s.padding = $A(s.padding), s.border = $A(s.border), s.borderColor = $A(s.borderColor), s.align = qi(s.align), {
                defaultStyle: s,
                defaultRowStyle: I,
                defaultColStyle: f
              };
            }
            function gr(g, s, I) {
              let f = s(I);
              (f == null || typeof f != "object") && (f = {
                height: f
              }), f.padding = $A(f.padding), f.border = $A(f.border), f.borderColor = $A(f.borderColor), f.align = qi(f.align), f = yn(g, f);
              const S = this.document, iA = S.page, YA = iA.contentHeight;
              return f.height == null || f.height === "auto" ? f.height = "auto" : f.height = S.sizeToPoint(f.height, 0, iA, YA), f.minHeight = S.sizeToPoint(f.minHeight, 0, iA, YA), f.maxHeight = S.sizeToPoint(f.maxHeight, 0, iA, YA), f;
            }
            function Lr(g, s, I) {
              let f = s(I);
              return (f == null || typeof f != "object") && (f = {
                width: f
              }), f.padding = $A(f.padding), f.border = $A(f.border), f.borderColor = $A(f.borderColor), f.align = qi(f.align), f = yn(g, f), f.width == null || f.width === "*" ? f.width = "*" : f.width = this.document.sizeToPoint(f.width, 0, this.document.page, this._maxWidth), f.minWidth = this.document.sizeToPoint(f.minWidth, 0, this.document.page, this._maxWidth), f.maxWidth = this.document.sizeToPoint(f.maxWidth, 0, this.document.page, this._maxWidth), f;
            }
            function qi(g) {
              return g == null || typeof g == "string" ? {
                x: g,
                y: g
              } : g;
            }
            function kr() {
              const g = this.document, s = this.opts;
              let I = g._tableIndex++;
              this._id = new String(s.id ?? `table-${I}`), this._position = {
                x: g.sizeToPoint(s.position?.x, g.x),
                y: g.sizeToPoint(s.position?.y, g.y)
              }, this._maxWidth = g.sizeToPoint(s.maxWidth, g.page.width - g.page.margins.right - this._position.x);
              const {
                defaultStyle: f,
                defaultColStyle: S,
                defaultRowStyle: iA
              } = Hr(s.defaultStyle);
              this._defaultStyle = f;
              let YA;
              s.columnStyles && (Array.isArray(s.columnStyles) ? YA = (oe) => s.columnStyles[oe] : typeof s.columnStyles == "function" ? YA = Br((oe) => s.columnStyles(oe), 1 / 0) : typeof s.columnStyles == "object" && (YA = () => s.columnStyles)), YA || (YA = () => ({})), this._colStyle = Lr.bind(this, S, YA);
              let XA;
              s.rowStyles && (Array.isArray(s.rowStyles) ? XA = (oe) => s.rowStyles[oe] : typeof s.rowStyles == "function" ? XA = Br((oe) => s.rowStyles(oe), 10) : typeof s.rowStyles == "object" && (XA = () => s.rowStyles)), XA || (XA = () => ({})), this._rowStyle = gr.bind(this, iA, XA);
            }
            function ln(g) {
              return g != null && (g = `${g}`), g;
            }
            function jr(g, s, I) {
              const f = this._colStyle(I);
              let S = this._rowStyle(s);
              const iA = yn({}, f.font, S.font, g.font), YA = Object.values(iA).filter((ke) => ke != null).length > 0, XA = this.document, oe = XA._fontSource, pe = XA._fontSize, xe = XA._fontFamily;
              YA && (iA.src && XA.font(iA.src, iA.family), iA.size && XA.fontSize(iA.size), S = this._rowStyle(s)), g.padding = $A(g.padding), g.border = $A(g.border), g.borderColor = $A(g.borderColor);
              const Qe = yn(this._defaultStyle, f, S, g);
              return Qe.rowIndex = s, Qe.colIndex = I, Qe.font = iA ?? {}, Qe.customFont = YA, Qe.text = ln(Qe.text), Qe.rowSpan = Qe.rowSpan ?? 1, Qe.colSpan = Qe.colSpan ?? 1, Qe.padding = $A(Qe.padding, "0.25em", (ke) => XA.sizeToPoint(ke, "0.25em")), Qe.border = $A(Qe.border, 1, (ke) => XA.sizeToPoint(ke, 1)), Qe.borderColor = $A(Qe.borderColor, "black", (ke) => ke ?? "black"), Qe.align = qi(Qe.align), Qe.align.x = Qe.align.x ?? "left", Qe.align.y = Qe.align.y ?? "top", Qe.textStroke = XA.sizeToPoint(Qe.textStroke, 0), Qe.textStrokeColor = Qe.textStrokeColor ?? "black", Qe.textColor = Qe.textColor ?? "black", Qe.textOptions = Qe.textOptions ?? {}, Qe.id = new String(Qe.id ?? `${this._id}-${s}-${I}`), Qe.type = Qe.type?.toUpperCase() === "TH" ? "TH" : "TD", Qe.scope && (Qe.scope = Qe.scope.toLowerCase(), Qe.scope === "row" ? Qe.scope = "Row" : Qe.scope === "both" ? Qe.scope = "Both" : Qe.scope === "column" && (Qe.scope = "Column")), typeof this.opts.debug == "boolean" && (Qe.debug = this.opts.debug), YA && XA.font(oe, xe, pe), Qe;
            }
            function Or(g, s) {
              this._cellClaim || (this._cellClaim = /* @__PURE__ */ new Set());
              let I = 0;
              return g.map((f) => {
                for ((f == null || typeof f != "object") && (f = {
                  text: f
                }); this._cellClaim.has(`${s},${I}`); )
                  I++;
                f = jr.call(this, f, s, I);
                for (let S = 0; S < f.rowSpan; S++)
                  for (let iA = 0; iA < f.colSpan; iA++)
                    this._cellClaim.add(`${s + S},${I + iA}`);
                return I += f.colSpan, f;
              });
            }
            function Jr(g) {
              this._columnWidths = [], Fn.call(this, g.reduce((s, I) => s + I.colSpan, 0)), this._rowHeights = [], this._rowYPos = [this._position.y], this._rowBuffer = /* @__PURE__ */ new Set();
            }
            function Fn(g) {
              let s = [], I = 0, f = this._maxWidth;
              for (let YA = 0; YA < g; YA++) {
                let XA = this._colStyle(YA);
                XA.width === "*" ? (s[YA] = XA, I += XA.minWidth) : (f -= XA.width, this._columnWidths[YA] = XA.width);
              }
              let S = s.reduce((YA) => YA + 1, 0);
              I >= f ? s.forEach((YA, XA) => {
                this._columnWidths[XA] = YA.minWidth;
              }) : S > 0 && s.forEach((YA, XA) => {
                let oe = f / S;
                this._columnWidths[XA] = Math.max(oe, YA.minWidth), YA.maxWidth > 0 && (this._columnWidths[XA] = Math.min(this._columnWidths[XA], YA.maxWidth)), f -= this._columnWidths[XA], S--;
              });
              let iA = this._position.x;
              this._columnXPos = Array.from(this._columnWidths, (YA) => {
                const XA = iA;
                return iA += YA, XA;
              });
            }
            function Kr(g, s) {
              g.forEach((YA) => this._rowBuffer.add(YA)), s > 0 && (this._rowYPos[s] = this._rowYPos[s - 1] + this._rowHeights[s - 1]);
              const I = this._rowStyle(s);
              let f = [];
              this._rowBuffer.forEach((YA) => {
                YA.rowIndex + YA.rowSpan - 1 === s && (f.push(cr.call(this, YA, I.height)), this._rowBuffer.delete(YA));
              });
              let S = I.height;
              S === "auto" && (S = f.reduce((YA, XA) => {
                let oe = XA.textBounds.height + XA.padding.top + XA.padding.bottom;
                for (let pe = 0; pe < XA.rowSpan - 1; pe++)
                  oe -= this._rowHeights[XA.rowIndex + pe];
                return Math.max(YA, oe);
              }, 0)), S = Math.max(S, I.minHeight), I.maxHeight > 0 && (S = Math.min(S, I.maxHeight)), this._rowHeights[s] = S;
              let iA = !1;
              return S > this.document.page.contentHeight ? (console.warn(new Error(`Row ${s} requested more than the safe page height, row has been clamped`).stack.slice(7)), this._rowHeights[s] = this.document.page.maxY() - this._rowYPos[s]) : this._rowYPos[s] + S >= this.document.page.maxY() && (this._rowYPos[s] = this.document.page.margins.top, iA = !0), {
                newPage: iA,
                toRender: f.map((YA) => cr.call(this, YA, S))
              };
            }
            function cr(g, s) {
              let I = 0;
              for (let Qe = 0; Qe < g.colSpan; Qe++)
                I += this._columnWidths[g.colIndex + Qe];
              let f = s;
              if (f === "auto")
                f = this.document.page.contentHeight;
              else
                for (let Qe = 0; Qe < g.rowSpan - 1; Qe++)
                  f += this._rowHeights[g.rowIndex + Qe];
              const S = I - g.padding.left - g.padding.right, iA = f - g.padding.top - g.padding.bottom, YA = g.textOptions.rotation ?? 0, {
                width: XA,
                height: oe
              } = Kn(YA, S, iA), pe = {
                align: g.align.x,
                ellipsis: !0,
                stroke: g.textStroke > 0,
                fill: !0,
                width: XA,
                height: oe,
                rotation: YA,
                ...g.textOptions
              };
              let xe = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
              };
              if (g.text) {
                const Qe = this.document._fontSource, ke = this.document._fontSize, lt = this.document._fontFamily;
                g.font?.src && this.document.font(g.font.src, g.font?.family), g.font?.size && this.document.fontSize(g.font.size);
                const Xe = this.document.boundsOfString(g.text, 0, 0, {
                  ...pe,
                  rotation: 0
                });
                pe.width = Xe.width, pe.height = Xe.height, xe = this.document.boundsOfString(g.text, 0, 0, pe), this.document.font(Qe, lt, ke);
              }
              return {
                ...g,
                textOptions: pe,
                x: this._columnXPos[g.colIndex],
                y: this._rowYPos[g.rowIndex],
                textX: this._columnXPos[g.colIndex] + g.padding.left,
                textY: this._rowYPos[g.rowIndex] + g.padding.top,
                width: I,
                height: f,
                textAllocatedHeight: iA,
                textAllocatedWidth: S,
                textBounds: xe
              };
            }
            function Kn(g, s, I) {
              let f, S;
              const iA = xA(g), YA = LA(g);
              g === 0 || g === 180 ? (f = s, S = I) : g === 90 || g === 270 ? (f = I, S = s) : g < 90 || g > 180 && g < 270 ? (f = s / (2 * iA), S = s / (2 * YA)) : (S = s / (2 * iA), f = s / (2 * YA));
              const XA = YA * f, oe = iA * S;
              if (XA + oe > I) {
                const pe = iA * iA - YA * YA;
                g === 0 || g === 180 ? (f = s, S = I) : g === 90 || g === 270 ? (f = I, S = s) : g < 90 || g > 180 && g < 270 ? (f = (s * iA - I * YA) / pe, S = (I * iA - s * YA) / pe) : (S = (s * iA - I * YA) / pe, f = (I * iA - s * YA) / pe);
              }
              return {
                width: Math.abs(f),
                height: Math.abs(S)
              };
            }
            function Wr() {
              const g = this.opts.structParent;
              g && (this._tableStruct = this.document.struct("Table"), this._tableStruct.dictionary.data.ID = this._id, g instanceof hi ? g.add(this._tableStruct) : g instanceof ye && g.addStructure(this._tableStruct), this._headerRowLookup = {}, this._headerColumnLookup = {});
            }
            function NA() {
              this._tableStruct && this._tableStruct.end();
            }
            function t(g, s, I) {
              const f = this.document.struct("TR");
              f.dictionary.data.ID = new String(`${this._id}-${s}`), this._tableStruct.add(f), g.forEach((S) => I(S, f)), f.end();
            }
            function C(g, s, I) {
              const f = this.document, S = f.struct(g.type, {
                title: g.title
              });
              S.dictionary.data.ID = g.id, s.add(S);
              const iA = g.padding, YA = g.border, XA = {
                O: "Table",
                Width: g.width,
                Height: g.height,
                Padding: [iA.top, iA.bottom, iA.left, iA.right],
                RowSpan: g.rowSpan > 1 ? g.rowSpan : void 0,
                ColSpan: g.colSpan > 1 ? g.colSpan : void 0,
                BorderThickness: [YA.top, YA.bottom, YA.left, YA.right]
              };
              if (g.type === "TH") {
                if (g.scope === "Row" || g.scope === "Both") {
                  for (let Qe = 0; Qe < g.rowSpan; Qe++)
                    this._headerRowLookup[g.rowIndex + Qe] || (this._headerRowLookup[g.rowIndex + Qe] = []), this._headerRowLookup[g.rowIndex + Qe].push(g.id);
                  XA.Scope = g.scope;
                }
                if (g.scope === "Column" || g.scope === "Both") {
                  for (let Qe = 0; Qe < g.colSpan; Qe++)
                    this._headerColumnLookup[g.colIndex + Qe] || (this._headerColumnLookup[g.colIndex + Qe] = []), this._headerColumnLookup[g.colIndex + Qe].push(g.id);
                  XA.Scope = g.scope;
                }
              }
              const oe = new Set([...Array.from({
                length: g.colSpan
              }, (Qe, ke) => this._headerColumnLookup[g.colIndex + ke]).flat(), ...Array.from({
                length: g.rowSpan
              }, (Qe, ke) => this._headerRowLookup[g.rowIndex + ke]).flat()].filter(Boolean));
              oe.size && (XA.Headers = Array.from(oe));
              const pe = f._normalizeColor;
              g.backgroundColor != null && (XA.BackgroundColor = pe(g.backgroundColor));
              const xe = [YA.top, YA.bottom, YA.left, YA.right];
              if (xe.some((Qe) => Qe)) {
                const Qe = g.borderColor;
                XA.BorderColor = [xe[0] ? pe(Qe.top) : null, xe[1] ? pe(Qe.bottom) : null, xe[2] ? pe(Qe.left) : null, xe[3] ? pe(Qe.right) : null];
              }
              Object.keys(XA).forEach((Qe) => XA[Qe] === void 0 && delete XA[Qe]), S.dictionary.data.A = f.ref(XA), S.add(I), S.end(), S.dictionary.data.A.end();
            }
            function b(g, s) {
              return this._tableStruct ? t.call(this, g, s, nA.bind(this)) : g.forEach((I) => nA.call(this, I)), this._rowYPos[s] + this._rowHeights[s];
            }
            function nA(g, s) {
              const I = () => {
                g.backgroundColor != null && this.document.save().fillColor(g.backgroundColor).rect(g.x, g.y, g.width, g.height).fill().restore(), hA.call(this, g.border, g.borderColor, g.x, g.y, g.width, g.height), g.debug && (this.document.save(), this.document.dash(1, {
                  space: 1
                }).lineWidth(1).strokeOpacity(0.3), this.document.rect(g.x, g.y, g.width, g.height).stroke("green"), this.document.restore()), g.text && gA.call(this, g);
              };
              s ? C.call(this, g, s, I) : I();
            }
            function gA(g) {
              const s = this.document, I = s._fontSource, f = s._fontSize, S = s._fontFamily;
              g.customFont && (g.font.src && s.font(g.font.src, g.font.family), g.font.size && s.fontSize(g.font.size));
              const iA = g.textX, YA = g.textY, XA = g.textAllocatedHeight, oe = g.textAllocatedWidth, pe = g.textBounds.width, xe = g.textBounds.height, Qe = -g.textBounds.x, ke = -g.textBounds.y, lt = g.align.x === "right" ? 1 : g.align.x === "center" ? 0.5 : 0, Xe = (oe - pe) * lt, et = g.align.y === "bottom" ? 1 : g.align.y === "center" ? 0.5 : 0, Oe = (XA - xe) * et, rt = Xe + Qe, $e = Oe + ke;
              g.debug && (s.save(), s.dash(1, {
                space: 1
              }).lineWidth(1).strokeOpacity(0.3), g.text && s.moveTo(iA + Xe, YA).lineTo(iA + Xe, YA + XA).moveTo(iA + Xe + pe, YA).lineTo(iA + Xe + pe, YA + XA).stroke("blue").moveTo(iA, YA + Oe).lineTo(iA + oe, YA + Oe).moveTo(iA, YA + Oe + xe).lineTo(iA + oe, YA + Oe + xe).stroke("green"), s.rect(iA, YA, oe, XA).stroke("orange"), s.restore()), s.save().rect(iA, YA, oe, XA).clip(), s.fillColor(g.textColor).strokeColor(g.textStrokeColor), g.textStroke > 0 && s.lineWidth(g.textStroke), s.text(g.text, iA + rt, YA + $e, g.textOptions), s.restore(), g.font && s.font(I, S, f);
            }
            function hA(g, s, I, f, S, iA, YA) {
              g = Object.fromEntries(Object.entries(g).map((oe) => {
                let [pe, xe] = oe;
                return [pe, YA && !YA[pe] ? 0 : xe];
              }));
              const XA = this.document;
              [g.right, g.bottom, g.left].every((oe) => oe === g.top) ? g.top > 0 && XA.save().lineWidth(g.top).strokeColor(s.top).rect(I, f, S, iA).stroke().restore() : (g.top > 0 && XA.save().lineWidth(g.top).moveTo(I, f).strokeColor(s.top).lineTo(I + S, f).stroke().restore(), g.right > 0 && XA.save().lineWidth(g.right).moveTo(I + S, f).strokeColor(s.right).lineTo(I + S, f + iA).stroke().restore(), g.bottom > 0 && XA.save().lineWidth(g.bottom).moveTo(I + S, f + iA).strokeColor(s.bottom).lineTo(I, f + iA).stroke().restore(), g.left > 0 && XA.save().lineWidth(g.left).moveTo(I, f + iA).strokeColor(s.left).lineTo(I, f).stroke().restore());
            }
            class HA {
              constructor(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.document = s, this.opts = Object.freeze(I), kr.call(this), Wr.call(this), this._currRowIndex = 0, this._ended = !1, I.data) {
                  for (const f of I.data) this.row(f);
                  return this.end();
                }
              }
              row(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (this._ended)
                  throw new Error(`Table was marked as ended on row ${this._currRowIndex}`);
                s = Array.from(s), s = Or.call(this, s, this._currRowIndex), this._currRowIndex === 0 && Jr.call(this, s);
                const {
                  newPage: f,
                  toRender: S
                } = Kr.call(this, s, this._currRowIndex);
                f && this.document.continueOnNewPage();
                const iA = b.call(this, S, this._currRowIndex);
                return this.document.x = this._position.x, this.document.y = iA, I ? this.end() : (this._currRowIndex++, this);
              }
              end() {
                for (; this._rowBuffer?.size; ) this.row([]);
                return this._ended = !0, NA.call(this), this.document;
              }
            }
            var GA = {
              initTables() {
                this._tableIndex = 0;
              },
              table(g) {
                return new HA(this, g);
              }
            };
            class fe {
              constructor() {
                this._metadata = `
        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
              }
              _closeTags() {
                this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
              }
              append(s) {
                let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                this._metadata = this._metadata.concat(s), I && (this._metadata = this._metadata.concat(`
`));
              }
              getXML() {
                return this._metadata;
              }
              getLength() {
                return this._metadata.length;
              }
              end() {
                this._closeTags(), this._metadata = this._metadata.trim();
              }
            }
            var we = {
              initMetadata() {
                this.metadata = new fe();
              },
              appendXML(g) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                this.metadata.append(g, s);
              },
              _addInfo() {
                this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>${this.info.CreationDate.toISOString().split(".")[0] + "Z"}</xmp:CreateDate>
            <xmp:CreatorTool>${this.info.Creator}</xmp:CreatorTool>
        </rdf:Description>
        `), (this.info.Title || this.info.Author || this.info.Subject) && (this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `), this.info.Title && this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Title}</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `), this.info.Author && this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>${this.info.Author}</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `), this.info.Subject && this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Subject}</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `), this.appendXML(`
            </rdf:Description>
            `)), this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${this.info.Creator}</pdf:Producer>`, !1), this.info.Keywords && this.appendXML(`
            <pdf:Keywords>${this.info.Keywords}</pdf:Keywords>`, !1), this.appendXML(`
        </rdf:Description>
        `);
              },
              endMetadata() {
                this._addInfo(), this.metadata.end(), this.version != 1.3 && (this.metadataRef = this.ref({
                  length: this.metadata.getLength(),
                  Type: "Metadata",
                  Subtype: "XML"
                }), this.metadataRef.compress = !1, this.metadataRef.write(a.from(this.metadata.getXML(), "utf-8")), this.metadataRef.end(), this._root.data.Metadata = this.metadataRef);
              }
            };
            class ye extends d.default.Readable {
              constructor() {
                let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                switch (super(s), this.options = s, s.pdfVersion) {
                  case "1.4":
                    this.version = 1.4;
                    break;
                  case "1.5":
                    this.version = 1.5;
                    break;
                  case "1.6":
                    this.version = 1.6;
                    break;
                  case "1.7":
                  case "1.7ext3":
                    this.version = 1.7;
                    break;
                  default:
                    this.version = 1.3;
                    break;
                }
                this.compress = this.options.compress != null ? this.options.compress : !0, this._pageBuffer = [], this._pageBufferStart = 0, this._offsets = [], this._waiting = 0, this._ended = !1, this._offset = 0;
                const I = this.ref({
                  Type: "Pages",
                  Count: 0,
                  Kids: []
                }), f = this.ref({
                  Dests: new sA()
                });
                if (this._root = this.ref({
                  Type: "Catalog",
                  Pages: I,
                  Names: f
                }), this.options.lang && (this._root.data.Lang = new String(this.options.lang)), this.options.pageLayout) {
                  const S = this.options.pageLayout;
                  this._root.data.PageLayout = S.charAt(0).toUpperCase() + S.slice(1);
                }
                if (this.page = null, this.initMetadata(), this.initColor(), this.initVector(), this.initFonts(s.font), this.initText(), this.initImages(), this.initOutline(), this.initMarkings(s), this.initTables(), this.initSubset(s), this.info = {
                  Producer: "PDFKit",
                  Creator: "PDFKit",
                  CreationDate: /* @__PURE__ */ new Date()
                }, this.options.info)
                  for (let S in this.options.info) {
                    const iA = this.options.info[S];
                    this.info[S] = iA;
                  }
                this.options.displayTitle && (this._root.data.ViewerPreferences = this.ref({
                  DisplayDocTitle: !0
                })), this._id = pA.generateFileID(this.info), this._security = pA.create(this, s), this._write(`%PDF-${this.version}`), this._write("%ÿÿÿÿ"), this.options.autoFirstPage !== !1 && this.addPage();
              }
              addPage(s) {
                s == null && ({
                  options: s
                } = this), this.options.bufferPages || this.flushPages(), this.page = new fA(this, s), this._pageBuffer.push(this.page);
                const I = this._root.data.Pages.data;
                return I.Kids.push(this.page.dictionary), I.Count++, this.x = this.page.margins.left, this.y = this.page.margins.top, this._ctm = [1, 0, 0, 1, 0, 0], this.transform(1, 0, 0, -1, 0, this.page.height), this.emit("pageAdded"), this;
              }
              continueOnNewPage(s) {
                const I = this.endPageMarkings(this.page);
                return this.addPage(s ?? this.page._options), this.initPageMarkings(I), this;
              }
              bufferedPageRange() {
                return {
                  start: this._pageBufferStart,
                  count: this._pageBuffer.length
                };
              }
              switchToPage(s) {
                let I;
                if (!(I = this._pageBuffer[s - this._pageBufferStart]))
                  throw new Error(`switchToPage(${s}) out of bounds, current buffer covers pages ${this._pageBufferStart} to ${this._pageBufferStart + this._pageBuffer.length - 1}`);
                return this.page = I;
              }
              flushPages() {
                const s = this._pageBuffer;
                this._pageBuffer = [], this._pageBufferStart += s.length;
                for (let I of s)
                  this.endPageMarkings(I), I.end();
              }
              addNamedDestination(s) {
                for (var I = arguments.length, f = new Array(I > 1 ? I - 1 : 0), S = 1; S < I; S++)
                  f[S - 1] = arguments[S];
                f.length === 0 && (f = ["XYZ", null, null, null]), f[0] === "XYZ" && f[2] !== null && (f[2] = this.page.height - f[2]), f.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(s, f);
              }
              addNamedEmbeddedFile(s, I) {
                this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new sA({
                  limits: !1
                })), this._root.data.Names.data.EmbeddedFiles.add(s, I);
              }
              addNamedJavaScript(s, I) {
                this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new sA());
                let f = {
                  JS: new String(I),
                  S: "JavaScript"
                };
                this._root.data.Names.data.JavaScript.add(s, f);
              }
              ref(s) {
                const I = new RA(this, this._offsets.length + 1, s);
                return this._offsets.push(null), this._waiting++, I;
              }
              _read() {
              }
              _write(s) {
                a.isBuffer(s) || (s = a.from(s + `
`, "binary")), this.push(s), this._offset += s.length;
              }
              addContent(s) {
                return this.page.write(s), this;
              }
              _refEnd(s) {
                this._offsets[s.id - 1] = s.offset, --this._waiting === 0 && this._ended && (this._finalize(), this._ended = !1);
              }
              end() {
                this.flushPages(), this._info = this.ref();
                for (let s in this.info) {
                  let I = this.info[s];
                  typeof I == "string" && (I = new String(I));
                  let f = this.ref(I);
                  f.end(), this._info.data[s] = f;
                }
                this._info.end();
                for (let s in this._fontFamilies)
                  this._fontFamilies[s].finalize();
                this.endOutline(), this.endMarkings(), this.subset && this.endSubset(), this.endMetadata(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._security && this._security.end(), this._waiting === 0 ? this._finalize() : this._ended = !0;
              }
              _finalize() {
                const s = this._offset;
                this._write("xref"), this._write(`0 ${this._offsets.length + 1}`), this._write("0000000000 65535 f ");
                for (let f of this._offsets)
                  f = `0000000000${f}`.slice(-10), this._write(f + " 00000 n ");
                const I = {
                  Size: this._offsets.length + 1,
                  Root: this._root,
                  Info: this._info,
                  ID: [this._id, this._id]
                };
                this._security && (I.Encrypt = this._security.dictionary), this._write("trailer"), this._write(v.convert(I)), this._write("startxref"), this._write(`${s}`), this._write("%%EOF"), this.push(null);
              }
              toString() {
                return "[object PDFDocument]";
              }
            }
            B.A = ye;
            const De = (g) => {
              Object.assign(ye.prototype, g);
            };
            De(we), De(Zt), De(Bt), De(oi), De(Pi), De(vi), De(zn), De(Tn), De(zr), De(ar), De(Tr), De(Sr), De(GA), ye.LineWrapper = St;
          },
          /***/
          6092(Q, B, r) {
            var A = r(2736), a = r(2022), d = a;
            typeof d.pdfMake > "u" && (d.pdfMake = A), Q.exports = A;
          },
          /***/
          656(Q, B, r) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.polyval = B.ghash = void 0, B._toGHASHKey = J;
            const A = r(5181), a = 16, d = /* @__PURE__ */ new Uint8Array(16), x = (0, A.u32)(d), U = 225, P = (T, H, eA, CA) => {
              const IA = CA & 1;
              return {
                s3: eA << 31 | CA >>> 1,
                s2: H << 31 | eA >>> 1,
                s1: T << 31 | H >>> 1,
                s0: T >>> 1 ^ U << 24 & -(IA & 1)
                // reduce % poly
              };
            }, D = (T) => (T >>> 0 & 255) << 24 | (T >>> 8 & 255) << 16 | (T >>> 16 & 255) << 8 | T >>> 24 & 255 | 0;
            function J(T) {
              T.reverse();
              const H = T[15] & 1;
              let eA = 0;
              for (let CA = 0; CA < T.length; CA++) {
                const IA = T[CA];
                T[CA] = IA >>> 1 | eA, eA = (IA & 1) << 7;
              }
              return T[0] ^= -H & 225, T;
            }
            const q = (T) => T > 64 * 1024 ? 8 : T > 1024 ? 4 : 2;
            class AA {
              // We select bits per window adaptively based on expectedLength
              constructor(H, eA) {
                this.blockLen = a, this.outputLen = a, this.s0 = 0, this.s1 = 0, this.s2 = 0, this.s3 = 0, this.finished = !1, H = (0, A.toBytes)(H), (0, A.abytes)(H, 16);
                const CA = (0, A.createView)(H);
                let IA = CA.getUint32(0, !1), k = CA.getUint32(4, !1), tA = CA.getUint32(8, !1), lA = CA.getUint32(12, !1);
                const uA = [];
                for (let cA = 0; cA < 128; cA++)
                  uA.push({ s0: D(IA), s1: D(k), s2: D(tA), s3: D(lA) }), { s0: IA, s1: k, s2: tA, s3: lA } = P(IA, k, tA, lA);
                const w = q(eA || 1024);
                if (![1, 2, 4, 8].includes(w))
                  throw new Error("ghash: invalid window size, expected 2, 4 or 8");
                this.W = w;
                const RA = 128 / w, DA = this.windowSize = 2 ** w, $ = [];
                for (let cA = 0; cA < RA; cA++)
                  for (let $A = 0; $A < DA; $A++) {
                    let kA = 0, WA = 0, EA = 0, zA = 0;
                    for (let OA = 0; OA < w; OA++) {
                      if (!($A >>> w - OA - 1 & 1))
                        continue;
                      const { s0: LA, s1: yA, s2: TA, s3: fA } = uA[w * cA + OA];
                      kA ^= LA, WA ^= yA, EA ^= TA, zA ^= fA;
                    }
                    $.push({ s0: kA, s1: WA, s2: EA, s3: zA });
                  }
                this.t = $;
              }
              _updateBlock(H, eA, CA, IA) {
                H ^= this.s0, eA ^= this.s1, CA ^= this.s2, IA ^= this.s3;
                const { W: k, t: tA, windowSize: lA } = this;
                let uA = 0, w = 0, v = 0, RA = 0;
                const DA = (1 << k) - 1;
                let $ = 0;
                for (const cA of [H, eA, CA, IA])
                  for (let $A = 0; $A < 4; $A++) {
                    const kA = cA >>> 8 * $A & 255;
                    for (let WA = 8 / k - 1; WA >= 0; WA--) {
                      const EA = kA >>> k * WA & DA, { s0: zA, s1: OA, s2: xA, s3: LA } = tA[$ * lA + EA];
                      uA ^= zA, w ^= OA, v ^= xA, RA ^= LA, $ += 1;
                    }
                  }
                this.s0 = uA, this.s1 = w, this.s2 = v, this.s3 = RA;
              }
              update(H) {
                (0, A.aexists)(this), H = (0, A.toBytes)(H), (0, A.abytes)(H);
                const eA = (0, A.u32)(H), CA = Math.floor(H.length / a), IA = H.length % a;
                for (let k = 0; k < CA; k++)
                  this._updateBlock(eA[k * 4 + 0], eA[k * 4 + 1], eA[k * 4 + 2], eA[k * 4 + 3]);
                return IA && (d.set(H.subarray(CA * a)), this._updateBlock(x[0], x[1], x[2], x[3]), (0, A.clean)(x)), this;
              }
              destroy() {
                const { t: H } = this;
                for (const eA of H)
                  eA.s0 = 0, eA.s1 = 0, eA.s2 = 0, eA.s3 = 0;
              }
              digestInto(H) {
                (0, A.aexists)(this), (0, A.aoutput)(H, this), this.finished = !0;
                const { s0: eA, s1: CA, s2: IA, s3: k } = this, tA = (0, A.u32)(H);
                return tA[0] = eA, tA[1] = CA, tA[2] = IA, tA[3] = k, H;
              }
              digest() {
                const H = new Uint8Array(a);
                return this.digestInto(H), this.destroy(), H;
              }
            }
            class K extends AA {
              constructor(H, eA) {
                H = (0, A.toBytes)(H), (0, A.abytes)(H);
                const CA = J((0, A.copyBytes)(H));
                super(CA, eA), (0, A.clean)(CA);
              }
              update(H) {
                H = (0, A.toBytes)(H), (0, A.aexists)(this);
                const eA = (0, A.u32)(H), CA = H.length % a, IA = Math.floor(H.length / a);
                for (let k = 0; k < IA; k++)
                  this._updateBlock(D(eA[k * 4 + 3]), D(eA[k * 4 + 2]), D(eA[k * 4 + 1]), D(eA[k * 4 + 0]));
                return CA && (d.set(H.subarray(IA * a)), this._updateBlock(D(x[3]), D(x[2]), D(x[1]), D(x[0])), (0, A.clean)(x)), this;
              }
              digestInto(H) {
                (0, A.aexists)(this), (0, A.aoutput)(H, this), this.finished = !0;
                const { s0: eA, s1: CA, s2: IA, s3: k } = this, tA = (0, A.u32)(H);
                return tA[0] = eA, tA[1] = CA, tA[2] = IA, tA[3] = k, H.reverse();
              }
            }
            function z(T) {
              const H = (CA, IA) => T(IA, CA.length).update((0, A.toBytes)(CA)).digest(), eA = T(new Uint8Array(16), 0);
              return H.outputLen = eA.outputLen, H.blockLen = eA.blockLen, H.create = (CA, IA) => T(CA, IA), H;
            }
            B.ghash = z((T, H) => new AA(T, H)), B.polyval = z((T, H) => new K(T, H));
          },
          /***/
          2651(Q, B, r) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.unsafe = B.aeskwp = B.aeskw = B.siv = B.gcmsiv = B.gcm = B.cfb = B.cbc = B.ecb = B.ctr = void 0;
            const A = r(656), a = r(5181), d = 16, x = 4, U = /* @__PURE__ */ new Uint8Array(d), P = 283;
            function D(fA) {
              return fA << 1 ^ P & -(fA >> 7);
            }
            function J(fA, sA) {
              let F = 0;
              for (; sA > 0; sA >>= 1)
                F ^= fA & -(sA & 1), fA = D(fA);
              return F;
            }
            const q = /* @__PURE__ */ (() => {
              const fA = new Uint8Array(256);
              for (let F = 0, o = 1; F < 256; F++, o ^= D(o))
                fA[F] = o;
              const sA = new Uint8Array(256);
              sA[0] = 99;
              for (let F = 0; F < 255; F++) {
                let o = fA[255 - F];
                o |= o << 8, sA[fA[F]] = (o ^ o >> 4 ^ o >> 5 ^ o >> 6 ^ o >> 7 ^ 99) & 255;
              }
              return (0, a.clean)(fA), sA;
            })(), AA = /* @__PURE__ */ q.map((fA, sA) => q.indexOf(sA)), K = (fA) => fA << 24 | fA >>> 8, z = (fA) => fA << 8 | fA >>> 24, T = (fA) => fA << 24 & 4278190080 | fA << 8 & 16711680 | fA >>> 8 & 65280 | fA >>> 24 & 255;
            function H(fA, sA) {
              if (fA.length !== 256)
                throw new Error("Wrong sbox length");
              const F = new Uint32Array(256).map((QA, bA) => sA(fA[bA])), o = F.map(z), h = o.map(z), _ = h.map(z), oA = new Uint32Array(256 * 256), p = new Uint32Array(256 * 256), rA = new Uint16Array(256 * 256);
              for (let QA = 0; QA < 256; QA++)
                for (let bA = 0; bA < 256; bA++) {
                  const y = QA * 256 + bA;
                  oA[y] = F[QA] ^ o[bA], p[y] = h[QA] ^ _[bA], rA[y] = fA[QA] << 8 | fA[bA];
                }
              return { sbox: fA, sbox2: rA, T0: F, T1: o, T2: h, T3: _, T01: oA, T23: p };
            }
            const eA = /* @__PURE__ */ H(q, (fA) => J(fA, 3) << 24 | fA << 16 | fA << 8 | J(fA, 2)), CA = /* @__PURE__ */ H(AA, (fA) => J(fA, 11) << 24 | J(fA, 13) << 16 | J(fA, 9) << 8 | J(fA, 14)), IA = /* @__PURE__ */ (() => {
              const fA = new Uint8Array(16);
              for (let sA = 0, F = 1; sA < 16; sA++, F = D(F))
                fA[sA] = F;
              return fA;
            })();
            function k(fA) {
              (0, a.abytes)(fA);
              const sA = fA.length;
              if (![16, 24, 32].includes(sA))
                throw new Error("aes: invalid key size, should be 16, 24 or 32, got " + sA);
              const { sbox2: F } = eA, o = [];
              (0, a.isAligned32)(fA) || o.push(fA = (0, a.copyBytes)(fA));
              const h = (0, a.u32)(fA), _ = h.length, oA = (rA) => uA(F, rA, rA, rA, rA), p = new Uint32Array(sA + 28);
              p.set(h);
              for (let rA = _; rA < p.length; rA++) {
                let QA = p[rA - 1];
                rA % _ === 0 ? QA = oA(K(QA)) ^ IA[rA / _ - 1] : _ > 6 && rA % _ === 4 && (QA = oA(QA)), p[rA] = p[rA - _] ^ QA;
              }
              return (0, a.clean)(...o), p;
            }
            function tA(fA) {
              const sA = k(fA), F = sA.slice(), o = sA.length, { sbox2: h } = eA, { T0: _, T1: oA, T2: p, T3: rA } = CA;
              for (let QA = 0; QA < o; QA += 4)
                for (let bA = 0; bA < 4; bA++)
                  F[QA + bA] = sA[o - QA - 4 + bA];
              (0, a.clean)(sA);
              for (let QA = 4; QA < o - 4; QA++) {
                const bA = F[QA], y = uA(h, bA, bA, bA, bA);
                F[QA] = _[y & 255] ^ oA[y >>> 8 & 255] ^ p[y >>> 16 & 255] ^ rA[y >>> 24];
              }
              return F;
            }
            function lA(fA, sA, F, o, h, _) {
              return fA[F << 8 & 65280 | o >>> 8 & 255] ^ sA[h >>> 8 & 65280 | _ >>> 24 & 255];
            }
            function uA(fA, sA, F, o, h) {
              return fA[sA & 255 | F & 65280] | fA[o >>> 16 & 255 | h >>> 16 & 65280] << 16;
            }
            function w(fA, sA, F, o, h) {
              const { sbox2: _, T01: oA, T23: p } = eA;
              let rA = 0;
              sA ^= fA[rA++], F ^= fA[rA++], o ^= fA[rA++], h ^= fA[rA++];
              const QA = fA.length / 4 - 2;
              for (let dA = 0; dA < QA; dA++) {
                const he = fA[rA++] ^ lA(oA, p, sA, F, o, h), ie = fA[rA++] ^ lA(oA, p, F, o, h, sA), KA = fA[rA++] ^ lA(oA, p, o, h, sA, F), Pe = fA[rA++] ^ lA(oA, p, h, sA, F, o);
                sA = he, F = ie, o = KA, h = Pe;
              }
              const bA = fA[rA++] ^ uA(_, sA, F, o, h), y = fA[rA++] ^ uA(_, F, o, h, sA), M = fA[rA++] ^ uA(_, o, h, sA, F), FA = fA[rA++] ^ uA(_, h, sA, F, o);
              return { s0: bA, s1: y, s2: M, s3: FA };
            }
            function v(fA, sA, F, o, h) {
              const { sbox2: _, T01: oA, T23: p } = CA;
              let rA = 0;
              sA ^= fA[rA++], F ^= fA[rA++], o ^= fA[rA++], h ^= fA[rA++];
              const QA = fA.length / 4 - 2;
              for (let dA = 0; dA < QA; dA++) {
                const he = fA[rA++] ^ lA(oA, p, sA, h, o, F), ie = fA[rA++] ^ lA(oA, p, F, sA, h, o), KA = fA[rA++] ^ lA(oA, p, o, F, sA, h), Pe = fA[rA++] ^ lA(oA, p, h, o, F, sA);
                sA = he, F = ie, o = KA, h = Pe;
              }
              const bA = fA[rA++] ^ uA(_, sA, h, o, F), y = fA[rA++] ^ uA(_, F, sA, h, o), M = fA[rA++] ^ uA(_, o, F, sA, h), FA = fA[rA++] ^ uA(_, h, o, F, sA);
              return { s0: bA, s1: y, s2: M, s3: FA };
            }
            function RA(fA, sA, F, o) {
              (0, a.abytes)(sA, d), (0, a.abytes)(F);
              const h = F.length;
              o = (0, a.getOutput)(h, o), (0, a.complexOverlapBytes)(F, o);
              const _ = sA, oA = (0, a.u32)(_);
              let { s0: p, s1: rA, s2: QA, s3: bA } = w(fA, oA[0], oA[1], oA[2], oA[3]);
              const y = (0, a.u32)(F), M = (0, a.u32)(o);
              for (let dA = 0; dA + 4 <= y.length; dA += 4) {
                M[dA + 0] = y[dA + 0] ^ p, M[dA + 1] = y[dA + 1] ^ rA, M[dA + 2] = y[dA + 2] ^ QA, M[dA + 3] = y[dA + 3] ^ bA;
                let he = 1;
                for (let ie = _.length - 1; ie >= 0; ie--)
                  he = he + (_[ie] & 255) | 0, _[ie] = he & 255, he >>>= 8;
                ({ s0: p, s1: rA, s2: QA, s3: bA } = w(fA, oA[0], oA[1], oA[2], oA[3]));
              }
              const FA = d * Math.floor(y.length / x);
              if (FA < h) {
                const dA = new Uint32Array([p, rA, QA, bA]), he = (0, a.u8)(dA);
                for (let ie = FA, KA = 0; ie < h; ie++, KA++)
                  o[ie] = F[ie] ^ he[KA];
                (0, a.clean)(dA);
              }
              return o;
            }
            function DA(fA, sA, F, o, h) {
              (0, a.abytes)(F, d), (0, a.abytes)(o), h = (0, a.getOutput)(o.length, h);
              const _ = F, oA = (0, a.u32)(_), p = (0, a.createView)(_), rA = (0, a.u32)(o), QA = (0, a.u32)(h), bA = sA ? 0 : 12, y = o.length;
              let M = p.getUint32(bA, sA), { s0: FA, s1: dA, s2: he, s3: ie } = w(fA, oA[0], oA[1], oA[2], oA[3]);
              for (let Pe = 0; Pe + 4 <= rA.length; Pe += 4)
                QA[Pe + 0] = rA[Pe + 0] ^ FA, QA[Pe + 1] = rA[Pe + 1] ^ dA, QA[Pe + 2] = rA[Pe + 2] ^ he, QA[Pe + 3] = rA[Pe + 3] ^ ie, M = M + 1 >>> 0, p.setUint32(bA, M, sA), { s0: FA, s1: dA, s2: he, s3: ie } = w(fA, oA[0], oA[1], oA[2], oA[3]);
              const KA = d * Math.floor(rA.length / x);
              if (KA < y) {
                const Pe = new Uint32Array([FA, dA, he, ie]), Je = (0, a.u8)(Pe);
                for (let Le = KA, Re = 0; Le < y; Le++, Re++)
                  h[Le] = o[Le] ^ Je[Re];
                (0, a.clean)(Pe);
              }
              return h;
            }
            B.ctr = (0, a.wrapCipher)({ blockSize: 16, nonceLength: 16 }, function(sA, F) {
              function o(h, _) {
                if ((0, a.abytes)(h), _ !== void 0 && ((0, a.abytes)(_), !(0, a.isAligned32)(_)))
                  throw new Error("unaligned destination");
                const oA = k(sA), p = (0, a.copyBytes)(F), rA = [oA, p];
                (0, a.isAligned32)(h) || rA.push(h = (0, a.copyBytes)(h));
                const QA = RA(oA, p, h, _);
                return (0, a.clean)(...rA), QA;
              }
              return {
                encrypt: (h, _) => o(h, _),
                decrypt: (h, _) => o(h, _)
              };
            });
            function $(fA) {
              if ((0, a.abytes)(fA), fA.length % d !== 0)
                throw new Error("aes-(cbc/ecb).decrypt ciphertext should consist of blocks with size " + d);
            }
            function cA(fA, sA, F) {
              (0, a.abytes)(fA);
              let o = fA.length;
              const h = o % d;
              if (!sA && h !== 0)
                throw new Error("aec/(cbc-ecb): unpadded plaintext with disabled padding");
              (0, a.isAligned32)(fA) || (fA = (0, a.copyBytes)(fA));
              const _ = (0, a.u32)(fA);
              if (sA) {
                let p = d - h;
                p || (p = d), o = o + p;
              }
              F = (0, a.getOutput)(o, F), (0, a.complexOverlapBytes)(fA, F);
              const oA = (0, a.u32)(F);
              return { b: _, o: oA, out: F };
            }
            function $A(fA, sA) {
              if (!sA)
                return fA;
              const F = fA.length;
              if (!F)
                throw new Error("aes/pcks5: empty ciphertext not allowed");
              const o = fA[F - 1];
              if (o <= 0 || o > 16)
                throw new Error("aes/pcks5: wrong padding");
              const h = fA.subarray(0, -o);
              for (let _ = 0; _ < o; _++)
                if (fA[F - _ - 1] !== o)
                  throw new Error("aes/pcks5: wrong padding");
              return h;
            }
            function kA(fA) {
              const sA = new Uint8Array(16), F = (0, a.u32)(sA);
              sA.set(fA);
              const o = d - fA.length;
              for (let h = d - o; h < d; h++)
                sA[h] = o;
              return F;
            }
            B.ecb = (0, a.wrapCipher)({ blockSize: 16 }, function(sA, F = {}) {
              const o = !F.disablePadding;
              return {
                encrypt(h, _) {
                  const { b: oA, o: p, out: rA } = cA(h, o, _), QA = k(sA);
                  let bA = 0;
                  for (; bA + 4 <= oA.length; ) {
                    const { s0: y, s1: M, s2: FA, s3: dA } = w(QA, oA[bA + 0], oA[bA + 1], oA[bA + 2], oA[bA + 3]);
                    p[bA++] = y, p[bA++] = M, p[bA++] = FA, p[bA++] = dA;
                  }
                  if (o) {
                    const y = kA(h.subarray(bA * 4)), { s0: M, s1: FA, s2: dA, s3: he } = w(QA, y[0], y[1], y[2], y[3]);
                    p[bA++] = M, p[bA++] = FA, p[bA++] = dA, p[bA++] = he;
                  }
                  return (0, a.clean)(QA), rA;
                },
                decrypt(h, _) {
                  $(h);
                  const oA = tA(sA);
                  _ = (0, a.getOutput)(h.length, _);
                  const p = [oA];
                  (0, a.isAligned32)(h) || p.push(h = (0, a.copyBytes)(h)), (0, a.complexOverlapBytes)(h, _);
                  const rA = (0, a.u32)(h), QA = (0, a.u32)(_);
                  for (let bA = 0; bA + 4 <= rA.length; ) {
                    const { s0: y, s1: M, s2: FA, s3: dA } = v(oA, rA[bA + 0], rA[bA + 1], rA[bA + 2], rA[bA + 3]);
                    QA[bA++] = y, QA[bA++] = M, QA[bA++] = FA, QA[bA++] = dA;
                  }
                  return (0, a.clean)(...p), $A(_, o);
                }
              };
            }), B.cbc = (0, a.wrapCipher)({ blockSize: 16, nonceLength: 16 }, function(sA, F, o = {}) {
              const h = !o.disablePadding;
              return {
                encrypt(_, oA) {
                  const p = k(sA), { b: rA, o: QA, out: bA } = cA(_, h, oA);
                  let y = F;
                  const M = [p];
                  (0, a.isAligned32)(y) || M.push(y = (0, a.copyBytes)(y));
                  const FA = (0, a.u32)(y);
                  let dA = FA[0], he = FA[1], ie = FA[2], KA = FA[3], Pe = 0;
                  for (; Pe + 4 <= rA.length; )
                    dA ^= rA[Pe + 0], he ^= rA[Pe + 1], ie ^= rA[Pe + 2], KA ^= rA[Pe + 3], { s0: dA, s1: he, s2: ie, s3: KA } = w(p, dA, he, ie, KA), QA[Pe++] = dA, QA[Pe++] = he, QA[Pe++] = ie, QA[Pe++] = KA;
                  if (h) {
                    const Je = kA(_.subarray(Pe * 4));
                    dA ^= Je[0], he ^= Je[1], ie ^= Je[2], KA ^= Je[3], { s0: dA, s1: he, s2: ie, s3: KA } = w(p, dA, he, ie, KA), QA[Pe++] = dA, QA[Pe++] = he, QA[Pe++] = ie, QA[Pe++] = KA;
                  }
                  return (0, a.clean)(...M), bA;
                },
                decrypt(_, oA) {
                  $(_);
                  const p = tA(sA);
                  let rA = F;
                  const QA = [p];
                  (0, a.isAligned32)(rA) || QA.push(rA = (0, a.copyBytes)(rA));
                  const bA = (0, a.u32)(rA);
                  oA = (0, a.getOutput)(_.length, oA), (0, a.isAligned32)(_) || QA.push(_ = (0, a.copyBytes)(_)), (0, a.complexOverlapBytes)(_, oA);
                  const y = (0, a.u32)(_), M = (0, a.u32)(oA);
                  let FA = bA[0], dA = bA[1], he = bA[2], ie = bA[3];
                  for (let KA = 0; KA + 4 <= y.length; ) {
                    const Pe = FA, Je = dA, Le = he, Re = ie;
                    FA = y[KA + 0], dA = y[KA + 1], he = y[KA + 2], ie = y[KA + 3];
                    const { s0: _e, s1: se, s2: Ee, s3: wA } = v(p, FA, dA, he, ie);
                    M[KA++] = _e ^ Pe, M[KA++] = se ^ Je, M[KA++] = Ee ^ Le, M[KA++] = wA ^ Re;
                  }
                  return (0, a.clean)(...QA), $A(oA, h);
                }
              };
            }), B.cfb = (0, a.wrapCipher)({ blockSize: 16, nonceLength: 16 }, function(sA, F) {
              function o(h, _, oA) {
                (0, a.abytes)(h);
                const p = h.length;
                if (oA = (0, a.getOutput)(p, oA), (0, a.overlapBytes)(h, oA))
                  throw new Error("overlapping src and dst not supported.");
                const rA = k(sA);
                let QA = F;
                const bA = [rA];
                (0, a.isAligned32)(QA) || bA.push(QA = (0, a.copyBytes)(QA)), (0, a.isAligned32)(h) || bA.push(h = (0, a.copyBytes)(h));
                const y = (0, a.u32)(h), M = (0, a.u32)(oA), FA = _ ? M : y, dA = (0, a.u32)(QA);
                let he = dA[0], ie = dA[1], KA = dA[2], Pe = dA[3];
                for (let Le = 0; Le + 4 <= y.length; ) {
                  const { s0: Re, s1: _e, s2: se, s3: Ee } = w(rA, he, ie, KA, Pe);
                  M[Le + 0] = y[Le + 0] ^ Re, M[Le + 1] = y[Le + 1] ^ _e, M[Le + 2] = y[Le + 2] ^ se, M[Le + 3] = y[Le + 3] ^ Ee, he = FA[Le++], ie = FA[Le++], KA = FA[Le++], Pe = FA[Le++];
                }
                const Je = d * Math.floor(y.length / x);
                if (Je < p) {
                  ({ s0: he, s1: ie, s2: KA, s3: Pe } = w(rA, he, ie, KA, Pe));
                  const Le = (0, a.u8)(new Uint32Array([he, ie, KA, Pe]));
                  for (let Re = Je, _e = 0; Re < p; Re++, _e++)
                    oA[Re] = h[Re] ^ Le[_e];
                  (0, a.clean)(Le);
                }
                return (0, a.clean)(...bA), oA;
              }
              return {
                encrypt: (h, _) => o(h, !0, _),
                decrypt: (h, _) => o(h, !1, _)
              };
            });
            function WA(fA, sA, F, o, h) {
              const _ = h ? h.length : 0, oA = fA.create(F, o.length + _);
              h && oA.update(h);
              const p = (0, a.u64Lengths)(8 * o.length, 8 * _, sA);
              oA.update(o), oA.update(p);
              const rA = oA.digest();
              return (0, a.clean)(p), rA;
            }
            B.gcm = (0, a.wrapCipher)({ blockSize: 16, nonceLength: 12, tagLength: 16, varSizeNonce: !0 }, function(sA, F, o) {
              if (F.length < 8)
                throw new Error("aes/gcm: invalid nonce length");
              const h = 16;
              function _(p, rA, QA) {
                const bA = WA(A.ghash, !1, p, QA, o);
                for (let y = 0; y < rA.length; y++)
                  bA[y] ^= rA[y];
                return bA;
              }
              function oA() {
                const p = k(sA), rA = U.slice(), QA = U.slice();
                if (DA(p, !1, QA, QA, rA), F.length === 12)
                  QA.set(F);
                else {
                  const y = U.slice(), M = (0, a.createView)(y);
                  (0, a.setBigUint64)(M, 8, BigInt(F.length * 8), !1);
                  const FA = A.ghash.create(rA).update(F).update(y);
                  FA.digestInto(QA), FA.destroy();
                }
                const bA = DA(p, !1, QA, U);
                return { xk: p, authKey: rA, counter: QA, tagMask: bA };
              }
              return {
                encrypt(p) {
                  const { xk: rA, authKey: QA, counter: bA, tagMask: y } = oA(), M = new Uint8Array(p.length + h), FA = [rA, QA, bA, y];
                  (0, a.isAligned32)(p) || FA.push(p = (0, a.copyBytes)(p)), DA(rA, !1, bA, p, M.subarray(0, p.length));
                  const dA = _(QA, y, M.subarray(0, M.length - h));
                  return FA.push(dA), M.set(dA, p.length), (0, a.clean)(...FA), M;
                },
                decrypt(p) {
                  const { xk: rA, authKey: QA, counter: bA, tagMask: y } = oA(), M = [rA, QA, y, bA];
                  (0, a.isAligned32)(p) || M.push(p = (0, a.copyBytes)(p));
                  const FA = p.subarray(0, -h), dA = p.subarray(-h), he = _(QA, y, FA);
                  if (M.push(he), !(0, a.equalBytes)(he, dA))
                    throw new Error("aes/gcm: invalid ghash tag");
                  const ie = DA(rA, !1, bA, FA);
                  return (0, a.clean)(...M), ie;
                }
              };
            });
            const EA = (fA, sA, F) => (o) => {
              if (!Number.isSafeInteger(o) || sA > o || o > F) {
                const h = "[" + sA + ".." + F + "]";
                throw new Error("" + fA + ": expected value in range " + h + ", got " + o);
              }
            };
            B.gcmsiv = (0, a.wrapCipher)({ blockSize: 16, nonceLength: 12, tagLength: 16, varSizeNonce: !0 }, function(sA, F, o) {
              const _ = EA("AAD", 0, 68719476736), oA = EA("plaintext", 0, 2 ** 36), p = EA("nonce", 12, 12), rA = EA("ciphertext", 16, 2 ** 36 + 16);
              (0, a.abytes)(sA, 16, 24, 32), p(F.length), o !== void 0 && _(o.length);
              function QA() {
                const M = k(sA), FA = new Uint8Array(sA.length), dA = new Uint8Array(16), he = [M, FA];
                let ie = F;
                (0, a.isAligned32)(ie) || he.push(ie = (0, a.copyBytes)(ie));
                const KA = (0, a.u32)(ie);
                let Pe = 0, Je = KA[0], Le = KA[1], Re = KA[2], _e = 0;
                for (const Ee of [dA, FA].map(a.u32)) {
                  const wA = (0, a.u32)(Ee);
                  for (let N = 0; N < wA.length; N += 2) {
                    const { s0: G, s1: W } = w(M, Pe, Je, Le, Re);
                    wA[N + 0] = G, wA[N + 1] = W, Pe = ++_e;
                  }
                }
                const se = { authKey: dA, encKey: k(FA) };
                return (0, a.clean)(...he), se;
              }
              function bA(M, FA, dA) {
                const he = WA(A.polyval, !0, FA, dA, o);
                for (let Re = 0; Re < 12; Re++)
                  he[Re] ^= F[Re];
                he[15] &= 127;
                const ie = (0, a.u32)(he);
                let KA = ie[0], Pe = ie[1], Je = ie[2], Le = ie[3];
                return { s0: KA, s1: Pe, s2: Je, s3: Le } = w(M, KA, Pe, Je, Le), ie[0] = KA, ie[1] = Pe, ie[2] = Je, ie[3] = Le, he;
              }
              function y(M, FA, dA) {
                let he = (0, a.copyBytes)(FA);
                he[15] |= 128;
                const ie = DA(M, !0, he, dA);
                return (0, a.clean)(he), ie;
              }
              return {
                encrypt(M) {
                  oA(M.length);
                  const { encKey: FA, authKey: dA } = QA(), he = bA(FA, dA, M), ie = [FA, dA, he];
                  (0, a.isAligned32)(M) || ie.push(M = (0, a.copyBytes)(M));
                  const KA = new Uint8Array(M.length + 16);
                  return KA.set(he, M.length), KA.set(y(FA, he, M)), (0, a.clean)(...ie), KA;
                },
                decrypt(M) {
                  rA(M.length);
                  const FA = M.subarray(-16), { encKey: dA, authKey: he } = QA(), ie = [dA, he];
                  (0, a.isAligned32)(M) || ie.push(M = (0, a.copyBytes)(M));
                  const KA = y(dA, FA, M.subarray(0, -16)), Pe = bA(dA, he, KA);
                  if (ie.push(Pe), !(0, a.equalBytes)(FA, Pe))
                    throw (0, a.clean)(...ie), new Error("invalid polyval tag");
                  return (0, a.clean)(...ie), KA;
                }
              };
            }), B.siv = B.gcmsiv;
            function zA(fA) {
              return fA instanceof Uint32Array || ArrayBuffer.isView(fA) && fA.constructor.name === "Uint32Array";
            }
            function OA(fA, sA) {
              if ((0, a.abytes)(sA, 16), !zA(fA))
                throw new Error("_encryptBlock accepts result of expandKeyLE");
              const F = (0, a.u32)(sA);
              let { s0: o, s1: h, s2: _, s3: oA } = w(fA, F[0], F[1], F[2], F[3]);
              return F[0] = o, F[1] = h, F[2] = _, F[3] = oA, sA;
            }
            function xA(fA, sA) {
              if ((0, a.abytes)(sA, 16), !zA(fA))
                throw new Error("_decryptBlock accepts result of expandKeyLE");
              const F = (0, a.u32)(sA);
              let { s0: o, s1: h, s2: _, s3: oA } = v(fA, F[0], F[1], F[2], F[3]);
              return F[0] = o, F[1] = h, F[2] = _, F[3] = oA, sA;
            }
            const LA = {
              /*
              High-level pseudocode:
              ```
              A: u64 = IV
              out = []
              for (let i=0, ctr = 0; i<6; i++) {
                for (const chunk of chunks(plaintext, 8)) {
                  A ^= swapEndianess(ctr++)
                  [A, res] = chunks(encrypt(A || chunk), 8);
                  out ||= res
                }
              }
              out = A || out
              ```
              Decrypt is the same, but reversed.
              */
              encrypt(fA, sA) {
                if (sA.length >= 2 ** 32)
                  throw new Error("plaintext should be less than 4gb");
                const F = k(fA);
                if (sA.length === 16)
                  OA(F, sA);
                else {
                  const o = (0, a.u32)(sA);
                  let h = o[0], _ = o[1];
                  for (let oA = 0, p = 1; oA < 6; oA++)
                    for (let rA = 2; rA < o.length; rA += 2, p++) {
                      const { s0: QA, s1: bA, s2: y, s3: M } = w(F, h, _, o[rA], o[rA + 1]);
                      h = QA, _ = bA ^ T(p), o[rA] = y, o[rA + 1] = M;
                    }
                  o[0] = h, o[1] = _;
                }
                F.fill(0);
              },
              decrypt(fA, sA) {
                if (sA.length - 8 >= 2 ** 32)
                  throw new Error("ciphertext should be less than 4gb");
                const F = tA(fA), o = sA.length / 8 - 1;
                if (o === 1)
                  xA(F, sA);
                else {
                  const h = (0, a.u32)(sA);
                  let _ = h[0], oA = h[1];
                  for (let p = 0, rA = o * 6; p < 6; p++)
                    for (let QA = o * 2; QA >= 1; QA -= 2, rA--) {
                      oA ^= T(rA);
                      const { s0: bA, s1: y, s2: M, s3: FA } = v(F, _, oA, h[QA], h[QA + 1]);
                      _ = bA, oA = y, h[QA] = M, h[QA + 1] = FA;
                    }
                  h[0] = _, h[1] = oA;
                }
                F.fill(0);
              }
            }, yA = /* @__PURE__ */ new Uint8Array(8).fill(166);
            B.aeskw = (0, a.wrapCipher)({ blockSize: 8 }, (fA) => ({
              encrypt(sA) {
                if (!sA.length || sA.length % 8 !== 0)
                  throw new Error("invalid plaintext length");
                if (sA.length === 8)
                  throw new Error("8-byte keys not allowed in AESKW, use AESKWP instead");
                const F = (0, a.concatBytes)(yA, sA);
                return LA.encrypt(fA, F), F;
              },
              decrypt(sA) {
                if (sA.length % 8 !== 0 || sA.length < 24)
                  throw new Error("invalid ciphertext length");
                const F = (0, a.copyBytes)(sA);
                if (LA.decrypt(fA, F), !(0, a.equalBytes)(F.subarray(0, 8), yA))
                  throw new Error("integrity check failed");
                return F.subarray(0, 8).fill(0), F.subarray(8);
              }
            }));
            const TA = 2790873510;
            B.aeskwp = (0, a.wrapCipher)({ blockSize: 8 }, (fA) => ({
              encrypt(sA) {
                if (!sA.length)
                  throw new Error("invalid plaintext length");
                const F = Math.ceil(sA.length / 8) * 8, o = new Uint8Array(8 + F);
                o.set(sA, 8);
                const h = (0, a.u32)(o);
                return h[0] = TA, h[1] = T(sA.length), LA.encrypt(fA, o), o;
              },
              decrypt(sA) {
                if (sA.length < 16)
                  throw new Error("invalid ciphertext length");
                const F = (0, a.copyBytes)(sA), o = (0, a.u32)(F);
                LA.decrypt(fA, F);
                const h = T(o[1]) >>> 0, _ = Math.ceil(h / 8) * 8;
                if (o[0] !== TA || F.length - 8 !== _)
                  throw new Error("integrity check failed");
                for (let oA = h; oA < _; oA++)
                  if (F[8 + oA] !== 0)
                    throw new Error("integrity check failed");
                return F.subarray(0, 8).fill(0), F.subarray(8, 8 + h);
              }
            })), B.unsafe = {
              expandKeyLE: k,
              expandKeyDecLE: tA,
              encrypt: w,
              decrypt: v,
              encryptBlock: OA,
              decryptBlock: xA,
              ctrCounter: RA,
              ctr32: DA
            };
          },
          /***/
          5181(Q, B) {
            /*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */
            Object.defineProperty(B, "__esModule", { value: !0 }), B.wrapCipher = B.Hash = B.nextTick = B.isLE = void 0, B.isBytes = r, B.abool = A, B.anumber = a, B.abytes = d, B.ahash = x, B.aexists = U, B.aoutput = P, B.u8 = D, B.u32 = J, B.clean = q, B.createView = AA, B.bytesToHex = T, B.hexToBytes = CA, B.hexToNumber = IA, B.bytesToNumberBE = k, B.numberToBytesBE = tA, B.utf8ToBytes = uA, B.bytesToUtf8 = w, B.toBytes = v, B.overlapBytes = RA, B.complexOverlapBytes = DA, B.concatBytes = $, B.checkOpts = cA, B.equalBytes = $A, B.getOutput = EA, B.setBigUint64 = zA, B.u64Lengths = OA, B.isAligned32 = xA, B.copyBytes = LA;
            function r(yA) {
              return yA instanceof Uint8Array || ArrayBuffer.isView(yA) && yA.constructor.name === "Uint8Array";
            }
            function A(yA) {
              if (typeof yA != "boolean")
                throw new Error(`boolean expected, not ${yA}`);
            }
            function a(yA) {
              if (!Number.isSafeInteger(yA) || yA < 0)
                throw new Error("positive integer expected, got " + yA);
            }
            function d(yA, ...TA) {
              if (!r(yA))
                throw new Error("Uint8Array expected");
              if (TA.length > 0 && !TA.includes(yA.length))
                throw new Error("Uint8Array expected of length " + TA + ", got length=" + yA.length);
            }
            function x(yA) {
              if (typeof yA != "function" || typeof yA.create != "function")
                throw new Error("Hash should be wrapped by utils.createHasher");
              a(yA.outputLen), a(yA.blockLen);
            }
            function U(yA, TA = !0) {
              if (yA.destroyed)
                throw new Error("Hash instance has been destroyed");
              if (TA && yA.finished)
                throw new Error("Hash#digest() has already been called");
            }
            function P(yA, TA) {
              d(yA);
              const fA = TA.outputLen;
              if (yA.length < fA)
                throw new Error("digestInto() expects output buffer of length at least " + fA);
            }
            function D(yA) {
              return new Uint8Array(yA.buffer, yA.byteOffset, yA.byteLength);
            }
            function J(yA) {
              return new Uint32Array(yA.buffer, yA.byteOffset, Math.floor(yA.byteLength / 4));
            }
            function q(...yA) {
              for (let TA = 0; TA < yA.length; TA++)
                yA[TA].fill(0);
            }
            function AA(yA) {
              return new DataView(yA.buffer, yA.byteOffset, yA.byteLength);
            }
            B.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
            const K = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", z = /* @__PURE__ */ Array.from({ length: 256 }, (yA, TA) => TA.toString(16).padStart(2, "0"));
            function T(yA) {
              if (d(yA), K)
                return yA.toHex();
              let TA = "";
              for (let fA = 0; fA < yA.length; fA++)
                TA += z[yA[fA]];
              return TA;
            }
            const H = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
            function eA(yA) {
              if (yA >= H._0 && yA <= H._9)
                return yA - H._0;
              if (yA >= H.A && yA <= H.F)
                return yA - (H.A - 10);
              if (yA >= H.a && yA <= H.f)
                return yA - (H.a - 10);
            }
            function CA(yA) {
              if (typeof yA != "string")
                throw new Error("hex string expected, got " + typeof yA);
              if (K)
                return Uint8Array.fromHex(yA);
              const TA = yA.length, fA = TA / 2;
              if (TA % 2)
                throw new Error("hex string expected, got unpadded hex of length " + TA);
              const sA = new Uint8Array(fA);
              for (let F = 0, o = 0; F < fA; F++, o += 2) {
                const h = eA(yA.charCodeAt(o)), _ = eA(yA.charCodeAt(o + 1));
                if (h === void 0 || _ === void 0) {
                  const oA = yA[o] + yA[o + 1];
                  throw new Error('hex string expected, got non-hex character "' + oA + '" at index ' + o);
                }
                sA[F] = h * 16 + _;
              }
              return sA;
            }
            function IA(yA) {
              if (typeof yA != "string")
                throw new Error("hex string expected, got " + typeof yA);
              return BigInt(yA === "" ? "0" : "0x" + yA);
            }
            function k(yA) {
              return IA(T(yA));
            }
            function tA(yA, TA) {
              return CA(yA.toString(16).padStart(TA * 2, "0"));
            }
            const lA = async () => {
            };
            B.nextTick = lA;
            function uA(yA) {
              if (typeof yA != "string")
                throw new Error("string expected");
              return new Uint8Array(new TextEncoder().encode(yA));
            }
            function w(yA) {
              return new TextDecoder().decode(yA);
            }
            function v(yA) {
              if (typeof yA == "string")
                yA = uA(yA);
              else if (r(yA))
                yA = LA(yA);
              else
                throw new Error("Uint8Array expected, got " + typeof yA);
              return yA;
            }
            function RA(yA, TA) {
              return yA.buffer === TA.buffer && // best we can do, may fail with an obscure Proxy
              yA.byteOffset < TA.byteOffset + TA.byteLength && // a starts before b end
              TA.byteOffset < yA.byteOffset + yA.byteLength;
            }
            function DA(yA, TA) {
              if (RA(yA, TA) && yA.byteOffset < TA.byteOffset)
                throw new Error("complex overlap of input and output is not supported");
            }
            function $(...yA) {
              let TA = 0;
              for (let sA = 0; sA < yA.length; sA++) {
                const F = yA[sA];
                d(F), TA += F.length;
              }
              const fA = new Uint8Array(TA);
              for (let sA = 0, F = 0; sA < yA.length; sA++) {
                const o = yA[sA];
                fA.set(o, F), F += o.length;
              }
              return fA;
            }
            function cA(yA, TA) {
              if (TA == null || typeof TA != "object")
                throw new Error("options must be defined");
              return Object.assign(yA, TA);
            }
            function $A(yA, TA) {
              if (yA.length !== TA.length)
                return !1;
              let fA = 0;
              for (let sA = 0; sA < yA.length; sA++)
                fA |= yA[sA] ^ TA[sA];
              return fA === 0;
            }
            class kA {
            }
            B.Hash = kA;
            const WA = /* @__NO_SIDE_EFFECTS__ */ (yA, TA) => {
              function fA(sA, ...F) {
                if (d(sA), !B.isLE)
                  throw new Error("Non little-endian hardware is not yet supported");
                if (yA.nonceLength !== void 0) {
                  const rA = F[0];
                  if (!rA)
                    throw new Error("nonce / iv required");
                  yA.varSizeNonce ? d(rA) : d(rA, yA.nonceLength);
                }
                const o = yA.tagLength;
                o && F[1] !== void 0 && d(F[1]);
                const h = TA(sA, ...F), _ = (rA, QA) => {
                  if (QA !== void 0) {
                    if (rA !== 2)
                      throw new Error("cipher output not supported");
                    d(QA);
                  }
                };
                let oA = !1;
                return {
                  encrypt(rA, QA) {
                    if (oA)
                      throw new Error("cannot encrypt() twice with same key + nonce");
                    return oA = !0, d(rA), _(h.encrypt.length, QA), h.encrypt(rA, QA);
                  },
                  decrypt(rA, QA) {
                    if (d(rA), o && rA.length < o)
                      throw new Error("invalid ciphertext length: smaller than tagLength=" + o);
                    return _(h.decrypt.length, QA), h.decrypt(rA, QA);
                  }
                };
              }
              return Object.assign(fA, yA), fA;
            };
            B.wrapCipher = WA;
            function EA(yA, TA, fA = !0) {
              if (TA === void 0)
                return new Uint8Array(yA);
              if (TA.length !== yA)
                throw new Error("invalid output length, expected " + yA + ", got: " + TA.length);
              if (fA && !xA(TA))
                throw new Error("invalid output, must be aligned");
              return TA;
            }
            function zA(yA, TA, fA, sA) {
              if (typeof yA.setBigUint64 == "function")
                return yA.setBigUint64(TA, fA, sA);
              const F = BigInt(32), o = BigInt(4294967295), h = Number(fA >> F & o), _ = Number(fA & o), oA = sA ? 4 : 0, p = sA ? 0 : 4;
              yA.setUint32(TA + oA, h, sA), yA.setUint32(TA + p, _, sA);
            }
            function OA(yA, TA, fA) {
              A(fA);
              const sA = new Uint8Array(16), F = AA(sA);
              return zA(F, 0, BigInt(TA), fA), zA(F, 8, BigInt(yA), fA), sA;
            }
            function xA(yA) {
              return yA.byteOffset % 4 === 0;
            }
            function LA(yA) {
              return Uint8Array.from(yA);
            }
          },
          /***/
          6784(Q, B, r) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.SHA512_IV = B.SHA384_IV = B.SHA224_IV = B.SHA256_IV = B.HashMD = void 0, B.setBigUint64 = a, B.Chi = d, B.Maj = x;
            const A = r(3973);
            function a(P, D, J, q) {
              if (typeof P.setBigUint64 == "function")
                return P.setBigUint64(D, J, q);
              const AA = BigInt(32), K = BigInt(4294967295), z = Number(J >> AA & K), T = Number(J & K), H = q ? 4 : 0, eA = q ? 0 : 4;
              P.setUint32(D + H, z, q), P.setUint32(D + eA, T, q);
            }
            function d(P, D, J) {
              return P & D ^ ~P & J;
            }
            function x(P, D, J) {
              return P & D ^ P & J ^ D & J;
            }
            class U extends A.Hash {
              constructor(D, J, q, AA) {
                super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = D, this.outputLen = J, this.padOffset = q, this.isLE = AA, this.buffer = new Uint8Array(D), this.view = (0, A.createView)(this.buffer);
              }
              update(D) {
                (0, A.aexists)(this), D = (0, A.toBytes)(D), (0, A.abytes)(D);
                const { view: J, buffer: q, blockLen: AA } = this, K = D.length;
                for (let z = 0; z < K; ) {
                  const T = Math.min(AA - this.pos, K - z);
                  if (T === AA) {
                    const H = (0, A.createView)(D);
                    for (; AA <= K - z; z += AA)
                      this.process(H, z);
                    continue;
                  }
                  q.set(D.subarray(z, z + T), this.pos), this.pos += T, z += T, this.pos === AA && (this.process(J, 0), this.pos = 0);
                }
                return this.length += D.length, this.roundClean(), this;
              }
              digestInto(D) {
                (0, A.aexists)(this), (0, A.aoutput)(D, this), this.finished = !0;
                const { buffer: J, view: q, blockLen: AA, isLE: K } = this;
                let { pos: z } = this;
                J[z++] = 128, (0, A.clean)(this.buffer.subarray(z)), this.padOffset > AA - z && (this.process(q, 0), z = 0);
                for (let IA = z; IA < AA; IA++)
                  J[IA] = 0;
                a(q, AA - 8, BigInt(this.length * 8), K), this.process(q, 0);
                const T = (0, A.createView)(D), H = this.outputLen;
                if (H % 4)
                  throw new Error("_sha2: outputLen should be aligned to 32bit");
                const eA = H / 4, CA = this.get();
                if (eA > CA.length)
                  throw new Error("_sha2: outputLen bigger than state");
                for (let IA = 0; IA < eA; IA++)
                  T.setUint32(4 * IA, CA[IA], K);
              }
              digest() {
                const { buffer: D, outputLen: J } = this;
                this.digestInto(D);
                const q = D.slice(0, J);
                return this.destroy(), q;
              }
              _cloneInto(D) {
                D || (D = new this.constructor()), D.set(...this.get());
                const { blockLen: J, buffer: q, length: AA, finished: K, destroyed: z, pos: T } = this;
                return D.destroyed = z, D.finished = K, D.length = AA, D.pos = T, AA % J && D.buffer.set(q), D;
              }
              clone() {
                return this._cloneInto();
              }
            }
            B.HashMD = U, B.SHA256_IV = Uint32Array.from([
              1779033703,
              3144134277,
              1013904242,
              2773480762,
              1359893119,
              2600822924,
              528734635,
              1541459225
            ]), B.SHA224_IV = Uint32Array.from([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]), B.SHA384_IV = Uint32Array.from([
              3418070365,
              3238371032,
              1654270250,
              914150663,
              2438529370,
              812702999,
              355462360,
              4144912697,
              1731405415,
              4290775857,
              2394180231,
              1750603025,
              3675008525,
              1694076839,
              1203062813,
              3204075428
            ]), B.SHA512_IV = Uint32Array.from([
              1779033703,
              4089235720,
              3144134277,
              2227873595,
              1013904242,
              4271175723,
              2773480762,
              1595750129,
              1359893119,
              2917565137,
              2600822924,
              725511199,
              528734635,
              4215389547,
              1541459225,
              327033209
            ]);
          },
          /***/
          4996(Q, B) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.toBig = B.shrSL = B.shrSH = B.rotrSL = B.rotrSH = B.rotrBL = B.rotrBH = B.rotr32L = B.rotr32H = B.rotlSL = B.rotlSH = B.rotlBL = B.rotlBH = B.add5L = B.add5H = B.add4L = B.add4H = B.add3L = B.add3H = void 0, B.add = IA, B.fromBig = a, B.split = d;
            const r = /* @__PURE__ */ BigInt(2 ** 32 - 1), A = /* @__PURE__ */ BigInt(32);
            function a(DA, $ = !1) {
              return $ ? { h: Number(DA & r), l: Number(DA >> A & r) } : { h: Number(DA >> A & r) | 0, l: Number(DA & r) | 0 };
            }
            function d(DA, $ = !1) {
              const cA = DA.length;
              let $A = new Uint32Array(cA), kA = new Uint32Array(cA);
              for (let WA = 0; WA < cA; WA++) {
                const { h: EA, l: zA } = a(DA[WA], $);
                [$A[WA], kA[WA]] = [EA, zA];
              }
              return [$A, kA];
            }
            const x = (DA, $) => BigInt(DA >>> 0) << A | BigInt($ >>> 0);
            B.toBig = x;
            const U = (DA, $, cA) => DA >>> cA;
            B.shrSH = U;
            const P = (DA, $, cA) => DA << 32 - cA | $ >>> cA;
            B.shrSL = P;
            const D = (DA, $, cA) => DA >>> cA | $ << 32 - cA;
            B.rotrSH = D;
            const J = (DA, $, cA) => DA << 32 - cA | $ >>> cA;
            B.rotrSL = J;
            const q = (DA, $, cA) => DA << 64 - cA | $ >>> cA - 32;
            B.rotrBH = q;
            const AA = (DA, $, cA) => DA >>> cA - 32 | $ << 64 - cA;
            B.rotrBL = AA;
            const K = (DA, $) => $;
            B.rotr32H = K;
            const z = (DA, $) => DA;
            B.rotr32L = z;
            const T = (DA, $, cA) => DA << cA | $ >>> 32 - cA;
            B.rotlSH = T;
            const H = (DA, $, cA) => $ << cA | DA >>> 32 - cA;
            B.rotlSL = H;
            const eA = (DA, $, cA) => $ << cA - 32 | DA >>> 64 - cA;
            B.rotlBH = eA;
            const CA = (DA, $, cA) => DA << cA - 32 | $ >>> 64 - cA;
            B.rotlBL = CA;
            function IA(DA, $, cA, $A) {
              const kA = ($ >>> 0) + ($A >>> 0);
              return { h: DA + cA + (kA / 4294967296 | 0) | 0, l: kA | 0 };
            }
            const k = (DA, $, cA) => (DA >>> 0) + ($ >>> 0) + (cA >>> 0);
            B.add3L = k;
            const tA = (DA, $, cA, $A) => $ + cA + $A + (DA / 2 ** 32 | 0) | 0;
            B.add3H = tA;
            const lA = (DA, $, cA, $A) => (DA >>> 0) + ($ >>> 0) + (cA >>> 0) + ($A >>> 0);
            B.add4L = lA;
            const uA = (DA, $, cA, $A, kA) => $ + cA + $A + kA + (DA / 2 ** 32 | 0) | 0;
            B.add4H = uA;
            const w = (DA, $, cA, $A, kA) => (DA >>> 0) + ($ >>> 0) + (cA >>> 0) + ($A >>> 0) + (kA >>> 0);
            B.add5L = w;
            const v = (DA, $, cA, $A, kA, WA) => $ + cA + $A + kA + WA + (DA / 2 ** 32 | 0) | 0;
            B.add5H = v;
            const RA = {
              fromBig: a,
              split: d,
              toBig: x,
              shrSH: U,
              shrSL: P,
              rotrSH: D,
              rotrSL: J,
              rotrBH: q,
              rotrBL: AA,
              rotr32H: K,
              rotr32L: z,
              rotlSH: T,
              rotlSL: H,
              rotlBH: eA,
              rotlBL: CA,
              add: IA,
              add3L: k,
              add3H: tA,
              add4L: lA,
              add4H: uA,
              add5H: v,
              add5L: w
            };
            B.default = RA;
          },
          /***/
          2491(Q, B) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.crypto = void 0, B.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
          },
          /***/
          2650(Q, B, r) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.sha512_224 = B.sha512_256 = B.sha384 = B.sha512 = B.sha224 = B.sha256 = B.SHA512_256 = B.SHA512_224 = B.SHA384 = B.SHA512 = B.SHA224 = B.SHA256 = void 0;
            const A = r(6784), a = r(4996), d = r(3973), x = /* @__PURE__ */ Uint32Array.from([
              1116352408,
              1899447441,
              3049323471,
              3921009573,
              961987163,
              1508970993,
              2453635748,
              2870763221,
              3624381080,
              310598401,
              607225278,
              1426881987,
              1925078388,
              2162078206,
              2614888103,
              3248222580,
              3835390401,
              4022224774,
              264347078,
              604807628,
              770255983,
              1249150122,
              1555081692,
              1996064986,
              2554220882,
              2821834349,
              2952996808,
              3210313671,
              3336571891,
              3584528711,
              113926993,
              338241895,
              666307205,
              773529912,
              1294757372,
              1396182291,
              1695183700,
              1986661051,
              2177026350,
              2456956037,
              2730485921,
              2820302411,
              3259730800,
              3345764771,
              3516065817,
              3600352804,
              4094571909,
              275423344,
              430227734,
              506948616,
              659060556,
              883997877,
              958139571,
              1322822218,
              1537002063,
              1747873779,
              1955562222,
              2024104815,
              2227730452,
              2361852424,
              2428436474,
              2756734187,
              3204031479,
              3329325298
            ]), U = /* @__PURE__ */ new Uint32Array(64);
            class P extends A.HashMD {
              constructor(lA = 32) {
                super(64, lA, 8, !1), this.A = A.SHA256_IV[0] | 0, this.B = A.SHA256_IV[1] | 0, this.C = A.SHA256_IV[2] | 0, this.D = A.SHA256_IV[3] | 0, this.E = A.SHA256_IV[4] | 0, this.F = A.SHA256_IV[5] | 0, this.G = A.SHA256_IV[6] | 0, this.H = A.SHA256_IV[7] | 0;
              }
              get() {
                const { A: lA, B: uA, C: w, D: v, E: RA, F: DA, G: $, H: cA } = this;
                return [lA, uA, w, v, RA, DA, $, cA];
              }
              // prettier-ignore
              set(lA, uA, w, v, RA, DA, $, cA) {
                this.A = lA | 0, this.B = uA | 0, this.C = w | 0, this.D = v | 0, this.E = RA | 0, this.F = DA | 0, this.G = $ | 0, this.H = cA | 0;
              }
              process(lA, uA) {
                for (let WA = 0; WA < 16; WA++, uA += 4)
                  U[WA] = lA.getUint32(uA, !1);
                for (let WA = 16; WA < 64; WA++) {
                  const EA = U[WA - 15], zA = U[WA - 2], OA = (0, d.rotr)(EA, 7) ^ (0, d.rotr)(EA, 18) ^ EA >>> 3, xA = (0, d.rotr)(zA, 17) ^ (0, d.rotr)(zA, 19) ^ zA >>> 10;
                  U[WA] = xA + U[WA - 7] + OA + U[WA - 16] | 0;
                }
                let { A: w, B: v, C: RA, D: DA, E: $, F: cA, G: $A, H: kA } = this;
                for (let WA = 0; WA < 64; WA++) {
                  const EA = (0, d.rotr)($, 6) ^ (0, d.rotr)($, 11) ^ (0, d.rotr)($, 25), zA = kA + EA + (0, A.Chi)($, cA, $A) + x[WA] + U[WA] | 0, xA = ((0, d.rotr)(w, 2) ^ (0, d.rotr)(w, 13) ^ (0, d.rotr)(w, 22)) + (0, A.Maj)(w, v, RA) | 0;
                  kA = $A, $A = cA, cA = $, $ = DA + zA | 0, DA = RA, RA = v, v = w, w = zA + xA | 0;
                }
                w = w + this.A | 0, v = v + this.B | 0, RA = RA + this.C | 0, DA = DA + this.D | 0, $ = $ + this.E | 0, cA = cA + this.F | 0, $A = $A + this.G | 0, kA = kA + this.H | 0, this.set(w, v, RA, DA, $, cA, $A, kA);
              }
              roundClean() {
                (0, d.clean)(U);
              }
              destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0), (0, d.clean)(this.buffer);
              }
            }
            B.SHA256 = P;
            class D extends P {
              constructor() {
                super(28), this.A = A.SHA224_IV[0] | 0, this.B = A.SHA224_IV[1] | 0, this.C = A.SHA224_IV[2] | 0, this.D = A.SHA224_IV[3] | 0, this.E = A.SHA224_IV[4] | 0, this.F = A.SHA224_IV[5] | 0, this.G = A.SHA224_IV[6] | 0, this.H = A.SHA224_IV[7] | 0;
              }
            }
            B.SHA224 = D;
            const J = a.split([
              "0x428a2f98d728ae22",
              "0x7137449123ef65cd",
              "0xb5c0fbcfec4d3b2f",
              "0xe9b5dba58189dbbc",
              "0x3956c25bf348b538",
              "0x59f111f1b605d019",
              "0x923f82a4af194f9b",
              "0xab1c5ed5da6d8118",
              "0xd807aa98a3030242",
              "0x12835b0145706fbe",
              "0x243185be4ee4b28c",
              "0x550c7dc3d5ffb4e2",
              "0x72be5d74f27b896f",
              "0x80deb1fe3b1696b1",
              "0x9bdc06a725c71235",
              "0xc19bf174cf692694",
              "0xe49b69c19ef14ad2",
              "0xefbe4786384f25e3",
              "0x0fc19dc68b8cd5b5",
              "0x240ca1cc77ac9c65",
              "0x2de92c6f592b0275",
              "0x4a7484aa6ea6e483",
              "0x5cb0a9dcbd41fbd4",
              "0x76f988da831153b5",
              "0x983e5152ee66dfab",
              "0xa831c66d2db43210",
              "0xb00327c898fb213f",
              "0xbf597fc7beef0ee4",
              "0xc6e00bf33da88fc2",
              "0xd5a79147930aa725",
              "0x06ca6351e003826f",
              "0x142929670a0e6e70",
              "0x27b70a8546d22ffc",
              "0x2e1b21385c26c926",
              "0x4d2c6dfc5ac42aed",
              "0x53380d139d95b3df",
              "0x650a73548baf63de",
              "0x766a0abb3c77b2a8",
              "0x81c2c92e47edaee6",
              "0x92722c851482353b",
              "0xa2bfe8a14cf10364",
              "0xa81a664bbc423001",
              "0xc24b8b70d0f89791",
              "0xc76c51a30654be30",
              "0xd192e819d6ef5218",
              "0xd69906245565a910",
              "0xf40e35855771202a",
              "0x106aa07032bbd1b8",
              "0x19a4c116b8d2d0c8",
              "0x1e376c085141ab53",
              "0x2748774cdf8eeb99",
              "0x34b0bcb5e19b48a8",
              "0x391c0cb3c5c95a63",
              "0x4ed8aa4ae3418acb",
              "0x5b9cca4f7763e373",
              "0x682e6ff3d6b2b8a3",
              "0x748f82ee5defb2fc",
              "0x78a5636f43172f60",
              "0x84c87814a1f0ab72",
              "0x8cc702081a6439ec",
              "0x90befffa23631e28",
              "0xa4506cebde82bde9",
              "0xbef9a3f7b2c67915",
              "0xc67178f2e372532b",
              "0xca273eceea26619c",
              "0xd186b8c721c0c207",
              "0xeada7dd6cde0eb1e",
              "0xf57d4f7fee6ed178",
              "0x06f067aa72176fba",
              "0x0a637dc5a2c898a6",
              "0x113f9804bef90dae",
              "0x1b710b35131c471b",
              "0x28db77f523047d84",
              "0x32caab7b40c72493",
              "0x3c9ebe0a15c9bebc",
              "0x431d67c49c100d4c",
              "0x4cc5d4becb3e42b6",
              "0x597f299cfc657e2a",
              "0x5fcb6fab3ad6faec",
              "0x6c44198c4a475817"
            ].map((tA) => BigInt(tA))), q = J[0], AA = J[1], K = /* @__PURE__ */ new Uint32Array(80), z = /* @__PURE__ */ new Uint32Array(80);
            class T extends A.HashMD {
              constructor(lA = 64) {
                super(128, lA, 16, !1), this.Ah = A.SHA512_IV[0] | 0, this.Al = A.SHA512_IV[1] | 0, this.Bh = A.SHA512_IV[2] | 0, this.Bl = A.SHA512_IV[3] | 0, this.Ch = A.SHA512_IV[4] | 0, this.Cl = A.SHA512_IV[5] | 0, this.Dh = A.SHA512_IV[6] | 0, this.Dl = A.SHA512_IV[7] | 0, this.Eh = A.SHA512_IV[8] | 0, this.El = A.SHA512_IV[9] | 0, this.Fh = A.SHA512_IV[10] | 0, this.Fl = A.SHA512_IV[11] | 0, this.Gh = A.SHA512_IV[12] | 0, this.Gl = A.SHA512_IV[13] | 0, this.Hh = A.SHA512_IV[14] | 0, this.Hl = A.SHA512_IV[15] | 0;
              }
              // prettier-ignore
              get() {
                const { Ah: lA, Al: uA, Bh: w, Bl: v, Ch: RA, Cl: DA, Dh: $, Dl: cA, Eh: $A, El: kA, Fh: WA, Fl: EA, Gh: zA, Gl: OA, Hh: xA, Hl: LA } = this;
                return [lA, uA, w, v, RA, DA, $, cA, $A, kA, WA, EA, zA, OA, xA, LA];
              }
              // prettier-ignore
              set(lA, uA, w, v, RA, DA, $, cA, $A, kA, WA, EA, zA, OA, xA, LA) {
                this.Ah = lA | 0, this.Al = uA | 0, this.Bh = w | 0, this.Bl = v | 0, this.Ch = RA | 0, this.Cl = DA | 0, this.Dh = $ | 0, this.Dl = cA | 0, this.Eh = $A | 0, this.El = kA | 0, this.Fh = WA | 0, this.Fl = EA | 0, this.Gh = zA | 0, this.Gl = OA | 0, this.Hh = xA | 0, this.Hl = LA | 0;
              }
              process(lA, uA) {
                for (let fA = 0; fA < 16; fA++, uA += 4)
                  K[fA] = lA.getUint32(uA), z[fA] = lA.getUint32(uA += 4);
                for (let fA = 16; fA < 80; fA++) {
                  const sA = K[fA - 15] | 0, F = z[fA - 15] | 0, o = a.rotrSH(sA, F, 1) ^ a.rotrSH(sA, F, 8) ^ a.shrSH(sA, F, 7), h = a.rotrSL(sA, F, 1) ^ a.rotrSL(sA, F, 8) ^ a.shrSL(sA, F, 7), _ = K[fA - 2] | 0, oA = z[fA - 2] | 0, p = a.rotrSH(_, oA, 19) ^ a.rotrBH(_, oA, 61) ^ a.shrSH(_, oA, 6), rA = a.rotrSL(_, oA, 19) ^ a.rotrBL(_, oA, 61) ^ a.shrSL(_, oA, 6), QA = a.add4L(h, rA, z[fA - 7], z[fA - 16]), bA = a.add4H(QA, o, p, K[fA - 7], K[fA - 16]);
                  K[fA] = bA | 0, z[fA] = QA | 0;
                }
                let { Ah: w, Al: v, Bh: RA, Bl: DA, Ch: $, Cl: cA, Dh: $A, Dl: kA, Eh: WA, El: EA, Fh: zA, Fl: OA, Gh: xA, Gl: LA, Hh: yA, Hl: TA } = this;
                for (let fA = 0; fA < 80; fA++) {
                  const sA = a.rotrSH(WA, EA, 14) ^ a.rotrSH(WA, EA, 18) ^ a.rotrBH(WA, EA, 41), F = a.rotrSL(WA, EA, 14) ^ a.rotrSL(WA, EA, 18) ^ a.rotrBL(WA, EA, 41), o = WA & zA ^ ~WA & xA, h = EA & OA ^ ~EA & LA, _ = a.add5L(TA, F, h, AA[fA], z[fA]), oA = a.add5H(_, yA, sA, o, q[fA], K[fA]), p = _ | 0, rA = a.rotrSH(w, v, 28) ^ a.rotrBH(w, v, 34) ^ a.rotrBH(w, v, 39), QA = a.rotrSL(w, v, 28) ^ a.rotrBL(w, v, 34) ^ a.rotrBL(w, v, 39), bA = w & RA ^ w & $ ^ RA & $, y = v & DA ^ v & cA ^ DA & cA;
                  yA = xA | 0, TA = LA | 0, xA = zA | 0, LA = OA | 0, zA = WA | 0, OA = EA | 0, { h: WA, l: EA } = a.add($A | 0, kA | 0, oA | 0, p | 0), $A = $ | 0, kA = cA | 0, $ = RA | 0, cA = DA | 0, RA = w | 0, DA = v | 0;
                  const M = a.add3L(p, QA, y);
                  w = a.add3H(M, oA, rA, bA), v = M | 0;
                }
                ({ h: w, l: v } = a.add(this.Ah | 0, this.Al | 0, w | 0, v | 0)), { h: RA, l: DA } = a.add(this.Bh | 0, this.Bl | 0, RA | 0, DA | 0), { h: $, l: cA } = a.add(this.Ch | 0, this.Cl | 0, $ | 0, cA | 0), { h: $A, l: kA } = a.add(this.Dh | 0, this.Dl | 0, $A | 0, kA | 0), { h: WA, l: EA } = a.add(this.Eh | 0, this.El | 0, WA | 0, EA | 0), { h: zA, l: OA } = a.add(this.Fh | 0, this.Fl | 0, zA | 0, OA | 0), { h: xA, l: LA } = a.add(this.Gh | 0, this.Gl | 0, xA | 0, LA | 0), { h: yA, l: TA } = a.add(this.Hh | 0, this.Hl | 0, yA | 0, TA | 0), this.set(w, v, RA, DA, $, cA, $A, kA, WA, EA, zA, OA, xA, LA, yA, TA);
              }
              roundClean() {
                (0, d.clean)(K, z);
              }
              destroy() {
                (0, d.clean)(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
              }
            }
            B.SHA512 = T;
            class H extends T {
              constructor() {
                super(48), this.Ah = A.SHA384_IV[0] | 0, this.Al = A.SHA384_IV[1] | 0, this.Bh = A.SHA384_IV[2] | 0, this.Bl = A.SHA384_IV[3] | 0, this.Ch = A.SHA384_IV[4] | 0, this.Cl = A.SHA384_IV[5] | 0, this.Dh = A.SHA384_IV[6] | 0, this.Dl = A.SHA384_IV[7] | 0, this.Eh = A.SHA384_IV[8] | 0, this.El = A.SHA384_IV[9] | 0, this.Fh = A.SHA384_IV[10] | 0, this.Fl = A.SHA384_IV[11] | 0, this.Gh = A.SHA384_IV[12] | 0, this.Gl = A.SHA384_IV[13] | 0, this.Hh = A.SHA384_IV[14] | 0, this.Hl = A.SHA384_IV[15] | 0;
              }
            }
            B.SHA384 = H;
            const eA = /* @__PURE__ */ Uint32Array.from([
              2352822216,
              424955298,
              1944164710,
              2312950998,
              502970286,
              855612546,
              1738396948,
              1479516111,
              258812777,
              2077511080,
              2011393907,
              79989058,
              1067287976,
              1780299464,
              286451373,
              2446758561
            ]), CA = /* @__PURE__ */ Uint32Array.from([
              573645204,
              4230739756,
              2673172387,
              3360449730,
              596883563,
              1867755857,
              2520282905,
              1497426621,
              2519219938,
              2827943907,
              3193839141,
              1401305490,
              721525244,
              746961066,
              246885852,
              2177182882
            ]);
            class IA extends T {
              constructor() {
                super(28), this.Ah = eA[0] | 0, this.Al = eA[1] | 0, this.Bh = eA[2] | 0, this.Bl = eA[3] | 0, this.Ch = eA[4] | 0, this.Cl = eA[5] | 0, this.Dh = eA[6] | 0, this.Dl = eA[7] | 0, this.Eh = eA[8] | 0, this.El = eA[9] | 0, this.Fh = eA[10] | 0, this.Fl = eA[11] | 0, this.Gh = eA[12] | 0, this.Gl = eA[13] | 0, this.Hh = eA[14] | 0, this.Hl = eA[15] | 0;
              }
            }
            B.SHA512_224 = IA;
            class k extends T {
              constructor() {
                super(32), this.Ah = CA[0] | 0, this.Al = CA[1] | 0, this.Bh = CA[2] | 0, this.Bl = CA[3] | 0, this.Ch = CA[4] | 0, this.Cl = CA[5] | 0, this.Dh = CA[6] | 0, this.Dl = CA[7] | 0, this.Eh = CA[8] | 0, this.El = CA[9] | 0, this.Fh = CA[10] | 0, this.Fl = CA[11] | 0, this.Gh = CA[12] | 0, this.Gl = CA[13] | 0, this.Hh = CA[14] | 0, this.Hl = CA[15] | 0;
              }
            }
            B.SHA512_256 = k, B.sha256 = (0, d.createHasher)(() => new P()), B.sha224 = (0, d.createHasher)(() => new D()), B.sha512 = (0, d.createHasher)(() => new T()), B.sha384 = (0, d.createHasher)(() => new H()), B.sha512_256 = (0, d.createHasher)(() => new k()), B.sha512_224 = (0, d.createHasher)(() => new IA());
          },
          /***/
          7785(Q, B, r) {
            Object.defineProperty(B, "__esModule", { value: !0 }), B.sha224 = B.SHA224 = B.sha256 = B.SHA256 = void 0;
            const A = r(2650);
            B.SHA256 = A.SHA256, B.sha256 = A.sha256, B.SHA224 = A.SHA224, B.sha224 = A.sha224;
          },
          /***/
          3973(Q, B, r) {
            /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
            Object.defineProperty(B, "__esModule", { value: !0 }), B.wrapXOFConstructorWithOpts = B.wrapConstructorWithOpts = B.wrapConstructor = B.Hash = B.nextTick = B.swap32IfBE = B.byteSwapIfBE = B.swap8IfBE = B.isLE = void 0, B.isBytes = a, B.anumber = d, B.abytes = x, B.ahash = U, B.aexists = P, B.aoutput = D, B.u8 = J, B.u32 = q, B.clean = AA, B.createView = K, B.rotr = z, B.rotl = T, B.byteSwap = H, B.byteSwap32 = eA, B.bytesToHex = k, B.hexToBytes = uA, B.asyncLoop = v, B.utf8ToBytes = RA, B.bytesToUtf8 = DA, B.toBytes = $, B.kdfInputToBytes = cA, B.concatBytes = $A, B.checkOpts = kA, B.createHasher = EA, B.createOptHasher = zA, B.createXOFer = OA, B.randomBytes = xA;
            const A = r(2491);
            function a(LA) {
              return LA instanceof Uint8Array || ArrayBuffer.isView(LA) && LA.constructor.name === "Uint8Array";
            }
            function d(LA) {
              if (!Number.isSafeInteger(LA) || LA < 0)
                throw new Error("positive integer expected, got " + LA);
            }
            function x(LA, ...yA) {
              if (!a(LA))
                throw new Error("Uint8Array expected");
              if (yA.length > 0 && !yA.includes(LA.length))
                throw new Error("Uint8Array expected of length " + yA + ", got length=" + LA.length);
            }
            function U(LA) {
              if (typeof LA != "function" || typeof LA.create != "function")
                throw new Error("Hash should be wrapped by utils.createHasher");
              d(LA.outputLen), d(LA.blockLen);
            }
            function P(LA, yA = !0) {
              if (LA.destroyed)
                throw new Error("Hash instance has been destroyed");
              if (yA && LA.finished)
                throw new Error("Hash#digest() has already been called");
            }
            function D(LA, yA) {
              x(LA);
              const TA = yA.outputLen;
              if (LA.length < TA)
                throw new Error("digestInto() expects output buffer of length at least " + TA);
            }
            function J(LA) {
              return new Uint8Array(LA.buffer, LA.byteOffset, LA.byteLength);
            }
            function q(LA) {
              return new Uint32Array(LA.buffer, LA.byteOffset, Math.floor(LA.byteLength / 4));
            }
            function AA(...LA) {
              for (let yA = 0; yA < LA.length; yA++)
                LA[yA].fill(0);
            }
            function K(LA) {
              return new DataView(LA.buffer, LA.byteOffset, LA.byteLength);
            }
            function z(LA, yA) {
              return LA << 32 - yA | LA >>> yA;
            }
            function T(LA, yA) {
              return LA << yA | LA >>> 32 - yA >>> 0;
            }
            B.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
            function H(LA) {
              return LA << 24 & 4278190080 | LA << 8 & 16711680 | LA >>> 8 & 65280 | LA >>> 24 & 255;
            }
            B.swap8IfBE = B.isLE ? (LA) => LA : (LA) => H(LA), B.byteSwapIfBE = B.swap8IfBE;
            function eA(LA) {
              for (let yA = 0; yA < LA.length; yA++)
                LA[yA] = H(LA[yA]);
              return LA;
            }
            B.swap32IfBE = B.isLE ? (LA) => LA : eA;
            const CA = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", IA = /* @__PURE__ */ Array.from({ length: 256 }, (LA, yA) => yA.toString(16).padStart(2, "0"));
            function k(LA) {
              if (x(LA), CA)
                return LA.toHex();
              let yA = "";
              for (let TA = 0; TA < LA.length; TA++)
                yA += IA[LA[TA]];
              return yA;
            }
            const tA = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
            function lA(LA) {
              if (LA >= tA._0 && LA <= tA._9)
                return LA - tA._0;
              if (LA >= tA.A && LA <= tA.F)
                return LA - (tA.A - 10);
              if (LA >= tA.a && LA <= tA.f)
                return LA - (tA.a - 10);
            }
            function uA(LA) {
              if (typeof LA != "string")
                throw new Error("hex string expected, got " + typeof LA);
              if (CA)
                return Uint8Array.fromHex(LA);
              const yA = LA.length, TA = yA / 2;
              if (yA % 2)
                throw new Error("hex string expected, got unpadded hex of length " + yA);
              const fA = new Uint8Array(TA);
              for (let sA = 0, F = 0; sA < TA; sA++, F += 2) {
                const o = lA(LA.charCodeAt(F)), h = lA(LA.charCodeAt(F + 1));
                if (o === void 0 || h === void 0) {
                  const _ = LA[F] + LA[F + 1];
                  throw new Error('hex string expected, got non-hex character "' + _ + '" at index ' + F);
                }
                fA[sA] = o * 16 + h;
              }
              return fA;
            }
            const w = async () => {
            };
            B.nextTick = w;
            async function v(LA, yA, TA) {
              let fA = Date.now();
              for (let sA = 0; sA < LA; sA++) {
                TA(sA);
                const F = Date.now() - fA;
                F >= 0 && F < yA || (await (0, B.nextTick)(), fA += F);
              }
            }
            function RA(LA) {
              if (typeof LA != "string")
                throw new Error("string expected");
              return new Uint8Array(new TextEncoder().encode(LA));
            }
            function DA(LA) {
              return new TextDecoder().decode(LA);
            }
            function $(LA) {
              return typeof LA == "string" && (LA = RA(LA)), x(LA), LA;
            }
            function cA(LA) {
              return typeof LA == "string" && (LA = RA(LA)), x(LA), LA;
            }
            function $A(...LA) {
              let yA = 0;
              for (let fA = 0; fA < LA.length; fA++) {
                const sA = LA[fA];
                x(sA), yA += sA.length;
              }
              const TA = new Uint8Array(yA);
              for (let fA = 0, sA = 0; fA < LA.length; fA++) {
                const F = LA[fA];
                TA.set(F, sA), sA += F.length;
              }
              return TA;
            }
            function kA(LA, yA) {
              if (yA !== void 0 && {}.toString.call(yA) !== "[object Object]")
                throw new Error("options should be object or undefined");
              return Object.assign(LA, yA);
            }
            class WA {
            }
            B.Hash = WA;
            function EA(LA) {
              const yA = (fA) => LA().update($(fA)).digest(), TA = LA();
              return yA.outputLen = TA.outputLen, yA.blockLen = TA.blockLen, yA.create = () => LA(), yA;
            }
            function zA(LA) {
              const yA = (fA, sA) => LA(sA).update($(fA)).digest(), TA = LA({});
              return yA.outputLen = TA.outputLen, yA.blockLen = TA.blockLen, yA.create = (fA) => LA(fA), yA;
            }
            function OA(LA) {
              const yA = (fA, sA) => LA(sA).update($(fA)).digest(), TA = LA({});
              return yA.outputLen = TA.outputLen, yA.blockLen = TA.blockLen, yA.create = (fA) => LA(fA), yA;
            }
            B.wrapConstructor = EA, B.wrapConstructorWithOpts = zA, B.wrapXOFConstructorWithOpts = OA;
            function xA(LA = 32) {
              if (A.crypto && typeof A.crypto.getRandomValues == "function")
                return A.crypto.getRandomValues(new Uint8Array(LA));
              if (A.crypto && typeof A.crypto.randomBytes == "function")
                return Uint8Array.from(A.crypto.randomBytes(LA));
              throw new Error("crypto.getRandomValues must be defined");
            }
          },
          /***/
          7801(Q, B, r) {
            var A = r(9964);
            function a(h) {
              "@babel/helpers - typeof";
              return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
                return typeof _;
              } : function(_) {
                return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
              }, a(h);
            }
            function d(h, _, oA) {
              return Object.defineProperty(h, "prototype", { writable: !1 }), h;
            }
            function x(h, _) {
              if (!(h instanceof _))
                throw new TypeError("Cannot call a class as a function");
            }
            var U = r(5403), P = U.codes, D = P.ERR_AMBIGUOUS_ARGUMENT, J = P.ERR_INVALID_ARG_TYPE, q = P.ERR_INVALID_ARG_VALUE, AA = P.ERR_INVALID_RETURN_VALUE, K = P.ERR_MISSING_ARGS, z = r(5416), T = r(7187), H = T.inspect, eA = r(7187).types, CA = eA.isPromise, IA = eA.isRegExp, k = r(7596)(), tA = r(9636)(), lA = r(7913)("RegExp.prototype.test"), uA, w;
            function v() {
              var h = r(6781);
              uA = h.isDeepEqual, w = h.isDeepStrictEqual;
            }
            var RA = !1, DA = Q.exports = WA, $ = {};
            function cA(h) {
              throw h.message instanceof Error ? h.message : new z(h);
            }
            function $A(h, _, oA, p, rA) {
              var QA = arguments.length, bA;
              if (QA === 0)
                bA = "Failed";
              else if (QA === 1)
                oA = h, h = void 0;
              else {
                if (RA === !1) {
                  RA = !0;
                  var y = A.emitWarning ? A.emitWarning : console.warn.bind(console);
                  y("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
                }
                QA === 2 && (p = "!=");
              }
              if (oA instanceof Error) throw oA;
              var M = {
                actual: h,
                expected: _,
                operator: p === void 0 ? "fail" : p,
                stackStartFn: rA || $A
              };
              oA !== void 0 && (M.message = oA);
              var FA = new z(M);
              throw bA && (FA.message = bA, FA.generatedMessage = !0), FA;
            }
            DA.fail = $A, DA.AssertionError = z;
            function kA(h, _, oA, p) {
              if (!oA) {
                var rA = !1;
                if (_ === 0)
                  rA = !0, p = "No value argument passed to `assert.ok()`";
                else if (p instanceof Error)
                  throw p;
                var QA = new z({
                  actual: oA,
                  expected: !0,
                  message: p,
                  operator: "==",
                  stackStartFn: h
                });
                throw QA.generatedMessage = rA, QA;
              }
            }
            function WA() {
              for (var h = arguments.length, _ = new Array(h), oA = 0; oA < h; oA++)
                _[oA] = arguments[oA];
              kA.apply(void 0, [WA, _.length].concat(_));
            }
            DA.ok = WA, DA.equal = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              _ != oA && cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "==",
                stackStartFn: h
              });
            }, DA.notEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              _ == oA && cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "!=",
                stackStartFn: h
              });
            }, DA.deepEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              uA === void 0 && v(), uA(_, oA) || cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "deepEqual",
                stackStartFn: h
              });
            }, DA.notDeepEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              uA === void 0 && v(), uA(_, oA) && cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "notDeepEqual",
                stackStartFn: h
              });
            }, DA.deepStrictEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              uA === void 0 && v(), w(_, oA) || cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "deepStrictEqual",
                stackStartFn: h
              });
            }, DA.notDeepStrictEqual = EA;
            function EA(h, _, oA) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              uA === void 0 && v(), w(h, _) && cA({
                actual: h,
                expected: _,
                message: oA,
                operator: "notDeepStrictEqual",
                stackStartFn: EA
              });
            }
            DA.strictEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              tA(_, oA) || cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "strictEqual",
                stackStartFn: h
              });
            }, DA.notStrictEqual = function h(_, oA, p) {
              if (arguments.length < 2)
                throw new K("actual", "expected");
              tA(_, oA) && cA({
                actual: _,
                expected: oA,
                message: p,
                operator: "notStrictEqual",
                stackStartFn: h
              });
            };
            var zA = /* @__PURE__ */ d(function h(_, oA, p) {
              var rA = this;
              x(this, h), oA.forEach(function(QA) {
                QA in _ && (p !== void 0 && typeof p[QA] == "string" && IA(_[QA]) && lA(_[QA], p[QA]) ? rA[QA] = p[QA] : rA[QA] = _[QA]);
              });
            });
            function OA(h, _, oA, p, rA, QA) {
              if (!(oA in h) || !w(h[oA], _[oA])) {
                if (!p) {
                  var bA = new zA(h, rA), y = new zA(_, rA, h), M = new z({
                    actual: bA,
                    expected: y,
                    operator: "deepStrictEqual",
                    stackStartFn: QA
                  });
                  throw M.actual = h, M.expected = _, M.operator = QA.name, M;
                }
                cA({
                  actual: h,
                  expected: _,
                  message: p,
                  operator: QA.name,
                  stackStartFn: QA
                });
              }
            }
            function xA(h, _, oA, p) {
              if (typeof _ != "function") {
                if (IA(_)) return lA(_, h);
                if (arguments.length === 2)
                  throw new J("expected", ["Function", "RegExp"], _);
                if (a(h) !== "object" || h === null) {
                  var rA = new z({
                    actual: h,
                    expected: _,
                    message: oA,
                    operator: "deepStrictEqual",
                    stackStartFn: p
                  });
                  throw rA.operator = p.name, rA;
                }
                var QA = Object.keys(_);
                if (_ instanceof Error)
                  QA.push("name", "message");
                else if (QA.length === 0)
                  throw new q("error", _, "may not be an empty object");
                return uA === void 0 && v(), QA.forEach(function(bA) {
                  typeof h[bA] == "string" && IA(_[bA]) && lA(_[bA], h[bA]) || OA(h, _, bA, oA, QA, p);
                }), !0;
              }
              return _.prototype !== void 0 && h instanceof _ ? !0 : Error.isPrototypeOf(_) ? !1 : _.call({}, h) === !0;
            }
            function LA(h) {
              if (typeof h != "function")
                throw new J("fn", "Function", h);
              try {
                h();
              } catch (_) {
                return _;
              }
              return $;
            }
            function yA(h) {
              return CA(h) || h !== null && a(h) === "object" && typeof h.then == "function" && typeof h.catch == "function";
            }
            function TA(h) {
              return Promise.resolve().then(function() {
                var _;
                if (typeof h == "function") {
                  if (_ = h(), !yA(_))
                    throw new AA("instance of Promise", "promiseFn", _);
                } else if (yA(h))
                  _ = h;
                else
                  throw new J("promiseFn", ["Function", "Promise"], h);
                return Promise.resolve().then(function() {
                  return _;
                }).then(function() {
                  return $;
                }).catch(function(oA) {
                  return oA;
                });
              });
            }
            function fA(h, _, oA, p) {
              if (typeof oA == "string") {
                if (arguments.length === 4)
                  throw new J("error", ["Object", "Error", "Function", "RegExp"], oA);
                if (a(_) === "object" && _ !== null) {
                  if (_.message === oA)
                    throw new D("error/message", 'The error message "'.concat(_.message, '" is identical to the message.'));
                } else if (_ === oA)
                  throw new D("error/message", 'The error "'.concat(_, '" is identical to the message.'));
                p = oA, oA = void 0;
              } else if (oA != null && a(oA) !== "object" && typeof oA != "function")
                throw new J("error", ["Object", "Error", "Function", "RegExp"], oA);
              if (_ === $) {
                var rA = "";
                oA && oA.name && (rA += " (".concat(oA.name, ")")), rA += p ? ": ".concat(p) : ".";
                var QA = h.name === "rejects" ? "rejection" : "exception";
                cA({
                  actual: void 0,
                  expected: oA,
                  operator: h.name,
                  message: "Missing expected ".concat(QA).concat(rA),
                  stackStartFn: h
                });
              }
              if (oA && !xA(_, oA, p, h))
                throw _;
            }
            function sA(h, _, oA, p) {
              if (_ !== $) {
                if (typeof oA == "string" && (p = oA, oA = void 0), !oA || xA(_, oA)) {
                  var rA = p ? ": ".concat(p) : ".", QA = h.name === "doesNotReject" ? "rejection" : "exception";
                  cA({
                    actual: _,
                    expected: oA,
                    operator: h.name,
                    message: "Got unwanted ".concat(QA).concat(rA, `
`) + 'Actual message: "'.concat(_ && _.message, '"'),
                    stackStartFn: h
                  });
                }
                throw _;
              }
            }
            DA.throws = function h(_) {
              for (var oA = arguments.length, p = new Array(oA > 1 ? oA - 1 : 0), rA = 1; rA < oA; rA++)
                p[rA - 1] = arguments[rA];
              fA.apply(void 0, [h, LA(_)].concat(p));
            }, DA.rejects = function h(_) {
              for (var oA = arguments.length, p = new Array(oA > 1 ? oA - 1 : 0), rA = 1; rA < oA; rA++)
                p[rA - 1] = arguments[rA];
              return TA(_).then(function(QA) {
                return fA.apply(void 0, [h, QA].concat(p));
              });
            }, DA.doesNotThrow = function h(_) {
              for (var oA = arguments.length, p = new Array(oA > 1 ? oA - 1 : 0), rA = 1; rA < oA; rA++)
                p[rA - 1] = arguments[rA];
              sA.apply(void 0, [h, LA(_)].concat(p));
            }, DA.doesNotReject = function h(_) {
              for (var oA = arguments.length, p = new Array(oA > 1 ? oA - 1 : 0), rA = 1; rA < oA; rA++)
                p[rA - 1] = arguments[rA];
              return TA(_).then(function(QA) {
                return sA.apply(void 0, [h, QA].concat(p));
              });
            }, DA.ifError = function h(_) {
              if (_ != null) {
                var oA = "ifError got unwanted exception: ";
                a(_) === "object" && typeof _.message == "string" ? _.message.length === 0 && _.constructor ? oA += _.constructor.name : oA += _.message : oA += H(_);
                var p = new z({
                  actual: _,
                  expected: null,
                  operator: "ifError",
                  message: oA,
                  stackStartFn: h
                }), rA = _.stack;
                if (typeof rA == "string") {
                  var QA = rA.split(`
`);
                  QA.shift();
                  for (var bA = p.stack.split(`
`), y = 0; y < QA.length; y++) {
                    var M = bA.indexOf(QA[y]);
                    if (M !== -1) {
                      bA = bA.slice(0, M);
                      break;
                    }
                  }
                  p.stack = "".concat(bA.join(`
`), `
`).concat(QA.join(`
`));
                }
                throw p;
              }
            };
            function F(h, _, oA, p, rA) {
              if (!IA(_))
                throw new J("regexp", "RegExp", _);
              var QA = rA === "match";
              if (typeof h != "string" || lA(_, h) !== QA) {
                if (oA instanceof Error)
                  throw oA;
                var bA = !oA;
                oA = oA || (typeof h != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(a(h), " (").concat(H(h), ")") : (QA ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(H(_), `. Input:

`).concat(H(h), `
`));
                var y = new z({
                  actual: h,
                  expected: _,
                  message: oA,
                  operator: rA,
                  stackStartFn: p
                });
                throw y.generatedMessage = bA, y;
              }
            }
            DA.match = function h(_, oA, p) {
              F(_, oA, p, h, "match");
            }, DA.doesNotMatch = function h(_, oA, p) {
              F(_, oA, p, h, "doesNotMatch");
            };
            function o() {
              for (var h = arguments.length, _ = new Array(h), oA = 0; oA < h; oA++)
                _[oA] = arguments[oA];
              kA.apply(void 0, [o, _.length].concat(_));
            }
            DA.strict = k(o, DA, {
              equal: DA.strictEqual,
              deepEqual: DA.deepStrictEqual,
              notEqual: DA.notStrictEqual,
              notDeepEqual: DA.notDeepStrictEqual
            }), DA.strict.strict = DA.strict;
          },
          /***/
          5416(Q, B, r) {
            var A = r(9964);
            function a(TA, fA) {
              var sA = Object.keys(TA);
              if (Object.getOwnPropertySymbols) {
                var F = Object.getOwnPropertySymbols(TA);
                fA && (F = F.filter(function(o) {
                  return Object.getOwnPropertyDescriptor(TA, o).enumerable;
                })), sA.push.apply(sA, F);
              }
              return sA;
            }
            function d(TA) {
              for (var fA = 1; fA < arguments.length; fA++) {
                var sA = arguments[fA] != null ? arguments[fA] : {};
                fA % 2 ? a(Object(sA), !0).forEach(function(F) {
                  x(TA, F, sA[F]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(TA, Object.getOwnPropertyDescriptors(sA)) : a(Object(sA)).forEach(function(F) {
                  Object.defineProperty(TA, F, Object.getOwnPropertyDescriptor(sA, F));
                });
              }
              return TA;
            }
            function x(TA, fA, sA) {
              return fA = J(fA), fA in TA ? Object.defineProperty(TA, fA, { value: sA, enumerable: !0, configurable: !0, writable: !0 }) : TA[fA] = sA, TA;
            }
            function U(TA, fA) {
              if (!(TA instanceof fA))
                throw new TypeError("Cannot call a class as a function");
            }
            function P(TA, fA) {
              for (var sA = 0; sA < fA.length; sA++) {
                var F = fA[sA];
                F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(TA, J(F.key), F);
              }
            }
            function D(TA, fA, sA) {
              return fA && P(TA.prototype, fA), Object.defineProperty(TA, "prototype", { writable: !1 }), TA;
            }
            function J(TA) {
              var fA = q(TA, "string");
              return lA(fA) === "symbol" ? fA : String(fA);
            }
            function q(TA, fA) {
              if (lA(TA) !== "object" || TA === null) return TA;
              var sA = TA[Symbol.toPrimitive];
              if (sA !== void 0) {
                var F = sA.call(TA, fA);
                if (lA(F) !== "object") return F;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String(TA);
            }
            function AA(TA, fA) {
              if (typeof fA != "function" && fA !== null)
                throw new TypeError("Super expression must either be null or a function");
              TA.prototype = Object.create(fA && fA.prototype, { constructor: { value: TA, writable: !0, configurable: !0 } }), Object.defineProperty(TA, "prototype", { writable: !1 }), fA && k(TA, fA);
            }
            function K(TA) {
              var fA = CA();
              return function() {
                var F = tA(TA), o;
                if (fA) {
                  var h = tA(this).constructor;
                  o = Reflect.construct(F, arguments, h);
                } else
                  o = F.apply(this, arguments);
                return z(this, o);
              };
            }
            function z(TA, fA) {
              if (fA && (lA(fA) === "object" || typeof fA == "function"))
                return fA;
              if (fA !== void 0)
                throw new TypeError("Derived constructors may only return object or undefined");
              return T(TA);
            }
            function T(TA) {
              if (TA === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return TA;
            }
            function H(TA) {
              var fA = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return H = function(F) {
                if (F === null || !IA(F)) return F;
                if (typeof F != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof fA < "u") {
                  if (fA.has(F)) return fA.get(F);
                  fA.set(F, o);
                }
                function o() {
                  return eA(F, arguments, tA(this).constructor);
                }
                return o.prototype = Object.create(F.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), k(o, F);
              }, H(TA);
            }
            function eA(TA, fA, sA) {
              return CA() ? eA = Reflect.construct.bind() : eA = function(o, h, _) {
                var oA = [null];
                oA.push.apply(oA, h);
                var p = Function.bind.apply(o, oA), rA = new p();
                return _ && k(rA, _.prototype), rA;
              }, eA.apply(null, arguments);
            }
            function CA() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function IA(TA) {
              return Function.toString.call(TA).indexOf("[native code]") !== -1;
            }
            function k(TA, fA) {
              return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(F, o) {
                return F.__proto__ = o, F;
              }, k(TA, fA);
            }
            function tA(TA) {
              return tA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(sA) {
                return sA.__proto__ || Object.getPrototypeOf(sA);
              }, tA(TA);
            }
            function lA(TA) {
              "@babel/helpers - typeof";
              return lA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(fA) {
                return typeof fA;
              } : function(fA) {
                return fA && typeof Symbol == "function" && fA.constructor === Symbol && fA !== Symbol.prototype ? "symbol" : typeof fA;
              }, lA(TA);
            }
            var uA = r(7187), w = uA.inspect, v = r(5403), RA = v.codes.ERR_INVALID_ARG_TYPE;
            function DA(TA, fA, sA) {
              return (sA === void 0 || sA > TA.length) && (sA = TA.length), TA.substring(sA - fA.length, sA) === fA;
            }
            function $(TA, fA) {
              if (fA = Math.floor(fA), TA.length == 0 || fA == 0) return "";
              var sA = TA.length * fA;
              for (fA = Math.floor(Math.log(fA) / Math.log(2)); fA; )
                TA += TA, fA--;
              return TA += TA.substring(0, sA - TA.length), TA;
            }
            var cA = "", $A = "", kA = "", WA = "", EA = {
              deepStrictEqual: "Expected values to be strictly deep-equal:",
              strictEqual: "Expected values to be strictly equal:",
              strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
              deepEqual: "Expected values to be loosely deep-equal:",
              equal: "Expected values to be loosely equal:",
              notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
              notStrictEqual: 'Expected "actual" to be strictly unequal to:',
              notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
              notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
              notEqual: 'Expected "actual" to be loosely unequal to:',
              notIdentical: "Values identical but not reference-equal:"
            }, zA = 10;
            function OA(TA) {
              var fA = Object.keys(TA), sA = Object.create(Object.getPrototypeOf(TA));
              return fA.forEach(function(F) {
                sA[F] = TA[F];
              }), Object.defineProperty(sA, "message", {
                value: TA.message
              }), sA;
            }
            function xA(TA) {
              return w(TA, {
                compact: !1,
                customInspect: !1,
                depth: 1e3,
                maxArrayLength: 1 / 0,
                // Assert compares only enumerable properties (with a few exceptions).
                showHidden: !1,
                // Having a long line as error is better than wrapping the line for
                // comparison for now.
                // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
                // have meta information about the inspected properties (i.e., know where
                // in what line the property starts and ends).
                breakLength: 1 / 0,
                // Assert does not detect proxies currently.
                showProxy: !1,
                sorted: !0,
                // Inspect getters as we also check them when comparing entries.
                getters: !0
              });
            }
            function LA(TA, fA, sA) {
              var F = "", o = "", h = 0, _ = "", oA = !1, p = xA(TA), rA = p.split(`
`), QA = xA(fA).split(`
`), bA = 0, y = "";
              if (sA === "strictEqual" && lA(TA) === "object" && lA(fA) === "object" && TA !== null && fA !== null && (sA = "strictEqualObject"), rA.length === 1 && QA.length === 1 && rA[0] !== QA[0]) {
                var M = rA[0].length + QA[0].length;
                if (M <= zA) {
                  if ((lA(TA) !== "object" || TA === null) && (lA(fA) !== "object" || fA === null) && (TA !== 0 || fA !== 0))
                    return "".concat(EA[sA], `

`) + "".concat(rA[0], " !== ").concat(QA[0], `
`);
                } else if (sA !== "strictEqualObject") {
                  var FA = A.stderr && A.stderr.isTTY ? A.stderr.columns : 80;
                  if (M < FA) {
                    for (; rA[0][bA] === QA[0][bA]; )
                      bA++;
                    bA > 2 && (y = `
  `.concat($(" ", bA), "^"), bA = 0);
                  }
                }
              }
              for (var dA = rA[rA.length - 1], he = QA[QA.length - 1]; dA === he && (bA++ < 2 ? _ = `
  `.concat(dA).concat(_) : F = dA, rA.pop(), QA.pop(), !(rA.length === 0 || QA.length === 0)); )
                dA = rA[rA.length - 1], he = QA[QA.length - 1];
              var ie = Math.max(rA.length, QA.length);
              if (ie === 0) {
                var KA = p.split(`
`);
                if (KA.length > 30)
                  for (KA[26] = "".concat(cA, "...").concat(WA); KA.length > 27; )
                    KA.pop();
                return "".concat(EA.notIdentical, `

`).concat(KA.join(`
`), `
`);
              }
              bA > 3 && (_ = `
`.concat(cA, "...").concat(WA).concat(_), oA = !0), F !== "" && (_ = `
  `.concat(F).concat(_), F = "");
              var Pe = 0, Je = EA[sA] + `
`.concat($A, "+ actual").concat(WA, " ").concat(kA, "- expected").concat(WA), Le = " ".concat(cA, "...").concat(WA, " Lines skipped");
              for (bA = 0; bA < ie; bA++) {
                var Re = bA - h;
                if (rA.length < bA + 1)
                  Re > 1 && bA > 2 && (Re > 4 ? (o += `
`.concat(cA, "...").concat(WA), oA = !0) : Re > 3 && (o += `
  `.concat(QA[bA - 2]), Pe++), o += `
  `.concat(QA[bA - 1]), Pe++), h = bA, F += `
`.concat(kA, "-").concat(WA, " ").concat(QA[bA]), Pe++;
                else if (QA.length < bA + 1)
                  Re > 1 && bA > 2 && (Re > 4 ? (o += `
`.concat(cA, "...").concat(WA), oA = !0) : Re > 3 && (o += `
  `.concat(rA[bA - 2]), Pe++), o += `
  `.concat(rA[bA - 1]), Pe++), h = bA, o += `
`.concat($A, "+").concat(WA, " ").concat(rA[bA]), Pe++;
                else {
                  var _e = QA[bA], se = rA[bA], Ee = se !== _e && (!DA(se, ",") || se.slice(0, -1) !== _e);
                  Ee && DA(_e, ",") && _e.slice(0, -1) === se && (Ee = !1, se += ","), Ee ? (Re > 1 && bA > 2 && (Re > 4 ? (o += `
`.concat(cA, "...").concat(WA), oA = !0) : Re > 3 && (o += `
  `.concat(rA[bA - 2]), Pe++), o += `
  `.concat(rA[bA - 1]), Pe++), h = bA, o += `
`.concat($A, "+").concat(WA, " ").concat(se), F += `
`.concat(kA, "-").concat(WA, " ").concat(_e), Pe += 2) : (o += F, F = "", (Re === 1 || bA === 0) && (o += `
  `.concat(se), Pe++));
                }
                if (Pe > 20 && bA < ie - 2)
                  return "".concat(Je).concat(Le, `
`).concat(o, `
`).concat(cA, "...").concat(WA).concat(F, `
`) + "".concat(cA, "...").concat(WA);
              }
              return "".concat(Je).concat(oA ? Le : "", `
`).concat(o).concat(F).concat(_).concat(y);
            }
            var yA = /* @__PURE__ */ (function(TA, fA) {
              AA(F, TA);
              var sA = K(F);
              function F(o) {
                var h;
                if (U(this, F), lA(o) !== "object" || o === null)
                  throw new RA("options", "Object", o);
                var _ = o.message, oA = o.operator, p = o.stackStartFn, rA = o.actual, QA = o.expected, bA = Error.stackTraceLimit;
                if (Error.stackTraceLimit = 0, _ != null)
                  h = sA.call(this, String(_));
                else if (A.stderr && A.stderr.isTTY && (A.stderr && A.stderr.getColorDepth && A.stderr.getColorDepth() !== 1 ? (cA = "\x1B[34m", $A = "\x1B[32m", WA = "\x1B[39m", kA = "\x1B[31m") : (cA = "", $A = "", WA = "", kA = "")), lA(rA) === "object" && rA !== null && lA(QA) === "object" && QA !== null && "stack" in rA && rA instanceof Error && "stack" in QA && QA instanceof Error && (rA = OA(rA), QA = OA(QA)), oA === "deepStrictEqual" || oA === "strictEqual")
                  h = sA.call(this, LA(rA, QA, oA));
                else if (oA === "notDeepStrictEqual" || oA === "notStrictEqual") {
                  var y = EA[oA], M = xA(rA).split(`
`);
                  if (oA === "notStrictEqual" && lA(rA) === "object" && rA !== null && (y = EA.notStrictEqualObject), M.length > 30)
                    for (M[26] = "".concat(cA, "...").concat(WA); M.length > 27; )
                      M.pop();
                  M.length === 1 ? h = sA.call(this, "".concat(y, " ").concat(M[0])) : h = sA.call(this, "".concat(y, `

`).concat(M.join(`
`), `
`));
                } else {
                  var FA = xA(rA), dA = "", he = EA[oA];
                  oA === "notDeepEqual" || oA === "notEqual" ? (FA = "".concat(EA[oA], `

`).concat(FA), FA.length > 1024 && (FA = "".concat(FA.slice(0, 1021), "..."))) : (dA = "".concat(xA(QA)), FA.length > 512 && (FA = "".concat(FA.slice(0, 509), "...")), dA.length > 512 && (dA = "".concat(dA.slice(0, 509), "...")), oA === "deepEqual" || oA === "equal" ? FA = "".concat(he, `

`).concat(FA, `

should equal

`) : dA = " ".concat(oA, " ").concat(dA)), h = sA.call(this, "".concat(FA).concat(dA));
                }
                return Error.stackTraceLimit = bA, h.generatedMessage = !_, Object.defineProperty(T(h), "name", {
                  value: "AssertionError [ERR_ASSERTION]",
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }), h.code = "ERR_ASSERTION", h.actual = rA, h.expected = QA, h.operator = oA, Error.captureStackTrace && Error.captureStackTrace(T(h), p), h.stack, h.name = "AssertionError", z(h);
              }
              return D(F, [{
                key: "toString",
                value: function() {
                  return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                }
              }, {
                key: fA,
                value: function(h, _) {
                  return w(this, d(d({}, _), {}, {
                    customInspect: !1,
                    depth: 0
                  }));
                }
              }]), F;
            })(/* @__PURE__ */ H(Error), w.custom);
            Q.exports = yA;
          },
          /***/
          5403(Q, B, r) {
            function A(tA) {
              "@babel/helpers - typeof";
              return A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(lA) {
                return typeof lA;
              } : function(lA) {
                return lA && typeof Symbol == "function" && lA.constructor === Symbol && lA !== Symbol.prototype ? "symbol" : typeof lA;
              }, A(tA);
            }
            function a(tA, lA, uA) {
              return Object.defineProperty(tA, "prototype", { writable: !1 }), tA;
            }
            function d(tA, lA) {
              if (!(tA instanceof lA))
                throw new TypeError("Cannot call a class as a function");
            }
            function x(tA, lA) {
              if (typeof lA != "function" && lA !== null)
                throw new TypeError("Super expression must either be null or a function");
              tA.prototype = Object.create(lA && lA.prototype, { constructor: { value: tA, writable: !0, configurable: !0 } }), Object.defineProperty(tA, "prototype", { writable: !1 }), lA && U(tA, lA);
            }
            function U(tA, lA) {
              return U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(w, v) {
                return w.__proto__ = v, w;
              }, U(tA, lA);
            }
            function P(tA) {
              var lA = q();
              return function() {
                var w = AA(tA), v;
                if (lA) {
                  var RA = AA(this).constructor;
                  v = Reflect.construct(w, arguments, RA);
                } else
                  v = w.apply(this, arguments);
                return D(this, v);
              };
            }
            function D(tA, lA) {
              if (lA && (A(lA) === "object" || typeof lA == "function"))
                return lA;
              if (lA !== void 0)
                throw new TypeError("Derived constructors may only return object or undefined");
              return J(tA);
            }
            function J(tA) {
              if (tA === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return tA;
            }
            function q() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function AA(tA) {
              return AA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(uA) {
                return uA.__proto__ || Object.getPrototypeOf(uA);
              }, AA(tA);
            }
            var K = {}, z, T;
            function H(tA, lA, uA) {
              uA || (uA = Error);
              function w(RA, DA, $) {
                return typeof lA == "string" ? lA : lA(RA, DA, $);
              }
              var v = /* @__PURE__ */ (function(RA) {
                x($, RA);
                var DA = P($);
                function $(cA, $A, kA) {
                  var WA;
                  return d(this, $), WA = DA.call(this, w(cA, $A, kA)), WA.code = tA, WA;
                }
                return a($);
              })(uA);
              K[tA] = v;
            }
            function eA(tA, lA) {
              if (Array.isArray(tA)) {
                var uA = tA.length;
                return tA = tA.map(function(w) {
                  return String(w);
                }), uA > 2 ? "one of ".concat(lA, " ").concat(tA.slice(0, uA - 1).join(", "), ", or ") + tA[uA - 1] : uA === 2 ? "one of ".concat(lA, " ").concat(tA[0], " or ").concat(tA[1]) : "of ".concat(lA, " ").concat(tA[0]);
              } else
                return "of ".concat(lA, " ").concat(String(tA));
            }
            function CA(tA, lA, uA) {
              return tA.substr(0, lA.length) === lA;
            }
            function IA(tA, lA, uA) {
              return (uA === void 0 || uA > tA.length) && (uA = tA.length), tA.substring(uA - lA.length, uA) === lA;
            }
            function k(tA, lA, uA) {
              return typeof uA != "number" && (uA = 0), uA + lA.length > tA.length ? !1 : tA.indexOf(lA, uA) !== -1;
            }
            H("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), H("ERR_INVALID_ARG_TYPE", function(tA, lA, uA) {
              z === void 0 && (z = r(7801)), z(typeof tA == "string", "'name' must be a string");
              var w;
              typeof lA == "string" && CA(lA, "not ") ? (w = "must not be", lA = lA.replace(/^not /, "")) : w = "must be";
              var v;
              if (IA(tA, " argument"))
                v = "The ".concat(tA, " ").concat(w, " ").concat(eA(lA, "type"));
              else {
                var RA = k(tA, ".") ? "property" : "argument";
                v = 'The "'.concat(tA, '" ').concat(RA, " ").concat(w, " ").concat(eA(lA, "type"));
              }
              return v += ". Received type ".concat(A(uA)), v;
            }, TypeError), H("ERR_INVALID_ARG_VALUE", function(tA, lA) {
              var uA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
              T === void 0 && (T = r(7187));
              var w = T.inspect(lA);
              return w.length > 128 && (w = "".concat(w.slice(0, 128), "...")), "The argument '".concat(tA, "' ").concat(uA, ". Received ").concat(w);
            }, TypeError), H("ERR_INVALID_RETURN_VALUE", function(tA, lA, uA) {
              var w;
              return uA && uA.constructor && uA.constructor.name ? w = "instance of ".concat(uA.constructor.name) : w = "type ".concat(A(uA)), "Expected ".concat(tA, ' to be returned from the "').concat(lA, '"') + " function but got ".concat(w, ".");
            }, TypeError), H("ERR_MISSING_ARGS", function() {
              for (var tA = arguments.length, lA = new Array(tA), uA = 0; uA < tA; uA++)
                lA[uA] = arguments[uA];
              z === void 0 && (z = r(7801)), z(lA.length > 0, "At least one arg needs to be specified");
              var w = "The ", v = lA.length;
              switch (lA = lA.map(function(RA) {
                return '"'.concat(RA, '"');
              }), v) {
                case 1:
                  w += "".concat(lA[0], " argument");
                  break;
                case 2:
                  w += "".concat(lA[0], " and ").concat(lA[1], " arguments");
                  break;
                default:
                  w += lA.slice(0, v - 1).join(", "), w += ", and ".concat(lA[v - 1], " arguments");
                  break;
              }
              return "".concat(w, " must be specified");
            }, TypeError), Q.exports.codes = K;
          },
          /***/
          6781(Q, B, r) {
            function A(se, Ee) {
              return P(se) || U(se, Ee) || d(se, Ee) || a();
            }
            function a() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function d(se, Ee) {
              if (se) {
                if (typeof se == "string") return x(se, Ee);
                var wA = Object.prototype.toString.call(se).slice(8, -1);
                if (wA === "Object" && se.constructor && (wA = se.constructor.name), wA === "Map" || wA === "Set") return Array.from(se);
                if (wA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(wA)) return x(se, Ee);
              }
            }
            function x(se, Ee) {
              (Ee == null || Ee > se.length) && (Ee = se.length);
              for (var wA = 0, N = new Array(Ee); wA < Ee; wA++) N[wA] = se[wA];
              return N;
            }
            function U(se, Ee) {
              var wA = se == null ? null : typeof Symbol < "u" && se[Symbol.iterator] || se["@@iterator"];
              if (wA != null) {
                var N, G, W, aA, j = [], pA = !0, Be = !1;
                try {
                  if (W = (wA = wA.call(se)).next, Ee !== 0) for (; !(pA = (N = W.call(wA)).done) && (j.push(N.value), j.length !== Ee); pA = !0) ;
                } catch (Ie) {
                  Be = !0, G = Ie;
                } finally {
                  try {
                    if (!pA && wA.return != null && (aA = wA.return(), Object(aA) !== aA)) return;
                  } finally {
                    if (Be) throw G;
                  }
                }
                return j;
              }
            }
            function P(se) {
              if (Array.isArray(se)) return se;
            }
            function D(se) {
              "@babel/helpers - typeof";
              return D = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ee) {
                return typeof Ee;
              } : function(Ee) {
                return Ee && typeof Symbol == "function" && Ee.constructor === Symbol && Ee !== Symbol.prototype ? "symbol" : typeof Ee;
              }, D(se);
            }
            var J = /a/g.flags !== void 0, q = function(Ee) {
              var wA = [];
              return Ee.forEach(function(N) {
                return wA.push(N);
              }), wA;
            }, AA = function(Ee) {
              var wA = [];
              return Ee.forEach(function(N, G) {
                return wA.push([G, N]);
              }), wA;
            }, K = Object.is ? Object.is : r(8527), z = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
              return [];
            }, T = Number.isNaN ? Number.isNaN : r(7051);
            function H(se) {
              return se.call.bind(se);
            }
            var eA = H(Object.prototype.hasOwnProperty), CA = H(Object.prototype.propertyIsEnumerable), IA = H(Object.prototype.toString), k = r(7187).types, tA = k.isAnyArrayBuffer, lA = k.isArrayBufferView, uA = k.isDate, w = k.isMap, v = k.isRegExp, RA = k.isSet, DA = k.isNativeError, $ = k.isBoxedPrimitive, cA = k.isNumberObject, $A = k.isStringObject, kA = k.isBooleanObject, WA = k.isBigIntObject, EA = k.isSymbolObject, zA = k.isFloat32Array, OA = k.isFloat64Array;
            function xA(se) {
              if (se.length === 0 || se.length > 10) return !0;
              for (var Ee = 0; Ee < se.length; Ee++) {
                var wA = se.charCodeAt(Ee);
                if (wA < 48 || wA > 57) return !0;
              }
              return se.length === 10 && se >= Math.pow(2, 32);
            }
            function LA(se) {
              return Object.keys(se).filter(xA).concat(z(se).filter(Object.prototype.propertyIsEnumerable.bind(se)));
            }
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
             * @license  MIT
             */
            function yA(se, Ee) {
              if (se === Ee)
                return 0;
              for (var wA = se.length, N = Ee.length, G = 0, W = Math.min(wA, N); G < W; ++G)
                if (se[G] !== Ee[G]) {
                  wA = se[G], N = Ee[G];
                  break;
                }
              return wA < N ? -1 : N < wA ? 1 : 0;
            }
            var TA = !0, fA = !1, sA = 0, F = 1, o = 2, h = 3;
            function _(se, Ee) {
              return J ? se.source === Ee.source && se.flags === Ee.flags : RegExp.prototype.toString.call(se) === RegExp.prototype.toString.call(Ee);
            }
            function oA(se, Ee) {
              if (se.byteLength !== Ee.byteLength)
                return !1;
              for (var wA = 0; wA < se.byteLength; wA++)
                if (se[wA] !== Ee[wA])
                  return !1;
              return !0;
            }
            function p(se, Ee) {
              return se.byteLength !== Ee.byteLength ? !1 : yA(new Uint8Array(se.buffer, se.byteOffset, se.byteLength), new Uint8Array(Ee.buffer, Ee.byteOffset, Ee.byteLength)) === 0;
            }
            function rA(se, Ee) {
              return se.byteLength === Ee.byteLength && yA(new Uint8Array(se), new Uint8Array(Ee)) === 0;
            }
            function QA(se, Ee) {
              return cA(se) ? cA(Ee) && K(Number.prototype.valueOf.call(se), Number.prototype.valueOf.call(Ee)) : $A(se) ? $A(Ee) && String.prototype.valueOf.call(se) === String.prototype.valueOf.call(Ee) : kA(se) ? kA(Ee) && Boolean.prototype.valueOf.call(se) === Boolean.prototype.valueOf.call(Ee) : WA(se) ? WA(Ee) && BigInt.prototype.valueOf.call(se) === BigInt.prototype.valueOf.call(Ee) : EA(Ee) && Symbol.prototype.valueOf.call(se) === Symbol.prototype.valueOf.call(Ee);
            }
            function bA(se, Ee, wA, N) {
              if (se === Ee)
                return se !== 0 ? !0 : wA ? K(se, Ee) : !0;
              if (wA) {
                if (D(se) !== "object")
                  return typeof se == "number" && T(se) && T(Ee);
                if (D(Ee) !== "object" || se === null || Ee === null || Object.getPrototypeOf(se) !== Object.getPrototypeOf(Ee))
                  return !1;
              } else {
                if (se === null || D(se) !== "object")
                  return Ee === null || D(Ee) !== "object" ? se == Ee : !1;
                if (Ee === null || D(Ee) !== "object")
                  return !1;
              }
              var G = IA(se), W = IA(Ee);
              if (G !== W)
                return !1;
              if (Array.isArray(se)) {
                if (se.length !== Ee.length)
                  return !1;
                var aA = LA(se), j = LA(Ee);
                return aA.length !== j.length ? !1 : M(se, Ee, wA, N, F, aA);
              }
              if (G === "[object Object]" && (!w(se) && w(Ee) || !RA(se) && RA(Ee)))
                return !1;
              if (uA(se)) {
                if (!uA(Ee) || Date.prototype.getTime.call(se) !== Date.prototype.getTime.call(Ee))
                  return !1;
              } else if (v(se)) {
                if (!v(Ee) || !_(se, Ee))
                  return !1;
              } else if (DA(se) || se instanceof Error) {
                if (se.message !== Ee.message || se.name !== Ee.name)
                  return !1;
              } else if (lA(se)) {
                if (!wA && (zA(se) || OA(se))) {
                  if (!oA(se, Ee))
                    return !1;
                } else if (!p(se, Ee))
                  return !1;
                var pA = LA(se), Be = LA(Ee);
                return pA.length !== Be.length ? !1 : M(se, Ee, wA, N, sA, pA);
              } else {
                if (RA(se))
                  return !RA(Ee) || se.size !== Ee.size ? !1 : M(se, Ee, wA, N, o);
                if (w(se))
                  return !w(Ee) || se.size !== Ee.size ? !1 : M(se, Ee, wA, N, h);
                if (tA(se)) {
                  if (!rA(se, Ee))
                    return !1;
                } else if ($(se) && !QA(se, Ee))
                  return !1;
              }
              return M(se, Ee, wA, N, sA);
            }
            function y(se, Ee) {
              return Ee.filter(function(wA) {
                return CA(se, wA);
              });
            }
            function M(se, Ee, wA, N, G, W) {
              if (arguments.length === 5) {
                W = Object.keys(se);
                var aA = Object.keys(Ee);
                if (W.length !== aA.length)
                  return !1;
              }
              for (var j = 0; j < W.length; j++)
                if (!eA(Ee, W[j]))
                  return !1;
              if (wA && arguments.length === 5) {
                var pA = z(se);
                if (pA.length !== 0) {
                  var Be = 0;
                  for (j = 0; j < pA.length; j++) {
                    var Ie = pA[j];
                    if (CA(se, Ie)) {
                      if (!CA(Ee, Ie))
                        return !1;
                      W.push(Ie), Be++;
                    } else if (CA(Ee, Ie))
                      return !1;
                  }
                  var ee = z(Ee);
                  if (pA.length !== ee.length && y(Ee, ee).length !== Be)
                    return !1;
                } else {
                  var Me = z(Ee);
                  if (Me.length !== 0 && y(Ee, Me).length !== 0)
                    return !1;
                }
              }
              if (W.length === 0 && (G === sA || G === F && se.length === 0 || se.size === 0))
                return !0;
              if (N === void 0)
                N = {
                  val1: /* @__PURE__ */ new Map(),
                  val2: /* @__PURE__ */ new Map(),
                  position: 0
                };
              else {
                var MA = N.val1.get(se);
                if (MA !== void 0) {
                  var be = N.val2.get(Ee);
                  if (be !== void 0)
                    return MA === be;
                }
                N.position++;
              }
              N.val1.set(se, N.position), N.val2.set(Ee, N.position);
              var at = Le(se, Ee, wA, W, N, G);
              return N.val1.delete(se), N.val2.delete(Ee), at;
            }
            function FA(se, Ee, wA, N) {
              for (var G = q(se), W = 0; W < G.length; W++) {
                var aA = G[W];
                if (bA(Ee, aA, wA, N))
                  return se.delete(aA), !0;
              }
              return !1;
            }
            function dA(se) {
              switch (D(se)) {
                case "undefined":
                  return null;
                case "object":
                  return;
                case "symbol":
                  return !1;
                case "string":
                  se = +se;
                // Loose equal entries exist only if the string is possible to convert to
                // a regular number and not NaN.
                // Fall through
                case "number":
                  if (T(se))
                    return !1;
              }
              return !0;
            }
            function he(se, Ee, wA) {
              var N = dA(wA);
              return N ?? (Ee.has(N) && !se.has(N));
            }
            function ie(se, Ee, wA, N, G) {
              var W = dA(wA);
              if (W != null)
                return W;
              var aA = Ee.get(W);
              return aA === void 0 && !Ee.has(W) || !bA(N, aA, !1, G) ? !1 : !se.has(W) && bA(N, aA, !1, G);
            }
            function KA(se, Ee, wA, N) {
              for (var G = null, W = q(se), aA = 0; aA < W.length; aA++) {
                var j = W[aA];
                if (D(j) === "object" && j !== null)
                  G === null && (G = /* @__PURE__ */ new Set()), G.add(j);
                else if (!Ee.has(j)) {
                  if (wA || !he(se, Ee, j))
                    return !1;
                  G === null && (G = /* @__PURE__ */ new Set()), G.add(j);
                }
              }
              if (G !== null) {
                for (var pA = q(Ee), Be = 0; Be < pA.length; Be++) {
                  var Ie = pA[Be];
                  if (D(Ie) === "object" && Ie !== null) {
                    if (!FA(G, Ie, wA, N)) return !1;
                  } else if (!wA && !se.has(Ie) && !FA(G, Ie, wA, N))
                    return !1;
                }
                return G.size === 0;
              }
              return !0;
            }
            function Pe(se, Ee, wA, N, G, W) {
              for (var aA = q(se), j = 0; j < aA.length; j++) {
                var pA = aA[j];
                if (bA(wA, pA, G, W) && bA(N, Ee.get(pA), G, W))
                  return se.delete(pA), !0;
              }
              return !1;
            }
            function Je(se, Ee, wA, N) {
              for (var G = null, W = AA(se), aA = 0; aA < W.length; aA++) {
                var j = A(W[aA], 2), pA = j[0], Be = j[1];
                if (D(pA) === "object" && pA !== null)
                  G === null && (G = /* @__PURE__ */ new Set()), G.add(pA);
                else {
                  var Ie = Ee.get(pA);
                  if (Ie === void 0 && !Ee.has(pA) || !bA(Be, Ie, wA, N)) {
                    if (wA || !ie(se, Ee, pA, Be, N)) return !1;
                    G === null && (G = /* @__PURE__ */ new Set()), G.add(pA);
                  }
                }
              }
              if (G !== null) {
                for (var ee = AA(Ee), Me = 0; Me < ee.length; Me++) {
                  var MA = A(ee[Me], 2), be = MA[0], at = MA[1];
                  if (D(be) === "object" && be !== null) {
                    if (!Pe(G, se, be, at, wA, N)) return !1;
                  } else if (!wA && (!se.has(be) || !bA(se.get(be), at, !1, N)) && !Pe(G, se, be, at, !1, N))
                    return !1;
                }
                return G.size === 0;
              }
              return !0;
            }
            function Le(se, Ee, wA, N, G, W) {
              var aA = 0;
              if (W === o) {
                if (!KA(se, Ee, wA, G))
                  return !1;
              } else if (W === h) {
                if (!Je(se, Ee, wA, G))
                  return !1;
              } else if (W === F)
                for (; aA < se.length; aA++)
                  if (eA(se, aA)) {
                    if (!eA(Ee, aA) || !bA(se[aA], Ee[aA], wA, G))
                      return !1;
                  } else {
                    if (eA(Ee, aA))
                      return !1;
                    for (var j = Object.keys(se); aA < j.length; aA++) {
                      var pA = j[aA];
                      if (!eA(Ee, pA) || !bA(se[pA], Ee[pA], wA, G))
                        return !1;
                    }
                    return j.length === Object.keys(Ee).length;
                  }
              for (aA = 0; aA < N.length; aA++) {
                var Be = N[aA];
                if (!bA(se[Be], Ee[Be], wA, G))
                  return !1;
              }
              return !0;
            }
            function Re(se, Ee) {
              return bA(se, Ee, fA);
            }
            function _e(se, Ee) {
              return bA(se, Ee, TA);
            }
            Q.exports = {
              isDeepEqual: Re,
              isDeepStrictEqual: _e
            };
          },
          /***/
          2504(Q, B) {
            B.byteLength = D, B.toByteArray = q, B.fromByteArray = z;
            for (var r = [], A = [], a = typeof Uint8Array < "u" ? Uint8Array : Array, d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", x = 0, U = d.length; x < U; ++x)
              r[x] = d[x], A[d.charCodeAt(x)] = x;
            A[45] = 62, A[95] = 63;
            function P(T) {
              var H = T.length;
              if (H % 4 > 0)
                throw new Error("Invalid string. Length must be a multiple of 4");
              var eA = T.indexOf("=");
              eA === -1 && (eA = H);
              var CA = eA === H ? 0 : 4 - eA % 4;
              return [eA, CA];
            }
            function D(T) {
              var H = P(T), eA = H[0], CA = H[1];
              return (eA + CA) * 3 / 4 - CA;
            }
            function J(T, H, eA) {
              return (H + eA) * 3 / 4 - eA;
            }
            function q(T) {
              var H, eA = P(T), CA = eA[0], IA = eA[1], k = new a(J(T, CA, IA)), tA = 0, lA = IA > 0 ? CA - 4 : CA, uA;
              for (uA = 0; uA < lA; uA += 4)
                H = A[T.charCodeAt(uA)] << 18 | A[T.charCodeAt(uA + 1)] << 12 | A[T.charCodeAt(uA + 2)] << 6 | A[T.charCodeAt(uA + 3)], k[tA++] = H >> 16 & 255, k[tA++] = H >> 8 & 255, k[tA++] = H & 255;
              return IA === 2 && (H = A[T.charCodeAt(uA)] << 2 | A[T.charCodeAt(uA + 1)] >> 4, k[tA++] = H & 255), IA === 1 && (H = A[T.charCodeAt(uA)] << 10 | A[T.charCodeAt(uA + 1)] << 4 | A[T.charCodeAt(uA + 2)] >> 2, k[tA++] = H >> 8 & 255, k[tA++] = H & 255), k;
            }
            function AA(T) {
              return r[T >> 18 & 63] + r[T >> 12 & 63] + r[T >> 6 & 63] + r[T & 63];
            }
            function K(T, H, eA) {
              for (var CA, IA = [], k = H; k < eA; k += 3)
                CA = (T[k] << 16 & 16711680) + (T[k + 1] << 8 & 65280) + (T[k + 2] & 255), IA.push(AA(CA));
              return IA.join("");
            }
            function z(T) {
              for (var H, eA = T.length, CA = eA % 3, IA = [], k = 16383, tA = 0, lA = eA - CA; tA < lA; tA += k)
                IA.push(K(T, tA, tA + k > lA ? lA : tA + k));
              return CA === 1 ? (H = T[eA - 1], IA.push(
                r[H >> 2] + r[H << 4 & 63] + "=="
              )) : CA === 2 && (H = (T[eA - 2] << 8) + T[eA - 1], IA.push(
                r[H >> 10] + r[H >> 4 & 63] + r[H << 2 & 63] + "="
              )), IA.join("");
            }
          },
          /***/
          4097(Q) {
            var B = 4096, r = 2 * B + 32, A = 2 * B - 1, a = new Uint32Array([
              0,
              1,
              3,
              7,
              15,
              31,
              63,
              127,
              255,
              511,
              1023,
              2047,
              4095,
              8191,
              16383,
              32767,
              65535,
              131071,
              262143,
              524287,
              1048575,
              2097151,
              4194303,
              8388607,
              16777215
            ]);
            function d(x) {
              this.buf_ = new Uint8Array(r), this.input_ = x, this.reset();
            }
            d.READ_SIZE = B, d.IBUF_MASK = A, d.prototype.reset = function() {
              this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
              for (var x = 0; x < 4; x++)
                this.val_ |= this.buf_[this.pos_] << 8 * x, ++this.pos_;
              return this.bit_end_pos_ > 0;
            }, d.prototype.readMoreInput = function() {
              if (!(this.bit_end_pos_ > 256))
                if (this.eos_) {
                  if (this.bit_pos_ > this.bit_end_pos_)
                    throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
                } else {
                  var x = this.buf_ptr_, U = this.input_.read(this.buf_, x, B);
                  if (U < 0)
                    throw new Error("Unexpected end of input");
                  if (U < B) {
                    this.eos_ = 1;
                    for (var P = 0; P < 32; P++)
                      this.buf_[x + U + P] = 0;
                  }
                  if (x === 0) {
                    for (var P = 0; P < 32; P++)
                      this.buf_[(B << 1) + P] = this.buf_[P];
                    this.buf_ptr_ = B;
                  } else
                    this.buf_ptr_ = 0;
                  this.bit_end_pos_ += U << 3;
                }
            }, d.prototype.fillBitWindow = function() {
              for (; this.bit_pos_ >= 8; )
                this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & A] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
            }, d.prototype.readBits = function(x) {
              32 - this.bit_pos_ < x && this.fillBitWindow();
              var U = this.val_ >>> this.bit_pos_ & a[x];
              return this.bit_pos_ += x, U;
            }, Q.exports = d;
          },
          /***/
          7043(Q, B) {
            B.lookup = new Uint8Array([
              /* CONTEXT_UTF8, last byte. */
              /* ASCII range. */
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              4,
              4,
              0,
              0,
              4,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              8,
              12,
              16,
              12,
              12,
              20,
              12,
              16,
              24,
              28,
              12,
              12,
              32,
              12,
              36,
              12,
              44,
              44,
              44,
              44,
              44,
              44,
              44,
              44,
              44,
              44,
              32,
              32,
              24,
              40,
              28,
              12,
              12,
              48,
              52,
              52,
              52,
              48,
              52,
              52,
              52,
              48,
              52,
              52,
              52,
              52,
              52,
              48,
              52,
              52,
              52,
              52,
              52,
              48,
              52,
              52,
              52,
              52,
              52,
              24,
              12,
              28,
              12,
              12,
              12,
              56,
              60,
              60,
              60,
              56,
              60,
              60,
              60,
              56,
              60,
              60,
              60,
              60,
              60,
              56,
              60,
              60,
              60,
              60,
              60,
              56,
              60,
              60,
              60,
              60,
              60,
              24,
              12,
              28,
              12,
              0,
              /* UTF8 continuation byte range. */
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              0,
              1,
              /* UTF8 lead byte range. */
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              2,
              3,
              /* CONTEXT_UTF8 second last byte. */
              /* ASCII range. */
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              1,
              1,
              1,
              1,
              1,
              1,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              1,
              1,
              1,
              1,
              0,
              /* UTF8 continuation byte range. */
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              /* UTF8 lead byte range. */
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              /* CONTEXT_SIGNED, second last byte. */
              0,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              1,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              3,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              4,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              7,
              /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
              0,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              8,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              24,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              32,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              40,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              48,
              56,
              /* CONTEXT_LSB6, last byte. */
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32,
              33,
              34,
              35,
              36,
              37,
              38,
              39,
              40,
              41,
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              59,
              60,
              61,
              62,
              63,
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32,
              33,
              34,
              35,
              36,
              37,
              38,
              39,
              40,
              41,
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              59,
              60,
              61,
              62,
              63,
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32,
              33,
              34,
              35,
              36,
              37,
              38,
              39,
              40,
              41,
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              59,
              60,
              61,
              62,
              63,
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32,
              33,
              34,
              35,
              36,
              37,
              38,
              39,
              40,
              41,
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              59,
              60,
              61,
              62,
              63,
              /* CONTEXT_MSB6, last byte. */
              0,
              0,
              0,
              0,
              1,
              1,
              1,
              1,
              2,
              2,
              2,
              2,
              3,
              3,
              3,
              3,
              4,
              4,
              4,
              4,
              5,
              5,
              5,
              5,
              6,
              6,
              6,
              6,
              7,
              7,
              7,
              7,
              8,
              8,
              8,
              8,
              9,
              9,
              9,
              9,
              10,
              10,
              10,
              10,
              11,
              11,
              11,
              11,
              12,
              12,
              12,
              12,
              13,
              13,
              13,
              13,
              14,
              14,
              14,
              14,
              15,
              15,
              15,
              15,
              16,
              16,
              16,
              16,
              17,
              17,
              17,
              17,
              18,
              18,
              18,
              18,
              19,
              19,
              19,
              19,
              20,
              20,
              20,
              20,
              21,
              21,
              21,
              21,
              22,
              22,
              22,
              22,
              23,
              23,
              23,
              23,
              24,
              24,
              24,
              24,
              25,
              25,
              25,
              25,
              26,
              26,
              26,
              26,
              27,
              27,
              27,
              27,
              28,
              28,
              28,
              28,
              29,
              29,
              29,
              29,
              30,
              30,
              30,
              30,
              31,
              31,
              31,
              31,
              32,
              32,
              32,
              32,
              33,
              33,
              33,
              33,
              34,
              34,
              34,
              34,
              35,
              35,
              35,
              35,
              36,
              36,
              36,
              36,
              37,
              37,
              37,
              37,
              38,
              38,
              38,
              38,
              39,
              39,
              39,
              39,
              40,
              40,
              40,
              40,
              41,
              41,
              41,
              41,
              42,
              42,
              42,
              42,
              43,
              43,
              43,
              43,
              44,
              44,
              44,
              44,
              45,
              45,
              45,
              45,
              46,
              46,
              46,
              46,
              47,
              47,
              47,
              47,
              48,
              48,
              48,
              48,
              49,
              49,
              49,
              49,
              50,
              50,
              50,
              50,
              51,
              51,
              51,
              51,
              52,
              52,
              52,
              52,
              53,
              53,
              53,
              53,
              54,
              54,
              54,
              54,
              55,
              55,
              55,
              55,
              56,
              56,
              56,
              56,
              57,
              57,
              57,
              57,
              58,
              58,
              58,
              58,
              59,
              59,
              59,
              59,
              60,
              60,
              60,
              60,
              61,
              61,
              61,
              61,
              62,
              62,
              62,
              62,
              63,
              63,
              63,
              63,
              /* CONTEXT_{M,L}SB6, second last byte, */
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), B.lookupOffsets = new Uint16Array([
              /* CONTEXT_LSB6 */
              1024,
              1536,
              /* CONTEXT_MSB6 */
              1280,
              1536,
              /* CONTEXT_UTF8 */
              0,
              256,
              /* CONTEXT_SIGNED */
              768,
              512
            ]);
          },
          /***/
          980(Q, B, r) {
            var A = r(8197).z, a = r(8197).y, d = r(4097), x = r(614), U = r(1561).z, P = r(1561).u, D = r(7043), J = r(2210), q = r(7984), AA = 8, K = 16, z = 256, T = 704, H = 26, eA = 6, CA = 2, IA = 8, k = 255, tA = 1080, lA = 18, uA = new Uint8Array([
              1,
              2,
              3,
              4,
              0,
              5,
              17,
              6,
              16,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15
            ]), w = 16, v = new Uint8Array([
              3,
              2,
              1,
              0,
              3,
              3,
              3,
              3,
              3,
              3,
              2,
              2,
              2,
              2,
              2,
              2
            ]), RA = new Int8Array([
              0,
              0,
              0,
              0,
              -1,
              1,
              -2,
              2,
              -3,
              3,
              -1,
              1,
              -2,
              2,
              -3,
              3
            ]), DA = new Uint16Array([
              256,
              402,
              436,
              468,
              500,
              534,
              566,
              598,
              630,
              662,
              694,
              726,
              758,
              790,
              822,
              854,
              886,
              920,
              952,
              984,
              1016,
              1048,
              1080
            ]);
            function $(p) {
              var rA;
              return p.readBits(1) === 0 ? 16 : (rA = p.readBits(3), rA > 0 ? 17 + rA : (rA = p.readBits(3), rA > 0 ? 8 + rA : 17));
            }
            function cA(p) {
              if (p.readBits(1)) {
                var rA = p.readBits(3);
                return rA === 0 ? 1 : p.readBits(rA) + (1 << rA);
              }
              return 0;
            }
            function $A() {
              this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
            }
            function kA(p) {
              var rA = new $A(), QA, bA, y;
              if (rA.input_end = p.readBits(1), rA.input_end && p.readBits(1))
                return rA;
              if (QA = p.readBits(2) + 4, QA === 7) {
                if (rA.is_metadata = !0, p.readBits(1) !== 0)
                  throw new Error("Invalid reserved bit");
                if (bA = p.readBits(2), bA === 0)
                  return rA;
                for (y = 0; y < bA; y++) {
                  var M = p.readBits(8);
                  if (y + 1 === bA && bA > 1 && M === 0)
                    throw new Error("Invalid size byte");
                  rA.meta_block_length |= M << y * 8;
                }
              } else
                for (y = 0; y < QA; ++y) {
                  var FA = p.readBits(4);
                  if (y + 1 === QA && QA > 4 && FA === 0)
                    throw new Error("Invalid size nibble");
                  rA.meta_block_length |= FA << y * 4;
                }
              return ++rA.meta_block_length, !rA.input_end && !rA.is_metadata && (rA.is_uncompressed = p.readBits(1)), rA;
            }
            function WA(p, rA, QA) {
              var bA;
              return QA.fillBitWindow(), rA += QA.val_ >>> QA.bit_pos_ & k, bA = p[rA].bits - IA, bA > 0 && (QA.bit_pos_ += IA, rA += p[rA].value, rA += QA.val_ >>> QA.bit_pos_ & (1 << bA) - 1), QA.bit_pos_ += p[rA].bits, p[rA].value;
            }
            function EA(p, rA, QA, bA) {
              for (var y = 0, M = AA, FA = 0, dA = 0, he = 32768, ie = [], KA = 0; KA < 32; KA++)
                ie.push(new U(0, 0));
              for (P(ie, 0, 5, p, lA); y < rA && he > 0; ) {
                var Pe = 0, Je;
                if (bA.readMoreInput(), bA.fillBitWindow(), Pe += bA.val_ >>> bA.bit_pos_ & 31, bA.bit_pos_ += ie[Pe].bits, Je = ie[Pe].value & 255, Je < K)
                  FA = 0, QA[y++] = Je, Je !== 0 && (M = Je, he -= 32768 >> Je);
                else {
                  var Le = Je - 14, Re, _e, se = 0;
                  if (Je === K && (se = M), dA !== se && (FA = 0, dA = se), Re = FA, FA > 0 && (FA -= 2, FA <<= Le), FA += bA.readBits(Le) + 3, _e = FA - Re, y + _e > rA)
                    throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
                  for (var Ee = 0; Ee < _e; Ee++)
                    QA[y + Ee] = dA;
                  y += _e, dA !== 0 && (he -= _e << 15 - dA);
                }
              }
              if (he !== 0)
                throw new Error("[ReadHuffmanCodeLengths] space = " + he);
              for (; y < rA; y++)
                QA[y] = 0;
            }
            function zA(p, rA, QA, bA) {
              var y = 0, M, FA = new Uint8Array(p);
              if (bA.readMoreInput(), M = bA.readBits(2), M === 1) {
                for (var dA, he = p - 1, ie = 0, KA = new Int32Array(4), Pe = bA.readBits(2) + 1; he; )
                  he >>= 1, ++ie;
                for (dA = 0; dA < Pe; ++dA)
                  KA[dA] = bA.readBits(ie) % p, FA[KA[dA]] = 2;
                switch (FA[KA[0]] = 1, Pe) {
                  case 1:
                    break;
                  case 3:
                    if (KA[0] === KA[1] || KA[0] === KA[2] || KA[1] === KA[2])
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    break;
                  case 2:
                    if (KA[0] === KA[1])
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    FA[KA[1]] = 1;
                    break;
                  case 4:
                    if (KA[0] === KA[1] || KA[0] === KA[2] || KA[0] === KA[3] || KA[1] === KA[2] || KA[1] === KA[3] || KA[2] === KA[3])
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    bA.readBits(1) ? (FA[KA[2]] = 3, FA[KA[3]] = 3) : FA[KA[0]] = 2;
                    break;
                }
              } else {
                var dA, Je = new Uint8Array(lA), Le = 32, Re = 0, _e = [
                  new U(2, 0),
                  new U(2, 4),
                  new U(2, 3),
                  new U(3, 2),
                  new U(2, 0),
                  new U(2, 4),
                  new U(2, 3),
                  new U(4, 1),
                  new U(2, 0),
                  new U(2, 4),
                  new U(2, 3),
                  new U(3, 2),
                  new U(2, 0),
                  new U(2, 4),
                  new U(2, 3),
                  new U(4, 5)
                ];
                for (dA = M; dA < lA && Le > 0; ++dA) {
                  var se = uA[dA], Ee = 0, wA;
                  bA.fillBitWindow(), Ee += bA.val_ >>> bA.bit_pos_ & 15, bA.bit_pos_ += _e[Ee].bits, wA = _e[Ee].value, Je[se] = wA, wA !== 0 && (Le -= 32 >> wA, ++Re);
                }
                if (!(Re === 1 || Le === 0))
                  throw new Error("[ReadHuffmanCode] invalid num_codes or space");
                EA(Je, p, FA, bA);
              }
              if (y = P(rA, QA, IA, FA, p), y === 0)
                throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
              return y;
            }
            function OA(p, rA, QA) {
              var bA, y;
              return bA = WA(p, rA, QA), y = J.kBlockLengthPrefixCode[bA].nbits, J.kBlockLengthPrefixCode[bA].offset + QA.readBits(y);
            }
            function xA(p, rA, QA) {
              var bA;
              return p < w ? (QA += v[p], QA &= 3, bA = rA[QA] + RA[p]) : bA = p - w + 1, bA;
            }
            function LA(p, rA) {
              for (var QA = p[rA], bA = rA; bA; --bA) p[bA] = p[bA - 1];
              p[0] = QA;
            }
            function yA(p, rA) {
              var QA = new Uint8Array(256), bA;
              for (bA = 0; bA < 256; ++bA)
                QA[bA] = bA;
              for (bA = 0; bA < rA; ++bA) {
                var y = p[bA];
                p[bA] = QA[y], y && LA(QA, y);
              }
            }
            function TA(p, rA) {
              this.alphabet_size = p, this.num_htrees = rA, this.codes = new Array(rA + rA * DA[p + 31 >>> 5]), this.htrees = new Uint32Array(rA);
            }
            TA.prototype.decode = function(p) {
              var rA, QA, bA = 0;
              for (rA = 0; rA < this.num_htrees; ++rA)
                this.htrees[rA] = bA, QA = zA(this.alphabet_size, this.codes, bA, p), bA += QA;
            };
            function fA(p, rA) {
              var QA = { num_htrees: null, context_map: null }, bA, y = 0, M, FA;
              rA.readMoreInput();
              var dA = QA.num_htrees = cA(rA) + 1, he = QA.context_map = new Uint8Array(p);
              if (dA <= 1)
                return QA;
              for (bA = rA.readBits(1), bA && (y = rA.readBits(4) + 1), M = [], FA = 0; FA < tA; FA++)
                M[FA] = new U(0, 0);
              for (zA(dA + y, M, 0, rA), FA = 0; FA < p; ) {
                var ie;
                if (rA.readMoreInput(), ie = WA(M, 0, rA), ie === 0)
                  he[FA] = 0, ++FA;
                else if (ie <= y)
                  for (var KA = 1 + (1 << ie) + rA.readBits(ie); --KA; ) {
                    if (FA >= p)
                      throw new Error("[DecodeContextMap] i >= context_map_size");
                    he[FA] = 0, ++FA;
                  }
                else
                  he[FA] = ie - y, ++FA;
              }
              return rA.readBits(1) && yA(he, p), QA;
            }
            function sA(p, rA, QA, bA, y, M, FA) {
              var dA = QA * 2, he = QA, ie = WA(rA, QA * tA, FA), KA;
              ie === 0 ? KA = y[dA + (M[he] & 1)] : ie === 1 ? KA = y[dA + (M[he] - 1 & 1)] + 1 : KA = ie - 2, KA >= p && (KA -= p), bA[QA] = KA, y[dA + (M[he] & 1)] = KA, ++M[he];
            }
            function F(p, rA, QA, bA, y, M) {
              var FA = y + 1, dA = QA & y, he = M.pos_ & d.IBUF_MASK, ie;
              if (rA < 8 || M.bit_pos_ + (rA << 3) < M.bit_end_pos_) {
                for (; rA-- > 0; )
                  M.readMoreInput(), bA[dA++] = M.readBits(8), dA === FA && (p.write(bA, FA), dA = 0);
                return;
              }
              if (M.bit_end_pos_ < 32)
                throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
              for (; M.bit_pos_ < 32; )
                bA[dA] = M.val_ >>> M.bit_pos_, M.bit_pos_ += 8, ++dA, --rA;
              if (ie = M.bit_end_pos_ - M.bit_pos_ >> 3, he + ie > d.IBUF_MASK) {
                for (var KA = d.IBUF_MASK + 1 - he, Pe = 0; Pe < KA; Pe++)
                  bA[dA + Pe] = M.buf_[he + Pe];
                ie -= KA, dA += KA, rA -= KA, he = 0;
              }
              for (var Pe = 0; Pe < ie; Pe++)
                bA[dA + Pe] = M.buf_[he + Pe];
              if (dA += ie, rA -= ie, dA >= FA) {
                p.write(bA, FA), dA -= FA;
                for (var Pe = 0; Pe < dA; Pe++)
                  bA[Pe] = bA[FA + Pe];
              }
              for (; dA + rA >= FA; ) {
                if (ie = FA - dA, M.input_.read(bA, dA, ie) < ie)
                  throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
                p.write(bA, FA), rA -= ie, dA = 0;
              }
              if (M.input_.read(bA, dA, rA) < rA)
                throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
              M.reset();
            }
            function o(p) {
              var rA = p.bit_pos_ + 7 & -8, QA = p.readBits(rA - p.bit_pos_);
              return QA == 0;
            }
            function h(p) {
              var rA = new A(p), QA = new d(rA);
              $(QA);
              var bA = kA(QA);
              return bA.meta_block_length;
            }
            function _(p, rA) {
              var QA = new A(p);
              rA == null && (rA = h(p));
              var bA = new Uint8Array(rA), y = new a(bA);
              return oA(QA, y), y.pos < y.buffer.length && (y.buffer = y.buffer.subarray(0, y.pos)), y.buffer;
            }
            B.BrotliDecompressBuffer = _;
            function oA(p, rA) {
              var QA, bA = 0, y = 0, M = 0, FA, dA = 0, he, ie, KA, Pe, Je = [16, 15, 11, 4], Le = 0, Re = 0, _e = 0, se = [new TA(0, 0), new TA(0, 0), new TA(0, 0)], Ee, wA, N, G = 128 + d.READ_SIZE;
              N = new d(p), M = $(N), FA = (1 << M) - 16, he = 1 << M, ie = he - 1, KA = new Uint8Array(he + G + x.maxDictionaryWordLength), Pe = he, Ee = [], wA = [];
              for (var W = 0; W < 3 * tA; W++)
                Ee[W] = new U(0, 0), wA[W] = new U(0, 0);
              for (; !y; ) {
                var aA = 0, j, pA = [1 << 28, 1 << 28, 1 << 28], Be = [0], Ie = [1, 1, 1], ee = [0, 1, 0, 1, 0, 1], Me = [0], MA, be, at, V, me = null, Ye = null, SA, ue = null, Fe, tt = 0, We = null, Ze = 0, Ct = 0, fi = null, st = 0, xt = 0, Mt = 0, zt, Xt;
                for (QA = 0; QA < 3; ++QA)
                  se[QA].codes = null, se[QA].htrees = null;
                N.readMoreInput();
                var xi = kA(N);
                if (aA = xi.meta_block_length, bA + aA > rA.buffer.length) {
                  var mi = new Uint8Array(bA + aA);
                  mi.set(rA.buffer), rA.buffer = mi;
                }
                if (y = xi.input_end, j = xi.is_uncompressed, xi.is_metadata) {
                  for (o(N); aA > 0; --aA)
                    N.readMoreInput(), N.readBits(8);
                  continue;
                }
                if (aA !== 0) {
                  if (j) {
                    N.bit_pos_ = N.bit_pos_ + 7 & -8, F(
                      rA,
                      aA,
                      bA,
                      KA,
                      ie,
                      N
                    ), bA += aA;
                    continue;
                  }
                  for (QA = 0; QA < 3; ++QA)
                    Ie[QA] = cA(N) + 1, Ie[QA] >= 2 && (zA(Ie[QA] + 2, Ee, QA * tA, N), zA(H, wA, QA * tA, N), pA[QA] = OA(wA, QA * tA, N), Me[QA] = 1);
                  for (N.readMoreInput(), MA = N.readBits(2), be = w + (N.readBits(4) << MA), at = (1 << MA) - 1, V = be + (48 << MA), Ye = new Uint8Array(Ie[0]), QA = 0; QA < Ie[0]; ++QA)
                    N.readMoreInput(), Ye[QA] = N.readBits(2) << 1;
                  var Ot = fA(Ie[0] << eA, N);
                  SA = Ot.num_htrees, me = Ot.context_map;
                  var vt = fA(Ie[2] << CA, N);
                  for (Fe = vt.num_htrees, ue = vt.context_map, se[0] = new TA(z, SA), se[1] = new TA(T, Ie[1]), se[2] = new TA(V, Fe), QA = 0; QA < 3; ++QA)
                    se[QA].decode(N);
                  for (We = 0, fi = 0, zt = Ye[Be[0]], xt = D.lookupOffsets[zt], Mt = D.lookupOffsets[zt + 1], Xt = se[1].htrees[0]; aA > 0; ) {
                    var Zt, ei, Ke, qe, Dt, ut, ni, wi, Yi, vA, UA;
                    for (N.readMoreInput(), pA[1] === 0 && (sA(
                      Ie[1],
                      Ee,
                      1,
                      Be,
                      ee,
                      Me,
                      N
                    ), pA[1] = OA(wA, tA, N), Xt = se[1].htrees[Be[1]]), --pA[1], Zt = WA(se[1].codes, Xt, N), ei = Zt >> 6, ei >= 2 ? (ei -= 2, ni = -1) : ni = 0, Ke = J.kInsertRangeLut[ei] + (Zt >> 3 & 7), qe = J.kCopyRangeLut[ei] + (Zt & 7), Dt = J.kInsertLengthPrefixCode[Ke].offset + N.readBits(J.kInsertLengthPrefixCode[Ke].nbits), ut = J.kCopyLengthPrefixCode[qe].offset + N.readBits(J.kCopyLengthPrefixCode[qe].nbits), Re = KA[bA - 1 & ie], _e = KA[bA - 2 & ie], vA = 0; vA < Dt; ++vA)
                      N.readMoreInput(), pA[0] === 0 && (sA(
                        Ie[0],
                        Ee,
                        0,
                        Be,
                        ee,
                        Me,
                        N
                      ), pA[0] = OA(wA, 0, N), tt = Be[0] << eA, We = tt, zt = Ye[Be[0]], xt = D.lookupOffsets[zt], Mt = D.lookupOffsets[zt + 1]), Yi = D.lookup[xt + Re] | D.lookup[Mt + _e], Ze = me[We + Yi], --pA[0], _e = Re, Re = WA(se[0].codes, se[0].htrees[Ze], N), KA[bA & ie] = Re, (bA & ie) === ie && rA.write(KA, he), ++bA;
                    if (aA -= Dt, aA <= 0) break;
                    if (ni < 0) {
                      var Yi;
                      if (N.readMoreInput(), pA[2] === 0 && (sA(
                        Ie[2],
                        Ee,
                        2,
                        Be,
                        ee,
                        Me,
                        N
                      ), pA[2] = OA(wA, 2 * tA, N), Ct = Be[2] << CA, fi = Ct), --pA[2], Yi = (ut > 4 ? 3 : ut - 2) & 255, st = ue[fi + Yi], ni = WA(se[2].codes, se[2].htrees[st], N), ni >= be) {
                        var mA, qA, _A;
                        ni -= be, qA = ni & at, ni >>= MA, mA = (ni >> 1) + 1, _A = (2 + (ni & 1) << mA) - 4, ni = be + (_A + N.readBits(mA) << MA) + qA;
                      }
                    }
                    if (wi = xA(ni, Je, Le), wi < 0)
                      throw new Error("[BrotliDecompress] invalid distance");
                    if (bA < FA && dA !== FA ? dA = bA : dA = FA, UA = bA & ie, wi > dA)
                      if (ut >= x.minDictionaryWordLength && ut <= x.maxDictionaryWordLength) {
                        var _A = x.offsetsByLength[ut], jA = wi - dA - 1, le = x.sizeBitsByLength[ut], JA = (1 << le) - 1, ne = jA & JA, ae = jA >> le;
                        if (_A += ne * ut, ae < q.kNumTransforms) {
                          var ve = q.transformDictionaryWord(KA, UA, _A, ut, ae);
                          if (UA += ve, bA += ve, aA -= ve, UA >= Pe) {
                            rA.write(KA, he);
                            for (var ze = 0; ze < UA - Pe; ze++)
                              KA[ze] = KA[Pe + ze];
                          }
                        } else
                          throw new Error("Invalid backward reference. pos: " + bA + " distance: " + wi + " len: " + ut + " bytes left: " + aA);
                      } else
                        throw new Error("Invalid backward reference. pos: " + bA + " distance: " + wi + " len: " + ut + " bytes left: " + aA);
                    else {
                      if (ni > 0 && (Je[Le & 3] = wi, ++Le), ut > aA)
                        throw new Error("Invalid backward reference. pos: " + bA + " distance: " + wi + " len: " + ut + " bytes left: " + aA);
                      for (vA = 0; vA < ut; ++vA)
                        KA[bA & ie] = KA[bA - wi & ie], (bA & ie) === ie && rA.write(KA, he), ++bA, --aA;
                    }
                    Re = KA[bA - 1 & ie], _e = KA[bA - 2 & ie];
                  }
                  bA &= 1073741823;
                }
              }
              rA.write(KA, bA & ie);
            }
            x.init();
          },
          /***/
          4543(Q, B, r) {
            var A = r(2504);
            B.init = function() {
              var a = r(980).BrotliDecompressBuffer, d = A.toByteArray(r(3501));
              return a(d);
            };
          },
          /***/
          3501(Q) {
            Q.exports = "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";
          },
          /***/
          614(Q, B, r) {
            var A = r(4543);
            B.init = function() {
              B.dictionary = A.init();
            }, B.offsetsByLength = new Uint32Array([
              0,
              0,
              0,
              0,
              0,
              4096,
              9216,
              21504,
              35840,
              44032,
              53248,
              63488,
              74752,
              87040,
              93696,
              100864,
              104704,
              106752,
              108928,
              113536,
              115968,
              118528,
              119872,
              121280,
              122016
            ]), B.sizeBitsByLength = new Uint8Array([
              0,
              0,
              0,
              0,
              10,
              10,
              11,
              11,
              10,
              10,
              10,
              10,
              10,
              9,
              9,
              8,
              7,
              7,
              8,
              7,
              7,
              6,
              6,
              5,
              5
            ]), B.minDictionaryWordLength = 4, B.maxDictionaryWordLength = 24;
          },
          /***/
          1561(Q, B) {
            function r(U, P) {
              this.bits = U, this.value = P;
            }
            B.z = r;
            var A = 15;
            function a(U, P) {
              for (var D = 1 << P - 1; U & D; )
                D >>= 1;
              return (U & D - 1) + D;
            }
            function d(U, P, D, J, q) {
              do
                J -= D, U[P + J] = new r(q.bits, q.value);
              while (J > 0);
            }
            function x(U, P, D) {
              for (var J = 1 << P - D; P < A && (J -= U[P], !(J <= 0)); )
                ++P, J <<= 1;
              return P - D;
            }
            B.u = function(U, P, D, J, q) {
              var AA = P, K, z, T, H, eA, CA, IA, k, tA, lA, uA, w = new Int32Array(A + 1), v = new Int32Array(A + 1);
              for (uA = new Int32Array(q), T = 0; T < q; T++)
                w[J[T]]++;
              for (v[1] = 0, z = 1; z < A; z++)
                v[z + 1] = v[z] + w[z];
              for (T = 0; T < q; T++)
                J[T] !== 0 && (uA[v[J[T]]++] = T);
              if (k = D, tA = 1 << k, lA = tA, v[A] === 1) {
                for (H = 0; H < lA; ++H)
                  U[P + H] = new r(0, uA[0] & 65535);
                return lA;
              }
              for (H = 0, T = 0, z = 1, eA = 2; z <= D; ++z, eA <<= 1)
                for (; w[z] > 0; --w[z])
                  K = new r(z & 255, uA[T++] & 65535), d(U, P + H, eA, tA, K), H = a(H, z);
              for (IA = lA - 1, CA = -1, z = D + 1, eA = 2; z <= A; ++z, eA <<= 1)
                for (; w[z] > 0; --w[z])
                  (H & IA) !== CA && (P += tA, k = x(w, z, D), tA = 1 << k, lA += tA, CA = H & IA, U[AA + CA] = new r(k + D & 255, P - AA - CA & 65535)), K = new r(z - D & 255, uA[T++] & 65535), d(U, P + (H >> D), eA, tA, K), H = a(H, z);
              return lA;
            };
          },
          /***/
          2210(Q, B) {
            function r(A, a) {
              this.offset = A, this.nbits = a;
            }
            B.kBlockLengthPrefixCode = [
              new r(1, 2),
              new r(5, 2),
              new r(9, 2),
              new r(13, 2),
              new r(17, 3),
              new r(25, 3),
              new r(33, 3),
              new r(41, 3),
              new r(49, 4),
              new r(65, 4),
              new r(81, 4),
              new r(97, 4),
              new r(113, 5),
              new r(145, 5),
              new r(177, 5),
              new r(209, 5),
              new r(241, 6),
              new r(305, 6),
              new r(369, 7),
              new r(497, 8),
              new r(753, 9),
              new r(1265, 10),
              new r(2289, 11),
              new r(4337, 12),
              new r(8433, 13),
              new r(16625, 24)
            ], B.kInsertLengthPrefixCode = [
              new r(0, 0),
              new r(1, 0),
              new r(2, 0),
              new r(3, 0),
              new r(4, 0),
              new r(5, 0),
              new r(6, 1),
              new r(8, 1),
              new r(10, 2),
              new r(14, 2),
              new r(18, 3),
              new r(26, 3),
              new r(34, 4),
              new r(50, 4),
              new r(66, 5),
              new r(98, 5),
              new r(130, 6),
              new r(194, 7),
              new r(322, 8),
              new r(578, 9),
              new r(1090, 10),
              new r(2114, 12),
              new r(6210, 14),
              new r(22594, 24)
            ], B.kCopyLengthPrefixCode = [
              new r(2, 0),
              new r(3, 0),
              new r(4, 0),
              new r(5, 0),
              new r(6, 0),
              new r(7, 0),
              new r(8, 0),
              new r(9, 0),
              new r(10, 1),
              new r(12, 1),
              new r(14, 2),
              new r(18, 2),
              new r(22, 3),
              new r(30, 3),
              new r(38, 4),
              new r(54, 4),
              new r(70, 5),
              new r(102, 5),
              new r(134, 6),
              new r(198, 7),
              new r(326, 8),
              new r(582, 9),
              new r(1094, 10),
              new r(2118, 24)
            ], B.kInsertRangeLut = [
              0,
              0,
              8,
              8,
              0,
              16,
              8,
              16,
              16
            ], B.kCopyRangeLut = [
              0,
              8,
              0,
              8,
              16,
              0,
              16,
              8,
              16
            ];
          },
          /***/
          8197(Q, B) {
            function r(a) {
              this.buffer = a, this.pos = 0;
            }
            r.prototype.read = function(a, d, x) {
              this.pos + x > this.buffer.length && (x = this.buffer.length - this.pos);
              for (var U = 0; U < x; U++)
                a[d + U] = this.buffer[this.pos + U];
              return this.pos += x, x;
            }, B.z = r;
            function A(a) {
              this.buffer = a, this.pos = 0;
            }
            A.prototype.write = function(a, d) {
              if (this.pos + d > this.buffer.length)
                throw new Error("Output buffer is not large enough");
              return this.buffer.set(a.subarray(0, d), this.pos), this.pos += d, d;
            }, B.y = A;
          },
          /***/
          7984(Q, B, r) {
            var A = r(614), a = 0, d = 1, x = 2, U = 3, P = 4, D = 5, J = 6, q = 7, AA = 8, K = 9, z = 10, T = 11, H = 12, eA = 13, CA = 14, IA = 15, k = 16, tA = 17, lA = 18, uA = 20;
            function w(DA, $, cA) {
              this.prefix = new Uint8Array(DA.length), this.transform = $, this.suffix = new Uint8Array(cA.length);
              for (var $A = 0; $A < DA.length; $A++)
                this.prefix[$A] = DA.charCodeAt($A);
              for (var $A = 0; $A < cA.length; $A++)
                this.suffix[$A] = cA.charCodeAt($A);
            }
            var v = [
              new w("", a, ""),
              new w("", a, " "),
              new w(" ", a, " "),
              new w("", H, ""),
              new w("", z, " "),
              new w("", a, " the "),
              new w(" ", a, ""),
              new w("s ", a, " "),
              new w("", a, " of "),
              new w("", z, ""),
              new w("", a, " and "),
              new w("", eA, ""),
              new w("", d, ""),
              new w(", ", a, " "),
              new w("", a, ", "),
              new w(" ", z, " "),
              new w("", a, " in "),
              new w("", a, " to "),
              new w("e ", a, " "),
              new w("", a, '"'),
              new w("", a, "."),
              new w("", a, '">'),
              new w("", a, `
`),
              new w("", U, ""),
              new w("", a, "]"),
              new w("", a, " for "),
              new w("", CA, ""),
              new w("", x, ""),
              new w("", a, " a "),
              new w("", a, " that "),
              new w(" ", z, ""),
              new w("", a, ". "),
              new w(".", a, ""),
              new w(" ", a, ", "),
              new w("", IA, ""),
              new w("", a, " with "),
              new w("", a, "'"),
              new w("", a, " from "),
              new w("", a, " by "),
              new w("", k, ""),
              new w("", tA, ""),
              new w(" the ", a, ""),
              new w("", P, ""),
              new w("", a, ". The "),
              new w("", T, ""),
              new w("", a, " on "),
              new w("", a, " as "),
              new w("", a, " is "),
              new w("", q, ""),
              new w("", d, "ing "),
              new w("", a, `
	`),
              new w("", a, ":"),
              new w(" ", a, ". "),
              new w("", a, "ed "),
              new w("", uA, ""),
              new w("", lA, ""),
              new w("", J, ""),
              new w("", a, "("),
              new w("", z, ", "),
              new w("", AA, ""),
              new w("", a, " at "),
              new w("", a, "ly "),
              new w(" the ", a, " of "),
              new w("", D, ""),
              new w("", K, ""),
              new w(" ", z, ", "),
              new w("", z, '"'),
              new w(".", a, "("),
              new w("", T, " "),
              new w("", z, '">'),
              new w("", a, '="'),
              new w(" ", a, "."),
              new w(".com/", a, ""),
              new w(" the ", a, " of the "),
              new w("", z, "'"),
              new w("", a, ". This "),
              new w("", a, ","),
              new w(".", a, " "),
              new w("", z, "("),
              new w("", z, "."),
              new w("", a, " not "),
              new w(" ", a, '="'),
              new w("", a, "er "),
              new w(" ", T, " "),
              new w("", a, "al "),
              new w(" ", T, ""),
              new w("", a, "='"),
              new w("", T, '"'),
              new w("", z, ". "),
              new w(" ", a, "("),
              new w("", a, "ful "),
              new w(" ", z, ". "),
              new w("", a, "ive "),
              new w("", a, "less "),
              new w("", T, "'"),
              new w("", a, "est "),
              new w(" ", z, "."),
              new w("", T, '">'),
              new w(" ", a, "='"),
              new w("", z, ","),
              new w("", a, "ize "),
              new w("", T, "."),
              new w("Â ", a, ""),
              new w(" ", a, ","),
              new w("", z, '="'),
              new w("", T, '="'),
              new w("", a, "ous "),
              new w("", T, ", "),
              new w("", z, "='"),
              new w(" ", z, ","),
              new w(" ", T, '="'),
              new w(" ", T, ", "),
              new w("", T, ","),
              new w("", T, "("),
              new w("", T, ". "),
              new w(" ", T, "."),
              new w("", T, "='"),
              new w(" ", T, ". "),
              new w(" ", z, '="'),
              new w(" ", T, "='"),
              new w(" ", z, "='")
            ];
            B.kTransforms = v, B.kNumTransforms = v.length;
            function RA(DA, $) {
              return DA[$] < 192 ? (DA[$] >= 97 && DA[$] <= 122 && (DA[$] ^= 32), 1) : DA[$] < 224 ? (DA[$ + 1] ^= 32, 2) : (DA[$ + 2] ^= 5, 3);
            }
            B.transformDictionaryWord = function(DA, $, cA, $A, kA) {
              var WA = v[kA].prefix, EA = v[kA].suffix, zA = v[kA].transform, OA = zA < H ? 0 : zA - (H - 1), xA = 0, LA = $, yA;
              OA > $A && (OA = $A);
              for (var TA = 0; TA < WA.length; )
                DA[$++] = WA[TA++];
              for (cA += OA, $A -= OA, zA <= K && ($A -= zA), xA = 0; xA < $A; xA++)
                DA[$++] = A.dictionary[cA + xA];
              if (yA = $ - $A, zA === z)
                RA(DA, yA);
              else if (zA === T)
                for (; $A > 0; ) {
                  var fA = RA(DA, yA);
                  yA += fA, $A -= fA;
                }
              for (var sA = 0; sA < EA.length; )
                DA[$++] = EA[sA++];
              return $ - LA;
            };
          },
          /***/
          4460(Q, B, r) {
            Q.exports = r(980).BrotliDecompressBuffer;
          },
          /***/
          2908(Q, B, r) {
            var A = r(783).Buffer, a = r(9964), d = r(7801), x = r(7468), U = r(2925), P = r(2269), D = r(1607);
            for (var J in D)
              B[J] = D[J];
            B.NONE = 0, B.DEFLATE = 1, B.INFLATE = 2, B.GZIP = 3, B.GUNZIP = 4, B.DEFLATERAW = 5, B.INFLATERAW = 6, B.UNZIP = 7;
            var q = 31, AA = 139;
            function K(z) {
              if (typeof z != "number" || z < B.DEFLATE || z > B.UNZIP)
                throw new TypeError("Bad argument");
              this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = z, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
            }
            K.prototype.close = function() {
              if (this.write_in_progress) {
                this.pending_close = !0;
                return;
              }
              this.pending_close = !1, d(this.init_done, "close before init"), d(this.mode <= B.UNZIP), this.mode === B.DEFLATE || this.mode === B.GZIP || this.mode === B.DEFLATERAW ? U.deflateEnd(this.strm) : (this.mode === B.INFLATE || this.mode === B.GUNZIP || this.mode === B.INFLATERAW || this.mode === B.UNZIP) && P.inflateEnd(this.strm), this.mode = B.NONE, this.dictionary = null;
            }, K.prototype.write = function(z, T, H, eA, CA, IA, k) {
              return this._write(!0, z, T, H, eA, CA, IA, k);
            }, K.prototype.writeSync = function(z, T, H, eA, CA, IA, k) {
              return this._write(!1, z, T, H, eA, CA, IA, k);
            }, K.prototype._write = function(z, T, H, eA, CA, IA, k, tA) {
              if (d.equal(arguments.length, 8), d(this.init_done, "write before init"), d(this.mode !== B.NONE, "already finalized"), d.equal(!1, this.write_in_progress, "write already in progress"), d.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, d.equal(!1, T === void 0, "must provide flush value"), this.write_in_progress = !0, T !== B.Z_NO_FLUSH && T !== B.Z_PARTIAL_FLUSH && T !== B.Z_SYNC_FLUSH && T !== B.Z_FULL_FLUSH && T !== B.Z_FINISH && T !== B.Z_BLOCK)
                throw new Error("Invalid flush value");
              if (H == null && (H = A.alloc(0), CA = 0, eA = 0), this.strm.avail_in = CA, this.strm.input = H, this.strm.next_in = eA, this.strm.avail_out = tA, this.strm.output = IA, this.strm.next_out = k, this.flush = T, !z)
                return this._process(), this._checkError() ? this._afterSync() : void 0;
              var lA = this;
              return a.nextTick(function() {
                lA._process(), lA._after();
              }), this;
            }, K.prototype._afterSync = function() {
              var z = this.strm.avail_out, T = this.strm.avail_in;
              return this.write_in_progress = !1, [T, z];
            }, K.prototype._process = function() {
              var z = null;
              switch (this.mode) {
                case B.DEFLATE:
                case B.GZIP:
                case B.DEFLATERAW:
                  this.err = U.deflate(this.strm, this.flush);
                  break;
                case B.UNZIP:
                  switch (this.strm.avail_in > 0 && (z = this.strm.next_in), this.gzip_id_bytes_read) {
                    case 0:
                      if (z === null)
                        break;
                      if (this.strm.input[z] === q) {
                        if (this.gzip_id_bytes_read = 1, z++, this.strm.avail_in === 1)
                          break;
                      } else {
                        this.mode = B.INFLATE;
                        break;
                      }
                    // fallthrough
                    case 1:
                      if (z === null)
                        break;
                      this.strm.input[z] === AA ? (this.gzip_id_bytes_read = 2, this.mode = B.GUNZIP) : this.mode = B.INFLATE;
                      break;
                    default:
                      throw new Error("invalid number of gzip magic number bytes read");
                  }
                // fallthrough
                case B.INFLATE:
                case B.GUNZIP:
                case B.INFLATERAW:
                  for (this.err = P.inflate(
                    this.strm,
                    this.flush
                    // If data was encoded with dictionary
                  ), this.err === B.Z_NEED_DICT && this.dictionary && (this.err = P.inflateSetDictionary(this.strm, this.dictionary), this.err === B.Z_OK ? this.err = P.inflate(this.strm, this.flush) : this.err === B.Z_DATA_ERROR && (this.err = B.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === B.GUNZIP && this.err === B.Z_STREAM_END && this.strm.next_in[0] !== 0; )
                    this.reset(), this.err = P.inflate(this.strm, this.flush);
                  break;
                default:
                  throw new Error("Unknown mode " + this.mode);
              }
            }, K.prototype._checkError = function() {
              switch (this.err) {
                case B.Z_OK:
                case B.Z_BUF_ERROR:
                  if (this.strm.avail_out !== 0 && this.flush === B.Z_FINISH)
                    return this._error("unexpected end of file"), !1;
                  break;
                case B.Z_STREAM_END:
                  break;
                case B.Z_NEED_DICT:
                  return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
                default:
                  return this._error("Zlib error"), !1;
              }
              return !0;
            }, K.prototype._after = function() {
              if (this._checkError()) {
                var z = this.strm.avail_out, T = this.strm.avail_in;
                this.write_in_progress = !1, this.callback(T, z), this.pending_close && this.close();
              }
            }, K.prototype._error = function(z) {
              this.strm.msg && (z = this.strm.msg), this.onerror(
                z,
                this.err
                // no hope of rescue.
              ), this.write_in_progress = !1, this.pending_close && this.close();
            }, K.prototype.init = function(z, T, H, eA, CA) {
              d(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), d(z >= 8 && z <= 15, "invalid windowBits"), d(T >= -1 && T <= 9, "invalid compression level"), d(H >= 1 && H <= 9, "invalid memlevel"), d(eA === B.Z_FILTERED || eA === B.Z_HUFFMAN_ONLY || eA === B.Z_RLE || eA === B.Z_FIXED || eA === B.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(T, z, H, eA, CA), this._setDictionary();
            }, K.prototype.params = function() {
              throw new Error("deflateParams Not supported");
            }, K.prototype.reset = function() {
              this._reset(), this._setDictionary();
            }, K.prototype._init = function(z, T, H, eA, CA) {
              switch (this.level = z, this.windowBits = T, this.memLevel = H, this.strategy = eA, this.flush = B.Z_NO_FLUSH, this.err = B.Z_OK, (this.mode === B.GZIP || this.mode === B.GUNZIP) && (this.windowBits += 16), this.mode === B.UNZIP && (this.windowBits += 32), (this.mode === B.DEFLATERAW || this.mode === B.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new x(), this.mode) {
                case B.DEFLATE:
                case B.GZIP:
                case B.DEFLATERAW:
                  this.err = U.deflateInit2(this.strm, this.level, B.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                  break;
                case B.INFLATE:
                case B.GUNZIP:
                case B.INFLATERAW:
                case B.UNZIP:
                  this.err = P.inflateInit2(this.strm, this.windowBits);
                  break;
                default:
                  throw new Error("Unknown mode " + this.mode);
              }
              this.err !== B.Z_OK && this._error("Init error"), this.dictionary = CA, this.write_in_progress = !1, this.init_done = !0;
            }, K.prototype._setDictionary = function() {
              if (this.dictionary != null) {
                switch (this.err = B.Z_OK, this.mode) {
                  case B.DEFLATE:
                  case B.DEFLATERAW:
                    this.err = U.deflateSetDictionary(this.strm, this.dictionary);
                    break;
                }
                this.err !== B.Z_OK && this._error("Failed to set dictionary");
              }
            }, K.prototype._reset = function() {
              switch (this.err = B.Z_OK, this.mode) {
                case B.DEFLATE:
                case B.DEFLATERAW:
                case B.GZIP:
                  this.err = U.deflateReset(this.strm);
                  break;
                case B.INFLATE:
                case B.INFLATERAW:
                case B.GUNZIP:
                  this.err = P.inflateReset(this.strm);
                  break;
              }
              this.err !== B.Z_OK && this._error("Failed to reset stream");
            }, B.Zlib = K;
          },
          /***/
          6729(Q, B, r) {
            var A = r(9964), a = r(783).Buffer, d = r(9760).Transform, x = r(2908), U = r(7187), P = r(7801).ok, D = r(783).kMaxLength, J = "Cannot create final Buffer. It would be larger than 0x" + D.toString(16) + " bytes";
            x.Z_MIN_WINDOWBITS = 8, x.Z_MAX_WINDOWBITS = 15, x.Z_DEFAULT_WINDOWBITS = 15, x.Z_MIN_CHUNK = 64, x.Z_MAX_CHUNK = 1 / 0, x.Z_DEFAULT_CHUNK = 16384, x.Z_MIN_MEMLEVEL = 1, x.Z_MAX_MEMLEVEL = 9, x.Z_DEFAULT_MEMLEVEL = 8, x.Z_MIN_LEVEL = -1, x.Z_MAX_LEVEL = 9, x.Z_DEFAULT_LEVEL = x.Z_DEFAULT_COMPRESSION;
            for (var q = Object.keys(x), AA = 0; AA < q.length; AA++) {
              var K = q[AA];
              K.match(/^Z/) && Object.defineProperty(B, K, {
                enumerable: !0,
                value: x[K],
                writable: !1
              });
            }
            for (var z = {
              Z_OK: x.Z_OK,
              Z_STREAM_END: x.Z_STREAM_END,
              Z_NEED_DICT: x.Z_NEED_DICT,
              Z_ERRNO: x.Z_ERRNO,
              Z_STREAM_ERROR: x.Z_STREAM_ERROR,
              Z_DATA_ERROR: x.Z_DATA_ERROR,
              Z_MEM_ERROR: x.Z_MEM_ERROR,
              Z_BUF_ERROR: x.Z_BUF_ERROR,
              Z_VERSION_ERROR: x.Z_VERSION_ERROR
            }, T = Object.keys(z), H = 0; H < T.length; H++) {
              var eA = T[H];
              z[z[eA]] = eA;
            }
            Object.defineProperty(B, "codes", {
              enumerable: !0,
              value: Object.freeze(z),
              writable: !1
            }), B.Deflate = k, B.Inflate = tA, B.Gzip = lA, B.Gunzip = uA, B.DeflateRaw = w, B.InflateRaw = v, B.Unzip = RA, B.createDeflate = function(kA) {
              return new k(kA);
            }, B.createInflate = function(kA) {
              return new tA(kA);
            }, B.createDeflateRaw = function(kA) {
              return new w(kA);
            }, B.createInflateRaw = function(kA) {
              return new v(kA);
            }, B.createGzip = function(kA) {
              return new lA(kA);
            }, B.createGunzip = function(kA) {
              return new uA(kA);
            }, B.createUnzip = function(kA) {
              return new RA(kA);
            }, B.deflate = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new k(WA), kA, EA);
            }, B.deflateSync = function(kA, WA) {
              return IA(new k(WA), kA);
            }, B.gzip = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new lA(WA), kA, EA);
            }, B.gzipSync = function(kA, WA) {
              return IA(new lA(WA), kA);
            }, B.deflateRaw = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new w(WA), kA, EA);
            }, B.deflateRawSync = function(kA, WA) {
              return IA(new w(WA), kA);
            }, B.unzip = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new RA(WA), kA, EA);
            }, B.unzipSync = function(kA, WA) {
              return IA(new RA(WA), kA);
            }, B.inflate = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new tA(WA), kA, EA);
            }, B.inflateSync = function(kA, WA) {
              return IA(new tA(WA), kA);
            }, B.gunzip = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new uA(WA), kA, EA);
            }, B.gunzipSync = function(kA, WA) {
              return IA(new uA(WA), kA);
            }, B.inflateRaw = function(kA, WA, EA) {
              return typeof WA == "function" && (EA = WA, WA = {}), CA(new v(WA), kA, EA);
            }, B.inflateRawSync = function(kA, WA) {
              return IA(new v(WA), kA);
            };
            function CA(kA, WA, EA) {
              var zA = [], OA = 0;
              kA.on("error", LA), kA.on("end", yA), kA.end(WA), xA();
              function xA() {
                for (var TA; (TA = kA.read()) !== null; )
                  zA.push(TA), OA += TA.length;
                kA.once("readable", xA);
              }
              function LA(TA) {
                kA.removeListener("end", yA), kA.removeListener("readable", xA), EA(TA);
              }
              function yA() {
                var TA, fA = null;
                OA >= D ? fA = new RangeError(J) : TA = a.concat(zA, OA), zA = [], kA.close(), EA(fA, TA);
              }
            }
            function IA(kA, WA) {
              if (typeof WA == "string" && (WA = a.from(WA)), !a.isBuffer(WA)) throw new TypeError("Not a string or buffer");
              var EA = kA._finishFlushFlag;
              return kA._processChunk(WA, EA);
            }
            function k(kA) {
              if (!(this instanceof k)) return new k(kA);
              $.call(this, kA, x.DEFLATE);
            }
            function tA(kA) {
              if (!(this instanceof tA)) return new tA(kA);
              $.call(this, kA, x.INFLATE);
            }
            function lA(kA) {
              if (!(this instanceof lA)) return new lA(kA);
              $.call(this, kA, x.GZIP);
            }
            function uA(kA) {
              if (!(this instanceof uA)) return new uA(kA);
              $.call(this, kA, x.GUNZIP);
            }
            function w(kA) {
              if (!(this instanceof w)) return new w(kA);
              $.call(this, kA, x.DEFLATERAW);
            }
            function v(kA) {
              if (!(this instanceof v)) return new v(kA);
              $.call(this, kA, x.INFLATERAW);
            }
            function RA(kA) {
              if (!(this instanceof RA)) return new RA(kA);
              $.call(this, kA, x.UNZIP);
            }
            function DA(kA) {
              return kA === x.Z_NO_FLUSH || kA === x.Z_PARTIAL_FLUSH || kA === x.Z_SYNC_FLUSH || kA === x.Z_FULL_FLUSH || kA === x.Z_FINISH || kA === x.Z_BLOCK;
            }
            function $(kA, WA) {
              var EA = this;
              if (this._opts = kA = kA || {}, this._chunkSize = kA.chunkSize || B.Z_DEFAULT_CHUNK, d.call(this, kA), kA.flush && !DA(kA.flush))
                throw new Error("Invalid flush flag: " + kA.flush);
              if (kA.finishFlush && !DA(kA.finishFlush))
                throw new Error("Invalid flush flag: " + kA.finishFlush);
              if (this._flushFlag = kA.flush || x.Z_NO_FLUSH, this._finishFlushFlag = typeof kA.finishFlush < "u" ? kA.finishFlush : x.Z_FINISH, kA.chunkSize && (kA.chunkSize < B.Z_MIN_CHUNK || kA.chunkSize > B.Z_MAX_CHUNK))
                throw new Error("Invalid chunk size: " + kA.chunkSize);
              if (kA.windowBits && (kA.windowBits < B.Z_MIN_WINDOWBITS || kA.windowBits > B.Z_MAX_WINDOWBITS))
                throw new Error("Invalid windowBits: " + kA.windowBits);
              if (kA.level && (kA.level < B.Z_MIN_LEVEL || kA.level > B.Z_MAX_LEVEL))
                throw new Error("Invalid compression level: " + kA.level);
              if (kA.memLevel && (kA.memLevel < B.Z_MIN_MEMLEVEL || kA.memLevel > B.Z_MAX_MEMLEVEL))
                throw new Error("Invalid memLevel: " + kA.memLevel);
              if (kA.strategy && kA.strategy != B.Z_FILTERED && kA.strategy != B.Z_HUFFMAN_ONLY && kA.strategy != B.Z_RLE && kA.strategy != B.Z_FIXED && kA.strategy != B.Z_DEFAULT_STRATEGY)
                throw new Error("Invalid strategy: " + kA.strategy);
              if (kA.dictionary && !a.isBuffer(kA.dictionary))
                throw new Error("Invalid dictionary: it should be a Buffer instance");
              this._handle = new x.Zlib(WA);
              var zA = this;
              this._hadError = !1, this._handle.onerror = function(LA, yA) {
                cA(zA), zA._hadError = !0;
                var TA = new Error(LA);
                TA.errno = yA, TA.code = B.codes[yA], zA.emit("error", TA);
              };
              var OA = B.Z_DEFAULT_COMPRESSION;
              typeof kA.level == "number" && (OA = kA.level);
              var xA = B.Z_DEFAULT_STRATEGY;
              typeof kA.strategy == "number" && (xA = kA.strategy), this._handle.init(kA.windowBits || B.Z_DEFAULT_WINDOWBITS, OA, kA.memLevel || B.Z_DEFAULT_MEMLEVEL, xA, kA.dictionary), this._buffer = a.allocUnsafe(this._chunkSize), this._offset = 0, this._level = OA, this._strategy = xA, this.once("end", this.close), Object.defineProperty(this, "_closed", {
                get: function() {
                  return !EA._handle;
                },
                configurable: !0,
                enumerable: !0
              });
            }
            U.inherits($, d), $.prototype.params = function(kA, WA, EA) {
              if (kA < B.Z_MIN_LEVEL || kA > B.Z_MAX_LEVEL)
                throw new RangeError("Invalid compression level: " + kA);
              if (WA != B.Z_FILTERED && WA != B.Z_HUFFMAN_ONLY && WA != B.Z_RLE && WA != B.Z_FIXED && WA != B.Z_DEFAULT_STRATEGY)
                throw new TypeError("Invalid strategy: " + WA);
              if (this._level !== kA || this._strategy !== WA) {
                var zA = this;
                this.flush(x.Z_SYNC_FLUSH, function() {
                  P(zA._handle, "zlib binding closed"), zA._handle.params(kA, WA), zA._hadError || (zA._level = kA, zA._strategy = WA, EA && EA());
                });
              } else
                A.nextTick(EA);
            }, $.prototype.reset = function() {
              return P(this._handle, "zlib binding closed"), this._handle.reset();
            }, $.prototype._flush = function(kA) {
              this._transform(a.alloc(0), "", kA);
            }, $.prototype.flush = function(kA, WA) {
              var EA = this, zA = this._writableState;
              (typeof kA == "function" || kA === void 0 && !WA) && (WA = kA, kA = x.Z_FULL_FLUSH), zA.ended ? WA && A.nextTick(WA) : zA.ending ? WA && this.once("end", WA) : zA.needDrain ? WA && this.once("drain", function() {
                return EA.flush(kA, WA);
              }) : (this._flushFlag = kA, this.write(a.alloc(0), "", WA));
            }, $.prototype.close = function(kA) {
              cA(this, kA), A.nextTick($A, this);
            };
            function cA(kA, WA) {
              WA && A.nextTick(WA), kA._handle && (kA._handle.close(), kA._handle = null);
            }
            function $A(kA) {
              kA.emit("close");
            }
            $.prototype._transform = function(kA, WA, EA) {
              var zA, OA = this._writableState, xA = OA.ending || OA.ended, LA = xA && (!kA || OA.length === kA.length);
              if (kA !== null && !a.isBuffer(kA)) return EA(new Error("invalid input"));
              if (!this._handle) return EA(new Error("zlib binding closed"));
              LA ? zA = this._finishFlushFlag : (zA = this._flushFlag, kA.length >= OA.length && (this._flushFlag = this._opts.flush || x.Z_NO_FLUSH)), this._processChunk(kA, zA, EA);
            }, $.prototype._processChunk = function(kA, WA, EA) {
              var zA = kA && kA.length, OA = this._chunkSize - this._offset, xA = 0, LA = this, yA = typeof EA == "function";
              if (!yA) {
                var TA = [], fA = 0, sA;
                this.on("error", function(oA) {
                  sA = oA;
                }), P(this._handle, "zlib binding closed");
                do
                  var F = this._handle.writeSync(
                    WA,
                    kA,
                    // in
                    xA,
                    // in_off
                    zA,
                    // in_len
                    this._buffer,
                    // out
                    this._offset,
                    //out_off
                    OA
                  );
                while (!this._hadError && _(F[0], F[1]));
                if (this._hadError)
                  throw sA;
                if (fA >= D)
                  throw cA(this), new RangeError(J);
                var o = a.concat(TA, fA);
                return cA(this), o;
              }
              P(this._handle, "zlib binding closed");
              var h = this._handle.write(
                WA,
                kA,
                // in
                xA,
                // in_off
                zA,
                // in_len
                this._buffer,
                // out
                this._offset,
                //out_off
                OA
              );
              h.buffer = kA, h.callback = _;
              function _(oA, p) {
                if (this && (this.buffer = null, this.callback = null), !LA._hadError) {
                  var rA = OA - p;
                  if (P(rA >= 0, "have should not go down"), rA > 0) {
                    var QA = LA._buffer.slice(LA._offset, LA._offset + rA);
                    LA._offset += rA, yA ? LA.push(QA) : (TA.push(QA), fA += QA.length);
                  }
                  if ((p === 0 || LA._offset >= LA._chunkSize) && (OA = LA._chunkSize, LA._offset = 0, LA._buffer = a.allocUnsafe(LA._chunkSize)), p === 0) {
                    if (xA += zA - oA, zA = oA, !yA) return !0;
                    var bA = LA._handle.write(WA, kA, xA, zA, LA._buffer, LA._offset, LA._chunkSize);
                    bA.callback = _, bA.buffer = kA;
                    return;
                  }
                  if (!yA) return !1;
                  EA();
                }
              }
            }, U.inherits(k, $), U.inherits(tA, $), U.inherits(lA, $), U.inherits(uA, $), U.inherits(w, $), U.inherits(v, $), U.inherits(RA, $);
          },
          /***/
          7802(Q, B, r) {
            var A = r(5049), a = r(3036), d = r(78), x = r(1909);
            Q.exports = x || A.call(d, a);
          },
          /***/
          8619(Q, B, r) {
            var A = r(5049), a = r(3036), d = r(7802);
            Q.exports = function() {
              return d(A, a, arguments);
            };
          },
          /***/
          3036(Q) {
            Q.exports = Function.prototype.apply;
          },
          /***/
          78(Q) {
            Q.exports = Function.prototype.call;
          },
          /***/
          6688(Q, B, r) {
            var A = r(5049), a = r(6785), d = r(78), x = r(7802);
            Q.exports = function(P) {
              if (P.length < 1 || typeof P[0] != "function")
                throw new a("a function is required");
              return x(A, d, P);
            };
          },
          /***/
          1909(Q) {
            Q.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
          },
          /***/
          7913(Q, B, r) {
            var A = r(8651), a = r(6601), d = a(A("String.prototype.indexOf"));
            Q.exports = function(U, P) {
              var D = A(U, !!P);
              return typeof D == "function" && d(U, ".prototype.") > -1 ? a(D) : D;
            };
          },
          /***/
          6601(Q, B, r) {
            var A = r(6255), a = r(6649), d = r(6688), x = r(8619);
            Q.exports = function(P) {
              var D = d(arguments), J = P.length - (arguments.length - 1);
              return A(
                D,
                1 + (J > 0 ? J : 0),
                !0
              );
            }, a ? a(Q.exports, "apply", { value: x }) : Q.exports.apply = x;
          },
          /***/
          2774(Q, B, r) {
            var A = r(8651), a = r(6688), d = a([A("%String.prototype.indexOf%")]);
            Q.exports = function(U, P) {
              var D = (
                /** @type {(this: unknown, ...args: unknown[]) => unknown} */
                A(U, !!P)
              );
              return typeof D == "function" && d(U, ".prototype.") > -1 ? a(
                /** @type {const} */
                [D]
              ) : D;
            };
          },
          /***/
          1613(Q, B, r) {
            var A = r(783).Buffer, a = (function() {
              function d(T, H) {
                return H != null && T instanceof H;
              }
              var x;
              try {
                x = Map;
              } catch {
                x = function() {
                };
              }
              var U;
              try {
                U = Set;
              } catch {
                U = function() {
                };
              }
              var P;
              try {
                P = Promise;
              } catch {
                P = function() {
                };
              }
              function D(T, H, eA, CA, IA) {
                typeof H == "object" && (eA = H.depth, CA = H.prototype, IA = H.includeNonEnumerable, H = H.circular);
                var k = [], tA = [], lA = typeof A < "u";
                typeof H > "u" && (H = !0), typeof eA > "u" && (eA = 1 / 0);
                function uA(w, v) {
                  if (w === null)
                    return null;
                  if (v === 0)
                    return w;
                  var RA, DA;
                  if (typeof w != "object")
                    return w;
                  if (d(w, x))
                    RA = new x();
                  else if (d(w, U))
                    RA = new U();
                  else if (d(w, P))
                    RA = new P(function(xA, LA) {
                      w.then(function(yA) {
                        xA(uA(yA, v - 1));
                      }, function(yA) {
                        LA(uA(yA, v - 1));
                      });
                    });
                  else if (D.__isArray(w))
                    RA = [];
                  else if (D.__isRegExp(w))
                    RA = new RegExp(w.source, z(w)), w.lastIndex && (RA.lastIndex = w.lastIndex);
                  else if (D.__isDate(w))
                    RA = new Date(w.getTime());
                  else {
                    if (lA && A.isBuffer(w))
                      return A.allocUnsafe ? RA = A.allocUnsafe(w.length) : RA = new A(w.length), w.copy(RA), RA;
                    d(w, Error) ? RA = Object.create(w) : typeof CA > "u" ? (DA = Object.getPrototypeOf(w), RA = Object.create(DA)) : (RA = Object.create(CA), DA = CA);
                  }
                  if (H) {
                    var $ = k.indexOf(w);
                    if ($ != -1)
                      return tA[$];
                    k.push(w), tA.push(RA);
                  }
                  d(w, x) && w.forEach(function(xA, LA) {
                    var yA = uA(LA, v - 1), TA = uA(xA, v - 1);
                    RA.set(yA, TA);
                  }), d(w, U) && w.forEach(function(xA) {
                    var LA = uA(xA, v - 1);
                    RA.add(LA);
                  });
                  for (var cA in w) {
                    var $A;
                    DA && ($A = Object.getOwnPropertyDescriptor(DA, cA)), !($A && $A.set == null) && (RA[cA] = uA(w[cA], v - 1));
                  }
                  if (Object.getOwnPropertySymbols)
                    for (var kA = Object.getOwnPropertySymbols(w), cA = 0; cA < kA.length; cA++) {
                      var WA = kA[cA], EA = Object.getOwnPropertyDescriptor(w, WA);
                      EA && !EA.enumerable && !IA || (RA[WA] = uA(w[WA], v - 1), EA.enumerable || Object.defineProperty(RA, WA, {
                        enumerable: !1
                      }));
                    }
                  if (IA)
                    for (var zA = Object.getOwnPropertyNames(w), cA = 0; cA < zA.length; cA++) {
                      var OA = zA[cA], EA = Object.getOwnPropertyDescriptor(w, OA);
                      EA && EA.enumerable || (RA[OA] = uA(w[OA], v - 1), Object.defineProperty(RA, OA, {
                        enumerable: !1
                      }));
                    }
                  return RA;
                }
                return uA(T, eA);
              }
              D.clonePrototype = function(H) {
                if (H === null)
                  return null;
                var eA = function() {
                };
                return eA.prototype = H, new eA();
              };
              function J(T) {
                return Object.prototype.toString.call(T);
              }
              D.__objToStr = J;
              function q(T) {
                return typeof T == "object" && J(T) === "[object Date]";
              }
              D.__isDate = q;
              function AA(T) {
                return typeof T == "object" && J(T) === "[object Array]";
              }
              D.__isArray = AA;
              function K(T) {
                return typeof T == "object" && J(T) === "[object RegExp]";
              }
              D.__isRegExp = K;
              function z(T) {
                var H = "";
                return T.global && (H += "g"), T.ignoreCase && (H += "i"), T.multiline && (H += "m"), H;
              }
              return D.__getRegExpFlags = z, D;
            })();
            Q.exports && (Q.exports = a);
          },
          /***/
          9295(Q, B, r) {
            var A = r(6649), a = r(7770), d = r(6785), x = r(8109);
            Q.exports = function(P, D, J) {
              if (!P || typeof P != "object" && typeof P != "function")
                throw new d("`obj` must be an object or a function`");
              if (typeof D != "string" && typeof D != "symbol")
                throw new d("`property` must be a string or a symbol`");
              if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
                throw new d("`nonEnumerable`, if provided, must be a boolean or null");
              if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
                throw new d("`nonWritable`, if provided, must be a boolean or null");
              if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
                throw new d("`nonConfigurable`, if provided, must be a boolean or null");
              if (arguments.length > 6 && typeof arguments[6] != "boolean")
                throw new d("`loose`, if provided, must be a boolean");
              var q = arguments.length > 3 ? arguments[3] : null, AA = arguments.length > 4 ? arguments[4] : null, K = arguments.length > 5 ? arguments[5] : null, z = arguments.length > 6 ? arguments[6] : !1, T = !!x && x(P, D);
              if (A)
                A(P, D, {
                  configurable: K === null && T ? T.configurable : !K,
                  enumerable: q === null && T ? T.enumerable : !q,
                  value: J,
                  writable: AA === null && T ? T.writable : !AA
                });
              else if (z || !q && !AA && !K)
                P[D] = J;
              else
                throw new a("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
            };
          },
          /***/
          5421(Q, B, r) {
            var A = r(5643), a = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", d = Object.prototype.toString, x = Array.prototype.concat, U = r(9295), P = function(AA) {
              return typeof AA == "function" && d.call(AA) === "[object Function]";
            }, D = r(8890)(), J = function(AA, K, z, T) {
              if (K in AA) {
                if (T === !0) {
                  if (AA[K] === z)
                    return;
                } else if (!P(T) || !T())
                  return;
              }
              D ? U(AA, K, z, !0) : U(AA, K, z);
            }, q = function(AA, K) {
              var z = arguments.length > 2 ? arguments[2] : {}, T = A(K);
              a && (T = x.call(T, Object.getOwnPropertySymbols(K)));
              for (var H = 0; H < T.length; H += 1)
                J(AA, T[H], K[T[H]], z[T[H]]);
            };
            q.supportsDescriptors = !!D, Q.exports = q;
          },
          /***/
          9302(Q, B, r) {
            var A = r(6688), a = r(8109), d;
            try {
              d = /** @type {{ __proto__?: typeof Array.prototype }} */
              [].__proto__ === Array.prototype;
            } catch (D) {
              if (!D || typeof D != "object" || !("code" in D) || D.code !== "ERR_PROTO_ACCESS")
                throw D;
            }
            var x = !!d && a && a(
              Object.prototype,
              /** @type {keyof typeof Object.prototype} */
              "__proto__"
            ), U = Object, P = U.getPrototypeOf;
            Q.exports = x && typeof x.get == "function" ? A([x.get]) : typeof P == "function" ? (
              /** @type {import('./get')} */
              function(J) {
                return P(J == null ? J : U(J));
              }
            ) : !1;
          },
          /***/
          6649(Q) {
            var B = Object.defineProperty || !1;
            if (B)
              try {
                B({}, "a", { value: 1 });
              } catch {
                B = !1;
              }
            Q.exports = B;
          },
          /***/
          9055(Q) {
            Q.exports = EvalError;
          },
          /***/
          5293(Q) {
            Q.exports = Error;
          },
          /***/
          8888(Q) {
            Q.exports = RangeError;
          },
          /***/
          7900(Q) {
            Q.exports = ReferenceError;
          },
          /***/
          7770(Q) {
            Q.exports = SyntaxError;
          },
          /***/
          6785(Q) {
            Q.exports = TypeError;
          },
          /***/
          4055(Q) {
            Q.exports = URIError;
          },
          /***/
          5846(Q) {
            Q.exports = Object;
          },
          /***/
          4785(Q) {
            var B = typeof Reflect == "object" ? Reflect : null, r = B && typeof B.apply == "function" ? B.apply : function(lA, uA, w) {
              return Function.prototype.apply.call(lA, uA, w);
            }, A;
            B && typeof B.ownKeys == "function" ? A = B.ownKeys : Object.getOwnPropertySymbols ? A = function(lA) {
              return Object.getOwnPropertyNames(lA).concat(Object.getOwnPropertySymbols(lA));
            } : A = function(lA) {
              return Object.getOwnPropertyNames(lA);
            };
            function a(tA) {
              console && console.warn && console.warn(tA);
            }
            var d = Number.isNaN || function(lA) {
              return lA !== lA;
            };
            function x() {
              x.init.call(this);
            }
            Q.exports = x, Q.exports.once = CA, x.EventEmitter = x, x.prototype._events = void 0, x.prototype._eventsCount = 0, x.prototype._maxListeners = void 0;
            var U = 10;
            function P(tA) {
              if (typeof tA != "function")
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof tA);
            }
            Object.defineProperty(x, "defaultMaxListeners", {
              enumerable: !0,
              get: function() {
                return U;
              },
              set: function(tA) {
                if (typeof tA != "number" || tA < 0 || d(tA))
                  throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + tA + ".");
                U = tA;
              }
            }), x.init = function() {
              (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, x.prototype.setMaxListeners = function(lA) {
              if (typeof lA != "number" || lA < 0 || d(lA))
                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + lA + ".");
              return this._maxListeners = lA, this;
            };
            function D(tA) {
              return tA._maxListeners === void 0 ? x.defaultMaxListeners : tA._maxListeners;
            }
            x.prototype.getMaxListeners = function() {
              return D(this);
            }, x.prototype.emit = function(lA) {
              for (var uA = [], w = 1; w < arguments.length; w++) uA.push(arguments[w]);
              var v = lA === "error", RA = this._events;
              if (RA !== void 0)
                v = v && RA.error === void 0;
              else if (!v)
                return !1;
              if (v) {
                var DA;
                if (uA.length > 0 && (DA = uA[0]), DA instanceof Error)
                  throw DA;
                var $ = new Error("Unhandled error." + (DA ? " (" + DA.message + ")" : ""));
                throw $.context = DA, $;
              }
              var cA = RA[lA];
              if (cA === void 0)
                return !1;
              if (typeof cA == "function")
                r(cA, this, uA);
              else
                for (var $A = cA.length, kA = T(cA, $A), w = 0; w < $A; ++w)
                  r(kA[w], this, uA);
              return !0;
            };
            function J(tA, lA, uA, w) {
              var v, RA, DA;
              if (P(uA), RA = tA._events, RA === void 0 ? (RA = tA._events = /* @__PURE__ */ Object.create(null), tA._eventsCount = 0) : (RA.newListener !== void 0 && (tA.emit(
                "newListener",
                lA,
                uA.listener ? uA.listener : uA
              ), RA = tA._events), DA = RA[lA]), DA === void 0)
                DA = RA[lA] = uA, ++tA._eventsCount;
              else if (typeof DA == "function" ? DA = RA[lA] = w ? [uA, DA] : [DA, uA] : w ? DA.unshift(uA) : DA.push(uA), v = D(tA), v > 0 && DA.length > v && !DA.warned) {
                DA.warned = !0;
                var $ = new Error("Possible EventEmitter memory leak detected. " + DA.length + " " + String(lA) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                $.name = "MaxListenersExceededWarning", $.emitter = tA, $.type = lA, $.count = DA.length, a($);
              }
              return tA;
            }
            x.prototype.addListener = function(lA, uA) {
              return J(this, lA, uA, !1);
            }, x.prototype.on = x.prototype.addListener, x.prototype.prependListener = function(lA, uA) {
              return J(this, lA, uA, !0);
            };
            function q() {
              if (!this.fired)
                return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function AA(tA, lA, uA) {
              var w = { fired: !1, wrapFn: void 0, target: tA, type: lA, listener: uA }, v = q.bind(w);
              return v.listener = uA, w.wrapFn = v, v;
            }
            x.prototype.once = function(lA, uA) {
              return P(uA), this.on(lA, AA(this, lA, uA)), this;
            }, x.prototype.prependOnceListener = function(lA, uA) {
              return P(uA), this.prependListener(lA, AA(this, lA, uA)), this;
            }, x.prototype.removeListener = function(lA, uA) {
              var w, v, RA, DA, $;
              if (P(uA), v = this._events, v === void 0)
                return this;
              if (w = v[lA], w === void 0)
                return this;
              if (w === uA || w.listener === uA)
                --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete v[lA], v.removeListener && this.emit("removeListener", lA, w.listener || uA));
              else if (typeof w != "function") {
                for (RA = -1, DA = w.length - 1; DA >= 0; DA--)
                  if (w[DA] === uA || w[DA].listener === uA) {
                    $ = w[DA].listener, RA = DA;
                    break;
                  }
                if (RA < 0)
                  return this;
                RA === 0 ? w.shift() : H(w, RA), w.length === 1 && (v[lA] = w[0]), v.removeListener !== void 0 && this.emit("removeListener", lA, $ || uA);
              }
              return this;
            }, x.prototype.off = x.prototype.removeListener, x.prototype.removeAllListeners = function(lA) {
              var uA, w, v;
              if (w = this._events, w === void 0)
                return this;
              if (w.removeListener === void 0)
                return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : w[lA] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete w[lA]), this;
              if (arguments.length === 0) {
                var RA = Object.keys(w), DA;
                for (v = 0; v < RA.length; ++v)
                  DA = RA[v], DA !== "removeListener" && this.removeAllListeners(DA);
                return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
              }
              if (uA = w[lA], typeof uA == "function")
                this.removeListener(lA, uA);
              else if (uA !== void 0)
                for (v = uA.length - 1; v >= 0; v--)
                  this.removeListener(lA, uA[v]);
              return this;
            };
            function K(tA, lA, uA) {
              var w = tA._events;
              if (w === void 0)
                return [];
              var v = w[lA];
              return v === void 0 ? [] : typeof v == "function" ? uA ? [v.listener || v] : [v] : uA ? eA(v) : T(v, v.length);
            }
            x.prototype.listeners = function(lA) {
              return K(this, lA, !0);
            }, x.prototype.rawListeners = function(lA) {
              return K(this, lA, !1);
            }, x.listenerCount = function(tA, lA) {
              return typeof tA.listenerCount == "function" ? tA.listenerCount(lA) : z.call(tA, lA);
            }, x.prototype.listenerCount = z;
            function z(tA) {
              var lA = this._events;
              if (lA !== void 0) {
                var uA = lA[tA];
                if (typeof uA == "function")
                  return 1;
                if (uA !== void 0)
                  return uA.length;
              }
              return 0;
            }
            x.prototype.eventNames = function() {
              return this._eventsCount > 0 ? A(this._events) : [];
            };
            function T(tA, lA) {
              for (var uA = new Array(lA), w = 0; w < lA; ++w)
                uA[w] = tA[w];
              return uA;
            }
            function H(tA, lA) {
              for (; lA + 1 < tA.length; lA++)
                tA[lA] = tA[lA + 1];
              tA.pop();
            }
            function eA(tA) {
              for (var lA = new Array(tA.length), uA = 0; uA < lA.length; ++uA)
                lA[uA] = tA[uA].listener || tA[uA];
              return lA;
            }
            function CA(tA, lA) {
              return new Promise(function(uA, w) {
                function v(DA) {
                  tA.removeListener(lA, RA), w(DA);
                }
                function RA() {
                  typeof tA.removeListener == "function" && tA.removeListener("error", v), uA([].slice.call(arguments));
                }
                k(tA, lA, RA, { once: !0 }), lA !== "error" && IA(tA, v, { once: !0 });
              });
            }
            function IA(tA, lA, uA) {
              typeof tA.on == "function" && k(tA, "error", lA, uA);
            }
            function k(tA, lA, uA, w) {
              if (typeof tA.on == "function")
                w.once ? tA.once(lA, uA) : tA.on(lA, uA);
              else if (typeof tA.addEventListener == "function")
                tA.addEventListener(lA, function v(RA) {
                  w.once && tA.removeEventListener(lA, v), uA(RA);
                });
              else
                throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof tA);
            }
          },
          /***/
          2022(Q, B, r) {
            Q.exports = (function() {
              if (typeof globalThis == "object")
                return globalThis;
              var A;
              try {
                A = this || new Function("return this")();
              } catch {
                if (typeof window == "object")
                  return window;
                if (typeof self == "object")
                  return self;
                if (typeof r.g < "u")
                  return r.g;
              }
              return A;
            })();
          },
          /***/
          453(Q) {
            Q.exports = function B(r, A) {
              if (r === A) return !0;
              if (r && A && typeof r == "object" && typeof A == "object") {
                if (r.constructor !== A.constructor) return !1;
                var a, d, x;
                if (Array.isArray(r)) {
                  if (a = r.length, a != A.length) return !1;
                  for (d = a; d-- !== 0; )
                    if (!B(r[d], A[d])) return !1;
                  return !0;
                }
                if (r.constructor === RegExp) return r.source === A.source && r.flags === A.flags;
                if (r.valueOf !== Object.prototype.valueOf) return r.valueOf() === A.valueOf();
                if (r.toString !== Object.prototype.toString) return r.toString() === A.toString();
                if (x = Object.keys(r), a = x.length, a !== Object.keys(A).length) return !1;
                for (d = a; d-- !== 0; )
                  if (!Object.prototype.hasOwnProperty.call(A, x[d])) return !1;
                for (d = a; d-- !== 0; ) {
                  var U = x[d];
                  if (!B(r[U], A[U])) return !1;
                }
                return !0;
              }
              return r !== r && A !== A;
            };
          },
          /***/
          8404(Q, B, r) {
            var A = r(3746), a = Object.prototype.toString, d = Object.prototype.hasOwnProperty, x = function(q, AA, K) {
              for (var z = 0, T = q.length; z < T; z++)
                d.call(q, z) && (K == null ? AA(q[z], z, q) : AA.call(K, q[z], z, q));
            }, U = function(q, AA, K) {
              for (var z = 0, T = q.length; z < T; z++)
                K == null ? AA(q.charAt(z), z, q) : AA.call(K, q.charAt(z), z, q);
            }, P = function(q, AA, K) {
              for (var z in q)
                d.call(q, z) && (K == null ? AA(q[z], z, q) : AA.call(K, q[z], z, q));
            };
            function D(J) {
              return a.call(J) === "[object Array]";
            }
            Q.exports = function(q, AA, K) {
              if (!A(AA))
                throw new TypeError("iterator must be a function");
              var z;
              arguments.length >= 3 && (z = K), D(q) ? x(q, AA, z) : typeof q == "string" ? U(q, AA, z) : P(q, AA, z);
            };
          },
          /***/
          2719(Q) {
            var B = "Function.prototype.bind called on incompatible ", r = Object.prototype.toString, A = Math.max, a = "[object Function]", d = function(D, J) {
              for (var q = [], AA = 0; AA < D.length; AA += 1)
                q[AA] = D[AA];
              for (var K = 0; K < J.length; K += 1)
                q[K + D.length] = J[K];
              return q;
            }, x = function(D, J) {
              for (var q = [], AA = J, K = 0; AA < D.length; AA += 1, K += 1)
                q[K] = D[AA];
              return q;
            }, U = function(P, D) {
              for (var J = "", q = 0; q < P.length; q += 1)
                J += P[q], q + 1 < P.length && (J += D);
              return J;
            };
            Q.exports = function(D) {
              var J = this;
              if (typeof J != "function" || r.apply(J) !== a)
                throw new TypeError(B + J);
              for (var q = x(arguments, 1), AA, K = function() {
                if (this instanceof AA) {
                  var CA = J.apply(
                    this,
                    d(q, arguments)
                  );
                  return Object(CA) === CA ? CA : this;
                }
                return J.apply(
                  D,
                  d(q, arguments)
                );
              }, z = A(0, J.length - q.length), T = [], H = 0; H < z; H++)
                T[H] = "$" + H;
              if (AA = Function("binder", "return function (" + U(T, ",") + "){ return binder.apply(this,arguments); }")(K), J.prototype) {
                var eA = function() {
                };
                eA.prototype = J.prototype, AA.prototype = new eA(), eA.prototype = null;
              }
              return AA;
            };
          },
          /***/
          5049(Q, B, r) {
            var A = r(2719);
            Q.exports = Function.prototype.bind || A;
          },
          /***/
          3011(Q) {
            const B = (
              /** @type {GeneratorFunctionConstructor} */
              (function* () {
              }).constructor
            );
            Q.exports = () => B;
          },
          /***/
          8651(Q, B, r) {
            var A, a = r(5846), d = r(5293), x = r(9055), U = r(8888), P = r(7900), D = r(7770), J = r(6785), q = r(4055), AA = r(716), K = r(7450), z = r(3774), T = r(7552), H = r(5874), eA = r(9292), CA = r(6071), IA = Function, k = function(rA) {
              try {
                return IA('"use strict"; return (' + rA + ").constructor;")();
              } catch {
              }
            }, tA = r(8109), lA = r(6649), uA = function() {
              throw new J();
            }, w = tA ? (function() {
              try {
                return arguments.callee, uA;
              } catch {
                try {
                  return tA(arguments, "callee").get;
                } catch {
                  return uA;
                }
              }
            })() : uA, v = r(3257)(), RA = r(7106), DA = r(3766), $ = r(6822), cA = r(3036), $A = r(78), kA = {}, WA = typeof Uint8Array > "u" || !RA ? A : RA(Uint8Array), EA = {
              __proto__: null,
              "%AggregateError%": typeof AggregateError > "u" ? A : AggregateError,
              "%Array%": Array,
              "%ArrayBuffer%": typeof ArrayBuffer > "u" ? A : ArrayBuffer,
              "%ArrayIteratorPrototype%": v && RA ? RA([][Symbol.iterator]()) : A,
              "%AsyncFromSyncIteratorPrototype%": A,
              "%AsyncFunction%": kA,
              "%AsyncGenerator%": kA,
              "%AsyncGeneratorFunction%": kA,
              "%AsyncIteratorPrototype%": kA,
              "%Atomics%": typeof Atomics > "u" ? A : Atomics,
              "%BigInt%": typeof BigInt > "u" ? A : BigInt,
              "%BigInt64Array%": typeof BigInt64Array > "u" ? A : BigInt64Array,
              "%BigUint64Array%": typeof BigUint64Array > "u" ? A : BigUint64Array,
              "%Boolean%": Boolean,
              "%DataView%": typeof DataView > "u" ? A : DataView,
              "%Date%": Date,
              "%decodeURI%": decodeURI,
              "%decodeURIComponent%": decodeURIComponent,
              "%encodeURI%": encodeURI,
              "%encodeURIComponent%": encodeURIComponent,
              "%Error%": d,
              "%eval%": eval,
              // eslint-disable-line no-eval
              "%EvalError%": x,
              "%Float16Array%": typeof Float16Array > "u" ? A : Float16Array,
              "%Float32Array%": typeof Float32Array > "u" ? A : Float32Array,
              "%Float64Array%": typeof Float64Array > "u" ? A : Float64Array,
              "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? A : FinalizationRegistry,
              "%Function%": IA,
              "%GeneratorFunction%": kA,
              "%Int8Array%": typeof Int8Array > "u" ? A : Int8Array,
              "%Int16Array%": typeof Int16Array > "u" ? A : Int16Array,
              "%Int32Array%": typeof Int32Array > "u" ? A : Int32Array,
              "%isFinite%": isFinite,
              "%isNaN%": isNaN,
              "%IteratorPrototype%": v && RA ? RA(RA([][Symbol.iterator]())) : A,
              "%JSON%": typeof JSON == "object" ? JSON : A,
              "%Map%": typeof Map > "u" ? A : Map,
              "%MapIteratorPrototype%": typeof Map > "u" || !v || !RA ? A : RA((/* @__PURE__ */ new Map())[Symbol.iterator]()),
              "%Math%": Math,
              "%Number%": Number,
              "%Object%": a,
              "%Object.getOwnPropertyDescriptor%": tA,
              "%parseFloat%": parseFloat,
              "%parseInt%": parseInt,
              "%Promise%": typeof Promise > "u" ? A : Promise,
              "%Proxy%": typeof Proxy > "u" ? A : Proxy,
              "%RangeError%": U,
              "%ReferenceError%": P,
              "%Reflect%": typeof Reflect > "u" ? A : Reflect,
              "%RegExp%": RegExp,
              "%Set%": typeof Set > "u" ? A : Set,
              "%SetIteratorPrototype%": typeof Set > "u" || !v || !RA ? A : RA((/* @__PURE__ */ new Set())[Symbol.iterator]()),
              "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? A : SharedArrayBuffer,
              "%String%": String,
              "%StringIteratorPrototype%": v && RA ? RA(""[Symbol.iterator]()) : A,
              "%Symbol%": v ? Symbol : A,
              "%SyntaxError%": D,
              "%ThrowTypeError%": w,
              "%TypedArray%": WA,
              "%TypeError%": J,
              "%Uint8Array%": typeof Uint8Array > "u" ? A : Uint8Array,
              "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? A : Uint8ClampedArray,
              "%Uint16Array%": typeof Uint16Array > "u" ? A : Uint16Array,
              "%Uint32Array%": typeof Uint32Array > "u" ? A : Uint32Array,
              "%URIError%": q,
              "%WeakMap%": typeof WeakMap > "u" ? A : WeakMap,
              "%WeakRef%": typeof WeakRef > "u" ? A : WeakRef,
              "%WeakSet%": typeof WeakSet > "u" ? A : WeakSet,
              "%Function.prototype.call%": $A,
              "%Function.prototype.apply%": cA,
              "%Object.defineProperty%": lA,
              "%Object.getPrototypeOf%": DA,
              "%Math.abs%": AA,
              "%Math.floor%": K,
              "%Math.max%": z,
              "%Math.min%": T,
              "%Math.pow%": H,
              "%Math.round%": eA,
              "%Math.sign%": CA,
              "%Reflect.getPrototypeOf%": $
            };
            if (RA)
              try {
                null.error;
              } catch (rA) {
                var zA = RA(RA(rA));
                EA["%Error.prototype%"] = zA;
              }
            var OA = function rA(QA) {
              var bA;
              if (QA === "%AsyncFunction%")
                bA = k("async function () {}");
              else if (QA === "%GeneratorFunction%")
                bA = k("function* () {}");
              else if (QA === "%AsyncGeneratorFunction%")
                bA = k("async function* () {}");
              else if (QA === "%AsyncGenerator%") {
                var y = rA("%AsyncGeneratorFunction%");
                y && (bA = y.prototype);
              } else if (QA === "%AsyncIteratorPrototype%") {
                var M = rA("%AsyncGenerator%");
                M && RA && (bA = RA(M.prototype));
              }
              return EA[QA] = bA, bA;
            }, xA = {
              __proto__: null,
              "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
              "%ArrayPrototype%": ["Array", "prototype"],
              "%ArrayProto_entries%": ["Array", "prototype", "entries"],
              "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
              "%ArrayProto_keys%": ["Array", "prototype", "keys"],
              "%ArrayProto_values%": ["Array", "prototype", "values"],
              "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
              "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
              "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
              "%BooleanPrototype%": ["Boolean", "prototype"],
              "%DataViewPrototype%": ["DataView", "prototype"],
              "%DatePrototype%": ["Date", "prototype"],
              "%ErrorPrototype%": ["Error", "prototype"],
              "%EvalErrorPrototype%": ["EvalError", "prototype"],
              "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
              "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
              "%FunctionPrototype%": ["Function", "prototype"],
              "%Generator%": ["GeneratorFunction", "prototype"],
              "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
              "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
              "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
              "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
              "%JSONParse%": ["JSON", "parse"],
              "%JSONStringify%": ["JSON", "stringify"],
              "%MapPrototype%": ["Map", "prototype"],
              "%NumberPrototype%": ["Number", "prototype"],
              "%ObjectPrototype%": ["Object", "prototype"],
              "%ObjProto_toString%": ["Object", "prototype", "toString"],
              "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
              "%PromisePrototype%": ["Promise", "prototype"],
              "%PromiseProto_then%": ["Promise", "prototype", "then"],
              "%Promise_all%": ["Promise", "all"],
              "%Promise_reject%": ["Promise", "reject"],
              "%Promise_resolve%": ["Promise", "resolve"],
              "%RangeErrorPrototype%": ["RangeError", "prototype"],
              "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
              "%RegExpPrototype%": ["RegExp", "prototype"],
              "%SetPrototype%": ["Set", "prototype"],
              "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
              "%StringPrototype%": ["String", "prototype"],
              "%SymbolPrototype%": ["Symbol", "prototype"],
              "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
              "%TypedArrayPrototype%": ["TypedArray", "prototype"],
              "%TypeErrorPrototype%": ["TypeError", "prototype"],
              "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
              "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
              "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
              "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
              "%URIErrorPrototype%": ["URIError", "prototype"],
              "%WeakMapPrototype%": ["WeakMap", "prototype"],
              "%WeakSetPrototype%": ["WeakSet", "prototype"]
            }, LA = r(5049), yA = r(5215), TA = LA.call($A, Array.prototype.concat), fA = LA.call(cA, Array.prototype.splice), sA = LA.call($A, String.prototype.replace), F = LA.call($A, String.prototype.slice), o = LA.call($A, RegExp.prototype.exec), h = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, _ = /\\(\\)?/g, oA = function(QA) {
              var bA = F(QA, 0, 1), y = F(QA, -1);
              if (bA === "%" && y !== "%")
                throw new D("invalid intrinsic syntax, expected closing `%`");
              if (y === "%" && bA !== "%")
                throw new D("invalid intrinsic syntax, expected opening `%`");
              var M = [];
              return sA(QA, h, function(FA, dA, he, ie) {
                M[M.length] = he ? sA(ie, _, "$1") : dA || FA;
              }), M;
            }, p = function(QA, bA) {
              var y = QA, M;
              if (yA(xA, y) && (M = xA[y], y = "%" + M[0] + "%"), yA(EA, y)) {
                var FA = EA[y];
                if (FA === kA && (FA = OA(y)), typeof FA > "u" && !bA)
                  throw new J("intrinsic " + QA + " exists, but is not available. Please file an issue!");
                return {
                  alias: M,
                  name: y,
                  value: FA
                };
              }
              throw new D("intrinsic " + QA + " does not exist!");
            };
            Q.exports = function(QA, bA) {
              if (typeof QA != "string" || QA.length === 0)
                throw new J("intrinsic name must be a non-empty string");
              if (arguments.length > 1 && typeof bA != "boolean")
                throw new J('"allowMissing" argument must be a boolean');
              if (o(/^%?[^%]*%?$/, QA) === null)
                throw new D("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
              var y = oA(QA), M = y.length > 0 ? y[0] : "", FA = p("%" + M + "%", bA), dA = FA.name, he = FA.value, ie = !1, KA = FA.alias;
              KA && (M = KA[0], fA(y, TA([0, 1], KA)));
              for (var Pe = 1, Je = !0; Pe < y.length; Pe += 1) {
                var Le = y[Pe], Re = F(Le, 0, 1), _e = F(Le, -1);
                if ((Re === '"' || Re === "'" || Re === "`" || _e === '"' || _e === "'" || _e === "`") && Re !== _e)
                  throw new D("property names with quotes must have matching quotes");
                if ((Le === "constructor" || !Je) && (ie = !0), M += "." + Le, dA = "%" + M + "%", yA(EA, dA))
                  he = EA[dA];
                else if (he != null) {
                  if (!(Le in he)) {
                    if (!bA)
                      throw new J("base intrinsic for " + QA + " exists, but the property is not available.");
                    return;
                  }
                  if (tA && Pe + 1 >= y.length) {
                    var se = tA(he, Le);
                    Je = !!se, Je && "get" in se && !("originalValue" in se.get) ? he = se.get : he = he[Le];
                  } else
                    Je = yA(he, Le), he = he[Le];
                  Je && !ie && (EA[dA] = he);
                }
              }
              return he;
            };
          },
          /***/
          3766(Q, B, r) {
            var A = r(5846);
            Q.exports = A.getPrototypeOf || null;
          },
          /***/
          6822(Q) {
            Q.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
          },
          /***/
          7106(Q, B, r) {
            var A = r(6822), a = r(3766), d = r(9302);
            Q.exports = A ? function(U) {
              return A(U);
            } : a ? function(U) {
              if (!U || typeof U != "object" && typeof U != "function")
                throw new TypeError("getProto: not an object");
              return a(U);
            } : d ? function(U) {
              return d(U);
            } : null;
          },
          /***/
          5567(Q) {
            Q.exports = Object.getOwnPropertyDescriptor;
          },
          /***/
          8109(Q, B, r) {
            var A = r(5567);
            if (A)
              try {
                A([], "length");
              } catch {
                A = null;
              }
            Q.exports = A;
          },
          /***/
          8890(Q, B, r) {
            var A = r(6649), a = function() {
              return !!A;
            };
            a.hasArrayLengthDefineBug = function() {
              if (!A)
                return null;
              try {
                return A([], "length", { value: 1 }).length !== 1;
              } catch {
                return !0;
              }
            }, Q.exports = a;
          },
          /***/
          3257(Q, B, r) {
            var A = typeof Symbol < "u" && Symbol, a = r(2843);
            Q.exports = function() {
              return typeof A != "function" || typeof Symbol != "function" || typeof A("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : a();
            };
          },
          /***/
          2843(Q) {
            Q.exports = function() {
              if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
                return !1;
              if (typeof Symbol.iterator == "symbol")
                return !0;
              var r = {}, A = Symbol("test"), a = Object(A);
              if (typeof A == "string" || Object.prototype.toString.call(A) !== "[object Symbol]" || Object.prototype.toString.call(a) !== "[object Symbol]")
                return !1;
              var d = 42;
              r[A] = d;
              for (var x in r)
                return !1;
              if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
                return !1;
              var U = Object.getOwnPropertySymbols(r);
              if (U.length !== 1 || U[0] !== A || !Object.prototype.propertyIsEnumerable.call(r, A))
                return !1;
              if (typeof Object.getOwnPropertyDescriptor == "function") {
                var P = (
                  /** @type {PropertyDescriptor} */
                  Object.getOwnPropertyDescriptor(r, A)
                );
                if (P.value !== d || P.enumerable !== !0)
                  return !1;
              }
              return !0;
            };
          },
          /***/
          6626(Q, B, r) {
            var A = r(2843);
            Q.exports = function() {
              return A() && !!Symbol.toStringTag;
            };
          },
          /***/
          5215(Q, B, r) {
            var A = Function.prototype.call, a = Object.prototype.hasOwnProperty, d = r(5049);
            Q.exports = d.call(A, a);
          },
          /***/
          9029(Q, B) {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
            B.read = function(r, A, a, d, x) {
              var U, P, D = x * 8 - d - 1, J = (1 << D) - 1, q = J >> 1, AA = -7, K = a ? x - 1 : 0, z = a ? -1 : 1, T = r[A + K];
              for (K += z, U = T & (1 << -AA) - 1, T >>= -AA, AA += D; AA > 0; U = U * 256 + r[A + K], K += z, AA -= 8)
                ;
              for (P = U & (1 << -AA) - 1, U >>= -AA, AA += d; AA > 0; P = P * 256 + r[A + K], K += z, AA -= 8)
                ;
              if (U === 0)
                U = 1 - q;
              else {
                if (U === J)
                  return P ? NaN : (T ? -1 : 1) * (1 / 0);
                P = P + Math.pow(2, d), U = U - q;
              }
              return (T ? -1 : 1) * P * Math.pow(2, U - d);
            }, B.write = function(r, A, a, d, x, U) {
              var P, D, J, q = U * 8 - x - 1, AA = (1 << q) - 1, K = AA >> 1, z = x === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, T = d ? 0 : U - 1, H = d ? 1 : -1, eA = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
              for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (D = isNaN(A) ? 1 : 0, P = AA) : (P = Math.floor(Math.log(A) / Math.LN2), A * (J = Math.pow(2, -P)) < 1 && (P--, J *= 2), P + K >= 1 ? A += z / J : A += z * Math.pow(2, 1 - K), A * J >= 2 && (P++, J /= 2), P + K >= AA ? (D = 0, P = AA) : P + K >= 1 ? (D = (A * J - 1) * Math.pow(2, x), P = P + K) : (D = A * Math.pow(2, K - 1) * Math.pow(2, x), P = 0)); x >= 8; r[a + T] = D & 255, T += H, D /= 256, x -= 8)
                ;
              for (P = P << x | D, q += x; q > 0; r[a + T] = P & 255, T += H, P /= 256, q -= 8)
                ;
              r[a + T - H] |= eA * 128;
            };
          },
          /***/
          9784(Q) {
            typeof Object.create == "function" ? Q.exports = function(r, A) {
              A && (r.super_ = A, r.prototype = Object.create(A.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }));
            } : Q.exports = function(r, A) {
              if (A) {
                r.super_ = A;
                var a = function() {
                };
                a.prototype = A.prototype, r.prototype = new a(), r.prototype.constructor = r;
              }
            };
          },
          /***/
          7906(Q, B, r) {
            var A = r(6626)(), a = r(2774), d = a("Object.prototype.toString"), x = function(J) {
              return A && J && typeof J == "object" && Symbol.toStringTag in J ? !1 : d(J) === "[object Arguments]";
            }, U = function(J) {
              return x(J) ? !0 : J !== null && typeof J == "object" && "length" in J && typeof J.length == "number" && J.length >= 0 && d(J) !== "[object Array]" && "callee" in J && d(J.callee) === "[object Function]";
            }, P = (function() {
              return x(arguments);
            })();
            x.isLegacyArguments = U, Q.exports = P ? x : U;
          },
          /***/
          3746(Q) {
            var B = Function.prototype.toString, r = typeof Reflect == "object" && Reflect !== null && Reflect.apply, A, a;
            if (typeof r == "function" && typeof Object.defineProperty == "function")
              try {
                A = Object.defineProperty({}, "length", {
                  get: function() {
                    throw a;
                  }
                }), a = {}, r(function() {
                  throw 42;
                }, null, A);
              } catch (IA) {
                IA !== a && (r = null);
              }
            else
              r = null;
            var d = /^\s*class\b/, x = function(k) {
              try {
                var tA = B.call(k);
                return d.test(tA);
              } catch {
                return !1;
              }
            }, U = function(k) {
              try {
                return x(k) ? !1 : (B.call(k), !0);
              } catch {
                return !1;
              }
            }, P = Object.prototype.toString, D = "[object Object]", J = "[object Function]", q = "[object GeneratorFunction]", AA = "[object HTMLAllCollection]", K = "[object HTML document.all class]", z = "[object HTMLCollection]", T = typeof Symbol == "function" && !!Symbol.toStringTag, H = !(0 in [,]), eA = function() {
              return !1;
            };
            if (typeof document == "object") {
              var CA = document.all;
              P.call(CA) === P.call(document.all) && (eA = function(k) {
                if ((H || !k) && (typeof k > "u" || typeof k == "object"))
                  try {
                    var tA = P.call(k);
                    return (tA === AA || tA === K || tA === z || tA === D) && k("") == null;
                  } catch {
                  }
                return !1;
              });
            }
            Q.exports = r ? function(k) {
              if (eA(k))
                return !0;
              if (!k || typeof k != "function" && typeof k != "object")
                return !1;
              try {
                r(k, null, A);
              } catch (tA) {
                if (tA !== a)
                  return !1;
              }
              return !x(k) && U(k);
            } : function(k) {
              if (eA(k))
                return !0;
              if (!k || typeof k != "function" && typeof k != "object")
                return !1;
              if (T)
                return U(k);
              if (x(k))
                return !1;
              var tA = P.call(k);
              return tA !== J && tA !== q && !/^\[object HTML/.test(tA) ? !1 : U(k);
            };
          },
          /***/
          4610(Q, B, r) {
            var A = r(2774), a = r(8843), d = a(/^\s*(?:function)?\*/), x = r(6626)(), U = r(7106), P = A("Object.prototype.toString"), D = A("Function.prototype.toString"), J = r(3011);
            Q.exports = function(AA) {
              if (typeof AA != "function")
                return !1;
              if (d(D(AA)))
                return !0;
              if (!x) {
                var K = P(AA);
                return K === "[object GeneratorFunction]";
              }
              if (!U)
                return !1;
              var z = J();
              return z && U(AA) === z.prototype;
            };
          },
          /***/
          2621(Q) {
            Q.exports = function(r) {
              return r !== r;
            };
          },
          /***/
          7051(Q, B, r) {
            var A = r(6601), a = r(5421), d = r(2621), x = r(1320), U = r(5074), P = A(x(), Number);
            a(P, {
              getPolyfill: x,
              implementation: d,
              shim: U
            }), Q.exports = P;
          },
          /***/
          1320(Q, B, r) {
            var A = r(2621);
            Q.exports = function() {
              return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : A;
            };
          },
          /***/
          5074(Q, B, r) {
            var A = r(5421), a = r(1320);
            Q.exports = function() {
              var x = a();
              return A(Number, { isNaN: x }, {
                isNaN: function() {
                  return Number.isNaN !== x;
                }
              }), x;
            };
          },
          /***/
          1689(Q, B, r) {
            var A = r(2774), a = r(6626)(), d = r(5215), x = r(8109), U;
            if (a) {
              var P = A("RegExp.prototype.exec"), D = {}, J = function() {
                throw D;
              }, q = {
                toString: J,
                valueOf: J
              };
              typeof Symbol.toPrimitive == "symbol" && (q[Symbol.toPrimitive] = J), U = function(T) {
                if (!T || typeof T != "object")
                  return !1;
                var H = (
                  /** @type {NonNullable<typeof gOPD>} */
                  x(
                    /** @type {{ lastIndex?: unknown }} */
                    T,
                    "lastIndex"
                  )
                ), eA = H && d(H, "value");
                if (!eA)
                  return !1;
                try {
                  P(
                    T,
                    /** @type {string} */
                    /** @type {unknown} */
                    q
                  );
                } catch (CA) {
                  return CA === D;
                }
              };
            } else {
              var AA = A("Object.prototype.toString"), K = "[object RegExp]";
              U = function(T) {
                return !T || typeof T != "object" && typeof T != "function" ? !1 : AA(T) === K;
              };
            }
            Q.exports = U;
          },
          /***/
          6094(Q, B, r) {
            var A = r(3381);
            Q.exports = function(d) {
              return !!A(d);
            };
          },
          /***/
          1632(Q, B, r) {
            var A = r(9964), a;
            /**
            * [js-md5]{@link https://github.com/emn178/js-md5}
            *
            * @namespace md5
            * @version 0.8.3
            * @author Chen, Yi-Cyuan [emn178@gmail.com]
            * @copyright Chen, Yi-Cyuan 2014-2023
            * @license MIT
            */
            (function() {
              var d = "input is invalid type", x = "finalize already called", U = typeof window == "object", P = U ? window : {};
              P.JS_MD5_NO_WINDOW && (U = !1);
              var D = !U && typeof self == "object", J = !P.JS_MD5_NO_NODE_JS && typeof A == "object" && A.versions && A.versions.node;
              J ? P = r.g : D && (P = self);
              var q = !P.JS_MD5_NO_COMMON_JS && !0 && Q.exports, AA = r.amdO, K = !P.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", z = "0123456789abcdef".split(""), T = [128, 32768, 8388608, -2147483648], H = [0, 8, 16, 24], eA = ["hex", "array", "digest", "buffer", "arrayBuffer", "base64"], CA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), IA = [], k;
              if (K) {
                var tA = new ArrayBuffer(68);
                k = new Uint8Array(tA), IA = new Uint32Array(tA);
              }
              var lA = Array.isArray;
              (P.JS_MD5_NO_NODE_JS || !lA) && (lA = function(EA) {
                return Object.prototype.toString.call(EA) === "[object Array]";
              });
              var uA = ArrayBuffer.isView;
              K && (P.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !uA) && (uA = function(EA) {
                return typeof EA == "object" && EA.buffer && EA.buffer.constructor === ArrayBuffer;
              });
              var w = function(EA) {
                var zA = typeof EA;
                if (zA === "string")
                  return [EA, !0];
                if (zA !== "object" || EA === null)
                  throw new Error(d);
                if (K && EA.constructor === ArrayBuffer)
                  return [new Uint8Array(EA), !1];
                if (!lA(EA) && !uA(EA))
                  throw new Error(d);
                return [EA, !1];
              }, v = function(EA) {
                return function(zA) {
                  return new $A(!0).update(zA)[EA]();
                };
              }, RA = function() {
                var EA = v("hex");
                J && (EA = DA(EA)), EA.create = function() {
                  return new $A();
                }, EA.update = function(xA) {
                  return EA.create().update(xA);
                };
                for (var zA = 0; zA < eA.length; ++zA) {
                  var OA = eA[zA];
                  EA[OA] = v(OA);
                }
                return EA;
              }, DA = function(EA) {
                var zA = r(8535), OA = r(6274).Buffer, xA;
                OA.from && !P.JS_MD5_NO_BUFFER_FROM ? xA = OA.from : xA = function(yA) {
                  return new OA(yA);
                };
                var LA = function(yA) {
                  if (typeof yA == "string")
                    return zA.createHash("md5").update(yA, "utf8").digest("hex");
                  if (yA == null)
                    throw new Error(d);
                  return yA.constructor === ArrayBuffer && (yA = new Uint8Array(yA)), lA(yA) || uA(yA) || yA.constructor === OA ? zA.createHash("md5").update(xA(yA)).digest("hex") : EA(yA);
                };
                return LA;
              }, $ = function(EA) {
                return function(zA, OA) {
                  return new kA(zA, !0).update(OA)[EA]();
                };
              }, cA = function() {
                var EA = $("hex");
                EA.create = function(xA) {
                  return new kA(xA);
                }, EA.update = function(xA, LA) {
                  return EA.create(xA).update(LA);
                };
                for (var zA = 0; zA < eA.length; ++zA) {
                  var OA = eA[zA];
                  EA[OA] = $(OA);
                }
                return EA;
              };
              function $A(EA) {
                if (EA)
                  IA[0] = IA[16] = IA[1] = IA[2] = IA[3] = IA[4] = IA[5] = IA[6] = IA[7] = IA[8] = IA[9] = IA[10] = IA[11] = IA[12] = IA[13] = IA[14] = IA[15] = 0, this.blocks = IA, this.buffer8 = k;
                else if (K) {
                  var zA = new ArrayBuffer(68);
                  this.buffer8 = new Uint8Array(zA), this.blocks = new Uint32Array(zA);
                } else
                  this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
              }
              $A.prototype.update = function(EA) {
                if (this.finalized)
                  throw new Error(x);
                var zA = w(EA);
                EA = zA[0];
                for (var OA = zA[1], xA, LA = 0, yA, TA = EA.length, fA = this.blocks, sA = this.buffer8; LA < TA; ) {
                  if (this.hashed && (this.hashed = !1, fA[0] = fA[16], fA[16] = fA[1] = fA[2] = fA[3] = fA[4] = fA[5] = fA[6] = fA[7] = fA[8] = fA[9] = fA[10] = fA[11] = fA[12] = fA[13] = fA[14] = fA[15] = 0), OA)
                    if (K)
                      for (yA = this.start; LA < TA && yA < 64; ++LA)
                        xA = EA.charCodeAt(LA), xA < 128 ? sA[yA++] = xA : xA < 2048 ? (sA[yA++] = 192 | xA >>> 6, sA[yA++] = 128 | xA & 63) : xA < 55296 || xA >= 57344 ? (sA[yA++] = 224 | xA >>> 12, sA[yA++] = 128 | xA >>> 6 & 63, sA[yA++] = 128 | xA & 63) : (xA = 65536 + ((xA & 1023) << 10 | EA.charCodeAt(++LA) & 1023), sA[yA++] = 240 | xA >>> 18, sA[yA++] = 128 | xA >>> 12 & 63, sA[yA++] = 128 | xA >>> 6 & 63, sA[yA++] = 128 | xA & 63);
                    else
                      for (yA = this.start; LA < TA && yA < 64; ++LA)
                        xA = EA.charCodeAt(LA), xA < 128 ? fA[yA >>> 2] |= xA << H[yA++ & 3] : xA < 2048 ? (fA[yA >>> 2] |= (192 | xA >>> 6) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA & 63) << H[yA++ & 3]) : xA < 55296 || xA >= 57344 ? (fA[yA >>> 2] |= (224 | xA >>> 12) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA >>> 6 & 63) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA & 63) << H[yA++ & 3]) : (xA = 65536 + ((xA & 1023) << 10 | EA.charCodeAt(++LA) & 1023), fA[yA >>> 2] |= (240 | xA >>> 18) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA >>> 12 & 63) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA >>> 6 & 63) << H[yA++ & 3], fA[yA >>> 2] |= (128 | xA & 63) << H[yA++ & 3]);
                  else if (K)
                    for (yA = this.start; LA < TA && yA < 64; ++LA)
                      sA[yA++] = EA[LA];
                  else
                    for (yA = this.start; LA < TA && yA < 64; ++LA)
                      fA[yA >>> 2] |= EA[LA] << H[yA++ & 3];
                  this.lastByteIndex = yA, this.bytes += yA - this.start, yA >= 64 ? (this.start = yA - 64, this.hash(), this.hashed = !0) : this.start = yA;
                }
                return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
              }, $A.prototype.finalize = function() {
                if (!this.finalized) {
                  this.finalized = !0;
                  var EA = this.blocks, zA = this.lastByteIndex;
                  EA[zA >>> 2] |= T[zA & 3], zA >= 56 && (this.hashed || this.hash(), EA[0] = EA[16], EA[16] = EA[1] = EA[2] = EA[3] = EA[4] = EA[5] = EA[6] = EA[7] = EA[8] = EA[9] = EA[10] = EA[11] = EA[12] = EA[13] = EA[14] = EA[15] = 0), EA[14] = this.bytes << 3, EA[15] = this.hBytes << 3 | this.bytes >>> 29, this.hash();
                }
              }, $A.prototype.hash = function() {
                var EA, zA, OA, xA, LA, yA, TA = this.blocks;
                this.first ? (EA = TA[0] - 680876937, EA = (EA << 7 | EA >>> 25) - 271733879 << 0, xA = (-1732584194 ^ EA & 2004318071) + TA[1] - 117830708, xA = (xA << 12 | xA >>> 20) + EA << 0, OA = (-271733879 ^ xA & (EA ^ -271733879)) + TA[2] - 1126478375, OA = (OA << 17 | OA >>> 15) + xA << 0, zA = (EA ^ OA & (xA ^ EA)) + TA[3] - 1316259209, zA = (zA << 22 | zA >>> 10) + OA << 0) : (EA = this.h0, zA = this.h1, OA = this.h2, xA = this.h3, EA += (xA ^ zA & (OA ^ xA)) + TA[0] - 680876936, EA = (EA << 7 | EA >>> 25) + zA << 0, xA += (OA ^ EA & (zA ^ OA)) + TA[1] - 389564586, xA = (xA << 12 | xA >>> 20) + EA << 0, OA += (zA ^ xA & (EA ^ zA)) + TA[2] + 606105819, OA = (OA << 17 | OA >>> 15) + xA << 0, zA += (EA ^ OA & (xA ^ EA)) + TA[3] - 1044525330, zA = (zA << 22 | zA >>> 10) + OA << 0), EA += (xA ^ zA & (OA ^ xA)) + TA[4] - 176418897, EA = (EA << 7 | EA >>> 25) + zA << 0, xA += (OA ^ EA & (zA ^ OA)) + TA[5] + 1200080426, xA = (xA << 12 | xA >>> 20) + EA << 0, OA += (zA ^ xA & (EA ^ zA)) + TA[6] - 1473231341, OA = (OA << 17 | OA >>> 15) + xA << 0, zA += (EA ^ OA & (xA ^ EA)) + TA[7] - 45705983, zA = (zA << 22 | zA >>> 10) + OA << 0, EA += (xA ^ zA & (OA ^ xA)) + TA[8] + 1770035416, EA = (EA << 7 | EA >>> 25) + zA << 0, xA += (OA ^ EA & (zA ^ OA)) + TA[9] - 1958414417, xA = (xA << 12 | xA >>> 20) + EA << 0, OA += (zA ^ xA & (EA ^ zA)) + TA[10] - 42063, OA = (OA << 17 | OA >>> 15) + xA << 0, zA += (EA ^ OA & (xA ^ EA)) + TA[11] - 1990404162, zA = (zA << 22 | zA >>> 10) + OA << 0, EA += (xA ^ zA & (OA ^ xA)) + TA[12] + 1804603682, EA = (EA << 7 | EA >>> 25) + zA << 0, xA += (OA ^ EA & (zA ^ OA)) + TA[13] - 40341101, xA = (xA << 12 | xA >>> 20) + EA << 0, OA += (zA ^ xA & (EA ^ zA)) + TA[14] - 1502002290, OA = (OA << 17 | OA >>> 15) + xA << 0, zA += (EA ^ OA & (xA ^ EA)) + TA[15] + 1236535329, zA = (zA << 22 | zA >>> 10) + OA << 0, EA += (OA ^ xA & (zA ^ OA)) + TA[1] - 165796510, EA = (EA << 5 | EA >>> 27) + zA << 0, xA += (zA ^ OA & (EA ^ zA)) + TA[6] - 1069501632, xA = (xA << 9 | xA >>> 23) + EA << 0, OA += (EA ^ zA & (xA ^ EA)) + TA[11] + 643717713, OA = (OA << 14 | OA >>> 18) + xA << 0, zA += (xA ^ EA & (OA ^ xA)) + TA[0] - 373897302, zA = (zA << 20 | zA >>> 12) + OA << 0, EA += (OA ^ xA & (zA ^ OA)) + TA[5] - 701558691, EA = (EA << 5 | EA >>> 27) + zA << 0, xA += (zA ^ OA & (EA ^ zA)) + TA[10] + 38016083, xA = (xA << 9 | xA >>> 23) + EA << 0, OA += (EA ^ zA & (xA ^ EA)) + TA[15] - 660478335, OA = (OA << 14 | OA >>> 18) + xA << 0, zA += (xA ^ EA & (OA ^ xA)) + TA[4] - 405537848, zA = (zA << 20 | zA >>> 12) + OA << 0, EA += (OA ^ xA & (zA ^ OA)) + TA[9] + 568446438, EA = (EA << 5 | EA >>> 27) + zA << 0, xA += (zA ^ OA & (EA ^ zA)) + TA[14] - 1019803690, xA = (xA << 9 | xA >>> 23) + EA << 0, OA += (EA ^ zA & (xA ^ EA)) + TA[3] - 187363961, OA = (OA << 14 | OA >>> 18) + xA << 0, zA += (xA ^ EA & (OA ^ xA)) + TA[8] + 1163531501, zA = (zA << 20 | zA >>> 12) + OA << 0, EA += (OA ^ xA & (zA ^ OA)) + TA[13] - 1444681467, EA = (EA << 5 | EA >>> 27) + zA << 0, xA += (zA ^ OA & (EA ^ zA)) + TA[2] - 51403784, xA = (xA << 9 | xA >>> 23) + EA << 0, OA += (EA ^ zA & (xA ^ EA)) + TA[7] + 1735328473, OA = (OA << 14 | OA >>> 18) + xA << 0, zA += (xA ^ EA & (OA ^ xA)) + TA[12] - 1926607734, zA = (zA << 20 | zA >>> 12) + OA << 0, LA = zA ^ OA, EA += (LA ^ xA) + TA[5] - 378558, EA = (EA << 4 | EA >>> 28) + zA << 0, xA += (LA ^ EA) + TA[8] - 2022574463, xA = (xA << 11 | xA >>> 21) + EA << 0, yA = xA ^ EA, OA += (yA ^ zA) + TA[11] + 1839030562, OA = (OA << 16 | OA >>> 16) + xA << 0, zA += (yA ^ OA) + TA[14] - 35309556, zA = (zA << 23 | zA >>> 9) + OA << 0, LA = zA ^ OA, EA += (LA ^ xA) + TA[1] - 1530992060, EA = (EA << 4 | EA >>> 28) + zA << 0, xA += (LA ^ EA) + TA[4] + 1272893353, xA = (xA << 11 | xA >>> 21) + EA << 0, yA = xA ^ EA, OA += (yA ^ zA) + TA[7] - 155497632, OA = (OA << 16 | OA >>> 16) + xA << 0, zA += (yA ^ OA) + TA[10] - 1094730640, zA = (zA << 23 | zA >>> 9) + OA << 0, LA = zA ^ OA, EA += (LA ^ xA) + TA[13] + 681279174, EA = (EA << 4 | EA >>> 28) + zA << 0, xA += (LA ^ EA) + TA[0] - 358537222, xA = (xA << 11 | xA >>> 21) + EA << 0, yA = xA ^ EA, OA += (yA ^ zA) + TA[3] - 722521979, OA = (OA << 16 | OA >>> 16) + xA << 0, zA += (yA ^ OA) + TA[6] + 76029189, zA = (zA << 23 | zA >>> 9) + OA << 0, LA = zA ^ OA, EA += (LA ^ xA) + TA[9] - 640364487, EA = (EA << 4 | EA >>> 28) + zA << 0, xA += (LA ^ EA) + TA[12] - 421815835, xA = (xA << 11 | xA >>> 21) + EA << 0, yA = xA ^ EA, OA += (yA ^ zA) + TA[15] + 530742520, OA = (OA << 16 | OA >>> 16) + xA << 0, zA += (yA ^ OA) + TA[2] - 995338651, zA = (zA << 23 | zA >>> 9) + OA << 0, EA += (OA ^ (zA | ~xA)) + TA[0] - 198630844, EA = (EA << 6 | EA >>> 26) + zA << 0, xA += (zA ^ (EA | ~OA)) + TA[7] + 1126891415, xA = (xA << 10 | xA >>> 22) + EA << 0, OA += (EA ^ (xA | ~zA)) + TA[14] - 1416354905, OA = (OA << 15 | OA >>> 17) + xA << 0, zA += (xA ^ (OA | ~EA)) + TA[5] - 57434055, zA = (zA << 21 | zA >>> 11) + OA << 0, EA += (OA ^ (zA | ~xA)) + TA[12] + 1700485571, EA = (EA << 6 | EA >>> 26) + zA << 0, xA += (zA ^ (EA | ~OA)) + TA[3] - 1894986606, xA = (xA << 10 | xA >>> 22) + EA << 0, OA += (EA ^ (xA | ~zA)) + TA[10] - 1051523, OA = (OA << 15 | OA >>> 17) + xA << 0, zA += (xA ^ (OA | ~EA)) + TA[1] - 2054922799, zA = (zA << 21 | zA >>> 11) + OA << 0, EA += (OA ^ (zA | ~xA)) + TA[8] + 1873313359, EA = (EA << 6 | EA >>> 26) + zA << 0, xA += (zA ^ (EA | ~OA)) + TA[15] - 30611744, xA = (xA << 10 | xA >>> 22) + EA << 0, OA += (EA ^ (xA | ~zA)) + TA[6] - 1560198380, OA = (OA << 15 | OA >>> 17) + xA << 0, zA += (xA ^ (OA | ~EA)) + TA[13] + 1309151649, zA = (zA << 21 | zA >>> 11) + OA << 0, EA += (OA ^ (zA | ~xA)) + TA[4] - 145523070, EA = (EA << 6 | EA >>> 26) + zA << 0, xA += (zA ^ (EA | ~OA)) + TA[11] - 1120210379, xA = (xA << 10 | xA >>> 22) + EA << 0, OA += (EA ^ (xA | ~zA)) + TA[2] + 718787259, OA = (OA << 15 | OA >>> 17) + xA << 0, zA += (xA ^ (OA | ~EA)) + TA[9] - 343485551, zA = (zA << 21 | zA >>> 11) + OA << 0, this.first ? (this.h0 = EA + 1732584193 << 0, this.h1 = zA - 271733879 << 0, this.h2 = OA - 1732584194 << 0, this.h3 = xA + 271733878 << 0, this.first = !1) : (this.h0 = this.h0 + EA << 0, this.h1 = this.h1 + zA << 0, this.h2 = this.h2 + OA << 0, this.h3 = this.h3 + xA << 0);
              }, $A.prototype.hex = function() {
                this.finalize();
                var EA = this.h0, zA = this.h1, OA = this.h2, xA = this.h3;
                return z[EA >>> 4 & 15] + z[EA & 15] + z[EA >>> 12 & 15] + z[EA >>> 8 & 15] + z[EA >>> 20 & 15] + z[EA >>> 16 & 15] + z[EA >>> 28 & 15] + z[EA >>> 24 & 15] + z[zA >>> 4 & 15] + z[zA & 15] + z[zA >>> 12 & 15] + z[zA >>> 8 & 15] + z[zA >>> 20 & 15] + z[zA >>> 16 & 15] + z[zA >>> 28 & 15] + z[zA >>> 24 & 15] + z[OA >>> 4 & 15] + z[OA & 15] + z[OA >>> 12 & 15] + z[OA >>> 8 & 15] + z[OA >>> 20 & 15] + z[OA >>> 16 & 15] + z[OA >>> 28 & 15] + z[OA >>> 24 & 15] + z[xA >>> 4 & 15] + z[xA & 15] + z[xA >>> 12 & 15] + z[xA >>> 8 & 15] + z[xA >>> 20 & 15] + z[xA >>> 16 & 15] + z[xA >>> 28 & 15] + z[xA >>> 24 & 15];
              }, $A.prototype.toString = $A.prototype.hex, $A.prototype.digest = function() {
                this.finalize();
                var EA = this.h0, zA = this.h1, OA = this.h2, xA = this.h3;
                return [
                  EA & 255,
                  EA >>> 8 & 255,
                  EA >>> 16 & 255,
                  EA >>> 24 & 255,
                  zA & 255,
                  zA >>> 8 & 255,
                  zA >>> 16 & 255,
                  zA >>> 24 & 255,
                  OA & 255,
                  OA >>> 8 & 255,
                  OA >>> 16 & 255,
                  OA >>> 24 & 255,
                  xA & 255,
                  xA >>> 8 & 255,
                  xA >>> 16 & 255,
                  xA >>> 24 & 255
                ];
              }, $A.prototype.array = $A.prototype.digest, $A.prototype.arrayBuffer = function() {
                this.finalize();
                var EA = new ArrayBuffer(16), zA = new Uint32Array(EA);
                return zA[0] = this.h0, zA[1] = this.h1, zA[2] = this.h2, zA[3] = this.h3, EA;
              }, $A.prototype.buffer = $A.prototype.arrayBuffer, $A.prototype.base64 = function() {
                for (var EA, zA, OA, xA = "", LA = this.array(), yA = 0; yA < 15; )
                  EA = LA[yA++], zA = LA[yA++], OA = LA[yA++], xA += CA[EA >>> 2] + CA[(EA << 4 | zA >>> 4) & 63] + CA[(zA << 2 | OA >>> 6) & 63] + CA[OA & 63];
                return EA = LA[yA], xA += CA[EA >>> 2] + CA[EA << 4 & 63] + "==", xA;
              };
              function kA(EA, zA) {
                var OA, xA = w(EA);
                if (EA = xA[0], xA[1]) {
                  var LA = [], yA = EA.length, TA = 0, fA;
                  for (OA = 0; OA < yA; ++OA)
                    fA = EA.charCodeAt(OA), fA < 128 ? LA[TA++] = fA : fA < 2048 ? (LA[TA++] = 192 | fA >>> 6, LA[TA++] = 128 | fA & 63) : fA < 55296 || fA >= 57344 ? (LA[TA++] = 224 | fA >>> 12, LA[TA++] = 128 | fA >>> 6 & 63, LA[TA++] = 128 | fA & 63) : (fA = 65536 + ((fA & 1023) << 10 | EA.charCodeAt(++OA) & 1023), LA[TA++] = 240 | fA >>> 18, LA[TA++] = 128 | fA >>> 12 & 63, LA[TA++] = 128 | fA >>> 6 & 63, LA[TA++] = 128 | fA & 63);
                  EA = LA;
                }
                EA.length > 64 && (EA = new $A(!0).update(EA).array());
                var sA = [], F = [];
                for (OA = 0; OA < 64; ++OA) {
                  var o = EA[OA] || 0;
                  sA[OA] = 92 ^ o, F[OA] = 54 ^ o;
                }
                $A.call(this, zA), this.update(F), this.oKeyPad = sA, this.inner = !0, this.sharedMemory = zA;
              }
              kA.prototype = new $A(), kA.prototype.finalize = function() {
                if ($A.prototype.finalize.call(this), this.inner) {
                  this.inner = !1;
                  var EA = this.array();
                  $A.call(this, this.sharedMemory), this.update(this.oKeyPad), this.update(EA), $A.prototype.finalize.call(this);
                }
              };
              var WA = RA();
              WA.md5 = WA, WA.md5.hmac = cA(), q ? Q.exports = WA : (P.md5 = WA, AA && (a = (function() {
                return WA;
              }).call(WA, r, WA, Q), a !== void 0 && (Q.exports = a)));
            })();
          },
          /***/
          716(Q) {
            Q.exports = Math.abs;
          },
          /***/
          7450(Q) {
            Q.exports = Math.floor;
          },
          /***/
          713(Q) {
            Q.exports = Number.isNaN || function(r) {
              return r !== r;
            };
          },
          /***/
          3774(Q) {
            Q.exports = Math.max;
          },
          /***/
          7552(Q) {
            Q.exports = Math.min;
          },
          /***/
          5874(Q) {
            Q.exports = Math.pow;
          },
          /***/
          9292(Q) {
            Q.exports = Math.round;
          },
          /***/
          6071(Q, B, r) {
            var A = r(713);
            Q.exports = function(d) {
              return A(d) || d === 0 ? d : d < 0 ? -1 : 1;
            };
          },
          /***/
          3249(Q) {
            var B = function(r) {
              return r !== r;
            };
            Q.exports = function(A, a) {
              return A === 0 && a === 0 ? 1 / A === 1 / a : !!(A === a || B(A) && B(a));
            };
          },
          /***/
          8527(Q, B, r) {
            var A = r(5421), a = r(6601), d = r(3249), x = r(9636), U = r(3534), P = a(x(), Object);
            A(P, {
              getPolyfill: x,
              implementation: d,
              shim: U
            }), Q.exports = P;
          },
          /***/
          9636(Q, B, r) {
            var A = r(3249);
            Q.exports = function() {
              return typeof Object.is == "function" ? Object.is : A;
            };
          },
          /***/
          3534(Q, B, r) {
            var A = r(9636), a = r(5421);
            Q.exports = function() {
              var x = A();
              return a(Object, { is: x }, {
                is: function() {
                  return Object.is !== x;
                }
              }), x;
            };
          },
          /***/
          8461(Q, B, r) {
            var A;
            if (!Object.keys) {
              var a = Object.prototype.hasOwnProperty, d = Object.prototype.toString, x = r(6515), U = Object.prototype.propertyIsEnumerable, P = !U.call({ toString: null }, "toString"), D = U.call(function() {
              }, "prototype"), J = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
              ], q = function(T) {
                var H = T.constructor;
                return H && H.prototype === T;
              }, AA = {
                $applicationCache: !0,
                $console: !0,
                $external: !0,
                $frame: !0,
                $frameElement: !0,
                $frames: !0,
                $innerHeight: !0,
                $innerWidth: !0,
                $onmozfullscreenchange: !0,
                $onmozfullscreenerror: !0,
                $outerHeight: !0,
                $outerWidth: !0,
                $pageXOffset: !0,
                $pageYOffset: !0,
                $parent: !0,
                $scrollLeft: !0,
                $scrollTop: !0,
                $scrollX: !0,
                $scrollY: !0,
                $self: !0,
                $webkitIndexedDB: !0,
                $webkitStorageInfo: !0,
                $window: !0
              }, K = (function() {
                if (typeof window > "u")
                  return !1;
                for (var T in window)
                  try {
                    if (!AA["$" + T] && a.call(window, T) && window[T] !== null && typeof window[T] == "object")
                      try {
                        q(window[T]);
                      } catch {
                        return !0;
                      }
                  } catch {
                    return !0;
                  }
                return !1;
              })(), z = function(T) {
                if (typeof window > "u" || !K)
                  return q(T);
                try {
                  return q(T);
                } catch {
                  return !1;
                }
              };
              A = function(H) {
                var eA = H !== null && typeof H == "object", CA = d.call(H) === "[object Function]", IA = x(H), k = eA && d.call(H) === "[object String]", tA = [];
                if (!eA && !CA && !IA)
                  throw new TypeError("Object.keys called on a non-object");
                var lA = D && CA;
                if (k && H.length > 0 && !a.call(H, 0))
                  for (var uA = 0; uA < H.length; ++uA)
                    tA.push(String(uA));
                if (IA && H.length > 0)
                  for (var w = 0; w < H.length; ++w)
                    tA.push(String(w));
                else
                  for (var v in H)
                    !(lA && v === "prototype") && a.call(H, v) && tA.push(String(v));
                if (P)
                  for (var RA = z(H), DA = 0; DA < J.length; ++DA)
                    !(RA && J[DA] === "constructor") && a.call(H, J[DA]) && tA.push(J[DA]);
                return tA;
              };
            }
            Q.exports = A;
          },
          /***/
          5643(Q, B, r) {
            var A = Array.prototype.slice, a = r(6515), d = Object.keys, x = d ? function(D) {
              return d(D);
            } : r(8461), U = Object.keys;
            x.shim = function() {
              if (Object.keys) {
                var D = (function() {
                  var J = Object.keys(arguments);
                  return J && J.length === arguments.length;
                })(1, 2);
                D || (Object.keys = function(q) {
                  return a(q) ? U(A.call(q)) : U(q);
                });
              } else
                Object.keys = x;
              return Object.keys || x;
            }, Q.exports = x;
          },
          /***/
          6515(Q) {
            var B = Object.prototype.toString;
            Q.exports = function(A) {
              var a = B.call(A), d = a === "[object Arguments]";
              return d || (d = a !== "[object Array]" && A !== null && typeof A == "object" && typeof A.length == "number" && A.length >= 0 && B.call(A.callee) === "[object Function]"), d;
            };
          },
          /***/
          6521(Q, B, r) {
            var A = r(5643), a = r(2843)(), d = r(2774), x = r(5846), U = d("Array.prototype.push"), P = d("Object.prototype.propertyIsEnumerable"), D = a ? x.getOwnPropertySymbols : null;
            Q.exports = function(q, AA) {
              if (q == null)
                throw new TypeError("target must be an object");
              var K = x(q);
              if (arguments.length === 1)
                return K;
              for (var z = 1; z < arguments.length; ++z) {
                var T = x(arguments[z]), H = A(T), eA = a && (x.getOwnPropertySymbols || D);
                if (eA)
                  for (var CA = eA(T), IA = 0; IA < CA.length; ++IA) {
                    var k = CA[IA];
                    P(T, k) && U(H, k);
                  }
                for (var tA = 0; tA < H.length; ++tA) {
                  var lA = H[tA];
                  if (P(T, lA)) {
                    var uA = T[lA];
                    K[lA] = uA;
                  }
                }
              }
              return K;
            };
          },
          /***/
          7596(Q, B, r) {
            var A = r(6521), a = function() {
              if (!Object.assign)
                return !1;
              for (var x = "abcdefghijklmnopqrst", U = x.split(""), P = {}, D = 0; D < U.length; ++D)
                P[U[D]] = U[D];
              var J = Object.assign({}, P), q = "";
              for (var AA in J)
                q += AA;
              return x !== q;
            }, d = function() {
              if (!Object.assign || !Object.preventExtensions)
                return !1;
              var x = Object.preventExtensions({ 1: 2 });
              try {
                Object.assign(x, "xy");
              } catch {
                return x[1] === "y";
              }
              return !1;
            };
            Q.exports = function() {
              return !Object.assign || a() || d() ? A : Object.assign;
            };
          },
          /***/
          2519(Q, B) {
            var r = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
            function A(x, U) {
              return Object.prototype.hasOwnProperty.call(x, U);
            }
            B.assign = function(x) {
              for (var U = Array.prototype.slice.call(arguments, 1); U.length; ) {
                var P = U.shift();
                if (P) {
                  if (typeof P != "object")
                    throw new TypeError(P + "must be non-object");
                  for (var D in P)
                    A(P, D) && (x[D] = P[D]);
                }
              }
              return x;
            }, B.shrinkBuf = function(x, U) {
              return x.length === U ? x : x.subarray ? x.subarray(0, U) : (x.length = U, x);
            };
            var a = {
              arraySet: function(x, U, P, D, J) {
                if (U.subarray && x.subarray) {
                  x.set(U.subarray(P, P + D), J);
                  return;
                }
                for (var q = 0; q < D; q++)
                  x[J + q] = U[P + q];
              },
              // Join array of chunks to single array.
              flattenChunks: function(x) {
                var U, P, D, J, q, AA;
                for (D = 0, U = 0, P = x.length; U < P; U++)
                  D += x[U].length;
                for (AA = new Uint8Array(D), J = 0, U = 0, P = x.length; U < P; U++)
                  q = x[U], AA.set(q, J), J += q.length;
                return AA;
              }
            }, d = {
              arraySet: function(x, U, P, D, J) {
                for (var q = 0; q < D; q++)
                  x[J + q] = U[P + q];
              },
              // Join array of chunks to single array.
              flattenChunks: function(x) {
                return [].concat.apply([], x);
              }
            };
            B.setTyped = function(x) {
              x ? (B.Buf8 = Uint8Array, B.Buf16 = Uint16Array, B.Buf32 = Int32Array, B.assign(B, a)) : (B.Buf8 = Array, B.Buf16 = Array, B.Buf32 = Array, B.assign(B, d));
            }, B.setTyped(r);
          },
          /***/
          6911(Q) {
            function B(r, A, a, d) {
              for (var x = r & 65535 | 0, U = r >>> 16 & 65535 | 0, P = 0; a !== 0; ) {
                P = a > 2e3 ? 2e3 : a, a -= P;
                do
                  x = x + A[d++] | 0, U = U + x | 0;
                while (--P);
                x %= 65521, U %= 65521;
              }
              return x | U << 16 | 0;
            }
            Q.exports = B;
          },
          /***/
          1607(Q) {
            Q.exports = {
              /* Allowed flush values; see deflate() and inflate() below for details */
              Z_NO_FLUSH: 0,
              Z_PARTIAL_FLUSH: 1,
              Z_SYNC_FLUSH: 2,
              Z_FULL_FLUSH: 3,
              Z_FINISH: 4,
              Z_BLOCK: 5,
              Z_TREES: 6,
              /* Return codes for the compression/decompression functions. Negative values
              * are errors, positive values are used for special but normal events.
              */
              Z_OK: 0,
              Z_STREAM_END: 1,
              Z_NEED_DICT: 2,
              Z_ERRNO: -1,
              Z_STREAM_ERROR: -2,
              Z_DATA_ERROR: -3,
              //Z_MEM_ERROR:     -4,
              Z_BUF_ERROR: -5,
              //Z_VERSION_ERROR: -6,
              /* compression levels */
              Z_NO_COMPRESSION: 0,
              Z_BEST_SPEED: 1,
              Z_BEST_COMPRESSION: 9,
              Z_DEFAULT_COMPRESSION: -1,
              Z_FILTERED: 1,
              Z_HUFFMAN_ONLY: 2,
              Z_RLE: 3,
              Z_FIXED: 4,
              Z_DEFAULT_STRATEGY: 0,
              /* Possible values of the data_type field (though see inflate()) */
              Z_BINARY: 0,
              Z_TEXT: 1,
              //Z_ASCII:                1, // = Z_TEXT (deprecated)
              Z_UNKNOWN: 2,
              /* The deflate compression method */
              Z_DEFLATED: 8
              //Z_NULL:                 null // Use -1 or null inline, depending on var type
            };
          },
          /***/
          9049(Q) {
            function B() {
              for (var a, d = [], x = 0; x < 256; x++) {
                a = x;
                for (var U = 0; U < 8; U++)
                  a = a & 1 ? 3988292384 ^ a >>> 1 : a >>> 1;
                d[x] = a;
              }
              return d;
            }
            var r = B();
            function A(a, d, x, U) {
              var P = r, D = U + x;
              a ^= -1;
              for (var J = U; J < D; J++)
                a = a >>> 8 ^ P[(a ^ d[J]) & 255];
              return a ^ -1;
            }
            Q.exports = A;
          },
          /***/
          2925(Q, B, r) {
            var A = r(2519), a = r(2367), d = r(6911), x = r(9049), U = r(6228), P = 0, D = 1, J = 3, q = 4, AA = 5, K = 0, z = 1, T = -2, H = -3, eA = -5, CA = -1, IA = 1, k = 2, tA = 3, lA = 4, uA = 0, w = 2, v = 8, RA = 9, DA = 15, $ = 8, cA = 29, $A = 256, kA = $A + 1 + cA, WA = 30, EA = 19, zA = 2 * kA + 1, OA = 15, xA = 3, LA = 258, yA = LA + xA + 1, TA = 32, fA = 42, sA = 69, F = 73, o = 91, h = 103, _ = 113, oA = 666, p = 1, rA = 2, QA = 3, bA = 4, y = 3;
            function M(V, me) {
              return V.msg = U[me], me;
            }
            function FA(V) {
              return (V << 1) - (V > 4 ? 9 : 0);
            }
            function dA(V) {
              for (var me = V.length; --me >= 0; )
                V[me] = 0;
            }
            function he(V) {
              var me = V.state, Ye = me.pending;
              Ye > V.avail_out && (Ye = V.avail_out), Ye !== 0 && (A.arraySet(V.output, me.pending_buf, me.pending_out, Ye, V.next_out), V.next_out += Ye, me.pending_out += Ye, V.total_out += Ye, V.avail_out -= Ye, me.pending -= Ye, me.pending === 0 && (me.pending_out = 0));
            }
            function ie(V, me) {
              a._tr_flush_block(V, V.block_start >= 0 ? V.block_start : -1, V.strstart - V.block_start, me), V.block_start = V.strstart, he(V.strm);
            }
            function KA(V, me) {
              V.pending_buf[V.pending++] = me;
            }
            function Pe(V, me) {
              V.pending_buf[V.pending++] = me >>> 8 & 255, V.pending_buf[V.pending++] = me & 255;
            }
            function Je(V, me, Ye, SA) {
              var ue = V.avail_in;
              return ue > SA && (ue = SA), ue === 0 ? 0 : (V.avail_in -= ue, A.arraySet(me, V.input, V.next_in, ue, Ye), V.state.wrap === 1 ? V.adler = d(V.adler, me, ue, Ye) : V.state.wrap === 2 && (V.adler = x(V.adler, me, ue, Ye)), V.next_in += ue, V.total_in += ue, ue);
            }
            function Le(V, me) {
              var Ye = V.max_chain_length, SA = V.strstart, ue, Fe, tt = V.prev_length, We = V.nice_match, Ze = V.strstart > V.w_size - yA ? V.strstart - (V.w_size - yA) : 0, Ct = V.window, fi = V.w_mask, st = V.prev, xt = V.strstart + LA, Mt = Ct[SA + tt - 1], zt = Ct[SA + tt];
              V.prev_length >= V.good_match && (Ye >>= 2), We > V.lookahead && (We = V.lookahead);
              do
                if (ue = me, !(Ct[ue + tt] !== zt || Ct[ue + tt - 1] !== Mt || Ct[ue] !== Ct[SA] || Ct[++ue] !== Ct[SA + 1])) {
                  SA += 2, ue++;
                  do
                    ;
                  while (Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && Ct[++SA] === Ct[++ue] && SA < xt);
                  if (Fe = LA - (xt - SA), SA = xt - LA, Fe > tt) {
                    if (V.match_start = me, tt = Fe, Fe >= We)
                      break;
                    Mt = Ct[SA + tt - 1], zt = Ct[SA + tt];
                  }
                }
              while ((me = st[me & fi]) > Ze && --Ye !== 0);
              return tt <= V.lookahead ? tt : V.lookahead;
            }
            function Re(V) {
              var me = V.w_size, Ye, SA, ue, Fe, tt;
              do {
                if (Fe = V.window_size - V.lookahead - V.strstart, V.strstart >= me + (me - yA)) {
                  A.arraySet(V.window, V.window, me, me, 0), V.match_start -= me, V.strstart -= me, V.block_start -= me, SA = V.hash_size, Ye = SA;
                  do
                    ue = V.head[--Ye], V.head[Ye] = ue >= me ? ue - me : 0;
                  while (--SA);
                  SA = me, Ye = SA;
                  do
                    ue = V.prev[--Ye], V.prev[Ye] = ue >= me ? ue - me : 0;
                  while (--SA);
                  Fe += me;
                }
                if (V.strm.avail_in === 0)
                  break;
                if (SA = Je(V.strm, V.window, V.strstart + V.lookahead, Fe), V.lookahead += SA, V.lookahead + V.insert >= xA)
                  for (tt = V.strstart - V.insert, V.ins_h = V.window[tt], V.ins_h = (V.ins_h << V.hash_shift ^ V.window[tt + 1]) & V.hash_mask; V.insert && (V.ins_h = (V.ins_h << V.hash_shift ^ V.window[tt + xA - 1]) & V.hash_mask, V.prev[tt & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = tt, tt++, V.insert--, !(V.lookahead + V.insert < xA)); )
                    ;
              } while (V.lookahead < yA && V.strm.avail_in !== 0);
            }
            function _e(V, me) {
              var Ye = 65535;
              for (Ye > V.pending_buf_size - 5 && (Ye = V.pending_buf_size - 5); ; ) {
                if (V.lookahead <= 1) {
                  if (Re(V), V.lookahead === 0 && me === P)
                    return p;
                  if (V.lookahead === 0)
                    break;
                }
                V.strstart += V.lookahead, V.lookahead = 0;
                var SA = V.block_start + Ye;
                if ((V.strstart === 0 || V.strstart >= SA) && (V.lookahead = V.strstart - SA, V.strstart = SA, ie(V, !1), V.strm.avail_out === 0) || V.strstart - V.block_start >= V.w_size - yA && (ie(V, !1), V.strm.avail_out === 0))
                  return p;
              }
              return V.insert = 0, me === q ? (ie(V, !0), V.strm.avail_out === 0 ? QA : bA) : (V.strstart > V.block_start && (ie(V, !1), V.strm.avail_out === 0), p);
            }
            function se(V, me) {
              for (var Ye, SA; ; ) {
                if (V.lookahead < yA) {
                  if (Re(V), V.lookahead < yA && me === P)
                    return p;
                  if (V.lookahead === 0)
                    break;
                }
                if (Ye = 0, V.lookahead >= xA && (V.ins_h = (V.ins_h << V.hash_shift ^ V.window[V.strstart + xA - 1]) & V.hash_mask, Ye = V.prev[V.strstart & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = V.strstart), Ye !== 0 && V.strstart - Ye <= V.w_size - yA && (V.match_length = Le(V, Ye)), V.match_length >= xA)
                  if (SA = a._tr_tally(V, V.strstart - V.match_start, V.match_length - xA), V.lookahead -= V.match_length, V.match_length <= V.max_lazy_match && V.lookahead >= xA) {
                    V.match_length--;
                    do
                      V.strstart++, V.ins_h = (V.ins_h << V.hash_shift ^ V.window[V.strstart + xA - 1]) & V.hash_mask, Ye = V.prev[V.strstart & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = V.strstart;
                    while (--V.match_length !== 0);
                    V.strstart++;
                  } else
                    V.strstart += V.match_length, V.match_length = 0, V.ins_h = V.window[V.strstart], V.ins_h = (V.ins_h << V.hash_shift ^ V.window[V.strstart + 1]) & V.hash_mask;
                else
                  SA = a._tr_tally(V, 0, V.window[V.strstart]), V.lookahead--, V.strstart++;
                if (SA && (ie(V, !1), V.strm.avail_out === 0))
                  return p;
              }
              return V.insert = V.strstart < xA - 1 ? V.strstart : xA - 1, me === q ? (ie(V, !0), V.strm.avail_out === 0 ? QA : bA) : V.last_lit && (ie(V, !1), V.strm.avail_out === 0) ? p : rA;
            }
            function Ee(V, me) {
              for (var Ye, SA, ue; ; ) {
                if (V.lookahead < yA) {
                  if (Re(V), V.lookahead < yA && me === P)
                    return p;
                  if (V.lookahead === 0)
                    break;
                }
                if (Ye = 0, V.lookahead >= xA && (V.ins_h = (V.ins_h << V.hash_shift ^ V.window[V.strstart + xA - 1]) & V.hash_mask, Ye = V.prev[V.strstart & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = V.strstart), V.prev_length = V.match_length, V.prev_match = V.match_start, V.match_length = xA - 1, Ye !== 0 && V.prev_length < V.max_lazy_match && V.strstart - Ye <= V.w_size - yA && (V.match_length = Le(V, Ye), V.match_length <= 5 && (V.strategy === IA || V.match_length === xA && V.strstart - V.match_start > 4096) && (V.match_length = xA - 1)), V.prev_length >= xA && V.match_length <= V.prev_length) {
                  ue = V.strstart + V.lookahead - xA, SA = a._tr_tally(V, V.strstart - 1 - V.prev_match, V.prev_length - xA), V.lookahead -= V.prev_length - 1, V.prev_length -= 2;
                  do
                    ++V.strstart <= ue && (V.ins_h = (V.ins_h << V.hash_shift ^ V.window[V.strstart + xA - 1]) & V.hash_mask, Ye = V.prev[V.strstart & V.w_mask] = V.head[V.ins_h], V.head[V.ins_h] = V.strstart);
                  while (--V.prev_length !== 0);
                  if (V.match_available = 0, V.match_length = xA - 1, V.strstart++, SA && (ie(V, !1), V.strm.avail_out === 0))
                    return p;
                } else if (V.match_available) {
                  if (SA = a._tr_tally(V, 0, V.window[V.strstart - 1]), SA && ie(V, !1), V.strstart++, V.lookahead--, V.strm.avail_out === 0)
                    return p;
                } else
                  V.match_available = 1, V.strstart++, V.lookahead--;
              }
              return V.match_available && (SA = a._tr_tally(V, 0, V.window[V.strstart - 1]), V.match_available = 0), V.insert = V.strstart < xA - 1 ? V.strstart : xA - 1, me === q ? (ie(V, !0), V.strm.avail_out === 0 ? QA : bA) : V.last_lit && (ie(V, !1), V.strm.avail_out === 0) ? p : rA;
            }
            function wA(V, me) {
              for (var Ye, SA, ue, Fe, tt = V.window; ; ) {
                if (V.lookahead <= LA) {
                  if (Re(V), V.lookahead <= LA && me === P)
                    return p;
                  if (V.lookahead === 0)
                    break;
                }
                if (V.match_length = 0, V.lookahead >= xA && V.strstart > 0 && (ue = V.strstart - 1, SA = tt[ue], SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue])) {
                  Fe = V.strstart + LA;
                  do
                    ;
                  while (SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && SA === tt[++ue] && ue < Fe);
                  V.match_length = LA - (Fe - ue), V.match_length > V.lookahead && (V.match_length = V.lookahead);
                }
                if (V.match_length >= xA ? (Ye = a._tr_tally(V, 1, V.match_length - xA), V.lookahead -= V.match_length, V.strstart += V.match_length, V.match_length = 0) : (Ye = a._tr_tally(V, 0, V.window[V.strstart]), V.lookahead--, V.strstart++), Ye && (ie(V, !1), V.strm.avail_out === 0))
                  return p;
              }
              return V.insert = 0, me === q ? (ie(V, !0), V.strm.avail_out === 0 ? QA : bA) : V.last_lit && (ie(V, !1), V.strm.avail_out === 0) ? p : rA;
            }
            function N(V, me) {
              for (var Ye; ; ) {
                if (V.lookahead === 0 && (Re(V), V.lookahead === 0)) {
                  if (me === P)
                    return p;
                  break;
                }
                if (V.match_length = 0, Ye = a._tr_tally(V, 0, V.window[V.strstart]), V.lookahead--, V.strstart++, Ye && (ie(V, !1), V.strm.avail_out === 0))
                  return p;
              }
              return V.insert = 0, me === q ? (ie(V, !0), V.strm.avail_out === 0 ? QA : bA) : V.last_lit && (ie(V, !1), V.strm.avail_out === 0) ? p : rA;
            }
            function G(V, me, Ye, SA, ue) {
              this.good_length = V, this.max_lazy = me, this.nice_length = Ye, this.max_chain = SA, this.func = ue;
            }
            var W;
            W = [
              /*      good lazy nice chain */
              new G(0, 0, 0, 0, _e),
              /* 0 store only */
              new G(4, 4, 8, 4, se),
              /* 1 max speed, no lazy matches */
              new G(4, 5, 16, 8, se),
              /* 2 */
              new G(4, 6, 32, 32, se),
              /* 3 */
              new G(4, 4, 16, 16, Ee),
              /* 4 lazy matches */
              new G(8, 16, 32, 32, Ee),
              /* 5 */
              new G(8, 16, 128, 128, Ee),
              /* 6 */
              new G(8, 32, 128, 256, Ee),
              /* 7 */
              new G(32, 128, 258, 1024, Ee),
              /* 8 */
              new G(32, 258, 258, 4096, Ee)
              /* 9 max compression */
            ];
            function aA(V) {
              V.window_size = 2 * V.w_size, dA(V.head), V.max_lazy_match = W[V.level].max_lazy, V.good_match = W[V.level].good_length, V.nice_match = W[V.level].nice_length, V.max_chain_length = W[V.level].max_chain, V.strstart = 0, V.block_start = 0, V.lookahead = 0, V.insert = 0, V.match_length = V.prev_length = xA - 1, V.match_available = 0, V.ins_h = 0;
            }
            function j() {
              this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new A.Buf16(zA * 2), this.dyn_dtree = new A.Buf16((2 * WA + 1) * 2), this.bl_tree = new A.Buf16((2 * EA + 1) * 2), dA(this.dyn_ltree), dA(this.dyn_dtree), dA(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new A.Buf16(OA + 1), this.heap = new A.Buf16(2 * kA + 1), dA(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new A.Buf16(2 * kA + 1), dA(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
            }
            function pA(V) {
              var me;
              return !V || !V.state ? M(V, T) : (V.total_in = V.total_out = 0, V.data_type = w, me = V.state, me.pending = 0, me.pending_out = 0, me.wrap < 0 && (me.wrap = -me.wrap), me.status = me.wrap ? fA : _, V.adler = me.wrap === 2 ? 0 : 1, me.last_flush = P, a._tr_init(me), K);
            }
            function Be(V) {
              var me = pA(V);
              return me === K && aA(V.state), me;
            }
            function Ie(V, me) {
              return !V || !V.state || V.state.wrap !== 2 ? T : (V.state.gzhead = me, K);
            }
            function ee(V, me, Ye, SA, ue, Fe) {
              if (!V)
                return T;
              var tt = 1;
              if (me === CA && (me = 6), SA < 0 ? (tt = 0, SA = -SA) : SA > 15 && (tt = 2, SA -= 16), ue < 1 || ue > RA || Ye !== v || SA < 8 || SA > 15 || me < 0 || me > 9 || Fe < 0 || Fe > lA)
                return M(V, T);
              SA === 8 && (SA = 9);
              var We = new j();
              return V.state = We, We.strm = V, We.wrap = tt, We.gzhead = null, We.w_bits = SA, We.w_size = 1 << We.w_bits, We.w_mask = We.w_size - 1, We.hash_bits = ue + 7, We.hash_size = 1 << We.hash_bits, We.hash_mask = We.hash_size - 1, We.hash_shift = ~~((We.hash_bits + xA - 1) / xA), We.window = new A.Buf8(We.w_size * 2), We.head = new A.Buf16(We.hash_size), We.prev = new A.Buf16(We.w_size), We.lit_bufsize = 1 << ue + 6, We.pending_buf_size = We.lit_bufsize * 4, We.pending_buf = new A.Buf8(We.pending_buf_size), We.d_buf = 1 * We.lit_bufsize, We.l_buf = 3 * We.lit_bufsize, We.level = me, We.strategy = Fe, We.method = Ye, Be(V);
            }
            function Me(V, me) {
              return ee(V, me, v, DA, $, uA);
            }
            function MA(V, me) {
              var Ye, SA, ue, Fe;
              if (!V || !V.state || me > AA || me < 0)
                return V ? M(V, T) : T;
              if (SA = V.state, !V.output || !V.input && V.avail_in !== 0 || SA.status === oA && me !== q)
                return M(V, V.avail_out === 0 ? eA : T);
              if (SA.strm = V, Ye = SA.last_flush, SA.last_flush = me, SA.status === fA)
                if (SA.wrap === 2)
                  V.adler = 0, KA(SA, 31), KA(SA, 139), KA(SA, 8), SA.gzhead ? (KA(
                    SA,
                    (SA.gzhead.text ? 1 : 0) + (SA.gzhead.hcrc ? 2 : 0) + (SA.gzhead.extra ? 4 : 0) + (SA.gzhead.name ? 8 : 0) + (SA.gzhead.comment ? 16 : 0)
                  ), KA(SA, SA.gzhead.time & 255), KA(SA, SA.gzhead.time >> 8 & 255), KA(SA, SA.gzhead.time >> 16 & 255), KA(SA, SA.gzhead.time >> 24 & 255), KA(SA, SA.level === 9 ? 2 : SA.strategy >= k || SA.level < 2 ? 4 : 0), KA(SA, SA.gzhead.os & 255), SA.gzhead.extra && SA.gzhead.extra.length && (KA(SA, SA.gzhead.extra.length & 255), KA(SA, SA.gzhead.extra.length >> 8 & 255)), SA.gzhead.hcrc && (V.adler = x(V.adler, SA.pending_buf, SA.pending, 0)), SA.gzindex = 0, SA.status = sA) : (KA(SA, 0), KA(SA, 0), KA(SA, 0), KA(SA, 0), KA(SA, 0), KA(SA, SA.level === 9 ? 2 : SA.strategy >= k || SA.level < 2 ? 4 : 0), KA(SA, y), SA.status = _);
                else {
                  var tt = v + (SA.w_bits - 8 << 4) << 8, We = -1;
                  SA.strategy >= k || SA.level < 2 ? We = 0 : SA.level < 6 ? We = 1 : SA.level === 6 ? We = 2 : We = 3, tt |= We << 6, SA.strstart !== 0 && (tt |= TA), tt += 31 - tt % 31, SA.status = _, Pe(SA, tt), SA.strstart !== 0 && (Pe(SA, V.adler >>> 16), Pe(SA, V.adler & 65535)), V.adler = 1;
                }
              if (SA.status === sA)
                if (SA.gzhead.extra) {
                  for (ue = SA.pending; SA.gzindex < (SA.gzhead.extra.length & 65535) && !(SA.pending === SA.pending_buf_size && (SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), he(V), ue = SA.pending, SA.pending === SA.pending_buf_size)); )
                    KA(SA, SA.gzhead.extra[SA.gzindex] & 255), SA.gzindex++;
                  SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), SA.gzindex === SA.gzhead.extra.length && (SA.gzindex = 0, SA.status = F);
                } else
                  SA.status = F;
              if (SA.status === F)
                if (SA.gzhead.name) {
                  ue = SA.pending;
                  do {
                    if (SA.pending === SA.pending_buf_size && (SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), he(V), ue = SA.pending, SA.pending === SA.pending_buf_size)) {
                      Fe = 1;
                      break;
                    }
                    SA.gzindex < SA.gzhead.name.length ? Fe = SA.gzhead.name.charCodeAt(SA.gzindex++) & 255 : Fe = 0, KA(SA, Fe);
                  } while (Fe !== 0);
                  SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), Fe === 0 && (SA.gzindex = 0, SA.status = o);
                } else
                  SA.status = o;
              if (SA.status === o)
                if (SA.gzhead.comment) {
                  ue = SA.pending;
                  do {
                    if (SA.pending === SA.pending_buf_size && (SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), he(V), ue = SA.pending, SA.pending === SA.pending_buf_size)) {
                      Fe = 1;
                      break;
                    }
                    SA.gzindex < SA.gzhead.comment.length ? Fe = SA.gzhead.comment.charCodeAt(SA.gzindex++) & 255 : Fe = 0, KA(SA, Fe);
                  } while (Fe !== 0);
                  SA.gzhead.hcrc && SA.pending > ue && (V.adler = x(V.adler, SA.pending_buf, SA.pending - ue, ue)), Fe === 0 && (SA.status = h);
                } else
                  SA.status = h;
              if (SA.status === h && (SA.gzhead.hcrc ? (SA.pending + 2 > SA.pending_buf_size && he(V), SA.pending + 2 <= SA.pending_buf_size && (KA(SA, V.adler & 255), KA(SA, V.adler >> 8 & 255), V.adler = 0, SA.status = _)) : SA.status = _), SA.pending !== 0) {
                if (he(V), V.avail_out === 0)
                  return SA.last_flush = -1, K;
              } else if (V.avail_in === 0 && FA(me) <= FA(Ye) && me !== q)
                return M(V, eA);
              if (SA.status === oA && V.avail_in !== 0)
                return M(V, eA);
              if (V.avail_in !== 0 || SA.lookahead !== 0 || me !== P && SA.status !== oA) {
                var Ze = SA.strategy === k ? N(SA, me) : SA.strategy === tA ? wA(SA, me) : W[SA.level].func(SA, me);
                if ((Ze === QA || Ze === bA) && (SA.status = oA), Ze === p || Ze === QA)
                  return V.avail_out === 0 && (SA.last_flush = -1), K;
                if (Ze === rA && (me === D ? a._tr_align(SA) : me !== AA && (a._tr_stored_block(SA, 0, 0, !1), me === J && (dA(SA.head), SA.lookahead === 0 && (SA.strstart = 0, SA.block_start = 0, SA.insert = 0))), he(V), V.avail_out === 0))
                  return SA.last_flush = -1, K;
              }
              return me !== q ? K : SA.wrap <= 0 ? z : (SA.wrap === 2 ? (KA(SA, V.adler & 255), KA(SA, V.adler >> 8 & 255), KA(SA, V.adler >> 16 & 255), KA(SA, V.adler >> 24 & 255), KA(SA, V.total_in & 255), KA(SA, V.total_in >> 8 & 255), KA(SA, V.total_in >> 16 & 255), KA(SA, V.total_in >> 24 & 255)) : (Pe(SA, V.adler >>> 16), Pe(SA, V.adler & 65535)), he(V), SA.wrap > 0 && (SA.wrap = -SA.wrap), SA.pending !== 0 ? K : z);
            }
            function be(V) {
              var me;
              return !V || !V.state ? T : (me = V.state.status, me !== fA && me !== sA && me !== F && me !== o && me !== h && me !== _ && me !== oA ? M(V, T) : (V.state = null, me === _ ? M(V, H) : K));
            }
            function at(V, me) {
              var Ye = me.length, SA, ue, Fe, tt, We, Ze, Ct, fi;
              if (!V || !V.state || (SA = V.state, tt = SA.wrap, tt === 2 || tt === 1 && SA.status !== fA || SA.lookahead))
                return T;
              for (tt === 1 && (V.adler = d(V.adler, me, Ye, 0)), SA.wrap = 0, Ye >= SA.w_size && (tt === 0 && (dA(SA.head), SA.strstart = 0, SA.block_start = 0, SA.insert = 0), fi = new A.Buf8(SA.w_size), A.arraySet(fi, me, Ye - SA.w_size, SA.w_size, 0), me = fi, Ye = SA.w_size), We = V.avail_in, Ze = V.next_in, Ct = V.input, V.avail_in = Ye, V.next_in = 0, V.input = me, Re(SA); SA.lookahead >= xA; ) {
                ue = SA.strstart, Fe = SA.lookahead - (xA - 1);
                do
                  SA.ins_h = (SA.ins_h << SA.hash_shift ^ SA.window[ue + xA - 1]) & SA.hash_mask, SA.prev[ue & SA.w_mask] = SA.head[SA.ins_h], SA.head[SA.ins_h] = ue, ue++;
                while (--Fe);
                SA.strstart = ue, SA.lookahead = xA - 1, Re(SA);
              }
              return SA.strstart += SA.lookahead, SA.block_start = SA.strstart, SA.insert = SA.lookahead, SA.lookahead = 0, SA.match_length = SA.prev_length = xA - 1, SA.match_available = 0, V.next_in = Ze, V.input = Ct, V.avail_in = We, SA.wrap = tt, K;
            }
            B.deflateInit = Me, B.deflateInit2 = ee, B.deflateReset = Be, B.deflateResetKeep = pA, B.deflateSetHeader = Ie, B.deflate = MA, B.deflateEnd = be, B.deflateSetDictionary = at, B.deflateInfo = "pako deflate (from Nodeca project)";
          },
          /***/
          6395(Q) {
            var B = 30, r = 12;
            Q.exports = function(a, d) {
              var x, U, P, D, J, q, AA, K, z, T, H, eA, CA, IA, k, tA, lA, uA, w, v, RA, DA, $, cA, $A;
              x = a.state, U = a.next_in, cA = a.input, P = U + (a.avail_in - 5), D = a.next_out, $A = a.output, J = D - (d - a.avail_out), q = D + (a.avail_out - 257), AA = x.dmax, K = x.wsize, z = x.whave, T = x.wnext, H = x.window, eA = x.hold, CA = x.bits, IA = x.lencode, k = x.distcode, tA = (1 << x.lenbits) - 1, lA = (1 << x.distbits) - 1;
              A:
                do {
                  CA < 15 && (eA += cA[U++] << CA, CA += 8, eA += cA[U++] << CA, CA += 8), uA = IA[eA & tA];
                  e:
                    for (; ; ) {
                      if (w = uA >>> 24, eA >>>= w, CA -= w, w = uA >>> 16 & 255, w === 0)
                        $A[D++] = uA & 65535;
                      else if (w & 16) {
                        v = uA & 65535, w &= 15, w && (CA < w && (eA += cA[U++] << CA, CA += 8), v += eA & (1 << w) - 1, eA >>>= w, CA -= w), CA < 15 && (eA += cA[U++] << CA, CA += 8, eA += cA[U++] << CA, CA += 8), uA = k[eA & lA];
                        t:
                          for (; ; ) {
                            if (w = uA >>> 24, eA >>>= w, CA -= w, w = uA >>> 16 & 255, w & 16) {
                              if (RA = uA & 65535, w &= 15, CA < w && (eA += cA[U++] << CA, CA += 8, CA < w && (eA += cA[U++] << CA, CA += 8)), RA += eA & (1 << w) - 1, RA > AA) {
                                a.msg = "invalid distance too far back", x.mode = B;
                                break A;
                              }
                              if (eA >>>= w, CA -= w, w = D - J, RA > w) {
                                if (w = RA - w, w > z && x.sane) {
                                  a.msg = "invalid distance too far back", x.mode = B;
                                  break A;
                                }
                                if (DA = 0, $ = H, T === 0) {
                                  if (DA += K - w, w < v) {
                                    v -= w;
                                    do
                                      $A[D++] = H[DA++];
                                    while (--w);
                                    DA = D - RA, $ = $A;
                                  }
                                } else if (T < w) {
                                  if (DA += K + T - w, w -= T, w < v) {
                                    v -= w;
                                    do
                                      $A[D++] = H[DA++];
                                    while (--w);
                                    if (DA = 0, T < v) {
                                      w = T, v -= w;
                                      do
                                        $A[D++] = H[DA++];
                                      while (--w);
                                      DA = D - RA, $ = $A;
                                    }
                                  }
                                } else if (DA += T - w, w < v) {
                                  v -= w;
                                  do
                                    $A[D++] = H[DA++];
                                  while (--w);
                                  DA = D - RA, $ = $A;
                                }
                                for (; v > 2; )
                                  $A[D++] = $[DA++], $A[D++] = $[DA++], $A[D++] = $[DA++], v -= 3;
                                v && ($A[D++] = $[DA++], v > 1 && ($A[D++] = $[DA++]));
                              } else {
                                DA = D - RA;
                                do
                                  $A[D++] = $A[DA++], $A[D++] = $A[DA++], $A[D++] = $A[DA++], v -= 3;
                                while (v > 2);
                                v && ($A[D++] = $A[DA++], v > 1 && ($A[D++] = $A[DA++]));
                              }
                            } else if ((w & 64) === 0) {
                              uA = k[(uA & 65535) + (eA & (1 << w) - 1)];
                              continue t;
                            } else {
                              a.msg = "invalid distance code", x.mode = B;
                              break A;
                            }
                            break;
                          }
                      } else if ((w & 64) === 0) {
                        uA = IA[(uA & 65535) + (eA & (1 << w) - 1)];
                        continue e;
                      } else if (w & 32) {
                        x.mode = r;
                        break A;
                      } else {
                        a.msg = "invalid literal/length code", x.mode = B;
                        break A;
                      }
                      break;
                    }
                } while (U < P && D < q);
              v = CA >> 3, U -= v, CA -= v << 3, eA &= (1 << CA) - 1, a.next_in = U, a.next_out = D, a.avail_in = U < P ? 5 + (P - U) : 5 - (U - P), a.avail_out = D < q ? 257 + (q - D) : 257 - (D - q), x.hold = eA, x.bits = CA;
            };
          },
          /***/
          2269(Q, B, r) {
            var A = r(2519), a = r(6911), d = r(9049), x = r(6395), U = r(2920), P = 0, D = 1, J = 2, q = 4, AA = 5, K = 6, z = 0, T = 1, H = 2, eA = -2, CA = -3, IA = -4, k = -5, tA = 8, lA = 1, uA = 2, w = 3, v = 4, RA = 5, DA = 6, $ = 7, cA = 8, $A = 9, kA = 10, WA = 11, EA = 12, zA = 13, OA = 14, xA = 15, LA = 16, yA = 17, TA = 18, fA = 19, sA = 20, F = 21, o = 22, h = 23, _ = 24, oA = 25, p = 26, rA = 27, QA = 28, bA = 29, y = 30, M = 31, FA = 32, dA = 852, he = 592, ie = 15, KA = ie;
            function Pe(ee) {
              return (ee >>> 24 & 255) + (ee >>> 8 & 65280) + ((ee & 65280) << 8) + ((ee & 255) << 24);
            }
            function Je() {
              this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new A.Buf16(320), this.work = new A.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
            }
            function Le(ee) {
              var Me;
              return !ee || !ee.state ? eA : (Me = ee.state, ee.total_in = ee.total_out = Me.total = 0, ee.msg = "", Me.wrap && (ee.adler = Me.wrap & 1), Me.mode = lA, Me.last = 0, Me.havedict = 0, Me.dmax = 32768, Me.head = null, Me.hold = 0, Me.bits = 0, Me.lencode = Me.lendyn = new A.Buf32(dA), Me.distcode = Me.distdyn = new A.Buf32(he), Me.sane = 1, Me.back = -1, z);
            }
            function Re(ee) {
              var Me;
              return !ee || !ee.state ? eA : (Me = ee.state, Me.wsize = 0, Me.whave = 0, Me.wnext = 0, Le(ee));
            }
            function _e(ee, Me) {
              var MA, be;
              return !ee || !ee.state || (be = ee.state, Me < 0 ? (MA = 0, Me = -Me) : (MA = (Me >> 4) + 1, Me < 48 && (Me &= 15)), Me && (Me < 8 || Me > 15)) ? eA : (be.window !== null && be.wbits !== Me && (be.window = null), be.wrap = MA, be.wbits = Me, Re(ee));
            }
            function se(ee, Me) {
              var MA, be;
              return ee ? (be = new Je(), ee.state = be, be.window = null, MA = _e(ee, Me), MA !== z && (ee.state = null), MA) : eA;
            }
            function Ee(ee) {
              return se(ee, KA);
            }
            var wA = !0, N, G;
            function W(ee) {
              if (wA) {
                var Me;
                for (N = new A.Buf32(512), G = new A.Buf32(32), Me = 0; Me < 144; )
                  ee.lens[Me++] = 8;
                for (; Me < 256; )
                  ee.lens[Me++] = 9;
                for (; Me < 280; )
                  ee.lens[Me++] = 7;
                for (; Me < 288; )
                  ee.lens[Me++] = 8;
                for (U(D, ee.lens, 0, 288, N, 0, ee.work, { bits: 9 }), Me = 0; Me < 32; )
                  ee.lens[Me++] = 5;
                U(J, ee.lens, 0, 32, G, 0, ee.work, { bits: 5 }), wA = !1;
              }
              ee.lencode = N, ee.lenbits = 9, ee.distcode = G, ee.distbits = 5;
            }
            function aA(ee, Me, MA, be) {
              var at, V = ee.state;
              return V.window === null && (V.wsize = 1 << V.wbits, V.wnext = 0, V.whave = 0, V.window = new A.Buf8(V.wsize)), be >= V.wsize ? (A.arraySet(V.window, Me, MA - V.wsize, V.wsize, 0), V.wnext = 0, V.whave = V.wsize) : (at = V.wsize - V.wnext, at > be && (at = be), A.arraySet(V.window, Me, MA - be, at, V.wnext), be -= at, be ? (A.arraySet(V.window, Me, MA - be, be, 0), V.wnext = be, V.whave = V.wsize) : (V.wnext += at, V.wnext === V.wsize && (V.wnext = 0), V.whave < V.wsize && (V.whave += at))), 0;
            }
            function j(ee, Me) {
              var MA, be, at, V, me, Ye, SA, ue, Fe, tt, We, Ze, Ct, fi, st = 0, xt, Mt, zt, Xt, xi, mi, Ot, vt, Zt = new A.Buf8(4), ei, Ke, qe = (
                /* permutation of code lengths */
                [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
              );
              if (!ee || !ee.state || !ee.output || !ee.input && ee.avail_in !== 0)
                return eA;
              MA = ee.state, MA.mode === EA && (MA.mode = zA), me = ee.next_out, at = ee.output, SA = ee.avail_out, V = ee.next_in, be = ee.input, Ye = ee.avail_in, ue = MA.hold, Fe = MA.bits, tt = Ye, We = SA, vt = z;
              A:
                for (; ; )
                  switch (MA.mode) {
                    case lA:
                      if (MA.wrap === 0) {
                        MA.mode = zA;
                        break;
                      }
                      for (; Fe < 16; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if (MA.wrap & 2 && ue === 35615) {
                        MA.check = 0, Zt[0] = ue & 255, Zt[1] = ue >>> 8 & 255, MA.check = d(MA.check, Zt, 2, 0), ue = 0, Fe = 0, MA.mode = uA;
                        break;
                      }
                      if (MA.flags = 0, MA.head && (MA.head.done = !1), !(MA.wrap & 1) || /* check if zlib header allowed */
                      (((ue & 255) << 8) + (ue >> 8)) % 31) {
                        ee.msg = "incorrect header check", MA.mode = y;
                        break;
                      }
                      if ((ue & 15) !== tA) {
                        ee.msg = "unknown compression method", MA.mode = y;
                        break;
                      }
                      if (ue >>>= 4, Fe -= 4, Ot = (ue & 15) + 8, MA.wbits === 0)
                        MA.wbits = Ot;
                      else if (Ot > MA.wbits) {
                        ee.msg = "invalid window size", MA.mode = y;
                        break;
                      }
                      MA.dmax = 1 << Ot, ee.adler = MA.check = 1, MA.mode = ue & 512 ? kA : EA, ue = 0, Fe = 0;
                      break;
                    case uA:
                      for (; Fe < 16; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if (MA.flags = ue, (MA.flags & 255) !== tA) {
                        ee.msg = "unknown compression method", MA.mode = y;
                        break;
                      }
                      if (MA.flags & 57344) {
                        ee.msg = "unknown header flags set", MA.mode = y;
                        break;
                      }
                      MA.head && (MA.head.text = ue >> 8 & 1), MA.flags & 512 && (Zt[0] = ue & 255, Zt[1] = ue >>> 8 & 255, MA.check = d(MA.check, Zt, 2, 0)), ue = 0, Fe = 0, MA.mode = w;
                    /* falls through */
                    case w:
                      for (; Fe < 32; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      MA.head && (MA.head.time = ue), MA.flags & 512 && (Zt[0] = ue & 255, Zt[1] = ue >>> 8 & 255, Zt[2] = ue >>> 16 & 255, Zt[3] = ue >>> 24 & 255, MA.check = d(MA.check, Zt, 4, 0)), ue = 0, Fe = 0, MA.mode = v;
                    /* falls through */
                    case v:
                      for (; Fe < 16; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      MA.head && (MA.head.xflags = ue & 255, MA.head.os = ue >> 8), MA.flags & 512 && (Zt[0] = ue & 255, Zt[1] = ue >>> 8 & 255, MA.check = d(MA.check, Zt, 2, 0)), ue = 0, Fe = 0, MA.mode = RA;
                    /* falls through */
                    case RA:
                      if (MA.flags & 1024) {
                        for (; Fe < 16; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        MA.length = ue, MA.head && (MA.head.extra_len = ue), MA.flags & 512 && (Zt[0] = ue & 255, Zt[1] = ue >>> 8 & 255, MA.check = d(MA.check, Zt, 2, 0)), ue = 0, Fe = 0;
                      } else MA.head && (MA.head.extra = null);
                      MA.mode = DA;
                    /* falls through */
                    case DA:
                      if (MA.flags & 1024 && (Ze = MA.length, Ze > Ye && (Ze = Ye), Ze && (MA.head && (Ot = MA.head.extra_len - MA.length, MA.head.extra || (MA.head.extra = new Array(MA.head.extra_len)), A.arraySet(
                        MA.head.extra,
                        be,
                        V,
                        // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        Ze,
                        /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                        Ot
                      )), MA.flags & 512 && (MA.check = d(MA.check, be, Ze, V)), Ye -= Ze, V += Ze, MA.length -= Ze), MA.length))
                        break A;
                      MA.length = 0, MA.mode = $;
                    /* falls through */
                    case $:
                      if (MA.flags & 2048) {
                        if (Ye === 0)
                          break A;
                        Ze = 0;
                        do
                          Ot = be[V + Ze++], MA.head && Ot && MA.length < 65536 && (MA.head.name += String.fromCharCode(Ot));
                        while (Ot && Ze < Ye);
                        if (MA.flags & 512 && (MA.check = d(MA.check, be, Ze, V)), Ye -= Ze, V += Ze, Ot)
                          break A;
                      } else MA.head && (MA.head.name = null);
                      MA.length = 0, MA.mode = cA;
                    /* falls through */
                    case cA:
                      if (MA.flags & 4096) {
                        if (Ye === 0)
                          break A;
                        Ze = 0;
                        do
                          Ot = be[V + Ze++], MA.head && Ot && MA.length < 65536 && (MA.head.comment += String.fromCharCode(Ot));
                        while (Ot && Ze < Ye);
                        if (MA.flags & 512 && (MA.check = d(MA.check, be, Ze, V)), Ye -= Ze, V += Ze, Ot)
                          break A;
                      } else MA.head && (MA.head.comment = null);
                      MA.mode = $A;
                    /* falls through */
                    case $A:
                      if (MA.flags & 512) {
                        for (; Fe < 16; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        if (ue !== (MA.check & 65535)) {
                          ee.msg = "header crc mismatch", MA.mode = y;
                          break;
                        }
                        ue = 0, Fe = 0;
                      }
                      MA.head && (MA.head.hcrc = MA.flags >> 9 & 1, MA.head.done = !0), ee.adler = MA.check = 0, MA.mode = EA;
                      break;
                    case kA:
                      for (; Fe < 32; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      ee.adler = MA.check = Pe(ue), ue = 0, Fe = 0, MA.mode = WA;
                    /* falls through */
                    case WA:
                      if (MA.havedict === 0)
                        return ee.next_out = me, ee.avail_out = SA, ee.next_in = V, ee.avail_in = Ye, MA.hold = ue, MA.bits = Fe, H;
                      ee.adler = MA.check = 1, MA.mode = EA;
                    /* falls through */
                    case EA:
                      if (Me === AA || Me === K)
                        break A;
                    /* falls through */
                    case zA:
                      if (MA.last) {
                        ue >>>= Fe & 7, Fe -= Fe & 7, MA.mode = rA;
                        break;
                      }
                      for (; Fe < 3; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      switch (MA.last = ue & 1, ue >>>= 1, Fe -= 1, ue & 3) {
                        case 0:
                          MA.mode = OA;
                          break;
                        case 1:
                          if (W(MA), MA.mode = sA, Me === K) {
                            ue >>>= 2, Fe -= 2;
                            break A;
                          }
                          break;
                        case 2:
                          MA.mode = yA;
                          break;
                        case 3:
                          ee.msg = "invalid block type", MA.mode = y;
                      }
                      ue >>>= 2, Fe -= 2;
                      break;
                    case OA:
                      for (ue >>>= Fe & 7, Fe -= Fe & 7; Fe < 32; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if ((ue & 65535) !== (ue >>> 16 ^ 65535)) {
                        ee.msg = "invalid stored block lengths", MA.mode = y;
                        break;
                      }
                      if (MA.length = ue & 65535, ue = 0, Fe = 0, MA.mode = xA, Me === K)
                        break A;
                    /* falls through */
                    case xA:
                      MA.mode = LA;
                    /* falls through */
                    case LA:
                      if (Ze = MA.length, Ze) {
                        if (Ze > Ye && (Ze = Ye), Ze > SA && (Ze = SA), Ze === 0)
                          break A;
                        A.arraySet(at, be, V, Ze, me), Ye -= Ze, V += Ze, SA -= Ze, me += Ze, MA.length -= Ze;
                        break;
                      }
                      MA.mode = EA;
                      break;
                    case yA:
                      for (; Fe < 14; ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if (MA.nlen = (ue & 31) + 257, ue >>>= 5, Fe -= 5, MA.ndist = (ue & 31) + 1, ue >>>= 5, Fe -= 5, MA.ncode = (ue & 15) + 4, ue >>>= 4, Fe -= 4, MA.nlen > 286 || MA.ndist > 30) {
                        ee.msg = "too many length or distance symbols", MA.mode = y;
                        break;
                      }
                      MA.have = 0, MA.mode = TA;
                    /* falls through */
                    case TA:
                      for (; MA.have < MA.ncode; ) {
                        for (; Fe < 3; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        MA.lens[qe[MA.have++]] = ue & 7, ue >>>= 3, Fe -= 3;
                      }
                      for (; MA.have < 19; )
                        MA.lens[qe[MA.have++]] = 0;
                      if (MA.lencode = MA.lendyn, MA.lenbits = 7, ei = { bits: MA.lenbits }, vt = U(P, MA.lens, 0, 19, MA.lencode, 0, MA.work, ei), MA.lenbits = ei.bits, vt) {
                        ee.msg = "invalid code lengths set", MA.mode = y;
                        break;
                      }
                      MA.have = 0, MA.mode = fA;
                    /* falls through */
                    case fA:
                      for (; MA.have < MA.nlen + MA.ndist; ) {
                        for (; st = MA.lencode[ue & (1 << MA.lenbits) - 1], xt = st >>> 24, Mt = st >>> 16 & 255, zt = st & 65535, !(xt <= Fe); ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        if (zt < 16)
                          ue >>>= xt, Fe -= xt, MA.lens[MA.have++] = zt;
                        else {
                          if (zt === 16) {
                            for (Ke = xt + 2; Fe < Ke; ) {
                              if (Ye === 0)
                                break A;
                              Ye--, ue += be[V++] << Fe, Fe += 8;
                            }
                            if (ue >>>= xt, Fe -= xt, MA.have === 0) {
                              ee.msg = "invalid bit length repeat", MA.mode = y;
                              break;
                            }
                            Ot = MA.lens[MA.have - 1], Ze = 3 + (ue & 3), ue >>>= 2, Fe -= 2;
                          } else if (zt === 17) {
                            for (Ke = xt + 3; Fe < Ke; ) {
                              if (Ye === 0)
                                break A;
                              Ye--, ue += be[V++] << Fe, Fe += 8;
                            }
                            ue >>>= xt, Fe -= xt, Ot = 0, Ze = 3 + (ue & 7), ue >>>= 3, Fe -= 3;
                          } else {
                            for (Ke = xt + 7; Fe < Ke; ) {
                              if (Ye === 0)
                                break A;
                              Ye--, ue += be[V++] << Fe, Fe += 8;
                            }
                            ue >>>= xt, Fe -= xt, Ot = 0, Ze = 11 + (ue & 127), ue >>>= 7, Fe -= 7;
                          }
                          if (MA.have + Ze > MA.nlen + MA.ndist) {
                            ee.msg = "invalid bit length repeat", MA.mode = y;
                            break;
                          }
                          for (; Ze--; )
                            MA.lens[MA.have++] = Ot;
                        }
                      }
                      if (MA.mode === y)
                        break;
                      if (MA.lens[256] === 0) {
                        ee.msg = "invalid code -- missing end-of-block", MA.mode = y;
                        break;
                      }
                      if (MA.lenbits = 9, ei = { bits: MA.lenbits }, vt = U(D, MA.lens, 0, MA.nlen, MA.lencode, 0, MA.work, ei), MA.lenbits = ei.bits, vt) {
                        ee.msg = "invalid literal/lengths set", MA.mode = y;
                        break;
                      }
                      if (MA.distbits = 6, MA.distcode = MA.distdyn, ei = { bits: MA.distbits }, vt = U(J, MA.lens, MA.nlen, MA.ndist, MA.distcode, 0, MA.work, ei), MA.distbits = ei.bits, vt) {
                        ee.msg = "invalid distances set", MA.mode = y;
                        break;
                      }
                      if (MA.mode = sA, Me === K)
                        break A;
                    /* falls through */
                    case sA:
                      MA.mode = F;
                    /* falls through */
                    case F:
                      if (Ye >= 6 && SA >= 258) {
                        ee.next_out = me, ee.avail_out = SA, ee.next_in = V, ee.avail_in = Ye, MA.hold = ue, MA.bits = Fe, x(ee, We), me = ee.next_out, at = ee.output, SA = ee.avail_out, V = ee.next_in, be = ee.input, Ye = ee.avail_in, ue = MA.hold, Fe = MA.bits, MA.mode === EA && (MA.back = -1);
                        break;
                      }
                      for (MA.back = 0; st = MA.lencode[ue & (1 << MA.lenbits) - 1], xt = st >>> 24, Mt = st >>> 16 & 255, zt = st & 65535, !(xt <= Fe); ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if (Mt && (Mt & 240) === 0) {
                        for (Xt = xt, xi = Mt, mi = zt; st = MA.lencode[mi + ((ue & (1 << Xt + xi) - 1) >> Xt)], xt = st >>> 24, Mt = st >>> 16 & 255, zt = st & 65535, !(Xt + xt <= Fe); ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        ue >>>= Xt, Fe -= Xt, MA.back += Xt;
                      }
                      if (ue >>>= xt, Fe -= xt, MA.back += xt, MA.length = zt, Mt === 0) {
                        MA.mode = p;
                        break;
                      }
                      if (Mt & 32) {
                        MA.back = -1, MA.mode = EA;
                        break;
                      }
                      if (Mt & 64) {
                        ee.msg = "invalid literal/length code", MA.mode = y;
                        break;
                      }
                      MA.extra = Mt & 15, MA.mode = o;
                    /* falls through */
                    case o:
                      if (MA.extra) {
                        for (Ke = MA.extra; Fe < Ke; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        MA.length += ue & (1 << MA.extra) - 1, ue >>>= MA.extra, Fe -= MA.extra, MA.back += MA.extra;
                      }
                      MA.was = MA.length, MA.mode = h;
                    /* falls through */
                    case h:
                      for (; st = MA.distcode[ue & (1 << MA.distbits) - 1], xt = st >>> 24, Mt = st >>> 16 & 255, zt = st & 65535, !(xt <= Fe); ) {
                        if (Ye === 0)
                          break A;
                        Ye--, ue += be[V++] << Fe, Fe += 8;
                      }
                      if ((Mt & 240) === 0) {
                        for (Xt = xt, xi = Mt, mi = zt; st = MA.distcode[mi + ((ue & (1 << Xt + xi) - 1) >> Xt)], xt = st >>> 24, Mt = st >>> 16 & 255, zt = st & 65535, !(Xt + xt <= Fe); ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        ue >>>= Xt, Fe -= Xt, MA.back += Xt;
                      }
                      if (ue >>>= xt, Fe -= xt, MA.back += xt, Mt & 64) {
                        ee.msg = "invalid distance code", MA.mode = y;
                        break;
                      }
                      MA.offset = zt, MA.extra = Mt & 15, MA.mode = _;
                    /* falls through */
                    case _:
                      if (MA.extra) {
                        for (Ke = MA.extra; Fe < Ke; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        MA.offset += ue & (1 << MA.extra) - 1, ue >>>= MA.extra, Fe -= MA.extra, MA.back += MA.extra;
                      }
                      if (MA.offset > MA.dmax) {
                        ee.msg = "invalid distance too far back", MA.mode = y;
                        break;
                      }
                      MA.mode = oA;
                    /* falls through */
                    case oA:
                      if (SA === 0)
                        break A;
                      if (Ze = We - SA, MA.offset > Ze) {
                        if (Ze = MA.offset - Ze, Ze > MA.whave && MA.sane) {
                          ee.msg = "invalid distance too far back", MA.mode = y;
                          break;
                        }
                        Ze > MA.wnext ? (Ze -= MA.wnext, Ct = MA.wsize - Ze) : Ct = MA.wnext - Ze, Ze > MA.length && (Ze = MA.length), fi = MA.window;
                      } else
                        fi = at, Ct = me - MA.offset, Ze = MA.length;
                      Ze > SA && (Ze = SA), SA -= Ze, MA.length -= Ze;
                      do
                        at[me++] = fi[Ct++];
                      while (--Ze);
                      MA.length === 0 && (MA.mode = F);
                      break;
                    case p:
                      if (SA === 0)
                        break A;
                      at[me++] = MA.length, SA--, MA.mode = F;
                      break;
                    case rA:
                      if (MA.wrap) {
                        for (; Fe < 32; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue |= be[V++] << Fe, Fe += 8;
                        }
                        if (We -= SA, ee.total_out += We, MA.total += We, We && (ee.adler = MA.check = /*UPDATE(state.check, put - _out, _out);*/
                        MA.flags ? d(MA.check, at, We, me - We) : a(MA.check, at, We, me - We)), We = SA, (MA.flags ? ue : Pe(ue)) !== MA.check) {
                          ee.msg = "incorrect data check", MA.mode = y;
                          break;
                        }
                        ue = 0, Fe = 0;
                      }
                      MA.mode = QA;
                    /* falls through */
                    case QA:
                      if (MA.wrap && MA.flags) {
                        for (; Fe < 32; ) {
                          if (Ye === 0)
                            break A;
                          Ye--, ue += be[V++] << Fe, Fe += 8;
                        }
                        if (ue !== (MA.total & 4294967295)) {
                          ee.msg = "incorrect length check", MA.mode = y;
                          break;
                        }
                        ue = 0, Fe = 0;
                      }
                      MA.mode = bA;
                    /* falls through */
                    case bA:
                      vt = T;
                      break A;
                    case y:
                      vt = CA;
                      break A;
                    case M:
                      return IA;
                    case FA:
                    /* falls through */
                    default:
                      return eA;
                  }
              return ee.next_out = me, ee.avail_out = SA, ee.next_in = V, ee.avail_in = Ye, MA.hold = ue, MA.bits = Fe, (MA.wsize || We !== ee.avail_out && MA.mode < y && (MA.mode < rA || Me !== q)) && aA(ee, ee.output, ee.next_out, We - ee.avail_out), tt -= ee.avail_in, We -= ee.avail_out, ee.total_in += tt, ee.total_out += We, MA.total += We, MA.wrap && We && (ee.adler = MA.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
              MA.flags ? d(MA.check, at, We, ee.next_out - We) : a(MA.check, at, We, ee.next_out - We)), ee.data_type = MA.bits + (MA.last ? 64 : 0) + (MA.mode === EA ? 128 : 0) + (MA.mode === sA || MA.mode === xA ? 256 : 0), (tt === 0 && We === 0 || Me === q) && vt === z && (vt = k), vt;
            }
            function pA(ee) {
              if (!ee || !ee.state)
                return eA;
              var Me = ee.state;
              return Me.window && (Me.window = null), ee.state = null, z;
            }
            function Be(ee, Me) {
              var MA;
              return !ee || !ee.state || (MA = ee.state, (MA.wrap & 2) === 0) ? eA : (MA.head = Me, Me.done = !1, z);
            }
            function Ie(ee, Me) {
              var MA = Me.length, be, at, V;
              return !ee || !ee.state || (be = ee.state, be.wrap !== 0 && be.mode !== WA) ? eA : be.mode === WA && (at = 1, at = a(at, Me, MA, 0), at !== be.check) ? CA : (V = aA(ee, Me, MA, MA), V ? (be.mode = M, IA) : (be.havedict = 1, z));
            }
            B.inflateReset = Re, B.inflateReset2 = _e, B.inflateResetKeep = Le, B.inflateInit = Ee, B.inflateInit2 = se, B.inflate = j, B.inflateEnd = pA, B.inflateGetHeader = Be, B.inflateSetDictionary = Ie, B.inflateInfo = "pako inflate (from Nodeca project)";
          },
          /***/
          2920(Q, B, r) {
            var A = r(2519), a = 15, d = 852, x = 592, U = 0, P = 1, D = 2, J = [
              /* Length codes 257..285 base */
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              13,
              15,
              17,
              19,
              23,
              27,
              31,
              35,
              43,
              51,
              59,
              67,
              83,
              99,
              115,
              131,
              163,
              195,
              227,
              258,
              0,
              0
            ], q = [
              /* Length codes 257..285 extra */
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              16,
              17,
              17,
              17,
              17,
              18,
              18,
              18,
              18,
              19,
              19,
              19,
              19,
              20,
              20,
              20,
              20,
              21,
              21,
              21,
              21,
              16,
              72,
              78
            ], AA = [
              /* Distance codes 0..29 base */
              1,
              2,
              3,
              4,
              5,
              7,
              9,
              13,
              17,
              25,
              33,
              49,
              65,
              97,
              129,
              193,
              257,
              385,
              513,
              769,
              1025,
              1537,
              2049,
              3073,
              4097,
              6145,
              8193,
              12289,
              16385,
              24577,
              0,
              0
            ], K = [
              /* Distance codes 0..29 extra */
              16,
              16,
              16,
              16,
              17,
              17,
              18,
              18,
              19,
              19,
              20,
              20,
              21,
              21,
              22,
              22,
              23,
              23,
              24,
              24,
              25,
              25,
              26,
              26,
              27,
              27,
              28,
              28,
              29,
              29,
              64,
              64
            ];
            Q.exports = function(T, H, eA, CA, IA, k, tA, lA) {
              var uA = lA.bits, w = 0, v = 0, RA = 0, DA = 0, $ = 0, cA = 0, $A = 0, kA = 0, WA = 0, EA = 0, zA, OA, xA, LA, yA, TA = null, fA = 0, sA, F = new A.Buf16(a + 1), o = new A.Buf16(a + 1), h = null, _ = 0, oA, p, rA;
              for (w = 0; w <= a; w++)
                F[w] = 0;
              for (v = 0; v < CA; v++)
                F[H[eA + v]]++;
              for ($ = uA, DA = a; DA >= 1 && F[DA] === 0; DA--)
                ;
              if ($ > DA && ($ = DA), DA === 0)
                return IA[k++] = 20971520, IA[k++] = 20971520, lA.bits = 1, 0;
              for (RA = 1; RA < DA && F[RA] === 0; RA++)
                ;
              for ($ < RA && ($ = RA), kA = 1, w = 1; w <= a; w++)
                if (kA <<= 1, kA -= F[w], kA < 0)
                  return -1;
              if (kA > 0 && (T === U || DA !== 1))
                return -1;
              for (o[1] = 0, w = 1; w < a; w++)
                o[w + 1] = o[w] + F[w];
              for (v = 0; v < CA; v++)
                H[eA + v] !== 0 && (tA[o[H[eA + v]]++] = v);
              if (T === U ? (TA = h = tA, sA = 19) : T === P ? (TA = J, fA -= 257, h = q, _ -= 257, sA = 256) : (TA = AA, h = K, sA = -1), EA = 0, v = 0, w = RA, yA = k, cA = $, $A = 0, xA = -1, WA = 1 << $, LA = WA - 1, T === P && WA > d || T === D && WA > x)
                return 1;
              for (; ; ) {
                oA = w - $A, tA[v] < sA ? (p = 0, rA = tA[v]) : tA[v] > sA ? (p = h[_ + tA[v]], rA = TA[fA + tA[v]]) : (p = 96, rA = 0), zA = 1 << w - $A, OA = 1 << cA, RA = OA;
                do
                  OA -= zA, IA[yA + (EA >> $A) + OA] = oA << 24 | p << 16 | rA | 0;
                while (OA !== 0);
                for (zA = 1 << w - 1; EA & zA; )
                  zA >>= 1;
                if (zA !== 0 ? (EA &= zA - 1, EA += zA) : EA = 0, v++, --F[w] === 0) {
                  if (w === DA)
                    break;
                  w = H[eA + tA[v]];
                }
                if (w > $ && (EA & LA) !== xA) {
                  for ($A === 0 && ($A = $), yA += RA, cA = w - $A, kA = 1 << cA; cA + $A < DA && (kA -= F[cA + $A], !(kA <= 0)); )
                    cA++, kA <<= 1;
                  if (WA += 1 << cA, T === P && WA > d || T === D && WA > x)
                    return 1;
                  xA = EA & LA, IA[xA] = $ << 24 | cA << 16 | yA - k | 0;
                }
              }
              return EA !== 0 && (IA[yA + EA] = w - $A << 24 | 4194304 | 0), lA.bits = $, 0;
            };
          },
          /***/
          6228(Q) {
            Q.exports = {
              2: "need dictionary",
              /* Z_NEED_DICT       2  */
              1: "stream end",
              /* Z_STREAM_END      1  */
              0: "",
              /* Z_OK              0  */
              "-1": "file error",
              /* Z_ERRNO         (-1) */
              "-2": "stream error",
              /* Z_STREAM_ERROR  (-2) */
              "-3": "data error",
              /* Z_DATA_ERROR    (-3) */
              "-4": "insufficient memory",
              /* Z_MEM_ERROR     (-4) */
              "-5": "buffer error",
              /* Z_BUF_ERROR     (-5) */
              "-6": "incompatible version"
              /* Z_VERSION_ERROR (-6) */
            };
          },
          /***/
          2367(Q, B, r) {
            var A = r(2519), a = 4, d = 0, x = 1, U = 2;
            function P(j) {
              for (var pA = j.length; --pA >= 0; )
                j[pA] = 0;
            }
            var D = 0, J = 1, q = 2, AA = 3, K = 258, z = 29, T = 256, H = T + 1 + z, eA = 30, CA = 19, IA = 2 * H + 1, k = 15, tA = 16, lA = 7, uA = 256, w = 16, v = 17, RA = 18, DA = (
              /* extra bits for each length code */
              [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
            ), $ = (
              /* extra bits for each distance code */
              [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
            ), cA = (
              /* extra bits for each bit length code */
              [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
            ), $A = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], kA = 512, WA = new Array((H + 2) * 2);
            P(WA);
            var EA = new Array(eA * 2);
            P(EA);
            var zA = new Array(kA);
            P(zA);
            var OA = new Array(K - AA + 1);
            P(OA);
            var xA = new Array(z);
            P(xA);
            var LA = new Array(eA);
            P(LA);
            function yA(j, pA, Be, Ie, ee) {
              this.static_tree = j, this.extra_bits = pA, this.extra_base = Be, this.elems = Ie, this.max_length = ee, this.has_stree = j && j.length;
            }
            var TA, fA, sA;
            function F(j, pA) {
              this.dyn_tree = j, this.max_code = 0, this.stat_desc = pA;
            }
            function o(j) {
              return j < 256 ? zA[j] : zA[256 + (j >>> 7)];
            }
            function h(j, pA) {
              j.pending_buf[j.pending++] = pA & 255, j.pending_buf[j.pending++] = pA >>> 8 & 255;
            }
            function _(j, pA, Be) {
              j.bi_valid > tA - Be ? (j.bi_buf |= pA << j.bi_valid & 65535, h(j, j.bi_buf), j.bi_buf = pA >> tA - j.bi_valid, j.bi_valid += Be - tA) : (j.bi_buf |= pA << j.bi_valid & 65535, j.bi_valid += Be);
            }
            function oA(j, pA, Be) {
              _(
                j,
                Be[pA * 2],
                Be[pA * 2 + 1]
                /*.Len*/
              );
            }
            function p(j, pA) {
              var Be = 0;
              do
                Be |= j & 1, j >>>= 1, Be <<= 1;
              while (--pA > 0);
              return Be >>> 1;
            }
            function rA(j) {
              j.bi_valid === 16 ? (h(j, j.bi_buf), j.bi_buf = 0, j.bi_valid = 0) : j.bi_valid >= 8 && (j.pending_buf[j.pending++] = j.bi_buf & 255, j.bi_buf >>= 8, j.bi_valid -= 8);
            }
            function QA(j, pA) {
              var Be = pA.dyn_tree, Ie = pA.max_code, ee = pA.stat_desc.static_tree, Me = pA.stat_desc.has_stree, MA = pA.stat_desc.extra_bits, be = pA.stat_desc.extra_base, at = pA.stat_desc.max_length, V, me, Ye, SA, ue, Fe, tt = 0;
              for (SA = 0; SA <= k; SA++)
                j.bl_count[SA] = 0;
              for (Be[j.heap[j.heap_max] * 2 + 1] = 0, V = j.heap_max + 1; V < IA; V++)
                me = j.heap[V], SA = Be[Be[me * 2 + 1] * 2 + 1] + 1, SA > at && (SA = at, tt++), Be[me * 2 + 1] = SA, !(me > Ie) && (j.bl_count[SA]++, ue = 0, me >= be && (ue = MA[me - be]), Fe = Be[me * 2], j.opt_len += Fe * (SA + ue), Me && (j.static_len += Fe * (ee[me * 2 + 1] + ue)));
              if (tt !== 0) {
                do {
                  for (SA = at - 1; j.bl_count[SA] === 0; )
                    SA--;
                  j.bl_count[SA]--, j.bl_count[SA + 1] += 2, j.bl_count[at]--, tt -= 2;
                } while (tt > 0);
                for (SA = at; SA !== 0; SA--)
                  for (me = j.bl_count[SA]; me !== 0; )
                    Ye = j.heap[--V], !(Ye > Ie) && (Be[Ye * 2 + 1] !== SA && (j.opt_len += (SA - Be[Ye * 2 + 1]) * Be[Ye * 2], Be[Ye * 2 + 1] = SA), me--);
              }
            }
            function bA(j, pA, Be) {
              var Ie = new Array(k + 1), ee = 0, Me, MA;
              for (Me = 1; Me <= k; Me++)
                Ie[Me] = ee = ee + Be[Me - 1] << 1;
              for (MA = 0; MA <= pA; MA++) {
                var be = j[MA * 2 + 1];
                be !== 0 && (j[MA * 2] = p(Ie[be]++, be));
              }
            }
            function y() {
              var j, pA, Be, Ie, ee, Me = new Array(k + 1);
              for (Be = 0, Ie = 0; Ie < z - 1; Ie++)
                for (xA[Ie] = Be, j = 0; j < 1 << DA[Ie]; j++)
                  OA[Be++] = Ie;
              for (OA[Be - 1] = Ie, ee = 0, Ie = 0; Ie < 16; Ie++)
                for (LA[Ie] = ee, j = 0; j < 1 << $[Ie]; j++)
                  zA[ee++] = Ie;
              for (ee >>= 7; Ie < eA; Ie++)
                for (LA[Ie] = ee << 7, j = 0; j < 1 << $[Ie] - 7; j++)
                  zA[256 + ee++] = Ie;
              for (pA = 0; pA <= k; pA++)
                Me[pA] = 0;
              for (j = 0; j <= 143; )
                WA[j * 2 + 1] = 8, j++, Me[8]++;
              for (; j <= 255; )
                WA[j * 2 + 1] = 9, j++, Me[9]++;
              for (; j <= 279; )
                WA[j * 2 + 1] = 7, j++, Me[7]++;
              for (; j <= 287; )
                WA[j * 2 + 1] = 8, j++, Me[8]++;
              for (bA(WA, H + 1, Me), j = 0; j < eA; j++)
                EA[j * 2 + 1] = 5, EA[j * 2] = p(j, 5);
              TA = new yA(WA, DA, T + 1, H, k), fA = new yA(EA, $, 0, eA, k), sA = new yA(new Array(0), cA, 0, CA, lA);
            }
            function M(j) {
              var pA;
              for (pA = 0; pA < H; pA++)
                j.dyn_ltree[pA * 2] = 0;
              for (pA = 0; pA < eA; pA++)
                j.dyn_dtree[pA * 2] = 0;
              for (pA = 0; pA < CA; pA++)
                j.bl_tree[pA * 2] = 0;
              j.dyn_ltree[uA * 2] = 1, j.opt_len = j.static_len = 0, j.last_lit = j.matches = 0;
            }
            function FA(j) {
              j.bi_valid > 8 ? h(j, j.bi_buf) : j.bi_valid > 0 && (j.pending_buf[j.pending++] = j.bi_buf), j.bi_buf = 0, j.bi_valid = 0;
            }
            function dA(j, pA, Be, Ie) {
              FA(j), h(j, Be), h(j, ~Be), A.arraySet(j.pending_buf, j.window, pA, Be, j.pending), j.pending += Be;
            }
            function he(j, pA, Be, Ie) {
              var ee = pA * 2, Me = Be * 2;
              return j[ee] < j[Me] || j[ee] === j[Me] && Ie[pA] <= Ie[Be];
            }
            function ie(j, pA, Be) {
              for (var Ie = j.heap[Be], ee = Be << 1; ee <= j.heap_len && (ee < j.heap_len && he(pA, j.heap[ee + 1], j.heap[ee], j.depth) && ee++, !he(pA, Ie, j.heap[ee], j.depth)); )
                j.heap[Be] = j.heap[ee], Be = ee, ee <<= 1;
              j.heap[Be] = Ie;
            }
            function KA(j, pA, Be) {
              var Ie, ee, Me = 0, MA, be;
              if (j.last_lit !== 0)
                do
                  Ie = j.pending_buf[j.d_buf + Me * 2] << 8 | j.pending_buf[j.d_buf + Me * 2 + 1], ee = j.pending_buf[j.l_buf + Me], Me++, Ie === 0 ? oA(j, ee, pA) : (MA = OA[ee], oA(j, MA + T + 1, pA), be = DA[MA], be !== 0 && (ee -= xA[MA], _(j, ee, be)), Ie--, MA = o(Ie), oA(j, MA, Be), be = $[MA], be !== 0 && (Ie -= LA[MA], _(j, Ie, be)));
                while (Me < j.last_lit);
              oA(j, uA, pA);
            }
            function Pe(j, pA) {
              var Be = pA.dyn_tree, Ie = pA.stat_desc.static_tree, ee = pA.stat_desc.has_stree, Me = pA.stat_desc.elems, MA, be, at = -1, V;
              for (j.heap_len = 0, j.heap_max = IA, MA = 0; MA < Me; MA++)
                Be[MA * 2] !== 0 ? (j.heap[++j.heap_len] = at = MA, j.depth[MA] = 0) : Be[MA * 2 + 1] = 0;
              for (; j.heap_len < 2; )
                V = j.heap[++j.heap_len] = at < 2 ? ++at : 0, Be[V * 2] = 1, j.depth[V] = 0, j.opt_len--, ee && (j.static_len -= Ie[V * 2 + 1]);
              for (pA.max_code = at, MA = j.heap_len >> 1; MA >= 1; MA--)
                ie(j, Be, MA);
              V = Me;
              do
                MA = j.heap[
                  1
                  /*SMALLEST*/
                ], j.heap[
                  1
                  /*SMALLEST*/
                ] = j.heap[j.heap_len--], ie(
                  j,
                  Be,
                  1
                  /*SMALLEST*/
                ), be = j.heap[
                  1
                  /*SMALLEST*/
                ], j.heap[--j.heap_max] = MA, j.heap[--j.heap_max] = be, Be[V * 2] = Be[MA * 2] + Be[be * 2], j.depth[V] = (j.depth[MA] >= j.depth[be] ? j.depth[MA] : j.depth[be]) + 1, Be[MA * 2 + 1] = Be[be * 2 + 1] = V, j.heap[
                  1
                  /*SMALLEST*/
                ] = V++, ie(
                  j,
                  Be,
                  1
                  /*SMALLEST*/
                );
              while (j.heap_len >= 2);
              j.heap[--j.heap_max] = j.heap[
                1
                /*SMALLEST*/
              ], QA(j, pA), bA(Be, at, j.bl_count);
            }
            function Je(j, pA, Be) {
              var Ie, ee = -1, Me, MA = pA[1], be = 0, at = 7, V = 4;
              for (MA === 0 && (at = 138, V = 3), pA[(Be + 1) * 2 + 1] = 65535, Ie = 0; Ie <= Be; Ie++)
                Me = MA, MA = pA[(Ie + 1) * 2 + 1], !(++be < at && Me === MA) && (be < V ? j.bl_tree[Me * 2] += be : Me !== 0 ? (Me !== ee && j.bl_tree[Me * 2]++, j.bl_tree[w * 2]++) : be <= 10 ? j.bl_tree[v * 2]++ : j.bl_tree[RA * 2]++, be = 0, ee = Me, MA === 0 ? (at = 138, V = 3) : Me === MA ? (at = 6, V = 3) : (at = 7, V = 4));
            }
            function Le(j, pA, Be) {
              var Ie, ee = -1, Me, MA = pA[1], be = 0, at = 7, V = 4;
              for (MA === 0 && (at = 138, V = 3), Ie = 0; Ie <= Be; Ie++)
                if (Me = MA, MA = pA[(Ie + 1) * 2 + 1], !(++be < at && Me === MA)) {
                  if (be < V)
                    do
                      oA(j, Me, j.bl_tree);
                    while (--be !== 0);
                  else Me !== 0 ? (Me !== ee && (oA(j, Me, j.bl_tree), be--), oA(j, w, j.bl_tree), _(j, be - 3, 2)) : be <= 10 ? (oA(j, v, j.bl_tree), _(j, be - 3, 3)) : (oA(j, RA, j.bl_tree), _(j, be - 11, 7));
                  be = 0, ee = Me, MA === 0 ? (at = 138, V = 3) : Me === MA ? (at = 6, V = 3) : (at = 7, V = 4);
                }
            }
            function Re(j) {
              var pA;
              for (Je(j, j.dyn_ltree, j.l_desc.max_code), Je(j, j.dyn_dtree, j.d_desc.max_code), Pe(j, j.bl_desc), pA = CA - 1; pA >= 3 && j.bl_tree[$A[pA] * 2 + 1] === 0; pA--)
                ;
              return j.opt_len += 3 * (pA + 1) + 5 + 5 + 4, pA;
            }
            function _e(j, pA, Be, Ie) {
              var ee;
              for (_(j, pA - 257, 5), _(j, Be - 1, 5), _(j, Ie - 4, 4), ee = 0; ee < Ie; ee++)
                _(j, j.bl_tree[$A[ee] * 2 + 1], 3);
              Le(j, j.dyn_ltree, pA - 1), Le(j, j.dyn_dtree, Be - 1);
            }
            function se(j) {
              var pA = 4093624447, Be;
              for (Be = 0; Be <= 31; Be++, pA >>>= 1)
                if (pA & 1 && j.dyn_ltree[Be * 2] !== 0)
                  return d;
              if (j.dyn_ltree[18] !== 0 || j.dyn_ltree[20] !== 0 || j.dyn_ltree[26] !== 0)
                return x;
              for (Be = 32; Be < T; Be++)
                if (j.dyn_ltree[Be * 2] !== 0)
                  return x;
              return d;
            }
            var Ee = !1;
            function wA(j) {
              Ee || (y(), Ee = !0), j.l_desc = new F(j.dyn_ltree, TA), j.d_desc = new F(j.dyn_dtree, fA), j.bl_desc = new F(j.bl_tree, sA), j.bi_buf = 0, j.bi_valid = 0, M(j);
            }
            function N(j, pA, Be, Ie) {
              _(j, (D << 1) + (Ie ? 1 : 0), 3), dA(j, pA, Be);
            }
            function G(j) {
              _(j, J << 1, 3), oA(j, uA, WA), rA(j);
            }
            function W(j, pA, Be, Ie) {
              var ee, Me, MA = 0;
              j.level > 0 ? (j.strm.data_type === U && (j.strm.data_type = se(j)), Pe(j, j.l_desc), Pe(j, j.d_desc), MA = Re(j), ee = j.opt_len + 3 + 7 >>> 3, Me = j.static_len + 3 + 7 >>> 3, Me <= ee && (ee = Me)) : ee = Me = Be + 5, Be + 4 <= ee && pA !== -1 ? N(j, pA, Be, Ie) : j.strategy === a || Me === ee ? (_(j, (J << 1) + (Ie ? 1 : 0), 3), KA(j, WA, EA)) : (_(j, (q << 1) + (Ie ? 1 : 0), 3), _e(j, j.l_desc.max_code + 1, j.d_desc.max_code + 1, MA + 1), KA(j, j.dyn_ltree, j.dyn_dtree)), M(j), Ie && FA(j);
            }
            function aA(j, pA, Be) {
              return j.pending_buf[j.d_buf + j.last_lit * 2] = pA >>> 8 & 255, j.pending_buf[j.d_buf + j.last_lit * 2 + 1] = pA & 255, j.pending_buf[j.l_buf + j.last_lit] = Be & 255, j.last_lit++, pA === 0 ? j.dyn_ltree[Be * 2]++ : (j.matches++, pA--, j.dyn_ltree[(OA[Be] + T + 1) * 2]++, j.dyn_dtree[o(pA) * 2]++), j.last_lit === j.lit_bufsize - 1;
            }
            B._tr_init = wA, B._tr_stored_block = N, B._tr_flush_block = W, B._tr_tally = aA, B._tr_align = G;
          },
          /***/
          7468(Q) {
            function B() {
              this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
            }
            Q.exports = B;
          },
          /***/
          884(Q) {
            Q.exports = [
              "Float16Array",
              "Float32Array",
              "Float64Array",
              "Int8Array",
              "Int16Array",
              "Int32Array",
              "Uint8Array",
              "Uint8ClampedArray",
              "Uint16Array",
              "Uint32Array",
              "BigInt64Array",
              "BigUint64Array"
            ];
          },
          /***/
          9964(Q) {
            var B = Q.exports = {}, r, A;
            function a() {
              throw new Error("setTimeout has not been defined");
            }
            function d() {
              throw new Error("clearTimeout has not been defined");
            }
            (function() {
              try {
                typeof setTimeout == "function" ? r = setTimeout : r = a;
              } catch {
                r = a;
              }
              try {
                typeof clearTimeout == "function" ? A = clearTimeout : A = d;
              } catch {
                A = d;
              }
            })();
            function x(H) {
              if (r === setTimeout)
                return setTimeout(H, 0);
              if ((r === a || !r) && setTimeout)
                return r = setTimeout, setTimeout(H, 0);
              try {
                return r(H, 0);
              } catch {
                try {
                  return r.call(null, H, 0);
                } catch {
                  return r.call(this, H, 0);
                }
              }
            }
            function U(H) {
              if (A === clearTimeout)
                return clearTimeout(H);
              if ((A === d || !A) && clearTimeout)
                return A = clearTimeout, clearTimeout(H);
              try {
                return A(H);
              } catch {
                try {
                  return A.call(null, H);
                } catch {
                  return A.call(this, H);
                }
              }
            }
            var P = [], D = !1, J, q = -1;
            function AA() {
              !D || !J || (D = !1, J.length ? P = J.concat(P) : q = -1, P.length && K());
            }
            function K() {
              if (!D) {
                var H = x(AA);
                D = !0;
                for (var eA = P.length; eA; ) {
                  for (J = P, P = []; ++q < eA; )
                    J && J[q].run();
                  q = -1, eA = P.length;
                }
                J = null, D = !1, U(H);
              }
            }
            B.nextTick = function(H) {
              var eA = new Array(arguments.length - 1);
              if (arguments.length > 1)
                for (var CA = 1; CA < arguments.length; CA++)
                  eA[CA - 1] = arguments[CA];
              P.push(new z(H, eA)), P.length === 1 && !D && x(K);
            };
            function z(H, eA) {
              this.fun = H, this.array = eA;
            }
            z.prototype.run = function() {
              this.fun.apply(null, this.array);
            }, B.title = "browser", B.browser = !0, B.env = {}, B.argv = [], B.version = "", B.versions = {};
            function T() {
            }
            B.on = T, B.addListener = T, B.once = T, B.off = T, B.removeListener = T, B.removeAllListeners = T, B.emit = T, B.prependListener = T, B.prependOnceListener = T, B.listeners = function(H) {
              return [];
            }, B.binding = function(H) {
              throw new Error("process.binding is not supported");
            }, B.cwd = function() {
              return "/";
            }, B.chdir = function(H) {
              throw new Error("process.chdir is not supported");
            }, B.umask = function() {
              return 0;
            };
          },
          /***/
          8843(Q, B, r) {
            var A = r(2774), a = r(1689), d = A("RegExp.prototype.exec"), x = r(6785);
            Q.exports = function(P) {
              if (!a(P))
                throw new x("`regex` must be a RegExp");
              return function(J) {
                return d(P, J) !== null;
              };
            };
          },
          /***/
          1733(Q, B, r) {
            var A = r(783).Buffer;
            (function(a) {
              a.parser = function(y, M) {
                return new x(y, M);
              }, a.SAXParser = x, a.SAXStream = z, a.createStream = AA, a.MAX_BUFFER_LENGTH = 65536;
              var d = [
                "comment",
                "sgmlDecl",
                "textNode",
                "tagName",
                "doctype",
                "procInstName",
                "procInstBody",
                "entity",
                "attribName",
                "attribValue",
                "cdata",
                "script"
              ];
              a.EVENTS = [
                "text",
                "processinginstruction",
                "sgmldeclaration",
                "doctype",
                "comment",
                "opentagstart",
                "attribute",
                "opentag",
                "closetag",
                "opencdata",
                "cdata",
                "closecdata",
                "error",
                "end",
                "ready",
                "script",
                "opennamespace",
                "closenamespace"
              ];
              function x(y, M) {
                if (!(this instanceof x))
                  return new x(y, M);
                var FA = this;
                P(FA), FA.q = FA.c = "", FA.bufferCheckPosition = a.MAX_BUFFER_LENGTH, FA.encoding = null, FA.opt = M || {}, FA.opt.lowercase = FA.opt.lowercase || FA.opt.lowercasetags, FA.looseCase = FA.opt.lowercase ? "toLowerCase" : "toUpperCase", FA.opt.maxEntityCount = FA.opt.maxEntityCount || 512, FA.opt.maxEntityDepth = FA.opt.maxEntityDepth || 4, FA.entityCount = FA.entityDepth = 0, FA.tags = [], FA.closed = FA.closedRoot = FA.sawRoot = !1, FA.tag = FA.error = null, FA.strict = !!y, FA.noscript = !!(y || FA.opt.noscript), FA.state = cA.BEGIN, FA.strictEntities = FA.opt.strictEntities, FA.ENTITIES = FA.strictEntities ? Object.create(a.XML_ENTITIES) : Object.create(a.ENTITIES), FA.attribList = [], FA.opt.xmlns && (FA.ns = Object.create(IA)), FA.opt.unquotedAttributeValues === void 0 && (FA.opt.unquotedAttributeValues = !y), FA.trackPosition = FA.opt.position !== !1, FA.trackPosition && (FA.position = FA.line = FA.column = 0), kA(FA, "onready");
              }
              Object.create || (Object.create = function(y) {
                function M() {
                }
                M.prototype = y;
                var FA = new M();
                return FA;
              }), Object.keys || (Object.keys = function(y) {
                var M = [];
                for (var FA in y) y.hasOwnProperty(FA) && M.push(FA);
                return M;
              });
              function U(y) {
                for (var M = Math.max(a.MAX_BUFFER_LENGTH, 10), FA = 0, dA = 0, he = d.length; dA < he; dA++) {
                  var ie = y[d[dA]].length;
                  if (ie > M)
                    switch (d[dA]) {
                      case "textNode":
                        LA(y);
                        break;
                      case "cdata":
                        xA(y, "oncdata", y.cdata), y.cdata = "";
                        break;
                      case "script":
                        xA(y, "onscript", y.script), y.script = "";
                        break;
                      default:
                        TA(y, "Max buffer length exceeded: " + d[dA]);
                    }
                  FA = Math.max(FA, ie);
                }
                var KA = a.MAX_BUFFER_LENGTH - FA;
                y.bufferCheckPosition = KA + y.position;
              }
              function P(y) {
                for (var M = 0, FA = d.length; M < FA; M++)
                  y[d[M]] = "";
              }
              function D(y) {
                LA(y), y.cdata !== "" && (xA(y, "oncdata", y.cdata), y.cdata = ""), y.script !== "" && (xA(y, "onscript", y.script), y.script = "");
              }
              x.prototype = {
                end: function() {
                  fA(this);
                },
                write: bA,
                resume: function() {
                  return this.error = null, this;
                },
                close: function() {
                  return this.write(null);
                },
                flush: function() {
                  D(this);
                }
              };
              var J;
              try {
                J = r(9760).Stream;
              } catch {
                J = function() {
                };
              }
              J || (J = function() {
              });
              var q = a.EVENTS.filter(function(y) {
                return y !== "error" && y !== "end";
              });
              function AA(y, M) {
                return new z(y, M);
              }
              function K(y, M) {
                if (y.length >= 2) {
                  if (y[0] === 255 && y[1] === 254)
                    return "utf-16le";
                  if (y[0] === 254 && y[1] === 255)
                    return "utf-16be";
                }
                return y.length >= 3 && y[0] === 239 && y[1] === 187 && y[2] === 191 ? "utf8" : y.length >= 4 ? y[0] === 60 && y[1] === 0 && y[2] === 63 && y[3] === 0 ? "utf-16le" : y[0] === 0 && y[1] === 60 && y[2] === 0 && y[3] === 63 ? "utf-16be" : "utf8" : M ? "utf8" : null;
              }
              function z(y, M) {
                if (!(this instanceof z))
                  return new z(y, M);
                J.apply(this), this._parser = new x(y, M), this.writable = !0, this.readable = !0;
                var FA = this;
                this._parser.onend = function() {
                  FA.emit("end");
                }, this._parser.onerror = function(dA) {
                  FA.emit("error", dA), FA._parser.error = null;
                }, this._decoder = null, this._decoderBuffer = null, q.forEach(function(dA) {
                  Object.defineProperty(FA, "on" + dA, {
                    get: function() {
                      return FA._parser["on" + dA];
                    },
                    set: function(he) {
                      if (!he)
                        return FA.removeAllListeners(dA), FA._parser["on" + dA] = he, he;
                      FA.on(dA, he);
                    },
                    enumerable: !0,
                    configurable: !1
                  });
                });
              }
              z.prototype = Object.create(J.prototype, {
                constructor: {
                  value: z
                }
              }), z.prototype._decodeBuffer = function(y, M) {
                if (this._decoderBuffer && (y = A.concat([this._decoderBuffer, y]), this._decoderBuffer = null), !this._decoder) {
                  var FA = K(y, M);
                  if (!FA)
                    return this._decoderBuffer = y, "";
                  this._parser.encoding = FA, this._decoder = new TextDecoder(FA);
                }
                return this._decoder.decode(y, { stream: !M });
              }, z.prototype.write = function(y) {
                if (typeof A == "function" && typeof A.isBuffer == "function" && A.isBuffer(y))
                  y = this._decodeBuffer(y, !1);
                else if (this._decoderBuffer) {
                  var M = this._decodeBuffer(A.alloc(0), !0);
                  M && (this._parser.write(M), this.emit("data", M));
                }
                return this._parser.write(y.toString()), this.emit("data", y), !0;
              }, z.prototype.end = function(y) {
                if (y && y.length && this.write(y), this._decoderBuffer) {
                  var M = this._decodeBuffer(A.alloc(0), !0);
                  M && (this._parser.write(M), this.emit("data", M));
                } else if (this._decoder) {
                  var FA = this._decoder.decode();
                  FA && (this._parser.write(FA), this.emit("data", FA));
                }
                return this._parser.end(), !0;
              }, z.prototype.on = function(y, M) {
                var FA = this;
                return !FA._parser["on" + y] && q.indexOf(y) !== -1 && (FA._parser["on" + y] = function() {
                  var dA = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                  dA.splice(0, 0, y), FA.emit.apply(FA, dA);
                }), J.prototype.on.call(FA, y, M);
              };
              var T = "[CDATA[", H = "DOCTYPE", eA = "http://www.w3.org/XML/1998/namespace", CA = "http://www.w3.org/2000/xmlns/", IA = { xml: eA, xmlns: CA }, k = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, tA = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, lA = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, uA = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
              function w(y) {
                return y === " " || y === `
` || y === "\r" || y === "	";
              }
              function v(y) {
                return y === '"' || y === "'";
              }
              function RA(y) {
                return y === ">" || w(y);
              }
              function DA(y, M) {
                return y.test(M);
              }
              function $(y, M) {
                return !DA(y, M);
              }
              var cA = 0;
              a.STATE = {
                BEGIN: cA++,
                // leading byte order mark or whitespace
                BEGIN_WHITESPACE: cA++,
                // leading whitespace
                TEXT: cA++,
                // general stuff
                TEXT_ENTITY: cA++,
                // &amp and such.
                OPEN_WAKA: cA++,
                // <
                SGML_DECL: cA++,
                // <!BLARG
                SGML_DECL_QUOTED: cA++,
                // <!BLARG foo "bar
                DOCTYPE: cA++,
                // <!DOCTYPE
                DOCTYPE_QUOTED: cA++,
                // <!DOCTYPE "//blah
                DOCTYPE_DTD: cA++,
                // <!DOCTYPE "//blah" [ ...
                DOCTYPE_DTD_QUOTED: cA++,
                // <!DOCTYPE "//blah" [ "foo
                COMMENT_STARTING: cA++,
                // <!-
                COMMENT: cA++,
                // <!--
                COMMENT_ENDING: cA++,
                // <!-- blah -
                COMMENT_ENDED: cA++,
                // <!-- blah --
                CDATA: cA++,
                // <![CDATA[ something
                CDATA_ENDING: cA++,
                // ]
                CDATA_ENDING_2: cA++,
                // ]]
                PROC_INST: cA++,
                // <?hi
                PROC_INST_BODY: cA++,
                // <?hi there
                PROC_INST_ENDING: cA++,
                // <?hi "there" ?
                OPEN_TAG: cA++,
                // <strong
                OPEN_TAG_SLASH: cA++,
                // <strong /
                ATTRIB: cA++,
                // <a
                ATTRIB_NAME: cA++,
                // <a foo
                ATTRIB_NAME_SAW_WHITE: cA++,
                // <a foo _
                ATTRIB_VALUE: cA++,
                // <a foo=
                ATTRIB_VALUE_QUOTED: cA++,
                // <a foo="bar
                ATTRIB_VALUE_CLOSED: cA++,
                // <a foo="bar"
                ATTRIB_VALUE_UNQUOTED: cA++,
                // <a foo=bar
                ATTRIB_VALUE_ENTITY_Q: cA++,
                // <foo bar="&quot;"
                ATTRIB_VALUE_ENTITY_U: cA++,
                // <foo bar=&quot
                CLOSE_TAG: cA++,
                // </a
                CLOSE_TAG_SAW_WHITE: cA++,
                // </a   >
                SCRIPT: cA++,
                // <script> ...
                SCRIPT_ENDING: cA++
                // <script> ... <
              }, a.XML_ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'"
              }, a.ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'",
                AElig: 198,
                Aacute: 193,
                Acirc: 194,
                Agrave: 192,
                Aring: 197,
                Atilde: 195,
                Auml: 196,
                Ccedil: 199,
                ETH: 208,
                Eacute: 201,
                Ecirc: 202,
                Egrave: 200,
                Euml: 203,
                Iacute: 205,
                Icirc: 206,
                Igrave: 204,
                Iuml: 207,
                Ntilde: 209,
                Oacute: 211,
                Ocirc: 212,
                Ograve: 210,
                Oslash: 216,
                Otilde: 213,
                Ouml: 214,
                THORN: 222,
                Uacute: 218,
                Ucirc: 219,
                Ugrave: 217,
                Uuml: 220,
                Yacute: 221,
                aacute: 225,
                acirc: 226,
                aelig: 230,
                agrave: 224,
                aring: 229,
                atilde: 227,
                auml: 228,
                ccedil: 231,
                eacute: 233,
                ecirc: 234,
                egrave: 232,
                eth: 240,
                euml: 235,
                iacute: 237,
                icirc: 238,
                igrave: 236,
                iuml: 239,
                ntilde: 241,
                oacute: 243,
                ocirc: 244,
                ograve: 242,
                oslash: 248,
                otilde: 245,
                ouml: 246,
                szlig: 223,
                thorn: 254,
                uacute: 250,
                ucirc: 251,
                ugrave: 249,
                uuml: 252,
                yacute: 253,
                yuml: 255,
                copy: 169,
                reg: 174,
                nbsp: 160,
                iexcl: 161,
                cent: 162,
                pound: 163,
                curren: 164,
                yen: 165,
                brvbar: 166,
                sect: 167,
                uml: 168,
                ordf: 170,
                laquo: 171,
                not: 172,
                shy: 173,
                macr: 175,
                deg: 176,
                plusmn: 177,
                sup1: 185,
                sup2: 178,
                sup3: 179,
                acute: 180,
                micro: 181,
                para: 182,
                middot: 183,
                cedil: 184,
                ordm: 186,
                raquo: 187,
                frac14: 188,
                frac12: 189,
                frac34: 190,
                iquest: 191,
                times: 215,
                divide: 247,
                OElig: 338,
                oelig: 339,
                Scaron: 352,
                scaron: 353,
                Yuml: 376,
                fnof: 402,
                circ: 710,
                tilde: 732,
                Alpha: 913,
                Beta: 914,
                Gamma: 915,
                Delta: 916,
                Epsilon: 917,
                Zeta: 918,
                Eta: 919,
                Theta: 920,
                Iota: 921,
                Kappa: 922,
                Lambda: 923,
                Mu: 924,
                Nu: 925,
                Xi: 926,
                Omicron: 927,
                Pi: 928,
                Rho: 929,
                Sigma: 931,
                Tau: 932,
                Upsilon: 933,
                Phi: 934,
                Chi: 935,
                Psi: 936,
                Omega: 937,
                alpha: 945,
                beta: 946,
                gamma: 947,
                delta: 948,
                epsilon: 949,
                zeta: 950,
                eta: 951,
                theta: 952,
                iota: 953,
                kappa: 954,
                lambda: 955,
                mu: 956,
                nu: 957,
                xi: 958,
                omicron: 959,
                pi: 960,
                rho: 961,
                sigmaf: 962,
                sigma: 963,
                tau: 964,
                upsilon: 965,
                phi: 966,
                chi: 967,
                psi: 968,
                omega: 969,
                thetasym: 977,
                upsih: 978,
                piv: 982,
                ensp: 8194,
                emsp: 8195,
                thinsp: 8201,
                zwnj: 8204,
                zwj: 8205,
                lrm: 8206,
                rlm: 8207,
                ndash: 8211,
                mdash: 8212,
                lsquo: 8216,
                rsquo: 8217,
                sbquo: 8218,
                ldquo: 8220,
                rdquo: 8221,
                bdquo: 8222,
                dagger: 8224,
                Dagger: 8225,
                bull: 8226,
                hellip: 8230,
                permil: 8240,
                prime: 8242,
                Prime: 8243,
                lsaquo: 8249,
                rsaquo: 8250,
                oline: 8254,
                frasl: 8260,
                euro: 8364,
                image: 8465,
                weierp: 8472,
                real: 8476,
                trade: 8482,
                alefsym: 8501,
                larr: 8592,
                uarr: 8593,
                rarr: 8594,
                darr: 8595,
                harr: 8596,
                crarr: 8629,
                lArr: 8656,
                uArr: 8657,
                rArr: 8658,
                dArr: 8659,
                hArr: 8660,
                forall: 8704,
                part: 8706,
                exist: 8707,
                empty: 8709,
                nabla: 8711,
                isin: 8712,
                notin: 8713,
                ni: 8715,
                prod: 8719,
                sum: 8721,
                minus: 8722,
                lowast: 8727,
                radic: 8730,
                prop: 8733,
                infin: 8734,
                ang: 8736,
                and: 8743,
                or: 8744,
                cap: 8745,
                cup: 8746,
                int: 8747,
                there4: 8756,
                sim: 8764,
                cong: 8773,
                asymp: 8776,
                ne: 8800,
                equiv: 8801,
                le: 8804,
                ge: 8805,
                sub: 8834,
                sup: 8835,
                nsub: 8836,
                sube: 8838,
                supe: 8839,
                oplus: 8853,
                otimes: 8855,
                perp: 8869,
                sdot: 8901,
                lceil: 8968,
                rceil: 8969,
                lfloor: 8970,
                rfloor: 8971,
                lang: 9001,
                rang: 9002,
                loz: 9674,
                spades: 9824,
                clubs: 9827,
                hearts: 9829,
                diams: 9830
              }, Object.keys(a.ENTITIES).forEach(function(y) {
                var M = a.ENTITIES[y], FA = typeof M == "number" ? String.fromCharCode(M) : M;
                a.ENTITIES[y] = FA;
              });
              for (var $A in a.STATE)
                a.STATE[a.STATE[$A]] = $A;
              cA = a.STATE;
              function kA(y, M, FA) {
                y[M] && y[M](FA);
              }
              function WA(y) {
                var M = y && y.match(/(?:^|\s)encoding\s*=\s*(['"])([^'"]+)\1/i);
                return M ? M[2] : null;
              }
              function EA(y) {
                return y ? y.toLowerCase().replace(/[^a-z0-9]/g, "") : null;
              }
              function zA(y, M) {
                const FA = EA(y), dA = EA(M);
                return !FA || !dA ? !0 : dA === "utf16" ? FA === "utf16le" || FA === "utf16be" : FA === dA;
              }
              function OA(y, M) {
                if (!(!y.strict || !y.encoding || !M || M.name !== "xml")) {
                  var FA = WA(M.body);
                  FA && !zA(y.encoding, FA) && sA(
                    y,
                    "XML declaration encoding " + FA + " does not match detected stream encoding " + y.encoding.toUpperCase()
                  );
                }
              }
              function xA(y, M, FA) {
                y.textNode && LA(y), kA(y, M, FA);
              }
              function LA(y) {
                y.textNode = yA(y.opt, y.textNode), y.textNode && kA(y, "ontext", y.textNode), y.textNode = "";
              }
              function yA(y, M) {
                return y.trim && (M = M.trim()), y.normalize && (M = M.replace(/\s+/g, " ")), M;
              }
              function TA(y, M) {
                return LA(y), y.trackPosition && (M += `
Line: ` + y.line + `
Column: ` + y.column + `
Char: ` + y.c), M = new Error(M), y.error = M, kA(y, "onerror", M), y;
              }
              function fA(y) {
                return y.sawRoot && !y.closedRoot && sA(y, "Unclosed root tag"), y.state !== cA.BEGIN && y.state !== cA.BEGIN_WHITESPACE && y.state !== cA.TEXT && TA(y, "Unexpected end"), LA(y), y.c = "", y.closed = !0, kA(y, "onend"), x.call(y, y.strict, y.opt), y;
              }
              function sA(y, M) {
                if (typeof y != "object" || !(y instanceof x))
                  throw new Error("bad call to strictFail");
                y.strict && TA(y, M);
              }
              function F(y) {
                y.strict || (y.tagName = y.tagName[y.looseCase]());
                var M = y.tags[y.tags.length - 1] || y, FA = y.tag = { name: y.tagName, attributes: {} };
                y.opt.xmlns && (FA.ns = M.ns), y.attribList.length = 0, xA(y, "onopentagstart", FA);
              }
              function o(y, M) {
                var FA = y.indexOf(":"), dA = FA < 0 ? ["", y] : y.split(":"), he = dA[0], ie = dA[1];
                return M && y === "xmlns" && (he = "xmlns", ie = ""), { prefix: he, local: ie };
              }
              function h(y) {
                if (y.strict || (y.attribName = y.attribName[y.looseCase]()), y.attribList.indexOf(y.attribName) !== -1 || y.tag.attributes.hasOwnProperty(y.attribName)) {
                  y.attribName = y.attribValue = "";
                  return;
                }
                if (y.opt.xmlns) {
                  var M = o(y.attribName, !0), FA = M.prefix, dA = M.local;
                  if (FA === "xmlns")
                    if (dA === "xml" && y.attribValue !== eA)
                      sA(
                        y,
                        "xml: prefix must be bound to " + eA + `
Actual: ` + y.attribValue
                      );
                    else if (dA === "xmlns" && y.attribValue !== CA)
                      sA(
                        y,
                        "xmlns: prefix must be bound to " + CA + `
Actual: ` + y.attribValue
                      );
                    else {
                      var he = y.tag, ie = y.tags[y.tags.length - 1] || y;
                      he.ns === ie.ns && (he.ns = Object.create(ie.ns)), he.ns[dA] = y.attribValue;
                    }
                  y.attribList.push([y.attribName, y.attribValue]);
                } else
                  y.tag.attributes[y.attribName] = y.attribValue, xA(y, "onattribute", {
                    name: y.attribName,
                    value: y.attribValue
                  });
                y.attribName = y.attribValue = "";
              }
              function _(y, M) {
                if (y.opt.xmlns) {
                  var FA = y.tag, dA = o(y.tagName);
                  FA.prefix = dA.prefix, FA.local = dA.local, FA.uri = FA.ns[dA.prefix] || "", FA.prefix && !FA.uri && (sA(
                    y,
                    "Unbound namespace prefix: " + JSON.stringify(y.tagName)
                  ), FA.uri = dA.prefix);
                  var he = y.tags[y.tags.length - 1] || y;
                  FA.ns && he.ns !== FA.ns && Object.keys(FA.ns).forEach(function(N) {
                    xA(y, "onopennamespace", {
                      prefix: N,
                      uri: FA.ns[N]
                    });
                  });
                  for (var ie = 0, KA = y.attribList.length; ie < KA; ie++) {
                    var Pe = y.attribList[ie], Je = Pe[0], Le = Pe[1], Re = o(Je, !0), _e = Re.prefix, se = Re.local, Ee = _e === "" ? "" : FA.ns[_e] || "", wA = {
                      name: Je,
                      value: Le,
                      prefix: _e,
                      local: se,
                      uri: Ee
                    };
                    _e && _e !== "xmlns" && !Ee && (sA(
                      y,
                      "Unbound namespace prefix: " + JSON.stringify(_e)
                    ), wA.uri = _e), y.tag.attributes[Je] = wA, xA(y, "onattribute", wA);
                  }
                  y.attribList.length = 0;
                }
                y.tag.isSelfClosing = !!M, y.sawRoot = !0, y.tags.push(y.tag), xA(y, "onopentag", y.tag), M || (!y.noscript && y.tagName.toLowerCase() === "script" ? y.state = cA.SCRIPT : y.state = cA.TEXT, y.tag = null, y.tagName = ""), y.attribName = y.attribValue = "", y.attribList.length = 0;
              }
              function oA(y) {
                if (!y.tagName) {
                  sA(y, "Weird empty close tag."), y.textNode += "</>", y.state = cA.TEXT;
                  return;
                }
                if (y.script) {
                  if (y.tagName !== "script") {
                    y.script += "</" + y.tagName + ">", y.tagName = "", y.state = cA.SCRIPT;
                    return;
                  }
                  xA(y, "onscript", y.script), y.script = "";
                }
                var M = y.tags.length, FA = y.tagName;
                y.strict || (FA = FA[y.looseCase]());
                for (var dA = FA; M--; ) {
                  var he = y.tags[M];
                  if (he.name !== dA)
                    sA(y, "Unexpected close tag");
                  else
                    break;
                }
                if (M < 0) {
                  sA(y, "Unmatched closing tag: " + y.tagName), y.textNode += "</" + y.tagName + ">", y.state = cA.TEXT;
                  return;
                }
                y.tagName = FA;
                for (var ie = y.tags.length; ie-- > M; ) {
                  var KA = y.tag = y.tags.pop();
                  y.tagName = y.tag.name, xA(y, "onclosetag", y.tagName);
                  var Pe = {};
                  for (var Je in KA.ns)
                    Pe[Je] = KA.ns[Je];
                  var Le = y.tags[y.tags.length - 1] || y;
                  y.opt.xmlns && KA.ns !== Le.ns && Object.keys(KA.ns).forEach(function(Re) {
                    var _e = KA.ns[Re];
                    xA(y, "onclosenamespace", { prefix: Re, uri: _e });
                  });
                }
                M === 0 && (y.closedRoot = !0), y.tagName = y.attribValue = y.attribName = "", y.attribList.length = 0, y.state = cA.TEXT;
              }
              function p(y) {
                var M = y.entity, FA = M.toLowerCase(), dA, he = "";
                return y.ENTITIES[M] ? y.ENTITIES[M] : y.ENTITIES[FA] ? y.ENTITIES[FA] : (M = FA, M.charAt(0) === "#" && (M.charAt(1) === "x" ? (M = M.slice(2), dA = parseInt(M, 16), he = dA.toString(16)) : (M = M.slice(1), dA = parseInt(M, 10), he = dA.toString(10))), M = M.replace(/^0+/, ""), isNaN(dA) || he.toLowerCase() !== M || dA < 0 || dA > 1114111 ? (sA(y, "Invalid character entity"), "&" + y.entity + ";") : String.fromCodePoint(dA));
              }
              function rA(y, M) {
                M === "<" ? (y.state = cA.OPEN_WAKA, y.startTagPosition = y.position) : w(M) || (sA(y, "Non-whitespace before first tag."), y.textNode = M, y.state = cA.TEXT);
              }
              function QA(y, M) {
                var FA = "";
                return M < y.length && (FA = y.charAt(M)), FA;
              }
              function bA(y) {
                var M = this;
                if (this.error)
                  throw this.error;
                if (M.closed)
                  return TA(
                    M,
                    "Cannot write after close. Assign an onready handler."
                  );
                if (y === null)
                  return fA(M);
                typeof y == "object" && (y = y.toString());
                for (var FA = 0, dA = ""; dA = QA(y, FA++), M.c = dA, !!dA; )
                  switch (M.trackPosition && (M.position++, dA === `
` ? (M.line++, M.column = 0) : M.column++), M.state) {
                    case cA.BEGIN:
                      if (M.state = cA.BEGIN_WHITESPACE, dA === "\uFEFF")
                        continue;
                      rA(M, dA);
                      continue;
                    case cA.BEGIN_WHITESPACE:
                      rA(M, dA);
                      continue;
                    case cA.TEXT:
                      if (M.sawRoot && !M.closedRoot) {
                        for (var ie = FA - 1; dA && dA !== "<" && dA !== "&"; )
                          dA = QA(y, FA++), dA && M.trackPosition && (M.position++, dA === `
` ? (M.line++, M.column = 0) : M.column++);
                        M.textNode += y.substring(ie, FA - 1);
                      }
                      dA === "<" && !(M.sawRoot && M.closedRoot && !M.strict) ? (M.state = cA.OPEN_WAKA, M.startTagPosition = M.position) : (!w(dA) && (!M.sawRoot || M.closedRoot) && sA(M, "Text data outside of root node."), dA === "&" ? M.state = cA.TEXT_ENTITY : M.textNode += dA);
                      continue;
                    case cA.SCRIPT:
                      dA === "<" ? M.state = cA.SCRIPT_ENDING : M.script += dA;
                      continue;
                    case cA.SCRIPT_ENDING:
                      dA === "/" ? M.state = cA.CLOSE_TAG : (M.script += "<" + dA, M.state = cA.SCRIPT);
                      continue;
                    case cA.OPEN_WAKA:
                      if (dA === "!")
                        M.state = cA.SGML_DECL, M.sgmlDecl = "";
                      else if (!w(dA)) if (DA(k, dA))
                        M.state = cA.OPEN_TAG, M.tagName = dA;
                      else if (dA === "/")
                        M.state = cA.CLOSE_TAG, M.tagName = "";
                      else if (dA === "?")
                        M.state = cA.PROC_INST, M.procInstName = M.procInstBody = "";
                      else {
                        if (sA(M, "Unencoded <"), M.startTagPosition + 1 < M.position) {
                          var he = M.position - M.startTagPosition;
                          dA = new Array(he).join(" ") + dA;
                        }
                        M.textNode += "<" + dA, M.state = cA.TEXT;
                      }
                      continue;
                    case cA.SGML_DECL:
                      if (M.sgmlDecl + dA === "--") {
                        M.state = cA.COMMENT, M.comment = "", M.sgmlDecl = "";
                        continue;
                      }
                      M.doctype && M.doctype !== !0 && M.sgmlDecl ? (M.state = cA.DOCTYPE_DTD, M.doctype += "<!" + M.sgmlDecl + dA, M.sgmlDecl = "") : (M.sgmlDecl + dA).toUpperCase() === T ? (xA(M, "onopencdata"), M.state = cA.CDATA, M.sgmlDecl = "", M.cdata = "") : (M.sgmlDecl + dA).toUpperCase() === H ? (M.state = cA.DOCTYPE, (M.doctype || M.sawRoot) && sA(
                        M,
                        "Inappropriately located doctype declaration"
                      ), M.doctype = "", M.sgmlDecl = "") : dA === ">" ? (xA(M, "onsgmldeclaration", M.sgmlDecl), M.sgmlDecl = "", M.state = cA.TEXT) : (v(dA) && (M.state = cA.SGML_DECL_QUOTED), M.sgmlDecl += dA);
                      continue;
                    case cA.SGML_DECL_QUOTED:
                      dA === M.q && (M.state = cA.SGML_DECL, M.q = ""), M.sgmlDecl += dA;
                      continue;
                    case cA.DOCTYPE:
                      dA === ">" ? (M.state = cA.TEXT, xA(M, "ondoctype", M.doctype), M.doctype = !0) : (M.doctype += dA, dA === "[" ? M.state = cA.DOCTYPE_DTD : v(dA) && (M.state = cA.DOCTYPE_QUOTED, M.q = dA));
                      continue;
                    case cA.DOCTYPE_QUOTED:
                      M.doctype += dA, dA === M.q && (M.q = "", M.state = cA.DOCTYPE);
                      continue;
                    case cA.DOCTYPE_DTD:
                      dA === "]" ? (M.doctype += dA, M.state = cA.DOCTYPE) : dA === "<" ? (M.state = cA.OPEN_WAKA, M.startTagPosition = M.position) : v(dA) ? (M.doctype += dA, M.state = cA.DOCTYPE_DTD_QUOTED, M.q = dA) : M.doctype += dA;
                      continue;
                    case cA.DOCTYPE_DTD_QUOTED:
                      M.doctype += dA, dA === M.q && (M.state = cA.DOCTYPE_DTD, M.q = "");
                      continue;
                    case cA.COMMENT:
                      dA === "-" ? M.state = cA.COMMENT_ENDING : M.comment += dA;
                      continue;
                    case cA.COMMENT_ENDING:
                      dA === "-" ? (M.state = cA.COMMENT_ENDED, M.comment = yA(M.opt, M.comment), M.comment && xA(M, "oncomment", M.comment), M.comment = "") : (M.comment += "-" + dA, M.state = cA.COMMENT);
                      continue;
                    case cA.COMMENT_ENDED:
                      dA !== ">" ? (sA(M, "Malformed comment"), M.comment += "--" + dA, M.state = cA.COMMENT) : M.doctype && M.doctype !== !0 ? M.state = cA.DOCTYPE_DTD : M.state = cA.TEXT;
                      continue;
                    case cA.CDATA:
                      for (var ie = FA - 1; dA && dA !== "]"; )
                        dA = QA(y, FA++), dA && M.trackPosition && (M.position++, dA === `
` ? (M.line++, M.column = 0) : M.column++);
                      M.cdata += y.substring(ie, FA - 1), dA === "]" && (M.state = cA.CDATA_ENDING);
                      continue;
                    case cA.CDATA_ENDING:
                      dA === "]" ? M.state = cA.CDATA_ENDING_2 : (M.cdata += "]" + dA, M.state = cA.CDATA);
                      continue;
                    case cA.CDATA_ENDING_2:
                      dA === ">" ? (M.cdata && xA(M, "oncdata", M.cdata), xA(M, "onclosecdata"), M.cdata = "", M.state = cA.TEXT) : dA === "]" ? M.cdata += "]" : (M.cdata += "]]" + dA, M.state = cA.CDATA);
                      continue;
                    case cA.PROC_INST:
                      dA === "?" ? M.state = cA.PROC_INST_ENDING : w(dA) ? M.state = cA.PROC_INST_BODY : M.procInstName += dA;
                      continue;
                    case cA.PROC_INST_BODY:
                      if (!M.procInstBody && w(dA))
                        continue;
                      dA === "?" ? M.state = cA.PROC_INST_ENDING : M.procInstBody += dA;
                      continue;
                    case cA.PROC_INST_ENDING:
                      if (dA === ">") {
                        const Le = {
                          name: M.procInstName,
                          body: M.procInstBody
                        };
                        OA(M, Le), xA(M, "onprocessinginstruction", Le), M.procInstName = M.procInstBody = "", M.state = cA.TEXT;
                      } else
                        M.procInstBody += "?" + dA, M.state = cA.PROC_INST_BODY;
                      continue;
                    case cA.OPEN_TAG:
                      DA(tA, dA) ? M.tagName += dA : (F(M), dA === ">" ? _(M) : dA === "/" ? M.state = cA.OPEN_TAG_SLASH : (w(dA) || sA(M, "Invalid character in tag name"), M.state = cA.ATTRIB));
                      continue;
                    case cA.OPEN_TAG_SLASH:
                      dA === ">" ? (_(M, !0), oA(M)) : (sA(
                        M,
                        "Forward-slash in opening tag not followed by >"
                      ), M.state = cA.ATTRIB);
                      continue;
                    case cA.ATTRIB:
                      if (w(dA))
                        continue;
                      dA === ">" ? _(M) : dA === "/" ? M.state = cA.OPEN_TAG_SLASH : DA(k, dA) ? (M.attribName = dA, M.attribValue = "", M.state = cA.ATTRIB_NAME) : sA(M, "Invalid attribute name");
                      continue;
                    case cA.ATTRIB_NAME:
                      dA === "=" ? M.state = cA.ATTRIB_VALUE : dA === ">" ? (sA(M, "Attribute without value"), M.attribValue = M.attribName, h(M), _(M)) : w(dA) ? M.state = cA.ATTRIB_NAME_SAW_WHITE : DA(tA, dA) ? M.attribName += dA : sA(M, "Invalid attribute name");
                      continue;
                    case cA.ATTRIB_NAME_SAW_WHITE:
                      if (dA === "=")
                        M.state = cA.ATTRIB_VALUE;
                      else {
                        if (w(dA))
                          continue;
                        sA(M, "Attribute without value"), M.tag.attributes[M.attribName] = "", M.attribValue = "", xA(M, "onattribute", {
                          name: M.attribName,
                          value: ""
                        }), M.attribName = "", dA === ">" ? _(M) : DA(k, dA) ? (M.attribName = dA, M.state = cA.ATTRIB_NAME) : (sA(M, "Invalid attribute name"), M.state = cA.ATTRIB);
                      }
                      continue;
                    case cA.ATTRIB_VALUE:
                      if (w(dA))
                        continue;
                      v(dA) ? (M.q = dA, M.state = cA.ATTRIB_VALUE_QUOTED) : (M.opt.unquotedAttributeValues || TA(M, "Unquoted attribute value"), M.state = cA.ATTRIB_VALUE_UNQUOTED, M.attribValue = dA);
                      continue;
                    case cA.ATTRIB_VALUE_QUOTED:
                      if (dA !== M.q) {
                        dA === "&" ? M.state = cA.ATTRIB_VALUE_ENTITY_Q : M.attribValue += dA;
                        continue;
                      }
                      h(M), M.q = "", M.state = cA.ATTRIB_VALUE_CLOSED;
                      continue;
                    case cA.ATTRIB_VALUE_CLOSED:
                      w(dA) ? M.state = cA.ATTRIB : dA === ">" ? _(M) : dA === "/" ? M.state = cA.OPEN_TAG_SLASH : DA(k, dA) ? (sA(M, "No whitespace between attributes"), M.attribName = dA, M.attribValue = "", M.state = cA.ATTRIB_NAME) : sA(M, "Invalid attribute name");
                      continue;
                    case cA.ATTRIB_VALUE_UNQUOTED:
                      if (!RA(dA)) {
                        dA === "&" ? M.state = cA.ATTRIB_VALUE_ENTITY_U : M.attribValue += dA;
                        continue;
                      }
                      h(M), dA === ">" ? _(M) : M.state = cA.ATTRIB;
                      continue;
                    case cA.CLOSE_TAG:
                      if (M.tagName)
                        dA === ">" ? oA(M) : DA(tA, dA) ? M.tagName += dA : M.script ? (M.script += "</" + M.tagName + dA, M.tagName = "", M.state = cA.SCRIPT) : (w(dA) || sA(M, "Invalid tagname in closing tag"), M.state = cA.CLOSE_TAG_SAW_WHITE);
                      else {
                        if (w(dA))
                          continue;
                        $(k, dA) ? M.script ? (M.script += "</" + dA, M.state = cA.SCRIPT) : sA(M, "Invalid tagname in closing tag.") : M.tagName = dA;
                      }
                      continue;
                    case cA.CLOSE_TAG_SAW_WHITE:
                      if (w(dA))
                        continue;
                      dA === ">" ? oA(M) : sA(M, "Invalid characters in closing tag");
                      continue;
                    case cA.TEXT_ENTITY:
                    case cA.ATTRIB_VALUE_ENTITY_Q:
                    case cA.ATTRIB_VALUE_ENTITY_U:
                      var KA, Pe;
                      switch (M.state) {
                        case cA.TEXT_ENTITY:
                          KA = cA.TEXT, Pe = "textNode";
                          break;
                        case cA.ATTRIB_VALUE_ENTITY_Q:
                          KA = cA.ATTRIB_VALUE_QUOTED, Pe = "attribValue";
                          break;
                        case cA.ATTRIB_VALUE_ENTITY_U:
                          KA = cA.ATTRIB_VALUE_UNQUOTED, Pe = "attribValue";
                          break;
                      }
                      if (dA === ";") {
                        var Je = p(M);
                        M.opt.unparsedEntities && !Object.values(a.XML_ENTITIES).includes(Je) ? ((M.entityCount += 1) > M.opt.maxEntityCount && TA(
                          M,
                          "Parsed entity count exceeds max entity count"
                        ), (M.entityDepth += 1) > M.opt.maxEntityDepth && TA(
                          M,
                          "Parsed entity depth exceeds max entity depth"
                        ), M.entity = "", M.state = KA, M.write(Je), M.entityDepth -= 1) : (M[Pe] += Je, M.entity = "", M.state = KA);
                      } else DA(M.entity.length ? uA : lA, dA) ? M.entity += dA : (sA(M, "Invalid character in entity name"), M[Pe] += "&" + M.entity + dA, M.entity = "", M.state = KA);
                      continue;
                    default:
                      throw new Error(M, "Unknown state: " + M.state);
                  }
                return M.position >= M.bufferCheckPosition && U(M), M;
              }
              /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
              String.fromCodePoint || (function() {
                var y = String.fromCharCode, M = Math.floor, FA = function() {
                  var dA = 16384, he = [], ie, KA, Pe = -1, Je = arguments.length;
                  if (!Je)
                    return "";
                  for (var Le = ""; ++Pe < Je; ) {
                    var Re = Number(arguments[Pe]);
                    if (!isFinite(Re) || // `NaN`, `+Infinity`, or `-Infinity`
                    Re < 0 || // not a valid Unicode code point
                    Re > 1114111 || // not a valid Unicode code point
                    M(Re) !== Re)
                      throw RangeError("Invalid code point: " + Re);
                    Re <= 65535 ? he.push(Re) : (Re -= 65536, ie = (Re >> 10) + 55296, KA = Re % 1024 + 56320, he.push(ie, KA)), (Pe + 1 === Je || he.length > dA) && (Le += y.apply(null, he), he.length = 0);
                  }
                  return Le;
                };
                Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
                  value: FA,
                  configurable: !0,
                  writable: !0
                }) : String.fromCodePoint = FA;
              })();
            })(B);
          },
          /***/
          6255(Q, B, r) {
            var A = r(8651), a = r(9295), d = r(8890)(), x = r(8109), U = r(6785), P = A("%Math.floor%");
            Q.exports = function(J, q) {
              if (typeof J != "function")
                throw new U("`fn` is not a function");
              if (typeof q != "number" || q < 0 || q > 4294967295 || P(q) !== q)
                throw new U("`length` must be a positive 32-bit integer");
              var AA = arguments.length > 2 && !!arguments[2], K = !0, z = !0;
              if ("length" in J && x) {
                var T = x(J, "length");
                T && !T.configurable && (K = !1), T && !T.writable && (z = !1);
              }
              return (K || z || !AA) && (d ? a(
                /** @type {Parameters<define>[0]} */
                J,
                "length",
                q,
                !0,
                !0
              ) : a(
                /** @type {Parameters<define>[0]} */
                J,
                "length",
                q
              )), J;
            };
          },
          /***/
          9760(Q, B, r) {
            Q.exports = d;
            var A = r(4785).EventEmitter, a = r(9784);
            a(d, A), d.Readable = r(8261), d.Writable = r(9781), d.Duplex = r(4903), d.Transform = r(8569), d.PassThrough = r(7723), d.finished = r(2167), d.pipeline = r(3765), d.Stream = d;
            function d() {
              A.call(this);
            }
            d.prototype.pipe = function(x, U) {
              var P = this;
              function D(H) {
                x.writable && x.write(H) === !1 && P.pause && P.pause();
              }
              P.on("data", D);
              function J() {
                P.readable && P.resume && P.resume();
              }
              x.on("drain", J), !x._isStdio && (!U || U.end !== !1) && (P.on("end", AA), P.on("close", K));
              var q = !1;
              function AA() {
                q || (q = !0, x.end());
              }
              function K() {
                q || (q = !0, typeof x.destroy == "function" && x.destroy());
              }
              function z(H) {
                if (T(), A.listenerCount(this, "error") === 0)
                  throw H;
              }
              P.on("error", z), x.on("error", z);
              function T() {
                P.removeListener("data", D), x.removeListener("drain", J), P.removeListener("end", AA), P.removeListener("close", K), P.removeListener("error", z), x.removeListener("error", z), P.removeListener("end", T), P.removeListener("close", T), x.removeListener("close", T);
              }
              return P.on("end", T), P.on("close", T), x.on("close", T), x.emit("pipe", P), x;
            };
          },
          /***/
          3797(Q) {
            function B(P, D) {
              P.prototype = Object.create(D.prototype), P.prototype.constructor = P, P.__proto__ = D;
            }
            var r = {};
            function A(P, D, J) {
              J || (J = Error);
              function q(K, z, T) {
                return typeof D == "string" ? D : D(K, z, T);
              }
              var AA = /* @__PURE__ */ (function(K) {
                B(z, K);
                function z(T, H, eA) {
                  return K.call(this, q(T, H, eA)) || this;
                }
                return z;
              })(J);
              AA.prototype.name = J.name, AA.prototype.code = P, r[P] = AA;
            }
            function a(P, D) {
              if (Array.isArray(P)) {
                var J = P.length;
                return P = P.map(function(q) {
                  return String(q);
                }), J > 2 ? "one of ".concat(D, " ").concat(P.slice(0, J - 1).join(", "), ", or ") + P[J - 1] : J === 2 ? "one of ".concat(D, " ").concat(P[0], " or ").concat(P[1]) : "of ".concat(D, " ").concat(P[0]);
              } else
                return "of ".concat(D, " ").concat(String(P));
            }
            function d(P, D, J) {
              return P.substr(0, D.length) === D;
            }
            function x(P, D, J) {
              return (J === void 0 || J > P.length) && (J = P.length), P.substring(J - D.length, J) === D;
            }
            function U(P, D, J) {
              return typeof J != "number" && (J = 0), J + D.length > P.length ? !1 : P.indexOf(D, J) !== -1;
            }
            A("ERR_INVALID_OPT_VALUE", function(P, D) {
              return 'The value "' + D + '" is invalid for option "' + P + '"';
            }, TypeError), A("ERR_INVALID_ARG_TYPE", function(P, D, J) {
              var q;
              typeof D == "string" && d(D, "not ") ? (q = "must not be", D = D.replace(/^not /, "")) : q = "must be";
              var AA;
              if (x(P, " argument"))
                AA = "The ".concat(P, " ").concat(q, " ").concat(a(D, "type"));
              else {
                var K = U(P, ".") ? "property" : "argument";
                AA = 'The "'.concat(P, '" ').concat(K, " ").concat(q, " ").concat(a(D, "type"));
              }
              return AA += ". Received type ".concat(typeof J), AA;
            }, TypeError), A("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), A("ERR_METHOD_NOT_IMPLEMENTED", function(P) {
              return "The " + P + " method is not implemented";
            }), A("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), A("ERR_STREAM_DESTROYED", function(P) {
              return "Cannot call " + P + " after a stream was destroyed";
            }), A("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), A("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), A("ERR_STREAM_WRITE_AFTER_END", "write after end"), A("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), A("ERR_UNKNOWN_ENCODING", function(P) {
              return "Unknown encoding: " + P;
            }, TypeError), A("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Q.exports.F = r;
          },
          /***/
          4903(Q, B, r) {
            var A = r(9964), a = Object.keys || function(K) {
              var z = [];
              for (var T in K) z.push(T);
              return z;
            };
            Q.exports = J;
            var d = r(8261), x = r(9781);
            r(9784)(J, d);
            for (var U = a(x.prototype), P = 0; P < U.length; P++) {
              var D = U[P];
              J.prototype[D] || (J.prototype[D] = x.prototype[D]);
            }
            function J(K) {
              if (!(this instanceof J)) return new J(K);
              d.call(this, K), x.call(this, K), this.allowHalfOpen = !0, K && (K.readable === !1 && (this.readable = !1), K.writable === !1 && (this.writable = !1), K.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", q)));
            }
            Object.defineProperty(J.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            }), Object.defineProperty(J.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            }), Object.defineProperty(J.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function q() {
              this._writableState.ended || A.nextTick(AA, this);
            }
            function AA(K) {
              K.end();
            }
            Object.defineProperty(J.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
              },
              set: function(z) {
                this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = z, this._writableState.destroyed = z);
              }
            });
          },
          /***/
          7723(Q, B, r) {
            Q.exports = a;
            var A = r(8569);
            r(9784)(a, A);
            function a(d) {
              if (!(this instanceof a)) return new a(d);
              A.call(this, d);
            }
            a.prototype._transform = function(d, x, U) {
              U(null, d);
            };
          },
          /***/
          8261(Q, B, r) {
            var A = r(9964);
            Q.exports = cA;
            var a;
            cA.ReadableState = $, r(4785).EventEmitter;
            var d = function(M, FA) {
              return M.listeners(FA).length;
            }, x = r(9018), U = r(783).Buffer, P = (typeof r.g < "u" ? r.g : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
            };
            function D(y) {
              return U.from(y);
            }
            function J(y) {
              return U.isBuffer(y) || y instanceof P;
            }
            var q = r(7199), AA;
            q && q.debuglog ? AA = q.debuglog("stream") : AA = function() {
            };
            var K = r(182), z = r(7385), T = r(8130), H = T.getHighWaterMark, eA = r(3797).F, CA = eA.ERR_INVALID_ARG_TYPE, IA = eA.ERR_STREAM_PUSH_AFTER_EOF, k = eA.ERR_METHOD_NOT_IMPLEMENTED, tA = eA.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, lA, uA, w;
            r(9784)(cA, x);
            var v = z.errorOrDestroy, RA = ["error", "close", "destroy", "pause", "resume"];
            function DA(y, M, FA) {
              if (typeof y.prependListener == "function") return y.prependListener(M, FA);
              !y._events || !y._events[M] ? y.on(M, FA) : Array.isArray(y._events[M]) ? y._events[M].unshift(FA) : y._events[M] = [FA, y._events[M]];
            }
            function $(y, M, FA) {
              a = a || r(4903), y = y || {}, typeof FA != "boolean" && (FA = M instanceof a), this.objectMode = !!y.objectMode, FA && (this.objectMode = this.objectMode || !!y.readableObjectMode), this.highWaterMark = H(this, y, "readableHighWaterMark", FA), this.buffer = new K(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = y.emitClose !== !1, this.autoDestroy = !!y.autoDestroy, this.destroyed = !1, this.defaultEncoding = y.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, y.encoding && (lA || (lA = r(3143).I), this.decoder = new lA(y.encoding), this.encoding = y.encoding);
            }
            function cA(y) {
              if (a = a || r(4903), !(this instanceof cA)) return new cA(y);
              var M = this instanceof a;
              this._readableState = new $(y, this, M), this.readable = !0, y && (typeof y.read == "function" && (this._read = y.read), typeof y.destroy == "function" && (this._destroy = y.destroy)), x.call(this);
            }
            Object.defineProperty(cA.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 ? !1 : this._readableState.destroyed;
              },
              set: function(M) {
                this._readableState && (this._readableState.destroyed = M);
              }
            }), cA.prototype.destroy = z.destroy, cA.prototype._undestroy = z.undestroy, cA.prototype._destroy = function(y, M) {
              M(y);
            }, cA.prototype.push = function(y, M) {
              var FA = this._readableState, dA;
              return FA.objectMode ? dA = !0 : typeof y == "string" && (M = M || FA.defaultEncoding, M !== FA.encoding && (y = U.from(y, M), M = ""), dA = !0), $A(this, y, M, !1, dA);
            }, cA.prototype.unshift = function(y) {
              return $A(this, y, null, !0, !1);
            };
            function $A(y, M, FA, dA, he) {
              AA("readableAddChunk", M);
              var ie = y._readableState;
              if (M === null)
                ie.reading = !1, xA(y, ie);
              else {
                var KA;
                if (he || (KA = WA(ie, M)), KA)
                  v(y, KA);
                else if (ie.objectMode || M && M.length > 0)
                  if (typeof M != "string" && !ie.objectMode && Object.getPrototypeOf(M) !== U.prototype && (M = D(M)), dA)
                    ie.endEmitted ? v(y, new tA()) : kA(y, ie, M, !0);
                  else if (ie.ended)
                    v(y, new IA());
                  else {
                    if (ie.destroyed)
                      return !1;
                    ie.reading = !1, ie.decoder && !FA ? (M = ie.decoder.write(M), ie.objectMode || M.length !== 0 ? kA(y, ie, M, !1) : TA(y, ie)) : kA(y, ie, M, !1);
                  }
                else dA || (ie.reading = !1, TA(y, ie));
              }
              return !ie.ended && (ie.length < ie.highWaterMark || ie.length === 0);
            }
            function kA(y, M, FA, dA) {
              M.flowing && M.length === 0 && !M.sync ? (M.awaitDrain = 0, y.emit("data", FA)) : (M.length += M.objectMode ? 1 : FA.length, dA ? M.buffer.unshift(FA) : M.buffer.push(FA), M.needReadable && LA(y)), TA(y, M);
            }
            function WA(y, M) {
              var FA;
              return !J(M) && typeof M != "string" && M !== void 0 && !y.objectMode && (FA = new CA("chunk", ["string", "Buffer", "Uint8Array"], M)), FA;
            }
            cA.prototype.isPaused = function() {
              return this._readableState.flowing === !1;
            }, cA.prototype.setEncoding = function(y) {
              lA || (lA = r(3143).I);
              var M = new lA(y);
              this._readableState.decoder = M, this._readableState.encoding = this._readableState.decoder.encoding;
              for (var FA = this._readableState.buffer.head, dA = ""; FA !== null; )
                dA += M.write(FA.data), FA = FA.next;
              return this._readableState.buffer.clear(), dA !== "" && this._readableState.buffer.push(dA), this._readableState.length = dA.length, this;
            };
            var EA = 1073741824;
            function zA(y) {
              return y >= EA ? y = EA : (y--, y |= y >>> 1, y |= y >>> 2, y |= y >>> 4, y |= y >>> 8, y |= y >>> 16, y++), y;
            }
            function OA(y, M) {
              return y <= 0 || M.length === 0 && M.ended ? 0 : M.objectMode ? 1 : y !== y ? M.flowing && M.length ? M.buffer.head.data.length : M.length : (y > M.highWaterMark && (M.highWaterMark = zA(y)), y <= M.length ? y : M.ended ? M.length : (M.needReadable = !0, 0));
            }
            cA.prototype.read = function(y) {
              AA("read", y), y = parseInt(y, 10);
              var M = this._readableState, FA = y;
              if (y !== 0 && (M.emittedReadable = !1), y === 0 && M.needReadable && ((M.highWaterMark !== 0 ? M.length >= M.highWaterMark : M.length > 0) || M.ended))
                return AA("read: emitReadable", M.length, M.ended), M.length === 0 && M.ended ? rA(this) : LA(this), null;
              if (y = OA(y, M), y === 0 && M.ended)
                return M.length === 0 && rA(this), null;
              var dA = M.needReadable;
              AA("need readable", dA), (M.length === 0 || M.length - y < M.highWaterMark) && (dA = !0, AA("length less than watermark", dA)), M.ended || M.reading ? (dA = !1, AA("reading or ended", dA)) : dA && (AA("do read"), M.reading = !0, M.sync = !0, M.length === 0 && (M.needReadable = !0), this._read(M.highWaterMark), M.sync = !1, M.reading || (y = OA(FA, M)));
              var he;
              return y > 0 ? he = p(y, M) : he = null, he === null ? (M.needReadable = M.length <= M.highWaterMark, y = 0) : (M.length -= y, M.awaitDrain = 0), M.length === 0 && (M.ended || (M.needReadable = !0), FA !== y && M.ended && rA(this)), he !== null && this.emit("data", he), he;
            };
            function xA(y, M) {
              if (AA("onEofChunk"), !M.ended) {
                if (M.decoder) {
                  var FA = M.decoder.end();
                  FA && FA.length && (M.buffer.push(FA), M.length += M.objectMode ? 1 : FA.length);
                }
                M.ended = !0, M.sync ? LA(y) : (M.needReadable = !1, M.emittedReadable || (M.emittedReadable = !0, yA(y)));
              }
            }
            function LA(y) {
              var M = y._readableState;
              AA("emitReadable", M.needReadable, M.emittedReadable), M.needReadable = !1, M.emittedReadable || (AA("emitReadable", M.flowing), M.emittedReadable = !0, A.nextTick(yA, y));
            }
            function yA(y) {
              var M = y._readableState;
              AA("emitReadable_", M.destroyed, M.length, M.ended), !M.destroyed && (M.length || M.ended) && (y.emit("readable"), M.emittedReadable = !1), M.needReadable = !M.flowing && !M.ended && M.length <= M.highWaterMark, oA(y);
            }
            function TA(y, M) {
              M.readingMore || (M.readingMore = !0, A.nextTick(fA, y, M));
            }
            function fA(y, M) {
              for (; !M.reading && !M.ended && (M.length < M.highWaterMark || M.flowing && M.length === 0); ) {
                var FA = M.length;
                if (AA("maybeReadMore read 0"), y.read(0), FA === M.length)
                  break;
              }
              M.readingMore = !1;
            }
            cA.prototype._read = function(y) {
              v(this, new k("_read()"));
            }, cA.prototype.pipe = function(y, M) {
              var FA = this, dA = this._readableState;
              switch (dA.pipesCount) {
                case 0:
                  dA.pipes = y;
                  break;
                case 1:
                  dA.pipes = [dA.pipes, y];
                  break;
                default:
                  dA.pipes.push(y);
                  break;
              }
              dA.pipesCount += 1, AA("pipe count=%d opts=%j", dA.pipesCount, M);
              var he = (!M || M.end !== !1) && y !== A.stdout && y !== A.stderr, ie = he ? Pe : N;
              dA.endEmitted ? A.nextTick(ie) : FA.once("end", ie), y.on("unpipe", KA);
              function KA(G, W) {
                AA("onunpipe"), G === FA && W && W.hasUnpiped === !1 && (W.hasUnpiped = !0, Re());
              }
              function Pe() {
                AA("onend"), y.end();
              }
              var Je = sA(FA);
              y.on("drain", Je);
              var Le = !1;
              function Re() {
                AA("cleanup"), y.removeListener("close", Ee), y.removeListener("finish", wA), y.removeListener("drain", Je), y.removeListener("error", se), y.removeListener("unpipe", KA), FA.removeListener("end", Pe), FA.removeListener("end", N), FA.removeListener("data", _e), Le = !0, dA.awaitDrain && (!y._writableState || y._writableState.needDrain) && Je();
              }
              FA.on("data", _e);
              function _e(G) {
                AA("ondata");
                var W = y.write(G);
                AA("dest.write", W), W === !1 && ((dA.pipesCount === 1 && dA.pipes === y || dA.pipesCount > 1 && bA(dA.pipes, y) !== -1) && !Le && (AA("false write response, pause", dA.awaitDrain), dA.awaitDrain++), FA.pause());
              }
              function se(G) {
                AA("onerror", G), N(), y.removeListener("error", se), d(y, "error") === 0 && v(y, G);
              }
              DA(y, "error", se);
              function Ee() {
                y.removeListener("finish", wA), N();
              }
              y.once("close", Ee);
              function wA() {
                AA("onfinish"), y.removeListener("close", Ee), N();
              }
              y.once("finish", wA);
              function N() {
                AA("unpipe"), FA.unpipe(y);
              }
              return y.emit("pipe", FA), dA.flowing || (AA("pipe resume"), FA.resume()), y;
            };
            function sA(y) {
              return function() {
                var FA = y._readableState;
                AA("pipeOnDrain", FA.awaitDrain), FA.awaitDrain && FA.awaitDrain--, FA.awaitDrain === 0 && d(y, "data") && (FA.flowing = !0, oA(y));
              };
            }
            cA.prototype.unpipe = function(y) {
              var M = this._readableState, FA = {
                hasUnpiped: !1
              };
              if (M.pipesCount === 0) return this;
              if (M.pipesCount === 1)
                return y && y !== M.pipes ? this : (y || (y = M.pipes), M.pipes = null, M.pipesCount = 0, M.flowing = !1, y && y.emit("unpipe", this, FA), this);
              if (!y) {
                var dA = M.pipes, he = M.pipesCount;
                M.pipes = null, M.pipesCount = 0, M.flowing = !1;
                for (var ie = 0; ie < he; ie++) dA[ie].emit("unpipe", this, {
                  hasUnpiped: !1
                });
                return this;
              }
              var KA = bA(M.pipes, y);
              return KA === -1 ? this : (M.pipes.splice(KA, 1), M.pipesCount -= 1, M.pipesCount === 1 && (M.pipes = M.pipes[0]), y.emit("unpipe", this, FA), this);
            }, cA.prototype.on = function(y, M) {
              var FA = x.prototype.on.call(this, y, M), dA = this._readableState;
              return y === "data" ? (dA.readableListening = this.listenerCount("readable") > 0, dA.flowing !== !1 && this.resume()) : y === "readable" && !dA.endEmitted && !dA.readableListening && (dA.readableListening = dA.needReadable = !0, dA.flowing = !1, dA.emittedReadable = !1, AA("on readable", dA.length, dA.reading), dA.length ? LA(this) : dA.reading || A.nextTick(o, this)), FA;
            }, cA.prototype.addListener = cA.prototype.on, cA.prototype.removeListener = function(y, M) {
              var FA = x.prototype.removeListener.call(this, y, M);
              return y === "readable" && A.nextTick(F, this), FA;
            }, cA.prototype.removeAllListeners = function(y) {
              var M = x.prototype.removeAllListeners.apply(this, arguments);
              return (y === "readable" || y === void 0) && A.nextTick(F, this), M;
            };
            function F(y) {
              var M = y._readableState;
              M.readableListening = y.listenerCount("readable") > 0, M.resumeScheduled && !M.paused ? M.flowing = !0 : y.listenerCount("data") > 0 && y.resume();
            }
            function o(y) {
              AA("readable nexttick read 0"), y.read(0);
            }
            cA.prototype.resume = function() {
              var y = this._readableState;
              return y.flowing || (AA("resume"), y.flowing = !y.readableListening, h(this, y)), y.paused = !1, this;
            };
            function h(y, M) {
              M.resumeScheduled || (M.resumeScheduled = !0, A.nextTick(_, y, M));
            }
            function _(y, M) {
              AA("resume", M.reading), M.reading || y.read(0), M.resumeScheduled = !1, y.emit("resume"), oA(y), M.flowing && !M.reading && y.read(0);
            }
            cA.prototype.pause = function() {
              return AA("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (AA("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function oA(y) {
              var M = y._readableState;
              for (AA("flow", M.flowing); M.flowing && y.read() !== null; ) ;
            }
            cA.prototype.wrap = function(y) {
              var M = this, FA = this._readableState, dA = !1;
              y.on("end", function() {
                if (AA("wrapped end"), FA.decoder && !FA.ended) {
                  var KA = FA.decoder.end();
                  KA && KA.length && M.push(KA);
                }
                M.push(null);
              }), y.on("data", function(KA) {
                if (AA("wrapped data"), FA.decoder && (KA = FA.decoder.write(KA)), !(FA.objectMode && KA == null) && !(!FA.objectMode && (!KA || !KA.length))) {
                  var Pe = M.push(KA);
                  Pe || (dA = !0, y.pause());
                }
              });
              for (var he in y)
                this[he] === void 0 && typeof y[he] == "function" && (this[he] = /* @__PURE__ */ (function(Pe) {
                  return function() {
                    return y[Pe].apply(y, arguments);
                  };
                })(he));
              for (var ie = 0; ie < RA.length; ie++)
                y.on(RA[ie], this.emit.bind(this, RA[ie]));
              return this._read = function(KA) {
                AA("wrapped _read", KA), dA && (dA = !1, y.resume());
              }, this;
            }, typeof Symbol == "function" && (cA.prototype[Symbol.asyncIterator] = function() {
              return uA === void 0 && (uA = r(9676)), uA(this);
            }), Object.defineProperty(cA.prototype, "readableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.highWaterMark;
              }
            }), Object.defineProperty(cA.prototype, "readableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState && this._readableState.buffer;
              }
            }), Object.defineProperty(cA.prototype, "readableFlowing", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.flowing;
              },
              set: function(M) {
                this._readableState && (this._readableState.flowing = M);
              }
            }), cA._fromList = p, Object.defineProperty(cA.prototype, "readableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.length;
              }
            });
            function p(y, M) {
              if (M.length === 0) return null;
              var FA;
              return M.objectMode ? FA = M.buffer.shift() : !y || y >= M.length ? (M.decoder ? FA = M.buffer.join("") : M.buffer.length === 1 ? FA = M.buffer.first() : FA = M.buffer.concat(M.length), M.buffer.clear()) : FA = M.buffer.consume(y, M.decoder), FA;
            }
            function rA(y) {
              var M = y._readableState;
              AA("endReadable", M.endEmitted), M.endEmitted || (M.ended = !0, A.nextTick(QA, M, y));
            }
            function QA(y, M) {
              if (AA("endReadableNT", y.endEmitted, y.length), !y.endEmitted && y.length === 0 && (y.endEmitted = !0, M.readable = !1, M.emit("end"), y.autoDestroy)) {
                var FA = M._writableState;
                (!FA || FA.autoDestroy && FA.finished) && M.destroy();
              }
            }
            typeof Symbol == "function" && (cA.from = function(y, M) {
              return w === void 0 && (w = r(378)), w(cA, y, M);
            });
            function bA(y, M) {
              for (var FA = 0, dA = y.length; FA < dA; FA++)
                if (y[FA] === M) return FA;
              return -1;
            }
          },
          /***/
          8569(Q, B, r) {
            Q.exports = J;
            var A = r(3797).F, a = A.ERR_METHOD_NOT_IMPLEMENTED, d = A.ERR_MULTIPLE_CALLBACK, x = A.ERR_TRANSFORM_ALREADY_TRANSFORMING, U = A.ERR_TRANSFORM_WITH_LENGTH_0, P = r(4903);
            r(9784)(J, P);
            function D(K, z) {
              var T = this._transformState;
              T.transforming = !1;
              var H = T.writecb;
              if (H === null)
                return this.emit("error", new d());
              T.writechunk = null, T.writecb = null, z != null && this.push(z), H(K);
              var eA = this._readableState;
              eA.reading = !1, (eA.needReadable || eA.length < eA.highWaterMark) && this._read(eA.highWaterMark);
            }
            function J(K) {
              if (!(this instanceof J)) return new J(K);
              P.call(this, K), this._transformState = {
                afterTransform: D.bind(this),
                needTransform: !1,
                transforming: !1,
                writecb: null,
                writechunk: null,
                writeencoding: null
              }, this._readableState.needReadable = !0, this._readableState.sync = !1, K && (typeof K.transform == "function" && (this._transform = K.transform), typeof K.flush == "function" && (this._flush = K.flush)), this.on("prefinish", q);
            }
            function q() {
              var K = this;
              typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(z, T) {
                AA(K, z, T);
              }) : AA(this, null, null);
            }
            J.prototype.push = function(K, z) {
              return this._transformState.needTransform = !1, P.prototype.push.call(this, K, z);
            }, J.prototype._transform = function(K, z, T) {
              T(new a("_transform()"));
            }, J.prototype._write = function(K, z, T) {
              var H = this._transformState;
              if (H.writecb = T, H.writechunk = K, H.writeencoding = z, !H.transforming) {
                var eA = this._readableState;
                (H.needTransform || eA.needReadable || eA.length < eA.highWaterMark) && this._read(eA.highWaterMark);
              }
            }, J.prototype._read = function(K) {
              var z = this._transformState;
              z.writechunk !== null && !z.transforming ? (z.transforming = !0, this._transform(z.writechunk, z.writeencoding, z.afterTransform)) : z.needTransform = !0;
            }, J.prototype._destroy = function(K, z) {
              P.prototype._destroy.call(this, K, function(T) {
                z(T);
              });
            };
            function AA(K, z, T) {
              if (z) return K.emit("error", z);
              if (T != null && K.push(T), K._writableState.length) throw new U();
              if (K._transformState.transforming) throw new x();
              return K.push(null);
            }
          },
          /***/
          9781(Q, B, r) {
            var A = r(9964);
            Q.exports = $;
            function a(oA) {
              var p = this;
              this.next = null, this.entry = null, this.finish = function() {
                _(p, oA);
              };
            }
            var d;
            $.WritableState = RA;
            var x = {
              deprecate: r(6465)
            }, U = r(9018), P = r(783).Buffer, D = (typeof r.g < "u" ? r.g : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
            };
            function J(oA) {
              return P.from(oA);
            }
            function q(oA) {
              return P.isBuffer(oA) || oA instanceof D;
            }
            var AA = r(7385), K = r(8130), z = K.getHighWaterMark, T = r(3797).F, H = T.ERR_INVALID_ARG_TYPE, eA = T.ERR_METHOD_NOT_IMPLEMENTED, CA = T.ERR_MULTIPLE_CALLBACK, IA = T.ERR_STREAM_CANNOT_PIPE, k = T.ERR_STREAM_DESTROYED, tA = T.ERR_STREAM_NULL_VALUES, lA = T.ERR_STREAM_WRITE_AFTER_END, uA = T.ERR_UNKNOWN_ENCODING, w = AA.errorOrDestroy;
            r(9784)($, U);
            function v() {
            }
            function RA(oA, p, rA) {
              d = d || r(4903), oA = oA || {}, typeof rA != "boolean" && (rA = p instanceof d), this.objectMode = !!oA.objectMode, rA && (this.objectMode = this.objectMode || !!oA.writableObjectMode), this.highWaterMark = z(this, oA, "writableHighWaterMark", rA), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var QA = oA.decodeStrings === !1;
              this.decodeStrings = !QA, this.defaultEncoding = oA.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(bA) {
                xA(p, bA);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = oA.emitClose !== !1, this.autoDestroy = !!oA.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
            }
            RA.prototype.getBuffer = function() {
              for (var p = this.bufferedRequest, rA = []; p; )
                rA.push(p), p = p.next;
              return rA;
            }, (function() {
              try {
                Object.defineProperty(RA.prototype, "buffer", {
                  get: x.deprecate(function() {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch {
              }
            })();
            var DA;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (DA = Function.prototype[Symbol.hasInstance], Object.defineProperty($, Symbol.hasInstance, {
              value: function(p) {
                return DA.call(this, p) ? !0 : this !== $ ? !1 : p && p._writableState instanceof RA;
              }
            })) : DA = function(p) {
              return p instanceof this;
            };
            function $(oA) {
              d = d || r(4903);
              var p = this instanceof d;
              if (!p && !DA.call($, this)) return new $(oA);
              this._writableState = new RA(oA, this, p), this.writable = !0, oA && (typeof oA.write == "function" && (this._write = oA.write), typeof oA.writev == "function" && (this._writev = oA.writev), typeof oA.destroy == "function" && (this._destroy = oA.destroy), typeof oA.final == "function" && (this._final = oA.final)), U.call(this);
            }
            $.prototype.pipe = function() {
              w(this, new IA());
            };
            function cA(oA, p) {
              var rA = new lA();
              w(oA, rA), A.nextTick(p, rA);
            }
            function $A(oA, p, rA, QA) {
              var bA;
              return rA === null ? bA = new tA() : typeof rA != "string" && !p.objectMode && (bA = new H("chunk", ["string", "Buffer"], rA)), bA ? (w(oA, bA), A.nextTick(QA, bA), !1) : !0;
            }
            $.prototype.write = function(oA, p, rA) {
              var QA = this._writableState, bA = !1, y = !QA.objectMode && q(oA);
              return y && !P.isBuffer(oA) && (oA = J(oA)), typeof p == "function" && (rA = p, p = null), y ? p = "buffer" : p || (p = QA.defaultEncoding), typeof rA != "function" && (rA = v), QA.ending ? cA(this, rA) : (y || $A(this, QA, oA, rA)) && (QA.pendingcb++, bA = WA(this, QA, y, oA, p, rA)), bA;
            }, $.prototype.cork = function() {
              this._writableState.corked++;
            }, $.prototype.uncork = function() {
              var oA = this._writableState;
              oA.corked && (oA.corked--, !oA.writing && !oA.corked && !oA.bufferProcessing && oA.bufferedRequest && TA(this, oA));
            }, $.prototype.setDefaultEncoding = function(p) {
              if (typeof p == "string" && (p = p.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((p + "").toLowerCase()) > -1)) throw new uA(p);
              return this._writableState.defaultEncoding = p, this;
            }, Object.defineProperty($.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            });
            function kA(oA, p, rA) {
              return !oA.objectMode && oA.decodeStrings !== !1 && typeof p == "string" && (p = P.from(p, rA)), p;
            }
            Object.defineProperty($.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            });
            function WA(oA, p, rA, QA, bA, y) {
              if (!rA) {
                var M = kA(p, QA, bA);
                QA !== M && (rA = !0, bA = "buffer", QA = M);
              }
              var FA = p.objectMode ? 1 : QA.length;
              p.length += FA;
              var dA = p.length < p.highWaterMark;
              if (dA || (p.needDrain = !0), p.writing || p.corked) {
                var he = p.lastBufferedRequest;
                p.lastBufferedRequest = {
                  chunk: QA,
                  encoding: bA,
                  isBuf: rA,
                  callback: y,
                  next: null
                }, he ? he.next = p.lastBufferedRequest : p.bufferedRequest = p.lastBufferedRequest, p.bufferedRequestCount += 1;
              } else
                EA(oA, p, !1, FA, QA, bA, y);
              return dA;
            }
            function EA(oA, p, rA, QA, bA, y, M) {
              p.writelen = QA, p.writecb = M, p.writing = !0, p.sync = !0, p.destroyed ? p.onwrite(new k("write")) : rA ? oA._writev(bA, p.onwrite) : oA._write(bA, y, p.onwrite), p.sync = !1;
            }
            function zA(oA, p, rA, QA, bA) {
              --p.pendingcb, rA ? (A.nextTick(bA, QA), A.nextTick(o, oA, p), oA._writableState.errorEmitted = !0, w(oA, QA)) : (bA(QA), oA._writableState.errorEmitted = !0, w(oA, QA), o(oA, p));
            }
            function OA(oA) {
              oA.writing = !1, oA.writecb = null, oA.length -= oA.writelen, oA.writelen = 0;
            }
            function xA(oA, p) {
              var rA = oA._writableState, QA = rA.sync, bA = rA.writecb;
              if (typeof bA != "function") throw new CA();
              if (OA(rA), p) zA(oA, rA, QA, p, bA);
              else {
                var y = fA(rA) || oA.destroyed;
                !y && !rA.corked && !rA.bufferProcessing && rA.bufferedRequest && TA(oA, rA), QA ? A.nextTick(LA, oA, rA, y, bA) : LA(oA, rA, y, bA);
              }
            }
            function LA(oA, p, rA, QA) {
              rA || yA(oA, p), p.pendingcb--, QA(), o(oA, p);
            }
            function yA(oA, p) {
              p.length === 0 && p.needDrain && (p.needDrain = !1, oA.emit("drain"));
            }
            function TA(oA, p) {
              p.bufferProcessing = !0;
              var rA = p.bufferedRequest;
              if (oA._writev && rA && rA.next) {
                var QA = p.bufferedRequestCount, bA = new Array(QA), y = p.corkedRequestsFree;
                y.entry = rA;
                for (var M = 0, FA = !0; rA; )
                  bA[M] = rA, rA.isBuf || (FA = !1), rA = rA.next, M += 1;
                bA.allBuffers = FA, EA(oA, p, !0, p.length, bA, "", y.finish), p.pendingcb++, p.lastBufferedRequest = null, y.next ? (p.corkedRequestsFree = y.next, y.next = null) : p.corkedRequestsFree = new a(p), p.bufferedRequestCount = 0;
              } else {
                for (; rA; ) {
                  var dA = rA.chunk, he = rA.encoding, ie = rA.callback, KA = p.objectMode ? 1 : dA.length;
                  if (EA(oA, p, !1, KA, dA, he, ie), rA = rA.next, p.bufferedRequestCount--, p.writing)
                    break;
                }
                rA === null && (p.lastBufferedRequest = null);
              }
              p.bufferedRequest = rA, p.bufferProcessing = !1;
            }
            $.prototype._write = function(oA, p, rA) {
              rA(new eA("_write()"));
            }, $.prototype._writev = null, $.prototype.end = function(oA, p, rA) {
              var QA = this._writableState;
              return typeof oA == "function" ? (rA = oA, oA = null, p = null) : typeof p == "function" && (rA = p, p = null), oA != null && this.write(oA, p), QA.corked && (QA.corked = 1, this.uncork()), QA.ending || h(this, QA, rA), this;
            }, Object.defineProperty($.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function fA(oA) {
              return oA.ending && oA.length === 0 && oA.bufferedRequest === null && !oA.finished && !oA.writing;
            }
            function sA(oA, p) {
              oA._final(function(rA) {
                p.pendingcb--, rA && w(oA, rA), p.prefinished = !0, oA.emit("prefinish"), o(oA, p);
              });
            }
            function F(oA, p) {
              !p.prefinished && !p.finalCalled && (typeof oA._final == "function" && !p.destroyed ? (p.pendingcb++, p.finalCalled = !0, A.nextTick(sA, oA, p)) : (p.prefinished = !0, oA.emit("prefinish")));
            }
            function o(oA, p) {
              var rA = fA(p);
              if (rA && (F(oA, p), p.pendingcb === 0 && (p.finished = !0, oA.emit("finish"), p.autoDestroy))) {
                var QA = oA._readableState;
                (!QA || QA.autoDestroy && QA.endEmitted) && oA.destroy();
              }
              return rA;
            }
            function h(oA, p, rA) {
              p.ending = !0, o(oA, p), rA && (p.finished ? A.nextTick(rA) : oA.once("finish", rA)), p.ended = !0, oA.writable = !1;
            }
            function _(oA, p, rA) {
              var QA = oA.entry;
              for (oA.entry = null; QA; ) {
                var bA = QA.callback;
                p.pendingcb--, bA(rA), QA = QA.next;
              }
              p.corkedRequestsFree.next = oA;
            }
            Object.defineProperty($.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState === void 0 ? !1 : this._writableState.destroyed;
              },
              set: function(p) {
                this._writableState && (this._writableState.destroyed = p);
              }
            }), $.prototype.destroy = AA.destroy, $.prototype._undestroy = AA.undestroy, $.prototype._destroy = function(oA, p) {
              p(oA);
            };
          },
          /***/
          9676(Q, B, r) {
            var A = r(9964), a;
            function d(uA, w, v) {
              return w = x(w), w in uA ? Object.defineProperty(uA, w, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : uA[w] = v, uA;
            }
            function x(uA) {
              var w = U(uA, "string");
              return typeof w == "symbol" ? w : String(w);
            }
            function U(uA, w) {
              if (typeof uA != "object" || uA === null) return uA;
              var v = uA[Symbol.toPrimitive];
              if (v !== void 0) {
                var RA = v.call(uA, w);
                if (typeof RA != "object") return RA;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return (w === "string" ? String : Number)(uA);
            }
            var P = r(2167), D = Symbol("lastResolve"), J = Symbol("lastReject"), q = Symbol("error"), AA = Symbol("ended"), K = Symbol("lastPromise"), z = Symbol("handlePromise"), T = Symbol("stream");
            function H(uA, w) {
              return {
                value: uA,
                done: w
              };
            }
            function eA(uA) {
              var w = uA[D];
              if (w !== null) {
                var v = uA[T].read();
                v !== null && (uA[K] = null, uA[D] = null, uA[J] = null, w(H(v, !1)));
              }
            }
            function CA(uA) {
              A.nextTick(eA, uA);
            }
            function IA(uA, w) {
              return function(v, RA) {
                uA.then(function() {
                  if (w[AA]) {
                    v(H(void 0, !0));
                    return;
                  }
                  w[z](v, RA);
                }, RA);
              };
            }
            var k = Object.getPrototypeOf(function() {
            }), tA = Object.setPrototypeOf((a = {
              get stream() {
                return this[T];
              },
              next: function() {
                var w = this, v = this[q];
                if (v !== null)
                  return Promise.reject(v);
                if (this[AA])
                  return Promise.resolve(H(void 0, !0));
                if (this[T].destroyed)
                  return new Promise(function(cA, $A) {
                    A.nextTick(function() {
                      w[q] ? $A(w[q]) : cA(H(void 0, !0));
                    });
                  });
                var RA = this[K], DA;
                if (RA)
                  DA = new Promise(IA(RA, this));
                else {
                  var $ = this[T].read();
                  if ($ !== null)
                    return Promise.resolve(H($, !1));
                  DA = new Promise(this[z]);
                }
                return this[K] = DA, DA;
              }
            }, d(a, Symbol.asyncIterator, function() {
              return this;
            }), d(a, "return", function() {
              var w = this;
              return new Promise(function(v, RA) {
                w[T].destroy(null, function(DA) {
                  if (DA) {
                    RA(DA);
                    return;
                  }
                  v(H(void 0, !0));
                });
              });
            }), a), k), lA = function(w) {
              var v, RA = Object.create(tA, (v = {}, d(v, T, {
                value: w,
                writable: !0
              }), d(v, D, {
                value: null,
                writable: !0
              }), d(v, J, {
                value: null,
                writable: !0
              }), d(v, q, {
                value: null,
                writable: !0
              }), d(v, AA, {
                value: w._readableState.endEmitted,
                writable: !0
              }), d(v, z, {
                value: function($, cA) {
                  var $A = RA[T].read();
                  $A ? (RA[K] = null, RA[D] = null, RA[J] = null, $(H($A, !1))) : (RA[D] = $, RA[J] = cA);
                },
                writable: !0
              }), v));
              return RA[K] = null, P(w, function(DA) {
                if (DA && DA.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                  var $ = RA[J];
                  $ !== null && (RA[K] = null, RA[D] = null, RA[J] = null, $(DA)), RA[q] = DA;
                  return;
                }
                var cA = RA[D];
                cA !== null && (RA[K] = null, RA[D] = null, RA[J] = null, cA(H(void 0, !0))), RA[AA] = !0;
              }), w.on("readable", CA.bind(null, RA)), RA;
            };
            Q.exports = lA;
          },
          /***/
          7385(Q, B, r) {
            var A = r(9964);
            function a(J, q) {
              var AA = this, K = this._readableState && this._readableState.destroyed, z = this._writableState && this._writableState.destroyed;
              return K || z ? (q ? q(J) : J && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, A.nextTick(P, this, J)) : A.nextTick(P, this, J)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(J || null, function(T) {
                !q && T ? AA._writableState ? AA._writableState.errorEmitted ? A.nextTick(x, AA) : (AA._writableState.errorEmitted = !0, A.nextTick(d, AA, T)) : A.nextTick(d, AA, T) : q ? (A.nextTick(x, AA), q(T)) : A.nextTick(x, AA);
              }), this);
            }
            function d(J, q) {
              P(J, q), x(J);
            }
            function x(J) {
              J._writableState && !J._writableState.emitClose || J._readableState && !J._readableState.emitClose || J.emit("close");
            }
            function U() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function P(J, q) {
              J.emit("error", q);
            }
            function D(J, q) {
              var AA = J._readableState, K = J._writableState;
              AA && AA.autoDestroy || K && K.autoDestroy ? J.destroy(q) : J.emit("error", q);
            }
            Q.exports = {
              destroy: a,
              undestroy: U,
              errorOrDestroy: D
            };
          },
          /***/
          2167(Q, B, r) {
            var A = r(3797).F.ERR_STREAM_PREMATURE_CLOSE;
            function a(P) {
              var D = !1;
              return function() {
                if (!D) {
                  D = !0;
                  for (var J = arguments.length, q = new Array(J), AA = 0; AA < J; AA++)
                    q[AA] = arguments[AA];
                  P.apply(this, q);
                }
              };
            }
            function d() {
            }
            function x(P) {
              return P.setHeader && typeof P.abort == "function";
            }
            function U(P, D, J) {
              if (typeof D == "function") return U(P, null, D);
              D || (D = {}), J = a(J || d);
              var q = D.readable || D.readable !== !1 && P.readable, AA = D.writable || D.writable !== !1 && P.writable, K = function() {
                P.writable || T();
              }, z = P._writableState && P._writableState.finished, T = function() {
                AA = !1, z = !0, q || J.call(P);
              }, H = P._readableState && P._readableState.endEmitted, eA = function() {
                q = !1, H = !0, AA || J.call(P);
              }, CA = function(lA) {
                J.call(P, lA);
              }, IA = function() {
                var lA;
                if (q && !H)
                  return (!P._readableState || !P._readableState.ended) && (lA = new A()), J.call(P, lA);
                if (AA && !z)
                  return (!P._writableState || !P._writableState.ended) && (lA = new A()), J.call(P, lA);
              }, k = function() {
                P.req.on("finish", T);
              };
              return x(P) ? (P.on("complete", T), P.on("abort", IA), P.req ? k() : P.on("request", k)) : AA && !P._writableState && (P.on("end", K), P.on("close", K)), P.on("end", eA), P.on("finish", T), D.error !== !1 && P.on("error", CA), P.on("close", IA), function() {
                P.removeListener("complete", T), P.removeListener("abort", IA), P.removeListener("request", k), P.req && P.req.removeListener("finish", T), P.removeListener("end", K), P.removeListener("close", K), P.removeListener("finish", T), P.removeListener("end", eA), P.removeListener("error", CA), P.removeListener("close", IA);
              };
            }
            Q.exports = U;
          },
          /***/
          378(Q) {
            Q.exports = function() {
              throw new Error("Readable.from is not available in the browser");
            };
          },
          /***/
          3765(Q, B, r) {
            var A;
            function a(T) {
              var H = !1;
              return function() {
                H || (H = !0, T.apply(void 0, arguments));
              };
            }
            var d = r(3797).F, x = d.ERR_MISSING_ARGS, U = d.ERR_STREAM_DESTROYED;
            function P(T) {
              if (T) throw T;
            }
            function D(T) {
              return T.setHeader && typeof T.abort == "function";
            }
            function J(T, H, eA, CA) {
              CA = a(CA);
              var IA = !1;
              T.on("close", function() {
                IA = !0;
              }), A === void 0 && (A = r(2167)), A(T, {
                readable: H,
                writable: eA
              }, function(tA) {
                if (tA) return CA(tA);
                IA = !0, CA();
              });
              var k = !1;
              return function(tA) {
                if (!IA && !k) {
                  if (k = !0, D(T)) return T.abort();
                  if (typeof T.destroy == "function") return T.destroy();
                  CA(tA || new U("pipe"));
                }
              };
            }
            function q(T) {
              T();
            }
            function AA(T, H) {
              return T.pipe(H);
            }
            function K(T) {
              return !T.length || typeof T[T.length - 1] != "function" ? P : T.pop();
            }
            function z() {
              for (var T = arguments.length, H = new Array(T), eA = 0; eA < T; eA++)
                H[eA] = arguments[eA];
              var CA = K(H);
              if (Array.isArray(H[0]) && (H = H[0]), H.length < 2)
                throw new x("streams");
              var IA, k = H.map(function(tA, lA) {
                var uA = lA < H.length - 1, w = lA > 0;
                return J(tA, uA, w, function(v) {
                  IA || (IA = v), v && k.forEach(q), !uA && (k.forEach(q), CA(IA));
                });
              });
              return H.reduce(AA);
            }
            Q.exports = z;
          },
          /***/
          8130(Q, B, r) {
            var A = r(3797).F.ERR_INVALID_OPT_VALUE;
            function a(x, U, P) {
              return x.highWaterMark != null ? x.highWaterMark : U ? x[P] : null;
            }
            function d(x, U, P, D) {
              var J = a(U, D, P);
              if (J != null) {
                if (!(isFinite(J) && Math.floor(J) === J) || J < 0) {
                  var q = D ? P : "highWaterMark";
                  throw new A(q, J);
                }
                return Math.floor(J);
              }
              return x.objectMode ? 16 : 16384;
            }
            Q.exports = {
              getHighWaterMark: d
            };
          },
          /***/
          9018(Q, B, r) {
            Q.exports = r(4785).EventEmitter;
          },
          /***/
          3143(Q, B, r) {
            var A = r(5691).Buffer, a = A.isEncoding || function(k) {
              switch (k = "" + k, k && k.toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                case "raw":
                  return !0;
                default:
                  return !1;
              }
            };
            function d(k) {
              if (!k) return "utf8";
              for (var tA; ; )
                switch (k) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return k;
                  default:
                    if (tA) return;
                    k = ("" + k).toLowerCase(), tA = !0;
                }
            }
            function x(k) {
              var tA = d(k);
              if (typeof tA != "string" && (A.isEncoding === a || !a(k))) throw new Error("Unknown encoding: " + k);
              return tA || k;
            }
            B.I = U;
            function U(k) {
              this.encoding = x(k);
              var tA;
              switch (this.encoding) {
                case "utf16le":
                  this.text = z, this.end = T, tA = 4;
                  break;
                case "utf8":
                  this.fillLast = q, tA = 4;
                  break;
                case "base64":
                  this.text = H, this.end = eA, tA = 3;
                  break;
                default:
                  this.write = CA, this.end = IA;
                  return;
              }
              this.lastNeed = 0, this.lastTotal = 0, this.lastChar = A.allocUnsafe(tA);
            }
            U.prototype.write = function(k) {
              if (k.length === 0) return "";
              var tA, lA;
              if (this.lastNeed) {
                if (tA = this.fillLast(k), tA === void 0) return "";
                lA = this.lastNeed, this.lastNeed = 0;
              } else
                lA = 0;
              return lA < k.length ? tA ? tA + this.text(k, lA) : this.text(k, lA) : tA || "";
            }, U.prototype.end = K, U.prototype.text = AA, U.prototype.fillLast = function(k) {
              if (this.lastNeed <= k.length)
                return k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, k.length), this.lastNeed -= k.length;
            };
            function P(k) {
              return k <= 127 ? 0 : k >> 5 === 6 ? 2 : k >> 4 === 14 ? 3 : k >> 3 === 30 ? 4 : k >> 6 === 2 ? -1 : -2;
            }
            function D(k, tA, lA) {
              var uA = tA.length - 1;
              if (uA < lA) return 0;
              var w = P(tA[uA]);
              return w >= 0 ? (w > 0 && (k.lastNeed = w - 1), w) : --uA < lA || w === -2 ? 0 : (w = P(tA[uA]), w >= 0 ? (w > 0 && (k.lastNeed = w - 2), w) : --uA < lA || w === -2 ? 0 : (w = P(tA[uA]), w >= 0 ? (w > 0 && (w === 2 ? w = 0 : k.lastNeed = w - 3), w) : 0));
            }
            function J(k, tA, lA) {
              if ((tA[0] & 192) !== 128)
                return k.lastNeed = 0, "�";
              if (k.lastNeed > 1 && tA.length > 1) {
                if ((tA[1] & 192) !== 128)
                  return k.lastNeed = 1, "�";
                if (k.lastNeed > 2 && tA.length > 2 && (tA[2] & 192) !== 128)
                  return k.lastNeed = 2, "�";
              }
            }
            function q(k) {
              var tA = this.lastTotal - this.lastNeed, lA = J(this, k);
              if (lA !== void 0) return lA;
              if (this.lastNeed <= k.length)
                return k.copy(this.lastChar, tA, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              k.copy(this.lastChar, tA, 0, k.length), this.lastNeed -= k.length;
            }
            function AA(k, tA) {
              var lA = D(this, k, tA);
              if (!this.lastNeed) return k.toString("utf8", tA);
              this.lastTotal = lA;
              var uA = k.length - (lA - this.lastNeed);
              return k.copy(this.lastChar, 0, uA), k.toString("utf8", tA, uA);
            }
            function K(k) {
              var tA = k && k.length ? this.write(k) : "";
              return this.lastNeed ? tA + "�" : tA;
            }
            function z(k, tA) {
              if ((k.length - tA) % 2 === 0) {
                var lA = k.toString("utf16le", tA);
                if (lA) {
                  var uA = lA.charCodeAt(lA.length - 1);
                  if (uA >= 55296 && uA <= 56319)
                    return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1], lA.slice(0, -1);
                }
                return lA;
              }
              return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = k[k.length - 1], k.toString("utf16le", tA, k.length - 1);
            }
            function T(k) {
              var tA = k && k.length ? this.write(k) : "";
              if (this.lastNeed) {
                var lA = this.lastTotal - this.lastNeed;
                return tA + this.lastChar.toString("utf16le", 0, lA);
              }
              return tA;
            }
            function H(k, tA) {
              var lA = (k.length - tA) % 3;
              return lA === 0 ? k.toString("base64", tA) : (this.lastNeed = 3 - lA, this.lastTotal = 3, lA === 1 ? this.lastChar[0] = k[k.length - 1] : (this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1]), k.toString("base64", tA, k.length - lA));
            }
            function eA(k) {
              var tA = k && k.length ? this.write(k) : "";
              return this.lastNeed ? tA + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : tA;
            }
            function CA(k) {
              return k.toString(this.encoding);
            }
            function IA(k) {
              return k && k.length ? this.write(k) : "";
            }
          },
          /***/
          3483(Q) {
            var B = 0, r = -3;
            function A() {
              this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
            }
            function a(v, RA) {
              this.source = v, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = RA, this.destLen = 0, this.ltree = new A(), this.dtree = new A();
            }
            var d = new A(), x = new A(), U = new Uint8Array(30), P = new Uint16Array(30), D = new Uint8Array(30), J = new Uint16Array(30), q = new Uint8Array([
              16,
              17,
              18,
              0,
              8,
              7,
              9,
              6,
              10,
              5,
              11,
              4,
              12,
              3,
              13,
              2,
              14,
              1,
              15
            ]), AA = new A(), K = new Uint8Array(320);
            function z(v, RA, DA, $) {
              var cA, $A;
              for (cA = 0; cA < DA; ++cA) v[cA] = 0;
              for (cA = 0; cA < 30 - DA; ++cA) v[cA + DA] = cA / DA | 0;
              for ($A = $, cA = 0; cA < 30; ++cA)
                RA[cA] = $A, $A += 1 << v[cA];
            }
            function T(v, RA) {
              var DA;
              for (DA = 0; DA < 7; ++DA) v.table[DA] = 0;
              for (v.table[7] = 24, v.table[8] = 152, v.table[9] = 112, DA = 0; DA < 24; ++DA) v.trans[DA] = 256 + DA;
              for (DA = 0; DA < 144; ++DA) v.trans[24 + DA] = DA;
              for (DA = 0; DA < 8; ++DA) v.trans[168 + DA] = 280 + DA;
              for (DA = 0; DA < 112; ++DA) v.trans[176 + DA] = 144 + DA;
              for (DA = 0; DA < 5; ++DA) RA.table[DA] = 0;
              for (RA.table[5] = 32, DA = 0; DA < 32; ++DA) RA.trans[DA] = DA;
            }
            var H = new Uint16Array(16);
            function eA(v, RA, DA, $) {
              var cA, $A;
              for (cA = 0; cA < 16; ++cA) v.table[cA] = 0;
              for (cA = 0; cA < $; ++cA) v.table[RA[DA + cA]]++;
              for (v.table[0] = 0, $A = 0, cA = 0; cA < 16; ++cA)
                H[cA] = $A, $A += v.table[cA];
              for (cA = 0; cA < $; ++cA)
                RA[DA + cA] && (v.trans[H[RA[DA + cA]]++] = cA);
            }
            function CA(v) {
              v.bitcount-- || (v.tag = v.source[v.sourceIndex++], v.bitcount = 7);
              var RA = v.tag & 1;
              return v.tag >>>= 1, RA;
            }
            function IA(v, RA, DA) {
              if (!RA)
                return DA;
              for (; v.bitcount < 24; )
                v.tag |= v.source[v.sourceIndex++] << v.bitcount, v.bitcount += 8;
              var $ = v.tag & 65535 >>> 16 - RA;
              return v.tag >>>= RA, v.bitcount -= RA, $ + DA;
            }
            function k(v, RA) {
              for (; v.bitcount < 24; )
                v.tag |= v.source[v.sourceIndex++] << v.bitcount, v.bitcount += 8;
              var DA = 0, $ = 0, cA = 0, $A = v.tag;
              do
                $ = 2 * $ + ($A & 1), $A >>>= 1, ++cA, DA += RA.table[cA], $ -= RA.table[cA];
              while ($ >= 0);
              return v.tag = $A, v.bitcount -= cA, RA.trans[DA + $];
            }
            function tA(v, RA, DA) {
              var $, cA, $A, kA, WA, EA;
              for ($ = IA(v, 5, 257), cA = IA(v, 5, 1), $A = IA(v, 4, 4), kA = 0; kA < 19; ++kA) K[kA] = 0;
              for (kA = 0; kA < $A; ++kA) {
                var zA = IA(v, 3, 0);
                K[q[kA]] = zA;
              }
              for (eA(AA, K, 0, 19), WA = 0; WA < $ + cA; ) {
                var OA = k(v, AA);
                switch (OA) {
                  case 16:
                    var xA = K[WA - 1];
                    for (EA = IA(v, 2, 3); EA; --EA)
                      K[WA++] = xA;
                    break;
                  case 17:
                    for (EA = IA(v, 3, 3); EA; --EA)
                      K[WA++] = 0;
                    break;
                  case 18:
                    for (EA = IA(v, 7, 11); EA; --EA)
                      K[WA++] = 0;
                    break;
                  default:
                    K[WA++] = OA;
                    break;
                }
              }
              eA(RA, K, 0, $), eA(DA, K, $, cA);
            }
            function lA(v, RA, DA) {
              for (; ; ) {
                var $ = k(v, RA);
                if ($ === 256)
                  return B;
                if ($ < 256)
                  v.dest[v.destLen++] = $;
                else {
                  var cA, $A, kA, WA;
                  for ($ -= 257, cA = IA(v, U[$], P[$]), $A = k(v, DA), kA = v.destLen - IA(v, D[$A], J[$A]), WA = kA; WA < kA + cA; ++WA)
                    v.dest[v.destLen++] = v.dest[WA];
                }
              }
            }
            function uA(v) {
              for (var RA, DA, $; v.bitcount > 8; )
                v.sourceIndex--, v.bitcount -= 8;
              if (RA = v.source[v.sourceIndex + 1], RA = 256 * RA + v.source[v.sourceIndex], DA = v.source[v.sourceIndex + 3], DA = 256 * DA + v.source[v.sourceIndex + 2], RA !== (~DA & 65535))
                return r;
              for (v.sourceIndex += 4, $ = RA; $; --$)
                v.dest[v.destLen++] = v.source[v.sourceIndex++];
              return v.bitcount = 0, B;
            }
            function w(v, RA) {
              var DA = new a(v, RA), $, cA, $A;
              do {
                switch ($ = CA(DA), cA = IA(DA, 2, 0), cA) {
                  case 0:
                    $A = uA(DA);
                    break;
                  case 1:
                    $A = lA(DA, d, x);
                    break;
                  case 2:
                    tA(DA, DA.ltree, DA.dtree), $A = lA(DA, DA.ltree, DA.dtree);
                    break;
                  default:
                    $A = r;
                }
                if ($A !== B)
                  throw new Error("Data error");
              } while (!$);
              return DA.destLen < DA.dest.length ? typeof DA.dest.slice == "function" ? DA.dest.slice(0, DA.destLen) : DA.dest.subarray(0, DA.destLen) : DA.dest;
            }
            T(d, x), z(U, P, 4, 3), z(D, J, 2, 1), U[28] = 0, P[28] = 258, Q.exports = w;
          },
          /***/
          6465(Q, B, r) {
            Q.exports = A;
            function A(d, x) {
              if (a("noDeprecation"))
                return d;
              var U = !1;
              function P() {
                if (!U) {
                  if (a("throwDeprecation"))
                    throw new Error(x);
                  a("traceDeprecation") ? console.trace(x) : console.warn(x), U = !0;
                }
                return d.apply(this, arguments);
              }
              return P;
            }
            function a(d) {
              try {
                if (!r.g.localStorage) return !1;
              } catch {
                return !1;
              }
              var x = r.g.localStorage[d];
              return x == null ? !1 : String(x).toLowerCase() === "true";
            }
          },
          /***/
          1201(Q) {
            Q.exports = function(r) {
              return r && typeof r == "object" && typeof r.copy == "function" && typeof r.fill == "function" && typeof r.readUInt8 == "function";
            };
          },
          /***/
          9490(Q, B, r) {
            var A = r(7906), a = r(4610), d = r(3381), x = r(6094);
            function U(KA) {
              return KA.call.bind(KA);
            }
            var P = typeof BigInt < "u", D = typeof Symbol < "u", J = U(Object.prototype.toString), q = U(Number.prototype.valueOf), AA = U(String.prototype.valueOf), K = U(Boolean.prototype.valueOf);
            if (P)
              var z = U(BigInt.prototype.valueOf);
            if (D)
              var T = U(Symbol.prototype.valueOf);
            function H(KA, Pe) {
              if (typeof KA != "object")
                return !1;
              try {
                return Pe(KA), !0;
              } catch {
                return !1;
              }
            }
            B.isArgumentsObject = A, B.isGeneratorFunction = a, B.isTypedArray = x;
            function eA(KA) {
              return typeof Promise < "u" && KA instanceof Promise || KA !== null && typeof KA == "object" && typeof KA.then == "function" && typeof KA.catch == "function";
            }
            B.isPromise = eA;
            function CA(KA) {
              return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(KA) : x(KA) || sA(KA);
            }
            B.isArrayBufferView = CA;
            function IA(KA) {
              return d(KA) === "Uint8Array";
            }
            B.isUint8Array = IA;
            function k(KA) {
              return d(KA) === "Uint8ClampedArray";
            }
            B.isUint8ClampedArray = k;
            function tA(KA) {
              return d(KA) === "Uint16Array";
            }
            B.isUint16Array = tA;
            function lA(KA) {
              return d(KA) === "Uint32Array";
            }
            B.isUint32Array = lA;
            function uA(KA) {
              return d(KA) === "Int8Array";
            }
            B.isInt8Array = uA;
            function w(KA) {
              return d(KA) === "Int16Array";
            }
            B.isInt16Array = w;
            function v(KA) {
              return d(KA) === "Int32Array";
            }
            B.isInt32Array = v;
            function RA(KA) {
              return d(KA) === "Float32Array";
            }
            B.isFloat32Array = RA;
            function DA(KA) {
              return d(KA) === "Float64Array";
            }
            B.isFloat64Array = DA;
            function $(KA) {
              return d(KA) === "BigInt64Array";
            }
            B.isBigInt64Array = $;
            function cA(KA) {
              return d(KA) === "BigUint64Array";
            }
            B.isBigUint64Array = cA;
            function $A(KA) {
              return J(KA) === "[object Map]";
            }
            $A.working = typeof Map < "u" && $A(/* @__PURE__ */ new Map());
            function kA(KA) {
              return typeof Map > "u" ? !1 : $A.working ? $A(KA) : KA instanceof Map;
            }
            B.isMap = kA;
            function WA(KA) {
              return J(KA) === "[object Set]";
            }
            WA.working = typeof Set < "u" && WA(/* @__PURE__ */ new Set());
            function EA(KA) {
              return typeof Set > "u" ? !1 : WA.working ? WA(KA) : KA instanceof Set;
            }
            B.isSet = EA;
            function zA(KA) {
              return J(KA) === "[object WeakMap]";
            }
            zA.working = typeof WeakMap < "u" && zA(/* @__PURE__ */ new WeakMap());
            function OA(KA) {
              return typeof WeakMap > "u" ? !1 : zA.working ? zA(KA) : KA instanceof WeakMap;
            }
            B.isWeakMap = OA;
            function xA(KA) {
              return J(KA) === "[object WeakSet]";
            }
            xA.working = typeof WeakSet < "u" && xA(/* @__PURE__ */ new WeakSet());
            function LA(KA) {
              return xA(KA);
            }
            B.isWeakSet = LA;
            function yA(KA) {
              return J(KA) === "[object ArrayBuffer]";
            }
            yA.working = typeof ArrayBuffer < "u" && yA(new ArrayBuffer());
            function TA(KA) {
              return typeof ArrayBuffer > "u" ? !1 : yA.working ? yA(KA) : KA instanceof ArrayBuffer;
            }
            B.isArrayBuffer = TA;
            function fA(KA) {
              return J(KA) === "[object DataView]";
            }
            fA.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && fA(new DataView(new ArrayBuffer(1), 0, 1));
            function sA(KA) {
              return typeof DataView > "u" ? !1 : fA.working ? fA(KA) : KA instanceof DataView;
            }
            B.isDataView = sA;
            var F = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
            function o(KA) {
              return J(KA) === "[object SharedArrayBuffer]";
            }
            function h(KA) {
              return typeof F > "u" ? !1 : (typeof o.working > "u" && (o.working = o(new F())), o.working ? o(KA) : KA instanceof F);
            }
            B.isSharedArrayBuffer = h;
            function _(KA) {
              return J(KA) === "[object AsyncFunction]";
            }
            B.isAsyncFunction = _;
            function oA(KA) {
              return J(KA) === "[object Map Iterator]";
            }
            B.isMapIterator = oA;
            function p(KA) {
              return J(KA) === "[object Set Iterator]";
            }
            B.isSetIterator = p;
            function rA(KA) {
              return J(KA) === "[object Generator]";
            }
            B.isGeneratorObject = rA;
            function QA(KA) {
              return J(KA) === "[object WebAssembly.Module]";
            }
            B.isWebAssemblyCompiledModule = QA;
            function bA(KA) {
              return H(KA, q);
            }
            B.isNumberObject = bA;
            function y(KA) {
              return H(KA, AA);
            }
            B.isStringObject = y;
            function M(KA) {
              return H(KA, K);
            }
            B.isBooleanObject = M;
            function FA(KA) {
              return P && H(KA, z);
            }
            B.isBigIntObject = FA;
            function dA(KA) {
              return D && H(KA, T);
            }
            B.isSymbolObject = dA;
            function he(KA) {
              return bA(KA) || y(KA) || M(KA) || FA(KA) || dA(KA);
            }
            B.isBoxedPrimitive = he;
            function ie(KA) {
              return typeof Uint8Array < "u" && (TA(KA) || h(KA));
            }
            B.isAnyArrayBuffer = ie, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(KA) {
              Object.defineProperty(B, KA, {
                enumerable: !1,
                value: function() {
                  throw new Error(KA + " is not supported in userland");
                }
              });
            });
          },
          /***/
          7187(Q, B, r) {
            var A = r(9964), a = Object.getOwnPropertyDescriptors || function(F) {
              for (var o = Object.keys(F), h = {}, _ = 0; _ < o.length; _++)
                h[o[_]] = Object.getOwnPropertyDescriptor(F, o[_]);
              return h;
            }, d = /%[sdj%]/g;
            B.format = function(sA) {
              if (!w(sA)) {
                for (var F = [], o = 0; o < arguments.length; o++)
                  F.push(D(arguments[o]));
                return F.join(" ");
              }
              for (var o = 1, h = arguments, _ = h.length, oA = String(sA).replace(d, function(rA) {
                if (rA === "%%") return "%";
                if (o >= _) return rA;
                switch (rA) {
                  case "%s":
                    return String(h[o++]);
                  case "%d":
                    return Number(h[o++]);
                  case "%j":
                    try {
                      return JSON.stringify(h[o++]);
                    } catch {
                      return "[Circular]";
                    }
                  default:
                    return rA;
                }
              }), p = h[o]; o < _; p = h[++o])
                tA(p) || !$(p) ? oA += " " + p : oA += " " + D(p);
              return oA;
            }, B.deprecate = function(sA, F) {
              if (typeof A < "u" && A.noDeprecation === !0)
                return sA;
              if (typeof A > "u")
                return function() {
                  return B.deprecate(sA, F).apply(this, arguments);
                };
              var o = !1;
              function h() {
                if (!o) {
                  if (A.throwDeprecation)
                    throw new Error(F);
                  A.traceDeprecation ? console.trace(F) : console.error(F), o = !0;
                }
                return sA.apply(this, arguments);
              }
              return h;
            };
            var x = {}, U = /^$/;
            if (A.env.NODE_DEBUG) {
              var P = A.env.NODE_DEBUG;
              P = P.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), U = new RegExp("^" + P + "$", "i");
            }
            B.debuglog = function(sA) {
              if (sA = sA.toUpperCase(), !x[sA])
                if (U.test(sA)) {
                  var F = A.pid;
                  x[sA] = function() {
                    var o = B.format.apply(B, arguments);
                    console.error("%s %d: %s", sA, F, o);
                  };
                } else
                  x[sA] = function() {
                  };
              return x[sA];
            };
            function D(sA, F) {
              var o = {
                seen: [],
                stylize: q
              };
              return arguments.length >= 3 && (o.depth = arguments[2]), arguments.length >= 4 && (o.colors = arguments[3]), k(F) ? o.showHidden = F : F && B._extend(o, F), RA(o.showHidden) && (o.showHidden = !1), RA(o.depth) && (o.depth = 2), RA(o.colors) && (o.colors = !1), RA(o.customInspect) && (o.customInspect = !0), o.colors && (o.stylize = J), K(o, sA, o.depth);
            }
            B.inspect = D, D.colors = {
              bold: [1, 22],
              italic: [3, 23],
              underline: [4, 24],
              inverse: [7, 27],
              white: [37, 39],
              grey: [90, 39],
              black: [30, 39],
              blue: [34, 39],
              cyan: [36, 39],
              green: [32, 39],
              magenta: [35, 39],
              red: [31, 39],
              yellow: [33, 39]
            }, D.styles = {
              special: "cyan",
              number: "yellow",
              boolean: "yellow",
              undefined: "grey",
              null: "bold",
              string: "green",
              date: "magenta",
              // "name": intentionally not styling
              regexp: "red"
            };
            function J(sA, F) {
              var o = D.styles[F];
              return o ? "\x1B[" + D.colors[o][0] + "m" + sA + "\x1B[" + D.colors[o][1] + "m" : sA;
            }
            function q(sA, F) {
              return sA;
            }
            function AA(sA) {
              var F = {};
              return sA.forEach(function(o, h) {
                F[o] = !0;
              }), F;
            }
            function K(sA, F, o) {
              if (sA.customInspect && F && kA(F.inspect) && // Filter out the util module, it's inspect function is special
              F.inspect !== B.inspect && // Also filter out any prototype objects using the circular check.
              !(F.constructor && F.constructor.prototype === F)) {
                var h = F.inspect(o, sA);
                return w(h) || (h = K(sA, h, o)), h;
              }
              var _ = z(sA, F);
              if (_)
                return _;
              var oA = Object.keys(F), p = AA(oA);
              if (sA.showHidden && (oA = Object.getOwnPropertyNames(F)), $A(F) && (oA.indexOf("message") >= 0 || oA.indexOf("description") >= 0))
                return T(F);
              if (oA.length === 0) {
                if (kA(F)) {
                  var rA = F.name ? ": " + F.name : "";
                  return sA.stylize("[Function" + rA + "]", "special");
                }
                if (DA(F))
                  return sA.stylize(RegExp.prototype.toString.call(F), "regexp");
                if (cA(F))
                  return sA.stylize(Date.prototype.toString.call(F), "date");
                if ($A(F))
                  return T(F);
              }
              var QA = "", bA = !1, y = ["{", "}"];
              if (IA(F) && (bA = !0, y = ["[", "]"]), kA(F)) {
                var M = F.name ? ": " + F.name : "";
                QA = " [Function" + M + "]";
              }
              if (DA(F) && (QA = " " + RegExp.prototype.toString.call(F)), cA(F) && (QA = " " + Date.prototype.toUTCString.call(F)), $A(F) && (QA = " " + T(F)), oA.length === 0 && (!bA || F.length == 0))
                return y[0] + QA + y[1];
              if (o < 0)
                return DA(F) ? sA.stylize(RegExp.prototype.toString.call(F), "regexp") : sA.stylize("[Object]", "special");
              sA.seen.push(F);
              var FA;
              return bA ? FA = H(sA, F, o, p, oA) : FA = oA.map(function(dA) {
                return eA(sA, F, o, p, dA, bA);
              }), sA.seen.pop(), CA(FA, QA, y);
            }
            function z(sA, F) {
              if (RA(F))
                return sA.stylize("undefined", "undefined");
              if (w(F)) {
                var o = "'" + JSON.stringify(F).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return sA.stylize(o, "string");
              }
              if (uA(F))
                return sA.stylize("" + F, "number");
              if (k(F))
                return sA.stylize("" + F, "boolean");
              if (tA(F))
                return sA.stylize("null", "null");
            }
            function T(sA) {
              return "[" + Error.prototype.toString.call(sA) + "]";
            }
            function H(sA, F, o, h, _) {
              for (var oA = [], p = 0, rA = F.length; p < rA; ++p)
                LA(F, String(p)) ? oA.push(eA(
                  sA,
                  F,
                  o,
                  h,
                  String(p),
                  !0
                )) : oA.push("");
              return _.forEach(function(QA) {
                QA.match(/^\d+$/) || oA.push(eA(
                  sA,
                  F,
                  o,
                  h,
                  QA,
                  !0
                ));
              }), oA;
            }
            function eA(sA, F, o, h, _, oA) {
              var p, rA, QA;
              if (QA = Object.getOwnPropertyDescriptor(F, _) || { value: F[_] }, QA.get ? QA.set ? rA = sA.stylize("[Getter/Setter]", "special") : rA = sA.stylize("[Getter]", "special") : QA.set && (rA = sA.stylize("[Setter]", "special")), LA(h, _) || (p = "[" + _ + "]"), rA || (sA.seen.indexOf(QA.value) < 0 ? (tA(o) ? rA = K(sA, QA.value, null) : rA = K(sA, QA.value, o - 1), rA.indexOf(`
`) > -1 && (oA ? rA = rA.split(`
`).map(function(bA) {
                return "  " + bA;
              }).join(`
`).slice(2) : rA = `
` + rA.split(`
`).map(function(bA) {
                return "   " + bA;
              }).join(`
`))) : rA = sA.stylize("[Circular]", "special")), RA(p)) {
                if (oA && _.match(/^\d+$/))
                  return rA;
                p = JSON.stringify("" + _), p.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (p = p.slice(1, -1), p = sA.stylize(p, "name")) : (p = p.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), p = sA.stylize(p, "string"));
              }
              return p + ": " + rA;
            }
            function CA(sA, F, o) {
              var h = sA.reduce(function(_, oA) {
                return oA.indexOf(`
`) >= 0, _ + oA.replace(/\u001b\[\d\d?m/g, "").length + 1;
              }, 0);
              return h > 60 ? o[0] + (F === "" ? "" : F + `
 `) + " " + sA.join(`,
  `) + " " + o[1] : o[0] + F + " " + sA.join(", ") + " " + o[1];
            }
            B.types = r(9490);
            function IA(sA) {
              return Array.isArray(sA);
            }
            B.isArray = IA;
            function k(sA) {
              return typeof sA == "boolean";
            }
            B.isBoolean = k;
            function tA(sA) {
              return sA === null;
            }
            B.isNull = tA;
            function lA(sA) {
              return sA == null;
            }
            B.isNullOrUndefined = lA;
            function uA(sA) {
              return typeof sA == "number";
            }
            B.isNumber = uA;
            function w(sA) {
              return typeof sA == "string";
            }
            B.isString = w;
            function v(sA) {
              return typeof sA == "symbol";
            }
            B.isSymbol = v;
            function RA(sA) {
              return sA === void 0;
            }
            B.isUndefined = RA;
            function DA(sA) {
              return $(sA) && EA(sA) === "[object RegExp]";
            }
            B.isRegExp = DA, B.types.isRegExp = DA;
            function $(sA) {
              return typeof sA == "object" && sA !== null;
            }
            B.isObject = $;
            function cA(sA) {
              return $(sA) && EA(sA) === "[object Date]";
            }
            B.isDate = cA, B.types.isDate = cA;
            function $A(sA) {
              return $(sA) && (EA(sA) === "[object Error]" || sA instanceof Error);
            }
            B.isError = $A, B.types.isNativeError = $A;
            function kA(sA) {
              return typeof sA == "function";
            }
            B.isFunction = kA;
            function WA(sA) {
              return sA === null || typeof sA == "boolean" || typeof sA == "number" || typeof sA == "string" || typeof sA == "symbol" || // ES6 symbol
              typeof sA > "u";
            }
            B.isPrimitive = WA, B.isBuffer = r(1201);
            function EA(sA) {
              return Object.prototype.toString.call(sA);
            }
            function zA(sA) {
              return sA < 10 ? "0" + sA.toString(10) : sA.toString(10);
            }
            var OA = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ];
            function xA() {
              var sA = /* @__PURE__ */ new Date(), F = [
                zA(sA.getHours()),
                zA(sA.getMinutes()),
                zA(sA.getSeconds())
              ].join(":");
              return [sA.getDate(), OA[sA.getMonth()], F].join(" ");
            }
            B.log = function() {
              console.log("%s - %s", xA(), B.format.apply(B, arguments));
            }, B.inherits = r(9784), B._extend = function(sA, F) {
              if (!F || !$(F)) return sA;
              for (var o = Object.keys(F), h = o.length; h--; )
                sA[o[h]] = F[o[h]];
              return sA;
            };
            function LA(sA, F) {
              return Object.prototype.hasOwnProperty.call(sA, F);
            }
            var yA = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
            B.promisify = function(F) {
              if (typeof F != "function")
                throw new TypeError('The "original" argument must be of type Function');
              if (yA && F[yA]) {
                var o = F[yA];
                if (typeof o != "function")
                  throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                return Object.defineProperty(o, yA, {
                  value: o,
                  enumerable: !1,
                  writable: !1,
                  configurable: !0
                }), o;
              }
              function o() {
                for (var h, _, oA = new Promise(function(QA, bA) {
                  h = QA, _ = bA;
                }), p = [], rA = 0; rA < arguments.length; rA++)
                  p.push(arguments[rA]);
                p.push(function(QA, bA) {
                  QA ? _(QA) : h(bA);
                });
                try {
                  F.apply(this, p);
                } catch (QA) {
                  _(QA);
                }
                return oA;
              }
              return Object.setPrototypeOf(o, Object.getPrototypeOf(F)), yA && Object.defineProperty(o, yA, {
                value: o,
                enumerable: !1,
                writable: !1,
                configurable: !0
              }), Object.defineProperties(
                o,
                a(F)
              );
            }, B.promisify.custom = yA;
            function TA(sA, F) {
              if (!sA) {
                var o = new Error("Promise was rejected with a falsy value");
                o.reason = sA, sA = o;
              }
              return F(sA);
            }
            function fA(sA) {
              if (typeof sA != "function")
                throw new TypeError('The "original" argument must be of type Function');
              function F() {
                for (var o = [], h = 0; h < arguments.length; h++)
                  o.push(arguments[h]);
                var _ = o.pop();
                if (typeof _ != "function")
                  throw new TypeError("The last argument must be of type Function");
                var oA = this, p = function() {
                  return _.apply(oA, arguments);
                };
                sA.apply(this, o).then(
                  function(rA) {
                    A.nextTick(p.bind(null, null, rA));
                  },
                  function(rA) {
                    A.nextTick(TA.bind(null, rA, p));
                  }
                );
              }
              return Object.setPrototypeOf(F, Object.getPrototypeOf(sA)), Object.defineProperties(
                F,
                a(sA)
              ), F;
            }
            B.callbackify = fA;
          },
          /***/
          3381(Q, B, r) {
            var A = r(8404), a = r(821), d = r(6601), x = r(2774), U = r(8109), P = r(7106), D = x("Object.prototype.toString"), J = r(6626)(), q = typeof globalThis > "u" ? r.g : globalThis, AA = a(), K = x("String.prototype.slice"), z = x("Array.prototype.indexOf", !0) || function(IA, k) {
              for (var tA = 0; tA < IA.length; tA += 1)
                if (IA[tA] === k)
                  return tA;
              return -1;
            }, T = { __proto__: null };
            J && U && P ? A(AA, function(CA) {
              var IA = new q[CA]();
              if (Symbol.toStringTag in IA && P) {
                var k = P(IA), tA = U(k, Symbol.toStringTag);
                if (!tA && k) {
                  var lA = P(k);
                  tA = U(lA, Symbol.toStringTag);
                }
                if (tA && tA.get) {
                  var uA = d(tA.get);
                  T[
                    /** @type {`$${import('.').TypedArrayName}`} */
                    "$" + CA
                  ] = uA;
                }
              }
            }) : A(AA, function(CA) {
              var IA = new q[CA](), k = IA.slice || IA.set;
              if (k) {
                var tA = (
                  /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
                  // @ts-expect-error TODO FIXME
                  d(k)
                );
                T[
                  /** @type {`$${import('.').TypedArrayName}`} */
                  "$" + CA
                ] = tA;
              }
            });
            var H = function(IA) {
              var k = !1;
              return A(
                /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
                T,
                /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
                function(tA, lA) {
                  if (!k)
                    try {
                      "$" + tA(IA) === lA && (k = /** @type {import('.').TypedArrayName} */
                      K(lA, 1));
                    } catch {
                    }
                }
              ), k;
            }, eA = function(IA) {
              var k = !1;
              return A(
                /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
                T,
                /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
                function(tA, lA) {
                  if (!k)
                    try {
                      tA(IA), k = /** @type {import('.').TypedArrayName} */
                      K(lA, 1);
                    } catch {
                    }
                }
              ), k;
            };
            Q.exports = function(IA) {
              if (!IA || typeof IA != "object")
                return !1;
              if (!J) {
                var k = K(D(IA), 8, -1);
                return z(AA, k) > -1 ? k : k !== "Object" ? !1 : eA(IA);
              }
              return U ? H(IA) : null;
            };
          },
          /***/
          6457(Q, B, r) {
            var A, a, d;
            (function(x, U) {
              a = [], A = U, d = typeof A == "function" ? A.apply(B, a) : A, d !== void 0 && (Q.exports = d);
            })(this, function() {
              function x(K, z) {
                return typeof z > "u" ? z = { autoBom: !1 } : typeof z != "object" && (console.warn("Deprecated: Expected third argument to be a object"), z = { autoBom: !z }), z.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(K.type) ? new Blob(["\uFEFF", K], { type: K.type }) : K;
              }
              function U(K, z, T) {
                var H = new XMLHttpRequest();
                H.open("GET", K), H.responseType = "blob", H.onload = function() {
                  AA(H.response, z, T);
                }, H.onerror = function() {
                  console.error("could not download file");
                }, H.send();
              }
              function P(K) {
                var z = new XMLHttpRequest();
                z.open("HEAD", K, !1);
                try {
                  z.send();
                } catch {
                }
                return 200 <= z.status && 299 >= z.status;
              }
              function D(K) {
                try {
                  K.dispatchEvent(new MouseEvent("click"));
                } catch {
                  var z = document.createEvent("MouseEvents");
                  z.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), K.dispatchEvent(z);
                }
              }
              var J = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof r.g == "object" && r.g.global === r.g ? r.g : void 0, q = J.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), AA = J.saveAs || (typeof window != "object" || window !== J ? function() {
              } : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !q ? function(K, z, T) {
                var H = J.URL || J.webkitURL, eA = document.createElement("a");
                z = z || K.name || "download", eA.download = z, eA.rel = "noopener", typeof K == "string" ? (eA.href = K, eA.origin === location.origin ? D(eA) : P(eA.href) ? U(K, z, T) : D(eA, eA.target = "_blank")) : (eA.href = H.createObjectURL(K), setTimeout(function() {
                  H.revokeObjectURL(eA.href);
                }, 4e4), setTimeout(function() {
                  D(eA);
                }, 0));
              } : "msSaveOrOpenBlob" in navigator ? function(K, z, T) {
                if (z = z || K.name || "download", typeof K != "string") navigator.msSaveOrOpenBlob(x(K, T), z);
                else if (P(K)) U(K, z, T);
                else {
                  var H = document.createElement("a");
                  H.href = K, H.target = "_blank", setTimeout(function() {
                    D(H);
                  });
                }
              } : function(K, z, T, H) {
                if (H = H || open("", "_blank"), H && (H.document.title = H.document.body.innerText = "downloading..."), typeof K == "string") return U(K, z, T);
                var eA = K.type === "application/octet-stream", CA = /constructor/i.test(J.HTMLElement) || J.safari, IA = /CriOS\/[\d]+/.test(navigator.userAgent);
                if ((IA || eA && CA || q) && typeof FileReader < "u") {
                  var k = new FileReader();
                  k.onloadend = function() {
                    var uA = k.result;
                    uA = IA ? uA : uA.replace(/^data:[^;]*;/, "data:attachment/file;"), H ? H.location.href = uA : location = uA, H = null;
                  }, k.readAsDataURL(K);
                } else {
                  var tA = J.URL || J.webkitURL, lA = tA.createObjectURL(K);
                  H ? H.location = lA : location.href = lA, H = null, setTimeout(function() {
                    tA.revokeObjectURL(lA);
                  }, 4e4);
                }
              });
              J.saveAs = AA.saveAs = AA, Q.exports = AA;
            });
          },
          /***/
          6274() {
          },
          /***/
          8535() {
          },
          /***/
          5470() {
          },
          /***/
          3779() {
          },
          /***/
          7199() {
          },
          /***/
          5117(Q) {
            Q.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
          },
          /***/
          4074(Q, B, r) {
            var A = r(5117), a = r(5144), d = r(7756), x = r(8681), U = r(3598), P = r(6341), D = r(9391), J = r(8819), q = r(5719), AA = r(4092), K = r(1182), z = r(9877), T = r(8607), H = r(443), eA = r(8663), CA = r(6044), IA = r(6921), k = IA.enforce, tA = IA.get, lA = d.Int8Array, uA = lA && lA.prototype, w = d.Uint8ClampedArray, v = w && w.prototype, RA = lA && T(lA), DA = uA && T(uA), $ = Object.prototype, cA = d.TypeError, $A = eA("toStringTag"), kA = CA("TYPED_ARRAY_TAG"), WA = "TypedArrayConstructor", EA = A && !!H && D(d.opera) !== "Opera", zA = !1, OA, xA, LA, yA = {
              Int8Array: 1,
              Uint8Array: 1,
              Uint8ClampedArray: 1,
              Int16Array: 2,
              Uint16Array: 2,
              Int32Array: 4,
              Uint32Array: 4,
              Float32Array: 4,
              Float64Array: 8
            }, TA = {
              BigInt64Array: 8,
              BigUint64Array: 8
            }, fA = function(rA) {
              if (!U(rA)) return !1;
              var QA = D(rA);
              return QA === "DataView" || P(yA, QA) || P(TA, QA);
            }, sA = function(p) {
              var rA = T(p);
              if (U(rA)) {
                var QA = tA(rA);
                return QA && P(QA, WA) ? QA[WA] : sA(rA);
              }
            }, F = function(p) {
              if (!U(p)) return !1;
              var rA = D(p);
              return P(yA, rA) || P(TA, rA);
            }, o = function(p) {
              if (F(p)) return p;
              throw new cA("Target is not a typed array");
            }, h = function(p) {
              if (x(p) && (!H || z(RA, p))) return p;
              throw new cA(J(p) + " is not a typed array constructor");
            }, _ = function(p, rA, QA, bA) {
              if (a) {
                if (QA) for (var y in yA) {
                  var M = d[y];
                  if (M && P(M.prototype, p)) try {
                    delete M.prototype[p];
                  } catch {
                    try {
                      M.prototype[p] = rA;
                    } catch {
                    }
                  }
                }
                (!DA[p] || QA) && AA(DA, p, QA ? rA : EA && uA[p] || rA, bA);
              }
            }, oA = function(p, rA, QA) {
              var bA, y;
              if (a) {
                if (H) {
                  if (QA) {
                    for (bA in yA)
                      if (y = d[bA], y && P(y, p)) try {
                        delete y[p];
                      } catch {
                      }
                  }
                  if (!RA[p] || QA)
                    try {
                      return AA(RA, p, QA ? rA : EA && RA[p] || rA);
                    } catch {
                    }
                  else return;
                }
                for (bA in yA)
                  y = d[bA], y && (!y[p] || QA) && AA(y, p, rA);
              }
            };
            for (OA in yA)
              xA = d[OA], LA = xA && xA.prototype, LA ? k(LA)[WA] = xA : EA = !1;
            for (OA in TA)
              xA = d[OA], LA = xA && xA.prototype, LA && (k(LA)[WA] = xA);
            if ((!EA || !x(RA) || RA === Function.prototype) && (RA = function() {
              throw new cA("Incorrect invocation");
            }, EA))
              for (OA in yA)
                d[OA] && H(d[OA], RA);
            if ((!EA || !DA || DA === $) && (DA = RA.prototype, EA))
              for (OA in yA)
                d[OA] && H(d[OA].prototype, DA);
            if (EA && T(v) !== DA && H(v, DA), a && !P(DA, $A)) {
              zA = !0, K(DA, $A, {
                configurable: !0,
                get: function() {
                  return U(this) ? this[kA] : void 0;
                }
              });
              for (OA in yA) d[OA] && q(d[OA].prototype, kA, OA);
            }
            Q.exports = {
              NATIVE_ARRAY_BUFFER_VIEWS: EA,
              TYPED_ARRAY_TAG: zA && kA,
              aTypedArray: o,
              aTypedArrayConstructor: h,
              exportTypedArrayMethod: _,
              exportTypedArrayStaticMethod: oA,
              getTypedArrayConstructor: sA,
              isView: fA,
              isTypedArray: F,
              TypedArray: RA,
              TypedArrayPrototype: DA
            };
          },
          /***/
          4415(Q, B) {
            function r(A, a, d) {
              return a in A ? Object.defineProperty(A, a, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : A[a] = d, A;
            }
            B._ = r;
          },
          /***/
          8395(Q, B, r) {
            B._ = r(1635).__decorate;
          },
          /***/
          821(Q, B, r) {
            var A = r(884), a = typeof globalThis > "u" ? r.g : globalThis;
            Q.exports = function() {
              for (var x = [], U = 0; U < A.length; U++)
                typeof a[A[U]] == "function" && (x[x.length] = A[U]);
              return x;
            };
          },
          /***/
          890(Q, B, r) {
            var A = r(6341), a = r(8468), d = r(5888), x = r(3793), U = d.data, P = d.normalize, D = "USE_FUNCTION_CONSTRUCTOR", J = "AsyncIteratorPrototype", q = function(AA, K) {
              if (a(AA)) for (var z = 0; z < AA.length; z++) U[P(AA[z])] = K;
            };
            Q.exports = function(AA) {
              AA && typeof AA == "object" && (q(AA.useNative, d.NATIVE), q(AA.usePolyfill, d.POLYFILL), q(AA.useFeatureDetection, null), A(AA, D) && (x[D] = !!AA[D]), A(AA, J) && (x[J] = AA[J]));
            };
          },
          /***/
          1078(Q, B, r) {
            var A = r(8681), a = r(8819), d = TypeError;
            Q.exports = function(x) {
              if (A(x)) return x;
              throw new d(a(x) + " is not a function");
            };
          },
          /***/
          7222(Q, B, r) {
            var A = r(2657), a = String, d = TypeError;
            Q.exports = function(x) {
              if (A(x)) return x;
              throw new d("Can't set " + a(x) + " as a prototype");
            };
          },
          /***/
          1825(Q, B, r) {
            var A = r(8663), a = r(4860), d = r(2333).f, x = A("unscopables"), U = Array.prototype;
            U[x] === void 0 && d(U, x, {
              configurable: !0,
              value: a(null)
            }), Q.exports = function(P) {
              U[x][P] = !0;
            };
          },
          /***/
          2091(Q, B, r) {
            var A = r(3598), a = String, d = TypeError;
            Q.exports = function(x) {
              if (A(x)) return x;
              throw new d(a(x) + " is not an object");
            };
          },
          /***/
          3161(Q, B, r) {
            var A = r(3297), a = r(4918), d = r(4730);
            Q.exports = function(U) {
              for (var P = A(this), D = d(P), J = arguments.length, q = a(J > 1 ? arguments[1] : void 0, D), AA = J > 2 ? arguments[2] : void 0, K = AA === void 0 ? D : a(AA, D); K > q; ) P[q++] = U;
              return P;
            };
          },
          /***/
          789(Q, B, r) {
            var A = r(5137), a = r(4918), d = r(4730), x = function(U) {
              return function(P, D, J) {
                var q = A(P), AA = d(q);
                if (AA === 0) return !U && -1;
                var K = a(J, AA), z;
                if (U && D !== D) {
                  for (; AA > K; )
                    if (z = q[K++], z !== z) return !0;
                } else for (; AA > K; K++)
                  if ((U || K in q) && q[K] === D) return U || K || 0;
                return !U && -1;
              };
            };
            Q.exports = {
              // `Array.prototype.includes` method
              // https://tc39.es/ecma262/#sec-array.prototype.includes
              includes: x(!0),
              // `Array.prototype.indexOf` method
              // https://tc39.es/ecma262/#sec-array.prototype.indexof
              indexOf: x(!1)
            };
          },
          /***/
          2740(Q, B, r) {
            var A = r(1212);
            Q.exports = A([].slice);
          },
          /***/
          644(Q, B, r) {
            var A = r(2740), a = Math.floor, d = function(x, U) {
              var P = x.length;
              if (P < 8)
                for (var D = 1, J, q; D < P; ) {
                  for (q = D, J = x[D]; q && U(x[q - 1], J) > 0; )
                    x[q] = x[--q];
                  q !== D++ && (x[q] = J);
                }
              else
                for (var AA = a(P / 2), K = d(A(x, 0, AA), U), z = d(A(x, AA), U), T = K.length, H = z.length, eA = 0, CA = 0; eA < T || CA < H; )
                  x[eA + CA] = eA < T && CA < H ? U(K[eA], z[CA]) <= 0 ? K[eA++] : z[CA++] : eA < T ? K[eA++] : z[CA++];
              return x;
            };
            Q.exports = d;
          },
          /***/
          8420(Q, B, r) {
            var A = r(1212), a = A({}.toString), d = A("".slice);
            Q.exports = function(x) {
              return d(a(x), 8, -1);
            };
          },
          /***/
          9391(Q, B, r) {
            var A = r(7920), a = r(8681), d = r(8420), x = r(8663), U = x("toStringTag"), P = Object, D = d(/* @__PURE__ */ (function() {
              return arguments;
            })()) === "Arguments", J = function(q, AA) {
              try {
                return q[AA];
              } catch {
              }
            };
            Q.exports = A ? d : function(q) {
              var AA, K, z;
              return q === void 0 ? "Undefined" : q === null ? "Null" : typeof (K = J(AA = P(q), U)) == "string" ? K : D ? d(AA) : (z = d(AA)) === "Object" && a(AA.callee) ? "Arguments" : z;
            };
          },
          /***/
          8032(Q, B, r) {
            var A = r(6341), a = r(7523), d = r(423), x = r(2333);
            Q.exports = function(U, P, D) {
              for (var J = a(P), q = x.f, AA = d.f, K = 0; K < J.length; K++) {
                var z = J[K];
                !A(U, z) && !(D && A(D, z)) && q(U, z, AA(P, z));
              }
            };
          },
          /***/
          5071(Q, B, r) {
            var A = r(299);
            Q.exports = !A(function() {
              function a() {
              }
              return a.prototype.constructor = null, Object.getPrototypeOf(new a()) !== a.prototype;
            });
          },
          /***/
          5719(Q, B, r) {
            var A = r(5144), a = r(2333), d = r(8264);
            Q.exports = A ? function(x, U, P) {
              return a.f(x, U, d(1, P));
            } : function(x, U, P) {
              return x[U] = P, x;
            };
          },
          /***/
          8264(Q) {
            Q.exports = function(B, r) {
              return {
                enumerable: !(B & 1),
                configurable: !(B & 2),
                writable: !(B & 4),
                value: r
              };
            };
          },
          /***/
          1182(Q, B, r) {
            var A = r(3383), a = r(2333);
            Q.exports = function(d, x, U) {
              return U.get && A(U.get, x, { getter: !0 }), U.set && A(U.set, x, { setter: !0 }), a.f(d, x, U);
            };
          },
          /***/
          4092(Q, B, r) {
            var A = r(8681), a = r(2333), d = r(3383), x = r(7309);
            Q.exports = function(U, P, D, J) {
              J || (J = {});
              var q = J.enumerable, AA = J.name !== void 0 ? J.name : P;
              if (A(D) && d(D, AA, J), J.global)
                q ? U[P] = D : x(P, D);
              else {
                try {
                  J.unsafe ? U[P] && (q = !0) : delete U[P];
                } catch {
                }
                q ? U[P] = D : a.f(U, P, {
                  value: D,
                  enumerable: !1,
                  configurable: !J.nonConfigurable,
                  writable: !J.nonWritable
                });
              }
              return U;
            };
          },
          /***/
          7309(Q, B, r) {
            var A = r(7756), a = Object.defineProperty;
            Q.exports = function(d, x) {
              try {
                a(A, d, { value: x, configurable: !0, writable: !0 });
              } catch {
                A[d] = x;
              }
              return x;
            };
          },
          /***/
          5144(Q, B, r) {
            var A = r(299);
            Q.exports = !A(function() {
              return Object.defineProperty({}, 1, { get: function() {
                return 7;
              } })[1] !== 7;
            });
          },
          /***/
          2283(Q, B, r) {
            var A = r(7756), a = r(3598), d = A.document, x = a(d) && a(d.createElement);
            Q.exports = function(U) {
              return x ? d.createElement(U) : {};
            };
          },
          /***/
          2555(Q) {
            Q.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          },
          /***/
          5337(Q, B, r) {
            var A = r(8115), a = A.match(/firefox\/(\d+)/i);
            Q.exports = !!a && +a[1];
          },
          /***/
          7383(Q, B, r) {
            var A = r(8115);
            Q.exports = /MSIE|Trident/.test(A);
          },
          /***/
          8115(Q, B, r) {
            var A = r(7756), a = A.navigator, d = a && a.userAgent;
            Q.exports = d ? String(d) : "";
          },
          /***/
          2227(Q, B, r) {
            var A = r(7756), a = r(8115), d = A.process, x = A.Deno, U = d && d.versions || x && x.version, P = U && U.v8, D, J;
            P && (D = P.split("."), J = D[0] > 0 && D[0] < 4 ? 1 : +(D[0] + D[1])), !J && a && (D = a.match(/Edge\/(\d+)/), (!D || D[1] >= 74) && (D = a.match(/Chrome\/(\d+)/), D && (J = +D[1]))), Q.exports = J;
          },
          /***/
          4507(Q, B, r) {
            var A = r(8115), a = A.match(/AppleWebKit\/(\d+)\./);
            Q.exports = !!a && +a[1];
          },
          /***/
          3762(Q, B, r) {
            var A = r(7756), a = r(423).f, d = r(5719), x = r(4092), U = r(7309), P = r(8032), D = r(5888);
            Q.exports = function(J, q) {
              var AA = J.target, K = J.global, z = J.stat, T, H, eA, CA, IA, k;
              if (K ? H = A : z ? H = A[AA] || U(AA, {}) : H = A[AA] && A[AA].prototype, H) for (eA in q) {
                if (IA = q[eA], J.dontCallGetSet ? (k = a(H, eA), CA = k && k.value) : CA = H[eA], T = D(K ? eA : AA + (z ? "." : "#") + eA, J.forced), !T && CA !== void 0) {
                  if (typeof IA == typeof CA) continue;
                  P(IA, CA);
                }
                (J.sham || CA && CA.sham) && d(IA, "sham", !0), x(H, eA, IA, J);
              }
            };
          },
          /***/
          299(Q) {
            Q.exports = function(B) {
              try {
                return !!B();
              } catch {
                return !0;
              }
            };
          },
          /***/
          1676(Q, B, r) {
            var A = r(299);
            Q.exports = !A(function() {
              var a = (function() {
              }).bind();
              return typeof a != "function" || a.hasOwnProperty("prototype");
            });
          },
          /***/
          8993(Q, B, r) {
            var A = r(1676), a = Function.prototype.call;
            Q.exports = A ? a.bind(a) : function() {
              return a.apply(a, arguments);
            };
          },
          /***/
          4378(Q, B, r) {
            var A = r(5144), a = r(6341), d = Function.prototype, x = A && Object.getOwnPropertyDescriptor, U = a(d, "name"), P = U && (function() {
            }).name === "something", D = U && (!A || A && x(d, "name").configurable);
            Q.exports = {
              EXISTS: U,
              PROPER: P,
              CONFIGURABLE: D
            };
          },
          /***/
          4494(Q, B, r) {
            var A = r(1212), a = r(1078);
            Q.exports = function(d, x, U) {
              try {
                return A(a(Object.getOwnPropertyDescriptor(d, x)[U]));
              } catch {
              }
            };
          },
          /***/
          5336(Q, B, r) {
            var A = r(8420), a = r(1212);
            Q.exports = function(d) {
              if (A(d) === "Function") return a(d);
            };
          },
          /***/
          1212(Q, B, r) {
            var A = r(1676), a = Function.prototype, d = a.call, x = A && a.bind.bind(d, d);
            Q.exports = A ? x : function(U) {
              return function() {
                return d.apply(U, arguments);
              };
            };
          },
          /***/
          7139(Q, B, r) {
            var A = r(7756), a = r(8681), d = function(x) {
              return a(x) ? x : void 0;
            };
            Q.exports = function(x, U) {
              return arguments.length < 2 ? d(A[x]) : A[x] && A[x][U];
            };
          },
          /***/
          9738(Q, B, r) {
            var A = r(1078), a = r(6297);
            Q.exports = function(d, x) {
              var U = d[x];
              return a(U) ? void 0 : A(U);
            };
          },
          /***/
          7756(Q, B, r) {
            var A = function(a) {
              return a && a.Math === Math && a;
            };
            Q.exports = // eslint-disable-next-line es/no-global-this -- safe
            A(typeof globalThis == "object" && globalThis) || A(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
            A(typeof self == "object" && self) || A(typeof r.g == "object" && r.g) || A(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
            /* @__PURE__ */ (function() {
              return this;
            })() || Function("return this")();
          },
          /***/
          6341(Q, B, r) {
            var A = r(1212), a = r(3297), d = A({}.hasOwnProperty);
            Q.exports = Object.hasOwn || function(U, P) {
              return d(a(U), P);
            };
          },
          /***/
          2993(Q) {
            Q.exports = {};
          },
          /***/
          4329(Q, B, r) {
            var A = r(7139);
            Q.exports = A("document", "documentElement");
          },
          /***/
          7657(Q, B, r) {
            var A = r(5144), a = r(299), d = r(2283);
            Q.exports = !A && !a(function() {
              return Object.defineProperty(d("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a !== 7;
            });
          },
          /***/
          2203(Q, B, r) {
            var A = r(1212), a = r(299), d = r(8420), x = Object, U = A("".split);
            Q.exports = a(function() {
              return !x("z").propertyIsEnumerable(0);
            }) ? function(P) {
              return d(P) === "String" ? U(P, "") : x(P);
            } : x;
          },
          /***/
          4550(Q, B, r) {
            var A = r(1212), a = r(8681), d = r(3793), x = A(Function.toString);
            a(d.inspectSource) || (d.inspectSource = function(U) {
              return x(U);
            }), Q.exports = d.inspectSource;
          },
          /***/
          6921(Q, B, r) {
            var A = r(1194), a = r(7756), d = r(3598), x = r(5719), U = r(6341), P = r(3793), D = r(7099), J = r(2993), q = "Object already initialized", AA = a.TypeError, K = a.WeakMap, z, T, H, eA = function(tA) {
              return H(tA) ? T(tA) : z(tA, {});
            }, CA = function(tA) {
              return function(lA) {
                var uA;
                if (!d(lA) || (uA = T(lA)).type !== tA)
                  throw new AA("Incompatible receiver, " + tA + " required");
                return uA;
              };
            };
            if (A || P.state) {
              var IA = P.state || (P.state = new K());
              IA.get = IA.get, IA.has = IA.has, IA.set = IA.set, z = function(tA, lA) {
                if (IA.has(tA)) throw new AA(q);
                return lA.facade = tA, IA.set(tA, lA), lA;
              }, T = function(tA) {
                return IA.get(tA) || {};
              }, H = function(tA) {
                return IA.has(tA);
              };
            } else {
              var k = D("state");
              J[k] = !0, z = function(tA, lA) {
                if (U(tA, k)) throw new AA(q);
                return lA.facade = tA, x(tA, k, lA), lA;
              }, T = function(tA) {
                return U(tA, k) ? tA[k] : {};
              }, H = function(tA) {
                return U(tA, k);
              };
            }
            Q.exports = {
              set: z,
              get: T,
              has: H,
              enforce: eA,
              getterFor: CA
            };
          },
          /***/
          8468(Q, B, r) {
            var A = r(8420);
            Q.exports = Array.isArray || function(d) {
              return A(d) === "Array";
            };
          },
          /***/
          8681(Q) {
            var B = typeof document == "object" && document.all;
            Q.exports = typeof B > "u" && B !== void 0 ? function(r) {
              return typeof r == "function" || r === B;
            } : function(r) {
              return typeof r == "function";
            };
          },
          /***/
          5888(Q, B, r) {
            var A = r(299), a = r(8681), d = /#|\.prototype\./, x = function(q, AA) {
              var K = P[U(q)];
              return K === J ? !0 : K === D ? !1 : a(AA) ? A(AA) : !!AA;
            }, U = x.normalize = function(q) {
              return String(q).replace(d, ".").toLowerCase();
            }, P = x.data = {}, D = x.NATIVE = "N", J = x.POLYFILL = "P";
            Q.exports = x;
          },
          /***/
          6297(Q) {
            Q.exports = function(B) {
              return B == null;
            };
          },
          /***/
          3598(Q, B, r) {
            var A = r(8681);
            Q.exports = function(a) {
              return typeof a == "object" ? a !== null : A(a);
            };
          },
          /***/
          2657(Q, B, r) {
            var A = r(3598);
            Q.exports = function(a) {
              return A(a) || a === null;
            };
          },
          /***/
          7695(Q) {
            Q.exports = !1;
          },
          /***/
          5985(Q, B, r) {
            var A = r(7139), a = r(8681), d = r(9877), x = r(8300), U = Object;
            Q.exports = x ? function(P) {
              return typeof P == "symbol";
            } : function(P) {
              var D = A("Symbol");
              return a(D) && d(D.prototype, U(P));
            };
          },
          /***/
          4730(Q, B, r) {
            var A = r(8266);
            Q.exports = function(a) {
              return A(a.length);
            };
          },
          /***/
          3383(Q, B, r) {
            var A = r(1212), a = r(299), d = r(8681), x = r(6341), U = r(5144), P = r(4378).CONFIGURABLE, D = r(4550), J = r(6921), q = J.enforce, AA = J.get, K = String, z = Object.defineProperty, T = A("".slice), H = A("".replace), eA = A([].join), CA = U && !a(function() {
              return z(function() {
              }, "length", { value: 8 }).length !== 8;
            }), IA = String(String).split("String"), k = Q.exports = function(tA, lA, uA) {
              T(K(lA), 0, 7) === "Symbol(" && (lA = "[" + H(K(lA), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), uA && uA.getter && (lA = "get " + lA), uA && uA.setter && (lA = "set " + lA), (!x(tA, "name") || P && tA.name !== lA) && (U ? z(tA, "name", { value: lA, configurable: !0 }) : tA.name = lA), CA && uA && x(uA, "arity") && tA.length !== uA.arity && z(tA, "length", { value: uA.arity });
              try {
                uA && x(uA, "constructor") && uA.constructor ? U && z(tA, "prototype", { writable: !1 }) : tA.prototype && (tA.prototype = void 0);
              } catch {
              }
              var w = q(tA);
              return x(w, "source") || (w.source = eA(IA, typeof lA == "string" ? lA : "")), tA;
            };
            Function.prototype.toString = k(function() {
              return d(this) && AA(this).source || D(this);
            }, "toString");
          },
          /***/
          2537(Q) {
            var B = Math.ceil, r = Math.floor;
            Q.exports = Math.trunc || function(a) {
              var d = +a;
              return (d > 0 ? r : B)(d);
            };
          },
          /***/
          4860(Q, B, r) {
            var A = r(2091), a = r(2197), d = r(2555), x = r(2993), U = r(4329), P = r(2283), D = r(7099), J = ">", q = "<", AA = "prototype", K = "script", z = D("IE_PROTO"), T = function() {
            }, H = function(tA) {
              return q + K + J + tA + q + "/" + K + J;
            }, eA = function(tA) {
              tA.write(H("")), tA.close();
              var lA = tA.parentWindow.Object;
              return tA = null, lA;
            }, CA = function() {
              var tA = P("iframe"), lA = "java" + K + ":", uA;
              return tA.style.display = "none", U.appendChild(tA), tA.src = String(lA), uA = tA.contentWindow.document, uA.open(), uA.write(H("document.F=Object")), uA.close(), uA.F;
            }, IA, k = function() {
              try {
                IA = new ActiveXObject("htmlfile");
              } catch {
              }
              k = typeof document < "u" ? document.domain && IA ? eA(IA) : CA() : eA(IA);
              for (var tA = d.length; tA--; ) delete k[AA][d[tA]];
              return k();
            };
            x[z] = !0, Q.exports = Object.create || function(lA, uA) {
              var w;
              return lA !== null ? (T[AA] = A(lA), w = new T(), T[AA] = null, w[z] = lA) : w = k(), uA === void 0 ? w : a.f(w, uA);
            };
          },
          /***/
          2197(Q, B, r) {
            var A = r(5144), a = r(2538), d = r(2333), x = r(2091), U = r(5137), P = r(9428);
            B.f = A && !a ? Object.defineProperties : function(J, q) {
              x(J);
              for (var AA = U(q), K = P(q), z = K.length, T = 0, H; z > T; ) d.f(J, H = K[T++], AA[H]);
              return J;
            };
          },
          /***/
          2333(Q, B, r) {
            var A = r(5144), a = r(7657), d = r(2538), x = r(2091), U = r(1413), P = TypeError, D = Object.defineProperty, J = Object.getOwnPropertyDescriptor, q = "enumerable", AA = "configurable", K = "writable";
            B.f = A ? d ? function(T, H, eA) {
              if (x(T), H = U(H), x(eA), typeof T == "function" && H === "prototype" && "value" in eA && K in eA && !eA[K]) {
                var CA = J(T, H);
                CA && CA[K] && (T[H] = eA.value, eA = {
                  configurable: AA in eA ? eA[AA] : CA[AA],
                  enumerable: q in eA ? eA[q] : CA[q],
                  writable: !1
                });
              }
              return D(T, H, eA);
            } : D : function(T, H, eA) {
              if (x(T), H = U(H), x(eA), a) try {
                return D(T, H, eA);
              } catch {
              }
              if ("get" in eA || "set" in eA) throw new P("Accessors not supported");
              return "value" in eA && (T[H] = eA.value), T;
            };
          },
          /***/
          423(Q, B, r) {
            var A = r(5144), a = r(8993), d = r(4961), x = r(8264), U = r(5137), P = r(1413), D = r(6341), J = r(7657), q = Object.getOwnPropertyDescriptor;
            B.f = A ? q : function(K, z) {
              if (K = U(K), z = P(z), J) try {
                return q(K, z);
              } catch {
              }
              if (D(K, z)) return x(!a(d.f, K, z), K[z]);
            };
          },
          /***/
          5412(Q, B, r) {
            var A = r(3120), a = r(2555), d = a.concat("length", "prototype");
            B.f = Object.getOwnPropertyNames || function(U) {
              return A(U, d);
            };
          },
          /***/
          4073(Q, B) {
            B.f = Object.getOwnPropertySymbols;
          },
          /***/
          8607(Q, B, r) {
            var A = r(6341), a = r(8681), d = r(3297), x = r(7099), U = r(5071), P = x("IE_PROTO"), D = Object, J = D.prototype;
            Q.exports = U ? D.getPrototypeOf : function(q) {
              var AA = d(q);
              if (A(AA, P)) return AA[P];
              var K = AA.constructor;
              return a(K) && AA instanceof K ? K.prototype : AA instanceof D ? J : null;
            };
          },
          /***/
          9877(Q, B, r) {
            var A = r(1212);
            Q.exports = A({}.isPrototypeOf);
          },
          /***/
          3120(Q, B, r) {
            var A = r(1212), a = r(6341), d = r(5137), x = r(789).indexOf, U = r(2993), P = A([].push);
            Q.exports = function(D, J) {
              var q = d(D), AA = 0, K = [], z;
              for (z in q) !a(U, z) && a(q, z) && P(K, z);
              for (; J.length > AA; ) a(q, z = J[AA++]) && (~x(K, z) || P(K, z));
              return K;
            };
          },
          /***/
          9428(Q, B, r) {
            var A = r(3120), a = r(2555);
            Q.exports = Object.keys || function(x) {
              return A(x, a);
            };
          },
          /***/
          4961(Q, B) {
            var r = {}.propertyIsEnumerable, A = Object.getOwnPropertyDescriptor, a = A && !r.call({ 1: 2 }, 1);
            B.f = a ? function(x) {
              var U = A(this, x);
              return !!U && U.enumerable;
            } : r;
          },
          /***/
          443(Q, B, r) {
            var A = r(4494), a = r(3598), d = r(5034), x = r(7222);
            Q.exports = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
              var U = !1, P = {}, D;
              try {
                D = A(Object.prototype, "__proto__", "set"), D(P, []), U = P instanceof Array;
              } catch {
              }
              return function(q, AA) {
                return d(q), x(AA), a(q) && (U ? D(q, AA) : q.__proto__ = AA), q;
              };
            })() : void 0);
          },
          /***/
          290(Q, B, r) {
            var A = r(8993), a = r(8681), d = r(3598), x = TypeError;
            Q.exports = function(U, P) {
              var D, J;
              if (P === "string" && a(D = U.toString) && !d(J = A(D, U)) || a(D = U.valueOf) && !d(J = A(D, U)) || P !== "string" && a(D = U.toString) && !d(J = A(D, U))) return J;
              throw new x("Can't convert object to primitive value");
            };
          },
          /***/
          7523(Q, B, r) {
            var A = r(7139), a = r(1212), d = r(5412), x = r(4073), U = r(2091), P = a([].concat);
            Q.exports = A("Reflect", "ownKeys") || function(J) {
              var q = d.f(U(J)), AA = x.f;
              return AA ? P(q, AA(J)) : q;
            };
          },
          /***/
          5034(Q, B, r) {
            var A = r(6297), a = TypeError;
            Q.exports = function(d) {
              if (A(d)) throw new a("Can't call method on " + d);
              return d;
            };
          },
          /***/
          7099(Q, B, r) {
            var A = r(997), a = r(6044), d = A("keys");
            Q.exports = function(x) {
              return d[x] || (d[x] = a(x));
            };
          },
          /***/
          3793(Q, B, r) {
            var A = r(7695), a = r(7756), d = r(7309), x = "__core-js_shared__", U = Q.exports = a[x] || d(x, {});
            (U.versions || (U.versions = [])).push({
              version: "3.49.0",
              mode: A ? "pure" : "global",
              copyright: "© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.",
              license: "https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE",
              source: "https://github.com/zloirock/core-js"
            });
          },
          /***/
          997(Q, B, r) {
            var A = r(3793);
            Q.exports = function(a, d) {
              return A[a] || (A[a] = d || {});
            };
          },
          /***/
          4483(Q, B, r) {
            var A = r(2227), a = r(299), d = r(7756), x = d.String;
            Q.exports = !!Object.getOwnPropertySymbols && !a(function() {
              var U = Symbol("symbol detection");
              return !x(U) || !(Object(U) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
              !Symbol.sham && A && A < 41;
            });
          },
          /***/
          4918(Q, B, r) {
            var A = r(2119), a = Math.max, d = Math.min;
            Q.exports = function(x, U) {
              var P = A(x);
              return P < 0 ? a(P + U, 0) : d(P, U);
            };
          },
          /***/
          3018(Q, B, r) {
            var A = r(3301), a = TypeError;
            Q.exports = function(d) {
              var x = A(d, "number");
              if (typeof x == "number") throw new a("Can't convert number to bigint");
              return BigInt(x);
            };
          },
          /***/
          5137(Q, B, r) {
            var A = r(2203), a = r(5034);
            Q.exports = function(d) {
              return A(a(d));
            };
          },
          /***/
          2119(Q, B, r) {
            var A = r(2537);
            Q.exports = function(a) {
              var d = +a;
              return d !== d || d === 0 ? 0 : A(d);
            };
          },
          /***/
          8266(Q, B, r) {
            var A = r(2119), a = Math.min;
            Q.exports = function(d) {
              var x = A(d);
              return x > 0 ? a(x, 9007199254740991) : 0;
            };
          },
          /***/
          3297(Q, B, r) {
            var A = r(5034), a = Object;
            Q.exports = function(d) {
              return a(A(d));
            };
          },
          /***/
          4001(Q, B, r) {
            var A = r(7866), a = RangeError;
            Q.exports = function(d, x) {
              var U = A(d);
              if (U % x) throw new a("Wrong offset");
              return U;
            };
          },
          /***/
          7866(Q, B, r) {
            var A = r(2119), a = RangeError;
            Q.exports = function(d) {
              var x = A(d);
              if (x < 0) throw new a("The argument can't be less than 0");
              return x;
            };
          },
          /***/
          3301(Q, B, r) {
            var A = r(8993), a = r(3598), d = r(5985), x = r(9738), U = r(290), P = r(8663), D = TypeError, J = P("toPrimitive");
            Q.exports = function(q, AA) {
              if (!a(q) || d(q)) return q;
              var K = x(q, J), z;
              if (K) {
                if (AA === void 0 && (AA = "default"), z = A(K, q, AA), !a(z) || d(z)) return z;
                throw new D("Can't convert object to primitive value");
              }
              return AA === void 0 && (AA = "number"), U(q, AA);
            };
          },
          /***/
          1413(Q, B, r) {
            var A = r(3301), a = r(5985);
            Q.exports = function(d) {
              var x = A(d, "string");
              return a(x) ? x : x + "";
            };
          },
          /***/
          7920(Q, B, r) {
            var A = r(8663), a = A("toStringTag"), d = {};
            d[a] = "z", Q.exports = String(d) === "[object z]";
          },
          /***/
          8819(Q) {
            var B = String;
            Q.exports = function(r) {
              try {
                return B(r);
              } catch {
                return "Object";
              }
            };
          },
          /***/
          6044(Q, B, r) {
            var A = r(1212), a = 0, d = Math.random(), x = A(1.1.toString);
            Q.exports = function(U) {
              return "Symbol(" + (U === void 0 ? "" : U) + ")_" + x(++a + d, 36);
            };
          },
          /***/
          8300(Q, B, r) {
            var A = r(4483);
            Q.exports = A && !Symbol.sham && typeof Symbol.iterator == "symbol";
          },
          /***/
          2538(Q, B, r) {
            var A = r(5144), a = r(299);
            Q.exports = A && a(function() {
              return Object.defineProperty(function() {
              }, "prototype", {
                value: 42,
                writable: !1
              }).prototype !== 42;
            });
          },
          /***/
          1194(Q, B, r) {
            var A = r(7756), a = r(8681), d = A.WeakMap;
            Q.exports = a(d) && /native code/.test(String(d));
          },
          /***/
          8663(Q, B, r) {
            var A = r(7756), a = r(997), d = r(6341), x = r(6044), U = r(4483), P = r(8300), D = A.Symbol, J = a("wks"), q = P ? D.for || D : D && D.withoutSetter || x;
            Q.exports = function(AA) {
              return d(J, AA) || (J[AA] = U && d(D, AA) ? D[AA] : q("Symbol." + AA)), J[AA];
            };
          },
          /***/
          187(Q, B, r) {
            var A = r(3762), a = r(789).includes, d = r(299), x = r(1825), U = d(function() {
              return !Array(1).includes();
            }), P = d(function() {
              return [, 1].includes(void 0, 1);
            });
            A({ target: "Array", proto: !0, forced: U || P }, {
              includes: function(J) {
                return a(this, J, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), x("includes");
          },
          /***/
          8376(Q, B, r) {
            var A = r(4074), a = r(3161), d = r(3018), x = r(9391), U = r(8993), P = r(1212), D = r(299), J = A.aTypedArray, q = A.exportTypedArrayMethod, AA = P("".slice), K = D(function() {
              var z = 0;
              return new Int8Array(2).fill({ valueOf: function() {
                return z++;
              } }), z !== 1;
            });
            q("fill", function(T) {
              var H = arguments.length;
              J(this);
              var eA = AA(x(this), 0, 3) === "Big" ? d(T) : +T;
              return U(a, this, eA, H > 1 ? arguments[1] : void 0, H > 2 ? arguments[2] : void 0);
            }, K);
          },
          /***/
          6401(Q, B, r) {
            var A = r(7756), a = r(8993), d = r(4074), x = r(4730), U = r(4001), P = r(3297), D = r(299), J = A.RangeError, q = A.Int8Array, AA = q && q.prototype, K = AA && AA.set, z = d.aTypedArray, T = d.exportTypedArrayMethod, H = !D(function() {
              var CA = new Uint8ClampedArray(2);
              return a(K, CA, { length: 1, 0: 3 }, 1), CA[1] !== 3;
            }), eA = H && d.NATIVE_ARRAY_BUFFER_VIEWS && D(function() {
              var CA = new q(2);
              return CA.set(1), CA.set("2", 1), CA[0] !== 0 || CA[1] !== 2;
            });
            T("set", function(IA) {
              z(this);
              var k = U(arguments.length > 1 ? arguments[1] : void 0, 1), tA = P(IA);
              if (H) return a(K, this, tA, k);
              var lA = this.length, uA = x(tA), w = 0;
              if (uA + k > lA) throw new J("Wrong length");
              for (; w < uA; ) this[k + w] = tA[w++];
            }, !H || eA);
          },
          /***/
          2017(Q, B, r) {
            var A = r(7756), a = r(5336), d = r(299), x = r(1078), U = r(644), P = r(4074), D = r(5337), J = r(7383), q = r(2227), AA = r(4507), K = P.aTypedArray, z = P.exportTypedArrayMethod, T = A.Uint16Array, H = T && a(T.prototype.sort), eA = !!H && !(d(function() {
              H(new T(2), null);
            }) && d(function() {
              H(new T(2), {});
            })), CA = !!H && !d(function() {
              if (q) return q < 74;
              if (D) return D < 67;
              if (J) return !0;
              if (AA) return AA < 602;
              var k = new T(516), tA = Array(516), lA, uA;
              for (lA = 0; lA < 516; lA++)
                uA = lA % 4, k[lA] = 515 - lA, tA[lA] = lA - 2 * uA + 3;
              for (H(k, function(w, v) {
                return (w / 4 | 0) - (v / 4 | 0);
              }), lA = 0; lA < 516; lA++)
                if (k[lA] !== tA[lA]) return !0;
            }), IA = function(k) {
              return function(tA, lA) {
                return k !== void 0 ? +k(tA, lA) || 0 : lA !== lA ? tA !== tA ? 0 : -1 : tA !== tA ? 1 : tA === 0 && lA === 0 ? 1 / tA > 0 ? 1 / lA > 0 ? 0 : 1 : 1 / lA > 0 ? -1 : 0 : tA > lA ? 1 : tA < lA ? -1 : 0;
              };
            };
            z("sort", function(tA) {
              return tA !== void 0 && x(tA), CA ? H(this, tA) : U(K(this), IA(tA));
            }, !CA || eA);
          },
          /***/
          1715(Q, B, r) {
            var A = r(5233), a = r(4415), d = r(8395), x = r(453), U = r(4766), P = r(7571), D = r(4406), J = r(1613), q = r(3483), AA = r(4460);
            function K(BA, i) {
              return Object.keys(i).forEach(function(u) {
                u === "default" || u === "__esModule" || Object.prototype.hasOwnProperty.call(BA, u) || Object.defineProperty(BA, u, {
                  enumerable: !0,
                  get: function() {
                    return i[u];
                  }
                });
              }), BA;
            }
            function z(BA, i, u, m) {
              Object.defineProperty(BA, i, { get: u, set: m, enumerable: !0, configurable: !0 });
            }
            function T(BA) {
              return BA && BA.__esModule ? BA.default : BA;
            }
            var H = {};
            z(H, "logErrors", () => eA), z(H, "registerFormat", () => IA), z(H, "create", () => k), z(H, "defaultLanguage", () => tA), z(H, "setDefaultLanguage", () => lA);
            let eA = !1, CA = [];
            function IA(BA) {
              CA.push(BA);
            }
            function k(BA, i) {
              for (let u = 0; u < CA.length; u++) {
                let m = CA[u];
                if (m.probe(BA)) {
                  let L = new m(new A.DecodeStream(BA));
                  return i ? L.getFont(i) : L;
                }
              }
              throw new Error("Unknown font format");
            }
            let tA = "en";
            function lA(BA = "en") {
              tA = BA;
            }
            function uA(BA, i, u) {
              if (u.get) {
                let m = u.get;
                u.get = function() {
                  let L = m.call(this);
                  return Object.defineProperty(this, i, {
                    value: L
                  }), L;
                };
              } else if (typeof u.value == "function") {
                let m = u.value;
                return {
                  get() {
                    let L = /* @__PURE__ */ new Map();
                    function Z(...O) {
                      let PA = O.length > 0 ? O[0] : "value";
                      if (L.has(PA)) return L.get(PA);
                      let VA = m.apply(this, O);
                      return L.set(PA, VA), VA;
                    }
                    return Object.defineProperty(this, i, {
                      value: Z
                    }), Z;
                  }
                };
              }
            }
            let w = new A.Struct({
              firstCode: A.uint16,
              entryCount: A.uint16,
              idDelta: A.int16,
              idRangeOffset: A.uint16
            }), v = new A.Struct({
              startCharCode: A.uint32,
              endCharCode: A.uint32,
              glyphID: A.uint32
            }), RA = new A.Struct({
              startUnicodeValue: A.uint24,
              additionalCount: A.uint8
            }), DA = new A.Struct({
              unicodeValue: A.uint24,
              glyphID: A.uint16
            }), $ = new A.Array(RA, A.uint32), cA = new A.Array(DA, A.uint32), $A = new A.Struct({
              varSelector: A.uint24,
              defaultUVS: new A.Pointer(A.uint32, $, {
                type: "parent"
              }),
              nonDefaultUVS: new A.Pointer(A.uint32, cA, {
                type: "parent"
              })
            }), kA = new A.VersionedStruct(A.uint16, {
              0: {
                length: A.uint16,
                language: A.uint16,
                codeMap: new A.LazyArray(A.uint8, 256)
              },
              2: {
                length: A.uint16,
                language: A.uint16,
                subHeaderKeys: new A.Array(A.uint16, 256),
                subHeaderCount: (BA) => Math.max.apply(Math, BA.subHeaderKeys),
                subHeaders: new A.LazyArray(w, "subHeaderCount"),
                glyphIndexArray: new A.LazyArray(A.uint16, "subHeaderCount")
              },
              4: {
                length: A.uint16,
                language: A.uint16,
                segCountX2: A.uint16,
                segCount: (BA) => BA.segCountX2 >> 1,
                searchRange: A.uint16,
                entrySelector: A.uint16,
                rangeShift: A.uint16,
                endCode: new A.LazyArray(A.uint16, "segCount"),
                reservedPad: new A.Reserved(A.uint16),
                startCode: new A.LazyArray(A.uint16, "segCount"),
                idDelta: new A.LazyArray(A.int16, "segCount"),
                idRangeOffset: new A.LazyArray(A.uint16, "segCount"),
                glyphIndexArray: new A.LazyArray(A.uint16, (BA) => (BA.length - BA._currentOffset) / 2)
              },
              6: {
                length: A.uint16,
                language: A.uint16,
                firstCode: A.uint16,
                entryCount: A.uint16,
                glyphIndices: new A.LazyArray(A.uint16, "entryCount")
              },
              8: {
                reserved: new A.Reserved(A.uint16),
                length: A.uint32,
                language: A.uint16,
                is32: new A.LazyArray(A.uint8, 8192),
                nGroups: A.uint32,
                groups: new A.LazyArray(v, "nGroups")
              },
              10: {
                reserved: new A.Reserved(A.uint16),
                length: A.uint32,
                language: A.uint32,
                firstCode: A.uint32,
                entryCount: A.uint32,
                glyphIndices: new A.LazyArray(A.uint16, "numChars")
              },
              12: {
                reserved: new A.Reserved(A.uint16),
                length: A.uint32,
                language: A.uint32,
                nGroups: A.uint32,
                groups: new A.LazyArray(v, "nGroups")
              },
              13: {
                reserved: new A.Reserved(A.uint16),
                length: A.uint32,
                language: A.uint32,
                nGroups: A.uint32,
                groups: new A.LazyArray(v, "nGroups")
              },
              14: {
                length: A.uint32,
                numRecords: A.uint32,
                varSelectors: new A.LazyArray($A, "numRecords")
              }
            }), WA = new A.Struct({
              platformID: A.uint16,
              encodingID: A.uint16,
              table: new A.Pointer(A.uint32, kA, {
                type: "parent",
                lazy: !0
              })
            });
            var EA = new A.Struct({
              version: A.uint16,
              numSubtables: A.uint16,
              tables: new A.Array(WA, "numSubtables")
            }), zA = new A.Struct({
              version: A.int32,
              revision: A.int32,
              checkSumAdjustment: A.uint32,
              magicNumber: A.uint32,
              flags: A.uint16,
              unitsPerEm: A.uint16,
              created: new A.Array(A.int32, 2),
              modified: new A.Array(A.int32, 2),
              xMin: A.int16,
              yMin: A.int16,
              xMax: A.int16,
              yMax: A.int16,
              macStyle: new A.Bitfield(A.uint16, [
                "bold",
                "italic",
                "underline",
                "outline",
                "shadow",
                "condensed",
                "extended"
              ]),
              lowestRecPPEM: A.uint16,
              fontDirectionHint: A.int16,
              indexToLocFormat: A.int16,
              glyphDataFormat: A.int16
              // 0 for current format
            }), OA = new A.Struct({
              version: A.int32,
              ascent: A.int16,
              descent: A.int16,
              lineGap: A.int16,
              advanceWidthMax: A.uint16,
              minLeftSideBearing: A.int16,
              minRightSideBearing: A.int16,
              xMaxExtent: A.int16,
              caretSlopeRise: A.int16,
              caretSlopeRun: A.int16,
              caretOffset: A.int16,
              reserved: new A.Reserved(A.int16, 4),
              metricDataFormat: A.int16,
              numberOfMetrics: A.uint16
              // Number of advance widths in 'hmtx' table
            });
            let xA = new A.Struct({
              advance: A.uint16,
              bearing: A.int16
            });
            var LA = new A.Struct({
              metrics: new A.LazyArray(xA, (BA) => BA.parent.hhea.numberOfMetrics),
              bearings: new A.LazyArray(A.int16, (BA) => BA.parent.maxp.numGlyphs - BA.parent.hhea.numberOfMetrics)
            }), yA = new A.Struct({
              version: A.int32,
              numGlyphs: A.uint16,
              maxPoints: A.uint16,
              maxContours: A.uint16,
              maxComponentPoints: A.uint16,
              maxComponentContours: A.uint16,
              maxZones: A.uint16,
              maxTwilightPoints: A.uint16,
              maxStorage: A.uint16,
              maxFunctionDefs: A.uint16,
              maxInstructionDefs: A.uint16,
              maxStackElements: A.uint16,
              maxSizeOfInstructions: A.uint16,
              maxComponentElements: A.uint16,
              maxComponentDepth: A.uint16
              // Maximum levels of recursion; 1 for simple components
            });
            function TA(BA, i, u = 0) {
              return BA === 1 && _[u] ? _[u] : h[BA][i];
            }
            const fA = /* @__PURE__ */ new Set([
              "x-mac-roman",
              "x-mac-cyrillic",
              "iso-8859-6",
              "iso-8859-8"
            ]), sA = {
              "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
              "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
              "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
              "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
              "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
              "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
              "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
              "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
            }, F = /* @__PURE__ */ new Map();
            function o(BA) {
              let i = F.get(BA);
              if (i) return i;
              let u = sA[BA];
              if (u) {
                let m = /* @__PURE__ */ new Map();
                for (let L = 0; L < u.length; L++) m.set(u.charCodeAt(L), 128 + L);
                return F.set(BA, m), m;
              }
              if (fA.has(BA)) {
                let m = new TextDecoder(BA), L = new Uint8Array(128);
                for (let PA = 0; PA < 128; PA++) L[PA] = 128 + PA;
                let Z = /* @__PURE__ */ new Map(), O = m.decode(L);
                for (let PA = 0; PA < 128; PA++) Z.set(O.charCodeAt(PA), 128 + PA);
                return F.set(BA, Z), Z;
              }
            }
            const h = [
              // unicode
              [
                "utf-16be",
                "utf-16be",
                "utf-16be",
                "utf-16be",
                "utf-16be",
                "utf-16be",
                "utf-16be"
              ],
              // macintosh
              // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
              // 0	Roman                 17	Malayalam
              // 1	Japanese	            18	Sinhalese
              // 2	Traditional Chinese	  19	Burmese
              // 3	Korean	              20	Khmer
              // 4	Arabic	              21	Thai
              // 5	Hebrew	              22	Laotian
              // 6	Greek	                23	Georgian
              // 7	Russian	              24	Armenian
              // 8	RSymbol	              25	Simplified Chinese
              // 9	Devanagari	          26	Tibetan
              // 10	Gurmukhi	            27	Mongolian
              // 11	Gujarati	            28	Geez
              // 12	Oriya	                29	Slavic
              // 13	Bengali	              30	Vietnamese
              // 14	Tamil	                31	Sindhi
              // 15	Telugu	              32	(Uninterpreted)
              // 16	Kannada
              [
                "x-mac-roman",
                "shift-jis",
                "big5",
                "euc-kr",
                "iso-8859-6",
                "iso-8859-8",
                "x-mac-greek",
                "x-mac-cyrillic",
                "x-mac-symbol",
                "x-mac-devanagari",
                "x-mac-gurmukhi",
                "x-mac-gujarati",
                "Oriya",
                "Bengali",
                "Tamil",
                "Telugu",
                "Kannada",
                "Malayalam",
                "Sinhalese",
                "Burmese",
                "Khmer",
                "iso-8859-11",
                "Laotian",
                "Georgian",
                "Armenian",
                "gbk",
                "Tibetan",
                "Mongolian",
                "Geez",
                "x-mac-ce",
                "Vietnamese",
                "Sindhi"
              ],
              // ISO (deprecated)
              [
                "ascii",
                null,
                "iso-8859-1"
              ],
              // windows
              // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
              [
                "symbol",
                "utf-16be",
                "shift-jis",
                "gb18030",
                "big5",
                "euc-kr",
                "johab",
                null,
                null,
                null,
                "utf-16be"
              ]
            ], _ = {
              15: "x-mac-icelandic",
              17: "x-mac-turkish",
              18: "x-mac-croatian",
              24: "x-mac-ce",
              25: "x-mac-ce",
              26: "x-mac-ce",
              27: "x-mac-ce",
              28: "x-mac-ce",
              30: "x-mac-icelandic",
              37: "x-mac-romanian",
              38: "x-mac-ce",
              39: "x-mac-ce",
              40: "x-mac-ce",
              143: "x-mac-inuit",
              146: "x-mac-gaelic"
            }, oA = [
              // unicode
              [],
              {
                0: "en",
                30: "fo",
                60: "ks",
                90: "rw",
                1: "fr",
                31: "fa",
                61: "ku",
                91: "rn",
                2: "de",
                32: "ru",
                62: "sd",
                92: "ny",
                3: "it",
                33: "zh",
                63: "bo",
                93: "mg",
                4: "nl",
                34: "nl-BE",
                64: "ne",
                94: "eo",
                5: "sv",
                35: "ga",
                65: "sa",
                128: "cy",
                6: "es",
                36: "sq",
                66: "mr",
                129: "eu",
                7: "da",
                37: "ro",
                67: "bn",
                130: "ca",
                8: "pt",
                38: "cz",
                68: "as",
                131: "la",
                9: "no",
                39: "sk",
                69: "gu",
                132: "qu",
                10: "he",
                40: "si",
                70: "pa",
                133: "gn",
                11: "ja",
                41: "yi",
                71: "or",
                134: "ay",
                12: "ar",
                42: "sr",
                72: "ml",
                135: "tt",
                13: "fi",
                43: "mk",
                73: "kn",
                136: "ug",
                14: "el",
                44: "bg",
                74: "ta",
                137: "dz",
                15: "is",
                45: "uk",
                75: "te",
                138: "jv",
                16: "mt",
                46: "be",
                76: "si",
                139: "su",
                17: "tr",
                47: "uz",
                77: "my",
                140: "gl",
                18: "hr",
                48: "kk",
                78: "km",
                141: "af",
                19: "zh-Hant",
                49: "az-Cyrl",
                79: "lo",
                142: "br",
                20: "ur",
                50: "az-Arab",
                80: "vi",
                143: "iu",
                21: "hi",
                51: "hy",
                81: "id",
                144: "gd",
                22: "th",
                52: "ka",
                82: "tl",
                145: "gv",
                23: "ko",
                53: "mo",
                83: "ms",
                146: "ga",
                24: "lt",
                54: "ky",
                84: "ms-Arab",
                147: "to",
                25: "pl",
                55: "tg",
                85: "am",
                148: "el-polyton",
                26: "hu",
                56: "tk",
                86: "ti",
                149: "kl",
                27: "es",
                57: "mn-CN",
                87: "om",
                150: "az",
                28: "lv",
                58: "mn",
                88: "so",
                151: "nn",
                29: "se",
                59: "ps",
                89: "sw"
              },
              // ISO (deprecated)
              [],
              {
                1078: "af",
                16393: "en-IN",
                1159: "rw",
                1074: "tn",
                1052: "sq",
                6153: "en-IE",
                1089: "sw",
                1115: "si",
                1156: "gsw",
                8201: "en-JM",
                1111: "kok",
                1051: "sk",
                1118: "am",
                17417: "en-MY",
                1042: "ko",
                1060: "sl",
                5121: "ar-DZ",
                5129: "en-NZ",
                1088: "ky",
                11274: "es-AR",
                15361: "ar-BH",
                13321: "en-PH",
                1108: "lo",
                16394: "es-BO",
                3073: "ar",
                18441: "en-SG",
                1062: "lv",
                13322: "es-CL",
                2049: "ar-IQ",
                7177: "en-ZA",
                1063: "lt",
                9226: "es-CO",
                11265: "ar-JO",
                11273: "en-TT",
                2094: "dsb",
                5130: "es-CR",
                13313: "ar-KW",
                2057: "en-GB",
                1134: "lb",
                7178: "es-DO",
                12289: "ar-LB",
                1033: "en",
                1071: "mk",
                12298: "es-EC",
                4097: "ar-LY",
                12297: "en-ZW",
                2110: "ms-BN",
                17418: "es-SV",
                6145: "ary",
                1061: "et",
                1086: "ms",
                4106: "es-GT",
                8193: "ar-OM",
                1080: "fo",
                1100: "ml",
                18442: "es-HN",
                16385: "ar-QA",
                1124: "fil",
                1082: "mt",
                2058: "es-MX",
                1025: "ar-SA",
                1035: "fi",
                1153: "mi",
                19466: "es-NI",
                10241: "ar-SY",
                2060: "fr-BE",
                1146: "arn",
                6154: "es-PA",
                7169: "aeb",
                3084: "fr-CA",
                1102: "mr",
                15370: "es-PY",
                14337: "ar-AE",
                1036: "fr",
                1148: "moh",
                10250: "es-PE",
                9217: "ar-YE",
                5132: "fr-LU",
                1104: "mn",
                20490: "es-PR",
                1067: "hy",
                6156: "fr-MC",
                2128: "mn-CN",
                3082: "es",
                1101: "as",
                4108: "fr-CH",
                1121: "ne",
                1034: "es",
                2092: "az-Cyrl",
                1122: "fy",
                1044: "nb",
                21514: "es-US",
                1068: "az",
                1110: "gl",
                2068: "nn",
                14346: "es-UY",
                1133: "ba",
                1079: "ka",
                1154: "oc",
                8202: "es-VE",
                1069: "eu",
                3079: "de-AT",
                1096: "or",
                2077: "sv-FI",
                1059: "be",
                1031: "de",
                1123: "ps",
                1053: "sv",
                2117: "bn",
                5127: "de-LI",
                1045: "pl",
                1114: "syr",
                1093: "bn-IN",
                4103: "de-LU",
                1046: "pt",
                1064: "tg",
                8218: "bs-Cyrl",
                2055: "de-CH",
                2070: "pt-PT",
                2143: "tzm",
                5146: "bs",
                1032: "el",
                1094: "pa",
                1097: "ta",
                1150: "br",
                1135: "kl",
                1131: "qu-BO",
                1092: "tt",
                1026: "bg",
                1095: "gu",
                2155: "qu-EC",
                1098: "te",
                1027: "ca",
                1128: "ha",
                3179: "qu",
                1054: "th",
                3076: "zh-HK",
                1037: "he",
                1048: "ro",
                1105: "bo",
                5124: "zh-MO",
                1081: "hi",
                1047: "rm",
                1055: "tr",
                2052: "zh",
                1038: "hu",
                1049: "ru",
                1090: "tk",
                4100: "zh-SG",
                1039: "is",
                9275: "smn",
                1152: "ug",
                1028: "zh-TW",
                1136: "ig",
                4155: "smj-NO",
                1058: "uk",
                1155: "co",
                1057: "id",
                5179: "smj",
                1070: "hsb",
                1050: "hr",
                1117: "iu",
                3131: "se-FI",
                1056: "ur",
                4122: "hr-BA",
                2141: "iu-Latn",
                1083: "se",
                2115: "uz-Cyrl",
                1029: "cs",
                2108: "ga",
                2107: "se-SE",
                1091: "uz",
                1030: "da",
                1076: "xh",
                8251: "sms",
                1066: "vi",
                1164: "prs",
                1077: "zu",
                6203: "sma-NO",
                1106: "cy",
                1125: "dv",
                1040: "it",
                7227: "sms",
                1160: "wo",
                2067: "nl-BE",
                2064: "it-CH",
                1103: "sa",
                1157: "sah",
                1043: "nl",
                1041: "ja",
                7194: "sr-Cyrl-BA",
                1144: "ii",
                3081: "en-AU",
                1099: "kn",
                3098: "sr",
                1130: "yo",
                10249: "en-BZ",
                1087: "kk",
                6170: "sr-Latn-BA",
                4105: "en-CA",
                1107: "km",
                2074: "sr-Latn",
                9225: "en-029",
                1158: "quc",
                1132: "nso"
              }
            ];
            let p = new A.Struct({
              platformID: A.uint16,
              encodingID: A.uint16,
              languageID: A.uint16,
              nameID: A.uint16,
              length: A.uint16,
              string: new A.Pointer(A.uint16, new A.String("length", (BA) => TA(BA.platformID, BA.encodingID, BA.languageID)), {
                type: "parent",
                relativeTo: (BA) => BA.parent.stringOffset,
                allowNull: !1
              })
            }), rA = new A.Struct({
              length: A.uint16,
              tag: new A.Pointer(A.uint16, new A.String("length", "utf16be"), {
                type: "parent",
                relativeTo: (BA) => BA.stringOffset
              })
            });
            var QA = new A.VersionedStruct(A.uint16, {
              0: {
                count: A.uint16,
                stringOffset: A.uint16,
                records: new A.Array(p, "count")
              },
              1: {
                count: A.uint16,
                stringOffset: A.uint16,
                records: new A.Array(p, "count"),
                langTagCount: A.uint16,
                langTags: new A.Array(rA, "langTagCount")
              }
            }), bA = QA;
            const y = [
              "copyright",
              "fontFamily",
              "fontSubfamily",
              "uniqueSubfamily",
              "fullName",
              "version",
              "postscriptName",
              "trademark",
              "manufacturer",
              "designer",
              "description",
              "vendorURL",
              "designerURL",
              "license",
              "licenseURL",
              null,
              "preferredFamily",
              "preferredSubfamily",
              "compatibleFull",
              "sampleText",
              "postscriptCIDFontName",
              "wwsFamilyName",
              "wwsSubfamilyName"
            ];
            QA.process = function(BA) {
              var i = {};
              for (let u of this.records) {
                let m = oA[u.platformID][u.languageID];
                m == null && this.langTags != null && u.languageID >= 32768 && (m = this.langTags[u.languageID - 32768].tag), m == null && (m = u.platformID + "-" + u.languageID);
                let L = u.nameID >= 256 ? "fontFeatures" : y[u.nameID] || u.nameID;
                i[L] == null && (i[L] = {});
                let Z = i[L];
                u.nameID >= 256 && (Z = Z[u.nameID] || (Z[u.nameID] = {})), (typeof u.string == "string" || typeof Z[m] != "string") && (Z[m] = u.string);
              }
              this.records = i;
            }, QA.preEncode = function() {
              if (Array.isArray(this.records)) return;
              this.version = 0;
              let BA = [];
              for (let i in this.records) {
                let u = this.records[i];
                i !== "fontFeatures" && (BA.push({
                  platformID: 3,
                  encodingID: 1,
                  languageID: 1033,
                  nameID: y.indexOf(i),
                  length: u.en.length * 2,
                  string: u.en
                }), i === "postscriptName" && BA.push({
                  platformID: 1,
                  encodingID: 0,
                  languageID: 0,
                  nameID: y.indexOf(i),
                  length: u.en.length,
                  string: u.en
                }));
              }
              this.records = BA, this.count = BA.length, this.stringOffset = QA.size(this, null, !1);
            };
            var M = new A.VersionedStruct(A.uint16, {
              header: {
                xAvgCharWidth: A.int16,
                usWeightClass: A.uint16,
                usWidthClass: A.uint16,
                fsType: new A.Bitfield(A.uint16, [
                  null,
                  "noEmbedding",
                  "viewOnly",
                  "editable",
                  null,
                  null,
                  null,
                  null,
                  "noSubsetting",
                  "bitmapOnly"
                ]),
                ySubscriptXSize: A.int16,
                ySubscriptYSize: A.int16,
                ySubscriptXOffset: A.int16,
                ySubscriptYOffset: A.int16,
                ySuperscriptXSize: A.int16,
                ySuperscriptYSize: A.int16,
                ySuperscriptXOffset: A.int16,
                ySuperscriptYOffset: A.int16,
                yStrikeoutSize: A.int16,
                yStrikeoutPosition: A.int16,
                sFamilyClass: A.int16,
                panose: new A.Array(A.uint8, 10),
                ulCharRange: new A.Array(A.uint32, 4),
                vendorID: new A.String(4),
                fsSelection: new A.Bitfield(A.uint16, [
                  "italic",
                  "underscore",
                  "negative",
                  "outlined",
                  "strikeout",
                  "bold",
                  "regular",
                  "useTypoMetrics",
                  "wws",
                  "oblique"
                ]),
                usFirstCharIndex: A.uint16,
                usLastCharIndex: A.uint16
                // The maximum Unicode index in this font
              },
              // The Apple version of this table ends here, but the Microsoft one continues on...
              0: {},
              1: {
                typoAscender: A.int16,
                typoDescender: A.int16,
                typoLineGap: A.int16,
                winAscent: A.uint16,
                winDescent: A.uint16,
                codePageRange: new A.Array(A.uint32, 2)
              },
              2: {
                // these should be common with version 1 somehow
                typoAscender: A.int16,
                typoDescender: A.int16,
                typoLineGap: A.int16,
                winAscent: A.uint16,
                winDescent: A.uint16,
                codePageRange: new A.Array(A.uint32, 2),
                xHeight: A.int16,
                capHeight: A.int16,
                defaultChar: A.uint16,
                breakChar: A.uint16,
                maxContent: A.uint16
              },
              5: {
                typoAscender: A.int16,
                typoDescender: A.int16,
                typoLineGap: A.int16,
                winAscent: A.uint16,
                winDescent: A.uint16,
                codePageRange: new A.Array(A.uint32, 2),
                xHeight: A.int16,
                capHeight: A.int16,
                defaultChar: A.uint16,
                breakChar: A.uint16,
                maxContent: A.uint16,
                usLowerOpticalPointSize: A.uint16,
                usUpperOpticalPointSize: A.uint16
              }
            });
            let FA = M.versions;
            FA[3] = FA[4] = FA[2];
            var dA = M, he = new A.VersionedStruct(A.fixed32, {
              header: {
                italicAngle: A.fixed32,
                underlinePosition: A.int16,
                underlineThickness: A.int16,
                isFixedPitch: A.uint32,
                minMemType42: A.uint32,
                maxMemType42: A.uint32,
                minMemType1: A.uint32,
                maxMemType1: A.uint32
                // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
              },
              1: {},
              2: {
                numberOfGlyphs: A.uint16,
                glyphNameIndex: new A.Array(A.uint16, "numberOfGlyphs"),
                names: new A.Array(new A.String(A.uint8))
              },
              2.5: {
                numberOfGlyphs: A.uint16,
                offsets: new A.Array(A.uint8, "numberOfGlyphs")
              },
              3: {},
              4: {
                map: new A.Array(A.uint32, (BA) => BA.parent.maxp.numGlyphs)
              }
            }), ie = new A.Struct({
              controlValues: new A.Array(A.int16)
            }), KA = new A.Struct({
              instructions: new A.Array(A.uint8)
            });
            let Pe = new A.VersionedStruct("head.indexToLocFormat", {
              0: {
                offsets: new A.Array(A.uint16)
              },
              1: {
                offsets: new A.Array(A.uint32)
              }
            });
            Pe.process = function() {
              if (this.version === 0 && !this._processed) {
                for (let BA = 0; BA < this.offsets.length; BA++) this.offsets[BA] <<= 1;
                this._processed = !0;
              }
            }, Pe.preEncode = function() {
              if (this.version === 0 && this._processed !== !1) {
                for (let BA = 0; BA < this.offsets.length; BA++) this.offsets[BA] >>>= 1;
                this._processed = !1;
              }
            };
            var Je = Pe, Le = new A.Struct({
              controlValueProgram: new A.Array(A.uint8)
            }), Re = new A.Array(new A.Buffer());
            class _e {
              getCFFVersion(i) {
                for (; i && !i.hdrSize; ) i = i.parent;
                return i ? i.version : -1;
              }
              decode(i, u) {
                let L = this.getCFFVersion(u) >= 2 ? i.readUInt32BE() : i.readUInt16BE();
                if (L === 0) return [];
                let Z = i.readUInt8(), O;
                if (Z === 1) O = A.uint8;
                else if (Z === 2) O = A.uint16;
                else if (Z === 3) O = A.uint24;
                else if (Z === 4) O = A.uint32;
                else throw new Error(`Bad offset size in CFFIndex: ${Z} ${i.pos}`);
                let PA = [], VA = i.pos + (L + 1) * Z - 1, te = O.decode(i);
                for (let ce = 0; ce < L; ce++) {
                  let ge = O.decode(i);
                  if (this.type != null) {
                    let Ge = i.pos;
                    i.pos = VA + te, u.length = ge - te, PA.push(this.type.decode(i, u)), i.pos = Ge;
                  } else PA.push({
                    offset: VA + te,
                    length: ge - te
                  });
                  te = ge;
                }
                return i.pos = VA + te, PA;
              }
              size(i, u) {
                let m = 2;
                if (i.length === 0) return m;
                let L = this.type || new A.Buffer(), Z = 1;
                for (let PA = 0; PA < i.length; PA++) {
                  let VA = i[PA];
                  Z += L.size(VA, u);
                }
                let O;
                if (Z <= 255) O = A.uint8;
                else if (Z <= 65535) O = A.uint16;
                else if (Z <= 16777215) O = A.uint24;
                else if (Z <= 4294967295) O = A.uint32;
                else throw new Error("Bad offset in CFFIndex");
                return m += 1 + O.size() * (i.length + 1), m += Z - 1, m;
              }
              encode(i, u, m) {
                if (i.writeUInt16BE(u.length), u.length === 0) return;
                let L = this.type || new A.Buffer(), Z = [], O = 1;
                for (let VA of u) {
                  let te = L.size(VA, m);
                  Z.push(te), O += te;
                }
                let PA;
                if (O <= 255) PA = A.uint8;
                else if (O <= 65535) PA = A.uint16;
                else if (O <= 16777215) PA = A.uint24;
                else if (O <= 4294967295) PA = A.uint32;
                else throw new Error("Bad offset in CFFIndex");
                i.writeUInt8(PA.size()), O = 1, PA.encode(i, O);
                for (let VA of Z)
                  O += VA, PA.encode(i, O);
                for (let VA of u) L.encode(i, VA, m);
              }
              constructor(i) {
                this.type = i;
              }
            }
            const se = 15, Ee = [
              "0",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              ".",
              "E",
              "E-",
              null,
              "-"
            ], wA = {
              ".": 10,
              E: 11,
              "E-": 12,
              "-": 14
            };
            class N {
              static decode(i, u) {
                if (32 <= u && u <= 246) return u - 139;
                if (247 <= u && u <= 250) return (u - 247) * 256 + i.readUInt8() + 108;
                if (251 <= u && u <= 254) return -(u - 251) * 256 - i.readUInt8() - 108;
                if (u === 28) return i.readInt16BE();
                if (u === 29) return i.readInt32BE();
                if (u === 30) {
                  let m = "";
                  for (; ; ) {
                    let L = i.readUInt8(), Z = L >> 4;
                    if (Z === se) break;
                    m += Ee[Z];
                    let O = L & 15;
                    if (O === se) break;
                    m += Ee[O];
                  }
                  return parseFloat(m);
                }
                return null;
              }
              static size(i) {
                if (i.forceLarge && (i = 32768), (i | 0) !== i) {
                  let u = "" + i;
                  return 1 + Math.ceil((u.length + 1) / 2);
                } else return -107 <= i && i <= 107 ? 1 : 108 <= i && i <= 1131 || -1131 <= i && i <= -108 ? 2 : -32768 <= i && i <= 32767 ? 3 : 5;
              }
              static encode(i, u) {
                let m = Number(u);
                if (u.forceLarge)
                  return i.writeUInt8(29), i.writeInt32BE(m);
                if ((m | 0) !== m) {
                  i.writeUInt8(30);
                  let Z = "" + m;
                  for (let O = 0; O < Z.length; O += 2) {
                    let PA = Z[O], VA = wA[PA] || +PA;
                    if (O === Z.length - 1) var L = se;
                    else {
                      let te = Z[O + 1];
                      var L = wA[te] || +te;
                    }
                    i.writeUInt8(VA << 4 | L & 15);
                  }
                  if (L !== se) return i.writeUInt8(se << 4);
                } else return -107 <= m && m <= 107 ? i.writeUInt8(m + 139) : 108 <= m && m <= 1131 ? (m -= 108, i.writeUInt8((m >> 8) + 247), i.writeUInt8(m & 255)) : -1131 <= m && m <= -108 ? (m = -m - 108, i.writeUInt8((m >> 8) + 251), i.writeUInt8(m & 255)) : -32768 <= m && m <= 32767 ? (i.writeUInt8(28), i.writeInt16BE(m)) : (i.writeUInt8(29), i.writeInt32BE(m));
              }
            }
            class G {
              decodeOperands(i, u, m, L) {
                if (Array.isArray(i)) return L.map((Z, O) => this.decodeOperands(i[O], u, m, [
                  Z
                ]));
                if (i.decode != null) return i.decode(u, m, L);
                switch (i) {
                  case "number":
                  case "offset":
                  case "sid":
                    return L[0];
                  case "boolean":
                    return !!L[0];
                  default:
                    return L;
                }
              }
              encodeOperands(i, u, m, L) {
                return Array.isArray(i) ? L.map((Z, O) => this.encodeOperands(i[O], u, m, Z)[0]) : i.encode != null ? i.encode(u, L, m) : typeof L == "number" ? [
                  L
                ] : typeof L == "boolean" ? [
                  +L
                ] : Array.isArray(L) ? L : [
                  L
                ];
              }
              decode(i, u) {
                let m = i.pos + u.length, L = {}, Z = [];
                Object.defineProperties(L, {
                  parent: {
                    value: u
                  },
                  _startOffset: {
                    value: i.pos
                  }
                });
                for (let O in this.fields) {
                  let PA = this.fields[O];
                  L[PA[1]] = PA[3];
                }
                for (; i.pos < m; ) {
                  let O = i.readUInt8();
                  if (O < 28) {
                    O === 12 && (O = O << 8 | i.readUInt8());
                    let PA = this.fields[O];
                    if (!PA) throw new Error(`Unknown operator ${O}`);
                    let VA = this.decodeOperands(PA[2], i, L, Z);
                    VA != null && (VA instanceof A.PropertyDescriptor ? Object.defineProperty(L, PA[1], VA) : L[PA[1]] = VA), Z = [];
                  } else Z.push(N.decode(i, O));
                }
                return L;
              }
              size(i, u, m = !0) {
                let L = {
                  parent: u,
                  val: i,
                  pointerSize: 0,
                  startOffset: u.startOffset || 0
                }, Z = 0;
                for (let O in this.fields) {
                  let PA = this.fields[O], VA = i[PA[1]];
                  if (VA == null || T(x)(VA, PA[3])) continue;
                  let te = this.encodeOperands(PA[2], null, L, VA);
                  for (let ge of te) Z += N.size(ge);
                  let ce = Array.isArray(PA[0]) ? PA[0] : [
                    PA[0]
                  ];
                  Z += ce.length;
                }
                return m && (Z += L.pointerSize), Z;
              }
              encode(i, u, m) {
                let L = {
                  pointers: [],
                  startOffset: i.pos,
                  parent: m,
                  val: u,
                  pointerSize: 0
                };
                L.pointerOffset = i.pos + this.size(u, L, !1);
                for (let O of this.ops) {
                  let PA = u[O[1]];
                  if (PA == null || T(x)(PA, O[3])) continue;
                  let VA = this.encodeOperands(O[2], i, L, PA);
                  for (let ce of VA) N.encode(i, ce);
                  let te = Array.isArray(O[0]) ? O[0] : [
                    O[0]
                  ];
                  for (let ce of te) i.writeUInt8(ce);
                }
                let Z = 0;
                for (; Z < L.pointers.length; ) {
                  let O = L.pointers[Z++];
                  O.type.encode(i, O.val, O.parent);
                }
              }
              constructor(i = []) {
                this.ops = i, this.fields = {};
                for (let u of i) {
                  let m = Array.isArray(u[0]) ? u[0][0] << 8 | u[0][1] : u[0];
                  this.fields[m] = u;
                }
              }
            }
            class W extends A.Pointer {
              decode(i, u, m) {
                return this.offsetType = {
                  decode: () => m[0]
                }, super.decode(i, u, m);
              }
              encode(i, u, m) {
                if (!i)
                  return this.offsetType = {
                    size: () => 0
                  }, this.size(u, m), [
                    new aA(0)
                  ];
                let L = null;
                return this.offsetType = {
                  encode: (Z, O) => L = O
                }, super.encode(i, u, m), [
                  new aA(L)
                ];
              }
              constructor(i, u = {}) {
                u.type == null && (u.type = "global"), super(null, i, u);
              }
            }
            class aA {
              valueOf() {
                return this.val;
              }
              constructor(i) {
                this.val = i, this.forceLarge = !0;
              }
            }
            class j {
              static decode(i, u, m) {
                let L = m.pop();
                for (; m.length > L; ) m.pop();
              }
            }
            var pA = new G([
              // key       name                    type                                          default
              [
                6,
                "BlueValues",
                "delta",
                null
              ],
              [
                7,
                "OtherBlues",
                "delta",
                null
              ],
              [
                8,
                "FamilyBlues",
                "delta",
                null
              ],
              [
                9,
                "FamilyOtherBlues",
                "delta",
                null
              ],
              [
                [
                  12,
                  9
                ],
                "BlueScale",
                "number",
                0.039625
              ],
              [
                [
                  12,
                  10
                ],
                "BlueShift",
                "number",
                7
              ],
              [
                [
                  12,
                  11
                ],
                "BlueFuzz",
                "number",
                1
              ],
              [
                10,
                "StdHW",
                "number",
                null
              ],
              [
                11,
                "StdVW",
                "number",
                null
              ],
              [
                [
                  12,
                  12
                ],
                "StemSnapH",
                "delta",
                null
              ],
              [
                [
                  12,
                  13
                ],
                "StemSnapV",
                "delta",
                null
              ],
              [
                [
                  12,
                  14
                ],
                "ForceBold",
                "boolean",
                !1
              ],
              [
                [
                  12,
                  17
                ],
                "LanguageGroup",
                "number",
                0
              ],
              [
                [
                  12,
                  18
                ],
                "ExpansionFactor",
                "number",
                0.06
              ],
              [
                [
                  12,
                  19
                ],
                "initialRandomSeed",
                "number",
                0
              ],
              [
                20,
                "defaultWidthX",
                "number",
                0
              ],
              [
                21,
                "nominalWidthX",
                "number",
                0
              ],
              [
                22,
                "vsindex",
                "number",
                0
              ],
              [
                23,
                "blend",
                j,
                null
              ],
              [
                19,
                "Subrs",
                new W(new _e(), {
                  type: "local"
                }),
                null
              ]
            ]), Be = [
              ".notdef",
              "space",
              "exclam",
              "quotedbl",
              "numbersign",
              "dollar",
              "percent",
              "ampersand",
              "quoteright",
              "parenleft",
              "parenright",
              "asterisk",
              "plus",
              "comma",
              "hyphen",
              "period",
              "slash",
              "zero",
              "one",
              "two",
              "three",
              "four",
              "five",
              "six",
              "seven",
              "eight",
              "nine",
              "colon",
              "semicolon",
              "less",
              "equal",
              "greater",
              "question",
              "at",
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "bracketleft",
              "backslash",
              "bracketright",
              "asciicircum",
              "underscore",
              "quoteleft",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "braceleft",
              "bar",
              "braceright",
              "asciitilde",
              "exclamdown",
              "cent",
              "sterling",
              "fraction",
              "yen",
              "florin",
              "section",
              "currency",
              "quotesingle",
              "quotedblleft",
              "guillemotleft",
              "guilsinglleft",
              "guilsinglright",
              "fi",
              "fl",
              "endash",
              "dagger",
              "daggerdbl",
              "periodcentered",
              "paragraph",
              "bullet",
              "quotesinglbase",
              "quotedblbase",
              "quotedblright",
              "guillemotright",
              "ellipsis",
              "perthousand",
              "questiondown",
              "grave",
              "acute",
              "circumflex",
              "tilde",
              "macron",
              "breve",
              "dotaccent",
              "dieresis",
              "ring",
              "cedilla",
              "hungarumlaut",
              "ogonek",
              "caron",
              "emdash",
              "AE",
              "ordfeminine",
              "Lslash",
              "Oslash",
              "OE",
              "ordmasculine",
              "ae",
              "dotlessi",
              "lslash",
              "oslash",
              "oe",
              "germandbls",
              "onesuperior",
              "logicalnot",
              "mu",
              "trademark",
              "Eth",
              "onehalf",
              "plusminus",
              "Thorn",
              "onequarter",
              "divide",
              "brokenbar",
              "degree",
              "thorn",
              "threequarters",
              "twosuperior",
              "registered",
              "minus",
              "eth",
              "multiply",
              "threesuperior",
              "copyright",
              "Aacute",
              "Acircumflex",
              "Adieresis",
              "Agrave",
              "Aring",
              "Atilde",
              "Ccedilla",
              "Eacute",
              "Ecircumflex",
              "Edieresis",
              "Egrave",
              "Iacute",
              "Icircumflex",
              "Idieresis",
              "Igrave",
              "Ntilde",
              "Oacute",
              "Ocircumflex",
              "Odieresis",
              "Ograve",
              "Otilde",
              "Scaron",
              "Uacute",
              "Ucircumflex",
              "Udieresis",
              "Ugrave",
              "Yacute",
              "Ydieresis",
              "Zcaron",
              "aacute",
              "acircumflex",
              "adieresis",
              "agrave",
              "aring",
              "atilde",
              "ccedilla",
              "eacute",
              "ecircumflex",
              "edieresis",
              "egrave",
              "iacute",
              "icircumflex",
              "idieresis",
              "igrave",
              "ntilde",
              "oacute",
              "ocircumflex",
              "odieresis",
              "ograve",
              "otilde",
              "scaron",
              "uacute",
              "ucircumflex",
              "udieresis",
              "ugrave",
              "yacute",
              "ydieresis",
              "zcaron",
              "exclamsmall",
              "Hungarumlautsmall",
              "dollaroldstyle",
              "dollarsuperior",
              "ampersandsmall",
              "Acutesmall",
              "parenleftsuperior",
              "parenrightsuperior",
              "twodotenleader",
              "onedotenleader",
              "zerooldstyle",
              "oneoldstyle",
              "twooldstyle",
              "threeoldstyle",
              "fouroldstyle",
              "fiveoldstyle",
              "sixoldstyle",
              "sevenoldstyle",
              "eightoldstyle",
              "nineoldstyle",
              "commasuperior",
              "threequartersemdash",
              "periodsuperior",
              "questionsmall",
              "asuperior",
              "bsuperior",
              "centsuperior",
              "dsuperior",
              "esuperior",
              "isuperior",
              "lsuperior",
              "msuperior",
              "nsuperior",
              "osuperior",
              "rsuperior",
              "ssuperior",
              "tsuperior",
              "ff",
              "ffi",
              "ffl",
              "parenleftinferior",
              "parenrightinferior",
              "Circumflexsmall",
              "hyphensuperior",
              "Gravesmall",
              "Asmall",
              "Bsmall",
              "Csmall",
              "Dsmall",
              "Esmall",
              "Fsmall",
              "Gsmall",
              "Hsmall",
              "Ismall",
              "Jsmall",
              "Ksmall",
              "Lsmall",
              "Msmall",
              "Nsmall",
              "Osmall",
              "Psmall",
              "Qsmall",
              "Rsmall",
              "Ssmall",
              "Tsmall",
              "Usmall",
              "Vsmall",
              "Wsmall",
              "Xsmall",
              "Ysmall",
              "Zsmall",
              "colonmonetary",
              "onefitted",
              "rupiah",
              "Tildesmall",
              "exclamdownsmall",
              "centoldstyle",
              "Lslashsmall",
              "Scaronsmall",
              "Zcaronsmall",
              "Dieresissmall",
              "Brevesmall",
              "Caronsmall",
              "Dotaccentsmall",
              "Macronsmall",
              "figuredash",
              "hypheninferior",
              "Ogoneksmall",
              "Ringsmall",
              "Cedillasmall",
              "questiondownsmall",
              "oneeighth",
              "threeeighths",
              "fiveeighths",
              "seveneighths",
              "onethird",
              "twothirds",
              "zerosuperior",
              "foursuperior",
              "fivesuperior",
              "sixsuperior",
              "sevensuperior",
              "eightsuperior",
              "ninesuperior",
              "zeroinferior",
              "oneinferior",
              "twoinferior",
              "threeinferior",
              "fourinferior",
              "fiveinferior",
              "sixinferior",
              "seveninferior",
              "eightinferior",
              "nineinferior",
              "centinferior",
              "dollarinferior",
              "periodinferior",
              "commainferior",
              "Agravesmall",
              "Aacutesmall",
              "Acircumflexsmall",
              "Atildesmall",
              "Adieresissmall",
              "Aringsmall",
              "AEsmall",
              "Ccedillasmall",
              "Egravesmall",
              "Eacutesmall",
              "Ecircumflexsmall",
              "Edieresissmall",
              "Igravesmall",
              "Iacutesmall",
              "Icircumflexsmall",
              "Idieresissmall",
              "Ethsmall",
              "Ntildesmall",
              "Ogravesmall",
              "Oacutesmall",
              "Ocircumflexsmall",
              "Otildesmall",
              "Odieresissmall",
              "OEsmall",
              "Oslashsmall",
              "Ugravesmall",
              "Uacutesmall",
              "Ucircumflexsmall",
              "Udieresissmall",
              "Yacutesmall",
              "Thornsmall",
              "Ydieresissmall",
              "001.000",
              "001.001",
              "001.002",
              "001.003",
              "Black",
              "Bold",
              "Book",
              "Light",
              "Medium",
              "Regular",
              "Roman",
              "Semibold"
            ];
            let Ie = [
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "space",
              "exclam",
              "quotedbl",
              "numbersign",
              "dollar",
              "percent",
              "ampersand",
              "quoteright",
              "parenleft",
              "parenright",
              "asterisk",
              "plus",
              "comma",
              "hyphen",
              "period",
              "slash",
              "zero",
              "one",
              "two",
              "three",
              "four",
              "five",
              "six",
              "seven",
              "eight",
              "nine",
              "colon",
              "semicolon",
              "less",
              "equal",
              "greater",
              "question",
              "at",
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "bracketleft",
              "backslash",
              "bracketright",
              "asciicircum",
              "underscore",
              "quoteleft",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "braceleft",
              "bar",
              "braceright",
              "asciitilde",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "exclamdown",
              "cent",
              "sterling",
              "fraction",
              "yen",
              "florin",
              "section",
              "currency",
              "quotesingle",
              "quotedblleft",
              "guillemotleft",
              "guilsinglleft",
              "guilsinglright",
              "fi",
              "fl",
              "",
              "endash",
              "dagger",
              "daggerdbl",
              "periodcentered",
              "",
              "paragraph",
              "bullet",
              "quotesinglbase",
              "quotedblbase",
              "quotedblright",
              "guillemotright",
              "ellipsis",
              "perthousand",
              "",
              "questiondown",
              "",
              "grave",
              "acute",
              "circumflex",
              "tilde",
              "macron",
              "breve",
              "dotaccent",
              "dieresis",
              "",
              "ring",
              "cedilla",
              "",
              "hungarumlaut",
              "ogonek",
              "caron",
              "emdash",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "AE",
              "",
              "ordfeminine",
              "",
              "",
              "",
              "",
              "Lslash",
              "Oslash",
              "OE",
              "ordmasculine",
              "",
              "",
              "",
              "",
              "",
              "ae",
              "",
              "",
              "",
              "dotlessi",
              "",
              "",
              "lslash",
              "oslash",
              "oe",
              "germandbls"
            ], ee = [
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "space",
              "exclamsmall",
              "Hungarumlautsmall",
              "",
              "dollaroldstyle",
              "dollarsuperior",
              "ampersandsmall",
              "Acutesmall",
              "parenleftsuperior",
              "parenrightsuperior",
              "twodotenleader",
              "onedotenleader",
              "comma",
              "hyphen",
              "period",
              "fraction",
              "zerooldstyle",
              "oneoldstyle",
              "twooldstyle",
              "threeoldstyle",
              "fouroldstyle",
              "fiveoldstyle",
              "sixoldstyle",
              "sevenoldstyle",
              "eightoldstyle",
              "nineoldstyle",
              "colon",
              "semicolon",
              "commasuperior",
              "threequartersemdash",
              "periodsuperior",
              "questionsmall",
              "",
              "asuperior",
              "bsuperior",
              "centsuperior",
              "dsuperior",
              "esuperior",
              "",
              "",
              "isuperior",
              "",
              "",
              "lsuperior",
              "msuperior",
              "nsuperior",
              "osuperior",
              "",
              "",
              "rsuperior",
              "ssuperior",
              "tsuperior",
              "",
              "ff",
              "fi",
              "fl",
              "ffi",
              "ffl",
              "parenleftinferior",
              "",
              "parenrightinferior",
              "Circumflexsmall",
              "hyphensuperior",
              "Gravesmall",
              "Asmall",
              "Bsmall",
              "Csmall",
              "Dsmall",
              "Esmall",
              "Fsmall",
              "Gsmall",
              "Hsmall",
              "Ismall",
              "Jsmall",
              "Ksmall",
              "Lsmall",
              "Msmall",
              "Nsmall",
              "Osmall",
              "Psmall",
              "Qsmall",
              "Rsmall",
              "Ssmall",
              "Tsmall",
              "Usmall",
              "Vsmall",
              "Wsmall",
              "Xsmall",
              "Ysmall",
              "Zsmall",
              "colonmonetary",
              "onefitted",
              "rupiah",
              "Tildesmall",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "exclamdownsmall",
              "centoldstyle",
              "Lslashsmall",
              "",
              "",
              "Scaronsmall",
              "Zcaronsmall",
              "Dieresissmall",
              "Brevesmall",
              "Caronsmall",
              "",
              "Dotaccentsmall",
              "",
              "",
              "Macronsmall",
              "",
              "",
              "figuredash",
              "hypheninferior",
              "",
              "",
              "Ogoneksmall",
              "Ringsmall",
              "Cedillasmall",
              "",
              "",
              "",
              "onequarter",
              "onehalf",
              "threequarters",
              "questiondownsmall",
              "oneeighth",
              "threeeighths",
              "fiveeighths",
              "seveneighths",
              "onethird",
              "twothirds",
              "",
              "",
              "zerosuperior",
              "onesuperior",
              "twosuperior",
              "threesuperior",
              "foursuperior",
              "fivesuperior",
              "sixsuperior",
              "sevensuperior",
              "eightsuperior",
              "ninesuperior",
              "zeroinferior",
              "oneinferior",
              "twoinferior",
              "threeinferior",
              "fourinferior",
              "fiveinferior",
              "sixinferior",
              "seveninferior",
              "eightinferior",
              "nineinferior",
              "centinferior",
              "dollarinferior",
              "periodinferior",
              "commainferior",
              "Agravesmall",
              "Aacutesmall",
              "Acircumflexsmall",
              "Atildesmall",
              "Adieresissmall",
              "Aringsmall",
              "AEsmall",
              "Ccedillasmall",
              "Egravesmall",
              "Eacutesmall",
              "Ecircumflexsmall",
              "Edieresissmall",
              "Igravesmall",
              "Iacutesmall",
              "Icircumflexsmall",
              "Idieresissmall",
              "Ethsmall",
              "Ntildesmall",
              "Ogravesmall",
              "Oacutesmall",
              "Ocircumflexsmall",
              "Otildesmall",
              "Odieresissmall",
              "OEsmall",
              "Oslashsmall",
              "Ugravesmall",
              "Uacutesmall",
              "Ucircumflexsmall",
              "Udieresissmall",
              "Yacutesmall",
              "Thornsmall",
              "Ydieresissmall"
            ], Me = [
              ".notdef",
              "space",
              "exclam",
              "quotedbl",
              "numbersign",
              "dollar",
              "percent",
              "ampersand",
              "quoteright",
              "parenleft",
              "parenright",
              "asterisk",
              "plus",
              "comma",
              "hyphen",
              "period",
              "slash",
              "zero",
              "one",
              "two",
              "three",
              "four",
              "five",
              "six",
              "seven",
              "eight",
              "nine",
              "colon",
              "semicolon",
              "less",
              "equal",
              "greater",
              "question",
              "at",
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "bracketleft",
              "backslash",
              "bracketright",
              "asciicircum",
              "underscore",
              "quoteleft",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "braceleft",
              "bar",
              "braceright",
              "asciitilde",
              "exclamdown",
              "cent",
              "sterling",
              "fraction",
              "yen",
              "florin",
              "section",
              "currency",
              "quotesingle",
              "quotedblleft",
              "guillemotleft",
              "guilsinglleft",
              "guilsinglright",
              "fi",
              "fl",
              "endash",
              "dagger",
              "daggerdbl",
              "periodcentered",
              "paragraph",
              "bullet",
              "quotesinglbase",
              "quotedblbase",
              "quotedblright",
              "guillemotright",
              "ellipsis",
              "perthousand",
              "questiondown",
              "grave",
              "acute",
              "circumflex",
              "tilde",
              "macron",
              "breve",
              "dotaccent",
              "dieresis",
              "ring",
              "cedilla",
              "hungarumlaut",
              "ogonek",
              "caron",
              "emdash",
              "AE",
              "ordfeminine",
              "Lslash",
              "Oslash",
              "OE",
              "ordmasculine",
              "ae",
              "dotlessi",
              "lslash",
              "oslash",
              "oe",
              "germandbls",
              "onesuperior",
              "logicalnot",
              "mu",
              "trademark",
              "Eth",
              "onehalf",
              "plusminus",
              "Thorn",
              "onequarter",
              "divide",
              "brokenbar",
              "degree",
              "thorn",
              "threequarters",
              "twosuperior",
              "registered",
              "minus",
              "eth",
              "multiply",
              "threesuperior",
              "copyright",
              "Aacute",
              "Acircumflex",
              "Adieresis",
              "Agrave",
              "Aring",
              "Atilde",
              "Ccedilla",
              "Eacute",
              "Ecircumflex",
              "Edieresis",
              "Egrave",
              "Iacute",
              "Icircumflex",
              "Idieresis",
              "Igrave",
              "Ntilde",
              "Oacute",
              "Ocircumflex",
              "Odieresis",
              "Ograve",
              "Otilde",
              "Scaron",
              "Uacute",
              "Ucircumflex",
              "Udieresis",
              "Ugrave",
              "Yacute",
              "Ydieresis",
              "Zcaron",
              "aacute",
              "acircumflex",
              "adieresis",
              "agrave",
              "aring",
              "atilde",
              "ccedilla",
              "eacute",
              "ecircumflex",
              "edieresis",
              "egrave",
              "iacute",
              "icircumflex",
              "idieresis",
              "igrave",
              "ntilde",
              "oacute",
              "ocircumflex",
              "odieresis",
              "ograve",
              "otilde",
              "scaron",
              "uacute",
              "ucircumflex",
              "udieresis",
              "ugrave",
              "yacute",
              "ydieresis",
              "zcaron"
            ], MA = [
              ".notdef",
              "space",
              "exclamsmall",
              "Hungarumlautsmall",
              "dollaroldstyle",
              "dollarsuperior",
              "ampersandsmall",
              "Acutesmall",
              "parenleftsuperior",
              "parenrightsuperior",
              "twodotenleader",
              "onedotenleader",
              "comma",
              "hyphen",
              "period",
              "fraction",
              "zerooldstyle",
              "oneoldstyle",
              "twooldstyle",
              "threeoldstyle",
              "fouroldstyle",
              "fiveoldstyle",
              "sixoldstyle",
              "sevenoldstyle",
              "eightoldstyle",
              "nineoldstyle",
              "colon",
              "semicolon",
              "commasuperior",
              "threequartersemdash",
              "periodsuperior",
              "questionsmall",
              "asuperior",
              "bsuperior",
              "centsuperior",
              "dsuperior",
              "esuperior",
              "isuperior",
              "lsuperior",
              "msuperior",
              "nsuperior",
              "osuperior",
              "rsuperior",
              "ssuperior",
              "tsuperior",
              "ff",
              "fi",
              "fl",
              "ffi",
              "ffl",
              "parenleftinferior",
              "parenrightinferior",
              "Circumflexsmall",
              "hyphensuperior",
              "Gravesmall",
              "Asmall",
              "Bsmall",
              "Csmall",
              "Dsmall",
              "Esmall",
              "Fsmall",
              "Gsmall",
              "Hsmall",
              "Ismall",
              "Jsmall",
              "Ksmall",
              "Lsmall",
              "Msmall",
              "Nsmall",
              "Osmall",
              "Psmall",
              "Qsmall",
              "Rsmall",
              "Ssmall",
              "Tsmall",
              "Usmall",
              "Vsmall",
              "Wsmall",
              "Xsmall",
              "Ysmall",
              "Zsmall",
              "colonmonetary",
              "onefitted",
              "rupiah",
              "Tildesmall",
              "exclamdownsmall",
              "centoldstyle",
              "Lslashsmall",
              "Scaronsmall",
              "Zcaronsmall",
              "Dieresissmall",
              "Brevesmall",
              "Caronsmall",
              "Dotaccentsmall",
              "Macronsmall",
              "figuredash",
              "hypheninferior",
              "Ogoneksmall",
              "Ringsmall",
              "Cedillasmall",
              "onequarter",
              "onehalf",
              "threequarters",
              "questiondownsmall",
              "oneeighth",
              "threeeighths",
              "fiveeighths",
              "seveneighths",
              "onethird",
              "twothirds",
              "zerosuperior",
              "onesuperior",
              "twosuperior",
              "threesuperior",
              "foursuperior",
              "fivesuperior",
              "sixsuperior",
              "sevensuperior",
              "eightsuperior",
              "ninesuperior",
              "zeroinferior",
              "oneinferior",
              "twoinferior",
              "threeinferior",
              "fourinferior",
              "fiveinferior",
              "sixinferior",
              "seveninferior",
              "eightinferior",
              "nineinferior",
              "centinferior",
              "dollarinferior",
              "periodinferior",
              "commainferior",
              "Agravesmall",
              "Aacutesmall",
              "Acircumflexsmall",
              "Atildesmall",
              "Adieresissmall",
              "Aringsmall",
              "AEsmall",
              "Ccedillasmall",
              "Egravesmall",
              "Eacutesmall",
              "Ecircumflexsmall",
              "Edieresissmall",
              "Igravesmall",
              "Iacutesmall",
              "Icircumflexsmall",
              "Idieresissmall",
              "Ethsmall",
              "Ntildesmall",
              "Ogravesmall",
              "Oacutesmall",
              "Ocircumflexsmall",
              "Otildesmall",
              "Odieresissmall",
              "OEsmall",
              "Oslashsmall",
              "Ugravesmall",
              "Uacutesmall",
              "Ucircumflexsmall",
              "Udieresissmall",
              "Yacutesmall",
              "Thornsmall",
              "Ydieresissmall"
            ], be = [
              ".notdef",
              "space",
              "dollaroldstyle",
              "dollarsuperior",
              "parenleftsuperior",
              "parenrightsuperior",
              "twodotenleader",
              "onedotenleader",
              "comma",
              "hyphen",
              "period",
              "fraction",
              "zerooldstyle",
              "oneoldstyle",
              "twooldstyle",
              "threeoldstyle",
              "fouroldstyle",
              "fiveoldstyle",
              "sixoldstyle",
              "sevenoldstyle",
              "eightoldstyle",
              "nineoldstyle",
              "colon",
              "semicolon",
              "commasuperior",
              "threequartersemdash",
              "periodsuperior",
              "asuperior",
              "bsuperior",
              "centsuperior",
              "dsuperior",
              "esuperior",
              "isuperior",
              "lsuperior",
              "msuperior",
              "nsuperior",
              "osuperior",
              "rsuperior",
              "ssuperior",
              "tsuperior",
              "ff",
              "fi",
              "fl",
              "ffi",
              "ffl",
              "parenleftinferior",
              "parenrightinferior",
              "hyphensuperior",
              "colonmonetary",
              "onefitted",
              "rupiah",
              "centoldstyle",
              "figuredash",
              "hypheninferior",
              "onequarter",
              "onehalf",
              "threequarters",
              "oneeighth",
              "threeeighths",
              "fiveeighths",
              "seveneighths",
              "onethird",
              "twothirds",
              "zerosuperior",
              "onesuperior",
              "twosuperior",
              "threesuperior",
              "foursuperior",
              "fivesuperior",
              "sixsuperior",
              "sevensuperior",
              "eightsuperior",
              "ninesuperior",
              "zeroinferior",
              "oneinferior",
              "twoinferior",
              "threeinferior",
              "fourinferior",
              "fiveinferior",
              "sixinferior",
              "seveninferior",
              "eightinferior",
              "nineinferior",
              "centinferior",
              "dollarinferior",
              "periodinferior",
              "commainferior"
            ], at = new A.Struct({
              reserved: new A.Reserved(A.uint16),
              reqFeatureIndex: A.uint16,
              featureCount: A.uint16,
              featureIndexes: new A.Array(A.uint16, "featureCount")
            }), V = new A.Struct({
              tag: new A.String(4),
              langSys: new A.Pointer(A.uint16, at, {
                type: "parent"
              })
            }), me = new A.Struct({
              defaultLangSys: new A.Pointer(A.uint16, at),
              count: A.uint16,
              langSysRecords: new A.Array(V, "count")
            }), Ye = new A.Struct({
              tag: new A.String(4),
              script: new A.Pointer(A.uint16, me, {
                type: "parent"
              })
            }), SA = new A.Array(Ye, A.uint16), ue = new A.Struct({
              version: A.uint16,
              nameID: A.uint16
            }), Fe = new A.Struct({
              featureParams: new A.Pointer(A.uint16, ue),
              lookupCount: A.uint16,
              lookupListIndexes: new A.Array(A.uint16, "lookupCount")
            }), tt = new A.Struct({
              tag: new A.String(4),
              feature: new A.Pointer(A.uint16, Fe, {
                type: "parent"
              })
            }), We = new A.Array(tt, A.uint16), Ze = new A.Struct({
              markAttachmentType: A.uint8,
              flags: new A.Bitfield(A.uint8, [
                "rightToLeft",
                "ignoreBaseGlyphs",
                "ignoreLigatures",
                "ignoreMarks",
                "useMarkFilteringSet"
              ])
            });
            function Ct(BA) {
              let i = new A.Struct({
                lookupType: A.uint16,
                flags: Ze,
                subTableCount: A.uint16,
                subTables: new A.Array(new A.Pointer(A.uint16, BA), "subTableCount"),
                markFilteringSet: new A.Optional(A.uint16, (u) => u.flags.flags.useMarkFilteringSet)
              });
              return new A.LazyArray(new A.Pointer(A.uint16, i), A.uint16);
            }
            let fi = new A.Struct({
              start: A.uint16,
              end: A.uint16,
              startCoverageIndex: A.uint16
            }), st = new A.VersionedStruct(A.uint16, {
              1: {
                glyphCount: A.uint16,
                glyphs: new A.Array(A.uint16, "glyphCount")
              },
              2: {
                rangeCount: A.uint16,
                rangeRecords: new A.Array(fi, "rangeCount")
              }
            }), xt = new A.Struct({
              start: A.uint16,
              end: A.uint16,
              class: A.uint16
            }), Mt = new A.VersionedStruct(A.uint16, {
              1: {
                startGlyph: A.uint16,
                glyphCount: A.uint16,
                classValueArray: new A.Array(A.uint16, "glyphCount")
              },
              2: {
                classRangeCount: A.uint16,
                classRangeRecord: new A.Array(xt, "classRangeCount")
              }
            }), zt = new A.Struct({
              a: A.uint16,
              b: A.uint16,
              deltaFormat: A.uint16
            }), Xt = new A.Struct({
              sequenceIndex: A.uint16,
              lookupListIndex: A.uint16
            }), xi = new A.Struct({
              glyphCount: A.uint16,
              lookupCount: A.uint16,
              input: new A.Array(A.uint16, (BA) => BA.glyphCount - 1),
              lookupRecords: new A.Array(Xt, "lookupCount")
            }), mi = new A.Array(new A.Pointer(A.uint16, xi), A.uint16), Ot = new A.Struct({
              glyphCount: A.uint16,
              lookupCount: A.uint16,
              classes: new A.Array(A.uint16, (BA) => BA.glyphCount - 1),
              lookupRecords: new A.Array(Xt, "lookupCount")
            }), vt = new A.Array(new A.Pointer(A.uint16, Ot), A.uint16), Zt = new A.VersionedStruct(A.uint16, {
              1: {
                coverage: new A.Pointer(A.uint16, st),
                ruleSetCount: A.uint16,
                ruleSets: new A.Array(new A.Pointer(A.uint16, mi), "ruleSetCount")
              },
              2: {
                coverage: new A.Pointer(A.uint16, st),
                classDef: new A.Pointer(A.uint16, Mt),
                classSetCnt: A.uint16,
                classSet: new A.Array(new A.Pointer(A.uint16, vt), "classSetCnt")
              },
              3: {
                glyphCount: A.uint16,
                lookupCount: A.uint16,
                coverages: new A.Array(new A.Pointer(A.uint16, st), "glyphCount"),
                lookupRecords: new A.Array(Xt, "lookupCount")
              }
            }), ei = new A.Struct({
              backtrackGlyphCount: A.uint16,
              backtrack: new A.Array(A.uint16, "backtrackGlyphCount"),
              inputGlyphCount: A.uint16,
              input: new A.Array(A.uint16, (BA) => BA.inputGlyphCount - 1),
              lookaheadGlyphCount: A.uint16,
              lookahead: new A.Array(A.uint16, "lookaheadGlyphCount"),
              lookupCount: A.uint16,
              lookupRecords: new A.Array(Xt, "lookupCount")
            }), Ke = new A.Array(new A.Pointer(A.uint16, ei), A.uint16), qe = new A.VersionedStruct(A.uint16, {
              1: {
                coverage: new A.Pointer(A.uint16, st),
                chainCount: A.uint16,
                chainRuleSets: new A.Array(new A.Pointer(A.uint16, Ke), "chainCount")
              },
              2: {
                coverage: new A.Pointer(A.uint16, st),
                backtrackClassDef: new A.Pointer(A.uint16, Mt),
                inputClassDef: new A.Pointer(A.uint16, Mt),
                lookaheadClassDef: new A.Pointer(A.uint16, Mt),
                chainCount: A.uint16,
                chainClassSet: new A.Array(new A.Pointer(A.uint16, Ke), "chainCount")
              },
              3: {
                backtrackGlyphCount: A.uint16,
                backtrackCoverage: new A.Array(new A.Pointer(A.uint16, st), "backtrackGlyphCount"),
                inputGlyphCount: A.uint16,
                inputCoverage: new A.Array(new A.Pointer(A.uint16, st), "inputGlyphCount"),
                lookaheadGlyphCount: A.uint16,
                lookaheadCoverage: new A.Array(new A.Pointer(A.uint16, st), "lookaheadGlyphCount"),
                lookupCount: A.uint16,
                lookupRecords: new A.Array(Xt, "lookupCount")
              }
            }), Dt = new A.Fixed(16, "BE", 14), ut = new A.Struct({
              startCoord: Dt,
              peakCoord: Dt,
              endCoord: Dt
            }), ni = new A.Struct({
              axisCount: A.uint16,
              regionCount: A.uint16,
              variationRegions: new A.Array(new A.Array(ut, "axisCount"), "regionCount")
            }), wi = new A.Struct({
              shortDeltas: new A.Array(A.int16, (BA) => BA.parent.shortDeltaCount),
              regionDeltas: new A.Array(A.int8, (BA) => BA.parent.regionIndexCount - BA.parent.shortDeltaCount),
              deltas: (BA) => BA.shortDeltas.concat(BA.regionDeltas)
            }), Yi = new A.Struct({
              itemCount: A.uint16,
              shortDeltaCount: A.uint16,
              regionIndexCount: A.uint16,
              regionIndexes: new A.Array(A.uint16, "regionIndexCount"),
              deltaSets: new A.Array(wi, "itemCount")
            }), vA = new A.Struct({
              format: A.uint16,
              variationRegionList: new A.Pointer(A.uint32, ni),
              variationDataCount: A.uint16,
              itemVariationData: new A.Array(new A.Pointer(A.uint32, Yi), "variationDataCount")
            }), UA = new A.VersionedStruct(A.uint16, {
              1: {
                axisIndex: A.uint16,
                axisIndex: A.uint16,
                filterRangeMinValue: Dt,
                filterRangeMaxValue: Dt
              }
            }), mA = new A.Struct({
              conditionCount: A.uint16,
              conditionTable: new A.Array(new A.Pointer(A.uint32, UA), "conditionCount")
            }), qA = new A.Struct({
              featureIndex: A.uint16,
              alternateFeatureTable: new A.Pointer(A.uint32, Fe, {
                type: "parent"
              })
            }), _A = new A.Struct({
              version: A.fixed32,
              substitutionCount: A.uint16,
              substitutions: new A.Array(qA, "substitutionCount")
            }), jA = new A.Struct({
              conditionSet: new A.Pointer(A.uint32, mA, {
                type: "parent"
              }),
              featureTableSubstitution: new A.Pointer(A.uint32, _A, {
                type: "parent"
              })
            }), le = new A.Struct({
              majorVersion: A.uint16,
              minorVersion: A.uint16,
              featureVariationRecordCount: A.uint32,
              featureVariationRecords: new A.Array(jA, "featureVariationRecordCount")
            });
            class JA {
              decode(i, u, m) {
                return this.predefinedOps[m[0]] ? this.predefinedOps[m[0]] : this.type.decode(i, u, m);
              }
              size(i, u) {
                return this.type.size(i, u);
              }
              encode(i, u, m) {
                let L = this.predefinedOps.indexOf(u);
                return L !== -1 ? L : this.type.encode(i, u, m);
              }
              constructor(i, u) {
                this.predefinedOps = i, this.type = u;
              }
            }
            class ne extends A.Number {
              decode(i) {
                return A.uint8.decode(i) & 127;
              }
              constructor() {
                super("UInt8");
              }
            }
            let ae = new A.Struct({
              first: A.uint16,
              nLeft: A.uint8
            }), ve = new A.Struct({
              first: A.uint16,
              nLeft: A.uint16
            }), ze = new A.VersionedStruct(new ne(), {
              0: {
                nCodes: A.uint8,
                codes: new A.Array(A.uint8, "nCodes")
              },
              1: {
                nRanges: A.uint8,
                ranges: new A.Array(ae, "nRanges")
              }
            }), At = new JA([
              Ie,
              ee
            ], new W(ze, {
              lazy: !0
            }));
            class Bt extends A.Array {
              decode(i, u) {
                let m = (0, A.resolveLength)(this.length, i, u), L = 0, Z = [];
                for (; L < m; ) {
                  let O = this.type.decode(i, u);
                  O.offset = L, L += O.nLeft + 1, Z.push(O);
                }
                return Z;
              }
            }
            let He = new A.VersionedStruct(A.uint8, {
              0: {
                glyphs: new A.Array(A.uint16, (BA) => BA.parent.CharStrings.length - 1)
              },
              1: {
                ranges: new Bt(ae, (BA) => BA.parent.CharStrings.length - 1)
              },
              2: {
                ranges: new Bt(ve, (BA) => BA.parent.CharStrings.length - 1)
              }
            }), Ce = new JA([
              Me,
              MA,
              be
            ], new W(He, {
              lazy: !0
            })), je = new A.Struct({
              first: A.uint16,
              fd: A.uint8
            }), it = new A.Struct({
              first: A.uint32,
              fd: A.uint16
            }), Et = new A.VersionedStruct(A.uint8, {
              0: {
                fds: new A.Array(A.uint8, (BA) => BA.parent.CharStrings.length)
              },
              3: {
                nRanges: A.uint16,
                ranges: new A.Array(je, "nRanges"),
                sentinel: A.uint16
              },
              4: {
                nRanges: A.uint32,
                ranges: new A.Array(it, "nRanges"),
                sentinel: A.uint32
              }
            }), Ft = new W(pA);
            class Qt {
              decode(i, u, m) {
                return u.length = m[0], Ft.decode(i, u, [
                  m[1]
                ]);
              }
              size(i, u) {
                return [
                  pA.size(i, u, !1),
                  Ft.size(i, u)[0]
                ];
              }
              encode(i, u, m) {
                return [
                  pA.size(u, m, !1),
                  Ft.encode(i, u, m)[0]
                ];
              }
            }
            let Nt = new G([
              // key       name                   type(s)                                 default
              [
                18,
                "Private",
                new Qt(),
                null
              ],
              [
                [
                  12,
                  38
                ],
                "FontName",
                "sid",
                null
              ],
              [
                [
                  12,
                  7
                ],
                "FontMatrix",
                "array",
                [
                  1e-3,
                  0,
                  0,
                  1e-3,
                  0,
                  0
                ]
              ],
              [
                [
                  12,
                  5
                ],
                "PaintType",
                "number",
                0
              ]
            ]), gt = new G([
              // key       name                   type(s)                                 default
              [
                [
                  12,
                  30
                ],
                "ROS",
                [
                  "sid",
                  "sid",
                  "number"
                ],
                null
              ],
              [
                0,
                "version",
                "sid",
                null
              ],
              [
                1,
                "Notice",
                "sid",
                null
              ],
              [
                [
                  12,
                  0
                ],
                "Copyright",
                "sid",
                null
              ],
              [
                2,
                "FullName",
                "sid",
                null
              ],
              [
                3,
                "FamilyName",
                "sid",
                null
              ],
              [
                4,
                "Weight",
                "sid",
                null
              ],
              [
                [
                  12,
                  1
                ],
                "isFixedPitch",
                "boolean",
                !1
              ],
              [
                [
                  12,
                  2
                ],
                "ItalicAngle",
                "number",
                0
              ],
              [
                [
                  12,
                  3
                ],
                "UnderlinePosition",
                "number",
                -100
              ],
              [
                [
                  12,
                  4
                ],
                "UnderlineThickness",
                "number",
                50
              ],
              [
                [
                  12,
                  5
                ],
                "PaintType",
                "number",
                0
              ],
              [
                [
                  12,
                  6
                ],
                "CharstringType",
                "number",
                2
              ],
              [
                [
                  12,
                  7
                ],
                "FontMatrix",
                "array",
                [
                  1e-3,
                  0,
                  0,
                  1e-3,
                  0,
                  0
                ]
              ],
              [
                13,
                "UniqueID",
                "number",
                null
              ],
              [
                5,
                "FontBBox",
                "array",
                [
                  0,
                  0,
                  0,
                  0
                ]
              ],
              [
                [
                  12,
                  8
                ],
                "StrokeWidth",
                "number",
                0
              ],
              [
                14,
                "XUID",
                "array",
                null
              ],
              [
                15,
                "charset",
                Ce,
                Me
              ],
              [
                16,
                "Encoding",
                At,
                Ie
              ],
              [
                17,
                "CharStrings",
                new W(new _e()),
                null
              ],
              [
                18,
                "Private",
                new Qt(),
                null
              ],
              [
                [
                  12,
                  20
                ],
                "SyntheticBase",
                "number",
                null
              ],
              [
                [
                  12,
                  21
                ],
                "PostScript",
                "sid",
                null
              ],
              [
                [
                  12,
                  22
                ],
                "BaseFontName",
                "sid",
                null
              ],
              [
                [
                  12,
                  23
                ],
                "BaseFontBlend",
                "delta",
                null
              ],
              // CID font specific
              [
                [
                  12,
                  31
                ],
                "CIDFontVersion",
                "number",
                0
              ],
              [
                [
                  12,
                  32
                ],
                "CIDFontRevision",
                "number",
                0
              ],
              [
                [
                  12,
                  33
                ],
                "CIDFontType",
                "number",
                0
              ],
              [
                [
                  12,
                  34
                ],
                "CIDCount",
                "number",
                8720
              ],
              [
                [
                  12,
                  35
                ],
                "UIDBase",
                "number",
                null
              ],
              [
                [
                  12,
                  37
                ],
                "FDSelect",
                new W(Et),
                null
              ],
              [
                [
                  12,
                  36
                ],
                "FDArray",
                new W(new _e(Nt)),
                null
              ],
              [
                [
                  12,
                  38
                ],
                "FontName",
                "sid",
                null
              ]
            ]), yt = new A.Struct({
              length: A.uint16,
              itemVariationStore: vA
            }), oi = new G([
              [
                [
                  12,
                  7
                ],
                "FontMatrix",
                "array",
                [
                  1e-3,
                  0,
                  0,
                  1e-3,
                  0,
                  0
                ]
              ],
              [
                17,
                "CharStrings",
                new W(new _e()),
                null
              ],
              [
                [
                  12,
                  37
                ],
                "FDSelect",
                new W(Et),
                null
              ],
              [
                [
                  12,
                  36
                ],
                "FDArray",
                new W(new _e(Nt)),
                null
              ],
              [
                24,
                "vstore",
                new W(yt),
                null
              ],
              [
                25,
                "maxstack",
                "number",
                193
              ]
            ]);
            var _t = new A.VersionedStruct(A.fixed16, {
              1: {
                hdrSize: A.uint8,
                offSize: A.uint8,
                nameIndex: new _e(new A.String("length")),
                topDictIndex: new _e(gt),
                stringIndex: new _e(new A.String("length")),
                globalSubrIndex: new _e()
              },
              2: {
                hdrSize: A.uint8,
                length: A.uint16,
                topDict: oi,
                globalSubrIndex: new _e()
              }
            });
            class St {
              static decode(i) {
                return new St(i);
              }
              decode() {
                this.stream.pos;
                let i = _t.decode(this.stream);
                for (let u in i) {
                  let m = i[u];
                  this[u] = m;
                }
                if (this.version < 2) {
                  if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
                  this.topDict = this.topDictIndex[0];
                }
                return this.isCIDFont = this.topDict.ROS != null, this;
              }
              string(i) {
                return this.version >= 2 ? null : i < Be.length ? Be[i] : this.stringIndex[i - Be.length];
              }
              get postscriptName() {
                return this.version < 2 ? this.nameIndex[0] : null;
              }
              get fullName() {
                return this.string(this.topDict.FullName);
              }
              get familyName() {
                return this.string(this.topDict.FamilyName);
              }
              getCharString(i) {
                return this.stream.pos = this.topDict.CharStrings[i].offset, this.stream.readBuffer(this.topDict.CharStrings[i].length);
              }
              getGlyphName(i) {
                if (this.version >= 2 || this.isCIDFont) return null;
                let { charset: u } = this.topDict;
                if (Array.isArray(u)) return u[i];
                if (i === 0) return ".notdef";
                switch (i -= 1, u.version) {
                  case 0:
                    return this.string(u.glyphs[i]);
                  case 1:
                  case 2:
                    for (let m = 0; m < u.ranges.length; m++) {
                      let L = u.ranges[m];
                      if (L.offset <= i && i <= L.offset + L.nLeft) return this.string(L.first + (i - L.offset));
                    }
                    break;
                }
                return null;
              }
              fdForGlyph(i) {
                if (!this.topDict.FDSelect) return null;
                switch (this.topDict.FDSelect.version) {
                  case 0:
                    return this.topDict.FDSelect.fds[i];
                  case 3:
                  case 4:
                    let { ranges: u } = this.topDict.FDSelect, m = 0, L = u.length - 1;
                    for (; m <= L; ) {
                      let Z = m + L >> 1;
                      if (i < u[Z].first) L = Z - 1;
                      else if (Z < L && i >= u[Z + 1].first) m = Z + 1;
                      else return u[Z].fd;
                    }
                  default:
                    throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
                }
              }
              privateDictForGlyph(i) {
                if (this.topDict.FDSelect) {
                  let u = this.fdForGlyph(i);
                  return this.topDict.FDArray[u] ? this.topDict.FDArray[u].Private : null;
                }
                return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
              }
              constructor(i) {
                this.stream = i, this.decode();
              }
            }
            var ri = St;
            let gn = new A.Struct({
              glyphIndex: A.uint16,
              vertOriginY: A.int16
            });
            var Pi = new A.Struct({
              majorVersion: A.uint16,
              minorVersion: A.uint16,
              defaultVertOriginY: A.int16,
              numVertOriginYMetrics: A.uint16,
              metrics: new A.Array(gn, "numVertOriginYMetrics")
            });
            let Fi = new A.Struct({
              height: A.uint8,
              width: A.uint8,
              horiBearingX: A.int8,
              horiBearingY: A.int8,
              horiAdvance: A.uint8,
              vertBearingX: A.int8,
              vertBearingY: A.int8,
              vertAdvance: A.uint8
            }), ki = new A.Struct({
              height: A.uint8,
              width: A.uint8,
              bearingX: A.int8,
              bearingY: A.int8,
              advance: A.uint8
            }), di = new A.Struct({
              glyph: A.uint16,
              xOffset: A.int8,
              yOffset: A.int8
            });
            class ji {
            }
            class pi {
            }
            new A.VersionedStruct("version", {
              1: {
                metrics: ki,
                data: ji
              },
              2: {
                metrics: ki,
                data: pi
              },
              // format 3 is deprecated
              // format 4 is not supported by Microsoft
              5: {
                data: pi
              },
              6: {
                metrics: Fi,
                data: ji
              },
              7: {
                metrics: Fi,
                data: pi
              },
              8: {
                metrics: ki,
                pad: new A.Reserved(A.uint8),
                numComponents: A.uint16,
                components: new A.Array(di, "numComponents")
              },
              9: {
                metrics: Fi,
                pad: new A.Reserved(A.uint8),
                numComponents: A.uint16,
                components: new A.Array(di, "numComponents")
              },
              17: {
                metrics: ki,
                dataLen: A.uint32,
                data: new A.Buffer("dataLen")
              },
              18: {
                metrics: Fi,
                dataLen: A.uint32,
                data: new A.Buffer("dataLen")
              },
              19: {
                dataLen: A.uint32,
                data: new A.Buffer("dataLen")
              }
            });
            let Ni = new A.Struct({
              ascender: A.int8,
              descender: A.int8,
              widthMax: A.uint8,
              caretSlopeNumerator: A.int8,
              caretSlopeDenominator: A.int8,
              caretOffset: A.int8,
              minOriginSB: A.int8,
              minAdvanceSB: A.int8,
              maxBeforeBL: A.int8,
              minAfterBL: A.int8,
              pad: new A.Reserved(A.int8, 2)
            }), vi = new A.Struct({
              glyphCode: A.uint16,
              offset: A.uint16
            }), Wi = new A.VersionedStruct(A.uint16, {
              header: {
                imageFormat: A.uint16,
                imageDataOffset: A.uint32
              },
              1: {
                offsetArray: new A.Array(A.uint32, (BA) => BA.parent.lastGlyphIndex - BA.parent.firstGlyphIndex + 1)
              },
              2: {
                imageSize: A.uint32,
                bigMetrics: Fi
              },
              3: {
                offsetArray: new A.Array(A.uint16, (BA) => BA.parent.lastGlyphIndex - BA.parent.firstGlyphIndex + 1)
              },
              4: {
                numGlyphs: A.uint32,
                glyphArray: new A.Array(vi, (BA) => BA.numGlyphs + 1)
              },
              5: {
                imageSize: A.uint32,
                bigMetrics: Fi,
                numGlyphs: A.uint32,
                glyphCodeArray: new A.Array(A.uint16, "numGlyphs")
              }
            }), zn = new A.Struct({
              firstGlyphIndex: A.uint16,
              lastGlyphIndex: A.uint16,
              subtable: new A.Pointer(A.uint32, Wi)
            }), Ri = new A.Struct({
              indexSubTableArray: new A.Pointer(A.uint32, new A.Array(zn, 1), {
                type: "parent"
              }),
              indexTablesSize: A.uint32,
              numberOfIndexSubTables: A.uint32,
              colorRef: A.uint32,
              hori: Ni,
              vert: Ni,
              startGlyphIndex: A.uint16,
              endGlyphIndex: A.uint16,
              ppemX: A.uint8,
              ppemY: A.uint8,
              bitDepth: A.uint8,
              flags: new A.Bitfield(A.uint8, [
                "horizontal",
                "vertical"
              ])
            });
            var nn = new A.Struct({
              version: A.uint32,
              numSizes: A.uint32,
              sizes: new A.Array(Ri, "numSizes")
            });
            let Tn = new A.Struct({
              ppem: A.uint16,
              resolution: A.uint16,
              imageOffsets: new A.Array(new A.Pointer(A.uint32, "void"), (BA) => BA.parent.parent.maxp.numGlyphs + 1)
            });
            var rn = new A.Struct({
              version: A.uint16,
              flags: new A.Bitfield(A.uint16, [
                "renderOutlines"
              ]),
              numImgTables: A.uint32,
              imageTables: new A.Array(new A.Pointer(A.uint32, Tn), "numImgTables")
            });
            let hi = new A.Struct({
              gid: A.uint16,
              paletteIndex: A.uint16
              // Index value to use in the appropriate palette. This value must
            }), In = new A.Struct({
              gid: A.uint16,
              // and is not rendered for color.
              firstLayerIndex: A.uint16,
              // There will be numLayers consecutive entries for this base glyph.
              numLayers: A.uint16
            });
            var zr = new A.Struct({
              version: A.uint16,
              numBaseGlyphRecords: A.uint16,
              baseGlyphRecord: new A.Pointer(A.uint32, new A.Array(In, "numBaseGlyphRecords")),
              layerRecords: new A.Pointer(A.uint32, new A.Array(hi, "numLayerRecords"), {
                lazy: !0
              }),
              numLayerRecords: A.uint16
            });
            let ir = new A.Struct({
              blue: A.uint8,
              green: A.uint8,
              red: A.uint8,
              alpha: A.uint8
            });
            var nr = new A.VersionedStruct(A.uint16, {
              header: {
                numPaletteEntries: A.uint16,
                numPalettes: A.uint16,
                numColorRecords: A.uint16,
                colorRecords: new A.Pointer(A.uint32, new A.Array(ir, "numColorRecords")),
                colorRecordIndices: new A.Array(A.uint16, "numPalettes")
              },
              0: {},
              1: {
                offsetPaletteTypeArray: new A.Pointer(A.uint32, new A.Array(A.uint32, "numPalettes")),
                offsetPaletteLabelArray: new A.Pointer(A.uint32, new A.Array(A.uint16, "numPalettes")),
                offsetPaletteEntryLabelArray: new A.Pointer(A.uint32, new A.Array(A.uint16, "numPaletteEntries"))
              }
            });
            let cn = new A.VersionedStruct(A.uint16, {
              1: {
                coordinate: A.int16
                // X or Y value, in design units
              },
              2: {
                coordinate: A.int16,
                referenceGlyph: A.uint16,
                baseCoordPoint: A.uint16
                // Index of contour point on the referenceGlyph
              },
              3: {
                coordinate: A.int16,
                deviceTable: new A.Pointer(A.uint16, zt)
                // Device table for X or Y value
              }
            }), rr = new A.Struct({
              defaultIndex: A.uint16,
              baseCoordCount: A.uint16,
              baseCoords: new A.Array(new A.Pointer(A.uint16, cn), "baseCoordCount")
            }), sr = new A.Struct({
              tag: new A.String(4),
              minCoord: new A.Pointer(A.uint16, cn, {
                type: "parent"
              }),
              maxCoord: new A.Pointer(A.uint16, cn, {
                type: "parent"
              })
              // May be NULL
            }), ar = new A.Struct({
              minCoord: new A.Pointer(A.uint16, cn),
              maxCoord: new A.Pointer(A.uint16, cn),
              featMinMaxCount: A.uint16,
              featMinMaxRecords: new A.Array(sr, "featMinMaxCount")
              // In alphabetical order
            }), Tr = new A.Struct({
              tag: new A.String(4),
              minMax: new A.Pointer(A.uint16, ar, {
                type: "parent"
              })
            }), Ur = new A.Struct({
              baseValues: new A.Pointer(A.uint16, rr),
              defaultMinMax: new A.Pointer(A.uint16, ar),
              baseLangSysCount: A.uint16,
              baseLangSysRecords: new A.Array(Tr, "baseLangSysCount")
              // in alphabetical order by BaseLangSysTag
            }), Nr = new A.Struct({
              tag: new A.String(4),
              script: new A.Pointer(A.uint16, Ur, {
                type: "parent"
              })
            }), Rr = new A.Array(Nr, A.uint16), Sr = new A.Array(new A.String(4), A.uint16), or = new A.Struct({
              baseTagList: new A.Pointer(A.uint16, Sr),
              baseScriptList: new A.Pointer(A.uint16, Rr)
            });
            var Gr = new A.VersionedStruct(A.uint32, {
              header: {
                horizAxis: new A.Pointer(A.uint16, or),
                vertAxis: new A.Pointer(A.uint16, or)
                // May be NULL
              },
              65536: {},
              65537: {
                itemVariationStore: new A.Pointer(A.uint32, vA)
              }
            });
            let Br = new A.Array(A.uint16, A.uint16), Un = new A.Struct({
              coverage: new A.Pointer(A.uint16, st),
              glyphCount: A.uint16,
              attachPoints: new A.Array(new A.Pointer(A.uint16, Br), "glyphCount")
            }), yn = new A.VersionedStruct(A.uint16, {
              1: {
                coordinate: A.int16
              },
              2: {
                caretValuePoint: A.uint16
              },
              3: {
                coordinate: A.int16,
                deviceTable: new A.Pointer(A.uint16, zt)
              }
            }), Jn = new A.Array(new A.Pointer(A.uint16, yn), A.uint16), Hr = new A.Struct({
              coverage: new A.Pointer(A.uint16, st),
              ligGlyphCount: A.uint16,
              ligGlyphs: new A.Array(new A.Pointer(A.uint16, Jn), "ligGlyphCount")
            }), gr = new A.Struct({
              markSetTableFormat: A.uint16,
              markSetCount: A.uint16,
              coverage: new A.Array(new A.Pointer(A.uint32, st), "markSetCount")
            });
            var Lr = new A.VersionedStruct(A.uint32, {
              header: {
                glyphClassDef: new A.Pointer(A.uint16, Mt),
                attachList: new A.Pointer(A.uint16, Un),
                ligCaretList: new A.Pointer(A.uint16, Hr),
                markAttachClassDef: new A.Pointer(A.uint16, Mt)
              },
              65536: {},
              65538: {
                markGlyphSetsDef: new A.Pointer(A.uint16, gr)
              },
              65539: {
                markGlyphSetsDef: new A.Pointer(A.uint16, gr),
                itemVariationStore: new A.Pointer(A.uint32, vA)
              }
            });
            let qi = new A.Bitfield(A.uint16, [
              "xPlacement",
              "yPlacement",
              "xAdvance",
              "yAdvance",
              "xPlaDevice",
              "yPlaDevice",
              "xAdvDevice",
              "yAdvDevice"
            ]), kr = {
              xPlacement: A.int16,
              yPlacement: A.int16,
              xAdvance: A.int16,
              yAdvance: A.int16,
              xPlaDevice: new A.Pointer(A.uint16, zt, {
                type: "global",
                relativeTo: (BA) => BA.rel
              }),
              yPlaDevice: new A.Pointer(A.uint16, zt, {
                type: "global",
                relativeTo: (BA) => BA.rel
              }),
              xAdvDevice: new A.Pointer(A.uint16, zt, {
                type: "global",
                relativeTo: (BA) => BA.rel
              }),
              yAdvDevice: new A.Pointer(A.uint16, zt, {
                type: "global",
                relativeTo: (BA) => BA.rel
              })
            };
            class ln {
              buildStruct(i) {
                let u = i;
                for (; !u[this.key] && u.parent; ) u = u.parent;
                if (!u[this.key]) return;
                let m = {};
                m.rel = () => u._startOffset;
                let L = u[this.key];
                for (let Z in L) L[Z] && (m[Z] = kr[Z]);
                return new A.Struct(m);
              }
              size(i, u) {
                return this.buildStruct(u).size(i, u);
              }
              decode(i, u) {
                let m = this.buildStruct(u).decode(i, u);
                return delete m.rel, m;
              }
              constructor(i = "valueFormat") {
                this.key = i;
              }
            }
            let jr = new A.Struct({
              secondGlyph: A.uint16,
              value1: new ln("valueFormat1"),
              value2: new ln("valueFormat2")
            }), Or = new A.Array(jr, A.uint16), Jr = new A.Struct({
              value1: new ln("valueFormat1"),
              value2: new ln("valueFormat2")
            }), Fn = new A.VersionedStruct(A.uint16, {
              1: {
                xCoordinate: A.int16,
                yCoordinate: A.int16
              },
              2: {
                xCoordinate: A.int16,
                yCoordinate: A.int16,
                anchorPoint: A.uint16
              },
              3: {
                xCoordinate: A.int16,
                yCoordinate: A.int16,
                xDeviceTable: new A.Pointer(A.uint16, zt),
                yDeviceTable: new A.Pointer(A.uint16, zt)
              }
            }), Kr = new A.Struct({
              entryAnchor: new A.Pointer(A.uint16, Fn, {
                type: "parent"
              }),
              exitAnchor: new A.Pointer(A.uint16, Fn, {
                type: "parent"
              })
            }), cr = new A.Struct({
              class: A.uint16,
              markAnchor: new A.Pointer(A.uint16, Fn, {
                type: "parent"
              })
            }), Kn = new A.Array(cr, A.uint16), Wr = new A.Array(new A.Pointer(A.uint16, Fn), (BA) => BA.parent.classCount), NA = new A.Array(Wr, A.uint16), t = new A.Array(new A.Pointer(A.uint16, Fn), (BA) => BA.parent.parent.classCount), C = new A.Array(t, A.uint16), b = new A.Array(new A.Pointer(A.uint16, C), A.uint16), nA = new A.VersionedStruct("lookupType", {
              1: new A.VersionedStruct(A.uint16, {
                1: {
                  coverage: new A.Pointer(A.uint16, st),
                  valueFormat: qi,
                  value: new ln()
                },
                2: {
                  coverage: new A.Pointer(A.uint16, st),
                  valueFormat: qi,
                  valueCount: A.uint16,
                  values: new A.LazyArray(new ln(), "valueCount")
                }
              }),
              2: new A.VersionedStruct(A.uint16, {
                1: {
                  coverage: new A.Pointer(A.uint16, st),
                  valueFormat1: qi,
                  valueFormat2: qi,
                  pairSetCount: A.uint16,
                  pairSets: new A.LazyArray(new A.Pointer(A.uint16, Or), "pairSetCount")
                },
                2: {
                  coverage: new A.Pointer(A.uint16, st),
                  valueFormat1: qi,
                  valueFormat2: qi,
                  classDef1: new A.Pointer(A.uint16, Mt),
                  classDef2: new A.Pointer(A.uint16, Mt),
                  class1Count: A.uint16,
                  class2Count: A.uint16,
                  classRecords: new A.LazyArray(new A.LazyArray(Jr, "class2Count"), "class1Count")
                }
              }),
              3: {
                format: A.uint16,
                coverage: new A.Pointer(A.uint16, st),
                entryExitCount: A.uint16,
                entryExitRecords: new A.Array(Kr, "entryExitCount")
              },
              4: {
                format: A.uint16,
                markCoverage: new A.Pointer(A.uint16, st),
                baseCoverage: new A.Pointer(A.uint16, st),
                classCount: A.uint16,
                markArray: new A.Pointer(A.uint16, Kn),
                baseArray: new A.Pointer(A.uint16, NA)
              },
              5: {
                format: A.uint16,
                markCoverage: new A.Pointer(A.uint16, st),
                ligatureCoverage: new A.Pointer(A.uint16, st),
                classCount: A.uint16,
                markArray: new A.Pointer(A.uint16, Kn),
                ligatureArray: new A.Pointer(A.uint16, b)
              },
              6: {
                format: A.uint16,
                mark1Coverage: new A.Pointer(A.uint16, st),
                mark2Coverage: new A.Pointer(A.uint16, st),
                classCount: A.uint16,
                mark1Array: new A.Pointer(A.uint16, Kn),
                mark2Array: new A.Pointer(A.uint16, NA)
              },
              7: Zt,
              8: qe,
              9: {
                posFormat: A.uint16,
                lookupType: A.uint16,
                extension: new A.Pointer(A.uint32, null)
              }
            });
            nA.versions[9].extension.type = nA;
            var gA = new A.VersionedStruct(A.uint32, {
              header: {
                scriptList: new A.Pointer(A.uint16, SA),
                featureList: new A.Pointer(A.uint16, We),
                lookupList: new A.Pointer(A.uint16, new Ct(nA))
              },
              65536: {},
              65537: {
                featureVariations: new A.Pointer(A.uint32, le)
              }
            });
            let hA = new A.Array(A.uint16, A.uint16), HA = hA, GA = new A.Struct({
              glyph: A.uint16,
              compCount: A.uint16,
              components: new A.Array(A.uint16, (BA) => BA.compCount - 1)
            }), fe = new A.Array(new A.Pointer(A.uint16, GA), A.uint16), we = new A.VersionedStruct("lookupType", {
              1: new A.VersionedStruct(A.uint16, {
                1: {
                  coverage: new A.Pointer(A.uint16, st),
                  deltaGlyphID: A.int16
                },
                2: {
                  coverage: new A.Pointer(A.uint16, st),
                  glyphCount: A.uint16,
                  substitute: new A.LazyArray(A.uint16, "glyphCount")
                }
              }),
              2: {
                substFormat: A.uint16,
                coverage: new A.Pointer(A.uint16, st),
                count: A.uint16,
                sequences: new A.LazyArray(new A.Pointer(A.uint16, hA), "count")
              },
              3: {
                substFormat: A.uint16,
                coverage: new A.Pointer(A.uint16, st),
                count: A.uint16,
                alternateSet: new A.LazyArray(new A.Pointer(A.uint16, HA), "count")
              },
              4: {
                substFormat: A.uint16,
                coverage: new A.Pointer(A.uint16, st),
                count: A.uint16,
                ligatureSets: new A.LazyArray(new A.Pointer(A.uint16, fe), "count")
              },
              5: Zt,
              6: qe,
              7: {
                substFormat: A.uint16,
                lookupType: A.uint16,
                extension: new A.Pointer(A.uint32, null)
              },
              8: {
                substFormat: A.uint16,
                coverage: new A.Pointer(A.uint16, st),
                backtrackCoverage: new A.Array(new A.Pointer(A.uint16, st), "backtrackGlyphCount"),
                lookaheadGlyphCount: A.uint16,
                lookaheadCoverage: new A.Array(new A.Pointer(A.uint16, st), "lookaheadGlyphCount"),
                glyphCount: A.uint16,
                substitutes: new A.Array(A.uint16, "glyphCount")
              }
            });
            we.versions[7].extension.type = we;
            var ye = new A.VersionedStruct(A.uint32, {
              header: {
                scriptList: new A.Pointer(A.uint16, SA),
                featureList: new A.Pointer(A.uint16, We),
                lookupList: new A.Pointer(A.uint16, new Ct(we))
              },
              65536: {},
              65537: {
                featureVariations: new A.Pointer(A.uint32, le)
              }
            });
            let De = new A.Array(A.uint16, A.uint16), g = new A.Struct({
              shrinkageEnableGSUB: new A.Pointer(A.uint16, De),
              shrinkageDisableGSUB: new A.Pointer(A.uint16, De),
              shrinkageEnableGPOS: new A.Pointer(A.uint16, De),
              shrinkageDisableGPOS: new A.Pointer(A.uint16, De),
              shrinkageJstfMax: new A.Pointer(A.uint16, new Ct(nA)),
              extensionEnableGSUB: new A.Pointer(A.uint16, De),
              extensionDisableGSUB: new A.Pointer(A.uint16, De),
              extensionEnableGPOS: new A.Pointer(A.uint16, De),
              extensionDisableGPOS: new A.Pointer(A.uint16, De),
              extensionJstfMax: new A.Pointer(A.uint16, new Ct(nA))
            }), s = new A.Array(new A.Pointer(A.uint16, g), A.uint16), I = new A.Struct({
              tag: new A.String(4),
              jstfLangSys: new A.Pointer(A.uint16, s)
            }), f = new A.Struct({
              extenderGlyphs: new A.Pointer(A.uint16, new A.Array(A.uint16, A.uint16)),
              defaultLangSys: new A.Pointer(A.uint16, s),
              langSysCount: A.uint16,
              langSysRecords: new A.Array(I, "langSysCount")
            }), S = new A.Struct({
              tag: new A.String(4),
              script: new A.Pointer(A.uint16, f, {
                type: "parent"
              })
            });
            var iA = new A.Struct({
              version: A.uint32,
              scriptCount: A.uint16,
              scriptList: new A.Array(S, "scriptCount")
            });
            class YA {
              decode(i, u) {
                switch (this.size(0, u)) {
                  case 1:
                    return i.readUInt8();
                  case 2:
                    return i.readUInt16BE();
                  case 3:
                    return i.readUInt24BE();
                  case 4:
                    return i.readUInt32BE();
                }
              }
              size(i, u) {
                return (0, A.resolveLength)(this._size, null, u);
              }
              constructor(i) {
                this._size = i;
              }
            }
            let XA = new A.Struct({
              entry: new YA((BA) => ((BA.parent.entryFormat & 48) >> 4) + 1),
              outerIndex: (BA) => BA.entry >> (BA.parent.entryFormat & 15) + 1,
              innerIndex: (BA) => BA.entry & (1 << (BA.parent.entryFormat & 15) + 1) - 1
            }), oe = new A.Struct({
              entryFormat: A.uint16,
              mapCount: A.uint16,
              mapData: new A.Array(XA, "mapCount")
            });
            var pe = new A.Struct({
              majorVersion: A.uint16,
              minorVersion: A.uint16,
              itemVariationStore: new A.Pointer(A.uint32, vA),
              advanceWidthMapping: new A.Pointer(A.uint32, oe),
              LSBMapping: new A.Pointer(A.uint32, oe),
              RSBMapping: new A.Pointer(A.uint32, oe)
            });
            let xe = new A.Struct({
              format: A.uint32,
              length: A.uint32,
              offset: A.uint32
            }), Qe = new A.Struct({
              reserved: new A.Reserved(A.uint16, 2),
              cbSignature: A.uint32,
              signature: new A.Buffer("cbSignature")
            });
            var ke = new A.Struct({
              ulVersion: A.uint32,
              usNumSigs: A.uint16,
              usFlag: A.uint16,
              signatures: new A.Array(xe, "usNumSigs"),
              signatureBlocks: new A.Array(Qe, "usNumSigs")
            });
            let lt = new A.Struct({
              rangeMaxPPEM: A.uint16,
              rangeGaspBehavior: new A.Bitfield(A.uint16, [
                "grayscale",
                "gridfit",
                "symmetricSmoothing",
                "symmetricGridfit"
                // only in version 1, for ClearType
              ])
            });
            var Xe = new A.Struct({
              version: A.uint16,
              numRanges: A.uint16,
              gaspRanges: new A.Array(lt, "numRanges")
              // Sorted by ppem
            });
            let et = new A.Struct({
              pixelSize: A.uint8,
              maximumWidth: A.uint8,
              widths: new A.Array(A.uint8, (BA) => BA.parent.parent.maxp.numGlyphs)
            });
            var Oe = new A.Struct({
              version: A.uint16,
              numRecords: A.int16,
              sizeDeviceRecord: A.int32,
              records: new A.Array(et, "numRecords")
            });
            let rt = new A.Struct({
              left: A.uint16,
              right: A.uint16,
              value: A.int16
            }), $e = new A.Struct({
              firstGlyph: A.uint16,
              nGlyphs: A.uint16,
              offsets: new A.Array(A.uint16, "nGlyphs"),
              max: (BA) => BA.offsets.length && Math.max.apply(Math, BA.offsets)
            }), wt = new A.Struct({
              off: (BA) => BA._startOffset - BA.parent.parent._startOffset,
              len: (BA) => ((BA.parent.leftTable.max - BA.off) / BA.parent.rowWidth + 1) * (BA.parent.rowWidth / 2),
              values: new A.LazyArray(A.int16, "len")
            }), Wt = new A.VersionedStruct("format", {
              0: {
                nPairs: A.uint16,
                searchRange: A.uint16,
                entrySelector: A.uint16,
                rangeShift: A.uint16,
                pairs: new A.Array(rt, "nPairs")
              },
              2: {
                rowWidth: A.uint16,
                leftTable: new A.Pointer(A.uint16, $e, {
                  type: "parent"
                }),
                rightTable: new A.Pointer(A.uint16, $e, {
                  type: "parent"
                }),
                array: new A.Pointer(A.uint16, wt, {
                  type: "parent"
                })
              },
              3: {
                glyphCount: A.uint16,
                kernValueCount: A.uint8,
                leftClassCount: A.uint8,
                rightClassCount: A.uint8,
                flags: A.uint8,
                kernValue: new A.Array(A.int16, "kernValueCount"),
                leftClass: new A.Array(A.uint8, "glyphCount"),
                rightClass: new A.Array(A.uint8, "glyphCount"),
                kernIndex: new A.Array(A.uint8, (BA) => BA.leftClassCount * BA.rightClassCount)
              }
            }), $t = new A.VersionedStruct("version", {
              0: {
                subVersion: A.uint16,
                length: A.uint16,
                format: A.uint8,
                coverage: new A.Bitfield(A.uint8, [
                  "horizontal",
                  "minimum",
                  "crossStream",
                  "override"
                  // If set to 1 the value in this table replaces the accumulated value
                ]),
                subtable: Wt,
                padding: new A.Reserved(A.uint8, (BA) => BA.length - BA._currentOffset)
              },
              1: {
                length: A.uint32,
                coverage: new A.Bitfield(A.uint8, [
                  null,
                  null,
                  null,
                  null,
                  null,
                  "variation",
                  "crossStream",
                  "vertical"
                  // Set if table has vertical kerning values
                ]),
                format: A.uint8,
                tupleIndex: A.uint16,
                subtable: Wt,
                padding: new A.Reserved(A.uint8, (BA) => BA.length - BA._currentOffset)
              }
            });
            var Gt = new A.VersionedStruct(A.uint16, {
              0: {
                nTables: A.uint16,
                tables: new A.Array($t, "nTables")
              },
              1: {
                reserved: new A.Reserved(A.uint16),
                nTables: A.uint32,
                tables: new A.Array($t, "nTables")
              }
            }), ct = new A.Struct({
              version: A.uint16,
              numGlyphs: A.uint16,
              yPels: new A.Array(A.uint8, "numGlyphs")
            }), jt = new A.Struct({
              version: A.uint16,
              fontNumber: A.uint32,
              pitch: A.uint16,
              xHeight: A.uint16,
              style: A.uint16,
              typeFamily: A.uint16,
              capHeight: A.uint16,
              symbolSet: A.uint16,
              typeface: new A.String(16),
              characterComplement: new A.String(8),
              fileName: new A.String(6),
              strokeWeight: new A.String(1),
              widthType: new A.String(1),
              serifStyle: A.uint8,
              reserved: new A.Reserved(A.uint8)
            });
            let bi = new A.Struct({
              bCharSet: A.uint8,
              xRatio: A.uint8,
              yStartRatio: A.uint8,
              yEndRatio: A.uint8
              // Ending y-Ratio value
            }), Ci = new A.Struct({
              yPelHeight: A.uint16,
              yMax: A.int16,
              yMin: A.int16
              // Minimum value (in pels) for this yPelHeight
            }), _i = new A.Struct({
              recs: A.uint16,
              startsz: A.uint8,
              endsz: A.uint8,
              entries: new A.Array(Ci, "recs")
              // The VDMX records
            });
            var Oi = new A.Struct({
              version: A.uint16,
              numRecs: A.uint16,
              numRatios: A.uint16,
              ratioRanges: new A.Array(bi, "numRatios"),
              offsets: new A.Array(A.uint16, "numRatios"),
              groups: new A.Array(_i, "numRecs")
              // The actual VDMX groupings
            }), xn = new A.Struct({
              version: A.uint16,
              ascent: A.int16,
              descent: A.int16,
              lineGap: A.int16,
              advanceHeightMax: A.int16,
              minTopSideBearing: A.int16,
              minBottomSideBearing: A.int16,
              yMaxExtent: A.int16,
              caretSlopeRise: A.int16,
              caretSlopeRun: A.int16,
              caretOffset: A.int16,
              reserved: new A.Reserved(A.int16, 4),
              metricDataFormat: A.int16,
              numberOfMetrics: A.uint16
              // Number of advance heights in the Vertical Metrics table
            });
            let gs = new A.Struct({
              advance: A.uint16,
              bearing: A.int16
              // The top sidebearing of the glyph
            });
            var Wn = new A.Struct({
              metrics: new A.LazyArray(gs, (BA) => BA.parent.vhea.numberOfMetrics),
              bearings: new A.LazyArray(A.int16, (BA) => BA.parent.maxp.numGlyphs - BA.parent.vhea.numberOfMetrics)
            });
            let cs = new A.Fixed(16, "BE", 14), ea = new A.Struct({
              fromCoord: cs,
              toCoord: cs
            }), jB = new A.Struct({
              pairCount: A.uint16,
              correspondence: new A.Array(ea, "pairCount")
            });
            var OB = new A.Struct({
              version: A.fixed32,
              axisCount: A.uint32,
              segment: new A.Array(jB, "axisCount")
            });
            class JB {
              getItem(i) {
                if (this._items[i] == null) {
                  let u = this.stream.pos;
                  this.stream.pos = this.base + this.type.size(null, this.parent) * i, this._items[i] = this.type.decode(this.stream, this.parent), this.stream.pos = u;
                }
                return this._items[i];
              }
              inspect() {
                return `[UnboundedArray ${this.type.constructor.name}]`;
              }
              constructor(i, u, m) {
                this.type = i, this.stream = u, this.parent = m, this.base = this.stream.pos, this._items = [];
              }
            }
            class En extends A.Array {
              decode(i, u) {
                return new JB(this.type, i, u);
              }
              constructor(i) {
                super(i, 0);
              }
            }
            let Nn = function(BA = A.uint16) {
              class i {
                decode(PA, VA) {
                  return VA = VA.parent.parent, this.type.decode(PA, VA);
                }
                size(PA, VA) {
                  return VA = VA.parent.parent, this.type.size(PA, VA);
                }
                encode(PA, VA, te) {
                  return te = te.parent.parent, this.type.encode(PA, VA, te);
                }
                constructor(PA) {
                  this.type = PA;
                }
              }
              BA = new i(BA);
              let u = new A.Struct({
                unitSize: A.uint16,
                nUnits: A.uint16,
                searchRange: A.uint16,
                entrySelector: A.uint16,
                rangeShift: A.uint16
              }), m = new A.Struct({
                lastGlyph: A.uint16,
                firstGlyph: A.uint16,
                value: BA
              }), L = new A.Struct({
                lastGlyph: A.uint16,
                firstGlyph: A.uint16,
                values: new A.Pointer(A.uint16, new A.Array(BA, (O) => O.lastGlyph - O.firstGlyph + 1), {
                  type: "parent"
                })
              }), Z = new A.Struct({
                glyph: A.uint16,
                value: BA
              });
              return new A.VersionedStruct(A.uint16, {
                0: {
                  values: new En(BA)
                  // length == number of glyphs maybe?
                },
                2: {
                  binarySearchHeader: u,
                  segments: new A.Array(m, (O) => O.binarySearchHeader.nUnits)
                },
                4: {
                  binarySearchHeader: u,
                  segments: new A.Array(L, (O) => O.binarySearchHeader.nUnits)
                },
                6: {
                  binarySearchHeader: u,
                  segments: new A.Array(Z, (O) => O.binarySearchHeader.nUnits)
                },
                8: {
                  firstGlyph: A.uint16,
                  count: A.uint16,
                  values: new A.Array(BA, "count")
                }
              });
            };
            function ls(BA = {}, i = A.uint16) {
              let u = Object.assign({
                newState: A.uint16,
                flags: A.uint16
              }, BA), m = new A.Struct(u), L = new En(new A.Array(A.uint16, (O) => O.nClasses));
              return new A.Struct({
                nClasses: A.uint32,
                classTable: new A.Pointer(A.uint32, new Nn(i)),
                stateArray: new A.Pointer(A.uint32, L),
                entryTable: new A.Pointer(A.uint32, new En(m))
              });
            }
            function KB(BA = {}, i = A.uint16) {
              let u = new A.Struct({
                version() {
                  return 8;
                },
                firstGlyph: A.uint16,
                values: new A.Array(A.uint8, A.uint16)
              }), m = Object.assign({
                newStateOffset: A.uint16,
                // convert offset to stateArray index
                newState: (PA) => (PA.newStateOffset - (PA.parent.stateArray.base - PA.parent._startOffset)) / PA.parent.nClasses,
                flags: A.uint16
              }, BA), L = new A.Struct(m), Z = new En(new A.Array(A.uint8, (PA) => PA.nClasses));
              return new A.Struct({
                nClasses: A.uint16,
                classTable: new A.Pointer(A.uint16, u),
                stateArray: new A.Pointer(A.uint16, Z),
                entryTable: new A.Pointer(A.uint16, new En(L))
              });
            }
            let WB = new A.VersionedStruct("format", {
              0: {
                deltas: new A.Array(A.int16, 32)
              },
              1: {
                deltas: new A.Array(A.int16, 32),
                mappingData: new Nn(A.uint16)
              },
              2: {
                standardGlyph: A.uint16,
                controlPoints: new A.Array(A.uint16, 32)
              },
              3: {
                standardGlyph: A.uint16,
                controlPoints: new A.Array(A.uint16, 32),
                mappingData: new Nn(A.uint16)
              }
            });
            var VB = new A.Struct({
              version: A.fixed32,
              format: A.uint16,
              defaultBaseline: A.uint16,
              subtable: WB
            });
            let XB = new A.Struct({
              setting: A.uint16,
              nameIndex: A.int16,
              name: (BA) => BA.parent.parent.parent.name.records.fontFeatures[BA.nameIndex]
            }), ZB = new A.Struct({
              feature: A.uint16,
              nSettings: A.uint16,
              settingTable: new A.Pointer(A.uint32, new A.Array(XB, "nSettings"), {
                type: "parent"
              }),
              featureFlags: new A.Bitfield(A.uint8, [
                null,
                null,
                null,
                null,
                null,
                null,
                "hasDefault",
                "exclusive"
              ]),
              defaultSetting: A.uint8,
              nameIndex: A.int16,
              name: (BA) => BA.parent.parent.name.records.fontFeatures[BA.nameIndex]
            });
            var qB = new A.Struct({
              version: A.fixed32,
              featureNameCount: A.uint16,
              reserved1: new A.Reserved(A.uint16),
              reserved2: new A.Reserved(A.uint32),
              featureNames: new A.Array(ZB, "featureNameCount")
            });
            let _B = new A.Struct({
              axisTag: new A.String(4),
              minValue: A.fixed32,
              defaultValue: A.fixed32,
              maxValue: A.fixed32,
              flags: A.uint16,
              nameID: A.uint16,
              name: (BA) => BA.parent.parent.name.records.fontFeatures[BA.nameID]
            }), $B = new A.Struct({
              nameID: A.uint16,
              name: (BA) => BA.parent.parent.name.records.fontFeatures[BA.nameID],
              flags: A.uint16,
              coord: new A.Array(A.fixed32, (BA) => BA.parent.axisCount),
              postscriptNameID: new A.Optional(A.uint16, (BA) => BA.parent.instanceSize - BA._currentOffset > 0)
            });
            var Ag = new A.Struct({
              version: A.fixed32,
              offsetToData: A.uint16,
              countSizePairs: A.uint16,
              axisCount: A.uint16,
              axisSize: A.uint16,
              instanceCount: A.uint16,
              instanceSize: A.uint16,
              axis: new A.Array(_B, "axisCount"),
              instance: new A.Array($B, "instanceCount")
            });
            let eg = new A.Fixed(16, "BE", 14);
            class tg {
              static decode(i, u) {
                return u.flags ? i.readUInt32BE() : i.readUInt16BE() * 2;
              }
            }
            var ig = new A.Struct({
              version: A.uint16,
              reserved: new A.Reserved(A.uint16),
              axisCount: A.uint16,
              globalCoordCount: A.uint16,
              globalCoords: new A.Pointer(A.uint32, new A.Array(new A.Array(eg, "axisCount"), "globalCoordCount")),
              glyphCount: A.uint16,
              flags: A.uint16,
              offsetToData: A.uint32,
              offsets: new A.Array(new A.Pointer(tg, "void", {
                relativeTo: (BA) => BA.offsetToData,
                allowNull: !1
              }), (BA) => BA.glyphCount + 1)
            });
            let ng = new A.Struct({
              length: A.uint16,
              coverage: A.uint16,
              subFeatureFlags: A.uint32,
              stateTable: new KB()
            }), rg = new A.Struct({
              justClass: A.uint32,
              beforeGrowLimit: A.fixed32,
              beforeShrinkLimit: A.fixed32,
              afterGrowLimit: A.fixed32,
              afterShrinkLimit: A.fixed32,
              growFlags: A.uint16,
              shrinkFlags: A.uint16
            }), sg = new A.Array(rg, A.uint32), ag = new A.VersionedStruct("actionType", {
              0: {
                lowerLimit: A.fixed32,
                upperLimit: A.fixed32,
                order: A.uint16,
                glyphs: new A.Array(A.uint16, A.uint16)
              },
              1: {
                addGlyph: A.uint16
              },
              2: {
                substThreshold: A.fixed32,
                addGlyph: A.uint16,
                substGlyph: A.uint16
              },
              3: {},
              4: {
                variationAxis: A.uint32,
                minimumLimit: A.fixed32,
                noStretchValue: A.fixed32,
                maximumLimit: A.fixed32
              },
              5: {
                flags: A.uint16,
                glyph: A.uint16
              }
            }), og = new A.Struct({
              actionClass: A.uint16,
              actionType: A.uint16,
              actionLength: A.uint32,
              actionData: ag,
              padding: new A.Reserved(A.uint8, (BA) => BA.actionLength - BA._currentOffset)
            }), Bg = new A.Array(og, A.uint32), gg = new A.Struct({
              lookupTable: new Nn(new A.Pointer(A.uint16, Bg))
            }), ja = new A.Struct({
              classTable: new A.Pointer(A.uint16, ng, {
                type: "parent"
              }),
              wdcOffset: A.uint16,
              postCompensationTable: new A.Pointer(A.uint16, gg, {
                type: "parent"
              }),
              widthDeltaClusters: new Nn(new A.Pointer(A.uint16, sg, {
                type: "parent",
                relativeTo: (BA) => BA.wdcOffset
              }))
            });
            var cg = new A.Struct({
              version: A.uint32,
              format: A.uint16,
              horizontal: new A.Pointer(A.uint16, ja),
              vertical: new A.Pointer(A.uint16, ja)
            });
            let lg = {
              action: A.uint16
            }, Eg = {
              markIndex: A.uint16,
              currentIndex: A.uint16
            }, wg = {
              currentInsertIndex: A.uint16,
              markedInsertIndex: A.uint16
            }, ug = new A.Struct({
              items: new En(new A.Pointer(A.uint32, new Nn()))
            }), fg = new A.VersionedStruct("type", {
              0: {
                stateTable: new ls()
              },
              1: {
                stateTable: new ls(Eg),
                substitutionTable: new A.Pointer(A.uint32, ug)
              },
              2: {
                stateTable: new ls(lg),
                ligatureActions: new A.Pointer(A.uint32, new En(A.uint32)),
                components: new A.Pointer(A.uint32, new En(A.uint16)),
                ligatureList: new A.Pointer(A.uint32, new En(A.uint16))
              },
              4: {
                lookupTable: new Nn()
              },
              5: {
                stateTable: new ls(wg),
                insertionActions: new A.Pointer(A.uint32, new En(A.uint16))
              }
            }), Qg = new A.Struct({
              length: A.uint32,
              coverage: A.uint24,
              type: A.uint8,
              subFeatureFlags: A.uint32,
              table: fg,
              padding: new A.Reserved(A.uint8, (BA) => BA.length - BA._currentOffset)
            }), hg = new A.Struct({
              featureType: A.uint16,
              featureSetting: A.uint16,
              enableFlags: A.uint32,
              disableFlags: A.uint32
            }), Cg = new A.Struct({
              defaultFlags: A.uint32,
              chainLength: A.uint32,
              nFeatureEntries: A.uint32,
              nSubtables: A.uint32,
              features: new A.Array(hg, "nFeatureEntries"),
              subtables: new A.Array(Qg, "nSubtables")
            });
            var Mg = new A.Struct({
              version: A.uint16,
              unused: new A.Reserved(A.uint16),
              nChains: A.uint32,
              chains: new A.Array(Cg, "nChains")
            });
            let Dg = new A.Struct({
              left: A.int16,
              top: A.int16,
              right: A.int16,
              bottom: A.int16
            });
            var dg = new A.Struct({
              version: A.fixed32,
              format: A.uint16,
              lookupTable: new Nn(Dg)
            });
            let Yt = {};
            var Es = Yt;
            Yt.cmap = EA, Yt.head = zA, Yt.hhea = OA, Yt.hmtx = LA, Yt.maxp = yA, Yt.name = bA, Yt["OS/2"] = dA, Yt.post = he, Yt.fpgm = KA, Yt.loca = Je, Yt.prep = Le, Yt["cvt "] = ie, Yt.glyf = Re, Yt["CFF "] = ri, Yt.CFF2 = ri, Yt.VORG = Pi, Yt.EBLC = nn, Yt.CBLC = Yt.EBLC, Yt.sbix = rn, Yt.COLR = zr, Yt.CPAL = nr, Yt.BASE = Gr, Yt.GDEF = Lr, Yt.GPOS = gA, Yt.GSUB = ye, Yt.JSTF = iA, Yt.HVAR = pe, Yt.DSIG = ke, Yt.gasp = Xe, Yt.hdmx = Oe, Yt.kern = Gt, Yt.LTSH = ct, Yt.PCLT = jt, Yt.VDMX = Oi, Yt.vhea = xn, Yt.vmtx = Wn, Yt.avar = OB, Yt.bsln = VB, Yt.feat = qB, Yt.fvar = Ag, Yt.gvar = ig, Yt.just = cg, Yt.morx = Mg, Yt.opbd = dg;
            let Ig = new A.Struct({
              tag: new A.String(4),
              checkSum: A.uint32,
              offset: new A.Pointer(A.uint32, "void", {
                type: "global"
              }),
              length: A.uint32
            }), ta = new A.Struct({
              tag: new A.String(4),
              numTables: A.uint16,
              searchRange: A.uint16,
              entrySelector: A.uint16,
              rangeShift: A.uint16,
              tables: new A.Array(Ig, "numTables")
            });
            ta.process = function() {
              let BA = {};
              for (let i of this.tables) BA[i.tag] = i;
              this.tables = BA;
            }, ta.preEncode = function() {
              if (!Array.isArray(this.tables)) {
                let u = [];
                for (let m in this.tables) {
                  let L = this.tables[m];
                  L && u.push({
                    tag: m,
                    checkSum: 0,
                    offset: new A.VoidPointer(Es[m], L),
                    length: Es[m].size(L)
                  });
                }
                this.tables = u;
              }
              this.tag = "true", this.numTables = this.tables.length;
              let BA = Math.floor(Math.log(this.numTables) / Math.LN2), i = Math.pow(2, BA);
              this.searchRange = i * 16, this.entrySelector = Math.log(i) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
            };
            var Oa = ta;
            function ws(BA, i) {
              let u = 0, m = BA.length - 1;
              for (; u <= m; ) {
                let L = u + m >> 1, Z = i(BA[L]);
                if (Z < 0) m = L - 1;
                else if (Z > 0) u = L + 1;
                else return L;
              }
              return -1;
            }
            function lr(BA, i) {
              let u = [];
              for (; BA < i; ) u.push(BA++);
              return u;
            }
            const us = new TextDecoder("ascii"), Ja = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Vr = new Uint8Array(256);
            for (let BA = 0; BA < Ja.length; BA++) Vr[Ja.charCodeAt(BA)] = BA;
            function ia(BA) {
              let i = BA.length * 0.75;
              BA[BA.length - 1] === "=" && (i--, BA[BA.length - 2] === "=" && i--);
              let u = new Uint8Array(i), m = 0;
              for (let L = 0, Z = BA.length; L < Z; L += 4) {
                let O = Vr[BA.charCodeAt(L)], PA = Vr[BA.charCodeAt(L + 1)], VA = Vr[BA.charCodeAt(L + 2)], te = Vr[BA.charCodeAt(L + 3)];
                u[m++] = O << 2 | PA >> 4, u[m++] = (PA & 15) << 4 | VA >> 2, u[m++] = (VA & 3) << 6 | te & 63;
              }
              return u;
            }
            class na {
              findSubtable(i, u) {
                for (let [m, L] of u) for (let Z of i.tables)
                  if (Z.platformID === m && Z.encodingID === L) return Z.table;
                return null;
              }
              lookup(i, u) {
                if (this.encoding) i = this.encoding.get(i) || i;
                else if (u) {
                  let L = this.getVariationSelector(i, u);
                  if (L) return L;
                }
                let m = this.cmap;
                switch (m.version) {
                  case 0:
                    return m.codeMap.get(i) || 0;
                  case 4: {
                    let L = 0, Z = m.segCount - 1;
                    for (; L <= Z; ) {
                      let O = L + Z >> 1;
                      if (i < m.startCode.get(O)) Z = O - 1;
                      else if (i > m.endCode.get(O)) L = O + 1;
                      else {
                        let PA = m.idRangeOffset.get(O), VA;
                        if (PA === 0) VA = i + m.idDelta.get(O);
                        else {
                          let te = PA / 2 + (i - m.startCode.get(O)) - (m.segCount - O);
                          VA = m.glyphIndexArray.get(te) || 0, VA !== 0 && (VA += m.idDelta.get(O));
                        }
                        return VA & 65535;
                      }
                    }
                    return 0;
                  }
                  case 8:
                    throw new Error("TODO: cmap format 8");
                  case 6:
                  case 10:
                    return m.glyphIndices.get(i - m.firstCode) || 0;
                  case 12:
                  case 13: {
                    let L = 0, Z = m.nGroups - 1;
                    for (; L <= Z; ) {
                      let O = L + Z >> 1, PA = m.groups.get(O);
                      if (i < PA.startCharCode) Z = O - 1;
                      else if (i > PA.endCharCode) L = O + 1;
                      else
                        return m.version === 12 ? PA.glyphID + (i - PA.startCharCode) : PA.glyphID;
                    }
                    return 0;
                  }
                  case 14:
                    throw new Error("TODO: cmap format 14");
                  default:
                    throw new Error(`Unknown cmap format ${m.version}`);
                }
              }
              getVariationSelector(i, u) {
                if (!this.uvs) return 0;
                let m = this.uvs.varSelectors.toArray(), L = ws(m, (O) => u - O.varSelector), Z = m[L];
                return L !== -1 && Z.defaultUVS && (L = ws(Z.defaultUVS, (O) => i < O.startUnicodeValue ? -1 : i > O.startUnicodeValue + O.additionalCount ? 1 : 0)), L !== -1 && Z.nonDefaultUVS && (L = ws(Z.nonDefaultUVS, (O) => i - O.unicodeValue), L !== -1) ? Z.nonDefaultUVS[L].glyphID : 0;
              }
              getCharacterSet() {
                let i = this.cmap;
                switch (i.version) {
                  case 0:
                    return lr(0, i.codeMap.length);
                  case 4: {
                    let u = [], m = i.endCode.toArray();
                    for (let L = 0; L < m.length; L++) {
                      let Z = m[L] + 1, O = i.startCode.get(L);
                      u.push(...lr(O, Z));
                    }
                    return u;
                  }
                  case 8:
                    throw new Error("TODO: cmap format 8");
                  case 6:
                  case 10:
                    return lr(i.firstCode, i.firstCode + i.glyphIndices.length);
                  case 12:
                  case 13: {
                    let u = [];
                    for (let m of i.groups.toArray()) u.push(...lr(m.startCharCode, m.endCharCode + 1));
                    return u;
                  }
                  case 14:
                    throw new Error("TODO: cmap format 14");
                  default:
                    throw new Error(`Unknown cmap format ${i.version}`);
                }
              }
              codePointsForGlyph(i) {
                let u = this.cmap;
                switch (u.version) {
                  case 0: {
                    let L = [];
                    for (let Z = 0; Z < 256; Z++) u.codeMap.get(Z) === i && L.push(Z);
                    return L;
                  }
                  case 4: {
                    let L = [];
                    for (let Z = 0; Z < u.segCount; Z++) {
                      let O = u.endCode.get(Z), PA = u.startCode.get(Z), VA = u.idRangeOffset.get(Z), te = u.idDelta.get(Z);
                      for (var m = PA; m <= O; m++) {
                        let ce = 0;
                        if (VA === 0) ce = m + te;
                        else {
                          let ge = VA / 2 + (m - PA) - (u.segCount - Z);
                          ce = u.glyphIndexArray.get(ge) || 0, ce !== 0 && (ce += te);
                        }
                        ce === i && L.push(m);
                      }
                    }
                    return L;
                  }
                  case 12: {
                    let L = [];
                    for (let Z of u.groups.toArray()) i >= Z.glyphID && i <= Z.glyphID + (Z.endCharCode - Z.startCharCode) && L.push(Z.startCharCode + (i - Z.glyphID));
                    return L;
                  }
                  case 13: {
                    let L = [];
                    for (let Z of u.groups.toArray()) i === Z.glyphID && L.push(...lr(Z.startCharCode, Z.endCharCode + 1));
                    return L;
                  }
                  default:
                    throw new Error(`Unknown cmap format ${u.version}`);
                }
              }
              constructor(i) {
                if (this.encoding = null, this.cmap = this.findSubtable(i, [
                  // 32-bit subtables
                  [
                    3,
                    10
                  ],
                  [
                    0,
                    6
                  ],
                  [
                    0,
                    4
                  ],
                  // 16-bit subtables
                  [
                    3,
                    1
                  ],
                  [
                    0,
                    3
                  ],
                  [
                    0,
                    2
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ]
                ]), !this.cmap) for (let u of i.tables) {
                  let m = TA(u.platformID, u.encodingID, u.table.language - 1), L = o(m);
                  L && (this.cmap = u.table, this.encoding = L);
                }
                if (!this.cmap) throw new Error("Could not find a supported cmap table");
                this.uvs = this.findSubtable(i, [
                  [
                    0,
                    5
                  ]
                ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
              }
            }
            (0, d._)([
              uA
            ], na.prototype, "getCharacterSet", null), (0, d._)([
              uA
            ], na.prototype, "codePointsForGlyph", null);
            class yg {
              process(i, u) {
                for (let m = 0; m < i.length - 1; m++) {
                  let L = i[m].id, Z = i[m + 1].id;
                  u[m].xAdvance += this.getKerning(L, Z);
                }
              }
              getKerning(i, u) {
                let m = 0;
                for (let L of this.kern.tables) {
                  if (L.coverage.crossStream) continue;
                  switch (L.version) {
                    case 0:
                      if (!L.coverage.horizontal) continue;
                      break;
                    case 1:
                      if (L.coverage.vertical || L.coverage.variation) continue;
                      break;
                    default:
                      throw new Error(`Unsupported kerning table version ${L.version}`);
                  }
                  let Z = 0, O = L.subtable;
                  switch (L.format) {
                    case 0:
                      let PA = ws(O.pairs, function(ge) {
                        return i - ge.left || u - ge.right;
                      });
                      PA >= 0 && (Z = O.pairs[PA].value);
                      break;
                    case 2:
                      let VA = 0, te = 0;
                      i >= O.leftTable.firstGlyph && i < O.leftTable.firstGlyph + O.leftTable.nGlyphs ? VA = O.leftTable.offsets[i - O.leftTable.firstGlyph] : VA = O.array.off, u >= O.rightTable.firstGlyph && u < O.rightTable.firstGlyph + O.rightTable.nGlyphs && (te = O.rightTable.offsets[u - O.rightTable.firstGlyph]);
                      let ce = (VA + te - O.array.off) / 2;
                      Z = O.array.values.get(ce);
                      break;
                    case 3:
                      if (i >= O.glyphCount || u >= O.glyphCount) return 0;
                      Z = O.kernValue[O.kernIndex[O.leftClass[i] * O.rightClassCount + O.rightClass[u]]];
                      break;
                    default:
                      throw new Error(`Unsupported kerning sub-table format ${L.format}`);
                  }
                  L.coverage.override ? m = Z : m += Z;
                }
                return m;
              }
              constructor(i) {
                this.kern = i.kern;
              }
            }
            class Fg {
              positionGlyphs(i, u) {
                let m = 0, L = 0;
                for (let Z = 0; Z < i.length; Z++)
                  i[Z].isMark ? L = Z : (m !== L && this.positionCluster(i, u, m, L), m = L = Z);
                return m !== L && this.positionCluster(i, u, m, L), u;
              }
              positionCluster(i, u, m, L) {
                let Z = i[m], O = Z.cbox.copy();
                Z.codePoints.length > 1 && (O.minX += (Z.codePoints.length - 1) * O.width / Z.codePoints.length);
                let PA = -u[m].xAdvance, VA = 0, te = this.font.unitsPerEm / 16;
                for (let ce = m + 1; ce <= L; ce++) {
                  let ge = i[ce], Ge = ge.cbox, nt = u[ce], ot = this.getCombiningClass(ge.codePoints[0]);
                  if (ot !== "Not_Reordered") {
                    switch (nt.xOffset = nt.yOffset = 0, ot) {
                      case "Double_Above":
                      case "Double_Below":
                        nt.xOffset += O.minX - Ge.width / 2 - Ge.minX;
                        break;
                      case "Attached_Below_Left":
                      case "Below_Left":
                      case "Above_Left":
                        nt.xOffset += O.minX - Ge.minX;
                        break;
                      case "Attached_Above_Right":
                      case "Below_Right":
                      case "Above_Right":
                        nt.xOffset += O.maxX - Ge.width - Ge.minX;
                        break;
                      default:
                        nt.xOffset += O.minX + (O.width - Ge.width) / 2 - Ge.minX;
                    }
                    switch (ot) {
                      case "Double_Below":
                      case "Below_Left":
                      case "Below":
                      case "Below_Right":
                      case "Attached_Below_Left":
                      case "Attached_Below":
                        (ot === "Attached_Below_Left" || ot === "Attached_Below") && (O.minY += te), nt.yOffset = -O.minY - Ge.maxY, O.minY += Ge.height;
                        break;
                      case "Double_Above":
                      case "Above_Left":
                      case "Above":
                      case "Above_Right":
                      case "Attached_Above":
                      case "Attached_Above_Right":
                        (ot === "Attached_Above" || ot === "Attached_Above_Right") && (O.maxY += te), nt.yOffset = O.maxY - Ge.minY, O.maxY += Ge.height;
                        break;
                    }
                    nt.xAdvance = nt.yAdvance = 0, nt.xOffset += PA, nt.yOffset += VA;
                  } else
                    PA -= nt.xAdvance, VA -= nt.yAdvance;
                }
              }
              getCombiningClass(i) {
                let u = (0, U.getCombiningClass)(i);
                if ((i & -256) === 3584) {
                  if (u === "Not_Reordered") switch (i) {
                    case 3633:
                    case 3636:
                    case 3637:
                    case 3638:
                    case 3639:
                    case 3655:
                    case 3660:
                    case 3645:
                    case 3662:
                      return "Above_Right";
                    case 3761:
                    case 3764:
                    case 3765:
                    case 3766:
                    case 3767:
                    case 3771:
                    case 3788:
                    case 3789:
                      return "Above";
                    case 3772:
                      return "Below";
                  }
                  else if (i === 3642) return "Below_Right";
                }
                switch (u) {
                  // Hebrew
                  case "CCC10":
                  case "CCC11":
                  case "CCC12":
                  case "CCC13":
                  case "CCC14":
                  case "CCC15":
                  case "CCC16":
                  case "CCC17":
                  case "CCC18":
                  case "CCC20":
                  case "CCC22":
                    return "Below";
                  case "CCC23":
                    return "Attached_Above";
                  case "CCC24":
                    return "Above_Right";
                  case "CCC25":
                  case "CCC19":
                    return "Above_Left";
                  case "CCC26":
                    return "Above";
                  case "CCC21":
                    break;
                  // Arabic and Syriac
                  case "CCC27":
                  case "CCC28":
                  case "CCC30":
                  case "CCC31":
                  case "CCC33":
                  case "CCC34":
                  case "CCC35":
                  case "CCC36":
                    return "Above";
                  case "CCC29":
                  case "CCC32":
                    return "Below";
                  // Thai
                  case "CCC103":
                    return "Below_Right";
                  case "CCC107":
                    return "Above_Right";
                  // Lao
                  case "CCC118":
                    return "Below";
                  case "CCC122":
                    return "Above";
                  // Tibetan
                  case "CCC129":
                  case "CCC132":
                    return "Below";
                  case "CCC130":
                    return "Above";
                }
                return u;
              }
              constructor(i) {
                this.font = i;
              }
            }
            class Rn {
              /**
              * The width of the bounding box
              * @type {number}
              */
              get width() {
                return this.maxX - this.minX;
              }
              /**
              * The height of the bounding box
              * @type {number}
              */
              get height() {
                return this.maxY - this.minY;
              }
              addPoint(i, u) {
                Math.abs(i) !== 1 / 0 && (i < this.minX && (this.minX = i), i > this.maxX && (this.maxX = i)), Math.abs(u) !== 1 / 0 && (u < this.minY && (this.minY = u), u > this.maxY && (this.maxY = u));
              }
              copy() {
                return new Rn(this.minX, this.minY, this.maxX, this.maxY);
              }
              constructor(i = 1 / 0, u = 1 / 0, m = -1 / 0, L = -1 / 0) {
                this.minX = i, this.minY = u, this.maxX = m, this.maxY = L;
              }
            }
            const Er = {
              Caucasian_Albanian: "aghb",
              Arabic: "arab",
              Imperial_Aramaic: "armi",
              Armenian: "armn",
              Avestan: "avst",
              Balinese: "bali",
              Bamum: "bamu",
              Bassa_Vah: "bass",
              Batak: "batk",
              Bengali: [
                "bng2",
                "beng"
              ],
              Bopomofo: "bopo",
              Brahmi: "brah",
              Braille: "brai",
              Buginese: "bugi",
              Buhid: "buhd",
              Chakma: "cakm",
              Canadian_Aboriginal: "cans",
              Carian: "cari",
              Cham: "cham",
              Cherokee: "cher",
              Coptic: "copt",
              Cypriot: "cprt",
              Cyrillic: "cyrl",
              Devanagari: [
                "dev2",
                "deva"
              ],
              Deseret: "dsrt",
              Duployan: "dupl",
              Egyptian_Hieroglyphs: "egyp",
              Elbasan: "elba",
              Ethiopic: "ethi",
              Georgian: "geor",
              Glagolitic: "glag",
              Gothic: "goth",
              Grantha: "gran",
              Greek: "grek",
              Gujarati: [
                "gjr2",
                "gujr"
              ],
              Gurmukhi: [
                "gur2",
                "guru"
              ],
              Hangul: "hang",
              Han: "hani",
              Hanunoo: "hano",
              Hebrew: "hebr",
              Hiragana: "hira",
              Pahawh_Hmong: "hmng",
              Katakana_Or_Hiragana: "hrkt",
              Old_Italic: "ital",
              Javanese: "java",
              Kayah_Li: "kali",
              Katakana: "kana",
              Kharoshthi: "khar",
              Khmer: "khmr",
              Khojki: "khoj",
              Kannada: [
                "knd2",
                "knda"
              ],
              Kaithi: "kthi",
              Tai_Tham: "lana",
              Lao: "lao ",
              Latin: "latn",
              Lepcha: "lepc",
              Limbu: "limb",
              Linear_A: "lina",
              Linear_B: "linb",
              Lisu: "lisu",
              Lycian: "lyci",
              Lydian: "lydi",
              Mahajani: "mahj",
              Mandaic: "mand",
              Manichaean: "mani",
              Mende_Kikakui: "mend",
              Meroitic_Cursive: "merc",
              Meroitic_Hieroglyphs: "mero",
              Malayalam: [
                "mlm2",
                "mlym"
              ],
              Modi: "modi",
              Mongolian: "mong",
              Mro: "mroo",
              Meetei_Mayek: "mtei",
              Myanmar: [
                "mym2",
                "mymr"
              ],
              Old_North_Arabian: "narb",
              Nabataean: "nbat",
              Nko: "nko ",
              Ogham: "ogam",
              Ol_Chiki: "olck",
              Old_Turkic: "orkh",
              Oriya: [
                "ory2",
                "orya"
              ],
              Osmanya: "osma",
              Palmyrene: "palm",
              Pau_Cin_Hau: "pauc",
              Old_Permic: "perm",
              Phags_Pa: "phag",
              Inscriptional_Pahlavi: "phli",
              Psalter_Pahlavi: "phlp",
              Phoenician: "phnx",
              Miao: "plrd",
              Inscriptional_Parthian: "prti",
              Rejang: "rjng",
              Runic: "runr",
              Samaritan: "samr",
              Old_South_Arabian: "sarb",
              Saurashtra: "saur",
              Shavian: "shaw",
              Sharada: "shrd",
              Siddham: "sidd",
              Khudawadi: "sind",
              Sinhala: "sinh",
              Sora_Sompeng: "sora",
              Sundanese: "sund",
              Syloti_Nagri: "sylo",
              Syriac: "syrc",
              Tagbanwa: "tagb",
              Takri: "takr",
              Tai_Le: "tale",
              New_Tai_Lue: "talu",
              Tamil: [
                "tml2",
                "taml"
              ],
              Tai_Viet: "tavt",
              Telugu: [
                "tel2",
                "telu"
              ],
              Tifinagh: "tfng",
              Tagalog: "tglg",
              Thaana: "thaa",
              Thai: "thai",
              Tibetan: "tibt",
              Tirhuta: "tirh",
              Ugaritic: "ugar",
              Vai: "vai ",
              Warang_Citi: "wara",
              Old_Persian: "xpeo",
              Cuneiform: "xsux",
              Yi: "yi  ",
              Inherited: "zinh",
              Common: "zyyy",
              Unknown: "zzzz"
            }, ra = {};
            for (let BA in Er) {
              let i = Er[BA];
              if (Array.isArray(i)) for (let u of i) ra[u] = BA;
              else ra[i] = BA;
            }
            function xg(BA) {
              return ra[BA];
            }
            function pg(BA) {
              let i = BA.length, u = 0;
              for (; u < i; ) {
                let m = BA.charCodeAt(u++);
                if (55296 <= m && m <= 56319 && u < i) {
                  let Z = BA.charCodeAt(u);
                  56320 <= Z && Z <= 57343 && (u++, m = ((m & 1023) << 10) + (Z & 1023) + 65536);
                }
                let L = (0, U.getScript)(m);
                if (L !== "Common" && L !== "Inherited" && L !== "Unknown") return Er[L];
              }
              return Er.Unknown;
            }
            function mg(BA) {
              for (let i = 0; i < BA.length; i++) {
                let u = BA[i], m = (0, U.getScript)(u);
                if (m !== "Common" && m !== "Inherited" && m !== "Unknown") return Er[m];
              }
              return Er.Unknown;
            }
            const Yg = {
              arab: !0,
              hebr: !0,
              syrc: !0,
              thaa: !0,
              cprt: !0,
              khar: !0,
              phnx: !0,
              "nko ": !0,
              lydi: !0,
              avst: !0,
              armi: !0,
              phli: !0,
              prti: !0,
              sarb: !0,
              orkh: !0,
              samr: !0,
              mand: !0,
              merc: !0,
              mero: !0,
              // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
              mani: !0,
              mend: !0,
              nbat: !0,
              narb: !0,
              palm: !0,
              phlp: !0
              // Psalter Pahlavi
            };
            function Ka(BA) {
              return Yg[BA] ? "rtl" : "ltr";
            }
            class Pg {
              /**
              * The total advance width of the run.
              * @type {number}
              */
              get advanceWidth() {
                let i = 0;
                for (let u of this.positions) i += u.xAdvance;
                return i;
              }
              /**
              * The total advance height of the run.
              * @type {number}
              */
              get advanceHeight() {
                let i = 0;
                for (let u of this.positions) i += u.yAdvance;
                return i;
              }
              /**
              * The bounding box containing all glyphs in the run.
              * @type {BBox}
              */
              get bbox() {
                let i = new Rn(), u = 0, m = 0;
                for (let L = 0; L < this.glyphs.length; L++) {
                  let Z = this.glyphs[L], O = this.positions[L], PA = Z.bbox;
                  i.addPoint(PA.minX + u + O.xOffset, PA.minY + m + O.yOffset), i.addPoint(PA.maxX + u + O.xOffset, PA.maxY + m + O.yOffset), u += O.xAdvance, m += O.yAdvance;
                }
                return i;
              }
              constructor(i, u, m, L, Z) {
                if (this.glyphs = i, this.positions = null, this.script = m, this.language = L || null, this.direction = Z || Ka(m), this.features = {}, Array.isArray(u)) for (let O of u) this.features[O] = !0;
                else typeof u == "object" && (this.features = u);
              }
            }
            class vg {
              constructor(i = 0, u = 0, m = 0, L = 0) {
                this.xAdvance = i, this.yAdvance = u, this.xOffset = m, this.yOffset = L;
              }
            }
            const Vn = {
              allTypographicFeatures: {
                code: 0,
                exclusive: !1,
                allTypeFeatures: 0
              },
              ligatures: {
                code: 1,
                exclusive: !1,
                requiredLigatures: 0,
                commonLigatures: 2,
                rareLigatures: 4,
                // logos: 6
                rebusPictures: 8,
                diphthongLigatures: 10,
                squaredLigatures: 12,
                abbrevSquaredLigatures: 14,
                symbolLigatures: 16,
                contextualLigatures: 18,
                historicalLigatures: 20
              },
              cursiveConnection: {
                code: 2,
                exclusive: !0,
                unconnected: 0,
                partiallyConnected: 1,
                cursive: 2
              },
              letterCase: {
                code: 3,
                exclusive: !0
              },
              // upperAndLowerCase: 0          # deprecated
              // allCaps: 1                    # deprecated
              // allLowerCase: 2               # deprecated
              // smallCaps: 3                  # deprecated
              // initialCaps: 4                # deprecated
              // initialCapsAndSmallCaps: 5    # deprecated
              verticalSubstitution: {
                code: 4,
                exclusive: !1,
                substituteVerticalForms: 0
              },
              linguisticRearrangement: {
                code: 5,
                exclusive: !1,
                linguisticRearrangement: 0
              },
              numberSpacing: {
                code: 6,
                exclusive: !0,
                monospacedNumbers: 0,
                proportionalNumbers: 1,
                thirdWidthNumbers: 2,
                quarterWidthNumbers: 3
              },
              smartSwash: {
                code: 8,
                exclusive: !1,
                wordInitialSwashes: 0,
                wordFinalSwashes: 2,
                // lineInitialSwashes: 4
                // lineFinalSwashes: 6
                nonFinalSwashes: 8
              },
              diacritics: {
                code: 9,
                exclusive: !0,
                showDiacritics: 0,
                hideDiacritics: 1,
                decomposeDiacritics: 2
              },
              verticalPosition: {
                code: 10,
                exclusive: !0,
                normalPosition: 0,
                superiors: 1,
                inferiors: 2,
                ordinals: 3,
                scientificInferiors: 4
              },
              fractions: {
                code: 11,
                exclusive: !0,
                noFractions: 0,
                verticalFractions: 1,
                diagonalFractions: 2
              },
              overlappingCharacters: {
                code: 13,
                exclusive: !1,
                preventOverlap: 0
              },
              typographicExtras: {
                code: 14,
                exclusive: !1,
                // hyphensToEmDash: 0
                // hyphenToEnDash: 2
                slashedZero: 4
              },
              // formInterrobang: 6
              // smartQuotes: 8
              // periodsToEllipsis: 10
              mathematicalExtras: {
                code: 15,
                exclusive: !1,
                // hyphenToMinus: 0
                // asteristoMultiply: 2
                // slashToDivide: 4
                // inequalityLigatures: 6
                // exponents: 8
                mathematicalGreek: 10
              },
              ornamentSets: {
                code: 16,
                exclusive: !0,
                noOrnaments: 0,
                dingbats: 1,
                piCharacters: 2,
                fleurons: 3,
                decorativeBorders: 4,
                internationalSymbols: 5,
                mathSymbols: 6
              },
              characterAlternatives: {
                code: 17,
                exclusive: !0,
                noAlternates: 0
              },
              // user defined options
              designComplexity: {
                code: 18,
                exclusive: !0,
                designLevel1: 0,
                designLevel2: 1,
                designLevel3: 2,
                designLevel4: 3,
                designLevel5: 4
              },
              styleOptions: {
                code: 19,
                exclusive: !0,
                noStyleOptions: 0,
                displayText: 1,
                engravedText: 2,
                illuminatedCaps: 3,
                titlingCaps: 4,
                tallCaps: 5
              },
              characterShape: {
                code: 20,
                exclusive: !0,
                traditionalCharacters: 0,
                simplifiedCharacters: 1,
                JIS1978Characters: 2,
                JIS1983Characters: 3,
                JIS1990Characters: 4,
                traditionalAltOne: 5,
                traditionalAltTwo: 6,
                traditionalAltThree: 7,
                traditionalAltFour: 8,
                traditionalAltFive: 9,
                expertCharacters: 10,
                JIS2004Characters: 11,
                hojoCharacters: 12,
                NLCCharacters: 13,
                traditionalNamesCharacters: 14
              },
              numberCase: {
                code: 21,
                exclusive: !0,
                lowerCaseNumbers: 0,
                upperCaseNumbers: 1
              },
              textSpacing: {
                code: 22,
                exclusive: !0,
                proportionalText: 0,
                monospacedText: 1,
                halfWidthText: 2,
                thirdWidthText: 3,
                quarterWidthText: 4,
                altProportionalText: 5,
                altHalfWidthText: 6
              },
              transliteration: {
                code: 23,
                exclusive: !0,
                noTransliteration: 0
              },
              // hanjaToHangul: 1
              // hiraganaToKatakana: 2
              // katakanaToHiragana: 3
              // kanaToRomanization: 4
              // romanizationToHiragana: 5
              // romanizationToKatakana: 6
              // hanjaToHangulAltOne: 7
              // hanjaToHangulAltTwo: 8
              // hanjaToHangulAltThree: 9
              annotation: {
                code: 24,
                exclusive: !0,
                noAnnotation: 0,
                boxAnnotation: 1,
                roundedBoxAnnotation: 2,
                circleAnnotation: 3,
                invertedCircleAnnotation: 4,
                parenthesisAnnotation: 5,
                periodAnnotation: 6,
                romanNumeralAnnotation: 7,
                diamondAnnotation: 8,
                invertedBoxAnnotation: 9,
                invertedRoundedBoxAnnotation: 10
              },
              kanaSpacing: {
                code: 25,
                exclusive: !0,
                fullWidthKana: 0,
                proportionalKana: 1
              },
              ideographicSpacing: {
                code: 26,
                exclusive: !0,
                fullWidthIdeographs: 0,
                proportionalIdeographs: 1,
                halfWidthIdeographs: 2
              },
              unicodeDecomposition: {
                code: 27,
                exclusive: !1,
                canonicalComposition: 0,
                compatibilityComposition: 2,
                transcodingComposition: 4
              },
              rubyKana: {
                code: 28,
                exclusive: !1,
                // noRubyKana: 0     # deprecated - use rubyKanaOff instead
                // rubyKana: 1     # deprecated - use rubyKanaOn instead
                rubyKana: 2
              },
              CJKSymbolAlternatives: {
                code: 29,
                exclusive: !0,
                noCJKSymbolAlternatives: 0,
                CJKSymbolAltOne: 1,
                CJKSymbolAltTwo: 2,
                CJKSymbolAltThree: 3,
                CJKSymbolAltFour: 4,
                CJKSymbolAltFive: 5
              },
              ideographicAlternatives: {
                code: 30,
                exclusive: !0,
                noIdeographicAlternatives: 0,
                ideographicAltOne: 1,
                ideographicAltTwo: 2,
                ideographicAltThree: 3,
                ideographicAltFour: 4,
                ideographicAltFive: 5
              },
              CJKVerticalRomanPlacement: {
                code: 31,
                exclusive: !0,
                CJKVerticalRomanCentered: 0,
                CJKVerticalRomanHBaseline: 1
              },
              italicCJKRoman: {
                code: 32,
                exclusive: !1,
                // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
                // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
                CJKItalicRoman: 2
              },
              caseSensitiveLayout: {
                code: 33,
                exclusive: !1,
                caseSensitiveLayout: 0,
                caseSensitiveSpacing: 2
              },
              alternateKana: {
                code: 34,
                exclusive: !1,
                alternateHorizKana: 0,
                alternateVertKana: 2
              },
              stylisticAlternatives: {
                code: 35,
                exclusive: !1,
                noStylisticAlternates: 0,
                stylisticAltOne: 2,
                stylisticAltTwo: 4,
                stylisticAltThree: 6,
                stylisticAltFour: 8,
                stylisticAltFive: 10,
                stylisticAltSix: 12,
                stylisticAltSeven: 14,
                stylisticAltEight: 16,
                stylisticAltNine: 18,
                stylisticAltTen: 20,
                stylisticAltEleven: 22,
                stylisticAltTwelve: 24,
                stylisticAltThirteen: 26,
                stylisticAltFourteen: 28,
                stylisticAltFifteen: 30,
                stylisticAltSixteen: 32,
                stylisticAltSeventeen: 34,
                stylisticAltEighteen: 36,
                stylisticAltNineteen: 38,
                stylisticAltTwenty: 40
              },
              contextualAlternates: {
                code: 36,
                exclusive: !1,
                contextualAlternates: 0,
                swashAlternates: 2,
                contextualSwashAlternates: 4
              },
              lowerCase: {
                code: 37,
                exclusive: !0,
                defaultLowerCase: 0,
                lowerCaseSmallCaps: 1,
                lowerCasePetiteCaps: 2
              },
              upperCase: {
                code: 38,
                exclusive: !0,
                defaultUpperCase: 0,
                upperCaseSmallCaps: 1,
                upperCasePetiteCaps: 2
              },
              languageTag: {
                code: 39,
                exclusive: !0
              },
              CJKRomanSpacing: {
                code: 103,
                exclusive: !0,
                halfWidthCJKRoman: 0,
                proportionalCJKRoman: 1,
                defaultCJKRoman: 2,
                fullWidthCJKRoman: 3
              }
            }, Ve = (BA, i) => [
              Vn[BA].code,
              Vn[BA][i]
            ], fs = {
              rlig: Ve("ligatures", "requiredLigatures"),
              clig: Ve("ligatures", "contextualLigatures"),
              dlig: Ve("ligatures", "rareLigatures"),
              hlig: Ve("ligatures", "historicalLigatures"),
              liga: Ve("ligatures", "commonLigatures"),
              hist: Ve("ligatures", "historicalLigatures"),
              smcp: Ve("lowerCase", "lowerCaseSmallCaps"),
              pcap: Ve("lowerCase", "lowerCasePetiteCaps"),
              frac: Ve("fractions", "diagonalFractions"),
              dnom: Ve("fractions", "diagonalFractions"),
              numr: Ve("fractions", "diagonalFractions"),
              afrc: Ve("fractions", "verticalFractions"),
              // aalt
              // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
              // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
              // unic, vatu, vhal, vjmo, vpal, vrt2
              // dist -> trak table?
              // kern, vkrn -> kern table
              // lfbd + opbd + rtbd -> opbd table?
              // mark, mkmk -> acnt table?
              // locl -> languageTag + ltag table
              case: Ve("caseSensitiveLayout", "caseSensitiveLayout"),
              ccmp: Ve("unicodeDecomposition", "canonicalComposition"),
              cpct: Ve("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
              valt: Ve("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
              swsh: Ve("contextualAlternates", "swashAlternates"),
              cswh: Ve("contextualAlternates", "contextualSwashAlternates"),
              curs: Ve("cursiveConnection", "cursive"),
              c2pc: Ve("upperCase", "upperCasePetiteCaps"),
              c2sc: Ve("upperCase", "upperCaseSmallCaps"),
              init: Ve("smartSwash", "wordInitialSwashes"),
              fin2: Ve("smartSwash", "wordFinalSwashes"),
              medi: Ve("smartSwash", "nonFinalSwashes"),
              med2: Ve("smartSwash", "nonFinalSwashes"),
              fin3: Ve("smartSwash", "wordFinalSwashes"),
              fina: Ve("smartSwash", "wordFinalSwashes"),
              pkna: Ve("kanaSpacing", "proportionalKana"),
              half: Ve("textSpacing", "halfWidthText"),
              halt: Ve("textSpacing", "altHalfWidthText"),
              hkna: Ve("alternateKana", "alternateHorizKana"),
              vkna: Ve("alternateKana", "alternateVertKana"),
              // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
              ital: Ve("italicCJKRoman", "CJKItalicRoman"),
              lnum: Ve("numberCase", "upperCaseNumbers"),
              onum: Ve("numberCase", "lowerCaseNumbers"),
              mgrk: Ve("mathematicalExtras", "mathematicalGreek"),
              // nalt: not enough info. what type of annotation?
              // ornm: ditto, which ornament style?
              calt: Ve("contextualAlternates", "contextualAlternates"),
              vrt2: Ve("verticalSubstitution", "substituteVerticalForms"),
              vert: Ve("verticalSubstitution", "substituteVerticalForms"),
              tnum: Ve("numberSpacing", "monospacedNumbers"),
              pnum: Ve("numberSpacing", "proportionalNumbers"),
              sups: Ve("verticalPosition", "superiors"),
              subs: Ve("verticalPosition", "inferiors"),
              ordn: Ve("verticalPosition", "ordinals"),
              pwid: Ve("textSpacing", "proportionalText"),
              hwid: Ve("textSpacing", "halfWidthText"),
              qwid: Ve("textSpacing", "quarterWidthText"),
              twid: Ve("textSpacing", "thirdWidthText"),
              fwid: Ve("textSpacing", "proportionalText"),
              palt: Ve("textSpacing", "altProportionalText"),
              trad: Ve("characterShape", "traditionalCharacters"),
              smpl: Ve("characterShape", "simplifiedCharacters"),
              jp78: Ve("characterShape", "JIS1978Characters"),
              jp83: Ve("characterShape", "JIS1983Characters"),
              jp90: Ve("characterShape", "JIS1990Characters"),
              jp04: Ve("characterShape", "JIS2004Characters"),
              expt: Ve("characterShape", "expertCharacters"),
              hojo: Ve("characterShape", "hojoCharacters"),
              nlck: Ve("characterShape", "NLCCharacters"),
              tnam: Ve("characterShape", "traditionalNamesCharacters"),
              ruby: Ve("rubyKana", "rubyKana"),
              titl: Ve("styleOptions", "titlingCaps"),
              zero: Ve("typographicExtras", "slashedZero"),
              ss01: Ve("stylisticAlternatives", "stylisticAltOne"),
              ss02: Ve("stylisticAlternatives", "stylisticAltTwo"),
              ss03: Ve("stylisticAlternatives", "stylisticAltThree"),
              ss04: Ve("stylisticAlternatives", "stylisticAltFour"),
              ss05: Ve("stylisticAlternatives", "stylisticAltFive"),
              ss06: Ve("stylisticAlternatives", "stylisticAltSix"),
              ss07: Ve("stylisticAlternatives", "stylisticAltSeven"),
              ss08: Ve("stylisticAlternatives", "stylisticAltEight"),
              ss09: Ve("stylisticAlternatives", "stylisticAltNine"),
              ss10: Ve("stylisticAlternatives", "stylisticAltTen"),
              ss11: Ve("stylisticAlternatives", "stylisticAltEleven"),
              ss12: Ve("stylisticAlternatives", "stylisticAltTwelve"),
              ss13: Ve("stylisticAlternatives", "stylisticAltThirteen"),
              ss14: Ve("stylisticAlternatives", "stylisticAltFourteen"),
              ss15: Ve("stylisticAlternatives", "stylisticAltFifteen"),
              ss16: Ve("stylisticAlternatives", "stylisticAltSixteen"),
              ss17: Ve("stylisticAlternatives", "stylisticAltSeventeen"),
              ss18: Ve("stylisticAlternatives", "stylisticAltEighteen"),
              ss19: Ve("stylisticAlternatives", "stylisticAltNineteen"),
              ss20: Ve("stylisticAlternatives", "stylisticAltTwenty")
            };
            for (let BA = 1; BA <= 99; BA++) fs[`cv${`00${BA}`.slice(-2)}`] = [
              Vn.characterAlternatives.code,
              BA
            ];
            let Xn = {};
            for (let BA in fs) {
              let i = fs[BA];
              Xn[i[0]] == null && (Xn[i[0]] = {}), Xn[i[0]][i[1]] = BA;
            }
            function bg(BA) {
              let i = {};
              for (let u in BA) {
                let m;
                (m = fs[u]) && (i[m[0]] == null && (i[m[0]] = {}), i[m[0]][m[1]] = BA[u]);
              }
              return i;
            }
            function Wa(BA) {
              let [i, u] = BA;
              if (isNaN(i)) var m = Vn[i] && Vn[i].code;
              else var m = i;
              if (isNaN(u)) var L = Vn[i] && Vn[i][u];
              else var L = u;
              return [
                m,
                L
              ];
            }
            function zg(BA) {
              let i = {};
              if (Array.isArray(BA)) for (let u = 0; u < BA.length; u++) {
                let m, L = Wa(BA[u]);
                (m = Xn[L[0]] && Xn[L[0]][L[1]]) && (i[m] = !0);
              }
              else if (typeof BA == "object") for (let u in BA) {
                let m = BA[u];
                for (let L in m) {
                  let Z, O = Wa([
                    u,
                    L
                  ]);
                  m[L] && (Z = Xn[O[0]] && Xn[O[0]][O[1]]) && (i[Z] = !0);
                }
              }
              return Object.keys(i);
            }
            class Xr {
              lookup(i) {
                switch (this.table.version) {
                  case 0:
                    return this.table.values.getItem(i);
                  case 2:
                  case 4: {
                    let L = 0, Z = this.table.binarySearchHeader.nUnits - 1;
                    for (; L <= Z; ) {
                      var u = L + Z >> 1, m = this.table.segments[u];
                      if (m.firstGlyph === 65535) return null;
                      if (i < m.firstGlyph) Z = u - 1;
                      else if (i > m.lastGlyph) L = u + 1;
                      else
                        return this.table.version === 2 ? m.value : m.values[i - m.firstGlyph];
                    }
                    return null;
                  }
                  case 6: {
                    let L = 0, Z = this.table.binarySearchHeader.nUnits - 1;
                    for (; L <= Z; ) {
                      var u = L + Z >> 1, m = this.table.segments[u];
                      if (m.glyph === 65535) return null;
                      if (i < m.glyph) Z = u - 1;
                      else if (i > m.glyph) L = u + 1;
                      else return m.value;
                    }
                    return null;
                  }
                  case 8:
                    return this.table.values[i - this.table.firstGlyph];
                  default:
                    throw new Error(`Unknown lookup table format: ${this.table.version}`);
                }
              }
              glyphsForValue(i) {
                let u = [];
                switch (this.table.version) {
                  case 2:
                  case 4:
                    for (let m of this.table.segments) if (this.table.version === 2 && m.value === i) u.push(...lr(m.firstGlyph, m.lastGlyph + 1));
                    else
                      for (let L = 0; L < m.values.length; L++) m.values[L] === i && u.push(m.firstGlyph + L);
                    break;
                  case 6:
                    for (let m of this.table.segments) m.value === i && u.push(m.glyph);
                    break;
                  case 8:
                    for (let m = 0; m < this.table.values.length; m++) this.table.values[m] === i && u.push(this.table.firstGlyph + m);
                    break;
                  default:
                    throw new Error(`Unknown lookup table format: ${this.table.version}`);
                }
                return u;
              }
              constructor(i) {
                this.table = i;
              }
            }
            (0, d._)([
              uA
            ], Xr.prototype, "glyphsForValue", null);
            const Tg = 0, Va = 0, Xa = 1, Za = 2, Ug = 16384;
            class Ng {
              process(i, u, m) {
                let L = Tg, Z = u ? i.length - 1 : 0, O = u ? -1 : 1;
                for (; O === 1 && Z <= i.length || O === -1 && Z >= -1; ) {
                  let PA = null, VA = Xa, te = !0;
                  Z === i.length || Z === -1 ? VA = Va : (PA = i[Z], PA.id === 65535 ? VA = Za : (VA = this.lookupTable.lookup(PA.id), VA == null && (VA = Xa)));
                  let ge = this.stateTable.stateArray.getItem(L)[VA], Ge = this.stateTable.entryTable.getItem(ge);
                  VA !== Va && VA !== Za && (m(PA, Ge, Z), te = !(Ge.flags & Ug)), L = Ge.newState, te && (Z += O);
                }
                return i;
              }
              /**
              * Performs a depth-first traversal of the glyph strings
              * represented by the state machine.
              */
              traverse(i, u = 0, m = /* @__PURE__ */ new Set()) {
                if (m.has(u)) return;
                m.add(u);
                let { nClasses: L, stateArray: Z, entryTable: O } = this.stateTable, PA = Z.getItem(u);
                for (let VA = 4; VA < L; VA++) {
                  let te = PA[VA], ce = O.getItem(te);
                  for (let ge of this.lookupTable.glyphsForValue(VA))
                    i.enter && i.enter(ge, ce), ce.newState !== 0 && this.traverse(i, ce.newState, m), i.exit && i.exit(ge, ce);
                }
              }
              constructor(i) {
                this.stateTable = i, this.lookupTable = new Xr(i.classTable);
              }
            }
            const Rg = 32768, Sg = 8192, Gg = 15, qa = 32768, Hg = 32768, Lg = 8192, kg = 2147483648, jg = 1073741824, Og = 1073741823, _a = 4194304, Jg = 2048, Kg = 1024, Wg = 992, Vg = 31;
            class $a {
              // Processes an array of glyphs and applies the specified features
              // Features should be in the form of {featureType:{featureSetting:boolean}}
              process(i, u = {}) {
                for (let L of this.morx.chains) {
                  let Z = L.defaultFlags;
                  for (let O of L.features) {
                    let PA;
                    (PA = u[O.featureType]) && (PA[O.featureSetting] ? (Z &= O.disableFlags, Z |= O.enableFlags) : PA[O.featureSetting] === !1 && (Z |= ~O.disableFlags, Z &= ~O.enableFlags));
                  }
                  for (let O of L.subtables) O.subFeatureFlags & Z && this.processSubtable(O, i);
                }
                let m = i.length - 1;
                for (; m >= 0; )
                  i[m].id === 65535 && i.splice(m, 1), m--;
                return i;
              }
              processSubtable(i, u) {
                if (this.subtable = i, this.glyphs = u, this.subtable.type === 4) {
                  this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
                  return;
                }
                this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
                let m = this.getStateMachine(i), L = this.getProcessor(), Z = !!(this.subtable.coverage & _a);
                return m.process(this.glyphs, Z, L);
              }
              getStateMachine(i) {
                return new Ng(i.table.stateTable);
              }
              getProcessor() {
                switch (this.subtable.type) {
                  case 0:
                    return this.processIndicRearragement;
                  case 1:
                    return this.processContextualSubstitution;
                  case 2:
                    return this.processLigature;
                  case 4:
                    return this.processNoncontextualSubstitutions;
                  case 5:
                    return this.processGlyphInsertion;
                  default:
                    throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
                }
              }
              processIndicRearragement(i, u, m) {
                u.flags & Rg && (this.firstGlyph = m), u.flags & Sg && (this.lastGlyph = m), Xg(this.glyphs, u.flags & Gg, this.firstGlyph, this.lastGlyph);
              }
              processContextualSubstitution(i, u, m) {
                let L = this.subtable.table.substitutionTable.items;
                if (u.markIndex !== 65535) {
                  let O = L.getItem(u.markIndex), PA = new Xr(O);
                  i = this.glyphs[this.markedGlyph];
                  var Z = PA.lookup(i.id);
                  Z && (this.glyphs[this.markedGlyph] = this.font.getGlyph(Z, i.codePoints));
                }
                if (u.currentIndex !== 65535) {
                  let O = L.getItem(u.currentIndex), PA = new Xr(O);
                  i = this.glyphs[m];
                  var Z = PA.lookup(i.id);
                  Z && (this.glyphs[m] = this.font.getGlyph(Z, i.codePoints));
                }
                u.flags & qa && (this.markedGlyph = m);
              }
              processLigature(i, u, m) {
                if (u.flags & Hg && this.ligatureStack.push(m), u.flags & Lg) {
                  let L = this.subtable.table.ligatureActions, Z = this.subtable.table.components, O = this.subtable.table.ligatureList, PA = u.action, VA = !1, te = 0, ce = [], ge = [];
                  for (; !VA; ) {
                    let Ge = this.ligatureStack.pop();
                    ce.unshift(...this.glyphs[Ge].codePoints);
                    let nt = L.getItem(PA++);
                    VA = !!(nt & kg);
                    let ot = !!(nt & jg), Tt = (nt & Og) << 2 >> 2;
                    Tt += this.glyphs[Ge].id;
                    let ui = Z.getItem(Tt);
                    if (te += ui, VA || ot) {
                      let bt = O.getItem(te);
                      this.glyphs[Ge] = this.font.getGlyph(bt, ce), ge.push(Ge), te = 0, ce = [];
                    } else this.glyphs[Ge] = this.font.getGlyph(65535);
                  }
                  this.ligatureStack.push(...ge);
                }
              }
              processNoncontextualSubstitutions(i, u, m) {
                let L = new Xr(i.table.lookupTable);
                for (m = 0; m < u.length; m++) {
                  let Z = u[m];
                  if (Z.id !== 65535) {
                    let O = L.lookup(Z.id);
                    O && (u[m] = this.font.getGlyph(O, Z.codePoints));
                  }
                }
              }
              _insertGlyphs(i, u, m, L) {
                let Z = [];
                for (; m--; ) {
                  let O = this.subtable.table.insertionActions.getItem(u++);
                  Z.push(this.font.getGlyph(O));
                }
                L || i++, this.glyphs.splice(i, 0, ...Z);
              }
              processGlyphInsertion(i, u, m) {
                if (u.flags & qa && (this.markedIndex = m), u.markedInsertIndex !== 65535) {
                  let L = (u.flags & Vg) >>> 5, Z = !!(u.flags & Kg);
                  this._insertGlyphs(this.markedIndex, u.markedInsertIndex, L, Z);
                }
                if (u.currentInsertIndex !== 65535) {
                  let L = (u.flags & Wg) >>> 5, Z = !!(u.flags & Jg);
                  this._insertGlyphs(m, u.currentInsertIndex, L, Z);
                }
              }
              getSupportedFeatures() {
                let i = [];
                for (let u of this.morx.chains) for (let m of u.features) i.push([
                  m.featureType,
                  m.featureSetting
                ]);
                return i;
              }
              generateInputs(i) {
                return this.inputCache || this.generateInputCache(), this.inputCache[i] || [];
              }
              generateInputCache() {
                this.inputCache = {};
                for (let i of this.morx.chains) {
                  let u = i.defaultFlags;
                  for (let m of i.subtables) m.subFeatureFlags & u && this.generateInputsForSubtable(m);
                }
              }
              generateInputsForSubtable(i) {
                if (i.type !== 2) return;
                if (!!(i.coverage & _a)) throw new Error("Reverse subtable, not supported.");
                this.subtable = i, this.ligatureStack = [];
                let m = this.getStateMachine(i), L = this.getProcessor(), Z = [], O = [];
                this.glyphs = [], m.traverse({
                  enter: (PA, VA) => {
                    let te = this.glyphs;
                    O.push({
                      glyphs: te.slice(),
                      ligatureStack: this.ligatureStack.slice()
                    });
                    let ce = this.font.getGlyph(PA);
                    Z.push(ce), te.push(Z[Z.length - 1]), L(te[te.length - 1], VA, te.length - 1);
                    let ge = 0, Ge = 0;
                    for (let nt = 0; nt < te.length && ge <= 1; nt++) te[nt].id !== 65535 && (ge++, Ge = te[nt].id);
                    if (ge === 1) {
                      let nt = Z.map((Tt) => Tt.id), ot = this.inputCache[Ge];
                      ot ? ot.push(nt) : this.inputCache[Ge] = [
                        nt
                      ];
                    }
                  },
                  exit: () => {
                    ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = O.pop()), Z.pop();
                  }
                });
              }
              constructor(i) {
                this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = i, this.morx = i.morx, this.inputCache = null;
              }
            }
            (0, d._)([
              uA
            ], $a.prototype, "getStateMachine", null);
            function Ji(BA, i, u, m = !1, L = !1) {
              let Z = BA.splice(u[0] - (u[1] - 1), u[1]);
              L && Z.reverse();
              let O = BA.splice(i[0], i[1], ...Z);
              return m && O.reverse(), BA.splice(u[0] - (i[1] - 1), 0, ...O), BA;
            }
            function Xg(BA, i, u, m) {
              switch (i) {
                case 0:
                  return BA;
                case 1:
                  return Ji(BA, [
                    u,
                    1
                  ], [
                    m,
                    0
                  ]);
                case 2:
                  return Ji(BA, [
                    u,
                    0
                  ], [
                    m,
                    1
                  ]);
                case 3:
                  return Ji(BA, [
                    u,
                    1
                  ], [
                    m,
                    1
                  ]);
                case 4:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    0
                  ]);
                case 5:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    0
                  ], !0, !1);
                case 6:
                  return Ji(BA, [
                    u,
                    0
                  ], [
                    m,
                    2
                  ]);
                case 7:
                  return Ji(BA, [
                    u,
                    0
                  ], [
                    m,
                    2
                  ], !1, !0);
                case 8:
                  return Ji(BA, [
                    u,
                    1
                  ], [
                    m,
                    2
                  ]);
                case 9:
                  return Ji(BA, [
                    u,
                    1
                  ], [
                    m,
                    2
                  ], !1, !0);
                case 10:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    1
                  ]);
                case 11:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    1
                  ], !0, !1);
                case 12:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    2
                  ]);
                case 13:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    2
                  ], !0, !1);
                case 14:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    2
                  ], !1, !0);
                case 15:
                  return Ji(BA, [
                    u,
                    2
                  ], [
                    m,
                    2
                  ], !0, !0);
                default:
                  throw new Error(`Unknown verb: ${i}`);
              }
            }
            class Zg {
              substitute(i) {
                i.direction === "rtl" && i.glyphs.reverse(), this.morxProcessor.process(i.glyphs, bg(i.features));
              }
              getAvailableFeatures(i, u) {
                return zg(this.morxProcessor.getSupportedFeatures());
              }
              stringsForGlyph(i) {
                let u = this.morxProcessor.generateInputs(i), m = /* @__PURE__ */ new Set();
                for (let L of u) this._addStrings(L, 0, m, "");
                return m;
              }
              _addStrings(i, u, m, L) {
                let Z = this.font._cmapProcessor.codePointsForGlyph(i[u]);
                for (let O of Z) {
                  let PA = L + String.fromCodePoint(O);
                  u < i.length - 1 ? this._addStrings(i, u + 1, m, PA) : m.add(PA);
                }
              }
              constructor(i) {
                this.font = i, this.morxProcessor = new $a(i), this.fallbackPosition = !1;
              }
            }
            class qg {
              /**
              * Adds the given features to the last stage.
              * Ignores features that have already been applied.
              */
              _addFeatures(i, u) {
                let m = this.stages.length - 1, L = this.stages[m];
                for (let Z of i) this.allFeatures[Z] == null && (L.push(Z), this.allFeatures[Z] = m, u && (this.globalFeatures[Z] = !0));
              }
              /**
              * Add features to the last stage
              */
              add(i, u = !0) {
                if (this.stages.length === 0 && this.stages.push([]), typeof i == "string" && (i = [
                  i
                ]), Array.isArray(i)) this._addFeatures(i, u);
                else if (typeof i == "object")
                  this._addFeatures(i.global || [], !0), this._addFeatures(i.local || [], !1);
                else throw new Error("Unsupported argument to ShapingPlan#add");
              }
              /**
              * Add a new stage
              */
              addStage(i, u) {
                typeof i == "function" ? this.stages.push(i, []) : (this.stages.push([]), this.add(i, u));
              }
              setFeatureOverrides(i) {
                if (Array.isArray(i)) this.add(i);
                else if (typeof i == "object") {
                  for (let u in i)
                    if (i[u]) this.add(u);
                    else if (this.allFeatures[u] != null) {
                      let m = this.stages[this.allFeatures[u]];
                      m.splice(m.indexOf(u), 1), delete this.allFeatures[u], delete this.globalFeatures[u];
                    }
                }
              }
              /**
              * Assigns the global features to the given glyphs
              */
              assignGlobalFeatures(i) {
                for (let u of i) for (let m in this.globalFeatures) u.features[m] = !0;
              }
              /**
              * Executes the planned stages using the given OTProcessor
              */
              process(i, u, m) {
                for (let L of this.stages)
                  typeof L == "function" ? m || L(this.font, u, this) : L.length > 0 && i.applyFeatures(L, u, m);
              }
              constructor(i, u, m) {
                this.font = i, this.script = u, this.direction = m, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
              }
            }
            const _g = [
              "rvrn"
            ], $g = [
              "ccmp",
              "locl",
              "rlig",
              "mark",
              "mkmk"
            ], Ac = [
              "frac",
              "numr",
              "dnom"
            ], ec = [
              "calt",
              "clig",
              "liga",
              "rclt",
              "curs",
              "kern"
            ], tc = {
              ltr: [
                "ltra",
                "ltrm"
              ],
              rtl: [
                "rtla",
                "rtlm"
              ]
            };
            class Sn {
              static plan(i, u, m) {
                this.planPreprocessing(i), this.planFeatures(i), this.planPostprocessing(i, m), i.assignGlobalFeatures(u), this.assignFeatures(i, u);
              }
              static planPreprocessing(i) {
                i.add({
                  global: [
                    ..._g,
                    ...tc[i.direction]
                  ],
                  local: Ac
                });
              }
              static planFeatures(i) {
              }
              static planPostprocessing(i, u) {
                i.add([
                  ...$g,
                  ...ec
                ]), i.setFeatureOverrides(u);
              }
              static assignFeatures(i, u) {
                for (let m = 0; m < u.length; m++) {
                  let L = u[m];
                  if (L.codePoints[0] === 8260) {
                    let Z = m, O = m + 1;
                    for (; Z > 0 && (0, U.isDigit)(u[Z - 1].codePoints[0]); )
                      u[Z - 1].features.numr = !0, u[Z - 1].features.frac = !0, Z--;
                    for (; O < u.length && (0, U.isDigit)(u[O].codePoints[0]); )
                      u[O].features.dnom = !0, u[O].features.frac = !0, O++;
                    L.features.frac = !0, m = O - 1;
                  }
                }
              }
            }
            (0, a._)(Sn, "zeroMarkWidths", "AFTER_GPOS");
            const ic = new (T(P))(ia("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==")), Ao = [
              "isol",
              "fina",
              "fin2",
              "fin3",
              "medi",
              "med2",
              "init"
            ], sa = {
              Non_Joining: 0,
              Transparent: 6
            }, si = "isol", Gn = "fina", aa = "fin2", nc = "fin3", Qs = "medi", hs = "med2", Cs = "init", Kt = null, rc = [
              //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
              // State 0: prev was U,  not willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  si,
                  1
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  si,
                  1
                ],
                [
                  Kt,
                  si,
                  6
                ]
              ],
              // State 1: prev was R or ISOL/ALAPH,  not willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  si,
                  1
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  aa,
                  5
                ],
                [
                  Kt,
                  si,
                  6
                ]
              ],
              // State 2: prev was D/L in ISOL form,  willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Cs,
                  Gn,
                  1
                ],
                [
                  Cs,
                  Gn,
                  3
                ],
                [
                  Cs,
                  Gn,
                  4
                ],
                [
                  Cs,
                  Gn,
                  6
                ]
              ],
              // State 3: prev was D in FINA form,  willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Qs,
                  Gn,
                  1
                ],
                [
                  Qs,
                  Gn,
                  3
                ],
                [
                  Qs,
                  Gn,
                  4
                ],
                [
                  Qs,
                  Gn,
                  6
                ]
              ],
              // State 4: prev was FINA ALAPH,  not willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  hs,
                  si,
                  1
                ],
                [
                  hs,
                  si,
                  2
                ],
                [
                  hs,
                  aa,
                  5
                ],
                [
                  hs,
                  si,
                  6
                ]
              ],
              // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  si,
                  si,
                  1
                ],
                [
                  si,
                  si,
                  2
                ],
                [
                  si,
                  aa,
                  5
                ],
                [
                  si,
                  si,
                  6
                ]
              ],
              // State 6: prev was DALATH/RISH,  not willing to join.
              [
                [
                  Kt,
                  Kt,
                  0
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  si,
                  1
                ],
                [
                  Kt,
                  si,
                  2
                ],
                [
                  Kt,
                  nc,
                  5
                ],
                [
                  Kt,
                  si,
                  6
                ]
              ]
            ];
            class Hn extends Sn {
              static planFeatures(i) {
                i.add([
                  "ccmp",
                  "locl"
                ]);
                for (let u = 0; u < Ao.length; u++) {
                  let m = Ao[u];
                  i.addStage(m, !1);
                }
                i.addStage("mset");
              }
              static assignFeatures(i, u) {
                super.assignFeatures(i, u);
                let m = -1, L = 0, Z = [];
                for (let PA = 0; PA < u.length; PA++) {
                  let VA, te;
                  var O = u[PA];
                  let ce = sc(O.codePoints[0]);
                  if (ce === sa.Transparent) {
                    Z[PA] = Kt;
                    continue;
                  }
                  [te, VA, L] = rc[L][ce], te !== Kt && m !== -1 && (Z[m] = te), Z[PA] = VA, m = PA;
                }
                for (let PA = 0; PA < u.length; PA++) {
                  let VA;
                  var O = u[PA];
                  (VA = Z[PA]) && (O.features[VA] = !0);
                }
              }
            }
            function sc(BA) {
              let i = ic.get(BA);
              if (i) return i - 1;
              let u = (0, U.getCategory)(BA);
              return u === "Mn" || u === "Me" || u === "Cf" ? sa.Transparent : sa.Non_Joining;
            }
            class ac {
              reset(i = {}, u = 0) {
                this.options = i, this.flags = i.flags || {}, this.markAttachmentType = i.markAttachmentType || 0, this.index = u;
              }
              get cur() {
                return this.glyphs[this.index] || null;
              }
              shouldIgnore(i) {
                return this.flags.ignoreMarks && i.isMark || this.flags.ignoreBaseGlyphs && i.isBase || this.flags.ignoreLigatures && i.isLigature || this.markAttachmentType && i.isMark && i.markAttachmentType !== this.markAttachmentType;
              }
              move(i) {
                for (this.index += i; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); ) this.index += i;
                return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
              }
              next() {
                return this.move(1);
              }
              prev() {
                return this.move(-1);
              }
              peek(i = 1) {
                let u = this.index, m = this.increment(i);
                return this.index = u, m;
              }
              peekIndex(i = 1) {
                let u = this.index;
                this.increment(i);
                let m = this.index;
                return this.index = u, m;
              }
              increment(i = 1) {
                let u = i < 0 ? -1 : 1;
                for (i = Math.abs(i); i--; ) this.move(u);
                return this.glyphs[this.index];
              }
              constructor(i, u) {
                this.glyphs = i, this.reset(u);
              }
            }
            const oc = [
              "DFLT",
              "dflt",
              "latn"
            ];
            class Ms {
              findScript(i) {
                if (this.table.scriptList == null) return null;
                Array.isArray(i) || (i = [
                  i
                ]);
                for (let u of i) for (let m of this.table.scriptList)
                  if (m.tag === u) return m;
                return null;
              }
              selectScript(i, u, m) {
                let L = !1, Z;
                if (!this.script || i !== this.scriptTag) {
                  if (Z = this.findScript(i), Z || (Z = this.findScript(oc)), !Z) return this.scriptTag;
                  this.scriptTag = Z.tag, this.script = Z.script, this.language = null, this.languageTag = null, L = !0;
                }
                if ((!m || m !== this.direction) && (this.direction = m || Ka(i)), u && u.length < 4 && (u += " ".repeat(4 - u.length)), !u || u !== this.languageTag) {
                  this.language = null;
                  for (let O of this.script.langSysRecords) if (O.tag === u) {
                    this.language = O.langSys, this.languageTag = O.tag;
                    break;
                  }
                  this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), L = !0;
                }
                if (L && (this.features = {}, this.language))
                  for (let O of this.language.featureIndexes) {
                    let PA = this.table.featureList[O], VA = this.substituteFeatureForVariations(O);
                    this.features[PA.tag] = VA || PA.feature;
                  }
                return this.scriptTag;
              }
              lookupsForFeatures(i = [], u) {
                let m = [];
                for (let L of i) {
                  let Z = this.features[L];
                  if (Z)
                    for (let O of Z.lookupListIndexes)
                      u && u.indexOf(O) !== -1 || m.push({
                        feature: L,
                        index: O,
                        lookup: this.table.lookupList.get(O)
                      });
                }
                return m.sort((L, Z) => L.index - Z.index), m;
              }
              substituteFeatureForVariations(i) {
                if (this.variationsIndex === -1) return null;
                let m = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
                for (let L of m)
                  if (L.featureIndex === i) return L.alternateFeatureTable;
                return null;
              }
              findVariationsIndex(i) {
                let u = this.table.featureVariations;
                if (!u) return -1;
                let m = u.featureVariationRecords;
                for (let L = 0; L < m.length; L++) {
                  let Z = m[L].conditionSet.conditionTable;
                  if (this.variationConditionsMatch(Z, i)) return L;
                }
                return -1;
              }
              variationConditionsMatch(i, u) {
                return i.every((m) => {
                  let L = m.axisIndex < u.length ? u[m.axisIndex] : 0;
                  return m.filterRangeMinValue <= L && L <= m.filterRangeMaxValue;
                });
              }
              applyFeatures(i, u, m) {
                let L = this.lookupsForFeatures(i);
                this.applyLookups(L, u, m);
              }
              applyLookups(i, u, m) {
                this.glyphs = u, this.positions = m, this.glyphIterator = new ac(u);
                for (let { feature: L, lookup: Z } of i)
                  for (this.currentFeature = L, this.glyphIterator.reset(Z.flags); this.glyphIterator.index < u.length; ) {
                    if (!(L in this.glyphIterator.cur.features)) {
                      this.glyphIterator.next();
                      continue;
                    }
                    for (let O of Z.subTables)
                      if (this.applyLookup(Z.lookupType, O)) break;
                    this.glyphIterator.next();
                  }
              }
              applyLookup(i, u) {
                throw new Error("applyLookup must be implemented by subclasses");
              }
              applyLookupList(i) {
                let u = this.glyphIterator.options, m = this.glyphIterator.index;
                for (let L of i) {
                  this.glyphIterator.reset(u, m), this.glyphIterator.increment(L.sequenceIndex);
                  let Z = this.table.lookupList.get(L.lookupListIndex);
                  this.glyphIterator.reset(Z.flags, this.glyphIterator.index);
                  for (let O of Z.subTables)
                    if (this.applyLookup(Z.lookupType, O)) break;
                }
                return this.glyphIterator.reset(u, m), !0;
              }
              coverageIndex(i, u) {
                switch (u == null && (u = this.glyphIterator.cur.id), i.version) {
                  case 1:
                    return i.glyphs.indexOf(u);
                  case 2:
                    for (let m of i.rangeRecords)
                      if (m.start <= u && u <= m.end) return m.startCoverageIndex + u - m.start;
                    break;
                }
                return -1;
              }
              match(i, u, m, L) {
                let Z = this.glyphIterator.index, O = this.glyphIterator.increment(i), PA = 0;
                for (; PA < u.length && O && m(u[PA], O); )
                  L && L.push(this.glyphIterator.index), PA++, O = this.glyphIterator.next();
                return this.glyphIterator.index = Z, PA < u.length ? !1 : L || !0;
              }
              sequenceMatches(i, u) {
                return this.match(i, u, (m, L) => m === L.id);
              }
              sequenceMatchIndices(i, u) {
                return this.match(i, u, (m, L) => this.currentFeature in L.features ? m === L.id : !1, []);
              }
              coverageSequenceMatches(i, u) {
                return this.match(i, u, (m, L) => this.coverageIndex(m, L.id) >= 0);
              }
              getClassID(i, u) {
                switch (u.version) {
                  case 1:
                    let m = i - u.startGlyph;
                    if (m >= 0 && m < u.classValueArray.length) return u.classValueArray[m];
                    break;
                  case 2:
                    for (let L of u.classRangeRecord)
                      if (L.start <= i && i <= L.end) return L.class;
                    break;
                }
                return 0;
              }
              classSequenceMatches(i, u, m) {
                return this.match(i, u, (L, Z) => L === this.getClassID(Z.id, m));
              }
              applyContext(i) {
                let u, m;
                switch (i.version) {
                  case 1:
                    if (u = this.coverageIndex(i.coverage), u === -1) return !1;
                    m = i.ruleSets[u];
                    for (let L of m)
                      if (this.sequenceMatches(1, L.input)) return this.applyLookupList(L.lookupRecords);
                    break;
                  case 2:
                    if (this.coverageIndex(i.coverage) === -1 || (u = this.getClassID(this.glyphIterator.cur.id, i.classDef), u === -1)) return !1;
                    m = i.classSet[u];
                    for (let L of m)
                      if (this.classSequenceMatches(1, L.classes, i.classDef)) return this.applyLookupList(L.lookupRecords);
                    break;
                  case 3:
                    if (this.coverageSequenceMatches(0, i.coverages)) return this.applyLookupList(i.lookupRecords);
                    break;
                }
                return !1;
              }
              applyChainingContext(i) {
                let u;
                switch (i.version) {
                  case 1:
                    if (u = this.coverageIndex(i.coverage), u === -1) return !1;
                    let m = i.chainRuleSets[u];
                    for (let Z of m)
                      if (this.sequenceMatches(-Z.backtrack.length, Z.backtrack) && this.sequenceMatches(1, Z.input) && this.sequenceMatches(1 + Z.input.length, Z.lookahead)) return this.applyLookupList(Z.lookupRecords);
                    break;
                  case 2:
                    if (this.coverageIndex(i.coverage) === -1) return !1;
                    u = this.getClassID(this.glyphIterator.cur.id, i.inputClassDef);
                    let L = i.chainClassSet[u];
                    if (!L) return !1;
                    for (let Z of L)
                      if (this.classSequenceMatches(-Z.backtrack.length, Z.backtrack, i.backtrackClassDef) && this.classSequenceMatches(1, Z.input, i.inputClassDef) && this.classSequenceMatches(1 + Z.input.length, Z.lookahead, i.lookaheadClassDef)) return this.applyLookupList(Z.lookupRecords);
                    break;
                  case 3:
                    if (this.coverageSequenceMatches(-i.backtrackGlyphCount, i.backtrackCoverage) && this.coverageSequenceMatches(0, i.inputCoverage) && this.coverageSequenceMatches(i.inputGlyphCount, i.lookaheadCoverage)) return this.applyLookupList(i.lookupRecords);
                    break;
                }
                return !1;
              }
              constructor(i, u) {
                this.font = i, this.table = u, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = i._variationProcessor ? this.findVariationsIndex(i._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
              }
            }
            class sn {
              get id() {
                return this._id;
              }
              set id(i) {
                this._id = i, this.substituted = !0;
                let u = this._font.GDEF;
                if (u && u.glyphClassDef) {
                  let m = Ms.prototype.getClassID(i, u.glyphClassDef);
                  this.isBase = m === 1, this.isLigature = m === 2, this.isMark = m === 3, this.markAttachmentType = u.markAttachClassDef ? Ms.prototype.getClassID(i, u.markAttachClassDef) : 0;
                } else
                  this.isMark = this.codePoints.length > 0 && this.codePoints.every(U.isMark), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
              }
              copy() {
                return new sn(this._font, this.id, this.codePoints, this.features);
              }
              constructor(i, u, m = [], L) {
                if (this._font = i, this.codePoints = m, this.id = u, this.features = {}, Array.isArray(L)) for (let Z = 0; Z < L.length; Z++) {
                  let O = L[Z];
                  this.features[O] = !0;
                }
                else typeof L == "object" && Object.assign(this.features, L);
                this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
              }
            }
            class eo extends Sn {
              static planFeatures(i) {
                i.add([
                  "ljmo",
                  "vjmo",
                  "tjmo"
                ], !1);
              }
              static assignFeatures(i, u) {
                let m = 0, L = 0;
                for (; L < u.length; ) {
                  let Z, PA = u[L].codePoints[0], VA = xs(PA);
                  switch ([Z, m] = xc[m][VA], Z) {
                    case pn:
                      i.font.hasGlyphForCodePoint(PA) || (L = ro(u, L, i.font));
                      break;
                    case Ba:
                      L = pc(u, L, i.font);
                      break;
                    case ga:
                      Yc(u, L, i.font);
                      break;
                    case ca:
                      L = Pc(u, L, i.font);
                      break;
                  }
                  L++;
                }
              }
            }
            (0, a._)(eo, "zeroMarkWidths", "NONE");
            const wr = 44032, to = 55204, Bc = to - wr + 1, Ds = 4352, ds = 4449, Zn = 4519, gc = 19, Is = 21, Zr = 28, cc = Ds + gc - 1, lc = ds + Is - 1, Ec = Zn + Zr - 1, io = 9676, wc = (BA) => 4352 <= BA && BA <= 4447 || 43360 <= BA && BA <= 43388, uc = (BA) => 4448 <= BA && BA <= 4519 || 55216 <= BA && BA <= 55238, fc = (BA) => 4520 <= BA && BA <= 4607 || 55243 <= BA && BA <= 55291, Qc = (BA) => 12334 <= BA && BA <= 12335, hc = (BA) => wr <= BA && BA <= to, Cc = (BA) => BA - wr < Bc && (BA - wr) % Zr === 0, Mc = (BA) => Ds <= BA && BA <= cc, Dc = (BA) => ds <= BA && BA <= lc, dc = (BA) => 1 <= BA && BA <= Ec, Ic = 0, yc = 1, ys = 2, oa = 3, Fs = 4, no = 5, Fc = 6;
            function xs(BA) {
              return wc(BA) ? yc : uc(BA) ? ys : fc(BA) ? oa : Cc(BA) ? Fs : hc(BA) ? no : Qc(BA) ? Fc : Ic;
            }
            const Vi = 0, pn = 1, Ba = 2, ga = 4, ca = 5, xc = [
              //       X                 L                 V                T                  LV                LVT               M
              // State 0: start state
              [
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  1
                ],
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  0
                ],
                [
                  pn,
                  2
                ],
                [
                  pn,
                  3
                ],
                [
                  ca,
                  0
                ]
              ],
              // State 1: <L>
              [
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  1
                ],
                [
                  Ba,
                  2
                ],
                [
                  Vi,
                  0
                ],
                [
                  pn,
                  2
                ],
                [
                  pn,
                  3
                ],
                [
                  ca,
                  0
                ]
              ],
              // State 2: <L,V> or <LV>
              [
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  1
                ],
                [
                  Vi,
                  0
                ],
                [
                  Ba,
                  3
                ],
                [
                  pn,
                  2
                ],
                [
                  pn,
                  3
                ],
                [
                  ga,
                  0
                ]
              ],
              // State 3: <L,V,T> or <LVT>
              [
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  1
                ],
                [
                  Vi,
                  0
                ],
                [
                  Vi,
                  0
                ],
                [
                  pn,
                  2
                ],
                [
                  pn,
                  3
                ],
                [
                  ga,
                  0
                ]
              ]
            ];
            function qr(BA, i, u) {
              return new sn(BA, BA.glyphForCodePoint(i).id, [
                i
              ], u);
            }
            function ro(BA, i, u) {
              let m = BA[i], Z = m.codePoints[0] - wr, O = Zn + Z % Zr;
              Z = Z / Zr | 0;
              let PA = Ds + Z / Is | 0, VA = ds + Z % Is;
              if (!u.hasGlyphForCodePoint(PA) || !u.hasGlyphForCodePoint(VA) || O !== Zn && !u.hasGlyphForCodePoint(O)) return i;
              let te = qr(u, PA, m.features);
              te.features.ljmo = !0;
              let ce = qr(u, VA, m.features);
              ce.features.vjmo = !0;
              let ge = [
                te,
                ce
              ];
              if (O > Zn) {
                let Ge = qr(u, O, m.features);
                Ge.features.tjmo = !0, ge.push(Ge);
              }
              return BA.splice(i, 1, ...ge), i + ge.length - 1;
            }
            function pc(BA, i, u) {
              let m = BA[i], L = BA[i].codePoints[0], Z = xs(L), O = BA[i - 1].codePoints[0], PA = xs(O), VA, te, ce, ge;
              if (PA === Fs && Z === oa)
                VA = O, ge = m;
              else {
                Z === ys ? (te = BA[i - 1], ce = m) : (te = BA[i - 2], ce = BA[i - 1], ge = m);
                let nt = te.codePoints[0], ot = ce.codePoints[0];
                Mc(nt) && Dc(ot) && (VA = wr + ((nt - Ds) * Is + (ot - ds)) * Zr);
              }
              let Ge = ge && ge.codePoints[0] || Zn;
              if (VA != null && (Ge === Zn || dc(Ge))) {
                let nt = VA + (Ge - Zn);
                if (u.hasGlyphForCodePoint(nt)) {
                  let ot = PA === ys ? 3 : 2;
                  return BA.splice(i - ot + 1, ot, qr(u, nt, m.features)), i - ot + 1;
                }
              }
              return te && (te.features.ljmo = !0), ce && (ce.features.vjmo = !0), ge && (ge.features.tjmo = !0), PA === Fs ? (ro(BA, i - 1, u), i + 1) : i;
            }
            function mc(BA) {
              switch (xs(BA)) {
                case Fs:
                case no:
                  return 1;
                case ys:
                  return 2;
                case oa:
                  return 3;
              }
            }
            function Yc(BA, i, u) {
              let m = BA[i], L = BA[i].codePoints[0];
              if (u.glyphForCodePoint(L).advanceWidth === 0) return;
              let Z = BA[i - 1].codePoints[0], O = mc(Z);
              return BA.splice(i, 1), BA.splice(i - O, 0, m);
            }
            function Pc(BA, i, u) {
              let m = BA[i], L = BA[i].codePoints[0];
              if (u.hasGlyphForCodePoint(io)) {
                let Z = qr(u, io, m.features), O = u.glyphForCodePoint(L).advanceWidth === 0 ? i : i + 1;
                BA.splice(O, 0, Z), i++;
              }
              return i;
            }
            var so = {};
            so = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
            var ps = {};
            ps = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","null","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","M","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
            const Lt = {
              X: 1,
              C: 2,
              V: 4,
              N: 8,
              H: 16,
              ZWNJ: 32,
              ZWJ: 64,
              M: 128,
              Placeholder: 2048,
              Dotted_Circle: 4096,
              RS: 8192,
              Coeng: 16384,
              Repha: 32768,
              Ra: 65536,
              CM: 131072
            }, dt = {
              Start: 1,
              Ra_To_Become_Reph: 2,
              Pre_M: 4,
              Pre_C: 8,
              Base_C: 16,
              After_Main: 32,
              Before_Sub: 128,
              Below_C: 256,
              After_Sub: 512,
              Before_Post: 1024,
              Post_C: 2048,
              After_Post: 4096,
              Final_C: 8192,
              SMVD: 16384,
              End: 32768
            }, vc = Lt.C | Lt.Ra | Lt.CM | Lt.V | Lt.Placeholder | Lt.Dotted_Circle, ao = Lt.ZWJ | Lt.ZWNJ, _r = Lt.H | Lt.Coeng, oo = {
              Default: {
                hasOldSpec: !1,
                virama: 0,
                basePos: "Last",
                rephPos: dt.Before_Post,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Devanagari: {
                hasOldSpec: !0,
                virama: 2381,
                basePos: "Last",
                rephPos: dt.Before_Post,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Bengali: {
                hasOldSpec: !0,
                virama: 2509,
                basePos: "Last",
                rephPos: dt.After_Sub,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Gurmukhi: {
                hasOldSpec: !0,
                virama: 2637,
                basePos: "Last",
                rephPos: dt.Before_Sub,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Gujarati: {
                hasOldSpec: !0,
                virama: 2765,
                basePos: "Last",
                rephPos: dt.Before_Post,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Oriya: {
                hasOldSpec: !0,
                virama: 2893,
                basePos: "Last",
                rephPos: dt.After_Main,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Tamil: {
                hasOldSpec: !0,
                virama: 3021,
                basePos: "Last",
                rephPos: dt.After_Post,
                rephMode: "Implicit",
                blwfMode: "Pre_And_Post"
              },
              Telugu: {
                hasOldSpec: !0,
                virama: 3149,
                basePos: "Last",
                rephPos: dt.After_Post,
                rephMode: "Explicit",
                blwfMode: "Post_Only"
              },
              Kannada: {
                hasOldSpec: !0,
                virama: 3277,
                basePos: "Last",
                rephPos: dt.After_Post,
                rephMode: "Implicit",
                blwfMode: "Post_Only"
              },
              Malayalam: {
                hasOldSpec: !0,
                virama: 3405,
                basePos: "Last",
                rephPos: dt.After_Main,
                rephMode: "Log_Repha",
                blwfMode: "Pre_And_Post"
              },
              // Handled by UniversalShaper
              // Sinhala: {
              //   hasOldSpec: false,
              //   virama: 0x0DCA,
              //   basePos: 'Last_Sinhala',
              //   rephPos: POSITIONS.After_Main,
              //   rephMode: 'Explicit',
              //   blwfMode: 'Pre_And_Post'
              // },
              Khmer: {
                hasOldSpec: !1,
                virama: 6098,
                basePos: "First",
                rephPos: dt.Ra_To_Become_Reph,
                rephMode: "Vis_Repha",
                blwfMode: "Pre_And_Post"
              }
            }, bc = {
              // Khmer
              6078: [
                6081,
                6078
              ],
              6079: [
                6081,
                6079
              ],
              6080: [
                6081,
                6080
              ],
              6084: [
                6081,
                6084
              ],
              6085: [
                6081,
                6085
              ]
            }, { decompositions: zc } = /* @__PURE__ */ T(ps), Bo = new (T(P))(ia("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")), Tc = new (T(D))(/* @__PURE__ */ T(so));
            class Ii extends Sn {
              static planFeatures(i) {
                i.addStage(Uc), i.addStage([
                  "locl",
                  "ccmp"
                ]), i.addStage(Rc), i.addStage("nukt"), i.addStage("akhn"), i.addStage("rphf", !1), i.addStage("rkrf"), i.addStage("pref", !1), i.addStage("blwf", !1), i.addStage("abvf", !1), i.addStage("half", !1), i.addStage("pstf", !1), i.addStage("vatu"), i.addStage("cjct"), i.addStage("cfar", !1), i.addStage(Sc), i.addStage({
                  local: [
                    "init"
                  ],
                  global: [
                    "pres",
                    "abvs",
                    "blws",
                    "psts",
                    "haln",
                    "dist",
                    "abvm",
                    "blwm",
                    "calt",
                    "clig"
                  ]
                }), i.unicodeScript = xg(i.script), i.indicConfig = oo[i.unicodeScript] || oo.Default, i.isOldSpec = i.indicConfig.hasOldSpec && i.script[i.script.length - 1] !== "2";
              }
              static assignFeatures(i, u) {
                for (let m = u.length - 1; m >= 0; m--) {
                  let L = u[m].codePoints[0], Z = bc[L] || zc[L];
                  if (Z) {
                    let O = Z.map((PA) => {
                      let VA = i.font.glyphForCodePoint(PA);
                      return new sn(i.font, VA.id, [
                        PA
                      ], u[m].features);
                    });
                    u.splice(m, 1, ...O);
                  }
                }
              }
            }
            (0, a._)(Ii, "zeroMarkWidths", "NONE");
            function la(BA) {
              return Bo.get(BA.codePoints[0]) >> 8;
            }
            function go(BA) {
              return 1 << (Bo.get(BA.codePoints[0]) & 255);
            }
            class ms {
              constructor(i, u, m, L) {
                this.category = i, this.position = u, this.syllableType = m, this.syllable = L;
              }
            }
            function Uc(BA, i) {
              let u = 0, m = 0;
              for (let [L, Z, O] of Tc.match(i.map(la))) {
                if (L > m) {
                  ++u;
                  for (let PA = m; PA < L; PA++) i[PA].shaperInfo = new ms(Lt.X, dt.End, "non_indic_cluster", u);
                }
                ++u;
                for (let PA = L; PA <= Z; PA++) i[PA].shaperInfo = new ms(1 << la(i[PA]), go(i[PA]), O[0], u);
                m = Z + 1;
              }
              if (m < i.length) {
                ++u;
                for (let L = m; L < i.length; L++) i[L].shaperInfo = new ms(Lt.X, dt.End, "non_indic_cluster", u);
              }
            }
            function qn(BA) {
              return BA.shaperInfo.category & vc;
            }
            function wn(BA) {
              return BA.shaperInfo.category & ao;
            }
            function mn(BA) {
              return BA.shaperInfo.category & _r;
            }
            function Yn(BA, i) {
              for (let m of BA) m.features = {
                [i]: !0
              };
              return BA[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
                i
              ], BA), BA.length === 1;
            }
            function Nc(BA, i, u) {
              let m = [
                u,
                i,
                u
              ];
              return Yn(m.slice(0, 2), "blwf") || Yn(m.slice(1, 3), "blwf") ? dt.Below_C : Yn(m.slice(0, 2), "pstf") || Yn(m.slice(1, 3), "pstf") || Yn(m.slice(0, 2), "pref") || Yn(m.slice(1, 3), "pref") ? dt.Post_C : dt.Base_C;
            }
            function Rc(BA, i, u) {
              let m = u.indicConfig, L = BA._layoutEngine.engine.GSUBProcessor.features, Z = BA.glyphForCodePoint(9676).id, O = BA.glyphForCodePoint(m.virama).id;
              if (O) {
                let PA = new sn(BA, O, [
                  m.virama
                ]);
                for (let VA = 0; VA < i.length; VA++) i[VA].shaperInfo.position === dt.Base_C && (i[VA].shaperInfo.position = Nc(BA, i[VA].copy(), PA));
              }
              for (let PA = 0, VA = Ys(i, 0); PA < i.length; PA = VA, VA = Ys(i, PA)) {
                let { category: te, syllableType: ce } = i[PA].shaperInfo;
                if (ce === "symbol_cluster" || ce === "non_indic_cluster") continue;
                if (ce === "broken_cluster" && Z) {
                  let Ue = new sn(BA, Z, [
                    9676
                  ]);
                  Ue.shaperInfo = new ms(1 << la(Ue), go(Ue), i[PA].shaperInfo.syllableType, i[PA].shaperInfo.syllable);
                  let ht = PA;
                  for (; ht < VA && i[ht].shaperInfo.category === Lt.Repha; ) ht++;
                  i.splice(ht++, 0, Ue), VA++;
                }
                let ge = VA, Ge = PA, nt = !1;
                if (m.rephPos !== dt.Ra_To_Become_Reph && L.rphf && PA + 3 <= VA && (m.rephMode === "Implicit" && !wn(i[PA + 2]) || m.rephMode === "Explicit" && i[PA + 2].shaperInfo.category === Lt.ZWJ)) {
                  let Ue = [
                    i[PA].copy(),
                    i[PA + 1].copy(),
                    i[PA + 2].copy()
                  ];
                  if (Yn(Ue.slice(0, 2), "rphf") || m.rephMode === "Explicit" && Yn(Ue, "rphf")) {
                    for (Ge += 2; Ge < VA && wn(i[Ge]); ) Ge++;
                    ge = PA, nt = !0;
                  }
                } else if (m.rephMode === "Log_Repha" && i[PA].shaperInfo.category === Lt.Repha) {
                  for (Ge++; Ge < VA && wn(i[Ge]); ) Ge++;
                  ge = PA, nt = !0;
                }
                switch (m.basePos) {
                  case "Last": {
                    let Ue = VA, ht = !1;
                    do {
                      let Ut = i[--Ue].shaperInfo;
                      if (qn(i[Ue])) {
                        if (Ut.position !== dt.Below_C && (Ut.position !== dt.Post_C || ht)) {
                          ge = Ue;
                          break;
                        }
                        Ut.position === dt.Below_C && (ht = !0), ge = Ue;
                      } else if (PA < Ue && Ut.category === Lt.ZWJ && i[Ue - 1].shaperInfo.category === Lt.H) break;
                    } while (Ue > Ge);
                    break;
                  }
                  case "First":
                    ge = PA;
                    for (let Ue = ge + 1; Ue < VA; Ue++) qn(i[Ue]) && (i[Ue].shaperInfo.position = dt.Below_C);
                }
                nt && ge === PA && Ge - ge <= 2 && (nt = !1);
                for (let Ue = PA; Ue < ge; Ue++) {
                  let ht = i[Ue].shaperInfo;
                  ht.position = Math.min(dt.Pre_C, ht.position);
                }
                ge < VA && (i[ge].shaperInfo.position = dt.Base_C);
                for (let Ue = ge + 1; Ue < VA; Ue++) if (i[Ue].shaperInfo.category === Lt.M) {
                  for (let ht = Ue + 1; ht < VA; ht++) if (qn(i[ht])) {
                    i[ht].shaperInfo.position = dt.Final_C;
                    break;
                  }
                  break;
                }
                if (nt && (i[PA].shaperInfo.position = dt.Ra_To_Become_Reph), u.isOldSpec) {
                  let Ue = u.unicodeScript !== "Malayalam";
                  for (let ht = ge + 1; ht < VA; ht++) if (i[ht].shaperInfo.category === Lt.H) {
                    let Ut;
                    for (Ut = VA - 1; Ut > ht && !(qn(i[Ut]) || Ue && i[Ut].shaperInfo.category === Lt.H); Ut--)
                      ;
                    if (i[Ut].shaperInfo.category !== Lt.H && Ut > ht) {
                      let yi = i[ht];
                      i.splice(ht, 0, ...i.splice(ht + 1, Ut - ht)), i[Ut] = yi;
                    }
                    break;
                  }
                }
                let ot = dt.Start;
                for (let Ue = PA; Ue < VA; Ue++) {
                  let ht = i[Ue].shaperInfo;
                  if (ht.category & (ao | Lt.N | Lt.RS | Lt.CM | _r & ht.category)) {
                    if (ht.position = ot, ht.category === Lt.H && ht.position === dt.Pre_M) {
                      for (let Ut = Ue; Ut > PA; Ut--) if (i[Ut - 1].shaperInfo.position !== dt.Pre_M) {
                        ht.position = i[Ut - 1].shaperInfo.position;
                        break;
                      }
                    }
                  } else ht.position !== dt.SMVD && (ot = ht.position);
                }
                let Tt = ge;
                for (let Ue = ge + 1; Ue < VA; Ue++)
                  if (qn(i[Ue])) {
                    for (let ht = Tt + 1; ht < Ue; ht++) i[ht].shaperInfo.position < dt.SMVD && (i[ht].shaperInfo.position = i[Ue].shaperInfo.position);
                    Tt = Ue;
                  } else i[Ue].shaperInfo.category === Lt.M && (Tt = Ue);
                let ui = i.slice(PA, VA);
                ui.sort((Ue, ht) => Ue.shaperInfo.position - ht.shaperInfo.position), i.splice(PA, ui.length, ...ui);
                for (let Ue = PA; Ue < VA; Ue++) if (i[Ue].shaperInfo.position === dt.Base_C) {
                  ge = Ue;
                  break;
                }
                for (let Ue = PA; Ue < VA && i[Ue].shaperInfo.position === dt.Ra_To_Become_Reph; Ue++) i[Ue].features.rphf = !0;
                let bt = !u.isOldSpec && m.blwfMode === "Pre_And_Post";
                for (let Ue = PA; Ue < ge; Ue++)
                  i[Ue].features.half = !0, bt && (i[Ue].features.blwf = !0);
                for (let Ue = ge + 1; Ue < VA; Ue++)
                  i[Ue].features.abvf = !0, i[Ue].features.pstf = !0, i[Ue].features.blwf = !0;
                if (u.isOldSpec && u.unicodeScript === "Devanagari")
                  for (let Ue = PA; Ue + 1 < ge; Ue++) i[Ue].shaperInfo.category === Lt.Ra && i[Ue + 1].shaperInfo.category === Lt.H && (Ue + 1 === ge || i[Ue + 2].shaperInfo.category === Lt.ZWJ) && (i[Ue].features.blwf = !0, i[Ue + 1].features.blwf = !0);
                let Jt = 2;
                if (L.pref && ge + Jt < VA)
                  for (let Ue = ge + 1; Ue + Jt - 1 < VA; Ue++) {
                    let ht = [
                      i[Ue].copy(),
                      i[Ue + 1].copy()
                    ];
                    if (Yn(ht, "pref")) {
                      for (let Ut = 0; Ut < Jt; Ut++) i[Ue++].features.pref = !0;
                      if (L.cfar) for (; Ue < VA; Ue++) i[Ue].features.cfar = !0;
                      break;
                    }
                  }
                for (let Ue = PA + 1; Ue < VA; Ue++) if (wn(i[Ue])) {
                  let ht = i[Ue].shaperInfo.category === Lt.ZWNJ, Ut = Ue;
                  do
                    Ut--, ht && delete i[Ut].features.half;
                  while (Ut > PA && !qn(i[Ut]));
                }
              }
            }
            function Sc(BA, i, u) {
              let m = u.indicConfig, L = BA._layoutEngine.engine.GSUBProcessor.features;
              for (let Z = 0, O = Ys(i, 0); Z < i.length; Z = O, O = Ys(i, Z)) {
                let PA = !!L.pref, VA = Z;
                for (; VA < O; VA++) if (i[VA].shaperInfo.position >= dt.Base_C) {
                  if (PA && VA + 1 < O) {
                    for (let te = VA + 1; te < O; te++) if (i[te].features.pref) {
                      if (!(i[te].substituted && i[te].isLigated && !i[te].isMultiplied)) {
                        for (VA = te; VA < O && mn(i[VA]); ) VA++;
                        i[VA].shaperInfo.position = dt.BASE_C, PA = !1;
                      }
                      break;
                    }
                  }
                  if (u.unicodeScript === "Malayalam") for (let te = VA + 1; te < O; te++) {
                    for (; te < O && wn(i[te]); ) te++;
                    if (te === O || !mn(i[te])) break;
                    for (te++; te < O && wn(i[te]); ) te++;
                    te < O && qn(i[te]) && i[te].shaperInfo.position === dt.Below_C && (VA = te, i[VA].shaperInfo.position = dt.Base_C);
                  }
                  Z < VA && i[VA].shaperInfo.position > dt.Base_C && VA--;
                  break;
                }
                if (VA === O && Z < VA && i[VA - 1].shaperInfo.category === Lt.ZWJ && VA--, VA < O) for (; Z < VA && i[VA].shaperInfo.category & (Lt.N | _r); ) VA--;
                if (Z + 1 < O && Z < VA) {
                  let te = VA === O ? VA - 2 : VA - 1;
                  if (u.unicodeScript !== "Malayalam" && u.unicodeScript !== "Tamil") {
                    for (; te > Z && !(i[te].shaperInfo.category & (Lt.M | _r)); ) te--;
                    mn(i[te]) && i[te].shaperInfo.position !== dt.Pre_M ? te + 1 < O && wn(i[te + 1]) && te++ : te = Z;
                  }
                  if (Z < te && i[te].shaperInfo.position !== dt.Pre_M) {
                    for (let ce = te; ce > Z; ce--) if (i[ce - 1].shaperInfo.position === dt.Pre_M) {
                      let ge = ce - 1;
                      ge < VA && VA <= te && VA--;
                      let Ge = i[ge];
                      i.splice(ge, 0, ...i.splice(ge + 1, te - ge)), i[te] = Ge, te--;
                    }
                  }
                }
                if (Z + 1 < O && i[Z].shaperInfo.position === dt.Ra_To_Become_Reph && i[Z].shaperInfo.category === Lt.Repha !== (i[Z].isLigated && !i[Z].isMultiplied)) {
                  let te, ce = m.rephPos, ge = !1;
                  if (ce !== dt.After_Post) {
                    for (te = Z + 1; te < VA && !mn(i[te]); ) te++;
                    if (te < VA && mn(i[te]) && (te + 1 < VA && wn(i[te + 1]) && te++, ge = !0), !ge && ce === dt.After_Main) {
                      for (te = VA; te + 1 < O && i[te + 1].shaperInfo.position <= dt.After_Main; ) te++;
                      ge = te < O;
                    }
                    if (!ge && ce === dt.After_Sub) {
                      for (te = VA; te + 1 < O && !(i[te + 1].shaperInfo.position & (dt.Post_C | dt.After_Post | dt.SMVD)); ) te++;
                      ge = te < O;
                    }
                  }
                  if (!ge) {
                    for (te = Z + 1; te < VA && !mn(i[te]); ) te++;
                    te < VA && mn(i[te]) && (te + 1 < VA && wn(i[te + 1]) && te++, ge = !0);
                  }
                  if (!ge) {
                    for (te = O - 1; te > Z && i[te].shaperInfo.position === dt.SMVD; ) te--;
                    if (mn(i[te]))
                      for (let nt = VA + 1; nt < te; nt++) i[nt].shaperInfo.category === Lt.M && te--;
                  }
                  let Ge = i[Z];
                  i.splice(Z, 0, ...i.splice(Z + 1, te - Z)), i[te] = Ge, Z < VA && VA <= te && VA--;
                }
                if (PA && VA + 1 < O) {
                  for (let te = VA + 1; te < O; te++) if (i[te].features.pref) {
                    if (i[te].isLigated && !i[te].isMultiplied) {
                      let ce = VA;
                      if (u.unicodeScript !== "Malayalam" && u.unicodeScript !== "Tamil") {
                        for (; ce > Z && !(i[ce - 1].shaperInfo.category & (Lt.M | _r)); ) ce--;
                        if (ce > Z && i[ce - 1].shaperInfo.category === Lt.M) {
                          let nt = te;
                          for (let ot = VA + 1; ot < nt; ot++) if (i[ot].shaperInfo.category === Lt.M) {
                            ce--;
                            break;
                          }
                        }
                      }
                      ce > Z && mn(i[ce - 1]) && ce < O && wn(i[ce]) && ce++;
                      let ge = te, Ge = i[ge];
                      i.splice(ce + 1, 0, ...i.splice(ce, ge - ce)), i[ce] = Ge, ce <= VA && VA < ge && VA++;
                    }
                    break;
                  }
                }
                i[Z].shaperInfo.position === dt.Pre_M && (!Z || !/Cf|Mn/.test((0, U.getCategory)(i[Z - 1].codePoints[0]))) && (i[Z].features.init = !0);
              }
            }
            function Ys(BA, i) {
              if (i >= BA.length) return i;
              let u = BA[i].shaperInfo.syllable;
              for (; ++i < BA.length && BA[i].shaperInfo.syllable === u; ) ;
              return i;
            }
            const { categories: Gc, decompositions: co } = /* @__PURE__ */ T(ps), Hc = new (T(P))(ia("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")), Lc = new (T(D))(/* @__PURE__ */ T(ps));
            class Ht extends Sn {
              static planFeatures(i) {
                i.addStage(jc), i.addStage([
                  "locl",
                  "ccmp",
                  "nukt",
                  "akhn"
                ]), i.addStage(Eo), i.addStage([
                  "rphf"
                ], !1), i.addStage(Oc), i.addStage(Eo), i.addStage([
                  "pref"
                ]), i.addStage(Jc), i.addStage([
                  "rkrf",
                  "abvf",
                  "blwf",
                  "half",
                  "pstf",
                  "vatu",
                  "cjct"
                ]), i.addStage(Kc), i.addStage([
                  "abvs",
                  "blws",
                  "pres",
                  "psts",
                  "dist",
                  "abvm",
                  "blwm"
                ]);
              }
              static assignFeatures(i, u) {
                for (let m = u.length - 1; m >= 0; m--) {
                  let L = u[m].codePoints[0];
                  if (co[L]) {
                    let Z = co[L].map((O) => {
                      let PA = i.font.glyphForCodePoint(O);
                      return new sn(i.font, PA.id, [
                        O
                      ], u[m].features);
                    });
                    u.splice(m, 1, ...Z);
                  }
                }
              }
            }
            (0, a._)(Ht, "zeroMarkWidths", "BEFORE_GPOS");
            function lo(BA) {
              return Hc.get(BA.codePoints[0]);
            }
            class kc {
              constructor(i, u, m) {
                this.category = i, this.syllableType = u, this.syllable = m;
              }
            }
            function jc(BA, i) {
              let u = 0;
              for (let [m, L, Z] of Lc.match(i.map(lo))) {
                ++u;
                for (let PA = m; PA <= L; PA++) i[PA].shaperInfo = new kc(Gc[lo(i[PA])], Z[0], u);
                let O = i[m].shaperInfo.category === "R" ? 1 : Math.min(3, L - m);
                for (let PA = m; PA < m + O; PA++) i[PA].features.rphf = !0;
              }
            }
            function Eo(BA, i) {
              for (let u of i) u.substituted = !1;
            }
            function Oc(BA, i) {
              for (let u of i) u.substituted && u.features.rphf && (u.shaperInfo.category = "R");
            }
            function Jc(BA, i) {
              for (let u of i) u.substituted && (u.shaperInfo.category = "VPre");
            }
            function Kc(BA, i) {
              let u = BA.glyphForCodePoint(9676).id;
              for (let m = 0, L = wo(i, 0); m < i.length; m = L, L = wo(i, m)) {
                let Z, O, PA = i[m].shaperInfo, VA = PA.syllableType;
                if (!(VA !== "virama_terminated_cluster" && VA !== "standard_cluster" && VA !== "broken_cluster")) {
                  if (VA === "broken_cluster" && u) {
                    let te = new sn(BA, u, [
                      9676
                    ]);
                    for (te.shaperInfo = PA, Z = m; Z < L && i[Z].shaperInfo.category === "R"; Z++) ;
                    i.splice(++Z, 0, te), L++;
                  }
                  if (PA.category === "R" && L - m > 1) {
                    for (Z = m + 1; Z < L; Z++)
                      if (PA = i[Z].shaperInfo, uo(PA) || Ps(i[Z])) {
                        Ps(i[Z]) && Z--, i.splice(m, 0, ...i.splice(m + 1, Z - m), i[Z]);
                        break;
                      }
                  }
                  for (Z = m, O = L; Z < L; Z++)
                    PA = i[Z].shaperInfo, uo(PA) || Ps(i[Z]) ? O = Ps(i[Z]) ? Z + 1 : Z : (PA.category === "VPre" || PA.category === "VMPre") && O < Z && i.splice(O, 1, i[Z], ...i.splice(O, Z - O));
                }
              }
            }
            function wo(BA, i) {
              if (i >= BA.length) return i;
              let u = BA[i].shaperInfo.syllable;
              for (; ++i < BA.length && BA[i].shaperInfo.syllable === u; ) ;
              return i;
            }
            function Ps(BA) {
              return BA.shaperInfo.category === "H" && !BA.isLigated;
            }
            function uo(BA) {
              return BA.category === "B" || BA.category === "GB";
            }
            const Wc = {
              arab: Hn,
              mong: Hn,
              syrc: Hn,
              "nko ": Hn,
              phag: Hn,
              mand: Hn,
              mani: Hn,
              phlp: Hn,
              hang: eo,
              bng2: Ii,
              beng: Ii,
              dev2: Ii,
              deva: Ii,
              gjr2: Ii,
              gujr: Ii,
              guru: Ii,
              gur2: Ii,
              knda: Ii,
              knd2: Ii,
              mlm2: Ii,
              mlym: Ii,
              ory2: Ii,
              orya: Ii,
              taml: Ii,
              tml2: Ii,
              telu: Ii,
              tel2: Ii,
              khmr: Ii,
              bali: Ht,
              batk: Ht,
              brah: Ht,
              bugi: Ht,
              buhd: Ht,
              cakm: Ht,
              cham: Ht,
              dupl: Ht,
              egyp: Ht,
              gran: Ht,
              hano: Ht,
              java: Ht,
              kthi: Ht,
              kali: Ht,
              khar: Ht,
              khoj: Ht,
              sind: Ht,
              lepc: Ht,
              limb: Ht,
              mahj: Ht,
              // mand: UniversalShaper, // Mandaic
              // mani: UniversalShaper, // Manichaean
              mtei: Ht,
              modi: Ht,
              // mong: UniversalShaper, // Mongolian
              // 'nko ': UniversalShaper, // N’Ko
              hmng: Ht,
              // phag: UniversalShaper, // Phags-pa
              // phlp: UniversalShaper, // Psalter Pahlavi
              rjng: Ht,
              saur: Ht,
              shrd: Ht,
              sidd: Ht,
              sinh: Ii,
              sund: Ht,
              sylo: Ht,
              tglg: Ht,
              tagb: Ht,
              tale: Ht,
              lana: Ht,
              tavt: Ht,
              takr: Ht,
              tibt: Ht,
              tfng: Ht,
              tirh: Ht,
              latn: Sn,
              DFLT: Sn
            };
            function Vc(BA) {
              Array.isArray(BA) || (BA = [
                BA
              ]);
              for (let i of BA) {
                let u = Wc[i];
                if (u) return u;
              }
              return Sn;
            }
            class Xc extends Ms {
              applyLookup(i, u) {
                switch (i) {
                  case 1: {
                    let L = this.coverageIndex(u.coverage);
                    if (L === -1) return !1;
                    let Z = this.glyphIterator.cur;
                    switch (u.version) {
                      case 1:
                        Z.id = Z.id + u.deltaGlyphID & 65535;
                        break;
                      case 2:
                        Z.id = u.substitute.get(L);
                        break;
                    }
                    return !0;
                  }
                  case 2: {
                    let L = this.coverageIndex(u.coverage);
                    if (L !== -1) {
                      let Z = u.sequences.get(L);
                      if (Z.length === 0)
                        return this.glyphs.splice(this.glyphIterator.index, 1), !0;
                      this.glyphIterator.cur.id = Z[0], this.glyphIterator.cur.ligatureComponent = 0;
                      let O = this.glyphIterator.cur.features, PA = this.glyphIterator.cur, VA = Z.slice(1).map((te, ce) => {
                        let ge = new sn(this.font, te, void 0, O);
                        return ge.shaperInfo = PA.shaperInfo, ge.isLigated = PA.isLigated, ge.ligatureComponent = ce + 1, ge.substituted = !0, ge.isMultiplied = !0, ge;
                      });
                      return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...VA), !0;
                    }
                    return !1;
                  }
                  case 3: {
                    let L = this.coverageIndex(u.coverage);
                    if (L !== -1) {
                      let Z = 0;
                      return this.glyphIterator.cur.id = u.alternateSet.get(L)[Z], !0;
                    }
                    return !1;
                  }
                  case 4: {
                    let L = this.coverageIndex(u.coverage);
                    if (L === -1) return !1;
                    for (let Z of u.ligatureSets.get(L)) {
                      let O = this.sequenceMatchIndices(1, Z.components);
                      if (!O) continue;
                      let PA = this.glyphIterator.cur, VA = PA.codePoints.slice();
                      for (let Tt of O) VA.push(...this.glyphs[Tt].codePoints);
                      let te = new sn(this.font, Z.glyph, VA, PA.features);
                      te.shaperInfo = PA.shaperInfo, te.isLigated = !0, te.substituted = !0;
                      let ce = PA.isMark;
                      for (let Tt = 0; Tt < O.length && ce; Tt++) ce = this.glyphs[O[Tt]].isMark;
                      te.ligatureID = ce ? null : this.ligatureID++;
                      let ge = PA.ligatureID, Ge = PA.codePoints.length, nt = Ge, ot = this.glyphIterator.index + 1;
                      for (let Tt of O) {
                        if (ce) ot = Tt;
                        else for (; ot < Tt; ) {
                          var m = nt - Ge + Math.min(this.glyphs[ot].ligatureComponent || 1, Ge);
                          this.glyphs[ot].ligatureID = te.ligatureID, this.glyphs[ot].ligatureComponent = m, ot++;
                        }
                        ge = this.glyphs[ot].ligatureID, Ge = this.glyphs[ot].codePoints.length, nt += Ge, ot++;
                      }
                      if (ge && !ce) for (let Tt = ot; Tt < this.glyphs.length && this.glyphs[Tt].ligatureID === ge; Tt++) {
                        var m = nt - Ge + Math.min(this.glyphs[Tt].ligatureComponent || 1, Ge);
                        this.glyphs[Tt].ligatureComponent = m;
                      }
                      for (let Tt = O.length - 1; Tt >= 0; Tt--) this.glyphs.splice(O[Tt], 1);
                      return this.glyphs[this.glyphIterator.index] = te, !0;
                    }
                    return !1;
                  }
                  case 5:
                    return this.applyContext(u);
                  case 6:
                    return this.applyChainingContext(u);
                  case 7:
                    return this.applyLookup(u.lookupType, u.extension);
                  default:
                    throw new Error(`GSUB lookupType ${i} is not supported`);
                }
              }
            }
            class Zc extends Ms {
              applyPositionValue(i, u) {
                let m = this.positions[this.glyphIterator.peekIndex(i)];
                u.xAdvance != null && (m.xAdvance += u.xAdvance), u.yAdvance != null && (m.yAdvance += u.yAdvance), u.xPlacement != null && (m.xOffset += u.xPlacement), u.yPlacement != null && (m.yOffset += u.yPlacement);
                let L = this.font._variationProcessor, Z = this.font.GDEF && this.font.GDEF.itemVariationStore;
                L && Z && (u.xPlaDevice && (m.xOffset += L.getDelta(Z, u.xPlaDevice.a, u.xPlaDevice.b)), u.yPlaDevice && (m.yOffset += L.getDelta(Z, u.yPlaDevice.a, u.yPlaDevice.b)), u.xAdvDevice && (m.xAdvance += L.getDelta(Z, u.xAdvDevice.a, u.xAdvDevice.b)), u.yAdvDevice && (m.yAdvance += L.getDelta(Z, u.yAdvDevice.a, u.yAdvDevice.b)));
              }
              applyLookup(i, u) {
                switch (i) {
                  case 1: {
                    let L = this.coverageIndex(u.coverage);
                    if (L === -1) return !1;
                    switch (u.version) {
                      case 1:
                        this.applyPositionValue(0, u.value);
                        break;
                      case 2:
                        this.applyPositionValue(0, u.values.get(L));
                        break;
                    }
                    return !0;
                  }
                  case 2: {
                    let L = this.glyphIterator.peek();
                    if (!L) return !1;
                    let Z = this.coverageIndex(u.coverage);
                    if (Z === -1) return !1;
                    switch (u.version) {
                      case 1:
                        let O = u.pairSets.get(Z);
                        for (let te of O) if (te.secondGlyph === L.id)
                          return this.applyPositionValue(0, te.value1), this.applyPositionValue(1, te.value2), !0;
                        return !1;
                      case 2:
                        let PA = this.getClassID(this.glyphIterator.cur.id, u.classDef1), VA = this.getClassID(L.id, u.classDef2);
                        if (PA === -1 || VA === -1) return !1;
                        var m = u.classRecords.get(PA).get(VA);
                        return this.applyPositionValue(0, m.value1), this.applyPositionValue(1, m.value2), !0;
                    }
                  }
                  case 3: {
                    let L = this.glyphIterator.peekIndex(), Z = this.glyphs[L];
                    if (!Z) return !1;
                    let O = u.entryExitRecords[this.coverageIndex(u.coverage)];
                    if (!O || !O.exitAnchor) return !1;
                    let PA = u.entryExitRecords[this.coverageIndex(u.coverage, Z.id)];
                    if (!PA || !PA.entryAnchor) return !1;
                    let VA = this.getAnchor(PA.entryAnchor), te = this.getAnchor(O.exitAnchor), ce = this.positions[this.glyphIterator.index], ge = this.positions[L], Ge;
                    switch (this.direction) {
                      case "ltr":
                        ce.xAdvance = te.x + ce.xOffset, Ge = VA.x + ge.xOffset, ge.xAdvance -= Ge, ge.xOffset -= Ge;
                        break;
                      case "rtl":
                        Ge = te.x + ce.xOffset, ce.xAdvance -= Ge, ce.xOffset -= Ge, ge.xAdvance = VA.x + ge.xOffset;
                        break;
                    }
                    return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = L, ce.yOffset = VA.y - te.y) : (Z.cursiveAttachment = this.glyphIterator.index, ce.yOffset = te.y - VA.y), !0;
                  }
                  case 4: {
                    let L = this.coverageIndex(u.markCoverage);
                    if (L === -1) return !1;
                    let Z = this.glyphIterator.index;
                    for (; --Z >= 0 && (this.glyphs[Z].isMark || this.glyphs[Z].ligatureComponent > 0); ) ;
                    if (Z < 0) return !1;
                    let O = this.coverageIndex(u.baseCoverage, this.glyphs[Z].id);
                    if (O === -1) return !1;
                    let PA = u.markArray[L], VA = u.baseArray[O][PA.class];
                    return this.applyAnchor(PA, VA, Z), !0;
                  }
                  case 5: {
                    let L = this.coverageIndex(u.markCoverage);
                    if (L === -1) return !1;
                    let Z = this.glyphIterator.index;
                    for (; --Z >= 0 && this.glyphs[Z].isMark; ) ;
                    if (Z < 0) return !1;
                    let O = this.coverageIndex(u.ligatureCoverage, this.glyphs[Z].id);
                    if (O === -1) return !1;
                    let PA = u.ligatureArray[O], VA = this.glyphIterator.cur, te = this.glyphs[Z], ce = te.ligatureID && te.ligatureID === VA.ligatureID && VA.ligatureComponent > 0 ? Math.min(VA.ligatureComponent, te.codePoints.length) - 1 : te.codePoints.length - 1, ge = u.markArray[L], Ge = PA[ce][ge.class];
                    return this.applyAnchor(ge, Ge, Z), !0;
                  }
                  case 6: {
                    let L = this.coverageIndex(u.mark1Coverage);
                    if (L === -1) return !1;
                    let Z = this.glyphIterator.peekIndex(-1), O = this.glyphs[Z];
                    if (!O || !O.isMark) return !1;
                    let PA = this.glyphIterator.cur, VA = !1;
                    if (PA.ligatureID === O.ligatureID ? PA.ligatureID ? PA.ligatureComponent === O.ligatureComponent && (VA = !0) : VA = !0 : (PA.ligatureID && !PA.ligatureComponent || O.ligatureID && !O.ligatureComponent) && (VA = !0), !VA) return !1;
                    let te = this.coverageIndex(u.mark2Coverage, O.id);
                    if (te === -1) return !1;
                    let ce = u.mark1Array[L], ge = u.mark2Array[te][ce.class];
                    return this.applyAnchor(ce, ge, Z), !0;
                  }
                  case 7:
                    return this.applyContext(u);
                  case 8:
                    return this.applyChainingContext(u);
                  case 9:
                    return this.applyLookup(u.lookupType, u.extension);
                  default:
                    throw new Error(`Unsupported GPOS table: ${i}`);
                }
              }
              applyAnchor(i, u, m) {
                let L = this.getAnchor(u), Z = this.getAnchor(i.markAnchor);
                this.positions[m];
                let O = this.positions[this.glyphIterator.index];
                O.xOffset = L.x - Z.x, O.yOffset = L.y - Z.y, this.glyphIterator.cur.markAttachment = m;
              }
              getAnchor(i) {
                let u = i.xCoordinate, m = i.yCoordinate, L = this.font._variationProcessor, Z = this.font.GDEF && this.font.GDEF.itemVariationStore;
                return L && Z && (i.xDeviceTable && (u += L.getDelta(Z, i.xDeviceTable.a, i.xDeviceTable.b)), i.yDeviceTable && (m += L.getDelta(Z, i.yDeviceTable.a, i.yDeviceTable.b))), {
                  x: u,
                  y: m
                };
              }
              applyFeatures(i, u, m) {
                super.applyFeatures(i, u, m);
                for (var L = 0; L < this.glyphs.length; L++) this.fixCursiveAttachment(L);
                this.fixMarkAttachment();
              }
              fixCursiveAttachment(i) {
                let u = this.glyphs[i];
                if (u.cursiveAttachment != null) {
                  let m = u.cursiveAttachment;
                  u.cursiveAttachment = null, this.fixCursiveAttachment(m), this.positions[i].yOffset += this.positions[m].yOffset;
                }
              }
              fixMarkAttachment() {
                for (let i = 0; i < this.glyphs.length; i++) {
                  let u = this.glyphs[i];
                  if (u.markAttachment != null) {
                    let m = u.markAttachment;
                    if (this.positions[i].xOffset += this.positions[m].xOffset, this.positions[i].yOffset += this.positions[m].yOffset, this.direction === "ltr") for (let L = m; L < i; L++)
                      this.positions[i].xOffset -= this.positions[L].xAdvance, this.positions[i].yOffset -= this.positions[L].yAdvance;
                    else for (let L = m + 1; L < i + 1; L++)
                      this.positions[i].xOffset += this.positions[L].xAdvance, this.positions[i].yOffset += this.positions[L].yAdvance;
                  }
                }
              }
            }
            class qc {
              setup(i) {
                this.glyphInfos = i.glyphs.map((m) => new sn(this.font, m.id, [
                  ...m.codePoints
                ]));
                let u = null;
                this.GPOSProcessor && (u = this.GPOSProcessor.selectScript(i.script, i.language, i.direction)), this.GSUBProcessor && (u = this.GSUBProcessor.selectScript(i.script, i.language, i.direction)), this.shaper = Vc(u), this.plan = new qg(this.font, u, i.direction), this.shaper.plan(this.plan, this.glyphInfos, i.features);
                for (let m in this.plan.allFeatures) i.features[m] = !0;
              }
              substitute(i) {
                this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), i.glyphs = this.glyphInfos.map((u) => this.font.getGlyph(u.id, u.codePoints)));
              }
              position(i) {
                return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(i.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, i.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(i.positions), i.direction === "rtl" && (i.glyphs.reverse(), i.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
              }
              zeroMarkAdvances(i) {
                for (let u = 0; u < this.glyphInfos.length; u++) this.glyphInfos[u].isMark && (i[u].xAdvance = 0, i[u].yAdvance = 0);
              }
              cleanup() {
                this.glyphInfos = null, this.plan = null, this.shaper = null;
              }
              getAvailableFeatures(i, u) {
                let m = [];
                return this.GSUBProcessor && (this.GSUBProcessor.selectScript(i, u), m.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(i, u), m.push(...Object.keys(this.GPOSProcessor.features))), m;
              }
              constructor(i) {
                this.font = i, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, i.GSUB && (this.GSUBProcessor = new Xc(i, i.GSUB)), i.GPOS && (this.GPOSProcessor = new Zc(i, i.GPOS));
              }
            }
            class _c {
              layout(i, u, m, L, Z) {
                if (typeof u == "string" && (Z = L, L = m, m = u, u = []), typeof i == "string") {
                  m == null && (m = pg(i));
                  var O = this.font.glyphsForString(i);
                } else {
                  if (m == null) {
                    let te = [];
                    for (let ce of i) te.push(...ce.codePoints);
                    m = mg(te);
                  }
                  var O = i;
                }
                let PA = new Pg(O, u, m, L, Z);
                return O.length === 0 ? (PA.positions = [], PA) : (this.engine && this.engine.setup && this.engine.setup(PA), this.substitute(PA), this.position(PA), this.hideDefaultIgnorables(PA.glyphs, PA.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), PA);
              }
              substitute(i) {
                this.engine && this.engine.substitute && this.engine.substitute(i);
              }
              position(i) {
                i.positions = i.glyphs.map((m) => new vg(m.advanceWidth));
                let u = null;
                this.engine && this.engine.position && (u = this.engine.position(i)), !u && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new Fg(this.font)), this.unicodeLayoutEngine.positionGlyphs(i.glyphs, i.positions)), (!u || !u.kern) && i.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new yg(this.font)), this.kernProcessor.process(i.glyphs, i.positions), i.features.kern = !0);
              }
              hideDefaultIgnorables(i, u) {
                let m = this.font.glyphForCodePoint(32);
                for (let L = 0; L < i.length; L++) this.isDefaultIgnorable(i[L].codePoints[0]) && (i[L] = m, u[L].xAdvance = 0, u[L].yAdvance = 0);
              }
              isDefaultIgnorable(i) {
                let u = i >> 16;
                if (u === 0)
                  switch (i >> 8) {
                    case 0:
                      return i === 173;
                    case 3:
                      return i === 847;
                    case 6:
                      return i === 1564;
                    case 23:
                      return 6068 <= i && i <= 6069;
                    case 24:
                      return 6155 <= i && i <= 6158;
                    case 32:
                      return 8203 <= i && i <= 8207 || 8234 <= i && i <= 8238 || 8288 <= i && i <= 8303;
                    case 254:
                      return 65024 <= i && i <= 65039 || i === 65279;
                    case 255:
                      return 65520 <= i && i <= 65528;
                    default:
                      return !1;
                  }
                else
                  switch (u) {
                    case 1:
                      return 113824 <= i && i <= 113827 || 119155 <= i && i <= 119162;
                    case 14:
                      return 917504 <= i && i <= 921599;
                    default:
                      return !1;
                  }
              }
              getAvailableFeatures(i, u) {
                let m = [];
                return this.engine && m.push(...this.engine.getAvailableFeatures(i, u)), this.font.kern && m.indexOf("kern") === -1 && m.push("kern"), m;
              }
              stringsForGlyph(i) {
                let u = /* @__PURE__ */ new Set(), m = this.font._cmapProcessor.codePointsForGlyph(i);
                for (let L of m) u.add(String.fromCodePoint(L));
                if (this.engine && this.engine.stringsForGlyph) for (let L of this.engine.stringsForGlyph(i)) u.add(L);
                return Array.from(u);
              }
              constructor(i) {
                this.font = i, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new Zg(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new qc(this.font));
              }
            }
            const $c = {
              moveTo: "M",
              lineTo: "L",
              quadraticCurveTo: "Q",
              bezierCurveTo: "C",
              closePath: "Z"
            };
            class ur {
              /**
              * Compiles the path to a JavaScript function that can be applied with
              * a graphics context in order to render the path.
              * @return {string}
              */
              toFunction() {
                return (i) => {
                  this.commands.forEach((u) => i[u.command].apply(i, u.args));
                };
              }
              /**
              * Converts the path to an SVG path data string
              * @return {string}
              */
              toSVG() {
                return this.commands.map((u) => {
                  let m = u.args.map((L) => Math.round(L * 100) / 100);
                  return `${$c[u.command]}${m.join(" ")}`;
                }).join("");
              }
              /**
              * Gets the "control box" of a path.
              * This is like the bounding box, but it includes all points including
              * control points of bezier segments and is much faster to compute than
              * the real bounding box.
              * @type {BBox}
              */
              get cbox() {
                if (!this._cbox) {
                  let i = new Rn();
                  for (let u of this.commands) for (let m = 0; m < u.args.length; m += 2) i.addPoint(u.args[m], u.args[m + 1]);
                  this._cbox = Object.freeze(i);
                }
                return this._cbox;
              }
              /**
              * Gets the exact bounding box of the path by evaluating curve segments.
              * Slower to compute than the control box, but more accurate.
              * @type {BBox}
              */
              get bbox() {
                if (this._bbox) return this._bbox;
                let i = new Rn(), u = 0, m = 0, L = (Jt) => Math.pow(1 - Jt, 3) * nt[bt] + 3 * Math.pow(1 - Jt, 2) * Jt * ot[bt] + 3 * (1 - Jt) * Math.pow(Jt, 2) * Tt[bt] + Math.pow(Jt, 3) * ui[bt];
                for (let Jt of this.commands) switch (Jt.command) {
                  case "moveTo":
                  case "lineTo":
                    let [Ue, ht] = Jt.args;
                    i.addPoint(Ue, ht), u = Ue, m = ht;
                    break;
                  case "quadraticCurveTo":
                  case "bezierCurveTo":
                    if (Jt.command === "quadraticCurveTo")
                      var [Z, O, ge, Ge] = Jt.args, PA = u + 2 / 3 * (Z - u), VA = m + 2 / 3 * (O - m), te = ge + 2 / 3 * (Z - ge), ce = Ge + 2 / 3 * (O - Ge);
                    else var [PA, VA, te, ce, ge, Ge] = Jt.args;
                    i.addPoint(ge, Ge);
                    for (var nt = [
                      u,
                      m
                    ], ot = [
                      PA,
                      VA
                    ], Tt = [
                      te,
                      ce
                    ], ui = [
                      ge,
                      Ge
                    ], bt = 0; bt <= 1; bt++) {
                      let Ut = 6 * nt[bt] - 12 * ot[bt] + 6 * Tt[bt], yi = -3 * nt[bt] + 9 * ot[bt] - 9 * Tt[bt] + 3 * ui[bt];
                      if (Jt = 3 * ot[bt] - 3 * nt[bt], yi === 0) {
                        if (Ut === 0) continue;
                        let ai = -Jt / Ut;
                        0 < ai && ai < 1 && (bt === 0 ? i.addPoint(L(ai), i.maxY) : bt === 1 && i.addPoint(i.maxX, L(ai)));
                        continue;
                      }
                      let zi = Math.pow(Ut, 2) - 4 * Jt * yi;
                      if (zi < 0) continue;
                      let ti = (-Ut + Math.sqrt(zi)) / (2 * yi);
                      0 < ti && ti < 1 && (bt === 0 ? i.addPoint(L(ti), i.maxY) : bt === 1 && i.addPoint(i.maxX, L(ti)));
                      let $i = (-Ut - Math.sqrt(zi)) / (2 * yi);
                      0 < $i && $i < 1 && (bt === 0 ? i.addPoint(L($i), i.maxY) : bt === 1 && i.addPoint(i.maxX, L($i)));
                    }
                    u = ge, m = Ge;
                    break;
                }
                return this._bbox = Object.freeze(i);
              }
              /**
              * Applies a mapping function to each point in the path.
              * @param {function} fn
              * @return {Path}
              */
              mapPoints(i) {
                let u = new ur();
                for (let m of this.commands) {
                  let L = [];
                  for (let Z = 0; Z < m.args.length; Z += 2) {
                    let [O, PA] = i(m.args[Z], m.args[Z + 1]);
                    L.push(O, PA);
                  }
                  u[m.command](...L);
                }
                return u;
              }
              /**
              * Transforms the path by the given matrix.
              */
              transform(i, u, m, L, Z, O) {
                return this.mapPoints((PA, VA) => {
                  const te = i * PA + m * VA + Z, ce = u * PA + L * VA + O;
                  return [
                    te,
                    ce
                  ];
                });
              }
              /**
              * Translates the path by the given offset.
              */
              translate(i, u) {
                return this.transform(1, 0, 0, 1, i, u);
              }
              /**
              * Rotates the path by the given angle (in radians).
              */
              rotate(i) {
                let u = Math.cos(i), m = Math.sin(i);
                return this.transform(u, m, -m, u, 0, 0);
              }
              /**
              * Scales the path.
              */
              scale(i, u = i) {
                return this.transform(i, 0, 0, u, 0, 0);
              }
              constructor() {
                this.commands = [], this._bbox = null, this._cbox = null;
              }
            }
            for (let BA of [
              "moveTo",
              "lineTo",
              "quadraticCurveTo",
              "bezierCurveTo",
              "closePath"
            ]) ur.prototype[BA] = function(...i) {
              return this._bbox = this._cbox = null, this.commands.push({
                command: BA,
                args: i
              }), this;
            };
            var $r = [
              ".notdef",
              ".null",
              "nonmarkingreturn",
              "space",
              "exclam",
              "quotedbl",
              "numbersign",
              "dollar",
              "percent",
              "ampersand",
              "quotesingle",
              "parenleft",
              "parenright",
              "asterisk",
              "plus",
              "comma",
              "hyphen",
              "period",
              "slash",
              "zero",
              "one",
              "two",
              "three",
              "four",
              "five",
              "six",
              "seven",
              "eight",
              "nine",
              "colon",
              "semicolon",
              "less",
              "equal",
              "greater",
              "question",
              "at",
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O",
              "P",
              "Q",
              "R",
              "S",
              "T",
              "U",
              "V",
              "W",
              "X",
              "Y",
              "Z",
              "bracketleft",
              "backslash",
              "bracketright",
              "asciicircum",
              "underscore",
              "grave",
              "a",
              "b",
              "c",
              "d",
              "e",
              "f",
              "g",
              "h",
              "i",
              "j",
              "k",
              "l",
              "m",
              "n",
              "o",
              "p",
              "q",
              "r",
              "s",
              "t",
              "u",
              "v",
              "w",
              "x",
              "y",
              "z",
              "braceleft",
              "bar",
              "braceright",
              "asciitilde",
              "Adieresis",
              "Aring",
              "Ccedilla",
              "Eacute",
              "Ntilde",
              "Odieresis",
              "Udieresis",
              "aacute",
              "agrave",
              "acircumflex",
              "adieresis",
              "atilde",
              "aring",
              "ccedilla",
              "eacute",
              "egrave",
              "ecircumflex",
              "edieresis",
              "iacute",
              "igrave",
              "icircumflex",
              "idieresis",
              "ntilde",
              "oacute",
              "ograve",
              "ocircumflex",
              "odieresis",
              "otilde",
              "uacute",
              "ugrave",
              "ucircumflex",
              "udieresis",
              "dagger",
              "degree",
              "cent",
              "sterling",
              "section",
              "bullet",
              "paragraph",
              "germandbls",
              "registered",
              "copyright",
              "trademark",
              "acute",
              "dieresis",
              "notequal",
              "AE",
              "Oslash",
              "infinity",
              "plusminus",
              "lessequal",
              "greaterequal",
              "yen",
              "mu",
              "partialdiff",
              "summation",
              "product",
              "pi",
              "integral",
              "ordfeminine",
              "ordmasculine",
              "Omega",
              "ae",
              "oslash",
              "questiondown",
              "exclamdown",
              "logicalnot",
              "radical",
              "florin",
              "approxequal",
              "Delta",
              "guillemotleft",
              "guillemotright",
              "ellipsis",
              "nonbreakingspace",
              "Agrave",
              "Atilde",
              "Otilde",
              "OE",
              "oe",
              "endash",
              "emdash",
              "quotedblleft",
              "quotedblright",
              "quoteleft",
              "quoteright",
              "divide",
              "lozenge",
              "ydieresis",
              "Ydieresis",
              "fraction",
              "currency",
              "guilsinglleft",
              "guilsinglright",
              "fi",
              "fl",
              "daggerdbl",
              "periodcentered",
              "quotesinglbase",
              "quotedblbase",
              "perthousand",
              "Acircumflex",
              "Ecircumflex",
              "Aacute",
              "Edieresis",
              "Egrave",
              "Iacute",
              "Icircumflex",
              "Idieresis",
              "Igrave",
              "Oacute",
              "Ocircumflex",
              "apple",
              "Ograve",
              "Uacute",
              "Ucircumflex",
              "Ugrave",
              "dotlessi",
              "circumflex",
              "tilde",
              "macron",
              "breve",
              "dotaccent",
              "ring",
              "cedilla",
              "hungarumlaut",
              "ogonek",
              "caron",
              "Lslash",
              "lslash",
              "Scaron",
              "scaron",
              "Zcaron",
              "zcaron",
              "brokenbar",
              "Eth",
              "eth",
              "Yacute",
              "yacute",
              "Thorn",
              "thorn",
              "minus",
              "multiply",
              "onesuperior",
              "twosuperior",
              "threesuperior",
              "onehalf",
              "onequarter",
              "threequarters",
              "franc",
              "Gbreve",
              "gbreve",
              "Idotaccent",
              "Scedilla",
              "scedilla",
              "Cacute",
              "cacute",
              "Ccaron",
              "ccaron",
              "dcroat"
            ];
            class un {
              _getPath() {
                return new ur();
              }
              _getCBox() {
                return this.path.cbox;
              }
              _getBBox() {
                return this.path.bbox;
              }
              _getTableMetrics(i) {
                if (this.id < i.metrics.length) return i.metrics.get(this.id);
                let u = i.metrics.get(i.metrics.length - 1);
                return {
                  advance: u ? u.advance : 0,
                  bearing: i.bearings.get(this.id - i.metrics.length) || 0
                };
              }
              _getMetrics(i) {
                if (this._metrics) return this._metrics;
                let { advance: u, bearing: m } = this._getTableMetrics(this._font.hmtx);
                if (this._font.vmtx) var { advance: L, bearing: Z } = this._getTableMetrics(this._font.vmtx);
                else {
                  let O;
                  if ((typeof i > "u" || i === null) && ({ cbox: i } = this), (O = this._font["OS/2"]) && O.version > 0)
                    var L = Math.abs(O.typoAscender - O.typoDescender), Z = O.typoAscender - i.maxY;
                  else {
                    let { hhea: PA } = this._font;
                    var L = Math.abs(PA.ascent - PA.descent), Z = PA.ascent - i.maxY;
                  }
                }
                return this._font._variationProcessor && this._font.HVAR && (u += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
                  advanceWidth: u,
                  advanceHeight: L,
                  leftBearing: m,
                  topBearing: Z
                };
              }
              /**
              * The glyph’s control box.
              * This is often the same as the bounding box, but is faster to compute.
              * Because of the way bezier curves are defined, some of the control points
              * can be outside of the bounding box. Where `bbox` takes this into account,
              * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
              * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
              * for a more detailed description.
              *
              * @type {BBox}
              */
              get cbox() {
                return this._getCBox();
              }
              /**
              * The glyph’s bounding box, i.e. the rectangle that encloses the
              * glyph outline as tightly as possible.
              * @type {BBox}
              */
              get bbox() {
                return this._getBBox();
              }
              /**
              * A vector Path object representing the glyph outline.
              * @type {Path}
              */
              get path() {
                return this._getPath();
              }
              /**
              * Returns a path scaled to the given font size.
              * @param {number} size
              * @return {Path}
              */
              getScaledPath(i) {
                let u = 1 / this._font.unitsPerEm * i;
                return this.path.scale(u);
              }
              /**
              * The glyph's advance width.
              * @type {number}
              */
              get advanceWidth() {
                return this._getMetrics().advanceWidth;
              }
              /**
              * The glyph's advance height.
              * @type {number}
              */
              get advanceHeight() {
                return this._getMetrics().advanceHeight;
              }
              get ligatureCaretPositions() {
              }
              _getName() {
                let { post: i } = this._font;
                if (!i) return null;
                switch (i.version) {
                  case 1:
                    return $r[this.id];
                  case 2:
                    let u = i.glyphNameIndex[this.id];
                    return u < $r.length ? $r[u] : i.names[u - $r.length];
                  case 2.5:
                    return $r[this.id + i.offsets[this.id]];
                  case 4:
                    return String.fromCharCode(i.map[this.id]);
                }
              }
              /**
              * The glyph's name
              * @type {string}
              */
              get name() {
                return this._getName();
              }
              /**
              * Renders the glyph to the given graphics context, at the specified font size.
              * @param {CanvasRenderingContext2d} ctx
              * @param {number} size
              */
              render(i, u) {
                i.save();
                let m = 1 / this._font.head.unitsPerEm * u;
                i.scale(m, m), this.path.toFunction()(i), i.fill(), i.restore();
              }
              constructor(i, u, m) {
                this.id = i, this.codePoints = u, this._font = m, this.isMark = this.codePoints.length > 0 && this.codePoints.every(U.isMark), this.isLigature = this.codePoints.length > 1;
              }
            }
            (0, d._)([
              uA
            ], un.prototype, "cbox", null), (0, d._)([
              uA
            ], un.prototype, "bbox", null), (0, d._)([
              uA
            ], un.prototype, "path", null), (0, d._)([
              uA
            ], un.prototype, "advanceWidth", null), (0, d._)([
              uA
            ], un.prototype, "advanceHeight", null), (0, d._)([
              uA
            ], un.prototype, "name", null);
            let fo = new A.Struct({
              numberOfContours: A.int16,
              xMin: A.int16,
              yMin: A.int16,
              xMax: A.int16,
              yMax: A.int16
            });
            const A0 = 1, e0 = 2, t0 = 4, i0 = 8, n0 = 16, r0 = 32, s0 = 1, a0 = 8, Qo = 32, o0 = 64, B0 = 128, g0 = 256;
            class an {
              copy() {
                return new an(this.onCurve, this.endContour, this.x, this.y);
              }
              constructor(i, u, m = 0, L = 0) {
                this.onCurve = i, this.endContour = u, this.x = m, this.y = L;
              }
            }
            class c0 {
              constructor(i, u, m) {
                this.glyphID = i, this.dx = u, this.dy = m, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
              }
            }
            class vs extends un {
              // Parses just the glyph header and returns the bounding box
              _getCBox(i) {
                if (this._font._variationProcessor && !i) return this.path.cbox;
                let u = this._font._getTableStream("glyf");
                u.pos += this._font.loca.offsets[this.id];
                let m = fo.decode(u), L = new Rn(m.xMin, m.yMin, m.xMax, m.yMax);
                return Object.freeze(L);
              }
              // Parses a single glyph coordinate
              _parseGlyphCoord(i, u, m, L) {
                if (m) {
                  var Z = i.readUInt8();
                  L || (Z = -Z), Z += u;
                } else if (L) var Z = u;
                else var Z = u + i.readInt16BE();
                return Z;
              }
              // Decodes the glyph data into points for simple glyphs,
              // or components for composite glyphs
              _decode() {
                let i = this._font.loca.offsets[this.id], u = this._font.loca.offsets[this.id + 1];
                if (i === u) return null;
                let m = this._font._getTableStream("glyf");
                m.pos += i;
                let L = m.pos, Z = fo.decode(m);
                return Z.numberOfContours > 0 ? this._decodeSimple(Z, m) : Z.numberOfContours < 0 && this._decodeComposite(Z, m, L), Z;
              }
              _decodeSimple(i, u) {
                i.points = [];
                let m = new A.Array(A.uint16, i.numberOfContours).decode(u);
                i.instructions = new A.Array(A.uint8, A.uint16).decode(u);
                let L = [], Z = m[m.length - 1] + 1;
                for (; L.length < Z; ) {
                  var O = u.readUInt8();
                  if (L.push(O), O & i0) {
                    let ce = u.readUInt8();
                    for (let ge = 0; ge < ce; ge++) L.push(O);
                  }
                }
                for (var PA = 0; PA < L.length; PA++) {
                  var O = L[PA];
                  let ge = new an(!!(O & A0), m.indexOf(PA) >= 0, 0, 0);
                  i.points.push(ge);
                }
                let VA = 0;
                for (var PA = 0; PA < L.length; PA++) {
                  var O = L[PA];
                  i.points[PA].x = VA = this._parseGlyphCoord(u, VA, O & e0, O & n0);
                }
                let te = 0;
                for (var PA = 0; PA < L.length; PA++) {
                  var O = L[PA];
                  i.points[PA].y = te = this._parseGlyphCoord(u, te, O & t0, O & r0);
                }
                if (this._font._variationProcessor) {
                  let ce = i.points.slice();
                  ce.push(...this._getPhantomPoints(i)), this._font._variationProcessor.transformPoints(this.id, ce), i.phantomPoints = ce.slice(-4);
                }
              }
              _decodeComposite(i, u, m = 0) {
                i.components = [];
                let L = !1, Z = Qo;
                for (; Z & Qo; ) {
                  Z = u.readUInt16BE();
                  let te = u.pos - m, ce = u.readUInt16BE();
                  if (L || (L = (Z & g0) !== 0), Z & s0)
                    var O = u.readInt16BE(), PA = u.readInt16BE();
                  else
                    var O = u.readInt8(), PA = u.readInt8();
                  var VA = new c0(ce, O, PA);
                  VA.pos = te, Z & a0 ? VA.scaleX = VA.scaleY = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824 : Z & o0 ? (VA.scaleX = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824, VA.scaleY = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824) : Z & B0 && (VA.scaleX = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824, VA.scale01 = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824, VA.scale10 = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824, VA.scaleY = (u.readUInt8() << 24 | u.readUInt8() << 16) / 1073741824), i.components.push(VA);
                }
                if (this._font._variationProcessor) {
                  let te = [];
                  for (let ce = 0; ce < i.components.length; ce++) {
                    var VA = i.components[ce];
                    te.push(new an(!0, !0, VA.dx, VA.dy));
                  }
                  te.push(...this._getPhantomPoints(i)), this._font._variationProcessor.transformPoints(this.id, te), i.phantomPoints = te.splice(-4, 4);
                  for (let ce = 0; ce < te.length; ce++) {
                    let ge = te[ce];
                    i.components[ce].dx = ge.x, i.components[ce].dy = ge.y;
                  }
                }
                return L;
              }
              _getPhantomPoints(i) {
                let u = this._getCBox(!0);
                this._metrics == null && (this._metrics = un.prototype._getMetrics.call(this, u));
                let { advanceWidth: m, advanceHeight: L, leftBearing: Z, topBearing: O } = this._metrics;
                return [
                  new an(!1, !0, i.xMin - Z, 0),
                  new an(!1, !0, i.xMin - Z + m, 0),
                  new an(!1, !0, 0, i.yMax + O),
                  new an(!1, !0, 0, i.yMax + O + L)
                ];
              }
              // Decodes font data, resolves composite glyphs, and returns an array of contours
              _getContours() {
                let i = this._decode();
                if (!i) return [];
                let u = [];
                if (i.numberOfContours < 0)
                  for (let O of i.components) {
                    let PA = this._font.getGlyph(O.glyphID)._getContours();
                    for (let VA = 0; VA < PA.length; VA++) {
                      let te = PA[VA];
                      for (let ce = 0; ce < te.length; ce++) {
                        let ge = te[ce], Ge = ge.x * O.scaleX + ge.y * O.scale01 + O.dx, nt = ge.y * O.scaleY + ge.x * O.scale10 + O.dy;
                        u.push(new an(ge.onCurve, ge.endContour, Ge, nt));
                      }
                    }
                  }
                else u = i.points || [];
                i.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = i.phantomPoints[1].x - i.phantomPoints[0].x, this._metrics.advanceHeight = i.phantomPoints[3].y - i.phantomPoints[2].y, this._metrics.leftBearing = i.xMin - i.phantomPoints[0].x, this._metrics.topBearing = i.phantomPoints[2].y - i.yMax);
                let m = [], L = [];
                for (let O = 0; O < u.length; O++) {
                  var Z = u[O];
                  L.push(Z), Z.endContour && (m.push(L), L = []);
                }
                return m;
              }
              _getMetrics() {
                if (this._metrics) return this._metrics;
                let i = this._getCBox(!0);
                return super._getMetrics(i), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
              }
              // Converts contours to a Path object that can be rendered
              _getPath() {
                let i = this._getContours(), u = new ur();
                for (let L = 0; L < i.length; L++) {
                  let Z = i[L], O = Z[0], PA = Z[Z.length - 1], VA = 0;
                  if (O.onCurve) {
                    var m = null;
                    VA = 1;
                  } else {
                    PA.onCurve ? O = PA : O = new an(!1, !1, (O.x + PA.x) / 2, (O.y + PA.y) / 2);
                    var m = O;
                  }
                  u.moveTo(O.x, O.y);
                  for (let te = VA; te < Z.length; te++) {
                    let ce = Z[te], ge = te === 0 ? O : Z[te - 1];
                    if (ge.onCurve && ce.onCurve) u.lineTo(ce.x, ce.y);
                    else if (ge.onCurve && !ce.onCurve) var m = ce;
                    else if (!ge.onCurve && !ce.onCurve) {
                      let nt = (ge.x + ce.x) / 2, ot = (ge.y + ce.y) / 2;
                      u.quadraticCurveTo(ge.x, ge.y, nt, ot);
                      var m = ce;
                    } else if (!ge.onCurve && ce.onCurve) {
                      u.quadraticCurveTo(m.x, m.y, ce.x, ce.y);
                      var m = null;
                    } else throw new Error("Unknown TTF path state");
                  }
                  m && u.quadraticCurveTo(m.x, m.y, O.x, O.y), u.closePath();
                }
                return u;
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "TTF");
              }
            }
            class l0 extends un {
              _getName() {
                return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
              }
              bias(i) {
                return i.length < 1240 ? 107 : i.length < 33900 ? 1131 : 32768;
              }
              _getPath() {
                let i = this._font.CFF2 || this._font["CFF "], { stream: u } = i, m = i.topDict.CharStrings[this.id], L = m.offset + m.length;
                u.pos = m.offset;
                let Z = new ur(), O = [], PA = [], VA = null, te = 0, ce = 0, ge = 0, Ge, nt, ot = !1;
                this._usedGsubrs = Ge = {}, this._usedSubrs = nt = {};
                let Tt = i.globalSubrIndex || [], ui = this.bias(Tt), bt = i.privateDictForGlyph(this.id) || {}, Jt = bt.Subrs || [], Ue = this.bias(Jt), ht = i.topDict.vstore && i.topDict.vstore.itemVariationStore, Ut = bt.vsindex, yi = this._font._variationProcessor;
                function zi() {
                  VA == null && (VA = O.shift() + bt.nominalWidthX);
                }
                function ti() {
                  return O.length % 2 !== 0 && zi(), te += O.length >> 1, O.length = 0;
                }
                function $i(on, Qn) {
                  ot && Z.closePath(), Z.moveTo(on, Qn), ot = !0;
                }
                let ai = function() {
                  for (; u.pos < L; ) {
                    let Xi = u.readUInt8();
                    if (Xi < 32) {
                      let fr, hn, Ln, Bi, gi, ci, li, Qr, hr, Cr, Mr, Dr, dr, Ir, yr, Pn;
                      switch (Xi) {
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                          ti();
                          break;
                        case 4:
                          O.length > 1 && zi(), ge += O.shift(), $i(ce, ge);
                          break;
                        case 5:
                          for (; O.length >= 2; )
                            ce += O.shift(), ge += O.shift(), Z.lineTo(ce, ge);
                          break;
                        case 6:
                        case 7:
                          for (Ln = Xi === 6; O.length >= 1; )
                            Ln ? ce += O.shift() : ge += O.shift(), Z.lineTo(ce, ge), Ln = !Ln;
                          break;
                        case 8:
                          for (; O.length > 0; )
                            Bi = ce + O.shift(), gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), ce = ci + O.shift(), ge = li + O.shift(), Z.bezierCurveTo(Bi, gi, ci, li, ce, ge);
                          break;
                        case 10:
                          if (fr = O.pop() + Ue, hn = Jt[fr], hn) {
                            nt[fr] = !0;
                            let Vt = u.pos, Qi = L;
                            u.pos = hn.offset, L = hn.offset + hn.length, ai(), u.pos = Vt, L = Qi;
                          }
                          break;
                        case 11:
                          if (i.version >= 2) break;
                          return;
                        case 14:
                          if (i.version >= 2) break;
                          O.length > 0 && zi(), ot && (Z.closePath(), ot = !1);
                          break;
                        case 15:
                          if (i.version < 2) throw new Error("vsindex operator not supported in CFF v1");
                          Ut = O.pop();
                          break;
                        case 16: {
                          if (i.version < 2) throw new Error("blend operator not supported in CFF v1");
                          if (!yi) throw new Error("blend operator in non-variation font");
                          let Vt = yi.getBlendVector(ht, Ut), Qi = O.pop(), bs = Qi * Vt.length, en = O.length - bs, zs = en - Qi;
                          for (let Fr = 0; Fr < Qi; Fr++) {
                            let Ts = O[zs + Fr];
                            for (let As = 0; As < Vt.length; As++) Ts += Vt[As] * O[en++];
                            O[zs + Fr] = Ts;
                          }
                          for (; bs--; ) O.pop();
                          break;
                        }
                        case 19:
                        case 20:
                          ti(), u.pos += te + 7 >> 3;
                          break;
                        case 21:
                          O.length > 2 && zi(), ce += O.shift(), ge += O.shift(), $i(ce, ge);
                          break;
                        case 22:
                          O.length > 1 && zi(), ce += O.shift(), $i(ce, ge);
                          break;
                        case 24:
                          for (; O.length >= 8; )
                            Bi = ce + O.shift(), gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), ce = ci + O.shift(), ge = li + O.shift(), Z.bezierCurveTo(Bi, gi, ci, li, ce, ge);
                          ce += O.shift(), ge += O.shift(), Z.lineTo(ce, ge);
                          break;
                        case 25:
                          for (; O.length >= 8; )
                            ce += O.shift(), ge += O.shift(), Z.lineTo(ce, ge);
                          Bi = ce + O.shift(), gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), ce = ci + O.shift(), ge = li + O.shift(), Z.bezierCurveTo(Bi, gi, ci, li, ce, ge);
                          break;
                        case 26:
                          for (O.length % 2 && (ce += O.shift()); O.length >= 4; )
                            Bi = ce, gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), ce = ci, ge = li + O.shift(), Z.bezierCurveTo(Bi, gi, ci, li, ce, ge);
                          break;
                        case 27:
                          for (O.length % 2 && (ge += O.shift()); O.length >= 4; )
                            Bi = ce + O.shift(), gi = ge, ci = Bi + O.shift(), li = gi + O.shift(), ce = ci + O.shift(), ge = li, Z.bezierCurveTo(Bi, gi, ci, li, ce, ge);
                          break;
                        case 28:
                          O.push(u.readInt16BE());
                          break;
                        case 29:
                          if (fr = O.pop() + ui, hn = Tt[fr], hn) {
                            Ge[fr] = !0;
                            let Vt = u.pos, Qi = L;
                            u.pos = hn.offset, L = hn.offset + hn.length, ai(), u.pos = Vt, L = Qi;
                          }
                          break;
                        case 30:
                        case 31:
                          for (Ln = Xi === 31; O.length >= 4; )
                            Ln ? (Bi = ce + O.shift(), gi = ge, ci = Bi + O.shift(), li = gi + O.shift(), ge = li + O.shift(), ce = ci + (O.length === 1 ? O.shift() : 0)) : (Bi = ce, gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), ce = ci + O.shift(), ge = li + (O.length === 1 ? O.shift() : 0)), Z.bezierCurveTo(Bi, gi, ci, li, ce, ge), Ln = !Ln;
                          break;
                        case 12:
                          switch (Xi = u.readUInt8(), Xi) {
                            case 3:
                              let Vt = O.pop(), Qi = O.pop();
                              O.push(Vt && Qi ? 1 : 0);
                              break;
                            case 4:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt || Qi ? 1 : 0);
                              break;
                            case 5:
                              Vt = O.pop(), O.push(Vt ? 0 : 1);
                              break;
                            case 9:
                              Vt = O.pop(), O.push(Math.abs(Vt));
                              break;
                            case 10:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt + Qi);
                              break;
                            case 11:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt - Qi);
                              break;
                            case 12:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt / Qi);
                              break;
                            case 14:
                              Vt = O.pop(), O.push(-Vt);
                              break;
                            case 15:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt === Qi ? 1 : 0);
                              break;
                            case 18:
                              O.pop();
                              break;
                            case 20:
                              let bs = O.pop(), en = O.pop();
                              PA[en] = bs;
                              break;
                            case 21:
                              en = O.pop(), O.push(PA[en] || 0);
                              break;
                            case 22:
                              let zs = O.pop(), Fr = O.pop(), Ts = O.pop(), As = O.pop();
                              O.push(Ts <= As ? zs : Fr);
                              break;
                            case 23:
                              O.push(Math.random());
                              break;
                            case 24:
                              Vt = O.pop(), Qi = O.pop(), O.push(Vt * Qi);
                              break;
                            case 26:
                              Vt = O.pop(), O.push(Math.sqrt(Vt));
                              break;
                            case 27:
                              Vt = O.pop(), O.push(Vt, Vt);
                              break;
                            case 28:
                              Vt = O.pop(), Qi = O.pop(), O.push(Qi, Vt);
                              break;
                            case 29:
                              en = O.pop(), en < 0 ? en = 0 : en > O.length - 1 && (en = O.length - 1), O.push(O[en]);
                              break;
                            case 30:
                              let Us = O.pop(), es = O.pop();
                              if (es >= 0) for (; es > 0; ) {
                                var on = O[Us - 1];
                                for (let Cn = Us - 2; Cn >= 0; Cn--) O[Cn + 1] = O[Cn];
                                O[0] = on, es--;
                              }
                              else for (; es < 0; ) {
                                var on = O[0];
                                for (let Ns = 0; Ns <= Us; Ns++) O[Ns] = O[Ns + 1];
                                O[Us - 1] = on, es++;
                              }
                              break;
                            case 34:
                              Bi = ce + O.shift(), gi = ge, ci = Bi + O.shift(), li = gi + O.shift(), Qr = ci + O.shift(), hr = li, Cr = Qr + O.shift(), Mr = hr, Dr = Cr + O.shift(), dr = Mr, Ir = Dr + O.shift(), yr = dr, ce = Ir, ge = yr, Z.bezierCurveTo(Bi, gi, ci, li, Qr, hr), Z.bezierCurveTo(Cr, Mr, Dr, dr, Ir, yr);
                              break;
                            case 35:
                              Pn = [];
                              for (let Cn = 0; Cn <= 5; Cn++)
                                ce += O.shift(), ge += O.shift(), Pn.push(ce, ge);
                              Z.bezierCurveTo(...Pn.slice(0, 6)), Z.bezierCurveTo(...Pn.slice(6)), O.shift();
                              break;
                            case 36:
                              Bi = ce + O.shift(), gi = ge + O.shift(), ci = Bi + O.shift(), li = gi + O.shift(), Qr = ci + O.shift(), hr = li, Cr = Qr + O.shift(), Mr = hr, Dr = Cr + O.shift(), dr = Mr + O.shift(), Ir = Dr + O.shift(), yr = dr, ce = Ir, ge = yr, Z.bezierCurveTo(Bi, gi, ci, li, Qr, hr), Z.bezierCurveTo(Cr, Mr, Dr, dr, Ir, yr);
                              break;
                            case 37:
                              let bo = ce, zo = ge;
                              Pn = [];
                              for (let Cn = 0; Cn <= 4; Cn++)
                                ce += O.shift(), ge += O.shift(), Pn.push(ce, ge);
                              Math.abs(ce - bo) > Math.abs(ge - zo) ? (ce += O.shift(), ge = zo) : (ce = bo, ge += O.shift()), Pn.push(ce, ge), Z.bezierCurveTo(...Pn.slice(0, 6)), Z.bezierCurveTo(...Pn.slice(6));
                              break;
                            default:
                              throw new Error(`Unknown op: 12 ${Xi}`);
                          }
                          break;
                        default:
                          throw new Error(`Unknown op: ${Xi}`);
                      }
                    } else if (Xi < 247) O.push(Xi - 139);
                    else if (Xi < 251) {
                      var Qn = u.readUInt8();
                      O.push((Xi - 247) * 256 + Qn + 108);
                    } else if (Xi < 255) {
                      var Qn = u.readUInt8();
                      O.push(-(Xi - 251) * 256 - Qn - 108);
                    } else O.push(u.readInt32BE() / 65536);
                  }
                };
                return ai(), ot && Z.closePath(), Z;
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "CFF");
              }
            }
            let E0 = new A.Struct({
              originX: A.uint16,
              originY: A.uint16,
              type: new A.String(4),
              data: new A.Buffer((BA) => BA.parent.buflen - BA._currentOffset)
            });
            class w0 extends vs {
              /**
              * Returns an object representing a glyph image at the given point size.
              * The object has a data property with a Buffer containing the actual image data,
              * along with the image type, and origin.
              *
              * @param {number} size
              * @return {object}
              */
              getImageForSize(i) {
                for (let O = 0; O < this._font.sbix.imageTables.length; O++) {
                  var u = this._font.sbix.imageTables[O];
                  if (u.ppem >= i) break;
                }
                let m = u.imageOffsets, L = m[this.id], Z = m[this.id + 1];
                return L === Z ? null : (this._font.stream.pos = L, E0.decode(this._font.stream, {
                  buflen: Z - L
                }));
              }
              render(i, u) {
                let m = this.getImageForSize(u);
                if (m != null) {
                  let L = u / this._font.unitsPerEm;
                  i.image(m.data, {
                    height: u,
                    x: m.originX,
                    y: (this.bbox.minY - m.originY) * L
                  });
                }
                this._font.sbix.flags.renderOutlines && super.render(i, u);
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "SBIX");
              }
            }
            class ho {
              constructor(i, u) {
                this.glyph = i, this.color = u;
              }
            }
            class u0 extends un {
              _getBBox() {
                let i = new Rn();
                for (let u = 0; u < this.layers.length; u++) {
                  let L = this.layers[u].glyph.bbox;
                  i.addPoint(L.minX, L.minY), i.addPoint(L.maxX, L.maxY);
                }
                return i;
              }
              /**
              * Returns an array of objects containing the glyph and color for
              * each layer in the composite color glyph.
              * @type {object[]}
              */
              get layers() {
                let i = this._font.CPAL, u = this._font.COLR, m = 0, L = u.baseGlyphRecord.length - 1;
                for (; m <= L; ) {
                  let ce = m + L >> 1;
                  var Z = u.baseGlyphRecord[ce];
                  if (this.id < Z.gid) L = ce - 1;
                  else if (this.id > Z.gid) m = ce + 1;
                  else {
                    var O = Z;
                    break;
                  }
                }
                if (O == null) {
                  var PA = this._font._getBaseGlyph(this.id), VA = {
                    red: 0,
                    green: 0,
                    blue: 0,
                    alpha: 255
                  };
                  return [
                    new ho(PA, VA)
                  ];
                }
                let te = [];
                for (let ce = O.firstLayerIndex; ce < O.firstLayerIndex + O.numLayers; ce++) {
                  var Z = u.layerRecords[ce], VA = i.colorRecords[Z.paletteIndex], PA = this._font._getBaseGlyph(Z.gid);
                  te.push(new ho(PA, VA));
                }
                return te;
              }
              render(i, u) {
                for (let { glyph: m, color: L } of this.layers)
                  i.fillColor([
                    L.red,
                    L.green,
                    L.blue
                  ], L.alpha / 255 * 100), m.render(i, u);
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "COLR");
              }
            }
            const f0 = 32768, Q0 = 4095, h0 = 32768, Co = 16384, C0 = 8192, Mo = 4095, Do = 128, Io = 127, M0 = 128, D0 = 64, d0 = 63;
            class I0 {
              normalizeCoords(i) {
                let u = [];
                for (var m = 0; m < this.font.fvar.axis.length; m++) {
                  let L = this.font.fvar.axis[m];
                  i[m] < L.defaultValue ? u.push((i[m] - L.defaultValue + Number.EPSILON) / (L.defaultValue - L.minValue + Number.EPSILON)) : u.push((i[m] - L.defaultValue + Number.EPSILON) / (L.maxValue - L.defaultValue + Number.EPSILON));
                }
                if (this.font.avar) for (var m = 0; m < this.font.avar.segment.length; m++) {
                  let Z = this.font.avar.segment[m];
                  for (let O = 0; O < Z.correspondence.length; O++) {
                    let PA = Z.correspondence[O];
                    if (O >= 1 && u[m] < PA.fromCoord) {
                      let VA = Z.correspondence[O - 1];
                      u[m] = ((u[m] - VA.fromCoord) * (PA.toCoord - VA.toCoord) + Number.EPSILON) / (PA.fromCoord - VA.fromCoord + Number.EPSILON) + VA.toCoord;
                      break;
                    }
                  }
                }
                return u;
              }
              transformPoints(i, u) {
                if (!this.font.fvar || !this.font.gvar) return;
                let { gvar: m } = this.font;
                if (i >= m.glyphCount) return;
                let L = m.offsets[i];
                if (L === m.offsets[i + 1]) return;
                let { stream: Z } = this.font;
                if (Z.pos = L, Z.pos >= Z.length) return;
                let O = Z.readUInt16BE(), PA = L + Z.readUInt16BE();
                if (O & f0) {
                  var VA = Z.pos;
                  Z.pos = PA;
                  var te = this.decodePoints();
                  PA = Z.pos, Z.pos = VA;
                }
                let ce = u.map((ui) => ui.copy());
                O &= Q0;
                for (let ui = 0; ui < O; ui++) {
                  let bt = Z.readUInt16BE(), Jt = Z.readUInt16BE();
                  if (Jt & h0) {
                    var ge = [];
                    for (let ti = 0; ti < m.axisCount; ti++) ge.push(Z.readInt16BE() / 16384);
                  } else {
                    if ((Jt & Mo) >= m.globalCoordCount) throw new Error("Invalid gvar table");
                    var ge = m.globalCoords[Jt & Mo];
                  }
                  if (Jt & Co) {
                    var Ge = [];
                    for (let ti = 0; ti < m.axisCount; ti++) Ge.push(Z.readInt16BE() / 16384);
                    var nt = [];
                    for (let ti = 0; ti < m.axisCount; ti++) nt.push(Z.readInt16BE() / 16384);
                  }
                  let Ue = this.tupleFactor(Jt, ge, Ge, nt);
                  if (Ue === 0) {
                    PA += bt;
                    continue;
                  }
                  var VA = Z.pos;
                  if (Z.pos = PA, Jt & C0) var ot = this.decodePoints();
                  else var ot = te;
                  let Ut = ot.length === 0 ? u.length : ot.length, yi = this.decodeDeltas(Ut), zi = this.decodeDeltas(Ut);
                  if (ot.length === 0) for (let ti = 0; ti < u.length; ti++) {
                    var Tt = u[ti];
                    Tt.x += Math.round(yi[ti] * Ue), Tt.y += Math.round(zi[ti] * Ue);
                  }
                  else {
                    let ti = ce.map((ai) => ai.copy()), $i = u.map(() => !1);
                    for (let ai = 0; ai < ot.length; ai++) {
                      let on = ot[ai];
                      if (on < u.length) {
                        let Qn = ti[on];
                        $i[on] = !0, Qn.x += yi[ai] * Ue, Qn.y += zi[ai] * Ue;
                      }
                    }
                    this.interpolateMissingDeltas(ti, ce, $i);
                    for (let ai = 0; ai < u.length; ai++) {
                      let on = ti[ai].x - ce[ai].x, Qn = ti[ai].y - ce[ai].y;
                      u[ai].x = Math.round(u[ai].x + on), u[ai].y = Math.round(u[ai].y + Qn);
                    }
                  }
                  PA += bt, Z.pos = VA;
                }
              }
              decodePoints() {
                let i = this.font.stream, u = i.readUInt8();
                u & Do && (u = (u & Io) << 8 | i.readUInt8());
                let m = new Uint16Array(u), L = 0, Z = 0;
                for (; L < u; ) {
                  let O = i.readUInt8(), PA = (O & Io) + 1, VA = O & Do ? i.readUInt16 : i.readUInt8;
                  for (let te = 0; te < PA && L < u; te++)
                    Z += VA.call(i), m[L++] = Z;
                }
                return m;
              }
              decodeDeltas(i) {
                let u = this.font.stream, m = 0, L = new Int16Array(i);
                for (; m < i; ) {
                  let Z = u.readUInt8(), O = (Z & d0) + 1;
                  if (Z & M0) m += O;
                  else {
                    let PA = Z & D0 ? u.readInt16BE : u.readInt8;
                    for (let VA = 0; VA < O && m < i; VA++) L[m++] = PA.call(u);
                  }
                }
                return L;
              }
              tupleFactor(i, u, m, L) {
                let Z = this.normalizedCoords, { gvar: O } = this.font, PA = 1;
                for (let VA = 0; VA < O.axisCount; VA++)
                  if (u[VA] !== 0) {
                    if (Z[VA] === 0) return 0;
                    if ((i & Co) === 0) {
                      if (Z[VA] < Math.min(0, u[VA]) || Z[VA] > Math.max(0, u[VA])) return 0;
                      PA = (PA * Z[VA] + Number.EPSILON) / (u[VA] + Number.EPSILON);
                    } else {
                      if (Z[VA] < m[VA] || Z[VA] > L[VA]) return 0;
                      Z[VA] < u[VA] ? PA = PA * (Z[VA] - m[VA] + Number.EPSILON) / (u[VA] - m[VA] + Number.EPSILON) : PA = PA * (L[VA] - Z[VA] + Number.EPSILON) / (L[VA] - u[VA] + Number.EPSILON);
                    }
                  }
                return PA;
              }
              // Interpolates points without delta values.
              // Needed for the Ø and Q glyphs in Skia.
              // Algorithm from Freetype.
              interpolateMissingDeltas(i, u, m) {
                if (i.length === 0) return;
                let L = 0;
                for (; L < i.length; ) {
                  let Z = L, O = L, PA = i[O];
                  for (; !PA.endContour; ) PA = i[++O];
                  for (; L <= O && !m[L]; ) L++;
                  if (L > O) continue;
                  let VA = L, te = L;
                  for (L++; L <= O; )
                    m[L] && (this.deltaInterpolate(te + 1, L - 1, te, L, u, i), te = L), L++;
                  te === VA ? this.deltaShift(Z, O, te, u, i) : (this.deltaInterpolate(te + 1, O, te, VA, u, i), VA > 0 && this.deltaInterpolate(Z, VA - 1, te, VA, u, i)), L = O + 1;
                }
              }
              deltaInterpolate(i, u, m, L, Z, O) {
                if (i > u) return;
                let PA = [
                  "x",
                  "y"
                ];
                for (let te = 0; te < PA.length; te++) {
                  let ce = PA[te];
                  if (Z[m][ce] > Z[L][ce]) {
                    var VA = m;
                    m = L, L = VA;
                  }
                  let ge = Z[m][ce], Ge = Z[L][ce], nt = O[m][ce], ot = O[L][ce];
                  if (ge !== Ge || nt === ot) {
                    let Tt = ge === Ge ? 0 : (ot - nt) / (Ge - ge);
                    for (let ui = i; ui <= u; ui++) {
                      let bt = Z[ui][ce];
                      bt <= ge ? bt += nt - ge : bt >= Ge ? bt += ot - Ge : bt = nt + (bt - ge) * Tt, O[ui][ce] = bt;
                    }
                  }
                }
              }
              deltaShift(i, u, m, L, Z) {
                let O = Z[m].x - L[m].x, PA = Z[m].y - L[m].y;
                if (!(O === 0 && PA === 0))
                  for (let VA = i; VA <= u; VA++) VA !== m && (Z[VA].x += O, Z[VA].y += PA);
              }
              getAdvanceAdjustment(i, u) {
                let m, L;
                if (u.advanceWidthMapping) {
                  let Z = i;
                  Z >= u.advanceWidthMapping.mapCount && (Z = u.advanceWidthMapping.mapCount - 1), u.advanceWidthMapping.entryFormat, { outerIndex: m, innerIndex: L } = u.advanceWidthMapping.mapData[Z];
                } else
                  m = 0, L = i;
                return this.getDelta(u.itemVariationStore, m, L);
              }
              // See pseudo code from `Font Variations Overview'
              // in the OpenType specification.
              getDelta(i, u, m) {
                if (u >= i.itemVariationData.length) return 0;
                let L = i.itemVariationData[u];
                if (m >= L.deltaSets.length) return 0;
                let Z = L.deltaSets[m], O = this.getBlendVector(i, u), PA = 0;
                for (let VA = 0; VA < L.regionIndexCount; VA++) PA += Z.deltas[VA] * O[VA];
                return PA;
              }
              getBlendVector(i, u) {
                let m = i.itemVariationData[u];
                if (this.blendVectors.has(m)) return this.blendVectors.get(m);
                let L = this.normalizedCoords, Z = [];
                for (let O = 0; O < m.regionIndexCount; O++) {
                  let PA = 1, VA = m.regionIndexes[O], te = i.variationRegionList.variationRegions[VA];
                  for (let ce = 0; ce < te.length; ce++) {
                    let ge = te[ce], Ge;
                    ge.startCoord > ge.peakCoord || ge.peakCoord > ge.endCoord || ge.startCoord < 0 && ge.endCoord > 0 && ge.peakCoord !== 0 || ge.peakCoord === 0 ? Ge = 1 : L[ce] < ge.startCoord || L[ce] > ge.endCoord ? Ge = 0 : L[ce] === ge.peakCoord ? Ge = 1 : L[ce] < ge.peakCoord ? Ge = (L[ce] - ge.startCoord + Number.EPSILON) / (ge.peakCoord - ge.startCoord + Number.EPSILON) : Ge = (ge.endCoord - L[ce] + Number.EPSILON) / (ge.endCoord - ge.peakCoord + Number.EPSILON), PA *= Ge;
                  }
                  Z[O] = PA;
                }
                return this.blendVectors.set(m, Z), Z;
              }
              constructor(i, u) {
                this.font = i, this.normalizedCoords = this.normalizeCoords(u), this.blendVectors = /* @__PURE__ */ new Map();
              }
            }
            Promise.resolve();
            class yo {
              includeGlyph(i) {
                return typeof i == "object" && (i = i.id), this.mapping[i] == null && (this.glyphs.push(i), this.mapping[i] = this.glyphs.length - 1), this.mapping[i];
              }
              constructor(i) {
                this.font = i, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
              }
            }
            const y0 = 1, F0 = 2, x0 = 4, p0 = 8, m0 = 16, Y0 = 32;
            class Fo {
              static size(i) {
                return i >= 0 && i <= 255 ? 1 : 2;
              }
              static encode(i, u) {
                u >= 0 && u <= 255 ? i.writeUInt8(u) : i.writeInt16BE(u);
              }
            }
            let xo = new A.Struct({
              numberOfContours: A.int16,
              xMin: A.int16,
              yMin: A.int16,
              xMax: A.int16,
              yMax: A.int16,
              endPtsOfContours: new A.Array(A.uint16, "numberOfContours"),
              instructions: new A.Array(A.uint8, A.uint16),
              flags: new A.Array(A.uint8, 0),
              xPoints: new A.Array(Fo, 0),
              yPoints: new A.Array(Fo, 0)
            });
            class P0 {
              encodeSimple(i, u = []) {
                let m = [], L = [], Z = [], O = [], PA = 0, VA = 0, te = 0, ce = 0, ge = 0;
                for (let bt = 0; bt < i.commands.length; bt++) {
                  let Jt = i.commands[bt];
                  for (let Ue = 0; Ue < Jt.args.length; Ue += 2) {
                    let ht = Jt.args[Ue], Ut = Jt.args[Ue + 1], yi = 0;
                    if (Jt.command === "quadraticCurveTo" && Ue === 2) {
                      let zi = i.commands[bt + 1];
                      if (zi && zi.command === "quadraticCurveTo") {
                        let ti = (VA + zi.args[0]) / 2, $i = (te + zi.args[1]) / 2;
                        if (ht === ti && Ut === $i) continue;
                      }
                    }
                    Jt.command === "quadraticCurveTo" && Ue === 0 || (yi |= y0), yi = this._encodePoint(ht, VA, L, yi, F0, m0), yi = this._encodePoint(Ut, te, Z, yi, x0, Y0), yi === ce && PA < 255 ? (O[O.length - 1] |= p0, PA++) : (PA > 0 && (O.push(PA), PA = 0), O.push(yi), ce = yi), VA = ht, te = Ut, ge++;
                  }
                  Jt.command === "closePath" && m.push(ge - 1);
                }
                i.commands.length > 1 && i.commands[i.commands.length - 1].command !== "closePath" && m.push(ge - 1);
                let Ge = i.bbox, nt = {
                  numberOfContours: m.length,
                  xMin: Ge.minX,
                  yMin: Ge.minY,
                  xMax: Ge.maxX,
                  yMax: Ge.maxY,
                  endPtsOfContours: m,
                  instructions: u,
                  flags: O,
                  xPoints: L,
                  yPoints: Z
                }, ot = xo.size(nt), Tt = 4 - ot % 4, ui = new A.EncodeStream(ot + Tt);
                return xo.encode(ui, nt), Tt !== 0 && ui.fill(0, Tt), ui.buffer;
              }
              _encodePoint(i, u, m, L, Z, O) {
                let PA = i - u;
                return i === u ? L |= O : (-255 <= PA && PA <= 255 && (L |= Z, PA < 0 ? PA = -PA : L |= O), m.push(PA)), L;
              }
            }
            class v0 extends yo {
              _addGlyph(i) {
                let u = this.font.getGlyph(i), m = u._decode(), L = this.font.loca.offsets[i], Z = this.font.loca.offsets[i + 1], O = this.font._getTableStream("glyf");
                O.pos += L;
                let PA = O.readBuffer(Z - L);
                if (m && m.numberOfContours < 0) {
                  PA = new Uint8Array(PA);
                  let VA = new DataView(PA.buffer);
                  for (let te of m.components)
                    i = this.includeGlyph(te.glyphID), VA.setUint16(te.pos, i);
                } else m && this.font._variationProcessor && (PA = this.glyphEncoder.encodeSimple(u.path, m.instructions));
                return this.glyf.push(PA), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
                  advance: u.advanceWidth,
                  bearing: u._getMetrics().leftBearing
                }), this.offset += PA.length, this.glyf.length - 1;
              }
              encode() {
                this.glyf = [], this.offset = 0, this.loca = {
                  offsets: [],
                  version: this.font.loca.version
                }, this.hmtx = {
                  metrics: [],
                  bearings: []
                };
                let i = 0;
                for (; i < this.glyphs.length; ) this._addGlyph(this.glyphs[i++]);
                let u = T(J)(this.font.maxp);
                u.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
                let m = T(J)(this.font.head);
                m.indexToLocFormat = this.loca.version;
                let L = T(J)(this.font.hhea);
                return L.numberOfMetrics = this.hmtx.metrics.length, Oa.toBuffer({
                  tables: {
                    head: m,
                    hhea: L,
                    loca: this.loca,
                    maxp: u,
                    "cvt ": this.font["cvt "],
                    prep: this.font.prep,
                    glyf: this.glyf,
                    hmtx: this.hmtx,
                    fpgm: this.font.fpgm
                  }
                });
              }
              constructor(i) {
                super(i), this.glyphEncoder = new P0();
              }
            }
            class b0 extends yo {
              subsetCharstrings() {
                this.charstrings = [];
                let i = {};
                for (let u of this.glyphs) {
                  this.charstrings.push(this.cff.getCharString(u));
                  let m = this.font.getGlyph(u);
                  m.path;
                  for (let L in m._usedGsubrs) i[L] = !0;
                }
                this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, i);
              }
              subsetSubrs(i, u) {
                let m = [];
                for (let L = 0; L < i.length; L++) {
                  let Z = i[L];
                  u[L] ? (this.cff.stream.pos = Z.offset, m.push(this.cff.stream.readBuffer(Z.length))) : m.push(new Uint8Array([
                    11
                  ]));
                }
                return m;
              }
              subsetFontdict(i) {
                i.FDArray = [], i.FDSelect = {
                  version: 0,
                  fds: []
                };
                let u = {}, m = [], L = {};
                for (let Z of this.glyphs) {
                  let O = this.cff.fdForGlyph(Z);
                  if (O == null) continue;
                  u[O] || (i.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[O])), m.push({}), L[O] = i.FDArray.length - 1), u[O] = !0, i.FDSelect.fds.push(L[O]);
                  let PA = this.font.getGlyph(Z);
                  PA.path;
                  for (let VA in PA._usedSubrs) m[L[O]][VA] = !0;
                }
                for (let Z = 0; Z < i.FDArray.length; Z++) {
                  let O = i.FDArray[Z];
                  delete O.FontName, O.Private && O.Private.Subrs && (O.Private = Object.assign({}, O.Private), O.Private.Subrs = this.subsetSubrs(O.Private.Subrs, m[Z]));
                }
              }
              createCIDFontdict(i) {
                let u = {};
                for (let L of this.glyphs) {
                  let Z = this.font.getGlyph(L);
                  Z.path;
                  for (let O in Z._usedSubrs) u[O] = !0;
                }
                let m = Object.assign({}, this.cff.topDict.Private);
                return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (m.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, u)), i.FDArray = [
                  {
                    Private: m
                  }
                ], i.FDSelect = {
                  version: 3,
                  nRanges: 1,
                  ranges: [
                    {
                      first: 0,
                      fd: 0
                    }
                  ],
                  sentinel: this.charstrings.length
                };
              }
              addString(i) {
                return i ? (this.strings || (this.strings = []), this.strings.push(i), Be.length + this.strings.length - 1) : null;
              }
              encode() {
                this.subsetCharstrings();
                let i = {
                  version: this.charstrings.length > 255 ? 2 : 1,
                  ranges: [
                    {
                      first: 1,
                      nLeft: this.charstrings.length - 2
                    }
                  ]
                }, u = Object.assign({}, this.cff.topDict);
                u.Private = null, u.charset = i, u.Encoding = null, u.CharStrings = this.charstrings;
                for (let L of [
                  "version",
                  "Notice",
                  "Copyright",
                  "FullName",
                  "FamilyName",
                  "Weight",
                  "PostScript",
                  "BaseFontName",
                  "FontName"
                ]) u[L] = this.addString(this.cff.string(u[L]));
                u.ROS = [
                  this.addString("Adobe"),
                  this.addString("Identity"),
                  0
                ], u.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(u) : this.createCIDFontdict(u);
                let m = {
                  version: 1,
                  hdrSize: this.cff.hdrSize,
                  offSize: 4,
                  header: this.cff.header,
                  nameIndex: [
                    this.cff.postscriptName
                  ],
                  topDictIndex: [
                    u
                  ],
                  stringIndex: this.strings,
                  globalSubrIndex: this.gsubrs
                };
                return _t.toBuffer(m);
              }
              constructor(i) {
                if (super(i), this.cff = this.font["CFF "], !this.cff) throw new Error("Not a CFF Font");
              }
            }
            class Si {
              static probe(i) {
                let u = us.decode(i.slice(0, 4));
                return u === "true" || u === "OTTO" || u === "\0\0\0";
              }
              setDefaultLanguage(i = null) {
                this.defaultLanguage = i;
              }
              _getTable(i) {
                if (!(i.tag in this._tables)) try {
                  this._tables[i.tag] = this._decodeTable(i);
                } catch {
                }
                return this._tables[i.tag];
              }
              _getTableStream(i) {
                let u = this.directory.tables[i];
                return u ? (this.stream.pos = u.offset, this.stream) : null;
              }
              _decodeDirectory() {
                return this.directory = Oa.decode(this.stream, {
                  _startOffset: 0
                });
              }
              _decodeTable(i) {
                let u = this.stream.pos, m = this._getTableStream(i.tag), L = Es[i.tag].decode(m, this, i.length);
                return this.stream.pos = u, L;
              }
              /**
              * Gets a string from the font's `name` table
              * `lang` is a BCP-47 language code.
              * @return {string}
              */
              getName(i, u = this.defaultLanguage || tA) {
                let m = this.name && this.name.records[i];
                return m && (m[u] || m[this.defaultLanguage] || m[tA] || m.en || m[Object.keys(m)[0]]) || null;
              }
              /**
              * The unique PostScript name for this font, e.g. "Helvetica-Bold"
              * @type {string}
              */
              get postscriptName() {
                return this.getName("postscriptName");
              }
              /**
              * The font's full name, e.g. "Helvetica Bold"
              * @type {string}
              */
              get fullName() {
                return this.getName("fullName");
              }
              /**
              * The font's family name, e.g. "Helvetica"
              * @type {string}
              */
              get familyName() {
                return this.getName("fontFamily");
              }
              /**
              * The font's sub-family, e.g. "Bold".
              * @type {string}
              */
              get subfamilyName() {
                return this.getName("fontSubfamily");
              }
              /**
              * The font's copyright information
              * @type {string}
              */
              get copyright() {
                return this.getName("copyright");
              }
              /**
              * The font's version number
              * @type {string}
              */
              get version() {
                return this.getName("version");
              }
              /**
              * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
              * @type {number}
              */
              get ascent() {
                return this.hhea.ascent;
              }
              /**
              * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
              * @type {number}
              */
              get descent() {
                return this.hhea.descent;
              }
              /**
              * The amount of space that should be included between lines
              * @type {number}
              */
              get lineGap() {
                return this.hhea.lineGap;
              }
              /**
              * The offset from the normal underline position that should be used
              * @type {number}
              */
              get underlinePosition() {
                return this.post.underlinePosition;
              }
              /**
              * The weight of the underline that should be used
              * @type {number}
              */
              get underlineThickness() {
                return this.post.underlineThickness;
              }
              /**
              * If this is an italic font, the angle the cursor should be drawn at to match the font design
              * @type {number}
              */
              get italicAngle() {
                return this.post.italicAngle;
              }
              /**
              * The height of capital letters above the baseline.
              * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
              * @type {number}
              */
              get capHeight() {
                let i = this["OS/2"];
                return i ? i.capHeight : this.ascent;
              }
              /**
              * The height of lower case letters in the font.
              * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
              * @type {number}
              */
              get xHeight() {
                let i = this["OS/2"];
                return i ? i.xHeight : 0;
              }
              /**
              * The number of glyphs in the font.
              * @type {number}
              */
              get numGlyphs() {
                return this.maxp.numGlyphs;
              }
              /**
              * The size of the font’s internal coordinate grid
              * @type {number}
              */
              get unitsPerEm() {
                return this.head.unitsPerEm;
              }
              /**
              * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
              * @type {BBox}
              */
              get bbox() {
                return Object.freeze(new Rn(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
              }
              get _cmapProcessor() {
                return new na(this.cmap);
              }
              /**
              * An array of all of the unicode code points supported by the font.
              * @type {number[]}
              */
              get characterSet() {
                return this._cmapProcessor.getCharacterSet();
              }
              /**
              * Returns whether there is glyph in the font for the given unicode code point.
              *
              * @param {number} codePoint
              * @return {boolean}
              */
              hasGlyphForCodePoint(i) {
                return !!this._cmapProcessor.lookup(i);
              }
              /**
              * Maps a single unicode code point to a Glyph object.
              * Does not perform any advanced substitutions (there is no context to do so).
              *
              * @param {number} codePoint
              * @return {Glyph}
              */
              glyphForCodePoint(i) {
                return this.getGlyph(this._cmapProcessor.lookup(i), [
                  i
                ]);
              }
              /**
              * Returns an array of Glyph objects for the given string.
              * This is only a one-to-one mapping from characters to glyphs.
              * For most uses, you should use font.layout (described below), which
              * provides a much more advanced mapping supporting AAT and OpenType shaping.
              *
              * @param {string} string
              * @return {Glyph[]}
              */
              glyphsForString(i) {
                let u = [], m = i.length, L = 0, Z = -1, O = -1;
                for (; L <= m; ) {
                  let PA = 0, VA = 0;
                  if (L < m) {
                    if (PA = i.charCodeAt(L++), 55296 <= PA && PA <= 56319 && L < m) {
                      let te = i.charCodeAt(L);
                      56320 <= te && te <= 57343 && (L++, PA = ((PA & 1023) << 10) + (te & 1023) + 65536);
                    }
                    VA = 65024 <= PA && PA <= 65039 || 917760 <= PA && PA <= 917999 ? 1 : 0;
                  } else L++;
                  O === 0 && VA === 1 ? u.push(this.getGlyph(this._cmapProcessor.lookup(Z, PA), [
                    Z,
                    PA
                  ])) : O === 0 && VA === 0 && u.push(this.glyphForCodePoint(Z)), Z = PA, O = VA;
                }
                return u;
              }
              get _layoutEngine() {
                return new _c(this);
              }
              /**
              * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
              *
              * @param {string} string
              * @param {string[]} [userFeatures]
              * @param {string} [script]
              * @param {string} [language]
              * @param {string} [direction]
              * @return {GlyphRun}
              */
              layout(i, u, m, L, Z) {
                return this._layoutEngine.layout(i, u, m, L, Z);
              }
              /**
              * Returns an array of strings that map to the given glyph id.
              * @param {number} gid - glyph id
              */
              stringsForGlyph(i) {
                return this._layoutEngine.stringsForGlyph(i);
              }
              /**
              * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
              * (or mapped AAT tags) supported by the font.
              * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
              * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
              *
              * @type {string[]}
              */
              get availableFeatures() {
                return this._layoutEngine.getAvailableFeatures();
              }
              getAvailableFeatures(i, u) {
                return this._layoutEngine.getAvailableFeatures(i, u);
              }
              _getBaseGlyph(i, u = []) {
                return this._glyphs[i] || (this.directory.tables.glyf ? this._glyphs[i] = new vs(i, u, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[i] = new l0(i, u, this))), this._glyphs[i] || null;
              }
              /**
              * Returns a glyph object for the given glyph id.
              * You can pass the array of code points this glyph represents for
              * your use later, and it will be stored in the glyph object.
              *
              * @param {number} glyph
              * @param {number[]} characters
              * @return {Glyph}
              */
              getGlyph(i, u = []) {
                return this._glyphs[i] || (this.directory.tables.sbix ? this._glyphs[i] = new w0(i, u, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[i] = new u0(i, u, this) : this._getBaseGlyph(i, u)), this._glyphs[i] || null;
              }
              /**
              * Returns a Subset for this font.
              * @return {Subset}
              */
              createSubset() {
                return this.directory.tables["CFF "] ? new b0(this) : new v0(this);
              }
              /**
              * Returns an object describing the available variation axes
              * that this font supports. Keys are setting tags, and values
              * contain the axis name, range, and default value.
              *
              * @type {object}
              */
              get variationAxes() {
                let i = {};
                if (!this.fvar) return i;
                for (let u of this.fvar.axis) i[u.axisTag.trim()] = {
                  name: u.name.en,
                  min: u.minValue,
                  default: u.defaultValue,
                  max: u.maxValue
                };
                return i;
              }
              /**
              * Returns an object describing the named variation instances
              * that the font designer has specified. Keys are variation names
              * and values are the variation settings for this instance.
              *
              * @type {object}
              */
              get namedVariations() {
                let i = {};
                if (!this.fvar) return i;
                for (let u of this.fvar.instance) {
                  let m = {};
                  for (let L = 0; L < this.fvar.axis.length; L++) {
                    let Z = this.fvar.axis[L];
                    m[Z.axisTag.trim()] = u.coord[L];
                  }
                  i[u.name.en] = m;
                }
                return i;
              }
              /**
              * Returns a new font with the given variation settings applied.
              * Settings can either be an instance name, or an object containing
              * variation tags as specified by the `variationAxes` property.
              *
              * @param {object} settings
              * @return {TTFFont}
              */
              getVariation(i) {
                if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
                if (typeof i == "string" && (i = this.namedVariations[i]), typeof i != "object") throw new Error("Variation settings must be either a variation name or settings object.");
                let u = this.fvar.axis.map((Z, O) => {
                  let PA = Z.axisTag.trim();
                  return PA in i ? Math.max(Z.minValue, Math.min(Z.maxValue, i[PA])) : Z.defaultValue;
                }), m = new A.DecodeStream(this.stream.buffer);
                m.pos = this._directoryPos;
                let L = new Si(m, u);
                return L._tables = this._tables, L;
              }
              get _variationProcessor() {
                if (!this.fvar) return null;
                let i = this.variationCoords;
                return !i && !this.CFF2 ? null : (i || (i = this.fvar.axis.map((u) => u.defaultValue)), new I0(this, i));
              }
              // Standardized format plugin API
              getFont(i) {
                return this.getVariation(i);
              }
              constructor(i, u = null) {
                (0, a._)(this, "type", "TTF"), this.defaultLanguage = null, this.stream = i, this.variationCoords = u, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
                for (let m in this.directory.tables) {
                  let L = this.directory.tables[m];
                  Es[m] && L.length > 0 && Object.defineProperty(this, m, {
                    get: this._getTable.bind(this, L)
                  });
                }
              }
            }
            (0, d._)([
              uA
            ], Si.prototype, "bbox", null), (0, d._)([
              uA
            ], Si.prototype, "_cmapProcessor", null), (0, d._)([
              uA
            ], Si.prototype, "characterSet", null), (0, d._)([
              uA
            ], Si.prototype, "_layoutEngine", null), (0, d._)([
              uA
            ], Si.prototype, "variationAxes", null), (0, d._)([
              uA
            ], Si.prototype, "namedVariations", null), (0, d._)([
              uA
            ], Si.prototype, "_variationProcessor", null);
            let z0 = new A.Struct({
              tag: new A.String(4),
              offset: new A.Pointer(A.uint32, "void", {
                type: "global"
              }),
              compLength: A.uint32,
              length: A.uint32,
              origChecksum: A.uint32
            }), po = new A.Struct({
              tag: new A.String(4),
              flavor: A.uint32,
              length: A.uint32,
              numTables: A.uint16,
              reserved: new A.Reserved(A.uint16),
              totalSfntSize: A.uint32,
              majorVersion: A.uint16,
              minorVersion: A.uint16,
              metaOffset: A.uint32,
              metaLength: A.uint32,
              metaOrigLength: A.uint32,
              privOffset: A.uint32,
              privLength: A.uint32,
              tables: new A.Array(z0, "numTables")
            });
            po.process = function() {
              let BA = {};
              for (let i of this.tables) BA[i.tag] = i;
              this.tables = BA;
            };
            var T0 = po;
            class U0 extends Si {
              static probe(i) {
                return us.decode(i.slice(0, 4)) === "wOFF";
              }
              _decodeDirectory() {
                this.directory = T0.decode(this.stream, {
                  _startOffset: 0
                });
              }
              _getTableStream(i) {
                let u = this.directory.tables[i];
                if (u)
                  if (this.stream.pos = u.offset, u.compLength < u.length) {
                    this.stream.pos += 2;
                    let m = new Uint8Array(u.length), L = T(q)(this.stream.readBuffer(u.compLength - 2), m);
                    return new A.DecodeStream(L);
                  } else return this.stream;
                return null;
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "WOFF");
              }
            }
            class N0 extends vs {
              _decode() {
                return this._font._transformedGlyphs[this.id];
              }
              _getCBox() {
                return this.path.bbox;
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "WOFF2");
              }
            }
            const mo = {
              decode(BA) {
                let i = 0, u = [
                  0,
                  1,
                  2,
                  3,
                  4
                ];
                for (let m = 0; m < u.length; m++) {
                  let L = BA.readUInt8();
                  if (i & 3758096384) throw new Error("Overflow");
                  if (i = i << 7 | L & 127, (L & 128) === 0) return i;
                }
                throw new Error("Bad base 128 number");
              }
            };
            let R0 = [
              "cmap",
              "head",
              "hhea",
              "hmtx",
              "maxp",
              "name",
              "OS/2",
              "post",
              "cvt ",
              "fpgm",
              "glyf",
              "loca",
              "prep",
              "CFF ",
              "VORG",
              "EBDT",
              "EBLC",
              "gasp",
              "hdmx",
              "kern",
              "LTSH",
              "PCLT",
              "VDMX",
              "vhea",
              "vmtx",
              "BASE",
              "GDEF",
              "GPOS",
              "GSUB",
              "EBSC",
              "JSTF",
              "MATH",
              "CBDT",
              "CBLC",
              "COLR",
              "CPAL",
              "SVG ",
              "sbix",
              "acnt",
              "avar",
              "bdat",
              "bloc",
              "bsln",
              "cvar",
              "fdsc",
              "feat",
              "fmtx",
              "fvar",
              "gvar",
              "hsty",
              "just",
              "lcar",
              "mort",
              "morx",
              "opbd",
              "prop",
              "trak",
              "Zapf",
              "Silf",
              "Glat",
              "Gloc",
              "Feat",
              "Sill"
            ], S0 = new A.Struct({
              flags: A.uint8,
              customTag: new A.Optional(new A.String(4), (BA) => (BA.flags & 63) === 63),
              tag: (BA) => BA.customTag || R0[BA.flags & 63],
              length: mo,
              transformVersion: (BA) => BA.flags >>> 6 & 3,
              transformed: (BA) => BA.tag === "glyf" || BA.tag === "loca" ? BA.transformVersion === 0 : BA.transformVersion !== 0,
              transformLength: new A.Optional(mo, (BA) => BA.transformed)
            }), Yo = new A.Struct({
              tag: new A.String(4),
              flavor: A.uint32,
              length: A.uint32,
              numTables: A.uint16,
              reserved: new A.Reserved(A.uint16),
              totalSfntSize: A.uint32,
              totalCompressedSize: A.uint32,
              majorVersion: A.uint16,
              minorVersion: A.uint16,
              metaOffset: A.uint32,
              metaLength: A.uint32,
              metaOrigLength: A.uint32,
              privOffset: A.uint32,
              privLength: A.uint32,
              tables: new A.Array(S0, "numTables")
            });
            Yo.process = function() {
              let BA = {};
              for (let i = 0; i < this.tables.length; i++) {
                let u = this.tables[i];
                BA[u.tag] = u;
              }
              return this.tables = BA;
            };
            var G0 = Yo;
            class H0 extends Si {
              static probe(i) {
                return us.decode(i.slice(0, 4)) === "wOF2";
              }
              _decodeDirectory() {
                this.directory = G0.decode(this.stream), this._dataPos = this.stream.pos;
              }
              _decompress() {
                if (!this._decompressed) {
                  this.stream.pos = this._dataPos;
                  let i = this.stream.readBuffer(this.directory.totalCompressedSize), u = 0;
                  for (let L in this.directory.tables) {
                    let Z = this.directory.tables[L];
                    Z.offset = u, u += Z.transformLength != null ? Z.transformLength : Z.length;
                  }
                  let m = T(AA)(i, u);
                  if (!m) throw new Error("Error decoding compressed data in WOFF2");
                  this.stream = new A.DecodeStream(m), this._decompressed = !0;
                }
              }
              _decodeTable(i) {
                return this._decompress(), super._decodeTable(i);
              }
              // Override this method to get a glyph and return our
              // custom subclass if there is a glyf table.
              _getBaseGlyph(i, u = []) {
                if (!this._glyphs[i])
                  return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[i] = new N0(i, u, this)) : super._getBaseGlyph(i, u);
              }
              _transformGlyfTable() {
                this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
                let i = L0.decode(this.stream), u = [];
                for (let L = 0; L < i.numGlyphs; L++) {
                  let Z = {}, O = i.nContours.readInt16BE();
                  if (Z.numberOfContours = O, O > 0) {
                    let PA = [], VA = 0;
                    for (let te = 0; te < O; te++) {
                      let ce = Ea(i.nPoints);
                      VA += ce, PA.push(VA);
                    }
                    Z.points = J0(i.flags, i.glyphs, VA);
                    for (let te = 0; te < O; te++) Z.points[PA[te] - 1].endContour = !0;
                    var m = Ea(i.glyphs);
                  } else if (O < 0 && vs.prototype._decodeComposite.call({
                    _font: this
                  }, Z, i.composites))
                    var m = Ea(i.glyphs);
                  u.push(Z);
                }
                this._transformedGlyphs = u;
              }
              constructor(...i) {
                super(...i), (0, a._)(this, "type", "WOFF2");
              }
            }
            class _n {
              decode(i, u) {
                return new A.DecodeStream(this._buf.decode(i, u));
              }
              constructor(i) {
                this.length = i, this._buf = new A.Buffer(i);
              }
            }
            let L0 = new A.Struct({
              version: A.uint32,
              numGlyphs: A.uint16,
              indexFormat: A.uint16,
              nContourStreamSize: A.uint32,
              nPointsStreamSize: A.uint32,
              flagStreamSize: A.uint32,
              glyphStreamSize: A.uint32,
              compositeStreamSize: A.uint32,
              bboxStreamSize: A.uint32,
              instructionStreamSize: A.uint32,
              nContours: new _n("nContourStreamSize"),
              nPoints: new _n("nPointsStreamSize"),
              flags: new _n("flagStreamSize"),
              glyphs: new _n("glyphStreamSize"),
              composites: new _n("compositeStreamSize"),
              bboxes: new _n("bboxStreamSize"),
              instructions: new _n("instructionStreamSize")
            });
            const k0 = 253, j0 = 254, O0 = 255, Po = 253;
            function Ea(BA) {
              let i = BA.readUInt8();
              return i === k0 ? BA.readUInt16BE() : i === O0 ? BA.readUInt8() + Po : i === j0 ? BA.readUInt8() + Po * 2 : i;
            }
            function fn(BA, i) {
              return BA & 1 ? i : -i;
            }
            function J0(BA, i, u) {
              let m, L = m = 0, Z = [];
              for (let VA = 0; VA < u; VA++) {
                let te = 0, ce = 0, ge = BA.readUInt8(), Ge = !(ge >> 7);
                if (ge &= 127, ge < 10)
                  te = 0, ce = fn(ge, ((ge & 14) << 7) + i.readUInt8());
                else if (ge < 20)
                  te = fn(ge, ((ge - 10 & 14) << 7) + i.readUInt8()), ce = 0;
                else if (ge < 84) {
                  var O = ge - 20, PA = i.readUInt8();
                  te = fn(ge, 1 + (O & 48) + (PA >> 4)), ce = fn(ge >> 1, 1 + ((O & 12) << 2) + (PA & 15));
                } else if (ge < 120) {
                  var O = ge - 84;
                  te = fn(ge, 1 + (O / 12 << 8) + i.readUInt8()), ce = fn(ge >> 1, 1 + (O % 12 >> 2 << 8) + i.readUInt8());
                } else if (ge < 124) {
                  var PA = i.readUInt8();
                  let ot = i.readUInt8();
                  te = fn(ge, (PA << 4) + (ot >> 4)), ce = fn(ge >> 1, ((ot & 15) << 8) + i.readUInt8());
                } else
                  te = fn(ge, i.readUInt16BE()), ce = fn(ge >> 1, i.readUInt16BE());
                L += te, m += ce, Z.push(new an(Ge, !1, L, m));
              }
              return Z;
            }
            let K0 = new A.VersionedStruct(A.uint32, {
              65536: {
                numFonts: A.uint32,
                offsets: new A.Array(A.uint32, "numFonts")
              },
              131072: {
                numFonts: A.uint32,
                offsets: new A.Array(A.uint32, "numFonts"),
                dsigTag: A.uint32,
                dsigLength: A.uint32,
                dsigOffset: A.uint32
              }
            });
            class W0 {
              static probe(i) {
                return us.decode(i.slice(0, 4)) === "ttcf";
              }
              getFont(i) {
                for (let u of this.header.offsets) {
                  let m = new A.DecodeStream(this.stream.buffer);
                  m.pos = u;
                  let L = new Si(m);
                  if (L.postscriptName === i || L.postscriptName instanceof Uint8Array && i instanceof Uint8Array && L.postscriptName.every((Z, O) => i[O] === Z)) return L;
                }
                return null;
              }
              get fonts() {
                let i = [];
                for (let u of this.header.offsets) {
                  let m = new A.DecodeStream(this.stream.buffer);
                  m.pos = u, i.push(new Si(m));
                }
                return i;
              }
              constructor(i) {
                if ((0, a._)(this, "type", "TTC"), this.stream = i, i.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
                this.header = K0.decode(i);
              }
            }
            let V0 = new A.String(A.uint8);
            new A.Struct({
              len: A.uint32,
              buf: new A.Buffer("len")
            });
            let X0 = new A.Struct({
              id: A.uint16,
              nameOffset: A.int16,
              attr: A.uint8,
              dataOffset: A.uint24,
              handle: A.uint32
            }), Z0 = new A.Struct({
              name: new A.String(4),
              maxTypeIndex: A.uint16,
              refList: new A.Pointer(A.uint16, new A.Array(X0, (BA) => BA.maxTypeIndex + 1), {
                type: "parent"
              })
            }), q0 = new A.Struct({
              length: A.uint16,
              types: new A.Array(Z0, (BA) => BA.length + 1)
            }), _0 = new A.Struct({
              reserved: new A.Reserved(A.uint8, 24),
              typeList: new A.Pointer(A.uint16, q0),
              nameListOffset: new A.Pointer(A.uint16, "void")
            }), vo = new A.Struct({
              dataOffset: A.uint32,
              map: new A.Pointer(A.uint32, _0),
              dataLength: A.uint32,
              mapLength: A.uint32
            });
            class $0 {
              static probe(i) {
                let u = new A.DecodeStream(i);
                try {
                  var m = vo.decode(u);
                } catch {
                  return !1;
                }
                for (let L of m.map.typeList.types)
                  if (L.name === "sfnt") return !0;
                return !1;
              }
              getFont(i) {
                if (!this.sfnt) return null;
                for (let u of this.sfnt.refList) {
                  let m = this.header.dataOffset + u.dataOffset + 4, L = new A.DecodeStream(this.stream.buffer.slice(m)), Z = new Si(L);
                  if (Z.postscriptName === i || Z.postscriptName instanceof Uint8Array && i instanceof Uint8Array && Z.postscriptName.every((O, PA) => i[PA] === O)) return Z;
                }
                return null;
              }
              get fonts() {
                let i = [];
                for (let u of this.sfnt.refList) {
                  let m = this.header.dataOffset + u.dataOffset + 4, L = new A.DecodeStream(this.stream.buffer.slice(m));
                  i.push(new Si(L));
                }
                return i;
              }
              constructor(i) {
                (0, a._)(this, "type", "DFont"), this.stream = i, this.header = vo.decode(this.stream);
                for (let u of this.header.map.typeList.types) {
                  for (let m of u.refList) m.nameOffset >= 0 ? (this.stream.pos = m.nameOffset + this.header.map.nameListOffset, m.name = V0.decode(this.stream)) : m.name = null;
                  u.name === "sfnt" && (this.sfnt = u);
                }
              }
            }
            IA(Si), IA(U0), IA(H0), IA(W0), IA($0), K(Q.exports, H);
          },
          /***/
          2532(Q, B, r) {
            var A = r(7571), a = r(3915);
            function d(xA) {
              return xA && xA.__esModule ? xA.default : xA;
            }
            const x = 5, U = 12, P = 13, D = 16, J = 17, q = 22, AA = 28, K = 31, z = 33, T = 34, H = 35, eA = 36, CA = 37, IA = 38, k = 39, tA = 40, lA = 41, uA = 42, w = 0, v = 1, RA = 2, DA = 3, $ = 4, cA = [
              //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
              [
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                DA,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $,
                $
              ],
              [
                w,
                $,
                $,
                v,
                v,
                $,
                $,
                $,
                $,
                v,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                $,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                $,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                v,
                w,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                w,
                v,
                $,
                $,
                $,
                w,
                w,
                v,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                w,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                $,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v,
                v
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                v,
                v,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                v,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                v,
                v,
                v,
                v,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                v,
                v,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                v,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                v,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                w,
                v,
                w,
                w,
                w,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                v,
                $,
                $,
                v,
                v,
                v,
                $,
                $,
                $,
                v,
                v,
                v,
                v,
                v,
                w,
                v,
                v,
                v,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ],
              [
                w,
                $,
                $,
                v,
                v,
                w,
                $,
                $,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                $,
                RA,
                $,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                w,
                v,
                w
              ]
              // CB
            ], $A = d(a).toByteArray("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"), kA = new (d(A))($A), WA = function(xA) {
              switch (xA) {
                case z:
                  return U;
                case k:
                case tA:
                case uA:
                  return U;
                case H:
                  return x;
                default:
                  return xA;
              }
            }, EA = function(xA) {
              switch (xA) {
                case CA:
                case IA:
                  return T;
                case lA:
                  return q;
                default:
                  return xA;
              }
            };
            class zA {
              constructor(LA, yA = !1) {
                this.position = LA, this.required = yA;
              }
            }
            class OA {
              nextCodePoint() {
                const LA = this.string.charCodeAt(this.pos++), yA = this.string.charCodeAt(this.pos);
                return 55296 <= LA && LA <= 56319 && 56320 <= yA && yA <= 57343 ? (this.pos++, (LA - 55296) * 1024 + (yA - 56320) + 65536) : LA;
              }
              nextCharClass() {
                return WA(kA.get(this.nextCodePoint()));
              }
              getSimpleBreak() {
                switch (this.nextClass) {
                  case lA:
                    return !1;
                  case T:
                  case CA:
                  case IA:
                    return this.curClass = T, !1;
                  case eA:
                    return this.curClass = eA, !1;
                }
                return null;
              }
              getPairTableBreak(LA) {
                let yA = !1;
                switch (cA[this.curClass][this.nextClass]) {
                  case w:
                    yA = !0;
                    break;
                  case v:
                    yA = LA === lA;
                    break;
                  case RA:
                    if (yA = LA === lA, !yA)
                      return yA = !1, yA;
                    break;
                  case DA:
                    if (LA !== lA) return yA;
                    break;
                }
                return this.LB8a && (yA = !1), this.LB21a && (this.curClass === D || this.curClass === J) ? (yA = !1, this.LB21a = !1) : this.LB21a = this.curClass === P, this.curClass === AA ? (this.LB30a++, this.LB30a == 2 && this.nextClass === AA && (yA = !0, this.LB30a = 0)) : this.LB30a = 0, this.curClass = this.nextClass, yA;
              }
              nextBreak() {
                if (this.curClass == null) {
                  let LA = this.nextCharClass();
                  this.curClass = EA(LA), this.nextClass = LA, this.LB8a = LA === K, this.LB30a = 0;
                }
                for (; this.pos < this.string.length; ) {
                  this.lastPos = this.pos;
                  const LA = this.nextClass;
                  if (this.nextClass = this.nextCharClass(), this.curClass === T || this.curClass === eA && this.nextClass !== CA)
                    return this.curClass = EA(WA(this.nextClass)), new zA(this.lastPos, !0);
                  let yA = this.getSimpleBreak();
                  if (yA === null && (yA = this.getPairTableBreak(LA)), this.LB8a = this.nextClass === K, yA) return new zA(this.lastPos);
                }
                return this.lastPos < this.string.length ? (this.lastPos = this.string.length, new zA(this.string.length)) : null;
              }
              constructor(LA) {
                this.string = LA, this.pos = 0, this.lastPos = 0, this.curClass = null, this.nextClass = null, this.LB8a = !1, this.LB21a = !1, this.LB30a = 0;
              }
            }
            Q.exports = OA;
          },
          /***/
          5233(Q) {
            function B(G, W) {
              return Object.keys(W).forEach(function(aA) {
                aA === "default" || aA === "__esModule" || Object.prototype.hasOwnProperty.call(G, aA) || Object.defineProperty(G, aA, {
                  enumerable: !0,
                  get: function() {
                    return W[aA];
                  }
                });
              }), G;
            }
            function r(G, W, aA, j) {
              Object.defineProperty(G, W, { get: aA, set: j, enumerable: !0, configurable: !0 });
            }
            r(Q.exports, "EncodeStream", () => U), r(Q.exports, "DecodeStream", () => a), r(Q.exports, "Array", () => QA), r(Q.exports, "LazyArray", () => bA), r(Q.exports, "Bitfield", () => M), r(Q.exports, "Boolean", () => FA), r(Q.exports, "Buffer", () => dA), r(Q.exports, "Enum", () => he), r(Q.exports, "Optional", () => ie), r(Q.exports, "Reserved", () => KA), r(Q.exports, "String", () => Pe), r(Q.exports, "Struct", () => Re), r(Q.exports, "VersionedStruct", () => se);
            const A = {
              utf16le: "utf-16le",
              ucs2: "utf-16le",
              utf16be: "utf-16be"
            };
            class a {
              constructor(W) {
                this.buffer = W, this.view = new DataView(W.buffer, W.byteOffset, W.byteLength), this.pos = 0, this.length = this.buffer.length;
              }
              readString(W, aA = "ascii") {
                aA = A[aA] || aA;
                let j = this.readBuffer(W);
                try {
                  return new TextDecoder(aA).decode(j);
                } catch {
                  return j;
                }
              }
              readBuffer(W) {
                return this.buffer.slice(this.pos, this.pos += W);
              }
              readUInt24BE() {
                return (this.readUInt16BE() << 8) + this.readUInt8();
              }
              readUInt24LE() {
                return this.readUInt16LE() + (this.readUInt8() << 16);
              }
              readInt24BE() {
                return (this.readInt16BE() << 8) + this.readUInt8();
              }
              readInt24LE() {
                return this.readUInt16LE() + (this.readInt8() << 16);
              }
            }
            a.TYPES = {
              UInt8: 1,
              UInt16: 2,
              UInt24: 3,
              UInt32: 4,
              Int8: 1,
              Int16: 2,
              Int24: 3,
              Int32: 4,
              Float: 4,
              Double: 8
            };
            for (let G of Object.getOwnPropertyNames(DataView.prototype)) if (G.slice(0, 3) === "get") {
              let W = G.slice(3).replace("Ui", "UI");
              W === "Float32" ? W = "Float" : W === "Float64" && (W = "Double");
              let aA = a.TYPES[W];
              a.prototype["read" + W + (aA === 1 ? "" : "BE")] = function() {
                const j = this.view[G](this.pos, !1);
                return this.pos += aA, j;
              }, aA !== 1 && (a.prototype["read" + W + "LE"] = function() {
                const j = this.view[G](this.pos, !0);
                return this.pos += aA, j;
              });
            }
            const d = new TextEncoder(), x = new Uint8Array(new Uint16Array([
              4660
            ]).buffer)[0] == 18;
            class U {
              constructor(W) {
                this.buffer = W, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
              }
              writeBuffer(W) {
                this.buffer.set(W, this.pos), this.pos += W.length;
              }
              writeString(W, aA = "ascii") {
                let j;
                switch (aA) {
                  case "utf16le":
                  case "utf16-le":
                  case "ucs2":
                    j = P(W, x);
                    break;
                  case "utf16be":
                  case "utf16-be":
                    j = P(W, !x);
                    break;
                  case "utf8":
                    j = d.encode(W);
                    break;
                  case "ascii":
                    j = D(W);
                    break;
                  default:
                    throw new Error(`Unsupported encoding: ${aA}`);
                }
                this.writeBuffer(j);
              }
              writeUInt24BE(W) {
                this.buffer[this.pos++] = W >>> 16 & 255, this.buffer[this.pos++] = W >>> 8 & 255, this.buffer[this.pos++] = W & 255;
              }
              writeUInt24LE(W) {
                this.buffer[this.pos++] = W & 255, this.buffer[this.pos++] = W >>> 8 & 255, this.buffer[this.pos++] = W >>> 16 & 255;
              }
              writeInt24BE(W) {
                W >= 0 ? this.writeUInt24BE(W) : this.writeUInt24BE(W + 16777215 + 1);
              }
              writeInt24LE(W) {
                W >= 0 ? this.writeUInt24LE(W) : this.writeUInt24LE(W + 16777215 + 1);
              }
              fill(W, aA) {
                if (aA < this.buffer.length)
                  this.buffer.fill(W, this.pos, this.pos + aA), this.pos += aA;
                else {
                  const j = new Uint8Array(aA);
                  j.fill(W), this.writeBuffer(j);
                }
              }
            }
            function P(G, W) {
              let aA = new Uint16Array(G.length);
              for (let j = 0; j < G.length; j++) {
                let pA = G.charCodeAt(j);
                W && (pA = pA >> 8 | (pA & 255) << 8), aA[j] = pA;
              }
              return new Uint8Array(aA.buffer);
            }
            function D(G) {
              let W = new Uint8Array(G.length);
              for (let aA = 0; aA < G.length; aA++)
                W[aA] = G.charCodeAt(aA);
              return W;
            }
            for (let G of Object.getOwnPropertyNames(DataView.prototype)) if (G.slice(0, 3) === "set") {
              let W = G.slice(3).replace("Ui", "UI");
              W === "Float32" ? W = "Float" : W === "Float64" && (W = "Double");
              let aA = a.TYPES[W];
              U.prototype["write" + W + (aA === 1 ? "" : "BE")] = function(j) {
                this.view[G](this.pos, j, !1), this.pos += aA;
              }, aA !== 1 && (U.prototype["write" + W + "LE"] = function(j) {
                this.view[G](this.pos, j, !0), this.pos += aA;
              });
            }
            class J {
              fromBuffer(W) {
                let aA = new a(W);
                return this.decode(aA);
              }
              toBuffer(W) {
                let aA = this.size(W), j = new Uint8Array(aA), pA = new U(j);
                return this.encode(pA, W), j;
              }
            }
            var q = {};
            r(q, "Number", () => AA), r(q, "uint8", () => K), r(q, "uint16be", () => z), r(q, "uint16", () => T), r(q, "uint16le", () => H), r(q, "uint24be", () => eA), r(q, "uint24", () => CA), r(q, "uint24le", () => IA), r(q, "uint32be", () => k), r(q, "uint32", () => tA), r(q, "uint32le", () => lA), r(q, "int8", () => uA), r(q, "int16be", () => w), r(q, "int16", () => v), r(q, "int16le", () => RA), r(q, "int24be", () => DA), r(q, "int24", () => $), r(q, "int24le", () => cA), r(q, "int32be", () => $A), r(q, "int32", () => kA), r(q, "int32le", () => WA), r(q, "floatbe", () => EA), r(q, "float", () => zA), r(q, "floatle", () => OA), r(q, "doublebe", () => xA), r(q, "double", () => LA), r(q, "doublele", () => yA), r(q, "Fixed", () => TA), r(q, "fixed16be", () => fA), r(q, "fixed16", () => sA), r(q, "fixed16le", () => F), r(q, "fixed32be", () => o), r(q, "fixed32", () => h), r(q, "fixed32le", () => _);
            class AA extends J {
              constructor(W, aA = "BE") {
                super(), this.type = W, this.endian = aA, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
              }
              size() {
                return a.TYPES[this.type];
              }
              decode(W) {
                return W[`read${this.fn}`]();
              }
              encode(W, aA) {
                return W[`write${this.fn}`](aA);
              }
            }
            const K = new AA("UInt8"), z = new AA("UInt16", "BE"), T = z, H = new AA("UInt16", "LE"), eA = new AA("UInt24", "BE"), CA = eA, IA = new AA("UInt24", "LE"), k = new AA("UInt32", "BE"), tA = k, lA = new AA("UInt32", "LE"), uA = new AA("Int8"), w = new AA("Int16", "BE"), v = w, RA = new AA("Int16", "LE"), DA = new AA("Int24", "BE"), $ = DA, cA = new AA("Int24", "LE"), $A = new AA("Int32", "BE"), kA = $A, WA = new AA("Int32", "LE"), EA = new AA("Float", "BE"), zA = EA, OA = new AA("Float", "LE"), xA = new AA("Double", "BE"), LA = xA, yA = new AA("Double", "LE");
            class TA extends AA {
              constructor(W, aA, j = W >> 1) {
                super(`Int${W}`, aA), this._point = 1 << j;
              }
              decode(W) {
                return super.decode(W) / this._point;
              }
              encode(W, aA) {
                return super.encode(W, aA * this._point | 0);
              }
            }
            const fA = new TA(16, "BE"), sA = fA, F = new TA(16, "LE"), o = new TA(32, "BE"), h = o, _ = new TA(32, "LE");
            var oA = {};
            r(oA, "resolveLength", () => p), r(oA, "PropertyDescriptor", () => rA);
            function p(G, W, aA) {
              let j;
              if (typeof G == "number" ? j = G : typeof G == "function" ? j = G.call(aA, aA) : aA && typeof G == "string" ? j = aA[G] : W && G instanceof AA && (j = G.decode(W)), isNaN(j)) throw new Error("Not a fixed size");
              return j;
            }
            class rA {
              constructor(W = {}) {
                this.enumerable = !0, this.configurable = !0;
                for (let aA in W) {
                  const j = W[aA];
                  this[aA] = j;
                }
              }
            }
            class QA extends J {
              constructor(W, aA, j = "count") {
                super(), this.type = W, this.length = aA, this.lengthType = j;
              }
              decode(W, aA) {
                let j;
                const { pos: pA } = W, Be = [];
                let Ie = aA;
                if (this.length != null && (j = p(this.length, W, aA)), this.length instanceof AA && (Object.defineProperties(Be, {
                  parent: {
                    value: aA
                  },
                  _startOffset: {
                    value: pA
                  },
                  _currentOffset: {
                    value: 0,
                    writable: !0
                  },
                  _length: {
                    value: j
                  }
                }), Ie = Be), j == null || this.lengthType === "bytes") {
                  const ee = j != null ? W.pos + j : aA?._length ? aA._startOffset + aA._length : W.length;
                  for (; W.pos < ee; ) Be.push(this.type.decode(W, Ie));
                } else for (let ee = 0, Me = j; ee < Me; ee++) Be.push(this.type.decode(W, Ie));
                return Be;
              }
              size(W, aA, j = !0) {
                if (!W) return this.type.size(null, aA) * p(this.length, null, aA);
                let pA = 0;
                this.length instanceof AA && (pA += this.length.size(), aA = {
                  parent: aA,
                  pointerSize: 0
                });
                for (let Be of W) pA += this.type.size(Be, aA);
                return aA && j && this.length instanceof AA && (pA += aA.pointerSize), pA;
              }
              encode(W, aA, j) {
                let pA = j;
                this.length instanceof AA && (pA = {
                  pointers: [],
                  startOffset: W.pos,
                  parent: j
                }, pA.pointerOffset = W.pos + this.size(aA, pA, !1), this.length.encode(W, aA.length));
                for (let Be of aA) this.type.encode(W, Be, pA);
                if (this.length instanceof AA) {
                  let Be = 0;
                  for (; Be < pA.pointers.length; ) {
                    const Ie = pA.pointers[Be++];
                    Ie.type.encode(W, Ie.val, Ie.parent);
                  }
                }
              }
            }
            class bA extends QA {
              decode(W, aA) {
                const { pos: j } = W, pA = p(this.length, W, aA);
                this.length instanceof AA && (aA = {
                  parent: aA,
                  _startOffset: j,
                  _currentOffset: 0,
                  _length: pA
                });
                const Be = new y(this.type, pA, W, aA);
                return W.pos += pA * this.type.size(null, aA), Be;
              }
              size(W, aA) {
                return W instanceof y && (W = W.toArray()), super.size(W, aA);
              }
              encode(W, aA, j) {
                return aA instanceof y && (aA = aA.toArray()), super.encode(W, aA, j);
              }
            }
            class y {
              constructor(W, aA, j, pA) {
                this.type = W, this.length = aA, this.stream = j, this.ctx = pA, this.base = this.stream.pos, this.items = [];
              }
              get(W) {
                if (!(W < 0 || W >= this.length)) {
                  if (this.items[W] == null) {
                    const { pos: aA } = this.stream;
                    this.stream.pos = this.base + this.type.size(null, this.ctx) * W, this.items[W] = this.type.decode(this.stream, this.ctx), this.stream.pos = aA;
                  }
                  return this.items[W];
                }
              }
              toArray() {
                const W = [];
                for (let aA = 0, j = this.length; aA < j; aA++) W.push(this.get(aA));
                return W;
              }
            }
            class M extends J {
              constructor(W, aA = []) {
                super(), this.type = W, this.flags = aA;
              }
              decode(W) {
                const aA = this.type.decode(W), j = {};
                for (let pA = 0; pA < this.flags.length; pA++) {
                  const Be = this.flags[pA];
                  Be != null && (j[Be] = !!(aA & 1 << pA));
                }
                return j;
              }
              size() {
                return this.type.size();
              }
              encode(W, aA) {
                let j = 0;
                for (let pA = 0; pA < this.flags.length; pA++) {
                  const Be = this.flags[pA];
                  Be != null && aA[Be] && (j |= 1 << pA);
                }
                return this.type.encode(W, j);
              }
            }
            class FA extends J {
              constructor(W) {
                super(), this.type = W;
              }
              decode(W, aA) {
                return !!this.type.decode(W, aA);
              }
              size(W, aA) {
                return this.type.size(W, aA);
              }
              encode(W, aA, j) {
                return this.type.encode(W, +aA, j);
              }
            }
            class dA extends J {
              constructor(W) {
                super(), this.length = W;
              }
              decode(W, aA) {
                const j = p(this.length, W, aA);
                return W.readBuffer(j);
              }
              size(W, aA) {
                if (!W) return p(this.length, null, aA);
                let j = W.length;
                return this.length instanceof AA && (j += this.length.size()), j;
              }
              encode(W, aA, j) {
                return this.length instanceof AA && this.length.encode(W, aA.length), W.writeBuffer(aA);
              }
            }
            class he extends J {
              constructor(W, aA = []) {
                super(), this.type = W, this.options = aA;
              }
              decode(W) {
                const aA = this.type.decode(W);
                return this.options[aA] || aA;
              }
              size() {
                return this.type.size();
              }
              encode(W, aA) {
                const j = this.options.indexOf(aA);
                if (j === -1) throw new Error(`Unknown option in enum: ${aA}`);
                return this.type.encode(W, j);
              }
            }
            class ie extends J {
              constructor(W, aA = !0) {
                super(), this.type = W, this.condition = aA;
              }
              decode(W, aA) {
                let { condition: j } = this;
                if (typeof j == "function" && (j = j.call(aA, aA)), j) return this.type.decode(W, aA);
              }
              size(W, aA) {
                let { condition: j } = this;
                return typeof j == "function" && (j = j.call(aA, aA)), j ? this.type.size(W, aA) : 0;
              }
              encode(W, aA, j) {
                let { condition: pA } = this;
                if (typeof pA == "function" && (pA = pA.call(j, j)), pA) return this.type.encode(W, aA, j);
              }
            }
            class KA extends J {
              constructor(W, aA = 1) {
                super(), this.type = W, this.count = aA;
              }
              decode(W, aA) {
                W.pos += this.size(null, aA);
              }
              size(W, aA) {
                const j = p(this.count, null, aA);
                return this.type.size() * j;
              }
              encode(W, aA, j) {
                return W.fill(0, this.size(aA, j));
              }
            }
            class Pe extends J {
              constructor(W, aA = "ascii") {
                super(), this.length = W, this.encoding = aA;
              }
              decode(W, aA) {
                let j, pA, { encoding: Be } = this;
                typeof Be == "function" && (Be = Be.call(aA, aA) || "ascii");
                let Ie = Je(Be);
                if (this.length != null) j = p(this.length, W, aA);
                else {
                  let Me;
                  for ({ buffer: Me, length: j, pos: pA } = W; pA < j - Ie + 1 && (Me[pA] !== 0 || Ie === 2 && Me[pA + 1] !== 0); ) pA += Ie;
                  j = pA - W.pos;
                }
                const ee = W.readString(j, Be);
                return this.length == null && W.pos < W.length && (W.pos += Ie), ee;
              }
              size(W, aA) {
                if (W == null) return p(this.length, null, aA);
                let { encoding: j } = this;
                typeof j == "function" && (j = j.call(aA?.val, aA?.val) || "ascii"), j === "utf16be" && (j = "utf16le");
                let pA = Le(W, j);
                return this.length instanceof AA && (pA += this.length.size()), this.length == null && (pA += Je(j)), pA;
              }
              encode(W, aA, j) {
                let { encoding: pA } = this;
                if (typeof pA == "function" && (pA = pA.call(j?.val, j?.val) || "ascii"), this.length instanceof AA && this.length.encode(W, Le(aA, pA)), W.writeString(aA, pA), this.length == null) return Je(pA) == 2 ? W.writeUInt16LE(0) : W.writeUInt8(0);
              }
            }
            function Je(G) {
              switch (G) {
                case "ascii":
                case "utf8":
                  return 1;
                case "utf16le":
                case "utf16-le":
                case "utf-16be":
                case "utf-16le":
                case "utf16be":
                case "utf16-be":
                case "ucs2":
                  return 2;
                default:
                  return 1;
              }
            }
            function Le(G, W) {
              switch (W) {
                case "ascii":
                  return G.length;
                case "utf8":
                  let aA = 0;
                  for (let j = 0; j < G.length; j++) {
                    let pA = G.charCodeAt(j);
                    if (pA >= 55296 && pA <= 56319 && j < G.length - 1) {
                      let Be = G.charCodeAt(++j);
                      (Be & 64512) === 56320 ? pA = ((pA & 1023) << 10) + (Be & 1023) + 65536 : j--;
                    }
                    (pA & 4294967168) === 0 ? aA++ : (pA & 4294965248) === 0 ? aA += 2 : (pA & 4294901760) === 0 ? aA += 3 : (pA & 4292870144) === 0 && (aA += 4);
                  }
                  return aA;
                case "utf16le":
                case "utf16-le":
                case "utf16be":
                case "utf16-be":
                case "ucs2":
                  return G.length * 2;
                default:
                  throw new Error("Unknown encoding " + W);
              }
            }
            class Re extends J {
              constructor(W = {}) {
                super(), this.fields = W;
              }
              decode(W, aA, j = 0) {
                const pA = this._setup(W, aA, j);
                return this._parseFields(W, pA, this.fields), this.process != null && this.process.call(pA, W), pA;
              }
              _setup(W, aA, j) {
                const pA = {};
                return Object.defineProperties(pA, {
                  parent: {
                    value: aA
                  },
                  _startOffset: {
                    value: W.pos
                  },
                  _currentOffset: {
                    value: 0,
                    writable: !0
                  },
                  _length: {
                    value: j
                  }
                }), pA;
              }
              _parseFields(W, aA, j) {
                for (let Be in j) {
                  var pA;
                  const Ie = j[Be];
                  typeof Ie == "function" ? pA = Ie.call(aA, aA) : pA = Ie.decode(W, aA), pA !== void 0 && (pA instanceof rA ? Object.defineProperty(aA, Be, pA) : aA[Be] = pA), aA._currentOffset = W.pos - aA._startOffset;
                }
              }
              size(W, aA, j = !0) {
                W == null && (W = {});
                const pA = {
                  parent: aA,
                  val: W,
                  pointerSize: 0
                };
                this.preEncode != null && this.preEncode.call(W);
                let Be = 0;
                for (let Ie in this.fields) {
                  const ee = this.fields[Ie];
                  ee.size != null && (Be += ee.size(W[Ie], pA));
                }
                return j && (Be += pA.pointerSize), Be;
              }
              encode(W, aA, j) {
                let pA;
                this.preEncode != null && this.preEncode.call(aA, W);
                const Be = {
                  pointers: [],
                  startOffset: W.pos,
                  parent: j,
                  val: aA,
                  pointerSize: 0
                };
                Be.pointerOffset = W.pos + this.size(aA, Be, !1);
                for (let ee in this.fields)
                  pA = this.fields[ee], pA.encode != null && pA.encode(W, aA[ee], Be);
                let Ie = 0;
                for (; Ie < Be.pointers.length; ) {
                  const ee = Be.pointers[Ie++];
                  ee.type.encode(W, ee.val, ee.parent);
                }
              }
            }
            const _e = (G, W) => W.reduce((aA, j) => aA && aA[j], G);
            class se extends Re {
              constructor(W, aA = {}) {
                super(), this.type = W, this.versions = aA, typeof W == "string" && (this.versionPath = W.split("."));
              }
              decode(W, aA, j = 0) {
                const pA = this._setup(W, aA, j);
                typeof this.type == "string" ? pA.version = _e(aA, this.versionPath) : pA.version = this.type.decode(W), this.versions.header && this._parseFields(W, pA, this.versions.header);
                const Be = this.versions[pA.version];
                if (Be == null) throw new Error(`Unknown version ${pA.version}`);
                return Be instanceof se ? Be.decode(W, aA) : (this._parseFields(W, pA, Be), this.process != null && this.process.call(pA, W), pA);
              }
              size(W, aA, j = !0) {
                let pA, Be;
                if (!W) throw new Error("Not a fixed size");
                this.preEncode != null && this.preEncode.call(W);
                const Ie = {
                  parent: aA,
                  val: W,
                  pointerSize: 0
                };
                let ee = 0;
                if (typeof this.type != "string" && (ee += this.type.size(W.version, Ie)), this.versions.header) for (pA in this.versions.header)
                  Be = this.versions.header[pA], Be.size != null && (ee += Be.size(W[pA], Ie));
                const Me = this.versions[W.version];
                if (Me == null) throw new Error(`Unknown version ${W.version}`);
                for (pA in Me)
                  Be = Me[pA], Be.size != null && (ee += Be.size(W[pA], Ie));
                return j && (ee += Ie.pointerSize), ee;
              }
              encode(W, aA, j) {
                let pA, Be;
                this.preEncode != null && this.preEncode.call(aA, W);
                const Ie = {
                  pointers: [],
                  startOffset: W.pos,
                  parent: j,
                  val: aA,
                  pointerSize: 0
                };
                if (Ie.pointerOffset = W.pos + this.size(aA, Ie, !1), typeof this.type != "string" && this.type.encode(W, aA.version), this.versions.header) for (pA in this.versions.header)
                  Be = this.versions.header[pA], Be.encode != null && Be.encode(W, aA[pA], Ie);
                const ee = this.versions[aA.version];
                for (pA in ee)
                  Be = ee[pA], Be.encode != null && Be.encode(W, aA[pA], Ie);
                let Me = 0;
                for (; Me < Ie.pointers.length; ) {
                  const MA = Ie.pointers[Me++];
                  MA.type.encode(W, MA.val, MA.parent);
                }
              }
            }
            var Ee = {};
            r(Ee, "Pointer", () => wA), r(Ee, "VoidPointer", () => N);
            class wA extends J {
              constructor(W, aA, j = {}) {
                if (super(), this.offsetType = W, this.type = aA, this.options = j, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
                  if (typeof this.options.relativeTo != "function") throw new Error("relativeTo option must be a function");
                  this.relativeToGetter = j.relativeTo;
                }
              }
              decode(W, aA) {
                const j = this.offsetType.decode(W, aA);
                if (j === this.options.nullValue && this.options.allowNull) return null;
                let pA;
                switch (this.options.type) {
                  case "local":
                    pA = aA._startOffset;
                    break;
                  case "immediate":
                    pA = W.pos - this.offsetType.size();
                    break;
                  case "parent":
                    pA = aA.parent._startOffset;
                    break;
                  default:
                    for (var Be = aA; Be.parent; ) Be = Be.parent;
                    pA = Be._startOffset || 0;
                }
                this.options.relativeTo && (pA += this.relativeToGetter(aA));
                const Ie = j + pA;
                if (this.type != null) {
                  let ee = null;
                  const Me = () => {
                    if (ee != null) return ee;
                    const { pos: MA } = W;
                    return W.pos = Ie, ee = this.type.decode(W, aA), W.pos = MA, ee;
                  };
                  return this.options.lazy ? new rA({
                    get: Me
                  }) : Me();
                } else return Ie;
              }
              size(W, aA) {
                const j = aA;
                switch (this.options.type) {
                  case "local":
                  case "immediate":
                    break;
                  case "parent":
                    aA = aA.parent;
                    break;
                  default:
                    for (; aA.parent; ) aA = aA.parent;
                }
                let { type: pA } = this;
                if (pA == null) {
                  if (!(W instanceof N)) throw new Error("Must be a VoidPointer");
                  ({ type: pA } = W), W = W.value;
                }
                if (W && aA) {
                  let Be = pA.size(W, j);
                  aA.pointerSize += Be;
                }
                return this.offsetType.size();
              }
              encode(W, aA, j) {
                let pA;
                const Be = j;
                if (aA == null) {
                  this.offsetType.encode(W, this.options.nullValue);
                  return;
                }
                switch (this.options.type) {
                  case "local":
                    pA = j.startOffset;
                    break;
                  case "immediate":
                    pA = W.pos + this.offsetType.size(aA, Be);
                    break;
                  case "parent":
                    j = j.parent, pA = j.startOffset;
                    break;
                  default:
                    for (pA = 0; j.parent; ) j = j.parent;
                }
                this.options.relativeTo && (pA += this.relativeToGetter(Be.val)), this.offsetType.encode(W, j.pointerOffset - pA);
                let { type: Ie } = this;
                if (Ie == null) {
                  if (!(aA instanceof N)) throw new Error("Must be a VoidPointer");
                  ({ type: Ie } = aA), aA = aA.value;
                }
                return j.pointers.push({
                  type: Ie,
                  val: aA,
                  parent: Be
                }), j.pointerOffset += Ie.size(aA, Be);
              }
            }
            class N {
              constructor(W, aA) {
                this.type = W, this.value = aA;
              }
            }
            B(Q.exports, oA), B(Q.exports, q), B(Q.exports, Ee);
          },
          /***/
          4766(Q, B, r) {
            var A = r(2504), a = r(7571);
            function d(sA) {
              return sA && sA.__esModule ? sA.default : sA;
            }
            function x(sA) {
              Object.defineProperty(sA, "__esModule", { value: !0, configurable: !0 });
            }
            function U(sA, F, o, h) {
              Object.defineProperty(sA, F, { get: o, set: h, enumerable: !0, configurable: !0 });
            }
            x(Q.exports), U(Q.exports, "getCategory", () => RA), U(Q.exports, "getCombiningClass", () => DA), U(Q.exports, "getScript", () => $), U(Q.exports, "getEastAsianWidth", () => cA), U(Q.exports, "getNumericValue", () => $A), U(Q.exports, "isAlphabetic", () => kA), U(Q.exports, "isDigit", () => WA), U(Q.exports, "isPunctuation", () => EA), U(Q.exports, "isLowerCase", () => zA), U(Q.exports, "isUpperCase", () => OA), U(Q.exports, "isTitleCase", () => xA), U(Q.exports, "isWhiteSpace", () => LA), U(Q.exports, "isBaseForm", () => yA), U(Q.exports, "isMark", () => TA), U(Q.exports, "default", () => fA);
            var P = {};
            P = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
            const D = new (d(a))(d(A).toByteArray("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")), J = Math.log2 || ((sA) => Math.log(sA) / Math.LN2), q = (sA) => J(sA) + 1 | 0, AA = q((/* @__PURE__ */ d(P)).categories.length - 1), K = q((/* @__PURE__ */ d(P)).combiningClasses.length - 1), z = q((/* @__PURE__ */ d(P)).scripts.length - 1), T = q((/* @__PURE__ */ d(P)).eaw.length - 1), H = 10, eA = K + z + T + H, CA = z + T + H, IA = T + H, k = H, tA = (1 << AA) - 1, lA = (1 << K) - 1, uA = (1 << z) - 1, w = (1 << T) - 1, v = (1 << H) - 1;
            function RA(sA) {
              const F = D.get(sA);
              return (/* @__PURE__ */ d(P)).categories[F >> eA & tA];
            }
            function DA(sA) {
              const F = D.get(sA);
              return (/* @__PURE__ */ d(P)).combiningClasses[F >> CA & lA];
            }
            function $(sA) {
              const F = D.get(sA);
              return (/* @__PURE__ */ d(P)).scripts[F >> IA & uA];
            }
            function cA(sA) {
              const F = D.get(sA);
              return (/* @__PURE__ */ d(P)).eaw[F >> k & w];
            }
            function $A(sA) {
              let F = D.get(sA), o = F & v;
              if (o === 0) return null;
              if (o <= 50) return o - 1;
              if (o < 480) {
                const h = (o >> 4) - 12, _ = (o & 15) + 1;
                return h / _;
              } else if (o < 768) {
                F = (o >> 5) - 14;
                let h = (o & 31) + 2;
                for (; h > 0; )
                  F *= 10, h--;
                return F;
              } else {
                F = (o >> 2) - 191;
                let h = (o & 3) + 1;
                for (; h > 0; )
                  F *= 60, h--;
                return F;
              }
            }
            function kA(sA) {
              const F = RA(sA);
              return F === "Lu" || F === "Ll" || F === "Lt" || F === "Lm" || F === "Lo" || F === "Nl";
            }
            function WA(sA) {
              return RA(sA) === "Nd";
            }
            function EA(sA) {
              const F = RA(sA);
              return F === "Pc" || F === "Pd" || F === "Pe" || F === "Pf" || F === "Pi" || F === "Po" || F === "Ps";
            }
            function zA(sA) {
              return RA(sA) === "Ll";
            }
            function OA(sA) {
              return RA(sA) === "Lu";
            }
            function xA(sA) {
              return RA(sA) === "Lt";
            }
            function LA(sA) {
              const F = RA(sA);
              return F === "Zs" || F === "Zl" || F === "Zp";
            }
            function yA(sA) {
              const F = RA(sA);
              return F === "Nd" || F === "No" || F === "Nl" || F === "Lu" || F === "Ll" || F === "Lt" || F === "Lm" || F === "Lo" || F === "Me" || F === "Mc";
            }
            function TA(sA) {
              const F = RA(sA);
              return F === "Mn" || F === "Me" || F === "Mc";
            }
            var fA = {
              getCategory: RA,
              getCombiningClass: DA,
              getScript: $,
              getEastAsianWidth: cA,
              getNumericValue: $A,
              isAlphabetic: kA,
              isDigit: WA,
              isPunctuation: EA,
              isLowerCase: zA,
              isUpperCase: OA,
              isTitleCase: xA,
              isWhiteSpace: LA,
              isBaseForm: yA,
              isMark: TA
            };
          },
          /***/
          7507(Q, B, r) {
            var A = this && this.__importDefault || function(z) {
              return z && z.__esModule ? z : { default: z };
            };
            Object.defineProperty(B, "__esModule", { value: !0 }), B.XmlDocument = B.XmlElement = B.XmlCommentNode = B.XmlCDataNode = B.XmlTextNode = void 0;
            const a = A(r(1733));
            class d {
              /**
               * Creates a new text node
               * @param text The text content
               */
              constructor(T) {
                this.text = T, this.type = "text";
              }
              /**
               * Converts the text node to a string
               * @param options Formatting options
               * @returns String representation of the text node
               */
              toString(T) {
                return K(AA(this.text), T);
              }
              /**
               * Converts the text node to a string with indentation
               * @param indent The indentation to use
               * @param options Formatting options
               * @returns String representation of the text node with indentation
               */
              toStringWithIndent(T, H) {
                return T + this.toString(H);
              }
            }
            B.XmlTextNode = d;
            class x {
              /**
               * Creates a new CDATA node
               * @param cdata The CDATA content
               */
              constructor(T) {
                this.cdata = T, this.type = "cdata";
              }
              /**
               * Converts the CDATA node to a string
               * @param options Formatting options
               * @returns String representation of the CDATA node
               */
              toString(T) {
                return `<![CDATA[${K(this.cdata, T)}]]>`;
              }
              /**
               * Converts the CDATA node to a string with indentation
               * @param indent The indentation to use
               * @param options Formatting options
               * @returns String representation of the CDATA node with indentation
               */
              toStringWithIndent(T, H) {
                return T + this.toString(H);
              }
            }
            B.XmlCDataNode = x;
            class U {
              /**
               * Creates a new comment node
               * @param comment The comment content
               */
              constructor(T) {
                this.comment = T, this.type = "comment";
              }
              /**
               * Converts the comment node to a string
               * @param options Formatting options
               * @returns String representation of the comment node
               */
              toString(T) {
                return `<!--${K(AA(this.comment), T)}-->`;
              }
              /**
               * Converts the comment node to a string with indentation
               * @param indent The indentation to use
               * @param options Formatting options
               * @returns String representation of the comment node with indentation
               */
              toStringWithIndent(T, H) {
                return T + this.toString(H);
              }
            }
            B.XmlCommentNode = U;
            class P {
              /**
               * Creates a new XML element
               * @param tag The tag name and attributes
               * @param parser Optional SAX parser instance with position information
               */
              constructor(T, H) {
                if (this.type = "element", !H && J.length) {
                  var eA = J[J.length - 1];
                  "parser" in eA && (H = eA.parser);
                }
                this.name = T.name, this.attr = T.attributes, this.val = "", this.children = [], this.firstChild = null, this.lastChild = null, this.line = H ? H.line : null, this.column = H ? H.column : null, this.position = H ? H.position : null, this.startTagPosition = H ? H.startTagPosition : null;
              }
              /**
               * Adds a child node to this element
               * @param child The child node to add
               */
              _addChild(T) {
                this.children.push(T), this.firstChild || (this.firstChild = T), this.lastChild = T;
              }
              _opentag(T) {
                const H = new P(T);
                this._addChild(H), J.unshift(H);
              }
              _closetag() {
                J.shift();
              }
              _text(T) {
                this.val += T, this._addChild(new d(T));
              }
              _cdata(T) {
                this.val += T, this._addChild(new x(T));
              }
              _comment(T) {
                this._addChild(new U(T));
              }
              _error(T) {
                throw T;
              }
              /**
               * Iterates through each child element of this node
               * @param iterator Function to call for each child element
               * @param context Optional context to use for the iterator function
               */
              eachChild(T, H) {
                for (let eA = 0, CA = this.children.length; eA < CA; eA++) {
                  const IA = this.children[eA];
                  if (IA.type === "element" && T.call(H, IA, eA, this.children) === !1)
                    return;
                }
              }
              /**
               * Finds the first child element with the given name
               * @param name The name of the child element to find
               * @returns The first matching child element, or undefined if not found
               */
              childNamed(T) {
                for (let H = 0, eA = this.children.length; H < eA; H++) {
                  const CA = this.children[H];
                  if (CA.type === "element" && CA.name === T)
                    return CA;
                }
              }
              /**
               * Finds all child elements with the given name
               * @param name The name of the child elements to find
               * @returns Array of matching child elements
               */
              childrenNamed(T) {
                const H = [];
                for (let eA = 0, CA = this.children.length; eA < CA; eA++) {
                  const IA = this.children[eA];
                  IA.type === "element" && IA.name === T && H.push(IA);
                }
                return H;
              }
              /**
               * Finds the first child element with the given attribute
               * @param name The name of the attribute to find
               * @param value Optional value the attribute should have
               * @returns The first matching child element, or undefined if not found
               */
              childWithAttribute(T, H) {
                for (let eA = 0, CA = this.children.length; eA < CA; eA++) {
                  const IA = this.children[eA];
                  if (IA.type === "element" && (H !== void 0 && IA.attr[T] === H || H === void 0 && IA.attr[T]))
                    return IA;
                }
              }
              /**
               * Finds all descendant elements with the given name, searching recursively
               * @param name The name of the descendant elements to find
               * @returns Array of matching descendant elements
               */
              descendantsNamed(T) {
                const H = [];
                for (let eA = 0, CA = this.children.length; eA < CA; eA++) {
                  const IA = this.children[eA];
                  if (IA.type === "element") {
                    const k = IA;
                    k.name === T && H.push(k), H.push(...k.descendantsNamed(T));
                  }
                }
                return H;
              }
              /**
               * Finds a descendant element using a dot-notation path
               * @param path The path to the descendant, e.g. "author.name"
               * @returns The matching descendant element, or undefined if not found
               * @example
               * // For XML: <book><author><name>John</name></author></book>
               * bookNode.descendantWithPath("author.name") // returns the <name> element
               */
              descendantWithPath(T) {
                let H = this;
                const eA = T.split(".");
                for (let CA = 0, IA = eA.length; CA < IA; CA++)
                  if (H && H.type === "element")
                    H = H.childNamed(eA[CA]);
                  else
                    return;
                return H;
              }
              /**
               * Gets the value of a descendant element or attribute using a path
               * @param path The path to the descendant or attribute, e.g. "author.name" or "author.name@id"
               * @returns The value of the descendant or attribute, or undefined if not found
               * @example
               * // For XML: <book><author><name id="1">John</name></author></book>
               * bookNode.valueWithPath("author.name")    // returns "John"
               * bookNode.valueWithPath("author.name@id") // returns "1"
               */
              valueWithPath(T) {
                const H = T.split("@"), eA = this.descendantWithPath(H[0]);
                if (eA)
                  return H.length > 1 ? eA.attr[H[1]] : eA.val;
              }
              /**
               * Converts the element to a string representation
               * @param options Formatting options
               * @returns String representation of the element
               */
              toString(T) {
                return this.toStringWithIndent("", T);
              }
              /**
               * Converts the element to a string with the specified indentation
               * @param indent The indentation to use
               * @param options Formatting options
               * @returns String representation of the element with indentation
               */
              toStringWithIndent(T, H) {
                let eA = `${T}<${this.name}`;
                const CA = H?.compressed ? "" : `
`;
                for (const IA in this.attr)
                  Object.prototype.hasOwnProperty.call(this.attr, IA) && (eA += ` ${IA}="${AA(this.attr[IA])}"`);
                if (this.children.length === 1 && this.children[0].type !== "element")
                  eA += `>${this.children[0].toString(H)}</${this.name}>`;
                else if (this.children.length) {
                  eA += `>${CA}`;
                  const IA = T + (H?.compressed ? "" : "  ");
                  for (let k = 0, tA = this.children.length; k < tA; k++)
                    eA += `${this.children[k].toStringWithIndent(IA, H)}${CA}`;
                  eA += `${T}</${this.name}>`;
                } else H?.html ? [
                  "area",
                  "base",
                  "br",
                  "col",
                  "embed",
                  "frame",
                  "hr",
                  "img",
                  "input",
                  "keygen",
                  "link",
                  "menuitem",
                  "meta",
                  "param",
                  "source",
                  "track",
                  "wbr"
                ].includes(this.name) ? eA += "/>" : eA += `></${this.name}>` : eA += "/>";
                return eA;
              }
            }
            B.XmlElement = P;
            class D extends P {
              /**
               * Creates a new XML document from an XML string
               * @param xml The XML string to parse
               * @throws {Error} If the XML is empty or invalid
               * @example
               * ```ts
               * import { XmlDocument } from 'xmldoc';
               *
               * const doc = new XmlDocument("<root><child>value</child></root>");
               * console.log(doc.childNamed("child")?.val); // "value"
               * ```
               */
              constructor(T) {
                if (super({ name: "", attributes: {} }), T = T.toString().trim(), !T)
                  throw new Error("No XML to parse!");
                this.doctype = "", this.parser = a.default.parser(!0), q(this.parser), J = [this];
                try {
                  this.parser.write(T);
                } finally {
                  delete this.parser;
                }
              }
              _opentag(T) {
                this.name === "" ? (this.name = T.name, this.attr = T.attributes) : super._opentag(T);
              }
              _doctype(T) {
                this.doctype += T;
              }
            }
            B.XmlDocument = D;
            let J = [];
            function q(z) {
              z.onopentag = (T) => {
                var H;
                return (H = J[0]) === null || H === void 0 ? void 0 : H._opentag(T);
              }, z.onclosetag = () => {
                var T;
                return (T = J[0]) === null || T === void 0 ? void 0 : T._closetag();
              }, z.ontext = (T) => {
                var H;
                return (H = J[0]) === null || H === void 0 ? void 0 : H._text(T);
              }, z.oncdata = (T) => {
                var H;
                return (H = J[0]) === null || H === void 0 ? void 0 : H._cdata(T);
              }, z.oncomment = (T) => {
                var H;
                return (H = J[0]) === null || H === void 0 ? void 0 : H._comment(T);
              }, z.ondoctype = (T) => {
                const H = J[0];
                H._doctype && H._doctype(T);
              }, z.onerror = (T) => {
                var H;
                return (H = J[0]) === null || H === void 0 ? void 0 : H._error(T);
              };
            }
            function AA(z) {
              return z.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;");
            }
            function K(z, T) {
              let H = z;
              return T?.trimmed && z.length > 25 && (H = H.substring(0, 25).trim() + "…"), T?.preserveWhitespace || (H = H.trim()), H;
            }
            B.default = D;
          },
          /***/
          1635(Q, B, r) {
            r.d(B, {
              /* harmony export */
              __decorate: () => (
                /* binding */
                A
              )
              /* harmony export */
            });
            function A(a, d, x, U) {
              var P = arguments.length, D = P < 3 ? d : U === null ? U = Object.getOwnPropertyDescriptor(d, x) : U, J;
              if (typeof Reflect == "object" && typeof Reflect.decorate == "function") D = Reflect.decorate(a, d, x, U);
              else for (var q = a.length - 1; q >= 0; q--) (J = a[q]) && (D = (P < 3 ? J(D) : P > 3 ? J(d, x, D) : J(d, x)) || D);
              return P > 3 && D && Object.defineProperty(d, x, D), D;
            }
            typeof SuppressedError == "function" && SuppressedError;
          }
          /******/
        }, E = {};
        function Y(Q) {
          var B = E[Q];
          if (B !== void 0)
            return B.exports;
          var r = E[Q] = {
            /******/
            id: Q,
            /******/
            loaded: !1,
            /******/
            exports: {}
            /******/
          };
          return c[Q].call(r.exports, r, r.exports, Y), r.loaded = !0, r.exports;
        }
        Y.amdO = {}, Y.n = (Q) => {
          var B = Q && Q.__esModule ? (
            /******/
            () => Q.default
          ) : (
            /******/
            () => Q
          );
          return Y.d(B, { a: B }), B;
        }, Y.d = (Q, B) => {
          for (var r in B)
            Y.o(B, r) && !Y.o(Q, r) && Object.defineProperty(Q, r, { enumerable: !0, get: B[r] });
        }, Y.g = (function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        })(), Y.o = (Q, B) => Object.prototype.hasOwnProperty.call(Q, B), Y.nmd = (Q) => (Q.paths = [], Q.children || (Q.children = []), Q);
        var X = Y(6092);
        return X;
      })()
    ));
  })(Ss)), Ss.exports;
}
var Il = dl();
const bn = /* @__PURE__ */ vB(Il);
var Rt = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(Rt || {}), va = /* @__PURE__ */ ((e) => (e.TRUE = "Tak", e.FALSE = "Nie", e))(va || {}), R = /* @__PURE__ */ ((e) => (e.Bold = "Bold", e.Boolean = "Boolean", e.Currency = "Currency", e.CurrencyAbs = "CurrencyAbs", e.CurrencyGreater = "CurrencyGreater", e.CurrencyGreaterWithSeparator = "CurrencyGreaterWithSeparator", e.Currency6 = "Currency6", e.Default = "Default", e.Description = "Description", e.GrayBoldTitle = "GrayBoldTitle", e.Label = "Label", e.LabelMedium = "LabelMedium", e.LabelMargin = "LabelMargin", e.LabelSmallMargin = "LabelSmallMargin", e.LabelGreater = "LabelGreater", e.Link = "Link", e.MarginBottom4 = "MarginBottom4", e.MarginBottom8 = "MarginBottom8", e.MarginTop4 = "MarginTop4", e.MarginTop8 = "MarginTop8", e.Value = "Value", e.ValueMedium = "ValueMedium", e.GrayTitle = "GrayTitle", e.HeaderContent = "HeaderContent", e.SubHeaderContent = "SubHeaderContent", e.TitleContent = "TitleContent", e.HeaderPosition = "HeaderPosition", e.Right = "Right", e.DateTime = "DateTime", e.Date = "Date", e.Time = "Time", e.FormOfPayment = "FormOfPayment", e.AccountNumber = "AccountNumber", e.Percentage = "Percentage", e.Number = "Number", e))(R || {}), bB = /* @__PURE__ */ ((e) => (e.VAT = "Faktura podstawowa", e.KOR = "Faktura korygująca", e.ZAL = "Faktura dokumentująca otrzymanie zapłaty lub jej części przed dokonaniem czynności oraz faktura wystawiona w związku z art. 106f ust. 4 ustawy", e.ROZ = "Faktura wystawiona w związku z art. 106f ust. 3 ustawy", e.UPR = "Faktura, o której mowa w art. 106e ust. 5 pkt 3 ustawy", e.KOR_ZAL = "Faktura korygująca fakturę dokumentującą otrzymanie zapłaty lub jej części przed dokonaniem czynności oraz fakturę wystawioną w związku z art. 106f ust. 4 ustawy", e.KOR_ROZ = "Faktura korygująca fakturę wystawioną w związku z art. 106f ust. 3 ustawy", e.VAT_RR = "Faktura pierwotna", e.KOR_VAT_RR = "Faktura korygująca", e))(bB || {});
const pt = Object.keys(bB).reduce(
  (e, n) => {
    const c = n;
    return e[c] = c, e;
  },
  {}
), yl = {
  1: "const.farr.correctionOriginalDate",
  2: "const.farr.correctionInvoiceDate",
  3: "const.fa.correctionOtherDate"
}, Fl = {
  23: "const.fa.taxRate23",
  22: "const.fa.taxRate22",
  8: "const.fa.taxRate8",
  7: "const.fa.taxRate7",
  5: "const.fa.taxRate5",
  4: "const.fa.taxRate4oo",
  3: "const.fa.taxRate4oo",
  0: "const.fa.taxRate0",
  zw: "const.fa.taxRateZw",
  oo: "const.fa.taxRateOo",
  np: "const.fa.taxRateNp"
}, xl = {
  23: "const.fa.taxRate23",
  22: "const.fa.taxRate22",
  8: "const.fa.taxRate8",
  7: "const.fa.taxRate7",
  5: "const.fa.taxRate5",
  4: "const.fa.taxRate4",
  3: "const.fa.taxRate3",
  0: "const.fa.taxRate0",
  zw: "const.fa.taxRateZw2",
  oo: "const.fa.taxRateRevOo",
  np: "const.fa.taxRateNp"
}, pl = {
  23: "const.fa.taxRate23",
  22: "const.fa.taxRate22",
  8: "const.fa.taxRate8",
  7: "const.fa.taxRate7",
  5: "const.fa.taxRate5",
  4: "const.fa.taxRate4",
  3: "const.fa.taxRate3",
  "0 KR": "const.fa.taxRate0KR",
  "0 WDT": "const.fa.taxRate0WDT",
  "0 EX": "const.fa.taxRate0EX",
  zw: "const.fa.zw",
  oo: "const.fa.oo",
  "np I": "const.fa.taxRateNpI",
  "np II": "const.fa.taxRateNpII"
}, kn = {
  AF: "const.countries.AF",
  AX: "const.countries.AX",
  AL: "const.countries.AL",
  DZ: "const.countries.DZ",
  AD: "const.countries.AD",
  AO: "const.countries.AO",
  AI: "const.countries.AI",
  AQ: "const.countries.AQ",
  AG: "const.countries.AG",
  AN: "const.countries.AN",
  SA: "const.countries.SA",
  AR: "const.countries.AR",
  AM: "const.countries.AM",
  AW: "const.countries.AW",
  AU: "const.countries.AU",
  AT: "const.countries.AT",
  AZ: "const.countries.AZ",
  BS: "const.countries.BS",
  BH: "const.countries.BH",
  BD: "const.countries.BD",
  BB: "const.countries.BB",
  BE: "const.countries.BE",
  BZ: "const.countries.BZ",
  BJ: "const.countries.BJ",
  BM: "const.countries.BM",
  BT: "const.countries.BT",
  BY: "const.countries.BY",
  BO: "const.countries.BO",
  BQ: "const.countries.BQ",
  BA: "const.countries.BA",
  BW: "const.countries.BW",
  BR: "const.countries.BR",
  BN: "const.countries.BN",
  IO: "const.countries.IO",
  BG: "const.countries.BG",
  BF: "const.countries.BF",
  BI: "const.countries.BI",
  XC: "const.countries.XC",
  CL: "const.countries.CL",
  CN: "const.countries.CN",
  HR: "const.countries.HR",
  CW: "const.countries.CW",
  CY: "const.countries.CY",
  TD: "const.countries.TD",
  ME: "const.countries.ME",
  DK: "const.countries.DK",
  DM: "const.countries.DM",
  DO: "const.countries.DO",
  DJ: "const.countries.DJ",
  EG: "const.countries.EG",
  EC: "const.countries.EC",
  ER: "const.countries.ER",
  EE: "const.countries.EE",
  ET: "const.countries.ET",
  FK: "const.countries.FK",
  FJ: "const.countries.FJ",
  PH: "const.countries.PH",
  FI: "const.countries.FI",
  FR: "const.countries.FR",
  TF: "const.countries.TF",
  GA: "const.countries.GA",
  GM: "const.countries.GM",
  GH: "const.countries.GH",
  GI: "const.countries.GI",
  GR: "const.countries.GR",
  GD: "const.countries.GD",
  GL: "const.countries.GL",
  GE: "const.countries.GE",
  GU: "const.countries.GU",
  GG: "const.countries.GG",
  GY: "const.countries.GY",
  GF: "const.countries.GF",
  GP: "const.countries.GP",
  GT: "const.countries.GT",
  GN: "const.countries.GN",
  GQ: "const.countries.GQ",
  GW: "const.countries.GW",
  HT: "const.countries.HT",
  ES: "const.countries.ES",
  HN: "const.countries.HN",
  HK: "const.countries.HK",
  IN: "const.countries.IN",
  ID: "const.countries.ID",
  IQ: "const.countries.IQ",
  IR: "const.countries.IR",
  IE: "const.countries.IE",
  IS: "const.countries.IS",
  IL: "const.countries.IL",
  JM: "const.countries.JM",
  JP: "const.countries.JP",
  YE: "const.countries.YE",
  JE: "const.countries.JE",
  JO: "const.countries.JO",
  KY: "const.countries.KY",
  KH: "const.countries.KH",
  CM: "const.countries.CM",
  CA: "const.countries.CA",
  QA: "const.countries.QA",
  KZ: "const.countries.KZ",
  KE: "const.countries.KE",
  KG: "const.countries.KG",
  KI: "const.countries.KI",
  CO: "const.countries.CO",
  KM: "const.countries.KM",
  CG: "const.countries.CG",
  CD: "const.countries.CD",
  KP: "const.countries.KP",
  XK: "const.countries.XK",
  CR: "const.countries.CR",
  CU: "const.countries.CU",
  KW: "const.countries.KW",
  LA: "const.countries.LA",
  LS: "const.countries.LS",
  LB: "const.countries.LB",
  LR: "const.countries.LR",
  LY: "const.countries.LY",
  LI: "const.countries.LI",
  LT: "const.countries.LT",
  LV: "const.countries.LV",
  LU: "const.countries.LU",
  MK: "const.countries.MK",
  MG: "const.countries.MG",
  YT: "const.countries.YT",
  MO: "const.countries.MO",
  MW: "const.countries.MW",
  MV: "const.countries.MV",
  MY: "const.countries.MY",
  ML: "const.countries.ML",
  MT: "const.countries.MT",
  MP: "const.countries.MP",
  MA: "const.countries.MA",
  MQ: "const.countries.MQ",
  MR: "const.countries.MR",
  MU: "const.countries.MU",
  MX: "const.countries.MX",
  XL: "const.countries.XL",
  FM: "const.countries.FM",
  UM: "const.countries.UM",
  MD: "const.countries.MD",
  MC: "const.countries.MC",
  MN: "const.countries.MN",
  MS: "const.countries.MS",
  MZ: "const.countries.MZ",
  MM: "const.countries.MM",
  NA: "const.countries.NA",
  NR: "const.countries.NR",
  NP: "const.countries.NP",
  NL: "const.countries.NL",
  DE: "const.countries.DE",
  NE: "const.countries.NE",
  NG: "const.countries.NG",
  NI: "const.countries.NI",
  NU: "const.countries.NU",
  NF: "const.countries.NF",
  NO: "const.countries.NO",
  NC: "const.countries.NC",
  NZ: "const.countries.NZ",
  PS: "const.countries.PS",
  OM: "const.countries.OM",
  PK: "const.countries.PK",
  PW: "const.countries.PW",
  PA: "const.countries.PA",
  PG: "const.countries.PG",
  PY: "const.countries.PY",
  PE: "const.countries.PE",
  PN: "const.countries.PN",
  PF: "const.countries.PF",
  PL: "const.countries.PL",
  GS: "const.countries.GS",
  PT: "const.countries.PT",
  PR: "const.countries.PR",
  CF: "const.countries.CF",
  CZ: "const.countries.CZ",
  KR: "const.countries.KR",
  ZA: "const.countries.ZA",
  RE: "const.countries.RE",
  RU: "const.countries.RU",
  RO: "const.countries.RO",
  RW: "const.countries.RW",
  EH: "const.countries.EH",
  BL: "const.countries.BL",
  KN: "const.countries.KN",
  LC: "const.countries.LC",
  MF: "const.countries.MF",
  VC: "const.countries.VC",
  SV: "const.countries.SV",
  WS: "const.countries.WS",
  AS: "const.countries.AS",
  SM: "const.countries.SM",
  SN: "const.countries.SN",
  RS: "const.countries.RS",
  SC: "const.countries.SC",
  SL: "const.countries.SL",
  SG: "const.countries.SG",
  SK: "const.countries.SK",
  SI: "const.countries.SI",
  SO: "const.countries.SO",
  LK: "const.countries.LK",
  PM: "const.countries.PM",
  US: "const.countries.US",
  SZ: "const.countries.SZ",
  SD: "const.countries.SD",
  SS: "const.countries.SS",
  SR: "const.countries.SR",
  SJ: "const.countries.SJ",
  SH: "const.countries.SH",
  SY: "const.countries.SY",
  CH: "const.countries.CH",
  SE: "const.countries.SE",
  TJ: "const.countries.TJ",
  TH: "const.countries.TH",
  TW: "const.countries.TW",
  TZ: "const.countries.TZ",
  TG: "const.countries.TG",
  TK: "const.countries.TK",
  TO: "const.countries.TO",
  TT: "const.countries.TT",
  TN: "const.countries.TN",
  TR: "const.countries.TR",
  TM: "const.countries.TM",
  TV: "const.countries.TV",
  UG: "const.countries.UG",
  UA: "const.countries.UA",
  UY: "const.countries.UY",
  UZ: "const.countries.UZ",
  VU: "const.countries.VU",
  WF: "const.countries.WF",
  VA: "const.countries.VA",
  HU: "const.countries.HU",
  VE: "const.countries.VE",
  GB: "const.countries.GB",
  VN: "const.countries.VN",
  IT: "const.countries.IT",
  TL: "const.countries.TL",
  CI: "const.countries.CI",
  BV: "const.countries.BV",
  CX: "const.countries.CX",
  IM: "const.countries.IM",
  SX: "const.countries.SX",
  CK: "const.countries.CK",
  VI: "const.countries.VI",
  VG: "const.countries.VG",
  HM: "const.countries.HM",
  CC: "const.countries.CC",
  MH: "const.countries.MH",
  FO: "const.countries.FO",
  SB: "const.countries.SB",
  ST: "const.countries.ST",
  TC: "const.countries.TC",
  ZM: "const.countries.ZM",
  CV: "const.countries.CV",
  ZW: "const.countries.ZW",
  AE: "const.countries.AE",
  XI: "const.countries.XI"
}, zB = {
  1: "const.fa.factor",
  2: "const.fa.recipient",
  3: "const.fa.primaryEntity",
  4: "const.fa.additionalBuyer",
  5: "const.fa.invoiceIssuer",
  6: "const.fa.payer",
  7: "const.fa.localGovernmentIssuer",
  8: "const.fa.localGovernmentRecipient",
  9: "const.fa.vatGroupIssuer",
  10: "const.fa.vatGroupRecipient",
  11: "const.fa.employee"
}, TB = {
  1: "const.fa.factor",
  2: "const.fa.recipient",
  3: "const.fa.primaryEntity",
  4: "const.fa.additionalBuyer",
  5: "const.fa.invoiceIssuer",
  6: "const.fa.payer",
  7: "const.fa.localGovernmentIssuer",
  8: "const.fa.localGovernmentRecipient",
  9: "const.fa.vatGroupIssuer",
  10: "const.fa.vatGroupRecipient"
}, UB = {
  1: "const.fa.factor",
  2: "const.fa.recipient",
  3: "const.fa.primaryEntity",
  4: "const.fa.additionalBuyer",
  5: "const.fa.invoiceIssuer",
  6: "const.fa.payer"
}, ml = {
  1: "const.fa.enforcementAuthority",
  2: "const.fa.courtBailiff",
  3: "const.fa.taxRepresentative"
}, Yl = {
  1: "const.fa.enforcementAuthorityArt106c1",
  2: "const.fa.courtBailiffArt106c2",
  3: "const.fa.taxRepresentativeArt18"
}, Pl = {
  1: "const.fa.enforcementAuthorityArt106c1",
  2: "const.fa.courtBailiffArt106c2",
  3: "const.fa.taxRepresentativeArt18"
}, Ws = {
  1: "const.fa.cash",
  2: "const.fa.card",
  3: "const.fa.voucher",
  4: "const.fa.check",
  5: "const.fa.credit",
  6: "const.fa.transfer",
  7: "const.fa.mobile"
}, za = {
  1: "const.fa.seaTransport",
  2: "const.fa.railTransport",
  3: "const.fa.roadTransport",
  4: "const.fa.airTransport",
  5: "const.fa.postalShipment",
  7: "const.fa.fixedPipeline",
  8: "const.fa.inlandNavigation"
}, Ta = {
  1: "const.fa.ownAccountSettlement",
  2: "const.fa.ownAccountCollection",
  3: "const.fa.ownAccountInternal"
}, NB = {
  1: "const.fa.domesticZeroRate",
  2: "const.fa.intraCommunitySupply",
  3: "const.fa.exportZeroRate",
  4: "const.fa.supplyOutsideCountry",
  5: "const.fa.servicesArt100",
  6: "const.fa.goodsServicesAttachment15",
  7: "const.fa.otherDomesticSales"
}, vl = {
  date: R.Date,
  datetime: R.DateTime,
  dec: R.Currency,
  int: R.Currency,
  time: R.Time,
  txt: R.Value
}, Ua = {
  1: "const.fa.bubble",
  2: "const.fa.barrel",
  3: "const.fa.cylinder",
  4: "const.fa.carton",
  5: "const.fa.canister",
  6: "const.fa.cage",
  7: "const.fa.container",
  8: "const.fa.basket",
  9: "const.fa.punnet",
  10: "const.fa.bulkPackage",
  11: "const.fa.package",
  12: "const.fa.packet",
  13: "const.fa.pallet",
  14: "const.fa.bin",
  15: "const.fa.bulkSolidContainer",
  16: "const.fa.bulkLiquidContainer",
  17: "const.fa.box",
  18: "const.fa.tin",
  19: "const.fa.crate",
  20: "const.fa.bag"
}, dn = {
  hLineWidth: () => 1,
  hLineColor: () => "#BABABA",
  vLineWidth: () => 1,
  vLineColor: () => "#BABABA"
}, On = {
  1: "const.fa.liquidation",
  2: "const.fa.restructuring",
  3: "const.fa.bankruptcy",
  4: "const.fa.inheritedBusiness"
}, bl = "1.1.16-HF1", zl = {
  version: bl
};
function qt(e, n) {
  let c = typeof e == "string" ? e : e?._text;
  return c = c?.trim(), !c || !n[c] ? "" : l.t(n[c]);
}
function tn(e, n, c) {
  if (!e)
    return "";
  const E = new Date(e);
  if (isNaN(E.getTime()))
    return e;
  const Y = E.getFullYear(), X = (E.getMonth() + 1).toString().padStart(2, "0"), Q = E.getDate().toString().padStart(2, "0");
  return E.getHours().toString().padStart(2, "0"), E.getMinutes().toString().padStart(2, "0"), E.getSeconds().toString().padStart(2, "0"), `${Q}.${X}.${Y}`;
}
function ba(e, n, c) {
  const E = { year: "numeric", month: "2-digit", day: "2-digit" }, Y = {
    hour: "2-digit",
    minute: "2-digit"
  }, X = { second: "2-digit" };
  if (!e)
    return "";
  const Q = new Date(e);
  return isNaN(Q.getTime()) ? e : new Intl.DateTimeFormat("pl-PL", {
    timeZone: "Europe/Warsaw",
    ...E,
    ...n && Y,
    ...c && X
  }).format(Q).replace(", ", " ");
}
function Yr(e) {
  return e?._text ? ba(e._text, !0) : "";
}
function Tl(e, n) {
  if (!e)
    return "";
  const c = new Date(e);
  if (isNaN(c.getTime()))
    return e;
  const E = c.getHours().toString().padStart(2, "0"), Y = c.getMinutes().toString().padStart(2, "0"), X = c.getSeconds().toString().padStart(2, "0");
  return `${E}:${Y}:${X}`;
}
function Ul(e) {
  return `${l.t("invoice.footer.appName")} (ksef-pdf-generator - ${l.t("invoice.footer.version")} ${zl.version})`;
}
const Nl = {
  1: "const.farr.factor",
  2: "const.farr.recipientInternalUnit",
  3: "const.farr.originalEntity",
  5: "const.farr.invoiceIssuer",
  6: "const.farr.paymentEntity",
  7: "const.farr.localGovIssuer",
  8: "const.farr.localGovRecipient",
  9: "const.farr.vatGroupMemberIssuer",
  10: "const.farr.vatGroupMemberRecipient",
  11: "const.farr.employee"
}, Rl = {
  1: "const.farr.correctionOriginalDate",
  2: "const.farr.correctionInvoiceDate",
  3: "const.farr.correctionOtherDate",
  4: "const.farr.correctionRefundDate"
}, Sl = {
  7: "const.farr.taxRate7",
  "6.5": "const.farr.taxRate65"
};
function re(e, n = null, c = {}, E = "") {
  if (!e)
    return "";
  const Y = { text: e.toString() };
  return Object.assign(Y, c), n && (Y.style = n, Array.isArray(n) ? n.forEach((X) => {
    Xo(X, Y, e, E);
  }) : Xo(n, Y, e, E)), Y;
}
function Xo(e, n, c, E = "") {
  switch (e) {
    case R.Currency:
      n.text = isNaN(Number(c)) ? c : `${rs(c)} ${E}`, n.alignment = Rt.RIGHT;
      break;
    case R.CurrencyAbs:
      n.text = isNaN(Number(c)) ? c : `${ss(Math.abs(Number(c)).toFixed(2))} ${E}`, n.alignment = Rt.RIGHT;
      break;
    case R.CurrencyGreater:
      n.text = isNaN(Number(c)) ? c : `${ss(Number(c).toFixed(2))} ${E}`, n.fontSize = 10;
      break;
    case R.CurrencyGreaterWithSeparator:
      n.text = isNaN(Number(c)) ? c : `${rs(c)} ${E}`, n.fontSize = 10;
      break;
    case R.Currency6:
      n.text = isNaN(Number(c)) ? c : `${ss(Number(c).toFixed(6))} ${E}`, n.alignment = Rt.RIGHT;
      break;
    case R.DateTime:
      n.text = ba(c, !0, !0);
      break;
    case R.Date:
      n.text = ba(c);
      break;
    case R.Time:
      n.text = Tl(c);
      break;
    case R.FormOfPayment:
      n.text = qt({ _text: c }, Ws);
      break;
    case R.Boolean:
      n.text = c?.trim() === "1" ? va.TRUE : va.FALSE;
      break;
    case R.Percentage:
      n.text = `${c}%`;
      break;
    case R.Number:
      n.text = Gl(c), n.alignment = Rt.RIGHT;
      break;
    case R.AccountNumber:
      n.text = kl(c);
      break;
  }
}
function rs(e) {
  if (!e)
    return "";
  const n = ss(typeof e == "string" ? e : e.toString());
  if (n.includes(",")) {
    const c = n.split(",");
    return Zo(c[1].length > 1 ? n : n + "0");
  } else
    return Zo(n + ",00");
}
function Gl(e) {
  let n = "";
  return typeof e == "number" && (n = e.toString()), typeof e == "string" && (n = e), n.includes(".") ? ss(n) : n;
}
function ss(e) {
  return e.replace(".", ",");
}
function Ae(e) {
  return !!(typeof e != "object" && e || typeof e == "object" && e._text) || e === 0;
}
function de(e) {
  return typeof e == "object" ? e._text : e;
}
function Hl(e) {
  const n = de(e);
  return n ? typeof n == "number" ? n : parseFloat(n.toString()) : 0;
}
function Se(e) {
  const n = Hl(e);
  return Math.round(n * 100) / 100;
}
function ii(e) {
  return [
    {
      text: e.map(
        (n) => re(de(n.value) ?? "", n.formatTyp ?? R.Label, {}, n.currency)
      )
    }
  ];
}
function Zo(e, n = " ", c = ",") {
  const E = /\B(?=(\d{3})+(?!\d))/g;
  if (e.includes(c)) {
    const Y = e.split(c);
    return `${Y[0].replace(E, n)}${c}${Y[1]}`;
  } else
    return e.replace(E, n);
}
function ZA(e, n, c = R.Value, E = {}) {
  return !n || typeof n == "object" && !n._text ? [] : typeof n == "object" ? [
    {
      text: [re(e, R.Label), re(n._text, c)],
      ...E
    }
  ] : [
    {
      text: [re(e, R.Label), re(n, c)],
      ...E
    }
  ];
}
function mt(e, n, c) {
  return [
    {
      stack: [
        ...e.length ? [...n ? [{ stack: [Ui()], margin: [0, 8, 0, 0] }] : [], e] : []
      ],
      margin: c ?? [0, 0, 0, 8]
    }
  ];
}
function Ne(e, n) {
  return [
    {
      stack: [re(e, R.HeaderContent)],
      margin: n ?? [0, 8, 0, 8]
    }
  ];
}
function kt(e, n) {
  return [
    {
      stack: [re(e, R.SubHeaderContent)],
      margin: n ?? [0, 4, 0, 4]
    }
  ];
}
function os() {
  return {
    styles: {
      columnMarginLeft: {
        margin: [4, 0, 0, 0]
      },
      columnMarginRight: {
        margin: [0, 0, 4, 0]
      },
      GrayBoldTitle: {
        fillColor: "#F6F7FA",
        bold: !0
      },
      GrayTitle: {
        fillColor: "#F6F7FA"
      },
      Label: {
        color: "#343A40",
        bold: !0
      },
      LabelMargin: {
        margin: [0, 12, 0, 1.3]
      },
      LabelSmallMargin: {
        margin: [0, 6, 0, 1.3]
      },
      LabelMedium: {
        color: "#343A40",
        bold: !0,
        fontSize: 9
      },
      LabelGreater: {
        color: "#343A40",
        bold: !0,
        fontSize: 10
      },
      Value: {
        color: "#343A40"
      },
      ValueMedium: {
        color: "#343A40",
        fontSize: 9
      },
      Bold: {
        fontSize: 9,
        bold: !0
      },
      Description: {
        color: "blue",
        bold: !1
      },
      HeaderPosition: {
        fontSize: 16,
        bold: !0
      },
      Right: {
        alignment: Rt.RIGHT
      },
      header: {
        fontSize: 12,
        bold: !0,
        margin: [0, 12, 0, 5]
      },
      HeaderContent: {
        fontSize: 10,
        bold: !0,
        color: "#343A40"
      },
      SubHeaderContent: {
        fontSize: 7,
        bold: !0,
        color: "#343A40"
      },
      TitleContent: {
        fontSize: 10,
        bold: !0
      },
      Link: {
        color: "blue"
      },
      MarginBottom4: {
        marginBottom: 4
      },
      MarginBottom8: {
        marginBottom: 8
      },
      MarginTop4: {
        marginTop: 4
      }
    },
    defaultStyle: {
      font: "Roboto",
      fontSize: 7,
      lineHeight: 1.2
    }
  };
}
function Te(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function Ll(e, n) {
  return e.map((c, E) => Array.isArray(n) ? re(c, n[E] ?? R.Default) : re(c, n ?? R.Default));
}
function Pr(e, n) {
  return n.some((c) => Ae(c[e]));
}
function vn(e, n) {
  const c = [];
  return n.forEach((E) => {
    const Y = de(E[e]);
    if (Y) {
      const X = c.findIndex((Q) => Q.value === Y);
      X < 0 ? c.push({ value: Y, count: 1 }) : c[X].count++;
    }
  }), c;
}
function ft(e, n, c, E, Y) {
  const X = e.filter((r) => n.some((A) => {
    const a = r.name;
    return a === "" && A?._text ? !0 : a === "" ? !1 : typeof A[a] == "object" && A[a]?._text ? !0 : !!(typeof A[a] != "object" && A[a]);
  }));
  if (X.length < 1)
    return { content: null, fieldsWithValue: [] };
  const Q = Ll(
    X.map((r) => r.title),
    R.GrayBoldTitle
  ), B = n.map((r) => X.map((A) => {
    const a = A.name ? r[A.name] : r, d = typeof a == "object" ? a?._text : a;
    return re(
      Ti(
        A.mappingData && d ? qt(d, A.mappingData) : d ?? "",
        Y ?? 40
      ),
      A.format ?? R.Default,
      { rowSpan: a?._rowSpan ?? 1 }
    );
  }));
  return {
    fieldsWithValue: X.map((r) => r.name),
    content: {
      table: {
        headerRows: 1,
        keepWithHeaderRows: 1,
        widths: X.map((r) => r.width ?? c),
        body: [Q, ...B]
      },
      margin: E ?? [0, 0, 0, 8],
      layout: dn
    }
  };
}
function It(e, n, c, E = !0) {
  return {
    columns: [
      { stack: [e], width: "50%" },
      { stack: [n], width: "50%" }
    ],
    margin: c ?? [0, 0, 0, 0],
    columnGap: 20,
    unbreakable: E
  };
}
function Li(e, n = void 0) {
  const c = (100 / e.length).toFixed(0) + "%", E = e.map((X) => ({ stack: X, width: c })), Y = n ? { ...n } : { columnGap: 20 };
  return {
    columns: E,
    ...Y
  };
}
function RB(e) {
  return e ? {
    qr: e,
    fit: 150,
    foreground: "black",
    background: "white",
    eccLevel: "M"
  } : void 0;
}
function Ei(e) {
  return { text: `
`, fontSize: e };
}
function Na(e) {
  return kn[e] ? kn[e] : e;
}
function er(e, n, c) {
  let E = {};
  switch (n) {
    case 1:
      E = Fl;
      break;
    case 2:
      E = xl;
      break;
    case 3:
      E = pl;
      break;
    case "RR":
      E = Sl;
      break;
  }
  return !e && c === "1" ? "marża" : E[e] ? qt(e, E) : e;
}
function Ui() {
  return {
    table: {
      widths: ["*"],
      body: [[{ text: " ", fontSize: 1 }]]
    },
    layout: {
      hLineWidth: (e) => e === 0 ? 1 : 0,
      vLineWidth: () => 0,
      hLineColor: function() {
        return "#c0bfc1";
      },
      paddingTop: () => 0,
      paddingBottom: () => 0
    }
  };
}
function Ti(e, n = 40) {
  return typeof e == "string" ? e.replace(new RegExp(`(.{${n}})`, "g"), "$1​") : e;
}
function qo(e, n) {
  return e.split("").reduce((c, E, Y) => (Y % n === 0 && c.push(""), c[c.length - 1] += E, c), []);
}
function kl(e) {
  if (e.length <= 12) return e;
  const n = /^[a-z!-\/:-@[-`{-~]/i;
  return e.charAt(0).match(n) ? e = qo(e.replace(/ /g, ""), 4).join(" ") : e = `${e.substring(0, 2)} ${qo(e.substring(2).replace(/ /g, ""), 4).join(" ")}`, e;
}
var Dn = /* @__PURE__ */ ((e) => (e.BeforeCorrection = "Zamówienie przed korektą", e.AfterCorrection = "Zamówienie po korekcie", e.Order = "Zamówienie", e))(Dn || {});
function jl(e) {
  const n = [];
  let c = [];
  const E = [];
  if (e) {
    if (e?.P_19?._text === "1" && (An(
      c,
      E,
      {
        text: l.t("invoice.annotations.noTaxDelivery")
      },
      !0
    ), e.P_19A?._text && (An(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument")
      ),
      !0
    ), An(
      c,
      E,
      ZA(l.t("invoice.annotations.law"), e.P_19A._text),
      !0
    )), e.P_19B?._text && (An(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument2")
      ),
      !0
    ), An(
      c,
      E,
      ZA(l.t("invoice.annotations.directiveLaw"), e.P_19B._text),
      !0
    )), e.P_19C?._text && (An(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument3")
      ),
      !0
    ), An(
      c,
      E,
      ZA(l.t("invoice.annotations.otherLaw"), e.P_19C._text),
      !0
    ))), e.P_18A?._text === "1" && An(c, E, { text: l.t("invoice.annotations.partialPayMechanism") }), e.P_16?._text === "1" && An(c, E, { text: l.t("invoice.annotations.cashMethod") }), e.P_18?._text === "1" && An(c, E, { text: l.t("invoice.annotations.reverseTax") }), e.P_23?._text === "1" && An(c, E, { text: l.t("invoice.annotations.threePartsSimplerMethod") }), e.P_PMarzy?._text === "1") {
      let Y = "";
      e.P_PMarzy_3_1?._text === "1" ? Y = l.t("invoice.annotations.usedGoods") : e.P_PMarzy_3_2?._text === "1" ? Y = l.t("invoice.annotations.artPieces") : e.P_PMarzy_2?._text === "1" ? Y = l.t("invoice.annotations.travelAgencies") : e.P_PMarzy_3_3?._text === "1" && (Y = l.t("invoice.annotations.antiques")), An(
        c,
        E,
        ZA(l.t("invoice.annotations.marginProcedure"), Y)
      );
    }
    if (e.P_17?._text === "1" && An(c, E, { text: l.t("invoice.annotations.selfInvoice") }), e.P_22?._text === "1") {
      let Y = [];
      Y = [...ZA(l.t("invoice.annotations.newTransportsDelivery"), " ")], Y && (c = [c, ...Y]);
    }
    (c.length || E.length) && n.push(Li([c, E])), n.length && (n.unshift(Ei(1)), n.unshift(Ne(l.t("invoice.annotations.header"))), n.unshift(Ei(1)), n.push(Ei(1))), e.P_22?._text === "1" && n.push(Ol(e));
  }
  return n;
}
function Ol(e) {
  const n = [], c = [], E = Ae(e.P_22B) || Ae(e.P_22BT) || Ae(e.P_22B1) || Ae(e.P_22B2) || Ae(e.P_22B3) || Ae(e.P_22B4), Y = Ae(e.P_22C) || Ae(e.P_22C1), X = Ae(e.P_22D) || Ae(e.P_22D1);
  return Ae(e.P_22A) && c.push([
    re(l.t("invoice.annotations.transportApprovalDate"), R.GrayBoldTitle),
    re(e.P_22A?._text, R.Default)
  ]), Ae(e.P_22BMK) && c.push([
    re(l.t("invoice.annotations.transportBrand"), R.GrayBoldTitle),
    re(e.P_22BMK?._text, R.Default)
  ]), Ae(e.P_22BMD) && c.push([
    re(l.t("invoice.annotations.transportModel"), R.GrayBoldTitle),
    re(e.P_22BMD?._text, R.Default)
  ]), Ae(e.P_22BK) && c.push([
    re(l.t("invoice.annotations.transportColor"), R.GrayBoldTitle),
    re(e.P_22BK?._text, R.Default)
  ]), Ae(e.P_22BNR) && c.push([
    re(l.t("invoice.annotations.transportRegistrationNumber"), R.GrayBoldTitle),
    re(e.P_22BNR?._text, R.Default)
  ]), Ae(e.P_22BRP) && c.push([
    re(l.t("invoice.annotations.transportProductionYear"), R.GrayBoldTitle),
    re(e.P_22BRP?._text, R.Default)
  ]), E ? (c.push([
    re(l.t("invoice.annotations.transportType"), R.GrayBoldTitle),
    re(l.t("invoice.annotations.landDelivery"), R.Default)
  ]), Ae(e.P_22B) && c.push([
    re(l.t("invoice.annotations.transportMileage"), R.GrayBoldTitle),
    re(e.P_22B?._text, R.Default)
  ]), Ae(e.P_22B1) && c.push([
    re(l.t("invoice.annotations.vin"), R.GrayBoldTitle),
    re(e.P_22B1?._text, R.Default)
  ]), Ae(e.P_22B2) && c.push([
    re(l.t("invoice.annotations.bodyNumber"), R.GrayBoldTitle),
    re(e.P_22B2?._text, R.Default)
  ]), Ae(e.P_22B3) && c.push([
    re(l.t("invoice.annotations.chassisNumber"), R.GrayBoldTitle),
    re(e.P_22B3?._text, R.Default)
  ]), Ae(e.P_22B4) && c.push([
    re(l.t("invoice.annotations.frameNumber"), R.GrayBoldTitle),
    re(e.P_22B4?._text, R.Default)
  ]), Ae(e.P_22BT) && c.push([
    re(l.t("invoice.annotations.newTransportType"), R.GrayBoldTitle),
    re(e.P_22BT?._text, R.Default)
  ])) : Y ? (c.push([
    re(l.t("invoice.annotations.transportType"), R.GrayBoldTitle),
    re(l.t("invoice.annotations.boatDelivery"), R.Default)
  ]), Ae(e.P_22C) && c.push([
    re(l.t("invoice.annotations.transportMileage"), R.GrayBoldTitle),
    re(e.P_22C?._text, R.Default)
  ]), Ae(e.P_22C1) && c.push([
    re(l.t("invoice.annotations.hullNumber"), R.GrayBoldTitle),
    re(e.P_22C1?._text, R.Default)
  ])) : X && (c.push([
    re(l.t("invoice.annotations.transportType"), R.GrayBoldTitle),
    re(l.t("invoice.annotations.airDelivery"), R.Default)
  ]), Ae(e.P_22D) && c.push([
    re(l.t("invoice.annotations.transportMileage"), R.GrayBoldTitle),
    re(e.P_22D?._text, R.Default)
  ]), Ae(e.P_22D1) && c.push([
    re(l.t("invoice.annotations.factoryNumber"), R.GrayBoldTitle),
    re(e.P_22D1?._text, R.Default)
  ])), c.length && n.push([
    {
      unbreakable: !0,
      table: {
        body: c,
        widths: ["*", "*"]
      },
      layout: dn
    }
  ]), n;
}
function An(e, n, c, E) {
  if (e.length > n.length && E) {
    n.push(c);
    return;
  }
  e.push(c);
}
function Jl(e) {
  const n = [];
  de(e.TP) === "1" && n.push(re(l.t("invoice.additionalInformation.tpLabel")));
  const c = [];
  de(e.FP) === "1" && c.push(re(l.t("invoice.additionalInformation.fpLabel")));
  const E = [];
  de(e.ZwrotAkcyzy) === "1" && E.push(re(l.t("invoice.additionalInformation.exciseTaxRefund")));
  const Y = [n, c, E].filter((Q) => Q.length > 0), X = [
    ...Ne(l.t("invoice.additionalInformation.additionalInformationLabel")),
    ...Y,
    ...Kl(e.DodatkowyOpis, l)
  ];
  return X.length > 1 ? mt(X, !0) : [];
}
function Kl(e, n) {
  if (!e)
    return [];
  const c = Te(e)?.map((Q, B) => ({
    ...Q,
    lp: { _text: B + 1 }
  })), E = kt(n.t("invoice.additionalInformation.additionalDescription")), Y = [
    {
      name: "lp",
      title: n.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Klucz",
      title: n.t("invoice.additionalInformation.typeOfInformation"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Wartosc",
      title: n.t("invoice.additionalInformation.informationContent"),
      format: R.Default,
      width: "*"
    }
  ], X = ft(
    Y,
    c,
    "*",
    [0, 0, 0, 0]
  );
  return X.content && E.push(X.content), E;
}
const _o = (e, n) => {
  const c = [];
  return e?.length ? (e.forEach((E, Y) => {
    const X = [], Q = Ne(
      n ? `${n} ${e?.length > 1 ? ++Y : ""}` : "",
      [0, 12, 0, 8]
    );
    Ae(E.NrRBZagr) ? X.push([
      re(l.t("invoice.registers.billFormat"), R.GrayBoldTitle),
      re(l.t("invoice.registers.foreign"), R.Default)
    ]) : Ae(E.NrRBPL) && X.push([
      re(l.t("invoice.registers.billFormat"), R.GrayBoldTitle),
      re(l.t("invoice.registers.polish"), R.Default)
    ]), Ae(E.NrRBPL) && X.push([
      re(l.t("invoice.registers.fullNrbAccountNumber"), R.GrayBoldTitle),
      re(de(E.NrRBPL), R.Default)
    ]), Ae(E.NrRBZagr) && X.push([
      re(l.t("invoice.registers.fullForeignAccountNumber"), R.GrayBoldTitle),
      re(de(E.NrRBZagr), R.Default)
    ]), X.push([
      re(l.t("invoice.registers.swiftCode"), R.GrayBoldTitle),
      re(de(E.SWIFT), R.Default)
    ]), X.push([
      re(l.t("invoice.registers.ownBankAccount"), R.GrayBoldTitle),
      re(
        Ti(qt(E.RachunekWlasnyBanku, Ta), 20),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.bankName"), R.GrayBoldTitle),
      re(Ti(de(E.NazwaBanku), 20), R.Default)
    ]), c.push([
      ...Q,
      {
        unbreakable: !0,
        table: {
          body: X,
          widths: ["auto", "*"]
        },
        layout: dn
      }
    ]);
  }), mt(c, !1)) : [];
};
function Wl(e) {
  if (!e)
    return [];
  const n = Te(e.TerminyPlatnosci), c = [
    {
      name: "TerminPlatnosci",
      title: l.t("invoice.payment.maturityDate"),
      format: R.Date
    }
  ];
  n.some((x) => x.TerminPlatnosciOpis) && c.push({
    name: "TerminPlatnosciOpis",
    title: l.t("invoice.payment.paymentDescription"),
    format: R.Date
  });
  const E = [
    {
      name: "DataZaplatyCzesciowej",
      title: l.t("invoice.payment.partialPaymentDate"),
      format: R.Date
    },
    {
      name: "KwotaZaplatyCzesciowej",
      title: l.t("invoice.payment.partialPaymentAmount"),
      format: R.Currency
    },
    {
      name: "FormaPlatnosci",
      title: l.t("invoice.payment.paymentMethod"),
      format: R.FormOfPayment
    }
  ], Y = [Ui(), ...Ne(l.t("invoice.payment.payment"))];
  e.Zaplacono?._text === "1" ? (Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.paidStatus"))
  ), Y.push(ZA(l.t("invoice.payment.paymentDate"), e.DataZaplaty, R.Date))) : e.ZaplataCzesciowa?._text === "1" ? Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.partialPayment"))
  ) : Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.noPayment"))
  ), Ae(e.FormaPlatnosci) ? Y.push(
    ZA(
      l.t("invoice.payment.paymentMethod2"),
      qt(e.FormaPlatnosci, Ws)
    )
  ) : e.OpisPlatnosci?._text && (Y.push(
    ZA(l.t("invoice.payment.paymentMethod2"), l.t("invoice.payment.paymentDifferent"))
  ), Y.push(ZA(l.t("invoice.payment.otherPaymentDescription"), e.OpisPlatnosci)));
  const X = Te(e.PlatnosciCzesciowe), Q = ft(
    E,
    X,
    "*"
  ), B = n.map(
    (x) => n.some((U) => U.TerminPlatnosciOpis) ? {
      ...x,
      TerminPlatnosciOpis: {
        _text: `${x.TerminPlatnosciOpis?._text ?? ""}`
      }
    } : x
  ), r = ft(
    c,
    B,
    "*"
  );
  X.length > 0 && n.length > 0 ? Y.push(
    It(
      Q.content ?? [],
      r.content ?? [],
      [0, 4, 0, 0]
    )
  ) : n.length > 0 ? r.content && Y.push(It(r.content, [])) : X.length > 0 && Q.content && Y.push(Q.content);
  const A = Te(e.RachunekBankowy).map(
    (x) => _o([x], l.t("invoice.payment.bankAccountNumber"))
  ), a = Te(e.RachunekBankowyFaktora).map(
    (x) => _o([x], l.t("invoice.payment.factorsBankAccountNumber"))
  ), d = [...A, ...a];
  return d.length > 0 && d.forEach((x, U) => {
    U % 2 === 0 && Y.push(It(x, d[U + 1] ?? []));
  }), e.Skonto && (Y.push(Ne(l.t("invoice.payment.conditionalDiscount"), [0, 0])), Y.push(ZA(l.t("invoice.payment.discountConditions"), e.Skonto.WarunkiSkonta)), Y.push(ZA(l.t("invoice.payment.discountAmount"), e.Skonto.WysokoscSkonta))), Y;
}
function Gs(e) {
  const n = [];
  if (e.AdresZagr) {
    const c = e.AdresZagr;
    c.KodKraju && n.push(ZA(l.t("invoice.address.countryName"), c.KodKraju)), c.Ulica && n.push(ZA(l.t("invoice.address.streetName"), c.Ulica)), c.NrDomu && n.push(ZA(l.t("invoice.address.houseNumber"), c.NrDomu)), c.NrLokalu && n.push(ZA(l.t("invoice.address.apartmentNumber"), c.NrLokalu)), c.KodPocztowy && n.push(ZA(l.t("invoice.address.zipCode"), c.KodPocztowy)), c.Miejscowosc && n.push(ZA(l.t("invoice.address.townName"), c.Miejscowosc)), c.GLN && n.push(ZA(l.t("invoice.address.GLN"), c.GLN));
  }
  if (e.AdresPol) {
    const c = e.AdresPol;
    c.Wojewodztwo && n.push(ZA(l.t("invoice.address.voivodeshipName"), c.Wojewodztwo)), c.Powiat && n.push(ZA(l.t("invoice.address.districtName"), c.Powiat)), c.Gmina && n.push(ZA(l.t("invoice.address.communeName"), c.Gmina)), c.Ulica && n.push(ZA(l.t("invoice.address.streetName"), c.Ulica)), c.NrDomu && n.push(ZA(l.t("invoice.address.houseNumber"), c.NrDomu)), c.NrLokalu && n.push(ZA(l.t("invoice.address.apartmentNumber"), c.NrLokalu)), c.KodPocztowy && n.push(ZA(l.t("invoice.address.zipCode"), c.KodPocztowy)), c.Miejscowosc && n.push(ZA(l.t("invoice.address.townName"), c.Miejscowosc)), c.Poczta && n.push(ZA(l.t("invoice.address.postName"), c.Poczta)), c.GLN && n.push(ZA(l.t("invoice.address.GLN"), c.GLN));
  }
  return n;
}
function Gi(e, n = "Adres", c = !1, E) {
  return e ? [
    ...c ? kt(n, E) : Ne(n, E),
    ...Gs(e)
  ] : [];
}
function Bn(e) {
  const n = [];
  return n.push(ZA(l.t("invoice.subjectIdentificationData.nip"), e.NIP)), (Ae(e.ImiePierwsze) || Ae(e.Nazwisko)) && n.push(
    ZA(
      l.t("invoice.subjectIdentificationData.nameSurname"),
      `${de(e.ImiePierwsze)} ${de(e.Nazwisko)}`
    )
  ), e.PelnaNazwa && n.push(
    ZA(l.t("invoice.subjectIdentificationData.fullName"), e.PelnaNazwa)
  ), e.Nazwisko && n.push(
    ZA(
      l.t("invoice.subjectIdentificationData.tradeName"),
      e.NazwaHandlowa
    )
  ), n;
}
function tr(e, n) {
  const c = [];
  return e && c.push(ZA(l.t("invoice.subjectContactData.email"), e)), n && n.forEach((E) => {
    c.push(ZA(l.t("invoice.subjectContactData.phone"), `${E._text}
`));
  }), c;
}
function $o(e) {
  const n = Ne(l.t("invoice.subject1.seller"));
  if (n.push(
    ZA(l.t("invoice.subject1.eoriNumber"), e.NrEORI),
    ZA(l.t("invoice.subject1.vatPrefix"), e.PrefiksPodatnika)
  ), e.DaneIdentyfikacyjne && n.push(...Bn(e.DaneIdentyfikacyjne)), e.Adres && n.push(
    Gi(e.Adres, l.t("invoice.subject1.address"), !0, [0, 12, 0, 1.3])
  ), e.AdresKoresp && n.push(
    ...Gi(
      e.AdresKoresp,
      l.t("invoice.subject1.mailingAddress"),
      !0,
      [0, 12, 0, 1.3]
    )
  ), (e.Email || e.Telefon) && n.push(
    re(l.t("invoice.subject1.contactDetails"), [R.Label, R.LabelMargin]),
    ...tr(e.Email, Te(e.Telefon))
  ), Ae(e.StatusInfoPodatnika)) {
    const c = qt(e.StatusInfoPodatnika, On);
    n.push(ZA(l.t("invoice.subject1.taxpayerStatus"), c));
  }
  return n;
}
function Vl(e, n) {
  const c = Ne(l.t("invoice.subject1K.seller"));
  let E = [], Y = [];
  if (E.push(
    kt(l.t("invoice.subject1K.identificationData")),
    ZA(l.t("invoice.subject1K.eoriNumber"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...Bn(e.DaneIdentyfikacyjne)), (e.Email || e.Telefon) && E.push(tr(e.Email, Te(e.Telefon))), e.StatusInfoPodatnika) {
    const X = qt(e.StatusInfoPodatnika, On);
    E.push(ZA(l.t("invoice.subject1K.taxpayerStatus"), X));
  }
  return E.length && c.push(E), E = AB(n, l.t("invoice.subject1K.correctedContent")), Y = AB(e, l.t("invoice.subject1K.correctiveContent")), e.AdresKoresp && Y.push(
    Gi(
      e.AdresKoresp,
      l.t("invoice.subject1K.mailingAddress"),
      !0,
      [0, 12, 0, 1.3]
    )
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function AB(e, n) {
  const c = [];
  return c.push(kt(n)), e.PrefiksPodatnika?._text && c.push(ZA(l.t("invoice.subject1K.vatPrefix"), e.PrefiksPodatnika)), e.DaneIdentyfikacyjne && c.push(...Bn(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    Gi(e.Adres, l.t("invoice.subject1K.address"), !0, [0, 12, 0, 1.3])
  ), c;
}
function eB(e) {
  const n = Ne(l.t("invoice.subject2.buyer"));
  return n.push(ZA(l.t("invoice.subject2.eoriNumber"), e.NrEORI)), Ae(e.PrefiksNabywcy) && n.push(ZA(l.t("invoice.subject2.vatPrefix"), e.PrefiksNabywcy)), e.DaneIdentyfikacyjne && (Ae(e.DaneIdentyfikacyjne.NrID) && n.push(ZA(l.t("invoice.subject2.taxIdOther"), e.DaneIdentyfikacyjne.NrID)), de(e.DaneIdentyfikacyjne.BrakID) === "1" && n.push(ZA(l.t("invoice.subject2.noId"), " ")), n.push(
    ...Bn(e.DaneIdentyfikacyjne)
  )), e.Adres && n.push(
    Gi(e.Adres, l.t("invoice.subject2.address"), !0, [0, 12, 0, 1.3])
  ), e.AdresKoresp && n.push(
    ...Gi(
      e.AdresKoresp,
      l.t("invoice.subject2.mailingAddress"),
      !0,
      [0, 12, 0, 1.3]
    )
  ), (e.Email || e.Telefon) && n.push(
    re(l.t("invoice.subject2.contactDetails"), [R.Label, R.LabelMargin]),
    ...tr(e.Email, Te(e.Telefon))
  ), e.NrKlienta && n.push(ZA(l.t("invoice.subject2.customerNumber"), e.NrKlienta)), n;
}
function Xl(e, n) {
  const c = [];
  c.push(Ui()), c.push(Ne(l.t("invoice.subject2.buyer")));
  let E = [], Y = [];
  return E.push(
    kt(l.t("invoice.subject2k.identificationData")),
    ZA(l.t("invoice.subject2k.eori"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...Bn(e.DaneIdentyfikacyjne)), (e.Email || e.Telefon) && E.push(tr(e.Email, Te(e.Telefon))), e.NrKlienta && E.push(ZA(l.t("invoice.subject2.customerNumber"), e.NrKlienta)), E.length && c.push({
    columns: [E, []],
    columnGap: 20
  }), n.DaneIdentyfikacyjne && (E = tB(n, l.t("invoice.subject2k.correctedContent")), Y = tB(e, l.t("invoice.subject2k.correctiveContent"))), e.AdresKoresp && Y.push(
    Gi(
      e.AdresKoresp,
      l.t("invoice.subject2.mailingAddress"),
      !0,
      [0, 12, 0, 1.3]
    )
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function tB(e, n) {
  const c = [];
  return c.push(kt(n)), Ae(e.PrefiksNabywcy) && c.push(ZA(l.t("invoice.subject1K.vatPrefix"), e.PrefiksNabywcy)), e.DaneIdentyfikacyjne && (Ae(e.DaneIdentyfikacyjne.NrID) && c.push(ZA(l.t("invoice.subject2.taxIdOther"), e.DaneIdentyfikacyjne.NrID)), de(e.DaneIdentyfikacyjne.BrakID) === "1" && c.push(ZA(l.t("invoice.subject2.noId"), " ")), c.push(...Bn(e.DaneIdentyfikacyjne))), e.Adres && c.push(
    Gi(e.Adres, l.t("invoice.subject2.address"), !0, [0, 12, 0, 1.3])
  ), c;
}
function iB(e, n) {
  const c = [], E = [
    ...Ne(l.t("invoice.subject3.otherEntity", { index: n + 1 })),
    ZA(l.t("invoice.subject3.eori"), e.NrEORI)
  ];
  Ae(e.DaneIdentyfikacyjne?.NrID) && E.push(ZA(l.t("invoice.subject3.otherTaxId"), e.DaneIdentyfikacyjne?.NrID)), de(e.DaneIdentyfikacyjne?.BrakID) === "1" && E.push(ZA(l.t("invoice.subject3.noTaxId"), " ")), e.DaneIdentyfikacyjne && E.push(...Bn(e.DaneIdentyfikacyjne)), E.push([
    ZA(l.t("invoice.subject3.role"), qt(e.Rola, UB)),
    ZA(l.t("invoice.subject3.otherRole"), e.OpisRoli),
    ZA(l.t("invoice.subject3.share"), e.Udzial, [R.Percentage])
  ]);
  const Y = [];
  return e.Adres && Y.push(
    Gi(e.Adres, l.t("invoice.subject3.address"), !0, [0, 12, 0, 1.3])
  ), e.AdresKoresp && Y.push(
    ...Gi(
      e.AdresKoresp,
      l.t("invoice.subject3.correspondenceAddress"),
      !0,
      [0, 12, 0, 1.3]
    )
  ), (e.Email || e.Telefon) && Y.push(
    re(l.t("invoice.subject3.contactData"), [R.Label, R.LabelMargin]),
    ...tr(e.Email, Te(e.Telefon))
  ), e.NrKlienta && Y.push(ZA(l.t("invoice.subject3.clientNumber"), e.NrKlienta)), c.push(It(E, Y)), mt(c, !0);
}
function Zl(e, n) {
  if (!e)
    return [];
  const c = e.fakturaPodmiotNDto, E = e.podmiot2KDto, Y = Ne(`${l.t("invoice.subject3k.otherEntity")} ${n + 1}`);
  (Ae(c.NrEORI) || Ae(c.Rola) || Ae(c.OpisRoli) || Ae(c?.Udzial)) && Y.push(
    ...kt(l.t("invoice.subject3k.identificationData")),
    ZA(l.t("invoice.subject3k.eori"), c.NrEORI),
    ZA(l.t("invoice.subject3k.role"), qt(c.Rola, UB)),
    ZA(l.t("invoice.subject3k.otherRole"), c.OpisRoli),
    ZA(l.t("invoice.subject3k.share"), c.Udzial, R.Percentage)
  ), (c.Email || c.Telefon) && Y.push(tr(c.Email, Te(c.Telefon))), Ae(c.NrKlienta) && Y.push(ZA(l.t("invoice.subject3k.clientNumber"), c.NrKlienta));
  const X = [...kt(l.t("invoice.subject3k.correctedContent"))];
  Ae(E?.DaneIdentyfikacyjne?.NrID) && X.push(
    ZA(l.t("invoice.subject3k.otherTaxId"), E?.DaneIdentyfikacyjne?.NrID)
  ), de(E?.DaneIdentyfikacyjne?.BrakID) === "1" && X.push(ZA(l.t("invoice.subject3k.noTaxId"), " ")), E?.DaneIdentyfikacyjne && X.push(Bn(E.DaneIdentyfikacyjne)), E?.Adres && X.push(Gi(E.Adres, l.t("invoice.subject3k.address"), !0));
  const Q = [...kt(l.t("invoice.subject3k.correctiveContent"))];
  return Ae(c.DaneIdentyfikacyjne?.NrID) && Q.push(
    ZA(l.t("invoice.subject3k.otherTaxId"), c.DaneIdentyfikacyjne?.NrID)
  ), de(c.DaneIdentyfikacyjne?.BrakID) === "1" && Q.push(ZA(l.t("invoice.subject3k.noTaxId"), " ")), c?.DaneIdentyfikacyjne && Q.push(Bn(c.DaneIdentyfikacyjne)), c?.Adres && Q.push(Gi(c.Adres, l.t("invoice.subject3k.address"), !0)), c.AdresKoresp != null && Q.push(
    Gi(c.AdresKoresp, l.t("invoice.subject3k.correspondenceAddress"), !0)
  ), Y.push(It(X, Q)), Y;
}
function ql(e) {
  if (!e)
    return [];
  const n = Ne(l.t("invoice.authorizedSubject.authorizedSubject")), c = [], E = [];
  return Ae(e.RolaPU) && c.push(
    ZA(
      l.t("invoice.authorizedSubject.role"),
      qt(e.RolaPU, Pl)
    )
  ), Ae(e.NrEORI) && c.push(ZA(l.t("invoice.authorizedSubject.eori"), e.NrEORI)), e.DaneIdentyfikacyjne && (Ae(e.DaneIdentyfikacyjne.NrID) && c.push(
    ZA(l.t("invoice.authorizedSubject.otherTaxId"), e.DaneIdentyfikacyjne.NrID)
  ), de(e.DaneIdentyfikacyjne.BrakID) === "1" && c.push(ZA(l.t("invoice.authorizedSubject.noTaxId"), " ")), c.push(Bn(e.DaneIdentyfikacyjne))), e.Adres && E.push(Gi(e.Adres, l.t("invoice.authorizedSubject.address"), !0)), e.AdresKoresp && E.push(
    Gi(
      e.AdresKoresp,
      l.t("invoice.authorizedSubject.correspondenceAddress"),
      !0
    )
  ), (e.EmailPU || e.TelefonPU) && E.push(
    re(l.t("invoice.authorizedSubject.contactData"), [R.Label]),
    ...tr(e.EmailPU, Te(e.TelefonPU))
  ), n.push(It(c, E)), n;
}
function _l(e) {
  const n = [], c = Te(e.Fa?.Podmiot2K), E = Te(e.Podmiot3);
  if (e.Fa?.Podmiot1K || c.length > 0 ? (e.Fa?.Podmiot1K ? n.push(Vl(e.Podmiot1 ?? {}, e.Fa?.Podmiot1K)) : e.Podmiot1 != null && n.push($o(e.Podmiot1)), c.length > 0 ? c.forEach((Y) => {
    n.push(Xl(e.Podmiot2 ?? {}, Y));
  }) : e.Podmiot2 && n.push(mt(eB(e.Podmiot2), !0))) : n.push([
    Li([$o(e.Podmiot1), eB(e.Podmiot2)], {
      margin: [0, 0, 0, 8],
      columnGap: 20
    })
  ]), E.length > 0) {
    const Y = $l(c, E);
    Y.length > 0 ? Y.forEach((X, Q) => {
      X.podmiot2KDto ? n.push(Zl(X, Q)) : n.push(iB(X.fakturaPodmiotNDto, Q)), Q < Y.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    }) : E.forEach((X, Q) => {
      n.push(iB(X, Q)), Q < E.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    });
  }
  return n.push(ql(e.PodmiotUpowazniony)), mt(n, !0);
}
function $l(e, n) {
  const c = [];
  if (e.length > 1 && n.filter((E) => de(E.Rola) === "4").length > 0) {
    let E = 1;
    n.forEach((Y) => {
      de(Y.Rola) === "4" ? (e.length > E && c.push({
        fakturaPodmiotNDto: Y,
        podmiot2KDto: e[E]
      }), E++) : c.push({
        fakturaPodmiotNDto: Y
      });
    });
  }
  return c;
}
function AE(e) {
  const n = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) && (!Ae(e.Fa?.P_14_5) || de(e.Fa?.P_14_5) == 0) || Ae(e.Fa?.P_13_6) || Ae(e.Fa?.P_13_7), c = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) || Ae(e.Fa?.P_13_7), E = Ae(e.Fa?.P_14_1W) || Ae(e.Fa?.P_14_2W) || Ae(e.Fa?.P_14_3W) || Ae(e.Fa?.P_14_4W);
  let Y = [];
  const X = {
    table: {
      headerRows: 1,
      widths: [],
      body: []
    },
    layout: dn
  }, Q = [
    { text: l.t("invoice.summary.lp"), style: R.GrayBoldTitle },
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxRate"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.netAmount"), style: R.GrayBoldTitle }] : [],
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxAmount"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.grossAmount"), style: R.GrayBoldTitle }] : [],
    ...E ? [{ text: l.t("invoice.summary.taxAmountPLN"), style: R.GrayBoldTitle }] : []
  ], B = [
    "auto",
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...E ? ["*"] : []
  ];
  return e?.Fa && (Y = eE(e.Fa).map((A) => {
    const a = [];
    return a.push(A.no ?? ""), n ? A.taxRateString ? a.push(A.taxRateString) : de(e.Fa?.P_13_5) ? a.push(l.t("invoice.summary.oss")) : a.push("") : Ae(e.Fa?.P_14_5) && a.push(l.t("invoice.summary.oss")), c && a.push(re(A.net, R.Currency)), n ? a.push(re(A.tax, R.Currency)) : Ae(e.Fa?.P_14_5) && a.push(de(e.Fa?.P_14_5) ?? ""), c && a.push(re(A.gross, R.Currency)), E && a.push(re(A.taxPLN, R.Currency)), a;
  })), X.table.body = [[...Q], ...Y], X.table.widths = [...B], Y.length ? mt([...Ne(l.t("invoice.summary.sectionHeader"), [0, 0, 0, 8]), X], !1) : [];
}
function eE(e) {
  const n = [], c = Ki(e?.P_13_1) || Ki(e?.P_14_1) || Ki(e?.P_14_1W), E = Ki(e?.P_13_2) || Ki(e?.P_14_2) || Ki(e?.P_14_2W), Y = Ki(e?.P_13_3) || Ki(e?.P_14_3) || Ki(e?.P_14_3W), X = Ki(e?.P_13_4) || Ki(e?.P_14_4) || Ki(e?.P_14_4W), Q = Ki(e?.P_13_5) || Ki(e?.P_14_5), B = Ki(e?.P_13_7);
  let r = 1;
  return c && (n.push({
    no: r,
    net: Se(e.P_13_1).toFixed(2),
    gross: (Se(e.P_13_1) + Se(e.P_14_1)).toFixed(2),
    tax: Se(e.P_14_1).toFixed(2),
    taxPLN: Se(e.P_14_1W).toFixed(2),
    taxRateString: l.t("invoice.summary.23or22")
  }), r++), E && (n.push({
    no: r,
    net: Se(e.P_13_2).toFixed(2),
    gross: (Se(e.P_13_2) + Se(e.P_14_2)).toFixed(2),
    tax: Se(e.P_14_2).toFixed(2),
    taxPLN: Se(e.P_14_2W).toFixed(2),
    taxRateString: l.t("invoice.summary.8or7")
  }), r++), Y && (n.push({
    no: r,
    net: Se(e.P_13_3).toFixed(2),
    gross: (Se(e.P_13_3) + Se(e.P_14_3)).toFixed(2),
    tax: Se(e.P_14_3).toFixed(2),
    taxPLN: Se(e.P_14_3W).toFixed(2),
    taxRateString: l.t("invoice.summary.5")
  }), r++), X && (n.push({
    no: r,
    net: Se(e.P_13_4).toFixed(2),
    gross: (Se(e.P_13_4) + Se(e.P_14_4)).toFixed(2),
    tax: Se(e.P_14_4).toFixed(2),
    taxPLN: Se(e.P_14_4W).toFixed(2),
    taxRateString: l.t("invoice.summary.4or3")
  }), r++), Q && (n.push({
    no: r,
    net: Se(e.P_13_5).toFixed(2),
    gross: (Se(e.P_13_5) + Se(e.P_14_5)).toFixed(2),
    tax: Se(e.P_14_5).toFixed(2),
    taxPLN: "",
    taxRateString: de(e.P_14_5) != 0 ? l.t("invoice.summary.oss") : ""
  }), r++), B && (n.push({
    no: r,
    net: Se(e.P_13_7).toFixed(2),
    gross: Se(e.P_13_7).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.taxFree")
  }), r++), n;
}
function Ki(e) {
  return Ae(e) && de(e) != 0;
}
function tE(e) {
  const n = Te(e.FaWiersze?.FaWiersz), c = [], E = [
    { name: "NrWierszaFa", title: l.t("invoice.discount.lp"), format: R.Default, width: "auto" },
    { name: "P_7", title: l.t("invoice.discount.productName"), format: R.Default },
    { name: "P_8B", title: l.t("invoice.discount.quantity"), format: R.Default },
    { name: "P_8A", title: l.t("invoice.discount.unit"), format: R.Default }
  ], Y = ft(E, n, "*"), X = Y.fieldsWithValue.includes("NrWierszaFa");
  return c.push(
    ...Ne(l.t("invoice.discount.header")),
    ...ZA(l.t("invoice.discount.totalValue"), e.P_15, R.Currency, {
      alignment: Rt.RIGHT
    }),
    It(
      re(
        l.t(X ? "invoice.discount.notAll" : "invoice.discount.all"),
        R.Default
      ),
      ""
    )
  ), Y.fieldsWithValue.length > 0 && Y.content && c.push(Y.content), mt(c, !0);
}
function iE(e) {
  const n = Te(e.FaWiersze?.FaWiersz), c = Te(e.Zamowienie?.ZamowienieWiersz), E = [pt.ZAL, pt.KOR_ZAL].includes(
    de(e.RodzajFaktury)
  ) ? l.t("invoice.details.paymentReceivedDate") : l.t("invoice.details.deliveryOrServiceDate"), Y = nE(e.OkresFa?.P_6_Od, e.OkresFa?.P_6_Do, l), X = [], Q = [];
  Ae(e.KodWaluty) && Q.push(ZA(l.t("invoice.details.currencyCode"), e.KodWaluty));
  const B = [];
  (Pr("P_12_XII", n) || Pr("P_12_XII", c)) && B.push(ZA(l.t("invoice.details.ossProcedure"), " "));
  const r = [], A = [];
  if (Ae(e.KodWaluty) && de(e.KodWaluty) != "PLN")
    if (e.Zamowienie?.ZamowienieWiersz?.length) {
      const J = vn(
        "KursWalutyZ",
        e.Zamowienie?.ZamowienieWiersz
      );
      J.length === 1 && (r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(
          l.t("invoice.details.currencyRate"),
          J[0].value,
          R.Currency6
        )
      ));
    } else {
      const J = vn("KursWaluty", n);
      J.length === 1 && (r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(
          l.t("invoice.details.currencyRate"),
          J[0].value,
          R.Currency6
        )
      ));
    }
  const a = [], d = [], x = [
    ZA(l.t("invoice.details.invoiceNumber"), e.P_2),
    ZA(l.t("invoice.details.issueDate"), e.P_1, R.Date),
    ZA(l.t("invoice.details.issuePlace"), e.P_1M),
    ZA(l.t("invoice.details.discountPeriod"), e.OkresFaKorygowanej),
    ZA(E, e.P_6, R.Date),
    Y,
    X,
    Q,
    B,
    r,
    A,
    a,
    d
  ].filter((J) => J.length > 0), U = [], P = [];
  x.forEach((J, q) => {
    q % 2 ? P.push(J) : U.push(J);
  });
  const D = [
    ...Ne(l.t("invoice.details.header")),
    It(U, P),
    ...rE(Te(e.NrFaZaliczkowej), l)
  ];
  return mt(D, !0);
}
function nE(e, n, c) {
  const E = [];
  return Ae(e) && Ae(n) ? E.push(
    ii([
      {
        value: c.t("invoice.details.deliveryOrServiceDateFrom")
      },
      { value: tn(de(e)), formatTyp: R.Value },
      { value: c.t("invoice.details.to") },
      { value: tn(de(n)), formatTyp: R.Value }
    ])
  ) : Ae(e) ? E.push(
    ZA(
      c.t("invoice.details.deliveryOrServiceDateFrom"),
      tn(de(e))
    )
  ) : Ae(n) && E.push(
    ZA(
      c.t("invoice.details.deliveryOrServiceDateTo"),
      tn(de(n))
    )
  ), E;
}
function rE(e, n) {
  if (!e)
    return [];
  const c = [], E = [
    {
      name: "",
      title: n.t("invoice.details.advanceInvoiceNumbers"),
      format: R.Default
    }
  ], Y = ft(
    E,
    e,
    "50%",
    [0, 4, 0, 0]
  );
  return Y.content && c.push(Y.content), c;
}
function sE(e) {
  return e ? [
    ...Ne(l.t("invoice.carrier.carrier")),
    [
      It(
        Bn(e.DaneIdentyfikacyjne),
        Gi(
          e.AdresPrzewoznika,
          l.t("invoice.carrier.carrierAddress"),
          !0,
          [0, 0, 0, 0]
        ),
        [0, 0, 0, 8]
      )
    ]
  ] : [];
}
function aE(e, n) {
  const c = [], E = {
    transport: [],
    dane: [],
    wysylkaZ: [],
    wysylkaDo: [],
    wysylkaPrzez: []
  };
  return c.push(
    Ne(
      n ? `${l.t("invoice.transport.header")} ${n}` : l.t("invoice.transport.header")
    )
  ), e.RodzajTransportu?._text ? E.transport.push(
    ZA(
      l.t("invoice.transport.type"),
      qt(e.RodzajTransportu, za)
    )
  ) : e.TransportInny?._text == "1" && e.OpisInnegoTransportu?._text && (E.transport.push(
    ZA(l.t("invoice.transport.type"), l.t("invoice.transport.otherType"))
  ), E.transport.push(
    ZA(l.t("invoice.transport.otherTypeDescription"), e.OpisInnegoTransportu)
  )), E.dane.push(ZA(l.t("invoice.transport.orderNumber"), e.NrZleceniaTransportu)), Ae(e.OpisLadunku) && (E.dane.push(
    ZA(
      l.t("invoice.transport.cargoDescription"),
      qt(e.OpisLadunku, Ua)
    )
  ), e.LadunekInny?._text === "1" && e.OpisInnegoLadunku?._text && (E.dane.push(
    ZA(l.t("invoice.transport.cargoDescription"), l.t("invoice.transport.otherCargo"))
  ), E.dane.push(
    ZA(l.t("invoice.transport.otherCargoDescription"), e.OpisInnegoLadunku)
  ))), E.dane.push(ZA(l.t("invoice.transport.packageUnit"), e.JednostkaOpakowania)), E.dane.push(
    ZA(
      l.t("invoice.transport.startDateTime"),
      Yr(e.DataGodzRozpTransportu)
    )
  ), E.dane.push(
    ZA(
      l.t("invoice.transport.endDateTime"),
      Yr(e.DataGodzZakTransportu)
    )
  ), E.dane.length > 0 && E.dane.unshift(kt(l.t("invoice.transport.dataHeader"), [0, 0, 0, 0])), c.push(It(E.transport, E.dane)), c.push(sE(e.Przewoznik)), e.WysylkaZ && (E.wysylkaZ.push(kt(l.t("invoice.transport.shipFrom"), [0, 0, 0, 0])), E.wysylkaZ.push(Gs(e.WysylkaZ))), e.WysylkaDo && (E.wysylkaDo.push(kt(l.t("invoice.transport.shipTo"), [0, 0, 0, 0])), E.wysylkaDo.push(Gs(e.WysylkaDo))), Te(e.WysylkaPrzez).forEach((X, Q) => {
    Q && E.wysylkaPrzez.push(`
`), E.wysylkaPrzez.push(kt(l.t("invoice.transport.intermediateAddress"), [0, 4, 0, 0])), E.wysylkaPrzez.push(Gs(X));
  }), (e.WysylkaZ || e.WysylkaDo || e.WysylkaPrzez?.length) && (c.push(Ne(l.t("invoice.transport.shipmentHeader"))), c.push(It(E.wysylkaZ, E.wysylkaDo)), c.push(It(E.wysylkaPrzez, []))), mt(c, !0);
}
function oE(e) {
  if (!e)
    return [];
  const n = [], c = { umowy: [], zamowienia: [] }, E = Te(e?.Umowy), Y = Te(e?.Zamowienia), X = Te(e?.NrPartiiTowaru), Q = [
    { name: "DataUmowy", title: l.t("invoice.transaction.contractDate"), format: R.Date },
    { name: "NrUmowy", title: l.t("invoice.transaction.contractNumber"), format: R.Default }
  ], B = [
    { name: "DataZamowienia", title: l.t("invoice.transaction.orderDate"), format: R.Date },
    { name: "NrZamowienia", title: l.t("invoice.transaction.orderNumber"), format: R.Default }
  ], r = [
    { name: "", title: l.t("invoice.transaction.batchNumber"), format: R.Default }
  ];
  if (n.push(Ne(l.t("invoice.transaction.header"), [0, 8, 0, 4])), E.length > 0) {
    const A = ft(Q, E, "*");
    A.content && (c.umowy = [kt(l.t("invoice.transaction.contract")), A.content]);
  }
  if (Y.length > 0) {
    const A = ft(
      B,
      Y,
      "*"
    );
    A.content && A.fieldsWithValue.length > 0 && (c.zamowienia = [kt(l.t("invoice.transaction.order")), A.content]);
  }
  if ((c.zamowienia.length > 0 || c.umowy.length > 0) && n.push(It(c.umowy, c.zamowienia, 0, !1)), (e.WalutaUmowna?._text || e.KursUmowny?._text) && (n.push(Ne(l.t("invoice.transaction.currencyAndRate"), [0, 8, 0, 4])), n.push(ZA(l.t("invoice.transaction.currency"), e.WalutaUmowna)), n.push(ZA(l.t("invoice.transaction.rate"), e.KursUmowny))), X.length > 0) {
    const A = ft(
      r,
      X,
      "*",
      [0, 4]
    );
    A.content && n.push(It(A.content, "", 0, !1));
  }
  return n.push(
    ZA(
      l.t("invoice.transaction.deliveryTerms"),
      e.WarunkiDostawy,
      R.MarginTop4
    )
  ), e.PodmiotPosredniczacy?._text === "1" && n.push(
    re(l.t("invoice.transaction.intermediaryDelivery"), [R.Label, R.MarginTop4])
  ), e.Transport && Te(e.Transport).forEach((A, a) => {
    n.push(
      aE(A, Te(e.Transport).length !== 0 ? a + 1 : null)
    );
  }), mt(n, !0);
}
function Ra(e, n, c) {
  if (typeof e == "string") {
    const E = [
      pt.VAT,
      pt.KOR,
      pt.ROZ,
      pt.KOR_ROZ
    ].includes(e), Y = [pt.ZAL, pt.KOR_ZAL].includes(e);
    if (n)
      return E && !de(c.P_12) && !de(c.P_12_XII) ? { P_12: { _text: l.t("invoice.footer.margin") } } : Y && !de(c.P_12Z) && !de(c.P_12Z_XII) ? { P_12Z: { _text: l.t("invoice.footer.margin") } } : {};
  }
  return {};
}
function BE(e) {
  const n = [], c = de(e.RodzajFaktury), E = !!Number(de(e.Adnotacje?.P_PMarzy)), Y = Te(e.FaWiersze?.FaWiersz).map(
    (x) => {
      const U = Ra(c, E, x);
      return de(x.P_12) && (x.P_12._text = er(de(x.P_12), 1)), { ...x, ...U };
    }
  ), X = [
    { name: "NrWierszaFa", title: l.t("invoice.rows.lp"), format: R.Default, width: "auto" }
  ], Q = [
    {
      name: "UU_ID",
      title: l.t("invoice.rows.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7", title: l.t("invoice.rows.productName"), format: R.Default, width: "*" },
    { name: "P_9A", title: l.t("invoice.rows.netUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_9B", title: l.t("invoice.rows.grossUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_8B", title: l.t("invoice.rows.quantity"), format: R.Number, width: "auto" },
    { name: "P_8A", title: l.t("invoice.rows.unit"), format: R.Default, width: "auto" },
    { name: "P_10", title: l.t("invoice.rows.discount"), format: R.Currency, width: "auto" },
    { name: "P_12", title: l.t("invoice.rows.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12_XII",
      title: l.t("invoice.rows.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    { name: "P_11", title: l.t("invoice.rows.netSalesValue"), format: R.Currency, width: "auto" },
    {
      name: "P_11A",
      title: l.t("invoice.rows.grossSalesValue"),
      format: R.Currency,
      width: "auto"
    }
  ];
  vn("KursWaluty", Y).length !== 1 && Q.push({
    name: "KursWaluty",
    title: l.t("invoice.rows.currencyRate"),
    format: R.Currency6,
    width: "auto"
  });
  const B = [
    { name: "GTIN", title: l.t("invoice.rows.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiU", title: l.t("invoice.rows.pkwiu"), format: R.Default, width: "auto" },
    { name: "CN", title: l.t("invoice.rows.cn"), format: R.Default, width: "auto" },
    { name: "PKOB", title: l.t("invoice.rows.pkob"), format: R.Default, width: "auto" },
    {
      name: "DodatkoweInfo",
      title: l.t("invoice.rows.additionalInfo"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "P_12_Procedura",
      title: l.t("invoice.rows.procedure"),
      format: R.Default,
      mappingData: NB,
      width: "*"
    },
    {
      name: "KwotaAkcyzy",
      title: l.t("invoice.rows.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTU", title: l.t("invoice.rows.gtu"), format: R.Default, width: "auto" },
    {
      name: "Procedura",
      title: l.t("invoice.rows.procedureMarkings"),
      format: R.Default,
      width: "*"
    },
    { name: "P_6A", title: l.t("invoice.rows.deliveryDate"), format: R.Default, width: "auto" }
  ];
  let r = ft(
    [...X, ...Q, ...B],
    Y,
    "*"
  );
  const A = re(
    l.t("invoice.rows.issuedInCurrency", {
      currency: e.KodWaluty?._text
    }),
    [R.Label, R.MarginBottom8]
  ), a = de(e.P_15);
  let d = [];
  return c == pt.ROZ && Number(a) !== 0 ? d = [
    {
      stack: ii([
        { value: l.t("invoice.rows.remainingAmount"), formatTyp: R.LabelGreater },
        {
          value: a,
          formatTyp: R.CurrencyGreater,
          currency: de(e.KodWaluty)?.toString() ?? ""
        }
      ]),
      alignment: Rt.RIGHT,
      margin: [0, 8, 0, 0]
    }
  ] : (c == pt.VAT || c == pt.KOR || c == pt.KOR_ROZ || c == pt.UPR) && Number(a) !== 0 && (d = [
    {
      stack: ii([
        { value: l.t("invoice.rows.totalAmountDue"), formatTyp: R.LabelGreater },
        {
          value: a,
          formatTyp: [R.CurrencyGreaterWithSeparator],
          currency: de(e.KodWaluty)?.toString() ?? ""
        }
      ]),
      alignment: Rt.RIGHT,
      margin: [0, 8, 0, 0]
    }
  ]), r.fieldsWithValue.length <= 9 && r.content ? n.push(r.content) : (r = ft([...X, ...Q], Y, "*"), r.content && n.push(r.content), r = ft([...X, ...B], Y, "*"), r.content && r.fieldsWithValue.length > 1 && (n.push(`
`), n.push(r.content))), n.length < 1 ? [] : mt([...Ne(l.t("invoice.rows.header")), A, ...n, ...d], !0);
}
function gE(e, n, c, E, Y, X) {
  if (!e)
    return [];
  const Q = n === Dn.BeforeCorrection ? R.CurrencyAbs : R.Currency, B = Te(e?.ZamowienieWiersz).map((D, J) => (D.NrWierszaZam._text || (D.NrWierszaZam._text = (J + 1).toString()), D.P_12Z = { _text: er(de(D.P_12Z), 1, X) }, D)), r = [
    { name: "NrWierszaZam", title: l.t("invoice.order.lp"), format: R.Default, width: "auto" }
  ], A = [
    {
      name: "UU_IDZ",
      title: l.t("invoice.order.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7Z", title: l.t("invoice.order.productName"), format: R.Default, width: "*" },
    {
      name: "P_9AZ",
      title: l.t("invoice.order.netUnitPrice"),
      format: Q
    },
    { name: "P_8BZ", title: l.t("invoice.order.quantity"), format: R.Right, width: "auto" },
    { name: "P_8AZ", title: l.t("invoice.order.unit"), format: R.Default, width: "auto" },
    { name: "P_12Z", title: l.t("invoice.order.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12Z_XII",
      title: l.t("invoice.order.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    { name: "P_11NettoZ", title: l.t("invoice.order.netSalesValue"), format: Q, width: "auto" },
    { name: "P_11VatZ", title: l.t("invoice.order.taxAmount"), format: Q, width: "auto" },
    { name: "KursWalutyZ", title: l.t("invoice.order.currencyRate"), format: Q, width: "auto" }
  ], a = [
    { name: "GTINZ", title: l.t("invoice.order.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiUZ", title: l.t("invoice.order.pkwiu"), format: R.Default, width: "auto" },
    { name: "CNZ", title: l.t("invoice.order.cn"), format: R.Default, width: "auto" },
    { name: "PKOBZ", title: l.t("invoice.order.pkob"), format: R.Default, width: "auto" },
    {
      name: "DodatkoweInfoZ",
      title: l.t("invoice.order.additionalInfo"),
      format: R.Default,
      width: "*"
    },
    {
      name: "P_12Z_Procedura",
      title: l.t("invoice.order.procedure"),
      format: R.Default,
      mappingData: NB,
      width: "*"
    },
    {
      name: "KwotaAkcyzyZ",
      title: l.t("invoice.order.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTUZ", title: l.t("invoice.order.gtu"), format: R.Default, width: "auto" },
    {
      name: "ProceduraZ",
      title: l.t("invoice.order.procedureMarkings"),
      format: R.Default,
      width: "*"
    }
  ];
  let d = ft(
    [...r, ...A, ...a],
    B,
    "*"
  );
  const x = [];
  d.fieldsWithValue.length <= 9 ? d.content && x.push(d.content) : (d = ft(
    [...r, ...A],
    B,
    "*"
  ), d.content && x.push(d.content), d = ft(
    [...r, ...a],
    B,
    "*"
  ), d.content && d.fieldsWithValue.length > 1 && x.push(d.content));
  const U = l.t("invoice.order.issuedInCurrency", {
    currency: Y
  });
  let P = "";
  return Number(c) > 0 && E == pt.ZAL ? P = {
    stack: ii([
      { value: l.t("invoice.order.receivedAdvance"), formatTyp: R.LabelGreater },
      { value: c, formatTyp: R.CurrencyGreaterWithSeparator }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  } : n !== Dn.BeforeCorrection && E == pt.KOR_ZAL && Number(c) >= 0 && (P = {
    stack: ii([
      { value: l.t("invoice.order.totalAmountDue"), formatTyp: R.LabelGreater },
      { value: c, formatTyp: R.CurrencyGreaterWithSeparator }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }), [
    {
      stack: [
        Ne(n),
        U,
        {
          text: [
            l.t("invoice.order.orderValueWithTax"),
            re(e.WartoscZamowienia?._text, R.Currency)
          ],
          marginBottom: 4
        },
        ...x,
        P
      ]
    }
  ];
}
function Vs(e) {
  const n = [];
  let c = [], E = [], Y = !1;
  if (e) {
    const X = Te(e.DaneFaKorygowanej ?? []);
    if (e.NrFaKorygowany && c.push(
      ZA(l.t("invoice.correctedInvoice.correctInvoiceNumber"), e.NrFaKorygowany)
    ), e.PrzyczynaKorekty && c.push(
      ZA(l.t("invoice.correctedInvoice.correctionReason"), e.PrzyczynaKorekty)
    ), e.TypKorekty?._text) {
      const Q = [pt.VAT_RR, pt.KOR_VAT_RR].includes(
        de(e?.RodzajFaktury)
      ), B = de(e.TypKorekty);
      c.push(
        ZA(
          l.t("invoice.correctedInvoice.correctionEffectType"),
          l.t(Q ? Rl[B] : yl[B])
        )
      );
    }
    c.length && c.unshift(Ne(l.t("invoice.correctedInvoice.sectionHeader"))), X?.length === 1 ? (E.push(Ne(l.t("invoice.correctedInvoice.identificationHeader"))), Qa(X[0], E), (c.length > 0 || E.length) && (c.length ? n.push(It(c, E)) : n.push(It(E, [])), Y = !0), c = [], E = []) : (c.length > 1 && (n.push(It(c, [])), Y = !0), c = [], X?.forEach((Q, B) => {
      B % 2 === 0 ? (c.push(
        Ne(l.t("invoice.correctedInvoice.identificationHeaderIndexed", { index: B + 1 }))
      ), Qa(Q, c)) : (E.push(
        Ne(l.t("invoice.correctedInvoice.identificationHeaderIndexed", { index: B + 1 }))
      ), Qa(Q, E));
    }));
  }
  return c.length && E.length && n.push(
    mt([It(c, E, void 0, !1)], Y)
  ), mt(n, !0);
}
function Qa(e, n) {
  e.DataWystFaKorygowanej && n.push(ZA(l.t("invoice.correctedInvoice.issueDate"), e.DataWystFaKorygowanej)), e.NrFaKorygowanej && n.push(ZA(l.t("invoice.correctedInvoice.invoiceNumber"), e.NrFaKorygowanej)), e.NrKSeFFaKorygowanej && n.push(ZA(l.t("invoice.correctedInvoice.ksefNumber"), e.NrKSeFFaKorygowanej));
}
function Sa(e, n, c) {
  let E = "";
  switch (de(e?.RodzajFaktury)) {
    case pt.VAT:
      E = l.t("invoice.header.vat");
      break;
    case pt.ZAL:
      E = l.t("invoice.header.advance");
      break;
    case pt.ROZ:
      E = l.t("invoice.header.settlement");
      break;
    case pt.KOR_ROZ:
      E = l.t("invoice.header.correctionSettlement");
      break;
    case pt.KOR_ZAL:
      E = l.t("invoice.header.correctionAdvance");
      break;
    case pt.KOR:
      e?.OkresFaKorygowanej != null ? E = l.t("invoice.header.correctionCollective") : E = l.t("invoice.header.correction");
      break;
    case pt.UPR:
      E = l.t("invoice.header.simplified");
      break;
  }
  return [
    {
      text: [
        { text: l.t("invoice.header.ksefPart1"), fontSize: 18 },
        { text: l.t("invoice.header.ksefPart2"), color: "red", bold: !0, fontSize: 18 },
        { text: l.t("invoice.header.ksefPart3"), bold: !0, fontSize: 18 }
      ]
    },
    {
      ...re(l.t("invoice.header.invoiceNumberLabel"), R.ValueMedium),
      alignment: Rt.RIGHT
    },
    {
      ...re(de(e?.P_2), R.HeaderPosition),
      alignment: Rt.RIGHT
    },
    {
      ...re(E, [R.ValueMedium, R.Default]),
      alignment: Rt.RIGHT
    },
    ...n?.nrKSeF ? [
      {
        text: [
          re(l.t("invoice.header.ksefNumberLabel"), R.LabelMedium),
          re(n?.nrKSeF, R.ValueMedium)
        ],
        alignment: Rt.RIGHT
      }
    ] : [],
    ...n?.isMobile && c ? [
      { stack: [Ui()], margin: [0, 8, 0, 8] },
      {
        text: [re(l.t("invoice.header.attachmentWarning"), R.Bold)]
      }
    ] : []
  ];
}
function Xs(e, n) {
  if (!e)
    return [];
  const c = Te(e?.Obciazenia), E = Te(e?.Odliczenia), Y = [], X = [
    {
      title: l.t("invoice.settlement.deductionReason"),
      name: "Powod",
      format: R.Default,
      width: "*"
    },
    {
      title: "Kwota",
      name: "Kwota",
      format: R.Currency,
      width: "auto"
    }
  ], Q = [
    {
      name: "Powod",
      title: l.t("invoice.settlement.chargeReason"),
      format: R.Default,
      width: "*"
    },
    {
      name: "Kwota",
      title: "Kwota",
      format: R.Currency,
      width: "auto"
    }
  ], B = ft(
    Q,
    c,
    "*",
    void 0,
    20
  ), r = ft(
    X,
    E,
    "*",
    void 0,
    20
  ), A = ZA(
    l.t("invoice.settlement.totalCharges"),
    e.SumaObciazen,
    R.Currency,
    {
      alignment: Rt.RIGHT
    }
  ), a = ZA(
    l.t("invoice.settlement.totalDeductions"),
    e?.SumaOdliczen,
    R.Currency,
    {
      alignment: Rt.RIGHT
    }
  ), d = [
    kt(l.t("invoice.settlement.charges")),
    B.content ?? [],
    A
  ], x = [
    kt(l.t("invoice.settlement.deductions")),
    r.content ?? [],
    a
  ];
  return Y.push(Ne(l.t("invoice.settlement.header"), [0, 8, 0, 4])), c.length > 0 && E.length > 0 ? Y.push(Li([d, x])) : c.length > 0 ? Y.push(It([d], [], void 0, !1)) : E.length > 0 && Y.push(It([], [x], void 0, !1)), e?.DoZaplaty?._text ? Y.push({
    stack: ii([
      { value: l.t("invoice.settlement.toPay"), formatTyp: R.LabelGreater },
      {
        value: e?.DoZaplaty,
        formatTyp: R.CurrencyGreater,
        currency: n
      }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }) : e?.DoRozliczenia?._text && Y.push({
    stack: ii([
      { value: l.t("invoice.settlement.toSettle"), formatTyp: R.LabelGreater },
      {
        value: e?.DoRozliczenia,
        formatTyp: R.CurrencyGreater,
        currency: n
      }
    ]),
    alignment: Rt.RIGHT,
    marginTop: 8
  }), mt(Y, !0);
}
function cE(e) {
  if (!Te(e?.BlokDanych).length)
    return [];
  const n = [], c = [
    { name: "PelnaNazwa", title: l.t("invoice.registers.fullName"), format: R.Default },
    { name: "KRS", title: l.t("invoice.registers.krs"), format: R.Default },
    { name: "REGON", title: l.t("invoice.registers.regon"), format: R.Default },
    { name: "BDO", title: l.t("invoice.registers.bdo"), format: R.Default }
  ], E = Te(e?.BlokDanych ?? []), Y = ft(
    [...c],
    E,
    "*"
  );
  return n.push(Ne(l.t("invoice.attachment.header"))), Te(e?.BlokDanych).forEach((X, Q) => {
    n.push(kt(l.t("invoice.attachment.details", { index: Q + 1 }))), X.ZNaglowek && n.push(
      ZA(l.t("invoice.attachment.blockHeader"), X.ZNaglowek, R.Value, {
        marginBottom: 8
      })
    ), Te(X.MetaDane)?.length && n.push(nB(Te(X.MetaDane))), X.Tekst?.Akapit && (n.push(ZA(l.t("invoice.attachment.description"), " ")), Te(X.Tekst.Akapit).forEach((B) => {
      Ae(B) && n.push(re(B._text, R.Value));
    })), Te(X.Tabela).length && Te(X.Tabela).forEach((B, r) => {
      X.ZNaglowek?._text && n.push(kt(`${X.ZNaglowek?._text} ${r + 1}`)), Te(B.TMetaDane)?.length && n.push({
        stack: nB(
          Te(B.TMetaDane).map(
            (A) => ({
              ZKlucz: A.TKlucz,
              ZWartosc: A.TWartosc
            })
          )
        ),
        margin: [0, 8, 0, 0]
      }), B.Opis && n.push(ZA(l.t("invoice.attachment.description"), B.Opis)), Te(B.TNaglowek?.Kol).length && (n.push(
        re(l.t("invoice.attachment.tableLabel"), [
          R.GrayBoldTitle,
          R.LabelSmallMargin
        ])
      ), n.push(lE(B))), Te(B.Suma?.SKom).length && n.push(wE(Te(B.Suma?.SKom)));
    });
  }), Y.fieldsWithValue.length && Y.content && n.push(Y.content), mt(n, !1);
}
function nB(e) {
  const n = [], c = [
    { name: "ZKlucz", title: l.t("invoice.attachment.key"), format: R.Default },
    { name: "ZWartosc", title: l.t("invoice.attachment.value"), format: R.Default }
  ], E = Te(e ?? []), Y = ft(
    [...c],
    E,
    "*"
  );
  return Y.fieldsWithValue.length && Y.content && n.push(Y.content), n;
}
function lE(e) {
  if (!e.TNaglowek?.Kol?.length)
    return [];
  const n = [], c = Te(e.TNaglowek.Kol);
  return SB(c).forEach((Y, X) => {
    n.push(EE(Y, e.Wiersz ?? [], X, c.length));
  }), n;
}
function EE(e, n, c, E) {
  const Y = e.map(
    (B) => re(Ti(B.NKom?._text), R.GrayBoldTitle)
  ), X = [];
  return Te(n).forEach((B) => {
    const r = Te(B.WKom);
    for (; r.length < E; )
      r.push({ _text: "" });
    const A = SB(r ?? []);
    A.length >= c + 1 && X.push(
      A[c].map((a, d) => {
        let x = R.Value;
        const U = e[d]._attributes?.Typ, P = U ? vl[U] : void 0;
        return P && ![R.Date, R.DateTime].includes(P) && (x = P), re(a._text ? Ti(a._text) : "", x);
      })
    );
  }), {
    table: {
      headerRows: 1,
      widths: [...Y.map((B, r) => r === 0 ? "*" : "auto")],
      body: [[...Y], ...X]
    },
    layout: dn,
    margin: [0, 8, 0, 0]
  };
}
function wE(e) {
  const n = [], c = [
    { name: "", title: l.t("invoice.attachment.tableSummary"), format: R.Default }
  ], E = Te(e ?? []), Y = ft(
    [...c],
    E,
    "*",
    [0, 8, 0, 0]
  );
  return Y.fieldsWithValue.length && Y.content && n.push(Y.content), n;
}
function SB(e) {
  if (!Array.isArray(e))
    return [];
  const n = e.length;
  if (n <= 7)
    return [e];
  if (n >= 8 && n <= 14) {
    const c = Math.floor(n / 2);
    return n % 2 === 0 ? [e.slice(0, c), [e[0], ...e.slice(c)]] : [e.slice(0, c + 1), [e[0], ...e.slice(c + 1)]];
  } else {
    const c = Math.floor(n / 3), E = n % 3, Y = [c, c, c];
    for (let B = 0; B < E; B++)
      Y[B] += 1;
    const X = [];
    let Q = 0;
    for (const B of Y)
      X.push(e.slice(Q, Q + B)), Q += B;
    return X[1].unshift(e[0]), X[2].unshift(e[0]), X;
  }
}
function Zs(e, n, c, E, Y) {
  const X = uE(E), Q = fE(n), B = QE(n), r = hE(e), A = ME(e), a = e?.isMobile ? [] : cE(Y), d = [
    Ei(1),
    ...X.length ? [Ui()] : [],
    ...X.length ? [It(X, [])] : [],
    ...Q.length || B.length ? [Ui()] : [],
    ...Q,
    ...B,
    ...a.length ? a : [],
    { stack: [...r], unbreakable: !0 },
    { stack: [...A], unbreakable: !0 },
    mt(
      [
        {
          stack: ZA(l.t("invoice.footer.generatedIn"), Ul()),
          margin: [0, 8, 0, 0]
        }
      ],
      !1,
      [0, 0, 0, 0]
    )
  ];
  return mt(d, !1);
}
function uE(e) {
  const n = [], c = [
    { name: "", title: l.t("invoice.wz.number"), format: R.Default }
  ], E = Te(e ?? []), Y = ft(
    [...c],
    E,
    "*"
  );
  return Y.fieldsWithValue.length && Y.content && (n.push(kt(l.t("invoice.wz.documentsHeader"), [0, 8, 0, 4])), n.push(Y.content)), n;
}
function fE(e) {
  const n = [], c = [
    { name: "PelnaNazwa", title: l.t("invoice.registers.fullName"), format: R.Default },
    { name: "KRS", title: l.t("invoice.registers.krs"), format: R.Default },
    { name: "REGON", title: l.t("invoice.registers.regon"), format: R.Default },
    { name: "BDO", title: l.t("invoice.registers.bdo"), format: R.Default }
  ], E = Te(e?.Rejestry ?? []), Y = ft(
    [...c],
    E,
    "*",
    void 0,
    30
  );
  return Y.fieldsWithValue.length && Y.content && (n.push(Ne(l.t("invoice.registers.header"))), n.push(Y.content)), n;
}
function QE(e) {
  const n = [], c = [
    { name: "StopkaFaktury", title: l.t("invoice.information.invoiceFooter"), format: R.Default }
  ], E = Te(e?.Informacje ?? []), Y = ft(
    [...c],
    E,
    "*"
  );
  return Y.fieldsWithValue.length && Y.content && (n.push(Ne(l.t("invoice.information.header"))), n.push(Y.content)), n;
}
function hE(e) {
  const n = [];
  if (e?.qrCode) {
    const E = RB(e.qrCode);
    n.push(Ne(l.t("invoice.qr1.header"))), E && (E.fit = 150, n.push({
      columns: [
        {
          stack: [
            E,
            {
              text: e.qr2Code ? l.t("invoice.qr1.offline") : e.nrKSeF,
              alignment: "center",
              margin: [0, 8, 0, 0]
            }
          ],
          alignment: "center",
          width: "auto"
        },
        {
          stack: [
            re(l.t("invoice.qr1.description"), R.Label),
            {
              text: re(e.qrCode, R.Link),
              link: e.qrCode,
              margin: [0, 5, 0, 0]
            }
          ],
          margin: [0, 2, 0, 0],
          width: 330,
          alignment: "left"
        }
      ],
      columnGap: 20
    }));
  }
  return mt(n, !0);
}
function CE(e, n = 60) {
  return e.match(new RegExp(`.{1,${n}}`, "g"))?.join(`
`) || e;
}
function ME(e) {
  const n = [];
  if (e?.qr2Code) {
    const E = RB(e.qr2Code);
    n.push(Ne(l.t("invoice.qr2.header"))), E && (E.fit = 210, n.push({
      columns: [
        {
          stack: [
            E,
            { text: l.t("invoice.qr2.certificate"), alignment: "center", margin: [0, 8, 0, 0] }
          ],
          alignment: "center",
          width: "auto"
        },
        {
          stack: [
            re(l.t("invoice.qr2.description"), R.Label),
            {
              text: re(CE(e.qr2Code), R.Link),
              link: e.qr2Code,
              margin: [0, 5, 0, 0]
            }
          ],
          margin: [0, 2, 0, 0],
          alignment: "left"
        }
      ],
      columnGap: 20
    }));
  }
  return mt(n, !0);
}
function qs(e) {
  return typeof e == "string" && e.trim() !== "" ? {
    watermark: {
      text: e,
      color: "#B1B1B1",
      opacity: 0.2,
      bold: !0,
      fontSize: 50
    }
  } : typeof e == "object" && e.text && e.text.trim() !== "" ? {
    watermark: e
  } : null;
}
var Hs = { exports: {} }, DE = Hs.exports, rB;
function dE() {
  return rB || (rB = 1, (function(e) {
    var n = {
      "Roboto-Italic.ttf": "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",
      "Roboto-Medium.ttf": "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",
      "Roboto-MediumItalic.ttf": "AAEAAAARAQAABAAQR0RFRqcXo6wAAduMAAACWEdQT1Oo8wYGAAHd5AAAiaxHU1VCzONMagACZ5AAABXoT1MvMpfnsTIAAAGYAAAAYGNtYXAi3dtfAAAWsAAABqZjdnQgO/gmfQAAL7AAAAD+ZnBnbagFhDIAAB1YAAAPhmdhc3AACAAZAAHbgAAAAAxnbHlmE0U5AwAAOxAAAZwsaGVhZA02DRkAAAEcAAAANmhoZWEM1xK/AAABVAAAACRobXR4rgGeCQAAAfgAABS4bG9jYZMgK3wAADCwAAAKXm1heHAI3hDGAAABeAAAACBuYW1laP6VsgAB1zwAAAQicG9zdP9hAGQAAdtgAAAAIHByZXB5WM7TAAAs4AAAAs4AAQAAAAMDlgRXVDFfDzz1ABsIAAAAAADE8BEuAAAAAOVdrQ/6Q/3VCXIIcwACAAkAAgAAAAAAAAABAAAHbP4MAAAJJvpD/l8JcggAAbMAAAAAAAAAAAAAAAAFLgABAAAFLgCpABUAdgAHAAIAEAAvAJoAAALmD3UAAwABAAQEbwH0AAUAAAWaBTMAAAEfBZoFMwAAA9EAZgIAAAACAAAAAAAAAAAA4AAC/1AAIFsAAAAgAAAAAEdPT0cAAQAA//0GAP4AAGYHmgIAIAABnwAAAAAEOgWwAAAAIAADA5YAZAAAAAAAAAAAAfgAAAH4AAACDgAzAnoAnQSuADIEaQBBBbYAtQT6ACkBTACRArAAaAK3/5QDcQBoBE8APAG8/48CowBAAigALgMH/34EaQBfBGkA8QRpAA0EaQAmBGkADQRpAFgEaQBdBGkAhgRpADcEaQCMAhYAJwHm/58D8wAzBF0AYAQIAC0DxgCTBvYALgUl/6ME5gAmBREAXwURACYEYwAmBEYAJgVJAGYFgQAmAjIANwRPAAQE5wAmBDEAJgbJACYFgQAmBVkAYgT0ACYFWQBeBOIAJgS0ACYEugCdBRQAWAUDAJoG1QC1BOb/wAS9AKEErv/lAhv/8AM8AKsCG/96A1QARAN5/3kCfADPBC8AHARdABAEDQA3BF8AOAQoADoCvgBeBGb/+QRQAA0B+gAgAfL/AgQMABEB+gAgBsMADwRSAA0EZwA4BF3/yARkADcCvgARA/8AGwKWAD8EUQBKA9oAZAXCAHkD6P+6A83/vAPo/+YClgAtAe0AIQKW/5gFJABcAg//5gRfAE0Ekf/3BXMABgQfAC4B6f/uBNP/4AN3ANcGGQBcA3UAvwPPAEYESQCABhoAXAO8AQQC+ADlBCkAGQLoAFcC6ABoAoEAxwSd/94DzAB+AjMAnwID/80C6ADkA4sAvgPOAAUFqADBBf0AtQY1AJYDx//UB0X/jQQhAB8FVwAWBKoAJwTFAB0GjgAOBIEARgRuAD4EYwAqBG7/zQTGADcFhQAsAgcAIwR3ACEEQwAfAkAAIAVsACMEYwARB3UAUAcHAD8B+AAcBWIASwK6/0QFZgBcBHoANAV3AFgEwABKAhX/BAQZADQDwAD+A44BCQPGAQQDZAD9AfoBAwKVAPoCOv+oA7EA3AMQAK4CYP/0AAD9VgAA/dwAAPz4AAD91QAA/LwAAPyhAlgBNgQbAO8CPQCfBFIAKwWW/6wFUABdBQ3/sgRp//4FggArBGn/3AXLAFQFhQB2BTAACgRhADsEpP/mA+0AdQRjADUEQwAoA/AAZgRjABEEggBuApAAZgRG/6cD+wBCBNYAYQRj/8sEEwA2BGsANwQKAGwEPABXBaQAMQWfAD8GYQBSBJAAUgRkAG4GRwBUBc8AlAUqAGEIQP/GCEoAKwYhAJ0FeQAiBOoAIwXP/4gHbv+kBLYAHwV6ACUFff/FBOQAmQYuAFUFygAhBVoAxAdgACgHvQAoBfIAhwbFACwE2wAkBSAASAczADMEwv+nBF0AQgRpACMDQQAWBMz/hQZV/7AD+AAXBG8AFwRKACIEcP+8BdQAIwRvABcEbwAXA9sAVAWnADkEqwAXBEMAbQZaABcGvAARBPkAUQZIACMERwAjBBkAIAZQACUETf+9BFAADQQZADkGof+4Bq8AFwRtAA0EbwAXByAAXwY5AEcERwAhBvEAKwXUABkE7/+sBEH/nQcTAD4GDgAtBrAAEgWwABUI5AA3B7EAIwQA/6kD1v+0BVAAYQRlADQE8QCoA+4AdQVQAGEEYwA1BxsAYwYlAEwHIABfBjkARwTpAFgEJgBEBNUAOwAA/PAAAP0QAAD+MQAA/j0AAPpDAAD6cwX7ACUE9gAXBEcAIQTpACYEY//IBEkAIwOHABEEzwArBAQAEQfv/6QGtf+wBacAKwTfACIFBgAkBIgAIQZhAKQFdABsBfsAJgTrABcHoAAmBYIAEQgTACoGugARBgcAXwTeAEsFG//ABCr/ugbxAJoFRQBXBc8AxATBAG0FRgC0BFIAggVbABwF7ABVBKD/8gT4ACQEVgAhBfr/xQT3/7wFgQArBGMAEQYFACYE9AAXB0YAJgZMACMFYgBLBIAALwSB//EEqAAnA5j/+gVJ/8AEWP+6BNMAKQa9AEIGpwBEBiEArAUAAGEEYACTBCcAiweB/9sGcf/ZB7gAJwZrAAcE3wBLBA8APQV9AJEE9gBzBSUAUAYf/8UFHf+8BScACAMDAOgD/wAAB/QAAAP/AAAH9AAAAq4AAAIEAAABXAAABGYAAAIpAAABnwAAAQIAAADVAAAAAAAAAqwAQAKsAEAFBgCbBgQAfAN+/1gBsgCyAa0AjQHB/6cBlgDNAv4AugMFAJoC6v+kBDkAaQR2//wCtgCfA+gANQWIADUBwgBeB3MAogJhAFoCV//8A33/4ALoAIkC6ABmAugAfgLoAIkC6ACYAugAeALoAKcDIACGAtwAhwLcAG8B8wCLAfMAPgNCAGsC6P/XAugAMQLo/6UC6P+2Auj/tALo/8wC6P/XAuj/5gLo/8YC6P/1Ayr/2gLm/9sC5v/DAfP/5QHz/54Ekf/3BjwADwaLACwIXQAmBgwAIAZpABAEaQBLBb0ARAQNAEQEeAAVBTj/5QVT/+oFtwDAA8UAKwfrACME4QDwBO0AfQYRALoGswCFBqYAiwaDALoEcABEBV8AHgS5/6YEXgCaBHkANAgSAEkCIf8PBG4AMQRdAGAD/f/WBBIAFAPvADwCSQBjAnoAZwHb/9EE/ABeBIkATgSYAF4G8gBeBvIAXgToAF4GgwAVAAAAAAfx/6gINQBcAt7/5ALeAHAC3gAWA/4AYQP+AB4D/gBZA/0APAP+ADAD/v//A/4ACAP+//ID/gC0A/4AOQQL/9YEHgBsBDv/ogXaAIsEVwBuBGYAOAQeAGMEFgAPBEMACQSZADoESQAJBJkAOwS2AAkF1wAJA5sACQQ8AAkDuf/zAe8AGgS3AAkEgwA/A6sACQQWAA8ERgARA4kAAgOfAAkEVv+kBJkAOwRW/6QDgf/bBLMACQP//9oFewBBBTAAbQS7AAAFZwBiBF4AOQcd/8EHHwAJBW4AYwSzAAkEUAALBTT/gwYV/6oEJQAOBLwACwQ8AAoEpv/BBCsAdgU5AAkEagBbBlEACQbYAAkFOABLBfEACwRGAAsEXgAUBlwACQRh/9EECP/2BnD/qgR8AAoE5gAKBUoAYAXKAD4EPwBsBJ//ogZlAGIEagBbBGoACQXSADsEqQAyBCYADgScADQERgAHA9YAHgfvAAkEzv/aAt7/9QLe//MC3gALAt4AFgLeACUC3gAFAt4ANAOZAJECmgEIA8IACQQa/4cEkgA7BRkAKwUAACsEEAAUBQ0AKwQJABQEVwAJBF4AOQQ/AAkEdv+aAe8A6AOFAQQAAP0nA9kA3APbABYD7ADcA9wA2wOfAAkDgQEEA4EBBQLoAIkC6ABmAugAfgLoAIkC6ACYAugAeALoAKcFSgBsBXMAawVVACsFrABuBa4AbQQJAKsEXwAcBDf/gQSX/9EESf/YBA4AMQOFAQUBrf+4BmYAOwSLAEUB/P8ABHP/qQRz/9oEc//JBHMAEwRzAE0EcwAiBHMAVgRzADEEcwA3BHMA+AIf/wQCH/8EAhEAIwIR/3wCEQAjBD8ACQTBAEwEEABWBGYAEAQeADYEcgA3BG4ALQR6ADIEb//IBHcANgQoADoEZgAuBDj/nwObAKsE5gAkA6f/7wYV/34D6AAJBJn/2wTnACIEtgAJAfgAAAKjAEAFLwAgBS8AIARuACsEugCdApb/5QUl/6MFJf+jBSX/owUl/6MFJf+jBSX/owUl/6MFEQBfBGMAJgRjACYEYwAmBGMAJgIyADcCMgA3AjIANwIyADcFgQAmBVkAYgVZAGIFWQBiBVkAYgVZAGIFFABYBRQAWAUUAFgFFABYBL0AoQQvABwELwAcBC8AHAQvABwELwAcBC8AHAQvABwEDQA3BCgAOgQoADoEKAA6BCgAOgIHACMCBwAjAgcAIwIHACMEUgANBGcAOARnADgEZwA4BGcAOARnADgEUQBKBFEASgRRAEoEUQBKA83/vAPN/7wFJf+jBC8AHAUl/6MELwAcBSX/owQvABwFEQBfBA0ANwURAF8EDQA3BREAXwQNADcFEQBfBA0ANwURACYE9QA4BGMAJgQoADoEYwAmBCgAOgRjACYEKAA6BGMAJgQoADoEYwAmBCgAOgVJAGYEZv/5BUkAZgRm//kFSQBmBGb/+QVJAGYEZv/5BYEAJgRQAA0CMgA3AgcAEwIyADcCBwAjAjIANwIHACMCMv+OAfr/dQIyADcGggA3A+wAIARPAAQCFf8EBOcAJgQMABEEMQAmAfoAIAQxACYB+v+mBDEAJgKQACAEMQAmAtYAIAWBACYEUgANBYEAJgRSAA0FgQAmBFIADQRSAA0FWQBiBGcAOAVZAGIEZwA4BVkAYgRnADgE4gAmAr4AEQTiACYCvv+fBOIAJgK+ABEEtAAmA/8AGwS0ACYD/wAbBLQAJgP/ABsEtAAmA/8AGwS0ACYD/wAbBLoAnQKWAD8EugCdApYAPwS6AJ0CvgA/BRQAWARRAEoFFABYBFEASgUUAFgEUQBKBRQAWARRAEoFFABYBFEASgUUAFgEUQBKBtUAtQXCAHkEvQChA83/vAS9AKEErv/lA+j/5gSu/+UD6P/mBK7/5QPo/+YHRf+NBo4ADgVXABYEYwAqBFf/lgRX/5YEHgBjBHb/mgR2/5oEdv+aBHb/mgR2/5oEdv+aBHb/mgReADkDwgAJA8IACQPCAAkDwgAJAe8AGgHvABoB7wAaAe8AGgS2AAkEmQA7BJkAOwSZADsEmQA7BJkAOwRmADgEZgA4BGYAOARmADgEHgBsBHb/mgR2/5oEdv+aBF4AOQReADkEXgA5BF4AOQRXAAkDwgAJA8IACQPCAAkDwgAJA8IACQSDAD8EgwA/BIMAPwSDAD8EtwAJAe8ADgHvABoB7wAaAfn/lgHvABoDuf/zBDwACQObAAkDmwAJA5sACQObAAkEtgAJBLYACQS2AAkEmQA7BJkAOwSZADsEQwAJBEMACQRDAAkEFgAPBBYADwQWAA8EFgAPBB4AYwQeAGMEHgBjBGYAOARmADgEZgA4BGYAOARmADgEZgA4BdoAiwQeAGwEHgBsBAv/1gQL/9YEC//WBSX/owTH/7oF5f/CApb/xgVtACcFIf+5BUQAHgKQAAkFJf+jBOYAJgRjACYErv/lBYEAJgIyADcE5wAmBskAJgWBACYFWQBiBPQAJgS6AJ0EvQChBOb/wAIyADcEvQChBGEAOwRDACgEYwARApAAZgQ8AFcEdwAhBGcAOASd/94D2gBkBDj/nwKQAEQEPABXBGcAOAQ8AFcGYQBSBGMAJgRSACsEtAAmAjIANwIyADcETwAEBQAAKwTnACYE5ACZBSX/owTmACYEUgArBGMAJgV6ACUGyQAmBYEAJgVZAGIFggArBPQAJgURAF8EugCdBOb/wAQvABwEKAA6BG8AFwRnADgEXf/IBA0ANwPN/7wD6P+6BCgAOgNBABYD/wAbAfoAIAIHACMB8v8CBEoAIgPN/7wG1QC1BcIAeQbVALUFwgB5BtUAtQXCAHkEvQChA83/vAFMAJECegCdBBsAMwIV/wQBrQCNBskAJgbDAA8FJf+jBC8AHARjACYFegAlBCgAOgRvABcFhQB2BZ8APwTxAKgD7gB1CDQAOAkmAGIEtgAfA/gAFwURAF8EDQA3BL0AoQPtAHUCMgA3B27/pAZV/7ACMgA3BSX/owQvABwFJf+jBC8AHAdF/40GjgAOBGMAJgQoADoFYgBLBBkANAQZADQHbv+kBlX/sAS2AB8D+AAXBXoAJQRvABcFegAlBG8AFwVZAGIEZwA4BVAAYQRlADQFUABhBGUANAUgAEgEGQAgBOQAmQPN/7wE5ACZA83/vATkAJkDzf+8BVoAxARDAG0GxQAsBkgAIwRfADgFJf+jBC8AHAUl/6MELwAcBSX/owQvABwFJf+jBC8AHAUl/6MELwAcBSX/owQvABwFJf+jBC8AHAUl/6MELwAcBSX/owQvABwFJf+jBC8AHAUl/6MELwAcBSX/owQvABwEYwAmBCgAOgRjACYEKAA6BGMAJgQoADoEYwAmBCgAOgRjACYEKAA6BGMAJgQoADoEYwAmBCgAOgRjACYEKAA6AjIANwIHACMCMv//Afr/4wVZAGIEZwA4BVkAYgRnADgFWQBiBGcAOAVZAGIEZwA4BVkAYgRnADgFWQBiBGcAOAVZAGIEZwA4BWYAXAR6ADQFZgBcBHoANAVmAFwEegA0BWYAXAR6ADQFZgBcBHoANAUUAFgEUQBKBRQAWARRAEoFdwBYBMAASgV3AFgEwABKBXcAWATAAEoFdwBYBMAASgV3AFgEwABKBL0AoQPN/7wEvQChA83/vAS9AKEDzf+8BH3/9AS6AJ0D2wBUBVoAxARDAG0EUgArA0EAFgXsAFUEoP/yBFAADQTbACQE2wAkBFIAAANB/8cFFAA/BCQAKAS9AKED7QBSBOb/wAPo/7oEQwAoBEb/wgYEAHwEaQANBGkAJgRpAA0EaQBYBH0AcQSRAEsEfQCMBJEAcwVJAGYEZv/5BYEAJgRSAA0FJf+jBC8AHARjACYEKAA6AjL/zwIH/4AFWQBiBGcAOATiACYCvgAMBRQAWARRAEoEyP+FBOYAJgRdABAFEQAmBF8AOAURACYEXwA4BYEAJgRQAA0E5wAmBAwAEQTnACYEDAARBDEAJgH6/+MGyQAmBsMADwWBACYEUgANBVkAYgT0ACYEXf/IBOIAJgK+/90EtAAmA/8AGwS6AJ0ClgA/BRQAWAUDAJoD2gBkBQMAmgPaAGQG1QC1BcIAeQSu/+UD6P/mBZ//AQR2/5oD/v+mBPP/rgIr/7EEo//YBFr/ZQTF/+oEdv+aBD8ACQPCAAkEC//WBLcACQHvABoEPAAJBdcACQS2AAkEmQA7BEkACQQeAGMEHgBsBDv/ogHvABoEHgBsA8IACQOfAAkEFgAPAe8AGgHvABoDuf/zBDwACQQrAHYEdv+aBD8ACQOfAAkDwgAJBLwACwXXAAkEtwAJBJkAOwSzAAkESQAJBF4AOQQeAGMEO/+iBCUADgS3AAkEXgA5BB4AbAXSADsEvAALBCsAdgV7AEEFqAAaBhX/fgSZ/9sEFgAPBdoAiwXaAIsF2gCLBB4AbAUl/6MELwAcBGMAJgQoADoEdv+aA8IACQIH/+ME1QCyBNUAkwXzAAIE1QCyAAAAAgAAAAMAAAAUAAMAAQAAABQABAaSAAAA/ACAAAYAfAAAAAIADQB+AKAArACtAL8AxgDPAOYA7wD+AQ8BEQElAScBMAFTAV8BZwF+AX8BjwGSAaEBsAHwAf8CGwI3AlkCvALHAskC3QLzAwEDAwMJAw8DIwOKA4wDkgOhA7ADuQPJA84D0gPWBCUELwRFBE8EYgRvBHkEhgSfBKkEsQS6BM4E1wThBPUFAQUQBRMeAR4/HoUenh7xHvMe+R9NIAkgCyARIBUgHiAiICcgMCAzIDogPCBEIHAgjiCkIKogrCCxILogvSDBIQUhEyEWISIhJiEuIV4iAiIGIg8iEiIaIh4iKyJIImAiZSWgJcslz+4C9sP7BP7///3//wAAAAAAAgANACAAoAChAK0ArgDAAMcA0ADnAPAA/wEQARIBJgEoATEBVAFgAWgBfwGPAZIBoAGvAfAB+gIYAjcCWQK8AsYCyQLYAvMDAAMDAwkDDwMjA4QDjAOOA5MDowOxA7oDygPRA9YEAAQmBDAERgRQBGMEcAR6BIgEoASqBLIEuwTPBNgE4gT2BQIFER4AHj4egB6eHqAe8h70H00gACAKIBAgEyAXICAgJSAwIDIgOSA8IEQgcCB0IKMgpiCrILEguSC8IMEhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJaAlyiXP7gH2w/sB/v///P//AAEAAP/2/+QB9P/CAej/wQAAAdsAAAHWAAAB0gAAAdAAAAHOAAABxgAAAcj/Fv8H/wX++P7rAgoAAAAA/mX+RAE//dj91/3J/bT9qP2n/aL9nf2KAAAAGgAZAAAAAP0KAAD/+vz+/PsAAPy6AAD8sgAA/KcAAPyhAAD8mQAA/JEAAP9EAAD/QQAA/F4AAOX+5b7lb+LT5ZrlA+WY5Znhc+F04XAAAOFt4WzhauFi48XhWuO94VHhJuEjAADhDQAA4QjhAeEA5GvgueCs4Krgn9+U4JTgaN/F3qzfud+437Hfrt+i34bfb99s34sAAN9bE9ILEgbWAt4B4gABAAAAAAAAAAAAAAAAAAAAAADsAAAA9gAAASAAAAE6AAABOgAAAToAAAF8AAAAAAAAAAAAAAAAAAABfAGGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXQAAAAAAXwBmAAAAbAAAAAAAAAByAAAAhAAAAI4AAACWgAAAmoAAAKWAAACogAAAsYAAALWAAAC6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2AAAAAAAAAAAAAAAAAAAAAAAAAAAAsgAAALIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACngAAAAAAAAAAAAAAAAAAApsCnAKdAp4CnwKgAIEClwKrAqwCrQKuAq8CsACCAIMCsQKyArMCtAK1AIQAhQK2ArcCuAK5AroCuwCGAIcCxgLHAsgCyQLKAssAiACJAswCzQLOAs8C0ACKApYAiwCMApgAjQL/AwADAQMCAwMDBACOAwUDBgMHAwgDCQMKAwsDDACPAJADDQMOAw8DEAMRAxIDEwCRAJIDFAMVAxYDFwMYAxkAkwCUAygDKQMsAy0DLgMvApkCmgKhArwDRwNIA0kDSgMmAycDKgMrAK4ArwOiALADowOkA6UAsQCyA6wDrQOuALMDrwOwALQDsQOyALUDswC2A7QAtwO1A7YAuAO3ALkAugO4A7kDugO7A7wDvQO+A78AxAPBA8IAxQPAAMYAxwDIAMkAygDLAMwDwwDNAM4EAAPJANIDygDTA8sDzAPNA84A1ADVANYD0AQBA9EA1wPSANgD0wPUANkD1QDaANsA3APWA88A3QPXA9gD2QPaA9sD3APdAN4A3wPeA98A6gDrAOwA7QPgAO4A7wDwA+EA8QDyAPMA9APiAPUD4wPkAPYD5QD3A+YEAgPnAQID6AEDA+kD6gPrA+wBBAEFAQYD7QQDA+4BBwEIAQkEnQQEBAUBFwEYARkBGgQGBAcECQQIASgBKQEqASsEnAEsAS0BLgEvATAEngSfATEBMgEzATQECgQLATUBNgE3ATgEoAShBAwEDQSTBJQEDgQPBKIEowSbAUwBTQSZBJoEEAQRBBIBTgFPAVABUQFSAVMBVAFVBJUElgFWAVcBWAQdBBwEHgQfBCAEIQQiAVkBWgSXBJgENwQ4AVsBXAFdAV4EpASlAV8EOQSmAW8BcAGCAYMEqASnAbIEkgG4AdIFLQAAQEqZmJeWh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNRUE9OTUxLSklIR0YoHxAKCSwBsQsKQyNDZQotLACxCgtDI0MLLSwBsAZDsAdDZQotLLBPKyCwQFFYIUtSWEVEGyEhWRsjIbBAsAQlRbAEJUVhZIpjUlhFRBshIVlZLSwAsAdDsAZDCy0sS1MjS1FaWCBFimBEGyEhWS0sS1RYIEWKYEQbISFZLSxLUyNLUVpYOBshIVktLEtUWDgbISFZLSywAkNUWLBGKxshISEhWS0ssAJDVFiwRysbISEhWS0ssAJDVFiwSCsbISEhIVktLLACQ1RYsEkrGyEhIVktLCMgsABQiopksQADJVRYsEAbsQEDJVRYsAVDi1mwTytZI7BiKyMhI1hlWS0ssQgADCFUYEMtLLEMAAwhVGBDLSwBIEewAkMguBAAYrgQAGNXI7gBAGK4EABjV1pYsCBgZllILSyxAAIlsAIlsAIlU7gANSN4sAIlsAIlYLAgYyAgsAYlI2JQWIohsAFgIxsgILAGJSNiUlgjIbABYRuKISMhIFlZuP/BHGCwIGMjIS0ssQIAQrEjAYhRsUABiFNaWLgQALAgiFRYsgIBAkNgQlmxJAGIUVi4IACwQIhUWLICAgJDYEKxJAGIVFiyAiACQ2BCAEsBS1JYsgIIAkNgQlkbuEAAsICIVFiyAgQCQ2BCWbhAALCAY7gBAIhUWLICCAJDYEJZuUAAAQBjuAIAiFRYsgIQAkNgQlmxJgGIUVi5QAACAGO4BACIVFiyAkACQ2BCWblAAAQAY7gIAIhUWLICgAJDYEJZsSgBiFFYuUAACABjuBAAiFRYuQACAQCwAkNgQllZWVlZWVmxAAJDVFhACgVACEAJQAwCDQIbsQECQ1RYsgVACLoBAAAJAQCzDAENARuxgAJDUliyBUAIuAGAsQlAG7gBALACQ1JYsgVACLoBgAAJAUAbuAGAsAJDUliyBUAIuAIAsQlAG7IFQAi6AQAACQEAWVlZuEAAsICIVblAAAIAY7gEAIhVWlizDAANARuzDAANAVlZWUJCQkJCLSxFsQJOKyOwTysgsEBRWCFLUViwAiVFsQFOK2BZGyNLUViwAyVFIGSKY7BAU1ixAk4rYBshWRshWVlELSwgsABQIFgjZRsjWbEUFIpwRbBPKyOxYQYmYCuKWLAFQ4tZI1hlWSMQOi0ssAMlSWMjRmCwTysjsAQlsAQlSbADJWNWIGCwYmArsAMlIBBGikZgsCBjYTotLLAAFrECAyWxAQQlAT4APrEBAgYMsAojZUKwCyNCsQIDJbEBBCUBPwA/sQECBgywBiNlQrAHI0KwARaxAAJDVFhFI0UgGGmKYyNiICCwQFBYZxtmWWGwIGOwQCNhsAQjQhuxBABCISFZGAEtLCBFsQBOK0QtLEtRsUBPK1BbWCBFsQFOKyCKikQgsUAEJmFjYbEBTitEIRsjIYpFsQFOKyCKI0REWS0sS1GxQE8rUFtYRSCKsEBhY2AbIyFFWbEBTitELSwjRSCKRSNhIGSwQFGwBCUgsABTI7BAUVpasUBPK1RaWIoMZCNkI1NYsUBAimEgY2EbIGNZG4pZY7ECTitgRC0sAS0sAC0sBbELCkMjQ2UKLSyxCgtDI0MLAi0ssAIlY2awAiW4IABiYCNiLSywAiVjsCBgZrACJbggAGJgI2ItLLACJWNnsAIluCAAYmAjYi0ssAIlY2awIGCwAiW4IABiYCNiLSwjSrECTistLCNKsQFOKy0sI4pKI0VksAIlZLACJWFksANDUlghIGRZsQJOKyOwAFBYZVktLCOKSiNFZLACJWSwAiVhZLADQ1JYISBkWbEBTisjsABQWGVZLSwgsAMlSrECTiuKEDstLCCwAyVKsQFOK4oQOy0ssAMlsAMlirBnK4oQOy0ssAMlsAMlirBoK4oQOy0ssAMlRrADJUZgsAQlLrAEJbAEJbAEJiCwAFBYIbBqG7BsWSuwAyVGsAMlRmBhsIBiIIogECM6IyAQIzotLLADJUewAyVHYLAFJUewgGNhsAIlsAYlSWMjsAUlSrCAYyBYYhshWbAEJkZgikaKRmCwIGNhLSywBCawBCWwBCWwBCawbisgiiAQIzojIBAjOi0sIyCwAVRYIbACJbECTiuwgFAgYFkgYGAgsAFRWCEhGyCwBVFYISBmYbBAI2GxAAMlULADJbADJVBaWCCwAyVhilNYIbAAWRshWRuwB1RYIGZhZSMhGyEhsABZWVmxAk4rLSywAiWwBCVKsABTWLAAG4qKI4qwAVmwBCVGIGZhILAFJrAGJkmwBSawBSawcCsjYWWwIGAgZmGwIGFlLSywAiVGIIogsABQWCGxAk4rG0UjIVlhZbACJRA7LSywBCYguAIAYiC4AgBjiiNhILBdYCuwBSURihKKIDmKWLkAXRAAsAQmY1ZgKyMhIBAgRiCxAk4rI2EbIyEgiiAQSbECTitZOy0suQBdEACwCSVjVmArsAUlsAUlsAUmsG0rsV0HJWArsAUlsAUlsAUlsAUlsG8ruQBdEACwCCZjVmArILAAUliwUCuwBSWwBSWwByWwByWwBSWwcSuwAhc4sABSsAIlsAFSWliwBCWwBiVJsAMlsAUlSWAgsEBSWCEbsABSWCCwAlRYsAQlsAQlsAclsAclSbACFzgbsAQlsAQlsAQlsAYlSbACFzhZWVlZWSEhISEhLSy5AF0QALALJWNWYCuwByWwByWwBiWwBiWwDCWwDCWwCSWwCCWwbiuwBBc4sAclsAclsAcmsG0rsAQlsAQlsAQmsG0rsFArsAYlsAYlsAMlsHErsAUlsAUlsAMlsAIXOCCwBiWwBiWwBSWwcStgsAYlsAYlsAQlZbACFziwAiWwAiVgILBAU1ghsEBhI7BAYSMbuP/AUFiwQGAjsEBgI1lZsAglsAglsAQmsAIXOLAFJbAFJYqwAhc4ILAAUliwBiWwCCVJsAMlsAUlSWAgsEBSWCEbsABSWLAGJbAGJbAGJbAGJbALJbALJUmwBBc4sAYlsAYlsAYlsAYlsAolsAolsAclsHErsAQXOLAEJbAEJbAFJbAHJbAFJbBxK7ACFzgbsAQlsAQluP/AsAIXOFlZWSEhISEhISEhLSywBCWwAyWHsAMlsAMliiCwAFBYIbBlG7BoWStksAQlsAQlBrAEJbAEJUkgIGOwAyUgY1GxAAMlVFtYISEjIQcbIGOwAiUgY2EgsFMrimOwBSWwBSWHsAQlsAQmSrAAUFhlWbAEJiABRiMARrAFJiABRiMARrAAFgCwACNIAbAAI0gAILABI0iwAiNIASCwASNIsAIjSCOyAgABCCM4sgIAAQkjOLECAQewARZZLSwjEA0MimMjimNgZLlAAAQAY1BYsAA4GzxZLSywBiWwCSWwCSWwByawdisjsABUWAUbBFmwBCWwBiawdyuwBSWwBSawBSWwBSawdiuwAFRYBRsEWbB3Ky0ssAclsAolsAolsAgmsHYrirAAVFgFGwRZsAUlsAcmsHcrsAYlsAYmsAYlsAYmsHYrCLB3Ky0ssAclsAolsAolsAgmsHYriooIsAQlsAYmsHcrsAUlsAUmsAUlsAUmsHYrsABUWAUbBFmwdystLLAIJbALJbALJbAJJrB2K7AEJrAEJgiwBSWwByawdyuwBiWwBiawBiWwBiawdisIsHcrLSwDsAMlsAMlSrAEJbADJUoCsAUlsAUmSrAFJrAFJkqwBCZjiopjYS0ssV0OJWArsAwmEbAFJhKwCiU5sAclObAKJbAKJbAJJbB8K7AAULALJbAIJbAKJbB8K7AAUFRYsAclsAslh7AEJbAEJQuwCiUQsAklwbACJbACJQuwByUQsAYlwRuwByWwCyWwCyW4//+wdiuwBCWwBCULsAclsAolsHcrsAolsAglsAgluP//sHYrsAIlsAIlC7AKJbAHJbB3K1mwCiVGsAolRmCwCCVGsAglRmCwBiWwBiULsAwlsAwlsAwmILAAUFghsGobsGxZK7AEJbAEJQuwCSWwCSWwCSYgsABQWCGwahuwbFkrI7AKJUawCiVGYGGwIGMjsAglRrAIJUZgYbAgY7EBDCVUWAQbBVmwCiYgELADJTqwBiawBiYLsAcmIBCKOrEBByZUWAQbBVmwBSYgELACJTqKigsjIBAjOi0sI7ABVFi5AABAABu4QACwAFmKsAFUWLkAAEAAG7hAALAAWbB9Ky0siooIDYqwAVRYuQAAQAAbuEAAsABZsH0rLSwIsAFUWLkAAEAAG7hAALAAWQ2wfSstLLAEJrAEJggNsAQmsAQmCA2wfSstLCABRiMARrAKQ7ALQ4pjI2JhLSywCSuwBiUusAUlfcWwBiWwBSWwBCUgsABQWCGwahuwbFkrsAUlsAQlsAMlILAAUFghsGobsGxZKxiwCCWwByWwBiWwCiWwbyuwBiWwBSWwBCYgsABQWCGwZhuwaFkrsAUlsAQlsAQmILAAUFghsGYbsGhZK1RYfbAEJRCwAyXFsAIlELABJcWwBSYhsAUmIRuwBiawBCWwAyWwCCawbytZsQACQ1RYfbACJbCCK7AFJbCCKyAgaWGwBEMBI2GwYGAgaWGwIGEgsAgmsAgmirACFziKimEgaWFhsAIXOBshISEhWRgtLEtSsQECQ1NaWCMQIAE8ADwbISFZLSwjsAIlsAIlU1ggsAQlWDwbOVmwAWC4/+kcWSEhIS0ssAIlR7ACJUdUiiAgEBGwAWCKIBKwAWGwhSstLLAEJUewAiVHVCMgErABYSMgsAYmICAQEbABYLAGJrCFK4qKsIUrLSywAkNUWAwCiktTsAQmS1FaWAo4GwohIVkbISEhIVktLLCYK1gMAopLU7AEJktRWlgKOBsKISFZGyEhISFZLSwgsAJDVLABI7gAaCN4IbEAAkO4AF4jeSGwAkMjsCAgXFghISGwALgATRxZioogiiCKI7gQAGNWWLgQAGNWWCEhIbABuAAwHFkbIVmwgGIgXFghISGwALgAHRxZI7CAYiBcWCEhIbAAuAAMHFmKsAFhuP+rHCMhLSwgsAJDVLABI7gAgSN4IbEAAkO4AHcjeSGxAAJDirAgIFxYISEhuABnHFmKiiCKIIojuBAAY1ZYuBAAY1ZYsAQmsAFbsAQmsAQmsAQmGyEhISG4ADiwACMcWRshWbAEJiOwgGIgXFiKXIpaIyEjIbgAHhxZirCAYiBcWCEhIyG4AA4cWbAEJrABYbj/kxwjIS0AAED/fjR9VXw+/x97O/8fej3/H3k7QB94PP8fdzw9H3Y1Bx91Ov8fdDpnH3M5Tx9yOf8fcTb/H3A4zR9vOP8fbjdeH203zR9sN/8fazctH2o3GB9pNP8faDL/H2cyzR9mM/8fZTH/H2Qw/x9jMKsfYjBnH2Eu/x9gLoAfXy//H14vkx9dLf8fXCz/H1sr/x9aKs0fWSr/H1gqDR9XKf8fVij/H1UnJB9UJy0fUyVeH1Il/x9RJasfUCb/H08mgB9OJP8fTSMrH0wjqx9LI/8fSiNWH0kjKx9IIv8fRyD/H0Ygch9FIf8fRCFyH0Mf/x9CHpMfQR7/H0Ad/x8/HP8fPTuTQOofPDs0Hzo1Dh85NnIfODZPHzc2Ih82NZMfMzJAHzEwch8vLkofKypAHycZBB8mJSgfJTMbGVwkGhIfIwUaGVwiGf8fISA9HyA4GBZcHxgtHx4X/x8dFv8fHBYHHxszGRxbGDQWHFsaMxkcWxc0FhxbFRk+FqZaEzESVRExEFUSWRBZDTQMVQU0BFUMWQRZHwRfBAIPBH8E7wQDD14OVQs0ClUHNAZVATEAVQ5ZClkGWX8GAS8GTwZvBgM/Bl8GfwYDAFkvAAEvAG8A7wADCTQIVQM0AlUIWQJZHwJfAgIPAn8C7wIDA0BABQG4AZCwVCtLuAf/UkuwCVBbsAGIsCVTsAGIsEBRWrAGiLAAVVpbWLEBAY5ZhY2NAB1CS7CQU1iyAwAAHUJZsQICQ1FYsQQDjllzdAArACsrK3N0ACtzdHUAKwArACsrKysrc3QAKwArKysAKwArKysBKwErASsBKwErASsrACsrASsrASsAKwArASsrKysrASsrACsrKysrKysBKysAKysrKysrKwErACsrKysrKysrKysrKysBKysAKysrKysrKysrKwErKysrKysrACsrKysrKysrKysrKysrKysrKysrKxgAAAYAABUFsAAUBbAAFAQ6ABQAAP/sAAD/7AAA/+z+YP/1BbAAFQAA/+sAAAC9AMAAnQCdALoAlwCXACcAwACdAIYAvACrALoAmgDTALMAmQHgAJYAugCaAKkBCwCCAK4AoACMAJUAuQCpABcAkwCaAHsAiwChAN4AoACMAJ0AtgAnAMAAnQCkAIYAogCrALYAvwC6AIIAjgCaAKIAsgDTAJEAmQCtALMAvgHJAf0AlgC6AEcAmACdAKkBCwCCAJkAnwCpALAAgQCFAIsAlACpALUAugAXAFAAYwB4AH0AgwCLAJAAmACiAK4A1ADeASYAewCJAJMAnQClALQEjQAQAAAAAAAyADIAMgAyADIAXAB+ALUBNAHDAj8CVQKGArcC5AMDAx8DMQNPA2MDuQPTBBcEiQS2BQcFaQWHBgEGYgZuBnoGoQa+BuUHPQfvCCYIjQjYCR0JUgl+CdIJ/QoSCkEKdgqXCssK8AtCC3sL2gwiDIkMqQzbDQINQw1xDZYNxg3iDfYOEg43DkgOXA7NDycPcw/NECIQVRDGEQMRLRFqEZ8RtRIZElcSpBL/E1oTkBPuFCIUXhSDFMYU8xUvFV0VqhW+Fg0WUBZ2FtgXJxeNF9cX8xiQGMMZSBmmGbIZ0Rp5GosawhrqGyYbjBugG+QcBRwhHE0cZhyrHLccyBzZHOodQR2SHbAeEh5QHrUfYR/IIAUgYCC8ISAhVSFqIZ0hyiHsIiwifyL0I4sjsyQHJFskxyUnJWwlvCXkJjYmVyZ3Jn8mpSbCJvMnICdgJ38nryfDJ9gn4SgPKCwoSShdKJ0opSi+KO4pUSl3KaEpwCn4KlQqmCsBK3Ur4SwPLIIs8y1HLYUt6C4QLmQu3S8aL3AvwDAbME8wjTDlMSoxmzIFMl4y2zMqM4Iz5TQ0NHg0nzToNT81izX+NiI2XTaaNvQ3IDdaN4I3tjf5OD44eDjQOTo5fjn1OmE6ejrCOxI7gTulO9g8EzxEPG88mDy2PVc9gj27PeI+Fj5aPp4+2D8uP5U/20A9QJJA80FDQYlBsEIOQm1CskMVQ3dDs0PsREFEkkT7RWFF30ZdRuZHa0fYSC5IZEicSQxJc0oqSt9LUUvETA9MV0yFTKNM1EzqTP9Ntk4KTiZOQk6ETsxPN09bT39Pv0/9UBBQI1AvUEJQg1DCUP5ROlFNUWBRlVHKUg5SXFLTU0ZTWVNsU6JT2FPrU/5UR1SPVMlVM1WbVehWMlZFVlhWk1bQVuNW9lcJVxxXcFfBWBJYIVgxWD1YSViAWN1ZWlnYWlRay1tAW6FcBFxTXKZc911HXYxd0V5FXlFeXV7IXvRe9F70XvRe9F70XvRe9F70XvRe9F70XvRe9F78XwRfFl8oX0VfYV99X5lftF/AX8xf+2AcYEpgamB2YIZgo2FrYY9hr2HGYc9h2GHhYeph82H8YgViJmI4YlRigWKuYudi8GL5YwJjC2MUYx1jJmMvYzhjQWNKY1NjXGOFY65kBmRBZKJkrmUHZVVlr2YAZlVmm2bcZx1nqGf6aGRoomjwaQZpF2ktaUNpsGnNagRqFmpCatxrGWt4a6dr22wPbEJsT2xtbIlslWzRbRFtdG3ebkJu+G74cBVwW3CVcLpw/XFWcdFx7XJGco5yt3Mkc2Jze3PIc/Z0J3RTdJR0t3TndQV1Z3Wqdgd2PnaLdq1233b8dy13WXdsd5Z35XgReIx43HkceTl5aXnBeeN6DHoyemt6vnsFe257u3wOfGp8tXz3fSp9a321fgd+dX6hftR/Dn9Jf35/tX/ngCmAaIB0gKmA/IFgga2B2II1gnOCsoLtg2GDbYOng+WEKoRghMCFEYVghcKGHoZ2huOHJoeCh6uH7Yg/iFqIxYkXiSmJZomZikaKposEiziLa4uci9GMEoxajMGM8Y0OjTyNe42gjcaOBo5PjnuOqo77jwSPDY8Wjx+PKI8xjzqPiY/gkCKQdpDZkPiRO5GBkauR+JIUkmqSfJL2k1qTf5OHk4+Tl5Ofk6eTr5O3k7+Tx5PPk9eT35Pnk/mUAZRqlLaU1JUulXmV05ZElpGW7JdHl5iYCJhXmF+Y05kAmVGZipnmmhmaXZpdmmWatpsHm02bdZu2m8mb3JvvnAKcFpwqnECcU5xmnHmcjJygnLOcxpzZnO2dAJ0TnSadOZ1MnWCdc52GnZmdrZ3AndOd5p34ngqeHZ4xnkeeWp5tnoCekp6lnreeyZ7cnvCfAp8VnyifOp9Mn1+fcp+Fn5efqp+9n9Cf45/1oAigG6B0oQahGaEsoT+hUaFkoXehiqGcoa+hwqHVoeeh+qIMoh+iMqKNowWjGKMqoz2jT6Nio3Sjh6Oao66jwaPUo+ej+qQNpCCkM6RGpFmka6R9pJCknKSopLukzqTipPalCaUcpTClRKVXpWqldqWCpZWlqKW8pdCl46X1pgimG6YtpkCmU6ZnpnumjqahprWmyabcpu6nAacUpyenOadMp1+nc6eHp5qnrKfAp9Sn56f6qA2oIag0qEaoWahrqH6okailqLmozajhqTipmqmtqcCp06nlqfmqDKofqjKqRapYqmqqfaqQqqOqtqrCqs6q2arsqv+rEasjqzerS6tXq2OrdquJq5urrqvAq9Kr5av5rAysH6wyrESsV6xrrH6skayjrLesyqzcrO+tQq1VrWeteq2MrZ6tsK3CrdWuLK4+rlCuY652roqunK6vrsKu1a7grvKvBa8RryOvN69Dr0+vYq9ur4Gvk6+mr7qvza/Zr+uv/rAQsBywLrBCsFSwYLBysISwl7CrsL+xFbEosTqxTbFgsXOxhbGYsayxuLHMseCx87IHshyyJLIssjSyPLJEskyyVLJcsmSybLJ0snyyhLKMsqCytLLHstqy7bL/sxOzG7MjsyuzM7M7s0+zYrN1s4izm7Ovs8K0J7QvtEO0S7RTtGa0ebSBtIm0kbSZtKy0tLS8tMS0zLTUtNy05LTstPS0/LUPtRe1H7VotXC1eLWLtZ61prWutcK1yrXdte+2ArYVtii2O7ZPtmO2draItpC2mLaktre2v7bStuW2+rcPtyK3NbdIt1u3Y7drt3+3k7eft6u3vrfRt+S397f/uAe4D7giuDW4PbhQuGO4d7iKuJK4mrituL+407jbuO65ArkWuSq5PblQuWK5drmKuZ65sbm5ucG51bnoufy6D7oiujS6SLpbum+6g7qXuqq6vrrSutq67rsCuxW7KLs8u0+7Y7t2u4q7nbuxu8S74bv9vBG8JLw4vEu8X7xyvIa8mby2vNO857z7vQ69Ib00vUa9Wr1tvYG9lL2ovbu9z73ivf++G74uvkG+Vb5pvn2+kb6kvre+y77evvK/Bb8Zvyy/QL9Tv3C/jL+fv7K/xb/Yv+u//sARwCPAN8BLwF/Ac8CGwJnArMC/wNLA5cD4wQvBHsEwwUTBWMFswYDBk8GmwbnBy8HowfvCDsIhwjTCR8Jawm3CgMKIwsvDDcMyw1fDmMPbxAvEQMR4xK/Et8TLxNPE28TjxOvE88T7xQPFC8UTxSbFOcVMxV/Fc8WHxZvFr8XDxdfF68X/xhPGJ8Y7xk/GW8ZvxoPGl8arxr/G08bnxvvHDschxzXHScddx3HHhceZx63HwcfVx+jH+8gPyCPIN8hLyF/Ic8iHyJrIrMjAyNTI6Mj8yRDJJMk4yUTJUMlcyWjJdMmAyYzJlMmcyaTJrMm0ybzJxMnMydTJ3MnkyezJ9Mn8yhDKI8o2yknKUcpZym3KdcqIypvKo8qryrPKu8rOytbK3srmyu7K9sr+ywbLDsuKy77MEcwZzCXMOMxKzFLMXsxxzITMkMyjzLbMyszWzOnM/M0PzSLNLs06zU7Nbs1/zdzOFgAAAAYAZAAAAygFsAADAAcACwAPABMAFwAAQRUhNTMRIxEhESMRExUhNQEBIwERATMBAwn9dhs2AsQ2F/12Aor9rzoCUf2vOgJRBbA2NvpQBbD6UAWw+oY2NgVc+owFdPqMBXT6jAACADP/8AIcBbAAAwAPABNACQICBw0LcgACcgArK93OLzAxQQMjEwM0Njc2FhcUBiMGJgIcycub8E45OE0BTjk4TQWw+/0EA/q+O0sBAUc5OUwBRgACAJ0D+AK8BgAABQALAAyzCQMLBQAvM80yMDFBBwMjEzchBwMjEzcBmRdbijsXAc0XXIk8FgYAlf6NAXSUlf6NAXyMAAQAMgAABNwFsAADAAcACwAPACNAEQQABQ0ODgAKCQkAAgJyABJyACsrETkvMxE5LzMyETMwMXMBMwEzATMBASE3IQMhNyGCAgCm/f/VAgGk/gACH/wOGwPzt/wNGwPzBbD6UAWw+lADdZv9ipsAAwBB/ywESQaZAAMABwA9ADZAHAQHOjoIKxAjBBQvNTUGLw1yAQIfHxQaGgMUBXIAK80zLxEzEjk5K80zLxESFzkzEjk5MDFBAyMTAwMjEwE2JiYnLgI3PgIXHgMHIzYuAicmBgYHBhYWFx4CBw4CJy4DNzMGHgIXFjY2A0gwlzB7KpYrAVoIMVs1ZaddCAiI1X1oll8pBeoCCiJFOEFjPQcIMV02ZKVdCAqQ34FpoWw0BewDES1QOkNwSQaZ/tUBK/mf/vQBDAFKQVo/FitwpHuBuWIDAkqAqmAtX1EzAQI1YD9DWD0YK3KkeYi4XAICRHypZjRgSysBATFfAAAFALX/6AU4BcgAEQAjADUARwBLACNAEUkySwU7RCkyFw4gBQVyMg1yACsrMsQyEMQyMxEzETMwMVM3PgIXHgIHBw4CJy4CNwcGFhYXFjY2Nzc2JiYnJgYGATc+AhceAgcHDgInLgI3BwYWFhcWNjY3NzYmJicmBgYBAScBugYJWY5bV3w/BgYJWI5aVn1AsgkDEzIsLUMoBwoDEjIsLkQpAWkGCFqOWld8PwUGCVePWlZ9QLIIAhIyKy9DKAYKAhIyLC5EKQFY/JF3A3AES0xYi04CAlCIVE1YiU0CAk+HoVAlRi4BASxJKU4mSC8BAS1J/FVNWIpOAgJQh1ROWIlOAgJQh6JRJUYvAQIsSipPJkguAQEsSQNJ+5hOBGcAAQAp/+oEngXHAEIAJEAUIxIADyIBBhowMCsRETsTcgcaA3IAKzIrMi8yMi8RFzkwMUElNjY3NiYnIgYGBwYWFhcBIQEuAjc+AhceAgcOAgcFDgIHBhYWFxY+AjczDgIHBgYHBgYnLgI3PgIBfAEQNlQHBkY5M0wwBgcmPhwCHf8A/kYsVjcGCG2zclmTVAUEQWU5/rMkQi4GCCpaQGitg1ENyQo+bk4JEQpW4XR2wGwIB2aTAxmpI1lDOksBM1IvNmhfKvzUApVAjZlScKxeAwJPjF1Kd2An3hpEUC4/YjoDA1ubvFxou6NFCBMJTFACA2GzfWGVcwABAJED/gGVBgAABQAIsQMFAC/GMDFBBwMjEzcBlRdSmz0UBgCL/okBgYEAAAEAaP4xAxcGXwAXAAixBhMALy8wMVM3NhISNjcXDgMHBwYGFhYXByYmAgJ5AxVfmtqPJGqbbEMTAw8OGVhYN3yTRAcCOxGSATgBIOhBjU/N6/x+FWb6/d9Mg0z0ASEBKAAAAf+U/jACSwZdABcACLETBgAvLzAxQQcGAgIGByc+Azc3NjYmJic3FhYSEgI6AhVhnN2RJGmbbUMTBA4OG1dXOXuVRwkCVRGT/sj+3uZBh1DO7f5+FmT5/uBLg0zy/t7+2QABAGgCTgOqBbEADgAUQAoNAQcEBA4MBgJyACvEMhc5MDFTEyU3BRMzAyUXBRMHAwOM+f7jTgEbL6tMATQX/rybkYHgAsUBDlmdeAFg/qVyr1v+718BI/7pAAACADwAkgQrBLYAAwAHABC1BwcDAwYCAC/GMxDGLzAxQQchNwEDIxMEKyX8NiYCnrjkuAMe2dkBmPvcBCQAAAH/j/64ARUA6AAKAAixBAAAL80wMWUHBgYHJz4CNzcBFR0Sfl18ITwtCyDoq3XJR00wXmY6tQAAAQBAAg4CZQLOAAMACLEDAgAvMzAxQQchNwJlIv39IQLOwMAAAQAu//IBQgD/AAsACrMDCQtyACsyMDF3JjY3NhYVFgYHBiYvAVA6Ok8BUDs4UHQ7TgEBSTo7TQEBSAAAAf9+/4MDeQWwAAMACbIAAgEALz8wMUEBIwEDefzHwgM5BbD50wYtAAIAX//oBDgFyAAXAC8AE0AJKwYfEgVyBg1yACsrMhEzMDFBBw4DJy4ENzc+AxceBAETNjYuAicmDgIHAwYGHgIXFj4CBC0lEkqBxItqj1goBAsjEkyBxIlqkVcpBP7hLgUJByFGO1JsQyMKLQUJBiBGPFJtQSQDUu135LdrBAJMgKGyV+534rVoBAJKfaCx/pgBNipoaFk5AgRLe45A/sspaWxbOwMDTH6RAAABAPEAAAN5BbUABgAMtQYEcgEMcgArKzAxQQMjEwU3JQN59+vM/o4lAkEFtfpLBJJ50csAAQANAAAEPAXHAB8AGUAMEBAMFQVyAx8fAgxyACsyETMrMjIvMDFlByE3AT4CNzYmJicmBgYHBz4CFx4CBw4DBwED3x78TBsCEjNxVwsHIFFCUXVFCukLkeeKd7xmCwdIa3o5/pXAwK4B/TF2hks8ZkABA0p+SwGL03QCAlywfVSWh3g2/qUAAAIAJv/qBDgFxwAcADsAKkAWGxweHwQAAB0dEjMvLykNcg0NCRIFcgArMjIvKzIvMhE5LzMSFzkwMUEXPgI3NiYmJyYGBgcHPgIXHgIHDgMjJwc3Fx4DBw4DJy4DNzMGFhYXFjY2NzYmJicBooJKe1AIByRUQUJpRAvrCpDZeXrAaAkGW42mUb4IFqJVm3c/BgdbkrdjXZxzPALqAy9cQ0p4SwgJMGVJA0UCAjVoTEBgNwIBNF8/AX61XwICYLWAXIlcLwE2hAECLFeJYGikcDgCAjpqmF9BYjgCAjxuS0tmNgIAAAIADQAABCsFsAAHAAsAHUAOAwcHBgICBQkMcgsFBHIAKzIrEjkvOTMSOTAxQQchNwEzCQIDIxMEKyL8BBQDAsv+8f5CAvv86/wCB8CdA8z+kP3IA6j6UAWwAAEAWP/oBHMFsAApAB1ADicJCQIdGRkTDXIFAgRyACsyKzIvMhE5LzMwMUEnEyEHIQM2NjMyHgIHDgMnLgMnMx4CFxY+Ajc2LgInJgYBeMC+Av0g/cpnMnM7ZpNaIwgJUom5blyXbj4C5QQqVkNCYkUmBgUQL1I8QGkCpjEC2cz+mh4dUIesXWy2hkkDAT5vl1s+ZDwCATRZcDo1ZFAvAgEsAAEAXf/pBA4FugA2ABtADQ4sGCIiLAMABHIsDXIAKysyETkvMxEzMDFBMwcjJg4CBwcGHgIXFj4CNzYuAicmBgYHJz4DFx4DBw4DJy4DNzc2EjYkA6kjFAx2wpNeER8GBSROQz9iRSgGBQspSztHeFQQVw9Mc5dbY4pVIAgJU4i3bXOkZCYMDRh9zQEbBbrFAUqKvXHmM3htSAICNVtuNzBnWDcCAUFuQh9Vk248AwJUiqlXabiNTgMCZKTIZ2SpASfhfwABAIYAAASbBbAABgATQAkBBQUGBHIDDHIAKysyETMwMUEHASEBITcEmxb9A/7+Avn9Kh8FsJD64ATwwAAEADf/6QRCBccAEAAgADAAQAAhQBANPT0lLRUVBDUtBXIdBA1yACsyKzISOS8SOTMSOTAxQQ4CJy4CNz4DFx4CBzYmJicmBgYHBhYWFxY2NgEOAicuAjc+AhceAgc2JiYnJgYGBwYWFhcWNjYD4gqT5YN5wmsJB1ySsl1yw3HxBydXQ0p1SggHJ1hESnRJAUkIj9ZzarZqBwiH1n11tGD1BSBLPEJmPAcGHkw9QmU+AZWKwGIDAmG1gWObaTUCAl6vbj9pQgECQ3VGQWc9AQI/cQLgeq5bAwJZo3KCu2EDAmCwgTdgPQEBPmo/N2E9AQE/awAAAQCM//YELAXHADgAG0ANADgWISE4DCsFcjgMcgArKzIROS8zETMwMXczFj4CNzc2LgInJg4CBwYeAhcWPgI3Fw4DJy4DNz4DFx4DBwcOBAcj4Q93vIxYESMGBCJLQz5hRCcFBQonSTs4YUw0C1YJSneXVWSMVSEHCVOHuG54oVodCwsSVYe88JQbvQFBfLRz/DB7cEwBAzpfcjYwZ1s6AgEpSl4zHFGXdkUCAlSKqlhovZFRAwJrrM5mV4n1yZJQAf//ACf/8gHQBFMEJgAS+QAABwASAI4DVP///5/+uAG9BFMEJwASAHsDVAAGABAQAAACADMArQPHBFIABAAJABZADAEDBwYABAgFCAIJAgAvLxIXOTAxUwEHATclBQc3AesCYij9DhoDT/1fxBwDdAKR/v7iAXSUpvwmpgFzAAACAGABZAQYA9IAAwAHAA61BgcSAwIQAD8zPzMwMUEHITcBByE3BBgj/LQjAwMk/LUiA9LGxv5YxsYAAgAtAKID1wRIAAQACQAVQAsFCAQABgMBBwIJAgAvLxIXOTAxQQE3AQcFJTcHAQMW/ZMnAwcb/JwCrs0e/HgCaQEA3/6Mlan7K6b+jAAAAgCT//ID2gXHACAALAAbQA0BASQkKgtyERENFgNyACsyMi8rMhEzLzAxQQc+Ajc+Ajc2JiYnJgYGBwc+AhceAgcOAgcGBgE0Njc2FhUWBgcGJgIX1ggvVD8tWkMJBhZBODpZOQvrDYHKeXKrWQoHXYZEPkH+y005OU0BTjo3TQGtAlOGcjYmUWI/MlU0AgEwVjcBfK5ZAgNbqHVflXs4MXj+djpMAQFHOTpKAQFGAAACAC7+OgapBZEAQQBoACdAEhIFBUdSE3JhZGQLXV0dHTwpMAAvMy8zETMvMzMRMysyMhEzMDFBDgMnLgM3EzMDBgYWFhcWPgI3NjQuAicmDgMHBgYeAhcWNjcXBgYnLgMCNzYSNjYkFx4DEgUGBhYWFxY+AjcXDgMnLgM3PgQXFhYXByYmJyYOAgaSEEl3qG9GXTMNCo+ujgUGCiYmSWlGKgoUNHK5hofpvZFgGBUBM3G4hViqUBxQw12g7J5UDhgbdrHoARmgnOaaUxH7/wYLCi0yLkk5Kg9CF0RZckZVYysBDA47WXaVWVWIQ2UjVjNRdlAxAg5fw6NiAwI7YXU9Ajn9xxtCPSkCA1KDjDdy2r+SVAIDWZ7R7Xpv3MOZWAEBJiOHMyUBAmSv5wEMj5MBGvS4ZgICYqzj/vv2IVxZPwICMU5VIlc6clw2AgNXhZZBS6KWeEUCAT0ydSQoAgJRg5UAAAP/owAABKsFsAAEAAkADQApQBQEBwcKDQ0GAAsMDAIIAwJyBQIIcgArMisyETkvMzk5MxEzMhEzMDFBASEBMxMDNzMBAwchNwMo/YX+9gMQq1TOD58BGbIj/P4jBOH7HwWw+lAE/LT6UAIcx8cAAgAm//8EtwWwABkAMAApQBQZKSYCJycBJiYODA8CchwbGw4IcgArMhEzKzIROS8zMxEzEjk5MDFBITcFMjY2NzYmJicnAyMTBR4DBw4CBwMhNwUyNjY3NiYmJyU3BRceAgcOAgK3/oweAS1HgFgLCS9iQvja9v0B0V2mfUMHCHi5ZtP+P5ABOEuAVQsJIlhG/uAiAVoqXodDBguc8gKStwEtX01IVicBAfsYBbABAitakWlwlU8K/TDHATRpTURjNwMBtwFFCVmSX5bAWwABAF//6AUKBccAJwAVQAoZFRADciQABQlyACvMMyvMMzAxQTcGBgQnLgM3Nz4DFx4CFyc0JiYnJg4CBwcGFBYWFxY2NgO28Bit/vycj8JuIxERFGqr7JWZ0XAF8y9sXmaUZToNEgopaWBkj10B2QOc4XcEA3jF8n15hvrEbwMDf+CUAVaGTgMDVJCvVnxIppRhAwRGhgACACYAAATZBbAAGgAeABtADQIBAR0ODw8eAnIdCHIAKysyETMRMxEzMDFhITcFMjY2Nzc2LgInJTcFHgMHBw4CBAMDIxMB0P7DJQEfk897FQoLCz58Z/61IwEvktWGMxAKFXzE/v9Q/fb9xwKG4IdQVamNVwMByAEDcb/2h06T/bpnBbD6UAWwAAAEACYAAAS8BbAAAwAHAAsADwAdQA4LCgoGDw4HAnIDAgYIcgArMjIrMjIROS8zMDFlByE3AQMjEwEHITcBByE3A+gj/REiASH99v0C0yL9ciMDUyP9FiTHx8cE6fpQBbD9oMTEAmDIyAAAAwAmAAAEqQWwAAMABwALABtADQcGBgIKCwsDAnICCHIAKysyETMROS8zMDFBAyMTAQchNwEHITcCGf32/QLHI/2BIwM+I/0wJAWw+lAFsP2Dx8cCfcjIAAEAZv/rBRcFxwArABtADSsqKgUZFRADciQFCXIAKzIrzDMSOS8zMDFBAw4CJy4DNzc+AxceAhcjLgInJg4CBwcGHgIXFjY2NxMhNwTmWT650F+UzHgpEQ8TaavumpPQdQrtBzdsU2mXZjwNDwoGNXVkNWZeKjX+2iEC6P3TUFslAQJ3xveEZIv9xXADAnHOkE92QwMEWJOyWGhPrJZeAgEPJyMBIbsAAAMAJgAABYUFsAADAAcACwAbQA0JBggDAgIGBwJyBghyACsrETkvMzIRMzAxQQchNxMDIxMhAyMTBGEj/RAjqP32/QRi/fP8A1DHxwJg+lAFsPpQBbAAAQA3AAACKQWwAAMADLUAAnIBCHIAKyswMUEDIxMCKf31/QWw+lAFsAAAAQAE/+gEXQWwABMAE0AJEAwMBwlyAgJyACsrMi8yMDFBEzMDDgInLgI3MwYWFhcWNjYCu670rhON4I2Gu10H9gUdUElMb0MBtAP8/AWK0HMCA2vDhkJqQQICR3cAAAMAJgAABXIFsAADAAkADQAcQBAGBwsFDAgGAgQDAnIKAghyACsyKzISFzkwMUEDIxMhAQETAQEDATcBAhn99v0ET/1H/ncBARgB7sn+oL0BtgWw+lAFsP0//pkBDAEjAfn6UAK8ovyiAAACACYAAAPABbAAAwAHABVACgMCAgYHAnIGCHIAKysRMxEzMDFlByE3AQMjEwPAI/05IwEg/fb9x8fHBOn6UAWwAAADACYAAAbOBbAABgALABAAG0ANAgcOBQsIcgwEAAcCcgArMjIyKzIyETkwMUEzEwEzASMBMwMDIwEzAyMTAYvR1QJa5Pzorv560IVT9QXW0v31VwWw+58EYfpQBbD8K/4lBbD6UAHwAAEAJgAABYYFsAAJABdACwMIBQkHAnICBQhyACsyKzISOTkwMUEDIwEDIxMzARMFhv3u/je29v3uAcq3BbD6UAQd++MFsPvhBB8AAgBi/+kFIgXHABUAKwATQAknBhwRA3IGCXIAKysyETMwMUEHBgIGBicuAzc3NhI2NhceAwU3Ni4CJyYOAgcHBh4CFxY+AgUSChRrrfCZkshxJhALFGyu8JiTx3Ek/vALCQIubWRnmWg9DAsKAy5uYmmYaD0DAk+K/v/LdAMDfMz5gE+JAQDLdAMDe8z40lNLq5liBARZlrRXU0qsmmUDBFqWtAABACYAAAT6BbAAFwAXQAsCAQEODA8Ccg4IcgArKzIROS8zMDFBJTcFMjY2NzYmJiclAyMTBR4CBw4CAqz+giMBY1OLWwsLLGRM/s/a9v0CC4fUcQwNpf4CHgHHATlyWEpxQQMB+xgFsAEDbciNnc1iAAADAF7/AwUeBccAAwAZAC8AGUAMIBUDcgArKwMKCXICAC8rMjIRMysyMDFlAQcBAQcGAgYGJy4DNzc2EjY2Fx4DBTc2LgInJg4CBwcGHgIXFj4CAyoBSqv+vAKJCxNrrvCYk8hxJRAKFGyu8ZeTx3Ik/u8LCQEubmNomGg+DAsJAi5uY2iZZzzC/seGATYCyU+K/v7KdAMDfMz5gFCIAQDLdAMDe8v50lNLq5liBARZlrRXU0qsmmUDBFqWtAAAAgAmAAAE1QWwABgAHQAjQBIbGgkDDAwLCwAcGRgIchYAAnIAKzIrMjISOS8zEhc5MDFBBR4CBw4CBwchNwUyNjY3NiYmJyUDIyEDNxMVASMB54XTcwwJZaNnUf4xIQFEUIhaCwosZEr+89r2Ay3b9esFsAEDXryQdKNwJSTHATtxUkxqOQIB+xgCjgH9fw4AAQAm/+oEvQXGADkAH0APCiYPNjExKwlyGBQUDwNyACsyLzIrMi8yETk5MDFBNi4CJy4DNz4DFx4CByM2JiYnJgYGBwYeAhceAwcOAycuAzcXBh4CMxY2NgNQCShLXi5MlHdCBghnoL5ehdB2BfQGMWhNRYBZCwgtUFwoUZV0PgcJZp6+YWe3iksE9AQhRmU/RIFbAX47UTcmERtKZotdaZtmMQIDbMaITG09AQItXko0TDQkDhxNapFha5tiLgIBPneqbQFAY0IiAipbAAACAJ0AAAUlBbAAAwAHABVACgADAwYHAnIBCHIAKysyMhEzMDFBAyMTIQchNwNq/PT9Aq4j+5sjBbD6UAWwyMgAAQBY/+gFMQWwABUAE0AJAREGCwJyBglyACsrETMyMDFBMwMOAicuAjcTMwMGFhYXFjY2NwQ89aYXpf+eldprEqb0pQomalthj1gOBbD8NZ3megMDfeGXA838MlSHUgIDS4xcAAIAmgAABX8FsAAEAAkAF0ALAAYIAQkCcgMICHIAKzIrMhI5OTAxQQEhASMDExcjAQJAAikBFv0ivkS5CLL+7AEVBJv6UAWw+0//BbAAAAQAtQAABzoFsAAFAAoADwAVABtADRAMAQoCchMSDgQJCHIAKzIyMjIrMjIyMDFBATMDASMTEwMjAwEBMwEjAxMDIwMTAcgBxZY9/iGdOjYeo2QEAQGM+P3Wpg9nB5h0GgFSBF7+0vt+BbD7lP68BbD7rgRS+lAFsPuI/sgEmAEYAAAB/8AAAAVGBbAACwAaQA4HBAoBBAkDCwJyBgkIcgArMisyEhc5MDFBEwEhAQEhAwEhAQEBydgBfgEn/dsBP/7w3v54/tYCMv7JBbD97wIR/SP9LQIc/eQC6gLGAAEAoQAABVAFsAAIABdADAQHAQMGAwgCcgYIcgArKzISFzkwMUETASEBAyMTAQGmzgHAARz9fFv3YP7HBbD9SwK1/Fz99AIlA4sAA//lAAAE6wWwAAMACQANAB9ADwQMDAkNAnIHAwMCAgYIcgArMhEzETMrMjIRMzAxZQchNwEBIzcBMyMHITcEJyP8KiMEffvDrB4EPqpbI/xXI8fHxwRD+varBQXIyAAAAf/w/roCtAaPAAcADrQDBgIHBgAvLzMRMzAxQQcjAzMHIQECtB6f/6Ad/nUBOQaPuvmguwfVAAABAKv/gwLHBbAAAwAJsgECAAAvPzAxRQEzAQHm/sXhATt9Bi350wAAAf96/roCQAaPAAcADrQFBAABBAAvLzMRMzAxUzchASE3MxOWHgGM/sf+cx2h/gXVuvgruwZgAAACAEQC2QMxBbAABAAJABZACQgHBwYABQIDAgA/zTI5OTMRMzAxQQEjATMRAyczEwIg/vTQAaGRaAKCowS//hoC1/0pAf7Z/SkAAAH/ef9EAxEAAAADAAixAgMALzMwMWEHITcDESH8iSG8vAABAM8E0wJZBgAAAwAKsgOAAgAvGs0wMUETIwMBy4601gYA/tMBLAAAAgAc/+kD0QRQABsAOgApQBUrLB4nHjo6DycxC3IYGQpyCQUPB3IAKzIyKzIrMhI5LzMREjk5MDFlEzYmJicmBgYHBz4DFx4CBwMGBhcHByY0EwcnIg4CBwYWFhcWNjY3Fw4DJy4CNz4DMwKIUgYaRTgyWD0K6wZZiZ9MbqpZC08JBxMC6Q91GJwwZVg8BwUfQCw7c1UQPxZPaHtBWpRWBQVhmbZZ2QIHNFQxAQEjRDEBVX9TJwECWqR0/h45dzcSATVvAe+VARIsSzgtQSYBATBZOmw9ZkooAQJPjl1pjVMkAAMAEP/oBBEGAAAEABoALwAZQA4hFgdyKwsLcgQKcgAAcgArKysyKzIwMUEzAwcjAQcOAycuAzc3PgMXHgMHNzYuAicmDgIHBwYWFhcWPgIBG+zlO9cD9wINQ3WrdGeJThwECBFLeKdrcIxJE/gDBgEeS0Y+ZEwyDRwDKFxLS2lDJgYA+tnZAi0VZMekYQMCYpy3WERdvZ1dAwNloL5wFjN4bEUCAy1PZje3Q3xRAgNCbIIAAAEAN//qA+YEUQAnABlADB0ZGRQHcgQEAAkLcgArMjIvKzIvMjAxZRY2Njc3DgInLgM3Nz4DFx4CByc0JiYnJg4CBwcGHgIB4DtiQQ3fDYnLcXOjZCcKBAxTi753eK5cAd0lTz9KaUUnBwQFAyJPqwEuVjgBdKxdAgJamMFoJG/GmVYDAmq3dQE4YT0CAj5qfz4jNXlqRAAAAwA4/+gEhwYAAAQAGgAvABlADSEEBBYLcisLB3IBAHIAKysyKzIvMjAxZRMzASMBNz4DFx4DBwcOAycuAzcHBh4CFxY2Njc3Ni4CJyYOAgK54e3+9dT9mQINRXetdWaITRwFCBBMeadra4xMFvkCBgIfS0RPe1IRHAMTME84SmtFKO4FEvoAAgkVZMimYgMDZJ63V0RcvJxcAwRlobtwFTR2a0YDA05+R7cyYlAzAQNCboIAAQA6/+sD8ARRACsAH0AQZxMBBhMSEgAZCwdyJAALcgArMisyETkvM19dMDFFLgM3Nz4DFx4DBwchNwU3NiYmJyYOAgcHBh4CFxY2NxcOAgH2b6twMggEC1SNwHZxnFwfCw781BwCPQQJH1JFS2tGJwgEBhI0XERVizl0LoedFAJTj7tqKW3Ln1wDAlqVvGVnrQEVP3BIAgJCcIM+KDt0XzsCAks8e0VaKwACAF4AAANbBhkAEQAVABVACxQVBnINBgFyAQpyACsrMisyMDFhIxM+AhcWFhcHJiYnIgYGBxcHITcBTuzKDmywdiRIIxcWLRc5VzcJyCD9nCAEonKpXAEBCgi8BQYBLE84aLCwAAAD//n+UQRCBFEAEwApAD4AG0APMCULcjoaB3IOBg9yAAZyACsrMisyKzIwMUEzAw4CJy4CJzcWFhcWNjY3EwE3PgMXHgMHBw4DJy4DNwcGHgIXFjY2Nzc2LgInJg4CA2rYsxST6JBIjHgrey58TVSCUw2M/RYDDEh5r3VqiUsaBQgQTHmnbGuOThn4AgYEIk5DUX1TERwEFDFQOUttSSoEOvvlj9BvBAErUDuMPkgCAkF4UgM4/rgWZMmlYAIDYpy4WkRdvJtcAwNloLxwFTV2akUCBEx+SbczY1AxAQNCboIAAgANAAAD8gYAAAMAGgAXQAwRAhYKB3IDAHICCnIAKysrMhEzMDFBASMBEyM+AxceAwcDIxM2JiYnJg4CAgP+9esBCx9KDUV2pm1Zd0QWCXTtdgYUREFGa0suBgD6AAYA/EVeu5laAwJCcZFR/UkCujteOQECOGB2AAACACAAAAIKBdgAAwAPABC3Bw0DBnICCnIAKyvOMjAxQQMjExMmNjc2FhUWBgcGJgHHvOu8IQFOOTdPAU84N04EOvvGBDoBGDpKAQFFOTpIAQFDAAAC/wL+RgIBBdgAEQAdABNACQ0GD3IVGwAGcgArzjIrMjAxUzMDDgInJiYnNxYWMzI2NjcTJjY3NhYVFAYHBibX7cgNW5ttI0UiFRYrFi9CKAfnAU44OE9OODdPBDr7aGidVwIBCgi8BAgmRC0FsDpKAQFFOTpIAQFDAAMAEQAABE4GAAADAAkADQAdQBEGBwsFDAgGAgkGAwByCgIKcgArMis/Ehc5MDFBASMJAyc3AQMBNwECCP717AELAzL94f7NHOABYHn+/qgBXQYA+gAGAP46/fr+79zqAVH7xgIGoP1aAAABACAAAAIWBgAAAwAMtQMAcgIKcgArKzAxQQEjAQIW/vXrAQoGAPoABgAAAAMADwAABmEEUQAEABsAMgAhQBEpEgIuIiIXCwMGcgsHcgIKcgArKysRMzMRMxEzMzAxQQMjEzMDIz4DFx4DBwMjEzYmJicmDgIlBz4DFx4DBwMjEzYmJicmDgIBjpPsvN5sTgxFdqpwU3FEFgd47HYHFkVAR2hFKwKNcgtHd6RoWHhFFgl17HYHFURBOltBKANQ/LAEOv4LY72WVgMCPmqHTP0vAr06XTgCAjhgdwQZXq+JTwICQXCPUf1EAr47XTYBAitLYAAAAgANAAAD8gRRAAQAGwAZQA0SAhcLAwZyCwdyAgpyACsrKxEzETMwMUEDIxMzAwc+AxceAwcDIxM2JiYnJg4CAYqR7Lzdb0gMR3apb1h1QRQJdO12BhREQEZqTC8DRfy7BDr+CwFhvZdYAwJCcJBP/UUCvjpdNwECOGF2AAIAOP/pBB4EUQAVACsAELccEQtyJwYHcgArMisyMDFTNz4DFx4DBwcOAycuAzcHBh4CFxY+Ajc3Ni4CJyYOAkEDDFaPw3h0p2kqCgINV4/Dd3OnaSr2AgUIKFRGSm5KLAcCBggoVEZLbkorAgsXcMqdWAMCXJnDahdwyJtXAwJbmMGAFzd6akQCAkBsgT4XNnttRQICQW6CAAAD/8j+YAQQBFEABAAaAC8AGUAOIRYHcisLC3IDBnICDnIAKysrMisyMDFBAyMBMwEHDgMnLgM3Nz4DFx4DBzc2LgInJg4CBwcGFhYXFj4CAZLe7AEE2QJhAgxFdapzZYpSIQQKEE16qG1vjEkT+AMFAyBNRD5kTDMLHwMrXUhKakYpA1z7BAXa/fMVYselYgMCXZazWFBfvp1cAwNkoL5wFjN4a0YCAy1QZjfEQndMAgJCb4MAAAMAN/5gBDgEUQAEABoALwAZQA4hFgtyKwsHcgQOcgMGcgArKysyKzIwMUETNzMBATc+AxceAwcHDgMnLgM3BwYeAhcWNjY3NzYuAicmDgICR+E71f77/Q4DDEV3rnVoiE8cBAgRTXqoa22MTBf6AwYDIEtEUXxSEhwDFDFPOUtqRyn+YAURyfomA6sVZMmkYAIDY523WERevJtcAwRloL1vFTN4bEcDA06BSLczY1AzAQJCb4IAAgARAAAC8gRTAAQAFgAZQA0GCQkFFAdyAwZyAgpyACsrKzIyETMwMUEDIxMzJQcmJiMmDgIHBz4DFzIWAZKW67zfAUYaFy8XPWJKMg44CjFYiGEXLgNg/KAEOgnhBAYBJENdOQRPqpNbAggAAQAb/+sDwQRPADUAF0ALGwAOMikLchcOB3IAKzIrMhE5OTAxQTYmJicuAzc+AxceAgcnNiYmJyYGBgcGHgIXHgIHDgMnLgI1FxQWFhcyNjYClwhAYCg9eWQ6AwRQf5hLabFrAeoCJ0o0LVc+BwYiPEMbVaRoBQNWhp9Nartx4y9VOS9fRQErNz0gCg8vSGlJVH5UKAECTphwATJJKAEBIEAxJjEeEwYXR39nWH9RJgECVJ9zATpQKQEbPgACAD//7QKuBUMAAwAVABNACQoRC3IEAgMGcgArMi8rMjAxQQchNxMzAwYWFhcWNjcHBgYnLgI3Aq4f/bAe2euzBAklJxUrFhEkSyZabiwIBDqwsAEJ++YjNB0BAQYDugsKAQFRiFQAAAIASv/oBC8EOgAEABsAFUAKAREGchgDAwsLcgArMi8yKzIwMUETMwMjEzcOAycuAzcTMwMGHgIXFjY2AraN7LzeY04MQG6kb1l5RhcIdet2AwYcNy1ggUsBCwMv+8YB4ANit5BSAwNBcJBQArv9QidIOiMCA1GOAAIAZAAABBIEOgAEAAkAF0ALAAYIAQkGcgMICnIAKzIrMhI5OTAxZQEzASMDEwcjAwGOAYj8/emdDXwQk8bJA3H7xgQ6/HawBDoABAB5AAAF9AQ6AAUACgAPABUAJEAUBwsAEQMUBgkQDAEKBnISDgQJCnIAKzIyMisyMjISFzkwMWUBMwMBIxMTByMDAQEzASMTEwcjAzcBWAF/nlr+go1JKxiTYANMAUPs/imcB2ANgWkD+wM//vn8zQQ6/KTeBDr8yAM4+8YEOvyy7ANL7wAB/7oAAAQSBDoACwAaQA4HBAoBBAkDCwZyBgkKcgArMisyEhc5MDFBEwEhARMjAwEhAQMBcY4BBAEP/mfv9Zv+8f7xAajmBDr+mwFl/eH95QF1/osCMgIIAAAC/7z+RwQZBDoAEwAYABlADRcWFQMIAhgGcg8ID3IAKzIrMhIXOTAxZQEhAQ4DIyYmJzcWFjMWNjY3ExMHBwMBVwG+AQT9hhtFWG1EHz0eEQsWCzlWQRl3bgKkvoIDuPsgOGRMKwELB7kBAwIhRDEEl/zK9ioEVgAD/+YAAAPkBDoAAwAJAA0AHEANBAwMCQ0GcgcDAwYCEgA/MzMRMysyMhEzMDFlByE3AQEjNwEzIwchNwNfIvzxIgN4/L+hHQM8pVoi/SQiwMDAAtn8Z6YDlMDAAAIALf6VAwMGPwARACUAGUAKHQkKChwcEhMBAAAvMi8zOS8zEjk5MDFBFwYGBwcOAgc3NjY3Nz4CAwcuAjc3NiYmJzceAgcHBhYWAt8kbmcPHA+Ax3cLZ28PHBBprW0zbIo5DBwHFEVCC22oWgsbCAY5Bj+LKLJuzn+dSwOLA3pizny4ffkBiSSFuHDNPWA7BYsEU550zUGBaAABACH+8gHNBbAAAwAJsgACAQAvPzAxQQEjAQHN/vKeAQ4FsPlCBr4AAv+Y/pICbgY8ABMAJgAbQAseCwoKHx8BFRQAAQAvMy8zEjkvMxI5OTAxUzceAgcHBhYWFwcuAjc3NiYmASc+Ajc3PgI3BwYGBwcOAqA1a4k6DRsIFEVCCmuqWgsbCAc5/tkkSV4zCxsQgMZ3C2duEBwQaK0FtYcjhrhvzz1fOgWFBFCac89BgWn4+owbYoJJzICaSAOEBHpjzH24fQABAFwBgwTHAzIAHwAbQAsMAAAWBoAcBhAQBgAvMy8RMxoQzTIvMjAxQTcOAycmJicmJiciBgYHBz4DFxYWFxYWFzI2NgQYrwYyV4BTUoE4IEsxNkcmCLcGMll/U1KDNiBLMjdIKgMRAkqPdEMBAk45IjoBOVktAUqMcUEBAk85ITsBPFwAAAL/5v6TAc4ETwADAA8ADLMBBw0AAC8v3c4wMUMTMwMTFAYjBiYnNDYzNhYaysmZ7k05OE4BTjo3Tf6TBAP7/QU+OkwBRjk6SwFFAAADAE3/CwQCBSYAAwAHAC8AJUASAgElJSEDHAdyBwQICAwGEQ1yACvNzDMSOTkrzcwzEjk5MDFBAyMTAwMjEzcWNjY3Nw4CJy4DNzc+AxceAgcjNiYmJyYOAgcHBh4CAxc0uzQiM7szcjxiQw3fDorNcXShYSULBA1WjcB3eKxbAt4BJE0/SmtHKAkDBwIgTQUm/t8BIfsF/uABIIACL1Y4AXWsXQIDWpjBZyRwx5hWAwNqtnU5YT4BAz9pgD4jNHlqRgAAA//3AAAEogXHAAMABwAiACFAEAYFBQEfFgVyDA0NAgIBDHIAKzIRMxEzKzIROS8zMDFhITchAyE3ISUDBgYHJz4CNxM+AhceAgcnNiYmJyYGBgPw/AcjA/n3/UAiAsH+60wLW1K2Jy4YBVUQhdSGeqtXBO0DHUk9RGE5xwGRw/X9lWCVMUgQR1cmAnSDx24DA2W0eAE4XDgCAUVvAAAGAAb/5QV/BPEAEwAnACsALwAzADcADrUPGQUjDXIAKzIvMzAxQQYeAhcWPgI3Ni4CJyYOAgc+AxceAwcOAycuAwEHJzcBByc3ASc3FwEnNxcBKgsgUYNWX6aDUw0LH1KBV1+mg1S7DnG054N9wH83DQ1xtOeDfcB/NwUP3XTe/Erdc90DXKmRqvyNqZCpAldPm35NAgNKg6ZZT5p9TQMDS4GmWH7ms2YCA2mw23R+57RnAwNqsdsCd8SWxPu5xJXD/qfYgdgDMdmA2AAFAC4AAASuBbEAAwAHAAwAEQAVAC1AFgsQEAYHEhUVCA4DAwICERQMcgkRBHIAKzIrEjkvMxI5OTIRM84yMxEzMDFBByE3AQchNyUBIQEjAxMHBwMBAyMTA8ca/LQaAxoa/LMbAZoBvAEP/dGPUcMuj/4B/IX0hQLjlZX+3ZSU+AL4/JQDbfzxXQEDbP1O/QIC/gAAAv/u/vIB9QWwAAMABwANtAECBgcCAD/d3s0wMVMjEzMTAyMTyduK26KE3IT+8gMZA6X9CgL2AAAC/+D+JASrBccALwBhAB5AE1M/AAEFK101MTAPIQxPRB0UEXIAKzIvMxc5MDFlNz4CNzYuAicuAzc+AxceAgcjNiYmJyYGBgcGHgIXHgMHDgMDBw4CBwYeAhceAwcOAycuAzc3Bh4CMxY2Njc2LgInLgM3PgMCTgs9c1ALCC9TYClOlHM9BwZlnLhahstrBuoEMGJJPn5cCwksUV8rT5V1QAcGYpewXQs+aUcKCCpQXy1PlXI+BgdjmrhbZa2BRAPuBCBAXDg9flwLCTBUXyZOlHVABgZekqp6gwIpVkI3SzMiDhpDXodgZ5JcKwICY76LR2k8AQEiU0Y4SS4fDRlBXodgZYRLIALxhQMpVEE6TDEgDhtBXodhaZFZKQECNWifbAE7VzkeASJRRDZIMCANGUJeh2Bhg04hAAIA1wTjA40FzwALABcADrQDCQkPFQAvMzMvMzAxUzQ2NzYWFxQGBwYmJSY2NzYWFRYGBwYm10cyMkgBRzIxSQHBAUYzMkkBSDIxSAVWM0QBAUAzM0MBAUAxM0QBAUA0M0IBAT8AAAMAXP/oBdwFxwAfADMARwAfQA4dBAQlJUMUDQ0vLzkDcgArMhEzETMvMxEzETMwMUE3BgYnLgI3Nz4CFxYWByc2JicmBgYHBwYWFhcWNiUGHgIXFj4CNzYuAicmDgIHNhI2JBceAhIHBgIGBCcuAgIDqZAMuJhshzsIDAtfonGRnAWSBUNZSWE3CQ0GEkRFXWD9RRAwebt9g+i3dREPL3m7fITot3WFEIbVARGcleeaQw8RhdX+75yV55pDAlUBlqkEA2+vYnVosmwCA6mQAVRjAgFLd0B3OHNSAgRk1HPcsWsCA2a153xz2rFrAgNms+Z9lQER1XoDAn7T/vqMlP7u1nsDAn/UAQcAAgC/ArIDRwXIABcAMQAatTEaGg0WKrgBALIIDQMAPzMa3MQSOS8zMDFBEzYmJicmBgcnPgIXHgIHAwYGFyMmEwcjDgIHBhYXMjY2NxcOAiMmJjc+AjMCajUDDCgnOFMPogdejEtTdDkGMQcDCJ8OYhSCJ1dBBgg9KiZSQhAGF01dNGR/AgJwolADXgFWIjokAQIyNgxTaDICAUd7Uv7GL1ouUAFtcQEWNS4vJgEfNiRzLkEhAXVmYWgnAP//AEYAiQOsA6cEJgGT7P4ABwGTAUv//gACAIABdwPGAyIAAwAHABK2BgcDBgICAwAvMxEzEjkvMDFBByE3BQMjEwPGHPzWHgMbPbo+AyKlpUv+oAFgAAQAXP/oBdsFxwAeAC8AQwBXADVAGx8bGCAEAgIBAQ8pDQ01NVMMDw9JUxNyP0kDcgArMisSOS8zETMRMy8zEjl9LzMSFzkwMUEjNxc+Ajc2JiYnIwMjEwUeAgcOAgcGBgcOAgc3FhYHBwYWFwcnJjY3NzYmJQYeAhcWPgI3Ni4CJyYOAgc2EjYkFx4CEgcGAgYEJy4CAgM13xKwKVI9CAkkRS2NcI6FAQFOhU8EAklpNQQHBAoQEiEXcX8IBgMDAgGOBQQEBwY2/XkPMHi8fYPot3UQDy94vHyD6bd1hRGF1QERnJXnmkMPEIXW/u+blueaQgKOggECGjYtMzUUAv0xA1ABAjRuVktMLh0CCQMHCAQCYwN0djchPSESASRJJTVIPEtz3LFrAwJmted8c9uwawIDZrPmfZUBEdV6AwJ+0/76jJT+7tZ7AgN/0wEIAAEBBAUQA7EFqgADAAixAwIALzMwMUEHITcDsRj9axkFqpqaAAIA5QOvAuUFxwAPABsAD7UTDMAZBAMAPzMazDIwMVM+AhceAgcOAicuAjcGFjMyNjc2JiciBugBTXxLRWk6AQNJektGaz2GBjkyOFEHBjQzOFYEsEmATgEBS3ZCSX5MAQFHdUUwSVI1L0wBVAAAAwAZAAEEAgT9AAMABwALABK3CwIDAwQKEnIAKy85LzMyMDFBByE3AQMjEwEHITcEAh/8hSACZ5fRlwFVH/zFHwODxMQBevw8A8T7xcHBAAABAFcCmwLuBb4AHAATsRwCuAEAswsTA3IAKzIazDIwMUEHITcBPgI3NiYnIgYHBz4CFx4CBw4CBwcCwRr9sBcBOBo+LwcGLCo6RQy0CFaJU0l8SgMDTGsznwMskYQBARY4QCUpMQFINQJUekEBATNnUEZtWCV1AAACAGgCjgL5Bb4AGQAzACxADBwYAAAaGhAsKSkkELgBALULCwgQA3IAKzIyLxoQzDIvMhE5LzMSOTkwMUEzPgI3NiYnIgYHIz4CFx4CBw4CByMHNxceAgcOAicuAjUzFhYXMjY3NiYmJwFhSSJBLwYGOigrQw62B1eESUSCVAICXYc+gAgPYkF7UAIBZpdKTH5MrgFAMTFaCAYdNiAEawIVLiYsKAEmKE1lLwEBLWBOS1gmAShSAQIgUk1WajECATZrUDIsATQ2JSkSAQABAMcE0wLNBgAAAwAKsgGAAAAvGs0wMVMTIQHH7QEZ/sgE0wEt/tMAA//e/mAEWQQ6AAQAGgAeABlADB0FABYLE3IDEnIcAAAvMisrMhE5LzAxQTMDIxM3Nw4DJy4CJxMzBh4CFxY+AgEzASMDbey82BpGVAowW5RsP3ZUCw6BBAEZQDtObkcp/cbr/vvqBDr7xgEI8gJYvJ9iAwIwXEMBEi9kVjcCAjReewKE+iYAAAEAfgAAA9AFsQAMAA62AwsCcgAScgArK80wMWEjEycuAjc+AjMFAtTGW0SHwV8NDpXskQElAggBA3XMh5TVdAEAAAEAnwJEAbIDUAALAAixAwkALzMwMVM0Njc2FhcUBiMGJqBOOzpOAVA6OVACxTtOAQFJOjtNAUcAAf/N/j0BLwAEABMAEbYLCoATAgASAD8yMhrMMjAxdzcHFhYHDgMHNz4CNzYmJicZrBQ+QAEBRGp6OAcgQjEGBixCGAMBPA1WP0ZaMhUCigISKSUlHwkDAAEA5AKbAoAFrwAGAAqzBgJyAQAvKzAxQQMjEwc3JQKAg7FkzBsBagWv/OwCPDGXcgAAAgC+ArADcAXIABEAIwAQthcOIAUDcg4ALysyETMwMVM3PgIXHgIHBw4CJy4CNwcGFhYXFjY2Nzc2JiYnJgYGxQcKY6FqZIhACAcLYaBqZIlAtQkFEj48PVUyCAkFFD06PlYyBBNPZKReAgNhn2BQZKJdAgNgn69SMl9AAQI9YjdRMWA/AgI8YgD//wAFAIsDdQOoBCYBlAkAAAcBlAFyAAD//wDBAAAFIgWsBCcB4QBRApgAJwGVARUACAAHAjsCqQAA//8AtQAABXgFrwQnAZUA6wAIACcB4QBFApsABwHgAv0AAP//AJYAAAWhBb4EJwGVAaMACAAnAjsDKAAAAAcCOgChApsAAv/U/nsDHwRQACEALQAYQAoAACUlKxAREQ0WAC8zMy8/My8zLzAxQTcOAgcOAgcGFhYXFjY2NzcOAicuAjc+Ajc+AgEUBiMGJic0Njc2FgGQ1QcuUT4uWkIJBxlDNzxaOQvrDIHKenKuWgkHXoZFKDUeATVNOThOAU45OE4ClgFSg3A3KFRlQDRSMQECMlc3An2vWwMCWad3YJh+OCFJVQFuOkwBRjk6SgEBRgAABv+NAAAHbwWwAAQACAAMABAAFAAYADFAGAAXFwgHFBMHEwcTAg0DGAJyDAsLDgIIcgArMjIRMysyMhE5OS8vETMRMzIRMzAxQQEhATMDByE3AQchNxMDIxMBByE3AQchNwQz/H/+2wQgmx8l/SolBX0i/Tgi88HrwgKnIv2bIgMcIv05IgUL+vUFsPx60tL+l8HBBO/6UAWw/aHBwQJfwcEAAgAfAMoEDwR3AAMABwAMswQGAgAALy8zMjAxdycBFwEBNwGdfgNzff71/Y2dAnLLnAMQnPzvAyaH/NsAAwAW/6IFkAXtAAMAGwAzABdACwEALwojFgNyCglyACsrMhEzMjMwMUEBIwETBwYCBgYnLgQ3NzYSNjYXHgQFNzY2LgInJg4CBwcGBh4CFxY+AgWQ+zexBMs1ChRqrvCZda92QRIMCxRsrvCYda52QhH+8wsHAxU4Zk5omWc+DAsIAhU5ZU5pmGc9Be35tQZL/RVQif7/y3QDAlKMs8pnUIgBAMt0AwJSi7PKuFM8iIJqQwMDWZa0V1M8h4NsQwMEWpa0AAIAJwAABIEFsAADABkAHUAODw4OAxkEBAMAAnIDCHIAKysROS8zETkvMzAxQTMDIwEhHgIHDgIjJTcFMjY2NzYmJicnASTs/ewBMAFqgc5xCwyi9oz+2CEBDU+JWwwJLWNI+AWw+lAElwNkvYmWxmIBvwE6cVJIajsDAQABAB3/6QRQBhgAOQAZQA0jGzYIAgpyCAFyGwtyACsrKxEzETMwMUEDIxM+AxceAgcOAwcGHgMHDgInLgInNxYWMzI2Njc2LgM3PgM3NiYmJyYGBgHDu+u9DU17qGlnoVgIBi47MgkJKUdKMQMHf8h0L2FeKkEubjg1X0AJCCxJSzAEBS89MwcGGj4xTF4yBFL7rgRTY6d6QQMCUplsO2JZXjc0WlZXYjt7pVABAQ0cF8AeIyVLNzZaVFVjPjdfWV04LkwuAgNOfAAAAwAO/+oGXwRRABQAMgBeADdAHFczMzIXRkUUJQADKRdFF0UPHykLckw+PgUPB3IAKzIyETMrMhI5OS8vEhc5ETMRMzIRMzAxZRM2JiYnJgYGByc+AxceAgcDAwcnIgYGBwYWFjMWPgI3Fw4CJy4CNz4DMwEuAzc3PgMXHgMHByE3ITc2JiYnJg4CBwcGHgIXFjY3Fw4CAoJYBRVBOTReRArpB1mIoFB1plAMUm8c1Tl1VAkHJ0csKF9aQgxhK5axVGKaVAUGXpOuVAJac6dpKwoHDVWJvXRol1sgCxX85h0CKgYJFUtER2tJKggIBg0xXUhVlkk4M4ONtQIXM1c3AgEjRzUSWH9RJQEDYq12/hEBq6QBJU9BMD4eARoxRCqWTWAqAQJMkGdkg00g/WgCU5G8azprxJlWAwJQh65gjKcfPGtFAgM9aX08OT91XjoCAjYopSs1GAACAEb/6ARIBi0ANAA4ABlACzYgFhYBKgwLcjgBAC8zKzISOS8zMzAxQTceAhIHBw4DJy4DNz4DFx4CFSc2LgInJg4CBwYeAhcWPgI3NzYuAiUBJwEBelan9pg5FQwQWY/DemSfbDMJCU2BsW5ooFxXAyVCUilIbk0uBwYQLU85SmxJLAkOEyVvvAJJ/bU8AksFbcAqsvr+0adVbdCmYQMDTYOsYWa7kVIDBGWmZgIvRi0XAQI1XnZBMmRUNQICRHKDPWaF7cSOLf6ddQFiAAMAPgCUBDwEywADAA8AGwATtxkTAgcNAwISAD/dxjIQxjIwMUEHITcBNDY3NhYVFgYHBiYDNjY3NhYVFAYHBiYEPCT8JiQBm1A5OVABUDo4UI4BTjs5UFA6OVADGM7OASk8TAEBRzo8SgEBRv0MPEsBAUc6O0sBAUYAAwAq/3UEMAS9AAMAGQAvABlADCABARULcisAAAoHcgArMi8yKzIvMjAxQQEjAQE3PgMXHgMHBw4DJy4DNwcGHgIXFj4CNzc2LgInJg4CBDD8k5kDbvynAw5ZkcR5c6ZmKAsCDlqRxHhzpWco+QMFBSZTRUtvTC0JAgcGJlNGS29MLAS9+rgFSP1NF3DLnVkDA1yawmkYcMmbVwMDW5fBgBc2eWtEAgI/bII+FzZ6bUYCAkBugwAD/83+YAQVBgAAAwAZAC8AG0APKwogFQdyCgtyAwByAg5yACsrKysyETMwMUEBIwEBBw4DJy4DNzc+AxceAwc3Ni4CJyYOAgcHBh4CFxY+AgIM/q3sAVMC6wINRHWqc2aKUiEFChBNealsb4xJFPgDBQMgTUQ+ZE0yCx8DGDJPN0pqRikGAPhgB6D8LRVjxqViAwJdlrNYUF++nV0DA2WhvW8VNHdrRgIDLVBmN8QyXEstAQNEboMABAA3/+gFEwYAAAQAGgAvADMAHUAPIQQEFgtyMzIrCwdyAQByACsrMs4yKzIvMjAxZRMzASMBNz4DFx4DBwcOAycuAzcHBh4CFxY2Njc3Ni4CJyYOAgEHITcCueHt/vXU/ZkCDEZ3rXRniE0cBQgQTHmna2uMTBf6AgYCH0tET3tSERwDEzBPOEprRSgD2h39cx3uBRL6AAIIFmPJpmMDBGSet1dEXLycXAMEZaC7cRU0dmtHAgNNf0e3MmJQMwEDQm6CAxSnpwAEACwAAAXaBbAAAwAHAAsADwAfQA8DAoAHBgYKDAsCcg0KCHIAKzIrMhE5LzMazDIwMUEHITcBByE3EwMjEyEDIxMF2hz6qxwD4SP9ECSn/fX9BGL99PwEq56e/qXHxwJg+lAFsPpQBbAAAQAjAAABygQ6AAMADLUDBnICCnIAKyswMUEDIxMByrzrvAQ6+8YEOgAAAwAhAAAEkAQ6AAMACQANAB9ADwwHBwsGBgIJAwZyCgIKcgArMisyETkvMzMRMzAxQQMjEyEBITczAQMBNwEByLzruwO0/Zz+9QejAY+Z/vDHAWYEOvvGBDr9ddoBsfvGAeGB/Z4AAwAfAAAD0gWwAAMABwALABtADQIKAAcGBgoLAnIKCHIAKysRMxEzMhEzMDFBBwU3AQchNwEDIxMCuBr9gRsDmCT9OiMBH/31/QOymLya/c/HxwTp+lAFsAAAAgAgAAACXwYAAAMABwATQAkCBgAHAHIGCnIAKysyETMwMUEHBTcBASMBAl8b/dwbAfj+9uwBCwO0mLuYAwf6AAYAAAADACP+RwV7BbMAAwAHABkAHUAOFQ4GBwcDCHIJBQQAAnIAKzIyMisyETMvMzAxQTMDIwE3AQcTMwEOAiciJic3FhYzMjY2NwEf9v31ATS1Aju19PX+/g9kqncjRSMjGDAZNEMmBwWw+lAFRG/6uWwFsPoZcK9jAgoJwgcIN1UtAAIAEf5IA/kEUQAEACoAGUAOHBUPciYLB3IDBnICCnIAKysrMisyMDFBAyMTMwMHPgMXHgMHAw4CIyYmJzcWFjMWNjY3EzYuAicmDgIBjZHrvNd9IwxBb6JuXHlBEwl2D2KndSNEISEYMhg1QyUIdgYFHT41SnJRNANF/LsEOv4GAl29nF0CAkp7mFH9I2+rYAEJCcEHCAE1Uy4C3C1URCgCAzZfeQAFAFD/7AeNBcYAIwAnACsALwAzADNAGi8uLiYyKDMCciknJghyFRISFhkJBAcHAwADAD8yMhEzPzMzETMrMjIrMjIROS8zMDFBMhYXByYmIyYOAgcDBh4CFxY2NwcGBicuAzcTPgMBByE3AQMjEwEHITcBByE3Ax1JkkkWRItFW45lQQ0wCQw2a1VJkUgTRoxGfb59MxAvE22q3wQgIv0QIwEg/Pb9AtMj/XMjA1Mj/RYjBcYOCMYOEAE/cZRT/s1IjXNHAgIODMcICwEDYKTUeAEwf9qjWvsBx8cE6fpQBbD9oMTEAmDIyAADAD//6AbOBFIAKgBAAFYAJ0ATJAAARzwTEhI8UhkLCzEHcjwLcgArKzIRMzIROS8zETMzETMwMUUuAzc3PgMXHgMHByE3BTc2JiYnJg4CBwcGHgIXFjY3FwYGATc+AxceAwcHDgMnLgM3BwYeAhcWPgI3NzYuAicmDgIEynCjZioKBAxVi7tzaJddIwwW/OweAiUFChpNREVmRigIBQYLK1VFVZpHPU/W+xkDDViPw3lzpWQmCgMOWJDCeHOkZSf7AgYEJFBGS25KKwkCBgUlUEdLbUoqFAJYlr1mK2nGnlsDA0+FrWKOrQEdPGpEAgJDbn45Kjh2ZD8CAzIsnkY6AiAXcMudWAMCXJvCaBhwyZtXAgNcmcB/FzZ5akUCA0Bsgj8WNnptRgICQW6CAAEAHAAAAxoGGQARAA62DQYBcgEKcgArKzIwMWEjEz4CFxYWFwcmJiMiBgYHAQfryg5orXYnTSclFy4YOFIyCQSicaldAQENB7gGCC9TNQAAAQBL/+kFLQXEACwAG0ANDwAGCQkAGiIDcgAJcgArKzIROS8zETMwMUUuAzc3IQchBwYeAhcWPgI3NzYuAicmBgcnPgIXHgMHBw4DAk2SznkpEhcEAyP8+QgNFUR2VWKYbkMOEg0TS4ppY75cHjqWmkSW34w2ExETc7XwFAJtuvGHj8MjTohmOwMCU4yrVXxcqYVPAgIoI8UlJwwBAWu9+I57hPfFcAAAAf9E/kYDTAYZACcAKUAVFAICFScGch8iIh4bAXILDg4KBw9yACsyMhEzKzIyETMrMjIRMzAxQQcjAw4CJyImJzcWFjMyNjY3EyM3Mzc+AhcyFhcHJiYjIgYGBwcCwhvJlQ1doXMjQyEgFi4YNEAiBpahG6ENDmesdShOJicYMBg4Ty4JDgQ6sPwxbahgAgsJuwcJNVItA8+waHKoXQIOCLgGBi5QNWgAAwBc/+kGIQYtAAkAIQA5AB1ADgUGBikpAAAcA3I1EAlyACsyKzIvMhE5ETMwMUE3DgIHNz4CAwcGAgYGJy4ENzc2EjY2Fx4EBTc2Ni4CJyYOAgcHBgYeAhcWPgIFeagKYLOHDlNgMGULE2uu8Jh2rnVDEg0LFGuv8Jh1rnZBEv7yCwgDFjhkUGiYaD0NCwgCFjhlT2mYZz0GKwKDvmgEkgJQfv0gT4r+/8t0AwJSjLTKZlCIAQDKdQMCUouzyrhTPIiCakIDBFmXs1hSPIeDbEQCBFqWtAAAAwA0/+kE8ASqAAkAHwA1ABVACiYbC3IxAAAQB3IAKzIvMisyMDFBNw4CBzc+AgE3PgMXHgMHBw4DJy4DNwcGHgIXFj4CNzc2LgInJg4CBFmXCVehegtNWCr78AIOWJLEeXSlZigLAg5ZksR4cqZmKfkCBgUmU0ZKb0wtCQIHBiZSRkxvTCwEqAJ3pVYEeQJFcP2mF3DLnVgDAlyawmkYcMmbVgIDW5jAgBc3eGtEAgI/bYE+FzZ6bUYCAkBugwAAAgBY/+kGpAYDAAkAHwAZQAwFCgoAABUCchsQCXIAKzIrMi8yETMwMUE3DgIHNz4CJTMDDgInLgI3EzMDBhYWFxY2NjcF/6UMbciXDmV3Pf5J9aYYpP6fldprEqb0pQomalthj1gOBgIBlMZnA5ICS4cL/DSd5XkDAn3hlwPN/DJUiFEDA0yMXAAAAwBK/+gFWQSWAAkADgAlAB1ADgULCwAAGwZyIg4OFQtyACsyLzIrMi8yETMwMUE3DgIHNz4CARMzAyMTNw4DJy4DNxMzAwYeAhcWNjYExJUKXqp+DFRfMP3+jey83mNNDD9upHBZeEUYCHXrdgQHHDctYIJKBJUBfptKAn0CMmb8wwMv+8YB4ANiuI9SAwJCcJBQArv9QidIOiMCBFKOAAH/BP5HAdsEOgARAA62DQYPcgEGcgArKzIwMVMzAw4CJyYmJzcWFjMyNjY37+zDDmKndSNDIiIYLxk0RCYHBDr7iW+sYQEBCgm7Bwk3Vy0AAQA0/+oD2gRRACoAGUAMERQUABkLC3IkAAdyACsyKzISOS8zMDFBHgMHBw4DJy4DNzchByUHBhYWFxY+Ajc3Ni4CJyYGByc2NgI4cKNmKQoEDFWKvHJpmFwiDBUDFR/93AULGk1DRmZGKAgFBgsrVURVm0c9T9cETwJZlb1mK2rGnVoDAk+FrWKOrgEcPGpEAgJDbn45Kjh1ZEACAzIsnUc6AAABAP4E3gOgBgAACAAUtwcFBQQBA4AIAC8azTI5MhEzMDFBExUnJwcHJwECtOy5eLDAAQEvBgD+7xEDnJsDEgEPAAABAQkE4AO9BgMACAAStgEGgAcEAgAALzIyMhrNOTAxQRc3NxcBIwMnAcx0rc8B/suU6gEGAJybBBD+7QETEAD//wEEBRADsQWqBgYAcAAAAAEA/QTLA3IF6AAOABC1AQEJgAwFAC8zGswyLzAxQTcOAicmJjUXBhYXFjYCxK4HXJNZgKavAzhDRFAF5gJbgEICApaDAT5PAQFPAAABAQME4gIABdcACwAJsgMJEAA/MzAxQTQ2NzYWFRQGBwYmAQNINTVLSDY1SgVYN0YBAUI2NkUBAUAAAgD6BIwCogYmAA0AGQAOtBcEgBELAC8zGswyMDFTNDY2MzIWFRQGBiMiJjcGFjMyNjc2JiMiBvo9ZTtUdz5lO1N3aAUwLDBKBgYwLTBKBU88YjlzVTxgNm5XKj9GLypBSQAB/6j+VQEgADsAFQAOtAgPgAEAAC8yGswyMDF3Fw4CBwYWFzI2NxcGBiMiJjc+Aqt1I1I+BgMYHRgsFQ0iTilVaQIBTnY7PRk6Si8dIAEOCY0VFGlXSnBQAAABANwE3wPEBfMAGQAnQBMAAAEBChJADxpIEgWADQ0ODhcFAC8zMy8zLxoQzSsyMi8zLzAxQRcOAicuAwcGBgcnPgIXHgM3NjYDNo4FN2RIJkA8PiMvMAySBjhkSSQ/PD8lLjIF8wpBd0sBAR4mHAECPigHQHhMAQEdJhwBAT8AAAIArgTRA+sF/wADAAcADrQBBYAABAAvMxrNMjAxQQEzASETMwEB5AES9f7I/fvk7v7xBNEBLv7SAS7+0gAAAv/0/mwBUf++AAsAFwAOtA8JgBUDAC8zGswyMDFHJjYzMhYVFgYHBiY3BhYzMjY3NiYjIgYLAWtKRGMBaEhFZ2IEIh4hNgUEHh8iOPNLZl5GSWMBAVpJHS00IBsxNQAAAf1WBNP+2wYAAAMACrIDgAIALxrNMDFBEyMD/lGKtNEGAP7TASwAAAH93ATT/+gGAAADAAqyAYAAAC8azTAxQRMFAf3c8gEa/sME0wEtAf7U///8+ATf/+AF8wQHAKX8HAAAAAH91QTl/zwGfAAUABC1FAIAgAsMAC8zGswyMjAxQSc3PgI3Ni4CJzceAwcGBgf+jLcLGkU3BQQcLjAQECprYz8BAmNABOUBkAEKHiMZGwsCAXgBDiZIOkhICwAAAvy8BOT/sAXuAAMABwAOtAcDgAQAAC8yGs0yMDFBIwMhASMDM/6J2/IBCgHqz8D/BOQBCv72AQoAAAH8of6V/a//jAALAAixAwkALzMwMUUmNjc2FhUWBgcGJvyiAVA3NVEBUTU1UvQ5RQEBQTc5RAEBQAABATYE7AKRBkAAAwAKsgCAAQAvGs0wMUETMwMBNnrhxgTsAVT+rAAAAwDvBOMEIAawAAMADwAbABlAChMZGQ0BgAAABw0ALzMzLxrNETMRMzAxQRMzAwU0Njc2FhUWBgcGJiUmNjc2FhUUBgcGJgJAYOSy/h1GMzFJAUcyMkgCPQFGMzJJRjIySQWHASn+1zI0RAEBQDI0QwEBPzE0RAEBQDM0QgEBPv//AJ8CRAGyA1AGBgB4AAAAAQArAAAErAWwAAUADrYCBQJyBAhyACsrMjAxQQchAyMTBKwj/XHa9f0FsMj7GAWwAAAD/6wAAAUPBbAABAAJAA0AG0ANBgIHAwJyDQwMBQIScgArMjIRMysyEjkwMUEBIQEzEwE3MwEnByE3A439KP73Az6Oov76OY4BNLEj/DYjBSL63gWw+lAFQ236UMfHxwADAF3/6QUXBccAAwAbADMAG0ANLwoDAgIKIxYDcgoJcgArKzIROS8zETMwMUEHITcFBwYCBgYnLgQ3NzYSNjYXHgQFNzY2LgInJg4CBwcGBh4CFxY+AgOrIf5RIgMNCxNrrvCYdq52QhINChRsr/CXda91QhL+8gsIAhU4ZU9omGg9DQsIAhY4ZU9omWc8Azm/vzdPi/7/ynQDAlKMtMpmUIgBAMt0AwJRjLPKuFM8iIJqQgMEWZa0V1M8h4NsRAIEWpa0AAAC/7IAAAR9BbAABAAJABdACwYAAgcDAnIFAghyACsyKzISOTkwMUEBIQEzEwM3MxMDF/2r/vAC6bEysxuo7wTD+z0FsPpQBOHP+lAAA//+AAAEhAWwAAMABwALABtADQEABQQEAAgJAnIACHIAKysyETkvMxEzMDFjNyEHATchBwE3IQcCIwOpJP0sIwLbIv04JAN6JMfHAofCwgJhyMgAAQArAAAFgwWwAAcAE0AJAgYEBwJyBghyACsrMhEzMDFBAyMTIQMjEwWD/fTZ/Y/a9f0FsPpQBOj7GAWwAAAD/9wAAASdBbAAAwAHABAAIUAQDgYGBwcPAnIMAwMCAgsIcgArMhEzETMrMhEzETMwMWUHITcBByE3AQcBIzcBATczA+Yj/HYjBEEj/JwjAeMC/Xu5HAIj/qYYqcfHxwTpyMj9OBX9LZ0CTAJBhgAAAwBUAAAFrAWwABMAJwArACFAEBQVFQEAKQhyHx4eCgsoAnIAK80yMhEzK80yMhEzMDFlJy4DNzYSJDMXHgMHBgYEJRcyNjY3Ni4CJycmBgYHBh4CAQMjEwMQxHbAhD4MEbYBHanJdr+EPQwRuf7i/p3HbqxrDwgVP2lLzG+taw0JF0FrAfH99f2qAgJPj8V3rAEAjQIDUpPHdq38h9MDVZ5tR3pbNQMCAVmibkh3VzMEMfpQBbAAAAIAdgAABdEFsAAZAB0AGUAMFAcHDRwIch0BDQJyACsyMisROREzMDFBMwMGAgQnJy4DNxMzAwYeAhcXFjY2NwMDIxME2/ZUG7v+3rhVgMiDNw9T9FMJE0BxU1N6s24Sufz1/QWw/hK1/vaPAQEEWJzUgAHu/hFMiWtABAECY7F0Ae76UAWwAAADAAoAAATvBccALQAxADUAJUASKBISLykpNBERMy4yEnIGHQNyACsyKzIyMhEzMxEzMhEzMDFBNzYuAicmDgIHBwYGFhYXBy4DNzc+AxceAwcHDgMHNz4DATchByE3IQcDyg4IAyddUliAVzMKDwgNEUNJDXKfXiANDhFopN2IgLtzLA8OEWOdz34PU3NKLP6jIwHhI/vHJAHoIwLvaD+QgFQDA0t/mElnPaOlgBuPF43I3WdkfOOxZAMDa7HddWR258KCEpAddpio/WHIyMjIAAADADv/5wQyBFIAFgAsAEEAGkANLgY0OzsdEgtyKAYHcgArMisyMhEzPzAxUzc+AxceBAcHDgMnLgM3BwYeAhcWPgI3NzYuAicmDgIBMwMGBhYWFxY2NxcGBicuAzcTRAMMQ3Wud1FxSCYMBAcPRXCfaWqMTRf5AgYDIEtCQmhPMw0JAwwpTz9Na0QmAinNgQIFAxQYBg4HBho4Hz1QLQ8CXgH0FWTQrWgDA0ZzipJCPli7nl8DA16ZtnAWM3FkQAMCOWF0OUYzdWtGAgNKeIkB8/0HDy0tHwIBBAG0DwwBATlbazQCPgAAAv/m/nUEaQXHABwAOgAeQA41ACYnJxwcMB0DEwkLcgArMj8zOS8zEjk5LzAxQRceAgcOAicuAzc3BhYWFxY2Njc2JiYnJxMeAgcOAiMjNzMyNjY3NiYmJyYGBgcDIxM+AgIve3O1YQkKgteIV5JpNwRdBUp8Rk1+UAoIH1FFfMJztWUJCIzPbm8UQUZrQggGIk06RG5HC/jr9xKT3AMtAQNaqnqHzHADAjlpkFgbTWYzAgFCdUtAbkcDAQMgAlyreHmiU4Q3ZUY3XDcCAkBsP/pXBah+wWsAAwB1/l8EMAQ6AAMACAANABlADggMAwQKBQEFDQZyAQ5yACsrMhIXOTAxZQMjEzcBMwEjExMHIwMCG1zsXIYBfv390KYHbgmZuG398gIOoQMs+8YEOvy38QQ6AAACADX/6QQcBiQALABCABlADRQoPgMEMx4LcgsEAXIAKzIrMhIXOTAxQT4CFxYWFwcmJgciBgYHBh4CFx4CBwcOAycuAzc3PgI3NS4CAwcGHgIXFj4CNzc2LgInJg4CAToFfb1lRIBAEzd3PilVPwkGGTE3F3qnTA4CDlmRwnVxpGgrCQMMZ6hwMEMiBwMFBidRRUhtSy0JAwUOLEw5SG9NLgTkcI5CAQEdFr8XIAEYNi0hMCYbCjWf14cWcMSXUwMCVpO7aBduv4QVDRtNYP1uFjZ3aUMCAj9qgD4VMW9mSQsGQG2BAAIAKP/qBAQETwAfAD8AH0APACE+PgMDFjUrB3IMFgtyACsyKzISOS8zEjk5MDFBFwcnIgYGBwYeAhcWNjY3Nw4DJy4DNz4DBScuAzc+AxceAxUnNiYmJyIGBgcGHgIXFwHt8xavOG9RCQUgO0YhNWpQDewIW42lU0iZgU0DBFaGmgEu1TmAb0QCA1uQpk1LjnND6AE2VS0wZ00IBhozPx7LAkwBdwEbRUEoOCIQAQEgRzgBXINSJQIBI0p5V1dxQBpHAQIdPGNHXX1KIAICKFB5UwEzPhwBHUI3JjIcDQEBAAACAGb+fAQ+BbAAKAAsABVACRUCLCwpKQACcgArMi8zETMvMDFBMwcBDgIHBh4CFxceAgcOAgcnPgI3NiYmJycuAzc+AjcDIQchA7COG/5lRX5ZDwUGGC4jXD1vQwQFSms1dhgyJgYGHC8XSERqSB8HDG2cUOgC9iH9CgWwmP5dRZSpZSU9MCUOHxUwVU1EemUkaBk3QCMdJBYHFhVAV3VKdtvAUQHYvgACABH+YQP7BFEABAAcABdADBgLAwZyAgpyCwdyEQAvKysrETMwMUEDIxMzAwc+AxceAwcDIxM2LgInJg4CAY6S67zXcD4LQ3Wob1t5QxQIu+y7BgggPjJKbk4wA0X8uwQ6/gcEYr2bWgICQ3CSU/usBFQtTTwjAQM3YXoAAwBu/+kEQgXHABkAJwA2AB1AEA0oajAgajAwDQAaagANC3IAKy8rEjkvKyswMUEeBAcHDgQnLgQ3Nz4EFyYOAgcHITc2Ni4CAxY+Azc3IQcGBh4CAsZpj1cpBAsgDjZXfKltaY9XKQQLIA42V32oYFFtQyUKBwHICAUIBiFE/EFeQywaBwf+NwYGCAcgRQXEA06CpLFW1ly7p4FIAwNPhaWzVNdduqV/RsEEUIGRPjQ2KGltXjz7pgM1XHF0MS4vKGpvYT4AAQBm//UCAAQ6ABEADrYGDQtyAAZyACsrMjAxUzMDBhYWFzI2NwcGBiMuAjfx7IQECSYmFSwVESRLJlpuLAgEOvz4IzQeAgYCuQsKAlGJVAAC/6f/8APaBfsABAAmAB5AEAAbBAMEAiAFAHIPFhYCCnIAKzIvMysyEhc5MDFBASEBFwEyHgIXEx4CFxY2MwcGBiMuAicDAy4CJyYGBzc2NgIq/ob+9wJPqP7+LEs8KwvjBREdGgkTCQ4VKhZFXzsQmT4IGCceDhwODR4+AuT9HARSCAGwFixAK/vKFyodAgEBwAQDATVeQQMSAQUbKRgBAQEBtAcIAAACAEL+dgQeBcYAHgBGABlACx8RDw8hITMFGwNyACsyLzkvMxI5OTAxQQcuAiMiBgYHBh4CFxcHJy4DNz4DFzIWFgEXByciBgYHBhYWFxceAgcOAgcnPgI3NiYmJycuAzc+AwQeNiJHSCU6fl4KCCJDVCucGoNIn4xUBAZck7BYMV1b/tOcGH1ir3YMCS5ePl48cEUFBEtrM3sYNigGBR0vFjdXkWYyBwp3t9gFmLoKEgofS0QzRCcRAQGMAQEeRndbZI5aKQELFP3FAYgBO4NqRWdFEhkRMlhJRHlkJGYaOD8mHCIUCBEbR2SRY3unZC0AAAMAYf/1BOUEOgADAAcAGQAZQA0OFQtyBgpyCQcCAwZyACsyMjIrKzIwMUEHITchAyMTITMDBhYWFzI2NwcGBiMuAjcE5SH7nSEBlLzsvAIu7IQECiUlFioVDiVLJVtuLAcEOrq6+8YEOvz4IzQeAQUDugsKAlGJVAAAAf/L/mAEDwRRAC8AF0AMHikGEQtyBgdyAA5yACsrKxEzMjAxQxM+AxceAwcHDgMnLgMnHgIXHgIXFj4CNzc2NiYmJyYOAgcDNaoQVIa4dHecVhsLAgxFdahwaIZLIQENHBwPAylaTUdoRigJAgUCG0tGQ2FBJwio/mAD4mnAk1MDA2WlyWYVYr6bWgMDXZWxVwoUFAlDdUgDAjtkejwVMoF4UAMCQmx6NvwsAAEANv6JA+MEUQAtAA61GwkFAAdyACvMMy8wMUEeAgcjNiYmJyYOAgcHBhYWFx4CBw4CByc+Ajc2JiYnLgI3Nz4DAmt5qlUE3gQfSkBIaUgqCAQKLWhQPnRKBANLajN4GDMmBQQZLReAsFQNBAxWjr4ETgJptnc6YD0CA0BsfjwjVYFbGxYxWFBCemUkaBg4PyYcJBQIKojIjSNtx5pXAAADADf/6QSvBEIAGAAuADIAE0AJKgYyBnIfFAtyACsyKzIyMDFTNz4DFx4CFx4CBwcOAycuAzcHBh4CFxY+Ajc3Ni4CJyYOAgEHITdBAw1ZkcJ3HTM1IVFpLwcDC1qPvW9zpGUm+AMFBSRRR0lrSCkIAgYGI09DSGxLLAN4Iv3TIgIKF2zHmlQGDzEzDyeNrFYXa7yPTgICW5rAfxc2eWpFAwJCbIE9FzRzZkICAjtnfAHbwMAAAAIAbP/sBCQEOgADABUAFUAKBQoRAgMGchELcgArKzIRMzIwMUEHITchMwMGFhYXFjY3FwYGJy4CNwQkIfxpIQFK64QDBB4iGS4XEihVL19tKQgEOr6+/PAdNiQBAQ0HshUSAQJaklcAAQBX/+cD7gQ8AB4AE0AJEAcZAAZyGQtyACsrETMyMDFTMwMGBhYWFxY+Ajc2AicXFhYGBw4DJy4DN8/rbQQBEjIvSW9NLggTCiDgGhUDCw9SisR+Y4lSHgkEOv1nIlNNNAEET36MOoABBn0CUayvVXHWqmEDAkZ6n1sAAAEAMf4iBV4ERQAvABlADCsFBRkYBnIiDwtyAAAvKzIrMjIRMzAxQRM+AhceAwcOAycuAzc+AjcXDgIHBh4CFxY2Njc2LgInBgYHAwGa3QlTglBtqXIxCxCByvuKid2ZQxANTn5XjDVUOgwPIFeLW3vUjQ8GCChQPh4hCOP+IgUcT3ZCAQJZlr5nkNuSSQICUZnbjGq+oD6SMnaFSFqTaToCAlmvfzVzZEMFCRYf+t0AAgA//iUFXwQ8AB4AIgAVQAohBxkLciAQAAZyACsyMisyLzAxUzMDBh4CFxY+Ajc2JicXHgIHDgMnLgM3ATMBI6LsUgwYSoJfY6uEVhATEyPbHxsCChN9xP2SjduQOxECVOv+8uwEOv4SWJdxQAICOG2dYnv+dwJOpqhTk+WcTwICVZ/ijwHp+esAAgBS/+cGBAQ9AB4APwAZQAwBFwoKKTYfBnI2C3IAKysRMzMRMzIwMUEXHgIHDgMnLgM3EzMDBgYWFhcWPgI3NgIlFwYCBwYGHgIXFj4CNxMzAw4DJy4ENz4CBN7dIyIECwxAca17Z309DAozrDQFAxQ6OURaNRwHERf8KvBDghYFCQEXNjA+VTYeBjWrMw07ZZpsXX9NIwMJDDtZBD0DUauvVmfTsGgDA2Obs1IBN/66J2hjQwIDVoKIMYIBB3kBff7/jh5faV0+AgQ7YW8wAUb+yVq5mlwDAkl4laBLYbWpAAEAUv/oBI4FygA4AB1ADR0eFzYEBA0jFwtyLQ0ALzMrMhE5LzMQzDIwMUEHBgYnLgI3Nz4CFx4DBwMOAicuAzcTNwMGFhYXFjY2NxM2NiYmJyIGBgcHBhYWFzI2BI4HOHU7mPKFDAELZ6pwVXdIGghnE4jbkGKbZywLLuQuCSBXTE5oOgtnAwEOJCIuOyAGAQhGi2I5dAMgxhIVAQGB554Ua6xkAwJDb41N/YaJ1ngDAkt/qGABIQH+3UR4TgIDTn1EAosbOzQjAi9KKRZhjU0CEgAAAwBuAAAFFwXIAAMAFgApAB5ADhAJCR8mA3IaGBYDAwISAD8zETMzMysyMhEzMDFBAyMTNwE+AhcyFhcHJiYjIgYGBwEnAxMHBwMuAicmBgcnNjYzHgICvnn0eHgBHh9SbkslRiM4DRsNHCojDv5jqBB7BZuvBhYgFg8cDxAePyFDXz4Ct/1JArc1AgE+ZDkCEA27AgUVJBX9TwEC+P3f1wECsRQgEwEBBAPBDAwBN14AAAMAVP/nBoUEPQADACQARQAhQBAmBQMcDy88C3I8DwIDBnIPAC8rMhE5KzIRMxEzMzAxQQchNyUXHgIHDgQnLgM3NzMHBgYWFhcWPgM3NgIlFwYCBw4CFhYXFj4CNzczBw4DJy4ENz4CBoUg+fkfBEncJCIDCgopRmeRYGeAPw4KIqwjBQIXPTo0STAfEAURGPxF8EODFgMLAhIvLD9XOB8IIqwiDTxonWxceUYfAQgNO1kEOrKyAwNQrK9WT6ebe0YDAmKbs1TU4ylpY0IBATpfbWYkggEHeQF9/v+OGl1pYEADBjticDDj1Fy5mloCA0x6l51HYbWpAAADAJT/7gWABbAAGwAfACMAIUARHyMYBQUOIiMeCHIjAnIOCXIAKysrETMSOS8zETMwMUE3PgIXHgIHDgMHNz4DNzYmJicmBgYTAyMTIQchNwIyEDl6fT2K1nEMC2Wgym8RQW5UNggJMGpOP3p4tf30/ALWI/u0IwJuzBQfEAECZsaSea1uOAK/ASFBY0JPbjwBAhEeAy76UAWwyMgAAAIAYf/pBQ0FxwADACwAHUAOAwICCR0ZFANyKQQJCXIAK8wzK8wzEjkvMzAxQQchNwE3BgYEJy4DNzc+AxceAhcjLgInJg4CBwcGBh4CFxY2NgNpI/2+IwKQ8hmt/vybkMJuIxASFGms65aZ0nAF8wIua15nlWQ8DREIBBM0YU1kkF0DQMfH/pkCm+F2AwN3xfN9d4j5xW8DA4Dgk1eGTwMEVpGvVns6g39pQgIDRogAA//G//8H7gWwABEAFQAuACdAEyQhIQkuFhYACgkIchQVFSMAAnIAKzIyETMrMhI5LzMRMxEzMDFBMwMOBCcjNzc+BDcBByE3AQUeAgcOAychEzMDBT4CNzYmJiclAe70nxQzTHeufEkaI1NxSCwcCwNdJP1gIwKyAVSG0nIMCmSgx2z95v312wELU4xbCwotY0r+jwWw/S1j0L2WWAHGAgZWhJyaPwKTyMj97gEDbsmMc7B4PQEFsPsXAgFDfFVIcEEDAQAAAwAr//8H9AWwAAMABwAgACNAEQggIAMCAgYVBwJyFhMTBghyACsyETMrMhE5LzMzLzMwMUEHITcTAyMTAQUeAgcOAychEzMDBT4CNzYmJiclBF0j/RYjqv31/QOuAVSC1HQLCWWfx2r95vz12QEJUYtdCwoxZUf+kANBxsYCb/pQBbD91AEEZsGLcq50OgEFsPsbAQE9dVNHaDoDAQADAJ0AAAWLBbAAFQAZAB0AHUAOGQEYBhERGBwdAnIYCHIAKysyETkvMxEzMjAxYSMTNiYmJyYOAgc3PgMXHgIHAQMjEyEHITcFL/RMCiRnWDJhY2AvFC1eX2EwkddrEf2m/fb9AtUj+8EjAcZWdDwCAQgOFg7KDhYMBgECZ82aA+z6UAWwyMgAAgAi/pkFegWwAAcACwAXQAsJBgECcgsDAwAIcgArMhI5KzIvMDFzEzMDIRMzAyUDIxMi/fXaAnDb9f3+eF/1XwWw+xcE6fpQu/3eAiIAAgAj//8EpAWwAAUAHgAhQBAGHh4EAhMTBQJyFBERBAhyACsyETMrMhEzETkvMzAxQQchAyMTEwUeAgcOAychEzMDBTI2Njc2JiYnJQSkI/1w2vT8SAFVg9R1DAlkoMZr/eb89tsBClKLWwwJMGVH/o4FsMj7GAWw/dEBA2TAjHOtdDoBBbD7FwE+dlVJZzcDAQAG/4j+mgWQBbAAAwAHAAsADwATACUAJ0ATCxERIAMDBx4Icg4PDxAUAnIJBQAvMysyMhEzKzIyETMyETMwMWUHITczAyMTIQMjExMHITchAyMTITMDDgUHIzcXPgM3BKcj++4jPWHpVgWGb+hhaCP9cyMDR/z0/f16+IoRL0BSaIJOkR0+TG1MMxPHx8f90wIt/dQCLATpyMj6UAWw/bNMqa6kkG0fxwI7m7C7XAAF/6QAAAfoBbAABQAJAA0AEwAXACdAExYRCQMDAAAPDxQMCAhyDgoBAnIAKzIyKzIyMi8zETMRMzMzMDFBASETIQcnASEBAQMjEyEBITczAQMDNwECSf6CAR3uAQhI1f4i/sECfAKx/PT9BAr9av6sBPEBvdn+ywFXAnYDOv2f2RX9dQM/AnH6UAWw/MbZAmH6UAKgovy+AAIAH//qBKQFxgAeAD4AI0ARACACAj4+FTQwKglyDwsVA3IAKzLMK8wzEjkvMxI5OTAxQSc3FzI2Njc2JiYnJgYGBwc+AxceAwcOAyUXHgMHDgMnLgM3FwYWFhcWNjY3Ni4CJycCk9MZnEuDVwoJO21BRHhVDfQJY5q5X1+rhEYIB2OZsf7otlakf0UHB2ypy2ZhqoBGA/MDPGlETJFoCwcZPFg3twK5AY8BMGVQR1wuAQEwX0UBZ5tmMwECMWOYamGMWyxYAQIpV4tkcqZrMgICOGqeZwFGYzYDATNqUTtVNxwCAQAAAQAlAAAFfAWwAAkAF0ALBQAGAggCcgQGCHIAKzIrMhI5OTAxQQEzAyMTASMTMwFiAx78/fW0/OP8/fQBqAQI+lAECfv3BbAAA//F//4FfgWwAAMABwAZABlADBIFEQhyAgMDBAgCcgArMjIRMysyMjAxQQchNyEDIxMhMwMOBCcjNzc+BDcEwyP9WiMDYf31/f1j9Z8VMk12r3tJGiNUcUgrGw0FsMjI+lAFsP0tYtC/mFYCxwIGVYSbmkAAAAIAmf/oBVYFsAATABgAGkAOFxYAFQQIAhgCcg8ICXIAKzIrMhIXOTAxQQEhAQ4DIyImJzcWFjMyNjY3AxMXBwECOAIGARj9SiNQYXlNGzcbFhIoFDRLOBcB2hi3/sYCBQOr+1c/aU4pBAPHAwQmQysEbfzP+wgENAAAAwBV/8QGDAXsABUAKQAtABtADB8MDCsWAAArKgNyKwAvKxE5LzMROS8zMDFBBR4DBw4DIyUuAzc+AxcmBgYHBh4CFwUyNjY3Ni4CJxMBIwEC/wEVe8GCOg0NcbXmg/7rfMGCOg0NcbTnfHm3bw8JFEBvUQEYeLVwDgoTP21TIf7v7AERBSgCA16g03eD3KBZAgJbn9B4hN2kWsgBa7h2SYZqQAMCaLZzSohsQgMBjvnYBigAAgAh/qEFeQWwAAUADQAZQAwMBwJyBQQECQYIcgEALysyMhEzKzIwMWUDIxMjNwUTMwMhEzMDBU5y4z5/I/xG/fXaAnHa9fzJ/dgBX8nJBbD7FwTp+lAAAAIAxAAABV0FsAAVABkAF0ALFwYRERgAAnIYCHIAKysROS8zMjAxQTMDBhYWFxY+AjcHDgMnLgI3ATMDIwEh9EoKJGZYMWJhYC8TLl1hYDCS12oRA5P1/fUFsP48V3Q8AgEHDxYNyQ8WDQYBAmjOmgHD+lAAAQAoAAAHZQWwAAsAGUAMBQkGAgILAAJyCwhyACsrETMRMzIyMDFBMwMhEzMDIRMzAyEBJfXaAbPa9dsBr9r1/fnABbD7FwTp+xcE6fpQAAACACj+oQdlBbAABQARAB1ADgwFCAgEEQhyDwsGAnIBAC8rMjIrMjIRMzMwMWUDIxMjNwEzAyETMwMhEzMDIQcxcNk9fyH7XvXaAbPa9dsBr9r1/fnAv/3iAV+/BPH7FwTp+xcE6fpQAAIAh///BZsFsAADABwAHUAOERIPBBwcDwABAnIPCHIAKysyETkvMxEzMjAxUzchBxMFHgIHDgMnIRMzAwU+Ajc2JiYnJYciAd4hFAFUg9V1DAlkoMZs/eb99dsBClOKWwwJL2ZG/o4E8MDA/pEBA2TAjHOtdDoBBbD7FwIBP3ZUSWc3AwEAAgAs//8GuQWwABgAHAAdQA4aGQ4LABgYCwwCcgsIcgArKxE5LzMRMzIzMDFBBR4CBw4DJyETMwMFMjY2NzYmJiclAQMjEwFwAVWD1HQLCmSfxmz95vz22gEJU4pcCwowZkf+jwVs/fT8A4EBA2TAjHOtdDoBBbD7FwE+dlVJZzcDAQL2+lAFsAAAAQAk//8EiAWwABgAGUAMDgsAGBgLDAJyCwhyACsrETkvMxEzMDFBBR4CBw4DJyETMwMFMjY2NzYmJiclAWcBVYPUdQwJZKDGa/3m/PbbAQpSi1sMCTBlR/6OA4EBA2TAjHOtdDoBBbD7FwE+dlVJZzcDAQACAEj/6QTyBccAAwAsAB1ADgMCAh4JBSkJchkVHgNyACsyzCvMMxI5LzMwMUEHITcBMx4CFxY+Ajc3NjYuAicmBgYHBzY2JBceAwcHDgMnLgIEVyP9sCP+QfIDMm9fZpJiOQ0RCAMVN2RNZI5aFvMbqgEAnJDEciQQEhNoqOmTmNh2AzvIyP6gWYNLAwNXkq9VezqEf2hAAwNLilwBmuR6AwJ4xvN+eIb4xHADA3rdAAQAM//pBwIFxwADAAcAHQAzACNAEy8HBgYOJBkDAnICCHIZA3IOCXIAKysrKxEzEjkvMzIwMUEDIxMBByE3BQcGAgYGJy4DNzc2EjY2Fx4DBTc2LgInJg4CBwcGHgIXFj4CAiX99f0BpBj+lRcFigsTa63wmZPHcSYQCxRsrvCYk8dxJP7wCwkCLm1jaJloPQwLCgIubmNpmGc9BbD6UAWw/XHAwB9Piv7/y3QDA3zM+YBPiQEAy3QDA3vM+NJTS6uZYgQEWZa0V1NKrJplAwRalrQAAv+nAAAEzAWxABYAGgAfQA8XFhYAAAkMDBkIcg4JAnIAKzIrMhESOS8zEjkwMUEhJyYmNz4CMwUDIxMnBgYHBhYWFwUFASEBA4X+hliJkQ0MpPyRAen89trZgLMQCSdhTAFE/s/+Rf7sAb8CIio6y5ucyGEB+lAE6AIBhYNKcEEDAVD9bgKSAAMAQv/oBFYGFQAWAC8ARAAZQAw6IjAXFyIAAXIiC3IAKysROS8zETMwMUE3DgMHDgMPAjc2EjY2Nz4CAx4DBwcOAycuAzc3PgI3PgIXJgYGBwcGHgIXFj4CNzc2LgIDmrwGQGuLUXadYjMLCb0JEE6J0ZIxaVH3aZZeJggCDFePv3N0pWcqCAIEISgNN5G3Olp9SAoCBgsoU0RHakkrBwIFDSxTBhQBXHZIKg8WcKHFbUQRRIcBB+GdHAoYOP4jA1OLr2AWbsCRUAMCWpnAaRYaLy0WW5xdwAJYkFAWN3JhPgECOWF4PRY2bFc3AAACACP//wQPBDoAGwAzAC1AFgIBGyspKSgBKAEoDw0QBnIeHR0PCnIAKzIRMysyETk5Ly8RMxI5OREzMDFBITcFPgI3Ni4CIycDIxMFHgMHDgMHAyE3BT4CNzYmJiclNwUXHgIHDgMCaP6mHAEIL2VMCQYbM0AfzJvquwGbRpF4RwQEQmh5Oo3+WH4BMDFeQwkHJkkp/uYgATQ1RnpKAgRShZ4Bz6oBAhM5OCcxGgsB/IQEOgEBHEBwVkVfPCEF/fC+AQEZPjcxOBgBAaoBQgk6aU5ce0cfAAABABYAAAOIBDoABQAOtgIFBnIECnIAKysyMDFBByEDIxMDiCL+NpvrvAQ6wPyGBDoAAAP/hf6+BGMEOgAPABUAHQAhQBAdGAkWFhsTCApyFRAQAAZyACsyETMrMjIyETMvMzAxQTMDDgMHIzc3PgM3EyEDIxMhASEDIxMhAyMBiuxOFEdxpHJQGh86WUAsD4oCnLzrmf5P/jwEeFrrOP1hOO8EOv6EbdrCkiO9ATdye4tQAX37xgNu/VL9/gFC/r4AAAX/sAAABoEEOgAFAAkADQATABcAMEAXFRAQABYREQkDAwYAABQHDBITDQ0CBnIAKzIRMz8zMzkvMzMRMzMRMxEzETMwMUEBIRMzBycBIQEBAyMTIQEhNzMBAwM3AQG//swBE6vWRKX+p/7TAeUCX7zrvAN4/e7+2QfDAUCcwMMBFAG1AoX+Vtsa/jECXwHb+8YEOv172wGq+8YB4YH9ngACABf/6gO9BFAAHQA7ACNAEQAfAgI7OxQyLikLcg8LFAdyACsyzCvMMxI5LzMSOTkwMUEnNxc+Ajc2JiYnJgYGBwc+AhceAwcOAyUXHgMHDgMnLgI3FwYWFhcyNjY3NiYmJycCKtgWljFXPAcGJEUqMFc/C+wJiMVoR4tvPwQETHWJ/vS7Qn9lOgMFV4qjTmmzbQLoAS9RMjNgQwgHI0ovsQIEAXoBARw+NS88HgEBIEAwAXGRRgIBI0l0U0tqQh9HAQEdPmhNW4BQJAICTZZwATRFIwEiSDY1PhsBAQABABcAAARFBDoACQAXQAsFAAYCCAZyBAYKcgArMisyEjk5MDFBATMDIxMBIxMzAUICEPO87H397/K86wFvAsv7xgLL/TUEOgADACIAAAR+BDoAAwAJAA0AH0APDAcHCwYGAgkDBnIKAgpyACsyKzIROS8zMxEzMDFBAyMTIQEhNzMBAwM3AQHIu+u8A6D9tv7uB7oBZprwxgFRBDr7xgQ6/XXaAbH7xgHhgf2eAAAD/7z//wRFBDoAAwAHABkAGUAMEgURCnICAwMECAZyACsyMhEzKzIyMDFBByE3IQMjEyEzAw4EJyM3Nz4ENwOPIv3+IgK4vOu8/fjrdw8pPl6HXlEXIztRNCETCAQ6wMD7xgQ6/epNnY5vPgHFAgQ9XG1tLQAAAwAjAAAFmwQ6AAYACgAOABtADQAJDAYBCgZyCwMJCnIAKzIyKzIyMhI5MDFBATMBIwMzIwMjEwETMwMCrQHC1v2RoffCN7zquwMVvOy8ASYDFPvGBDr7xgQ6+8YEOvvGAAADABcAAARDBDoAAwAHAAsAG0ANCQYIAwICBgcGcgYKcgArKxE5LzMyETMwMUEHITcTAyMTIQMjEwNMIf3eIpO867wDcLzsvAJ2vr4BxPvGBDr7xgQ6AAMAFwAABEUEOgADAAcACwAZQAwJBggCAwMHBnIGCnIAKysyETMyETMwMUEHITczAyMTIQMjEwONIf34Iji867wDcrztvAQ6wMD7xgQ6+8YEOgACAFQAAAQMBDoAAwAHABC3AwYHBnICCnIAKysyMjAxQQMjEyEHITcCtLzsvAJEIfxpIQQ6+8YEOr6+AAAFADn+YAVSBgAAFgArAEIAVgBaACdAFScGBkkeERFSMz4LcjMHclgAclcOcgArKysrETMzETMyMhEzMDFBBw4DJy4DNxM+AxceBAc3NjYuAicmBgYHAx4CMxY+AiU3PgQXHgMHAw4DJy4DNwcGBhYWFxY2NjcTLgInJg4CEwEzAQVKAgw+baFvT3NLIgMwDUBliVdZd0cgBPQCBAUIHz82Olc9EUoHKkcxRWFAJPvrAgoqSGiPXFFyRR0CLg1AZIdWaYNEEfgCBQIYQT84Vj4TRwUkRDZKYz4gcQFT7P6tAhYVXr+eXwMDQ3CJSAE7TZd6RwICSnqUmloWJGBlVjcCAyxQMf5ULj4jAkBneSwVTKSZeUYDAkx6kUj+00yTdUUDA2KbtWsWLHBnRAICJUcwAaAwTC4BAUx6iPwdB6D4YAAAAgAX/r8ERQQ6AAcADQAbQA0GAQMNDAwACnIBBnIJAC8rKzIRMzIRMzAxcxMzAyETMwM3AyMTIzcXvOuaAZqa7bywbNg4fiEEOvyGA3r7xr/+AAFBvwACAG0AAAQYBDsAAwAXABdACw8UCQkBAAZyAQpyACsrETkvMzIwMUEDIxMTBw4CJy4CNxMzAwYWFhcWNjYEGLvsvC4SMm5xOH66Ww416zUJG01GOnFuBDr7xgQ6/iHBFx0OAQFgtoMBSP63Ql81AgERIAABABcAAAYtBDoACwAZQAwFCQYCAgsABnILCnIAKysRMxEzMjIwMVMzAyETMwMhEzMDIdPrmgFMmuyaAUub67z6pgQ6/IYDevyGA3r7xgACABH+vwZCBDoABQARAB1ADgwFCAgEEQpyDwsGBnIBAC8rMjIrMjIRMzMwMWUDIxMjNwEzAyETMwMhEzMDIQZCa9k4fiH79OubAUyb7JoBS5rsvPqmv/4AAUG/A3v8hgN6/IYDevvGAAIAUf//BKsEOgADABwAHUAOERIPHAQEDwIDBnIPCnIAKysyETkvMxEzMjAxQQchNwEFHgIHDgMnIRMzAxc+Ajc2JiYnJQJuIv4FIgGRASdrsWQIBlOGpVf+ILztm9g6Y0QJByBHMv68BDrAwP6oAQRSnXRgjl8uAQQ6/IUBASlRPTRLKgIBAAACACP//wX4BDoAGAAcAB1ADhoZDgsYAAALDAZyCwpyACsrETkvMxEzMjMwMUEFHgIHDgMnIRMzAxc+Ajc2JiYnJQEDIxMBPQEnbLFkCAZThqVX/iG765rZOmNECQcfSDL+vATcvOy8AuIBA1OddF+PXy4BBDr8hQEBKVE9NEsqAgECGPvGBDoAAQAj//8D5QQ6ABgAGUAMDgsYAAALDAZyCwpyACsrETkvMxEzMDFBBR4CBw4DJyETMwMXPgI3NiYmJyUBPQEnbLFkCAZThqVX/iG765rZOmNECQcfSDL+vALiAQNTnXRfj18uAQQ6/IUBASlRPTRLKgIBAAACACD/6APMBFEAJwArAB1ADisqKgkdGRQLcgQACQdyACsyzCvMMxI5LzMwMUEmBgYHBz4CFx4DBwcOAycuAjcXBhYWFxY+Ajc3Ni4CEwchNwIoOl4/C94Kh8xwcaBhJQoEDlWNv3Z1q1kF3wQhSzxIakgpCAQGAyFN0x3+VR0DjwIwVTgBdKxeAwJcmr9mJG3HmVgDAmy3dAE3YT4DAkBrfzsjNHdsR/7oo6MABAAl/+gGCQRSAAMABwAdADMAI0ATJAMCAhkvDgcGcgYKcg4HchkLcgArKysrETMSOS8zMjAxQQchNwEDIxMBNz4DFx4DBwcOAycuAzcHBh4CFxY+Ajc3Ni4CJyYOAgLsIv3MIQEVvOu8AUkDDliRxHl0pmYoCwMNWpLEeHKlZyj5AgYFJlJGSnBMLQkDBgYnUkdLbkwsAoXAwAG1+8YEOv3QF3DLnVkDA1yawmkYcMmbVwMDW5jAgBc2eWpFAgI/bIE/FzZ7bEYCAkBugwAC/70AAAQYBDsAAwAdAB1ADgESEhMTAwkEBnIHAwpyACsyKzISOS8zEjkwMUEhASEBBQMjEycOAgcGFhYXBQclLgM3PgMBQgEC/nr+/wKJAdK865vMNWNHCQciRCsBQx/+2UmJaToFBVWHpAIR/e8EOwH7xgN8AQEmSzgvQCMCAbABAStRe1FdhlcpAAQADf5HA/EGAAARABUALAAwAB1AEDAvKBwHchUAchQKcg0GD3IAKzIrKysyzDIwMUEzAw4CJyImJzcWFjMyNjY3AwEjARMjPgMXHgMHAyMTNiYmJyYOAgEHITcC2O1XDmGndiNDIiAYMxk1QyQHfv716wELH0oNRXambFp3RBUIdO11BxRDQUdrSy4BqR39cx0Bzv31bqxiAQoJvAgJOFctBj76AAYA/EVeu5laAwJCcZFR/UkCujteOQIBN2B3AtWmpgACADn/6QPsBFEAAwArABtADQQNAwICDSEYB3INC3IAKysyETkvMxEzMDFBByE3ARY2Njc3DgInLgM3Nz4DFx4CByM0JiYnJg4CBwcGHgIClBz+NRwBFDtiQw7dDIrOcXOiYSQKBA5VjcB3eataAd0jTz5Ka0coCQMGASBOAmijo/5DAi9WOAF0rV0CA1qYwWckcMaZVgMCa7Z1OWE9AgM/aYA+IzR5akYAAAP/uP//BkkEOgARABUALgAlQBIWLi4AJCEhCgkKchQVFSMABnIAKzIyETMrMjIRMxE5LzMwMUEzAw4EJyM3Nz4ENwEHITcBBR4CBw4DJyETMwMXPgI3NiYmJyUBUOp3Dyg+XodeUxkiO1E0IRQIAooi/g0iAhkBJmezaQcFVYakVf4hvOyb2DdkRAkIJkou/r0EOv3qTZ2Obz4BxQIEPF1tbS0Bz8DA/ocBA0uVcl6KWSsBBDr8hAEBJ007MkEfAgEAAwAX//8GWgQ6AAMABwAgACVAEhUWExMGCAMgAwICBgcGcgYKcgArKxE5LzMzETMRMxEzMjAxQQchNxMDIxMBBR4CBw4DJyETMwMXPgI3NiYmJyUDUyL93yGNvOu8At4BJ2eyaQcGVIakVP4gvOyb2DhjRQgIJkkv/r0CnL6+AZ77xgQ6/ocBA0qVc12KWisBBDr8hAEBJ007MkEfAgEAAAMADQAAA/IGAAADABoAHgAZQA0eHRYKB3IDAHIRAgpyACsyKysyzDIwMUEBIwETIz4DFx4DBwMjEzYmJicmDgIBByE3AgP+9esBCx9KDUV2pm1Zd0QWCXTtdgYUREFGa0suAbse/XMeBgD6AAYA/EVeu5laAwJCcZFR/UkCujteOQECOGB2At6npwAAAgAX/psERQQ6AAMACwAXQAsABgYLCnIJBAZyAgAvKzIrMhI5MDFlMwMjAzMDIRMzAyEBfexg60vrmgGamu28/I7A/dsFn/yGA3r7xgAAAgBf/+YHMAWwABgAMAAbQA4sHwlyFAcJciYaDgACcgArMjIyKzIrMjAxQTMDDgMnLgM3EzMDBh4CFxY2NjcBMwMOAicuAzcTMwMGHgIXFjY2NwOoyK8NSnelaGKYYyoLrvWtBQYgPzVNbUALA0H1rhOG2Y1hi1YgCq7HrQYJI0Q1TGg9CgWw/AFhp35EAgJGe6RgBAD7/yxXSi4CA0V2RgQA/AGI0HMDA0t+oVoEAPv/LVlILQIDRndEAAACAEf/5wYqBDoAGAAxABtADiwfC3IUBwtyJhoOAAZyACsyMjIrMisyMDFBMwMOAycuAzcTMwMGHgIXFjY2NwEzAw4CJy4DNxMzAwYeAhcWPgI3AwHAcgxCbJVhW4ZVIgly7HIEAhYyLURdNgkCr+xzEHXBg1p9SRsJcsBxBAMbOC8ySDEdBgQ6/VhZm3ZAAgNDc5dXAqn9ViJPRS4DA0JsPAKq/Vh8wm0EAkd3lVECqf1WJlBEKwICKERTKgAAAgAh//4D5wYXABcAGwAhQBANCgAXFwoaGxsKCwFyCgpyACsrETkvMxE5LzMRMzAxQQUeAgcOAichATMDFz4CNzYmJiclAQchNwFCASdusGAICojTef4gAQ/s7tg+ZkEICB1FNv69Adod/VgdAwABBFijdYGxWwIGF/qoAQEwWT81UTADAQKgp6cAAwAr/+oG5AXJAAMALAAwACBAEQMCAi8wAnIvCB0UA3IpCQlyACsyKzI/KxI5LzMwMUEHITcBNwYGBCcuAzc3PgMXHgIXJy4CJyYOAgcHBgYeAhcWNjYBAyMTBSwh/C8iBDPwGK3+/J2Owm4jEBIUaqvslZjScAb0AS1sXmaVZDsMEgcFEjRhTGSQXfyk/fT9A07AwP6MApzgdgMDeMTzfXmG+sRwAwOB35QBVoZPAwNVkK9WfDmDfmlBAgRHhQQz+lAFsAAAAwAZ/+kFpARRAAMAKwAvACRAEwMCAi4vBnIuCiEdGAdyCAQNC3IAKzLMK8wzPysSOS8zMDFBByE3ARY2Njc3DgInLgM3Nz4DFx4CByM0JiYnJg4CBwcGHgIBAyMTBGQd/LAdAoA7YkMO3QyKznB0omEkCwMNV4zBd3isWgLcI08+SmtHKQgEBgIgTf5zvOy8AnGnp/46Ai9WOAF1rF0CA1qZwGckcMaZVgMDarZ1OWE+AQM/aYA+IzR5akYDjvvGBDoAAAT/rAAABIkFsAAEAAkADQARACRAERENDAwCAAYGBwMCcg8FBQIIAD8zETMrMjIRMxE5LzMzMDFBASEBMxMDNzMTAwchNwUDIxMDQf1z/vgC9I9kyjqQ9qAg/SsgAdBe2F4FFvrqBbD6UAU4ePpQAma4uEr95AIcAAT/nQAAA7oEOgAEAAkADQARAB5ADhENDAwBBwMGchAFBQEKAD8zETMrMhI5LzMzMDFBASMBMxMDAzMTAwchNwUDIxMCD/6J+wJYuiWMGKrgcR79dR4Bj0S1RALC/T4EOvvGAtgBYvvGAcWpqUD+ewGFAAYAPgAABpMFsAADAAgADQARABUAGQA0QBoJFBQGBhgVEREQEAMCAhgIFgJyBAoKCwcCcgArMjIRMys/OS8zMxEzETMRMxEzETMwMUEHITcBASEBMxMDNzMTAwchNwUDIxMBAyMTA3Ah/c8gBA39c/73AvWPY8k6kPagIf0rIQHPXthe/hv99f0CZre3ArH66QWw+lAFOHj6UAJmuLhK/eQCHAOU+lAFsAAABgAtAAAFggQ6AAMACAANABEAFQAZAC5AFxURERAQAwICGBkGcgkUFAYGGAoLBwZyACsyPzMRMxEzKxI5LzMzETMRMzAxQQchNyUBIwEzEwMDMxMDByE3BQMjEwEDIxMC9B790h4DEv6I+wJYuiWMGKrgcR79dh4BjkO1Q/51vOy8AcWoqP39PgQ6+8YC2QFh+8YBxampQP57AYUCtfvGBDoABQASAAAGXwWxABYAGgAfACQAKAA0QBkZGhokGx8fIyMTKAYGExMBHCQCcg0nJwEIAD8zETMrMhI5LzMRMxEzETMRMxEzETMwMWEjEz4CMwUeAgcDIxM2JiYnJSIGBwEHITcTASEBIwMBByMBAQMjEwEH9ToWlvCbAdaQzWMQOvU6Ch5dUv4rh58VBDoj/QUjtwILAR39d5KiARgyjP6lAleF9IYBYaDHXQECY8aY/p8BYlFtOQIEdYkET8nJ/RcC6fyXA2r8+2UDaf1R/P8DAQAABQAVAAAFJwQ7ABcAGwAgACUAKQAwQBcaGxslICQkEykGBhMTAR0lBnINKCgBCgA/MxEzKzISOS8zETMRMxEzETMRMzAxYSM3PgIzBR4CBwcjNzYmJiclIgYGBwEHITcTASEBIwMTByMBAQMjEwEA6xoUg9iTATWItlIPGuwbCA5ITP7KVXBADAOGHv1EHbQBgAEP/gWIZckrgf7vAf5f7GCtk8NfAgNlwIqur0RtQwMEOnFRA42rq/3HAjj9WgKn/a9WAqb97P3aAiYABwA3AAAIkwWxAAMABwAeACIAJwAsADAAPEAeISIiJCwCcicrKxswDg4bGwMCAgUHAnIVLy8JCQUIAD8zETMRMysSOS8zMxEzETMRMxEzKzIyETMwMUEHITcTAyMTASMTPgIzBR4CBwMjEzYmJiclIgYHAQchNxMBIQEjAwEHIwEBAyMTBQEi/Gsivf31/QIH9TkUl/KbAdWRzmIROfU6Ch5cU/4qhp8VBDoj/QUjtwIMARz9dpGiARgyjP6lAliF9oYDJ8DAAon6UAWw+lABYKHIXAECYsaZ/p8BYlFtOQIEdYkET8nJ/RcC6fyXA2r8/GYDaf1R/P8DAQAABwAjAAAHKAQ7AAMABwAfACMAKAAtADEAPkAeJSIjIy0tBygsLBsxDg4bGwMCAgYHBnIVMDAJCQYKAD8zETMRMysSOS8zMxEzETMRMxEzETMRMxEzMzAxQQchNxMDIxMBIzc+AjMFHgIHByM3NiYmJyUiBgYHAQchNxMBIQEjAxMHIwEBAyMTBK0g/D0g4LzrvAIi7BsUg9iTATWJtlEPGu0cCA5HTf7KVXBADAOGHv1DHrQBgAEP/gaIZskqgf7uAf9g618CYbW1Adn7xgQ6+8atlMJfAgNlwIqur0RtQwMEOnFRA42rq/3HAjj9WgKn/a1UAqb97P3aAiYAA/+p/kUEMgeKABcAQABJACtAFBgNDEBAACssCUVDQ0JIQYBHFwACAD8y3hrNMjkyETM/MxI5LzMzMzAxQQUeAwcOAyMnNxcyNjY3NiYmJyUTFx4DBw4DIycGBgcGFhYXBy4CNz4CMxc+Azc2LgInJwEXNzcXASMDNQEPAQNYoX1DBgdlnLhZoRiCSYRZCwk0Yj3+4S1/V66MTgcIXZW6Zjg3XggHITshVkpxPgQFaqVdODZnVDgJCB1CXzmYAT91rc8B/sqT6wWwAQIsW45iaI9YKAGMAS5iT0NUKQIB/iQBASdUjWhtpG02AQEzPCs9LBCTG1+DU2d8OAIBHjxYOj5YOR0BAQT+nJsEEP7tARMQAAP/tP5NA8QGHgAYAEEASgAmQBENGQxBQQAtQ0lGREKASBgABgA/Mt4azTIyMjkvEjkvMzMzMDFTFx4DBw4DIyc3Fz4CNzYuAiMlExceAwcOAyMnBgYHBhYWFwcuAjc+AjMzMj4CNzYuAicnExc3NxUBIwMnzf9FlIBMBANilKNGqRaJNG9RCQYgOkMe/uNEiECcjloDBFqOpE8xOGQKBh04IFVCazwDBGWeVjImV083CAgnRVAhofh1rND+y5TrAQQ6AQEdQnFWWHI/GQF9AQEZQz0nMRsKAf69AQETN2lVXYBNIwECMD4qPC0Sih1gfkxidjQPIjwuLjgdCgEBBFGcmwQR/u4BExAAAwBh/+kFGwXHABcAKAA5AB9AEgwpajIgajIyDAAYagADcgwJcgArKysSOS8rKzAxQR4EBwcGAgYGJy4ENzc2EjY2FyYOAgcGBgchNjY1Ni4CARY+Ajc2NjchBhQHBh4CAy91rnZCEQ0LE2uu75l1rndCEg0LFGuv8ItekGZCEAEDAgKmAQEHDDRr/uJfj2VBEQICAf1ZAQEFDTVrBcQCUouzyWdPiv7/y3QDAlKLtMlnUIkBAMt0zwNJf59RBwwHBgsGSpiBUvvCA0h/n1EGDAUFCwZIloJSAAADADT/6AQdBFIAFQAgACsAH0ASCyFqJxtqJycLABZqAAdyCwtyACsrKxI5LysrMDFBHgMHBw4DJy4DNzc+AxcmDgIHITYuAgMWPgI3IQYeAgJ3c6ZlKAsCDlmSxHhypmYpCwIOWJLEbEBjSTIPAe8BECxMuz9lSjIO/g8CECtOBE8DXJrCaRhwyZpYAwNbmMBpF3DLnVnDAi9SaDcyZFM0/RwCL1NqNzJlVDQAAgCoAAAFYQXGAA4AEwAZQA0OEggFEwJyBQNyEghyACsrKxEzETMwMUEBPgIXFwcnDgIHASMDExMjAwJaAV0kYo9mLxkTKDsrEP3lvxiCFLDjAYYC/FWVWgEB0gEBJjwi+5IFsPvE/owFsAAAAgB1AAAESgRSABIAFwAVQAsXBnISFgpyDAUHcgArMisyKzAxQRM+AhcyFhcHJiYjDgIHASMbAiMDAc++HVp/Vx82GyoLFwweMSYM/nmlHEQLl6QBbgHBSoVUAQwMugMFAR4vGPzfBDr9J/6fBDoAAAQAYf92BRsGLgADAAcAHwA3ACRAEAICJycDGgNyBwczMwYOCXIAK80zETN8LysYzTMRM30vMDFBAyMTAwMjEwEHBgIGBicuBDc3NhI2NhceBAU3NjYuAicmDgIHBwYGHgIXFj4CA69KuEklS7hLAvULE2qu8Zh1rndCEg0LE2yv8Jh1rnZBEv7yCwgDFjdlT2iYaD0NDAcCFTlkT2mYZz0GLv5ZAaf6+P5QAbAB3FCJ/v7KdAMDUYu0yWZRiQEAy3QDAlKLs8q4UzyHgmtDAwNZl7NYUjyHg2xDAwRal7QABAA1/4YEHgS1AAMABwAdADMAJEAQBwckJAYZC3ICAi8vAw4HcgArzTMRM30vKxjNMxEzfC8wMUEDIxMTAyMTJTc+AxceAwcHDgMnLgM3BwYeAhcWPgI3NzYuAicmDgIC8UepRwhIqUj+mQIOWZHEeXOmZigLAg5akcR4c6VmKfkDBQUmUkZLb0wtCQIHBiZTRktvTCwEtf5oAZj8cP5hAZ/lF3DLnVkDA1yawmkYcMmbVwMDW5fBgBc2eWtEAgI/bII+FzZ6bUYCAkBugwAEAGP/5wbZB0AAFQAgAEEAZQAzQBlbTglyVDExLDgJckJDQxEICBsbFhYiIQJyACsyMnwvMxgvMxEzMhEzKzIyLzMrMjAxQTMHJy4DIyIGBwcnNzY2Fx4DASc2Njc3FwcOAiUHDgIHAwYeAhcWNjY3EzMDDgMnLgM3Ez4CBTceAwcDDgMnLgM3EzMDBh4CFxY+AjcTNi4CBdwgCBk8cG9uODNECgJ+AgmCaz1wbnL+TlEdMwoSng0HNUr+uhZPaDsMVAUDHT84TW0/C0HGQA1KeaRnZZhgJgpVFIfcAxIQZJVfJgtVD1CCr2xijFgiCkHGPwYKJkY2O1Y8IwhVBgMbQAbAhAEDJzAlOjMTASZqcwIBJjEl/lM9IUYsXwFlLUw7icgBT31H/e0sXVI1AgRGd0YBhv56YKd9RQMCTIKqYAISkdR0ycsFTYCpYP3uZq6CRwMCSn6hWwGG/nkvWkgsAgIuUmMzAhMvXE4yAAAEAEz/5wXDBecAFQAgAEIAZgAzQBlcTwtyVTIyLDkLckNERBEICBsbFhYiIQZyACsyMnwvMxgvMxEzMhEzKzIyLzMrMjAxQTcHJy4DIyIGBwcnNzY2Fx4DASc2Njc3FwcOAiUHDgIHBwYGFhYXFj4CNzczBw4DJy4DNzc+AgU3HgMHBw4DJy4DNzczBwYeAhcWPgI3NzY0JiYFNyIIHTtxbG44NEUIAn8CCIRrPXBtcv5PTh0zCRKfDgc3Sv7nFUZaMgoiBAEUMC4xSTQfBx62Hgs9ZZBdXYVRIAkiEnrKAosQXIhVIgkiDERxm2NYeUgZCB+2HQUHHDctMkYtGgUjBBY2BWcBhQECJzElOjMSASVrcgIBJjEl/lI9IEcsXgFlLko7e8ABSHE+8iFTTTQCAyhEVCrGxVSaeUMDAkl6nFbxhsNswMEESHeaWfFboXpEAwNJeJVOxcYlT0YsAQMvS1go9ChSRi8AAAMAX//mBzAHEAAHACAAOAArQBU0JwlyBQIBAQcHLSEICBUCchwPCXIAKzIrMhEzMzN8LzMYLzMzKzIwMUEhNyEHIQcjBzMDDgMnLgM3EzMDBh4CFxY2NjcBMwMOAicuAzcTMwMGHgIXFjY2NwPy/sAVAzoU/q8XqTTIrw1Kd6VnY5hjKguu9a0FBiBANE1tQAsDQfWuE4bZjWGLViAKrsetBgkjRDVMaD0KBph4eH5q/AFhp35EAgFHe6RgBAD7/yxYSS4CA0V2RgQA/AGI0HMDAkt+oloEAPv/LVlILQIDR3ZEAAMAR//nBioFsQAHACAAOQArQBU0JwtyBQIBAQcHLSEICBUGchwPC3IAKzIrMhEzMzN8LzMYLzMzKzIwMUEhNyEHIQcjBzMDDgMnLgM3EzMDBh4CFxY2NjcBMwMOAicuAzcTMwMGHgIXFj4CNwNJ/tAVAxgR/r0XqTHAcgxBbJZgXIdVIQhz7HIEAhYyLURdNgkCr+xzEHXBg1p9ShoJcsBxBAMbNzAxSTEdBgU5eHh/gP1YWZx1QQMCRHOXVwKp/VYiT0UuAgNBbDwCqv1YfMJtAwJHd5ZRAqn9ViZQQysCAidDVCoAAgBY/o4E3AXIACEAJQAZQAwWEg0DciUAACQBCXIAK80zETMrzDMwMWUHLgQ3Ez4DFx4CByM2JiYnJg4CBwMGHgMXAyMTAjQQZZxxQxcMKhNnotqFmNRnCPQGJ2hcVYJcOQssCAEXNFfgX/Rgs8kFRnaYsF0BEHvfrGIDAnvdl1SFUAICSHqUSf7tNXFoVTUF/dwCJAAAAgBE/osD7wRRAB8AIwAZQAwVEQwHciAAACIBC3IAK80zETMrzDMwMWUHLgM3Nz4DFx4CByc2JiYnJg4CBwcGHgIXAyMTAeUSb55fIwsDDVaNv3V3qlgF3QMgSzxIakgrCAUGAiBO2l/sYK3DB12YvWYjbceaVwMDa7dzATZhPwIDQGt/PCM3dmZEB/3gAiAAAQA7AAAEuAU+ABMACLEPBQAvLzAxQQEXBycDIwEnNxcBJzcXEzMBFwcDPP7x/FP96bUBJvtS/gEN/VT88LL+1f9WAyz+i6xyqf6+AZarcqoBdat0qgFL/mGrcQAB/PAEpf/gBfwABwAVtwYGBAQBAgIBAC8zLxEzETN8LzAxQyEHJzchNxdG/fMXpioCDhKmBSN+AepsAQAB/RAFFv/yBhQAFQAStgEUFA8GgAsALxrMMjMRMzAxQRcWPgIXFhYHByc3NiYnJg4CByP9GhlBenV4QGRzBQN9AgMmMT13eHs/JQWaAQEmMSUBAW9mJwEULjYCAiMxJwEAAAH+MQUY/wIGYgAFAAqyAIACAC8azTAxQSc3MwcX/raFFrQfJgUYz3ukbQAAAf49BRr/VwZiAAUACrIBgAQALxrNMDFDByc3NzPDtUtOGLQF0bdMcYsACPpD/sIBoQWxAA0AGwApADcARQBTAGEAbwAAQQc2NhcWFhcnNiYjJgYBBzY2FxYWFyc2JiMmBhMHNjYXFhYXJzYmIyIGAQc2NhcWFhcnNiYjIgYBBzY2FxYWFyc2JiMmBgEHNjYXFhYXJzYmIyYGAQc2NhcWFhcnNiYjIgYTBzY2FxYWFyc2JiMiBv4PcAhxWlhrAWwDHjAwNAICcQhyWVhsAWwCHTEvNFFuCHBaWGoBawIdMDA1/ttuCHBaV2sBawIdMDA1/ZVxCXFaV2sBawIdMDA1/qdxCHJaWGsBbAMdMTA0/vFuCHBaV2sBawIdMS81PG8IcFpXbAFsAh0wMDQE9AFYZgEBZ1cBKjwBO/7BAVhmAQFnVwEqPAE8/eABV2YBAWZXASo8O/3QAVdmAQFmVwEqPDv+uwFYZgEBZ1cBKjwBOwTwAVhmAQFnVwEqPAE7/d8BV2YBAWZXASo8O/3QAVdmAQFmVwEqPDsACPpz/mMBeAXGAAQACQAOABMAGAAdACIAJwAARTcXAyMBBycTMwE3NwUHJQcHJTcBJzclFwEXBwUnAQcnAzcBNxcTB/1jhQ6rZgGlhA6qZgEgDQsBOBD6Ww4J/scRBWhbAwFMPvraWgL+tkACBmcRX0IC32cTXkM9AxP+sAYEAxEBUfwmjAqAWpSMCoBaAQhiEphO/DFiE5hPBAJfAgFRO/tXYAL+rzz//wAl/oAFfAcmBCYA3AAAACcAoQFHAT4BBwAQBE3/yAAVQA4CIwQAAJhWAQ8BAQFeVgArNCs0AP//ABf+gARtBdsEJgDwAAAAJwChAIv/8wEHABADWP/IABVADgIjBAEAmFYBDwEBAX1WACs0KzQAAAIAIf/+A+cGYAAXABsAGkAMGgsbAnIAFxcNDQoSAD8zETMvMyvOMzAxQQUeAgcOAichATMDFz4CNzYmJiclAQchNwFCASdusGAICojTef4gARvs+tg+ZkEICB1FNv69Af8e/VceAwABBFijdYKxWgIGYPpfAQEwWj41UTADAQNvpqYAAAIAJgAABPoFsAADABsAI0ARAQIFAAMGBgUFEhATAnISCHIAKysyETkvMxEzMxEzMzAxQQEHAQMlNwUyNjY3NiYmJyUDIxMFHgIHDgIDWQFEa/69Q/6CIwFjU4tbCwssZEz+ztr1/QILh9NyDA2l/gPf/jZWAcn+lgHHATlzV0pxQQMB+xgFsAEDbcmMnc1iAAT/yP5gBBAEUgADAAgAHgA0ACVAFAADMAECMCUaDwtyBwZyGgdyBg5yACsrKysRMzIyMhEzMzAxQQEHAQMDIwEzAQcOAycuAzc3PgMXHgMHNzYuAicmDgIHBwYeAhcWPgICggEcbP7lhd7sAQTZAmECDEV1qnNmiVMgBAoQTXqobW+MSRP3AgUDIE1EPmRMMwsfAhczTzZKakcoAav+U1YBrgIG+wQF2v3zFWLHpWIDAl2Ws1hQX76dXQQDZKG9cBYzeGtGAgMtUGY3xDJcSywCAkJvgwACACMAAATqBxMAAwAJABVACgIGBgMJAnIICHIAKyvOMxEzMDFBAyMTEwchAyMTBOpf7F+mI/1w2vT8BxP93gIi/p3I+xgFsAACABEAAAPSBXcAAwAJABVACgIGBgMJBnIICnIAKyvOMxEzMDFBAyMTEwchAyMTA9JZ7FmdIv42m+u8BXf+AwH9/sPA/IYEOgACACv+wwSsBbAABQAdABlADAYHBxMSAgUCcgQIcgArKzIvMzkvMzAxQQchAyMTEzcXHgMHDgMHNz4DNzYuAicErCP9cdr1/Rgj6IHFgTYODVqVz4ITU3ZPLAkJETxvVQWwyPsYBbD8zcYBAlWX0X9/0ZpVArcCQW2JSkyJaT8CAAIAEf7gA4UEOgAUABoAG0ANAAEBCxcaBnIZCnIMCwAvMysrMhE5LzMwMVM3Fx4CBw4DByc+Ajc2JiYnAQchAyMTriPdjNlyDghMd5ZRSEZySgoLL2xSAdwi/jab67wBysYBA3LSk1iYeFYXrRlRc01ReUUDAnHA/IYEOv///6T+mgfoBbAEJgDaAAABBwJsBoUAAAALtgUbDAAAmlYAKzQA////sP6aBoEEOgQmAO4AAAEHAmwFSAAAAAu2BRsMAACaVgArNAD//wAr/pgFdgWwBCYCRwAAAAcCbAQM//7//wAi/poEfgQ6BCYA8QAAAQcCbANUAAAAC7YDEQIBAJpWACs0AAAEACQAAAWDBbAAAwAHAA0AEQAvQBcPDg4LDAQEDAwLBwcLCwAQAwhyCAACcgArMisyEjkvMy8RMxEzLxESOREzMDFBMwMjATMDIwEhASE3IQc3ASEBIPb99QIMm3ybApgBN/2c/iEGAYUexgEx/tUFsPpQBEv9OAQt/MDZqaL8vgAABAAhAAAEygQ6AAMABwANABEALUAWDw4OCwQEDAwLBwcLCwAQAwpyCQAGcgArMisyEjkvMy8RMxEzLxEzETMwMVMzAyMBMwMjASEBITchBzcTIdzsvOsB1ZJqkgIMATL+Dv5JBwFhJb/3/uAEOvvGA1P9pQNC/XXap4D9ngAABACkAAAG4QWwAAMABwANABEAI0AREA8PCwoKAw4GCHINBwIDAnIAKzIyMisyEjkvMzMRMzAxQQchNyEDIxMhASE3MwEDATcBAuMh/eIiAsH89f0ETv0x/qEF6AIGvP6ktgG+BbDAwPpQBbD8wtoCZPpQAqS3/KUABABsAAAFtAQ6AAMABwANABEAI0AREA8PCwoKAw4GCnINBwIDBnIAKzIyMisyEjkvMzMRMzAxQQchNyEDIxMhASE3MwEDAzcBApMi/fsiAnG87LwDof22/u4HuQFnmu/GAU8EOsDA+8YEOv112gGx+8YB4YH9ngD//wAm/poFhQWwBCYALAAAAQcCbARgAAAAC7YDDwoAAJpWACs0AP//ABf+mgRhBDoEJgD0AAABBwJsA2AAAAALtgMPCgAAmlYAKzQAAAQAJgAAB+oFsAADAAcACwAPAB9ADwcGBgoCAwMMCwJyDQoIcgArMisyMhEzETkvMzAxQQclJwMHITcTAyMTIQMjEwfqIf2blm4j/REjqP32/QRi/fT8BbDAAb79ocfHAmD6UAWw+lAFsAAEABEAAAWWBDoAAwAHAAsADwAfQA8HBgYKAgMDDAsGcg0KCnIAKzIrMjIRMxE5LzMwMUEHITcDByE3EwMjEyEDIxMFliL+UCOgIv3eIZS867wDcLzsvAQ6wMD+PL6+AcT7xgQ6+8YEOgAAAgAq/sIHiQWwAAcAHwAZQAwICQkUBAcCcgYIcgIALysrMi85LzMwMUEDIxMhAyMTATcXHgMHDgMHNz4DNzYuAicFgf3z2f2P2vX9A1oj6YHEgTYODVmWzoMTU3ZPLAkKEjxvVQWw+lAE6PsYBbD8zMYBAlWX0X9/0ZpVArcCQW2JSkyIaj8CAAQAEf7jBkcEOgAUABgAHAAgACNAER4XGBgAAQELHRwGchsKcgwLAC8zKysyETkvMzIRMy8wMUE3BR4CBw4DByc+Ajc2JiYnAwchNzMDIxMhAyMTAzIjAQqO4XkNB0t3lFFLRnJKCgs3dlPRIv34Ijm867wDcrzsvAHNxgEDbtGXWZd5VheuGVB0TVV5QQICbsDA+8YEOvvGBDoAAAEAX//oBeYFxwBDAB1ADjkMDCMiA3IAAQEuFwlyACsyMhEzKzIyETMwMWUHJiQmAjc3PgMXHgMHBwYCBgQnLgM3Nz4DNwcOAwcHBh4CFxY+Ajc3NjYmJicmDgIHBwYeAgVkEaD+5dBkGCAOR3iob3GRTRcMIBeM2P7tnY/ajToSHRJaksqBGExqSCgKHgsRQ35icLuQXhEiBQcQOjs+VDMcBiESPY7LsMYFZrsBDq7TXsOkYwQDba3HW86Y/vrFawMDccH1hsF2269oA88CUn2LPsRRqI1YAwNPj7po4ydzck8DA0dtdy7YgsaIRwABAEv/6ASWBFMAQwAdQA45DAwjIgdyAAEBLhcLcgArMjIvMysyMhEzMDFlBy4DNzc+AxceAwcHDgMnLgM3Nz4DNwcOAwcHBh4CFxY+Ajc3NjYmJiciDgIHBwYeAgRTCn7kqlUQEQo2XIRXV3A9EgcREG2p1Xl0rnAtCwoMR3WhZRcxRSwaBwoHCSxYR02BYz8KEgIFCiIkJzQgEgMSDjh1oI6jBUuP0oyBSph9SwMDWIqcR392yJRPAwNgoMpsTl+rhE0DxgU5U10pTzp+b0gDAzdjgUeCGE5TOwQwSk4dh2WVYzEA////wP6aBUYFsAQmADwAAAEHAmwDsgAAAAu2AQ8GAACaVgArNAD///+6/poEEgQ6BCYAXAAAAQcCbAK9AAAAC7YBDwYAAJpWACs0AAADAJr+oQZtBbAAAwAJABEAHUAOCQ0NCAoIcgUQDAIDAnIAKzIyMi8rMjIRMzAxQQchNwEDIxMjNwUTMwMhEzMDBF4i/F4iBYVy4j1/JPxG/PbbAnLa9f0FsMDA+xn92AFfyckFsPsXBOn6UAADAFf+vwTZBDsAAwALABEAH0APAgMDDQoFBnIIBwcQBApyACsyMhEzKzIvOS8zMDFBByE3ExMzAyETMwM3AyMTIzcDKSL9UCIxvOybAZua7bywa9o4fiIEO8DA+8UEOvyGA3r7xr/+AAFBv///AMT+mgVdBbAEJgDhAAABBwJsBDQAAAALtgIdGQAAmlYAKzQA//8Abf6aBDcEOwQmAPkAAAEHAmwDNgAAAAu2AhsCAACaVgArNAAAAwC0AAAFTgWwAAMAGQAdACNAEQMDCgoVAgIVFQQcCHIbBAJyACsyKxE5LzMvETMRMy8wMUEDIxMBMwMGFhYXFj4CNwcOAycuAjcBMwMjA0N/mn/+aPVKCiRlWTFiYWAuEi5eYGEvkthqEgOT9f31BBD9JALcAaD+PFd0PAIBBw8WDckPFg0GAQJozpoBw/pQAAADAIIAAAQuBDsAAwAHABsAI0AQAAAYGA0BAQ0NBQpyEgQGcgArMisyLzN9LxEzETMYLzAxQQMjEwEDIxMTBw4CJy4CNxMzAwYWFhcWNjYCoGqaagIovOy8LREybnE3f7lcDjXrNQgaTUY6cW4DLP2gAmABDvvGBDr+IcIWHg0BAWC2gwFI/rdCXzUCAREgAAACABwAAAS1BbAAFQAZABlADAEXBhERFxgCchcIcgArKxE5LzMRMzAxYSMTNiYmJyYOAgc3PgMXHgIHASMTMwRZ9UoKI2VZMWJhYS8ULV5fYDCS2GoR/G72/fUBxVZ1OwIBBw8VDskPFQ0GAQJnzpr+PQWwAAIAVf/pBbsFxgAJADYAJUASBR0BAR0dBhwcCiQVA3IvCglyACsyKzIROS8zMxEzLxEzMDFTFwYWFhcHLgIBLgM3Nz4DFx4DBwchNyE3Ni4CJyYOAgcDBh4CFxY2NxcOAlusBh9RRw94mEQDAYrVizoSJxNrqtyFjbplGxEV/F0iAqcGDAgvYlBVhWE8DSkLFEZ9Xl60Vx01i5IEOgFEZTsFrwVttfwiAV6p5Ib/euGuYgMDdsLte4m+IkKEbkQCA0V3kkv/AFOUc0ICAigiwyYnDAAAAv/y/+oEcwRRAAgANQAlQBIEHAEBHBwFGxsJIxQHci4JC3IAKzIrMhI5LzMzETMvETMwMUMXBhYXBy4CAS4DNzc+AxceAwcHITcFNzYuAicmDgIHBwYeAhcWNjcXDgIIoAhLZQ5wj0ECfG+oby8JBQxXjsJ2cZpaHgwQ/NMeAj4FBwwpSDRLbEkpCAUGEDJaRFaMOnMvh54DXQFicAaiBWSn/PoCU5C6ailtzJ9bAwNZlrtlZ60BFi5YRioDAkJwhD4oO3NgOwICSzx8RFosAAMAJP65BVQFsAADAAkAIQAhQBAKBgYLCAcHFxYJAwJyAghyACsrMi8zOS8zMzMRMzAxQQMjEyEBITczAQE3Fx4DBw4DBzc+Azc2LgInAhb99fwENP0V/tgGzgIG/W0k8YDGgDcODVuY0IISUXZNLQkJEDpsVAWw+lAFsPzD3wJe/MLNAQJVmdCAf9KbVgPAAUFrh0lKhmlAAgADACH+5AR+BDoAAwAJAB4AIUAQFhUJBnIGCgoHCwsBAwZyAQAvKxI5LzMzETMrLzMwMUEDIxMhASM3MwEBNwUeAgcOAwcnPgI3NiYmJwHIvOu7A6L9of4HowF9/XkjAQyL5H0NCEx5lFBHRHFMCQw7eFAEOvvGBDr9ddoBsf12xQEDZceYWJR0UxatGExvS1ZvOQL////F/oAFfgWwBCYA3QAAAQcAEARM/8gAC7YDJAYAAJhWACs0AP///7z+gARtBDoEJgDyAAABBwAQA1j/yAALtgMkBgEAmFYAKzQAAAEAK/5IBYIFsAAZABlADBkIchcCAhEKBQACcgArMi8zOS8zKzAxQTMDIRMzAQ4CJyImJzcWFjMyNjY3EyEDIwEo9W8CcG/1/v4PZKl4I0UiIxcxGDVDJQhx/ZFs9QWw/YICfvoYcK9hAQsIwgcIN1UtAqP9lQABABH+SAQ9BDoAGQAdQA8ZCnIXAgIAEQoPcgUABnIAKzIrMhI5LzMrMDFTMwMhEzMDDgInIiYnNxYWMxY2NjcTIQMjzetPAZlP7MMOYqZ1I0MiIhcwGTREJQdU/mdM6wQ6/jwBxPuIb6tgAQkJvAcJAThWLgH2/kgA//8AJv6ABYUFsAQmACwAAAEHABAEVv/IAAu2AxYKAQCYVgArNAD//wAX/oAEawQ6BCYA9AAAAQcAEANW/8gAC7YDFgoBAJhWACs0AP//ACb+gAbOBbAEJgAxAAABBwAQBZj/yAALtgMbDwAAmFYAKzQA//8AI/6ABcMEOgQmAPMAAAEHABAErv/IAAu2AxkLAQCYVgArNAAAAQBL/+kFLQXEACwAG0ANGgsRFBQLJQADcgsJcgArKzIROS8zETMwMUEeAwcHDgMnLgM3NyEHIQcGHgIXFj4CNzc2LgInJgYHJz4CAu2X4pA3ExETc7XwkZLOeSkSFwQDI/z5CA0VRHZVYphuQw4SDRNLimljvlweOpGXBcMBarz4kHuE+MRwAwNsuvGHj8MjTohmOwMCU4yrVXxcqYVPAgIoI8UlJwwAAgAv/+gEngWwAAcAJQAfQA8FCAgEJSUAHBIJcgcAAnIAKzIrMhE5ETMzETMwMUEhBwEjNwEhEzc2FhYHDgMnLgM3MwYWFhcWNjY3NiYmJycBIQN9Hv3XrhcBmv2kwJSKz2sLCWOdwGZgn3I8BfMEK1tCSYJYCgssbVaTBbCs/eKBAYH+cwcBbMqObqVuNgICPG+cYT9kPAIDOWtLVnpCAwEAAv/x/nMEVgQ6AAcAJQAfQA4IBQUEJSUAHBgSBwAGcgArMi/MMxI5LzMzETMwMVMhBwEjNwElEzcyFhYHDgMnLgM3MwYWFhcWNjY3NiYmJyfdA3kb/dquFwGV/ajBj4nQbAsJYZy/ZWCecjoE6gQtXERLhFoKCy1vWJMEOqT92IIBiQH+ZwZpx45tpW42AgI8bpxgQGg9AgM6bk1XekIDAQD//wAn/kcE+AWwBCYAsUwAACYCQakoAAcCbwEnAAD////6/kMD1AQ6BCYA7EwAACcCQf+C/3YABwJvAPr//P///8D+RwVGBbAEJgA8AAAABwJvA6sAAP///7r+RwQSBDoEJgBcAAAABwJvArYAAAABACkAAATsBbAAGAAStwMAAAsQDQJyACsvMzkvMzAxQQUHJQ4CBwYWFhcFEzMDJS4CNz4DAnUBciP+qlKKXAoLK2NKASTa9fz+AobScQwKZKDGA5oBxwEBP3ZUSHJEAwEE6fpQAQRtx45zrnY8AAIAQv//Bm0FsAAYAC0AH0AOGwsLECUlAwAAGhANAnIAKy8zOS8zMy8RMxEzMDFBBQclDgIHBhYWFwUTMwMlLgI3PgMBIzcXPgI3NjY0JicXFhYGBw4CAo4BciT+qlKKXAsKK2NKASXa9f3+AobScAsKZZ/HAj+WJHtObUANCAoKC+YMDAEIFIXZA5oBxwEBP3ZUSHJEAwEE6fpQAQRsyI5zrnY8/GbGAQFPfEgsXF5dLAI7e3s8i9d4AAMARP/nBkoGGAAWACsARwAdQBAzRAtyOy0Bch0SC3InBgdyACsyKzIrLysyMDFTNz4DFx4EBwcOAycuAzcHBh4CFxY2Njc3Ni4CJyYOAgUTMwMGFhYXFj4CNzY2JxcWFgcOAycuAk4CDUJ1rndRc0opDgQID0h0oWhri0wY+QIGAyBKQ059VRAcBBQyUDhNakUnAY/L7MwFDS8ySGpHKgoQBBHeDgcOEFSLv3lzlUMB9BVkz65oAwNFcYmSQ0Nau5xdAwNembZwFjNwY0ACA0x8SLczYlMzAgJJdojgBLD7TyhUPAMEQ3CBOmTJYwFkx2NvyptaAgFhqwACAKz/6QW3BbAAIABGACFAECgnJwIBAQ4yQwlyOg0OAnIAKzIvKzIROS8zMxEzMDFBIzcXMjY2NzYuAiclNwUeAwcOBAcOAgcGBhMnNzYmJic3HgMHBwYWFhcWPgI3NjYnFxYWBw4DJy4CAcLlI5dSjl8LBxw7UzH+nyMBRWCqf0IIBjhXa3I1BwYGBww4iwEIByBQRBpVlW04CQcCDSciRWFAJgkQBBLoDQcOD1OJvXhtgjsCZ8kBLGhaNkswFgIByQECL2GYalRoQCwtIgUREQUICP7RAkNBZTwFeAIoU4ReRyA5KAMCRW19NmPKYwFkx2NtyZ5aAQJSlgACAGH/4wTFBDoAHQBCACVAEj49PRsCAQENKioiMwtyDA0GcgArMisyMi8ROS8zMzMRMzAxQSU3Fz4CNzYmJiclNxceAgcOAwcOAgcGBgU3BhYXFj4CNzYmJxcWFgcOAyciLgI3NzYmJic3HgIHAW3+9B+oMWFFCAgnSiz+8xz2YrVwBgQ9WmQsCQQECAkzATEEAxMtOFI3IgcMBhTeDxIKC0p3omQ8bFQuAwkDID4oL1OXWQkBoAG4AQEaPjkyPh4CAb8BAj6Hck5PJyUlBxobBgcIvRMqNgcCM1VkL06gTQFOnU5fpX1GAhk4XUNOLTQYA4MBLG1iAAMAk/63A98FsAAfADQAPwAfQA46OT8sDA0CciEgIAEBAgAvMxEzETMrMi8zLzMwMUEhNxcyNjY3NiYmJyU3BR4CBw4EBw4CBw4CBzceAgcHBgYWFwcjJiY2Nzc2JiYBBwYGByc+Ajc3Aar+6SG8UY1dCwovY0f+1x8BD4HOcgoHMlBibDUGBwcGCR8fMzF3tF0PEQYCERkD6BoRBQURCiVcAhMcEoBcfCE8LgohAl3AAS9pV0llNAIBwAEDWraLUGZBMC8hBQ8OBQYJBgGAAlCif3klTUgeGSFTWSd2SWg9/o+sdMlHTDBfZjm2AAADAIv+qAO8BDoAHgAzAD4AHkAOOCAfHwIBAT4rCgwNBnIAKzI/MzkvMzMRMy8wMUEhNxc+Ajc2JiYnJTcFHgMHDgMHBgYHDgIjNx4CBwcGBhYXBwcmJjY3NzYmJgUHBgYHJz4CNzcBu/7QHtg0Z0oKBytOLv7WHQESTI9zQAUEQWFuMwgGBwgaG0U9XaBaCgsEAQ0QAuwPCwMECwYlTAIGHBN9W38hPC0LIAGdrwEBHEI8NEEfAQG+AQIlTXtWUVcvKCIGFwYGBwV5ATZ8alYbMi8WEgEYODodVTlFIMCsdMlITTBeZjq2AAAD/9v/5gdDBbAAEQAVADIAHUAOJiYeLwlyFxQAFQJyCwgALzMrMjIyKzIyLzAxQTMDDgQjIzc3PgQ3AQchNwETMwMGHgIXFj4CNzY2JxcWFgcOAycuAgIC9J8UMk12rnxJGiNTcEksGwwDRSP9liMBdLn1uQMFFSslRmdEKQkQBBLpDQYNEFWMv3p1mkMFsP0tZM+9llfHAgVWhZuaPwKTycn7uwRF+7odPjcjAgRCbn84Y8pjAWPIY2/LnVoDA2CrAAP/2f/mBh8EOgARABUAMwAfQBAnJx4vC3IXFAAVBnILCApyACsyKzIyMisyMi8wMUEzAw4EJyM3Nz4ENwEHITcBEzMDBh4CFxY+Ajc2NiczFhYHDgMnLgMBcOt4Dyg+XodeUhkjO1A0IRQIAoMi/iIjASN563kDBhkvJj1XOCEIDgIR3Q4KDQ1Le6xuV4RWJAQ6/epMnY9vPgHFAgQ8XW1tLQHPwsL9LgLS/S0gQDcjAQI9ZHAvXr9dXr1eYruTVQMCN2SLAAMAJ//nB0IFsAADAAcAIwAgQBEWFg4fCXIIAnIAAwMGCAQCcgArPzkvMysrMjIvMDFBIQchAzMDIwEzAwYWFhcWPgI3NjYnFxYWBw4DJy4CNwFsAuIj/R4l9f31BFj0twQMLi9GZ0UpCRADEukMBw0QVorAenOXRAkDMscDRfpQBbD7uSdTOgMDQm9+OGPKYwFjyGNwyZ5ZAgJirHIAAwAH/+gGHgQ6AAMABwAlACJAEhkZECELcgkGcgMCAgUHBnIFCgA/KxI5LzMrKzIyLzAxQQchNxMDIxMBEzMDBh4CFxY+Ajc2NiczFhYHDgMnLgMDMCL98iGPvO28AhV57HkDBhgwJj1XOSAIDwER3Q4KDQ1Le6xvVoJVJAJ8v78BvvvGBDr9LgLS/S0gQDciAgI9ZHAvXr9dXr1eY7qSVAEBOGWMAAEAS//oBIsFyAArABVAChILA3IlJR0ACXIAKzIyLysyMDFFLgM3Ez4DFzIWFwcmJicmDgIHAwYeAhcWNjY3NiYnFxYWBw4CAkyBx4M2ECkUdLLniVutTkpAjElZkmxHDSoKEj5wVFGCVA4PAgzqCQgLE5/yFQNjrN17AQaC4qpfAikvtiQiAQFEd5ZS/vdHkntMAgJCdk9WsVYBV65WktFtAAEAPf/oA6cEUQArABVACiEaB3IHBwAPC3IAKzIyLysyMDFlFjY2NzY2JzMWFgcOAicuAzc3PgMXFhYXByYmIyYOAgcHBh4CAgIxTjEICQEF3gUFBg16u25yqWwtCgUNWpPBdEmNP0AxdDpHbk4vCQUHDS1YrAEhQjE2bzY2bTZzmkwCA1iWwGorbsaXVgEBHSe4IB0BPmh9Pio5eGhBAAACAJH/5gUtBbAAAwAgABdACxQUDB0JcgUCAwJyACsyMisyMi8wMUEHITcTEzMDBh4CFxY+Ajc2NicXFhYHDgMnLgIFEyP7oSP9ufS5AgQVKyRHZkUpChADEecOBg4PVYu/enSXRQWwycn7uwRF+7odPzYkAgNCb344Y8pjAWTHY2/LnVoDAmKsAAACAHP/6ASSBDoAAwAgABdACxMTCxwLcgUCAwZyACsyMisyMi8wMUEHITcTEzMDBhYWFxY+Ajc2JicXFhYHDgMnLgMEBiH8jiLCeet5BA81MjZSOyMIDQkU3BAUCgxNfqdmV4NUJQQ6v7/9LgLS/S0qVDoCAixNXi5NmUoBSphMYad8RQEBN2WMAAACAFD/6QUZBccAIAA/ACNAEQAiPz8CAhc1MSwDchENFwlyACsyzCvMMxI5LzMSOTkwMUEXByciDgIHBh4CFxY2Njc3DgMnLgM3PgMFJy4DNz4DFx4CByc2JiYnJgYGBwYeAhcXAp7lGK9AemdECAgvVWgzSpFqD/MJbqrLZmC9mVUHCG6rxgE1yE2li1MGB3Cvz2d724YD8gJDcUFJmXALCSJGXTPKAxIBjAEYN2BIPVU0GAEBMGZOAXGiaDACATFknnBylVclWAECKVWFXnWkZCwCA1y1hwFHXC0CAitjUztRMBcBAQD////F/kcFiwWwBCYA3QAAAAcCbwRQAAD///+8/kcElwQ6BCYA8gAAAAcCbwNcAAAAAwAI/+cE2QXIAAMAGAAyAChAFBAnJw8ABAolJQodMAlyFAoDcgIIAD8rMisyETkvEjk5MzMRMzAxQQMjExcHPgMXFgQXAQc3ASYmJyYOAgM3FhYzMjY2NzYmJicnNzcyFhYHDgInJiYBmqbsp+/lCkyEvXucAQBy/hGeFwFQMH9DSmhCJj9VMGo2TodbCgsxcVWXHZSF0XELDJrtiE+WA8D8QAPAAgJ1wYxKAwKHZP4AAYMBTzAtAgE2Xnf8JLoYGzpvUVdzOgIBowZhwIyRx2cBAR0AAAIA6ARyA0kF2AAFAA8AErYFBQ0HAgIHAC8zLxDNMi8wMUE3EzcHASU3MwcGFhcHJiYB5AGgxAH+9P60DKUPChAnTEdEBIMWAT4BF/7D+VpVO2QuQyuNAP//AEACDgJlAs4EBgARAAD//wBAAg4CZQLOBAYAEQAAAAEAmwJwBKUDMQADAAixAwIALzMwMUEHITcEpSn8HykDMcHBAAEAfAJwBd4DMQADAAixAwIALzMwMUEHITcF3jb61DcDMcHBAAL/WP5mAxUAAAADAAcADrQCA4AGBwAvMxrOMjAxQQchNwEHITcC6Bv8ixsDohv8ixv+/piYAQKYmAABALIEJgIcBhwACgAIsQUAAC/NMDFTNz4CNxcGBgcHshQLP1w5dzBKDxgEJodJhXMuTkKLUokAAAEAjQQEAfoGAAAKAAixBQAAL80wMUEHDgIHJzY2NzcB+hYLPlw4ejFKDxkGAIxKhXMuT0KLUY8AAf+n/toBEwDPAAoACLEFAAAvzTAxZQcOAgcnNjY3NwETFQw+Wzl5MUUPGM+FSoVzLk5CjFGIAAABAM0EBgHGBgAACgAIsQYAAC/NMDFTMwcGFhcHLgI368sZDBIjdi09GQcGAJBNkEZHL3iEQv//ALoEJgNhBhwEJgGFCAAABwGFAUUAAP//AJoEBANEBgAEJgGGDQAABwGGAUoAAAAC/6T+yAJSAP4ACgAVAAyzEAULAAAvMs0yMDFlBw4CByc2Njc3IQcOAgcnNjY3NwEbHgw9XDt5MkcPIAIGHgw/Xzp5MkoQIP60TIt6MU1HlVa3tE2LeTFNR5VWtwAAAgBpAAAESgWwAAMABwAVQAoGBwcCAwJyAhJyACsrETkvMzAxQQMjEwEHITcDF+Ts5AIfIPw/HwWw+lAFsP6KxMQAA//8/mAEZgWwAAMABwALAB1ADgsKBgcHAQMKEnIDAnIBAC8rKxESOS8zETMwMUEBIwEBByE3AQchNwMz/tvsASUCHx78Px4DNh78Px4FsPiwB1D+isDA/IbAwAABAJ8CAwJPA9gADQAIsQQLAC/NMDFTNzY2MxYWBwcGBicmJp8CBXtjXm0BAQZ8YltuAtIoYX0Bd1wpYHgBAXL//wA1//IDAwD/BCYAEgcAAAcAEgHBAAD//wA1//IErwD/BCYAEgcAACcAEgHBAAAABwASA20AAAABAF4B7gFrAvEACwAIsQMJAC/NMDFTJjY3NhYVFAYHBiZfAU45N09OODdPAms6SgEBRTk7SAEBRAAABwCi/+gHAwXHABEAIwA1AEcAWQBrAG8AKUATX1ZWMmhNTUQpKTsyDRcODiAFBQA/MzMvMz8zMy8zMy8zETMvMzAxUzc+AhceAgcHDgInLgI3BwYWFhcWNjY3NzYmJicmBgYBNz4CFx4CBwcOAicuAjcHBhYWFxY2Njc3NiYmJyYGBgU3PgIXHgIHBw4CJy4CNwcGFhYXFjY2Nzc2JiYnJgYGAwEnAacGCVaLWVV9QAYGCVmPWFV5PaoJAxIyLC5DKQYJBBIyLS1EKQGTBghaj1lUcjYFBglPg1dWfUGzCgITMisvRCcGCQQTMiwuRCgBHgYIUIRYVnxABQcIWI9YVXI3mwkDEzMrL0MoBgoDEzIsLkMqePyRdwNwBEtMVYtQAgJRh1NNV4lOAgJSh55PJkYuAQEsSCpOJkgvAQEtSfxVTVeKTwICVYdPTlKLUgICUYehUCVHLgICLEoqTyZILgEBLEl4TlOJUwICUYdTTlaKTwICVYedUCVHLgICLUkqTyZILgEBLEkDSfuYTgRnAAIAWgCLAmEDqQAEAAkAEkAJAQUDCQIIBgYAAC8vFzkwMUEBBzUBAxMHAzUCYf7HxwFQlK6U3QOo/m8DEgGD/nb+bQEBhBIAAAL//ACLAgMDqAAEAAkADrQCCAgFAAAvLzkvMzAxZwE3FwEDMxMVJwQBOccB/q8Zk93CjAGRAxL+fQMd/n0SAgAB/+AAcAPGBSUAAwAOswADAgEAfC8zGC8zMDFBAScBA8b8kHYDcATY+5hOBGf//wCJAowC9AW/BgcB4gBzApv//wBmApsC7AWwBgcCOwBzApv//wB+Ao4DBQWwBgcCPABzApv//wCJAo4C3wW/BgcCPQBzApv//wCYApsDLQWwBgcCPgBzApv//wB4Ao4C9QW9BgcCPwBzApv//wCnAo8C7wW9BgcCQABzApsAAgCGAo8DKAVRAAMABwAVtwYGAgIDBwcDAC8zLxEzETN9LzAxQQchNwEDIxMDKBr9eBsBwnudewQ7l5cBFv0+AsIAAQCHA6YC5AQ+AAMACLEDAgAvMzAxQQchNwLkG/2+GgQ+mJgAAgBvAx0C+wTAAAMABwAMswIDBwYALzPOMjAxQQchNwEHITcCzBr9vRsCcRv9vRsDtZiYAQuXlwABAIsBhQI7BjUAFQAMsxARBgUALzMvMzAxUzc+AjcXDgIHBwYGFhYXBy4DkwEQVZdxOkRfOg0CCAgKJyhLRVEnBQPMEXXswjV+QJKmXBM6fX1zMHQsiaOmAAABAD4BggHvBjIAFQAMsxARBgUALzMvMzAxQQcOAgcnPgI3NzY2JiYnNx4DAecCD1WXcTtGXjoNAggICicoTERRJwUD6xF17cI0e0GSpV8TOXx8cy94LImjpwACAGsCjANMBb0ABAAZABO3FgsEBAsCEQIALzM/My8RMzAxQQMjEzMDBz4DFx4CBwMjEzYmJicmBgYBkmq9jI8uKQgpSHBPWmYlB1K7SgUGKzVBUSwE8/2ZAyH+iQFBinZHAgJXi1D+BQHMKVk+AgFFa////9f+hAJCAbcGBwHi/8H+k///ADH+lAHNAagGBwHh/8H+lP///6X+lAI8AbcGBwHg/8H+lP///7b+hwJGAbcGBwI6/8H+lP///7T+lAI6AakGBwI7/8H+lP///8z+hwJTAakGBwI8/8H+lP///9f+hwItAbgGBwI9/8H+lP///+b+lAJ7AakGBwI+/8H+lP///8b+hwJDAbYGBwI//8H+lP////X+iAI9AbYGBwJA/8H+lP///9r+qAJ8AWoGBwGd/1T8Gf///9v/vwI4AFcGBwGe/1T8Gf///8P/NgJPANkGBwGf/1T8GQAB/+X96wGQAlkAFAAIsQUQAC8vMDFnNz4CNxcOAgcHBgYWFwcuAxMCDlWWbjpDXTkMAgkEJzVMQ1IpCQ4SceG2MX85iJxXE0mekzp0KX+YnQAAAf+e/egBSgJWABQACLEQBQAvLzAxZQcOAgcnPgI3NzY2Jic3HgMBQwIOVZZuPEReOQwDCAMnNUtCUyoJORFz47czfDyKnVsSRpuQOHkofpacAAT/9wAABKIFxwADAB4AIgAmACJAECIhJSYmARsXEgVyCQICAQwAPzMRMyvMMxI5LzPOMjAxYSE3IQEDBgYHJz4CNxM+AhceAgcnNiYmJyYGBgUHITcBByE3A/D8ByMD+f4XTAtbUrYnLhgFVRCF1IZ6q1cE7QMdST5EYDkBFxj9QxoCjhr9RBnHA0n9lmCWMUkPR1cmAnSDx24DA2WzeQE4XDgCAUVv4I2N/veOjgAAAwAPAAAGWwWwAAMABwARACJAEAMCBgsOEAcHDREOBHIKDQwAPzMrMhI5LzkSOTPOMjAxQQchNwEHITcBAyMBAyMTMwETBlsb+gUbBcUb+gUcBbb87f43t/X97QHKtwPEm5v+yZubAyP6UAQd++MFsPvhBB8AAAMALP/tBl0FsAAXABsALQAjQBIiKQ0cGRgGcgIBAQ4MDwRyDgwAPysyEjkvMysyzD8zMDFBJzcXMjY2NzYmJicnAyMTBR4CBw4CAQchNxMzAwYWFhcWNjcHBgYnLgI3AhfkJMhVfkwLCh5YTJXd8/0Bb4fGZAwOlu8Dsx/9sB/Y6rIECSUmFSsVECRLJVpuLAgCHAHJAUF3U0dtQAMB+xgFsAEEa8SKmNJtAh+wsAEJ++YjNB0BAQYDugsKAQFRiVP//wAm/+sIFQWwBCYANgAAAAcAVwRUAAAABgAgAAAGRQWwAAMABwANABIAFwAdACpAFB0VCgoSBgcDAgIREgRyExsbCBEMAD8zMxEzKxI5LzPOMhEzETMzMDFBByE3AQchNwETATMDAQsCIwMBEwEzAQsCIxMTBj0c+jYcBZIb+jYcATNSAWqPQf6LJREjmiECn1YBZ/n95icRJZcNMAQtmpr+wpqa/REBZgRK/qH7rwWw+53+swWw+lABaQRH+lAFsPud/rMEXgFSAAIAEP/+BkUEOgARACIAIEAPFhMTERQIFAgRChwPAAZyACsyMj85OS8vETMRMzAxUwUeAwcDIxM2LgInJQMjISETMwMFFjY2NxMzAw4DzAJ0XXtFFAkz7TUFBR09Mf6lm+wDvP3Wf+tdAUFKZTwMcuxxDVyNsAQ6AgI/bJJW/sIBQC1MOSACAfyGAtf96QIBMWBIAqT9XWSaZzQAAAMAS//tBJ8FxgAjACcAKwAdQA4qKycmJgcZEgVyAAcNcgArMisyEjkvM84yMDFlFjY3FwYGJy4DNxM+AxcWFhcHJiYnJg4CBwMGHgITByE3AQchNwLgNGYyCTt4PHy5dS8ONRRnpNyIPHU7Ly5eMFmJYz0MNgkNNGf8Gf0IGQLJGP0HGrQBEQ/KDg4BAlebzHgBU4HZnlUBARIMyhATAQE6a45T/qpHg2c+AvGJif70iYkAAAMARAAABgMFsAADAAcAHwApQBMGBwMCAhQKFBcJCgoWFwRyFgxyACsrEjl9LzMRMxESORgvM84yMDFBByE3BQchNwElNwUyNjY3NiYmJyUDIxMFHgIHDgIGAxz6hRwFUxz6hRsCkP6BJAFjU4tbDAkrZEz+ztr0/AILhtRzDA2m/QSmm5vqm5v+YgHHATlyWEpxQQMB+xgFsAEDbciOncxjAAMARAAABH4FsAADABwAIAAtQBUfICARAwIFBgYaAhoCGgQQEQRyBAwAPysyEjk5fS8vETMRMxEzETMRMzAxQQchNwEBNxcyNjY3NiYmJyU3Fx4CBw4CBwEHAQchNwQ/T/xrTwEj/ncZ21KJXAsKKmVN/u9XwIzTbQwNhdiKAWIBAaNP/RBQBEexsfu5AluLAT51VE1uPgIByAEDYsOTk79nD/3jDwWwsbEABAAV/+cEPgWwAAMAFAAYABwAFUAJBAQDDwELDQMEAD8/MzMSOS8wMUEDIxMBNwcGAgYGJyYmJyU+AzcDBwE3BQcBNwJ3/fT9AcnyCQ9ssPKXP3w+AQBrnGo9DAwl/T4jAook/T0kBbD6UAWw/U8BTov+/8p1AgEQBrcDVY+zXwKAzP71zEDM/vXLAAAC/+UAAASuBDoAGwAfABhACwgVFR4fBnIOAR4KAD8zMysSOS8zMDFhIzc2Ni4CJyYOAgcHIzc+AxceBAcBAyMTBITsHgkBGD1pUWmdbUIOHewdFW6v8Jl1r3dEEg7+xrzsvLU/iYNrQgIEWpa2WrOxif/LdAMCUou0ymcDifvGBDoAAv/qAAAFWgWwABcAGwAaQAwZGAMAAA4MDwRyDgwAPysyEjkvM84yMDFBJTcFMjY2NzYmJiclAyMTBR4CBw4CBwchNwMM/RMjAs1WjVsLCi1kSv7O2fX9AgqG03MLDqT+myP9CSMCHgHHATl0WUlwQAMB+xgFsAEDa8aOnc5kasfHAAQAwP/oBTgFyQAhADMARQBJACVAEkInMEdHOTANch8FDklJFg4FcgArMjIvEMwyKzIyLxDMMjAxQTcOAicuAjc3PgIXHgIVJzYmJyYGBgcHBhYWFzI2Ezc+AhceAgcHDgInLgI3BwYWFhcWNjY3NzYmJicmBgYBAScBAkKiBk6BUFRzOAUGCFGHWE91QKMCLDgsPCQFCgMKKSg2QaAGCFqPWVd8PwUGCViOWlZ+P7IIAxMyKy9DKAYJAxIyLC5EKQFQ/JF3A3AEIgJQd0ACAlOIT01Ui1ICAkN2TgExRwEBMUomTiBIMwFF/SRNWYlOAwFQh1ROWIlOAgJQh6JRJUctAgIsSipPJkgvAQEtSQNJ+5hOBGcAAQAr/+oD2gX6AC4AFLcZGBgBJAwAAQAvMy8zEjkvMzAxZQcuAzcTPgMXHgMHBw4EBzc+Azc3NjQmJiciDgIHAwYeAgJ7E2OZZioLbwo2XIZaRGdBHAQFDXu/6v14EnboxYQRBgEJGBgiKxoNA2wHAx9FxNoFQ3ejYwKmT5Z6RgMCN1t1QCqF4LJ+RAG0Ak2Pyn0qESwoHAMpP0Ia/V80XEksAAAEACMAAAfgBcMAAwAVACcAMQAlQBErMC4qAgMbEiQJCTEuBCotDAA/Mz8zMy8z3DLOMhESOTkwMUEHITcTNz4CFx4CBwcOAicuAjcHBhYWFxY2Njc3NiYmJyYGBgMDIwEDIxMzARMHUhr9tBouBwtiompkh0EICApioWlkiEG1CQQTPjs+VTEICQUUPjo+VjL2/fz+zbjs/P4BM7gCL4+PAdtUZKNeAgNhnWBTZaFdAwNenbNVMl0+AQI8YjdUMV8/AQI8YwEb+lAEHPvkBbD74gQeAAIA8AOUBNEFsAAMABQAJEARCQQBAwYKBwcTFAIAAwMGBhEALzMRMxEzPzMzETMSFzkwMUETAwcDAyMTMxMTMwMBByMDIxMjNwQGP69AOUNuXoM6xIZe/hERhU51TYgQA5UBY/6dAQF//oICG/6DAX395QIbXv5EAbxeAAACAH3/6wRuBFEAHQAmABdACiIXFwQeDgcbBAsAPzM/MxI5LzMwMWUHBgYnLgM3PgMXHgMHBgYHIQMWFhcWNgMmBgcDIRMmJgOpAVO/Y22ocDEKCmWhy3Fvn2IrBAECAf0RPC55RWnAclOSPjQCCjUsd8VoNT0CAmCewmVrzaZfAwNem79iDBcM/rYyNwIDSANeAkky/uoBHzQ7AP//ALr/8wWMBZoEJwHhAEoChgAnAZUA+AAAAQcCPwMKAAAAB7EGBAA/MDEA//8Ahf/zBiYFtwQnAjoAkAKUACcBlQGbAAAABwI/A6QAAP//AIv/8wYWBagEJwI8AIACkwAnAZUBggAAAQcCPwOUAAAAB7ECBAA/MDEA//8Auv/zBdgFpAQnAj4AlQKPACcBlQEtAAABBwI/A1YAAAAHsQYEAD8wMQAAAgBE/+gERgX3ACkAPwAZQAwqAAASNR8LcgkSAHIAKzIrMhE5LzMwMUEWFhc2LgMnJgYGByc+AhceAwYHBw4EJy4DNzc+AxcmDgIHBwYeAhcWPgI3Ny4DAmFRjjQECSA7W0AvWFYsDy9maTaCql8mAg0IDT1fha1scKRnKQoDDFWJt31Fa0wvCAMFBydQQ1FzSiwKDwQoPkkEBgJDPzR0b104AwENGg+zGCEPAQJsstnfYjtcva2GTQMCV5K8aBZquItLwQI0W3Q9FjZyYj0DAkt8kEFcKD4sGAABAB7/FgVJBbAABwAOtQQHAnICBgAvMysyMDFBASMTIQMjAQVJ/vjt6/236+0BCAWw+WYF3fojBpoAA/+m/vMFAQWwAAMABwAQAB9ADg4GBgcHDwJyDAMDCgILAC8zMzMRMysyETMRMzAxRQchNwEHITcBBwEjNwEBNzMEKiL79yIE4CL8JyICRgP85KkbArX+QxiYTr+/Bf6/v/yyH/ywmwLQAsyGAAABAJoCcAP4AzEAAwAIsQMCAC8zMDFBByE3A/gi/MQiAzHBwQADADT//wTzBbAABAAJAA0AFkAKCQsLCgQICAECcgArPzMvMxEzMDFlATMBIxMTByMDBzchBwHcAkLV/TmgHVIIiI2qIwFKIvUEu/pPAwP91NcDA8LCwgAABABJ/+gHrgRRABcALwBHAF8AHUAOWzY2HhMLck5DQysGB3IAKzIyETMrMjIRMzAxUzc+AxceBBcHDgQnLgM3BwYeAhcWPgM3NzYuAycmDgIFBw4DJy4EJzc+BBceAwc3Ni4CJyYOAwcHBh4DFxY+AlMDDVqSwnZXiGZHLgsFE1F0jqBUcKJoKvQDBQkqVUU1ZFlJNg4GBBcuQ1IvSXJRMQZfAw1aksR2V4hlRy0KBBNSdY6gVG+jZyn0AwUJKlNFNWRYSjYPBwMVLkJSLktyUTECChdtyp9aAwNAa4iXSyRPn45vPgECXpvAexc3eGlDAQErSl5kLyMsXlhGLAICP2yCMRdtyp9aAwNCbYuYSyRPnYxsPgICXpy/exc2eGlEAgEqSFtjMCIrYFpJLQIDP2yBAAAB/w/+RgMeBhkAHwAQtxsUAXILBA9yACsyKzIwMUUOAicmJic3FhYzFjY2NxM+AhcyFhcHJiYjIgYGBwEdDWCkcyREIiMTKRU1SCgIvw5mrHUoTCYkFy0XOFExCE1vpFoCAQsJugcIAi5PMATxcahcAQ0ItwYHLlM0AAIAMQEEBDgD+QAZADMAG0ALFwSAChFAMR6AJCsALzMa3TIa3jIazTIwMVM3NjYzNhYXFhYzMjY3BwYGIyImJyYmIwYGAzc2NjM2FhcWFjMyNjcHBgYnIiYnJiYjBgZ6EzKBSEFrNzJjPEt9NBYvdEQ8ZjI3aUBPh4ATMn1HQWs4MmQ7TH81FjB3RTxlMzZpQE6EArnTMjoBKyAcKk0x0zA8KR4fKwFL/ivTMTsBLB8dKUwy0zA9ASkdHywBSwADAGAAgQQYBL0AAwAHAAsAH0ANAgEBCgoLAAMDBwcGCwAvzjIRMxEzETMRMxEzMDFBAScBFwchNwEHITcD2f0oaQLZpyP8tCMDAyT8tSIEevwHQgP668bG/ljGxgAAA//WAAED3wRRAAQACQANACJAEAMHBgAECAYFCQkBAgINDQwALzN8EM4vMjIYLzMXOTAxQQUHATclBQc3AQMHITcBAwJiKP0NGwNO/WDFHgNzrCL8xSICyuPDAUZ+k90fjQFF/Gi4uAADABQAAAPxBFQABAAJAA0AIkAQAwcGAAQIBgECAgUJCQ0NDAAvM3wQzi8yMhgvMxc5MDFBJTcBBwUlNwcBBQchNwMx/ZInAwca/JwCrc0d/HgDKSL8xSICs+HA/rt/l90kjv68b7m5AAIAPAAAA+MFsAAHAA8AHUAOBQgIDgcScgMKCgsBAnIAKzIyETMrMjIRMzAxUwEzBwETByM3AQM3MxMBIzwB6bRK/pWxBJlWAWyvA5n8/harAuQCzL/92f3cprwCKAIkqP0a/TYA//8AYwCoAgoFCAQnABIANQC2AAcAEgDIBAkAAgBnAoQCdgQ6AAMABwAQtgYCAgcDBnIAKzIyETMwMUEDIxMhAyMTAUhMlU0Bwk2UTQQ6/koBtv5KAbYAAf/R/2QBDAEAAAkACrIEgAkALxrNMDFBBwYGByc2Njc3AQwKDWJLdyk8DQ8BAEpjrkFNO3lHVP//AF4AAAWQBhkEJgBKAAAABwBKAjUAAAADAE4AAARTBhkAEAAUABgAG0APGAYXCnITFAZyDQYBcgEKAD8rMisyKz8wMWEjEz4CFxYWFwcmJiMmBgcXByE3IQMjEwE97MURgM2DTpZKNzp5PmaEEMog/aEfA+a87LwEf4O3YAICJRbFFxwCZWVGsLD7xgQ6AAADAF4AAAStBhkAEgAWABoAG0APGRoGchQAcg4GAXITAQpyACsyKzIrKzIwMWEjEz4CFx4CFwcmJiMiBgYHEwEzAQMHITcBTuzIEHjAfEqWk0l4S5pNPWFACqMBB+v++sUg/ZwgBJl8rFgCAQ8XC7YOGStTPPtkBef6GQQ6sLAAAAUAXgAABrwGGgARABUAJgAqAC4AJUAUIxwBci4qFBUGcg0GAXItFxcBCnIAKzIRMysyKzIyMisyMDFhIxM+AhcWFhcHJiYjIgYGBxcHITcBIxM+AhcWFhcHJiYjJgYHFwchNyEDIxMBTuzKDmywdyRHIxcWLRc5VzcJzh/9lSADKezEEYDNg06VSjY6eT9khBHKH/2gHwPmvOy8BKJyqlwBAQsIvAYGK1A4aLCw+8YEfoS2YAEBJRfFFhwBY2VGsLD7xgQ6AAUAXgAABwYGGgARABUAKAAsADAAKUAXKwByJBwBci4UFC0VBnINBgFyKRcBCnIAKzIyKzIrMjIRMysyKzAxYSMTPgIXFhYXByYmIyIGBgcXByE3ASMTPgIXHgIXByYmIyYGBgcTATMBAwchNwFO7MoObLF2JEcjFxYuFzhXNwnPIP2VIAMp7MkQeL97SpaVSHdMmkw9YkAKowEG7P76xR/9mx8EonKqXAEBCwi8BgYrUDhosLD7xgSafKpYAQEQFgu2DRgBKlM8+2QF5/oZBDqwsAAABABe/+0E+wYZAAMAFwAbAC0AJUAUIikLchMKcgkcHA0NBAFyGAIDBnIAKzIyKzIRMxEzKysyMDFBByE3ARYWFwcnNyYmIyIGBgcDIxM+AgEHITcTMwMGFhYXFjY3BwYGJy4CNwHVH/6oIAJIctpoH+cQJlgpOFIxCsvryg5prgKqIP2vH9nrswQKJSYVKxQQJEkmWm0uCAQ6sLAB3gI+K88BWBMPL1I1+10EonKpXP4hsLABCfvmIjQdAQEFA7oLCgEBUYhUAAAEABX/6gabBhYAGwAfADEAZwAxQBs7MkBkYFsLcgFFSUAHciYtC3IeEB8GchQKAXIAKzIrMjIrMisyzDIrzDMSOTkwMUEjLgI3PgMXHgMHIzYmJicmBgcGHgIBByE3NzMDBhYWFxY2NwcGBicuAjcFNiYmJy4DNz4DFx4CByc2JiYnIgYGBwYeAhceAgcOAycuAjcXFBYWFzI2NgPFchA6KAcHTXWNRluMXy0E7AMXQj5KbQwIBhAMAtEe/bUetOyRBAckJxUrFBAkSyZgaiUJ/hwJPl8oPHljOQQEUYCZTGixaQLqAiVKMi9XQAcHITtCHFWiZQYEVoegTWu5bwHjLVQ6L19HAvZQp6lTTnJKIwECN2SOWTVdOgEBV0o4cnJyAQqwsFn8qCE9JwIBBgO6CwoBAmGYVBE2PSAKDy9IZ0pUf1QoAQJPl3EBM0koAR9BMCYxHhMHFkd/Zll/UiYCAlSfcwE6UCkBGz4AFf+o/nIIRAWuAAUACwARABcAGwAfACMAJwArAC8AMwA3ADsAPwBDAEcAVwBzAIwAmgCoAABBIxMhByMhIzchAyMBIRMzBzMFITczNzMBITchBSE3IQEhNyEBByM3EwcjNwEhNyEBByM3ASE3IQUhNyEBByM3EwcjNwEHIzcFEzMDBgYjIiYnFwYWNzI2JSM3FzY2NzYmJycDIxMXHgIHDgIHBgYHBiIHJzczNjY3NiYnJzc3MhYXFgYXHgIVBgYBBwYGJyYmNzc2NhcWFgc3NiYnJgYHBwYWFxY2ASdvMgEtFL4GfsIVAS4ybfkx/tI4byS/Bhn+0hTAJG3+J/7xFAEP/OT+8hUBDQEY/vMVAQ0D4SxuLfAtbSz8Tf7xFQEO/J8tby0E6P7yFQEOAW/+8RUBD/ovLW8tsCxvLAcZLG4t/vY6YzsJaFBRaQJZAiUwLDr985oEbCxWCQlAImZRXmCoLlk6AQIyRh8EAgQEDy6+NH8rSgkGLCR8BosFEwQDAwQYNSMBgP7DBwmGZGBzAwgKhWNfdGoOBTBAQ1EKDwYxQURQBJEBHXR0/uP54QE7ynFxyv7FcXFxBld0+3T5+QLy+vr6XnECP/n5BBh0dHT87vz8AXj6+v6I/Pz0AXv+hU5cUlUCKzMBOnBGAQIiMiwUAQH+LwIlAQEZPjc4JxEYAw8DBPUDSAMoLykjAwFGAQIFAw8DGBIiMldJAUdwYX4CAnxfcGJ8AgJ8znI6VwIBWD1yO1cCAVgABQBc/dUH1whzAAMAHgAiACYAKgAAUwkCAzM0Njc2NjU0JiMiBgczNjYzMhYVFAYHDgITNSMVEzUzFQM1MxVcA7wDv/xBd8oZKURip5V/sQLLAj4nODk1KC89HcnKfwQGBAKDA8/8MfwxAt4zPhslgVKAl32NNzBANDRNGiE6Tv67qqr9SAQECpoEBAAB/+QAAAJ7AyMAHAAQtQMcHAsTAgAvzDIzETMwMWUHITcBPgI3NiYnIgYHBz4CFx4CBw4CBwcCThr9sBcBOBo+LwcGLCo6RQy0B1eJU0h9SgMDTGwznpGRhAEBFjhAJSkxAUg1AlR6QQEBM2dQRm1YJXUAAAEAcAAAAgwDFAAGACNAFQQFBQMDLwB/AAIPAF8ArwD/AAQAAQAvzV1xMhEzETMwMUEDIxMHNyUCDIKxY8wbAWsDFPzsAjwxl3IAAgAW//ECgQMkABEAIwAMsxcOIAUALzPEMjAxQQcOAicuAjc3PgIXHgIHNzYmJicmBgYHBwYWFhcWNjYCehAKUIxlYHYzBxELT4xmX3cxzRQEBScuMTseBRUEBicvMTsdAdaYXZhYAwNak1qYXphYAwNblfuxI085AQI2UiiwJE85AQI1UwABAGH/8wO0BKAAMgAXQAoUHh4mATEKDCZ+AD8zPzMSOS8zMDF3MxY+Ajc3Ni4CJyYGBgcGFhYXFj4CNxcOAicuAjc+AhceAwcHDgMHI8EPXZ98UQ8gBAcgPjFBYDoIBRxHOydLPy4KPw5rmVNxlkcICoXQfGaSWCAJCRN0vPycG7MCJ1aIYNkpVEUrAQFCajw1WzkBARctPiZEVX5FAQJmrGt8wWwCAk6Dql5LmvClVQEABAAe/+4DvwSgABIAIgA0AEQAHUANKBcXQQ4OBTkxfh8FCwA/Mz8zEjkvMzMRMzAxQQ4DJy4CNz4DFx4DBzYmJicmBgYHBhYWFxY2NgEOAycuAzc+AhceAgc2JiYjJgYGBwYWFhcyNjYDeAVThqJRY7ZwBQVWiJ9OR4xzQ+wHK04uNWFBBwYpTjA1YEIBMARQfpVIQoRrPgIFgMRoYalm8wYjQiowUTYGBSFBKzBSNwFHW4RTJwIBRo9xWX9RJgIBJk12QDJFIwEBJ0w5M0UjAQEoTQI9UndMJAECJEhuTHSVSAICRot5LD8hASVGMC1BIgEmSQAAAQBZAAAEFASNAAYADrUFAQZ9AwoAPz8zMzAxQQcBIQElNwQUGf1j/vsCnv2AIQSNkfwEA8wBwAABADz/7AOeBJwAMQAVQAkWHx8OJwsDAH4APzI/MzkvMzAxQTMHIyYOAgcHBh4CFxY2Njc2JiYnJgYGByc+AhceAgcOAicuAzc3PgIkAzYnFQxiqYVYDxkFCSJBND9iPgcGH0k6NWZMDzgOcqFXbZJECAmFz3pklmEoCgkUecABAAScxAItYZNlrCtXSS0BATtkOjdXNAEBKUw1SFeCRgECaaxnfLtmAwNIfqZgUZnxqVoAAQAw/+sD3QSNACMAF0AKIQkJAhkRCwUCfQA/Mz8zEjkvMzAxQScTIQchBzY2FzYWFgcOAicuAiczFhYXMjY2NzYmJicmBgE8wa4CtCL+E1ctZTNwnE0ICYPRfGWvbQPmBFxKQmE6BgYkTzs2XQIPMQJNw/wXFgEBYKhufrljAwJQlmtMRQE4Yz85WDIBASAAAv//AAADtQSNAAcACwAVQAkAAQEKBAt9ChIAPz8zEjkvMzAxQQchNwEzCQIDIxMDtSL8bBICk8n+9/6jApTK68oBu8CjAu/+qP6HAtH7cwSNAAIACP/uA8AEoAAdAD0AHUANHwAAHR4eEjQqCwkSfgA/Mz8zEjkvMzMRMzAxQRc+Ajc2JiYjJgYGBwc+AhceAwcOAyMnBzcXHgMHDgMnLgM3FwYWFhcWNjY3Ni4CJwFtcDZoSQgHJ0ktL1U9C+4Jh8dnS41wPgQEU4KTRbIKFZRHinA/BQRZjaZSUI9sPgLpATBRMTdkRQgGGTNGKAKnAQEhSzwxQB8BHDwvAXKRRQIBJk96VVJxRR8BN3MBARxAb1RdhlYnAgEsV4BWATNEIQECJU06LT0lEQEAAf/yAAADvASgAB4AErcLFH4DHh4CEgA/MxEzPzMwMWUHITcBPgI3NiYnJgYGBwc+AhceAgcOAwcFA3Qi/KAeAdUpYUwJCk9FP2A+CewKiNF2Z69lCAVDZHI1/uW/v6wBhiNVZTlGUgEBMFo8AXuvWwIBTZZwSX1rXCnUAAEAtAAAAwwEjQAGAAqzBn0CCgA/PzAxQQMjEwU3JQMMw+yZ/r4kAhUEjftzA3FSxqgAAgA5/+0DvQSgABUAKwAOtRwRficGCwA/Mz8zMDFBBw4DJy4DNzc+AxceAwE3NjQmJicmDgIHBwYUFhYXFj4CA7IcDkl6rXBqk1UdCx0OSXqtcGuSVRz+6yIFGT84PFY3HwgiBRk+OT1VNyACrcxntotMAwJTirBhzWe1i0wDAlOKsP6++CthVTgCAjFVZjP2LGJWOQICMlZnAAP/1gAABCoEjQADAAkADQAcQAwEDAwNDQh9BwMDBgIALzMzETM/My8zETMwMWUHITcBASM3ATMjByE3A5Ei/KYiA9n8dK4aA5OnUiH8yiK/v78DPfwElAP5wMAAAwBsAAAEggSOAAQACQANABtAEAgHAwQGAAoNCAEMCnIFAX0APzMrERc5MDFBASEBIwMTByMBAQMjEwHIAasBD/3XiXDaMYD+4wIMX+tfAg4Cf/z3Awr9aHIDCf2V/d4CIgAB/6IAAAR9BI0ACwAVQAoHCgQBBAkFAwB9AD8yLzMXOTAxQRMBIQEBIQMBIQEBAYejATIBIf4mARf+97L+xP7fAeb++wSN/msBlf2x/cIBnP5kAlcCNgAABACLAAAGHgSNAAUACgAPABUAIEAOEgQQAQ4EDAEIBAYBfQQALz8zETMRMxEzETMRMzAxZQEzBwEjExMHIwMBATMBIxMTByMDNwFaAY2JHf5mjDogH5VIA0kBX+v+JJMFShWNTiLTA7rQ/EMEjfw/zASN/FMDrftzBI38M8AD1bgAAAIAbgAABLcEjQAEAAkAD7UHAwUBfQMALz8zETMwMUEBIQEjAxMTIwMCCQGsAQL9i7cshRKo4AE6A1P7cwSN/Jf+3ASNAAABADj/7ARkBI0AFQAPtQwRBgB9BgAvPxEzMjAxQTMDDgInLgI3EzMDBhYWFxY2NjcDd+2CEpLehXvCZg6B64IIJFhFSXBICwSN/QCGvF8DAmK4ggMA/P9DYjcCAjRkSAACAGMAAAReBI0AAwAHABG2BgcHAQB9AQAvPxE5LzMwMUEDIxMhByE3AuTK7MsCZSP8KCMEjftzBI3AwAABAA//7gP+BJ4AOQAYQAoKJg82MSsYFA9+AD/MMy/MMxI5OTAxQTYuAicuAzc+AxceAgcnNiYmIyIGBgcGHgIXHgMHDgMnLgM3FwYeAjMyNjYCvQgiPUohRIVrPAUFV4ehTm+8cQLqAy5WODFkSggHJ0JKHUaEaDkFBlmKpFBXnntFAusDHTtSMTJlSQE4LDsnGAoUNlB1U1iCVCYBAlCfdwE6TigdQjYpNyUXCRQ5VHlUXIBQJAIBMF2NXgE0Si4XHEAAAgAJAAAEFgSNABkAHgAYQAobDQ0MDBoYFwB9AD8yLzM5LzMSOTAxUwUeAwcOAgcHITcFMjY2NzYmJicnAyMhAzcTFdMBr1CUcj4GBlWJVVL+aSABGztrSwkHKFA136nsArO/7c4EjQECKFGBWmWEVyMpwAEnUUE4SyUCAfwzAgQC/gcNAAADADr/LwRWBKAAAwAZAC8AHEAMAAMDKysKCgIgFX4CAC8/MxI5LzMSOREzMDFlAQcBAQcOAycuAzc3PgMXHgMHNzYuAicmDgIHBwYeAhcWPgICqwEkov7jAjsGD16Zzn55rGspCwYOX5nPfXmtain8BwYIKlpMUXlUMgkIBgcqWk1Re1Myrv78ewEFAjE4d9KfWAMCXp7Kbjp30aBYAwJfn8qiOj2AbkUDA0BviUY7PYFxSAMDQnKLAAABAAkAAAQwBI0AGAATtwIBAQ0MD30NAC8/MxI5LzMwMUElNwU+Ajc2JiYnJwMjEwUeAgcOAwI0/rgiASw8cE4KCChTNvep7MsBxnC7awgHWY6sAZoBwAEBJVBCOVIsAwH8MwSNAQNWpnlkkFsrAAIAO//tBFgEoAAVACsAELYnBhwRfgYLAD8/MxEzMDFBBw4DJy4DNzc+AxceAwc3Ni4CJyYOAgcHBh4CFxY+AgRMBg5emM9+ea1rKQsHDl+Zzn54rWoq/QcGCCpZTFF5VDIJBwcHK1pMUnlUMAJpOXbUoFkDAl6eym46d9GgWAMCXZ7Jpjo9gG1GAwNAb4lGOz2BcUgDA0NxiwABAAkAAASoBI0ACQARtgMIBQEHAH0APzIvMzk5MDFBAyMBAyMTMwETBKjK5P6JjuzL4wF4jQSN+3MDLfzTBI380wMtAAMACQAABcgEjQAGAAsAEAAWQAkCDgoFDAcEAH0APzIyMi8zMzkwMUEzEwEzASMBMwMDIwEzAyMTAUDCswHY1v12ov6dx3A27AT1ysvsOgSN/LEDT/tzBI38qP7LBI37cwFKAAACAAkAAAMxBI0AAwAHAA+1BgMCBH0CAC8/ETMzMDFlByE3EwMjEwMxIv2bIvPK7Mu/v78DzvtzBI0AAwAJAAAEnQSNAAMACQANABdADAYHCwUMCAYKAQQAfQA/Mi8zFzkwMUEDIxMhAQEnNwEDATcBAb/K7MsDyf21/r8R4wGEmf7hvAFtBI37cwSN/bn+7vPpAX37cwIjjf1QAAAB//P/7QOvBI0AEwANtBAMBwF9AD8vzDMwMUETMwMOAicuAjcXBhYWFxY2NgI8hu2HEHm+dnOrWgXrAx1EOTlRLwFuAx/84nSuYAIDVqJ3ATVQLQECN1gAAQAaAAABzwSNAAMACbIAfQEALz8wMUEDIxMBz8rrygSN+3MEjQADAAkAAASpBI0AAwAHAAsAGEAKAgMDBAkFCAR9BQAvPzMRMxI5LzMwMUEHITcTAyMTIQMjEwOnIf1+IpnK7MsD1cvqygKdwMAB8PtzBI37cwSNAAABAD//7wROBKAAKgAWQAkpKioFGRB+JAUALzM/MxI5LzMwMUEDDgInLgM3Nz4DFx4CFycuAicmDgIHBwYeAhcWNjc3IzcELEc4pLVQerBvLA0JD1yWy399um0K4gYyWUFReFQxCgoICjBgTj1zMyj1HwJi/i9BRhsCAVqbyXJJd86bVQMCWKt/AUBWLAMCPWqFSExBgmtBAgEZIcytAAMACQAAA+gEjQADAAcACwAaQAsHBgYBCgsLAQB9AQAvPxE5LzMROS8zMDFBAyMTAQchNwEHITcBv8rsywJ/Iv3XIgK+Iv2XIgSN+3MEjf4RwMAB78DAAAADAA//EwP+BXMAAwAHAEEAKUATBz4+JAgXMwYGMwsCICAXAAAXfgA/My8RMxEzPzMvERI5OTMRMzAxQQMjEwMDIxMlNi4CJy4DNz4DFx4CByc2JiYjJgYGBwYeAhceAwcOAycuAzcXBh4CMz4CAvM1ljZQNpY2AUUIIj1JIkSFazwFBVaIoE9vvHEC6gMuVjgxZEkJBydCSh1GhGg5BQZZiqRQV557RQLrAx07UjIxZUoFc/7MATT61P7MATTxLDsnGAoUNVB2UlmCUycBAlCfdwE6TigBHkM2KDclFwkUOVR5U1yBUCQBAi9ejV4BNEouFwEbQAADABEAAAQIBKAAAwAHACYAHUANBAUFASIZfg4CAg0BCgA/MzMRMz8zEjkvMzAxYSE3IQMHITclBw4CByc+AzcTPgMXHgIHJzYmJicmDgIDlPx9IQOEfxn9BhkBkBwIOmNFiiYwHQ8FHwpDcZ5leaBLBO4EEDo8M0ktGcABuZCQaflTj3QrWQ5CVlciAQFeo3pEAwJns3YBMWBAAgEtTFsABQACAAAD5wSOAAMABwAMABEAFQAbQAsGBwMCAhEUCgkRfQA/Mz8SOXwvMxjOMjAxQQchNwUHITclASEBIwMTByMDAQMjEwM7Gv0HGQLUGv0HGQFpAWIBAf4miSeNLIHMAb1g62ACRJGR2I+PogJ//PcDCv1ocgMJ/ZX93gIiAAACAAkAAAPgBI0AAwAHAA61BwYDfQIKAD8/MzMwMUEDIxMhByE3Ab/K7MsDDCL9nCIEjftzBI3AwAAAA/+kAAAD6wSNAAMACAANABtADAgMfQAFBQkCAwMJCgA/MxEzETMRMz8zMDFhNyEHARMzAyMBARMjAQMrIv0zIgIKhP/hs/48AbV3pv2LwMADUfyvBI37cwNqASP7cwAAAwA7/+0EWASgAAMAGQAvABdACgMCAgogFX4rCgsAPzM/MxI5LzMwMUEHITcFBw4DJy4DNzc+AxceAwc3Ni4CJyYOAgcHBh4CFxY+AgMtIv5mIQK6Bg5emM9+ea1rKQsHDl+Zzn54rWoq/QcGCCpZTFF5VDIJBwcHK1pMUnpTMQKhwMA4OXfToFkDAl6eym46d9GgWAIDXZ7Jpjs8gG5FAwNAb4lGOz2BcUgDAkJxiwAC/6QAAAPrBI0ABAAJAA61AQkKBAh9AD8zPzMwMUETMwMjAQETIwECaIT/4bP+PAG1d6b9iwNR/K8EjftzA2oBI/tzAAP/2wAAA6EEjQADAAcACwAXQAoHBgYCCgt9AwIKAD8zPzMSOS8zMDFlByE3AQchNwEHITcC+CL9BSEDDCP9lyEDBCH9AyLAwMAB/sHBAc/AwAADAAkAAASkBI0AAwAHAAsAE7cKBQsHAgADfQA/MzMzMy8zMDFBByE3MwMjEyEDIxMD+yL9fyJFyuzLA9DK7csEjcDA+3MEjftzBI0AA//aAAEEDASNAAMABwAQACVAEg0ICQMKBhAQDgd9CgIMAwMCCgA/MxEzETM/MzMRMxIXOTAxZQchNwEHITcBBwEjNwEDNzMDhyL8zyIDtiL88CIBfwL+DKsbAYbvGJrAv78DzcDA/dAX/budAb4Bq4YAAwBBAAAFNASNABUAJwArABVACRYAACt9HgwqCgA/zTI/My8zMDFBFx4DBw4DIycuAzc+AxcmBgYHBhYWFxcWNjY3NiYmJxMDIxMCwXhou45KCQpxstlzeGq7jEgJCnGy2WRhpGwODDl7WYtkpGsMCzp8V1nL7MsEGQECOXCqc323eDoCAjt0rXN8tXQ4uwE7gGddeT8DAQE/hGlcdToDAS/7cwSNAAIAbQAABUUEjQAZAB0AH0AOFRQUBgcHDRwOAB0dDX0APzMRMz8SOREzMxEzMDFBMwMGAgQnJy4DNxMzAwYeAhcXFjY2NwMDIxMEWusyGqX+8rhJgbpyKxAy6zIJBzBmVUp9o1sSuMvrygSN/tOx/viTAQEDW57SewEu/tFJim5EBAEDZ7RzAS77cwSNAAADAAAAAARxBKAALAAwADQAJ0ATLTQKLjMKKBISKRERMjIxCgYdfgA/Mz8zETMRMzMRMz8zPzMwMUE3Ni4CJyYOAgcHBgYWFhcHLgM3Nz4DFx4DBwcOAwc3PgIBNyEHITchBwNzBQcML1tHTHZVNAkFBwIaRkAKZ5RcJQkEDGSdyXJtrHQ1CQMNWY68cQtgeD/+ySMBwCL8ECIBwCMCays+c104AgI0XnxFKzp9c1kYdRJml7ViI3K9i0sDAk6Lt2okcMCSXQ91IH+o/fXBwcHBAAADAGL/6wULBI0AAwAHACMAHEANFxYLIA0NAwQKBQIDfQA/MzM/EjkvMz8zMDFBByE3ExMzAxM3PgIXHgIHDgMHNzI+Ajc2JiYnJgYGBBsi/Gkih8rtywcPNXx+O3y4YAkHWo+0YBMyWUYsCAgmWUM8dnQEjcDA+3MEjftzAfu/Gh4MAQFdsYBtlFkoAboXL0w1RVswAQITHwAAAgA5/+0ERASgAAMAKwAXQAoAAQEJHRR+KAkLAD8zPzMSOS8zMDFBByE3ATcOAicuAzc3PgMXHgIXIy4CJyYOAgcHBh4CFxY2NgK9Iv5EIQIM6hSY44J4qWYlDAoOXJXJe4G9bAjqAi1dR1B2TzAJCgcDJVVMS3JMAqfAwP7cAYW3WwMCXJzHbU9zzpxWAwJjuH9GYTQDAj1rh0RRO39tRgIDL2EAAAP/wf//BsMEjQARACkALQAgQA8oKSkcLB0BLX0fHAoLCAoAPzM/Mz8zMzMSOS8zMDFBMwMOBCcjNzc+BDclHgIHDgMnIRMzAxc2Njc2JiYnJTcDByE3AXPvbhIsRGyecTYWIkNaOSIVCAQgbrtsCAdYjq1b/hvK7andXpkOCCpTNP62IiAi/dIiBI39+Fy6poFJAcgBBEFleHk0XwNToXlkk2IvAQSN/DMBAWdjOEsoAgHAAZXAwAADAAn//wbGBI0AFwAbAB8AIUAPFxYWGxoaHgsffQ0KCh4KAD8zETM/MxI5LzMzLzMwMUEeAgcOAychEzMDFzY2NzYmJiclNwcHITcTAyMTBS9uvG0IBlqNrlr+Gsvrqd9emA4IKlI1/rciayH9jSKZyuzLAvcDU6F5Y5RiLwEEjfwzAQFnYjlLKAIBwFvAwAHw+3MEjQADAGMAAAUKBI0AAwAHABsAGUALGA0NAxMECgUCA30APzMzPzMSOS8zMDFBByE3ExMzAxM3PgIXHgIHAyMTNiYmJyYGBgQcIvxpI4fK7MsHDTZ7fjuDuVgON+w4CR5VSzt2cwSNwMD7cwSN+3MB+78aHgwBAWS7h/6qAVdIZTcCAhMfAAAEAAn+oQSjBI0AAwAHAAsADwAbQAwPC30DBwcOCgICCgoAPzMvETMzETM/MzAxZQMjEyUHITcTAyMTIQMjEwKOXOxcAbAi/X8i7srsywPPyuzLs/3uAhINwMADzftzBI37cwSNAAACAAv//AP4BI0AFwAbABtADAIBAQ0LDgobGhoNfQA/MxEzPzMSOS8zMDFBIQcFHgIHBgYHJxMjAwUWPgI3NiYmNzchBwJv/rkiASw0XDcBAo1a+6rpygHIXLCTYg0QX7X6If2HIgLpwAEBIkk8Y10BAQPN+3MCAi9gk2J5nk/pvr4AA/+D/q8EvwSNABAAFgAeACNAEBodHQkXCgocFAkKFhERAH0APzIRMz8zMzMRMxEzLzMwMUEzAw4EByM3Fz4DNxMhAyMTIQEhAyMTIQMjAZrrUxAyTGySYFAaIEBeQSwPjALpyuup/gH+LATIXOw7/Q877ASN/mNau7KYcx6/ATx/iplXAZr7cwPN/PP97wFR/rAAAAX/qgAABkUEjQADAAkADQATABcANUAZFBcXEQwLCwcHEREGDg4PCgICFQoJAwMPfQA/MxEzPzMRMxI5LzMzETMRMxEzETMRMzAxQQMjEyEBITczAQMDNwkCIRMzBycBIQED48rsygNO/gf+1xWnAUOqu8wBBPwX/v4BCZ22NY3+n/7PAe0EjftzBI39S9UB4PtzAguQ/WUB2AK1/iDVH/4JApcAAgAO/+4D6wSfAB4APgAdQA0fAgIBPj4VNCoLCxV+AD8zPzMSOS8zMxEzMDFBJzcXPgI3NiYmIyYGBgcHPgMXHgMHDgMnFx4DBw4DJy4DNxceAhcWNjY3Ni4CJycCLsIWgTdqSggINFguMVdBDO0HVYSdUEmTekYEA1SCl/6lRIpxQgQFX5OtVVCTcUAC6AExUjQ5clIJBho2SSiXAisBfQEBHUc/NkEbARs8MQFYfk8kAQEhRndXVHhMJUcBASBEb1JhhlIkAgEqVIFZATdDHQEBIEpALz8kEQEBAAMACwAABK0EjgADAAcACwAbQAwAAwoHCwoBAgUFCH0APzMRMzM/MzMzMzAxdwEXAQEzAyMBMwMjWgNyj/yQAtnpyun92+nK6VYEOFf7yQSN+3MEjftzAAADAAoAAARqBI0AAwAJAA0AH0AODAsLBwcGBgIJA30KAgoAPzM/MxI5LzMRMxEzMDFBAyMTIQEhNzMBAwM3AQHAyuzLA5X9uv7uBrQBfa36tgFbBI37cwSN/UvVAeD7cwILkP1lAAAD/8H//gSYBI0AAwAHABkAGEALExAKBwIDAwh9BgoAPz8zETMzPzMwMUEHITchAyMTITMDDgQnIzc3PgQ3A+Ai/dIiAubL7Mr9yO5vEi1Fap1wNhciQlk5IhUJBI3AwPtzBI3991u4p4JKAsgCB0Fjdng0AAIAdv/oBIkEjQASABcAF0AKARd9FRYWDg4HCwA/MxEzETM/MzAxQQEhAQ4CByImJzcWFjMyNjY3AxMTBwECCAF1AQz93C1oi2McNhoRFCkUMkc2FyCfKKz+6wHnAqb8eFCBSwEDAsEDBClDKANS/af+80UDqwAEAAn+rwS4BI0ABQAJAA0AEQAdQA0RDX0FCQkQCwgCAggKAD8zLxEzMzMRMz8zMDFlAyMTIzczByE3EwMjEyEDIxMEuG7ZOoAiBSL9fyLuyuzLA9DK7cvA/e8BUcDAwAPN+3MEjftzBI0AAgBbAAAEWwSNAAMAFwATtxQJCQIDDn0CAC8/MxI5LzMwMUEDIxMDBw4CJy4CNxMzAwYWFhcWNjYEW8rsyggONXR2OoXBXw857DoIHVZLO3ZzBI37cwSN/f+/GB8OAgFfu4wBXP6jSGQ3AwESHwAEAAkAAAZDBI0AAwAHAAsADwAZQAsLBwcPEAoGBgMOfQA/MzMRMz8zETMwMWUHITcBAyMTIQMjEyEDIxME8SL7xiIDSsrsygMuyuzK/GjK7MvAwMADzftzBI37cwSN+3MEjQAABQAJ/q8GVwSNAAUACQANABEAFQAnQBIRDQ0VfQQQAgIQEAwMExMJCAoAPzMzETMRMxEzLxEzPzMRMzAxZQMjEyM3MwchNwEDIxMhAyMTIQMjEwZXbtg6gCIEIvvGIgNKyuzKAy/L7Mr8aMrsy8D97wFRwMDAA837cwSN+3MEjftzBI0AAgBL//wE5QSNAAMAGgAXQAoGBQUPEgoRAQB9AD8yMj8zOS8zMDFTByE3ASUHBR4CBwYGBycTIwMFFjY2NzYmJmwhAbsiAT3+uSIBKjZbNwECj1r7qunKAch75J4SEF+zBI3AwP5qAcABAiZMO2JmAQEDzftzAgJZsYF4olP//wAL//wF2QSNBCYCIwAAAAcB/gQKAAAAAQAL//wD8wSNABYAFUAJFRYWCgwJCgp9AD8/MxI5LzMwMUEeAgcOAiclEzMDFzY2NzQmJiclNwJxb7NgERKe5Xr+OMrpqvtbjQM2WzX+1SEC9wNToniBsVkDAQSN/DMBAWZiO0wmAgHAAAIAFP/tBB8EoAADACsAF0AKAgEBHAgnCxMcfgA/Mz8zEjkvMzAxQSE3IQEeAhcWPgI3NzYuAicmBgYHBz4CFx4DBwcOAycuAicDWP5FIQG8/YQCL15IUXROLQoKBwUmV0pLc0wQ7BaY4IR3qmcnDAoPWpPHfX7BcAYB58D+3kdeMAIDPmuGRVE6fm5GAwIzZEcBhbpfAwJcncZuT3TNm1YDA1+zgAAEAAn/7QYaBKAAAwAHAB0AMwAdQA4kGX4vDgsDAgIGB30GCgA/PxI5LzM/Mz8zMDFBByE3EwMjEwEHDgMnLgM3Nz4DFx4DBzc2LgInJg4CBwcGHgIXFj4CApUi/pMil8rsywU8Bw5dmc5+ea5rKQwGD16azn14rWop/AcGBypaS1F6VTIJBwcIK1pMUXpTMQKkwMAB6ftzBI393Dl306BZAwJfnstvOHbRoFgCA12eyao7PYFuRwMDQG+KRjo9gnBIAwNBcYoAAAL/0QAABFIEjgADACMAGUALIwAEBBkbFn0ZAQoAPzM/MxI5LzMzMDFBASEBBSUiJiYnLgInLgI3PgMzBQMjEycGBgcGFhYXBQJn/nT+9gGSAd7+ow0VFQoEBgYDSG07BQVWiqVWAc3K7KnHV40OByZMMgE1Akv9tQJLjQEHCQUFDQwGHU5zVGCIVScB+3MDzQEBVFw3RCICAQAD//YAAARJBI0AAwAHAAsAG0AMCwoKAwIGBwcDfQIKAD8/MxEzERI5LzMwMUEDIxMhByE3EwchNwIoyuzKAw0h/Zsiux39cx4EjftzBI3AwP4BpqYAAAb/qv6vBkUEjQADAAcADQARABcAGwA7QBwCDgEBDg4GGxgYFRISEA8MCQkTBgYZCg0HBxN9AD8zETM/MxESOS8zMzMzETMzETMRMxEzLxEzMDFBIxMzAQMjEyEBITczAQMDNwkCIRMzBycBIQEFpclcyf3iyuzKA07+B/7XFacBQ6q7zAEE/Bf+/gEJnbY1jf6f/s8B7f6vAhADzvtzBI39S9UB4PtzAguR/WQB2AK1/iDVH/4JApcAAAQACv6vBGoEjQADAAcADQARACdAEhAPDwsKCgYNB30CDgEBDg4GCgA/MxEzLxEzPzMSOS8zMxEzMDFBIxMzAQMjEyEBITczAQMDNwEDu8lcyP2qyuzLA5X9uv7uBrQBfa36tgFb/q8CEAPO+3MEjf1L1QHg+3MCC5D9ZQAEAAoAAAUVBI0AAwAHAA0AEQApQBMQDw8KAAsLCgMDCgoGDQd9DgYKAD8zPzMSOS8zLxEzETMRMxEzMDFBMwMjEwMjEyEBITchAQMDNwEB15pwmlnK7MsEQP26/kMGAV4Bfqz8twFbA439fgOC+3MEjf1L1QHg+3MCC5D9ZQAEAGAAAAV0BI0AAwAHAA0AEQAhQA8QDw8LCgoOBgoNBwcDAH0APzIyETM/MzkvMzMRMzAxUyEHISUDIxMhASE3MwEDAzcBggG/Iv5BAmrK7MsDlf26/u4GtAF9rPq1AVwEjcDA+3MEjf1L1QHg+3MCC5D9ZQAAAQA+/+gFdwSoAEQAG0AMAAEBLxgLJCMjOg1+AD8zMxEzPzMzLzMwMWUHLgQ3Nz4DFx4DBwcOAgQnLgM3Nz4DNwcOAwcHBh4CFxY+Ajc3NjYmJicmDgIHBwYeAgUmEHzkv4dADQULRHSmbGqMUBoJCROJ0/77j4nTiz0OBQ5YkcR6FkttSSsJBQkZSYBcaLOMWQ0GBQUQODg9VDMcBgUORJDKr8EDNGSa1YopYbeRUwIDVo6vXUaQ7qpcAwJZoN6GMHXKl1UDyAFAaoBBJVaUcEACAz96p2Y1J2diQgMCOl5sMC2Fsmsu//8AbAAABIIEjgQmAe4AAAAHAkEACf7TAAL/ov6vBH0EjQADAA8AIkARCw4IBQQKBg99AgoBAQoKDQoAPzMRMy8RMz8zEhc5MDFBIxMzARMBIQEBIQMBIQEBA8LIXMj9aaMBMgEh/iYBF/73sv7E/t8B5v77/q8CEAPO/msBlf2x/cIBnP5kAlcCNgAABQBi/q8FvASNAAUACQANABEAFQAiQBARDQ0UFX0QEgwJBAgCAggSAD8zLxEzMzM/PzMzETMwMWUDIxMjNzMHITcTAyMTIQMjEyMHITcFvG7ZO4AhBSH9fiLuyuzKA9HL68qtIvx1IsD97wFRwMDAA837cwSN+3MEjcDAAAMAWwAABFsEjQADAAcAGwAfQA4AGBgNAwMNDQYHEn0GCgA/PzMSOS8zLxEzETMwMUEzAyMBAyMTAwcOAicuAjcTMwMGFhYXFjY2Af2Zb5oCzsrsyggONXR3OYXCXg857DkJHlVLO3ZzA0L9fgPN+3MEjf3/vxgeDwIBX7uMAVz+o0hlNgMBEh8AAAIACQAABAkEjQADABcAFEAJDxIUCQkBfQASAD8/OS8zPzAxcxMzAxM3PgIXHgIHAyMTNiYmJyYGBgnL68oJDzN0dziGwl4OOes5CR5VSzx1cwSN+3MCAr8YHw4BAl+7i/6iAV5IZTcCAhIgAAEAO//wBZQEpwA0ABtADBgYHR0RESILfi0ACwA/Mj8zOS8zETMvMDFFLgM3Nz4DFx4DBwclLgM3FwYWFhcFNzYmJicmDgIHBwYeAhcWNjcXDgIDVnnDhj0ODw9moM93eLJwKw4X/CNdhVIjBboEGUdBAwcFDittVUx6WTkLEwoYQ3FOUJhJMTR7gQ8BTpDHe3RzyJRSAgNTksN0mAEDQXGVWAE7ZD8EAxtSf0sCAjZifUaFS3pXMQECIxy3ICIMAAEAMv/tBG8EpAArABVACREUFBkLCyQAfgA/Mj8zOS8zMDFBHgMHBw4DJy4DNzchByUHBhYWFxY+Ajc3Ni4CJyYGByc+AgJ7eMCCOg0QD2efznh4sm8sDhgDZiL9jQUOLGxVTHpaOAsTCRdDcU5Rl0kwNX6EBKMBUJHHeHRzx5VSAwJSksR0mcABGlGASgMCN2F9R4NLe1gxAQEiHbgfIgwAAAIADv/oBAYEjQAHACYAG0AMCAUFBCYmHRMLBwB9AD8yPzM5LzMzETMwMVMhBwEjNwEhExceAwcOAycuAzcXFBYWFzI2Njc2JiYnJ8oDPBv+MqQXASv97eSdTItqOgUGXZGwWVGTcT8C6DNVNTxwTQgIMFo2kASNo/5lfQEB/ugCAi1Vf1Rjj1kpAgIrVoJaAThFHwEkUUI+SSECAQAAAwA0/+0EUAShABUAJAA0ABtADgslai0dai0tCwAWagALAC8vKxI5LysrMDFBHgMHBw4DJy4DNzc+AxcmBgYHBgYHITY0JzYmJgMWNjY3NjY3IRQGFwYeAgKXeaxqKgsGDl6ZzX95rWspCwcOX5nOcFqDVBUBAwICIAEBAiRd5FqCVBQCAwH94QEBARMwVASeA12eyW45dtSgWQMCXp7Kbjp30aBZwwRRhk8GCwYGCwZHglb80wJPhk8GCgYFCQQ2Z1M0AAQABwAABAoEoAADAAcACwAqACFADwYHAwICCSYdfhIKChEJEgA/MzMRMz8zEjkvM84yMDFBByE3BQchNwEhNyEBBw4CByc+AzcTPgMXHgIHJzYmJicmDgIDQxn9BhkC0Rn9BhoDc/x9IQOE/hccCDpjRIsmMB0PBR8KQ3GeZXehTgXsAxI6OzRILhkCvJGR64+P/i/AAiL5U490K1kOQlZXIgEBXqN6RAMCY611ATJaOgIBLUxbAAADAB7/8QPuBKEAIwAnACsAHUANJyYmKisrBxkSfgAHCwA/Mz8zEjkvMzMvMzAxZRY2NxcGBicuAzc3PgMXFhYXByYmJyIOAgcHBh4CAQchNwUHITcCZTNkMgY1bDdupWkrDBsQWI7AdzpyOSkwYjNJbUsuCRwHBidQATAZ/Q0aAskZ/Q4ZsQEQDL4ODwECS4Sza8ByvIlJAQEUDbsQDwExWHRDwzlqVjQCUJGR7pCQAAQACQAAB7YEoQADABUAJwAxAClAEiswLi0kCQkxLn0qLQobEhICAwAvMzN8LzMYPzM/MzMvMxESOTkwMUEHITcTNz4CFx4CBwcOAicuAjcHBhYWFxY2Njc3NiYmJyYGBgEDIwEDIxMzARMHIxr91hoTBgpkomVhiUUHBwpjoWVgiUayCAQXPzg7VTQHCAQYPzc6VjP+6Mrk/omO7MvjAXiNAWGQkAGiSWSbVgICWZZfSWOZVQICV5WqSzJWNwECNVo2SjFWNwICNVkBCPtzAy380wSN/NMDLQAAAv/aAAAEtASNABgAHAAbQAsbHAIBAQ4MD30OCgA/PzMSOXwvMxjOMjAxQSU3BT4CNzYmJiclAyMTBR4CBw4DBwchNwK//UcfAp4+bUoICCVONf8AqevKAc9tuGoIBliLqlsf/TsfAZ0BsgEBL1hAOE8sAgH8MwSNAQNUonZikV8uTbKyAAAC//X/8wKFAyMAGQAzABlAChsAABkaGggQLCQALzPMMjkvMzMRMzAxUzM+Ajc2JiciBgcjPgIXHgIHDgIHIwc3Fx4CBw4CJy4CNTMWFhcyNjc2JiYn7kkiQS4GBzopKkMPtgdYhEhFgVQBAl2HPoEHD2JBe08BAmaWS0t+TK0BQTExWQkGHTcfAdACFS4mLCgBJihNZS8BAS1gTktYJgEoUgECIFJNVmoxAgE2a1AyLAE0NiUpEgEAAv/zAAACeQMVAAcACwAXQAkDBwcBAQYFCAoAL8wyMjkvMxEzMDFBByE3ATMDBwEDIxMCeRr9lAwBspzJzgG2ibKKATmUggHu/v/aAdv86wMVAAEAC//zApIDFQAhABK2HwkJBAMZEQAvM8wyOS8zMDFTJxMhByEHNjYzNhYWBw4CJy4CJxcWFjcyNjc2JiciBs+WeAHhGv62Oh5AIEtsOAMDWI1VR3xQA60ENS89SggGNjciOwFeJwGQkZwNDwE+cEpXf0QCATZnSwIuJwFMOzVBARUAAAEAFv/zAmwDJAAtABO2ExwcAwAMJAAvM8wyOX0vMzAxQTMHJyYGBgcHBhYWNz4CNzYmByIGBgcnPgIzMhYWBw4CJy4CNzc+AwIeIg4HWY5eDg8DDi4rJT0nBAc1MyE9MA0uCElrPUpnMgMDWI5TXX48BgQMUoewAySWAQM0dFt3JEMqAQElPCQzPgEXKx8jPl00RnVHVX9GAQJUj1o1a6RyOgAAAQAlAAACugMVAAYADLMFAQYCAC/MMjIwMUEHASMBJTcCuhT+R8gBvP5bGgMVcv1dAoIBkgAABAAF//MCggMiAA8AHwAvAD0AF0AKDCQ7AxQUNCwcBAAvM8wyOS8XMzAxZQ4CJy4CNz4CFx4CBzYmJiMiBgYHBhYWMzI2NhMOAiMuAjU0NjYXHgIHNiYmIyIGBwYWFjMyNgJTAl2OSkSBUgECYI5HQoBUrQQaMRsgOykFBBovHCA7KuACWYVCPXlQVoZGQ3hMtgQUJxoqRAcEFCgZK0ThVWkwAQEtYk1SZjABAS1ePR8oFBcuIh8pFBcwAXtMXywBKlhGT2cxAQEuX1caJhMyLBsmFDQAAAEANP/0AnwDIgAuABO2EhsbCiMBLQAvM8wyOXwvMzAxdxcWNjY3NzYmJiMiBgYHBhYWMzI2NjcXDgIjLgI3PgIXHgIHBw4DByd4ClKBVQ0UAwwpKSc7JQQDEy0jIDgrCjcJQ2Q6TWk1AwNYj1RddjQGBQpOga5qFoYBAitlVpohQCkrQyQhNx8WKh0hOVkzAUN0SVaFSwECWJFXNm2jbTcBAQAAAQCRAosDPAMxAAMACLEDAgAvMzAxQQchNwM8Hv1zHQMxpqYAAwEIBEwDWgaaAAMADwAbABlACRMNDQcBAwMZBwAvMzN8LxjNETMRMzAxQTcXBQUmNjcyFhUUBiMiJjcUFjMyNjc2JiciBgGix/H+7/7AAW9NR2dsTEhqYCAkJToFBiIjKTUF2MIBweRNagFiSUxpXksgMTclIDMBOgAEAAkAAAP7BI0AAwAHAAsADwAbQAwLCgoGDw4HfQMCBgoAPzMzPzMzEjkvMzAxZQchNxMDIxMBByE3AQchNwNUIv14IvPK7MsChCL9yyIC2CL9eSK/v78DzvtzBI3+Lb+/AdPAwAAE/4f+SQRLBFEAEgAkAFsAXwAzQBpdXwZyJSYYGA9AQUEuU1MPDwVKNw9yIQUHcgArMisyETkvOREzMxEzETMSOTkrMjAxUzc+AhceAgcHDgMnLgI3BwYWFhcWNjY3NzYmJiciBgYDFwYGBwYWFhcXHgIHDgMnLgM3PgI3Fw4CBwYeAjMWPgI3NiYmJycuAjc+AgEHITdaAgqQ1XNrt2wGAQhZiaRTaLhv8QMDLFEyN2VHCQMEK1A0OGZGLVwkPwcFHC8YrVulYgYFd7PBTjyXi1gDA2aXTjMlPyoHBidDTCAoaWdKCQgpRybBOXBJAQI+XgNcGf6MEALGFnunUwMCU550F1qLXS4CAlSciBY1TSoBAS1TOBY1TiwBLFT+tTgTOiweHgoBAQI5fWpiilUmAQEYO2hQWnxLEVsKLkIoKzYdDAEPJkEzLjASAgIBIk5DQF1DAomVlQAABAA7/+cEiQRSABUAKwAvADMAF0AMMAotBhwRC3InBgdyACsyKzI/PzAxUzc+AxceAwcHDgMnLgM3BwYeAhcWPgI3NzYuAicmDgIFEzMDAxMzE0QDDEV4sXhpiU0bBAcRTHqobWuOTxn5AgUDH0tDQWNILQsHBAgiSD1Ma0QmAcqp2sbFDLQQAfQVZtCtZgMDZaG7WDhfvptcAwNdl7dyFjJyZUEBAkBpdzY0LnVvSQMDSXmJKwIe/eL95AIc/eQAAgArAAAE6gWwABkALgAfQA8mCBsaGgIBAQ4MDwJyDggAPysyEjkvMzMRMz8wMUEhNwUyNjY3NiYmJyUDIxMFHgIHDgIPAjceAgcHBgYWFwcjJiY2Nzc2JiYC2v5iIQFMT4pbCwkrYEX+2dr1/QIKgMttCgl4tWMgezl2s1oPEQUDERoD8RsQBAYQCSJXAljGAS9nVUdiNAIB+xgFsAEDWrWKcZRZGDEUhAJSon91JE1HHhwhVFknckhoOwADACsAAAV2BbAAAwAJAA0AIEAQCggJAgwLCwcGBgIDAnICCAA/KxI5LzMzETM/PzAxQQMjEyEBITczAQMBNwECHf31/QRO/TL+oAXpAga8/qS2Ab0FsPpQBbD8wtoCZPpQAqS3/KUAAAMAFAAABEYGAAADAAkADQAcQA4LBwYGAgkGcgMAcgoCCgA/MysrEjkvMzMwMUEBIwkCISczAQMDNwECCv716wELAyf96f7gI98BWIH2rgFMBgD6AAYA/jr9ob8BoPvGAgWg/VsAAAMAKwAABWAFsAADAAkADQAaQA4GCwcIDAUCCQMCcgoCCAA/MysyEhc5MDFBAyMTIQEhNzMBAwE3AQId/fX9BDj9Df7OCmMCd8j+GeECJgWw+lAFsP0GdgKE+lAC32D8wQAAAwAUAAAEMwYYAAMACQANACBAEAwLCwcGBgIJBnIDAXIKAgoAPzMrKxI5LzMzETMwMUEBIwkCITUzAQMBNwECDv7x6wEPAxD9vP78fgGbfv60vAGbBhj56AYY/iL9wZ4BofvGAh95/WgAAAIACf//BBYEjQAZAB0AFkAJGxoPAgEOD30BAC8/MxEzETMyMDFhITcXFjY2Nzc2LgInJTcFHgMHBwYGBAMDIxMBhv7qI/p0pWQPCAgNNGVR/uEiAQJ3t3s2DAYUsP7ub8rsy78BAVukbzpHf2M7AwHAAQNWlcZzOaf7iwSO+3MEjQABADn/7QREBKAAJwARthkVEH4kAAUAL8wzP8wzMDFBNw4CJy4DNzc+AxceAhcjLgInJg4CBwcGHgIXFjY2AwzqFJjjgneqZiUMCg5clcl8gL1sCOoCLV1HUHZPMAkKBwMlVUxLckwBgwGFt1sDAlycx21Pc86cVgMCY7h/RmE0AwI9bIVFUTt/bUYCAy9hAAACAAn//wQABI0AGQAxAChAExwbKRkCAgEbJgEBJhsDDQwPfQ0ALz8zEhc5Ly8vETMSOTkRMzAxQSE3BT4CNzYmJicnAyMTBR4DBw4CBwMhNwU+Ajc2JiYnJzcFFx4CBw4DAkL+uxwBCTRlSAgIKU4vz6nsywGSS5R3RAUFaqFWs/56gQEMNWZJCggiSDH9HwEkKU58RQQFVYilAf2mAQEcQzo3PRsBAfwzBI0BAh9Gd1lieDsF/cW/AQIfRjs1QyICAaYBQQRAdFNihE8iAAP/mgAABAEEjQAEAAkADQAcQAwNAAYDDAwBBwN9BQEALzM/MxI5LxI5OTMwMUEBIwEzEwM3MxMDByE3AoD+E/kCkqZMtwSb+6sg/XkgA5P8bQSN+3MDq+L7cwGwtbUAAAEA6ARtAiwGKgAKAAqyBYAAAC8azTAxUzc+AjcXBgYHB+gUCC5JMn8jNgwXBG2EPXNjJlI6dEN6AAACAQQE0gN9BnwADwATABK1EhMKAA0FAC8zfNwy1hjNMDFBNw4CJy4CJxcGFhcyNicnMxcC06oHZpRKR4lbA6YCSDs9XaSHolEFsAJUYykCASxhUQI9NQE2R8HBAAL9JwS+/3YGiQAXABsAHUAMABUVBRkbGwkREQwFAC8zMxEzMy8zETMRMzAxQxcOAgcGJiYHBgYHJz4CMzIWFjc2Nic3Fwf6YgYnRzMqREQnJioLZgUqSDQpREYnJinzpMrVBZ4cLlM2AQEoJwMCNSAaLlU1JycDAjc60QHQAAIA3ATnBR0GigAGAAoAFLcIBwcFAYAEBgAvMxrNOTMvzTAxUyUXFwcnByUTMwHcAUGY77WCtAG/w+L/AATn9gH0AY2NmwEI/vgAAgAWBNsDoQZ/AAYACgAXQAkHQAgIAwaAAgQALzMazTkzLxrNMDFBFyMnByMlJRMjAwKz7rWCs94BQf6/aomkBdH2jo72rv74AQcAAAIA3AToBI8GxwAGABoAH0ANERIIQBoJCAgDBoACBAAvMxrNOTMRMzMaEMwyMDFBFwcnBwclBSc3PgI3NiYmIzceAwcGBgcCv+Slj8XOATcB5o0KFjovBQQrOhIQI1ZOMQICUzYF3vUBn54B93QBewIIGR0dFwVnAQ0iPDA+OwsAAgDbBOgDowbMAAYAHgAlQBAIBwcQGAxAFBMTHAwMBoAEAC8azTIRMzMRMxoQzTIyETMwMUEXBycHByUlFw4CBwYmJgcGBgcnPgIzMhYWNzY2Aq32pZLCzwFFARpZBiQ/LCVAPSUfJgtbBiQ/LSRAPyQgJgXS6QGOjQHq+hwoSC4BASYlAwItGhgnSTAmIwMDLQADAAkAAAQWBcQAAwAHAAsAG0AMAgoKCwsHAwMHfQYKAD8/My8RMxEzETMwMUEDIxMBAyMTIQchNwQWWOtY/pTK7MsDDCL9nCIFxP4JAff+yftzBI3AwAAAAgEEBNEDfAZ8AA8AEwAStRETAAoNBQAvM3zcMhjWzTAxQTcOAicuAicXBhYXMjYnNxcHAtOpBmaUSkeKWwKlAUg7PV3MlsDIBa8CVWIpAgEsYVECPTUBNknAAb8AAAIBBQTTA3UHBwAPACUAKEARGxwcESUSEhERCQ0FAAkJBRAAPzN8LzMRMxEzGC8zETMRMy8zMDFBNw4CJy4CJxcGFhcyNicjNz4CNzYmJiIjNx4DFQ4CBwLPpgZlkUpHiFoBowJIOjtdJaIHFUM4BAQgMC4LDSBiYUABMUgiBa8CU2IpAgErYFECPDMBNFN1AQUXHRUVCF8BCBw4MSoxFwYA//8AiQKJAvQFvAYHAeIAcwKY//8AZgKYAuwFrQYHAjsAcwKY//8AfgKLAwUFrQYHAjwAcwKY//8AiQKLAt8FvAYHAj0AcwKY//8AmAKYAy0FrQYHAj4AcwKY//8AeAKLAvUFugYHAj8AcwKY//8ApwKMAu8FugYHAkAAcwKYAAEAbP/oBT8FyAApABVAChoWEQNyJgAFCXIAK8wzK8wzMDFBNwYGBCcuBDc3NhI2NhceAhcnLgInJg4CBwcGHgMXFjY2A+nyG67++513s31HFg0HEnK4+Jmb2ncG9AQ2cV5qoXFFDQcIARtAalFjkWAB2QKd4HYDAlKOts1pOI0BBc53AwN94JcBV4ZPAwNdnLtZOT6NiG9GAgNJiAAAAQBr/+oFRgXIAC0AG0ANLSwsBRoWEQNyJgUJcgArMivMMxI5LzMwMUEDDgInLgQ3NzYSNjYXHgIXIy4CJyYOAgcHBh4DFxY2NjcTITcFE1c7u9Bdeb6IUh0OBRNyufublNh9C+4HP3NUa6V0Rg0GCQUlSXVUNGliKTb+4yEC4f3aUFsmAQJQi7fSbiiOAQjSeQMDbs+SUXZBAwNfoL1cKEWSh21BAgEOJSIBH7sAAgArAAAFFQWwABsAHwAStxwPEAJyAh0AAC8yMisyMjAxYSE3BTI+Ajc3Ni4CJyU3BR4DBwcGAgYEAwMjEwHg/rclASJzvpJbEAYNGFCRbf6yIwE7luSUPhAFFIjW/u9g/fX9xwFLirpwLGCzjFQDAcgBA3DC/I4tm/79vmcFsPpQBbAAAgBu/+gFaQXIABkAMQAQtyEUA3ItBwlyACsyKzIwMUEHDgQnLgQ3Nz4EFx4EBTc2LgMnJg4CBwcGHgMXFj4CBV0FD1GCrdN7drR+TBkMBQ9Tg63SeHa1f0sZ/vsGCAQfQm1RaKZ5SQ0GCAQfQm1Ra6Z3SAL1LXDXvY1PAwJVkLjOZy1v1ruNTwMCVI63zpMuP4yFbkMDA16dvFkuPo2IcEYCBF6gvwAAAwBt/wQFaQXIAAMAHQA1ABtADSUYA3IAAwMxCwlyAQIALzMrMjIRMysyMDFlAQcBAQcOBCcuBDc3PgQXHgQFNzYuAycmDgIHBwYeAxcWPgIDYwE+rP7JAp4ED1KArNV7d7V/ShkNBA9Tga3Tene1f0sY/vwFCAMeQm1Saqd3SQ4ECAMfQW5RbaZ2SML+yIYBNgK1I3HZvY5PAwJVkbjQaSJx2LyOTwMCVY650IokQI2Hb0QDA1+fvVwjP46JcUYCBF+hwAAAAQCrAAADMASNAAYAFUAJAwQEBQUGfQIKAD8/My8zETMwMUEDIxMFNyUDMMTql/6SJQI9BI37cwNqetDNAAABABwAAAQJBKIAIAAXQAoQEAwVfgMgIAISAD8zETM/MzMvMDFlByE3AT4CNzYmJicmBgYHBz4CFx4DBw4DBwUDySH8dB0CGipSPAgHJ0wxRWtFDOkLkt58TI5vPQcEO1ppMv7Gv7+lAZ8iTFo5NEUkAQI5ZUEBgbpiAgIoUH1WRXViVij5AAH/gf6hBBIEjQAfABpACwYAHh4DFg8FAgN9AD8zMy8zEjkvMzMwMUEBITchBwEeAgcOAycmJic3FhYXFjY2NzYmJicnAUQBf/3SIgNbGv5jaZBECAtxs+N9Zr9bRkWcUmm0eA4NQIheUwJfAW7Al/6CE4G4aILLjUkCATossysvAQJVnGpkfj0BAQAAAv/R/sQEHwSNAAcACwAWQAkGBAt9CgMHBwIALzMRMy8/MzMwMWUHITcBMwkDIwEEHyL71BQDO8j+8f4RAzD+/+sBAb/AngPw/oj9qwPN+jcFyQAAAf/Y/p0ETQSMACcAFkAJJAkJAhoTBQJ9AD8zLzMSOS8zMDFBJxMhByEDNjYXMh4CBw4DJyYmJzcWFhcWPgI3Ni4CJyYGBgErztwDFCT9r3Q2eD1nklgiCQtlo9B4asNZWDybUEyAYz0KBg4uUT0wUkMBahIDEMz+nx8ZAU+HrF54xZBMAQI9N680MQEBNF59SjVnUzQBARYyAAEAMf7EBFoEjQAGAA+1AQUFBn0DAC8/MxEzMDFBBwEjASU3BFoZ/Oj4Awz9QyIEjZH6yAUIAcAAAgEFBMwDgwbZAA8AJwApQBEREBAZISEVHRwcJRUVAAkNBQAvM80yMnwvMzMRMxEzGC8zMxEzMDFBNw4CJy4CJxcGFhcyNhMXDgIjBiYmBwYGByc+AjMyFhY3NjYCzacGZJJLR4dYAqUDRTs8XGNhBClINClERScmKQtnBilJNChFRicmKwWuAlVjLAIBLmNRAjw1ATUBZxsvVDUBKCcCAzUhHC5UNigmAgM1AAH/uP6aAQEAswADAAixAQAAL80wMWUDIxMBAV3sXrP95wIZAAUAO//wBp8EnwApAC0AMQA1ADkAMUAYODk5MX0WLS0XMAo1NDQmGwEGBiZ+ERsLAD8zPzMRMxESOS8zPzMzETM/MxEzMDFBBy4DJyYOAgcHBh4CFxY+AjcXDgInLgM3Nz4DMx4CAQchNxMDIxMBByE3AQchNwQmJyxaWlotUntWMwoHBwYoWEstWltZLgU+fn0+eaxpKQsHD16azn5BgoICEiH9eCH0yuzLAoQi/csiAtgi/XkiBI3DAgYIBgEBQG2KSDs8gG9HBAIDBQYBvwMHBgIDXZ3Jbjp40J9YAQgJ/DK/vwPO+3MEjf4tv78B08DAAAABAEX+sQQ9BKQAOwAUtwAVHx81Cyk1AC8vMxI5LzMyMDFFFj4CNzc2LgInJg4CBwYeAhcWPgI3Nw4CJy4DNz4DFx4DBwcOBCcmJic3FhYBUXGjbkEPJAcEJlRGRGlJKgcFCSlMPDlrWz8MZA6AzYRolFojCApVjLtweaxnJQ4fEEhwncp9S5BEQDFlkAJgocFf9jh4aUIDATtkeDsxa1w8AgIfPlk5CoDFbQMDU4uvX2rAk1QCA16fy2/Pbte/klICASEdsBUcAAH/AP5HATsAzgARAAqyDQYAAC/MMjAxdzMDDgInIiYnNxYWMzI2NjdP7CkPYaZ1I0MhIBcxGTRCJgfO/vVurGIBCgjCBgk0VC3///+p/qEEOgSNBAYCZygA////2v6dBE8EjAQGAmkCAP///8n+xAQXBI0EBgJo+AD//wATAAAEAASiBAYCZvcA//8ATf7EBHYEjQQGAmocAP//ACL/6AQ/BKMEBgKA1gD//wBW/+kEBwW6BAYAGvkA//8AMf6xBCkEpAQGAm7sAP//ADf/6QRCBccGBgAcAAD//wD4AAADfQSNBAYCZU0A////BP5HAdsEOgQGAJwAAP///wT+RwHbBDoGBgCcAAD//wAjAAABygQ6BgYAjQAA////fP5fAcoEOgYmAI0AAAEGAKTUCgALtgEEAgAAQ1YAKzQA//8AIwAAAcoEOgYGAI0AAAADAAn/5gPnBKEAAwAWADEAKUAUDyYmDSMjCRsvC3IEAAACEwl+AgoAPz8zEjkvMysyETkvMzMRMzAxQQMjExcHPgIXFhYXASc3NyYmJyYGBgM3FhYzMjY2NzYmJicnNzc2HgIHDgInJiYBc4PnguvgCm3Ci36/UP50ixXxHEUoR1gvQlUeRCY5VzYHCDZeNV4cX0uQc0AECHG8cz5zAu39EwLtAgKFx2wDA3hb/mYDe/wcIAEBS3T8/LYYHDZYNj9CGAEBngUCI0x6VXWvYQIBHgACAEz/6ARpBKMAFQArAA61HBF+JwYLAD8zPzMwMUEHDgMnLgM3Nz4DFx4DBzc2LgInJg4CBwcGHgIXFj4CBF4CD1uX0YR+rmgmDAIPXZjRg32uZyX6BgYIKVlMUXtWMwkFBgcqWU1Se1UxAlURetupXgMDY6fRcRN52addAwJjpdCRMjyCcUkDA0NzjEYxPIR0SwMDRHWOAAEAVgAABGEFsAAGABNACQEFBQYEcgMMcgArKzIRMzAxQQcBIwEhNwRhGf0G+AL6/VohBbCR+uEE8MAAAAMAEP/oBCUGAAAEABoALwAZQA4hFgdyKwsLcgQKcgAAcgArKysyKzIwMUEzAwcjAQcOAycuAzc3PgMXHgMHNzYuAicmDgIHBwYWFhcWPgIBG+zlRM4ECwMMSn2wdGeJTh0FCBBLeKhrcZJQGfgCBgYlUUc9Zk40Cx0EK15KS29LLAYA+tnZAi0WZMijYAMDYZq2WERdv51eAwNjn79yFjd4aUQCAixQZzi3Q3tPAgNAbYEAAAEANv/pA/YEUQAnABlADB0ZGRQHcgQEAAkLcgArMjIvKzIvMjAxZRY2Njc3DgInLgM3Nz4DFx4CByM0JiYnJg4CBwcGHgIB4zxiRg/dDozOcXOlZCgLBQ1YkMN4eKxcAdsmUD9KbUssCAQGBCNQqgIvVjgCdaxdAgNal8FoJHDImFUDA2q2dTlhPQIDPmmAPyM2eWpEAAMAN//oBJkGAAAEABoALwAZQA0hBAQWC3IrCwdyAQByACsrMisyLzIwMWUTMwEjATc+AxceAwcHDgMnLgM3BwYeAhcWNjY3NzYuAicmDgICzOHs/vXK/XwDDEt/s3Noh00cBAgQTXmna2yRUxz5AwYHJ1FET35UERwDFDFQOEtwTS7uBRL6AAIJFmXKpGADA2Sdt1dEXbycXAMEY6C8chU2d2pEAwNNf0i3MmJQMgEDQG2CAAMALf5SBEoEUQATACkAPgAbQA8wJQtyOhoHcg4GD3IABnIAKysyKzIrMjAxQTMDDgMnJiYnNxYWFxY2NjcTATc+AxceAwcHDgMnLgM3BwYeAhcWNjY3NzYuAicmDgIDfc2rEViOwHhVpEpAOH9CZIlRDoT9CwIMS32zdWqJSxsFCBFMeahrbJFSHPkDBgcnUURRfFQQHQMTMlA5S29NLgQ6/BZyvIhIAgEwKawiKAEDUo9eAwj+txZmyaJgAwJim7haQ169m1wDA2WgvHEWNXdqRAIETX5JtzNjTzECAkBtggACADL/6QQ0BFEAFQArABC3HBELcicGB3IAKzIrMjAxUzc+AxceAwcHDgMnLgM3BwYeAhcWPgI3NzYuAicmDgI8Aw1dlsh5c6lsLAoDDl6XyHhxqWws+AMGCipXRkpzUjEJAwUILFZGS3NRMQIKF3HMnFcDAluawmoYccqZVgMCWpjBgBc4emlDAgM/a4JBFjh7a0UCAkBtgwAAA//I/mAEJARSAAQAGgAvABlADiEWB3IrCwtyAwZyAg5yACsrKzIrMjAxQQMjATMBBw4DJy4DNzc+AxceAwc3Ni4CJyYOAgcHBhYWFxY+AgGS3uwBBNICfAMMSn2xc2WJUyAEChBNeqlsb5JQGvkDBggnU0U9Z000DB8DLV5ISnBOLgNc+wQF2v3zFWTIo2EDA12VslhRXr6eXQMDY6C+cRU2eGpEAgMtUGY4xEJ3SwMCQm6CAAADADb+YARKBFIABAAaAC8AGUAOIRYLcisLB3IEDnIDBnIAKysrMisyMDFBEzczAQE3PgMXHgMHBw4DJy4DNwcGHgIXFjY2Nzc2LgInJg4CAlnhQc/+/Pz6AwxKf7R1aIlOHAQIEE17qGttklQc+gMGBydSRVB/VBEdAxQyUTlLcU4u/mAFEcn6JgOpFmbKo2ADA2OduFdEXr2bWwMDY5+9chU2eGpGAwJNgEq3M2NRMQICQW6DAAEAOv/sA/UEUQAqABlADBMSEgAZCwdyJAALcgArMisyETkvMzAxRS4DNzc+AxceAwcHITcFNzYmJicmDgIHBwYeAhcWNjcXBgYCBHKwdTMJBA1Xj8B1bZtdIQwU/NQfAj0FCxxRRkpsSSoIBQgVPGZKTJJCKUrDEwFTkcBtK23Hm1gDAlOMtGV/rQEdQGxDAwI/a4A+KkJ5XzgCASwmpzsvAAMALv5SBDkEUQASACgAPQAbQA8vJAtyORkHcg0GD3IABnIAKysyKzIrMjAxQTMDDgInJiYnNxYWFxY2NjcTATc+AxceAwcHDgMnLgM3BwYeAhcWNjY3NzYuAicmDgIDa86tFpDqnU+cRkA1dT1hiVIOhv0dAwxFdq10a4lLGgUIEEx5p2tsjEsW+AIGAh9LQ1F7UBEdAxMvTzlLakYnBDr8C5fiegIBKSStHiEBAkyKXAMU/rYWZMilYQIDYZy4WkRdvJxcAwRlobxuFTN2a0YCBE1/SLczYlAxAgJCboEAAv+f/k8EZwRIAAMAJQAZQAwOFQEBFR8EB3IDBnIAKysyLzMvETMwMUEBIwElHgMXEx4CFxY2NwcGBicuAycDLgInJgYHNzY2BGf8M/sDzf2MP1g+KxDuBxclHxMoEzQYLxg6UTYjDuEKIjcpECIQDB49BDr6JgXaDQEsSmA0/GYaOiwGAwEBwQYFAgI6WWcvA3UjQisBAQMBuQcJAP//AKsAAAMzBbUEBgAVugAAAQAk/+0ESQSfAEEAF0ALODgQIn4ZCjMAC3IAKzI/PzM5LzAxRS4DNz4CNyU2Njc2JgciBgcGFhYXASMBLgI3PgIXHgIHDgIHBQ4CBwYWFhcWPgI3NwYGBwYGBwYGAZhChW4/BARCZToBHyNIBwU7KzNQCAYgMxQCF/L+QSZFKwQGaaBWT41VBQM1Ui/+xhktIAUHKUgpXZ96Tg3LDWtZDh4QVuARASNHbk1KblcksxhCLy00AUMyJUM8Gv1PAkQwYmxBXX9AAQI/eVg7YE4exxEpMyAvOhoBBD1wl1kBfsxXDhwLRj4AAAP/7wAAAz0EjQADAAcACwAdQA0ICQkLCgoGB30DAgYKAD8zMz8SOS8zMy8zMDFlByE3EwMjEwEHBTcDPSL9myLzyuvKAagb/YIbv7+/A877cwSN/qWZupgAAAb/fgAABg8EjQADAAcACwAQABQAGAAzQBgKCwsYGA8HBhQTBhMGEw0PfQMCAhcXDQoAPzMRMxEzPxI5OS8vETMRMxEzETMRMzAxZQchNwEHITcBByE3BwEhATMTByE3AQMjEwWQIv2WIQJdIf3gIgKsIf2VInH9Vf71AySjLiL9miEC+KHpob6+vgIAvr4Bz76+f/vyBI39N7y8Asn7cwSNAAIACQAAA7wEjQADABkAF0AKDxAQAX0FBAQACgA/Mi8zPzMvMzAxcxMzAyc3FzI2Njc2JiYnJzcXHgIHDgIjCcvryiki2T1wTQkIKlM18iPUb7ttCAmT3nsEjftz5MEBKFNDOk4pAgHAAQNTonmGq1AAAAP/2//HBLsEuwAVACsALwAbQAsvLxwRfi0tJwYLcgArMjJ8Lxg/MzN8LzAxQQcOAycuAzc3PgMXHgMHNzYuAicmDgIHBwYeAhcWPgIBASMBBEwGDl6Yz355rWspCwcOX5nOfnitair9BwYHK1lMUXlUMgkHBwcrWkxSelQwAWn7y6sENQJpOXfToFkDAl6eym46d9GgWAIDXZ/Ipjs9gG1FAwNAb4lGOz2BcUgDAkJxiwLR+wwE9AAEACIAAAT+BI0AAwAHAAsADwAbQAwCA4AODw8LB30KBgoAPzM/MzMvMxrMMjAxQQchNxMDIxMhAyMTBQchNwPAIv1+IprK7MsD1MvqygEoHvt9HgKdwMAB8PtzBI37cwSNlqenAAACAAn+RwSoBI0ACQAbAB9ADxcQD3IJAwZ9CAoKAgIFCgA/MxEzETM/MzMrMjAxQQMjAQMjEzMBEwMzBw4CJyYmJzcWFjMyNjY3BKjK5P6JjuzL4wF4jb3rEg5jpnYjQyIjGDAYNEMmCASN+3MDLfzTBI380wMt+7iBcKxhAQEKCcAGCTRTLgD//wBAAg4CZQLOBgYAEQAAAAMAIAAABPcFsAAaAB4AIgAjQBECAQEdIiEhHQ4PDx4Cch0IcgArKzIRMxE5LzMRMxEzMDFhITcFMjY2Nzc2LgInJTcFHgMHBw4CBAMDIxMBByE3Ae7+wyUBH5PPexUKCws+fGf+tSMBL5LVhjMQChV8xP7/UP32/QGKHv1zHccChuCHUFWpjVcDAcgBA3G/9odOk/26ZwWw+lAFsP2EpqYAAAMAIAAABPcFsAAaAB4AIgAjQBECAQEdIiEhHQ4PDx4Cch0IcgArKzIRMxE5LzMRMxEzMDFhITcFMjY2Nzc2LgInJTcFHgMHBw4CBAMDIxMBByE3Ae7+wyUBH5PPexUKCws+fGf+tSMBL5LVhjMQChV8xP7/UP32/QGKHv1zHccChuCHUFWpjVcDAcgBA3G/9odOk/26ZwWw+lAFsP2EpqYAAAMAKwAABBAGAAADABoAHgAZQA0eHRYKB3IDAHIRAgpyACsyKysyxDIwMUEBIwETIz4DFx4DBwMjEzYmJicmDgIBByE3AiH+9esBCx9KDUV2pm1Zd0QWCXTtdgYUREFGa0suAa0d/XMdBgD6AAYA/EVeu5laAwJCcZFR/UkCujteOQECOGB2Au6mpgAAAwCdAAAFJQWwAAMABwALABVACgMKCwYHAnIBCHIAKysyLzMyMDFBAyMTIQchNwEHITcDavz0/QKuI/ubIwMbHv1zHgWw+lAFsMjI/gimpgAD/+X/7QKuBUMAAwAVABkAHUAOChELchgZGQICBAQDBnIAKzIvMhEzLzMrMjAxQQchNxMzAwYWFhcWNjcHBgYnLgI3AQchNwKuH/2wHtnrswQJJScVKxYRJEsmWm4sCAINHv1zHgQ6sLABCfvmIzQdAQEGA7oLCgEBUYhUAcGmpgD///+jAAAEqwc3BiYAJQAAAQcARAFUATcAC7YDEAcBAWFWACs0AP///6MAAATDBzcGJgAlAAABBwB1AfYBNwALtgMOAwEBYVYAKzQA////owAABKsHNwYmACUAAAEHAJ4A8gE3AAu2AxEHAQFsVgArNAD///+jAAAExQcqBiYAJQAAAQcApQEBATcAC7YDHAMBAWtWACs0AP///6MAAASrBwYGJgAlAAABBwBqAR4BNwANtwQDIwcBAXhWACs0NAD///+jAAAEqweSBiYAJQAAAQcAowGNAWwADbcEAxkHAQFHVgArNDQA////owAABNgHsQYmACUAAAEHAkIBfgEXABK2BQQDGwcBALj/srBWACs0NDT//wBf/jcFCgXHBiYAJwAAAQcAeQG8//oAC7YBKAUAAApWACs0AP//ACYAAAS8Bz4GJgApAAABBwBEASEBPgALtgQSBwEBbFYAKzQA//8AJgAABLwHPgYmACkAAAEHAHUBwwE+AAu2BBAHAQFsVgArNAD//wAmAAAEvAc+BiYAKQAAAQcAngC/AT4AC7YEEwcBAXdWACs0AP//ACYAAAS8Bw0GJgApAAABBwBqAOsBPgANtwUEJQcBAYNWACs0NAD//wA3AAACMgc+BiYALQAAAQcARP/ZAT4AC7YBBgMBAWxWACs0AP//ADcAAANIBz4GJgAtAAABBwB1AHsBPgALtgEEAwEBbFYAKzQA//8ANwAAAxcHPgYmAC0AAAEHAJ7/dwE+AAu2AQcDAQF3VgArNAD//wA3AAADMAcNBiYALQAAAQcAav+jAT4ADbcCARkDAQGDVgArNDQA//8AJgAABYYHKgYmADIAAAEHAKUBLAE3AAu2ARgGAQFrVgArNAD//wBi/+kFIgc4BiYAMwAAAQcARAFsATgAC7YCLhEBAU9WACs0AP//AGL/6QUiBzgGJgAzAAABBwB1Ag0BOAALtgIsEQEBT1YAKzQA//8AYv/pBSIHOAYmADMAAAEHAJ4BCgE4AAu2Ai8RAQFaVgArNAD//wBi/+kFIgcsBiYAMwAAAQcApQEYATkAC7YCOhEBAVlWACs0AP//AGL/6QUiBwcGJgAzAAABBwBqATUBOAANtwMCQREBAWZWACs0NAD//wBY/+gFMQc3BiYAOQAAAQcARAFJATcAC7YBGAABAWFWACs0AP//AFj/6AUxBzcGJgA5AAABBwB1AeoBNwALtgEWCwEBYVYAKzQA//8AWP/oBTEHNwYmADkAAAEHAJ4A5gE3AAu2ARkAAQFsVgArNAD//wBY/+gFMQcGBiYAOQAAAQcAagESATcADbcCASsAAQF4VgArNDQA//8AoQAABVAHNgYmAD0AAAEHAHUBwQE2AAu2AQkCAQFgVgArNAD//wAc/+kD0QYABiYARQAAAQcARACsAAAAC7YCPQ8BAYxWACs0AP//ABz/6QQbBgAGJgBFAAABBwB1AU4AAAALtgI7DwEBjFYAKzQA//8AHP/pA+sGAAYmAEUAAAEGAJ5LAAALtgI+DwEBl1YAKzQA//8AHP/pBB0F9AYmAEUAAAEGAKVZAQALtgJJDwEBllYAKzQA//8AHP/pBAQFzwYmAEUAAAEGAGp3AAANtwMCUA8BAaNWACs0NAD//wAc/+kD0QZbBiYARQAAAQcAowDmADUADbcDAkYPAQFyVgArNDQA//8AHP/pBDAGegYmAEUAAAEHAkIA1v/gABK2BAMCSA8AALj/3bBWACs0NDT//wA3/jcD5gRRBiYARwAAAQcAeQFB//oAC7YBKAkAAApWACs0AP//ADr/6wPwBgAGJgBJAAABBwBEAJYAAAALtgEuCwEBjFYAKzQA//8AOv/rBAUGAAYmAEkAAAEHAHUBOAAAAAu2ASwLAQGMVgArNAD//wA6/+sD8AYABiYASQAAAQYAnjQAAAu2AS8LAQGXVgArNAD//wA6/+sD8AXPBiYASQAAAQYAamAAAA23AgFBCwEBo1YAKzQ0AP//ACMAAAHkBfcGJgCNAAABBgBEi/cAC7YBBgMBAZ5WACs0AP//ACMAAAL6BfcGJgCNAAABBgB1LfcAC7YBBAMBAZ5WACs0AP//ACMAAALIBfcGJgCNAAABBwCe/yj/9wALtgEHAwEBqVYAKzQA//8AIwAAAuIFxgYmAI0AAAEHAGr/Vf/3AA23AgEZAwEBtVYAKzQ0AP//AA0AAAQnBfQGJgBSAAABBgClYwEAC7YCKgMBAapWACs0AP//ADj/6QQeBgAGJgBTAAABBwBEAKsAAAALtgIuBgEBjFYAKzQA//8AOP/pBB4GAAYmAFMAAAEHAHUBTQAAAAu2AiwGAQGMVgArNAD//wA4/+kEHgYABiYAUwAAAQYAnkkAAAu2Ai8GAQGXVgArNAD//wA4/+kEHgX0BiYAUwAAAQYApVgBAAu2AjoGAQGWVgArNAD//wA4/+kEHgXPBiYAUwAAAQYAanUAAA23AwJBBgEBo1YAKzQ0AP//AEr/6AQvBgAGJgBZAAABBwBEALIAAAALtgIeEQEBoFYAKzQA//8ASv/oBC8GAAYmAFkAAAEHAHUBVAAAAAu2AhwRAQGgVgArNAD//wBK/+gELwYABiYAWQAAAQYAnlAAAAu2Ah8RAQGrVgArNAD//wBK/+gELwXPBiYAWQAAAQYAanwAAA23AwIxEQEBt1YAKzQ0AP///7z+RwQZBgAGJgBdAAABBwB1AR4AAAALtgIZAQEBoFYAKzQA////vP5HBBkFzwYmAF0AAAEGAGpHAAANtwMCLgEBAbdWACs0NAD///+jAAAEqwbjBiYAJQAAAQcAcAD5ATkAC7YDEAMBAaZWACs0AP//ABz/6QQDBa0GJgBFAAABBgBwUgMAC7YCPQ8BAdFWACs0AP///6MAAASrBx8GJgAlAAABBwChASoBNwALtgMTBwEBU1YAKzQA//8AHP/pA/UF6AYmAEUAAAEHAKEAgwAAAAu2AkAPAQF+VgArNAAABP+j/lUEqwWwAAQACQANACMAK0AVDQwMAxYdBgACBwMCcg4PDwUFAghyACsyETMRMysyEjk5LzMSOS8zMDFBASEBMxMDNzMBAwchNwEXDgIHBhYXMjY3FwYGIyImNz4CAyj9hf72AxCrVM4PnwEZsiP8/iMDBXUjUj4GAxgeFy0VDCJOKFZpAgFOdgTh+x8FsPpQBPy0+lACHMfH/h89GTpKLx0gAQ4JjRUUaVdKcFAAAAMAHP5VA9EEUAAbADoAUAArQBceOjoPQ0oPcicxC3I7PDwZCnIJBQ8HcgArMjIrMhEzKzIrMhI5LzMwMWUTNiYmJyYGBgcHPgMXHgIHAwYGFwcHJjQTByciDgIHBhYWFxY2NjcXDgMnLgI3PgMzExcOAgcGFhcyNjcXBgYjIiY3PgICiFIGGkU4Mlg9CusGWYmfTG6qWQtPCQcTAukPdRicMGVYPAcFH0AsO3NVED8WT2h7QVqUVgUFYZm2Wad1I1I+BgMYHhctFA0iTilVaQECTnXZAgc0VDEBASNEMQFVf1MnAQJapHT+Hjl3NxIBNW8B75UBEixLOC1BJgEBMFk6bD1mSigBAk+OXWmNUyT9qD0ZOkovHSABDgmNFRRpV0pwUP//AF//6AUKB0sGJgAnAAABBwB1AfwBSwALtgEoEAEBbVYAKzQA//8AN//qA/IGAAYmAEcAAAEHAHUBJQAAAAu2ASgUAQGMVgArNAD//wBf/+gFCgdLBiYAJwAAAQcAngD4AUsAC7YBKxABAXhWACs0AP//ADf/6gPmBgAGJgBHAAABBgCeIgAAC7YBKxQBAZdWACs0AP//AF//6AUKByoGJgAnAAABBwCiAdcBUwALtgExEAEBglYAKzQA//8AN//qA+YF3wYmAEcAAAEHAKIBAAAIAAu2ATEUAQGhVgArNAD//wBf/+gFCgdOBiYAJwAAAQcAnwEOAUsAC7YBLhABAXZWACs0AP//ADf/6gP0BgMGJgBHAAABBgCfNwAAC7YBLhQBAZVWACs0AP//ACYAAATZB0EGJgAoAAABBwCfAJUBPgALtgIlHgEBdVYAKzQA//8AOP/oBc8GAgQmAEgAAAEHAdUEwwUCAAu2AzkBAQAAVgArNAD//wAmAAAEvAbqBiYAKQAAAQcAcADGAUAAC7YEEgcBAbFWACs0AP//ADr/6wPwBa0GJgBJAAABBgBwOwMAC7YBLgsBAdFWACs0AP//ACYAAAS8ByYGJgApAAABBwChAPgBPgALtgQVBwEBXlYAKzQA//8AOv/rA/AF6AYmAEkAAAEGAKFsAAALtgExCwEBflYAKzQA//8AJgAABLwHHQYmACkAAAEHAKIBngFGAAu2BBkHAQGBVgArNAD//wA6/+sD8AXgBiYASQAAAQcAogETAAkAC7YBNQsBAaFWACs0AAAFACb+VQS8BbAAAwAHAAsADwAlAClAFAoLCxgfDg8PBwJyEBERAwICBghyACsyETMyETMrMhEzLzM5LzMwMWUHITcBAyMTAQchNwEHITcBFw4CBwYWFzI2NxcGBiMiJjc+AgPoI/0RIgEh/fb9AtMi/XIjA1Mj/RYkAQt1JFE+BgMYHhctFAwiTShWaQIBTnXHx8cE6fpQBbD9oMTEAmDIyPqLPRk6Si8dIAEOCY0VFGlXSnBQAAIAOv5yA/AEUQArAEEAJUATEhMTCzQ7DnIZCwdyLC0kJAALcgArMhE5OSsyKzISOS8zMDFFLgM3Nz4DFx4DBwchNwU3NiYmJyYOAgcHBh4CFxY2NxcOAjcXDgIHBhYXMjY3FwYGIyYmNz4CAfZvq3AyCAQLVI3AdnGcXB8LDvzUHAI9BAkfUkVLa0YnCAQGEjRcRFWLOXQuh50YdCNSPgYDGB4XLRUMIk4oVmkCAU52FAJTj7tqKW3Ln1wDAlqVvGVnrQEVP3BIAgJCcIM+KDt0XzsCAks8e0VaK209GDpKMB0gAQ8IjBYUAWlWSnBQ//8AJgAABLwHQQYmACkAAAEHAJ8A1QE+AAu2BBYHAQF1VgArNAD//wA6/+sEBwYDBiYASQAAAQYAn0oAAAu2ATILAQGVVgArNAD//wBm/+sFFwdLBiYAKwAAAQcAngD6AUsAC7YBLxABAXhWACs0AP////n+UQRCBgAGJgBLAAABBgCeQQAAC7YDQhoBAZdWACs0AP//AGb/6wUXBzMGJgArAAABBwChATIBSwALtgExEAEBX1YAKzQA////+f5RBEIF6AYmAEsAAAEGAKF6AAALtgNEGgEBflYAKzQA//8AZv/rBRcHKgYmACsAAAEHAKIB2AFTAAu2ATUQAQGCVgArNAD////5/lEEQgXfBCYASwAAAQcAogEhAAgAC7YDSBoBAaFWACs0AP//AGb99gUXBccGJgArAAABBwHVAZj+kgAOtAE1BQEBuP+YsFYAKzT////5/lEEQgamBCYASwAAAQcCTwE8AHwAC7YDPxoBAZhWACs0AP//ACYAAAWFBz4GJgAsAAABBwCeARYBPgALtgMPCwEBd1YAKzQA//8ADQAAA/YHXwYmAEwAAAEHAJ4AVgFfAAu2Ah4DAQEmVgArNAD//wA3AAADSQcxBiYALQAAAQcApf+FAT4AC7YBEgMBAXZWACs0AP//ABMAAAL7BesGJgCNAAABBwCl/zf/+AALtgESAwEBqFYAKzQA//8ANwAAAy4G6gYmAC0AAAEHAHD/fQFAAAu2AQYDAQGxVgArNAD//wAjAAAC4AWkBiYAjQAAAQcAcP8v//oAC7YBBgMBAeNWACs0AP//ADcAAAMhByYGJgAtAAABBwCh/68BPgALtgEJAwEBXlYAKzQA//8AIwAAAtMF3wYmAI0AAAEHAKH/Yf/3AAu2AQkDAQGQVgArNAD///+O/lsCKQWwBiYALQAAAQYApOYGAAu2AQUCAAAAVgArNAD///91/lUCCgXYBiYATQAAAQYApM0AAAu2AhECAAAAVgArNAD//wA3AAACVgcdBiYALQAAAQcAogBWAUYAC7YBDQMBAYFWACs0AP//ADf/6AaPBbAEJgAtAAAABwAuAjIAAP//ACD+RgP7BdgEJgBNAAAABwBOAfoAAP//AAT/6AU6BzUGJgAuAAABBwCeAZoBNQALtgEXAQEBalYAKzQA////BP5HAscF3gYmAJwAAAEHAJ7/J//eAAu2ARUAAQGCVgArNAD//wAm/kkFcgWwBCYALwAAAQcB1QFe/uUADrQDFwIBALj/57BWACs0//8AEf40BE4GAAYmAE8AAAEHAdUA9P7QAA60AxcCAQG4/9SwVgArNP//ACYAAAPABzMGJgAwAAABBwB1AGwBMwALtgIIBwEBXFYAKzQA//8AIAAAAzkHkAYmAFAAAAEHAHUAbAGQAAu2AQQDAQFxVgArNAD//wAm/gYDwAWwBCYAMAAAAQcB1QEo/qIADrQCEQIBAbj/l7BWACs0////pv4GAhYGAAQmAFAAAAEHAdX/1f6iAA60AQ0CAQG4/5ewVgArNP//ACYAAAPXBbEGJgAwAAABBwHVAssEsQALtgIRBwAAAVYAKzQA//8AIAAAA2oGAgQmAFAAAAEHAdUCXgUCAAu2AQ0DAAACVgArNAD//wAmAAADwAWwBiYAMAAAAAcAogFe/dD//wAgAAAC9AYABCYAUAAAAAcAogD0/a3//wAmAAAFhgc3BiYAMgAAAQcAdQIgATcAC7YBCgYBAWFWACs0AP//AA0AAAQlBgAGJgBSAAABBwB1AVgAAAALtgIcAwEBoFYAKzQA//8AJv4CBYYFsAQmADIAAAEHAdUBlf6eAA60ARMFAQG4/5ewVgArNP//AA3+BgPyBFEEJgBSAAABBwHVAQD+ogAOtAIlAgEBuP+XsFYAKzT//wAmAAAFhgc6BiYAMgAAAQcAnwEyATcAC7YBEAkBAWpWACs0AP//AA0AAAQnBgMGJgBSAAABBgCfagAAC7YCIgMBAalWACs0AP//AA0AAAPyBgMGJgBSAAABBwHVAD8FAwALtgIgAwEBOlYAKzQA//8AYv/pBSIG5QYmADMAAAEHAHABEAE7AAu2Ai4RAQGUVgArNAD//wA4/+kEHgWtBiYAUwAAAQYAcFADAAu2Ai4GAQHRVgArNAD//wBi/+kFIgcgBiYAMwAAAQcAoQFBATgAC7YCMREBAUFWACs0AP//ADj/6QQeBegGJgBTAAABBwChAIIAAAALtgIxBgEBflYAKzQA//8AYv/pBXYHNwYmADMAAAEHAKYBiwE4AA23AwIsEQEBRVYAKzQ0AP//ADj/6QS1Bf8GJgBTAAABBwCmAMoAAAANtwMCLAYBAYJWACs0NAD//wAmAAAE1Qc3BiYANgAAAQcAdQGqATcAC7YCHgABAWFWACs0AP//ABEAAAOFBgAGJgBWAAABBwB1ALgAAAALtgIXAwEBoFYAKzQA//8AJv4GBNUFsAQmADYAAAEHAdUBKf6iAA60AicYAQG4/5ewVgArNP///5/+BwLyBFMEJgBWAAABBwHV/87+owAOtAIgAgEBuP+YsFYAKzT//wAmAAAE1Qc6BiYANgAAAQcAnwC8ATcAC7YCJAABAWpWACs0AP//ABEAAAOHBgMGJgBWAAABBgCfygAAC7YCHQMBAalWACs0AP//ACb/6gS9BzgGJgA3AAABBwB1AcsBOAALtgE6DwEBT1YAKzQA//8AG//rA/oGAAYmAFcAAAEHAHUBLQAAAAu2ATYOAQGMVgArNAD//wAm/+oEvQc4BiYANwAAAQcAngDHATgAC7YBPQ8BAVpWACs0AP//ABv/6wPKBgAGJgBXAAABBgCeKgAAC7YBOQ4BAZdWACs0AP//ACb+PAS9BcYGJgA3AAABBwB5AZP//wALtgE6KwAAE1YAKzQA//8AG/4zA8EETwYmAFcAAAEHAHkBPf/2AAu2ATYpAAAKVgArNAD//wAm/fsEvQXGBiYANwAAAQcB1QFE/pcADrQBQysBAbj/oLBWACs0//8AG/3yA8EETwYmAFcAAAEHAdUA7f6OAA60AT8pAQG4/5ewVgArNP//ACb/6gS9BzsGJgA3AAABBwCfANwBOAALtgFADwEBWFYAKzQA//8AG//rA/wGAwYmAFcAAAEGAJ8/AAALtgE8DgEBlVYAKzQA//8Anf4ABSUFsAYmADgAAAEHAdUBM/6cAA60AhECAQG4/42wVgArNP//AD/9/AKuBUMGJgBYAAABBwHVAIL+mAAOtAIfEQEBuP+hsFYAKzT//wCd/kEFJQWwBiYAOAAAAQcAeQGDAAQAC7YCCAIBAABWACs0AP//AD/+PQKuBUMGJgBYAAABBwB5ANMAAAALtgIWEQAAFFYAKzQA//8AnQAABSUHOQYmADgAAAEHAJ8AzQE2AAu2Ag4DAQFpVgArNAD//wA//+0DvwZ+BCYAWAAAAQcB1QKzBX4ADrQCGgQBALj/qLBWACs0//8AWP/oBTEHKgYmADkAAAEHAKUA9AE3AAu2ASQLAQFrVgArNAD//wBK/+gELwX0BiYAWQAAAQYApV8BAAu2AioRAQGqVgArNAD//wBY/+gFMQbjBiYAOQAAAQcAcADtATkAC7YBGAsBAaZWACs0AP//AEr/6AQvBa0GJgBZAAABBgBwVwMAC7YCHhEBAeVWACs0AP//AFj/6AUxBx8GJgA5AAABBwChAR4BNwALtgEbAAEBU1YAKzQA//8ASv/oBC8F6AYmAFkAAAEHAKEAiAAAAAu2AiERAQGSVgArNAD//wBY/+gFMQeSBiYAOQAAAQcAowGBAWwADbcCASEAAQFHVgArNDQA//8ASv/oBC8GWwYmAFkAAAEHAKMA6wA1AA23AwInEQEBhlYAKzQ0AP//AFj/6AVTBzYGJgA5AAABBwCmAWgBNwANtwIBFgABAVdWACs0NAD//wBK/+gEvAX/BiYAWQAAAQcApgDRAAAADbcDAhwRAQGWVgArNDQAAAIAWP6MBTEFsAAVACsAG0ANHiUBCwJyFxYREQYJcgArMhI5OSsyLzMwMUEzAw4CJy4CNxMzAwYWFhcWNjY3AxcOAgcGFhcyNjcXBgYjJiY3PgIEPPWmF6X/npXaaxKm9KUKJmpbYY9YDrF1I1M9BQQYHhcsFQ0jTShWaQIBTnUFsPw1neZ6AwN94ZcDzfwyVIdSAgNLjFz+kD0ZOkovHSABDgmNFRUBaVZLb1EAAAMASv5VBC8EOgAEABsAMQAhQBEkKw9yAREGchwdHQQEGAsLcgArMjIRMxEzKzIrMjAxQRMzAyMTNw4DJy4DNxMzAwYeAhcWNjYDFw4CBwYWFzI2NxcGBiMiJjc+AgK2jey83mNODEBupG9ZeUYXCHXrdgMGHDctYIFLAnUjUj8FBBkdFy0VDSNNKVZoAQFPdQELAy/7xgHgA2K3kFIDA0FwkFACu/1CJ0g6IwIDUY7+sT0ZOkovHSABDgmNFRRpV0pwUP//ALUAAAc6BzcGJgA7AAABBwCeAcEBNwALtgQZFQEBbFYAKzQA//8AeQAABfQGAAYmAFsAAAEHAJ4BBAAAAAu2BBkVAQGrVgArNAD//wChAAAFUAc2BiYAPQAAAQcAngC9ATYAC7YBDAIBAWtWACs0AP///7z+RwQZBgAGJgBdAAABBgCeGwAAC7YCHAEBAatWACs0AP//AKEAAAVQBwUGJgA9AAABBwBqAOkBNgANtwIBHgIBAXdWACs0NAD////lAAAE6wc3BiYAPgAAAQcAdQG9ATcAC7YDDg0BAWFWACs0AP///+YAAAPvBgAGJgBeAAABBwB1ASIAAAALtgMODQEBoFYAKzQA////5QAABOsHFgYmAD4AAAEHAKIBmAE/AAu2AxcIAQF2VgArNAD////mAAAD5AXfBiYAXgAAAQcAogD9AAgAC7YDFwgBAbVWACs0AP///+UAAATrBzoGJgA+AAABBwCfAM8BNwALtgMUCAEBalYAKzQA////5gAAA/EGAwYmAF4AAAEGAJ80AAALtgMUCAEBqVYAKzQA////jQAAB28HQgYmAIEAAAEHAHUC8AFCAAu2BhkDAQFsVgArNAD//wAO/+oGXwYBBiYAhgAAAQcAdQJuAAEAC7YDXw8BAY1WACs0AP//ABb/ogWQB4AGJgCDAAABBwB1AiMBgAALtgM0FgEBllYAKzQA//8AKv91BDAF/QYmAIkAAAEHAHUBNP/9AAu2AzAKAQGLVgArNAD///+W//8EFgSNBiYCSwAAAAcCQf8F/2v///+W//8EFgSNBiYCSwAAAAcCQf8F/2v//wBjAAAEXgSNBiYB8wAAAAYCQSW6////mgAABAEGHgYmAk4AAAEHAEQAywAeAAu2AxAHAQFrVgArNAD///+aAAAEOgYeBiYCTgAAAQcAdQFtAB4AC7YDDgMBAWtWACs0AP///5oAAAQJBh4GJgJOAAABBgCeaR4AC7YDEwMBAWtWACs0AP///5oAAAQ7BhIGJgJOAAABBgCldx8AC7YDGwMBAWtWACs0AP///5oAAAQiBe0GJgJOAAABBwBqAJUAHgANtwQDFwMBAWtWACs0NAD///+aAAAEAQZ5BiYCTgAAAQcAowEEAFMADbcEAxkDAQFRVgArNDQA////mgAABE4GmAYmAk4AAAAHAkIA9P/+//8AOf48BEQEoAYmAkwAAAAHAHkBYv////8ACQAAA/sGHgYmAkMAAAEHAEQAoAAeAAu2BBIHAQFsVgArNAD//wAJAAAEDwYeBiYCQwAAAQcAdQFCAB4AC7YEEAcBAWxWACs0AP//AAkAAAP7Bh4GJgJDAAABBgCePh4AC7YEFgcBAWxWACs0AP//AAkAAAP7Be0GJgJDAAABBgBqah4ADbcFBBkHAQGEVgArNDQA//8AGgAAAd8GHgYmAf4AAAEGAESGHgALtgEGAwEBa1YAKzQA//8AGgAAAvQGHgYmAf4AAAEGAHUnHgALtgEEAwEBa1YAKzQA//8AGgAAAsMGHgYmAf4AAAEHAJ7/IwAeAAu2AQkDAQF2VgArNAD//wAaAAAC3QXtBiYB/gAAAQcAav9QAB4ADbcCAQ0DAQGEVgArNDQA//8ACQAABKgGEgYmAfkAAAEHAKUAmAAfAAu2ARgGAQF2VgArNAD//wA7/+0EWAYeBiYB+AAAAQcARADZAB4AC7YCLhEBAVtWACs0AP//ADv/7QRYBh4GJgH4AAABBwB1AXoAHgALtgIsEQEBW1YAKzQA//8AO//tBFgGHgYmAfgAAAEGAJ53HgALtgIxEQEBW1YAKzQA//8AO//tBFgGEgYmAfgAAAEHAKUAhgAfAAu2AjERAQFvVgArNAD//wA7/+0EWAXtBiYB+AAAAQcAagCjAB4ADbcDAjURAQF0VgArNDQA//8AOP/sBGQGHgYmAfIAAAEHAEQAvwAeAAu2ARgLAQFrVgArNAD//wA4/+wEZAYeBiYB8gAAAQcAdQFhAB4AC7YBFgsBAWtWACs0AP//ADj/7ARkBh4GJgHyAAABBgCeXR4AC7YBGwsBAWtWACs0AP//ADj/7ARkBe0GJgHyAAABBwBqAIkAHgANtwIBHwsBAYRWACs0NAD//wBsAAAEggYeBiYB7gAAAQcAdQE5AB4AC7YDDgkBAWtWACs0AP///5oAAAQhBcsGJgJOAAABBgBwcCEAC7YDEAMBAbBWACs0AP///5oAAAQTBgYGJgJOAAABBwChAKEAHgALtgMTAwEBXVYAKzQAAAT/mv5VBAEEjQAEAAkADQAjACFADw0MDAMWHQgDfQ8OBQUBEgA/MxEzMz8zLzMSOS8zMDFBASMBMxMDNzMTAwchNwEXDgIHBhYXMjY3FwYGIyImNz4CAoD+E/kCkqZMtwSb+6sg/XkgAo92JFI+BgMZHRctFA0iTihWaQECTnYDk/xtBI37cwOr4vtzAbC1tf6LPRk6Si8dIAEOCY0VFGlXSnBQAP//ADn/7QREBh4GJgJMAAABBwB1AW0AHgALtgEoEAEBW1YAKzQA//8AOf/tBEQGHgYmAkwAAAEGAJ5qHgALtgEtEAEBW1YAKzQA//8AOf/tBEQF/QYmAkwAAAEHAKIBSAAmAAu2ATEQAQFwVgArNAD//wA5/+0ERAYhBiYCTAAAAQYAn38eAAu2AS4QAQFkVgArNAD//wAJ//8EFgYhBiYCSwAAAQYAn/keAAu2AiQdAQF0VgArNAD//wAJAAAD+wXLBiYCQwAAAQYAcEUhAAu2BBIHAQGwVgArNAD//wAJAAAD+wYGBiYCQwAAAQYAoXYeAAu2BBUHAQFeVgArNAD//wAJAAAD+wX9BiYCQwAAAQcAogEdACYAC7YEGQcBAYBWACs0AAAFAAn+VQP7BI0AAwAHAAsADwAlACNAEBgfCwoKBg8OB30REBAFBhIAPzMzETM/MzMSOS8zLzMwMWUHITcTAyMTAQchNwEHITcTFw4CBwYWFzI2NxcGBiMiJjc+AgNUIv14IvPK7MsChCL9yyIC2CL9eSLpdSNSPwUDGB4XLBYMI00pVWkCAU52v7+/A877cwSN/i2/vwHTwMD7rj0ZOkovHSABDgmNFRRpV0pwUP//AAkAAAQRBiEGJgJDAAABBgCfVB4AC7YEFgcBAXRWACs0AP//AD//7wROBh4GJgIAAAABBgCecR4AC7YBMBABAWZWACs0AP//AD//7wROBgYGJgIAAAABBwChAKkAHgALtgEwEAEBTVYAKzQA//8AP//vBE4F/QYmAgAAAAEHAKIBUAAmAAu2ATQQAQFwVgArNAD//wA//fsETgSgBiYCAAAAAQcB1QEp/pcADrQBNAUBAbj/mbBWACs0//8ACQAABKkGHgYmAf8AAAEGAJ5/HgALtgMRBwEBdlYAKzQA//8ADgAAAvYGEgYmAf4AAAEHAKX/MgAfAAu2AQkDAQF/VgArNAD//wAaAAAC2wXLBiYB/gAAAQcAcP8qACEAC7YBBgMBAbBWACs0AP//ABoAAALOBgYGJgH+AAABBwCh/1wAHgALtgEJAwEBXVYAKzQA////lv5VAc8EjQYmAf4AAAAGAKTuAP//ABoAAAICBf0GJgH+AAABBgCiAiYAC7YBDQMBAYBWACs0AP////P/7QSYBh4GJgH9AAABBwCeAPgAHgALtgEZAQEBdlYAKzQA//8ACf4DBJ0EjQYmAfwAAAAHAdUAz/6f//8ACQAAAzEGHgYmAfsAAAEGAHUdHgALtgIIBwEBa1YAKzQA//8ACf4EAzEEjQYmAfsAAAEHAdUAzf6gAA60AhEGAQG4/5WwVgArNP//AAkAAAMxBJAGJgH7AAAABwHVAiQDkP//AAkAAAMxBI0GJgH7AAAABwCiAPD9Qf//AAkAAASoBh4GJgH5AAABBwB1AY0AHgALtgEKBgEBa1YAKzQA//8ACf39BKgEjQYmAfkAAAAHAdUBMv6Z//8ACQAABKgGIQYmAfkAAAEHAJ8AnwAeAAu2ARAGAQF0VgArNAD//wA7/+0EWAXLBiYB+AAAAQYAcH4hAAu2Ai4RAQGgVgArNAD//wA7/+0EWAYGBiYB+AAAAQcAoQCvAB4AC7YCMREBAU1WACs0AP//ADv/7QTjBh0GJgH4AAABBwCmAPgAHgANtwMCMBEBAVFWACs0NAD//wAJAAAEFgYeBiYB9QAAAQcAdQEiAB4AC7YCHwABAWtWACs0AP//AAn+BAQWBI0GJgH1AAAABwHVANX+oP//AAkAAAQWBiEGJgH1AAABBgCfNB4AC7YCJQABAXRWACs0AP//AA//7gQbBh4GJgH0AAABBwB1AU4AHgALtgE6DwEBW1YAKzQA//8AD//uA/4GHgYmAfQAAAEGAJ5KHgALtgE/DwEBZlYAKzQA//8AD/49A/4EngYmAfQAAAAHAHkBSAAA//8AD//uBBwGIQYmAfQAAAEGAJ9fHgALtgFADwEBZlYAKzQA//8AY/4DBF4EjQYmAfMAAAEHAdUA4/6fAA60AhECAQG4/5CwVgArNP//AGMAAAReBiEGJgHzAAABBgCfTR4AC7YCDgcBAXRWACs0AP//AGP+RAReBI0GJgHzAAAABwB5ATQAB///ADj/7ARkBhIGJgHyAAABBgClbB8AC7YBGwsBAX9WACs0AP//ADj/7ARkBcsGJgHyAAABBgBwZCEAC7YBGAsBAbBWACs0AP//ADj/7ARkBgYGJgHyAAABBwChAJUAHgALtgEbCwEBXVYAKzQA//8AOP/sBGQGeQYmAfIAAAEHAKMA+ABTAA23AgEhCwEBUVYAKzQ0AP//ADj/7ATJBh0GJgHyAAABBwCmAN4AHgANtwIBGgsBAWFWACs0NAAAAgA4/oUEZASNABUAKwAaQAweJRcWFhEGC3IMAH0APzIrMjIRMy8zMDFBMwMOAicuAjcTMwMGFhYXFjY2NwMXDgIHBhYXMjY3FwYGIyImNz4CA3ftghKS3oV7wmYOgeuCCCRYRUlwSAuVdSNSPgYDGB4XLRQNIk4oVmkCAU51BI39AIa8XwMCYriCAwD8/0NiNwICNGRI/t89GTpKLx0gAQ4JjRUUaVdKcFAA//8AiwAABh4GHgYmAfAAAAEHAJ4BFwAeAAu2BBsKAQF2VgArNAD//wBsAAAEggYeBiYB7gAAAQYAnjUeAAu2AxMJAQF2VgArNAD//wBsAAAEggXtBiYB7gAAAQYAamEeAA23BAMXCQEBhFYAKzQ0AP///9YAAAQqBh4GJgHtAAABBwB1ATwAHgALtgMODQEBa1YAKzQA////1gAABCoF/QYmAe0AAAEHAKIBFwAmAAu2AxcNAQGAVgArNAD////WAAAEKgYhBiYB7QAAAQYAn04eAAu2AxQNAQF0VgArNAD///+jAAAEqwY/BiYAJQAAAQYArrD/AA60Aw4DAAC4/z6wVgArNP///7oAAAUgBkEEJgApZAABBwCu/oQAAQAOtAQQBwAAuP8/sFYAKzT////CAAAF6QZABCYALGQAAAcArv6MAAD////GAAACjQZCBCYALWQAAQcArv6QAAIADrQBBAMAALj/QbBWACs0//8AJ//pBTYGPwQmADMUAAEHAK7+8f//AA60AiwRAAC4/yqwVgArNP///7kAAAW0Bj8EJgA9ZAABBwCu/oP//wALtgEKCAAAjlYAKzQA//8AHgAABQMGPwQmALoUAAEHAK7+/v//AA60AzYdAAC4/yqwVgArNP//AAn/9QM6BpsGJgDDAAABBwCv/xr/6wAQQAkDAgErAAEBolYAKzQ0NP///6MAAASrBbAGBgAlAAD//wAm//8EtwWwBgYAJgAA//8AJgAABLwFsAYGACkAAP///+UAAATrBbAGBgA+AAD//wAmAAAFhQWwBgYALAAA//8ANwAAAikFsAYGAC0AAP//ACYAAAVyBbAGBgAvAAD//wAmAAAGzgWwBgYAMQAA//8AJgAABYYFsAYGADIAAP//AGL/6QUiBccGBgAzAAD//wAmAAAE+gWwBgYANAAA//8AnQAABSUFsAYGADgAAP//AKEAAAVQBbAGBgA9AAD////AAAAFRgWwBgYAPAAA//8ANwAAAzAHDQYmAC0AAAEHAGr/owE+AA23AgEZAwEBg1YAKzQ0AP//AKEAAAVQBwUGJgA9AAABBwBqAOkBNgANtwIBHgIBAXdWACs0NAD//wA7/+cEMgY8BiYAuwAAAQcArgE///wAC7YDQgYBAZpWACs0AP//ACj/6gQEBjsGJgC/AAABBwCuAQz/+wALtgJAKwEBmlYAKzQA//8AEf5hA/sGPAYmAMEAAAEHAK4BFP/8AAu2Ah0DAQGuVgArNAD//wBm//UCjgYmBiYAwwAAAQYArv3mAAu2ARIAAQGZVgArNAD//wBX/+cEOAajBiYAywAAAQYArxjzABBACQMCATgPAQGiVgArNDQ0//8AIQAABJAEOgYGAI4AAP//ADj/6QQeBFEGBgBTAAD////e/mAEWQQ6BgYAdgAA//8AZAAABBIEOgYGAFoAAP///5/+TwRnBEgGBgKLAAD//wBE//UC+gW6BiYAwwAAAQcAav9t/+sADbcCAScAAQGiVgArNDQA//8AV//nA/gFwgYmAMsAAAEGAGpr8wANtwIBNA8BAaJWACs0NAD//wA4/+kEHgY8BiYAUwAAAQcArgEF//wAC7YCLAYBAZpWACs0AP//AFf/5wPuBi4GJgDLAAABBwCuAPv/7gALtgEfDwEBmVYAKzQA//8AUv/nBgQGLAYmAM4AAAEHAK4CE//sAAu2AkAfAQGWVgArNAD//wAmAAAEvAcNBiYAKQAAAQcAagDrAT4ADbcFBCUHAQGDVgArNDQA//8AKwAABKwHPgYmALEAAAEHAHUBugE+AAu2AQYFAQFsVgArNAAAAQAm/+oEvQXGADkAG0ANCiYPNjErCXIYFA8DcgArzDMrzDMSOTkwMUE2LgInLgM3PgMXHgIHIzYmJicmBgYHBh4CFx4DBw4DJy4DNxcGHgIzFjY2A1AJKEteLkyUd0IGCGegvl6F0HYF9AYxaE1FgFkLCC1QXChRlXQ+Bwlmnr5hZ7eKSwT0BCFGZT9EgVsBfjtRNyYRG0pmi11pm2YxAgNsxohMbT0BAi1eSjRMNCQOHE1qkWFrm2IuAgE+d6ptAUBjQiICKlsA//8ANwAAAikFsAYGAC0AAP//ADcAAAMwBw0GJgAtAAABBwBq/6MBPgANtwIBGQMBAYNWACs0NAD//wAE/+gEXQWwBgYALgAA//8AKwAABXYFsAYGAkcAAP//ACYAAAVyBzMGJgAvAAABBwB1AaYBMwALtgMOAwEBW1YAKzQA//8Amf/oBVYHJgYmAN4AAAEHAKEBFQE+AAu2Ah4BAQFeVgArNAD///+jAAAEqwWwBgYAJQAA//8AJv//BLcFsAYGACYAAP//ACsAAASsBbAGBgCxAAD//wAmAAAEvAWwBgYAKQAA//8AJQAABXwHJgYmANwAAAEHAKEBUwE+AAu2AQ8BAQFeVgArNAD//wAmAAAGzgWwBgYAMQAA//8AJgAABYUFsAYGACwAAP//AGL/6QUiBccGBgAzAAD//wArAAAFgwWwBgYAtgAA//8AJgAABPoFsAYGADQAAP//AF//6AUKBccGBgAnAAD//wCdAAAFJQWwBgYAOAAA////wAAABUYFsAYGADwAAP//ABz/6QPRBFAGBgBFAAD//wA6/+sD8ARRBgYASQAA//8AFwAABEUF2wYmAPAAAAEHAKEAlv/zAAu2AQ8BAQF9VgArNAD//wA4/+kEHgRRBgYAUwAA////yP5gBBAEUQYGAFQAAAABADf/6gPmBFEAJwATQAkACR0UB3IJC3IAKysyETMwMWUWNjY3Nw4CJy4DNzc+AxceAgcnNCYmJyYOAgcHBh4CAeA7YkEN3w2Jy3Fzo2QnCgQMU4u+d3iuXAHdJU8/SmlFJwcEBQMiT6sBLlY4AXSsXQICWpjBaCRvxplWAwJqt3UBOGE9AgI+an8+IzV5akQA////vP5HBBkEOgYGAF0AAP///7oAAAQSBDoGBgBcAAD//wA6/+sD8AXPBiYASQAAAQYAamAAAA23AgFBCwEBo1YAKzQ0AP//ABYAAAOVBfMGJgDsAAABBwB1AMj/8wALtgEGBQEBi1YAKzQA//8AG//rA8EETwYGAFcAAP//ACAAAAIKBdgGBgBNAAD//wAjAAAC4gXGBiYAjQAAAQcAav9V//cADbcCARkDAQG1VgArNDQA////Av5GAgEF2AYGAE4AAP//ACIAAAR+BfIGJgDxAAABBwB1AUr/8gALtgMOAwEBilYAKzQA////vP5HBBkF6AYmAF0AAAEGAKFTAAALtgIeAQEBklYAKzQA//8AtQAABzoHNwYmADsAAAEHAEQCIwE3AAu2BBgVAQFhVgArNAD//wB5AAAF9AYABiYAWwAAAQcARAFmAAAAC7YEGBUBAaBWACs0AP//ALUAAAc6BzcGJgA7AAABBwB1AsQBNwALtgQWAQEBYVYAKzQA//8AeQAABfQGAAYmAFsAAAEHAHUCCAAAAAu2BBYBAQGgVgArNAD//wC1AAAHOgcGBiYAOwAAAQcAagHtATcADbcFBCsVAQF4VgArNDQA//8AeQAABfQFzwYmAFsAAAEHAGoBMQAAAA23BQQrFQEBt1YAKzQ0AP//AKEAAAVQBzYGJgA9AAABBwBEAR8BNgALtgELAgEBYFYAKzQA////vP5HBBkGAAYmAF0AAAEGAER9AAALtgIbAQEBoFYAKzQA//8AkQP+AZUGAAYGAAsAAP//AJ0D+AK8BgAGBgAGAAD//wAz//AEKgWwBCYABQAAAAcABQIOAAD///8E/kcC+QXhBiYAnAAAAQcAn/88/94AC7YBGAABAYBWACs0AP//AI0EBAH6BgAGBgGGAAD//wAmAAAGzgc3BiYAMQAAAQcAdQLBATcAC7YDEQABAWFWACs0AP//AA8AAAZhBgAGJgBRAAABBwB1ApsAAAALtgMzAwEBoFYAKzQA////o/5wBKsFsAYmACUAAAEHAKcBaQAEABC1BAMRBQEBuP+1sFYAKzQ0//8AHP51A9EEUAYmAEUAAAEHAKcApAAJABC1AwI+MQEBuP/JsFYAKzQ0//8AJgAABLwHPgYmACkAAAEHAEQBIQE+AAu2BBIHAQFsVgArNAD//wAlAAAFfAc+BiYA3AAAAQcARAF9AT4AC7YBDAEBAWxWACs0AP//ADr/6wPwBgAGJgBJAAABBwBEAJYAAAALtgEuCwEBjFYAKzQA//8AFwAABEUF8wYmAPAAAAEHAEQAwP/zAAu2AQwBAQGLVgArNAD//wB2AAAF0QWwBgYAuQAA//8AP/4lBV8EPAYGAM0AAP//AKgAAAVhBv0GJgEZAAABBwCsBFwBDwANtwMCFRMBAS1WACs0NAD//wB1AAAESgXQBiYBGgAAAQcArAPH/+IADbcDAhkXAQF7VgArNDQA//8AOP5HCIAEUQQmAFMAAAAHAF0EZwAA//8AYv5HCXIFxwQmADMAAAAHAF0FWQAA//8AH/43BKQFxgYmANsAAAEHAmwBc/+dAAu2AkIqAABkVgArNAD//wAX/jgDvQRQBiYA7wAAAQcCbAEa/54AC7YCPykAAGVWACs0AP//AF/+OgUKBccGJgAnAAABBwJsAbP/oAALtgErBQAAZFYAKzQA//8AN/46A+YEUQYmAEcAAAEHAmwBN/+gAAu2ASsJAABkVgArNAD//wChAAAFUAWwBgYAPQAA//8Adf5fBDAEOgYGAL0AAP//ADcAAAIpBbAGBgAtAAD///+kAAAH6AcmBiYA2gAAAQcAoQJQAT4AC7YFHQ0BAV5WACs0AP///7AAAAaBBdsGJgDuAAABBwChAYv/8wALtgUdDQEBfVYAKzQA//8ANwAAAikFsAYGAC0AAP///6MAAASrBx8GJgAlAAABBwChASoBNwALtgMTBwEBU1YAKzQA//8AHP/pA/UF6AYmAEUAAAEHAKEAgwAAAAu2AkAPAQF+VgArNAD///+jAAAEqwcGBiYAJQAAAQcAagEeATcADbcEAyMHAQF4VgArNDQA//8AHP/pBAQFzwYmAEUAAAEGAGp3AAANtwMCUA8BAaNWACs0NAD///+NAAAHbwWwBgYAgQAA//8ADv/qBl8EUQYGAIYAAP//ACYAAAS8ByYGJgApAAABBwChAPgBPgALtgQVBwEBXlYAKzQA//8AOv/rA/AF6AYmAEkAAAEGAKFsAAALtgExCwEBflYAKzQA//8AS//pBS0G3gYmAVgAAAEHAGoA9wEPAA23AgFCAAEBQVYAKzQ0AP//ADT/6gPaBFEGBgCdAAD//wA0/+oD+AXQBiYAnQAAAQYAamsBAA23AgFAAAEBolYAKzQ0AP///6QAAAfoBw0GJgDaAAABBwBqAkQBPgANtwYFLQ0BAYNWACs0NAD///+wAAAGgQXCBiYA7gAAAQcAagF///MADbcGBS0NAQGiVgArNDQA//8AH//qBKQHGgYmANsAAAEHAGoA3wFLAA23AwJUFQEBhFYAKzQ0AP//ABf/6gPfBc4GJgDvAAABBgBqUv8ADbcDAlEUAQGjVgArNDQA//8AJQAABXwG6gYmANwAAAEHAHABIgFAAAu2AQwIAQGxVgArNAD//wAXAAAERQWgBiYA8AAAAQYAcGX2AAu2AQwIAQHQVgArNAD//wAlAAAFfAcNBiYA3AAAAQcAagFHAT4ADbcCAR8BAQGDVgArNDQA//8AFwAABEUFwgYmAPAAAAEHAGoAiv/zAA23AgEfAQEBolYAKzQ0AP//AGL/6QUiBwcGJgAzAAABBwBqATUBOAANtwMCQREBAWZWACs0NAD//wA4/+kEHgXPBiYAUwAAAQYAanUAAA23AwJBBgEBo1YAKzQ0AP//AGH/6QUbBccGBgEXAAD//wA0/+gEHQRSBgYBGAAA//8AYf/pBRsHCQYmARcAAAEHAGoBRgE6AA23BANPAAEBalYAKzQ0AP//ADT/6AQdBdAGJgEYAAABBgBqdgEADbcEA0EAAQGlVgArNDQA//8ASP/pBPIHGwYmAOcAAAEHAGoBFwFMAA23AwJCHgEBhVYAKzQ0AP//ACD/6APmBc8GJgD/AAABBgBqWQAADbcDAkEJAQGjVgArNDQA//8Amf/oBVYG6gYmAN4AAAEHAHAA5AFAAAu2AhsYAQGxVgArNAD///+8/kcEGQWtBiYAXQAAAQYAcCIDAAu2AhsYAQHlVgArNAD//wCZ/+gFVgcNBiYA3gAAAQcAagEJAT4ADbcDAi4BAQGDVgArNDQA////vP5HBBkFzwYmAF0AAAEGAGpHAAANtwMCLgEBAbdWACs0NAD//wCZ/+gFVgc9BiYA3gAAAQcApgFeAT4ADbcDAhkBAQFiVgArNDQA////vP5HBIcF/wYmAF0AAAEHAKYAnAAAAA23AwIZAQEBllYAKzQ0AP//AMQAAAVdBw0GJgDhAAABBwBqAUgBPgANtwMCLxYBAYNWACs0NAD//wBtAAAEGAXCBiYA+QAAAQYAamnzAA23AwItAwEBolYAKzQ0AP//ACz//wa5Bw0GJgDlAAABBwBqAe8BPgANtwMCMhwBAYNWACs0NAD//wAj//8F+AXCBiYA/QAAAQcAagFy//MADbcDAjIcAQGiVgArNDQA//8AOP/oBIcGAAYGAEgAAP///6P+mASrBbAGJgAlAAABBwCtBOQAAwAOtAMRBQEBuP91sFYAKzT//wAc/p0D0QRQBiYARQAAAQcArQQeAAgADrQCPjEBAbj/ibBWACs0////owAABKsHuQYmACUAAAEHAKsFEwE9AAu2Aw8HAQFxVgArNAD//wAc/+kD0QaDBiYARQAAAQcAqwRsAAcAC7YCPA8BAZxWACs0AP///6MAAAYLB6sGJgAlAAABBwJSAO4BIQANtwQDEgcBAWFWACs0NAD//wAc/+kFYwZ0BiYARQAAAQYCUkbqAA23AwJBDwEBjFYAKzQ0AP///6MAAASrB6kGJgAlAAABBwJTAPEBKgANtwQDEAcBAVxWACs0NAD//wAc/+kD6gZyBiYARQAAAQYCU0nzAA23AwI9DwEBh1YAKzQ0AP///6MAAAV7B9wGJgAlAAABBwJUAOwBFQANtwQDEwMBAVBWACs0NAD//wAc/+kE1AalBiYARQAAAQYCVEXeAA23AwJADwEBe1YAKzQ0AP///6MAAASrB9MGJgAlAAABBwJVAOsBBwANtwQDEAcBATpWACs0NAD//wAc/+kD5wacBiYARQAAAQYCVUTQAA23AwI9DwEBZVYAKzQ0AP///6P+mASrBzcGJgAlAAAAJwCeAPIBNwEHAK0E5AADABe0BBoFAQG4/3W3VgMRBwEBbFYAKzQrNAD//wAc/p0D6wYABiYARQAAACYAnksAAQcArQQeAAgAF7QDRzEBAbj/ibdWAj4PAQGXVgArNCs0AP///6MAAASrB64GJgAlAAABBwJXARgBMgANtwQDEwcBAVxWACs0NAD//wAc/+kD7QZ4BiYARQAAAQYCV3H8AA23AwJADwEBh1YAKzQ0AP///6MAAASrB64GJgAlAAABBwJQARgBMgANtwQDEwcBAVxWACs0NAD//wAc/+kD7gZ4BiYARQAAAQYCUHH8AA23AwJADwEBh1YAKzQ0AP///6MAAASrCD0GJgAlAAABBwJYARcBNgANtwQDEwcBAW5WACs0NAD//wAc/+kD5QcGBiYARQAAAQYCWHD/AA23AwJADwEBmVYAKzQ0AP///6MAAASrCBUGJgAlAAABBwJrARsBPAANtwQDEwcBAW9WACs0NAD//wAc/+kD9wbeBiYARQAAAQYCa3QFAA23AwJADwEBmlYAKzQ0AP///6P+mASrBx8GJgAlAAAAJwChASoBNwEHAK0E5AADABe0BCAFAQG4/3W3VgMTBwEBU1YAKzQrNAD//wAc/p0D9QXoBiYARQAAACcAoQCDAAABBwCtBB4ACAAXtANNMQEBuP+Jt1YCQA8BAX5WACs0KzQA//8AJv6fBLwFsAYmACkAAAEHAK0EqAAKAA60BBMCAQG4/3+wVgArNP//ADr+lQPwBFEGJgBJAAABBwCtBHUAAAAOtAEvAAEBuP+JsFYAKzT//wAmAAAEvAfABiYAKQAAAQcAqwTgAUQAC7YEEQcBAXxWACs0AP//ADr/6wPwBoMGJgBJAAABBwCrBFUABwALtgEtCwEBnFYAKzQA//8AJgAABLwHMQYmACkAAAEHAKUAzgE+AAu2BB4HAQF2VgArNAD//wA6/+sEBwX0BiYASQAAAQYApUMBAAu2AToLAQGWVgArNAD//wAmAAAF2AeyBiYAKQAAAQcCUgC7ASgADbcFBBQHAQFsVgArNDQA//8AOv/rBU0GdQYmAEkAAAEGAlIw6wANtwIBMAsBAYxWACs0NAD//wAmAAAEvAewBiYAKQAAAQcCUwC+ATEADbcFBBIHAQFnVgArNDQA//8AOv/rA/AGcwYmAEkAAAEGAlMz9AANtwIBLgsBAYdWACs0NAD//wAmAAAFSQfjBiYAKQAAAQcCVAC6ARwADbcFBBUHAQFbVgArNDQA//8AOv/rBL4GpgYmAEkAAAEGAlQv3wANtwIBMQsBAXtWACs0NAD//wAmAAAEvAfaBiYAKQAAAQcCVQC5AQ4ADbcFBBIHAQFFVgArNDQA//8AOv/rA/AGnQYmAEkAAAEGAlUt0QANtwIBLgsBAWVWACs0NAD//wAm/p8EvAc+BiYAKQAAACcAngC/AT4BBwCtBKgACgAXtAUcAgEBuP9/t1YEEwcBAXdWACs0KzQA//8AOv6VA/AGAAYmAEkAAAAmAJ40AAEHAK0EdQAAABe0AjgAAQG4/4m3VgEvCwEBl1YAKzQrNAD//wA3AAAC0wfABiYALQAAAQcAqwOXAUQAC7YBBQMBAXxWACs0AP//ACMAAAKFBnoGJgCNAAABBwCrA0n//gALtgEFAwEBrlYAKzQA//////6bAikFsAYmAC0AAAEHAK0DXgAGAA60AQcCAQG4/36wVgArNP///+P+nwIKBdgGJgBNAAABBwCtA0IACgAOtAITAgEBuP9/sFYAKzT//wBi/pUFIgXHBiYAMwAAAQcArQT0AAAADrQCLwYBAbj/ibBWACs0//8AOP6RBB4EUQYmAFMAAAEHAK0Egf/8AA60Ai8RAQG4/4iwVgArNP//AGL/6QUiB7sGJgAzAAABBwCrBSoBPwALtgItEQEBX1YAKzQA//8AOP/pBB4GgwYmAFMAAAEHAKsEagAHAAu2Ai0GAQGcVgArNAD//wBi/+kGIwesBiYAMwAAAQcCUgEGASIADbcDAjARAQFPVgArNDQA//8AOP/pBWIGdAYmAFMAAAEGAlJF6gANtwMCMAYBAYxWACs0NAD//wBi/+kFIgeqBiYAMwAAAQcCUwEIASsADbcDAi4RAQFKVgArNDQA//8AOP/pBB4GcgYmAFMAAAEGAlNI8wANtwMCLgYBAYdWACs0NAD//wBi/+kFkgfdBiYAMwAAAQcCVAEDARYADbcDAjERAQE+VgArNDQA//8AOP/pBNMGpQYmAFMAAAEGAlRE3gANtwMCMQYBAXtWACs0NAD//wBi/+kFIgfUBiYAMwAAAQcCVQEDAQgADbcDAi4RAQEoVgArNDQA//8AOP/pBB4GnAYmAFMAAAEGAlVD0AANtwMCLgYBAWVWACs0NAD//wBi/pUFIgc4BiYAMwAAACcAngEKATgBBwCtBPQAAAAXtAM4BgEBuP+Jt1YCLxEBAVpWACs0KzQA//8AOP6RBB4GAAYmAFMAAAAmAJ5JAAEHAK0Egf/8ABe0AzgRAQG4/4i3VgIvBgEBl1YAKzQrNAD//wBc/+kGIQc1BiYAmAAAAQcAdQIMATUAC7YDOhwBAUdWACs0AP//ADT/6QTwBgAGJgCZAAABBwB1AV0AAAALtgM2EAEBjFYAKzQA//8AXP/pBiEHNQYmAJgAAAEHAEQBagE1AAu2AzwcAQFHVgArNAD//wA0/+kE8AYABiYAmQAAAQcARAC7AAAAC7YDOBABAYxWACs0AP//AFz/6QYhB7gGJgCYAAABBwCrBSkBPAALtgM7HAEBV1YAKzQA//8ANP/pBPAGgwYmAJkAAAEHAKsEegAHAAu2AzcQAQGcVgArNAD//wBc/+kGIQcpBiYAmAAAAQcApQEXATYAC7YDSBwBAVFWACs0AP//ADT/6QTwBfQGJgCZAAABBgClaAEAC7YDRBABAZZWACs0AP//AFz+lQYhBi0GJgCYAAABBwCtBN4AAAAOtAM9EAEBuP+JsFYAKzT//wA0/osE8ASqBiYAmQAAAQcArQR0//YADrQDORsBAbj/f7BWACs0//8AWP6VBTEFsAYmADkAAAEHAK0EzQAAAA60ARkGAQG4/4mwVgArNP//AEr+lQQvBDoGJgBZAAABBwCtBB4AAAAOtAIfCwEBuP+JsFYAKzT//wBY/+gFMQe5BiYAOQAAAQcAqwUHAT0AC7YBFwABAXFWACs0AP//AEr/6AQvBoMGJgBZAAABBwCrBHEABwALtgIdEQEBsFYAKzQA//8AWP/pBqQHQgYmAJoAAAEHAHUCDwFCAAu2AiAKAQFsVgArNAD//wBK/+gFWQXrBiYAmwAAAQcAdQFX/+sAC7YDJhsBAYtWACs0AP//AFj/6QakB0IGJgCaAAABBwBEAW0BQgALtgIiCgEBbFYAKzQA//8ASv/oBVkF6wYmAJsAAAEHAEQAtv/rAAu2AygbAQGLVgArNAD//wBY/+kGpAfFBiYAmgAAAQcAqwUsAUkAC7YCIQoBAXxWACs0AP//AEr/6AVZBm4GJgCbAAABBwCrBHX/8gALtgMnGwEBm1YAKzQA//8AWP/pBqQHNgYmAJoAAAEHAKUBGgFDAAu2Ai4VAQF2VgArNAD//wBK/+gFWQXfBiYAmwAAAQYApWPsAAu2AzQbAQGVVgArNAD//wBY/owGpAYDBiYAmgAAAQcArQTu//cADrQCIxABAbj/gLBWACs0//8ASv6VBVkElgYmAJsAAAEHAK0EawAAAA60AykVAQG4/4mwVgArNP//AKH+pwVQBbAGJgA9AAABBwCtBKUAEgAOtAEMBgEBuP92sFYAKzT///+8/g8EGQQ6BiYAXQAAAQcArQUN/3oADrQCIggAALj/ubBWACs0//8AoQAABVAHuQYmAD0AAAEHAKsE3gE9AAu2AQoCAQFwVgArNAD///+8/kcEGQaDBiYAXQAAAQcAqwQ8AAcAC7YCGgEBAbBWACs0AP//AKEAAAVQByoGJgA9AAABBwClAMwBNwALtgEXCAEBalYAKzQA////vP5HBBkF9AYmAF0AAAEGAKUpAQALtgInGAEBqlYAKzQA////9P6wBRQGAAQmAEgAAAAnAkEB2AI/AQcAQwB7/2wAF7QENxYBAbj/d7dWAzILAQGDVgArNCs0AP//AJ3+mgUlBbAGJgA4AAABBwJsAjQAAAALtgILAgAAmlYAKzQA//8AVP6aBAwEOgYmAPYAAAEHAmwB0QAAAAu2AgsCAACaVgArNAD//wDE/poFXQWwBiYA4QAAAQcCbAK4AAAAC7YCHRkBAJpWACs0AP//AG3+mgQYBDsGJgD5AAABBwJsAbkAAAALtgIbAgEAmlYAKzQA//8AK/6aBKwFsAYmALEAAAEHAmwA9QAAAAu2AQkEAACaVgArNAD//wAW/poDiAQ6BiYA7AAAAQcCbADbAAAAC7YBCQQAAJpWACs0AP//AFX+PQW7BcYGJgFMAAABBwJsArn/owALtgI6CgAAa1YAKzQA////8v5EBHMEUQYmAU0AAAEHAmwB0f+qAAu2AjkJAABrVgArNAD//wANAAAD8gYABgYATAAAAAIAJP//BIgFsAAYABwAGkAMHBsYAAALDAJyDgsIAD8zKxI5LzPMMjAxQQUeAgcOAychEzMDBTI2Njc2JiYnJQEHITcBZwFVg9R1DAlkoMZr/eb89tsBClKLWwwJMGVH/o4BlB79cx4DgQEDZMCMc610OgEFsPsXAT52VUlnNwMBAjWnpwAAAgAk//8EiAWwABgAHAAZQAscGxgAAAsMAg4LCAA/Mz8SOS8zzDIwMUEFHgIHDgMnIRMzAwUyNjY3NiYmJyUBByE3AWcBVYPUdQwJZKDGa/3m/PbbAQpSi1sMCTBlR/6OAZQe/XMeA4EBA2TAjHOtdDoBBbD7FwE+dlVJZzcDAQI1p6cAAgAAAAAErAWwAAUACQAWQAoGBwcEAgUCcgQIAD8rMhI5LzMwMUEHIQMjEwEHITcErCP9cdr1/QGDHv1zHgWwyPsYBbD9l6amAAAC/8cAAAOIBDoABQAJABZACgkICAQCBQZyBAoAPysyEjkvMzAxQQchAyMTAQchNwOIIv42m+u8AaAd/XIeBDrA/IYEOv4/p6cAAAQAPwAABYoFsAADAAkADQARACtAFQwLCwcHBhARBhEGEQIJAwJyCgIIcgArMisyETk5Ly8RMxEzEjkRMzAxQQMjEyEBITczAQMBNwEBByE3AjH99f0ETv0y/qAF6QIGvP6ktgG9/kce/XMeBbD6UAWw/MLaAmT6UAKkt/ylBOenpwAEACgAAARaBgAAAwAJAA0AEQAtQBcEBnIMCwsHBwYQEQYRBhECAwByCgIKcgArMisROTkvLxEzETMSOREzKzAxQQEjCQIhJzMBAwM3AQMHITcCHv716wELAyf96f7gI98BWIH2rgFM2x79cx4GAPoABgD+Ov2hvwGg+8YCBaD9WwVjpqYAAAIAoQAABVAFsAAIAAwAHUAPDAEEBwMLCwYDCAJyBghyACsrMhE5Lxc5MzAxQRMBIQEDIxMBAQchNwGmzgHAARz9fFv3YP7HAxke/XQdBbD9SwK1/Fz99AIlA4v8/KenAAQAUv5fBDAEOgADAAgADQARABdACxEQEAIFDQZyAg5yACsrMhI5LzMwMWUDIxM3ATMBIxMTByMDAQchNwIbXOxchgF+/f3QpgduCZm4Aoge/XMdbf3yAg6hAyz7xgQ6/LfxBDr8bKamAAAC/8AAAAVGBbAACwAPAB9ADw8HBQEECgMODgkFAwACcgArMi8zOS8XORI5MzAxQRMBIQEBIQMBIQkCByE3AcnYAX4BJ/3bAT/+8N7+eP7WAjL+yQMpHv1zHgWw/e8CEf0j/S0CHP3kAuoCxv2Np6cAAv+6AAAEEgQ6AAsADwAfQA8PBwUBCgQDDg4JBQMABnIAKzIvMzkvFzkSOTMwMUETASEBEyMDASEBAwEHITcBcY4BBAEP/mfv9Zv+8f7xAajmAs0e/XMeBDr+mwFl/eH95QF1/osCMgII/kWmpv//ACj/6gQEBE8GBgC/AAD////CAAAEqQWwBiYAKgAAAQcCQf8x/mUADrQDDgICALgBCLBWACs0//8AfAJwBd4DMQYGAYMAAP//AA0AAAQ8BccGBgAWAAD//wAm/+oEOAXHBgYAFwAA//8ADQAABCsFsAYGABgAAP//AFj/6ARzBbAGBgAZAAD//wBx/+kEIgW6BAYAGhQA//8AS//pBFYFxwQGABwUAP//AIz/9gQsBccEBgAdAAD//wBz/+gETAXIBAYAFBQA//8AZv/rBRcHSwYmACsAAAEHAHUB/QFLAAu2ASwQAQFtVgArNAD////5/lEEQgYABiYASwAAAQcAdQFFAAAAC7YDPxoBAYxWACs0AP//ACYAAAWGBzcGJgAyAAABBwBEAX8BNwALtgEMCQEBYVYAKzQA//8ADQAAA/IGAAYmAFIAAAEHAEQAtwAAAAu2Ah4DAQGgVgArNAD///+jAAAEqwchBiYAJQAAAQcArASOATMADbcEAw4DAQFmVgArNDQA//8AHP/pA9EF6wYmAEUAAAEHAKwD5//9AA23AwI8DwEBkVYAKzQ0AP//ACYAAAS8BygGJgApAAABBwCsBFsBOgANtwUEEQcBAXFWACs0NAD//wA6/+sD8AXrBiYASQAAAQcArAPQ//0ADbcCAS0LAQGRVgArNDQA////zwAAAsMHKAYmAC0AAAEHAKwDEwE6AA23AgEFAwEBcVYAKzQ0AP///4AAAAJ0BeIGJgCNAAABBwCsAsT/9AANtwIBBQMBAaNWACs0NAD//wBi/+kFIgcjBiYAMwAAAQcArASlATUADbcDAi0RAQFUVgArNDQA//8AOP/pBB4F6wYmAFMAAAEHAKwD5f/9AA23AwItBgEBkVYAKzQ0AP//ACYAAATVByEGJgA2AAABBwCsBEIBMwANtwMCHwABAWZWACs0NAD//wAMAAADAAXrBiYAVgAAAQcArANQ//0ADbcDAhgDAQGlVgArNDQA//8AWP/oBTEHIQYmADkAAAEHAKwEggEzAA23AgEXCwEBZlYAKzQ0AP//AEr/6AQvBesGJgBZAAABBwCsA+z//QANtwMCHREBAaVWACs0NAD///+FAAAFewY/BCYA0GQAAAcArv5P/////wAm/p8EtwWwBiYAJgAAAQcArQSQAAoADrQCNBsBAbj/f7BWACs0//8AEP6LBBEGAAYmAEYAAAEHAK0Ep//2AA60AzMEAQG4/2uwVgArNP//ACb+nwTZBbAGJgAoAAABBwCtBGkACgAOtAIiHQEBuP9/sFYAKzT//wA4/pUEhwYABiYASAAAAQcArQSLAAAADrQDMxYBAbj/ibBWACs0//8AJv4GBNkFsAYmACgAAAEHAdUA/P6iAA60AigdAQG4/5ewVgArNP//ADj9/ASHBgAGJgBIAAABBwHVAR3+mAAOtAM5FgEBuP+hsFYAKzT//wAm/p8FhQWwBiYALAAAAQcArQUAAAoADrQDDwoBAbj/f7BWACs0//8ADf6fA/IGAAYmAEwAAAEHAK0EfQAKAA60Ah4CAQG4/3+wVgArNP//ACYAAAVyBzMGJgAvAAABBwB1AaYBMwALtgMOAwEBW1YAKzQA//8AEQAABHoHPQYmAE8AAAEHAHUBrQE9AAu2Aw4DAQAbVgArNAD//wAm/uEFcgWwBiYALwAAAQcArQTMAEwADrQDEQIBAbj/z7BWACs0//8AEf7NBE4GAAYmAE8AAAEHAK0EYQA4AA60AxECAQG4/7ywVgArNP//ACb+nwPABbAGJgAwAAABBwCtBJUACgAOtAILAgEBuP9/sFYAKzT////j/p8CFgYABiYAUAAAAQcArQNCAAoADrQBBwIBAbj/f7BWACs0//8AJv6fBs4FsAYmADEAAAEHAK0FqQAKAA60AxQGAQG4/3+wVgArNP//AA/+nwZhBFEGJgBRAAABBwCtBa8ACgAOtAM2AgEBuP9/sFYAKzT//wAm/psFhgWwBiYAMgAAAQcArQUCAAYADrQBDQIBAbj/f7BWACs0//8ADf6fA/IEUQYmAFIAAAEHAK0EbQAKAA60Ah8CAQG4/3+wVgArNP//AGL/6QUiB94GJgAzAAABBwJRBRQBVQANtwMCMREBAVpWACs0NAD//wAmAAAE+gdCBiYANAAAAQcAdQGqAUIAC7YBGA8BAWxWACs0AP///8j+YARqBfYGJgBUAAABBwB1AZ3/9gALtgMwAwEBllYAKzQA//8AJv6fBNUFsAYmADYAAAEHAK0ElgAKAA60AiEYAQG4/3+wVgArNP///93+oALyBFMGJgBWAAABBwCtAzwACwAOtAIaAgEBuP+AsFYAKzT//wAm/pQEvQXGBiYANwAAAQcArQSx//8ADrQBPSsBAbj/iLBWACs0//8AG/6LA8EETwYmAFcAAAEHAK0EWv/2AA60ATkpAQG4/3+wVgArNP//AJ3+mQUlBbAGJgA4AAABBwCtBKEABAAOtAILAgEBuP91sFYAKzT//wA//pUCrgVDBiYAWAAAAQcArQPwAAAADrQCGREBAbj/ibBWACs0//8AWP/oBTEH3AYmADkAAAEHAlEE8QFTAA23AgEbAAEBbFYAKzQ0AP//AJoAAAV/BzYGJgA6AAABBwClAN4BQwALtgIYCQEBdlYAKzQA//8AZAAABBIF6gYmAFoAAAEGAKUb9wALtgIYCQEBoFYAKzQA//8Amv6fBX8FsAYmADoAAAEHAK0E0gAKAA60Ag0EAQG4/3+wVgArNP//AGT+nwQSBDoGJgBaAAABBwCtBEEACgAOtAINBAEBuP9/sFYAKzT//wC1/p8HOgWwBiYAOwAAAQcArQXBAAoADrQEGRMBAbj/f7BWACs0//8Aef6fBfQEOgYmAFsAAAEHAK0FJQAKAA60BBkTAQG4/3+wVgArNP///+X+nwTrBbAGJgA+AAABBwCtBKEACgAOtAMRAgEBuP9/sFYAKzT////m/p8D5AQ6BiYAXgAAAQcArQREAAoADrQDEQIBAbj/f7BWACs0////Af/pBWgF1wQmADNGAAEHAXL+Gf//AA23AwIuEQAAElYAKzQ0AP///5oAAAQBBRwGJgJOAAAABwCu/zL+3P///6YAAAQ3BR8EJgJDPAAABwCu/nD+3////64AAATlBRoEJgH/PAAABwCu/nj+2v///7EAAAILBR8EJgH+PAAABwCu/nv+3////9j/7QRiBRwEJgH4CgAABwCu/qL+3P///2UAAAS+BRwEJgHuPAAABwCu/i/+3P///+oAAAR7BRwEJgIOCgAABwCu/rT+3P///5oAAAQBBI0GBgJOAAD//wAJ//8EAASNBgYCTQAA//8ACQAAA/sEjQYGAkMAAP///9YAAAQqBI0GBgHtAAD//wAJAAAEqQSNBgYB/wAA//8AGgAAAc8EjQYGAf4AAP//AAkAAASdBI0GBgH8AAD//wAJAAAFyASNBgYB+gAA//8ACQAABKgEjQYGAfkAAP//ADv/7QRYBKAGBgH4AAD//wAJAAAEMASNBgYB9wAA//8AYwAABF4EjQYGAfMAAP//AGwAAASCBI4GBgHuAAD///+iAAAEfQSNBgYB7wAA//8AGgAAAt0F7QYmAf4AAAEHAGr/UAAeAA23AgENAwEBhFYAKzQ0AP//AGwAAASCBe0GJgHuAAABBgBqYR4ADbcEAxcJAQGDVgArNDQA//8ACQAAA/sF7QYmAkMAAAEGAGpqHgANtwUEGQcBAYNWACs0NAD//wAJAAAD+AYeBiYCBQAAAQcAdQErAB4AC7YCCAMBAYNWACs0AP//AA//7gP+BJ4GBgH0AAD//wAaAAABzwSNBgYB/gAA//8AGgAAAt0F7QYmAf4AAAEHAGr/UAAeAA23AgENAwEBhFYAKzQ0AP////P/7QOvBI0GBgH9AAD//wAJAAAEnQYeBiYB/AAAAQcAdQEiAB4AC7YDDgMBAYRWACs0AP//AHb/6ASJBgYGJgIcAAABBwChAIsAHgALtgIdFwEBhFYAKzQA////mgAABAEEjQYGAk4AAP//AAn//wQABI0GBgJNAAD//wAJAAAD4ASNBgYCBQAA//8ACQAAA/sEjQYGAkMAAP//AAsAAAStBgYGJgIZAAABBwChAMEAHgALtgMRCAEBhFYAKzQA//8ACQAABcgEjQYGAfoAAP//AAkAAASpBI0GBgH/AAD//wA7/+0EWASgBgYB+AAA//8ACQAABKQEjQYGAgoAAP//AAkAAAQwBI0GBgH3AAD//wA5/+0ERASgBgYCTAAA//8AYwAABF4EjQYGAfMAAP///6IAAAR9BI0GBgHvAAAAAwAO/jcD6wSfAB4APgBCAChAEx8BAgI+PhU/NDRAMCoLcg8LFX4APzPMK8zNMxI5EjkvMxI5OTAxQSc3Fz4CNzYmJiMmBgYHBz4DFx4DBw4DJxceAwcOAycuAzcXHgIXFjY2NzYuAicnEwMjEwIuwhaBN2pKCAg0WC4xV0EM7QdVhJ1QSZN6RgQDVIKX/qVEinFCBAVfk61VUJNxQALoATFSNDlyUgkGGjZJKJeyXexeAisBfQEBHUc/NkEbARs8MQFYfk8kAQEhRndXVHhMJUcBASBEb1JhhlIkAgEqVIFZATdDHQEBIEpALz8kEQEB/lL95wIZAAAEAAn+mgS5BI0AAwAHAAsADwAdQA0DAgIGCwd9Dw4KCgYSAD8zEM4zPzMSOS8zMDFBByE3EwMjEyEDIxMTAyMTA6ch/X4imcrsywPVy+rK+17sXgKdwMAB8PtzBI37cwSN/Cb95wIZAAIAOf5ABEQEoAAnACsAGEALGRB+KCQkKioFC3IAKzIvMhEzPzMwMUE3DgInLgM3Nz4DFx4CFyMuAicmDgIHBwYeAhcWNjYHAyMTAwzqFJjjgneqZiUMCg5clcl8gL1sCOoCLV1HUHZPMAkKBwMlVUxLckygXutdAYMBhbdbAwJcnMdtT3POnFYDAmO4f0ZhNAMCPWyFRVE7f21GAgMvYeL95wIZAP//AGwAAASCBI4GBgHuAAD//wA7/jcFlASnBiYCMgAAAAcCbAK//53//wALAAAErQXLBiYCGQAAAQcAcACPACEAC7YDDggBAbBWACs0AP//AHb/6ASJBcsGJgIcAAABBgBwWSEAC7YCGhcBAbBWACs0AP//AEEAAAU0BI0GBgIMAAD//wAa/+0FngSNBCYB/gAAAAcB/QHvAAD///9+AAAGDwYABiYCjwAAAQcAdQJ5AAAAC7YGGQ8BAU1WACs0AP///9v/xwS7Bh4GJgKRAAABBwB1AXoAHgALtgMwEQEBW1YAKzQA//8AD/38A/4EngYmAfQAAAAHAdUA9/6Y//8AiwAABh4GHgYmAfAAAAEHAEQBeAAeAAu2BBgKAQFrVgArNAD//wCLAAAGHgYeBiYB8AAAAQcAdQIaAB4AC7YEFgoBAWtWACs0AP//AIsAAAYeBe0GJgHwAAABBwBqAUMAHgANtwUEHwoBAYRWACs0NAD//wBsAAAEggYeBiYB7gAAAAcARACXAB7///+j/lgEqwWwBiYAJQAAAQcApAFrAAMAC7YDDgUBATlWACs0AP//ABz+XQPRBFAGJgBFAAABBwCkAKYACAALtgI7MQAATVYAKzQA//8AJv5fBLwFsAYmACkAAAEHAKQBMAAKAAu2BBACAABDVgArNAD//wA6/lUD8ARRBiYASQAAAQcApAD9AAAAC7YBLAAAAE1WACs0AP///5r+VQQBBI0GJgJOAAAABwCkAQ8AAP//AAn+XQP7BI0GJgJDAAAABwCkAOAACP///+P+nwHKBDoGJgCNAAABBwCtA0IACgAOtAEHAgEBuP9/sFYAKzQAAQCyAIkEJAP7AA8ACLEIAAAvLzAxZSImJjU0NjYzMhYWFRQGBgJresh3d8h6esh3d8iJd8h6esh3d8h6esh3AAEAkwAABEEDrwADAAizAQAScgArL3MRIRGTA64Dr/xRAAAEAAL/7wXeBcIAEAAYACAAKgAXQAkgECQIGBAcCBAALy8zETMRMxEzMDF3NjY3JRM2NjcDBgYHBwYGBwU2NjclBgYHATY2NwEGBgcBEzY2NwMlBgYHAgwvIQGUmzF4O68DEApkFjwhASQPLSICFw4xH/uJCzIfBPANMh/9sJ4ydj+PAXwOMR55Om8yUwN9NVIX/AoPHgx5GiMG6DhxM205ci8BrTtuMgEDOnEy/jgDkjVRGvzITjhzMQACALIAiQQkA/sADwAfABC3ABBqCBhqCAAALy8rKzAxZSImJjU0NjYzMhYWFRQGBicyNjY1NCYmIyIGBhUUFhYCa3rId3fIenrId3fIemalYmKlZmWmYmKmiXfIenrId3fIenrId0xipmVmpWJipWZlpmIAAAAAEQDSAAMAAQQJAAAAsgAAAAMAAQQJAAEAGgCyAAMAAQQJAAIADADMAAMAAQQJAAMAKADYAAMAAQQJAAQAKADYAAMAAQQJAAUAJgEAAAMAAQQJAAYAJgEmAAMAAQQJAAcAQAFMAAMAAQQJAAgADAGMAAMAAQQJAAkAJgGYAAMAAQQJAAsAFAG+AAMAAQQJAAwAFAG+AAMAAQQJAA0BIgHSAAMAAQQJAA4ANgL0AAMAAQQJABAADAMqAAMAAQQJABEAGgM2AAMAAQQJABkADAMqAEMAbwBwAHkAcgBpAGcAaAB0ACAAMgAwADEAMQAgAFQAaABlACAAUgBvAGIAbwB0AG8AIABQAHIAbwBqAGUAYwB0ACAAQQB1AHQAaABvAHIAcwAgACgAaAB0AHQAcABzADoALwAvAGcAaQB0AGgAdQBiAC4AYwBvAG0ALwBnAG8AbwBnAGwAZQBmAG8AbgB0AHMALwByAG8AYgBvAHQAbwAtAGMAbABhAHMAcwBpAGMAKQBSAG8AYgBvAHQAbwAgAE0AZQBkAGkAdQBtAEkAdABhAGwAaQBjAFIAbwBiAG8AdABvACAATQBlAGQAaQB1AG0AIABJAHQAYQBsAGkAYwBWAGUAcgBzAGkAbwBuACAAMwAuADAAMQA0ADsAIAAyADAAMgA1AFIAbwBiAG8AdABvAC0ATQBlAGQAaQB1AG0ASQB0AGEAbABpAGMAUgBvAGIAbwB0AG8AIABpAHMAIABhACAAdAByAGEAZABlAG0AYQByAGsAIABvAGYAIABHAG8AbwBnAGwAZQAuAEcAbwBvAGcAbABlAEMAaAByAGkAcwB0AGkAYQBuACAAUgBvAGIAZQByAHQAcwBvAG4ARwBvAG8AZwBsAGUALgBjAG8AbQBUAGgAaQBzACAARgBvAG4AdAAgAFMAbwBmAHQAdwBhAHIAZQAgAGkAcwAgAGwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAUwBJAEwAIABPAHAAZQBuACAARgBvAG4AdAAgAEwAaQBjAGUAbgBzAGUALAAgAFYAZQByAHMAaQBvAG4AIAAxAC4AMQAuACAAVABoAGkAcwAgAGwAaQBjAGUAbgBzAGUAIABpAHMAIABhAHYAYQBpAGwAYQBiAGwAZQAgAHcAaQB0AGgAIABhACAARgBBAFEAIABhAHQAOgAgAGgAdAB0AHAAcwA6AC8ALwBvAHAAZQBuAGYAbwBuAHQAbABpAGMAZQBuAHMAZQAuAG8AcgBnAGgAdAB0AHAAcwA6AC8ALwBvAHAAZQBuAGYAbwBuAHQAbABpAGMAZQBuAHMAZQAuAG8AcgBnAFIAbwBiAG8AdABvAE0AZQBkAGkAdQBtACAASQB0AGEAbABpAGMAAAADAAD/9AAA/2oAZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAgAIAAj//wAPAAEAAgAOAAAAAAAAAigAAgBZACUAPgABAEQAXgABAGoAagABAHAAcAABAHUAdQABAIEAgQABAIMAgwABAIYAhgABAIkAiQABAIsAlgABAJgAnwABAKEAowABAKUApgABAKgArQADALEAsQABALoAuwABAL8AvwABAMEAwQABAMMAxAABAMcAxwABAMsAywABAM0AzgABANAA0QABANMA0wABANoA3gABAOEA4QABAOUA5QABAOcA6QABAOsA+wABAP0A/QABAP8BAQABAQMBAwABAQgBCQABARYBGgABARwBHAABASABIgABASQBJwADASoBKwABATMBNAABATYBNgABATsBPAABAUEBRAABAUcBSAABAUsBTQABAVEBUQABAVQBWAABAV0BXgABAWIBYgABAWQBZAABAWgBaAABAWoBbAABAW4BbgABAXABcAABAdYB3AACAe0CAQABAgUCBQABAg4CDgABAhACEAABAhcCGQABAhsCHAABAh4CHgABAiICIgABAiQCJgABAiwCLAABAjECMwABAjUCNQABAkMCQwABAkYCRgABAkgCSAABAksCTgABAnoCfgABAo4CkwABApYC/gABAwEDwAABA8IDwgABA8QDzgABA9AD2QABA9sD9gABA/oD+gABA/wEAwABBAUEBwABBAoEDgABBBAEmwABBJ4EnwABBKEEogABBKQEpwABBLEFDQABBQ8FGQABBRwFKQABAAEAAwAAABAAAAAWAAAAIAABAAEArQACAAEAqACsAAAAAgACAKgArAAAASQBJwAFAAEAAAAaADQACgAHAEQAXABmAEwAVABwAHoABERGTFQAdGN5cmwAdGdyZWsAdGxhdG4AdAAEY3BzcABea2VybgBkbWFyawBsbWttawB0AAEAAAABAGIABAAAAAEAZAAEAAAAAQBoAAIACAACAMIEogACAAgAAgB6AJYABgAQAAEAWAAAAAYAEAABAFoAAgBqAAAAAAABAAAAAAACAAIAAQAAAAIAAwAEAAAAAgAFAAYAARXGAAUAJABIAAERLhISAAERNDgKAAERXBPSAAERbEsMAAERFhEWAAERHBEiAAERRBEmAAERVBE4AAERJAAEAAAAAhEOERQAAP//AAQAAAABAAIAAwACEVIABAAAEXYRngADAAMAAP+v/4gAAP8sAAAAAP+IAAAAAV4oAAQAAAHrGjgXYBdgHmYeDBewF+4YwBfSWooZABkAHCAYEhkAGQAYwBkiJ0IgAiZ4GAAYKB2yH5AYPhtKGN4YiBecMJYXfi10F7oXuhlqGIgX4B8qGKIYVBdmGKIbkBiIGMAgeCWyHQYYwB4MLHYudim8JEoXSBiiF4hRFBe6RCQrhC94GG4XThdUU/4XWhrSGmYg+kYWNFhAdDMKGQA9HEhIHbIoEBkAGQAb1hkAGQAZAD7GIYQZABoOJOwjJh7IKp4juBemKOYXZhmQQkpW/BiIGwwxzCIOGUQYiCKYGbodXBqcGUQeDBlqGAAYohnkGIglshemHbIXZhwgHCAcIBkAHbIXZhkAGQAYwBemHbIXZhdgNfoXYBdgF2AXeBxqHLgXcheSF2wXchdsF8QXbBfuGMAYwBjAGMAmeB4MHgweDB4MHgweDB4MF+4X0hfSF9IX0hkAGQAZABkAGQAYwBjAGMAYwBjAH5AY3hjeGN4Y3hjeGN4Y3hecF5wXnBecF7oZahlqGWoZahlqGKIYoh4MGN4eDBjeHgwY3hfuF+4X7hfuGMAX0hecF9IXnBfSF5wX0hecF9IXnBkAF7oZABkAGQAZABkAHCAYEhgSGBIYEhkAF7oZABe6GQAXuhe6GMAZahjAGWoYwBlqF+AX4BfgJngmeCZ4GCgfkBiiH5AYPhg+GD4XchdyF3gXbBdsF2wXbBdsF2wXbBdyF3IXchdyF3IXbBdsF2wXcheSF5IXkheSF3IXchdyF3geDBfSGQAZABjAH5AeDBewF9IYPhkAGQAcIBkAGQAYwBkiJngfkB2yGQAfkBe6GWoYohlqF9IlshkAGQAcIBwgG9YeDBewJbIX0hkAGQAYwBkiF+4meB2yGN4XnBlqGIgYohdmF5wXphiiGCgYKBgoH5AYohdgF2AXYBkAF7oeDBjeF9IXnBgAGKIX7h+QGKIZAB2yF2YZAB4MGN4eDBjeF9IXnBecF5wdshdmGMAZahlqGIgb1hiiG9YYohvWGKIeDBjeHgwY3h4MGN4eDBjeHgwY3h4MGN4eDBjeHgwY3h4MGN4eDBjeHgwY3h4MGN4X0hecF9IXnBfSF5wX0hecF9IXnBfSF5wX0hecF9IXnBkAGQAYwBlqGMAZahjAGWoYwBlqGMAZahjAGWoYwBlqGWofkBiiH5AYoh+QGKImeCWyF6YXuhoOJbIcIB+QGQAXuh4MGN4X0hkAGMAZahfgF7AYiBjAGMAZABe6HCAcIBgSGQAXuhkAF7oYwBkiGIgX4CZ4GAAYohgAGKIYKBg+GMAXbBdyF2wXeBdsF3IXeAACXgYABAAAYaZqYgApACgAAAAAAAAAAAASAAAAAAAAAAAAAAAAAAD/5P/jAAAAEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAA/+QAEf/lAAAAAAAAAAAAEgAAAAAAAAAA/+sAAAAAAAAAAAAA/+0AAP/V/9AAAP/qAAAAAAAAAAAAAAAAAAD/6f+T//X/6gAAAAAAAP/hAAAAAAAAAAAAAAAA/+0AAP/rAAAAAP/x/+4AAP/1AAD/9P/1/84AAP/v/43/gv/xAAAAAP/E/4gAAAAA/8f/xgAAAAAAAP+tAAAAAAAMABEAAP/JABL/rAAA/90AAP+IAAAAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/zwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/88AAAAA/+0AAAAAAAAAAAAA/+3/7//mAAAAAAAAABQAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/tAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/iv/rAAAAAAAAAAAAAAAAAAAAAAAA//AAAAAAAAD/8AAAAAAAAAAA/4oAAAAA//MAAAAAAAAAAP/x//EAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAAAAAAAAAAAAAP9/AAAAAAAAAAAAAAAAAAAAAP/XAAAAAAAAAAAADwAAAAAAAAAAAAD/6gAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/6wAA/+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/oQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/6EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/6gAAAAAAAP/uAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAP/sAAAAAP+/AAAAAAAA/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9gAAAAAAAAAAP+//+P/2P+N/8v/u/+//9n/7P+r/6AAEgARAAAADf/GAAAAAP/p//D/8wARAAD/Jv/vABL/pwAA/+IAAAAAAAAAAAAA/6D/8/+rAAD/jQAA/+b/4f/xAAD/5wAA/+X/6f/YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+bAAAAAAAAAAAAAAAA/6MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//UAAAAAAAAAAAAAAAAAAAAA/+P/8QAAAAAAAAAAAAAAAAAAAAAAAP/xAAAAAAAA//IAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+b/5wAAAAD/5wAA/+v/6//hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADv+qAAAAAAARAAAAAAAR/9EAAAAAAAAAAAAAAAD/of/k/5r/ov+5/3v/df+s/7T/rwAAABAAEAAAAAD/mwAAAAD/s//w//EADwAA/xf/7QAQ/wn/vP/E/8sAAAAA/37/fP8Z//H/rwAA/6IAAP/FAAD/7P+IAAD/zv+4AAAAAAAAAAAAAAAAAAAAAP+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/68AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAAAAAAAAAAAAP/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAP/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/0r/vf8//zoAAP8//1D/Xv9sAAAAAAAHAAcAAAAA/0AAAAAA/2r/0QAAAAUAAP5hAAAAB/5JAAD/hv+SAAAAAP8P/wwAAAAAAAAAAP86AAAAAP+/AAAAE//yAAAAAP/f/38AE//V/wL/B//hAAAAAP9rAAAAAAAA/2v/gwAAAAAAAP9GAAAAAAAAAAAAAAAAAAAAAAAA/6sAEwAAABMAAP/hAAAAAP/V/+f/3//h/+0AAP/LAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAD/fgAAAAD/xAAAAAAAAAAAAAAAAAAAAAAAAP/LAAD/1QAA/+v/5gAAAA3/7AAA/+v/7f/lAA0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0AAAANAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8sAAAAAP/tAAAAAAAAAAD/3P/mAAAAEgAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAD/cwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAA/9T/8wAA/7X/2f/S/9L/5P/1/7QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8jAAAAAP+vAAAAAAAAAAAAAAAAAAAAAAAA/7QAAP+1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+8AAAAAAAAAAAAAAAAAAAAA/+wAAAAA/7QAAAAAAAD/uwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/1QAAAAAAAAAA//AAAAAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/63/MwAA//YAAAAA/8D/yQAAAAAAAAAAAAAAAP/IAAAAAAAA//n/6//nAAAAAAAAAAAAAP/AAAAAAP+9/+n/of+lAAD/nP+9AAAAAAAAAAAAEgASAAAAAP/SAAAAAAAAAAAAAAAAAAD+cQAAAAD/bAAAAAD/ygAAAAD/u//pAAAAAAAAAAD/pQAA/+wAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/84AAAAAAAAAAAAAAAAAAAAA/3n/8QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/3QAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/yf/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+gAAAAAAAAAAP/zAAAAAAAAAAAAAAAAAAAAAAAA//MAAAAA/2cAAP/1//MAAAAP/6wAAAAAAAAAAP/aAAAAAAAAAAAAAAAAAAD/4v6fAAAAAAAAAAAAAP+oAAAAAP/HAAD/PgAA/6wAAP9nAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAP/sAAAAAP+/AAAAAAAA/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9gAAAAAAAAAAP/FAAD/7P+IAAD/zv+4AAAAAAAAAAAAAAAAAAAAAP+sAAD/rwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/6//iAAAAAD/8f/uAAD/9QAA//T/9f/OAAD/7/+N/4L/8QAAAAD/xAAAAAAAAP/H/8YAAAAAAAD/rQAAAAAADAARAAD/yQAS/6wAAP/dAAD/iAAAAAEAAQCtAAEAAGekAAFnpAABABP/FwABACP/vAACAAEAqACsAAAAAQACABMAsgAFZ4hnjmeUZ5pnoAACAAIAqACsAAABJAEnAAUACQAAZ4oAAGeQAABnlgAAZ5wAAGeiAABnqAAAZ64AAGe0AABnugABABAABgALABAAEgCyAYUBhgGHAYgBiQGKAYsBjwGQA/cD+AACAAYAEAAQAAEAEgASAAEAsgCyAAIBhwGHAAEBiwGLAAEBjwGQAAEAAgAGAAYABgABAAsACwABALIAsgACAYUBhgABAYgBigABA/cD+AABAAIATAAlAD4AAABFAF4AGgCLAJYANACYAJsAQACdAJ0ARAC6ALsARQDBAMEARwDOAM4ASADbANsASQDdAN0ASgDvAO8ASwDyAPIATAEhASIATQFBAUIATwFMAU0AUQFYAVgAUwFiAWIAVAFkAWQAVQFqAWwAVgFuAW4AWQHtAgEAWgIOAg4AbwIYAhgAcAIbAhsAcQIsAiwAcgIyAjMAcwJDAkMAdQJGAkYAdgJIAkgAdwJLAk4AeAJ6An4AfAKOApMAgQKWAv4AhwMBAwEA8AMDA0YA8QNLA6gBNQOqA7oBkwO8A7wBpAO/A8ABpQPCA8IBpwPGA8YBqAPIA8kBqQPLA84BqwPQA9ABrwPSA9MBsAPVA9UBsgPXA9kBswPbA+ABtgPiA+cBvAPpA+wBwgPuA/YBxgP6A/oBzwP8BAAB0AQCBAIB1QQKBA4B1gQQBBAB2wQTBBcB3AQaBB4B4QQhBCIB5gQnBCgB6AQwBDAB6gQyBDIB6wQ0BDQB7AQ5BJMB7QSZBJsCSAShBKICSwSkBKUCTQSnBKcCTwSxBMACUATCBP4CYAUABQQCnQUGBQcCogUJBQkCpAULBQ0CpQUPBRcCqAUcBSkCsQACAE8AJQA+AAAARQBeABoAgQCBADQAgwCDADUAhgCGADYAiQCJADcAiwCWADgAmACdAEQAsQCxAEoAuwC7AEsAvwC/AEwAwQDBAE0AwwDDAE4AxwDHAE8AywDLAFAAzQDOAFEA0ADRAFMA0wDTAFUA2gDcAFYA3gDeAFkA4QDhAFoA5QDlAFsA5wDpAFwA6wD7AF8A/QD9AHAA/wEBAHEBAwEDAHQBCAEJAHUBFgEaAHcBHAEcAHwBIAEiAH0BKgErAIABQQFCAIIBSwFLAIQBWAFYAIUBYgFiAIYBZAFkAIcBaAFoAIgBagFsAIkBbgFuAIwB7QIBAI0CBQIFAKICEAIQAKMCFwIZAKQCHAIcAKcCHgIeAKgCIgIiAKkCJAImAKoCLAIsAK0CMQIxAK4CMwIzAK8CNQI1ALACQwJDALECRgJGALICSAJIALMCSwJOALQCegJ+ALgCjgKTAL0ClgL+AMMDAQOnASwDqQPAAdMDwgPCAesDxAPOAewD0APZAfcD2wP2AgED+gP6Ah0D/AQDAh4EBQQHAiYECgQOAikEEASYAi4EmwSbArcEngSfArgEoQSiAroEpASnArwEsQTsAsAE7gUNAvwFDwUWAxwFGAUZAyQFHAUpAyYAAQD7AAgACgAUABUAFgAXABgAGQAaABsAHAAdACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAgQCDAIQAjACPAJEAkwCxALIAswC0ALUAtgC3ALgAuQC6ANIA0wDUANUA1gDXANgA2QDaANsA3ADdAN4A3wDgAOEA4gDjAOQA5QDmAOcA6ADpAS8BMwE1ATcBOQE7AUEBQwFFAUkBSwFMAVgBWQFxAbIBuAG9AcAClgKXApkCmwKcAp0CngKfAqACoQKiAqMCpAKlAqYCpwKoAqkCqgKrAqwCrQKuAq8CsAKxArICswK0ArUC0gLUAtYC2ALaAtwC3gLgAuIC5ALmAugC6gLsAu4C8ALyAvQC9gL4AvoC/AL+Av8DAQMDAwUDBwMJAwsDDQMPAxEDFAMWAxgDGgMcAx4DIAMiAyQDJgMoAyoDLAMuAzADMgM0AzYDOAM6AzwDPgNAA0EDQwNFA0cDSQOiA6MDpAOlA6YDpwOoA6oDqwOsA60DrgOvA7ADsQOyA7MDtAO1A7YDtwO4A7kDyQPKA8sDzAPNA84DzwPQA9ED0gPTA9QD1QPWA9cD2APZA9oD2wPcA90D3gPvA/ED8wP1BAoEDAQOBCMEKQQvBJkEngSiBSMFJQABAMQADgABAPb/zQABAMoAEwABAPb/3AABAFsACwABARz/8QABAfH/xwABAfH/8QABAfEADQACAPb/yAGG/6cAAgDK//QA9v/YAAIB8f+3Afb/8AACAPb/9QGG/7YAAgDt/6UBHP/uAAIBEQALAWz/5gACAPb/yAGG/6EAAwHw//UB8f/uA5z/9QADAEr/7gBb/+oB8f/wAAMASgARAFgAMgBbABEABAAN/+YAQf/0AGH/7wFN/+0ABAANABQAQQARAFb/4gBhABMABQBb/7MB8f95Afb/8QIA//ECTP/zAAUADQAPAEEADABW/+sAYQAOAkz/6QAFAFv/5QC4/8sAzf/kAgD/6wJM/+0ABgAQ/4QAEv+EAYf/hAGL/4QBj/+EAZD/hAAGAMr/6gDt/+4A9v+6AP7/+QE6/+wBbf/sAAYAyv/qAO3/7gD2/74A/v/5ATr/7AFt/+wABwBKAA0Avv/5AMYACwDH/+oAygAMAO3/yAEc//EABwCB/98Atf/zALf/8ADE/+oA2f/fAOb/4AFs/+AACAD2//AA/v/6AQn/8QEg//MBOv/xAWP/8wFl/+0Bbf/eAAgA2QAVAO0AFQFJ/+QBSv/lAUz/5AFi/+MBZP/iAWz/5AAIAFgADgCB/1YAvv/5AMT/xADH/9oA2f9xAO3/ngFf/9wACQD2/50A/v/rAQn/0wEg/9sBOv8+AUr/ugFj//ABZf/yAW3/UAAJAMr/6gDt/7gA9v/nAQn/8AEg//EBOv/rAWP/9QFt/+wBhv+kAAoABv/1AAv/9QGF//UBhv/1AYj/9QGJ//UBiv/1A/f/9QP4//UD+//1AAoABv/WAAv/1gGF/9YBhv/WAYj/1gGJ/9YBiv/WA/f/1gP4/9YD+//WAAoABv/qAAv/6gGF/+oBhv/qAYj/6gGJ/+oBiv/qA/f/6gP4/+oD+//qAAoA5v/DAPb/zwD+//ABOv/OAUn/5wFM/98BYv/RAWT/7AFs/6ABbf/RAAsAOP/RANL/0QDW/9EBOf/RAUX/0QMq/9EDLP/RAy7/0QPd/9EEk//RBNv/0QANAFz/8gBe//IA7v/yATT/8gFE//IBXv/yA0L/8gNE//IDRv/yA+b/8gQS//IEIP/yBOX/8gANAPb/mgD5/9YA/v/yAQn/0wEg/9sBOv8+AUj/1gFK/7oBY//wAWX/8gFt/1AENv/WBJb/1gAOAFz/7QBe/+0A7v/tAPb/sgE0/+0BRP/tAV7/7QNC/+0DRP/tA0b/7QPm/+0EEv/tBCD/7QTl/+0ADwDtABQA8gAQAPb/8AD5//AA/v/6AQEAEAEEABABOv/sAUj/8AFK/+IBUQAQAW3/8AFwABAENv/wBJb/8AARAC7/7gA5/+4Csf/uArL/7gKz/+4CtP/uAwH/7gMw/+4DMv/uAzT/7gM2/+4DOP/uAzr/7gPO/+4Efv/uBID/7gTd/+4AEQAu/+wAOf/sArH/7AKy/+wCs//sArT/7AMB/+wDMP/sAzL/7AM0/+wDNv/sAzj/7AM6/+wDzv/sBH7/7ASA/+wE3f/sABIA2f+uAOYAEgDr/+AA7f+tAO//1gD9/98BAf/SAQf/4AEc/84BLv/dATD/4gE4/+ABQP/gAUr/6QFN/9oBX/+9AWn/3wFsABEAEgBb/8EAuP/FAMr/tADq/9cA9v+5AP7/6QEJ/7IBHP/SASD/yAE6/6ABSv/FAVj/5AFj/8wBZf/MAW3/ywFu/+8CAP/mAkz/6AATAe7/7gHw//UB8f/xAfP/8gIP//ICE//yAiv/8gIt/+4CL//yA2j/7gOU//IDnP/1A53/7gOe/+4E7P/uBPr/7gT9/+4FEf/yBRb/7gATAe7/5QHw//EB8f/rAfP/6QIP/+kCE//pAiv/6QIt/+UCL//pA2j/5QOU/+kDnP/xA53/5QOe/+UE7P/lBPr/5QT9/+UFEf/pBRb/5QAVAFj/7wBb/98Amv/uALj/5QC5/9EAxAARAMr/yADZABMA5v/FAPb/ygE6/5QBSf9YAUr/fwFM/6UBTf/dAVj/8gFi/4sBZP/KAWz/cAFt/6IB8f/NABUAXP/tAO7/7QD2/6EA+f/RAP7/7wEJ/9MBIP/bATT/7QE6/z4BRP/tAUj/0QFK/7oBXv/tAWP/8AFl//IBbf9QA+b/7QQS/+0EIP/tBDb/0QSW/9EAFgC4/9QAvv/2AML/7QDEABEAyv/gAMz/5wDN/+UAzv/uANkAEgDq/+kA9v/XATr/1wFK/9MBTP/WAU3/xQFY/+cBYgANAWQADAFt/9YBbv/yAfb/6QJM/+kAFgAj/7wAWP/vAFv/3wCa/+4AuP/lALn/0QDEABEAyv/IANkAEwDm/8UA9v/KATr/lAFJ/1gBSv9/AUz/pQFN/90BWP/yAWL/iwFk/8oBbP9wAW3/ogHx/80AGAA6ABQAOwAZAD0AFgEZABQCtQAWAzwAGQM+ABYDQAAWA6cAFgO2ABYDuQAWA+8AGQPxABkD8wAZA/UAFgQGABQEDgAWBIwAFgSOABYEkAAWBKIAFgTeABQE4AAUBOIAGQAYADj/6wA9//MA0v/rANb/6wE5/+sBRf/rArX/8wMq/+sDLP/rAy7/6wM+//MDQP/zA6f/8wO2//MDuf/zA93/6wP1//MEDv/zBIz/8wSO//MEkP/zBJP/6wSi//ME2//rABkAU//oARj/6AGGAAkCx//oAsj/6ALJ/+gCyv/oAsv/6AMV/+gDF//oAxn/6APA/+gDxv/oA+L/6AQo/+gELP/oBGf/6ARp/+gEa//oBG3/6ARv/+gEcf/oBHP/6AR7/+gEvP/oABwACv/iAA0AFAAO/88AQQASAEr/6gBW/9gAWP/qAGEAEwBt/64AfP/NAIH/oACG/8EAif/AALj/0AC8/+oAvv/1AL//xgDAAA0Awv/pAMP/1gDG/+gAx/+6AMr/6QDM/8sAzf/aAM7/xwGO/9MCTP/NAB0AOP+7ADr/7QA9/9AA0v+7ANb/uwEZ/+0BOf+7AUX/uwK1/9ADKv+7Ayz/uwMu/7sDPv/QA0D/0AOn/9ADtv/QA7n/0APd/7sD9f/QBAb/7QQO/9AEjP/QBI7/0ASQ/9AEk/+7BKL/0ATb/7sE3v/tBOD/7QAgAAb/8gAL//IAWv/zAF3/8wC9//MA9v/1ARr/8wGF//IBhv/yAYj/8gGJ//IBiv/yAtD/8wLR//MDP//zA8L/8wPl//MD7v/zA/b/8wP3//ID+P/yA/v/8gQH//MED//zBDD/8wQy//MENP/zBI3/8wSP//MEkf/zBN//8wTh//MAIgBa//QAXP/yAF3/9ABe//MAvf/0AO7/8gEa//QBNP/yAUT/8gFe//IC0P/0AtH/9AM///QDQv/zA0T/8wNG//MDwv/0A+X/9APm//ID7v/0A/b/9AQH//QED//0BBL/8gQg//IEMP/0BDL/9AQ0//QEjf/0BI//9ASR//QE3//0BOH/9ATl//MAIgAG/8AAC//AADr/yADe/+sA4f/nAOb/wwD2/84A/v/wARn/yAE6/80BR//nAUn/5wFM/98BYv/RAWT/7AFs/6ABbf/QAYX/wAGG/8ABiP/AAYn/wAGK/8AD0f/rA/f/wAP4/8AD+//ABAb/yAQv/+sEMf/rBDP/6wQ1/+cElf/nBN7/yATg/8gAIgBa/9IAXf/SAL3/0gD2/6UA+f/hAP7/+gEJ/9MBGv/SASD/2wE6/00BSP/hAUr/uwFj//gBZf/zAW3/XwLQ/9IC0f/SAz//0gPC/9ID5f/SA+7/0gP2/9IEB//SBA//0gQw/9IEMv/SBDT/0gQ2/+EEjf/SBI//0gSR/9IElv/hBN//0gTh/9IAIwBa//QAXP/wAF3/9AC9//QA7f/vAO7/8ADy//MA/v/5AQT/8wEa//QBNP/wAUT/8AFR//MBXv/wAXD/8wLQ//QC0f/0Az//9APC//QD5f/0A+b/8APu//QD9v/0BAf/9AQP//QEEv/wBCD/8AQw//QEMv/0BDT/9ASN//QEj//0BJH/9ATf//QE4f/0ACQAOP/iADz/5ADS/+IA1P/kANb/4gDZ/+EA2v/kAN3/5ADe/+kA7f/kAPL/6wEE/+sBM//kATn/4gFD/+QBRf/iAVD/5AFR/+sBXf/kAWb/5AFv/+QBcP/rAyr/4gMs/+IDLv/iA7f/5APR/+kD3f/iA97/5AQR/+QEH//kBC//6QQx/+kEM//pBJP/4gTb/+IAJAAG//IAC//yAFr/9QBd//UAvf/1APb/9AD+//wBCf/1ARr/9QE6//UBbf/1AYX/8gGG//IBiP/yAYn/8gGK//IC0P/1AtH/9QM///UDwv/1A+X/9QPu//UD9v/1A/f/8gP4//ID+//yBAf/9QQP//UEMP/1BDL/9QQ0//UEjf/1BI//9QSR//UE3//1BOH/9QAoABD/LQAS/y0AJf/NALL/zQC0/80Ax//yAQ3/zQGH/y0Bi/8tAY//LQGQ/y0Cm//NApz/zQKd/80Cnv/NAp//zQKg/80Cof/NAtL/zQLU/80C1v/NA6L/zQOq/80D0v/NA/7/zQQU/80EFv/NBDr/zQQ8/80EPv/NBED/zQRC/80ERP/NBEb/zQRI/80ESv/NBEz/zQRO/80EUP/NBLX/zQAxADj/4wA8/+UAPf/kANL/4wDU/+UA1v/jANn/4gDa/+UA3f/lAN7/6QDy/+oBBP/qATP/5QE5/+MBQ//lAUX/4wFQ/+UBUf/qAV3/5QFm/+UBbP/kAW//5QFw/+oCtf/kAyr/4wMs/+MDLv/jAz7/5ANA/+QDp//kA7b/5AO3/+UDuf/kA9H/6QPd/+MD3v/lA/X/5AQO/+QEEf/lBB//5QQv/+kEMf/pBDP/6QSM/+QEjv/kBJD/5AST/+MEov/kBNv/4wAxAFb/cwBb/5IAbf4vAHz+qQCB/rYAhv8+AIn/SwC4/2cAvv+5AL//DwDD/vQAxv8rAMf+8QDK/1IAzP75AM3/AwDO/uwA2f9YAOYABQDq/70A6/9JAO3+/gDv/xMA9v9oAP3/DgD+/0YA//8TAQH/BwECABIBB/8OAQn/EQEc/x0BIP+sAS7/FQEw/zwBOP8OATr/agFA/0kBSv8MAUz/PwFN/vEBWP/AAV/+7wFj/zEBZf9fAWn/CgFsAAUBbf8wAW7/1QAyAAT/0QBW/7kAW//LAG3++gB8/0IAgf9JAIb/mQCJ/6EAuP+yAL7/3QC//34Aw/9uAMb/jgDH/2wAyv+lAMz/cQDN/3cAzv9pANn/qQDmAA8A6v/kAOv/oADt/3QA7/+AAPb/sgD9/30A/v+eAP//gAEB/3kBAgAPAQf/fQEJ/38BHP+GASD/2gEu/4EBMP+YATj/fQE6/7MBQP+gAUr/fAFM/5oBTf9sAVj/5gFf/2sBY/+SAWX/rQFp/3sBbAAPAW3/kQFu//IAMwA4/9kAOv/kADv/7AA9/90A0v/ZANb/2QEZ/+QBOf/ZAUX/2QIGAA4CCAAOAk4ADgK1/90DKv/ZAyz/2QMu/9kDPP/sAz7/3QNA/90DTgAOA08ADgNQAA4DUQAOA1IADgNTAA4DVAAOA2kADgNqAA4DawAOA6f/3QO2/90Duf/dA93/2QPv/+wD8f/sA/P/7AP1/90EBv/kBA7/3QSM/90Ejv/dBJD/3QST/9kEov/dBNv/2QTe/+QE4P/kBOL/7ATnAA4E7gAOBQYADgA1ABv/8gA4//EAOv/0ADz/9AA9//AA0v/xANT/9QDW//EA2v/0AN3/9QDe//MA5v/xARn/9AEz//QBOf/xAUP/9AFF//EBUP/1AV3/9AFi//IBZP/yAWb/9QFs//IBb//1ArX/8AMq//EDLP/xAy7/8QM+//ADQP/wA6f/8AO2//ADt//0A7n/8APR//MD3f/xA97/9AP1//AEBv/0BA7/8AQR//QEH//0BC//8wQx//MEM//zBIz/8ASO//AEkP/wBJP/8QSi//AE2//xBN7/9ATg//QANQBR//kAUv/5AFT/+QDB//kA7P/5AO0AFADw//kA8f/5APP/+QD0//kA9f/5APb/7QD4//kA+f/tAPr/+QD7//kA/P/bAP7/+QEA//kBBf/5ASv/+QE2//kBOv/tATz/+QE+//kBSP/tAUr/7QFT//kBVf/5AVf/+QFc//kBbf/tAsb/+QMO//kDEP/5AxL/+QMT//kDvP/5A+H/+QPj//kD6P/5A+3/+QP9//kEA//5BCT/+QQm//kENv/tBDj/+QSW/+0EmP/5BLT/+QTR//kE0//5ADgAJf/kADz/0gA9/9MAsv/kALT/5ADE/+IA2v/SAQ3/5AEz/9IBQ//SAV3/0gKb/+QCnP/kAp3/5AKe/+QCn//kAqD/5AKh/+QCtf/TAtL/5ALU/+QC1v/kAz7/0wNA/9MDov/kA6f/0wOq/+QDtv/TA7f/0gO5/9MD0v/kA97/0gP1/9MD/v/kBA7/0wQR/9IEFP/kBBb/5AQf/9IEOv/kBDz/5AQ+/+QEQP/kBEL/5ARE/+QERv/kBEj/5ARK/+QETP/kBE7/5ARQ/+QEjP/TBI7/0wSQ/9MEov/TBLX/5AA5AFH/7wBS/+8AVP/vAFz/8ADB/+8A7P/vAO3/7gDu//AA8P/vAPH/7wDz/+8A9P/vAPX/7wD2/+4A+P/vAPr/7wD7/+8A/v/vAQD/7wEF/+8BCf/0ASD/8QEr/+8BNP/wATb/7wE6/+8BPP/vAT7/7wFE//ABU//vAVX/7wFX/+8BXP/vAV7/8AFt/+8Cxv/vAw7/7wMQ/+8DEv/vAxP/7wO8/+8D4f/vA+P/7wPm//AD6P/vA+3/7wP9/+8EA//vBBL/8AQg//AEJP/vBCb/7wQ4/+8EmP/vBLT/7wTR/+8E0//vADwABv/DAAv/wwBK//EAWf/3AFr/2wBd/9sAm//3AL3/2wDC//UAxAAKAMb/8wDK/3IAy//3ARr/2wGF/8MBhv/DAYj/wwGJ/8MBiv/DAsz/9wLN//cCzv/3As//9wLQ/9sC0f/bAzH/9wMz//cDNf/3Azf/9wM5//cDO//3Az//2wO+//cDwv/bA8X/9wPH//cD5f/bA+7/2wP2/9sD9//DA/j/wwP7/8MEB//bBA//2wQw/9sEMv/bBDT/2wR///cEgf/3BIP/9wSF//cEh//3BIn/9wSL//cEjf/bBI//2wSR/9sEwP/3BN//2wTh/9sAPwAn//MAK//zADP/8wA1//MAg//zAJP/8wCY//MAs//zAMQADQDT//MBCP/zARf/8wEb//MBHf/zAR//8wEh//MBQf/zAWr/8wJg//MCYf/zAmP/8wJk//MCov/zAqz/8wKt//MCrv/zAq//8wKw//MC2P/zAtr/8wLc//MC3v/zAuz/8wLu//MC8P/zAvL/8wMU//MDFv/zAxj/8wNJ//MDpv/zA7P/8wPZ//MD3P/zBAn/8wQM//MEJ//zBCn/8wQr//MEZv/zBGj/8wRq//MEbP/zBG7/8wRw//MEcv/zBHT/8wR2//MEeP/zBHr/8wR8//MEu//zBNT/8wBAAEf/7ABI/+wASf/sAEv/7ABV/+wAlP/sAJn/7AC7/+wAyP/sAMn/7AD3/+wBA//sAR7/7AEi/+wBQv/sAWD/7AFh/+wBa//sAr3/7AK+/+wCv//sAsD/7ALB/+wC2f/sAtv/7ALd/+wC3//sAuH/7ALj/+wC5f/sAuf/7ALp/+wC6//sAu3/7ALv/+wC8f/sAvP/7AO6/+wD4P/sA+T/7APn/+wEAv/sBAj/7AQN/+wEG//sBB3/7AQe/+wEKv/sBDn/7ART/+wEVf/sBFf/7ARZ/+wEW//sBF3/7ARf/+wEYf/sBHX/7AR3/+wEef/sBH3/7AS4/+wExf/sBMf/7ABAACf/5gAr/+YAM//mADX/5gCD/+YAk//mAJj/5gCz/+YAuP/CAMQAEADT/+YBCP/mARf/5gEb/+YBHf/mAR//5gEh/+YBQf/mAWr/5gJg/+YCYf/mAmP/5gJk/+YCov/mAqz/5gKt/+YCrv/mAq//5gKw/+YC2P/mAtr/5gLc/+YC3v/mAuz/5gLu/+YC8P/mAvL/5gMU/+YDFv/mAxj/5gNJ/+YDpv/mA7P/5gPZ/+YD3P/mBAn/5gQM/+YEJ//mBCn/5gQr/+YEZv/mBGj/5gRq/+YEbP/mBG7/5gRw/+YEcv/mBHT/5gR2/+YEeP/mBHr/5gR8/+YEu//mBNT/5gBHABAABAASAAQAR//nAEj/5wBJ/+cAS//nAFX/5wCU/+cAmf/nALv/5wDEAA8AyP/nAMn/5wD3/+cBA//nAR7/5wEi/+cBQv/nAWD/5wFh/+cBa//nAYcABAGLAAQBjwAEAZAABAK9/+cCvv/nAr//5wLA/+cCwf/nAtn/5wLb/+cC3f/nAt//5wLh/+cC4//nAuX/5wLn/+cC6f/nAuv/5wLt/+cC7//nAvH/5wLz/+cDuv/nA+D/5wPk/+cD5//nBAL/5wQI/+cEDf/nBBv/5wQd/+cEHv/nBCr/5wQ5/+cEU//nBFX/5wRX/+cEWf/nBFv/5wRd/+cEX//nBGH/5wR1/+cEd//nBHn/5wR9/+cEuP/nBMX/5wTH/+cATQAGABAACwAQAA0AFABBABIAR//oAEj/6ABJ/+gAS//oAFX/6ABhABMAlP/oAJn/6AC7/+gAyP/oAMn/6AD3/+gBA//oAR7/6AEi/+gBQv/oAWD/6AFh/+gBa//oAYUAEAGGABABiAAQAYkAEAGKABACvf/oAr7/6AK//+gCwP/oAsH/6ALZ/+gC2//oAt3/6ALf/+gC4f/oAuP/6ALl/+gC5//oAun/6ALr/+gC7f/oAu//6ALx/+gC8//oA7r/6APg/+gD5P/oA+f/6AP3ABAD+AAQA/sAEAQC/+gECP/oBA3/6AQb/+gEHf/oBB7/6AQq/+gEOf/oBFP/6ARV/+gEV//oBFn/6ARb/+gEXf/oBF//6ARh/+gEdf/oBHf/6AR5/+gEff/oBLj/6ATF/+gEx//oAE8ARwABAEgAAQBJAAEASwABAFUAAQCUAAEAmQABALsAAQDIAAEAyQABAO0AKwDyABQA9v/jAPcAAQD5//AA/P/mAP7/9QEDAAEBBAAUAR4AAQEiAAEBOv/TAUIAAQFI//ABSv/fAVEAFAFgAAEBYQABAWsAAQFt/+MBcAAUAr0AAQK+AAECvwABAsAAAQLBAAEC2QABAtsAAQLdAAEC3wABAuEAAQLjAAEC5QABAucAAQLpAAEC6wABAu0AAQLvAAEC8QABAvMAAQO6AAED4AABA+QAAQPnAAEEAgABBAgAAQQNAAEEGwABBB0AAQQeAAEEKgABBDb/8AQ5AAEEUwABBFUAAQRXAAEEWQABBFsAAQRdAAEEXwABBGEAAQR1AAEEdwABBHkAAQR9AAEElv/wBLgAAQTFAAEExwABAFMAOP++AFH/9QBS//UAVP/1AFr/7wBd/+8Avf/vAMH/9QDS/74A1v++AOb/yQDs//UA8P/1APH/9QDz//UA9P/1APX/9QD2/98A+P/1APr/9QD7//UA/v/1AQD/9QEF//UBCf/tARr/7wEg/+sBK//1ATb/9QE5/74BOv/fATz/9QE+//UBRf++AUz/6QFT//UBVf/1AVf/9QFc//UBY//1AW3/4ALG//UC0P/vAtH/7wMO//UDEP/1AxL/9QMT//UDKv++Ayz/vgMu/74DP//vA7z/9QPC/+8D3f++A+H/9QPj//UD5f/vA+j/9QPt//UD7v/vA/b/7wP9//UEA//1BAf/7wQP/+8EJP/1BCb/9QQw/+8EMv/vBDT/7wQ4//UEjf/vBI//7wSR/+8Ek/++BJj/9QS0//UE0f/1BNP/9QTb/74E3//vBOH/7wBoADj/MwA6/8gAPP/wAD3/rABR/+8AUv/vAFT/7wDB/+8A0v8zANT/9QDW/zMA2v/wAN3/9QDe/+sA4f/mAOb/wgDs/+8A8P/vAPH/7wDz/+8A9P/vAPX/7wD2/84A+P/vAPr/7wD7/+8A/v/vAQD/7wEF/+8BGf/IASv/7wEz//ABNv/vATn/MwE6/80BPP/vAT7/7wFD//ABRf8zAUf/5gFJ/+YBTP/fAVD/9QFT/+8BVf/vAVf/7wFc/+8BXf/wAWL/0AFk/+sBZv/1AWz/nwFt/9ABb//1ArX/rALG/+8DDv/vAxD/7wMS/+8DE//vAyr/MwMs/zMDLv8zAz7/rANA/6wDp/+sA7b/rAO3//ADuf+sA7z/7wPR/+sD3f8zA97/8APh/+8D4//vA+j/7wPt/+8D9f+sA/3/7wQD/+8EBv/IBA7/rAQR//AEH//wBCT/7wQm/+8EL//rBDH/6wQz/+sENf/mBDj/7wSM/6wEjv+sBJD/rAST/zMElf/mBJj/7wSi/6wEtP/vBNH/7wTT/+8E2/8zBN7/yATg/8gAaABH/7QASP+0AEn/tABL/7QATAAUAE8AFABQABQAU/96AFX/tABX/2QAWwALAJT/tACZ/7QAu/+0AMj/tADJ/7QA9/+0AQP/tAEY/3oBHv+0ASL/tAFC/7QBYP+0AWH/tAFr/7QB3P9kAr3/tAK+/7QCv/+0AsD/tALB/7QCx/96Asj/egLJ/3oCyv96Asv/egLZ/7QC2/+0At3/tALf/7QC4f+0AuP/tALl/7QC5/+0Aun/tALr/7QC7f+0Au//tALx/7QC8/+0AxX/egMX/3oDGf96AyH/ZAMj/2QDJf9kAyf/ZAMp/2QDuv+0A8D/egPG/3oD4P+0A+L/egPk/7QD5/+0A+n/ZAQC/7QECP+0BA3/tAQb/7QEHf+0BB7/tAQo/3oEKv+0BCz/egQ5/7QEU/+0BFX/tARX/7QEWf+0BFv/tARd/7QEX/+0BGH/tARn/3oEaf96BGv/egRt/3oEb/96BHH/egRz/3oEdf+0BHf/tAR5/7QEe/96BH3/tAS4/7QEvP96BMX/tATH/7QEyQAUBMsAFATNABQE2v9kAr9EFkMCQzJB9EQiQ/hD/kMIRC5C/ESCQh5DJkQKRR5EuEEuREBC9kPOROhE7kMUQ+xD5kLYRBxBNEM4Q8hEKEE6RARD4EQ0QyBEiEQ0QyxEEEQ6RL5BQERGQw5CbERMRPRDGkPyQ8JCckPIQUZENELqQUxBUkQKRBBBWEFeRDRBZEOAQ4ZDpERMQ0RC0kLeQuRC8ENKQWpDUEFwQXZBfEG4QYJD1EPaQz5BiEGOQaBBlEGaQaBFKkWiRWxFnEQQQsxFZkU2QrRBpkVgRZBFMEVaQqJFSEVCRTxFeEKEQaxFJEVyQbJBuEWEQb5FbEHERIhCfkV+RVRFTkMgQcpENEHQRDRB1kWKQdxFkEHiRTBB9EH0Q+BDzkJsRBZEFkQWRBZEFkQWRBZB6EQiRCJEIkQiRC5ELkQuRC5ECkUeRR5FHkUeRR5E6EToROhE6EPmRBxEHEQcRBxEHEQcRBxB7kQoRChEKEQoRDRENEQ0RDREEEQ6RDpEOkQ6RDpETERMRExETEPCQ8JEFkQcRBZEHEQWRBxDMkM4QzJDOEMyQzhDMkM4QfRDyEQiRChEIkQoRCJEKEQiRChEIkQoQ/5EBEP+RARD/kQEQfpEBEMIQ+BELkQ0RC5ENEQuRDRCAEQ0RC5C/EIGQgxCHkQ0QhJCGEIeRDRCHkQ0RApEEEIkQipECkQQRBBFHkQ6RR5EOkUeRDpEQERGQjBCNkRAREZC9kMOQvZDDkI8QkJCSEJOQvZDDkJUQlpCYEJmQ85CbEToRExE6ERMROhETEToRExE6ERMROhETEMUQxpD5kPCQ+ZC2EJyQthCckLYQnJCfkJ+RWZFTkVORU5FTkVORU5FTkJ4RWxFbEVsRWxFPEU8RTxFPEUwRZBFkEWQRZBFkELMQsxCzELMRaJFTkVORU5FfkV+RX5FfkJ+RWxFbEVsRWxFbEKEQoRChEKKRXhFPEU8RTxCkEU8RUJClkKiQpxCokKiRTBCqEUwRZBFkEWQQrRCrkK0RTZFNkK6RTZCwEVmQsZCzELMQsxCzELMQsxFnEWiRaJFKkUqRSpEFkQiQwhELkUeQ+ZC0kQWQwJEIkLYQwhELkSCQyZECkUeRLhDzkPmQ+xELkPmQt5C5ELqRDpE9EQ6QvBEIkL2RC5ELkL8RIJEFkMCRCJDJkMIRR5EuEMyQ85D7EQcRChEOkS+QzhDwkPyRChDDkQ0RDRDIEPCQxRDGkMUQxpDFEMaQ+ZDwkMgQyZDLEQWRBxEIkQoQ0pDUEMyQzhD5kQuRC5EFkQcRBZEHEQiRChDPkNEQ0RDSkNQRR5EOkPCQ8JDwkPIQ1ZDXEQWRBxEFkQcRBZEHEQWRBxEFkQcQ1ZDXEQWRBxEFkQcRBZEHEQWRBxDVkNcQ2JDaEQiRChEIkQoRCJEKEQiRChEIkQoRCJEKENiQ2hELkQ0Q25FzEN0Q3pFHkQ6RR5EOkUeRDpFHkQ6RR5EOkN0Q3pDgEOGQ4BDhkOAQ4ZDgEOGQ4xDkkOYQ55E6ERMQ6RETEOkRExDpERMQ6RETEOqQ7BDtkO8Q+ZDwkPmQ8JDyEPOQ9RD2kPgRIhD5kPsQ/JD+EP+RARECkQQRBZEHEQiRChELkQ0RR5EOkRAREZE6ERMRFJEWEReRGREakRwRHZEfESCRIhEjkSURJpFzESgRKZErESyRR5EuES+RMREykTQRNZE3ETiROhE7kT0RPpFAEUGRQxFEkUYRR5FTkVsRXhFPEWQRaJFJEVORVRFbEUqRXhFPEVIRVpFMEWQRWBFZkWiRWxFPEWiRWxFNkU8RTxFQkVIRU5FVEVsRVpFeEWQRWBFfkVmRWxFckV4RX5FokWERYpFkEWWRZxFnEWcRaJFqEWuRbRFukXARcZFzABqADj/5gA6/+cAPP/yAD3/5wBR//EAUv/xAFT/8QBc//EAwf/xANL/5gDW/+YA2v/yAN7/7gDh/+gA5v/mAOz/8QDu//EA8P/xAPH/8QDz//EA9P/xAPX/8QD2/9AA+P/xAPr/8QD7//EA/v/xAQD/8QEF//EBGf/nASv/8QEz//IBNP/xATb/8QE5/+YBOv/OATz/8QE+//EBQ//yAUT/8QFF/+YBR//oAUn/6AFT//EBVf/xAVf/8QFc//EBXf/yAV7/8QFi/+cBZP/tAWz/5gFt/9ACtf/nAsb/8QMO//EDEP/xAxL/8QMT//EDKv/mAyz/5gMu/+YDPv/nA0D/5wOn/+cDtv/nA7f/8gO5/+cDvP/xA9H/7gPd/+YD3v/yA+H/8QPj//ED5v/xA+j/8QPt//ED9f/nA/3/8QQD//EEBv/nBA7/5wQR//IEEv/xBB//8gQg//EEJP/xBCb/8QQv/+4EMf/uBDP/7gQ1/+gEOP/xBIz/5wSO/+cEkP/nBJP/5gSV/+gEmP/xBKL/5wS0//EE0f/xBNP/8QTb/+YE3v/nBOD/5wBrACUADwA4/+YAOv/mADwADgA9/+YAsgAPALQADwDS/+YA1AAOANb/5gDZABMA2gAOAN0ADgDeAAsA4f/lAOb/5gDn//QA7QASAPIADwD2/+cA+f/oAP7/9wEEAA8BDQAPARn/5gEzAA4BOf/mATr/5wFDAA4BRf/mAUf/5QFI/+gBSf/lAUr/6AFM/+QBUAAOAVEADwFdAA4BYv/mAWT/5gFmAA4BbP/mAW3/5wFvAA4BcAAPApsADwKcAA8CnQAPAp4ADwKfAA8CoAAPAqEADwK1/+YC0gAPAtQADwLWAA8DKv/mAyz/5gMu/+YDPv/mA0D/5gOiAA8Dp//mA6oADwO2/+YDtwAOA7n/5gPRAAsD0gAPA93/5gPeAA4D9f/mA/4ADwQG/+YEDv/mBBEADgQUAA8EFgAPBB8ADgQvAAsEMQALBDMACwQ1/+UENv/oBDoADwQ8AA8EPgAPBEAADwRCAA8ERAAPBEYADwRIAA8ESgAPBEwADwROAA8EUAAPBIz/5gSO/+YEkP/mBJP/5gSV/+UElv/oBKL/5gS1AA8E2//mBN7/5gTg/+YAdQAG/7oAC/+6ADj/MwA6/8cAPP/xAD3/qwBR/+4AUv/uAFT/7gBc/9cAwf/uANL/MwDW/zMA2v/xAN7/6wDh/+UA5v/DAOz/7gDu/9cA8P/uAPH/7gDz/+4A9P/uAPX/7gD2/8wA+P/uAPr/7gD7/+4A/v/uAQD/7gEF/+4BGf/HASv/7gEz//EBNP/XATb/7gE5/zMBOv/JATz/7gE+/+4BQ//xAUT/1wFF/zMBR//lAUn/5QFM/98BU//uAVX/7gFX/+4BXP/uAV3/8QFe/9cBYv/QAWT/6wFs/6ABbf/NAYX/ugGG/7oBiP+6AYn/ugGK/7oCtf+rAsb/7gMO/+4DEP/uAxL/7gMT/+4DKv8zAyz/MwMu/zMDPv+rA0D/qwOn/6sDtv+rA7f/8QO5/6sDvP/uA9H/6wPd/zMD3v/xA+H/7gPj/+4D5v/XA+j/7gPt/+4D9f+rA/f/ugP4/7oD+/+6A/3/7gQD/+4EBv/HBA7/qwQR//EEEv/XBB//8QQg/9cEJP/uBCb/7gQv/+sEMf/rBDP/6wQ1/+UEOP/uBIz/qwSO/6sEkP+rBJP/MwSV/+UEmP/uBKL/qwS0/+4E0f/uBNP/7gTb/zME3v/HBOD/xwB2AEf/8ABI//AASf/wAEv/8ABT/94AVf/wAJT/8ACZ//AAu//wAMj/8ADJ//AA9//wAQP/8AEY/94BHP/rAR7/8AEi//ABQv/wAWD/8AFh//ABa//wAfb/6wH4/+sCAP/pAgf/6wIQ/+sCLP/rAjX/6wJM/+sCvf/wAr7/8AK///ACwP/wAsH/8ALH/94CyP/eAsn/3gLK/94Cy//eAtn/8ALb//AC3f/wAt//8ALh//AC4//wAuX/8ALn//AC6f/wAuv/8ALt//AC7//wAvH/8ALz//ADFf/eAxf/3gMZ/94DVf/rA1//6wNg/+sDYf/rA2L/6wNj/+sDbP/rA23/6wNu/+sDb//rA3b/6wN3/+sDeP/rA3n/6wOJ/+sDiv/rA4v/6wO6//ADwP/eA8b/3gPg//AD4v/eA+T/8APn//AEAv/wBAj/8AQN//AEG//wBB3/8AQe//AEKP/eBCr/8AQs/94EOf/wBFP/8ARV//AEV//wBFn/8ARb//AEXf/wBF//8ARh//AEZ//eBGn/3gRr/94Ebf/eBG//3gRx/94Ec//eBHX/8AR3//AEef/wBHv/3gR9//AEuP/wBLz/3gTF//AEx//wBOv/6wUN/+sFEP/rBRX/6wB8AAb/2gAL/9oAR//wAEj/8ABJ//AAS//wAFX/8ABZ/+8AWv/cAF3/3ACU//AAmf/wAJv/7wC7//AAvf/cAML/7ADEAA8Axv/qAMj/8ADJ//AAyv/IAMv/7wDM/+cA9//wAQP/8AEa/9wBHv/wASL/8AFC//ABYP/wAWH/8AFr//ABhf/aAYb/2gGI/9oBif/aAYr/2gK9//ACvv/wAr//8ALA//ACwf/wAsz/7wLN/+8Czv/vAs//7wLQ/9wC0f/cAtn/8ALb//AC3f/wAt//8ALh//AC4//wAuX/8ALn//AC6f/wAuv/8ALt//AC7//wAvH/8ALz//ADMf/vAzP/7wM1/+8DN//vAzn/7wM7/+8DP//cA7r/8AO+/+8Dwv/cA8X/7wPH/+8D4P/wA+T/8APl/9wD5//wA+7/3AP2/9wD9//aA/j/2gP7/9oEAv/wBAf/3AQI//AEDf/wBA//3AQb//AEHf/wBB7/8AQq//AEMP/cBDL/3AQ0/9wEOf/wBFP/8ARV//AEV//wBFn/8ARb//AEXf/wBF//8ARh//AEdf/wBHf/8AR5//AEff/wBH//7wSB/+8Eg//vBIX/7wSH/+8Eif/vBIv/7wSN/9wEj//cBJH/3AS4//AEwP/vBMX/8ATH//AE3//cBOH/3ACMAAb/ygAL/8oAOP/SADr/1AA8//QAPf/TAFH/4gBS/+IAVP/iAFr/5gBc/+8AXf/mAL3/5gDB/+IA0v/SANb/0gDa//QA3v/tAOH/4QDm/9QA7P/iAO7/7wDw/+IA8f/iAPP/4gD0/+IA9f/iAPb/yQD4/+IA+v/iAPv/4gD+/9EBAP/iAQX/4gEJ/+UBGf/UARr/5gEg/+MBK//iATP/9AE0/+8BNv/iATn/0gE6/8QBPP/iAT7/4gFD//QBRP/vAUX/0gFH/+EBSf/hAVP/4gFV/+IBV//iAVz/4gFd//QBXv/vAWL/1AFj//UBZP/nAWz/qgFt/8kBhf/KAYb/ygGI/8oBif/KAYr/ygK1/9MCxv/iAtD/5gLR/+YDDv/iAxD/4gMS/+IDE//iAyr/0gMs/9IDLv/SAz7/0wM//+YDQP/TA6f/0wO2/9MDt//0A7n/0wO8/+IDwv/mA9H/7QPd/9ID3v/0A+H/4gPj/+ID5f/mA+b/7wPo/+ID7f/iA+7/5gP1/9MD9v/mA/f/ygP4/8oD+//KA/3/4gQD/+IEBv/UBAf/5gQO/9MED//mBBH/9AQS/+8EH//0BCD/7wQk/+IEJv/iBC//7QQw/+YEMf/tBDL/5gQz/+0ENP/mBDX/4QQ4/+IEjP/TBI3/5gSO/9MEj//mBJD/0wSR/+YEk//SBJX/4QSY/+IEov/TBLT/4gTR/+IE0//iBNv/0gTe/9QE3//mBOD/1ATh/+YAmAAlABAAJ//oACv/6AAz/+gANf/oADj/4AA6/+AAPf/fAIP/6ACT/+gAmP/oALIAEACz/+gAtAAQANL/4ADT/+gA1AAQANb/4ADZABQA3QAQAOH/4QDm/+AA7QATAPIAEAD5/+ABBAAQAQj/6AENABABF//oARn/4AEb/+gBHf/oAR//6AEh/+gBOf/gAUH/6AFF/+ABR//hAUj/4AFJ/+EBSv/gAU3/4QFQABABUQAQAVj/6QFi/98BZP/eAWYAEAFq/+gBbP/fAW7/8gFvABABcAAQAmD/6AJh/+gCY//oAmT/6AKbABACnAAQAp0AEAKeABACnwAQAqAAEAKhABACov/oAqz/6AKt/+gCrv/oAq//6AKw/+gCtf/fAtIAEALUABAC1gAQAtj/6ALa/+gC3P/oAt7/6ALs/+gC7v/oAvD/6ALy/+gDFP/oAxb/6AMY/+gDKv/gAyz/4AMu/+ADPv/fA0D/3wNJ/+gDogAQA6b/6AOn/98DqgAQA7P/6AO2/98Duf/fA9IAEAPZ/+gD3P/oA93/4AP1/98D/gAQBAb/4AQJ/+gEDP/oBA7/3wQUABAEFgAQBCf/6AQp/+gEK//oBDX/4QQ2/+AEOgAQBDwAEAQ+ABAEQAAQBEIAEAREABAERgAQBEgAEARKABAETAAQBE4AEARQABAEZv/oBGj/6ARq/+gEbP/oBG7/6ARw/+gEcv/oBHT/6AR2/+gEeP/oBHr/6AR8/+gEjP/fBI7/3wSQ/98Ek//gBJX/4QSW/+AEov/fBLUAEAS7/+gE1P/oBNv/4ATe/+AE4P/gAzQ9sDwqOZA8Nj28O741xDxCOs443DxaPGY8cjx+PPA8KjMYPJY8ojyuPLo8zDzYO6w7pjzkPbY8MDmWPDw9wjLENco8SDrUOQw8YDxsPHg8hDrmOPQyyjycPKg8tDsoPNI83juyO2o86jm0MtA5ujLWMtwy4j3UOKwy6DLuPH48hDL0MvozADMGOxw7IjteO2Q0jDnSO5o4mju4OKA4pjMMOL45cjjEPCQzEjMYMx45hDMkMyo7jjMwMzYzPDNCM0g7oDNOM1Q5ijNaM2AzZjNsM3IzeDuIM34zhDuUM5wzijOQM5YznDOiM6gzrjO0M7o6GjogM8AzxjPMM9Iz2DPeM+Qz6jPwM/Yz/DQCNAg0DjQUNCY0GjQgNCY9Vj10PVw0LDQyOHA9Vj2SPPY0OD1QPUo8/D1EOAo89j0gPRQ9aDfaND49OD3INEQ9YjRKNFA0VjRcPZI0YjRoNG40dDR6NIA9zjSGPGA3Gj1uPTI9yDSMNIw91D3UPdQ0kjSYNJ49SjSkPPw8Njw2PEg8rjy0NKo0qjqGNLA5qDS2PbA5kDlaOVo6tjjKNLw0wjTIONY0zjTUNNQ67DTaOg404DTgNOY07Dk8NPI08jqMNPg5rjT+PbY5ljlmOWY6vDj6NQQ1CjUQOQY1FjUcNRw68jUiOhQ1KDUoNS41NDlCOlA1OjVAOpI6mD2wPbY1RjVMNVI1WDVeNWQ1ajVwNXY8PDV8NYI5wDnGNYg1jj28PcI1lDWaNaA1pjWsNbI1uDW+NcQ1yjXQNdY13DXiNeg17jX0Nfo6zjrUNgA2BjYMPFo8YDYSNhg8ZjxsPGY8bDxmPGw70DvWPH48hDYeNiQ8hDYqNjA2NjY8NkI2SDZONlQ8ljycNlo2YDZmNmw2cjZ4PKI8qDyiPKg2fjaEPK48tDyuPLQ6qjy0Noo2kDaWNpw2ojaoNq42tDa6NsA8ujsoNsY2zDbSNtg4lDbeNuQ26jbwNvY2/DcCNwg3DjcUNxo3Gj1WNyA3IDeYNyY3LDcyPcg9bjc4Nzg3Pj0IN0Q3SjdQPRo3Vj2MPYw3XDdiN2g3bjduN3Q3ejeAN4Y3jD3IN5I3mDeeN6Q3qjewN7Y3vD3ON8I3yDfON9Q32jfgN+Y37DfyPRQ3+Df+PPY4BDgKOAo4CjgQPPw4FjgcOCI4KDguPPY4NDg6OEA9kjhGPVY4TD1WOFI4WDheOGQ4ajhwOHY4fD0COII4iDiOPbA9vDxCOs488DumOKY9sDwqPbw85DxCOs48WjxyPH488DwqPK47pjusONY4lDiaO7g4oDimOL44rDrmPNI4sji4OuY4vjjEOMo40DyiOs441jjcPE444j2wPCo7mj28OOg8cjxCPPA8KjmQPK47rD22PcI47jrmOPQ5ljtqO7I4+jkAPKg61DkGOQw5EjkYOR45KjkkOSo5MDk2OTw5QjlIOU45VD2wPbY5WjlgOWY5bDlyOXg5fjmEOYo5kDmWO6Y6zjmcOaI6zjqSOpg5qDmuObQ5ujnAOcY5zDnSOdg53jnkOeo58Dn2Ofw6AjoIOg46FDoaOiA6JjosOjI6ODo+OkQ6SjpQOlY6XDpiOmg6bjp0PDw9sD22Ono6gD2wPbY9sD22PbA9tj2wPbY6hjqMPbA9tj2wPbY9sD22PbA9tjqSOpg9vD3COp46pDqqOrA9vD3CPbw9wj28PcI9vD3COrY6vDrCOsg6zjrUPPA65jraOuA88DrmPPA65jzwOuY88DrmOuw68jr4Ov46+Dr+OwQ7CjsQOxY7HDsiPLo7KDsuOzQ7OjtAOzo7QDtGO0w7UjtYO147ZDumO2o7cDt2O3w7gjw8PK47iDuOO5Q7mjugPEg7mjugPGA7pjusO7I7uDu+O8Q7yjvQO9Y73DviO+g77jv0O/o8ADwGPAw8EjwYPB48JDwqPDA8Njw8PDY8PDxCPEg8TjxUPFo8YDxmPGw8cjx4PH48hDzwPIo8kDyWPJw8ojyoPK48tDy6PMA8xjzMPNI82DzePOQ86jzwPcg9zj1oPRQ9Sj10Pcg9Mj3OPVY9aD0UPPY9RDz8PUo9UD1WPXQ9XD0aPQI9CD0OPZI9FD0aPSA9Jj0sPcg9Mj04Pc49Pj1EPWg9Sj1QPW49Vj1cPWI9aD1uPXQ9ej2APYY9jD2SPZg9nj2kPao9sD22Pbw9wj3IPc491AC6AEf/3ABI/9wASf/cAEv/3ABR/+EAUv/hAFP/1gBU/+EAVf/cAFn/3QBa/+EAXf/hAJT/3ACZ/9wAm//dALv/3AC9/+EAvv/1AL//5gDB/+EAwv/rAMP/6QDF//AAxv/nAMj/3ADJ/9wAyv/jAMv/3QDM/84Azf/UAM7/2wDs/+EA8P/hAPH/4QDz/+EA9P/hAPX/4QD3/9wA+P/hAPr/4QD7/+EA/v/hAQD/4QED/9wBBf/hARj/1gEa/+EBHv/cASL/3AEr/+EBNv/hATz/4QE+/+EBQv/cAVP/4QFV/+EBV//hAVz/4QFg/9wBYf/cAWv/3AK9/9wCvv/cAr//3ALA/9wCwf/cAsb/4QLH/9YCyP/WAsn/1gLK/9YCy//WAsz/3QLN/90Czv/dAs//3QLQ/+EC0f/hAtn/3ALb/9wC3f/cAt//3ALh/9wC4//cAuX/3ALn/9wC6f/cAuv/3ALt/9wC7//cAvH/3ALz/9wDDv/hAxD/4QMS/+EDE//hAxX/1gMX/9YDGf/WAzH/3QMz/90DNf/dAzf/3QM5/90DO//dAz//4QO6/9wDvP/hA77/3QPA/9YDwv/hA8X/3QPG/9YDx//dA+D/3APh/+ED4v/WA+P/4QPk/9wD5f/hA+f/3APo/+ED7f/hA+7/4QP2/+ED/f/hBAL/3AQD/+EEB//hBAj/3AQN/9wED//hBBv/3AQd/9wEHv/cBCT/4QQm/+EEKP/WBCr/3AQs/9YEMP/hBDL/4QQ0/+EEOP/hBDn/3ART/9wEVf/cBFf/3ARZ/9wEW//cBF3/3ARf/9wEYf/cBGf/1gRp/9YEa//WBG3/1gRv/9YEcf/WBHP/1gR1/9wEd//cBHn/3AR7/9YEff/cBH//3QSB/90Eg//dBIX/3QSH/90Eif/dBIv/3QSN/+EEj//hBJH/4QSY/+EEtP/hBLj/3AS8/9YEwP/dBMX/3ATH/9wE0f/hBNP/4QTf/+EE4f/hAL8ABgAMAAsADABH/+gASP/oAEn/6ABKAAwAS//oAFP/6gBV/+gAWgALAF0ACwCU/+gAmf/oALv/6AC9AAsAvv/0AMT/1wDGAAsAyP/oAMn/6ADKAAwA9//oAQP/6AEY/+oBGgALAR7/6AEi/+gBQv/oAWD/6AFh/+gBa//oAYUADAGGAAwBiAAMAYkADAGKAAwB7gANAfEADQHzAA4B9P/1Afb/7AH4/+0CAP/sAgb/vwIH/+0CCP+/Ag8ADgIQ/+0CEwAOAisADgIs/+0CLQANAi8ADgI1/+0CTP/uAk7/vwK9/+gCvv/oAr//6ALA/+gCwf/oAsf/6gLI/+oCyf/qAsr/6gLL/+oC0AALAtEACwLZ/+gC2//oAt3/6ALf/+gC4f/oAuP/6ALl/+gC5//oAun/6ALr/+gC7f/oAu//6ALx/+gC8//oAxX/6gMX/+oDGf/qAz8ACwNO/78DT/+/A1D/vwNR/78DUv+/A1P/vwNU/78DVf/tA1//7QNg/+0DYf/tA2L/7QNj/+0DaAANA2n/vwNq/78Da/+/A2z/7QNt/+0Dbv/tA2//7QN2/+0Dd//tA3j/7QN5/+0Dif/tA4r/7QOL/+0Dj//1A5D/9QOR//UDkv/1A5QADgOdAA0DngANA7r/6APA/+oDwgALA8b/6gPg/+gD4v/qA+T/6APlAAsD5//oA+4ACwP2AAsD9wAMA/gADAP7AAwEAv/oBAcACwQI/+gEDf/oBA8ACwQb/+gEHf/oBB7/6AQo/+oEKv/oBCz/6gQwAAsEMgALBDQACwQ5/+gEU//oBFX/6ARX/+gEWf/oBFv/6ARd/+gEX//oBGH/6ARn/+oEaf/qBGv/6gRt/+oEb//qBHH/6gRz/+oEdf/oBHf/6AR5/+gEe//qBH3/6ASNAAsEjwALBJEACwS4/+gEvP/qBMX/6ATH/+gE3wALBOEACwTn/78E6//tBOwADQTu/78E+gANBP0ADQUG/78FDf/tBRD/7QURAA4FFf/tBRYADQDjAAYADQALAA0ARf/wAEf/tgBI/7YASf+2AEoADQBL/7YAU//aAFX/tgBaAAsAXQALAJT/tgCZ/7YAu/+2AL0ACwC+/80Ax/+7AMj/wADJ/7YAzP/VAO3/tQDy/74A9/+2AQP/tgEE/74BGP/aARoACwEc/+YBHv+2ASAADAEi/7YBQv+2AVH/vgFg/7YBYf+2AWMACwFlAAsBa/+2AXD/vgGFAA0BhgANAYgADQGJAA0BigANAe4ADQHxAA0B8wAOAfT/9QH2/+wB+P/tAgD/7AIG/78CB//tAgj/vwIPAA4CEP/tAhMADgIrAA4CLP/tAi0ADQIvAA4CNf/tAkz/7gJO/78Ctv/wArf/8AK4//ACuf/wArr/8AK7//ACvP/wAr3/tgK+/7YCv/+2AsD/tgLB/7YCx//aAsj/2gLJ/9oCyv/aAsv/2gLQAAsC0QALAtP/8ALV//AC1//wAtn/tgLb/7YC3f+2At//tgLh/7YC4/+2AuX/tgLn/7YC6f+2Auv/tgLt/7YC7/+2AvH/tgLz/7YDFf/aAxf/2gMZ/9oDPwALA07/vwNP/78DUP+/A1H/vwNS/78DU/+/A1T/vwNV/+0DX//tA2D/7QNh/+0DYv/tA2P/7QNoAA0Daf+/A2r/vwNr/78DbP/tA23/7QNu/+0Db//tA3b/7QN3/+0DeP/tA3n/7QOJ/+0Div/tA4v/7QOP//UDkP/1A5H/9QOS//UDlAAOA50ADQOeAA0Duv+2A8D/2gPCAAsDxv/aA9//8APg/7YD4v/aA+T/tgPlAAsD5/+2A+4ACwP2AAsD9wANA/gADQP7AA0D///wBAL/tgQHAAsECP+2BA3/tgQPAAsEFf/wBBf/8AQb/7YEHf+2BB7/tgQo/9oEKv+2BCz/2gQwAAsEMgALBDQACwQ5/7YEO//wBD3/8AQ///AEQf/wBEP/8ARF//AER//wBEn/8ARL//AETf/wBE//8ARR//AEU/+2BFX/tgRX/7YEWf+2BFv/tgRd/7YEX/+2BGH/tgRn/9oEaf/aBGv/2gRt/9oEb//aBHH/2gRz/9oEdf+2BHf/tgR5/7YEe//aBH3/tgSNAAsEjwALBJEACwS2//AEuP+2BLz/2gTF/7YEx/+2BN8ACwThAAsE5/+/BOv/7QTsAA0E7v+/BPoADQT9AA0FBv+/BQ3/7QUQ/+0FEQAOBRX/7QUWAA0A5wAQ/wcAEv8HACX/TgAu/w0AOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBW/+YAWf/qAFr/6ABd/+gAlP/rAJn/6wCb/+oAsv9OALT/TgC7/+sAvf/oAMj/6wDJ/+sAy//qANIAFADWABQA9//rAQP/6wEN/04BGP/rARr/6AEe/+sBIv/rATkAFAFC/+sBRQAUAWD/6wFh/+sBa//rAYf/BwGL/wcBj/8HAZD/BwIG/8ACCP/AAk7/wAKb/04CnP9OAp3/TgKe/04Cn/9OAqD/TgKh/04Ctv/eArf/3gK4/94Cuf/eArr/3gK7/94CvP/eAr3/6wK+/+sCv//rAsD/6wLB/+sCx//rAsj/6wLJ/+sCyv/rAsv/6wLM/+oCzf/qAs7/6gLP/+oC0P/oAtH/6ALS/04C0//eAtT/TgLV/94C1v9OAtf/3gLZ/+sC2//rAt3/6wLf/+sC4f/rAuP/6wLl/+sC5//rAun/6wLr/+sC7f/rAu//6wLx/+sC8//rAwH/DQMV/+sDF//rAxn/6wMqABQDLAAUAy4AFAMx/+oDM//qAzX/6gM3/+oDOf/qAzv/6gM//+gDTv/AA0//wANQ/8ADUf/AA1L/wANT/8ADVP/AA2n/wANq/8ADa//AA6L/TgOq/04Duv/rA77/6gPA/+sDwv/oA8X/6gPG/+sDx//qA87/DQPS/04D3QAUA9//3gPg/+sD4v/rA+T/6wPl/+gD5//rA+7/6AP2/+gD/v9OA///3gQC/+sEB//oBAj/6wQN/+sED//oBBT/TgQV/94EFv9OBBf/3gQb/+sEHf/rBB7/6wQo/+sEKv/rBCz/6wQw/+gEMv/oBDT/6AQ5/+sEOv9OBDv/3gQ8/04EPf/eBD7/TgQ//94EQP9OBEH/3gRC/04EQ//eBET/TgRF/94ERv9OBEf/3gRI/04ESf/eBEr/TgRL/94ETP9OBE3/3gRO/04ET//eBFD/TgRR/94EU//rBFX/6wRX/+sEWf/rBFv/6wRd/+sEX//rBGH/6wRn/+sEaf/rBGv/6wRt/+sEb//rBHH/6wRz/+sEdf/rBHf/6wR5/+sEe//rBH3/6wR//+oEgf/qBIP/6gSF/+oEh//qBIn/6gSL/+oEjf/oBI//6ASR/+gEkwAUBLX/TgS2/94EuP/rBLz/6wTA/+oExf/rBMf/6wTbABQE3//oBOH/6ATn/8AE7v/ABQb/wAACAJ8ABAAEAAAABgAGAAEACwAMAAIAJQAqAAQALAAtAAoALwA2AAwAOAA4ABQAOgA/ABUARQBGABsASQBKAB0ATABMAB8ATwBPACAAUQBUACEAVgBWACUAWABYACYAWgBdACcAXwBfACsAigCKACwAlgCWAC0AnQCdAC4AsQC1AC8AtwC5ADQAuwC7ADcAvQC+ADgAwADBADoAwwDFADwAxwDOAD8A0gDSAEcA1ADeAEgA4ADvAFMA8QDxAGMA9gD4AGQA+wD8AGcA/gEAAGkBAwEFAGwBCgEKAG8BDQENAHABGAEaAHEBIgEiAHQBLgEwAHUBMwE1AHgBNwE3AHsBOQE5AHwBOwE7AH0BQwFEAH4BVAFUAIABVgFWAIEBWAFYAIIBXAFeAIMBhQGGAIYBiAGKAIgB8wHzAIsB9QH2AIwB+AH4AI4B+wH7AI8CBgIIAJACSwJLAJMCTgJOAJQCYAJgAJUCYgJjAJYClgKXAJgCmQKZAJoCmwKwAJsCtQK8ALECvgLBALkCxgLLAL0C0ALYAMMC2gLaAMwC3ALcAM0C3gLeAM4C4ALgAM8C4gLrANAC9AL2ANoC+AL4AN0C+gL6AN4C/AL8AN8C/gL+AOADAwMDAOEDBQMFAOIDBwMHAOMDCQMJAOQDCwMLAOUDDQMZAOYDGwMbAPMDHQMdAPQDHwMfAPUDKgMqAPYDLAMsAPcDLgMuAPgDPAM8APkDPgNBAPoDQwNDAP4DRQNFAP8DSwNUAQADXwNjAQoDaQNrAQ8DcANwARIDggOFARMDiQOLARcDlAOUARoDogOnARsDqgO5ASEDvAO8ATEDwAPAATIDwgPCATMDxgPGATQDyQPKATUDzAPNATcDzwPVATkD1wPZAUAD2wPgAUMD4gPjAUkD5QPoAUsD7gPvAU8D8QPxAVED8wPzAVID9QP4AVMD+wQAAVcEAgQCAV0EBgQHAV4EDAQMAWAEDgQXAWEEGgQbAWsEHQQgAW0EJwQoAXEELAQsAXMELgQ0AXQEOgRiAXsEZARkAaQEZgRzAaUEewR7AbMEjASRAbQEkwSTAboElwSYAbsEmwSbAb0EnQSeAb4EoASgAcAEogSiAcEEswS3AcIEuQS5AccEuwS8AcgEvgS+AcoEwgTEAcsExgTGAc4EyATKAc8EzATMAdIEzgTOAdME0ATWAdQE2ATYAdsE2wTbAdwE3gTiAd0E5ATkAeIE5gTnAeME6wTrAeUE7gTuAeYE+QT5AecFBgUGAegFDQUNAekFEQURAeoAAgCaAAYABgAAAAsACwABABAAEAACABIAEgADACUAKQAEACwANAAJADgAPgASAEUARwAZAEkASQAcAEwATAAdAFEAVAAeAFYAVgAiAFoAWgAjAFwAXgAkAIoAigAnAJYAlgAoALEAtAApAL0AvQAtAMEAwQAuAMcAxwAvANQA1QAwANcA1wAyANoA2gAzANwA3gA0AOAA5gA3AOwA7AA+AO4A7gA/APcA9wBAAPwA/ABBAP4A/wBCAQQBBQBEAQoBCgBGAQ0BDQBHARgBGgBIAS4BMABLATMBNQBOATcBNwBRATkBOQBSATsBOwBTAUMBRABUAVQBVABWAVYBVgBXAVgBWABYAVwBXgBZAYUBiwBcAY8BkABjAfMB8wBlAfgB+ABmAfsB/ABnAgYCCABpAhoCGgBsAikCKwBtAksCSwBwAk4CTgBxAmACYAByAmICYwBzApYClwB1ApkCmQB3ApsCwQB4AsYCywCfAtAC4AClAuIC6wC2AvQC9gDAAvgC+ADDAvoC+gDEAvwC/ADFAv4C/gDGAwEDAQDHAwMDAwDIAwUDBQDJAwcDBwDKAwkDCQDLAwsDCwDMAw0DGQDNAxsDGwDaAx0DHQDbAx8DHwDcAyoDKgDdAywDLADeAy4DLgDfAzADMADgAzIDMgDhAzQDNADiAzYDNgDjAzgDOADkAzoDOgDlAzwDPADmAz4DRgDnA0sDVADwA18DYwD6A2kDawD/A3ADcAECA4EDhQEDA4kDiwEIA5QDlAELA6IDpwEMA6oDuQESA7wDvAEiA8ADwAEjA8IDwgEkA8YDxgElA8kDygEmA8wD1QEoA9cD2QEyA9sD4AE1A+ID6AE7A+4D7wFCA/ED8QFEA/MD8wFFA/UD+AFGA/sEAAFKBAIEAgFQBAYEBwFRBAwEFwFTBBoEGwFfBB0EIAFhBCcEKAFlBCwELAFnBC4ENAFoBDoEYgFvBGQEZAGYBGYEcwGZBHsEewGnBH4EfgGoBIAEgAGpBIwEkQGqBJMEkwGwBJcEmAGxBJsEmwGzBJ0EngG0BKAEoAG2BKIEogG3BLMEtwG4BLkEuQG9BLsEvAG+BL4EvgHABMIExAHBBMYExgHEBMgEygHFBMwEzAHIBM4EzgHJBNAE1gHKBNgE2AHRBNsE2wHSBN0E4gHTBOQE5wHZBOsE6wHdBO4E7gHeBPQE9AHfBPkE+QHgBQQFBAHhBQYFBgHiBQ0FDQHjBREFEQHkAAIBdAAGAAYAEgALAAsAEgAQABAAGgASABIAGgAlACUAAgAmACYAJAAnACcADwAoACgAAQApACkABAAuAC4ACAAvAC8ADQAwADAAFwAzADMAAQA0ADQAJQA4ADgAEQA5ADkACAA6ADoAHAA7ADsAGAA8ADwAEAA9AD0ADAA+AD4AGQBFAEUAAwBGAEYADgBHAEcAEwBJAEkABQBMAEwACQBRAFIACQBTAFMABgBUAFQADgBWAFYAGwBaAFoABwBcAFwAFQBdAF0ABwBeAF4AHwCKAIoADgCWAJYAAQCxALEAFgCyALIAKACzALMAAQC0ALQAAgC9AL0ABwDBAMEACQDHAMcADgDUANUAIADaANoAEADeAN4AIQDkAOQAIADmAOYAIADsAOwAIgDuAO4AFQD3APcADgD8APwAIwD+AP4AIwD/AP8ADgEEAQUAIwEKAQoAIwENAQ0AAgEYARgABgEZARkAHAEaARoABwEuAS4ADgEvAS8AFgEwATAAIgEzATMAEAE0ATQAFQE1ATUADQE3ATcADQE5ATkADQFDAUMAEAFEAUQAFQFYAVgAAQFcAVwAIgFdAV0AEAFeAV4AFQGFAYYAEgGHAYcAGgGIAYoAEgGLAYsAGgGPAZAAGgHzAfMAHQH4AfgACgH7AfsAHgH8AfwAFAIGAgYAJgIHAgcACgIIAggACwIaAhoAFAIpAisAFAJLAksACgJOAk4ACwJgAmAADwJiAmMAAQKWApcAAQKZApkAEQKbAqEAAgKiAqIADwKjAqYABAKsArAAAQKxArQACAK1ArUADAK2ArwAAwK9Ar0AEwK+AsEABQLGAsYACQLHAssABgLQAtEABwLSAtIAAgLTAtMAAwLUAtQAAgLVAtUAAwLWAtYAAgLXAtcAAwLYAtgADwLZAtkAEwLaAtoADwLbAtsAEwLcAtwADwLdAt0AEwLeAt4ADwLfAt8AEwLgAuAAAQLiAuIABALjAuMABQLkAuQABALlAuUABQLmAuYABALnAucABQLoAugABALpAukABQLqAuoABALrAusABQL1AvUACQMBAwEACAMDAwMADQMFAwUAFwMHAwcAFwMJAwkAFwMLAwsAFwMOAw4ACQMQAxAACQMSAxMACQMUAxQAAQMVAxUABgMWAxYAAQMXAxcABgMYAxgAAQMZAxkABgMbAxsAGwMdAx0AGwMfAx8AGwMqAyoAEQMsAywAEQMuAy4AEQMwAzAACAMyAzIACAM0AzQACAM2AzYACAM4AzgACAM6AzoACAM8AzwAGAM+Az4ADAM/Az8ABwNAA0AADANBA0EAGQNCA0IAHwNDA0MAGQNEA0QAHwNFA0UAGQNGA0YAHwNLA0wACgNNA00AHQNOA1QACwNfA2MACgNpA2sACwNwA3AACgOBA4EAFAOCA4UAHgOJA4sACgOUA5QAHQOiA6IAAgOjA6MABAOmA6YAAQOnA6cADAOqA6oAAgOrA6sAJAOsA6wABAOtA60AGQOwA7AADQOzA7MAAQO0A7QAJQO1A7UAEQO2A7YADAO3A7cAEAO5A7kADAO8A7wACQPAA8AABgPCA8IABwPGA8YABgPJA8kABAPKA8oAFgPOA84ACAPPA9AADQPRA9EAIQPSA9IAAgPTA9MAJAPUA9QAFgPVA9UABAPZA9kAAQPbA9sAJQPcA9wADwPdA90AEQPeA94AEAPfA98AAwPgA+AABQPiA+IABgPjA+MADgPkA+QAEwPlA+UABwPmA+YAFQPnA+cABQPoA+gAIgPuA+4ABwPvA+8AGAPxA/EAGAPzA/MAGAP1A/UADAP2A/YABwP3A/gAEgP7A/sAJwP9A/0ACQP+A/4AAgP/A/8AAwQABAAABAQCBAIABQQGBAYAHAQHBAcABwQMBAwADwQNBA0AEwQOBA4ADAQPBA8ABwQRBBEAEAQSBBIAFQQUBBQAAgQVBBUAAwQWBBYAAgQXBBcAAwQaBBoABAQbBBsABQQdBB4ABQQfBB8AEAQgBCAAFQQnBCcAAQQoBCgABgQsBCwABgQuBC4ADgQvBC8AIQQwBDAABwQxBDEAIQQyBDIABwQzBDMAIQQ0BDQABwQ6BDoAAgQ7BDsAAwQ8BDwAAgQ9BD0AAwQ+BD4AAgQ/BD8AAwRABEAAAgRBBEEAAwRCBEIAAgRDBEMAAwREBEQAAgRFBEUAAwRGBEYAAgRHBEcAAwRIBEgAAgRJBEkAAwRKBEoAAgRLBEsAAwRMBEwAAgRNBE0AAwROBE4AAgRPBE8AAwRQBFAAAgRRBFEAAwRSBFIABARTBFMABQRUBFQABARVBFUABQRWBFYABARXBFcABQRYBFgABARZBFkABQRaBFoABARbBFsABQRcBFwABARdBF0ABQReBF4ABARfBF8ABQRgBGAABARhBGEABQRmBGYAAQRnBGcABgRoBGgAAQRpBGkABgRqBGoAAQRrBGsABgRsBGwAAQRtBG0ABgRuBG4AAQRvBG8ABgRwBHAAAQRxBHEABgRyBHIAAQRzBHMABgR7BHsABgR+BH4ACASABIAACASMBIwADASNBI0ABwSOBI4ADASPBI8ABwSQBJAADASRBJEABwSTBJMAEQSXBJcAFgSYBJgAIgSbBJsACQSdBJ0AIASeBJ4AFgSgBKAADQSiBKIADAS0BLQACQS1BLUAAgS2BLYAAwS3BLcABAS7BLsAAQS8BLwABgS+BL4AGwTCBMIAJATDBMMADgTEBMQAAQTGBMYAAQTJBMkACQTKBMoADQTMBMwADQTOBM4AFwTRBNEACQTTBNMACQTUBNQAAQTVBNUAJQTWBNYADgTYBNgAGwTbBNsAEQTdBN0ACATeBN4AHATfBN8ABwTgBOAAHAThBOEABwTiBOIAGATkBOQAGQTlBOUAHwTmBOYAAQTnBOcACwTrBOsACgTuBO4ACwT0BPQAFAT5BPkAHQUEBQQAFAUGBQYACwUNBQ0ACgURBREAHQABAAYFEQASAAAAAAAAAAAAEgAAAAAAAAAAABgAGwAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAACAAAAAAAAAAIAAAAAACMAAAAAAAAAAAACAAAAAgAAABQADQALABoAFgAPAAwAFwAAAAAAAAAAAAAAAAAGAAAAAQABAAEAAAABAAAAAAAAAAAAAAADAAMABwADAAEAAAAQAAAACAAJAAAAEwAJAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAEAAAAAAAAAAgABAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcAAgAEAAAAAAAAAAAAAAAAAAEAAAAJAAAAAAAAAAMAAAAAAAAAAAAAAAAAAQABAAAACAAAAAAAAAAAAAAAAAANAAIAHgAAAA0AAAAAAAAADwAAAAAAHgAfAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAABMAAAADAAMAIQADAAMAAwAAAAEAAwAiAAMAAwAAAAAAAwAAAAMAAAAAAAEAIQADAAAAAAACAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAACAAcAGgAJAAIAAAACAAEAAgAAAAIAAQAAAAAAAAAAAAAAAAAAAAAAAwAAAAAAAAAAAAAAAAAAAA8AEwAAAAMAAAAAAA0AAAAAAAMAAAADAAAAAAACAAEADwATAA0AAAAgACIAAAAAAAAAAAAAAAAAAAAeACEAAAADAAAAAwAAAAMAAAAAAAAAAAADAA8AEwAAAAEAAQAAAAAAAAAAAB4AAAAAAAAAAgABAAAAAAAAAB4AIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwAbAAAAEgASABgAEgASABIAGAAAAAAAAAAYABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAZACQAAAAOABUAHAAAAAUAAAAFAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAJQAFAAoAAAAAAAAAAAAAAAAAFQAFAAAAAAAVAAAAAAAAABkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZAAAAAAAVAAUAEQAZABUAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAACgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgACAAAAAgACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAgAAAAAAAAAAAAAAAAAAAAAAAAACAAIAAgACAAIACwALAAsACwAMAAYABgAGAAYABgAGAAYAAQABAAEAAQABAAAAAAAAAAAAAwAHAAcABwAHAAcACAAIAAgACAAJAAkABAAGAAQABgAEAAYAAgABAAIAAQACAAEAAgABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAIAAQACAAEAAgABAAIAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAMAAAADAAMAAgAHAAIABwACAAcAAAAAAAAAAAAAAAAAFAAQABQAEAAUABAAFAAQABQAEAANAAAADQAAAA0AAAALAAgACwAIAAsACAALAAgACwAIAAsACAAWAAAADAAJAAwAFwAdABcAHQAXAB0AAAAAAAIAAAAAAAAAAAAKAAoACgAKAAoACgAKAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAA4ADgAOAA4AEQAKAAoACgAFAAUABQAFAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAHAAcABwAHAAAABUAAAAOAA4ADgAOAA4ADgAkABEAEQAAAAAAAAAEAAAAAAAAAAIADAAAAAAABAAAAAAAFwAAAAAAAAAAAAAAAgAAAAAADAAPAAAADAABAAAAAwAAAAgAAAAHAAAACQAAAAAACAAHAAgAAAAAAAAAAAAAAAAAIwAAAAAAHwAEAAAAAAAAAAAAAAAAAAIAAAAAAAIADQAPAAYAAQADAAcAAwABAAkAEwABAAMAEAAAAAAAAAADAAkAFgAAABYAAAAWAAAADAAJABIAEgAAAAAAJgAAAAMABAAGAAAAAAABAAMAAAAAABoACQABAAIAAAAAAAIAAQAMAAkAAAAPABMAAAAEAAYABAAGAAAAAAAAAAEAAAABAAEADwATAAAAAAAAAAMAAAADAAIABwACAAEAAgAHAAAAAAAfAAkAHwAJAB8ACQAgACIAAAADAAEABAAGAAQABgAEAAYABAAGAAQABgAEAAYABAAGAAQABgAEAAYABAAGAAQABgAEAAYAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAAAAAAAAAIABwACAAcAAgAHAAIABwACAAcAAgAHAAIABwACAAEAAgABAAIAAQACAAcAAgABAAsACAALAAgAAAAIAAAACAAAAAgAAAAIAAAACAAMAAkADAAJAAwACQAAAA0AAAAgACIAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAAAAAAAAAAABsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMABAAGAAAAAQAAAAAAAgAHAAAAAAAAAAgAAAAAAAAAAAABAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAADAAAAAwACAAAAAAAAAAAAFAAQAA0AAAALABoACQAaAAkAFgAAABcAHQAAAAoAAAAAAAAABQARAAAACgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAZAAAAEQAAAAAAAAAAAAAAAAAAAAAACgAAAAAAAAAAAAAAAAAFAAAAAAAFABUAGQAAAAAABQARAAH9VAAAAAH9Ff6UAAH+rQZ0AAH+oAZ0AAH+lwZbAAH+fQbDAAH+7AZPAAH+bwUKAAH+YQUKAAH+VgToAAH+LwUDAAH+tAUNAAH+XASmAAH+wASmAAH+fwUBAAH+ogUBAAECPP/2AAEB/P/2AAEA2gAKAAECw/5pAAECYgAKAAEB6AAKAAEAuwAKAAEDSAAAAAEDJP/8AAECPwAAAAECTQAKAAEBsQAKAAECHP/2AAEBzf/2AAEB0//2AAEB4wAKAAEAogAKAAEBpv/2AAEB6gAKAAECJf/2AAEB4P/2AAEBVQAKAAEB4gAKAAECXf/2AAEB1gAAAAEB+QAKAAEATv41AAEARv41AAEBmwAIAAEBUwAKAAECBQAKAAEB3/42AAEBZP42AAEBvgAKAAECAf32AAEAcf5aAAEByP5IAAEBXf40AAEBkP4GAAEAPv4GAAEB6QAKAAEB/f4CAAEBaf4GAAEBkv4GAAEAOP4HAAEBt/48AAEBYP4yAAEBrP37AAEBVv3yAAEBnP4AAAEA6/38AAEBpv5AAAEA9f48AAEBRQAAAAEBmAAKAAEBhf48AAEBUQAKAAEB6///AAEBkv37AAEARv5UAAEBN/4DAAEBNv4EAAEBjwAIAAEBm/39AAEBP/4EAAEBmAAIAAEBav48AAEBTP4DAAEBVv5DAAEByAAAAAECLwAKAAEB9QAKAAEBlP/2AAEAiQAKAAEB2gAKAAECyP/2AAECBf//AAEBh//2AAEB5QAKAAECVQAKAAEBr//2AAEDFgAKAAECegAKAAEAAf41AAEC/QAKAAEDAwAKAAECLv/6AAEBs//6AAECLAAAAAEBxQAAAAEB7f/2AAEBlf/3AAEB+P6YAAEBM/6dAAEBvf6eAAEBi/6UAAEAc/6aAAECCP6UAAEBlf6QAAECMwAAAAEByP/2AAEB8/6UAAEBif6KAAEB4v6UAAEBMv6UAAECQv/3AAECAv6LAAEBgP6UAAEBuf6mAAECIv4PAAECYv96AAEB4AAAAAEB9QAEAAEDNP/8AAECTQADAAEB0QAKAAEB+QASAAECGgANAAEBmwAKAAEBnQAKAAECWv/6AAEBZP5BAAECVgAGAAEBwgAKAAECOAADAAEBcwAIAAEB/QAKAAEBygAAAAEAswAGAAEAlwAKAAEB1f/8AAEB7AAKAAEAkAALAAEBvwAAAAEBpf6eAAEBvP6KAAEBfv6eAAEBoP6UAAEBZP4GAAEBh/38AAECFf6eAAEBkv6eAAECIQBMAAEBtgA4AAEB4f7hAAEBdv7NAAEBqv6eAAECvv6eAAECw/6eAAECF/6bAAEBgv6eAAEBnAAKAAEAPf5pAAEBrP6eAAEAUP6fAAEBxv6UAAEBb/6KAAEBtf6YAAEBBf6UAAECIQAAAAECJgAKAAEBlQAKAAEB5/6eAAEBVf6eAAEC1/6eAAECOv6eAAEBtv6eAAEBWf6eAAECSAAAAAEB+wAKAAEBpgAKAAEB9AABAAEBuQAAAAEAkQABAAEBWf/2AAEBkAAHAAEB3AAAAAEBmQAKAAECggAKAAEBbwAKAAEBpQAHAAEBrgAIAAEBj//2AAEB7QAKAAEB0///AAEDOv/2AAEC5gAAAAEB7wAAAAEBYP38AAEChAAKAAEBqgAWAAEB9f5YAAEBMP5cAAEBuv5eAAEBh/5UAAEBmf5UAAEBav5cAAEAWP6eAAECkQa4AAECgAUKAAEDbwaKAAECgAUHAAECpgZHAAEDdgZIAAEBwwY9AAEB3QaaAAEEXQZCAAEEBAUKAAECSQa4AAEDQAZCAAECuwUBAAEDmwT9AAEDVAZAAAEEaAZIAAEDawZIAAEDLQZIAAEEFAZIAAEDPAZWAAEEJQZAAAEDJQZMAAEChAT1AAEDHAT1AAEDowT9AAECrwT9AAEClwT8AAEC4QT1AAEDUwT1AAECrQT1AAECsQT1AAEDlgbMAAECwgT1AAEDhwT1AAEDlgT9AAECfgUKAAEDlgT1AAECcQT1AAECqAUJAAEEOAZDAAEDjQT9AAECigbMAAEDEAYdAAECewTvAAECtwVQAAEDywZAAAEDOAZhAAECrgUMAAEDngdrAAEC4QYhAAEDdwZXAAECtAUKAAEDAwZMAAEDGwYZAAEC+AZMAAEBtwZMAAEDXgZMAAEChwUKAAEC/wZMAAEDQQZhAAEDZwUoAAECpQUoAAECxgUoAAECgQUoAAEDiAUoAAEC2QUoAAECowUoAAECoAUoAAEDbQUoAAEDagUoAAEC8wUoAAEDQgUoAAEC0QUoAAECrAUoAAECwgUoAAEDDgZMAAEBdgToAAEBdgUoAAEDxQUKAAECewUoAAEC5wUoAAEDegeqAAEDdgeSAAEDiQfcAAECAAexAAEB/gexAAECBAekAAEDoAeSAAEDkQesAAEDjQeTAAEDbgeqAAEDcgedAAEDZQdsAAEC0wZ0AAECzwZbAAEC4galAAEBsQZrAAEBsAZrAAEBtgZdAAEC2AZbAAEC0QZ0AAECzQZbAAEC2AZ0AAEC3AZmAAECzwY1AAEDcQdvAAECygY4AAEDgAe/AAECqQZ0AAEDhAexAAECrQZmAAEDfQeSAAECpwZHAAEDhAeuAAECrQZjAAEDCwehAAEDPgd2AAECswY4AAEDRQeFAAECugZIAAEDSwehAAECwAZkAAEDhQexAAECzQZmAAEDfAebAAECxAZQAAEDfweSAAECxwZHAAEDSQZVAAECkgUKAAEDogekAAEC4gfFAAEB+weZAAEBrQZSAAEB9wd2AAEBqQYvAAEB+geOAAEBrAZHAAEB/AeFAAEEJQebAAEBswZEAAEB8AenAAEB8QgDAAEDqAeaAAEC4AZjAAEDiQdwAAECyAY4AAEDjAeIAAECzAZQAAEDkwePAAEC0wZYAAEDLQeqAAECPAZ0AAEDMQeaAAECQQZjAAEDTgesAAECsQZ0AAEDUweeAAECtQZmAAEDUgebAAECtAZjAAEDageSAAEC1AZbAAEDZQdvAAECzwY4AAEDaQeHAAEC0wZQAAEDfQfcAAEC5walAAEDcAeOAAEC2gZYAAEETQedAAEDkAZmAAEDSQecAAECpgZmAAEDQQeqAAECpwZ0AAEDPwd+AAECpAZHAAEDRQeaAAECqgZjAAEEcwe2AAED8gZ1AAEDpwf0AAECuAZxAAECMwUoAAEC8QaSAAEC7QZ5AAEC6AZTAAEDAAbDAAECxgaSAAECygaEAAEBrAaSAAEBqwaSAAEBsAaEAAEDDQZ5AAEDAwaEAAEC+wZ5AAEC9gZTAAEC5QaSAAEC6QaEAAEC3AZTAAECvAaSAAEC6AZWAAEC7AZuAAEC8gaSAAEC9QaEAAEC8AZlAAEC9gaBAAECbwaBAAECvQZWAAECwAZuAAECwwZlAAECygaBAAEC/AaEAAEC9AZuAAEC9wZlAAECwQUoAAEDCgaEAAEBqAZ5AAEBpAZWAAEBpwZuAAEBqgZlAAEDhAaEAAEBoQaSAAEBaQUoAAEDEQaSAAEDFQaBAAEC9gZWAAEC+QZuAAEDAQZ2AAECpwaSAAECqgaBAAEC0gaSAAEC1gaEAAEC1gaBAAECwwaBAAEC4QZ5AAEC3AZWAAEC4AZuAAEC9AbDAAEC5wZ2AAECrQUoAAEDogaEAAECwQaEAAECwAaSAAECvgZlAAECxAaBAAEDPAdrAAEC0gUKAAECqAUKAAEBkQT1AAECuAUKAAEBwAYgAAECvQYoAAECjwT9AAEDpwT7AAEDPgdzAAEDPwexAAEB9gdzAAED6gY/AAEDXweOAAEDngeOAAEC4QZDAAEC6gUAAAECswY1AAECSwZmAAEBqAYsAAEBhQZAAAECzwZmAAECnQZQAAEESQeqAAEESAeqAAEDiwZ0AAEEPwdsAAEDggY1AAEDRQeqAAECowZ0AAEBswZCAAEERQeqAAEEIAZ0AAEDRwexAAEDowexAAECvAZ0AAEC5gZmAAEDPAT1AAEDSAdeAAECswYxAAEDBAZVAAECdgUJAAEDSAZVAAECcgUKAAEEmweOAAED1gZDAAEDcAdsAAECyQY1AAEEPAZMAAEDugULAAEDQgeOAAECtwZRAAEDSgdEAAECjwULAAECvQY2AAEElwdzAAED0gYoAAEDMgeAAAECpAY0AAEDmgd2AAEC3QYrAAEDmgdzAAEC3QYoAAEDiAdtAAECyAY1AAEDagZEAAECmgULAAEDmAdwAAECyAY2AAEDageBAAECqwY1AAEDXAd2AAECmQY4AAEDXAdzAAECmgY1AAEDZweVAAECpQZYAAEDmwdzAAECuwYoAAEEQgdzAAEDxQYoAAEDjwgBAAEC5wbKAAEDfgedAAEC1gZmAAEDdQeHAAECzgZQAAEDXAgIAAEC0QbKAAEDQweZAAECuAZcAAEDSwekAAECwAZmAAECFAgIAAEBxgbBAAEBxwZIAAEBqgZAAAEDpggCAAEC5gbKAAECmQUKAAEDlgeeAAEC1QZmAAEDkAepAAEC4QZ0AAEDpQgAAAEC9gbKAAEDjAeRAAEC3QZbAAEDWQY/AAECqQUKAAECoAUKAAEDgwgBAAEC7QbKAAEDkwe2AAEC3AZfAAEDqAgMAAEC8Qa1AAEDjwedAAEC2AZGAAEDWwZMAAECpAT1AAECawUKAAEDWwgAAAECuAbKAAEDQQeRAAECnwZbAAECYgT1AAEDbQZIAAECjQT9AAEDBwZIAAECFQT9AAEDDQZAAAEDEQZMAAECYAUAAAECoAUJAAEDEAZMAAEDgQe/AAECyQZ0AAEDpAeqAAEC3AZ0AAEDeQeCAAEC0gZMAAEDRweJAAECvAZMAAEB/geJAAEBsAZDAAEDkQeDAAEC0QZMAAEDLQeCAAECPAZMAAEDbgeCAAEC2AZMAAEC3AZMAAEC9wZMAAEDJgZHAAEC0AZIAAECpgZIAAEDZgZIAAECpwZpAAEDKgemAAEDMgexAAEC8wY9AAEC+gZHAAEBuAY9AAEBuQaaAAEEDQZBAAED6AUKAAEDbQZBAAECpQUKAAEDLQe2AAEDIQZqAAEC9gZBAAECBQUKAAEDFwZCAAECegUKAAEDBwZAAAEB0gXHAAEDNwZBAAEDVAedAAECkAZRAAEDIAZMAAECXAUAAAEEEQZBAAEDVAUKAAEDCQZBAAECbwUKAAEDWgZCAAECbwUoAAEC2gUoAAECswZTAAECvQZTAAECrwaSAAEBdAUoAAEBowZTAAEDSAUoAAECpgaSAAEC1QZuAAECeAUoAAECdwUoAAEDCwZuAAEDZAUoAAECxwUoAAEClwUoAAECiAUoAAECkQUoAAECegUoAAECzwUoAAECugUoAAEChQUoAAEDCAZWAAEC0QZWAAED/QZ0AAEC/waSAAECmgUoAAEDnwaSAAEDngaSAAEDlQZTAAECvQaSAAEDQwZBAAECmwUKAAEDDwZIAAEChQUKAAECuQUoAAECjgUoAAEBeQUBAAEAAAAKAGQAJAAEREZMVAD4Y3lybAD4Z3JlawD4bGF0bgD8AB8BEAEYASABKAEwATgBOAFAAUgBUAFYAWABaAFwAXgBgAGIAZABmAGgAagBsAG4AcAByAHQAdgB0AHYAeAB6AAaYzJzYwGwY2NtcAI6ZGxpZwG2ZG5vbQG8ZnJhYwJKbGlnYQHCbGlnYQJCbG51bQHIbG9jbAHObG9jbAHUbG9jbAHabG9jbAHgbnVtcgHmb251bQHscG51bQHyc21jcAH4c3MwMQH+c3MwMgIEc3MwMwIKc3MwNAIQc3MwNQIWc3MwNgIcc3MwNwIic3VicwIoc3VwcwIudG51bQI0AbYAAAO6AAdBWkUgA+pDUlQgA+pGUkEgBBpNT0wgBExOQVYgBH5ST00gBLBUUksgA+oAAQAAAAEHAgABAAAAAQUeAAYAAAABAj4AAQAAAAECAAAEAAAAAQSUAAEAAAABAYoAAQAAAAEB+gABAAAAAQGAAAQAAAABAZwABAAAAAEBnAAEAAAAAQGwAAEAAAABAWYAAQAAAAEBZAABAAAAAQFiAAEAAAABAXwAAQAAAAEBfgABAAAAAQI2AAEAAAABAYQAAQAAAAECRAABAAAAAQJqAAEAAAABApAAAQAAAAECtgABAAAAAQEgAAYAAAABAYQAAQAAAAEBqAABAAAAAQG6AAEAAAABAcwAAQAAAAEA/gAAAAEAAAAAAAEACwAAAAEAGwAAAAEACgAAAAEAFgAAAAEACAAAAAEABQAAAAEABwAAAAEABgAAAAEAHAAAAAEAEwAAAAEAFAAAAAEAAQAAAAEADAAAAAEADQAAAAEADgAAAAEADwAAAAEAEAAAAAEAEQAAAAEAEgAAAAEAHgAAAAEAHQAAAAEAFQAAAAIAAgAEAAAAAgAJAAoAAAADABcAGAAaAAD//wAUAAAAAQACAAMABAAHAAwADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQABB2oAAgABB0YAAQABB0YB+QABB0YBigABB0YCEAABB0YBggABB2wBjwABB04AAQdIAAEHRgABB0wAAgdgAAICRwJIAAIHVgACAkkCSgABB1QAAwc2BzoHPgACB1IAAwKJAooCigACB2gABgJ8AnoCfQJ+AnsFKQACB0YABgUjBSQFJQUmBScFKAADAAEHVAABBwYAAAABAAAAGQACBzIHGgeUB1gABwAABx4HHgceBx4HHgceAAIG2gAKAeIB4QHgAjoCOwI8Aj0CPgI/AkAAAgbAAAoCWQB6AHMAdAJaAlsCXAJdAl4CXwACBqYACgGWAHoAcwB0AZcBmAGZAZoBmwGcAAIHAAAMAmACYgJhAmMCZAKCAoMChAKFAoYChwKIAAIHNgAUAnUCeQJzAnACcgJxAnYCdAJ4AncCagJlAmYCZwJoAmkAGgAcAm4CgAACBtAAFASwAowEqQSqBKsErAStAoEErgSvAmcCaQJoAmYCagKAABoCbgAcAmUAAgceABQCdgJ4AnkCcwJwAnICcQJ0AncCdQAbABUAFgAXABgAGQAaABwAHQAUAAIGyAAUBK0ErgKMBKkEqgSrBKwCgQSvABcAGQAYABYAGwAUABoAHQAcABUEsAAA//8AFQAAAAEAAgADAAQABgAHAAwADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAA//8AFQAAAAEAAgADAAQABQAHAAwADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAA//8AFgAAAAEAAgADAAQABgAHAAgADAANAA4ADwAQABEAEgATABQAFQAWABcAGAAZAAD//wAWAAAAAQACAAMABAAGAAcACQAMAA0ADgAPABAAEQASABMAFAAVABYAFwAYABkAAP//ABYAAAABAAIAAwAEAAYABwAKAAwADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAA//8AFgAAAAEAAgADAAQABgAHAAsADAANAA4ADwAQABEAEgATABQAFQAWABcAGAAZAAEHhgA2BwQFxgXKBgIHEgYIBc4HIAZEBkwGDgaYB2YF0gaEBlQGFAd2BhoGXAakBiAHLgXWBdoGJgc8Bd4F4gXmBmQGbAYsBrAHSgXqBo4GdAYyB1gGOAZ8BrwGPgXuBfIF9gX6BsgG1AbgBuwG+AX+AAIHfgDrAo0CTgJNAkwCSwJDAgECAAH/Af4B/QH8AfsB+gH5AfgB9wH2AfUB9AHzAfIB8QHwAe8B7gHtAn8CjwNMApECkANLAf4CjgKTAm0E7gTvAgUCBgTwBPEE8gIHBPMCCAIJAgoE+AILAgsE+QT6AgwCDQIOAhUFBwUIAhYCFwIYAhkCGgIbBQsFDAUOBREFGgIdAh4CHwIgAiECIgIjAiQCJQImAg8CEAIRAhICEwIUAlYCKAIpAioCKwUUAiwCLgIvAjACMgI0ApIDTQNOA08DUANRA1IDUwNUA1UDVgNXA1gDWQNaA1sDXANdA14DXwNgA2EDYgNjA2QDZQNmA2cDaAOeA2kDagNrA2wDbQNuA28DcANxA3IDcwN0A3UDdgN3A3gDeQN6A3sDfAN9A34FGwOAA4EDggODA4QDhQOGA4cDiAOJA4oDiwOMA40DjgOPA5ADkQUeA5IDkwOVA5QDlgOXA5gDmQOaA5sDnAOdA58DoAOhBRwFHQTnBOgE6QTqBPQE9wT1BPYE+wT8BP0E6wTsBO0FBgUJBQoFDQUPBRACHAUSBP4E/wUABQEFAgUDBQQFBQUfBSAFIQUiBRMFFQUWAjMFGAI1BRkFFwIxAicCLQUnBSgAAgd8APsCAgKNAewB6wHqAekB6AHnAeYB5QHkAeMCTgJNAkwCSwJDAgECAAH/Af4B/QH8AfsB+gH5AfgB9wH2AfUB9AHzAfIB8QHwAe8B7gHtAgMCBAKPApECkAKSAo4CkwJtAgUCBgIHAggCCQIKAgsCDAINAg4CDwIQAhECEgITAhQCFQIWAhcCGAIZAhsCHAUaAh0CHgIfAiACIQIiAiMCJAIlAiYCVgIoAikCKgIrBRQCLAIuAi8CMAIxAjICMwI0An8CNgI3AjkCOANLA0wDTQNOA08DUANRA1IDUwNUA1UDVgNXA1gDWQNaA1sDXANdA14DXwNgA2EDYgNjA2QDZQNmA2cDaANpA2oDawNsA20DbgNvA3ADcQNyA3MDdAN1A3YDdwN4A3kDegN7A3wDfQN+A38FGwOAA4EDggODA4QDhQOGA4cDiAOJA4oDiwOMA40DjgOPA5ADkQUeA5IDkwOVA5QDlgOXA5gDmQOaA5sDnAOdA54DnwOgA6EFHAUdBOcE6ATpBOoE6wTsBO0E7gTvBPAE8QTyBPME9AT1BPYE9wT4BPkE+gT7BPwE/QT+BP8FAAUBBQIFAwIaBQQFBQUGBQcFCAUJBQoFCwUMBQ0FDgUPBRAFEQUSBR8FIAUhBSIFEwUVBRYFGAI1BRkFFwInAi0FJwUoAAEAAQF8AAEAAQBLAAEAAQC7AAEAAQA2AAEAAQATAAEAAgMkAyUAAgdgB1QAAQABAEoAAgdcB04AAQdeAAEHYAABB2IAAgABABQAHQAAAAEAAgAvAE8AAQADAEoAVwCVAAEAAwBJAEsChQACAAAAAQc6AAEABgLWAtcC6ALpA2sDdAABAAYATQBOAv0D6gPsBGUAAgADAZUBlQAAAeAB4gABAjoCQAAEAAIAAgCoAKwAAQEkAScAAQABAAwAJwAoACsAMwA1AEYARwBIAEsAUwBUAFUAAgACABQAHQAAAnACeQAKAAIABgBNAE0AAQBOAE4AAwL9Av0AAgPqA+oABAPsA+wABQRlBGUABgACAAQAFAAdAAACgQKBAAoCjAKMAAsEqQSwAAwAAgAGABoAGgAAABwAHAABAmUCagACAm4CbgAIAnACeQAJAoACgAATAAEAFAAaABwCZQJmAmcCaAJpAmoCbgKAAoECjASpBKoEqwSsBK0ErgSvBLAAAQY6AAEGPAABBj4AAQZAAAEGQgABBkQAAQZGAAEGSAABBkoAAQZMAAEGTgABBlAAAQZSAAEGVAABBlYAAgZYBl4AAgZeBmQAAgZkBmoAAgZqBnAAAgZwBnYAAgZ2BnwAAgZ8BoIAAgaCBogAAgaIBo4AAgaOBpQAAgaUBpoAAwaaBqAGpgADBqQGqgawAAMGrga0BroAAwa4Br4GxAADBsIGyAbOAAMGzAbSBtgAAwbWBtwG4gADBuAG5gbsAAQG6gbwBvYG/AAEBvgG/gcEBwoABQcGBwwHEgcYBx4ABQcYBx4HJAcqBzAABQcqBzAHNgc8B0IABQc8B0IHSAdOB1QABQdOB1QHWgdgB2YABQdgB2YHbAdyB3gABQdyB3gHfgeEB4oABQeEB4oHkAeWB5wABQeWB5wHogeoB64ABgeoB64HtAe6B8AHxgAGB74HxAfKB9AH1gfcAAYH1AfaB+AH5gfsB/IABgfqB/AH9gf8CAIICAAGCAAIBggMCBIIGAgeAAYIFggcCCIIKAguCDQABggsCDIIOAg+CEQISgAHCIoIQghICE4IVAhaCGAABwiCCFYIXAhiCGgIbgh0AAIAEQAlACkAAAArAC0ABQAvADQACAA2ADsADgA9AD4AFABFAEkAFgBLAE0AGwBPAFQAHgBWAFsAJABdAF4AKgCBAIEALACDAIMALQCGAIYALgCJAIkALwCNAI0AMACYAJsAMQDQANAANQABAOsACgBFAEYARwBIAEkASgBLAEwATQBOAE8AUABRAFIAUwBUAFUAVgBXAFgAWQBaAFsAXABdAF4AhQCGAIcAiQCKAIsAjQCQAJIAlAC7ALwAvQC+AL8AwADBAMIAwwDEAMUAxgDHAMgAyQDKAMsAzADNAM4A6gDrAOwA7QDuAO8A8ADxAPIA8wD0APUA9gD3APgA+QD6APsA/AD9AP4A/wEAAQEBAgEDAQQBBQEGAQcBMAE0ATYBOAE6ATwBQgFEAUYBSgFNAVoCmAKaArYCtwK4ArkCugK7ArwCvQK+Ar8CwALBAsICwwLEAsUCxgLHAsgCyQLKAssCzALNAs4CzwLQAtEC0wLVAtcC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLzAvUC9wL5AvsC/QMAAwIDBAMGAwgDCgMMAw4DEAMSAxUDFwMZAxsDHQMfAyEDIwMlAycDKQMrAy0DLwMxAzMDNQM3AzkDOwM9Az8DQgNEA0YDSANKA7oDuwO8A70DvwPAA8EDwgPDA8QDxQPGA8cDyAPfA+AD4QPiA+MD5APlA+YD5wPoA+kD6gPrA+wD7QPuA/AD8gP0A/YECwQNBA8EHQQkBCoEMASaBJsEnwSjBSQFJgABAPsACAAKABQAFQAWABcAGAAZABoAGwAcAB0AJQAmACcAKAApACoAKwAsAC0ALgAvADAAMQAyADMANAA1ADYANwA4ADkAOgA7ADwAPQA+AGUAZwCBAIMAhACMAI8AkQCTALEAsgCzALQAtQC2ALcAuAC5ALoA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoAOkBLwEzATUBNwE5ATsBQQFDAUUBSQFLAUwBWAFZAXEBsgG4Ab0BwAKWApcCmQKbApwCnQKeAp8CoAKhAqICowKkAqUCpgKnAqgCqQKqAqsCrAKtAq4CrwKwArECsgKzArQCtQLSAtQC1gLYAtoC3ALeAuAC4gLkAuYC6ALqAuwC7gLwAvIC9AL2AvgC+gL8Av4C/wMBAwMDBQMHAwkDCwMNAw8DEQMUAxYDGAMaAxwDHgMgAyIDJAMmAygDKgMsAy4DMAMyAzQDNgM4AzoDPAM+A0ADQQNDA0UDRwNJA6IDowOkA6UDpgOnA6gDqgOrA6wDrQOuA68DsAOxA7IDswO0A7UDtgO3A7gDuQPJA8oDywPMA80DzgPPA9AD0QPSA9MD1APVA9YD1wPYA9kD2gPbA9wD3QPeA+8D8QPzA/UECgQMBA4EIwQpBC8EmQSeBKIFIwUlAdcAAgBNAdgAAgBQAdkAAwBKAE0B2gADAEoAUAHWAAIASgHcAAIAWAHbAAIAWAAAAAEAAQABAAEAAAADBMIAAgCtAtgAAgCpBMgAAgCtBNUAAgCpBMMAAgCtAtkAAgCpBLIAAgCpBMkAAgCtBGUAAgCtBNYAAgCpA0cAAgCpA0kAAgCpA0gAAgCpA0oAAgCpBMEAAgCpBMQAAgCtBMYAAgHVAvIAAgHVBLEAAgCpA/wAAgCpBNAAAgCtAyoAAgHVBNsAAgCtBN4AAgCqBOAAAgCtA0EAAgCpBOQAAgCtBMUAAgCtBMcAAgHVA/0AAgCpBNEAAgCtAysAAgHVBNwAAgCtBN8AAgCqBOEAAgCtA0IAAgCpBOUAAgCtAwMAAgHVBMoAAgCpBMwAAgCtAwUAAgCpAwcAAgHVBM4AAgCtAyAAAgCpAyYAAgHVBNkAAgCtA+8AAgCoA/EAAgCpBOIAAgCtAwQAAgHVBMsAAgCpBM0AAgCtAwYAAgCpAwgAAgHVBM8AAgCtAyEAAgCpAycAAgHVBNoAAgCtA/AAAgCoA/IAAgCpBOMAAgCtAxoAAgCpAxwAAgHVBL0AAgCsBNcAAgCtAxsAAgCpAx0AAgHVBL4AAgCsBNgAAgCtAqsAAgCqAw0AAgCpAw8AAgHVBLMAAgCoBNIAAgCtArUAAgCpA/UAAgCoBIwAAgCtBI4AAgCrBJAAAgCqAsYAAgCqAw4AAgCpAxAAAgHVBLQAAgCoBNMAAgCtAtAAAgCpA/YAAgCoBI0AAgCtBI8AAgCrBJEAAgCqAsIAAgCoAsMAAgCpAvcAAgCqBGMAAgCrBLoAAgCsBHQAAgCpBHYAAgCoBHgAAgCrBHoAAgCqBHwAAgCtBHUAAgCpBHcAAgCoBHkAAgCrBHsAAgCqBH0AAgCtBIIAAgCpBIQAAgCoBIYAAgCrBIgAAgCqBIoAAgCtBIMAAgCpBIUAAgCoBIcAAgCrBIkAAgCqBIsAAgCtApsAAgCoApwAAgCpAp4AAgCqBDoAAgCtBDwAAgCrBLUAAgCsAqMAAgCoAqQAAgCpBFIAAgCtBFQAAgCrBFYAAgCqBLcAAgCsAqcAAgCoAqgAAgCpAvYAAgCqBGIAAgCrBGQAAgCtBLkAAgCsArYAAgCoArcAAgCpArkAAgCqBDsAAgCtBD0AAgCrBLYAAgCsAr4AAgCoAr8AAgCpBFMAAgCtBFUAAgCrBFcAAgCqBLgAAgCsAscAAgCoAsgAAgCpAsoAAgCqBGcAAgCtBGkAAgCrBLwAAgCsAswAAgCoAs0AAgCpAzEAAgCqBH8AAgCtBIEAAgCrBMAAAgCsAqwAAgCoAq0AAgCpAq8AAgCqBGYAAgCtBGgAAgCrBLsAAgCsArEAAgCoArIAAgCpAzAAAgCqBH4AAgCtBIAAAgCrBL8AAgCsBNQAAwCqAKkE3QADAKoAqQ==",
      "Roboto-Regular.ttf": "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"
    }, c = typeof window == "object" ? window : typeof Wo == "object" ? Wo : typeof self == "object" ? self : DE;
    typeof c.pdfMake < "u" && typeof c.pdfMake.addVirtualFileSystem < "u" && c.pdfMake.addVirtualFileSystem(n), e.exports = n;
  })(Hs)), Hs.exports;
}
var IE = dE();
const _s = /* @__PURE__ */ vB(IE);
bn.addVirtualFileSystem(_s);
function yE(e, n) {
  const E = e.Fa?.RodzajFaktury?._text == pt.KOR && Ae(e.Fa?.OkresFaKorygowanej) ? tE(e.Fa) : BE(e.Fa), Y = {
    ...qs(n?.watermark),
    content: [
      ...Sa(e.Fa, n),
      Vs(e.Fa),
      ..._l(e),
      iE(e.Fa),
      E,
      gE(
        e.Fa?.Zamowienie,
        Dn.Order,
        e.Fa?.P_15?._text ?? "",
        e.Fa?.RodzajFaktury?._text ?? "",
        e.Fa?.KodWaluty?._text ?? "",
        de(e.Fa?.Adnotacje?.P_PMarzy)
      ),
      AE(e),
      jl(e.Fa?.Adnotacje),
      Jl(e.Fa),
      Xs(e.Fa?.Rozliczenie, e.Fa?.KodWaluty?._text ?? ""),
      Wl(e.Fa?.Platnosc),
      oE(e.Fa?.WarunkiTransakcji),
      ...Zs(n, e.Stopka, e.Naglowek, e.Fa?.WZ)
    ],
    footer: (X, Q) => ({
      text: `${X.toString()} ${l.t("invoice.footer.pagesTotal")} ${Q}`,
      alignment: Rt.RIGHT,
      margin: [0, 0, 40, 0]
    }),
    ...os()
  };
  return bn.createPdf(Y);
}
function FE(e) {
  const n = [];
  let c = [];
  const E = [];
  if (e) {
    const Y = e.Zwolnienie;
    if (Y?.P_19?._text === "1" && (c.push({
      text: l.t("invoice.annotations.noTaxDelivery")
    }), Y.P_19A?._text && (c.push(
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument")
      )
    ), c.push(ZA(l.t("invoice.annotations.law"), Y.P_19A._text))), Y.P_19B?._text && (c.push(
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument2")
      )
    ), c.push(ZA(l.t("invoice.annotations.directiveLaw"), Y.P_19B._text))), Y.P_19C?._text && (c.push(
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument3")
      )
    ), c.push(ZA(l.t("invoice.annotations.otherLaw"), Y.P_19C._text)))), e.NoweSrodkiTransportu?.P_42_5?._text === "1" || e.NoweSrodkiTransportu?.P_42_5?._text === "2") {
      let X = [], Q = " ";
      e.NoweSrodkiTransportu.P_42_5?._text === "1" ? Q = l.t("invoice.annotations.vat22DocumentRequired") : e.NoweSrodkiTransportu.P_42_5?._text === "2" && (Q = l.t("invoice.annotations.vat22DocumentNotRequired")), X = [
        ...ZA(`${l.t("invoice.annotations.newTransportsDelivery")}: `, Q ?? "")
      ], X && (c = [c, ...X]);
    }
    if (e.P_18A?._text === "1" && E.push({ text: l.t("invoice.annotations.partialPayMechanism") }), e.P_16?._text === "1" && E.push({ text: l.t("invoice.annotations.cashMethod") }), e.P_18?._text === "1" && E.push({ text: l.t("invoice.annotations.reverseTax") }), e.P_23?._text === "1" && E.push({ text: l.t("invoice.annotations.threePartsSimplerMethod") }), e.PMarzy?.P_PMarzy?._text === "1") {
      let X = "";
      e.PMarzy.P_PMarzy_3_1?._text === "1" ? X = l.t("invoice.annotations.usedGoods") : e.PMarzy.P_PMarzy_3_2?._text === "1" ? X = l.t("invoice.annotations.artPieces") : e.PMarzy.P_PMarzy_2?._text === "1" ? X = l.t("invoice.annotations.travelAgencies") : e.PMarzy.P_PMarzy_3_3?._text === "1" && (X = l.t("invoice.annotations.antiques")), E.push(ZA(l.t("invoice.annotations.marginProcedure"), X));
    }
    e.P_17?._text === "1" && E.push({ text: l.t("invoice.annotations.selfInvoice") }), (c.length || E.length) && n.push(Li([c, E])), n.length && (n.unshift(Ei(1)), n.unshift(Ne(l.t("invoice.annotations.header"))), n.unshift(Ei(1)), n.push(Ei(1))), (e.NoweSrodkiTransportu?.P_42_5?._text === "1" || e.NoweSrodkiTransportu?.P_42_5?._text === "2") && n.push(xE(e.NoweSrodkiTransportu));
  }
  return n;
}
function xE(e) {
  const n = Te(e.NowySrodekTransportu);
  let c = [];
  const E = {
    table: {
      headerRows: 1,
      widths: [100, "*"],
      body: []
    },
    layout: dn,
    marginTop: 4
  };
  if (n?.length) {
    const Y = [
      { text: l.t("invoice.annotations.usePermissionDate"), style: R.GrayBoldTitle },
      { text: l.t("invoice.annotations.description"), style: R.GrayBoldTitle }
    ];
    c = n.map((X) => {
      const Q = [], B = Ae(X.P_22B) || Ae(X.P_22BT) || Ae(X.P_22B1) || Ae(X.P_22B2) || Ae(X.P_22B3) || Ae(X.P_22B4), r = Ae(X.P_22C) || Ae(X.P_22C1), A = Ae(X.P_22D) || Ae(X.P_22D1), a = Ae(X.P_22B1) || Ae(X.P_22B2) || Ae(X.P_22B3) || Ae(X.P_22B4);
      X.P_NrWierszaNST?._text && Q.push(X.P_NrWierszaNST._text), B ? Q.push(l.t("invoice.annotations.landDelivery")) : r ? Q.push(l.t("invoice.annotations.boatDelivery")) : A && Q.push(l.t("invoice.annotations.airDelivery"));
      const d = [
        de(X.P_22BMK),
        de(X.P_22BMD),
        de(X.P_22BK),
        de(X.P_22BNR),
        de(X.P_22BRP)
      ].filter((x) => !!x);
      return d.length && Q.push(d.join(", ")), X.DetailsString?._text && Q.push(X.DetailsString._text), (B || r || A) && Q.push(X.P_22B?._text ?? X.P_22C?._text ?? X.P_22D?._text ?? ""), X.P_22C1?._text && Q.push(`${l.t("invoice.annotations.hullNumber")}: ${X.P_22C1._text}`), X.P_22D1?._text && Q.push(`${l.t("invoice.annotations.factoryNumber")}: ${X.P_22D1._text}`), a && (X.P_22B1?._text && Q.push(`${l.t("invoice.annotations.vin")}: ${X.P_22B1._text}`), X.P_22B2?._text && Q.push(`${l.t("invoice.annotations.bodyNumber")}: ${X.P_22B2._text}`), X.P_22B3?._text && Q.push(`${l.t("invoice.annotations.chassisNumber")}: ${X.P_22B3._text}`), X.P_22B4?._text && Q.push(`${l.t("invoice.annotations.frameNumber")}: ${X.P_22B4._text}`)), X.P_22BT?._text && Q.push(X.P_22BT._text), [re(X.P_22A?._text), { text: Q.join(`
`) }];
    }), E.table.body = [[...Y], ...c];
  }
  return c.length ? [E, Ei(1)] : [];
}
function pE(e) {
  const n = [];
  de(e.TP) === "1" && n.push(re(l.t("invoice.additionalInformation.tpLabel")));
  const c = [];
  de(e.FP) === "1" && c.push(re(l.t("invoice.additionalInformation.fpLabel")));
  const E = [];
  de(e.ZwrotAkcyzy) === "1" && E.push(re(l.t("invoice.additionalInformation.exciseTaxRefund")));
  const Y = [n, c, E].filter(
    (Q) => Q.length > 0
  ), X = [
    ...Ne(l.t("invoice.additionalInformation.additionalInformationLabel")),
    ...Y,
    ...mE(e.DodatkowyOpis)
  ];
  return X.length > 1 ? mt(X, !0) : [];
}
function mE(e) {
  if (!e)
    return [];
  const n = Te(e)?.map(
    (X, Q) => ({
      ...X,
      lp: { _text: Q + 1 }
    })
  ), c = kt(l.t("invoice.additionalInformation.additionalDescription")), E = [
    {
      name: "lp",
      title: l.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "NrWiersza",
      title: l.t("invoice.additionalInformation.rowNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Klucz",
      title: l.t("invoice.additionalInformation.infoType"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Wartosc",
      title: l.t("invoice.additionalInformation.infoContent"),
      format: R.Default,
      width: "*"
    }
  ], Y = ft(
    E,
    n,
    "*",
    [0, 0, 0, 0]
  );
  return Y.content && c.push(Y.content), c;
}
const sB = (e, n) => {
  const c = [];
  return e?.length ? (e.forEach((E, Y) => {
    const X = [], Q = Ne(
      n ? `${n} ${e?.length > 1 ? ++Y : ""}` : "",
      [0, 12, 0, 8]
    );
    X.push([
      re(l.t("invoice.registers.fullAccountNumber"), R.GrayBoldTitle),
      re(de(E.NrRB), R.AccountNumber)
    ]), X.push([
      re(l.t("invoice.registers.swiftCode"), R.GrayBoldTitle),
      re(de(E.SWIFT), R.Default)
    ]), X.push([
      re(l.t("invoice.registers.ownBankAccount"), R.GrayBoldTitle),
      re(
        Ti(qt(E.RachunekWlasnyBanku, Ta), 20),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.bankName"), R.GrayBoldTitle),
      re(
        Ae(E.NazwaBanku) ? Ti(de(E.NazwaBanku), 20) : de(E.NazwaBanku),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.accountDescription"), R.GrayBoldTitle),
      re(
        Ae(E.OpisRachunku) ? Ti(de(E.OpisRachunku), 20) : de(E.OpisRachunku),
        R.Default
      )
    ]), c.push([
      ...Q,
      {
        unbreakable: !0,
        table: {
          body: X,
          widths: ["auto", "*"]
        },
        layout: dn
      }
    ]);
  }), mt(c, !1)) : [];
};
function YE(e) {
  if (!e)
    return [];
  const n = Te(e.TerminPlatnosci), c = [
    {
      name: "Termin",
      title: l.t("invoice.payment.maturityDate"),
      format: R.Date
    }
  ];
  n.some((x) => x.TerminOpis) && c.push({
    name: "TerminOpis",
    title: l.t("invoice.payment.paymentDescription"),
    format: R.Date
  });
  const E = [
    {
      name: "DataZaplatyCzesciowej",
      title: l.t("invoice.payment.partialPaymentDate"),
      format: R.Date
    },
    {
      name: "KwotaZaplatyCzesciowej",
      title: l.t("invoice.payment.partialPaymentAmount"),
      format: R.Currency
    },
    {
      name: "FormaPlatnosci",
      title: l.t("invoice.payment.paymentMethod"),
      format: R.FormOfPayment
    }
  ], Y = [Ui(), ...Ne(l.t("invoice.payment.payment"))];
  e.Zaplacono?._text === "1" ? (Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.paidStatus"))
  ), Y.push(ZA(l.t("invoice.payment.paymentDate"), e.DataZaplaty, R.Date))) : e.ZnacznikZaplatyCzesciowej?._text === "1" ? Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.partialPayment"))
  ) : Y.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.noPayment"))
  ), Ae(e.FormaPlatnosci) ? Y.push(
    ZA(
      l.t("invoice.payment.paymentMethod2"),
      qt(e.FormaPlatnosci, Ws)
    )
  ) : e.OpisPlatnosci?._text && (Y.push(
    ZA(l.t("invoice.payment.paymentMethod2"), l.t("invoice.payment.paymentDifferent"))
  ), Y.push(ZA(l.t("invoice.payment.otherPaymentDescription"), e.OpisPlatnosci)));
  const X = Te(e.ZaplataCzesciowa), Q = ft(
    E,
    X,
    "*"
  ), B = n.map(
    (x) => n.some((U) => U.TerminOpis) ? {
      ...x,
      TerminOpis: {
        _text: `${x.Termin?._text ?? ""}`
      }
    } : x
  ), r = ft(
    c,
    B,
    "*"
  );
  X.length > 0 && n.length > 0 ? Y.push(
    It(
      Q.content ?? [],
      r.content ?? [],
      [0, 4, 0, 0]
    )
  ) : n.length > 0 ? r.content && Y.push(It(r.content, [])) : X.length > 0 && Q.content && Y.push(Q.content);
  const A = Te(e.RachunekBankowy).map(
    (x) => sB([x], l.t("invoice.payment.bankAccountNumber"))
  ), a = Te(
    e.RachunekBankowyFaktora
  ).map((x) => sB([x], l.t("invoice.payment.factorsBankAccountNumber"))), d = [...A, ...a];
  return d.length > 0 && d.forEach((x, U) => {
    U % 2 === 0 && Y.push(It(x, d[U + 1] ?? []));
  }), e.Skonto && (Y.push(Ne(l.t("invoice.payment.conditionalDiscount"), [0, 0])), Y.push(ZA(l.t("invoice.payment.discountConditions"), e.Skonto.WarunkiSkonta)), Y.push(ZA(l.t("invoice.payment.discountAmount"), e.Skonto.WysokoscSkonta))), Y;
}
function Hi(e) {
  const n = [];
  return e?.AdresL1 && n.push(re(e.AdresL1._text, R.Value)), e?.AdresL2 && n.push(re(e.AdresL2._text, R.Value)), e?.KodKraju && n.push(re(l.t(Na(e.KodKraju._text ?? "")), R.Value)), n.push(...ZA(l.t("invoice.address.GLN"), e.GLN)), n;
}
function $s(e) {
  return [
    ZA(l.t("invoice.subject1.nip"), e.NIP),
    ZA(l.t("invoice.subject1.name"), e.Nazwa)
  ];
}
function vr(e) {
  return Te(e)?.map((n) => [
    ZA(l.t("invoice.authorizedSubject.email"), n.Email),
    ZA(l.t("invoice.authorizedSubject.phone"), n.Telefon)
  ]);
}
function aB(e) {
  const n = Ne(l.t("invoice.subject1.seller"));
  if (n.push(
    ZA(l.t("invoice.subject1.eoriNumber"), e.NrEORI),
    ZA(l.t("invoice.subject1.vatPrefix"), e.PrefiksPodatnika)
  ), e.DaneIdentyfikacyjne && n.push(...$s(e.DaneIdentyfikacyjne)), e.Adres && n.push(
    re(l.t("invoice.subject1.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject1.correspondenceAddress"), [R.Label, R.LabelMargin]),
    ...Hi(e.AdresKoresp)
  ), e.DaneKontaktowe && n.push(
    re(l.t("invoice.subject1.contactDetails"), [R.Label, R.LabelMargin]),
    ...vr(e.DaneKontaktowe)
  ), Ae(e.StatusInfoPodatnika)) {
    const c = qt(e.StatusInfoPodatnika, On);
    n.push(ZA(l.t("invoice.subject1.taxpayerStatus"), c));
  }
  return n;
}
function PE(e, n) {
  const c = Ne(l.t("invoice.subject1K.seller"));
  let E = [], Y = [];
  if (E.push(
    Ne(l.t("invoice.subject1K.identificationData")),
    ZA(l.t("invoice.subject1K.eoriNumber"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...$s(e.DaneIdentyfikacyjne)), e.DaneKontaktowe && E.push(vr(Te(e.DaneKontaktowe))), e.StatusInfoPodatnika) {
    const X = qt(e.StatusInfoPodatnika, On);
    E.push(ZA(l.t("invoice.subject1K.taxpayerStatus"), X));
  }
  return E.length && c.push(E), E = oB(n, l.t("invoice.subject1K.correctedContent")), Y = oB(e, l.t("invoice.subject1K.correctiveContent")), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject1K.correspondenceAddress"), [R.Label, R.LabelMargin]),
    Hi(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function oB(e, n) {
  const c = [];
  return c.push(Ne(n)), e.PrefiksPodatnika?._text && c.push(ZA(l.t("invoice.subject1K.vatPrefix"), e.PrefiksPodatnika)), e.DaneIdentyfikacyjne && c.push(...$s(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    re(l.t("invoice.subject1K.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), c;
}
function $n(e) {
  const n = [];
  return n.push(ZA(l.t("invoice.subject2.nip"), e.NIP)), e.NrVatUE?._text && n.push(
    ii([
      { value: l.t("invoice.subject2.vatUeNumber"), formatTyp: R.Label },
      { value: e.KodUE, formatTyp: R.Value },
      { value: " " },
      { value: e.NrVatUE, formatTyp: R.Value }
    ])
  ), e.NrID?._text && n.push(
    ii([
      { value: l.t("invoice.subject2.taxIdOther"), formatTyp: R.Label },
      { value: e.KodKraju || "", formatTyp: R.Value },
      { value: " " },
      { value: e.NrID, formatTyp: R.Value }
    ])
  ), e.BrakID?._text === "1" && n.push(re(l.t("invoice.subject2.noTaxId"), R.Label)), n.push(ZA(l.t("invoice.subject2.name"), e.Nazwa)), n;
}
function ha(e) {
  const n = Ne(l.t("invoice.subject2.buyer"));
  return n.push(
    ZA(l.t("invoice.subject2.getterId"), e.IDNabywcy),
    ZA(l.t("invoice.subject2.eoriNumber"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && n.push(
    ...$n(
      e.DaneIdentyfikacyjne
    )
  ), e.Adres && n.push(
    re(l.t("invoice.subject2.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject2.correspondenceAddress"), [R.Label, R.LabelMargin]),
    ...Hi(e.AdresKoresp)
  ), e.DaneKontaktowe && n.push(
    re(l.t("invoice.subject2.contactDetails"), [R.Label, R.LabelMargin]),
    ...vr(e.DaneKontaktowe),
    ZA(l.t("invoice.subject2.customerNumber"), e.NrKlienta)
  ), n;
}
function vE(e, n) {
  const c = [];
  c.push(Ui()), c.push(Ne(l.t("invoice.subject2k.buyer")));
  let E = [], Y = [];
  return E.push(
    Ne(l.t("invoice.subject2k.identificationData")),
    ZA(l.t("invoice.subject2k.eori"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...$n(e.DaneIdentyfikacyjne)), e.DaneKontaktowe && E.push(vr(Te(e.DaneKontaktowe))), e.NrKlienta && E.push(ZA(l.t("invoice.subject2k.clientNumber"), e.NrKlienta)), E.length && c.push({
    columns: [E, []],
    columnGap: 20
  }), n.DaneIdentyfikacyjne && (E = Os(n, l.t("invoice.subject2k.correctedContent")), Y = Os(e, l.t("invoice.subject2k.correctiveContent"))), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject2k.correspondenceAddress"), [R.Label, R.LabelMargin]),
    Hi(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function Os(e, n) {
  const c = [];
  return c.push(Ne(n)), Ae(e.IDNabywcy) && c.push(ZA(l.t("invoice.subject2k.buyerId"), e.IDNabywcy)), e.DaneIdentyfikacyjne && c.push(...$n(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    re(l.t("invoice.subject2k.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), c;
}
function bE(e) {
  if (!e)
    return [];
  const n = [];
  return Ae(e.NIP) ? n.push(ZA(l.t("invoice.subject2.nip"), e.NIP, R.Default)) : Ae(e.IDWew) ? n.push(
    ZA(l.t("invoice.subject2.internalId"), e.IDWew, R.Default)
  ) : Ae(e.KodUE) ? n.push(
    ii([
      { value: l.t("invoice.subject2.vatUeNumber"), formatTyp: R.Label },
      { value: e.KodUE, formatTyp: R.Default },
      { value: "" },
      { value: e.NrVatUE, formatTyp: R.Default }
    ])
  ) : Ae(e.NrID) ? n.push(
    ii([
      { value: l.t("invoice.subject2.taxIdOther"), formatTyp: R.Label },
      { value: e.KodKraju, formatTyp: R.Default },
      { value: "" },
      { value: e.NrID, formatTyp: R.Default }
    ])
  ) : e.BrakID?._text === "1" && n.push(ZA(l.t("invoice.subject2.noTaxId"), " ", R.Default)), Ae(e.Nazwa) && n.push(
    ZA(l.t("invoice.subject2.name"), e.Nazwa, R.Default)
  ), n;
}
function BB(e, n) {
  const c = [];
  c.push(Ui());
  const E = [
    ...Ne(l.t("invoice.subject3.otherEntity", { index: n + 1 })),
    ZA(l.t("invoice.subject3.getterId"), e.IDNabywcy),
    ZA(l.t("invoice.subject3.eori"), e.NrEORI),
    ...bE(e.DaneIdentyfikacyjne),
    ZA(l.t("invoice.subject3.role"), qt(e.Rola, TB)),
    ZA(l.t("invoice.subject3.otherRole"), e.OpisRoli),
    ZA(l.t("invoice.subject3.share"), e.Udzial, [R.Percentage])
  ], Y = [];
  return e.Adres && Y.push(
    re(l.t("invoice.subject3.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject3.correspondenceAddress"), [R.Label, R.LabelMargin]),
    ...Hi(e.AdresKoresp)
  ), (e.DaneKontaktowe || e.NrKlienta) && (Y.push(
    re(l.t("invoice.subject3.contactData"), [R.Label, R.LabelMargin])
  ), e.DaneKontaktowe && Y.push(...vr(e.DaneKontaktowe)), e.NrKlienta && Y.push(ZA(l.t("invoice.subject3.clientNumber"), e.NrKlienta))), c.push(It(E, Y)), c;
}
function pr(e, n = l.t("invoice.subject1.address"), c = !1, E) {
  return e ? [
    ...c ? kt(n, E) : Ne(n, E),
    ...Hi(e)
  ] : [];
}
function zE(e, n) {
  if (!e)
    return [];
  const c = e.fakturaPodmiotNDto, E = Te(c.DaneKontaktowe), Y = e.podmiot2KDto, X = [];
  X.push(Ui()), X.push(Ne(`${l.t("invoice.subject3k.otherEntity")} ${n + 1}`)), (Ae(c.NrEORI) || Ae(c.Rola) || Ae(c.OpisRoli) || Ae(c?.Udzial)) && X.push(
    ...Ne(l.t("invoice.subject3k.identificationData")),
    ZA(l.t("invoice.subject3k.eori"), c.NrEORI),
    ZA(l.t("invoice.subject3k.role"), qt(c.Rola, TB)),
    ZA(l.t("invoice.subject3k.otherRole"), c.OpisRoli),
    ZA(l.t("invoice.subject3k.share"), c.Udzial, R.Percentage)
  ), (E.length > 0 || Ae(c.NrKlienta)) && (X.push(vr(c.DaneKontaktowe ?? [])), X.push(ZA(l.t("invoice.subject3k.clientNumber"), c.NrKlienta)));
  const Q = [
    ...Ne(l.t("invoice.subject3k.correctedContent")),
    ZA(l.t("invoice.subject3k.getterId"), Y?.IDNabywcy)
  ];
  Y?.DaneIdentyfikacyjne && Q.push($n(Y.DaneIdentyfikacyjne)), Y?.Adres && Q.push(pr(Y.Adres));
  const B = [
    ...Ne(l.t("invoice.subject3k.correctiveContent")),
    ZA(l.t("invoice.subject3k.getterId"), c?.IDNabywcy)
  ];
  return c?.DaneIdentyfikacyjne && B.push($n(c.DaneIdentyfikacyjne)), c?.Adres && B.push(pr(c.Adres)), c.AdresKoresp != null && B.push(
    pr(c.AdresKoresp, l.t("invoice.subject3k.correspondenceAddress"))
  ), X.push(It(Q, B)), X;
}
function TE(e) {
  if (!e)
    return [];
  const n = [
    re(l.t("invoice.authorizedSubject.contactData"), R.Description)
  ], c = Te(e);
  return c.length === 0 ? [] : (c.forEach((E) => {
    Ae(E.EmailPU) && n.push(ZA(l.t("invoice.authorizedSubject.email"), E.EmailPU)), Ae(E.TelefonPU) && n.push(ZA(l.t("invoice.authorizedSubject.phone"), E.TelefonPU)), n.push(Ei(1));
  }), n);
}
function UE(e) {
  if (!e)
    return [];
  const n = Ne(l.t("invoice.authorizedSubject.authorizedSubject"));
  return Ae(e.RolaPU) && n.push(
    ZA(
      l.t("invoice.authorizedSubject.role"),
      qt(e.RolaPU, Yl)
    )
  ), Ae(e.NrEORI) && n.push(ZA(l.t("invoice.authorizedSubject.eori"), e.NrEORI)), e.DaneIdentyfikacyjne && n.push($s(e.DaneIdentyfikacyjne)), n.push([
    ...pr(e.Adres),
    ...pr(
      e.AdresKoresp,
      l.t("invoice.authorizedSubject.correspondenceAddress2")
    ),
    ...TE(e.DaneKontaktowe)
  ]), n;
}
function NE(e) {
  const n = [], c = Te(e.Fa?.Podmiot2K), E = Te(e.Podmiot3);
  if (e.Fa?.Podmiot1K || c.length > 0)
    if (e.Fa?.Podmiot1K ? n.push(PE(e.Podmiot1 ?? {}, e.Fa?.Podmiot1K)) : e.Podmiot1 != null && n.push(aB(e.Podmiot1)), e.Fa?.Podmiot2K) {
      const Y = c.find(
        (X) => de(X.IDNabywcy) === de(e.Podmiot2?.IDNabywcy)
      );
      Y ? n.push(vE(e.Podmiot2 ?? {}, Y)) : n.push(mt(ha(e.Podmiot2), !0));
    } else e.Podmiot2 && n.push(mt(ha(e.Podmiot2), !0));
  else
    n.push([
      Li([aB(e.Podmiot1), ha(e.Podmiot2)], {
        margin: [0, 0, 0, 8],
        columnGap: 20
      })
    ]);
  if (E.length > 0) {
    const Y = RE(c, E);
    Y.filter(
      (X) => X.fakturaPodmiotNDto.IDNabywcy === e.Podmiot2?.IDNabywcy
    ), Y.length > 0 ? Y.forEach((X, Q) => {
      X.podmiot2KDto ? n.push(zE(X, Q)) : n.push(BB(X.fakturaPodmiotNDto, Q)), Q < Y.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    }) : E.forEach((X, Q) => {
      n.push(BB(X, Q)), Q < E.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    });
  }
  return n.push(UE(e.PodmiotUpowazniony)), mt(n, !0);
}
function RE(e, n) {
  const c = [];
  return n.filter((E) => de(E.Rola) === "4").length > 0 && n.forEach((E) => {
    de(E.Rola) === "4" ? c.push({
      fakturaPodmiotNDto: E,
      podmiot2KDto: e.find(
        (Y) => de(Y.IDNabywcy) === de(E.IDNabywcy)
      )
    }) : c.push({
      fakturaPodmiotNDto: E
    });
  }), c;
}
function SE(e) {
  const n = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) && (!Ae(e.Fa?.P_14_5) || de(e.Fa?.P_14_5) == 0) || Ae(e.Fa?.P_13_6_1) || Ae(e.Fa?.P_13_6_2) || Ae(e.Fa?.P_13_6_3) || Ae(e.Fa?.P_13_7) || Ae(e.Fa?.P_13_8) || Ae(e.Fa?.P_13_9) || Ae(e.Fa?.P_13_10) || Ae(e.Fa?.P_13_11), c = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) || Ae(e.Fa?.P_13_6_1) || Ae(e.Fa?.P_13_6_2) || Ae(e.Fa?.P_13_6_3) || Ae(e.Fa?.P_13_7) || Ae(e.Fa?.P_13_8) || Ae(e.Fa?.P_13_9) || Ae(e.Fa?.P_13_10) || Ae(e.Fa?.P_13_11), E = Ae(e.Fa?.P_14_1W) || Ae(e.Fa?.P_14_2W) || Ae(e.Fa?.P_14_3W) || Ae(e.Fa?.P_14_4W);
  let Y = [];
  const X = {
    table: {
      headerRows: 1,
      widths: [],
      body: []
    },
    layout: dn
  }, Q = [
    { text: l.t("invoice.summary.lp"), style: R.GrayBoldTitle },
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxRate"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.netAmount"), style: R.GrayBoldTitle }] : [],
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxAmount"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.grossAmount"), style: R.GrayBoldTitle }] : [],
    ...E ? [{ text: l.t("invoice.summary.taxAmountPLN"), style: R.GrayBoldTitle }] : []
  ], B = [
    "auto",
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...E ? ["*"] : []
  ];
  return e?.Fa && (Y = GE(e.Fa).map((A) => {
    const a = [];
    return a.push(A.no ?? ""), n ? A.taxRateString ? a.push(A.taxRateString) : de(e.Fa?.P_13_5) ? a.push(l.t("invoice.summary.oss")) : a.push("") : Ae(e.Fa?.P_14_5) && a.push(l.t("invoice.summary.oss")), c && a.push(re(A.net, R.Currency)), n ? a.push(re(A.tax, R.Currency)) : Ae(e.Fa?.P_14_5) && a.push(de(e.Fa?.P_14_5) ?? ""), c && a.push(re(A.gross, R.Currency)), E && a.push(re(A.taxPLN, R.Currency)), a;
  })), X.table.body = [[...Q], ...Y], X.table.widths = [...B], Y.length ? mt([...Ne(l.t("invoice.summary.sectionHeader"), [0, 0, 0, 8]), X], !1) : [];
}
function GE(e) {
  const n = [], c = Mi(e?.P_13_1) || Mi(e?.P_14_1) || Mi(e?.P_14_1W), E = Mi(e?.P_13_2) || Mi(e?.P_14_2) || Mi(e?.P_14_2W), Y = Mi(e?.P_13_3) || Mi(e?.P_14_3) || Mi(e?.P_14_3W), X = Mi(e?.P_13_4) || Mi(e?.P_14_4) || Mi(e?.P_14_4W), Q = Mi(e?.P_13_5) || Mi(e?.P_14_5), B = Mi(e?.P_13_6_1), r = Mi(e?.P_13_6_2), A = Mi(e?.P_13_6_3), a = Mi(e?.P_13_7), d = Mi(e?.P_13_8), x = Mi(e?.P_13_9), U = Mi(e?.P_13_10), P = Mi(e?.P_13_11);
  let D = 1;
  return c && (n.push({
    no: D,
    net: Se(e.P_13_1).toFixed(2),
    gross: (Se(e.P_13_1) + Se(e.P_14_1)).toFixed(2),
    tax: Se(e.P_14_1).toFixed(2),
    taxPLN: Se(e.P_14_1W).toFixed(2),
    taxRateString: l.t("invoice.summary.23or22")
  }), D++), E && (n.push({
    no: D,
    net: Se(e.P_13_2).toFixed(2),
    gross: (Se(e.P_13_2) + Se(e.P_14_2)).toFixed(2),
    tax: Se(e.P_14_2).toFixed(2),
    taxPLN: Se(e.P_14_2W).toFixed(2),
    taxRateString: l.t("invoice.summary.8or7")
  }), D++), Y && (n.push({
    no: D,
    net: Se(e.P_13_3).toFixed(2),
    gross: (Se(e.P_13_3) + Se(e.P_14_3)).toFixed(2),
    tax: Se(e.P_14_3).toFixed(2),
    taxPLN: Se(e.P_14_3W).toFixed(2),
    taxRateString: l.t("invoice.summary.5")
  }), D++), X && (n.push({
    no: D,
    net: Se(e.P_13_4).toFixed(2),
    gross: (Se(e.P_13_4) + Se(e.P_14_4)).toFixed(2),
    tax: Se(e.P_14_4).toFixed(2),
    taxPLN: Se(e.P_14_4W).toFixed(2),
    taxRateString: l.t("invoice.summary.4or3")
  }), D++), Q && (n.push({
    no: D,
    net: Se(e.P_13_5).toFixed(2),
    gross: (Se(e.P_13_5) + Se(e.P_14_5)).toFixed(2),
    tax: Se(e.P_14_5).toFixed(2),
    taxPLN: "",
    taxRateString: de(e.P_14_5) != 0 ? l.t("invoice.summary.oss") : ""
  }), D++), B && (n.push({
    no: D,
    net: Se(e.P_13_6_1).toFixed(2),
    gross: Se(e.P_13_6_1).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0domestic")
  }), D++), r && (n.push({
    no: D,
    net: Se(e.P_13_6_2).toFixed(2),
    gross: Se(e.P_13_6_2).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0wdt")
  }), D++), A && (n.push({
    no: D,
    net: Se(e.P_13_6_3).toFixed(2),
    gross: Se(e.P_13_6_3).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0export")
  }), D++), a && (n.push({
    no: D,
    net: Se(e.P_13_7).toFixed(2),
    gross: Se(e.P_13_7).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.taxFree")
  }), D++), d && (n.push({
    no: D,
    net: Se(e.P_13_8).toFixed(2),
    gross: Se(e.P_13_8).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.npExcludingArt100")
  }), D++), x && (n.push({
    no: D,
    net: Se(e.P_13_9).toFixed(2),
    gross: Se(e.P_13_9).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.npBasedArt100")
  }), D++), U && (n.push({
    no: D,
    net: Se(e.P_13_10).toFixed(2),
    gross: Se(e.P_13_10).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.reverseTax")
  }), D++), P && (n.push({
    no: D,
    net: Se(e.P_13_11).toFixed(2),
    gross: Se(e.P_13_11).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.margin")
  }), D++), n;
}
function Mi(e) {
  return Ae(e) && de(e) != 0;
}
function HE(e) {
  const n = Te(e.FaWiersz), c = [], E = [
    { name: "NrWierszaFa", title: l.t("invoice.discount.lp"), format: R.Default, width: "auto" },
    { name: "P_7", title: l.t("invoice.discount.productName"), format: R.Default },
    { name: "P_8B", title: l.t("invoice.discount.quantity"), format: R.Default },
    { name: "P_8A", title: l.t("invoice.discount.unit"), format: R.Default }
  ], Y = ft(E, n, "*"), X = Y.fieldsWithValue.includes("NrWierszaFa");
  return c.push(
    ...Ne(l.t("invoice.discount.header")),
    ...ZA(l.t("invoice.discount.totalValue"), e.P_15, R.Currency, {
      alignment: Rt.RIGHT
    }),
    It(
      re(
        l.t(X ? "invoice.discount.notAll" : "invoice.discount.all"),
        R.Default
      ),
      ""
    )
  ), Y.fieldsWithValue.length > 0 && Y.content && c.push(Y.content), mt(c, !0);
}
function LE(e) {
  const n = Te(e.FaWiersz), c = Te(e.Zamowienie?.ZamowienieWiersz), E = [pt.ZAL, pt.KOR_ZAL].includes(
    de(e.RodzajFaktury)
  ) ? l.t("invoice.details.getMoneyDate") : l.t("invoice.details.deliveryOrServiceDate"), Y = kE(e.OkresFa?.P_6_Od, e.OkresFa?.P_6_Do), X = [], Q = [];
  Ae(e.KodWaluty) && Q.push(ZA(l.t("invoice.details.currencyCode"), e.KodWaluty));
  const B = [];
  (Pr("P_12_XII", n) || Pr("P_12_XII", c)) && B.push(ZA(l.t("invoice.details.ossProcedure"), " "));
  const r = [], A = [];
  if (Ae(e.KodWaluty) && de(e.KodWaluty) != "PLN")
    if (Ae(e.KursWalutyZ))
      r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(l.t("invoice.details.currencyRate"), e.KursWalutyZ, R.Currency6)
      );
    else {
      const J = vn("KursWaluty", n);
      J.length === 1 && (r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(
          l.t("invoice.details.currencyRate"),
          J[0].value,
          R.Currency6
        )
      ));
    }
  const a = [], d = [], x = [
    ZA(l.t("invoice.details.issueDate"), e.P_1, R.Date),
    ZA(l.t("invoice.details.issuePlace"), e.P_1M),
    ZA(l.t("invoice.details.discountPeriod"), e.OkresFaKorygowanej),
    ZA(E, e.P_6, R.Date),
    Y,
    X,
    Q,
    B,
    r,
    A,
    a,
    d
  ].filter((J) => J.length > 0), U = [], P = [];
  x.forEach((J, q) => {
    q % 2 ? P.push(J) : U.push(J);
  });
  const D = [
    ...Ne(l.t("invoice.details.header")),
    It(U, P),
    ...jE(e.ZaliczkaCzesciowa),
    ...OE(e.FakturaZaliczkowa)
  ];
  return mt(D, !0);
}
function kE(e, n) {
  const c = [];
  return Ae(e) && Ae(n) ? c.push(
    ii([
      {
        value: l.t("invoice.details.deliveryOrServiceDateFrom")
      },
      { value: tn(de(e)), formatTyp: R.Value },
      { value: " do " },
      { value: tn(de(n)), formatTyp: R.Value }
    ])
  ) : Ae(e) ? c.push(
    ZA(
      l.t("invoice.details.deliveryOrServiceDateFrom"),
      tn(de(e))
    )
  ) : Ae(n) && c.push(
    ZA(
      l.t("invoice.details.deliveryOrServiceDateTo"),
      tn(de(n))
    )
  ), c;
}
function jE(e) {
  if (!e)
    return [];
  const n = Te(e), c = [], E = [
    { name: "P_6Z", title: l.t("invoice.details.getMoneyDate2"), format: R.Date },
    { name: "P_15Z", title: l.t("invoice.details.costAmount"), format: R.Default },
    { name: "KursWalutyZW", title: l.t("invoice.details.currencyRate2"), format: R.Currency6 }
  ], Y = ft(
    E,
    n,
    "auto"
  );
  return Y.content && c.push(Y.content), c;
}
function OE(e) {
  if (!e)
    return [];
  const c = Te(e).map((Q) => "NrFaZaliczkowej" in Q && Q.NrFaZaliczkowej ? { ...Q, NrFaZaliczkowej: Q.NrFaZaliczkowej } : "NrKSeFFaZaliczkowej" in Q && Q.NrKSeFFaZaliczkowej ? { ...Q, NrFaZaliczkowej: Q.NrKSeFFaZaliczkowej } : { ...Q, NrFaZaliczkowej: { _text: "" } }), E = [], Y = [
    {
      name: "NrFaZaliczkowej",
      title: l.t("invoice.details.advanceInvoiceNumbers"),
      format: R.Default
    }
  ], X = ft(
    Y,
    c,
    "auto",
    [0, 4, 0, 0]
  );
  return X.content && E.push(X.content), E;
}
function JE(e) {
  return e ? [
    ...Ne(l.t("invoice.carrier.carrier")),
    [
      It(
        $n(e.DaneIdentyfikacyjne),
        pr(
          e.AdresPrzewoznika,
          l.t("invoice.carrier.carrierAddress"),
          !0,
          [0, 0, 0, 0]
        ),
        [0, 0, 0, 8]
      )
    ]
  ] : [];
}
function KE(e, n) {
  const c = [], E = {
    transport: [],
    dane: [],
    wysylkaZ: [],
    wysylkaDo: [],
    wysylkaPrzez: []
  }, Y = l.t("invoice.transport.header");
  return c.push(Ne(n ? `${Y} ${n}` : Y)), e.RodzajTransportu?._text ? E.transport.push(
    ZA(
      l.t("invoice.transport.type"),
      qt(e.RodzajTransportu, za)
    )
  ) : e.TransportInny?._text == "1" && e.OpisInnegoTransportu?._text && (E.transport.push(
    ZA(l.t("invoice.transport.type"), l.t("invoice.transport.otherType"))
  ), E.transport.push(
    ZA(l.t("invoice.transport.otherTypeDescription"), e.OpisInnegoTransportu)
  )), E.dane.push(ZA(l.t("invoice.transport.orderNumber"), e.NrZleceniaTransportu)), Ae(e.OpisLadunku) && (E.dane.push(
    ZA(
      l.t("invoice.transport.cargoDescription"),
      qt(e.OpisLadunku, Ua)
    )
  ), e.LadunekInny?._text === "1" && e.OpisInnegoLadunku?._text && (E.dane.push(
    ZA(l.t("invoice.transport.cargoDescription"), l.t("invoice.transport.otherCargo"))
  ), E.dane.push(
    ZA(l.t("invoice.transport.otherCargoDescription"), e.OpisInnegoLadunku)
  ))), E.dane.push(ZA(l.t("invoice.transport.packageUnit"), e.JednostkaOpakowania)), E.dane.push(
    ZA(
      l.t("invoice.transport.startDateTime"),
      Yr(e.DataGodzRozpTransportu)
    )
  ), E.dane.push(
    ZA(
      l.t("invoice.transport.endDateTime"),
      Yr(e.DataGodzZakTransportu)
    )
  ), E.dane.length > 0 && E.dane.unshift(kt(l.t("invoice.transport.dataHeader"), [0, 0, 0, 0])), c.push(It(E.transport, E.dane)), c.push(JE(e.Przewoznik)), e.WysylkaZ?.AdresL1 && (E.wysylkaZ.push(kt(l.t("invoice.transport.shipFrom"), [0, 0, 0, 0])), E.wysylkaZ.push(re(e.WysylkaZ?.AdresL1?._text, R.Default)), E.wysylkaZ.push(re(e.WysylkaZ?.AdresL2?._text, R.Default)), E.wysylkaZ.push(
    re(l.t(kn[e.WysylkaZ?.KodKraju?._text ?? ""]), R.Default)
  ), E.wysylkaZ.push(ZA(l.t("invoice.transport.gln"), e.WysylkaZ?.GLN?._text))), e.WysylkaDo?.AdresL1 && (E.wysylkaDo.push(kt(l.t("invoice.transport.shipTo"), [0, 0, 0, 0])), E.wysylkaDo.push(re(e.WysylkaDo?.AdresL1?._text, R.Default)), E.wysylkaDo.push(re(e.WysylkaDo?.AdresL2?._text, R.Default)), E.wysylkaDo.push(
    re(l.t(kn[e.WysylkaDo?.KodKraju?._text ?? ""]), R.Default)
  ), E.wysylkaDo.push(ZA(l.t("invoice.transport.gln"), e.WysylkaDo?.GLN?._text))), Te(e.WysylkaPrzez).forEach((Q, B) => {
    B && E.wysylkaPrzez.push(`
`), E.wysylkaPrzez.push(kt(l.t("invoice.transport.intermediateAddress"), [0, 4, 0, 0])), E.wysylkaPrzez.push(re(Q.AdresL1?._text, R.Default)), E.wysylkaPrzez.push(re(Q?.AdresL2?._text, R.Default)), E.wysylkaPrzez.push(re(l.t(kn[Q?.KodKraju?._text ?? ""]), R.Default)), E.wysylkaPrzez.push(ZA(l.t("invoice.transport.gln"), Q?.GLN?._text));
  }), (e.WysylkaZ?.AdresL1 || e.WysylkaDo?.AdresL1 || e.WysylkaPrzez?.length) && (c.push(Ne(l.t("invoice.transport.shipmentHeader"))), c.push(It(E.wysylkaZ, E.wysylkaDo)), c.push(It(E.wysylkaPrzez, []))), mt(c, !0);
}
function WE(e) {
  if (!e)
    return [];
  const n = [], c = { umowy: [], zamowienia: [] }, E = Te(e?.Umowy), Y = Te(e?.Zamowienia), X = Te(e?.NrPartiiTowaru), Q = [
    { name: "DataUmowy", title: l.t("invoice.transaction.contractDate"), format: R.Date },
    { name: "NrUmowy", title: l.t("invoice.transaction.contractNumber"), format: R.Default }
  ], B = [
    { name: "DataZamowienia", title: l.t("invoice.transaction.orderDate"), format: R.Date },
    { name: "NrZamowienia", title: l.t("invoice.transaction.orderNumber"), format: R.Default }
  ], r = [
    { name: "", title: l.t("invoice.transaction.batchNumber"), format: R.Default }
  ];
  if (n.push(Ne(l.t("invoice.transaction.header"), [0, 8, 0, 4])), E.length > 0) {
    const A = ft(Q, E, "*");
    A.content && (c.umowy = [kt(l.t("invoice.transaction.contract")), A.content]);
  }
  if (Y.length > 0) {
    const A = ft(
      B,
      Y,
      "*"
    );
    A.content && A.fieldsWithValue.length > 0 && (c.zamowienia = [kt(l.t("invoice.transaction.order")), A.content]);
  }
  if ((c.zamowienia.length > 0 || c.umowy.length > 0) && n.push(It(c.umowy, c.zamowienia, 0, !1)), (e.WalutaUmowna?._text || e.KursUmowny?._text) && (n.push(Ne(l.t("invoice.transaction.currencyAndRate"), [0, 8, 0, 4])), n.push(ZA(l.t("invoice.transaction.currency"), e.WalutaUmowna)), n.push(ZA(l.t("invoice.transaction.rate"), e.KursUmowny))), X.length > 0) {
    const A = ft(
      r,
      X,
      "*",
      [0, 4]
    );
    A.content && n.push(It(A.content, "", 0, !1));
  }
  return n.push(
    ZA(
      l.t("invoice.transaction.deliveryTerms"),
      e.WarunkiDostawy,
      R.MarginTop4
    )
  ), e.PodmiotPosredniczacy?._text === "1" && n.push(
    re(l.t("invoice.transaction.intermediaryDelivery"), [R.Label, R.MarginTop4])
  ), e.Transport && Te(e.Transport).forEach((A, a) => {
    n.push(
      KE(A, Te(e.Transport).length !== 0 ? a + 1 : null)
    );
  }), mt(n, !0);
}
function VE(e) {
  const n = [], c = de(e.RodzajFaktury), E = !!Number(de(e.Adnotacje?.PMarzy?.P_PMarzy)), Y = Te(e.FaWiersz).map((x) => {
    const U = Ra(c, E, x);
    return de(x.P_12) && (x.P_12._text = er(de(x.P_12), 2)), { ...x, ...U };
  }), X = [
    { name: "NrWierszaFa", title: l.t("invoice.rows.lp"), format: R.Default, width: "auto" }
  ], Q = [
    {
      name: "UU_ID",
      title: l.t("invoice.rows.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7", title: l.t("invoice.rows.productName"), format: R.Default, width: "*" },
    { name: "P_9A", title: l.t("invoice.rows.netUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_9B", title: l.t("invoice.rows.grossUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_8B", title: l.t("invoice.rows.quantity"), format: R.Number, width: "auto" },
    { name: "P_8A", title: l.t("invoice.rows.unit"), format: R.Default, width: "auto" },
    { name: "P_10", title: l.t("invoice.rows.discount"), format: R.Currency, width: "auto" },
    { name: "P_12", title: l.t("invoice.rows.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12_XII",
      title: l.t("invoice.rows.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    {
      name: "P_12_Zal_15",
      title: l.t("invoice.rows.productMarker"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_11", title: l.t("invoice.rows.netSalesValue"), format: R.Currency, width: "auto" },
    {
      name: "P_11A",
      title: l.t("invoice.rows.grossSalesValue"),
      format: R.Currency,
      width: "auto"
    },
    {
      name: "P_11Vat",
      title: l.t("invoice.rows.vatSalesValue"),
      format: R.Currency,
      width: "auto"
    }
  ];
  vn("KursWaluty", Y).length !== 1 && Q.push({
    name: "KursWaluty",
    title: l.t("invoice.rows.currencyRate"),
    format: R.Currency6,
    width: "auto"
  }), Q.push({
    name: "StanPrzed",
    title: l.t("invoice.rows.stateBefore"),
    format: R.Boolean,
    width: "auto"
  });
  const B = [
    { name: "GTIN", title: l.t("invoice.rows.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiU", title: l.t("invoice.rows.pkwiu"), format: R.Default, width: "auto" },
    { name: "CN", title: l.t("invoice.rows.cn"), format: R.Default, width: "auto" },
    { name: "PKOB", title: l.t("invoice.rows.pkob"), format: R.Default, width: "auto" },
    {
      name: "KwotaAkcyzy",
      title: l.t("invoice.rows.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTU", title: l.t("invoice.rows.gtu"), format: R.Default, width: "auto" },
    { name: "Procedura", title: l.t("invoice.rows.procedure"), format: R.Default, width: "*" },
    { name: "P_6A", title: l.t("invoice.rows.getOrMakeDate"), format: R.Date, width: "auto" },
    { name: "Indeks", title: l.t("invoice.rows.index"), format: R.Default, width: "auto" }
  ];
  let r = ft(
    [...X, ...Q, ...B],
    Y,
    "auto"
  );
  const A = re(l.t("invoice.rows.issuedInCurrency", { currency: e.KodWaluty?._text }), [
    R.Label,
    R.MarginBottom8
  ]), a = de(e.P_15);
  let d = "";
  return c == pt.ROZ && Number(a) !== 0 ? d = {
    stack: ii([
      { value: l.t("invoice.rows.remainingAmount"), formatTyp: R.LabelGreater },
      {
        value: a,
        formatTyp: R.CurrencyGreater,
        currency: de(e.KodWaluty)?.toString() ?? ""
      }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  } : (c == pt.VAT || c == pt.KOR || c == pt.KOR_ROZ || c == pt.UPR) && Number(a) !== 0 && (d = {
    stack: ii([
      { value: l.t("invoice.rows.totalAmountDue"), formatTyp: R.LabelGreater },
      {
        value: a,
        formatTyp: [R.CurrencyGreaterWithSeparator, R.HeaderContent, R.Value],
        currency: de(e.KodWaluty)?.toString() ?? ""
      }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }), r.fieldsWithValue.length <= 8 && r.content ? n.push(r.content) : (r = ft([...X, ...Q], Y, "*"), r.content && n.push(r.content), r = ft([...X, ...B], Y, "*"), r.content && r.fieldsWithValue.length > 1 && (n.push(`
`), n.push(r.content))), n.length < 1 ? [] : mt([...Ne(l.t("invoice.rows.header")), A, ...n, d], !0);
}
function XE(e, n, c, E, Y, X) {
  if (!e)
    return [];
  const Q = n === Dn.BeforeCorrection ? R.CurrencyAbs : R.Currency, B = Te(e?.ZamowienieWiersz).map((D, J) => (D.NrWierszaZam._text || (D.NrWierszaZam._text = (J + 1).toString()), D.P_12Z = { _text: er(de(D.P_12Z), 2, X) }, D)), r = [
    { name: "NrWierszaZam", title: l.t("invoice.order.lp"), format: R.Default, width: "auto" }
  ], A = [
    {
      name: "UU_ID",
      title: l.t("invoice.order.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7Z", title: l.t("invoice.order.productName"), format: R.Default, width: "*" },
    {
      name: "P_9AZ",
      title: l.t("invoice.order.netUnitPrice"),
      format: Q,
      width: "auto"
    },
    { name: "P_8BZ", title: l.t("invoice.order.quantity"), format: R.Right, width: "auto" },
    { name: "P_8AZ", title: l.t("invoice.order.unit"), format: R.Default, width: "auto" },
    { name: "P_12Z", title: l.t("invoice.order.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12Z_XII",
      title: l.t("invoice.order.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    {
      name: "P_12Z_Zal_15",
      title: l.t("invoice.order.productMarker"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_11NettoZ", title: l.t("invoice.order.netSalesValue"), format: Q, width: "auto" },
    { name: "P_11VatZ", title: l.t("invoice.order.taxAmount"), format: Q, width: "auto" }
  ], a = [
    { name: "UU_IDZ", title: l.t("invoice.order.orderNumber"), format: R.Default, width: "auto" },
    { name: "GTINZ", title: l.t("invoice.order.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiUZ", title: l.t("invoice.order.pkwiu"), format: R.Default, width: "auto" },
    { name: "CNZ", title: l.t("invoice.order.cn"), format: R.Default, width: "auto" },
    { name: "PKOBZ", title: l.t("invoice.order.pkob"), format: R.Default, width: "auto" },
    {
      name: "KwotaAkcyzyZ",
      title: l.t("invoice.order.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTUZ", title: l.t("invoice.order.gtu"), format: R.Default, width: "auto" },
    {
      name: "ProceduraZ",
      title: l.t("invoice.order.procedureMarkings"),
      format: R.Default,
      width: "*"
    },
    { name: "IndeksZ", title: l.t("invoice.order.index"), format: R.Default, width: "auto" },
    {
      name: "StanPrzedZ",
      title: l.t("invoice.order.stateBefore"),
      format: R.Boolean,
      width: "auto"
    }
  ];
  let d = ft(
    [...r, ...A, ...a],
    B,
    "*"
  );
  const x = [];
  d.fieldsWithValue.length <= 8 ? d.content && x.push(d.content) : (d = ft(
    [...r, ...A],
    B,
    "*"
  ), d.content && x.push(d.content), d = ft(
    [...r, ...a],
    B,
    "*"
  ), d.content && d.fieldsWithValue.length > 1 && x.push(d.content));
  const U = l.t("invoice.order.issuedInCurrency", { currency: Y });
  let P = "";
  return Number(c) > 0 && E == pt.ZAL ? P = {
    stack: ii([
      { value: l.t("invoice.order.advancePaymentAmount"), formatTyp: R.LabelGreater },
      { value: c, formatTyp: R.CurrencyGreater }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  } : n !== Dn.BeforeCorrection && E == pt.KOR_ZAL && (P = {
    stack: ii([
      {
        value: l.t("invoice.order.advancePaymentAmountCorrection"),
        formatTyp: R.LabelGreater
      },
      { value: c, formatTyp: R.CurrencyGreater }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }), [
    {
      stack: [
        Ne(n),
        U,
        {
          text: [
            l.t("invoice.order.orderValueWithTax"),
            re(e.WartoscZamowienia?._text, R.Currency)
          ],
          marginBottom: 4
        },
        ...x,
        P
      ]
    }
  ];
}
bn.addVirtualFileSystem(_s);
function ZE(e, n) {
  const E = e.Fa?.RodzajFaktury?._text == pt.KOR && Ae(e.Fa?.OkresFaKorygowanej) ? HE(e.Fa) : VE(e.Fa), Y = {
    ...qs(n?.watermark),
    content: [
      ...Sa(e.Fa, n),
      Vs(e.Fa),
      ...NE(e),
      LE(e.Fa),
      E,
      XE(
        e.Fa?.Zamowienie,
        Dn.Order,
        e.Fa?.P_15?._text ?? "",
        e.Fa?.RodzajFaktury?._text ?? "",
        e.Fa?.KodWaluty?._text ?? "",
        de(e.Fa?.Adnotacje?.PMarzy?.P_PMarzy)
      ),
      SE(e),
      FE(e.Fa?.Adnotacje),
      pE(e.Fa),
      Xs(e.Fa?.Rozliczenie, e.Fa?.KodWaluty?._text ?? ""),
      YE(e.Fa?.Platnosc),
      WE(e.Fa?.WarunkiTransakcji),
      ...Zs(n, e.Stopka, e.Naglowek, e.Fa?.WZ)
    ],
    footer: (X, Q) => ({
      text: `${X.toString()} ${l.t("invoice.footer.pagesTotal")} ${Q}`,
      alignment: Rt.RIGHT,
      margin: [0, 0, 40, 0]
    }),
    ...os()
  };
  return bn.createPdf(Y);
}
function qE(e) {
  const n = [], c = [], E = [];
  if (e) {
    const Y = e.Zwolnienie;
    if (Y?.P_19?._text === "1" && (Zi(
      c,
      E,
      {
        text: l.t("invoice.annotations.noTaxDelivery")
      },
      !0
    ), Y.P_19A?._text && (Zi(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument")
      ),
      !0
    ), Zi(
      c,
      E,
      ZA(l.t("invoice.annotations.law"), Y.P_19A._text),
      !0
    )), Y.P_19B?._text && (Zi(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument2")
      ),
      !0
    ), Zi(
      c,
      E,
      ZA(l.t("invoice.annotations.directiveLaw"), Y.P_19B._text),
      !0
    )), Y.P_19C?._text && (Zi(
      c,
      E,
      ZA(
        l.t("invoice.annotations.noTaxBase"),
        l.t("invoice.annotations.noTaxBaseDocument3")
      ),
      !0
    ), Zi(
      c,
      E,
      ZA(l.t("invoice.annotations.otherLaw"), Y.P_19C._text),
      !0
    ))), e.NoweSrodkiTransportu?.P_42_5?._text === "1" || e.NoweSrodkiTransportu?.P_42_5?._text === "2") {
      let X = [], Q = " ";
      e.NoweSrodkiTransportu.P_42_5?._text === "1" ? Q = l.t("invoice.annotations.vat22DocumentRequired") : e.NoweSrodkiTransportu.P_42_5?._text === "2" && (Q = l.t("invoice.annotations.vat22DocumentNotRequired")), X = [
        ...ZA(`${l.t("invoice.annotations.newTransportsDelivery")}: `, Q ?? "")
      ], X && Zi(c, E, X, !0);
    }
    if (e.P_18A?._text === "1" && Zi(c, E, { text: l.t("invoice.annotations.partialPayMechanism") }), e.P_16?._text === "1" && Zi(c, E, { text: l.t("invoice.annotations.cashMethod") }), e.P_18?._text === "1" && Zi(c, E, { text: l.t("invoice.annotations.reverseTax") }), e.P_23?._text === "1" && Zi(c, E, { text: l.t("invoice.annotations.threePartsSimplerMethod") }), e.PMarzy?.P_PMarzy?._text === "1") {
      let X = "";
      e.PMarzy.P_PMarzy_3_1?._text === "1" ? X = l.t("invoice.annotations.usedGoods") : e.PMarzy.P_PMarzy_3_2?._text === "1" ? X = l.t("invoice.annotations.artPieces") : e.PMarzy.P_PMarzy_2?._text === "1" ? X = l.t("invoice.annotations.travelAgencies") : e.PMarzy.P_PMarzy_3_3?._text === "1" && (X = l.t("invoice.annotations.antiques")), Zi(
        c,
        E,
        ZA(l.t("invoice.annotations.marginProcedure"), X)
      );
    }
    e.P_17?._text === "1" && Zi(c, E, { text: l.t("invoice.annotations.selfInvoice") }), (c.length || E.length) && n.push(Li([c, E])), n.length && (n.unshift(Ei(1)), n.unshift(Ne(l.t("invoice.annotations.header"))), n.unshift(Ei(1)), n.push(Ei(1))), (e.NoweSrodkiTransportu?.P_42_5?._text === "1" || e.NoweSrodkiTransportu?.P_42_5?._text === "2") && n.push(_E(e.NoweSrodkiTransportu));
  }
  return n;
}
function _E(e) {
  const n = Te(e.NowySrodekTransportu);
  let c = [];
  const E = {
    table: {
      headerRows: 1,
      widths: [100, "*"],
      body: []
    },
    layout: {
      hLineWidth: () => 1,
      hLineColor: () => "#BABABA",
      vLineWidth: () => 1,
      vLineColor: () => "#BABABA"
    },
    marginTop: 4
  };
  if (n?.length) {
    const Y = [
      { text: l.t("invoice.annotations.usePermissionDate"), style: R.GrayBoldTitle },
      { text: l.t("invoice.annotations.description"), style: R.GrayBoldTitle }
    ];
    c = n.map((X) => {
      const Q = [], B = Ae(X.P_22B) || Ae(X.P_22BT) || Ae(X.P_22B1) || Ae(X.P_22B2) || Ae(X.P_22B3) || Ae(X.P_22B4), r = Ae(X.P_22C) || Ae(X.P_22C1), A = Ae(X.P_22D) || Ae(X.P_22D1), a = Ae(X.P_22B1) || Ae(X.P_22B2) || Ae(X.P_22B3) || Ae(X.P_22B4);
      X.P_NrWierszaNST?._text && Q.push(X.P_NrWierszaNST._text), B ? Q.push(l.t("invoice.annotations.landDelivery")) : r ? Q.push(l.t("invoice.annotations.boatDelivery")) : A && Q.push(l.t("invoice.annotations.airDelivery"));
      const d = [
        de(X.P_22BMK),
        de(X.P_22BMD),
        de(X.P_22BK),
        de(X.P_22BNR),
        de(X.P_22BRP)
      ].filter((x) => !!x);
      return d.length && Q.push(d.join(", ")), X.DetailsString?._text && Q.push(X.DetailsString._text), (B || r || A) && Q.push(X.P_22B?._text ?? X.P_22C?._text ?? X.P_22D?._text ?? ""), X.P_22C1?._text && Q.push(`${l.t("invoice.annotations.hullNumber")}: ${X.P_22C1._text}`), X.P_22D1?._text && Q.push(`${l.t("invoice.annotations.factoryNumber")}: ${X.P_22D1._text}`), a && (X.P_22B1?._text && Q.push(`${l.t("invoice.annotations.vin")}: ${X.P_22B1._text}`), X.P_22B2?._text && Q.push(`${l.t("invoice.annotations.bodyNumber")}: ${X.P_22B2._text}`), X.P_22B3?._text && Q.push(`${l.t("invoice.annotations.chassisNumber")}: ${X.P_22B3._text}`), X.P_22B4?._text && Q.push(`${l.t("invoice.annotations.frameNumber")}: ${X.P_22B4._text}`)), X.P_22BT?._text && Q.push(X.P_22BT._text), [re(X.P_22A?._text), { text: Q.join(`
`) }];
    }), E.table.body = [[...Y], ...c];
  }
  return c.length ? [E, Ei(1)] : [];
}
function Zi(e, n, c, E) {
  if (e.length > n.length && E) {
    n.push(c);
    return;
  }
  e.push(c);
}
function $E(e) {
  const n = [];
  de(e.TP) === "1" && n.push(re(l.t("invoice.additionalInformation.tpLabel")));
  const c = [];
  de(e.FP) === "1" && c.push(re(l.t("invoice.additionalInformation.fpLabel")));
  const E = [];
  de(e.ZwrotAkcyzy) === "1" && E.push(re(l.t("invoice.additionalInformation.exciseTaxRefund")));
  const Y = [n, c, E].filter((Q) => Q.length > 0), X = [
    ...Ne(l.t("invoice.additionalInformation.additionalInformationLabel")),
    ...Y,
    ...Aw(e.DodatkowyOpis)
  ];
  return X.length > 1 ? mt(X, !0) : [];
}
function Aw(e) {
  if (!e)
    return [];
  const n = Te(e)?.map((X, Q) => ({
    ...X,
    lp: { _text: Q + 1 }
  })), c = kt(l.t("invoice.additionalInformation.additionalDescription")), E = [
    {
      name: "lp",
      title: l.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "NrWiersza",
      title: l.t("invoice.additionalInformation.rowNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Klucz",
      title: l.t("invoice.additionalInformation.infoType"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Wartosc",
      title: l.t("invoice.additionalInformation.infoContent"),
      format: R.Default,
      width: "*"
    }
  ], Y = ft(
    E,
    n,
    "*",
    [0, 0, 0, 0]
  );
  return Y.content && c.push(Y.content), c;
}
const gB = (e, n) => {
  const c = [];
  return e?.length ? (e.forEach((E, Y) => {
    const X = [], Q = Ne(
      n ? `${n} ${e?.length > 1 ? ++Y : ""}` : "",
      [0, 12, 0, 8]
    );
    X.push([
      re(l.t("invoice.registers.fullAccountNumber"), R.GrayBoldTitle),
      re(de(E.NrRB), R.AccountNumber)
    ]), X.push([
      re(l.t("invoice.registers.swiftCode"), R.GrayBoldTitle),
      re(de(E.SWIFT), R.Default)
    ]), X.push([
      re(l.t("invoice.registers.ownBankAccount"), R.GrayBoldTitle),
      re(
        Ti(qt(E.RachunekWlasnyBanku, Ta), 20),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.bankName"), R.GrayBoldTitle),
      re(
        Ae(E.NazwaBanku) ? Ti(de(E.NazwaBanku), 20) : de(E.NazwaBanku),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.accountDescription"), R.GrayBoldTitle),
      re(
        Ae(E.OpisRachunku) ? Ti(de(E.OpisRachunku), 20) : de(E.OpisRachunku),
        R.Default
      )
    ]), c.push([
      ...Q,
      {
        unbreakable: !0,
        table: {
          body: X,
          widths: ["auto", "*"]
        },
        layout: {
          hLineWidth: () => 1,
          hLineColor: () => "#BABABA",
          vLineWidth: () => 1,
          vLineColor: () => "#BABABA"
        }
      }
    ]);
  }), mt(c, !1)) : [];
};
function ew(e) {
  if (!e)
    return [];
  const n = Te(e.TerminPlatnosci), c = [
    {
      name: "Termin",
      title: l.t("invoice.payment.maturityDate"),
      format: R.Date
    }
  ];
  n.some((x) => x.TerminOpis) && c.push({
    name: "TerminOpis",
    title: l.t("invoice.payment.paymentDescription"),
    format: R.Date
  });
  const E = [Ui(), ...Ne(l.t("invoice.payment.payment"))];
  de(e.Zaplacono) === "1" ? (E.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.paidStatus"))
  ), E.push(ZA(l.t("invoice.payment.paymentDate"), e.DataZaplaty, R.Date))) : de(e.ZnacznikZaplatyCzesciowej) === "1" || de(e.ZnacznikZaplatyCzesciowej) === "2" ? (E.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.partialPayment"))
  ), E.push(
    ZA(
      l.t("invoice.payment.paymentInformationContinued"),
      de(e.ZnacznikZaplatyCzesciowej) === "1" ? l.t("invoice.payment.paidInPart") : l.t("invoice.payment.paidAllInParts")
    )
  )) : E.push(
    ZA(l.t("invoice.payment.paymentInformation"), l.t("invoice.payment.noPayment"))
  ), Ae(e.FormaPlatnosci) ? E.push(
    ZA(
      l.t("invoice.payment.paymentMethod2"),
      qt(e.FormaPlatnosci, Ws)
    )
  ) : e.OpisPlatnosci?._text && (E.push(
    ZA(l.t("invoice.payment.paymentMethod2"), l.t("invoice.payment.paymentDifferent"))
  ), E.push(ZA(l.t("invoice.payment.otherPaymentDescription"), e.OpisPlatnosci)));
  const Y = Te(e.ZaplataCzesciowa), X = Q();
  function Q() {
    const x = [
      re(Ti(l.t("invoice.payment.partialPaymentDate"), 20), R.GrayBoldTitle),
      re(Ti(l.t("invoice.payment.partialPaymentAmount"), 20), R.GrayBoldTitle),
      re(Ti(l.t("invoice.payment.paymentMethod"), 20), R.GrayBoldTitle)
    ], U = Y.map((P) => {
      const D = [];
      return D.push(
        re(de(P.DataZaplatyCzesciowej), R.Date),
        re(de(P.KwotaZaplatyCzesciowej), R.Currency)
      ), P.PlatnoscInna ? D.push(re(Ti(de(P.OpisPlatnosci) ?? "", 20), R.Default)) : D.push(re(de(P.FormaPlatnosci), R.FormOfPayment)), D;
    });
    return {
      content: {
        table: {
          headerRows: 1,
          keepWithHeaderRows: 1,
          widths: ["*", "*", "*"],
          body: [x, ...U]
        },
        margin: [0, 0, 0, 8],
        layout: dn,
        alignment: Rt.LEFT
      }
    };
  }
  const B = n.map((x) => n.some((U) => U.TerminOpis) ? {
    ...x,
    TerminOpis: {
      _text: `${x.TerminOpis?.Ilosc?._text ?? ""} ${x.TerminOpis?.Jednostka?._text ?? ""} ${x.TerminOpis?.ZdarzeniePoczatkowe?._text ?? ""}`
    }
  } : x), r = ft(
    c,
    B,
    "*",
    void 0,
    20
  );
  Y.length > 0 && n.length > 0 ? E.push(
    It(
      X.content ?? [],
      r.content ?? [],
      [0, 4, 0, 0]
    )
  ) : n.length > 0 ? r.content && E.push(It(r.content, [])) : Y.length > 0 && X.content && E.push(X.content), e.LinkDoPlatnosci && (E.push(re(l.t("invoice.payment.moneylessLink"), R.Label)), E.push({
    text: re(e.LinkDoPlatnosci._text, R.Link),
    link: re(e.LinkDoPlatnosci._text, R.Link)
  })), e.IPKSeF?._text && E.push(ZA(l.t("invoice.payment.ksefTransferId"), e.IPKSeF));
  const A = Te(e.RachunekBankowy).map(
    (x) => gB([x], l.t("invoice.payment.bankAccountNumber"))
  ), a = Te(e.RachunekBankowyFaktora).map(
    (x) => gB([x], l.t("invoice.payment.factorsBankAccountNumber"))
  ), d = [...A, ...a];
  return d.length > 0 && d.forEach((x, U) => {
    U % 2 === 0 && E.push(It(x, d[U + 1] ?? []));
  }), e.Skonto && (E.push(Ne(l.t("invoice.payment.conditionalDiscount"), [0, 0])), E.push(ZA(l.t("invoice.payment.discountConditions"), e.Skonto.WarunkiSkonta)), E.push(ZA(l.t("invoice.payment.discountAmount"), e.Skonto.WysokoscSkonta))), E;
}
function Ar(e) {
  const n = [];
  return e?.AdresL1 && n.push(re(e.AdresL1._text, R.Value)), e?.AdresL2 && n.push(re(e.AdresL2._text, R.Value)), e?.KodKraju && n.push(re(l.t(Na(e.KodKraju._text ?? "")), R.Value)), n.push(...ZA(l.t("invoice.address.GLN"), e.GLN)), n;
}
function Aa(e) {
  return [
    ZA(l.t("invoice.subject1.nip"), e.NIP),
    ZA(l.t("invoice.subject1.name"), e.Nazwa)
  ];
}
function br(e) {
  return Te(e)?.map((n) => n?.Email || n?.Telefon ? [
    ZA(l.t("invoice.authorizedSubject.email"), n.Email),
    ZA(l.t("invoice.authorizedSubject.phone"), n.Telefon)
  ] : "-");
}
function cB(e) {
  const n = Ne(l.t("invoice.subject1.seller"));
  if (n.push(
    ZA(l.t("invoice.subject1.eoriNumber"), e.NrEORI),
    ZA(l.t("invoice.subject1.vatPrefix"), e.PrefiksPodatnika)
  ), e.DaneIdentyfikacyjne && n.push(...Aa(e.DaneIdentyfikacyjne)), e.Adres && n.push(
    re(l.t("invoice.subject1.address"), [R.Label, R.LabelMargin]),
    Ar(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject1.mailingAddress"), [R.Label, R.LabelMargin]),
    ...Ar(e.AdresKoresp)
  ), e.DaneKontaktowe && n.push(
    re(l.t("invoice.subject1.contactDetails"), [R.Label, R.LabelMargin]),
    ...br(e.DaneKontaktowe)
  ), Ae(e.StatusInfoPodatnika)) {
    const c = qt(e.StatusInfoPodatnika, On);
    n.push(ZA(l.t("invoice.subject1.taxpayerStatus"), c));
  }
  return n;
}
function tw(e, n) {
  const c = Ne(l.t("invoice.subject1K.seller"));
  let E = [], Y = [];
  if (E.push(
    Ne(l.t("invoice.subject1K.identificationData")),
    ZA(l.t("invoice.subject1K.eoriNumber"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...Aa(e.DaneIdentyfikacyjne)), e.DaneKontaktowe) {
    const X = br(Te(e.DaneKontaktowe));
    X.length && (E.push(Ne(l.t("invoice.subject1K.contactDetails"))), E.push(X));
  }
  if (e.StatusInfoPodatnika) {
    const X = qt(e.StatusInfoPodatnika, On);
    E.push(ZA(l.t("invoice.subject1K.taxpayerStatus"), X));
  }
  return E.length && c.push(E), E = lB(n, l.t("invoice.subject1K.correctedContent")), Y = lB(e, l.t("invoice.subject1K.correctiveContent")), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject1K.mailingAddress"), [R.Label, R.LabelMargin]),
    Ar(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function lB(e, n) {
  const c = [];
  return c.push(Ne(n)), e.PrefiksPodatnika?._text && c.push(ZA(l.t("invoice.subject1K.vatPrefix"), e.PrefiksPodatnika)), e.DaneIdentyfikacyjne && c.push(...Aa(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    re(l.t("invoice.subject1K.address"), [R.Label, R.LabelMargin]),
    Ar(e.Adres)
  ), c;
}
function Js(e) {
  const n = [];
  return n.push(ZA(l.t("invoice.subject2.nip"), e.NIP)), e.NrVatUE?._text && n.push(
    ii([
      { value: l.t("invoice.subject2.vatUeNumber"), formatTyp: R.Label },
      { value: e.KodUE, formatTyp: R.Value },
      { value: " " },
      { value: e.NrVatUE, formatTyp: R.Value }
    ])
  ), e.NrID?._text && n.push(
    ii([
      { value: l.t("invoice.subject2.taxIdOther"), formatTyp: R.Label },
      { value: e.KodKraju || "", formatTyp: R.Value },
      { value: " " },
      { value: e.NrID, formatTyp: R.Value }
    ])
  ), e.BrakID?._text === "1" && n.push(re(l.t("invoice.subject2.noTaxId"), R.Label)), n.push(ZA(l.t("invoice.subject2.name"), e.Nazwa)), n;
}
function Ca(e) {
  const n = Ne(l.t("invoice.subject2.buyer"));
  return n.push(
    ZA(l.t("invoice.subject2.getterId"), e.IDNabywcy),
    ZA(l.t("invoice.subject2.eoriNumber"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && n.push(
    ...Js(
      e.DaneIdentyfikacyjne
    )
  ), e.Adres && n.push(
    re(l.t("invoice.subject2.address"), [R.Label, R.LabelMargin]),
    Ar(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject2.mailingAddress"), [R.Label, R.LabelMargin]),
    ...Ar(e.AdresKoresp)
  ), (e.DaneKontaktowe || e.NrKlienta) && n.push(
    re(l.t("invoice.subject2.contactDetails"), [R.Label, R.LabelMargin]),
    ...br(e.DaneKontaktowe ?? []),
    ZA(l.t("invoice.subject2.customerNumber"), e.NrKlienta)
  ), e?.JST && n.push(
    ZA(
      l.t("invoice.subject2.jst"),
      l.t(
        de(e?.JST)?.toString().trim() === "1" ? "invoice.subject2.yes" : "invoice.subject2.no"
      ),
      R.Default,
      { marginTop: 8 }
    )
  ), e?.GV && n.push(
    ZA(
      l.t("invoice.subject2.gv"),
      l.t(
        de(e?.GV)?.toString().trim() === "1" ? "invoice.subject2.yes" : "invoice.subject2.no"
      ),
      R.Default,
      e?.JST ? {} : { marginTop: 8 }
    )
  ), n;
}
function iw(e) {
  if (!e)
    return [];
  const n = [];
  return Ae(e.NIP) ? n.push(ZA(l.t("invoice.subject3.nip"), e.NIP, R.Default)) : Ae(e.IDWew) ? n.push(
    ZA(l.t("invoice.subject3.internalId"), e.IDWew, R.Default)
  ) : Ae(e.KodUE) ? n.push(
    ii([
      { value: l.t("invoice.subject3.vatUeNumber"), formatTyp: R.Label },
      { value: e.KodUE, formatTyp: R.Default },
      { value: "" },
      { value: e.NrVatUE, formatTyp: R.Default }
    ])
  ) : Ae(e.NrID) ? n.push(
    ii([
      { value: l.t("invoice.subject3.otherId"), formatTyp: R.Label },
      { value: e.KodKraju, formatTyp: R.Default },
      { value: "" },
      { value: e.NrID, formatTyp: R.Default }
    ])
  ) : e.BrakID?._text === "1" && n.push(ZA(l.t("invoice.subjectIdentificationData.noId"), " ", R.Default)), Ae(e.Nazwa) && n.push(
    ZA(l.t("invoice.subject3.name"), e.Nazwa, R.Default)
  ), n;
}
function EB(e, n) {
  const c = [];
  c.push(Ui());
  const E = [
    ...Ne(l.t("invoice.subject3.otherEntity", { index: n + 1 })),
    ZA(l.t("invoice.subject3.getterId"), e.IDNabywcy),
    ZA(l.t("invoice.subject3.eori"), e.NrEORI),
    ...iw(e.DaneIdentyfikacyjne),
    ZA(l.t("invoice.subject3.role"), qt(e.Rola, zB)),
    ZA(l.t("invoice.subject3.otherRole"), e.OpisRoli),
    ZA(l.t("invoice.subject3.share"), e.Udzial, [R.Percentage])
  ], Y = [];
  return e.Adres && Y.push(
    re(l.t("invoice.subject3.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject3.correspondenceAddress"), [R.Label, R.LabelMargin]),
    ...Hi(e.AdresKoresp)
  ), (e.DaneKontaktowe || e.NrKlienta) && (Y.push(
    re(l.t("invoice.subject3.contactData"), [R.Label, R.LabelMargin])
  ), e.DaneKontaktowe && Y.push(...br(e.DaneKontaktowe)), e.NrKlienta && Y.push(ZA(l.t("invoice.subject3.clientNumber"), e.NrKlienta))), c.push(It(E, Y)), c;
}
function mr(e, n = l.t("invoice.subject1.address"), c = !1, E) {
  return e ? [
    ...c ? kt(n, E) : Ne(n, E),
    ...Ar(e)
  ] : [];
}
function nw(e, n) {
  if (!e)
    return [];
  const c = e.fakturaPodmiotNDto, E = Te(c.DaneKontaktowe), Y = e.podmiot2KDto, X = [];
  X.push(Ui()), X.push(Ne(`${l.t("invoice.subject3k.otherEntity")} ${n + 1}`)), (Ae(c.NrEORI) || Ae(c.Rola) || Ae(c.OpisRoli) || Ae(c?.Udzial)) && X.push(
    ...Ne(l.t("invoice.subject3k.identificationData")),
    ZA(l.t("invoice.subject3k.eori"), c.NrEORI),
    ZA(l.t("invoice.subject3k.role"), qt(c.Rola, zB)),
    ZA(l.t("invoice.subject3k.otherRole"), c.OpisRoli),
    ZA(l.t("invoice.subject3k.share"), c.Udzial, R.Percentage)
  ), (E.length > 0 || Ae(c.NrKlienta)) && (X.push(br(c.DaneKontaktowe ?? [])), X.push(ZA(l.t("invoice.subject3k.clientNumber"), c.NrKlienta)));
  const Q = [
    ...Ne(l.t("invoice.subject3k.correctedContent")),
    ZA(l.t("invoice.subject3k.getterId"), Y?.IDNabywcy)
  ];
  Y?.DaneIdentyfikacyjne && Q.push(Js(Y.DaneIdentyfikacyjne)), Y?.Adres && Q.push(mr(Y.Adres));
  const B = [
    ...Ne(l.t("invoice.subject3k.correctiveContent")),
    ZA(l.t("invoice.subject3k.getterId"), c?.IDNabywcy)
  ];
  return c?.DaneIdentyfikacyjne && B.push(Js(c.DaneIdentyfikacyjne)), c?.Adres && B.push(mr(c.Adres)), c.AdresKoresp != null && B.push(
    mr(c.AdresKoresp, l.t("invoice.subject3k.correspondenceAddress"))
  ), X.push(It(Q, B)), X;
}
function rw(e) {
  if (!e)
    return [];
  const n = [
    re(l.t("invoice.authorizedSubject.contactData"), R.Description)
  ], c = Te(e);
  return c.length === 0 ? [] : (c.forEach((E) => {
    Ae(E.EmailPU) && n.push(ZA(l.t("invoice.authorizedSubject.email"), E.EmailPU)), Ae(E.TelefonPU) && n.push(ZA(l.t("invoice.authorizedSubject.phone"), E.TelefonPU)), n.push(Ei(1));
  }), n);
}
function sw(e) {
  if (!e)
    return [];
  const n = Ne(l.t("invoice.authorizedSubject.authorizedSubject"));
  return Ae(e.RolaPU) && n.push(
    ZA(
      l.t("invoice.authorizedSubject.role"),
      qt(e.RolaPU, ml)
    )
  ), Ae(e.NrEORI) && n.push(ZA(l.t("invoice.authorizedSubject.eori"), e.NrEORI)), e.DaneIdentyfikacyjne && n.push(Aa(e.DaneIdentyfikacyjne)), n.push([
    ...mr(e.Adres),
    ...mr(
      e.AdresKoresp,
      l.t("invoice.authorizedSubject.correspondenceAddress2")
    ),
    ...rw(e.DaneKontaktowe)
  ]), n;
}
function aw(e, n) {
  const c = [];
  c.push(Ui()), c.push(Ne(l.t("invoice.subject2k.buyer")));
  let E = [], Y = [];
  return E.push(
    Ne(l.t("invoice.subject2k.identificationData")),
    ZA(l.t("invoice.subject2k.eori"), e.NrEORI)
  ), e.DaneIdentyfikacyjne && E.push(...$n(e.DaneIdentyfikacyjne)), e.DaneKontaktowe && (E.push(
    re(l.t("invoice.subject2k.contactDetails"), [R.Label, R.LabelMargin])
  ), e.NrKlienta && E.push(ZA(l.t("invoice.subject2k.clientNumber"), e.NrKlienta)), E.push(br(Te(e.DaneKontaktowe)))), E.length && c.push({
    columns: [E, []],
    columnGap: 20
  }), n.DaneIdentyfikacyjne && (E = Os(n, l.t("invoice.subject2k.correctedContent")), Y = Os(e, l.t("invoice.subject2k.correctiveContent"))), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject2k.mailingAddress"), [R.Label, R.LabelMargin]),
    Hi(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function ow(e) {
  const n = [], c = Te(e.Fa?.Podmiot2K), E = Te(e.Podmiot3);
  if (e.Fa?.Podmiot1K || c.length > 0)
    if (e.Fa?.Podmiot1K ? n.push(tw(e.Podmiot1 ?? {}, e.Fa?.Podmiot1K)) : e.Podmiot1 != null && n.push(cB(e.Podmiot1)), e.Fa?.Podmiot2K) {
      const Y = c.find(
        (X) => de(X.IDNabywcy) === de(e.Podmiot2?.IDNabywcy)
      );
      Y ? n.push(aw(e.Podmiot2 ?? {}, Y)) : n.push(mt(Ca(e.Podmiot2), !0));
    } else e.Podmiot2 && n.push(mt(Ca(e.Podmiot2), !0));
  else
    n.push([
      Li([cB(e.Podmiot1), Ca(e.Podmiot2)], {
        margin: [0, 0, 0, 8],
        columnGap: 20
      })
    ]);
  if (E.length > 0) {
    const Y = Bw(c, E);
    Y.filter(
      (X) => X.fakturaPodmiotNDto.IDNabywcy === e.Podmiot2?.IDNabywcy
    ), Y.length > 0 ? Y.forEach((X, Q) => {
      X.podmiot2KDto ? n.push(nw(X, Q)) : n.push(EB(X.fakturaPodmiotNDto, Q)), Q < Y.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    }) : E.forEach((X, Q) => {
      n.push(EB(X, Q)), Q < E.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
    });
  }
  return n.push(sw(e.PodmiotUpowazniony)), mt(n, !0, [0, 0, 0, 0]);
}
function Bw(e, n) {
  const c = [];
  return n.filter((E) => de(E.Rola) === "4").length > 0 && n.forEach((E) => {
    de(E.Rola) === "4" ? c.push({
      fakturaPodmiotNDto: E,
      podmiot2KDto: e.find(
        (Y) => de(Y.IDNabywcy) === de(E.IDNabywcy)
      )
    }) : c.push({
      fakturaPodmiotNDto: E
    });
  }), c;
}
function gw(e) {
  const n = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) && (!Ae(e.Fa?.P_14_5) || de(e.Fa?.P_14_5) == 0) || Ae(e.Fa?.P_13_6_1) || Ae(e.Fa?.P_13_6_2) || Ae(e.Fa?.P_13_6_3) || Ae(e.Fa?.P_13_7) || Ae(e.Fa?.P_13_8) || Ae(e.Fa?.P_13_9) || Ae(e.Fa?.P_13_10) || Ae(e.Fa?.P_13_11), c = Ae(e.Fa?.P_13_1) || Ae(e.Fa?.P_13_2) || Ae(e.Fa?.P_13_3) || Ae(e.Fa?.P_13_4) || Ae(e.Fa?.P_13_5) || Ae(e.Fa?.P_13_6_1) || Ae(e.Fa?.P_13_6_2) || Ae(e.Fa?.P_13_6_3) || Ae(e.Fa?.P_13_7) || Ae(e.Fa?.P_13_8) || Ae(e.Fa?.P_13_9) || Ae(e.Fa?.P_13_10) || Ae(e.Fa?.P_13_11), E = Ae(e.Fa?.P_14_1W) || Ae(e.Fa?.P_14_2W) || Ae(e.Fa?.P_14_3W) || Ae(e.Fa?.P_14_4W);
  let Y = [];
  const X = {
    table: {
      headerRows: 1,
      widths: [],
      body: []
    },
    layout: {
      hLineWidth: () => 1,
      hLineColor: () => "#BABABA",
      vLineWidth: () => 1,
      vLineColor: () => "#BABABA"
    }
  }, Q = [
    { text: l.t("invoice.summary.lp"), style: R.GrayBoldTitle },
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxRate"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.netAmount"), style: R.GrayBoldTitle }] : [],
    ...n || Ae(e.Fa?.P_14_5) ? [
      {
        text: l.t("invoice.summary.taxAmount"),
        style: R.GrayBoldTitle
      }
    ] : [],
    ...c ? [{ text: l.t("invoice.summary.grossAmount"), style: R.GrayBoldTitle }] : [],
    ...E ? [{ text: l.t("invoice.summary.taxAmountPLN"), style: R.GrayBoldTitle }] : []
  ], B = [
    "auto",
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...n || Ae(e.Fa?.P_14_5) ? ["*"] : [],
    ...c ? ["*"] : [],
    ...E ? ["*"] : []
  ];
  return e?.Fa && (Y = cw(e.Fa).map((A) => {
    const a = [];
    return a.push(A.no ?? ""), n ? A.taxRateString ? a.push(A.taxRateString) : de(e.Fa?.P_13_5) ? a.push(l.t("invoice.summary.oss")) : a.push("") : Ae(e.Fa?.P_14_5) && a.push(l.t("invoice.summary.oss")), c && a.push(re(A.net, R.Currency)), n ? a.push(re(A.tax, R.Currency)) : Ae(e.Fa?.P_14_5) && a.push(de(e.Fa?.P_14_5) ?? ""), c && a.push(re(A.gross, R.Currency)), E && a.push(re(A.taxPLN, R.Currency)), a;
  })), X.table.body = [[...Q], ...Y], X.table.widths = [...B], Y.length ? mt([...Ne(l.t("invoice.summary.sectionHeader"), [0, 0, 0, 8]), X], !1) : [];
}
function cw(e) {
  const n = [], c = Di(e?.P_13_1) || Di(e?.P_14_1) || Di(e?.P_14_1W), E = Di(e?.P_13_2) || Di(e?.P_14_2) || Di(e?.P_14_2W), Y = Di(e?.P_13_3) || Di(e?.P_14_3) || Di(e?.P_14_3W), X = Di(e?.P_13_4) || Di(e?.P_14_4) || Di(e?.P_14_4W), Q = Di(e?.P_13_5) || Di(e?.P_14_5), B = Di(e?.P_13_6_1), r = Di(e?.P_13_6_2), A = Di(e?.P_13_6_3), a = Di(e?.P_13_7), d = Di(e?.P_13_8), x = Di(e?.P_13_9), U = Di(e?.P_13_10), P = Di(e?.P_13_11);
  let D = 1;
  return c && (n.push({
    no: D,
    net: Se(e.P_13_1).toFixed(2),
    gross: (Se(e.P_13_1) + Se(e.P_14_1)).toFixed(2),
    tax: Se(e.P_14_1).toFixed(2),
    taxPLN: Se(e.P_14_1W).toFixed(2),
    taxRateString: l.t("invoice.summary.23or22")
  }), D++), E && (n.push({
    no: D,
    net: Se(e.P_13_2).toFixed(2),
    gross: (Se(e.P_13_2) + Se(e.P_14_2)).toFixed(2),
    tax: Se(e.P_14_2).toFixed(2),
    taxPLN: Se(e.P_14_2W).toFixed(2),
    taxRateString: l.t("invoice.summary.8or7")
  }), D++), Y && (n.push({
    no: D,
    net: Se(e.P_13_3).toFixed(2),
    gross: (Se(e.P_13_3) + Se(e.P_14_3)).toFixed(2),
    tax: Se(e.P_14_3).toFixed(2),
    taxPLN: Se(e.P_14_3W).toFixed(2),
    taxRateString: l.t("invoice.summary.5")
  }), D++), X && (n.push({
    no: D,
    net: Se(e.P_13_4).toFixed(2),
    gross: (Se(e.P_13_4) + Se(e.P_14_4)).toFixed(2),
    tax: Se(e.P_14_4).toFixed(2),
    taxPLN: Se(e.P_14_4W).toFixed(2),
    taxRateString: l.t("invoice.summary.4or3")
  }), D++), Q && (n.push({
    no: D,
    net: Se(e.P_13_5).toFixed(2),
    gross: (Se(e.P_13_5) + Se(e.P_14_5)).toFixed(2),
    tax: Se(e.P_14_5).toFixed(2),
    taxPLN: "",
    taxRateString: de(e.P_14_5) != 0 ? l.t("invoice.summary.oss") : ""
  }), D++), B && (n.push({
    no: D,
    net: Se(e.P_13_6_1).toFixed(2),
    gross: Se(e.P_13_6_1).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0long")
  }), D++), r && (n.push({
    no: D,
    net: Se(e.P_13_6_2).toFixed(2),
    gross: Se(e.P_13_6_2).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0mid")
  }), D++), A && (n.push({
    no: D,
    net: Se(e.P_13_6_3).toFixed(2),
    gross: Se(e.P_13_6_3).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.0short")
  }), D++), a && (n.push({
    no: D,
    net: Se(e.P_13_7).toFixed(2),
    gross: Se(e.P_13_7).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.noTax")
  }), D++), d && (n.push({
    no: D,
    net: Se(e.P_13_8).toFixed(2),
    gross: Se(e.P_13_8).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.npExcludingArt100")
  }), D++), x && (n.push({
    no: D,
    net: Se(e.P_13_9).toFixed(2),
    gross: Se(e.P_13_9).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.npBasedArt100")
  }), D++), U && (n.push({
    no: D,
    net: Se(e.P_13_10).toFixed(2),
    gross: Se(e.P_13_10).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.reverseTax")
  }), D++), P && (n.push({
    no: D,
    net: Se(e.P_13_11).toFixed(2),
    gross: Se(e.P_13_11).toFixed(2),
    tax: "0.00",
    taxPLN: "",
    taxRateString: l.t("invoice.summary.margin")
  }), D++), n;
}
function Di(e) {
  return Ae(e) && de(e) != 0;
}
function lw(e) {
  const n = Te(e.FaWiersz), c = [], E = [
    { name: "NrWierszaFa", title: l.t("invoice.discount.lp"), format: R.Default, width: "auto" },
    { name: "P_7", title: l.t("invoice.discount.productName"), format: R.Default },
    { name: "P_8B", title: l.t("invoice.discount.quantity"), format: R.Default },
    { name: "P_8A", title: l.t("invoice.discount.unit"), format: R.Default }
  ], Y = ft(E, n, "*"), X = Y.fieldsWithValue.includes("NrWierszaFa");
  return c.push(
    ...Ne(l.t("invoice.discount.header")),
    ...ZA(l.t("invoice.discount.totalValue"), e.P_15, R.Currency, {
      alignment: Rt.RIGHT
    }),
    It(
      re(
        l.t(X ? "invoice.discount.notAll" : "invoice.discount.all"),
        R.Default
      ),
      ""
    )
  ), Y.fieldsWithValue.length > 0 && Y.content && c.push(Y.content), mt(c, !0);
}
function Ew(e) {
  const n = Te(e.FaWiersz), c = Te(e.Zamowienie?.ZamowienieWiersz), E = [pt.ZAL, pt.KOR_ZAL].includes(
    de(e.RodzajFaktury)
  ) ? l.t("invoice.details.getMoneyDate") : l.t("invoice.details.deliveryOrServiceDate"), Y = ww(e.OkresFa?.P_6_Od, e.OkresFa?.P_6_Do), X = [], Q = [];
  Ae(e.KodWaluty) && Q.push(ZA(l.t("invoice.details.currencyCode"), e.KodWaluty));
  const B = [];
  (Pr("P_12_XII", n) || Pr("P_12_XII", c)) && B.push(ZA(l.t("invoice.details.ossProcedure"), " "));
  const r = [], A = [];
  if (Ae(e.KodWaluty) && de(e.KodWaluty) != "PLN")
    if (Ae(e.KursWalutyZ))
      r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(l.t("invoice.details.currencyRate"), e.KursWalutyZ, R.Currency6)
      );
    else {
      const J = vn("KursWaluty", n);
      J.length === 1 && (r.push(ZA(l.t("invoice.details.commonCurrencyRate"), " ")), A.push(
        ZA(
          l.t("invoice.details.currencyRate"),
          J[0].value,
          R.Currency6
        )
      ));
    }
  const a = [], d = [], x = [
    ZA(l.t("invoice.details.issueDate"), e.P_1, R.Date),
    ZA(l.t("invoice.details.issuePlace"), e.P_1M),
    ZA(l.t("invoice.details.discountPeriod"), e.OkresFaKorygowanej),
    ZA(E, e.P_6, R.Date),
    Y,
    X,
    Q,
    B,
    r,
    A,
    a,
    d
  ].filter((J) => J.length > 0), U = [], P = [];
  x.forEach((J, q) => {
    q % 2 ? P.push(J) : U.push(J);
  });
  const D = [
    ...Ne(l.t("invoice.details.header")),
    It(U, P),
    ...uw(e.ZaliczkaCzesciowa),
    ...fw(e.FakturaZaliczkowa)
  ];
  return mt(D, !0);
}
function ww(e, n) {
  const c = [];
  return Ae(e) && Ae(n) ? c.push(
    ii([
      {
        value: l.t("invoice.details.deliveryOrServiceDateFrom")
      },
      { value: tn(de(e)), formatTyp: R.Value },
      { value: l.t("invoice.details.to") },
      { value: tn(de(n)), formatTyp: R.Value }
    ])
  ) : Ae(e) ? c.push(
    ZA(
      l.t("invoice.details.deliveryOrServiceDateFrom"),
      tn(de(e))
    )
  ) : Ae(n) && c.push(
    ZA(
      l.t("invoice.details.deliveryOrServiceDateTo"),
      tn(de(n))
    )
  ), c;
}
function uw(e) {
  if (!e)
    return [];
  const n = Te(e), c = [], E = [
    { name: "P_6Z", title: l.t("invoice.details.getMoneyDate2"), format: R.Date },
    { name: "P_15Z", title: l.t("invoice.details.costAmount"), format: R.Default },
    { name: "KursWalutyZW", title: l.t("invoice.details.currencyRate2"), format: R.Currency6 }
  ], Y = ft(
    E,
    n,
    "auto"
  );
  return Y.content && c.push(Y.content), c;
}
function fw(e) {
  if (!e)
    return [];
  const c = Te(e).map((Q) => "NrFaZaliczkowej" in Q && Q.NrFaZaliczkowej ? { ...Q, NrFaZaliczkowej: Q.NrFaZaliczkowej } : "NrKSeFFaZaliczkowej" in Q && Q.NrKSeFFaZaliczkowej ? { ...Q, NrFaZaliczkowej: Q.NrKSeFFaZaliczkowej } : { ...Q, NrFaZaliczkowej: { _text: "" } }), E = [], Y = [
    {
      name: "NrFaZaliczkowej",
      title: l.t("invoice.details.advanceInvoiceNumbers"),
      format: R.Default
    }
  ], X = ft(
    Y,
    c,
    "auto",
    [0, 4, 0, 0]
  );
  return X.content && E.push(X.content), E;
}
function Qw(e) {
  return e ? [
    ...Ne(l.t("invoice.carrier.carrier")),
    [
      It(
        Js(
          e.DaneIdentyfikacyjne
        ),
        mr(
          e.AdresPrzewoznika,
          l.t("invoice.carrier.carrierAddress"),
          !0,
          [0, 0, 0, 0]
        ),
        [0, 0, 0, 8]
      )
    ]
  ] : [];
}
function hw(e, n) {
  const c = [], E = {
    transport: [],
    dane: [],
    wysylkaZ: [],
    wysylkaDo: [],
    wysylkaPrzez: []
  }, Y = l.t("invoice.transport.header");
  return c.push(Ne(n ? `${Y} ${n}` : Y)), e.RodzajTransportu?._text ? E.transport.push(
    ZA(
      l.t("invoice.transport.type"),
      qt(e.RodzajTransportu, za)
    )
  ) : e.TransportInny?._text == "1" && e.OpisInnegoTransportu?._text && (E.transport.push(
    ZA(l.t("invoice.transport.type"), l.t("invoice.transport.otherType"))
  ), E.transport.push(
    ZA(l.t("invoice.transport.otherTypeDescription"), e.OpisInnegoTransportu)
  )), E.dane.push(ZA(l.t("invoice.transport.orderNumber"), e.NrZleceniaTransportu)), Ae(e.OpisLadunku) && (E.dane.push(
    ZA(
      l.t("invoice.transport.cargoDescription"),
      qt(e.OpisLadunku, Ua)
    )
  ), e.LadunekInny?._text === "1" && e.OpisInnegoLadunku?._text && (E.dane.push(
    ZA(l.t("invoice.transport.cargoDescription"), l.t("invoice.transport.otherCargo"))
  ), E.dane.push(
    ZA(l.t("invoice.transport.otherCargoDescription"), e.OpisInnegoLadunku)
  ))), E.dane.push(ZA(l.t("invoice.transport.packageUnit"), e.JednostkaOpakowania)), E.dane.push(
    ZA(
      l.t("invoice.transport.startDateTime"),
      Yr(e.DataGodzRozpTransportu)
    )
  ), E.dane.push(
    ZA(
      l.t("invoice.transport.endDateTime"),
      Yr(e.DataGodzZakTransportu)
    )
  ), E.dane.length > 0 && E.dane.unshift(kt(l.t("invoice.transport.dataHeader"), [0, 0, 0, 0])), c.push(It(E.transport, E.dane)), c.push(Qw(e.Przewoznik)), e.WysylkaZ?.AdresL1 && (E.wysylkaZ.push(kt(l.t("invoice.transport.shipFrom"), [0, 0, 0, 0])), E.wysylkaZ.push(re(e.WysylkaZ?.AdresL1?._text, R.Default)), E.wysylkaZ.push(re(e.WysylkaZ?.AdresL2?._text, R.Default)), E.wysylkaZ.push(
    re(l.t(kn[e.WysylkaZ?.KodKraju?._text ?? ""]), R.Default)
  ), E.wysylkaZ.push(ZA(l.t("invoice.transport.gln"), e.WysylkaZ?.GLN?._text))), e.WysylkaDo?.AdresL1 && (E.wysylkaDo.push(kt(l.t("invoice.transport.shipTo"), [0, 0, 0, 0])), E.wysylkaDo.push(re(e.WysylkaDo?.AdresL1?._text, R.Default)), E.wysylkaDo.push(re(e.WysylkaDo?.AdresL2?._text, R.Default)), E.wysylkaDo.push(
    re(l.t(kn[e.WysylkaDo?.KodKraju?._text ?? ""]), R.Default)
  ), E.wysylkaDo.push(ZA(l.t("invoice.transport.gln"), e.WysylkaDo?.GLN?._text))), Te(e.WysylkaPrzez).forEach((Q, B) => {
    B && E.wysylkaPrzez.push(`
`), E.wysylkaPrzez.push(kt(l.t("invoice.transport.intermediateAddress"), [0, 4, 0, 0])), E.wysylkaPrzez.push(re(Q.AdresL1?._text, R.Default)), E.wysylkaPrzez.push(re(Q?.AdresL2?._text, R.Default)), E.wysylkaPrzez.push(re(l.t(kn[Q?.KodKraju?._text ?? ""]), R.Default)), E.wysylkaPrzez.push(ZA(l.t("invoice.transport.gln"), Q?.GLN?._text));
  }), (e.WysylkaZ?.AdresL1 || e.WysylkaDo?.AdresL1 || e.WysylkaPrzez?.length) && (c.push(Ne(l.t("invoice.transport.shipmentHeader"))), c.push(It(E.wysylkaZ, E.wysylkaDo)), c.push(It(E.wysylkaPrzez, []))), mt(c, !0);
}
function Cw(e) {
  if (!e)
    return [];
  const n = [], c = { umowy: [], zamowienia: [] }, E = Te(e?.Umowy), Y = Te(e?.Zamowienia), X = Te(e?.NrPartiiTowaru), Q = [
    { name: "DataUmowy", title: l.t("invoice.transaction.contractDate"), format: R.Date },
    { name: "NrUmowy", title: l.t("invoice.transaction.contractNumber"), format: R.Default }
  ], B = [
    { name: "DataZamowienia", title: l.t("invoice.transaction.orderDate"), format: R.Date },
    { name: "NrZamowienia", title: l.t("invoice.transaction.orderNumber"), format: R.Default }
  ], r = [
    { name: "", title: l.t("invoice.transaction.batchNumber"), format: R.Default }
  ];
  if (n.push(Ne(l.t("invoice.transaction.header"), [0, 8, 0, 4])), E.length > 0) {
    const A = ft(Q, E, "*", void 0, 20);
    A.content && (c.umowy = [kt(l.t("invoice.transaction.contract")), A.content]);
  }
  if (Y.length > 0) {
    const A = ft(
      B,
      Y,
      "*",
      void 0,
      20
    );
    A.content && A.fieldsWithValue.length > 0 && (c.zamowienia = [kt(l.t("invoice.transaction.order")), A.content]);
  }
  if ((c.zamowienia.length > 0 || c.umowy.length > 0) && n.push(It(c.umowy, c.zamowienia, 0, !1)), (e.WalutaUmowna?._text || e.KursUmowny?._text) && (n.push(Ne(l.t("invoice.transaction.currencyAndRate"), [0, 8, 0, 4])), n.push(ZA(l.t("invoice.transaction.currency"), e.WalutaUmowna)), n.push(ZA(l.t("invoice.transaction.rate"), e.KursUmowny))), X.length > 0) {
    const A = ft(
      r,
      X,
      "*",
      [0, 4]
    );
    A.content && n.push(It(A.content, "", 0, !1));
  }
  return n.push(
    ZA(
      l.t("invoice.transaction.deliveryTerms"),
      e.WarunkiDostawy,
      R.MarginTop4
    )
  ), e.PodmiotPosredniczacy?._text === "1" && n.push(
    re(l.t("invoice.transaction.intermediaryDelivery"), [R.Label, R.MarginTop4])
  ), e.Transport && Te(e.Transport).forEach((A, a) => {
    n.push(
      hw(A, Te(e.Transport).length !== 0 ? a + 1 : null)
    );
  }), mt(n, !0);
}
function Mw(e) {
  const n = [], c = de(e.RodzajFaktury), E = !!Number(de(e.Adnotacje?.PMarzy?.P_PMarzy)), Y = Te(e.FaWiersz).map(
    (x) => {
      const U = Ra(c, E, x);
      return de(x.P_12) && (x.P_12._text = er(de(x.P_12), 3)), { ...x, ...U };
    }
  ), X = [
    { name: "NrWierszaFa", title: l.t("invoice.rows.lp"), format: R.Default, width: "auto" }
  ], Q = [
    {
      name: "UU_ID",
      title: l.t("invoice.rows.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7", title: l.t("invoice.rows.productName"), format: R.Default, width: "*" },
    { name: "P_9A", title: l.t("invoice.rows.netUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_9B", title: l.t("invoice.rows.grossUnitPrice"), format: R.Currency, width: "auto" },
    { name: "P_8B", title: l.t("invoice.rows.amount"), format: R.Number, width: "auto" },
    { name: "P_8A", title: l.t("invoice.rows.unit"), format: R.Default, width: "auto" },
    { name: "P_10", title: l.t("invoice.rows.discount"), format: R.Currency, width: "auto" },
    { name: "P_12", title: l.t("invoice.rows.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12_XII",
      title: l.t("invoice.rows.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    {
      name: "P_12_Zal_15",
      title: l.t("invoice.rows.productMarker"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_11", title: l.t("invoice.rows.netSalesValue"), format: R.Currency, width: "auto" },
    {
      name: "P_11A",
      title: l.t("invoice.rows.grossSalesValue"),
      format: R.Currency,
      width: "auto"
    },
    {
      name: "P_11Vat",
      title: l.t("invoice.rows.vatSalesValue"),
      format: R.Currency,
      width: "auto"
    }
  ];
  vn("KursWaluty", Y).length !== 1 && Q.push({
    name: "KursWaluty",
    title: l.t("invoice.rows.currencyRate"),
    format: R.Currency6,
    width: "auto"
  }), Q.push({
    name: "StanPrzed",
    title: l.t("invoice.rows.stateBefore"),
    format: R.Boolean,
    width: "auto"
  });
  const B = [
    { name: "GTIN", title: l.t("invoice.rows.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiU", title: l.t("invoice.rows.pkwiu"), format: R.Default, width: "auto" },
    { name: "CN", title: l.t("invoice.rows.cn"), format: R.Default, width: "auto" },
    { name: "PKOB", title: l.t("invoice.rows.pkob"), format: R.Default, width: "auto" },
    {
      name: "KwotaAkcyzy",
      title: l.t("invoice.rows.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTU", title: l.t("invoice.rows.gtu"), format: R.Default, width: "auto" },
    { name: "Procedura", title: l.t("invoice.rows.procedure"), format: R.Default, width: "*" },
    { name: "P_6A", title: l.t("invoice.rows.getOrMakeDate"), format: R.Date, width: "auto" },
    { name: "Indeks", title: l.t("invoice.rows.index"), format: R.Default, width: "auto" }
  ];
  let r = ft(
    [...X, ...Q, ...B],
    Y,
    "auto"
  );
  const A = re(l.t("invoice.rows.issuedInCurrency", { currency: e.KodWaluty?._text }), [
    R.Label,
    R.MarginBottom8
  ]), a = de(e.P_15);
  let d = "";
  return c == pt.ROZ && Number(a) !== 0 ? d = {
    stack: ii([
      { value: l.t("invoice.rows.remainingAmount"), formatTyp: R.LabelGreater },
      {
        value: a,
        formatTyp: R.CurrencyGreater,
        currency: de(e.KodWaluty)?.toString() ?? ""
      }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  } : (c == pt.VAT || c == pt.KOR || c == pt.KOR_ROZ || c == pt.UPR) && Number(a) !== 0 && (d = {
    stack: ii([
      { value: l.t("invoice.rows.totalAmountDue"), formatTyp: R.LabelGreater },
      {
        value: a,
        formatTyp: [R.CurrencyGreaterWithSeparator, R.HeaderContent, R.Value],
        currency: de(e.KodWaluty)?.toString() ?? ""
      }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }), r.fieldsWithValue.length <= 8 && r.content ? n.push(r.content) : (r = ft([...X, ...Q], Y, "*"), r.content && n.push(r.content), r = ft([...X, ...B], Y, "*"), r.content && r.fieldsWithValue.length > 1 && (n.push(`
`), n.push(r.content))), n.length < 1 ? [] : mt([...Ne(l.t("invoice.rows.header")), A, ...n, d], !0);
}
function Dw(e, n, c, E, Y, X) {
  if (!e)
    return [];
  const Q = n === Dn.BeforeCorrection ? R.CurrencyAbs : R.Currency, B = Te(e?.ZamowienieWiersz).map((D, J) => (D.NrWierszaZam._text || (D.NrWierszaZam._text = (J + 1).toString()), D.P_12Z = { _text: l.t(er(de(D.P_12Z), 3, X)) }, D)), r = [
    { name: "NrWierszaZam", title: l.t("invoice.order.lp"), format: R.Default, width: "auto" }
  ], A = [
    {
      name: "UU_ID",
      title: l.t("invoice.order.uniqueRowNumber"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_7Z", title: l.t("invoice.order.productName"), format: R.Default, width: "*" },
    {
      name: "P_9AZ",
      title: l.t("invoice.order.netUnitPrice"),
      format: Q,
      width: "auto"
    },
    { name: "P_8BZ", title: l.t("invoice.order.quantity"), format: R.Right, width: "auto" },
    { name: "P_8AZ", title: l.t("invoice.order.unit"), format: R.Default, width: "auto" },
    { name: "P_12Z", title: l.t("invoice.order.taxRate"), format: R.Default, width: "auto" },
    {
      name: "P_12Z_XII",
      title: l.t("invoice.order.ossTaxRate"),
      format: R.Percentage,
      width: "auto"
    },
    {
      name: "P_12Z_Zal_15",
      title: l.t("invoice.order.productMarker"),
      format: R.Default,
      width: "auto"
    },
    { name: "P_11NettoZ", title: l.t("invoice.order.netSalesValue"), format: Q, width: "auto" },
    { name: "P_11VatZ", title: l.t("invoice.order.taxAmount"), format: Q, width: "auto" }
  ], a = [
    { name: "UU_IDZ", title: l.t("invoice.order.orderNumber"), format: R.Default, width: "auto" },
    { name: "GTINZ", title: l.t("invoice.order.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiUZ", title: l.t("invoice.order.pkwiu"), format: R.Default, width: "auto" },
    { name: "CNZ", title: l.t("invoice.order.cn"), format: R.Default, width: "auto" },
    { name: "PKOBZ", title: l.t("invoice.order.pkob"), format: R.Default, width: "auto" },
    {
      name: "KwotaAkcyzyZ",
      title: l.t("invoice.order.exciseTaxAmount"),
      format: R.Currency,
      width: "auto"
    },
    { name: "GTUZ", title: l.t("invoice.order.gtu"), format: R.Default, width: "auto" },
    {
      name: "ProceduraZ",
      title: l.t("invoice.order.procedureMarkings"),
      format: R.Default,
      width: "*"
    },
    { name: "IndeksZ", title: l.t("invoice.order.index"), format: R.Default, width: "auto" },
    {
      name: "StanPrzedZ",
      title: l.t("invoice.order.stateBefore"),
      format: R.Boolean,
      width: "auto"
    }
  ];
  let d = ft(
    [...r, ...A, ...a],
    B,
    "*"
  );
  const x = [];
  d.fieldsWithValue.length <= 8 ? d.content && x.push(d.content) : (d = ft(
    [...r, ...A],
    B,
    "*"
  ), d.content && x.push(d.content), d = ft(
    [...r, ...a],
    B,
    "*"
  ), d.content && d.fieldsWithValue.length > 1 && x.push(d.content));
  const U = l.t("invoice.order.issuedInCurrency", { currency: Y });
  let P = "";
  return Number(c) > 0 && E == pt.ZAL ? P = {
    stack: ii([
      { value: l.t("invoice.order.advancePaymentAmount"), formatTyp: R.LabelGreater },
      { value: c, formatTyp: R.CurrencyGreater }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  } : n !== Dn.BeforeCorrection && E == pt.KOR_ZAL && (P = {
    stack: ii([
      { value: l.t("invoice.order.advancePaymentAmountCorrection"), formatTyp: R.LabelGreater },
      { value: c, formatTyp: R.CurrencyGreater }
    ]),
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  }), [
    {
      stack: [
        Ne(n),
        U,
        {
          text: [
            l.t("invoice.order.orderValueWithTax"),
            re(e.WartoscZamowienia?._text, R.Currency)
          ],
          marginBottom: 4
        },
        ...x,
        P
      ]
    }
  ];
}
bn.addVirtualFileSystem(_s);
function dw(e, n) {
  const E = e.Fa?.RodzajFaktury?._text == pt.KOR && Ae(e.Fa?.OkresFaKorygowanej) ? lw(e.Fa) : Mw(e.Fa), Y = {
    ...qs(n?.watermark),
    content: [
      ...Sa(e.Fa, n, e.Zalacznik),
      Vs(e.Fa),
      ...ow(e),
      Ew(e.Fa),
      E,
      Dw(
        e.Fa?.Zamowienie,
        Dn.Order,
        e.Fa?.P_15?._text ?? "",
        e.Fa?.RodzajFaktury?._text ?? "",
        e.Fa?.KodWaluty?._text ?? "",
        de(e.Fa?.Adnotacje?.PMarzy?.P_PMarzy)
      ),
      gw(e),
      qE(e.Fa?.Adnotacje),
      $E(e.Fa),
      Xs(e.Fa?.Rozliczenie, e.Fa?.KodWaluty?._text ?? ""),
      ew(e.Fa?.Platnosc),
      Cw(e.Fa?.WarunkiTransakcji),
      ...Zs(n, e.Stopka, e.Naglowek, e.Fa?.WZ, e.Zalacznik)
    ],
    footer: (X, Q) => ({
      text: `${X.toString()} ${l.t("invoice.footer.pagesTotal")} ${Q}`,
      alignment: Rt.RIGHT,
      margin: [0, 0, 40, 0]
    }),
    ...os()
  };
  return bn.createPdf(Y);
}
function Iw(e) {
  const n = [
    ...Ne("invoice.additionalInformation.additionalInformationLabel"),
    ...yw(e.DokumentZaplaty),
    ...Fw(e.DodatkowyOpis)
  ];
  return n.length > 1 ? mt(n, !0) : [];
}
function yw(e) {
  if (!e)
    return [];
  const n = Te(e)?.map((X, Q) => ({
    ...X,
    lp: { _text: Q + 1 }
  })), c = kt(
    l.t("invoice.additionalInformation.paymentDocuments"),
    [0, 0, 0, 4]
  ), E = [
    {
      name: "lp",
      title: l.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "NrDokumentu",
      title: l.t("invoice.additionalInformation.documentNumber"),
      format: R.Default,
      width: "*"
    },
    {
      name: "DataDokumentu",
      title: l.t("invoice.additionalInformation.documentDate"),
      format: R.Date,
      width: "auto"
    }
  ], Y = ft(
    E,
    n,
    "*",
    [0, 0, 0, 0]
  );
  return Y.content && c.push(Y.content), c;
}
function Fw(e) {
  if (!e)
    return [];
  const n = Te(e)?.map((X, Q) => ({
    ...X,
    lp: { _text: Q + 1 }
  })), c = kt(l.t("invoice.additionalInformation.additionalDescription")), E = [
    {
      name: "lp",
      title: l.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "NrWiersza",
      title: l.t("invoice.additionalInformation.rowNumber"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Klucz",
      title: l.t("invoice.additionalInformation.infoType"),
      format: R.Default,
      width: "auto"
    },
    {
      name: "Wartosc",
      title: l.t("invoice.additionalInformation.infoContent"),
      format: R.Default,
      width: "*"
    }
  ], Y = ft(
    E,
    n,
    "*",
    [0, 0, 0, 0]
  );
  return Y.content && c.push(Y.content), c;
}
function xw(e, n) {
  let c = "";
  switch (de(e?.RodzajFaktury)) {
    case pt.VAT_RR:
      c = l.t("invoice.header.primalInvoiceVatRr");
      break;
    case pt.KOR_VAT_RR:
      c = l.t("invoice.header.correctedInvoiceVatRr");
      break;
  }
  return [
    {
      text: [
        { text: l.t("invoice.header.ksefPart1"), fontSize: 18 },
        { text: l.t("invoice.header.ksefPart2"), color: "red", bold: !0, fontSize: 18 },
        { text: l.t("invoice.header.ksefPart3"), bold: !0, fontSize: 18 }
      ]
    },
    {
      ...re(l.t("invoice.header.invoiceNumberLabel"), R.ValueMedium),
      alignment: Rt.RIGHT
    },
    {
      ...re(de(e?.P_4C), R.HeaderPosition),
      alignment: Rt.RIGHT
    },
    {
      ...re(c, [R.ValueMedium, R.Default]),
      alignment: Rt.RIGHT
    },
    ...n?.nrKSeF ? [
      {
        text: [
          re(l.t("invoice.header.ksefNumberLabel"), R.LabelMedium),
          re(n?.nrKSeF, R.ValueMedium)
        ],
        alignment: Rt.RIGHT
      }
    ] : []
  ];
}
const wB = (e, n) => {
  const c = [];
  return e?.length ? (e.forEach((E, Y) => {
    const X = [], Q = Ne(
      n ? `${n} ${e?.length > 1 ? ++Y : ""}` : "",
      [0, 8, 0, 8]
    );
    X.push([
      re(l.t("invoice.registers.fullAccountNumber"), R.GrayBoldTitle),
      re(de(E.NrRB), R.AccountNumber)
    ]), X.push([
      re(l.t("invoice.registers.swiftCode"), R.GrayBoldTitle),
      re(de(E.SWIFT), R.Default)
    ]), X.push([
      re(l.t("invoice.registers.bankName"), R.GrayBoldTitle),
      re(
        Ae(E.NazwaBanku) ? Ti(de(E.NazwaBanku), 20) : de(E.NazwaBanku),
        R.Default
      )
    ]), X.push([
      re(l.t("invoice.registers.accountDescription"), R.GrayBoldTitle),
      re(
        Ae(E.OpisRachunku) ? Ti(de(E.OpisRachunku), 20) : de(E.OpisRachunku),
        R.Default
      )
    ]), c.push([
      ...Q,
      {
        unbreakable: !0,
        table: {
          body: X,
          widths: ["auto", "*"]
        },
        layout: {
          hLineWidth: () => 1,
          hLineColor: () => "#BABABA",
          vLineWidth: () => 1,
          vLineColor: () => "#BABABA"
        }
      }
    ]);
  }), mt(c, !1, [0, 0, 0, 0])) : [];
};
function pw(e) {
  if (!e)
    return [];
  const n = [Ui(), ...Ne(l.t("invoice.payment.payment"))];
  Ae(e.FormaPlatnosci) ? n.push(ZA(l.t("invoice.payment.paymentMethod3"), l.t("invoice.payment.transfer"))) : Ae(e.OpisPlatnosci) && (n.push(ZA(l.t("invoice.payment.paymentMethod3"), l.t("invoice.payment.other"))), n.push(ZA(l.t("invoice.payment.description"), e.OpisPlatnosci))), Ae(e.LinkDoPlatnosci) && (n.push(re(l.t("invoice.payment.moneylessLink"), R.Label)), n.push({
    text: re(de(e.LinkDoPlatnosci), R.Link),
    link: re(de(e.LinkDoPlatnosci), R.Link)
  })), Ae(e.IPKSeF) && n.push(ZA(l.t("invoice.payment.ksefTransferId"), e.IPKSeF));
  const c = Te(e.RachunekBankowy1).map(
    (X) => wB([X], l.t("invoice.payment.farmer"))
  ), E = Te(e.RachunekBankowy2).map(
    (X) => wB([X], l.t("invoice.payment.getter"))
  ), Y = [...c, ...E];
  return Y.length > 0 && Y.forEach((X, Q) => {
    Q % 2 === 0 && n.push(It(X, Y[Q + 1] ?? []));
  }), n.push({ margin: [0, 8, 0, 0], text: "" }), n;
}
function jn(e) {
  const n = [];
  return e?.AdresL1 && n.push(re(de(e.AdresL1), R.Value)), e?.AdresL2 && n.push(re(de(e.AdresL2), R.Value)), e?.KodKraju && n.push(re(l.t(Na(de(e.KodKraju) ?? "")), R.Value)), n.push(...ZA(l.t("invoice.address.GLN"), e.GLN)), n;
}
function Ga(e) {
  return [
    ZA(l.t("invoice.subjectIdentificationData.nip"), e.NIP),
    ZA(l.t("invoice.subjectIdentificationData.name"), e.Nazwa)
  ];
}
function Bs(e) {
  return Te(e)?.map((n) => [
    ZA(l.t("invoice.subjectContactData.e-mail"), n.Email),
    ZA(l.t("invoice.subjectContactData.phone"), n.Telefon)
  ]);
}
function uB(e) {
  const n = Ne(l.t("invoice.subject1.seller"));
  return e.DaneIdentyfikacyjne && n.push(...Ga(e.DaneIdentyfikacyjne)), e.Adres && n.push(
    re(l.t("invoice.subject1.address"), [R.Label, R.LabelMargin]),
    jn(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject1.mailingAddress"), [R.Label, R.LabelMargin]),
    ...jn(e.AdresKoresp)
  ), e.DaneKontaktowe && n.push(
    re(l.t("invoice.subject1.contactDetails"), [R.Label, R.LabelMargin]),
    ...Bs(e.DaneKontaktowe)
  ), Ae(e.NrKontrahenta) && n.push(
    ZA(l.t("invoice.subject1.contractorNumber"), de(e.NrKontrahenta))
  ), n;
}
function Ha(e) {
  return [
    ZA(l.t("invoice.subjectIdentificationData.nip"), e.NIP),
    ZA(l.t("invoice.subjectIdentificationData.name"), e.Nazwa)
  ];
}
function fB(e) {
  const n = Ne(l.t("invoice.subject2.buyer"));
  if (e.DaneIdentyfikacyjne && n.push(...Ha(e.DaneIdentyfikacyjne)), e.Adres && n.push(
    re(l.t("invoice.subject2.address"), [R.Label, R.LabelMargin]),
    jn(e.Adres)
  ), e.AdresKoresp && n.push(
    re(l.t("invoice.subject2.mailingAddress"), [R.Label, R.LabelMargin]),
    ...jn(e.AdresKoresp)
  ), e.DaneKontaktowe && n.push(
    re(l.t("invoice.subject2.contactDetails"), [R.Label, R.LabelMargin]),
    ...Bs(e.DaneKontaktowe)
  ), Ae(e.StatusInfoPodatnika)) {
    const c = qt(e.StatusInfoPodatnika, On);
    n.push(ZA(l.t("invoice.subject2.taxPayerStatus"), c));
  }
  return n;
}
function mw(e) {
  if (!e)
    return [];
  const n = [];
  return Ae(e.NIP) ? n.push(
    ZA(
      l.t("invoice.subjectIdentificationData.nip"),
      e.NIP,
      R.Default
    )
  ) : Ae(e.IDWew) ? n.push(
    ZA(
      l.t("invoice.subjectIdentificationData.internalId"),
      e.IDWew,
      R.Default
    )
  ) : de(e.BrakID) === "1" && n.push(ZA(l.t("invoice.subjectIdentificationData.noId"), " ", R.Default)), Ae(e.Nazwa) && n.push(
    ZA(
      l.t("invoice.subjectIdentificationData.name"),
      e.Nazwa,
      R.Default
    )
  ), n;
}
function Yw(e, n) {
  const c = [];
  c.push(Ui());
  const E = [
    ...Ne(l.t("invoice.subject3.otherEntity", { index: n + 1 })),
    ...mw(e.DaneIdentyfikacyjne),
    ZA(l.t("invoice.subject3.role"), qt(e.Rola, Nl)),
    ZA(l.t("invoice.subject3.roleDescription"), e.OpisRoli)
  ], Y = [];
  return e.Adres && Y.push(
    re(l.t("invoice.subject3.address"), [R.Label, R.LabelMargin]),
    jn(e.Adres)
  ), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject3.correspondenceAddress"), [R.Label, R.LabelMargin]),
    ...jn(e.AdresKoresp)
  ), e.DaneKontaktowe && Y.push(
    re(l.t("invoice.subject3.contactData"), [R.Label, R.LabelMargin]),
    ...Bs(e.DaneKontaktowe)
  ), c.push(It(E, Y)), c;
}
function Pw(e, n) {
  const c = Ne(l.t("invoice.subject1K.seller"));
  let E = [], Y = [];
  if (e.DaneIdentyfikacyjne && E.push(
    Ne(l.t("invoice.subject1K.identificationData")),
    ...Ga(e.DaneIdentyfikacyjne)
  ), e.DaneKontaktowe) {
    const X = Bs(Te(e.DaneKontaktowe));
    X.length && (E.push(Ne(l.t("invoice.subject1K.contactDetails"))), E.push(X));
  }
  return Ae(e.NrKontrahenta) && E.push(
    ZA(l.t("invoice.subject1K.contractorNumber"), de(e.NrKontrahenta))
  ), E.length && c.push({
    columns: [E, []],
    columnGap: 20
  }), E = QB(n, l.t("invoice.subject1K.correctedContent")), Y = QB(e, l.t("invoice.subject1K.correctiveContent")), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject1K.mailingAddress"), [R.Label, R.LabelMargin]),
    jn(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function QB(e, n) {
  const c = [];
  return c.push(Ne(n)), e.DaneIdentyfikacyjne && c.push(...Ga(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    re(l.t("invoice.subject1K.address"), [R.Label, R.LabelMargin]),
    jn(e.Adres)
  ), c;
}
function vw(e, n) {
  const c = Ne(l.t("invoice.subject2k.buyer"));
  let E = [], Y = [];
  if (e.DaneIdentyfikacyjne && E.push(
    Ne(l.t("invoice.subject2k.identificationData")),
    ...Ha(e.DaneIdentyfikacyjne)
  ), e.DaneKontaktowe && (E.push(
    re(l.t("invoice.subject2k.contactDetails"), [R.Label, R.LabelMargin])
  ), E.push(Bs(Te(e.DaneKontaktowe)))), Ae(e.StatusInfoPodatnika)) {
    const X = qt(e.StatusInfoPodatnika, On);
    E.push(ZA(l.t("invoice.subject2k.taxPayerStatus"), X));
  }
  return E.length && c.push({
    columns: [E, []],
    columnGap: 20
  }), E = hB(n, l.t("invoice.subject2k.correctedContent")), Y = hB(e, l.t("invoice.subject2k.correctiveContent")), e.AdresKoresp && Y.push(
    re(l.t("invoice.subject2k.mailingAddress"), [R.Label, R.LabelMargin]),
    Hi(e.AdresKoresp)
  ), (E.length || Y.length) && c.push(Li([E, Y])), c.length && c.push(Ei(1)), c;
}
function hB(e, n) {
  const c = [];
  return c.push(Ne(n)), e.DaneIdentyfikacyjne && c.push(...Ha(e.DaneIdentyfikacyjne)), e.Adres && c.push(
    re(l.t("invoice.subject2k.address"), [R.Label, R.LabelMargin]),
    Hi(e.Adres)
  ), c;
}
function bw(e) {
  const n = [], c = Te(e.Podmiot3);
  return e.FakturaRR?.Podmiot1K || e.FakturaRR?.Podmiot2K ? (e.FakturaRR?.Podmiot1K ? n.push(Pw(e.Podmiot1 ?? {}, e.FakturaRR?.Podmiot1K)) : e.Podmiot1 != null && n.push(uB(e.Podmiot1)), e.FakturaRR?.Podmiot2K ? n.push(vw(e.Podmiot2 ?? {}, e.FakturaRR?.Podmiot2K)) : e.Podmiot2 && n.push(mt(fB(e.Podmiot2), !0))) : n.push([
    Li([uB(e.Podmiot1), fB(e.Podmiot2)], {
      margin: [0, 0, 0, 8],
      columnGap: 20
    })
  ]), c.length > 0 && c.forEach((E, Y) => {
    n.push(Yw(E, Y)), Y < c.length - 1 && n.push({ margin: [0, 8, 0, 0], text: "" });
  }), mt(n, !0, [0, 0, 0, 0]);
}
function zw(e) {
  const n = Te(e.FakturaRRWiersz), c = [];
  if (Ae(e.KodWaluty) && de(e.KodWaluty) != "PLN") {
    const Q = vn("KursWaluty", n);
    Q.length === 1 && c.push(
      ZA(
        l.t("invoice.details.currencyRate"),
        Q[0].value,
        R.Currency6
      )
    );
  }
  const E = [
    ZA(l.t("invoice.details.invoiceDateShort"), e.P_4B, R.Date),
    ZA(l.t("invoice.details.getDate"), e.P_4A, R.Date),
    c
  ].filter((Q) => Q.length > 0), Y = [ZA(l.t("invoice.details.place"), e.P_1M)].filter(
    (Q) => Q.length > 0
  ), X = [
    ...Ne(l.t("invoice.details.header")),
    It(E, Y)
  ];
  return mt(X, !0);
}
function Tw(e) {
  const n = [], c = Te(e.FakturaRRWiersz).map(
    (r) => (de(r.P_9) && (r.P_9._text = l.t(er(de(r.P_9), "RR"))), { ...r })
  ), E = [
    {
      name: "NrWierszaFa",
      title: l.t("invoice.additionalInformation.ordinalNumber"),
      format: R.Default,
      width: "auto"
    }
  ], Y = [
    { name: "P_5", title: l.t("invoice.rows.name"), format: R.Default, width: "*" },
    { name: "P_6A", title: l.t("invoice.rows.unit"), format: R.Default, width: "auto" },
    { name: "P_6B", title: l.t("invoice.rows.amount"), format: R.Number, width: "auto" },
    { name: "P_6C", title: l.t("invoice.rows.qualityDesc"), format: R.Default, width: "auto" },
    { name: "P_7", title: l.t("invoice.rows.unitPrice"), format: R.Currency, width: "auto" },
    { name: "P_8", title: l.t("invoice.rows.priceNoZZP"), format: R.Currency, width: "auto" },
    { name: "P_9", title: l.t("invoice.rows.wageZZP"), format: R.Default, width: "auto" },
    { name: "P_10", title: l.t("invoice.rows.costZZP"), format: R.Currency, width: "auto" },
    { name: "P_11", title: l.t("invoice.rows.valueZZP"), format: R.Currency, width: "auto" }
  ];
  vn("KursWaluty", c).length !== 1 && Y.push({
    name: "KursWaluty",
    title: l.t("invoice.rows.currencyRate"),
    format: R.Currency6,
    width: "auto"
  }), Y.push({
    name: "StanPrzed",
    title: l.t("invoice.rows.stateBefore"),
    format: R.Boolean,
    width: "auto"
  });
  const X = [
    { name: "P_4AA", title: l.t("invoice.rows.getDate"), format: R.Date, width: "auto" },
    { name: "GTIN", title: l.t("invoice.rows.gtin"), format: R.Default, width: "auto" },
    { name: "PKWiU", title: l.t("invoice.rows.pkwiu"), format: R.Default, width: "auto" },
    { name: "CN", title: l.t("invoice.rows.cn"), format: R.Default, width: "auto" }
  ];
  let Q = ft(
    [...E, ...Y, ...X],
    c,
    "auto"
  );
  const B = {
    stack: [
      {
        stack: [
          ii([
            {
              value: l.t("invoice.rows.farmProductCost")
            },
            {
              value: de(e.P_11_1),
              formatTyp: [R.Currency, R.Value],
              currency: de(e.KodWaluty)?.toString() ?? ""
            },
            de(e.KodWaluty)?.toString() === "PLN" ? { value: "" } : {
              value: ` (${rs(de(e.P_11_1W))} PLN)`,
              formatTyp: [R.Currency, R.Value, R.LabelMargin],
              currency: de(e.KodWaluty)?.toString() ?? ""
            }
          ])
        ],
        margin: [0, 0, 0, 8]
      },
      {
        stack: [
          ii([
            {
              value: l.t("invoice.rows.lumpSumTaxRefund"),
              formatTyp: [R.LabelMargin, R.Label]
            },
            {
              value: de(e.P_11_2),
              formatTyp: [R.Currency, R.Value, R.LabelMargin],
              currency: de(e.KodWaluty)?.toString() ?? ""
            },
            de(e.KodWaluty)?.toString() === "PLN" ? { value: "" } : {
              value: ` (${rs(de(e.P_11_2W))} PLN)`,
              formatTyp: [R.Currency, R.Value, R.LabelMargin],
              currency: de(e.KodWaluty)?.toString() ?? ""
            }
          ])
        ],
        margin: [0, 0, 0, 8]
      },
      {
        stack: [
          ii([
            {
              value: l.t("invoice.rows.overallCost"),
              formatTyp: [R.LabelGreater, R.LabelMargin]
            },
            {
              value: de(e.P_12_1),
              formatTyp: [R.Currency, R.ValueMedium, R.LabelMargin],
              currency: de(e.KodWaluty)?.toString() ?? ""
            },
            de(e.KodWaluty)?.toString() === "PLN" ? { value: "" } : {
              value: ` (${rs(de(e.P_12_1W))} PLN)`,
              formatTyp: [R.Currency, R.ValueMedium, R.LabelMargin]
            }
          ])
        ],
        margin: [0, 0, 0, 8]
      },
      ii([
        { value: l.t("invoice.rows.inWords"), formatTyp: [R.LabelMargin, R.Label] },
        {
          value: de(e.P_12_2),
          formatTyp: [R.Value]
        }
      ])
    ],
    alignment: Rt.RIGHT,
    margin: [0, 8, 0, 0]
  };
  return Q.fieldsWithValue.length <= 8 && Q.content ? n.push(Q.content) : (Q = ft([...E, ...Y], c, "*"), Q.content && n.push(Q.content), Q = ft([...E, ...X], c, "*"), Q.content && Q.fieldsWithValue.length > 1 && (n.push(`
`), n.push(Q.content))), n.length < 1 ? [] : mt([...Ne(l.t("invoice.rows.header")), ...n, B], !0);
}
bn.addVirtualFileSystem(_s);
function Uw(e, n) {
  const c = {
    ...qs(n?.watermark),
    content: [
      ...xw(e.FakturaRR, n),
      Vs(e.FakturaRR),
      ...bw(e),
      zw(e.FakturaRR),
      Tw(e.FakturaRR),
      Iw(e.FakturaRR),
      Xs(e.FakturaRR?.Rozliczenie, e.FakturaRR?.KodWaluty?._text ?? ""),
      pw(e.FakturaRR?.Platnosc),
      ...Zs(n, e.Stopka, e.Naglowek)
    ],
    footer: (E, Y) => ({
      text: `${E.toString()} ${l.t("invoice.footer.pagesTotal")} ${Y}`,
      alignment: Rt.RIGHT,
      margin: [0, 0, 40, 0]
    }),
    ...os()
  };
  return bn.createPdf(c);
}
var Ma = {};
const Nw = {}, Rw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nw
}, Symbol.toStringTag, { value: "Module" })), Sw = /* @__PURE__ */ Ml(Rw);
var CB;
function Gw() {
  return CB || (CB = 1, (function(e) {
    (function(n) {
      n.parser = function(F, o) {
        return new E(F, o);
      }, n.SAXParser = E, n.SAXStream = d, n.createStream = A, n.MAX_BUFFER_LENGTH = 64 * 1024;
      var c = [
        "comment",
        "sgmlDecl",
        "textNode",
        "tagName",
        "doctype",
        "procInstName",
        "procInstBody",
        "entity",
        "attribName",
        "attribValue",
        "cdata",
        "script"
      ];
      n.EVENTS = [
        "text",
        "processinginstruction",
        "sgmldeclaration",
        "doctype",
        "comment",
        "opentagstart",
        "attribute",
        "opentag",
        "closetag",
        "opencdata",
        "cdata",
        "closecdata",
        "error",
        "end",
        "ready",
        "script",
        "opennamespace",
        "closenamespace"
      ];
      function E(F, o) {
        if (!(this instanceof E))
          return new E(F, o);
        var h = this;
        X(h), h.q = h.c = "", h.bufferCheckPosition = n.MAX_BUFFER_LENGTH, h.encoding = null, h.opt = o || {}, h.opt.lowercase = h.opt.lowercase || h.opt.lowercasetags, h.looseCase = h.opt.lowercase ? "toLowerCase" : "toUpperCase", h.opt.maxEntityCount = h.opt.maxEntityCount || 512, h.opt.maxEntityDepth = h.opt.maxEntityDepth || 4, h.entityCount = h.entityDepth = 0, h.tags = [], h.closed = h.closedRoot = h.sawRoot = !1, h.tag = h.error = null, h.strict = !!F, h.noscript = !!(F || h.opt.noscript), h.state = k.BEGIN, h.strictEntities = h.opt.strictEntities, h.ENTITIES = h.strictEntities ? Object.create(n.XML_ENTITIES) : Object.create(n.ENTITIES), h.attribList = [], h.opt.xmlns && (h.ns = Object.create(J)), h.opt.unquotedAttributeValues === void 0 && (h.opt.unquotedAttributeValues = !F), h.trackPosition = h.opt.position !== !1, h.trackPosition && (h.position = h.line = h.column = 0), lA(h, "onready");
      }
      Object.create || (Object.create = function(F) {
        function o() {
        }
        o.prototype = F;
        var h = new o();
        return h;
      }), Object.keys || (Object.keys = function(F) {
        var o = [];
        for (var h in F) F.hasOwnProperty(h) && o.push(h);
        return o;
      });
      function Y(F) {
        for (var o = Math.max(n.MAX_BUFFER_LENGTH, 10), h = 0, _ = 0, oA = c.length; _ < oA; _++) {
          var p = F[c[_]].length;
          if (p > o)
            switch (c[_]) {
              case "textNode":
                $(F);
                break;
              case "cdata":
                DA(F, "oncdata", F.cdata), F.cdata = "";
                break;
              case "script":
                DA(F, "onscript", F.script), F.script = "";
                break;
              default:
                $A(F, "Max buffer length exceeded: " + c[_]);
            }
          h = Math.max(h, p);
        }
        var rA = n.MAX_BUFFER_LENGTH - h;
        F.bufferCheckPosition = rA + F.position;
      }
      function X(F) {
        for (var o = 0, h = c.length; o < h; o++)
          F[c[o]] = "";
      }
      function Q(F) {
        $(F), F.cdata !== "" && (DA(F, "oncdata", F.cdata), F.cdata = ""), F.script !== "" && (DA(F, "onscript", F.script), F.script = "");
      }
      E.prototype = {
        end: function() {
          kA(this);
        },
        write: sA,
        resume: function() {
          return this.error = null, this;
        },
        close: function() {
          return this.write(null);
        },
        flush: function() {
          Q(this);
        }
      };
      var B;
      try {
        B = Sw.Stream;
      } catch {
        B = function() {
        };
      }
      B || (B = function() {
      });
      var r = n.EVENTS.filter(function(F) {
        return F !== "error" && F !== "end";
      });
      function A(F, o) {
        return new d(F, o);
      }
      function a(F, o) {
        if (F.length >= 2) {
          if (F[0] === 255 && F[1] === 254)
            return "utf-16le";
          if (F[0] === 254 && F[1] === 255)
            return "utf-16be";
        }
        return F.length >= 3 && F[0] === 239 && F[1] === 187 && F[2] === 191 ? "utf8" : F.length >= 4 ? F[0] === 60 && F[1] === 0 && F[2] === 63 && F[3] === 0 ? "utf-16le" : F[0] === 0 && F[1] === 60 && F[2] === 0 && F[3] === 63 ? "utf-16be" : "utf8" : o ? "utf8" : null;
      }
      function d(F, o) {
        if (!(this instanceof d))
          return new d(F, o);
        B.apply(this), this._parser = new E(F, o), this.writable = !0, this.readable = !0;
        var h = this;
        this._parser.onend = function() {
          h.emit("end");
        }, this._parser.onerror = function(_) {
          h.emit("error", _), h._parser.error = null;
        }, this._decoder = null, this._decoderBuffer = null, r.forEach(function(_) {
          Object.defineProperty(h, "on" + _, {
            get: function() {
              return h._parser["on" + _];
            },
            set: function(oA) {
              if (!oA)
                return h.removeAllListeners(_), h._parser["on" + _] = oA, oA;
              h.on(_, oA);
            },
            enumerable: !0,
            configurable: !1
          });
        });
      }
      d.prototype = Object.create(B.prototype, {
        constructor: {
          value: d
        }
      }), d.prototype._decodeBuffer = function(F, o) {
        if (this._decoderBuffer && (F = Buffer.concat([this._decoderBuffer, F]), this._decoderBuffer = null), !this._decoder) {
          var h = a(F, o);
          if (!h)
            return this._decoderBuffer = F, "";
          this._parser.encoding = h, this._decoder = new TextDecoder(h);
        }
        return this._decoder.decode(F, { stream: !o });
      }, d.prototype.write = function(F) {
        if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(F))
          F = this._decodeBuffer(F, !1);
        else if (this._decoderBuffer) {
          var o = this._decodeBuffer(Buffer.alloc(0), !0);
          o && (this._parser.write(o), this.emit("data", o));
        }
        return this._parser.write(F.toString()), this.emit("data", F), !0;
      }, d.prototype.end = function(F) {
        if (F && F.length && this.write(F), this._decoderBuffer) {
          var o = this._decodeBuffer(Buffer.alloc(0), !0);
          o && (this._parser.write(o), this.emit("data", o));
        } else if (this._decoder) {
          var h = this._decoder.decode();
          h && (this._parser.write(h), this.emit("data", h));
        }
        return this._parser.end(), !0;
      }, d.prototype.on = function(F, o) {
        var h = this;
        return !h._parser["on" + F] && r.indexOf(F) !== -1 && (h._parser["on" + F] = function() {
          var _ = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
          _.splice(0, 0, F), h.emit.apply(h, _);
        }), B.prototype.on.call(h, F, o);
      };
      var x = "[CDATA[", U = "DOCTYPE", P = "http://www.w3.org/XML/1998/namespace", D = "http://www.w3.org/2000/xmlns/", J = { xml: P, xmlns: D }, q = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, AA = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, K = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, z = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
      function T(F) {
        return F === " " || F === `
` || F === "\r" || F === "	";
      }
      function H(F) {
        return F === '"' || F === "'";
      }
      function eA(F) {
        return F === ">" || T(F);
      }
      function CA(F, o) {
        return F.test(o);
      }
      function IA(F, o) {
        return !CA(F, o);
      }
      var k = 0;
      n.STATE = {
        BEGIN: k++,
        // leading byte order mark or whitespace
        BEGIN_WHITESPACE: k++,
        // leading whitespace
        TEXT: k++,
        // general stuff
        TEXT_ENTITY: k++,
        // &amp and such.
        OPEN_WAKA: k++,
        // <
        SGML_DECL: k++,
        // <!BLARG
        SGML_DECL_QUOTED: k++,
        // <!BLARG foo "bar
        DOCTYPE: k++,
        // <!DOCTYPE
        DOCTYPE_QUOTED: k++,
        // <!DOCTYPE "//blah
        DOCTYPE_DTD: k++,
        // <!DOCTYPE "//blah" [ ...
        DOCTYPE_DTD_QUOTED: k++,
        // <!DOCTYPE "//blah" [ "foo
        COMMENT_STARTING: k++,
        // <!-
        COMMENT: k++,
        // <!--
        COMMENT_ENDING: k++,
        // <!-- blah -
        COMMENT_ENDED: k++,
        // <!-- blah --
        CDATA: k++,
        // <![CDATA[ something
        CDATA_ENDING: k++,
        // ]
        CDATA_ENDING_2: k++,
        // ]]
        PROC_INST: k++,
        // <?hi
        PROC_INST_BODY: k++,
        // <?hi there
        PROC_INST_ENDING: k++,
        // <?hi "there" ?
        OPEN_TAG: k++,
        // <strong
        OPEN_TAG_SLASH: k++,
        // <strong /
        ATTRIB: k++,
        // <a
        ATTRIB_NAME: k++,
        // <a foo
        ATTRIB_NAME_SAW_WHITE: k++,
        // <a foo _
        ATTRIB_VALUE: k++,
        // <a foo=
        ATTRIB_VALUE_QUOTED: k++,
        // <a foo="bar
        ATTRIB_VALUE_CLOSED: k++,
        // <a foo="bar"
        ATTRIB_VALUE_UNQUOTED: k++,
        // <a foo=bar
        ATTRIB_VALUE_ENTITY_Q: k++,
        // <foo bar="&quot;"
        ATTRIB_VALUE_ENTITY_U: k++,
        // <foo bar=&quot
        CLOSE_TAG: k++,
        // </a
        CLOSE_TAG_SAW_WHITE: k++,
        // </a   >
        SCRIPT: k++,
        // <script> ...
        SCRIPT_ENDING: k++
        // <script> ... <
      }, n.XML_ENTITIES = {
        amp: "&",
        gt: ">",
        lt: "<",
        quot: '"',
        apos: "'"
      }, n.ENTITIES = {
        amp: "&",
        gt: ">",
        lt: "<",
        quot: '"',
        apos: "'",
        AElig: 198,
        Aacute: 193,
        Acirc: 194,
        Agrave: 192,
        Aring: 197,
        Atilde: 195,
        Auml: 196,
        Ccedil: 199,
        ETH: 208,
        Eacute: 201,
        Ecirc: 202,
        Egrave: 200,
        Euml: 203,
        Iacute: 205,
        Icirc: 206,
        Igrave: 204,
        Iuml: 207,
        Ntilde: 209,
        Oacute: 211,
        Ocirc: 212,
        Ograve: 210,
        Oslash: 216,
        Otilde: 213,
        Ouml: 214,
        THORN: 222,
        Uacute: 218,
        Ucirc: 219,
        Ugrave: 217,
        Uuml: 220,
        Yacute: 221,
        aacute: 225,
        acirc: 226,
        aelig: 230,
        agrave: 224,
        aring: 229,
        atilde: 227,
        auml: 228,
        ccedil: 231,
        eacute: 233,
        ecirc: 234,
        egrave: 232,
        eth: 240,
        euml: 235,
        iacute: 237,
        icirc: 238,
        igrave: 236,
        iuml: 239,
        ntilde: 241,
        oacute: 243,
        ocirc: 244,
        ograve: 242,
        oslash: 248,
        otilde: 245,
        ouml: 246,
        szlig: 223,
        thorn: 254,
        uacute: 250,
        ucirc: 251,
        ugrave: 249,
        uuml: 252,
        yacute: 253,
        yuml: 255,
        copy: 169,
        reg: 174,
        nbsp: 160,
        iexcl: 161,
        cent: 162,
        pound: 163,
        curren: 164,
        yen: 165,
        brvbar: 166,
        sect: 167,
        uml: 168,
        ordf: 170,
        laquo: 171,
        not: 172,
        shy: 173,
        macr: 175,
        deg: 176,
        plusmn: 177,
        sup1: 185,
        sup2: 178,
        sup3: 179,
        acute: 180,
        micro: 181,
        para: 182,
        middot: 183,
        cedil: 184,
        ordm: 186,
        raquo: 187,
        frac14: 188,
        frac12: 189,
        frac34: 190,
        iquest: 191,
        times: 215,
        divide: 247,
        OElig: 338,
        oelig: 339,
        Scaron: 352,
        scaron: 353,
        Yuml: 376,
        fnof: 402,
        circ: 710,
        tilde: 732,
        Alpha: 913,
        Beta: 914,
        Gamma: 915,
        Delta: 916,
        Epsilon: 917,
        Zeta: 918,
        Eta: 919,
        Theta: 920,
        Iota: 921,
        Kappa: 922,
        Lambda: 923,
        Mu: 924,
        Nu: 925,
        Xi: 926,
        Omicron: 927,
        Pi: 928,
        Rho: 929,
        Sigma: 931,
        Tau: 932,
        Upsilon: 933,
        Phi: 934,
        Chi: 935,
        Psi: 936,
        Omega: 937,
        alpha: 945,
        beta: 946,
        gamma: 947,
        delta: 948,
        epsilon: 949,
        zeta: 950,
        eta: 951,
        theta: 952,
        iota: 953,
        kappa: 954,
        lambda: 955,
        mu: 956,
        nu: 957,
        xi: 958,
        omicron: 959,
        pi: 960,
        rho: 961,
        sigmaf: 962,
        sigma: 963,
        tau: 964,
        upsilon: 965,
        phi: 966,
        chi: 967,
        psi: 968,
        omega: 969,
        thetasym: 977,
        upsih: 978,
        piv: 982,
        ensp: 8194,
        emsp: 8195,
        thinsp: 8201,
        zwnj: 8204,
        zwj: 8205,
        lrm: 8206,
        rlm: 8207,
        ndash: 8211,
        mdash: 8212,
        lsquo: 8216,
        rsquo: 8217,
        sbquo: 8218,
        ldquo: 8220,
        rdquo: 8221,
        bdquo: 8222,
        dagger: 8224,
        Dagger: 8225,
        bull: 8226,
        hellip: 8230,
        permil: 8240,
        prime: 8242,
        Prime: 8243,
        lsaquo: 8249,
        rsaquo: 8250,
        oline: 8254,
        frasl: 8260,
        euro: 8364,
        image: 8465,
        weierp: 8472,
        real: 8476,
        trade: 8482,
        alefsym: 8501,
        larr: 8592,
        uarr: 8593,
        rarr: 8594,
        darr: 8595,
        harr: 8596,
        crarr: 8629,
        lArr: 8656,
        uArr: 8657,
        rArr: 8658,
        dArr: 8659,
        hArr: 8660,
        forall: 8704,
        part: 8706,
        exist: 8707,
        empty: 8709,
        nabla: 8711,
        isin: 8712,
        notin: 8713,
        ni: 8715,
        prod: 8719,
        sum: 8721,
        minus: 8722,
        lowast: 8727,
        radic: 8730,
        prop: 8733,
        infin: 8734,
        ang: 8736,
        and: 8743,
        or: 8744,
        cap: 8745,
        cup: 8746,
        int: 8747,
        there4: 8756,
        sim: 8764,
        cong: 8773,
        asymp: 8776,
        ne: 8800,
        equiv: 8801,
        le: 8804,
        ge: 8805,
        sub: 8834,
        sup: 8835,
        nsub: 8836,
        sube: 8838,
        supe: 8839,
        oplus: 8853,
        otimes: 8855,
        perp: 8869,
        sdot: 8901,
        lceil: 8968,
        rceil: 8969,
        lfloor: 8970,
        rfloor: 8971,
        lang: 9001,
        rang: 9002,
        loz: 9674,
        spades: 9824,
        clubs: 9827,
        hearts: 9829,
        diams: 9830
      }, Object.keys(n.ENTITIES).forEach(function(F) {
        var o = n.ENTITIES[F], h = typeof o == "number" ? String.fromCharCode(o) : o;
        n.ENTITIES[F] = h;
      });
      for (var tA in n.STATE)
        n.STATE[n.STATE[tA]] = tA;
      k = n.STATE;
      function lA(F, o, h) {
        F[o] && F[o](h);
      }
      function uA(F) {
        var o = F && F.match(/(?:^|\s)encoding\s*=\s*(['"])([^'"]+)\1/i);
        return o ? o[2] : null;
      }
      function w(F) {
        return F ? F.toLowerCase().replace(/[^a-z0-9]/g, "") : null;
      }
      function v(F, o) {
        const h = w(F), _ = w(o);
        return !h || !_ ? !0 : _ === "utf16" ? h === "utf16le" || h === "utf16be" : h === _;
      }
      function RA(F, o) {
        if (!(!F.strict || !F.encoding || !o || o.name !== "xml")) {
          var h = uA(o.body);
          h && !v(F.encoding, h) && WA(
            F,
            "XML declaration encoding " + h + " does not match detected stream encoding " + F.encoding.toUpperCase()
          );
        }
      }
      function DA(F, o, h) {
        F.textNode && $(F), lA(F, o, h);
      }
      function $(F) {
        F.textNode = cA(F.opt, F.textNode), F.textNode && lA(F, "ontext", F.textNode), F.textNode = "";
      }
      function cA(F, o) {
        return F.trim && (o = o.trim()), F.normalize && (o = o.replace(/\s+/g, " ")), o;
      }
      function $A(F, o) {
        return $(F), F.trackPosition && (o += `
Line: ` + F.line + `
Column: ` + F.column + `
Char: ` + F.c), o = new Error(o), F.error = o, lA(F, "onerror", o), F;
      }
      function kA(F) {
        return F.sawRoot && !F.closedRoot && WA(F, "Unclosed root tag"), F.state !== k.BEGIN && F.state !== k.BEGIN_WHITESPACE && F.state !== k.TEXT && $A(F, "Unexpected end"), $(F), F.c = "", F.closed = !0, lA(F, "onend"), E.call(F, F.strict, F.opt), F;
      }
      function WA(F, o) {
        if (typeof F != "object" || !(F instanceof E))
          throw new Error("bad call to strictFail");
        F.strict && $A(F, o);
      }
      function EA(F) {
        F.strict || (F.tagName = F.tagName[F.looseCase]());
        var o = F.tags[F.tags.length - 1] || F, h = F.tag = { name: F.tagName, attributes: {} };
        F.opt.xmlns && (h.ns = o.ns), F.attribList.length = 0, DA(F, "onopentagstart", h);
      }
      function zA(F, o) {
        var h = F.indexOf(":"), _ = h < 0 ? ["", F] : F.split(":"), oA = _[0], p = _[1];
        return o && F === "xmlns" && (oA = "xmlns", p = ""), { prefix: oA, local: p };
      }
      function OA(F) {
        if (F.strict || (F.attribName = F.attribName[F.looseCase]()), F.attribList.indexOf(F.attribName) !== -1 || F.tag.attributes.hasOwnProperty(F.attribName)) {
          F.attribName = F.attribValue = "";
          return;
        }
        if (F.opt.xmlns) {
          var o = zA(F.attribName, !0), h = o.prefix, _ = o.local;
          if (h === "xmlns")
            if (_ === "xml" && F.attribValue !== P)
              WA(
                F,
                "xml: prefix must be bound to " + P + `
Actual: ` + F.attribValue
              );
            else if (_ === "xmlns" && F.attribValue !== D)
              WA(
                F,
                "xmlns: prefix must be bound to " + D + `
Actual: ` + F.attribValue
              );
            else {
              var oA = F.tag, p = F.tags[F.tags.length - 1] || F;
              oA.ns === p.ns && (oA.ns = Object.create(p.ns)), oA.ns[_] = F.attribValue;
            }
          F.attribList.push([F.attribName, F.attribValue]);
        } else
          F.tag.attributes[F.attribName] = F.attribValue, DA(F, "onattribute", {
            name: F.attribName,
            value: F.attribValue
          });
        F.attribName = F.attribValue = "";
      }
      function xA(F, o) {
        if (F.opt.xmlns) {
          var h = F.tag, _ = zA(F.tagName);
          h.prefix = _.prefix, h.local = _.local, h.uri = h.ns[_.prefix] || "", h.prefix && !h.uri && (WA(
            F,
            "Unbound namespace prefix: " + JSON.stringify(F.tagName)
          ), h.uri = _.prefix);
          var oA = F.tags[F.tags.length - 1] || F;
          h.ns && oA.ns !== h.ns && Object.keys(h.ns).forEach(function(KA) {
            DA(F, "onopennamespace", {
              prefix: KA,
              uri: h.ns[KA]
            });
          });
          for (var p = 0, rA = F.attribList.length; p < rA; p++) {
            var QA = F.attribList[p], bA = QA[0], y = QA[1], M = zA(bA, !0), FA = M.prefix, dA = M.local, he = FA === "" ? "" : h.ns[FA] || "", ie = {
              name: bA,
              value: y,
              prefix: FA,
              local: dA,
              uri: he
            };
            FA && FA !== "xmlns" && !he && (WA(
              F,
              "Unbound namespace prefix: " + JSON.stringify(FA)
            ), ie.uri = FA), F.tag.attributes[bA] = ie, DA(F, "onattribute", ie);
          }
          F.attribList.length = 0;
        }
        F.tag.isSelfClosing = !!o, F.sawRoot = !0, F.tags.push(F.tag), DA(F, "onopentag", F.tag), o || (!F.noscript && F.tagName.toLowerCase() === "script" ? F.state = k.SCRIPT : F.state = k.TEXT, F.tag = null, F.tagName = ""), F.attribName = F.attribValue = "", F.attribList.length = 0;
      }
      function LA(F) {
        if (!F.tagName) {
          WA(F, "Weird empty close tag."), F.textNode += "</>", F.state = k.TEXT;
          return;
        }
        if (F.script) {
          if (F.tagName !== "script") {
            F.script += "</" + F.tagName + ">", F.tagName = "", F.state = k.SCRIPT;
            return;
          }
          DA(F, "onscript", F.script), F.script = "";
        }
        var o = F.tags.length, h = F.tagName;
        F.strict || (h = h[F.looseCase]());
        for (var _ = h; o--; ) {
          var oA = F.tags[o];
          if (oA.name !== _)
            WA(F, "Unexpected close tag");
          else
            break;
        }
        if (o < 0) {
          WA(F, "Unmatched closing tag: " + F.tagName), F.textNode += "</" + F.tagName + ">", F.state = k.TEXT;
          return;
        }
        F.tagName = h;
        for (var p = F.tags.length; p-- > o; ) {
          var rA = F.tag = F.tags.pop();
          F.tagName = F.tag.name, DA(F, "onclosetag", F.tagName);
          var QA = {};
          for (var bA in rA.ns)
            QA[bA] = rA.ns[bA];
          var y = F.tags[F.tags.length - 1] || F;
          F.opt.xmlns && rA.ns !== y.ns && Object.keys(rA.ns).forEach(function(M) {
            var FA = rA.ns[M];
            DA(F, "onclosenamespace", { prefix: M, uri: FA });
          });
        }
        o === 0 && (F.closedRoot = !0), F.tagName = F.attribValue = F.attribName = "", F.attribList.length = 0, F.state = k.TEXT;
      }
      function yA(F) {
        var o = F.entity, h = o.toLowerCase(), _, oA = "";
        return F.ENTITIES[o] ? F.ENTITIES[o] : F.ENTITIES[h] ? F.ENTITIES[h] : (o = h, o.charAt(0) === "#" && (o.charAt(1) === "x" ? (o = o.slice(2), _ = parseInt(o, 16), oA = _.toString(16)) : (o = o.slice(1), _ = parseInt(o, 10), oA = _.toString(10))), o = o.replace(/^0+/, ""), isNaN(_) || oA.toLowerCase() !== o || _ < 0 || _ > 1114111 ? (WA(F, "Invalid character entity"), "&" + F.entity + ";") : String.fromCodePoint(_));
      }
      function TA(F, o) {
        o === "<" ? (F.state = k.OPEN_WAKA, F.startTagPosition = F.position) : T(o) || (WA(F, "Non-whitespace before first tag."), F.textNode = o, F.state = k.TEXT);
      }
      function fA(F, o) {
        var h = "";
        return o < F.length && (h = F.charAt(o)), h;
      }
      function sA(F) {
        var o = this;
        if (this.error)
          throw this.error;
        if (o.closed)
          return $A(
            o,
            "Cannot write after close. Assign an onready handler."
          );
        if (F === null)
          return kA(o);
        typeof F == "object" && (F = F.toString());
        for (var h = 0, _ = ""; _ = fA(F, h++), o.c = _, !!_; )
          switch (o.trackPosition && (o.position++, _ === `
` ? (o.line++, o.column = 0) : o.column++), o.state) {
            case k.BEGIN:
              if (o.state = k.BEGIN_WHITESPACE, _ === "\uFEFF")
                continue;
              TA(o, _);
              continue;
            case k.BEGIN_WHITESPACE:
              TA(o, _);
              continue;
            case k.TEXT:
              if (o.sawRoot && !o.closedRoot) {
                for (var p = h - 1; _ && _ !== "<" && _ !== "&"; )
                  _ = fA(F, h++), _ && o.trackPosition && (o.position++, _ === `
` ? (o.line++, o.column = 0) : o.column++);
                o.textNode += F.substring(p, h - 1);
              }
              _ === "<" && !(o.sawRoot && o.closedRoot && !o.strict) ? (o.state = k.OPEN_WAKA, o.startTagPosition = o.position) : (!T(_) && (!o.sawRoot || o.closedRoot) && WA(o, "Text data outside of root node."), _ === "&" ? o.state = k.TEXT_ENTITY : o.textNode += _);
              continue;
            case k.SCRIPT:
              _ === "<" ? o.state = k.SCRIPT_ENDING : o.script += _;
              continue;
            case k.SCRIPT_ENDING:
              _ === "/" ? o.state = k.CLOSE_TAG : (o.script += "<" + _, o.state = k.SCRIPT);
              continue;
            case k.OPEN_WAKA:
              if (_ === "!")
                o.state = k.SGML_DECL, o.sgmlDecl = "";
              else if (!T(_)) if (CA(q, _))
                o.state = k.OPEN_TAG, o.tagName = _;
              else if (_ === "/")
                o.state = k.CLOSE_TAG, o.tagName = "";
              else if (_ === "?")
                o.state = k.PROC_INST, o.procInstName = o.procInstBody = "";
              else {
                if (WA(o, "Unencoded <"), o.startTagPosition + 1 < o.position) {
                  var oA = o.position - o.startTagPosition;
                  _ = new Array(oA).join(" ") + _;
                }
                o.textNode += "<" + _, o.state = k.TEXT;
              }
              continue;
            case k.SGML_DECL:
              if (o.sgmlDecl + _ === "--") {
                o.state = k.COMMENT, o.comment = "", o.sgmlDecl = "";
                continue;
              }
              o.doctype && o.doctype !== !0 && o.sgmlDecl ? (o.state = k.DOCTYPE_DTD, o.doctype += "<!" + o.sgmlDecl + _, o.sgmlDecl = "") : (o.sgmlDecl + _).toUpperCase() === x ? (DA(o, "onopencdata"), o.state = k.CDATA, o.sgmlDecl = "", o.cdata = "") : (o.sgmlDecl + _).toUpperCase() === U ? (o.state = k.DOCTYPE, (o.doctype || o.sawRoot) && WA(
                o,
                "Inappropriately located doctype declaration"
              ), o.doctype = "", o.sgmlDecl = "") : _ === ">" ? (DA(o, "onsgmldeclaration", o.sgmlDecl), o.sgmlDecl = "", o.state = k.TEXT) : (H(_) && (o.state = k.SGML_DECL_QUOTED), o.sgmlDecl += _);
              continue;
            case k.SGML_DECL_QUOTED:
              _ === o.q && (o.state = k.SGML_DECL, o.q = ""), o.sgmlDecl += _;
              continue;
            case k.DOCTYPE:
              _ === ">" ? (o.state = k.TEXT, DA(o, "ondoctype", o.doctype), o.doctype = !0) : (o.doctype += _, _ === "[" ? o.state = k.DOCTYPE_DTD : H(_) && (o.state = k.DOCTYPE_QUOTED, o.q = _));
              continue;
            case k.DOCTYPE_QUOTED:
              o.doctype += _, _ === o.q && (o.q = "", o.state = k.DOCTYPE);
              continue;
            case k.DOCTYPE_DTD:
              _ === "]" ? (o.doctype += _, o.state = k.DOCTYPE) : _ === "<" ? (o.state = k.OPEN_WAKA, o.startTagPosition = o.position) : H(_) ? (o.doctype += _, o.state = k.DOCTYPE_DTD_QUOTED, o.q = _) : o.doctype += _;
              continue;
            case k.DOCTYPE_DTD_QUOTED:
              o.doctype += _, _ === o.q && (o.state = k.DOCTYPE_DTD, o.q = "");
              continue;
            case k.COMMENT:
              _ === "-" ? o.state = k.COMMENT_ENDING : o.comment += _;
              continue;
            case k.COMMENT_ENDING:
              _ === "-" ? (o.state = k.COMMENT_ENDED, o.comment = cA(o.opt, o.comment), o.comment && DA(o, "oncomment", o.comment), o.comment = "") : (o.comment += "-" + _, o.state = k.COMMENT);
              continue;
            case k.COMMENT_ENDED:
              _ !== ">" ? (WA(o, "Malformed comment"), o.comment += "--" + _, o.state = k.COMMENT) : o.doctype && o.doctype !== !0 ? o.state = k.DOCTYPE_DTD : o.state = k.TEXT;
              continue;
            case k.CDATA:
              for (var p = h - 1; _ && _ !== "]"; )
                _ = fA(F, h++), _ && o.trackPosition && (o.position++, _ === `
` ? (o.line++, o.column = 0) : o.column++);
              o.cdata += F.substring(p, h - 1), _ === "]" && (o.state = k.CDATA_ENDING);
              continue;
            case k.CDATA_ENDING:
              _ === "]" ? o.state = k.CDATA_ENDING_2 : (o.cdata += "]" + _, o.state = k.CDATA);
              continue;
            case k.CDATA_ENDING_2:
              _ === ">" ? (o.cdata && DA(o, "oncdata", o.cdata), DA(o, "onclosecdata"), o.cdata = "", o.state = k.TEXT) : _ === "]" ? o.cdata += "]" : (o.cdata += "]]" + _, o.state = k.CDATA);
              continue;
            case k.PROC_INST:
              _ === "?" ? o.state = k.PROC_INST_ENDING : T(_) ? o.state = k.PROC_INST_BODY : o.procInstName += _;
              continue;
            case k.PROC_INST_BODY:
              if (!o.procInstBody && T(_))
                continue;
              _ === "?" ? o.state = k.PROC_INST_ENDING : o.procInstBody += _;
              continue;
            case k.PROC_INST_ENDING:
              if (_ === ">") {
                const y = {
                  name: o.procInstName,
                  body: o.procInstBody
                };
                RA(o, y), DA(o, "onprocessinginstruction", y), o.procInstName = o.procInstBody = "", o.state = k.TEXT;
              } else
                o.procInstBody += "?" + _, o.state = k.PROC_INST_BODY;
              continue;
            case k.OPEN_TAG:
              CA(AA, _) ? o.tagName += _ : (EA(o), _ === ">" ? xA(o) : _ === "/" ? o.state = k.OPEN_TAG_SLASH : (T(_) || WA(o, "Invalid character in tag name"), o.state = k.ATTRIB));
              continue;
            case k.OPEN_TAG_SLASH:
              _ === ">" ? (xA(o, !0), LA(o)) : (WA(
                o,
                "Forward-slash in opening tag not followed by >"
              ), o.state = k.ATTRIB);
              continue;
            case k.ATTRIB:
              if (T(_))
                continue;
              _ === ">" ? xA(o) : _ === "/" ? o.state = k.OPEN_TAG_SLASH : CA(q, _) ? (o.attribName = _, o.attribValue = "", o.state = k.ATTRIB_NAME) : WA(o, "Invalid attribute name");
              continue;
            case k.ATTRIB_NAME:
              _ === "=" ? o.state = k.ATTRIB_VALUE : _ === ">" ? (WA(o, "Attribute without value"), o.attribValue = o.attribName, OA(o), xA(o)) : T(_) ? o.state = k.ATTRIB_NAME_SAW_WHITE : CA(AA, _) ? o.attribName += _ : WA(o, "Invalid attribute name");
              continue;
            case k.ATTRIB_NAME_SAW_WHITE:
              if (_ === "=")
                o.state = k.ATTRIB_VALUE;
              else {
                if (T(_))
                  continue;
                WA(o, "Attribute without value"), o.tag.attributes[o.attribName] = "", o.attribValue = "", DA(o, "onattribute", {
                  name: o.attribName,
                  value: ""
                }), o.attribName = "", _ === ">" ? xA(o) : CA(q, _) ? (o.attribName = _, o.state = k.ATTRIB_NAME) : (WA(o, "Invalid attribute name"), o.state = k.ATTRIB);
              }
              continue;
            case k.ATTRIB_VALUE:
              if (T(_))
                continue;
              H(_) ? (o.q = _, o.state = k.ATTRIB_VALUE_QUOTED) : (o.opt.unquotedAttributeValues || $A(o, "Unquoted attribute value"), o.state = k.ATTRIB_VALUE_UNQUOTED, o.attribValue = _);
              continue;
            case k.ATTRIB_VALUE_QUOTED:
              if (_ !== o.q) {
                _ === "&" ? o.state = k.ATTRIB_VALUE_ENTITY_Q : o.attribValue += _;
                continue;
              }
              OA(o), o.q = "", o.state = k.ATTRIB_VALUE_CLOSED;
              continue;
            case k.ATTRIB_VALUE_CLOSED:
              T(_) ? o.state = k.ATTRIB : _ === ">" ? xA(o) : _ === "/" ? o.state = k.OPEN_TAG_SLASH : CA(q, _) ? (WA(o, "No whitespace between attributes"), o.attribName = _, o.attribValue = "", o.state = k.ATTRIB_NAME) : WA(o, "Invalid attribute name");
              continue;
            case k.ATTRIB_VALUE_UNQUOTED:
              if (!eA(_)) {
                _ === "&" ? o.state = k.ATTRIB_VALUE_ENTITY_U : o.attribValue += _;
                continue;
              }
              OA(o), _ === ">" ? xA(o) : o.state = k.ATTRIB;
              continue;
            case k.CLOSE_TAG:
              if (o.tagName)
                _ === ">" ? LA(o) : CA(AA, _) ? o.tagName += _ : o.script ? (o.script += "</" + o.tagName + _, o.tagName = "", o.state = k.SCRIPT) : (T(_) || WA(o, "Invalid tagname in closing tag"), o.state = k.CLOSE_TAG_SAW_WHITE);
              else {
                if (T(_))
                  continue;
                IA(q, _) ? o.script ? (o.script += "</" + _, o.state = k.SCRIPT) : WA(o, "Invalid tagname in closing tag.") : o.tagName = _;
              }
              continue;
            case k.CLOSE_TAG_SAW_WHITE:
              if (T(_))
                continue;
              _ === ">" ? LA(o) : WA(o, "Invalid characters in closing tag");
              continue;
            case k.TEXT_ENTITY:
            case k.ATTRIB_VALUE_ENTITY_Q:
            case k.ATTRIB_VALUE_ENTITY_U:
              var rA, QA;
              switch (o.state) {
                case k.TEXT_ENTITY:
                  rA = k.TEXT, QA = "textNode";
                  break;
                case k.ATTRIB_VALUE_ENTITY_Q:
                  rA = k.ATTRIB_VALUE_QUOTED, QA = "attribValue";
                  break;
                case k.ATTRIB_VALUE_ENTITY_U:
                  rA = k.ATTRIB_VALUE_UNQUOTED, QA = "attribValue";
                  break;
              }
              if (_ === ";") {
                var bA = yA(o);
                o.opt.unparsedEntities && !Object.values(n.XML_ENTITIES).includes(bA) ? ((o.entityCount += 1) > o.opt.maxEntityCount && $A(
                  o,
                  "Parsed entity count exceeds max entity count"
                ), (o.entityDepth += 1) > o.opt.maxEntityDepth && $A(
                  o,
                  "Parsed entity depth exceeds max entity depth"
                ), o.entity = "", o.state = rA, o.write(bA), o.entityDepth -= 1) : (o[QA] += bA, o.entity = "", o.state = rA);
              } else CA(o.entity.length ? z : K, _) ? o.entity += _ : (WA(o, "Invalid character in entity name"), o[QA] += "&" + o.entity + _, o.entity = "", o.state = rA);
              continue;
            default:
              throw new Error(o, "Unknown state: " + o.state);
          }
        return o.position >= o.bufferCheckPosition && Y(o), o;
      }
      /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
      String.fromCodePoint || (function() {
        var F = String.fromCharCode, o = Math.floor, h = function() {
          var _ = 16384, oA = [], p, rA, QA = -1, bA = arguments.length;
          if (!bA)
            return "";
          for (var y = ""; ++QA < bA; ) {
            var M = Number(arguments[QA]);
            if (!isFinite(M) || // `NaN`, `+Infinity`, or `-Infinity`
            M < 0 || // not a valid Unicode code point
            M > 1114111 || // not a valid Unicode code point
            o(M) !== M)
              throw RangeError("Invalid code point: " + M);
            M <= 65535 ? oA.push(M) : (M -= 65536, p = (M >> 10) + 55296, rA = M % 1024 + 56320, oA.push(p, rA)), (QA + 1 === bA || oA.length > _) && (y += F.apply(null, oA), oA.length = 0);
          }
          return y;
        };
        Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
          value: h,
          configurable: !0,
          writable: !0
        }) : String.fromCodePoint = h;
      })();
    })(e);
  })(Ma)), Ma;
}
var Da, MB;
function La() {
  return MB || (MB = 1, Da = {
    isArray: function(e) {
      return Array.isArray ? Array.isArray(e) : Object.prototype.toString.call(e) === "[object Array]";
    }
  }), Da;
}
var da, DB;
function ka() {
  if (DB) return da;
  DB = 1;
  var e = La().isArray;
  return da = {
    copyOptions: function(n) {
      var c, E = {};
      for (c in n)
        n.hasOwnProperty(c) && (E[c] = n[c]);
      return E;
    },
    ensureFlagExists: function(n, c) {
      (!(n in c) || typeof c[n] != "boolean") && (c[n] = !1);
    },
    ensureSpacesExists: function(n) {
      (!("spaces" in n) || typeof n.spaces != "number" && typeof n.spaces != "string") && (n.spaces = 0);
    },
    ensureAlwaysArrayExists: function(n) {
      (!("alwaysArray" in n) || typeof n.alwaysArray != "boolean" && !e(n.alwaysArray)) && (n.alwaysArray = !1);
    },
    ensureKeyExists: function(n, c) {
      (!(n + "Key" in c) || typeof c[n + "Key"] != "string") && (c[n + "Key"] = c.compact ? "_" + n : n);
    },
    checkFnExists: function(n, c) {
      return n + "Fn" in c;
    }
  }, da;
}
var Ia, dB;
function GB() {
  if (dB) return Ia;
  dB = 1;
  var e = Gw(), n = ka(), c = La().isArray, E, Y;
  function X(q) {
    return E = n.copyOptions(q), n.ensureFlagExists("ignoreDeclaration", E), n.ensureFlagExists("ignoreInstruction", E), n.ensureFlagExists("ignoreAttributes", E), n.ensureFlagExists("ignoreText", E), n.ensureFlagExists("ignoreComment", E), n.ensureFlagExists("ignoreCdata", E), n.ensureFlagExists("ignoreDoctype", E), n.ensureFlagExists("compact", E), n.ensureFlagExists("alwaysChildren", E), n.ensureFlagExists("addParent", E), n.ensureFlagExists("trim", E), n.ensureFlagExists("nativeType", E), n.ensureFlagExists("nativeTypeAttributes", E), n.ensureFlagExists("sanitize", E), n.ensureFlagExists("instructionHasAttributes", E), n.ensureFlagExists("captureSpacesBetweenElements", E), n.ensureAlwaysArrayExists(E), n.ensureKeyExists("declaration", E), n.ensureKeyExists("instruction", E), n.ensureKeyExists("attributes", E), n.ensureKeyExists("text", E), n.ensureKeyExists("comment", E), n.ensureKeyExists("cdata", E), n.ensureKeyExists("doctype", E), n.ensureKeyExists("type", E), n.ensureKeyExists("name", E), n.ensureKeyExists("elements", E), n.ensureKeyExists("parent", E), n.checkFnExists("doctype", E), n.checkFnExists("instruction", E), n.checkFnExists("cdata", E), n.checkFnExists("comment", E), n.checkFnExists("text", E), n.checkFnExists("instructionName", E), n.checkFnExists("elementName", E), n.checkFnExists("attributeName", E), n.checkFnExists("attributeValue", E), n.checkFnExists("attributes", E), E;
  }
  function Q(q) {
    var AA = Number(q);
    if (!isNaN(AA))
      return AA;
    var K = q.toLowerCase();
    return K === "true" ? !0 : K === "false" ? !1 : q;
  }
  function B(q, AA) {
    var K;
    if (E.compact) {
      if (!Y[E[q + "Key"]] && (c(E.alwaysArray) ? E.alwaysArray.indexOf(E[q + "Key"]) !== -1 : E.alwaysArray) && (Y[E[q + "Key"]] = []), Y[E[q + "Key"]] && !c(Y[E[q + "Key"]]) && (Y[E[q + "Key"]] = [Y[E[q + "Key"]]]), q + "Fn" in E && typeof AA == "string" && (AA = E[q + "Fn"](AA, Y)), q === "instruction" && ("instructionFn" in E || "instructionNameFn" in E)) {
        for (K in AA)
          if (AA.hasOwnProperty(K))
            if ("instructionFn" in E)
              AA[K] = E.instructionFn(AA[K], K, Y);
            else {
              var z = AA[K];
              delete AA[K], AA[E.instructionNameFn(K, z, Y)] = z;
            }
      }
      c(Y[E[q + "Key"]]) ? Y[E[q + "Key"]].push(AA) : Y[E[q + "Key"]] = AA;
    } else {
      Y[E.elementsKey] || (Y[E.elementsKey] = []);
      var T = {};
      if (T[E.typeKey] = q, q === "instruction") {
        for (K in AA)
          if (AA.hasOwnProperty(K))
            break;
        T[E.nameKey] = "instructionNameFn" in E ? E.instructionNameFn(K, AA, Y) : K, E.instructionHasAttributes ? (T[E.attributesKey] = AA[K][E.attributesKey], "instructionFn" in E && (T[E.attributesKey] = E.instructionFn(T[E.attributesKey], K, Y))) : ("instructionFn" in E && (AA[K] = E.instructionFn(AA[K], K, Y)), T[E.instructionKey] = AA[K]);
      } else
        q + "Fn" in E && (AA = E[q + "Fn"](AA, Y)), T[E[q + "Key"]] = AA;
      E.addParent && (T[E.parentKey] = Y), Y[E.elementsKey].push(T);
    }
  }
  function r(q) {
    if ("attributesFn" in E && q && (q = E.attributesFn(q, Y)), (E.trim || "attributeValueFn" in E || "attributeNameFn" in E || E.nativeTypeAttributes) && q) {
      var AA;
      for (AA in q)
        if (q.hasOwnProperty(AA) && (E.trim && (q[AA] = q[AA].trim()), E.nativeTypeAttributes && (q[AA] = Q(q[AA])), "attributeValueFn" in E && (q[AA] = E.attributeValueFn(q[AA], AA, Y)), "attributeNameFn" in E)) {
          var K = q[AA];
          delete q[AA], q[E.attributeNameFn(AA, q[AA], Y)] = K;
        }
    }
    return q;
  }
  function A(q) {
    var AA = {};
    if (q.body && (q.name.toLowerCase() === "xml" || E.instructionHasAttributes)) {
      for (var K = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g, z; (z = K.exec(q.body)) !== null; )
        AA[z[1]] = z[2] || z[3] || z[4];
      AA = r(AA);
    }
    if (q.name.toLowerCase() === "xml") {
      if (E.ignoreDeclaration)
        return;
      Y[E.declarationKey] = {}, Object.keys(AA).length && (Y[E.declarationKey][E.attributesKey] = AA), E.addParent && (Y[E.declarationKey][E.parentKey] = Y);
    } else {
      if (E.ignoreInstruction)
        return;
      E.trim && (q.body = q.body.trim());
      var T = {};
      E.instructionHasAttributes && Object.keys(AA).length ? (T[q.name] = {}, T[q.name][E.attributesKey] = AA) : T[q.name] = q.body, B("instruction", T);
    }
  }
  function a(q, AA) {
    var K;
    if (typeof q == "object" && (AA = q.attributes, q = q.name), AA = r(AA), "elementNameFn" in E && (q = E.elementNameFn(q, Y)), E.compact) {
      if (K = {}, !E.ignoreAttributes && AA && Object.keys(AA).length) {
        K[E.attributesKey] = {};
        var z;
        for (z in AA)
          AA.hasOwnProperty(z) && (K[E.attributesKey][z] = AA[z]);
      }
      !(q in Y) && (c(E.alwaysArray) ? E.alwaysArray.indexOf(q) !== -1 : E.alwaysArray) && (Y[q] = []), Y[q] && !c(Y[q]) && (Y[q] = [Y[q]]), c(Y[q]) ? Y[q].push(K) : Y[q] = K;
    } else
      Y[E.elementsKey] || (Y[E.elementsKey] = []), K = {}, K[E.typeKey] = "element", K[E.nameKey] = q, !E.ignoreAttributes && AA && Object.keys(AA).length && (K[E.attributesKey] = AA), E.alwaysChildren && (K[E.elementsKey] = []), Y[E.elementsKey].push(K);
    K[E.parentKey] = Y, Y = K;
  }
  function d(q) {
    E.ignoreText || !q.trim() && !E.captureSpacesBetweenElements || (E.trim && (q = q.trim()), E.nativeType && (q = Q(q)), E.sanitize && (q = q.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")), B("text", q));
  }
  function x(q) {
    E.ignoreComment || (E.trim && (q = q.trim()), B("comment", q));
  }
  function U(q) {
    var AA = Y[E.parentKey];
    E.addParent || delete Y[E.parentKey], Y = AA;
  }
  function P(q) {
    E.ignoreCdata || (E.trim && (q = q.trim()), B("cdata", q));
  }
  function D(q) {
    E.ignoreDoctype || (q = q.replace(/^ /, ""), E.trim && (q = q.trim()), B("doctype", q));
  }
  function J(q) {
    q.note = q;
  }
  return Ia = function(q, AA) {
    var K = e.parser(!0, {}), z = {};
    if (Y = z, E = X(AA), K.opt = { strictEntities: !0 }, K.onopentag = a, K.ontext = d, K.oncomment = x, K.onclosetag = U, K.onerror = J, K.oncdata = P, K.ondoctype = D, K.onprocessinginstruction = A, K.write(q).close(), z[E.elementsKey]) {
      var T = z[E.elementsKey];
      delete z[E.elementsKey], z[E.elementsKey] = T, delete z.text;
    }
    return z;
  }, Ia;
}
var ya, IB;
function Hw() {
  if (IB) return ya;
  IB = 1;
  var e = ka(), n = GB();
  function c(E) {
    var Y = e.copyOptions(E);
    return e.ensureSpacesExists(Y), Y;
  }
  return ya = function(E, Y) {
    var X, Q, B, r;
    return X = c(Y), Q = n(E, X), r = "compact" in X && X.compact ? "_parent" : "parent", "addParent" in X && X.addParent ? B = JSON.stringify(Q, function(A, a) {
      return A === r ? "_" : a;
    }, X.spaces) : B = JSON.stringify(Q, null, X.spaces), B.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }, ya;
}
var Fa, yB;
function HB() {
  if (yB) return Fa;
  yB = 1;
  var e = ka(), n = La().isArray, c, E;
  function Y(K) {
    var z = e.copyOptions(K);
    return e.ensureFlagExists("ignoreDeclaration", z), e.ensureFlagExists("ignoreInstruction", z), e.ensureFlagExists("ignoreAttributes", z), e.ensureFlagExists("ignoreText", z), e.ensureFlagExists("ignoreComment", z), e.ensureFlagExists("ignoreCdata", z), e.ensureFlagExists("ignoreDoctype", z), e.ensureFlagExists("compact", z), e.ensureFlagExists("indentText", z), e.ensureFlagExists("indentCdata", z), e.ensureFlagExists("indentAttributes", z), e.ensureFlagExists("indentInstruction", z), e.ensureFlagExists("fullTagEmptyElement", z), e.ensureFlagExists("noQuotesForNativeAttributes", z), e.ensureSpacesExists(z), typeof z.spaces == "number" && (z.spaces = Array(z.spaces + 1).join(" ")), e.ensureKeyExists("declaration", z), e.ensureKeyExists("instruction", z), e.ensureKeyExists("attributes", z), e.ensureKeyExists("text", z), e.ensureKeyExists("comment", z), e.ensureKeyExists("cdata", z), e.ensureKeyExists("doctype", z), e.ensureKeyExists("type", z), e.ensureKeyExists("name", z), e.ensureKeyExists("elements", z), e.checkFnExists("doctype", z), e.checkFnExists("instruction", z), e.checkFnExists("cdata", z), e.checkFnExists("comment", z), e.checkFnExists("text", z), e.checkFnExists("instructionName", z), e.checkFnExists("elementName", z), e.checkFnExists("attributeName", z), e.checkFnExists("attributeValue", z), e.checkFnExists("attributes", z), e.checkFnExists("fullTagEmptyElement", z), z;
  }
  function X(K, z, T) {
    return (!T && K.spaces ? `
` : "") + Array(z + 1).join(K.spaces);
  }
  function Q(K, z, T) {
    if (z.ignoreAttributes)
      return "";
    "attributesFn" in z && (K = z.attributesFn(K, E, c));
    var H, eA, CA, IA, k = [];
    for (H in K)
      K.hasOwnProperty(H) && K[H] !== null && K[H] !== void 0 && (IA = z.noQuotesForNativeAttributes && typeof K[H] != "string" ? "" : '"', eA = "" + K[H], eA = eA.replace(/"/g, "&quot;"), CA = "attributeNameFn" in z ? z.attributeNameFn(H, eA, E, c) : H, k.push(z.spaces && z.indentAttributes ? X(z, T + 1, !1) : " "), k.push(CA + "=" + IA + ("attributeValueFn" in z ? z.attributeValueFn(eA, H, E, c) : eA) + IA));
    return K && Object.keys(K).length && z.spaces && z.indentAttributes && k.push(X(z, T, !1)), k.join("");
  }
  function B(K, z, T) {
    return c = K, E = "xml", z.ignoreDeclaration ? "" : "<?xml" + Q(K[z.attributesKey], z, T) + "?>";
  }
  function r(K, z, T) {
    if (z.ignoreInstruction)
      return "";
    var H;
    for (H in K)
      if (K.hasOwnProperty(H))
        break;
    var eA = "instructionNameFn" in z ? z.instructionNameFn(H, K[H], E, c) : H;
    if (typeof K[H] == "object")
      return c = K, E = eA, "<?" + eA + Q(K[H][z.attributesKey], z, T) + "?>";
    var CA = K[H] ? K[H] : "";
    return "instructionFn" in z && (CA = z.instructionFn(CA, H, E, c)), "<?" + eA + (CA ? " " + CA : "") + "?>";
  }
  function A(K, z) {
    return z.ignoreComment ? "" : "<!--" + ("commentFn" in z ? z.commentFn(K, E, c) : K) + "-->";
  }
  function a(K, z) {
    return z.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in z ? z.cdataFn(K, E, c) : K.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
  }
  function d(K, z) {
    return z.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in z ? z.doctypeFn(K, E, c) : K) + ">";
  }
  function x(K, z) {
    return z.ignoreText ? "" : (K = "" + K, K = K.replace(/&amp;/g, "&"), K = K.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "textFn" in z ? z.textFn(K, E, c) : K);
  }
  function U(K, z) {
    var T;
    if (K.elements && K.elements.length)
      for (T = 0; T < K.elements.length; ++T)
        switch (K.elements[T][z.typeKey]) {
          case "text":
            if (z.indentText)
              return !0;
            break;
          // skip to next key
          case "cdata":
            if (z.indentCdata)
              return !0;
            break;
          // skip to next key
          case "instruction":
            if (z.indentInstruction)
              return !0;
            break;
          // skip to next key
          case "doctype":
          case "comment":
          case "element":
            return !0;
          default:
            return !0;
        }
    return !1;
  }
  function P(K, z, T) {
    c = K, E = K.name;
    var H = [], eA = "elementNameFn" in z ? z.elementNameFn(K.name, K) : K.name;
    H.push("<" + eA), K[z.attributesKey] && H.push(Q(K[z.attributesKey], z, T));
    var CA = K[z.elementsKey] && K[z.elementsKey].length || K[z.attributesKey] && K[z.attributesKey]["xml:space"] === "preserve";
    return CA || ("fullTagEmptyElementFn" in z ? CA = z.fullTagEmptyElementFn(K.name, K) : CA = z.fullTagEmptyElement), CA ? (H.push(">"), K[z.elementsKey] && K[z.elementsKey].length && (H.push(D(K[z.elementsKey], z, T + 1)), c = K, E = K.name), H.push(z.spaces && U(K, z) ? `
` + Array(T + 1).join(z.spaces) : ""), H.push("</" + eA + ">")) : H.push("/>"), H.join("");
  }
  function D(K, z, T, H) {
    return K.reduce(function(eA, CA) {
      var IA = X(z, T, H && !eA);
      switch (CA.type) {
        case "element":
          return eA + IA + P(CA, z, T);
        case "comment":
          return eA + IA + A(CA[z.commentKey], z);
        case "doctype":
          return eA + IA + d(CA[z.doctypeKey], z);
        case "cdata":
          return eA + (z.indentCdata ? IA : "") + a(CA[z.cdataKey], z);
        case "text":
          return eA + (z.indentText ? IA : "") + x(CA[z.textKey], z);
        case "instruction":
          var k = {};
          return k[CA[z.nameKey]] = CA[z.attributesKey] ? CA : CA[z.instructionKey], eA + (z.indentInstruction ? IA : "") + r(k, z, T);
      }
    }, "");
  }
  function J(K, z, T) {
    var H;
    for (H in K)
      if (K.hasOwnProperty(H))
        switch (H) {
          case z.parentKey:
          case z.attributesKey:
            break;
          // skip to next key
          case z.textKey:
            if (z.indentText || T)
              return !0;
            break;
          // skip to next key
          case z.cdataKey:
            if (z.indentCdata || T)
              return !0;
            break;
          // skip to next key
          case z.instructionKey:
            if (z.indentInstruction || T)
              return !0;
            break;
          // skip to next key
          case z.doctypeKey:
          case z.commentKey:
            return !0;
          default:
            return !0;
        }
    return !1;
  }
  function q(K, z, T, H, eA) {
    c = K, E = z;
    var CA = "elementNameFn" in T ? T.elementNameFn(z, K) : z;
    if (typeof K > "u" || K === null || K === "")
      return "fullTagEmptyElementFn" in T && T.fullTagEmptyElementFn(z, K) || T.fullTagEmptyElement ? "<" + CA + "></" + CA + ">" : "<" + CA + "/>";
    var IA = [];
    if (z) {
      if (IA.push("<" + CA), typeof K != "object")
        return IA.push(">" + x(K, T) + "</" + CA + ">"), IA.join("");
      K[T.attributesKey] && IA.push(Q(K[T.attributesKey], T, H));
      var k = J(K, T, !0) || K[T.attributesKey] && K[T.attributesKey]["xml:space"] === "preserve";
      if (k || ("fullTagEmptyElementFn" in T ? k = T.fullTagEmptyElementFn(z, K) : k = T.fullTagEmptyElement), k)
        IA.push(">");
      else
        return IA.push("/>"), IA.join("");
    }
    return IA.push(AA(K, T, H + 1, !1)), c = K, E = z, z && IA.push((eA ? X(T, H, !1) : "") + "</" + CA + ">"), IA.join("");
  }
  function AA(K, z, T, H) {
    var eA, CA, IA, k = [];
    for (CA in K)
      if (K.hasOwnProperty(CA))
        for (IA = n(K[CA]) ? K[CA] : [K[CA]], eA = 0; eA < IA.length; ++eA) {
          switch (CA) {
            case z.declarationKey:
              k.push(B(IA[eA], z, T));
              break;
            case z.instructionKey:
              k.push((z.indentInstruction ? X(z, T, H) : "") + r(IA[eA], z, T));
              break;
            case z.attributesKey:
            case z.parentKey:
              break;
            // skip
            case z.textKey:
              k.push((z.indentText ? X(z, T, H) : "") + x(IA[eA], z));
              break;
            case z.cdataKey:
              k.push((z.indentCdata ? X(z, T, H) : "") + a(IA[eA], z));
              break;
            case z.doctypeKey:
              k.push(X(z, T, H) + d(IA[eA], z));
              break;
            case z.commentKey:
              k.push(X(z, T, H) + A(IA[eA], z));
              break;
            default:
              k.push(X(z, T, H) + q(IA[eA], CA, z, T, J(IA[eA], z)));
          }
          H = H && !k.length;
        }
    return k.join("");
  }
  return Fa = function(K, z) {
    z = Y(z);
    var T = [];
    return c = K, E = "_root_", z.compact ? T.push(AA(K, z, 0, !0)) : (K[z.declarationKey] && T.push(B(K[z.declarationKey], z, 0)), K[z.elementsKey] && K[z.elementsKey].length && T.push(D(K[z.elementsKey], z, 0, !T.length))), T.join("");
  }, Fa;
}
var xa, FB;
function Lw() {
  if (FB) return xa;
  FB = 1;
  var e = HB();
  return xa = function(n, c) {
    n instanceof Buffer && (n = n.toString());
    var E = null;
    if (typeof n == "string")
      try {
        E = JSON.parse(n);
      } catch {
        throw new Error("The JSON structure is invalid");
      }
    else
      E = n;
    return e(E, c);
  }, xa;
}
var pa, xB;
function kw() {
  if (xB) return pa;
  xB = 1;
  var e = GB(), n = Hw(), c = HB(), E = Lw();
  return pa = {
    xml2js: e,
    xml2json: n,
    js2xml: c,
    json2xml: E
  }, pa;
}
var jw = kw();
function pB(e) {
  return e.includes(":") ? e.split(":")[1] : e;
}
function LB(e) {
  return new Promise((n, c) => {
    const E = new FileReader();
    E.onload = function(Y) {
      try {
        const X = Y.target?.result, Q = jw.xml2js(X, {
          compact: !0,
          cdataKey: "_text",
          trim: !0,
          elementNameFn: pB,
          attributeNameFn: pB
        });
        n(Q);
      } catch (X) {
        c(X);
      }
    }, E.readAsText(e);
  });
}
const Ow = /* @__PURE__ */ JSON.parse(`{"additionalInformation":{"additionalDescription":"Dodatkowy opis","additionalInformationLabel":"Dodatkowe informacje","documentDate":"Data dokumentu","documentNumber":"Numer dokumentu","exciseTaxRefund":"- Informacja dodatkowa związana ze zwrotem podatku akcyzowego zawartego w cenie oleju napędowego","fpLabel":"- Faktura, o której mowa w art. 109 ust. 3d ustawy","infoContent":"Treść informacji","informationContent":"Treść informacji","infoType":"Rodzaj informacji","ksefDocumentNumber":"Numer identyfikujący fakturę w KSeF","ordinalNumber":"Lp.","paymentDocuments":"Dokumenty Zapłaty","rowNumber":"Numer wiersza","tpLabel":"- Istniejące powiązania między nabywcą a dokonującym dostawy towarów lub usługodawcą","typeOfInformation":"Rodzaj informacji"},"address":{"apartmentNumber":"Numer lokalu: ","communeName":"Gmina: ","countryName":"Kraj: ","districtName":"Powiat: ","GLN":"GLN: ","houseNumber":"Numer domu: ","postName":"Poczta: ","streetName":"Ulica: ","townName":"Miejscowość: ","voivodeshipName":"Województwo: ","zipCode":"Kod pocztowy: "},"annotations":{"airDelivery":"Dostawa dotyczy statków powietrznych, o których mowa w art. 2 pkt 10 lit. c ustawy","antiques":"przedmioty kolekcjonerskie i antyki","artPieces":"dzieła sztuki","boatDelivery":"Dostawa dotyczy jednostek pływających, o których mowa w art. 2 pkt 10 lit. b ustawy","bodyNumber":"Numer nadwozia","cashMethod":"Metoda kasowa","chassisNumber":"Numer podwozia","description":"Opis","directiveLaw":"Przepis dyrektywy: ","factoryNumber":"Numer fabryczny nowego środka transportu","frameNumber":"Numer ramy","header":"Adnotacje","hullNumber":"Numer kadłuba nowego środka transportu","landDelivery":"Dostawa dotyczy pojazdów lądowych, o których mowa w art. 2 pkt 10 lit. a ustawy","law":"Przepis ustawy albo aktu wydanego na podstawie ustawy: ","marginProcedure":"Procedura marży: ","newTransportsDelivery":"Wewnątrzwspólnotowe dostawy nowych środków transportu","newTransportType":"Typ nowego środka transportu","noTaxBase":"Podstawa zwolnienia od podatku: ","noTaxBaseDocument":"Przepis ustawy albo aktu wydanego na podstawie ustawy, na podstawie którego podatnik stosuje zwolnienie od podatku","noTaxBaseDocument2":"Przepis dyrektywy 2006/112/WE, który zwalnia od podatku taką dostawę towarów lub takie świadczenie usług","noTaxBaseDocument3":"Inna podstawa prawna wskazującą na to, że dostawa towarów lub świadczenie usług korzysta ze zwolnienia","noTaxDelivery":"Dostawa towarów lub świadczenie usług zwolnionych od podatku na podstawie art. 43 ust. 1, art. 113 ust. 1 i 9 albo przepisów wydanych na podstawie art. 82 ust. 3 lub na podstawie innych przepisów","otherLaw":"Inna podstawa prawna: ","partialPayMechanism":"Mechanizm podzielonej płatności","reverseTax":"Odwrotne obciążenie","selfInvoice":"Samofakturowanie","threePartsSimplerMethod":"Procedura trójstronna uproszczona","transportApprovalDate":"Data dopuszczenia nowego środka transportu do użytku","transportBrand":"Marka nowego środka transportu","transportColor":"Kolor nowego środka transportu","transportMileage":"Przebieg pojazdu","transportModel":"Model nowego środka transportu","transportProductionYear":"Rok produkcji nowego środka transportu","transportRegistrationNumber":"Numer rejestracyjny nowego środka transportu","transportType":"Rodzaj pojazdu","travelAgencies":"biura podróży","usedGoods":"towary używane","usePermissionDate":"Data dopuszczenia do użytku","vat22DocumentNotRequired":"Nie istnieje obowiązek wystawienia dokumentu VAT-22","vat22DocumentRequired":"Istnieje obowiązek wystawienia dokumentu VAT-22","vin":"Numer VIN"},"attachment":{"blockHeader":"Nagłówek bloku danych: ","description":"Opis: ","details":"Szczegółowe dane załącznika ({{index}})","header":"Załącznik do Faktury VAT","key":"Klucz","tableLabel":"Tabela","tableSummary":"Podsumowanie tabeli","value":"Wartość"},"authorizedSubject":{"address":"Adres","authorizedSubject":"Podmiot upoważniony","contactData":"Dane kontaktowe","correspondenceAddress":"Adres do korespondencji","correspondenceAddress2":"Adres korespondencyjny","email":"E-mail: ","eori":"Numer EORI: ","noTaxId":"Brak identyfikatora ","otherTaxId":"Identyfikator podatkowy inny: ","phone":"Tel.: ","role":"Rola: "},"carrier":{"carrier":"Przewoźnik","carrierAddress":"Adres przewoźnika"},"correctedInvoice":{"correctInvoiceNumber":"Poprawny numer faktury korygowanej: ","correctionEffectType":"Typ skutku korekty: ","correctionReason":"Przyczyna korekty dla faktur korygujących: ","identificationHeader":"Dane identyfikacyjne faktury korygowanej","identificationHeaderIndexed":"Dane identyfikacyjne faktury korygowanej {{index}}","invoiceNumber":"Numer faktury korygowanej: ","issueDate":"Data wystawienia faktury, której dotyczy faktura korygująca: ","ksefNumber":"Numer KSeF faktury korygowanej: ","sectionHeader":"Dane faktury korygowanej"},"details":{"advanceInvoiceNumbers":"Numery wcześniejszych faktur zaliczkowych","assignKsefNumberDate":"Data nadania numeru KSeF","commonCurrencyRate":"Kurs waluty wspólny dla wszystkich wierszy faktury","costAmount":"Kwota płatności","currencyCode":"Kod waluty: ","currencyRate":"Kurs waluty: ","currencyRate2":"Kurs waluty","deliveryOrServiceDate":"Data dokonania lub zakończenia dostawy towarów lub wykonania usługi: ","deliveryOrServiceDateFrom":"Data dokonania lub zakończenia dostawy towarów lub wykonania usługi: od ","deliveryOrServiceDateTo":"Data dokonania lub zakończenia dostawy towarów lub wykonania usługi: do ","discountPeriod":"Okres, którego dotyczy rabat: ","getDate":"Data dokonania nabycia: ","getMoneyDate":"Data otrzymania zapłaty: ","getMoneyDate2":"Data otrzymania płatności","header":"Szczegóły","invoiceDate":"Data wystawienia faktury","invoiceDateSentToKsef":"Data przesłania do KSeF","invoiceDateShort":"Data wystawienia: ","invoiceNumber":"Numer faktury: ","issueDate":"Data wystawienia, z zastrzeżeniem art. 106na ust. 1 ustawy: ","issuePlace":"Miejsce wystawienia: ","ossProcedure":"Procedura One Stop Shop","paymentReceivedDate":"Data otrzymania zapłaty: ","place":"Miejsce wystawienia: ","to":" do "},"discount":{"all":"Rabat dotyczy wszystkich dostaw towarów i wykonanych usług na rzecz tego nabywcy w danym okresie.","header":"Rabat","lp":"Lp.","notAll":"Rabat nie dotyczy wszystkich dostaw towarów i wykonanych usług na rzecz tego nabywcy w danym okresie.","productName":"Nazwa towaru lub usługi","quantity":"Ilość","totalValue":"Wartość rabatu ogółem: ","unit":"Miara"},"footer":{"generatedIn":"Wytworzona w: ","margin":"marża","pagesTotal":"z","version":"wersja","appName":"Aplikacja Podatnika KSeF"},"header":{"advance":"Faktura zaliczkowa","attachmentWarning":"Uwaga, faktura zawiera załącznik, jednak ze względu na ograniczenia wizualizacji, nie został on uwzględniony w pliku PDF","correctedInvoiceVatRr":"Faktura korygująca VAT RR","correction":"Faktura korygująca","correctionAdvance":"Faktura korygująca zaliczkową","correctionCollective":"Faktura korygująca zbiorcza (rabat)","correctionSettlement":"Faktura korygująca rozliczeniową","invoiceNumberLabel":"Numer Faktury:","ksefNumberLabel":"Numer KSEF:","ksefPart1":"Krajowy System ","ksefPart2":"e","ksefPart3":"-Faktur","primalInvoiceVatRr":"Faktura pierwotna VAT RR","settlement":"Faktura rozliczeniowa","simplified":"Faktura uproszczona","vat":"Faktura podstawowa"},"information":{"header":"Pozostałe informacje","invoiceFooter":"Stopka faktury"},"order":{"additionalInfo":"Dodatkowe informacje","advancePaymentAmount":"Kwota zapłaty (zaliczki) dokumentowana fakturą: ","advancePaymentAmountCorrection":"Korekta kwoty zapłaty (zaliczki) dokumentowana fakturą: ","cn":"CN","currencyRate":"Kurs waluty","exciseTaxAmount":"Kwota podatku akcyzowego","gtin":"GTIN","gtu":"GTU","index":"Indeks","issuedInCurrency":"Faktura wystawiona w walucie {{currency}}","lp":"Lp.","netSalesValue":"Wartość sprzedaży netto","netUnitPrice":"Cena jedn. netto","orderNumber":"Numer umowy / Zamów.","orderValueWithTax":"Wartość zamówienia lub umowy z uwzględnieniem kwoty podatku: ","ossTaxRate":"Stawka podatku OSS","pkob":"PKOB","pkwiu":"PKWiU","procedure":"Procedura","procedureMarkings":"Oznaczenia dotyczące procedur","productMarker":"Znacznik dla towaru lub usługi z zał. nr 15 do ustawy","productName":"Nazwa towaru lub usługi","quantity":"Ilość","receivedAdvance":"Otrzymana kwota zapłaty (zaliczki): ","stateBefore":"Stan przed","taxAmount":"Kwota podatku","taxRate":"Stawka podatku","totalAmountDue":"Kwota należności ogółem: ","uniqueRowNumber":"Unikalny numer wiersza","unit":"Miara"},"payment":{"bankAccountNumber":"Numer rachunku bankowego","conditionalDiscount":"Skonto","description":"Opis: ","discountAmount":"Wysokość skonta: ","discountConditions":"Warunki skonta: ","factorsBankAccountNumber":"Numer rachunku bankowego faktora","farmer":"Rachunek bankowy rolnika","getter":"Rachunek bankowy nabywcy","ksefTransferId":"Identyfikator płatności Krajowego Systemu e-Faktur: ","maturityDate":"Termin płatności","moneylessLink":"Link do płatności bezgotówkowej: ","noPayment":"Brak zapłaty","other":"Inna","otherPaymentDescription":"Opis płatności innej: ","paidAllInParts":"Zapłacono całość w częściach","paidInPart":"Zapłacono w części","paidStatus":"Zapłacono","partialPayment":"Zapłata częściowa","partialPaymentAmount":"Kwota zapłaty częściowej","partialPaymentDate":"Data zapłaty częściowej","payment":"Płatność","paymentDate":"Data zapłaty: ","paymentDescription":"Opis płatności","paymentDifferent":"Płatność inna","paymentInformation":"Informacja o płatności: ","paymentInformationContinued":"Informacja o płatności (kontynuacja): ","paymentMethod":"Forma płatności","paymentMethod2":"Forma płatności: ","paymentMethod3":"Forma zapłaty: ","transfer":"Przelew"},"qr1":{"description":"Nie możesz zeskanować kodu z obrazka? Kliknij w link weryfikacyjny i przejdź do weryfikacji faktury!","header":"Sprawdź, czy Twoja faktura znajduje się w KSeF!","offline":"OFFLINE"},"qr2":{"certificate":"CERTYFIKAT","description":"Nie możesz zeskanować kodu z obrazka? Kliknij w link weryfikacyjny i przejdź do weryfikacji wystawcy faktury!","header":"Zweryfikuj dostawcę faktury"},"registers":{"accountDescription":"Opis rachunku","bankName":"Nazwa banku","bdo":"BDO","billFormat":"'Format rachunku","foreign":"Zagraniczny","fullAccountNumber":"Pełny numer rachunku","fullForeignAccountNumber":"Pełny numer rachunku zagranicznego","fullName":"Pełna nazwa","fullNrbAccountNumber":"Pełny numer rachunku w standardzie NRB","header":"Rejestry","krs":"KRS","ownBankAccount":"Rachunek własny banku","polish":"Polski","regon":"REGON","swiftCode":"Kod SWIFT"},"rows":{"additionalInfo":"Dodatkowe informacje","amount":"Ilość","cn":"CN","costZZP":"Kwota ZZP","currencyRate":"Kurs waluty","deliveryDate":"Data dostawy / wykonania","discount":"Rabat","exciseTaxAmount":"Kwota podatku akcyzowego","farmProductCost":"Wartość nabytych produktów rolnych lub wykonanych usług rolniczych: ","getDate":"Data dokonania nabycia","getOrMakeDate":"Data dostawy / wykonania","grossSalesValue":"Wartość sprzedaży brutto","grossUnitPrice":"Cena jedn. brutto","gtin":"GTIN","gtu":"GTU","header":"Pozycje","index":"Indeks","inWords":"Słownie: ","issuedInCurrency":"Faktura wystawiona w walucie {{currency}}","lp":"Lp.","lumpSumTaxRefund":"Kwota zryczałtowanego zwrotu podatku: ","name":"Nazwa","netSalesValue":"Wartość sprzedaży netto","netUnitPrice":"Cena jedn. netto","ossTaxRate":"Stawka podatku OSS","overallCost":"Kwota należności ogółem: ","pkob":"PKOB","pkwiu":"PKWiU","priceNoZZP":"Wartość bez ZZP","procedure":"Procedura","procedureMarkings":"Oznaczenia dotyczące procedur","productMarker":"Znacznik dla towaru lub usługi z zał. nr 15 do ustawy","productName":"Nazwa towaru lub usługi","qualityDesc":"Opis klasy lub jakości","quantity":"Ilość","remainingAmount":"Kwota pozostała do zapłaty: ","stateBefore":"Stan przed","taxRate":"Stawka podatku","totalAmountDue":"Kwota należności ogółem: ","uniqueRowNumber":"Unikalny numer wiersza","unit":"Miara","unitPrice":"Cena jedn.","valueZZP":"Wartość z ZZP","vatSalesValue":"Wartość sprzedaży vat","wageZZP":"Stawka ZZP"},"settlement":{"chargeReason":"Powód obciążenia","charges":"Obciążenia","deductionReason":"Powód odliczenia","deductions":"Odliczenia","header":"Rozliczenie","toPay":"Do zapłaty: ","toSettle":"Do rozliczenia: ","totalCharges":"Suma kwot obciążenia: ","totalDeductions":"Suma kwot odliczenia: "},"subject1":{"address":"Adres","contactDetails":"Dane kontaktowe","contractorNumber":"Numer kontrahenta: ","correspondenceAddress":"Adres do korespondencji","eoriNumber":"Numer EORI: ","mailingAddress":"Adres do korespondencji","name":"Nazwa: ","nip":"NIP: ","seller":"Sprzedawca","taxpayerStatus":"Status podatnika: ","vatPrefix":"Prefiks VAT: "},"subject1K":{"address":"Adres","contactDetails":"Dane kontaktowe","contractorNumber":"Numer kontrahenta: ","correctedContent":"Treść korygowana","correctiveContent":"Treść korygująca","correspondenceAddress":"Adres do korespondencji","eoriNumber":"Numer EORI: ","identificationData":"Dane identyfikacyjne","mailingAddress":"Adres do korespondencji","seller":"Sprzedawca","taxpayerStatus":"Status podatnika: ","vatPrefix":"Prefiks VAT: "},"subject2":{"address":"Adres","buyer":"Nabywca","contactDetails":"Dane kontaktowe","correspondenceAddress":"Adres do korespondencji","customerNumber":"Numer klienta: ","eoriNumber":"Numer EORI: ","getterId":"Identyfikator nabywcy: ","gv":"Faktura dotyczy członka grupy GV: ","internalId":"Identyfikator wewnętrzny: ","jst":"Faktura dotyczy jednostki podrzędnej JST: ","mailingAddress":"Adres do korespondencji","name":"Nazwa: ","nip":"NIP: ","no":"NIE","noId":"Brak identyfikatora ","noTaxId":"Brak identyfikatora","taxIdOther":"Identyfikator podatkowy inny: ","taxPayerStatus":"Status podatnika: ","vatPrefix":"Prefiks VAT: ","vatUeNumber":"Numer VAT-UE: ","yes":"TAK"},"subject2k":{"address":"Adres","buyer":"Nabywca","buyerId":"Identyfikator nabywcy: ","clientNumber":"Numer klienta: ","contactDetails":"Dane kontaktowe","correctedContent":"Treść korygowana","correctiveContent":"Treść korygująca","correspondenceAddress":"Adres do korespondencji","eori":"Numer EORI: ","identificationData":"Dane identyfikacyjne","mailingAddress":"Adres do korespondencji","taxPayerStatus":"Status podatnika: "},"subject3":{"address":"Adres","clientNumber":"Numer klienta: ","contactData":"Dane kontaktowe","correspondenceAddress":"Adres do korespondencji","eori":"Numer EORI: ","getterId":"Identyfikator nabywcy: ","internalId":"Identyfikator wewnętrzny: ","name":"Nazwa: ","nip":"NIP: ","noTaxId":"Brak identyfikatora ","otherEntity":"Podmiot inny {{index}}","otherId":"Identyfikator podatkowy inny: ","otherRole":"Rola inna: ","otherTaxId":"Identyfikator podatkowy inny: ","role":"Rola: ","roleDescription":"Opis roli: ","share":"Udział: ","vatUeNumber":"Numer VAT-UE: "},"subject3k":{"address":"Adres","clientNumber":"Numer klienta: ","correctedContent":"Treść korygowana","correctiveContent":"Treść korygująca","correspondenceAddress":"Adres korespondencyjny","eori":"Numer EORI: ","getterId":"Identyfikator nabywcy: ","identificationData":"Dane identyfikacyjne","noTaxId":"Brak identyfikatora ","otherEntity":"Podmiot inny","otherRole":"Rola inna: ","otherTaxId":"Identyfikator podatkowy inny: ","role":"Rola: ","share":"Udział: "},"subjectContactData":{"e-mail":"E-mail: ","email":"Email: ","phone":"Tel.: "},"subjectIdentificationData":{"fullName":"Pełna nazwa: ","internalId":"Identyfikator wewnętrzny: ","name":"Nazwa: ","nameSurname":"Imię i nazwisko: ","nip":"NIP: ","noId":"Brak identyfikatora","tradeName":"Nazwa handlowa: "},"summary":{"5":"5%","0domestic":"0% - krajowe","0export":"0% - eksport","0long":"0% w przypadku sprzedaży towarów i świadczenia usług na terytorium kraju (z wyłączeniem WDT i eksportu)","0mid":"0% w przypadku wewnątrzwspólnotowej dostawy towarów (WDT)","0short":"0% w przypadku eksportu towarów","0wdt":"0% - wdt","23or22":"23% lub 22%","4or3":"4% lub 3%","8or7":"8% lub 7%","grossAmount":"Kwota brutto","lp":"Lp.","margin":"marża","netAmount":"Kwota netto","noTax":"zwolnione od podatku","npBasedArt100":"np na podstawie art. 100 ust. 1 pkt 4 ustawy","npExcludingArt100":"np z wyłączeniem art. 100 ust 1 pkt 4 ustawy","oss":"OSS","reverseTax":"odwrotne obciążenie","sectionHeader":"Podsumowanie stawek podatku","taxAmount":"Kwota podatku","taxAmountPLN":"Kwota podatku PLN","taxFree":"zwolnione z opodatkowania","taxRate":"Stawka podatku"},"transaction":{"batchNumber":"Numer partii towaru","contract":"Umowa","contractDate":"Data umowy","contractNumber":"Numer umowy","currency":"Waluta umowna: ","currencyAndRate":"Waluta umowna i kurs umowny","deliveryTerms":"Warunki dostawy towarów: ","header":"Warunki transakcji","intermediaryDelivery":"Dostawa dokonana przez podmiot, o którym mowa w art. 22 ust. 2d ustawy. Pole dotyczy sytuacji, w której podmiot uczestniczy w transakcji łańcuchowej innej niż procedura trójstronna uproszczona, o której mowa w art. 135 ust. 1 pkt 4 ustawy","order":"Zamówienie","orderDate":"Data zamówienia","orderNumber":"Numer zamówienia","rate":"Kurs umowny: "},"transport":{"cargoDescription":"Opis ładunku: ","dataHeader":"Dane transportu","endDateTime":"Data i godzina zakończenia transportu: ","gln":"GLN: ","header":"Transport","intermediateAddress":"Adres pośredni wysyłki","orderNumber":"Numer zlecenia transportu: ","otherCargo":"Ładunek inny","otherCargoDescription":"Opis innego ładunku: ","otherType":"Transport inny","otherTypeDescription":"Opis innego rodzaju transportu: ","packageUnit":"Jednostka opakowania: ","shipFrom":"Adres miejsca wysyłki","shipmentHeader":"Wysyłka","shipTo":"Adres miejsca docelowego, do którego został zlecony transport","startDateTime":"Data i godzina rozpoczęcia transportu: ","type":"Rodzaj transportu: "},"upo":{"authorizationDocumentShortcut":"Skrót dokumentu uwierzytelniającego: ","complexId":"Identyfikator złożony","contextAuthorizationId":"Identyfikator kontekstu uwierzytelnienia: ","contextType":"Typ kontekstu: ","documentInfo":"Informacja o dokumencie: ","documentRangeFrom":"Zakres dokumentów od: ","documentRangeTo":"Zakres dokumentów do: ","documentsTotal":"Całkowita liczba dokumentów: ","eDocumentFormCode":"Kod formularza przedłożonego dokumentu elektronicznego:","entityFullName":"Nazwa pełna podmiotu, któremu doręczono dokument elektroniczny: ","functionValueShortcut":"Wartość funkcji skrótu złożonego dokumentu","internalId":"Identyfikator wewnętrzny","peppolId":"Identyfikator Peppol","registeredInMF":"Dokument został zarejestrowany w systemie teleinformatycznym Ministerstwa Finansów","sendMethod":"Tryb wysyłki","sessionReferenceNumber":"Numer referencyjny sesji: ","upoKsef":"Urzędowe poświadczenie odbioru dokumentu elektronicznego KSeF","upoPage":"Strona dokumentu UPO: ","upoPageTotal":"Całkowita liczba stron dokumentu UPO: ","vendorNIP":"NIP sprzedawcy","xsdFileLogicName":"Nazwa pliku XSD struktury logicznej dotycząca przesłanego dokumentu:","nip":"NIP"},"wz":{"documentsHeader":"Numery dokumentów magazynowych WZ","number":"Numer WZ"}}`), Jw = {
  const: /* @__PURE__ */ JSON.parse('{"countries":{"AD":"Andora","AE":"Zjednoczone Emiraty Arabskie","AF":"Afganistan","AG":"Antigua i Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AN":"Antyle Holenderskie","AO":"Angola","AQ":"Antarktyda","AR":"Argentyna","AS":"Samoa Amerykańskie","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Aland Islands","AZ":"Azerbejdżan","BA":"Bośnia i Hercegowina","BB":"Barbados","BD":"Bangladesz","BE":"Belgia","BF":"Burkina Faso","BG":"Bułgaria","BH":"Bahrajn","BI":"Burundi","BJ":"Benin","BL":"Saint Barthelemy","BM":"Bermudy","BN":"Brunei Darussalam","BO":"Boliwia","BQ":"Bonaire, Sint Eustatius i Saba","BR":"Brazylia","BS":"Bahamy","BT":"Bhutan","BV":"Wyspa Bouveta","BW":"Botswana","BY":"Białoruś","BZ":"Belize","CA":"Kanada","CC":"Wyspy Kokosowe (Keelinga)","CD":"Kongo, Republika Demokratyczna","CF":"Rep.środkowoafrykańska","CG":"Kongo","CH":"Szwajcaria","CI":"Wybrzeże Kości Słoniowej","CK":"Wyspy Cooka","CL":"Chile","CM":"Kamerun","CN":"Chiny","CO":"Kolumbia","CR":"Kostaryka","CU":"Kuba","CV":"Zielony Przylądek","CW":"Curaçao","CX":"Wyspa Bożego Narodzenia","CY":"Cypr","CZ":"Republika Czeska","DE":"Niemcy","DJ":"Dżibuti","DK":"Dania","DM":"Dominika","DO":"Dominikana","DZ":"Algieria","EC":"Ekwador","EE":"Estonia","EG":"Egipt","EH":"Sahara Zachodnia","ER":"Erytrea","ES":"Hiszpania","ET":"Etiopia","FI":"Finlandia","FJ":"Fidżi Republika","FK":"Falklandy","FM":"Mikronezja","FO":"Wyspy Owcze","FR":"Francja","GA":"Gabon","GB":"Wielka Brytania","GD":"Grenada","GE":"Gruzja","GF":"Gujana Francuska","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Grenlandia","GM":"Gambia","GN":"Gwinea","GP":"Gwadelupa","GQ":"Gwinea Równikowa","GR":"Grecja","GS":"Południowa Georgia i Połud.Wyspy Sandwich","GT":"Gwatemala","GU":"Guam","GW":"Gwinea Bissau","GY":"Gujana","HK":"Hongkong","HM":"Wyspy Heard i Mcdonald","HN":"Honduras","HR":"Chorwacja","HT":"Haiti","HU":"Węgry","ID":"Indonezja","IE":"Irlandia","IL":"Izrael","IM":"Wyspa Man","IN":"Indie","IO":"Brytyjskie Terytorium Oceanu Indyjskiego","IQ":"Irak","IR":"Iran","IS":"Islandia","IT":"Włochy","JE":"Jersey","JM":"Jamajka","JO":"Jordania","JP":"Japonia","KE":"Kenia","KG":"Kirgistan","KH":"Kambodża","KI":"Kiribati","KM":"Komory","KN":"Saint Kitts i Nevis","KP":"Koreańska Republika Ludowo-Demokratyczna","KR":"Republika Korei","KW":"Kuwejt","KY":"Kajmany","KZ":"Kazachstan","LA":"Laos","LB":"Liban","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litwa","LU":"Luksemburg","LV":"Łotwa","LY":"Libia","MA":"Maroko","MC":"Monako","MD":"Mołdowa","ME":"Czarnogóra","MF":"Saint Martin","MG":"Madagaskar","MH":"Wyspy Marshalla","MK":"Macedonia","ML":"Mali","MM":"Myanmar (Burma)","MN":"Mongolia","MO":"Makau","MP":"Mariany Północne","MQ":"Martynika","MR":"Mauretania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Malediwy","MW":"Malawi","MX":"Meksyk","MY":"Malezja","MZ":"Mozambik","NA":"Namibia","NC":"Nowa Kaledonia","NE":"Niger","NF":"Norfolk","NG":"Nigeria","NI":"Nikaragua","NL":"Niderlandy (Holandia)","NO":"Norwegia","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nowa Zelandia","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Polinezja Francuska","PG":"Papua Nowa Gwinea","PH":"Filipiny","PK":"Pakistan","PL":"Polska","PM":"Saint Pierre i Miquelon","PN":"Pitcairn","PR":"Portoryko","PS":"Okupowane Terytorium Palestyny","PT":"Portugalia","PW":"Palau","PY":"Paragwaj","QA":"Katar","RE":"Reunion","RO":"Rumunia","RS":"Serbia","RU":"Rosja","RW":"Rwanda","SA":"Arabia Saudyjska","SB":"Wyspy Salomona","SC":"Seszele","SD":"Sudan","SE":"Szwecja","SG":"Singapur","SH":"Święta Helena","SI":"Słowenia","SJ":"Svalbard i Jan Mayen","SK":"Słowacja","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"Sudan Południowy","ST":"Wyspy Świętego Tomasza i Książęca","SV":"Salwador","SX":"Wyspa Sint Maarten (część holenderska wyspy)","SY":"Syria","SZ":"Suazi","TC":"Wyspy Turks i Caicos","TD":"Czad","TF":"Francuskie Terytorium Południowe","TG":"Togo","TH":"Tajlandia","TJ":"Tadżykistan","TK":"Tokelau","TL":"Wschodni Timor","TM":"Turkmenistan","TN":"Tunezja","TO":"Tonga","TR":"Turcja","TT":"Trynidad i Tobago","TV":"Tuvalu","TW":"Tajwan","TZ":"Tanzania","UA":"Ukraina","UG":"Uganda","UM":"Minor","US":"Stany Zjednoczone Ameryki","UY":"Urugwaj","UZ":"Uzbekistan","VA":"Watykan","VC":"Saint Vincent i Grenadyny","VE":"Wenezuela","VG":"Wyspy Dziewicze-W.B.","VI":"Wyspy Dziewicze-USA","VN":"Wietnam","VU":"Vanuatu","WF":"Wallis i Futuna","WS":"Samoa","XC":"Ceuta","XI":"Zjednoczone Królestwo (Irlandia Północna)","XK":"Kosowo","XL":"Melilla","YE":"Jemen","YT":"Majotta","ZA":"Republika Południowej Afryki","ZM":"Zambia","ZW":"Zimbabwe"},"fa":{"additionalBuyer":"Dodatkowy nabywca - w przypadku, gdy na fakturze występują dane kolejnych (innych niż wymieniony w części Podmiot2) nabywców","airTransport":"Transport lotniczy","bag":"Worek","bankruptcy":"Stan upadłości","barrel":"Beczka","basket":"Kosz/koszyk","bin":"Pojemnik","box":"Pudełko","bubble":"Bańka","bulkLiquidContainer":"Pojemnik do ładunków masowych w postaci płynnej","bulkPackage":"Opakowanie zbiorcze","bulkSolidContainer":"Pojemnik do ładunków masowych stałych","cage":"Klatka","canister":"Kanister","card":"Karta","carton":"Karton","cash":"Gotówka","check":"Czek","container":"Kontener","correctionOtherDate":"Korekta skutkująca w dacie innej, w tym gdy dla różnych pozycji faktury korygującej daty te są różne","courtBailiff":"Komornik sądowy","courtBailiffArt106c2":"Komornik sądowy - w przypadku, o którym mowa w art. 106c pkt 2 ustawy","crate":"Skrzynia","credit":"Kredyt","cylinder":"Butla","domesticZeroRate":"Stawka 0% stosowana w ramach sprzedaży krajowej","employee":"Pracownik","enforcementAuthority":"Organ egzekucyjny","enforcementAuthorityArt106c1":"Organ egzekucyjny - w przypadku, o którym mowa w art. 106c pkt 1 ustawy","exportZeroRate":"Stawka 0% - eksport towarów","factor":"Faktor - w przypadku, gdy na fakturze występują dane faktora","fixedPipeline":"Stałe instalacje przesyłowe","goodsServicesAttachment15":"Towar/usługa wymienione w załączniku 15","inheritedBusiness":"Przedsiębiorstwo w spadku","inlandNavigation":"Żegluga śródlądowa","intraCommunitySupply":"Stawka 0% - wewnątrzwspólnotowa dostawa towarów","invoiceIssuer":"Wystawca faktury - w przypadku, gdy na fakturze występują dane podmiotu wystawiającego fakturę w imieniu podatnika. Nie dotyczy przypadku, gdy wystawcą faktury jest nabywca","liquidation":"Stan likwidacji","localGovernmentIssuer":"Jednostka samorządu terytorialnego - wystawca","localGovernmentRecipient":"Jednostka samorządu terytorialnego - odbiorca","mobile":"Mobilna","oo":"oo","otherDomesticSales":"Pozostała sprzedaż krajowa","ownAccountCollection":"Rachunek banku lub rachunek spółdzielczej kasy oszczędnościowo-kredytowej wykorzystywany przez ten bank lub tę kasę do pobrania należności od nabywcy towarów lub usług za dostawę towarów lub świadczenie usług, potwierdzone fakturą, i przekazania jej w całości albo części dostawcy towarów lub usługodawcy","ownAccountInternal":"Rachunek banku lub rachunek spółdzielczej kasy oszczędnościowo-kredytowej prowadzony przez ten bank lub tę kasę w ramach gospodarki własnej, niebędący rachunkiem rozliczeniowym","ownAccountSettlement":"Rachunek banku lub rachunek spółdzielczej kasy oszczędnościowo-kredytowej służący do dokonywania rozliczeń z tytułu nabywanych przez ten bank lub tę kasę wierzytelności pieniężnych","package":"Paczka","packet":"Pakiet","pallet":"Paleta","payer":"Dokonujący płatności - w przypadku, gdy na fakturze występują dane podmiotu regulującego zobowiązanie w miejsce nabywcy","postalShipment":"Przesyłka pocztowa","primaryEntity":"Podmiot pierwotny - w przypadku, gdy na fakturze występują dane podmiotu będącego w stosunku do podatnika podmiotem przejętym lub przekształconym, który dokonywał dostawy lub świadczył usługę. Z wyłączeniem przypadków, o których mowa w art. 106j ust.2 pkt 3 ustawy, gdy dane te wykazywane są w części Podmiot1K","punnet":"Łubianka","railTransport":"Transport kolejowy","recipient":"Odbiorca - w przypadku, gdy na fakturze występują dane jednostek wewnętrznych, oddziałów, wyodrębnionych w ramach nabywcy, które same nie stanowią nabywcy w rozumieniu ustawy","restructuring":"Postępowanie restrukturyzacyjne","roadTransport":"Transport drogowy","seaTransport":"Transport morski","servicesArt100":"Świadczenie usług z art. 100 ust. 1 pkt 4 ustawy","supplyOutsideCountry":"Dostawa towarów oraz świadczenie usług opodatkowane poza terytorium kraju","taxRate0":"0%","taxRate0EX":"0% - EX","taxRate0KR":"0% - KR","taxRate0WDT":"0% - WDT","taxRate22":"22%","taxRate23":"23%","taxRate3":"3%","taxRate4":"4%","taxRate4oo":"4% lub 3% lub oo","taxRate5":"5%","taxRate7":"7%","taxRate8":"8%","taxRateNp":"niepodlegające opodatkowaniu-transakcje dostawy towarów oraz świadczenia usług poza terytorium kraju","taxRateNpI":"np I","taxRateNpII":"np II","taxRateOo":"4% lub 3% lub oo\\nUWAGA: oo jest wykazywane łącznie z 4% lub 3%","taxRateRevOo":"odwrotne obciążenie","taxRateZw":"zwolnione z opodatkowania","taxRateZw2":"zwolnione od podatku","taxRepresentative":"Przedstawiciel podatkowy","taxRepresentativeArt18":"Przedstawiciel podatkowy - w przypadku, gdy na fakturze występują dane przedstawiciela podatkowego, o którym mowa w przepisach art. 18a - 18d ustawy","tin":"Puszka","transfer":"Przelew","vatGroupIssuer":"Członek grupy VAT - wystawca","vatGroupRecipient":"Członek grupy VAT - odbiorca","voucher":"Bon","zw":"zw"},"farr":{"correctionInvoiceDate":"Korekta skutkująca w dacie wystawienia faktury korygującej","correctionOriginalDate":"Korekta skutkująca w dacie ujęcia faktury pierwotnej","correctionOtherDate":"Korekta skutkująca w dacie innej","correctionRefundDate":"Korekta skutkująca w dacie dokonania zwrotu całości lub części należności","employee":"Pracownik","factor":"Faktor - w przypadku gdy na fakturze występują dane faktora","invoiceIssuer":"Wystawca faktury - w przypadku gdy na fakturze występują dane podmiotu wystawiającego fakturę w imieniu podatnika. Nie dotyczy przypadku, gdy wystawcą faktury jest nabywca","localGovIssuer":"Jednostka samorządu terytorialnego - wystawca","localGovRecipient":"Jednostka samorządu terytorialnego - odbiorca","originalEntity":"Podmiot pierwotny - w przypadku gdy na fakturze występują dane podmiotu będącego w stosunku do podatnika podmiotem przejętym lub przekształconym, który dokonywał dostawy lub świadczył usługę. Z wyłączeniem przypadków, o których mowa w art. 106j ust.2 pkt 3 ustawy, gdy dane te wykazywane są w części Podmiot1K","paymentEntity":"Dokonujący płatności - w przypadku gdy na fakturze występują dane podmiotu regulującego zobowiązanie w miejsce nabywcy","recipientInternalUnit":"Odbiorca - w przypadku gdy na fakturze występują dane jednostek wewnętrznych, oddziałów, wyodrębnionych w ramach nabywcy, które same nie stanowią nabywcy w rozumieniu ustawy","taxRate65":"6.5%","taxRate7":"7%","vatGroupMemberIssuer":"Członek grupy VAT - wystawca","vatGroupMemberRecipient":"Członek grupy VAT - odbiorca"}}'),
  invoice: Ow
}, Kw = /* @__PURE__ */ JSON.parse('{"additionalInformation":{"additionalDescription":"ExampleText","additionalInformationLabel":"ExampleText","documentDate":"ExampleText","documentNumber":"ExampleText","exciseTaxRefund":"ExampleText","fpLabel":"ExampleText","infoContent":"ExampleText","informationContent":"ExampleText","infoType":"ExampleText","ksefDocumentNumber":"ExampleText","ordinalNumber":"ExampleText","paymentDocuments":"ExampleText","rowNumber":"ExampleText","tpLabel":"ExampleText","typeOfInformation":"ExampleText"},"address":{"apartmentNumber":"ExampleText","communeName":"ExampleText","countryName":"ExampleText","districtName":"ExampleText","GLN":"ExampleText","houseNumber":"ExampleText","postName":"ExampleText","streetName":"ExampleText","townName":"ExampleText","voivodeshipName":"ExampleText","zipCode":"ExampleText"},"annotations":{"airDelivery":"ExampleText","antiques":"ExampleText","artPieces":"ExampleText","boatDelivery":"ExampleText","bodyNumber":"ExampleText","cashMethod":"ExampleText","chassisNumber":"ExampleText","description":"ExampleText","directiveLaw":"ExampleText","factoryNumber":"ExampleText","frameNumber":"ExampleText","header":"ExampleText","hullNumber":"ExampleText","landDelivery":"ExampleText","law":"ExampleText","marginProcedure":"ExampleText","newTransportsDelivery":"ExampleText","newTransportType":"ExampleText","noTaxBase":"ExampleText","noTaxBaseDocument":"ExampleText","noTaxBaseDocument2":"ExampleText","noTaxBaseDocument3":"ExampleText","noTaxDelivery":"ExampleText","otherLaw":"ExampleText","partialPayMechanism":"ExampleText","reverseTax":"ExampleText","selfInvoice":"ExampleText","threePartsSimplerMethod":"ExampleText","transportApprovalDate":"ExampleText","transportBrand":"ExampleText","transportColor":"ExampleText","transportMileage":"ExampleText","transportModel":"ExampleText","transportProductionYear":"ExampleText","transportRegistrationNumber":"ExampleText","transportType":"ExampleText","travelAgencies":"ExampleText","usedGoods":"ExampleText","usePermissionDate":"ExampleText","vat22DocumentNotRequired":"ExampleText","vat22DocumentRequired":"ExampleText","vin":"ExampleText"},"attachment":{"blockHeader":"ExampleText","description":"ExampleText","details":"ExampleText","header":"ExampleText","key":"ExampleText","tableLabel":"ExampleText","tableSummary":"ExampleText","value":"ExampleText"},"authorizedSubject":{"address":"ExampleText","authorizedSubject":"ExampleText","contactData":"ExampleText","correspondenceAddress":"ExampleText","correspondenceAddress2":"ExampleText","email":"ExampleText","eori":"ExampleText","noTaxId":"ExampleText","otherTaxId":"ExampleText","phone":"ExampleText","role":"ExampleText"},"carrier":{"carrier":"ExampleText","carrierAddress":"ExampleText"},"correctedInvoice":{"correctInvoiceNumber":"ExampleText","correctionEffectType":"ExampleText","correctionReason":"ExampleText","identificationHeader":"ExampleText","identificationHeaderIndexed":"ExampleText","invoiceNumber":"ExampleText","issueDate":"ExampleText","ksefNumber":"ExampleText","sectionHeader":"ExampleText"},"details":{"advanceInvoiceNumbers":"ExampleText","assignKsefNumberDate":"ExampleText","commonCurrencyRate":"ExampleText","costAmount":"ExampleText","currencyCode":"ExampleText","currencyRate":"ExampleText","currencyRate2":"ExampleText","deliveryOrServiceDate":"ExampleText","deliveryOrServiceDateFrom":"ExampleText","deliveryOrServiceDateTo":"ExampleText","discountPeriod":"ExampleText","getDate":"ExampleText","getMoneyDate":"ExampleText","getMoneyDate2":"ExampleText","header":"ExampleText","invoiceDate":"ExampleText","invoiceDateSentToKsef":"ExampleText","invoiceDateShort":"ExampleText","invoiceNumber":"ExampleText","issueDate":"ExampleText","issuePlace":"ExampleText","ossProcedure":"ExampleText","paymentReceivedDate":"ExampleText","place":"ExampleText","to":"ExampleText"},"discount":{"all":"ExampleText","header":"ExampleText","lp":"ExampleText","notAll":"ExampleText","productName":"ExampleText","quantity":"ExampleText","totalValue":"ExampleText","unit":"ExampleText"},"footer":{"generatedIn":"ExampleText","margin":"ExampleText","pagesTotal":"ExampleText","version":"ExampleText","appName":"ExampleText"},"header":{"advance":"ExampleText","attachmentWarning":"ExampleText","correctedInvoiceVatRr":"ExampleText","correction":"ExampleText","correctionAdvance":"ExampleText","correctionCollective":"ExampleText","correctionSettlement":"ExampleText","invoiceNumberLabel":"ExampleText","ksefNumberLabel":"ExampleText","ksefPart1":"ExampleText","ksefPart2":"ExampleText","ksefPart3":"ExampleText","primalInvoiceVatRr":"ExampleText","settlement":"ExampleText","simplified":"ExampleText","vat":"ExampleText"},"information":{"header":"ExampleText","invoiceFooter":"ExampleText"},"order":{"additionalInfo":"ExampleText","advancePaymentAmount":"ExampleText","advancePaymentAmountCorrection":"ExampleText","cn":"ExampleText","currencyRate":"ExampleText","exciseTaxAmount":"ExampleText","gtin":"ExampleText","gtu":"ExampleText","index":"ExampleText","issuedInCurrency":"ExampleText","lp":"ExampleText","netSalesValue":"ExampleText","netUnitPrice":"ExampleText","orderNumber":"ExampleText","orderValueWithTax":"ExampleText","ossTaxRate":"ExampleText","pkob":"ExampleText","pkwiu":"ExampleText","procedure":"ExampleText","procedureMarkings":"ExampleText","productMarker":"ExampleText","productName":"ExampleText","quantity":"ExampleText","receivedAdvance":"ExampleText","stateBefore":"ExampleText","taxAmount":"ExampleText","taxRate":"ExampleText","totalAmountDue":"ExampleText","uniqueRowNumber":"ExampleText","unit":"ExampleText"},"payment":{"bankAccountNumber":"ExampleText","conditionalDiscount":"ExampleText","description":"ExampleText","discountAmount":"ExampleText","discountConditions":"ExampleText","factorsBankAccountNumber":"ExampleText","farmer":"ExampleText","getter":"ExampleText","ksefTransferId":"ExampleText","maturityDate":"ExampleText","moneylessLink":"ExampleText","noPayment":"ExampleText","other":"ExampleText","otherPaymentDescription":"ExampleText","paidAllInParts":"ExampleText","paidInPart":"ExampleText","paidStatus":"ExampleText","partialPayment":"ExampleText","partialPaymentAmount":"ExampleText","partialPaymentDate":"ExampleText","payment":"ExampleText","paymentDate":"ExampleText","paymentDescription":"ExampleText","paymentDifferent":"ExampleText","paymentInformation":"ExampleText","paymentInformationContinued":"ExampleText","paymentMethod":"ExampleText","paymentMethod2":"ExampleText","paymentMethod3":"ExampleText","transfer":"ExampleText"},"qr1":{"description":"ExampleText","header":"ExampleText","offline":"ExampleText"},"qr2":{"certificate":"ExampleText","description":"ExampleText","header":"ExampleText"},"registers":{"accountDescription":"ExampleText","bankName":"ExampleText","bdo":"ExampleText","billFormat":"ExampleText","foreign":"ExampleText","fullAccountNumber":"ExampleText","fullForeignAccountNumber":"ExampleText","fullName":"ExampleText","fullNrbAccountNumber":"ExampleText","header":"ExampleText","krs":"ExampleText","ownBankAccount":"ExampleText","polish":"ExampleText","regon":"ExampleText","swiftCode":"ExampleText"},"rows":{"additionalInfo":"ExampleText","amount":"ExampleText","cn":"ExampleText","costZZP":"ExampleText","currencyRate":"ExampleText","deliveryDate":"ExampleText","discount":"ExampleText","exciseTaxAmount":"ExampleText","farmProductCost":"ExampleText","getDate":"ExampleText","getOrMakeDate":"ExampleText","grossSalesValue":"ExampleText","grossUnitPrice":"ExampleText","gtin":"ExampleText","gtu":"ExampleText","header":"ExampleText","index":"ExampleText","inWords":"ExampleText","issuedInCurrency":"ExampleText","lp":"ExampleText","lumpSumTaxRefund":"ExampleText","name":"ExampleText","netSalesValue":"ExampleText","netUnitPrice":"ExampleText","ossTaxRate":"ExampleText","overallCost":"ExampleText","pkob":"ExampleText","pkwiu":"ExampleText","priceNoZZP":"ExampleText","procedure":"ExampleText","procedureMarkings":"ExampleText","productMarker":"ExampleText","productName":"ExampleText","qualityDesc":"ExampleText","quantity":"ExampleText","remainingAmount":"ExampleText","stateBefore":"ExampleText","taxRate":"ExampleText","totalAmountDue":"ExampleText","uniqueRowNumber":"ExampleText","unit":"ExampleText","unitPrice":"ExampleText","valueZZP":"ExampleText","vatSalesValue":"ExampleText","wageZZP":"ExampleText"},"settlement":{"chargeReason":"ExampleText","charges":"ExampleText","deductionReason":"ExampleText","deductions":"ExampleText","header":"ExampleText","toPay":"ExampleText","toSettle":"ExampleText","totalCharges":"ExampleText","totalDeductions":"ExampleText"},"subject1":{"address":"ExampleText","contactDetails":"ExampleText","contractorNumber":"ExampleText","correspondenceAddress":"ExampleText","eoriNumber":"ExampleText","mailingAddress":"ExampleText","name":"ExampleText","nip":"ExampleText","seller":"ExampleText","taxpayerStatus":"ExampleText","vatPrefix":"ExampleText"},"subject1K":{"address":"ExampleText","contactDetails":"ExampleText","contractorNumber":"ExampleText","correctedContent":"ExampleText","correctiveContent":"ExampleText","correspondenceAddress":"ExampleText","eoriNumber":"ExampleText","identificationData":"ExampleText","mailingAddress":"ExampleText","seller":"ExampleText","taxpayerStatus":"ExampleText","vatPrefix":"ExampleText"},"subject2":{"address":"ExampleText","buyer":"ExampleText","contactDetails":"ExampleText","correspondenceAddress":"ExampleText","customerNumber":"ExampleText","eoriNumber":"ExampleText","getterId":"ExampleText","gv":"ExampleText","internalId":"ExampleText","jst":"ExampleText","mailingAddress":"ExampleText","name":"ExampleText","nip":"ExampleText","no":"ExampleText","noId":"ExampleText","noTaxId":"ExampleText","taxIdOther":"ExampleText","taxPayerStatus":"ExampleText","vatPrefix":"ExampleText","vatUeNumber":"ExampleText","yes":"ExampleText"},"subject2k":{"address":"ExampleText","buyer":"ExampleText","buyerId":"ExampleText","clientNumber":"ExampleText","contactDetails":"ExampleText","correctedContent":"ExampleText","correctiveContent":"ExampleText","correspondenceAddress":"ExampleText","eori":"ExampleText","identificationData":"ExampleText","mailingAddress":"ExampleText","taxPayerStatus":"ExampleText"},"subject3":{"address":"ExampleText","clientNumber":"ExampleText","contactData":"ExampleText","correspondenceAddress":"ExampleText","eori":"ExampleText","getterId":"ExampleText","internalId":"ExampleText","name":"ExampleText","nip":"ExampleText","noTaxId":"ExampleText","otherEntity":"ExampleText","otherId":"ExampleText","otherRole":"ExampleText","otherTaxId":"ExampleText","role":"ExampleText","roleDescription":"ExampleText","share":"ExampleText","vatUeNumber":"ExampleText"},"subject3k":{"address":"ExampleText","clientNumber":"ExampleText","correctedContent":"ExampleText","correctiveContent":"ExampleText","correspondenceAddress":"ExampleText","eori":"ExampleText","getterId":"ExampleText","identificationData":"ExampleText","noTaxId":"ExampleText","otherEntity":"ExampleText","otherRole":"ExampleText","otherTaxId":"ExampleText","role":"ExampleText","share":"ExampleText"},"subjectContactData":{"e-mail":"ExampleText","email":"ExampleText","phone":"ExampleText"},"subjectIdentificationData":{"fullName":"ExampleText","internalId":"ExampleText","name":"ExampleText","nameSurname":"ExampleText","nip":"ExampleText","noId":"ExampleText","tradeName":"ExampleText"},"summary":{"5":"ExampleText","0domestic":"ExampleText","0export":"ExampleText","0long":"ExampleText","0mid":"ExampleText","0short":"ExampleText","0wdt":"ExampleText","23or22":"ExampleText","4or3":"ExampleText","8or7":"ExampleText","grossAmount":"ExampleText","lp":"ExampleText","margin":"ExampleText","netAmount":"ExampleText","noTax":"ExampleText","npBasedArt100":"ExampleText","npExcludingArt100":"ExampleText","oss":"ExampleText","reverseTax":"ExampleText","sectionHeader":"ExampleText","taxAmount":"ExampleText","taxAmountPLN":"ExampleText","taxFree":"ExampleText","taxRate":"ExampleText"},"transaction":{"batchNumber":"ExampleText","contract":"ExampleText","contractDate":"ExampleText","contractNumber":"ExampleText","currency":"ExampleText","currencyAndRate":"ExampleText","deliveryTerms":"ExampleText","header":"ExampleText","intermediaryDelivery":"ExampleText","order":"ExampleText","orderDate":"ExampleText","orderNumber":"ExampleText","rate":"ExampleText"},"transport":{"cargoDescription":"ExampleText","dataHeader":"ExampleText","endDateTime":"ExampleText","gln":"ExampleText","header":"ExampleText","intermediateAddress":"ExampleText","orderNumber":"ExampleText","otherCargo":"ExampleText","otherCargoDescription":"ExampleText","otherType":"ExampleText","otherTypeDescription":"ExampleText","packageUnit":"ExampleText","shipFrom":"ExampleText","shipmentHeader":"ExampleText","shipTo":"ExampleText","startDateTime":"ExampleText","type":"ExampleText"},"upo":{"authorizationDocumentShortcut":"ExampleText","complexId":"ExampleText","contextAuthorizationId":"ExampleText","contextType":"ExampleText","documentInfo":"ExampleText","documentRangeFrom":"ExampleText","documentRangeTo":"ExampleText","documentsTotal":"ExampleText","eDocumentFormCode":"ExampleText","entityFullName":"ExampleText","functionValueShortcut":"ExampleText","internalId":"ExampleText","peppolId":"ExampleText","registeredInMF":"ExampleText","sendMethod":"ExampleText","sessionReferenceNumber":"ExampleText","upoKsef":"ExampleText","upoPage":"ExampleText","upoPageTotal":"ExampleText","vendorNIP":"ExampleText","xsdFileLogicName":"ExampleText","nip":"ExampleText"},"wz":{"documentsHeader":"ExampleText","number":"ExampleText"}}'), Ww = {
  const: { countries: { AD: "ExampleText", AE: "ExampleText", AF: "ExampleText", AG: "ExampleText", AI: "ExampleText", AL: "ExampleText", AM: "ExampleText", AN: "ExampleText", AO: "ExampleText", AQ: "ExampleText", AR: "ExampleText", AS: "ExampleText", AT: "ExampleText", AU: "ExampleText", AW: "ExampleText", AX: "ExampleText", AZ: "ExampleText", BA: "ExampleText", BB: "ExampleText", BD: "ExampleText", BE: "ExampleText", BF: "ExampleText", BG: "ExampleText", BH: "ExampleText", BI: "ExampleText", BJ: "ExampleText", BL: "ExampleText", BM: "ExampleText", BN: "ExampleText", BO: "ExampleText", BQ: "ExampleText", BR: "ExampleText", BS: "ExampleText", BT: "ExampleText", BV: "ExampleText", BW: "ExampleText", BY: "ExampleText", BZ: "ExampleText", CA: "ExampleText", CC: "ExampleText", CD: "ExampleText", CF: "ExampleText", CG: "ExampleText", CH: "ExampleText", CI: "ExampleText", CK: "ExampleText", CL: "ExampleText", CM: "ExampleText", CN: "ExampleText", CO: "ExampleText", CR: "ExampleText", CU: "ExampleText", CV: "ExampleText", CW: "ExampleText", CX: "ExampleText", CY: "ExampleText", CZ: "ExampleText", DE: "ExampleText", DJ: "ExampleText", DK: "ExampleText", DM: "ExampleText", DO: "ExampleText", DZ: "ExampleText", EC: "ExampleText", EE: "ExampleText", EG: "ExampleText", EH: "ExampleText", ER: "ExampleText", ES: "ExampleText", ET: "ExampleText", FI: "ExampleText", FJ: "ExampleText", FK: "ExampleText", FM: "ExampleText", FO: "ExampleText", FR: "ExampleText", GA: "ExampleText", GB: "ExampleText", GD: "ExampleText", GE: "ExampleText", GF: "ExampleText", GG: "ExampleText", GH: "ExampleText", GI: "ExampleText", GL: "ExampleText", GM: "ExampleText", GN: "ExampleText", GP: "ExampleText", GQ: "ExampleText", GR: "ExampleText", GS: "ExampleText", GT: "ExampleText", GU: "ExampleText", GW: "ExampleText", GY: "ExampleText", HK: "ExampleText", HM: "ExampleText", HN: "ExampleText", HR: "ExampleText", HT: "ExampleText", HU: "ExampleText", ID: "ExampleText", IE: "ExampleText", IL: "ExampleText", IM: "ExampleText", IN: "ExampleText", IO: "ExampleText", IQ: "ExampleText", IR: "ExampleText", IS: "ExampleText", IT: "ExampleText", JE: "ExampleText", JM: "ExampleText", JO: "ExampleText", JP: "ExampleText", KE: "ExampleText", KG: "ExampleText", KH: "ExampleText", KI: "ExampleText", KM: "ExampleText", KN: "ExampleText", KP: "ExampleText", KR: "ExampleText", KW: "ExampleText", KY: "ExampleText", KZ: "ExampleText", LA: "ExampleText", LB: "ExampleText", LC: "ExampleText", LI: "ExampleText", LK: "ExampleText", LR: "ExampleText", LS: "ExampleText", LT: "ExampleText", LU: "ExampleText", LV: "ExampleText", LY: "ExampleText", MA: "ExampleText", MC: "ExampleText", MD: "ExampleText", ME: "ExampleText", MF: "ExampleText", MG: "ExampleText", MH: "ExampleText", MK: "ExampleText", ML: "ExampleText", MM: "ExampleText", MN: "ExampleText", MO: "ExampleText", MP: "ExampleText", MQ: "ExampleText", MR: "ExampleText", MS: "ExampleText", MT: "ExampleText", MU: "ExampleText", MV: "ExampleText", MW: "ExampleText", MX: "ExampleText", MY: "ExampleText", MZ: "ExampleText", NA: "ExampleText", NC: "ExampleText", NE: "ExampleText", NF: "ExampleText", NG: "ExampleText", NI: "ExampleText", NL: "ExampleText", NO: "ExampleText", NP: "ExampleText", NR: "ExampleText", NU: "ExampleText", NZ: "ExampleText", OM: "ExampleText", PA: "ExampleText", PE: "ExampleText", PF: "ExampleText", PG: "ExampleText", PH: "ExampleText", PK: "ExampleText", PL: "ExampleText", PM: "ExampleText", PN: "ExampleText", PR: "ExampleText", PS: "ExampleText", PT: "ExampleText", PW: "ExampleText", PY: "ExampleText", QA: "ExampleText", RE: "ExampleText", RO: "ExampleText", RS: "ExampleText", RU: "ExampleText", RW: "ExampleText", SA: "ExampleText", SB: "ExampleText", SC: "ExampleText", SD: "ExampleText", SE: "ExampleText", SG: "ExampleText", SH: "ExampleText", SI: "ExampleText", SJ: "ExampleText", SK: "ExampleText", SL: "ExampleText", SM: "ExampleText", SN: "ExampleText", SO: "ExampleText", SR: "ExampleText", SS: "ExampleText", ST: "ExampleText", SV: "ExampleText", SX: "ExampleText", SY: "ExampleText", SZ: "ExampleText", TC: "ExampleText", TD: "ExampleText", TF: "ExampleText", TG: "ExampleText", TH: "ExampleText", TJ: "ExampleText", TK: "ExampleText", TL: "ExampleText", TM: "ExampleText", TN: "ExampleText", TO: "ExampleText", TR: "ExampleText", TT: "ExampleText", TV: "ExampleText", TW: "ExampleText", TZ: "ExampleText", UA: "ExampleText", UG: "ExampleText", UM: "ExampleText", US: "ExampleText", UY: "ExampleText", UZ: "ExampleText", VA: "ExampleText", VC: "ExampleText", VE: "ExampleText", VG: "ExampleText", VI: "ExampleText", VN: "ExampleText", VU: "ExampleText", WF: "ExampleText", WS: "ExampleText", XC: "ExampleText", XI: "ExampleText", XK: "ExampleText", XL: "ExampleText", YE: "ExampleText", YT: "ExampleText", ZA: "ExampleText", ZM: "ExampleText", ZW: "ExampleText" }, fa: { additionalBuyer: "ExampleText", airTransport: "ExampleText", bag: "ExampleText", bankruptcy: "ExampleText", barrel: "ExampleText", basket: "ExampleText", bin: "ExampleText", box: "ExampleText", bubble: "ExampleText", bulkLiquidContainer: "ExampleText", bulkPackage: "ExampleText", bulkSolidContainer: "ExampleText", cage: "ExampleText", canister: "ExampleText", card: "ExampleText", carton: "ExampleText", cash: "ExampleText", check: "ExampleText", container: "ExampleText", correctionOtherDate: "ExampleText", courtBailiff: "ExampleText", courtBailiffArt106c2: "ExampleText", crate: "ExampleText", credit: "ExampleText", cylinder: "ExampleText", domesticZeroRate: "ExampleText", employee: "ExampleText", enforcementAuthority: "ExampleText", enforcementAuthorityArt106c1: "ExampleText", exportZeroRate: "ExampleText", factor: "ExampleText", fixedPipeline: "ExampleText", goodsServicesAttachment15: "ExampleText", inheritedBusiness: "ExampleText", inlandNavigation: "ExampleText", intraCommunitySupply: "ExampleText", invoiceIssuer: "ExampleText", liquidation: "ExampleText", localGovernmentIssuer: "ExampleText", localGovernmentRecipient: "ExampleText", mobile: "ExampleText", oo: "ExampleText", otherDomesticSales: "ExampleText", ownAccountCollection: "ExampleText", ownAccountInternal: "ExampleText", ownAccountSettlement: "ExampleText", package: "ExampleText", packet: "ExampleText", pallet: "ExampleText", payer: "ExampleText", postalShipment: "ExampleText", primaryEntity: "ExampleText", punnet: "ExampleText", railTransport: "ExampleText", recipient: "ExampleText", restructuring: "ExampleText", roadTransport: "ExampleText", seaTransport: "ExampleText", servicesArt100: "ExampleText", supplyOutsideCountry: "ExampleText", taxRate0: "ExampleText", taxRate0EX: "ExampleText", taxRate0KR: "ExampleText", taxRate0WDT: "ExampleText", taxRate22: "ExampleText", taxRate23: "ExampleText", taxRate3: "ExampleText", taxRate4: "ExampleText", taxRate4oo: "ExampleText", taxRate5: "ExampleText", taxRate7: "ExampleText", taxRate8: "ExampleText", taxRateNp: "ExampleText", taxRateNpI: "ExampleText", taxRateNpII: "ExampleText", taxRateOo: "ExampleText", taxRateRevOo: "ExampleText", taxRateZw: "ExampleText", taxRateZw2: "ExampleText", taxRepresentative: "ExampleText", taxRepresentativeArt18: "ExampleText", tin: "ExampleText", transfer: "ExampleText", vatGroupIssuer: "ExampleText", vatGroupRecipient: "ExampleText", voucher: "ExampleText", zw: "ExampleText" }, farr: { correctionInvoiceDate: "ExampleText", correctionOriginalDate: "ExampleText", correctionOtherDate: "ExampleText", correctionRefundDate: "ExampleText", employee: "ExampleText", factor: "ExampleText", invoiceIssuer: "ExampleText", localGovIssuer: "ExampleText", localGovRecipient: "ExampleText", originalEntity: "ExampleText", paymentEntity: "ExampleText", recipientInternalUnit: "ExampleText", taxRate65: "ExampleText", taxRate7: "ExampleText", vatGroupMemberIssuer: "ExampleText", vatGroupMemberRecipient: "ExampleText" } },
  invoice: Kw
}, kB = l.init({
  lng: "pl",
  debug: !0,
  resources: {
    en: { translation: Ww },
    pl: { translation: Jw }
  }
}).then(() => {
});
async function _w(e, n, c = "blob") {
  const E = await LB(e), Y = E?.Faktura?.Naglowek?.KodFormularza?._attributes?.kodSystemowy;
  let X;
  switch (await kB, Y) {
    case "FA (1)":
      X = yE(E.Faktura, n);
      break;
    case "FA (2)":
      X = ZE(E.Faktura, n);
      break;
    case "FA (3)":
      X = dw(E.Faktura, n);
      break;
    case "FA_RR (1)":
    case "FA_RR(1)":
      X = Uw(E.Faktura, n);
      break;
    default:
      throw new Error(`Unknown XML Version: ${Y}`);
  }
  switch (c) {
    case "blob":
      return X.getBlob();
    case "base64":
    default:
      return X.getBase64();
  }
}
function Vw(e) {
  const n = Te(e.Dokument), c = [], E = [];
  c.push(Ei(4)), c.push(Ui()), c.push(Ei(8)), c.push(re(l.t("invoice.upo.upoKsef"), R.HeaderPosition)), c.push(Ei(8)), Ae(e.NumerReferencyjnySesji) && E.push([
    re(l.t("invoice.upo.sessionReferenceNumber"), R.GrayBoldTitle),
    re(e.NumerReferencyjnySesji?._text, R.Default)
  ]), Ae(e.OpisPotwierdzenia?.Strona) && E.push([
    re(l.t("invoice.upo.upoPage"), R.GrayBoldTitle),
    re(e.OpisPotwierdzenia?.Strona?._text, R.Default)
  ]), Ae(e.OpisPotwierdzenia?.LiczbaStron) && E.push([
    re(l.t("invoice.upo.upoPageTotal"), R.GrayBoldTitle),
    re(e.OpisPotwierdzenia?.LiczbaStron?._text, R.Default)
  ]), Ae(e.OpisPotwierdzenia?.ZakresDokumentowOd) && E.push([
    re(l.t("invoice.upo.documentRangeFrom"), R.GrayBoldTitle),
    re(e.OpisPotwierdzenia?.ZakresDokumentowOd?._text, R.Default)
  ]), Ae(e.OpisPotwierdzenia?.ZakresDokumentowDo) && E.push([
    re(l.t("invoice.upo.documentRangeTo"), R.GrayBoldTitle),
    re(e.OpisPotwierdzenia?.ZakresDokumentowDo?._text, R.Default)
  ]), Ae(e.OpisPotwierdzenia?.CalkowitaLiczbaDokumentow) && E.push([
    re(l.t("invoice.upo.documentsTotal"), R.GrayBoldTitle),
    re(e.OpisPotwierdzenia?.CalkowitaLiczbaDokumentow?._text, R.Default)
  ]);
  const Y = e?.Uwierzytelnienie?.IdKontekstu;
  if (Y) {
    let r = "", A;
    Ae(Y.IdDostawcyUslugPeppol) && (r = l.t("invoice.upo.peppolId"), A = de(Y.IdDostawcyUslugPeppol)), Ae(Y.Nip) && (r = l.t("invoice.upo.nip"), A = de(Y.Nip)), Ae(Y.IdWewnetrzny) && (r = l.t("invoice.upo.internalId"), A = de(Y.IdWewnetrzny)), Ae(Y.IdZlozonyVatUE) && (r = l.t("invoice.upo.complexId"), A = de(Y.IdZlozonyVatUE)), E.push([
      re(l.t("invoice.upo.contextType"), R.GrayBoldTitle),
      re(r, R.Default)
    ]), E.push([
      re(l.t("invoice.upo.contextAuthorizationId"), R.GrayBoldTitle),
      re(A, R.Default)
    ]);
  }
  Ae(e.Uwierzytelnienie?.SkrotDokumentuUwierzytelniajacego) && E.push([
    re(l.t("invoice.upo.authorizationDocumentShortcut"), R.GrayBoldTitle),
    re(e.Uwierzytelnienie?.SkrotDokumentuUwierzytelniajacego?._text, R.Default)
  ]), Ae(e.NazwaStrukturyLogicznej) && E.push([
    re(l.t("invoice.upo.xsdFileLogicName"), R.GrayBoldTitle),
    re(e.NazwaStrukturyLogicznej?._text, R.Default)
  ]), Ae(e.KodFormularza) && E.push([
    re(l.t("invoice.upo.eDocumentFormCode"), R.GrayBoldTitle),
    re(e.KodFormularza?._text, R.Default)
  ]), c.push([
    {
      unbreakable: !0,
      table: {
        body: E,
        widths: ["auto", "*"]
      },
      layout: dn
    }
  ]), c.push(Ei(8));
  const X = [
    { name: "lp", title: l.t("invoice.additionalInformation.ordinalNumber"), format: R.Default },
    {
      name: "NumerKSeFDokumentu",
      title: l.t("invoice.additionalInformation.ksefDocumentNumber"),
      format: R.Default
    },
    { name: "NumerFaktury", title: l.t("invoice.details.invoiceNumber"), format: R.Default },
    { name: "NipSprzedawcy", title: l.t("invoice.upo.vendorNIP"), format: R.Default },
    {
      name: "DataWystawieniaFaktury",
      title: l.t("invoice.details.invoiceDate"),
      format: R.Date
    },
    {
      name: "DataPrzeslaniaDokumentu",
      title: l.t("invoice.details.invoiceDateSentToKsef"),
      format: R.DateTime
    },
    {
      name: "DataNadaniaNumeruKSeF",
      title: l.t("invoice.details.assignKsefNumberDate"),
      format: R.DateTime
    },
    {
      name: "SkrotDokumentu",
      title: l.t("invoice.upo.functionValueShortcut"),
      format: R.Default
    },
    {
      name: "TrybWysylki",
      title: l.t("invoice.upo.sendMethod"),
      format: R.Default,
      width: "*"
    }
  ], Q = n.map((r, A) => ({ ...r, lp: A + 1 })) ?? [], B = ft(
    X,
    Q,
    "auto"
  );
  return B.content && c.push(B.content), c;
}
function Xw(e) {
  return [
    It(
      {
        text: [
          { text: l.t("invoice.header.ksefPart1"), fontSize: 18 },
          { text: l.t("invoice.header.ksefPart2"), color: "red", bold: !0, fontSize: 18 },
          { text: l.t("invoice.header.ksefPart3"), bold: !0, fontSize: 18 }
        ]
      },
      [
        {
          text: ZA(
            l.t("invoice.upo.entityFullName"),
            e.NazwaPodmiotuPrzyjmujacego
          ),
          alignment: Rt.RIGHT
        },
        {
          text: ZA(l.t("invoice.upo.documentInfo"), l.t("invoice.upo.registeredInMF")),
          alignment: Rt.RIGHT
        }
      ]
    )
  ];
}
async function $w(e) {
  const n = await LB(e);
  await kB;
  const c = {
    content: [Xw(n.Potwierdzenie), Vw(n.Potwierdzenie)],
    ...os(),
    pageSize: "A4",
    pageOrientation: "landscape",
    footer: function(E, Y) {
      return {
        text: `${E.toString()} ${l.t("invoice.footer.pagesTotal")} ${Y}`,
        alignment: Rt.RIGHT,
        margin: [0, 0, 20, 0]
      };
    }
  };
  return bn.createPdf(c).getBlob();
}
export {
  va as Answer,
  R as FormatTyp,
  Rt as Position,
  Vw as generateDokumentUPO,
  yE as generateFA1,
  ZE as generateFA2,
  dw as generateFA3,
  Uw as generateFARR,
  _w as generateInvoice,
  Xw as generateNaglowekUPO,
  $w as generatePDFUPO,
  os as generateStyle,
  kB as i18nReady,
  l as i18next
};
